import { id, getCreate2Address, getAddress, Interface } from 'ethers/lib/utils';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _createClass from '@babel/runtime/helpers/createClass';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { CurrencyAmount, Token, WETH9, Ether, NativeCurrency, Percent as Percent$1, TradeType as TradeType$1, validateAndParseAddress as validateAndParseAddress$1 } from '@uniswap/sdk-core';
import { FACTORY_ADDRESS as FACTORY_ADDRESS$1, Route, Pool, TICK_SPACINGS, Position, computePoolAddress, nearestUsableTick } from '@uniswap/v3-sdk';
import { ethers, BigNumber, utils, Contract } from 'ethers';
import { config } from 'dotenv';
import { getCreate2Address as getCreate2Address$1, getAddress as getAddress$1 } from '@ethersproject/address';
import { keccak256, pack } from '@ethersproject/solidity';
import { FACTORY_ADDRESS_MAP, INIT_CODE_HASH, Route as Route$1, Pair } from '@uniswap/v2-sdk';
import BN from 'bignumber.js';
import BigDecimal from 'js-big-decimal';
import { parseUnits } from '@ethersproject/units';
import JSBI from 'jsbi';
import _get from '@babel/runtime/helpers/get';
import { deepmerge } from 'deepmerge-ts';
import require$$0 from 'crypto';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _typeof from '@babel/runtime/helpers/typeof';
import utils$1 from 'web3-utils';
import { Trade, Protocol } from '@uniswap/router-sdk';
import { AddressZero as AddressZero$2 } from '@ethersproject/constants';
import { Contract as Contract$1 } from '@ethersproject/contracts';
import { FACTORY_ADDRESS as FACTORY_ADDRESS$2, INIT_CODE_HASH as INIT_CODE_HASH$1, Token as Token$1, Ether as Ether$1, Percent, CurrencyAmount as CurrencyAmount$1, validateAndParseAddress, Fraction, JSBI as JSBI$1 } from '@sushiswap/sdk';
import { SushiswapPair, SushiswapPairSettings, WETH } from 'simple-sushiswap-sdk';
import Decimal from 'decimal.js';
import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import _toArray from '@babel/runtime/helpers/toArray';
import _, { sample } from 'lodash';
import { createPublicClient, http } from 'viem';
import { arbitrumGoerli, arbitrum } from 'viem/chains';
import uniqid from 'uniqid';

var cometList = [
	{
		chainId: 1,
		address: "0xc3d688B66703497DAA19211EEdff47f25384cdc3",
		name: "Compound USDC",
		symbol: "cUSDCv3",
		decimals: 6
	},
	{
		chainId: 5,
		address: "0x3EE77595A8459e93C2888b13aDB354017B198188",
		name: "Compound USDC",
		symbol: "cUSDCv3",
		decimals: 6
	},
	{
		chainId: 42161,
		address: "0xA5EDBDD9646f8dFF606d7448e414884C7d905dCA",
		name: "Compound USDC",
		symbol: "cUSDCv3",
		decimals: 6
	},
	{
		chainId: 421613,
		address: "0x1d573274E19174260c5aCE3f2251598959d24456",
		name: "Compound USDC",
		symbol: "cUSDCv3",
		decimals: 6
	}
];

var SUSHISWAP_ROUTER_ADDRESS = {
  '1': '0xd9e1cE17f2641f24aE83637ab66a2cca9C378B9F',
  '5': '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
  '42161': '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
  '421613': '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
  '11155111': ''
};
var ROUTER_ADDRESSES = [{
  address: SUSHISWAP_ROUTER_ADDRESS['1'],
  chainId: 1
}, {
  address: SUSHISWAP_ROUTER_ADDRESS['5'],
  chainId: 5
}, {
  address: SUSHISWAP_ROUTER_ADDRESS['42161'],
  chainId: 42161
}, {
  address: SUSHISWAP_ROUTER_ADDRESS['421613'],
  chainId: 421613
}, {
  address: SUSHISWAP_ROUTER_ADDRESS['11155111'],
  chainId: 11155111
}];

var ROUTER_V2 = '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D';
var ROUTER_V2_ADDRESS = {
  '1': ROUTER_V2,
  '5': ROUTER_V2,
  "42161": ROUTER_V2,
  "421613": ROUTER_V2,
  "11155111": '0xC532a74256D3Db42D0Bf7a0400fEFDbad7694008'
};
var ROUTER_V2_ADDRESSES = [{
  address: ROUTER_V2,
  chainId: 1
}, {
  address: ROUTER_V2,
  chainId: 5
}, {
  address: ROUTER_V2,
  chainId: 42161
}, {
  address: ROUTER_V2,
  chainId: 421613
}, {
  address: '0xC532a74256D3Db42D0Bf7a0400fEFDbad7694008',
  chainId: 11155111
}];

var aaveGoerliErc20 = [
	{
		chainId: "5",
		address: "0x65E2fe35C30eC218b46266F89847c63c2eDa7Dc7",
		symbol: "USDT",
		decimals: 6,
		name: "USDT",
		index: 15,
		logoURI: "https://assets.coingecko.com/coins/images/325/thumb/Tether-logo.png?1598003707"
	},
	{
		chainId: "5",
		address: "0xCCa7d1416518D095E729904aAeA087dBA749A4dC",
		symbol: "WETH",
		decimals: 18,
		name: "Wrapped Ether",
		index: 17,
		logoURI: "https://assets.coingecko.com/coins/images/2518/thumb/weth.png?1628852295"
	},
	{
		chainId: "5",
		address: "0xf4423F4152966eBb106261740da907662A3569C5",
		symbol: "WBTC",
		decimals: 8,
		name: "WBTC",
		index: 16,
		logoURI: "https://assets.coingecko.com/coins/images/7598/thumb/wrapped_bitcoin_wbtc.png?1548822744"
	},
	{
		chainId: "5",
		address: "0x6c260F702B6Bb9AC989DA4B0fcbE7fddF8f749c4",
		symbol: "YFI",
		decimals: 18,
		name: "YFI",
		index: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11849/thumb/yfi-192x192.png?1598325330"
	},
	{
		chainId: "5",
		address: "0x515614aA3d8f09152b1289848383A260c7D053Ff",
		symbol: "BAT",
		decimals: 18,
		name: "BAT",
		index: 1,
		logoURI: "https://assets.coingecko.com/coins/images/677/thumb/basic-attention-token.png?1547034427"
	},
	{
		chainId: "5",
		address: "0x3160F3f3B55eF85d0D27f04A2d74d426c32de842",
		symbol: "REN",
		decimals: 18,
		name: "REN",
		index: 9,
		logoURI: "https://assets.coingecko.com/coins/images/3139/thumb/REN.png?1589985807"
	},
	{
		chainId: "5",
		address: "0xFc1Ab0379db4B6ad8Bf5Bc1382e108a341E2EaBb",
		symbol: "SNX",
		decimals: 18,
		name: "SNX",
		index: 10,
		logoURI: "https://assets.coingecko.com/coins/images/3406/thumb/SNX.png?1598631139"
	},
	{
		chainId: "5",
		address: "0x45E18E77b15A02a31507e948A546a509A50a2376",
		symbol: "xSUSHI",
		decimals: 18,
		name: "xSUSHI",
		index: 20
	},
	{
		chainId: "5",
		address: "0x4e62eB262948671590b8D967BDE048557bdd03eD",
		symbol: "SUSD",
		decimals: 18,
		name: "SUSD",
		index: 11,
		logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"
	},
	{
		chainId: "5",
		address: "0xc048C1b6ac47393F073dA2b3d5D1cc43b94891Fd",
		symbol: "TUSD",
		decimals: 18,
		name: "TUSD",
		index: 12,
		logoURI: "https://assets.coingecko.com/coins/images/3449/thumb/tusd.png?1618395665"
	},
	{
		chainId: "5",
		address: "0x1057DCaa0b66dFBcEc5241fD51F4326C210f201F",
		symbol: "ENJ",
		decimals: 18,
		name: "ENJ",
		index: 4,
		logoURI: "https://assets.coingecko.com/coins/images/1102/thumb/enjin-coin-logo.png?1547035078"
	},
	{
		chainId: "5",
		address: "0x75Ab5AB1Eef154C0352Fc31D2428Cef80C7F8B33",
		symbol: "DAI",
		decimals: 18,
		name: "DAI",
		index: 3,
		logoURI: "https://assets.coingecko.com/coins/images/9956/thumb/4943.png?1636636734"
	},
	{
		chainId: "5",
		address: "0x54Bc1D59873A5ABde98cf76B6EcF4075ff65d685",
		symbol: "KNC",
		decimals: 18,
		name: "KNC",
		index: "5",
		logoURI: "https://assets.coingecko.com/coins/images/14899/thumb/RwdVsGcw_400x400.jpg?1618923851"
	},
	{
		chainId: "5",
		address: "0x9FD21bE27A2B059a288229361E2fA632D8D2d074",
		symbol: "USDC",
		decimals: 6,
		name: "USDC",
		index: 14,
		logoURI: "https://assets.coingecko.com/coins/images/6319/thumb/USD_Coin_icon.png?1547042389"
	},
	{
		chainId: "5",
		address: "0xAcFd03DdF9C68015E1943FB02b60c5df56C4CB9e",
		symbol: "ZRX",
		decimals: 18,
		name: "ZRX",
		index: 19,
		logoURI: "https://assets.coingecko.com/coins/images/863/thumb/0x.png?1547034672"
	},
	{
		chainId: "5",
		address: "0x7337e7FF9abc45c0e43f130C136a072F4794d40b",
		symbol: "LINK",
		decimals: 18,
		name: "LINK",
		index: 6,
		logoURI: "https://assets.coingecko.com/coins/images/877/thumb/chainlink-new-logo.png?1547034700"
	},
	{
		chainId: "5",
		address: "0xa7c3Bf25FFeA8605B516Cf878B7435fe1768c89b",
		symbol: "BUSD",
		decimals: 18,
		name: "BUSD",
		index: 2,
		logoURI: "https://assets.coingecko.com/coins/images/9576/thumb/BUSD.png?1568947766"
	},
	{
		chainId: "5",
		address: "0x8d9EAc6f25470EFfD68f0AD22993CB2813c0c9B9",
		symbol: "MANA",
		decimals: 18,
		name: "MANA",
		index: 7,
		logoURI: "https://assets.coingecko.com/coins/images/878/thumb/decentraland-mana.png?1550108745"
	},
	{
		chainId: "5",
		address: "0x981D8AcaF6af3a46785e7741d22fBE81B25Ebf1e",
		symbol: "UNI",
		decimals: 18,
		name: "UNI",
		index: 13,
		logoURI: "https://assets.coingecko.com/coins/images/12504/thumb/uniswap-uni.png?1600306604"
	},
	{
		chainId: "5",
		address: "0x0B7a69d978DdA361Db5356D4Bd0206496aFbDD96",
		symbol: "AAVE",
		decimals: 18,
		name: "AAVE",
		index: 0,
		logoURI: "https://assets.coingecko.com/coins/images/12645/thumb/AAVE.png?1601374110"
	},
	{
		chainId: "5",
		address: "0x90be02599452FBC1a3D47E9EB62895330cfA05Ed",
		symbol: "MKR",
		decimals: 18,
		name: "MKR",
		index: 8,
		logoURI: "https://assets.coingecko.com/coins/images/1364/thumb/Mark_Maker.png?1585191826"
	}
];

var aaveMainnetErc20 = [
	{
		chainId: "1",
		address: "0x0D8775F648430679A709E98d2b0Cb6250d2887EF",
		symbol: "BAT",
		decimals: 18,
		name: "Basic Attention Token",
		index: 7,
		logoURI: "https://assets.coingecko.com/coins/images/677/thumb/basic-attention-token.png?1547034427"
	},
	{
		chainId: "1",
		address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
		symbol: "BUSD",
		decimals: 18,
		name: "Binance USD",
		index: 8,
		logoURI: "https://assets.coingecko.com/coins/images/9576/thumb/BUSD.png?1568947766"
	},
	{
		chainId: "1",
		address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
		symbol: "WETH",
		decimals: 18,
		name: "Wrapped Ether",
		index: 2,
		logoURI: "https://assets.coingecko.com/coins/images/2518/thumb/weth.png?1628852295"
	},
	{
		chainId: "1",
		address: "0x408e41876cCCDC0F92210600ef50372656052a38",
		symbol: "REN",
		decimals: 18,
		name: "Republic Token",
		index: 15,
		logoURI: "https://assets.coingecko.com/coins/images/3139/thumb/REN.png?1589985807"
	},
	{
		chainId: "1",
		address: "0xE41d2489571d322189246DaFA5ebDe1F4699F498",
		symbol: "ZRX",
		decimals: 18,
		name: "0x Protocol Token",
		index: 4,
		logoURI: "https://assets.coingecko.com/coins/images/863/thumb/0x.png?1547034672"
	},
	{
		chainId: "1",
		address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
		symbol: "AAVE",
		decimals: 18,
		name: "Aave Token",
		index: 6,
		logoURI: "https://assets.coingecko.com/coins/images/12645/thumb/AAVE.png?1601374110"
	},
	{
		chainId: "1",
		address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
		symbol: "UNI",
		decimals: 18,
		name: "Uniswap",
		index: 5,
		logoURI: "https://assets.coingecko.com/coins/images/12504/thumb/uniswap-uni.png?1600306604"
	},
	{
		chainId: "1",
		address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
		symbol: "LINK",
		decimals: 18,
		name: "ChainLink Token",
		index: 12,
		logoURI: "https://assets.coingecko.com/coins/images/877/thumb/chainlink-new-logo.png?1547034700"
	},
	{
		chainId: "1",
		address: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
		symbol: "YFI",
		decimals: 18,
		name: "yearn.finance",
		index: 3,
		logoURI: "https://assets.coingecko.com/coins/images/11849/thumb/yfi-192x192.png?1598325330"
	},
	{
		chainId: "1",
		address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
		symbol: "USDT",
		decimals: 6,
		name: "Tether USD",
		index: 0,
		logoURI: "https://assets.coingecko.com/coins/images/325/thumb/Tether-logo.png?1598003707"
	},
	{
		chainId: "1",
		address: "0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919",
		symbol: "RAI",
		decimals: 18,
		name: "Rai Reflex Index",
		index: 25,
		logoURI: "https://assets.coingecko.com/coins/images/14004/thumb/RAI-logo-coin.png?1613592334"
	},
	{
		chainId: "1",
		address: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		symbol: "sUSD",
		decimals: 18,
		name: "Synth sUSD",
		index: 17
	},
	{
		chainId: "1",
		address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
		symbol: "DAI",
		decimals: 18,
		name: "Dai Stablecoin",
		index: 9,
		logoURI: "https://assets.coingecko.com/coins/images/9956/thumb/4943.png?1636636734"
	},
	{
		chainId: "1",
		address: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
		symbol: "SNX",
		decimals: 18,
		name: "Synthetix Network Token",
		index: 16,
		logoURI: "https://assets.coingecko.com/coins/images/3406/thumb/SNX.png?1598631139"
	},
	{
		chainId: "1",
		address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
		symbol: "USDC",
		decimals: 6,
		name: "USD Coin",
		index: 19,
		logoURI: "https://assets.coingecko.com/coins/images/6319/thumb/USD_Coin_icon.png?1547042389"
	},
	{
		chainId: "1",
		address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
		symbol: "WBTC",
		decimals: 8,
		name: "Wrapped BTC",
		index: "1",
		logoURI: "https://assets.coingecko.com/coins/images/7598/thumb/wrapped_bitcoin_wbtc.png?1548822744"
	},
	{
		chainId: "1",
		address: "0xF629cBd94d3791C9250152BD8dfBDF380E2a3B9c",
		symbol: "ENJ",
		decimals: 18,
		name: "Enjin Coin",
		index: 10,
		logoURI: "https://assets.coingecko.com/coins/images/1102/thumb/enjin-coin-logo.png?1547035078"
	},
	{
		chainId: "1",
		address: "0x0F5D2fB29fb7d3CFeE444a200298f468908cC942",
		symbol: "MANA",
		decimals: 18,
		name: "Decentraland MANA",
		index: 13,
		logoURI: "https://assets.coingecko.com/coins/images/878/thumb/decentraland-mana.png?1550108745"
	},
	{
		chainId: "1",
		address: "0xba100000625a3754423978a60c9317c58a424e3D",
		symbol: "BAL",
		decimals: 18,
		name: "Balancer",
		index: 22,
		logoURI: "https://assets.coingecko.com/coins/images/11683/thumb/Balancer.png?1592792958"
	},
	{
		chainId: "1",
		address: "0xdd974D5C2e2928deA5F71b9825b8b646686BD200",
		symbol: "KNC",
		decimals: 18,
		name: "Kyber Network Crystal",
		index: 11,
		logoURI: "https://assets.coingecko.com/coins/images/14899/thumb/RwdVsGcw_400x400.jpg?1618923851"
	},
	{
		chainId: "1",
		address: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
		symbol: "GUSD",
		decimals: 2,
		name: "Gemini dollar",
		index: 21,
		logoURI: "https://assets.coingecko.com/coins/images/5992/thumb/gemini-dollar-gusd.png?1536745278"
	},
	{
		chainId: "1",
		address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
		symbol: "FRAX",
		decimals: 18,
		name: "Frax",
		index: 29,
		logoURI: "https://assets.coingecko.com/coins/images/13422/thumb/frax_logo.png?1608476506"
	},
	{
		chainId: "1",
		address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
		symbol: "MKR",
		decimals: 18,
		name: "",
		index: 14,
		logoURI: "https://assets.coingecko.com/coins/images/1364/thumb/Mark_Maker.png?1585191826"
	},
	{
		chainId: "1",
		address: "0x8E870D67F660D95d5be530380D0eC0bd388289E1",
		symbol: "USDP",
		decimals: 18,
		name: "Pax Dollar",
		index: 27,
		logoURI: "https://assets.coingecko.com/coins/images/6013/thumb/Pax_Dollar.png?1629877204"
	},
	{
		chainId: "1",
		address: "0x0000000000085d4780B73119b644AE5ecd22b376",
		symbol: "TUSD",
		decimals: 18,
		name: "TrueUSD",
		index: 18,
		logoURI: "https://assets.coingecko.com/coins/images/3449/thumb/tusd.png?1618395665"
	},
	{
		chainId: "1",
		address: "0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84",
		symbol: "stETH",
		decimals: 18,
		name: "Liquid staked Ether 2.0",
		index: 31
	},
	{
		chainId: "1",
		address: "0x4e3FBD56CD56c3e72c1403e103b45Db9da5B9D2B",
		symbol: "CVX",
		decimals: 18,
		name: "Convex Token",
		index: 34,
		logoURI: "https://assets.coingecko.com/coins/images/15585/thumb/convex.png?1621256328"
	},
	{
		chainId: "1",
		address: "0x8798249c2E607446EfB7Ad49eC89dD1865Ff4272",
		symbol: "xSUSHI",
		decimals: 18,
		name: "SushiBar",
		index: 23
	},
	{
		chainId: "1",
		address: "0xD46bA6D942050d489DBd938a2C909A5d5039A161",
		symbol: "AMPL",
		decimals: 9,
		name: "Ampleforth",
		index: 26,
		logoURI: "https://assets.coingecko.com/coins/images/4708/thumb/Ampleforth.png?1561684250"
	},
	{
		chainId: "1",
		address: "0xD5147bc8e386d91Cc5DBE72099DAC6C9b99276F5",
		symbol: "renFIL",
		decimals: 18,
		name: "renFIL",
		index: 24
	},
	{
		chainId: "1",
		address: "0x1494CA1F11D487c2bBe4543E90080AeBa4BA3C2b",
		symbol: "DPI",
		decimals: 18,
		name: "DefiPulse Index",
		index: 28,
		logoURI: "https://assets.coingecko.com/coins/images/12465/thumb/defi_pulse_index_set.png?1600051053"
	},
	{
		chainId: "1",
		address: "0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72",
		symbol: "ENS",
		decimals: 18,
		name: "Ethereum Name Service",
		index: 32,
		logoURI: "https://assets.coingecko.com/coins/images/19785/thumb/acatxTm8_400x400.jpg?1635850140"
	},
	{
		chainId: "1",
		address: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
		symbol: "LUSD",
		decimals: 18,
		name: "LUSD Stablecoin",
		index: 36,
		logoURI: "https://assets.coingecko.com/coins/images/14666/thumb/Group_3.png?1617631327"
	},
	{
		chainId: "1",
		address: "0x956F47F50A910163D8BF957Cf5846D573E7f87CA",
		symbol: "FEI",
		decimals: 18,
		name: "Fei USD",
		index: 30,
		logoURI: "https://assets.coingecko.com/coins/images/14570/thumb/ZqsF51Re_400x400.png?1617082206"
	},
	{
		chainId: "1",
		address: "0x111111111117dC0aa78b770fA6A738034120C302",
		symbol: "1INCH",
		decimals: 18,
		name: "1INCH Token",
		index: 35,
		logoURI: "https://assets.coingecko.com/coins/images/13469/thumb/1inch-token.png?1608803028"
	},
	{
		chainId: "1",
		address: "0xD533a949740bb3306d119CC777fa900bA034cd52",
		symbol: "CRV",
		decimals: 18,
		name: "Curve DAO Token",
		index: 20,
		logoURI: "https://assets.coingecko.com/coins/images/12124/thumb/Curve.png?1597369484"
	},
	{
		chainId: "1",
		address: "0xa693B19d2931d498c5B318dF961919BB4aee87a5",
		symbol: "UST",
		decimals: 6,
		name: "UST",
		index: 33,
		logoURI: "https://assets.coingecko.com/coins/images/21150/thumb/UST_wh_small.png?1644223065"
	}
];

var aaveV3ArbitrumErc20$1 = [
	{
		chainId: "42161",
		address: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
		symbol: "DAI",
		decimals: 18,
		name: "Dai Stablecoin",
		logoURI: ""
	},
	{
		chainId: "42161",
		address: "0xf97f4df75117a78c1A5a0DBb814Af92458539FB4",
		symbol: "LINK",
		decimals: 18,
		name: "ChainLink Token",
		logoURI: ""
	},
	{
		chainId: "42161",
		address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
		symbol: "USDC",
		decimals: 6,
		name: "USD Coin (Arb1)",
		logoURI: ""
	},
	{
		chainId: "42161",
		address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
		symbol: "WBTC",
		decimals: 8,
		name: "Wrapped BTC",
		logoURI: ""
	},
	{
		chainId: "42161",
		address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
		symbol: "WETH",
		decimals: 18,
		name: "Wrapped Ether",
		logoURI: ""
	},
	{
		chainId: "42161",
		address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
		symbol: "USDT",
		decimals: 6,
		name: "Tether USD",
		logoURI: ""
	},
	{
		chainId: "42161",
		address: "0xba5DdD1f9d7F570dc94a51479a000E3BCE967196",
		symbol: "AAVE",
		decimals: 18,
		name: "Aave Token",
		logoURI: ""
	},
	{
		chainId: "42161",
		address: "0xD22a58f79e9481D1a88e00c343885A588b34b68B",
		symbol: "EURS",
		decimals: 2,
		name: "STASIS EURS Token",
		logoURI: ""
	},
	{
		chainId: "42161",
		address: "0x5979D7b546E38E414F7E9822514be443A4800529",
		symbol: "wstETH",
		decimals: 18,
		name: "Wrapped liquid staked Ether 2.0",
		logoURI: ""
	},
	{
		chainId: "42161",
		address: "0x3F56e0c36d275367b8C502090EDF38289b3dEa0d",
		symbol: "MAI",
		decimals: 18,
		name: "Mai Stablecoin",
		logoURI: ""
	}
];

var aaveV3MainnetErc20$1 = [
	{
		chainId: "1",
		address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
		symbol: "WETH",
		decimals: 18,
		name: "Wrapped Ether",
		logoURI: ""
	},
	{
		chainId: "1",
		address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
		symbol: "wstETH",
		decimals: 18,
		name: "Wrapped liquid staked Ether 2.0",
		logoURI: ""
	},
	{
		chainId: "1",
		address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
		symbol: "WBTC",
		decimals: 8,
		name: "Wrapped BTC",
		logoURI: ""
	},
	{
		chainId: "1",
		address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
		symbol: "USDC",
		decimals: 6,
		name: "USD Coin",
		logoURI: ""
	},
	{
		chainId: "1",
		address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
		symbol: "DAI",
		decimals: 18,
		name: "Dai Stablecoin",
		logoURI: ""
	},
	{
		chainId: "1",
		address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
		symbol: "LINK",
		decimals: 18,
		name: "ChainLink Token",
		logoURI: ""
	},
	{
		chainId: "1",
		address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
		symbol: "AAVE",
		decimals: 18,
		name: "Aave Token",
		logoURI: ""
	},
	{
		chainId: "1",
		address: "0xBe9895146f7AF43049ca1c1AE358B0541Ea49704",
		symbol: "cbETH",
		decimals: 18,
		name: "Coinbase Wrapped Staked ETH",
		logoURI: ""
	},
	{
		chainId: "1",
		address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
		symbol: "USDT",
		decimals: 6,
		name: "Tether USD",
		logoURI: ""
	},
	{
		chainId: "1",
		address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
		symbol: "rETH",
		decimals: 18,
		name: "Rocket Pool ETH",
		logoURI: ""
	},
	{
		chainId: "1",
		address: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
		symbol: "LUSD",
		decimals: 18,
		name: "LUSD Stablecoin",
		logoURI: ""
	},
	{
		chainId: "1",
		address: "0xD533a949740bb3306d119CC777fa900bA034cd52",
		symbol: "CRV",
		decimals: 18,
		name: "Curve DAO Token",
		logoURI: ""
	},
	{
		chainId: "1",
		address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
		symbol: "MKR",
		decimals: 18,
		name: "Maker DAO",
		logoURI: ""
	},
	{
		chainId: "1",
		address: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
		symbol: "SNX",
		decimals: 18,
		name: "Synthetix Network Token",
		logoURI: ""
	},
	{
		chainId: "1",
		address: "0xba100000625a3754423978a60c9317c58a424e3D",
		symbol: "BAL",
		decimals: 18,
		name: "Balancer",
		logoURI: ""
	},
	{
		chainId: "1",
		address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
		symbol: "UNI",
		decimals: 18,
		name: "Uniswap",
		logoURI: ""
	},
	{
		chainId: "1",
		address: "0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32",
		symbol: "LDO",
		decimals: 18,
		name: "Lido DAO Token",
		logoURI: ""
	}
];

var cTokens = [
	{
		chainId: 1,
		address: "0x39AA39c021dfbaE8faC545936693aC917d5E7563",
		name: "Compound USD Coin",
		symbol: "cUSDC",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_usdc.svg",
		assetAddress: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"
	},
	{
		chainId: 1,
		address: "0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643",
		name: "Compound Dai",
		symbol: "cDAI",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_dai.svg",
		assetAddress: "0x6b175474e89094c44da98b954eedeac495271d0f"
	},
	{
		chainId: 1,
		address: "0x70e36f6BF80a52b3B46b3aF8e106CC0ed743E8e4",
		name: "Compound Collateral",
		symbol: "cCOMP",
		decimals: 8,
		assetAddress: "0xc00e94cb662c3520282e6f5717214004a7f26888"
	},
	{
		chainId: 1,
		address: "0xf650C3d88D12dB855b8bf7D11Be6C55A4e07dCC9",
		name: "Compound USDT",
		symbol: "cUSDT",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_usdt.svg",
		assetAddress: "0xdac17f958d2ee523a2206206994597c13d831ec7"
	},
	{
		chainId: 1,
		address: "0x6C8c6b02E7b2BE14d4fA6022Dfd6d75921D90E4E",
		name: "Compound Basic Attention Token",
		symbol: "cBAT",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_bat.svg",
		assetAddress: "0x0d8775f648430679a709e98d2b0cb6250d2887ef"
	},
	{
		chainId: 1,
		address: "0x4Ddc2D193948926D02f9B1fE9e1daa0718270ED5",
		name: "Compound Ether",
		symbol: "cETH",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_eth.svg"
	},
	{
		chainId: 1,
		address: "0xF5DCe57282A584D2746FaF1593d3121Fcac444dC",
		name: "Compound Sai",
		symbol: "cSAI",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_sai.svg",
		assetAddress: "0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359"
	},
	{
		chainId: 1,
		address: "0x158079Ee67Fce2f58472A96584A73C7Ab9AC95c1",
		name: "Compound Augur",
		symbol: "cREP",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_rep.svg",
		assetAddress: "0x1985365e9f78359a9B6AD760e32412f4a445E862"
	},
	{
		chainId: 1,
		address: "0xB3319f5D18Bc0D84dD1b4825Dcde5d5f7266d407",
		name: "Compound 0x",
		symbol: "cZRX",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_zrx.svg",
		assetAddress: "0xE41d2489571d322189246DaFA5ebDe1F4699F498"
	},
	{
		chainId: 1,
		address: "0xC11b1268C1A384e55C48c2391d8d480264A3A7F4",
		name: "Compound Wrapped BTC",
		symbol: "cWBTC",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_wbtc.svg",
		assetAddress: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599"
	},
	{
		chainId: 1,
		address: "0xFAce851a4921ce59e912d19329929CE6da6EB0c7",
		name: "Compound ChainLink",
		symbol: "cLINK",
		decimals: 8,
		assetAddress: "0x514910771af9ca656af840dff83e8264ecf986ca"
	},
	{
		chainId: 1,
		address: "0x35A18000230DA775CAc24873d00Ff85BccdeD550",
		name: "Compound Uniswap",
		symbol: "cUNI",
		decimals: 8,
		assetAddress: "0x1f9840a85d5af5bf1d1762f925bdaddc4201f984"
	},
	{
		chainId: 1,
		address: "0x12392F67bdf24faE0AF363c24aC620a2f67DAd86",
		name: "Compound TrueUSD",
		symbol: "cTUSD",
		decimals: 8,
		assetAddress: "0x0000000000085d4780B73119b644AE5ecd22b376"
	},
	{
		chainId: 5,
		address: "0x0fF50a12759b081Bb657ADaCf712C52bb015F1Cd",
		name: "Compound Collateral",
		symbol: "cCOMP",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_comp.svg",
		assetAddress: "0x3587b2F7E0E2D6166d6C14230e7Fe160252B0ba4"
	},
	{
		chainId: 5,
		address: "0x73506770799Eb04befb5AaE4734e58C2C624F493",
		name: "Compound USD Coin",
		symbol: "cUSDC",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_usdc.svg",
		assetAddress: "0x07865c6E87B9F70255377e024ace6630C1Eaa37F"
	},
	{
		chainId: 5,
		address: "0x0545a8eaF7ff6bB6F708CbB544EA55DBc2ad7b2a",
		name: "Compound Dai",
		symbol: "cDAI",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_dai.svg",
		assetAddress: "0x2899a03ffDab5C90BADc5920b4f53B0884EB13cC"
	},
	{
		chainId: 5,
		address: "0x20572e4c090f15667cF7378e16FaD2eA0e2f3EfF",
		name: "Compound Ether",
		symbol: "cETH",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_eth.svg"
	},
	{
		chainId: 5,
		address: "0xDa6F609F3636062E06fFB5a1701Df3c5F1ab3C8f",
		name: "Compound Wrapped BTC",
		symbol: "cWBTC",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_wbtc.svg",
		assetAddress: "0xAAD4992D949f9214458594dF92B44165Fb84dC19"
	},
	{
		chainId: 5,
		address: "0x2073d38198511F5Ed8d893AB43A03bFDEae0b1A5",
		name: "Compound Uniswap",
		symbol: "cUNI",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_uni.svg",
		assetAddress: "0x208F73527727bcB2D9ca9bA047E3979559EB08cC"
	}
];

var curveGaugeTokens = [
	{
		chainId: 1,
		address: "0xbfcf63294ad7105dea65aa58f8ae5be2d9d0952a",
		symbol: "Curve Gauge 3Crv",
		decimals: 18,
		name: "Curve Gauge Curve.fi DAI/USDC/USDT",
		index: 0
	},
	{
		chainId: 1,
		address: "0xd662908ada2ea1916b3318327a97eb18ad588b5d",
		symbol: "Curve Gauge a3CRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi aDAI/aUSDC/aUSDT",
		index: 1
	},
	{
		chainId: 1,
		address: "0x6d10ed2cf043e6fcf51a0e7b4c2af3fa06695707",
		symbol: "Curve Gauge ankrCRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi ETH/aETH",
		index: 2
	},
	{
		chainId: 1,
		address: "0x69fb7c45726cfe2badee8317005d3f94be838840",
		symbol: "Curve Gauge yDAI+yUSDC+yUSDT+yBUSD",
		decimals: 18,
		name: "Curve Gauge Curve.fi yDAI/yUSDC/yUSDT/yBUSD",
		index: 3
	},
	{
		chainId: 1,
		address: "0x7ca5b0a2910b33e9759dc7ddb0413949071d7575",
		symbol: "Curve Gauge cDAI+cUSDC",
		decimals: 18,
		name: "Curve Gauge Curve.fi cDAI/cUSDC",
		index: 4
	},
	{
		chainId: 1,
		address: "0x90bb609649e0451e5ad952683d64bd2d1f245840",
		symbol: "Curve Gauge eursCRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi EURS/sEUR",
		index: 5
	},
	{
		chainId: 1,
		address: "0x4c18e409dc8619bfb6a1cb56d114c3f592e0ae79",
		symbol: "Curve Gauge hCRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi hBTC/wBTC",
		index: 6
	},
	{
		chainId: 1,
		address: "0xf5194c3325202f456c95c1cf0ca36f8475c1949f",
		symbol: "Curve Gauge ib3CRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi cyDAI/cyUSDC/cyUSDT",
		index: 7
	},
	{
		chainId: 1,
		address: "0xfd4d8a17df4c27c1dd245d153ccf4499e806c87d",
		symbol: "Curve Gauge linkCRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi LINK/sLINK",
		index: 8
	},
	{
		chainId: 1,
		address: "0x64e3c23bfc40722d3b649844055f1d51c1ac041d",
		symbol: "Curve Gauge ypaxCrv",
		decimals: 18,
		name: "Curve Gauge Curve.fi DAI/USDC/USDT/PAX",
		index: 9
	},
	{
		chainId: 1,
		address: "0xb1f2cdec61db658f091671f5f199635aef202cac",
		symbol: "Curve Gauge crvRenWBTC",
		decimals: 18,
		name: "Curve Gauge Curve.fi renBTC/wBTC",
		index: 10
	},
	{
		chainId: 1,
		address: "0x462253b8f74b72304c145db0e4eebd326b22ca39",
		symbol: "Curve Gauge saCRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi aDAI/aSUSD",
		index: 11
	},
	{
		chainId: 1,
		address: "0x705350c4bcd35c9441419ddd5d2f097d7a55410f",
		symbol: "Curve Gauge crvRenWSBTC",
		decimals: 18,
		name: "Curve Gauge Curve.fi renBTC/wBTC/sBTC",
		index: 12
	},
	{
		chainId: 1,
		address: "0x3c0ffff15ea30c35d7a85b85c0782d6c94e1d238",
		symbol: "Curve Gauge eCRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi ETH/sETH",
		index: 13
	},
	{
		chainId: 1,
		address: "0x182b723a58739a9c974cfdb385ceadb237453c28",
		symbol: "Curve Gauge steCRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi ETH/stETH",
		index: 14
	},
	{
		chainId: 1,
		address: "0xa90996896660decc6e997655e065b23788857849",
		symbol: "Curve Gauge crvPlain3andSUSD",
		decimals: 18,
		name: "Curve Gauge Curve.fi DAI/USDC/USDT/sUSD",
		index: 15
	},
	{
		chainId: 1,
		address: "0xbc89cd85491d81c6ad2954e6d0362ee29fca8f53",
		symbol: "Curve Gauge cDAI+cUSDC+USDT",
		decimals: 18,
		name: "Curve Gauge Curve.fi cDAI/cUSDC/USDT",
		index: 16
	},
	{
		chainId: 1,
		address: "0xfa712ee4788c042e2b7bb55e6cb8ec569c4530c1",
		symbol: "Curve Gauge yDAI+yUSDC+yUSDT+yTUSD",
		decimals: 18,
		name: "Curve Gauge Curve.fi yDAI/yUSDC/yUSDT/yTUSD",
		index: 17
	},
	{
		chainId: 1,
		address: "0xaea6c312f4b3e04d752946d329693f7293bc2e6d",
		symbol: "Curve Gauge dusd3CRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi DUSD/3Crv",
		index: 18
	},
	{
		chainId: 1,
		address: "0xc5cfada84e902ad92dd40194f0883ad49639b023",
		symbol: "Curve Gauge gusd3CRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi GUSD/3Crv",
		index: 19
	},
	{
		chainId: 1,
		address: "0x2db0e83599a91b508ac268a6197b8b14f5e72840",
		symbol: "Curve Gauge husd3CRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi HUSD/3Crv",
		index: 20
	},
	{
		chainId: 1,
		address: "0x5f626c30ec1215f4edcc9982265e8b1f411d1352",
		symbol: "Curve Gauge musd3CRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi MUSD/3Crv",
		index: 22
	},
	{
		chainId: 1,
		address: "0x4dc4a289a8e33600d8bd4cf5f6313e43a37adec7",
		symbol: "Curve Gauge rsv3CRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi RSV/3Crv",
		index: 23
	},
	{
		chainId: 1,
		address: "0xc2b1df84112619d190193e48148000e3990bf627",
		symbol: "Curve Gauge usdk3CRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi USDK/3Crv",
		index: 24
	},
	{
		chainId: 1,
		address: "0xf98450b5602fa59cc66e1379dffb6fddc724cfc4",
		symbol: "Curve Gauge usdn3CRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi USDN/3Crv",
		index: 25
	},
	{
		chainId: 1,
		address: "0x055be5ddb7a925bfef3417fc157f53ca77ca7222",
		symbol: "Curve Gauge usdp3CRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi USDP/3Crv",
		index: 26
	},
	{
		chainId: 1,
		address: "0x3b7020743bc2a4ca9eaf9d0722d42e20d6935855",
		symbol: "Curve Gauge ust3CRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi UST/3Crv",
		index: 27
	},
	{
		chainId: 1,
		address: "0xdfc7adfa664b08767b735de28f9e84cd30492aee",
		symbol: "Curve Gauge bBTC/sbtcCRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi bBTC/sbtcCRV",
		index: 28
	},
	{
		chainId: 1,
		address: "0x11137b10c210b579405c21a07489e28f3c040ab1",
		symbol: "Curve Gauge oBTC/sbtcCRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi oBTC/sbtcCRV",
		index: 29
	},
	{
		chainId: 1,
		address: "0xd7d147c6bb90a718c3de8c0568f9b560c79fa416",
		symbol: "Curve Gauge pBTC/sbtcCRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi pBTC/sbtcCRV",
		index: 30
	},
	{
		chainId: 1,
		address: "0x6828bcf74279ee32f2723ec536c22c51eed383c6",
		symbol: "Curve Gauge tbtc/sbtcCrv",
		decimals: 18,
		name: "Curve Gauge Curve.fi tBTC/sbtcCrv",
		index: 31
	},
	{
		chainId: 1,
		address: "0x359fd5d6417ae3d8d6497d9b2e7a890798262ba4",
		symbol: "Curve Gauge TUSD/3Crv",
		decimals: 18,
		name: "Curve Gauge TUSD/3Crv",
		index: 32
	},
	{
		chainId: 1,
		address: "0x9b8519a9a00100720ccdc8a120fbed319ca47a14",
		symbol: "Curve Gauge LUSD/3Crv",
		decimals: 18,
		name: "Curve Gauge LUSD/3Crv",
		index: 33
	},
	{
		chainId: 1,
		address: "0x72e158d38dbd50a483501c24f792bdaaa3e7d55c",
		symbol: "Curve Gauge FRAX/3Crv",
		decimals: 18,
		name: "Curve Gauge FRAX/3Crv",
		index: 34
	},
	{
		chainId: 1,
		address: "0xd4b22fedca85e684919955061fdf353b9d38389b",
		symbol: "Curve Gauge BUSD/3Crv",
		decimals: 18,
		name: "Curve Gauge BUSD/3Crv",
		index: 35
	},
	{
		chainId: 1,
		address: "0x824f13f1a2f29cfeea81154b46c0fc820677a637",
		symbol: "Curve Gauge rCRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi ETH/rETH",
		index: 36
	},
	{
		chainId: 1,
		address: "0x9582c4adacb3bce56fea3e590f05c3ca2fb9c477",
		symbol: "Curve Gauge alUSD/3Crv",
		decimals: 18,
		name: "Curve Gauge alUSD/3Crv",
		index: 37
	},
	{
		chainId: 1,
		address: "0x6955a55416a06839309018a8b0cb72c4ddc11f15",
		symbol: "Curve Gauge crvTricrypto",
		decimals: 18,
		name: "Curve Gauge Curve.fi USD-BTC-ETH",
		index: 38
	},
	{
		chainId: 1,
		address: "0x66ec719045bbd62db5ebb11184c18237d3cc2e62",
		symbol: "Curve Gauge RAI3CRV",
		decimals: 18,
		name: "Curve Gauge RAI3CRV",
		index: 39
	},
	{
		chainId: 1,
		address: "0xd8b712d29381748db89c36bca0138d7c75866ddf",
		symbol: "Curve Gauge MIM/3Crv",
		decimals: 18,
		name: "Curve Gauge MIM/3Crv",
		index: 40
	},
	{
		chainId: 1,
		address: "0xe8060ad8971450e624d5289a10017dd30f5da85f",
		symbol: "Curve Gauge EURT/sEUR",
		decimals: 18,
		name: "Curve Gauge EURT/sEUR",
		index: 41
	},
	{
		chainId: 1,
		address: "0x34883134a39b206a451c2d3b0e7cac44be4d9181",
		symbol: "Curve Gauge USDC/USDT/UST/FRAX",
		decimals: 18,
		name: "Curve Gauge USDC/USDT/UST/FRAX",
		index: 42
	},
	{
		chainId: 1,
		address: "0x9f330db38caaae5b61b410e2f0aad63fff2109d8",
		symbol: "Curve Gauge USDC/USDT",
		decimals: 18,
		name: "Curve Gauge USDC/USDT",
		index: 43
	},
	{
		chainId: 1,
		address: "0xcfc25170633581bf896cb6cdee170e3e3aa59503",
		symbol: "Curve Gauge crvFRAX",
		decimals: 18,
		name: "Curve Gauge Curve.fi FRAX/USDC",
		index: 44
	},
	{
		chainId: 1,
		address: "0x2932a86df44fe8d2a706d8e9c5d51c24883423f5",
		symbol: "Curve Gauge frxETHCRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi ETH/frxETH",
		index: 45
	},
	{
		chainId: 1,
		address: "0x95f00391cb5eebcd190eb58728b4ce23dbfa6ac1",
		symbol: "Curve Gauge crvUSDUSDC-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD/USDC",
		index: 46
	},
	{
		chainId: 1,
		address: "0x4e6bb6b7447b7b2aa268c16ab87f4bb48bf57939",
		symbol: "Curve Gauge crvUSDUSDT-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD/USDT",
		index: 47
	},
	{
		chainId: 1,
		address: "0x5c07440a172805d566faf7ebaf16ef068ac05f43",
		symbol: "Curve Gauge crvUSDUSDP-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD/USDP",
		index: 48
	},
	{
		chainId: 1,
		address: "0xfcaf4ec80a94a5409141af16a1dca950a6973a39",
		symbol: "Curve Gauge crvUSDTUSD-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD/TUSD",
		index: 49
	},
	{
		chainId: 1,
		address: "0x96424e6b5eaafe0c3b36ca82068d574d44be4e3c",
		symbol: "Curve Gauge crvUSDFRAX-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD/Frax",
		index: 50
	},
	{
		chainId: 1,
		address: "0x42144499fd4d017723b3a723953b229e64eb1ffd",
		symbol: "Curve Gauge crvUSDDAI-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD/DAI",
		index: 51
	},
	{
		chainId: 1,
		address: "0x533b5aee744647c20e33653f03676c471bb8e67b",
		symbol: "Curve Gauge crvUSDMIM-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD/MIM",
		index: 52
	},
	{
		chainId: 1,
		address: "0x512a68dd5433563bad526c8c2838c39debc9a756",
		symbol: "Curve Gauge crvUSDSUSD-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD/SUSD",
		index: 53
	},
	{
		chainId: 1,
		address: "0xfc58c946a2d541cfa29ad8c16fc2994323e34458",
		symbol: "Curve Gauge crvUSDGHO-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD/GHO",
		index: 54
	},
	{
		chainId: 1,
		address: "0x71873000399db5fddcd8d953e0e6570a0cb4c50c",
		symbol: "Curve Gauge crvUSDMAI-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD/MAI",
		index: 55
	},
	{
		chainId: 1,
		address: "0x9dc22ca10bb8210c8788827204da091eb6ca04a5",
		symbol: "Curve Gauge crvUSDXAI-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD/XAI",
		index: 56
	},
	{
		chainId: 1,
		address: "0xe39c817fe25ac1a8bd343a74037e3c90b09beeef",
		symbol: "Curve Gauge crvUSDUZD-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD/UZD",
		index: 57
	},
	{
		chainId: 1,
		address: "0xecad6745058377744c09747b2715c0170b5699e5",
		symbol: "Curve Gauge crvUSDDOLA-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD/DOLA",
		index: 58
	},
	{
		chainId: 1,
		address: "0xde14d2b848a7a1373e155cc4db9b649f4be24296",
		symbol: "Curve Gauge crvUSDGUSD-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD/GUSD",
		index: 59
	},
	{
		chainId: 1,
		address: "0x4e21418095d32d15c6e2b96a9910772613a50d50",
		symbol: "Curve Gauge frxeth-ng-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: frxETH/WETH",
		index: 61
	},
	{
		chainId: 1,
		address: "0x5010263ac1978297f56048c7d2b02316a3435404",
		symbol: "Curve Gauge 2BTC-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: tBTC/WBTC",
		index: 62
	},
	{
		chainId: 1,
		address: "0x0e5bdb5afe132d1c6a6c67f6d8eb6133dd607e36",
		symbol: "Curve Gauge mkcrvUSD-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: mkUSD/crvUSD",
		index: 63
	},
	{
		chainId: 1,
		address: "0x731d19d122d6187cd64c44708dd8665fe8126fa8",
		symbol: "Curve Gauge crvsDAI-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD-sDAI",
		index: 66
	},
	{
		chainId: 1,
		address: "0x188a85362cc5e245a377294aa270c7758a203918",
		symbol: "Curve Gauge crvstUSDT-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD-stUSDT",
		index: 67
	},
	{
		chainId: 1,
		address: "0xd32f4be8f777ac27c6aad544457de6d4f17a1bfa",
		symbol: "Curve Gauge crvSTBT-f",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: crvUSD-STBT",
		index: 68
	},
	{
		chainId: 1,
		address: "0x85d44861d024cb7603ba906f2dc9569fc02083f6",
		symbol: "Curve Gauge crvUSDCWBTCWETH",
		decimals: 18,
		name: "Curve Gauge TricryptoUSDC",
		index: 69
	},
	{
		chainId: 1,
		address: "0xf29fff074f5cf755b55fbb3eb10a29203ac91ea2",
		symbol: "Curve Gauge crvUSDTWBTCWETH",
		decimals: 18,
		name: "Curve Gauge TricryptoUSDT",
		index: 70
	},
	{
		chainId: 1,
		address: "0x60d3d7ebbc44dc810a743703184f062d00e6db7e",
		symbol: "Curve Gauge crvCRVUSDTBTCWSTETH",
		decimals: 18,
		name: "Curve Gauge TricryptoLLAMA",
		index: 71
	},
	{
		chainId: 1,
		address: "0x4fc86cd0f9b650280fa783e3116258e0e0496a2c",
		symbol: "Curve Gauge crvUSDCWETHINV",
		decimals: 18,
		name: "Curve Gauge TricryptoINV",
		index: 72
	},
	{
		chainId: 1,
		address: "0x8d867bef70c6733ff25cc0d1caa8aa6c38b24817",
		symbol: "Curve Gauge crvUSDETHCRV",
		decimals: 18,
		name: "Curve Gauge TriCRV",
		index: 73
	},
	{
		chainId: 1,
		address: "0x5832c01c465e7c51b22ecb4f02d63081dbed2b28",
		symbol: "Curve Gauge 3SPool",
		decimals: 18,
		name: "Curve Gauge sUSD/snxUSD/wUSDA",
		index: 74
	},
	{
		chainId: 1,
		address: "0xfb3fd2825fe128c3aa7576a2b87be19880015cae",
		symbol: "Curve Gauge AMPHDUP",
		decimals: 18,
		name: "Curve Gauge WETH/AMPH/wUSDA",
		index: 75
	},
	{
		chainId: 1,
		address: "0xfbb82a8df175ab3ee94eae2fec1c43467d6cf222",
		symbol: "Curve Gauge AMPHDUP",
		decimals: 18,
		name: "Curve Gauge AMPH/WETH/wUSDA",
		index: 76
	},
	{
		chainId: 1,
		address: "0x23376482abc1403e24306d6d09da10df7f9c570f",
		symbol: "Curve Gauge AMPHDUP",
		decimals: 18,
		name: "Curve Gauge AMPH/wUSDA/WETH",
		index: 77
	},
	{
		chainId: 1,
		address: "0xa6aae326b8901a610db0d25e863b2a1b2f10cd4e",
		symbol: "Curve Gauge AMPHDUP",
		decimals: 18,
		name: "Curve Gauge AMPH/wUSDA/WETH",
		index: 78
	},
	{
		chainId: 1,
		address: "0xbb091d9a2ea48f35360420e5bee935663042bbc3",
		symbol: "Curve Gauge AMPHDUP",
		decimals: 18,
		name: "Curve Gauge AMPH/wUSDA/WETH",
		index: 79
	},
	{
		chainId: 1,
		address: "0xb901a92f2c385afa0a019e8a307a59a570239ca4",
		symbol: "Curve Gauge crvUSDETHSILO",
		decimals: 18,
		name: "Curve Gauge TriSILO",
		index: 80
	},
	{
		chainId: 1,
		address: "0x2b7822e663c856153ea1a36acead03dd3b7c6561",
		symbol: "Curve Gauge 3AMPH",
		decimals: 18,
		name: "Curve Gauge 3AMPH",
		index: 81
	},
	{
		chainId: 1,
		address: "0x8c94e9a3b68316fba06ba6666acdfc2dc7b7f623",
		symbol: "Curve Gauge OSAKETHcrvUSD",
		decimals: 18,
		name: "Curve Gauge TriOSAK",
		index: 82
	},
	{
		chainId: 1,
		address: "0xea012f5b25fa0d8e46123b85f585d0a5075e96b5",
		symbol: "Curve Gauge TryLSD",
		decimals: 18,
		name: "Curve Gauge TryLSD",
		index: 83
	},
	{
		chainId: 1,
		address: "0x33dc66f2808d8df2798e9e02ce15f8658ac6d0f8",
		symbol: "Curve Gauge triSDT",
		decimals: 18,
		name: "Curve Gauge triSDT",
		index: 84
	},
	{
		chainId: 1,
		address: "0x2dd2b7e07dd433b758b98a3889a63cbf48ef0d99",
		symbol: "Curve Gauge triSDT",
		decimals: 18,
		name: "Curve Gauge triSDT",
		index: 85
	},
	{
		chainId: 1,
		address: "0x5ccde4bec0f4006c3826b51edf0d227d12ea33fa",
		symbol: "Curve Gauge crvDBRINV",
		decimals: 18,
		name: "Curve Gauge TriDBR",
		index: 87
	},
	{
		chainId: 1,
		address: "0xab79226e4fbd6d299316c0964be9f417c8f920c9",
		symbol: "Curve Gauge crvUSDETHLDO",
		decimals: 18,
		name: "Curve Gauge TriLDO",
		index: 88
	}
];

var curveGaugeTokensArbitrum = [
	{
		chainId: 42161,
		address: "0xce5f24b7a95e9cba7df4b54e911b4a3dc8cdaf6f",
		symbol: "Curve Gauge USDC.e/USDT",
		decimals: 18,
		name: "Curve Gauge Curve.fi USDC/USDT",
		index: 0
	},
	{
		chainId: 42161,
		address: "0xc2b1df84112619d190193e48148000e3990bf627",
		symbol: "Curve Gauge WBTC/renBTC",
		decimals: 18,
		name: "Curve Gauge Curve.fi WBTC/renBTC",
		index: 1
	},
	{
		chainId: 42161,
		address: "0x555766f3da968ecbefa690ffd49a2ac02f47aa5f",
		symbol: "Curve Gauge crv3crypto",
		decimals: 18,
		name: "Curve Gauge Curve.fi USD-BTC-ETH",
		index: 2
	},
	{
		chainId: 42161,
		address: "0x95285ea6ff14f80a2fd3989a6bab993bd6b5fa13",
		symbol: "Curve Gauge FRAX/USDC.e",
		decimals: 18,
		name: "Curve Gauge Curve.fi Factory Plain Pool: FRAXBP",
		index: 4
	},
	{
		chainId: 42161,
		address: "0x098ef55011b6b8c99845128114a9d9159777d697",
		symbol: "Curve Gauge wstETHCRV",
		decimals: 18,
		name: "Curve Gauge Curve.fi ETH/wstETH",
		index: 5
	},
	{
		chainId: 42161,
		address: "0x555766f3da968ecbefa690ffd49a2ac02f47aa5f",
		symbol: "Curve Gauge crv3crypto",
		decimals: 18,
		name: "Curve Gauge Curve.fi USD-BTC-ETH",
		index: 6
	},
	{
		chainId: 42161,
		address: "0x6339ef8df0c2d3d3e7ee697e241666a916b81587",
		symbol: "Curve Gauge crvEURSUSD",
		decimals: 18,
		name: "Curve Gauge Curve EURS-2Crv",
		index: 7
	}
];

var curveLPTokens = [
	{
		chainId: 1,
		address: "0x6c3f90f043a72fa612cbac8115ee7e52bde6e490",
		symbol: "Curve LP 3Crv",
		decimals: 18,
		name: "Curve LP Curve.fi DAI/USDC/USDT",
		index: 0
	},
	{
		chainId: 1,
		address: "0xFd2a8fA60Abd58Efe3EeE34dd494cD491dC14900",
		symbol: "Curve LP a3CRV",
		decimals: 18,
		name: "Curve LP Curve.fi aDAI/aUSDC/aUSDT",
		index: 1
	},
	{
		chainId: 1,
		address: "0xaA17A236F2bAdc98DDc0Cf999AbB47D47Fc0A6Cf",
		symbol: "Curve LP ankrCRV",
		decimals: 18,
		name: "Curve LP Curve.fi ETH/aETH",
		index: 2
	},
	{
		chainId: 1,
		address: "0x3b3ac5386837dc563660fb6a0937dfaa5924333b",
		symbol: "Curve LP yDAI+yUSDC+yUSDT+yBUSD",
		decimals: 18,
		name: "Curve LP Curve.fi yDAI/yUSDC/yUSDT/yBUSD",
		index: 3
	},
	{
		chainId: 1,
		address: "0x845838df265dcd2c412a1dc9e959c7d08537f8a2",
		symbol: "Curve LP cDAI+cUSDC",
		decimals: 18,
		name: "Curve LP Curve.fi cDAI/cUSDC",
		index: 4
	},
	{
		chainId: 1,
		address: "0x194eBd173F6cDacE046C53eACcE9B953F28411d1",
		symbol: "Curve LP eursCRV",
		decimals: 18,
		name: "Curve LP Curve.fi EURS/sEUR",
		index: 5
	},
	{
		chainId: 1,
		address: "0xb19059ebb43466c323583928285a49f558e572fd",
		symbol: "Curve LP hCRV",
		decimals: 18,
		name: "Curve LP Curve.fi hBTC/wBTC",
		index: 6
	},
	{
		chainId: 1,
		address: "0x5282a4eF67D9C33135340fB3289cc1711c13638C",
		symbol: "Curve LP ib3CRV",
		decimals: 18,
		name: "Curve LP Curve.fi cyDAI/cyUSDC/cyUSDT",
		index: 7
	},
	{
		chainId: 1,
		address: "0xcee60cFa923170e4f8204AE08B4fA6A3F5656F3a",
		symbol: "Curve LP linkCRV",
		decimals: 18,
		name: "Curve LP Curve.fi LINK/sLINK",
		index: 8
	},
	{
		chainId: 1,
		address: "0xd905e2eaebe188fc92179b6350807d8bd91db0d8",
		symbol: "Curve LP ypaxCrv",
		decimals: 18,
		name: "Curve LP Curve.fi DAI/USDC/USDT/PAX",
		index: 9
	},
	{
		chainId: 1,
		address: "0x49849c98ae39fff122806c06791fa73784fb3675",
		symbol: "Curve LP crvRenWBTC",
		decimals: 18,
		name: "Curve LP Curve.fi renBTC/wBTC",
		index: 10
	},
	{
		chainId: 1,
		address: "0x02d341CcB60fAaf662bC0554d13778015d1b285C",
		symbol: "Curve LP saCRV",
		decimals: 18,
		name: "Curve LP Curve.fi aDAI/aSUSD",
		index: 11
	},
	{
		chainId: 1,
		address: "0x075b1bb99792c9e1041ba13afef80c91a1e70fb3",
		symbol: "Curve LP crvRenWSBTC",
		decimals: 18,
		name: "Curve LP Curve.fi renBTC/wBTC/sBTC",
		index: 12
	},
	{
		chainId: 1,
		address: "0xa3d87fffce63b53e0d54faa1cc983b7eb0b74a9c",
		symbol: "Curve LP eCRV",
		decimals: 18,
		name: "Curve LP Curve.fi ETH/sETH",
		index: 13
	},
	{
		chainId: 1,
		address: "0x06325440D014e39736583c165C2963BA99fAf14E",
		symbol: "Curve LP steCRV",
		decimals: 18,
		name: "Curve LP Curve.fi ETH/stETH",
		index: 14
	},
	{
		chainId: 1,
		address: "0xc25a3a3b969415c80451098fa907ec722572917f",
		symbol: "Curve LP crvPlain3andSUSD",
		decimals: 18,
		name: "Curve LP Curve.fi DAI/USDC/USDT/sUSD",
		index: 15
	},
	{
		chainId: 1,
		address: "0x9fc689ccada600b6df723d9e47d84d76664a1f23",
		symbol: "Curve LP cDAI+cUSDC+USDT",
		decimals: 18,
		name: "Curve LP Curve.fi cDAI/cUSDC/USDT",
		index: 16
	},
	{
		chainId: 1,
		address: "0xdf5e0e81dff6faf3a7e52ba697820c5e32d806a8",
		symbol: "Curve LP yDAI+yUSDC+yUSDT+yTUSD",
		decimals: 18,
		name: "Curve LP Curve.fi yDAI/yUSDC/yUSDT/yTUSD",
		index: 17
	},
	{
		chainId: 1,
		address: "0x3a664ab939fd8482048609f652f9a0b0677337b9",
		symbol: "Curve LP dusd3CRV",
		decimals: 18,
		name: "Curve LP Curve.fi DUSD/3Crv",
		index: 18
	},
	{
		chainId: 1,
		address: "0xd2967f45c4f384deea880f807be904762a3dea07",
		symbol: "Curve LP gusd3CRV",
		decimals: 18,
		name: "Curve LP Curve.fi GUSD/3Crv",
		index: 19
	},
	{
		chainId: 1,
		address: "0x5B5CFE992AdAC0C9D48E05854B2d91C73a003858",
		symbol: "Curve LP husd3CRV",
		decimals: 18,
		name: "Curve LP Curve.fi HUSD/3Crv",
		index: 20
	},
	{
		chainId: 1,
		address: "0x6d65b498cb23deaba52db31c93da9bffb340fb8f",
		symbol: "Curve LP LinkUSD3CRV",
		decimals: 18,
		name: "Curve LP Curve.fi LinkUSD/3Crv",
		index: 21
	},
	{
		chainId: 1,
		address: "0x1aef73d49dedc4b1778d0706583995958dc862e6",
		symbol: "Curve LP musd3CRV",
		decimals: 18,
		name: "Curve LP Curve.fi MUSD/3Crv",
		index: 22
	},
	{
		chainId: 1,
		address: "0xc2ee6b0334c261ed60c72f6054450b61b8f18e35",
		symbol: "Curve LP rsv3CRV",
		decimals: 18,
		name: "Curve LP Curve.fi RSV/3Crv",
		index: 23
	},
	{
		chainId: 1,
		address: "0x97e2768e8e73511ca874545dc5ff8067eb19b787",
		symbol: "Curve LP usdk3CRV",
		decimals: 18,
		name: "Curve LP Curve.fi USDK/3Crv",
		index: 24
	},
	{
		chainId: 1,
		address: "0x4f3e8f405cf5afc05d68142f3783bdfe13811522",
		symbol: "Curve LP usdn3CRV",
		decimals: 18,
		name: "Curve LP Curve.fi USDN/3Crv",
		index: 25
	},
	{
		chainId: 1,
		address: "0x7Eb40E450b9655f4B3cC4259BCC731c63ff55ae6",
		symbol: "Curve LP usdp3CRV",
		decimals: 18,
		name: "Curve LP Curve.fi USDP/3Crv",
		index: 26
	},
	{
		chainId: 1,
		address: "0x94e131324b6054c0D789b190b2dAC504e4361b53",
		symbol: "Curve LP ust3CRV",
		decimals: 18,
		name: "Curve LP Curve.fi UST/3Crv",
		index: 27
	},
	{
		chainId: 1,
		address: "0x410e3E86ef427e30B9235497143881f717d93c2A",
		symbol: "Curve LP bBTC/sbtcCRV",
		decimals: 18,
		name: "Curve LP Curve.fi bBTC/sbtcCRV",
		index: 28
	},
	{
		chainId: 1,
		address: "0x2fE94ea3d5d4a175184081439753DE15AeF9d614",
		symbol: "Curve LP oBTC/sbtcCRV",
		decimals: 18,
		name: "Curve LP Curve.fi oBTC/sbtcCRV",
		index: 29
	},
	{
		chainId: 1,
		address: "0xDE5331AC4B3630f94853Ff322B66407e0D6331E8",
		symbol: "Curve LP pBTC/sbtcCRV",
		decimals: 18,
		name: "Curve LP Curve.fi pBTC/sbtcCRV",
		index: 30
	},
	{
		chainId: 1,
		address: "0x64eda51d3Ad40D56b9dFc5554E06F94e1Dd786Fd",
		symbol: "Curve LP tbtc/sbtcCrv",
		decimals: 18,
		name: "Curve LP Curve.fi tBTC/sbtcCrv",
		index: 31
	},
	{
		chainId: 1,
		address: "0x53a901d48795C58f485cBB38df08FA96a24669D5",
		symbol: "Curve LP rCRV",
		decimals: 18,
		name: "Curve LP Curve.fi ETH/rETH",
		index: 36
	},
	{
		chainId: 1,
		address: "0xcA3d75aC011BF5aD07a98d02f18225F9bD9A6BDF",
		symbol: "Curve LP crvTricrypto",
		decimals: 18,
		name: "Curve LP Curve.fi USD-BTC-ETH",
		index: 38
	},
	{
		chainId: 1,
		address: "0x6BA5b4e438FA0aAf7C1bD179285aF65d13bD3D90",
		symbol: "Curve LP RAI3CRV",
		decimals: 18,
		name: "Curve LP RAI3CRV",
		index: 39
	},
	{
		chainId: 1,
		address: "0x3175Df0976dFA876431C2E9eE6Bc45b65d3473CC",
		symbol: "Curve LP crvFRAX",
		decimals: 18,
		name: "Curve LP Curve.fi FRAX/USDC",
		index: 44
	},
	{
		chainId: 1,
		address: "0xf43211935C781D5ca1a41d2041F397B8A7366C7A",
		symbol: "Curve LP frxETHCRV",
		decimals: 18,
		name: "Curve LP Curve.fi ETH/frxETH",
		index: 45
	},
	{
		chainId: 1,
		address: "0x4DEcE678ceceb27446b35C672dC7d61F30bAD69E",
		symbol: "Curve LP crvUSDUSDC-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD/USDC",
		index: 46
	},
	{
		chainId: 1,
		address: "0x390f3595bCa2Df7d23783dFd126427CCeb997BF4",
		symbol: "Curve LP crvUSDUSDT-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD/USDT",
		index: 47
	},
	{
		chainId: 1,
		address: "0xCa978A0528116DDA3cbA9ACD3e68bc6191CA53D0",
		symbol: "Curve LP crvUSDUSDP-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD/USDP",
		index: 48
	},
	{
		chainId: 1,
		address: "0x34D655069F4cAc1547E4C8cA284FfFF5ad4A8db0",
		symbol: "Curve LP crvUSDTUSD-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD/TUSD",
		index: 49
	},
	{
		chainId: 1,
		address: "0x0CD6f267b2086bea681E922E19D40512511BE538",
		symbol: "Curve LP crvUSDFRAX-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD/Frax",
		index: 50
	},
	{
		chainId: 1,
		address: "0x58B94400bdAd7b9ac8d5335E12eF96E8B4966b4a",
		symbol: "Curve LP crvUSDDAI-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD/DAI",
		index: 51
	},
	{
		chainId: 1,
		address: "0xBe426b0f37c112dd20d5866769c8034171567b31",
		symbol: "Curve LP crvUSDMIM-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD/MIM",
		index: 52
	},
	{
		chainId: 1,
		address: "0x94cC50e4521bD271C1a997a3A4Dc815C2F920b41",
		symbol: "Curve LP crvUSDSUSD-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD/SUSD",
		index: 53
	},
	{
		chainId: 1,
		address: "0x86152dF0a0E321Afb3B0B9C4deb813184F365ADa",
		symbol: "Curve LP crvUSDGHO-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD/GHO",
		index: 54
	},
	{
		chainId: 1,
		address: "0x1982Fe483f4bff067A2183c98fA231423d41E92B",
		symbol: "Curve LP crvUSDMAI-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD/MAI",
		index: 55
	},
	{
		chainId: 1,
		address: "0xA8a02c7D9ada50444F8c658F43Dc440675B21797",
		symbol: "Curve LP crvUSDXAI-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD/XAI",
		index: 56
	},
	{
		chainId: 1,
		address: "0xfC636D819d1a98433402eC9dEC633d864014F28C",
		symbol: "Curve LP crvUSDUZD-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD/UZD",
		index: 57
	},
	{
		chainId: 1,
		address: "0x8272E1A3dBef607C04AA6e5BD3a1A134c8ac063B",
		symbol: "Curve LP crvUSDDOLA-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD/DOLA",
		index: 58
	},
	{
		chainId: 1,
		address: "0xeCDd0cE505da71cd9dE855CD6804BA1e8C7bdB07",
		symbol: "Curve LP crvUSDGUSD-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD/GUSD",
		index: 59
	},
	{
		chainId: 1,
		address: "0xAe9e8c9A548505c9ad22a412354186151363c09e",
		symbol: "Curve LP crvUSDeUSD-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD/eUSD",
		index: 60
	},
	{
		chainId: 1,
		address: "0x9c3B46C0Ceb5B9e304FCd6D88Fc50f7DD24B31Bc",
		symbol: "Curve LP frxeth-ng-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: frxETH/WETH",
		index: 61
	},
	{
		chainId: 1,
		address: "0xB7ECB2AA52AA64a717180E030241bC75Cd946726",
		symbol: "Curve LP 2BTC-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: tBTC/WBTC",
		index: 62
	},
	{
		chainId: 1,
		address: "0x3de254A0f838a844F727fee81040e0FA7884B935",
		symbol: "Curve LP mkcrvUSD-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: mkUSD/crvUSD",
		index: 63
	},
	{
		chainId: 1,
		address: "0x143B33AF57172E2FBF67F30B3A4d49e7f0199EeC",
		symbol: "Curve LP crvsDAI-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD<>sDAI",
		index: 64
	},
	{
		chainId: 1,
		address: "0xb7be2211430D8b59BFCBcA029c2f3a2577369A19",
		symbol: "Curve LP crvstUSDT-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD<>stUSDT",
		index: 65
	},
	{
		chainId: 1,
		address: "0xAcfFeB3DD13Ca770976deB3deaD62D4Eb5cf0ac4",
		symbol: "Curve LP crvsDAI-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD-sDAI",
		index: 66
	},
	{
		chainId: 1,
		address: "0xB9eC78Bd89d3Ef17537f130CC72750FD4DE85f82",
		symbol: "Curve LP crvstUSDT-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD-stUSDT",
		index: 67
	},
	{
		chainId: 1,
		address: "0x707EAe1CcFee0B8fef07D3F18EAFD1246762d587",
		symbol: "Curve LP crvSTBT-f",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: crvUSD-STBT",
		index: 68
	},
	{
		chainId: 1,
		address: "0x7F86Bf177Dd4F3494b841a37e810A34dD56c829B",
		symbol: "Curve LP crvUSDCWBTCWETH",
		decimals: 18,
		name: "Curve LP TricryptoUSDC",
		index: 69
	},
	{
		chainId: 1,
		address: "0xf5f5B97624542D72A9E06f04804Bf81baA15e2B4",
		symbol: "Curve LP crvUSDTWBTCWETH",
		decimals: 18,
		name: "Curve LP TricryptoUSDT",
		index: 70
	},
	{
		chainId: 1,
		address: "0x2889302a794dA87fBF1D6Db415C1492194663D13",
		symbol: "Curve LP crvCRVUSDTBTCWSTETH",
		decimals: 18,
		name: "Curve LP TricryptoLLAMA",
		index: 71
	},
	{
		chainId: 1,
		address: "0x5426178799ee0a0181A89b4f57eFddfAb49941Ec",
		symbol: "Curve LP crvUSDCWETHINV",
		decimals: 18,
		name: "Curve LP TricryptoINV",
		index: 72
	},
	{
		chainId: 1,
		address: "0x4eBdF703948ddCEA3B11f675B4D1Fba9d2414A14",
		symbol: "Curve LP crvUSDETHCRV",
		decimals: 18,
		name: "Curve LP TriCRV",
		index: 73
	},
	{
		chainId: 1,
		address: "0x9847a74fB7C3c4362220f616E15b83A58527F7E4",
		symbol: "Curve LP 3SPool",
		decimals: 18,
		name: "Curve LP sUSD/snxUSD/wUSDA",
		index: 74
	},
	{
		chainId: 1,
		address: "0xdcafD1914afDBC5788B701F47283CaeEAa5FBAed",
		symbol: "Curve LP AMPHDUP",
		decimals: 18,
		name: "Curve LP WETH/AMPH/wUSDA",
		index: 75
	},
	{
		chainId: 1,
		address: "0x05CA1ff6fF45e55906c86Ad0d3FB2EbFaE9E0891",
		symbol: "Curve LP AMPHDUP",
		decimals: 18,
		name: "Curve LP AMPH/WETH/wUSDA",
		index: 76
	},
	{
		chainId: 1,
		address: "0x037164C912f9733A0973B18EE339FBeF66cfd2C2",
		symbol: "Curve LP AMPHDUP",
		decimals: 18,
		name: "Curve LP AMPH/wUSDA/WETH",
		index: 77
	},
	{
		chainId: 1,
		address: "0x3921e2cb3Ac3bC009Fa4ec5Ea1ee0bc7FA4Be4C1",
		symbol: "Curve LP AMPHDUP",
		decimals: 18,
		name: "Curve LP AMPH/wUSDA/WETH",
		index: 78
	},
	{
		chainId: 1,
		address: "0x38AB39c82BE45f660AFa4A74E85dAd4b4aDd0492",
		symbol: "Curve LP AMPHDUP",
		decimals: 18,
		name: "Curve LP AMPH/wUSDA/WETH",
		index: 79
	},
	{
		chainId: 1,
		address: "0x86bF09aCB47AB31686bE413d614E9ded3666a1d3",
		symbol: "Curve LP crvUSDETHSILO",
		decimals: 18,
		name: "Curve LP TriSILO",
		index: 80
	},
	{
		chainId: 1,
		address: "0x50120e3348287C6d001E455f5b00FeA07A875541",
		symbol: "Curve LP 3AMPH",
		decimals: 18,
		name: "Curve LP 3AMPH",
		index: 81
	},
	{
		chainId: 1,
		address: "0x6A62EE3e5c4b412Cd9167D3aFd5E481e1E30715a",
		symbol: "Curve LP OSAKETHcrvUSD",
		decimals: 18,
		name: "Curve LP TriOSAK",
		index: 82
	},
	{
		chainId: 1,
		address: "0x2570f1bD5D2735314FC102eb12Fc1aFe9e6E7193",
		symbol: "Curve LP TryLSD",
		decimals: 18,
		name: "Curve LP TryLSD",
		index: 83
	},
	{
		chainId: 1,
		address: "0x56aEFfd9935ACabF21543701212d67aD529F7f2e",
		symbol: "Curve LP triSDT",
		decimals: 18,
		name: "Curve LP triSDT",
		index: 84
	},
	{
		chainId: 1,
		address: "0x954313005C56b555bdC41B84D6c63B69049d7847",
		symbol: "Curve LP triSDT",
		decimals: 18,
		name: "Curve LP triSDT",
		index: 85
	},
	{
		chainId: 1,
		address: "0x1Ac76b6e2926ff475969d22a2258449a4600E006",
		symbol: "Curve LP AMPHDUP",
		decimals: 18,
		name: "Curve LP AMPH/WETH/wUSDA",
		index: 86
	},
	{
		chainId: 1,
		address: "0xC7DE47b9Ca2Fc753D6a2F167D8b3e19c6D18b19a",
		symbol: "Curve LP crvDBRINV",
		decimals: 18,
		name: "Curve LP TriDBR",
		index: 87
	},
	{
		chainId: 1,
		address: "0x5b3BA844b3859f56524e99Ae54857b36c8Ae3eFE",
		symbol: "Curve LP crvUSDETHLDO",
		decimals: 18,
		name: "Curve LP TriLDO",
		index: 88
	},
	{
		chainId: 1,
		address: "0x8e2b641271544300e59d14E27520DEA204056D66",
		symbol: "Curve LP crvRSReUSD",
		decimals: 18,
		name: "Curve LP TriRSR",
		index: 89
	},
	{
		chainId: 1,
		address: "0xDB6925eA42897ca786a045B252D95aA7370f44b4",
		symbol: "Curve LP crvRSReUSDETH+",
		decimals: 18,
		name: "Curve LP TriRSR",
		index: 90
	}
];

var curveLPTokensArbitrum = [
	{
		chainId: 42161,
		address: "0x7f90122BF0700F9E7e1F688fe926940E8839F353",
		symbol: "Curve LP USDC.e/USDT",
		decimals: 18,
		name: "Curve LP Curve.fi USDC/USDT",
		index: 0
	},
	{
		chainId: 42161,
		address: "0x3E01dD8a5E1fb3481F0F589056b428Fc308AF0Fb",
		symbol: "Curve LP WBTC/renBTC",
		decimals: 18,
		name: "Curve LP Curve.fi WBTC/renBTC",
		index: 1
	},
	{
		chainId: 42161,
		address: "0x8e0B8c8BB9db49a46697F3a5Bb8A308e744821D2",
		symbol: "Curve LP crv3crypto",
		decimals: 18,
		name: "Curve LP Curve.fi USD-BTC-ETH",
		index: 2
	},
	{
		chainId: 42161,
		address: "0x30dF229cefa463e991e29D42DB0bae2e122B2AC7",
		symbol: "Curve LP MIM/2CRV",
		decimals: 18,
		name: "Curve LP Curve.fi Factory USD Metapool: MIM",
		index: 3
	},
	{
		chainId: 42161,
		address: "0xC9B8a3FDECB9D5b218d02555a8Baf332E5B740d5",
		symbol: "Curve LP FRAX/USDC.e",
		decimals: 18,
		name: "Curve LP Curve.fi Factory Plain Pool: FRAXBP",
		index: 4
	},
	{
		chainId: 42161,
		address: "0xDbcD16e622c95AcB2650b38eC799f76BFC557a0b",
		symbol: "Curve LP wstETHCRV",
		decimals: 18,
		name: "Curve LP Curve.fi ETH/wstETH",
		index: 5
	},
	{
		chainId: 42161,
		address: "0x8e0B8c8BB9db49a46697F3a5Bb8A308e744821D2",
		symbol: "Curve LP crv3crypto",
		decimals: 18,
		name: "Curve LP Curve.fi USD-BTC-ETH",
		index: 6
	},
	{
		chainId: 42161,
		address: "0x3dFe1324A0ee9d86337d06aEB829dEb4528DB9CA",
		symbol: "Curve LP crvEURSUSD",
		decimals: 18,
		name: "Curve LP Curve EURS-2Crv",
		index: 7
	}
];

var ETHAddresses = [
	{
		name: "Ether",
		address: "0x0000000000000000000000000000000000000000",
		symbol: "ETH",
		decimals: 18,
		chainId: 1,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
	},
	{
		name: "Ether",
		address: "0x0000000000000000000000000000000000000000",
		symbol: "ETH",
		decimals: 18,
		chainId: 5,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
	}
];

var RadiantV2RTokens = [
	{
		symbol: "rWBTC",
		address: "0x727354712BDFcd8596a3852Fd2065b3C34F4F770",
		decimals: 8,
		underlying: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
		chainId: 42161
	},
	{
		symbol: "rUSDT",
		address: "0xd69D402D1bDB9A2b8c3d88D98b9CEaf9e4Cd72d9",
		decimals: 8,
		underlying: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
		chainId: 42161
	},
	{
		symbol: "rUSDC",
		address: "0x48a29E756CC1C097388f3B2f3b570ED270423b3d",
		decimals: 8,
		underlying: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
		chainId: 42161
	},
	{
		symbol: "rDAI",
		address: "0x0D914606f3424804FA1BbBE56CCC3416733acEC6",
		decimals: 8,
		underlying: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
		chainId: 42161
	},
	{
		symbol: "rWETH",
		address: "0x0dF5dfd95966753f01cb80E76dc20EA958238C46",
		decimals: 8,
		underlying: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
		chainId: 42161
	},
	{
		symbol: "rWSTETH",
		address: "0x42C248D137512907048021B30d9dA17f48B5b7B2",
		decimals: 8,
		underlying: "0x5979D7b546E38E414F7E9822514be443A4800529",
		chainId: 42161
	},
	{
		symbol: "rARB",
		address: "0x2dADe5b7df9DA3a7e1c9748d169Cd6dFf77e3d01",
		decimals: 8,
		underlying: "0x912CE59144191C1204E64559FE8253a0e49E6548",
		chainId: 42161
	}
];

var uniswapDefaultErc20 = [
	{
		chainId: 1,
		address: "0x111111111117dC0aa78b770fA6A738034120C302",
		name: "1inch",
		symbol: "1INCH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13469/thumb/1inch-token.png?1608803028"
	},
	{
		chainId: 1,
		address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
		name: "Aave",
		symbol: "AAVE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12645/thumb/AAVE.png?1601374110"
	},
	{
		chainId: 1,
		address: "0xB98d4C97425d9908E66E53A6fDf673ACcA0BE986",
		name: "Arcblock",
		symbol: "ABT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2341/thumb/arcblock.png?1547036543"
	},
	{
		chainId: 1,
		address: "0xEd04915c23f00A313a544955524EB7DBD823143d",
		name: "Alchemy Pay",
		symbol: "ACH",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/12390/thumb/ACH_%281%29.png?1599691266"
	},
	{
		chainId: 1,
		address: "0xADE00C28244d5CE17D72E40330B1c318cD12B7c3",
		name: "Ambire AdEx",
		symbol: "ADX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/847/thumb/Ambire_AdEx_Symbol_color.png?1655432540"
	},
	{
		chainId: 1,
		address: "0x91Af0fBB28ABA7E31403Cb457106Ce79397FD4E6",
		name: "Aergo",
		symbol: "AERGO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4490/thumb/aergo.png?1647696770"
	},
	{
		chainId: 1,
		address: "0x32353A6C91143bfd6C7d363B546e62a9A2489A20",
		name: "Adventure Gold",
		symbol: "AGLD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/18125/thumb/lpgblc4h_400x400.jpg?1630570955"
	},
	{
		chainId: 1,
		address: "0x626E8036dEB333b408Be468F951bdB42433cBF18",
		name: "AIOZ Network",
		symbol: "AIOZ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14631/thumb/aioz_logo.png?1617413126"
	},
	{
		chainId: 1,
		address: "0xdBdb4d16EdA451D0503b854CF79D55697F90c8DF",
		name: "Alchemix",
		symbol: "ALCX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14113/thumb/Alchemix.png?1614409874"
	},
	{
		chainId: 1,
		address: "0x27702a26126e0B3702af63Ee09aC4d1A084EF628",
		name: "Aleph im",
		symbol: "ALEPH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11676/thumb/Monochram-aleph.png?1608483725"
	},
	{
		chainId: 1,
		address: "0x6B0b3a982b4634aC68dD83a4DBF02311cE324181",
		name: "Alethea Artificial Liquid Intelligence",
		symbol: "ALI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/22062/thumb/alethea-logo-transparent-colored.png?1642748848"
	},
	{
		chainId: 1,
		address: "0xAC51066d7bEC65Dc4589368da368b212745d63E8",
		name: "My Neighbor Alice",
		symbol: "ALICE",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/14375/thumb/alice_logo.jpg?1615782968"
	},
	{
		chainId: 1,
		address: "0xa1faa113cbE53436Df28FF0aEe54275c13B40975",
		name: "Alpha Venture DAO",
		symbol: "ALPHA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12738/thumb/AlphaToken_256x256.png?1617160876"
	},
	{
		chainId: 1,
		address: "0xfF20817765cB7f73d4bde2e66e067E58D11095C2",
		name: "Amp",
		symbol: "AMP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12409/thumb/amp-200x200.png?1599625397"
	},
	{
		chainId: 1,
		address: "0x8290333ceF9e6D528dD5618Fb97a76f268f3EDD4",
		name: "Ankr",
		symbol: "ANKR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4324/thumb/U85xTl2.png?1608111978"
	},
	{
		chainId: 1,
		address: "0xa117000000f279D81A1D3cc75430fAA017FA5A2e",
		name: "Aragon",
		symbol: "ANT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/681/thumb/JelZ58cv_400x400.png?1601449653"
	},
	{
		chainId: 1,
		address: "0x4d224452801ACEd8B2F0aebE155379bb5D594381",
		name: "ApeCoin",
		symbol: "APE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/24383/small/apecoin.jpg?1647476455"
	},
	{
		chainId: 1,
		address: "0x0b38210ea11411557c13457D4dA7dC6ea731B88a",
		name: "API3",
		symbol: "API3",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13256/thumb/api3.jpg?1606751424"
	},
	{
		chainId: 1,
		address: "0xBA50933C268F567BDC86E1aC131BE072C6B0b71a",
		name: "ARPA Chain",
		symbol: "ARPA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/8506/thumb/9u0a23XY_400x400.jpg?1559027357"
	},
	{
		chainId: 1,
		address: "0x64D91f12Ece7362F91A6f8E7940Cd55F05060b92",
		name: "ASH",
		symbol: "ASH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15714/thumb/omnPqaTY.png?1622820503"
	},
	{
		chainId: 1,
		address: "0x2565ae0385659badCada1031DB704442E1b69982",
		name: "Assemble Protocol",
		symbol: "ASM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11605/thumb/gpvrlkSq_400x400_%281%29.jpg?1591775789"
	},
	{
		chainId: 1,
		address: "0x27054b13b1B798B345b591a4d22e6562d47eA75a",
		name: "AirSwap",
		symbol: "AST",
		decimals: 4,
		logoURI: "https://assets.coingecko.com/coins/images/1019/thumb/Airswap.png?1630903484"
	},
	{
		chainId: 1,
		address: "0xA2120b9e674d3fC3875f415A7DF52e382F141225",
		name: "Automata",
		symbol: "ATA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15985/thumb/ATA.jpg?1622535745"
	},
	{
		chainId: 1,
		address: "0xA9B1Eb5908CfC3cdf91F9B8B3a74108598009096",
		name: "Bounce",
		symbol: "AUCTION",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13860/thumb/1_KtgpRIJzuwfHe0Rl0avP_g.jpeg?1612412025"
	},
	{
		chainId: 1,
		address: "0x18aAA7115705e8be94bfFEBDE57Af9BFc265B998",
		name: "Audius",
		symbol: "AUDIO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12913/thumb/AudiusCoinLogo_2x.png?1603425727"
	},
	{
		chainId: 1,
		address: "0x845576c64f9754CF09d87e45B720E82F3EeF522C",
		name: "Artverse Token",
		symbol: "AVT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/19727/thumb/ewnektoB_400x400.png?1635767094"
	},
	{
		chainId: 1,
		address: "0xBB0E17EF65F82Ab018d8EDd776e8DD940327B28b",
		name: "Axie Infinity",
		symbol: "AXS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13029/thumb/axie_infinity_logo.png?1604471082"
	},
	{
		chainId: 1,
		address: "0x3472A5A71965499acd81997a54BBA8D852C6E53d",
		name: "Badger DAO",
		symbol: "BADGER",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13287/thumb/badger_dao_logo.jpg?1607054976"
	},
	{
		chainId: 1,
		address: "0xba100000625a3754423978a60c9317c58a424e3D",
		name: "Balancer",
		symbol: "BAL",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xba100000625a3754423978a60c9317c58a424e3D/logo.png"
	},
	{
		chainId: 1,
		address: "0xBA11D00c5f74255f56a5E366F4F77f5A186d7f55",
		name: "Band Protocol",
		symbol: "BAND",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9545/thumb/band-protocol.png?1568730326"
	},
	{
		chainId: 1,
		address: "0x0D8775F648430679A709E98d2b0Cb6250d2887EF",
		name: "Basic Attention Token",
		symbol: "BAT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/677/thumb/basic-attention-token.png?1547034427"
	},
	{
		chainId: 1,
		address: "0xF17e65822b568B3903685a7c9F496CF7656Cc6C2",
		name: "Biconomy",
		symbol: "BICO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/21061/thumb/biconomy_logo.jpg?1638269749"
	},
	{
		chainId: 1,
		address: "0x1A4b46696b2bB4794Eb3D4c26f1c55F9170fa4C5",
		name: "BitDAO",
		symbol: "BIT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17627/thumb/rI_YptK8.png?1653983088"
	},
	{
		chainId: 1,
		address: "0x5732046A883704404F284Ce41FfADd5b007FD668",
		name: "Bluzelle",
		symbol: "BLZ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2848/thumb/ColorIcon_3x.png?1622516510"
	},
	{
		chainId: 1,
		address: "0x1F573D6Fb3F13d689FF844B4cE37794d79a7FF1C",
		name: "Bancor Network Token",
		symbol: "BNT",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x1F573D6Fb3F13d689FF844B4cE37794d79a7FF1C/logo.png"
	},
	{
		chainId: 1,
		address: "0x42bBFa2e77757C645eeaAd1655E0911a7553Efbc",
		name: "Boba Network",
		symbol: "BOBA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/20285/thumb/BOBA.png?1636811576"
	},
	{
		chainId: 1,
		address: "0x0391D2021f89DC339F60Fff84546EA23E337750f",
		name: "BarnBridge",
		symbol: "BOND",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12811/thumb/barnbridge.jpg?1602728853"
	},
	{
		chainId: 1,
		address: "0x799ebfABE77a6E34311eeEe9825190B9ECe32824",
		name: "Braintrust",
		symbol: "BTRST",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/18100/thumb/braintrust.PNG?1630475394"
	},
	{
		chainId: 1,
		address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
		name: "Binance USD",
		symbol: "BUSD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9576/thumb/BUSD.png?1568947766"
	},
	{
		chainId: 1,
		address: "0xAE12C5930881c53715B369ceC7606B70d8EB229f",
		name: "Coin98",
		symbol: "C98",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17117/thumb/logo.png?1626412904"
	},
	{
		chainId: 1,
		address: "0x4F9254C83EB525f9FCf346490bbb3ed28a81C667",
		name: "Celer Network",
		symbol: "CELR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4379/thumb/Celr.png?1554705437"
	},
	{
		chainId: 1,
		address: "0x8A2279d4A90B6fe1C4B30fa660cC9f926797bAA2",
		name: "Chromia",
		symbol: "CHR",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/5000/thumb/Chromia.png?1559038018"
	},
	{
		chainId: 1,
		address: "0x3506424F91fD33084466F402d5D97f05F8e3b4AF",
		name: "Chiliz",
		symbol: "CHZ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/8834/thumb/Chiliz.png?1561970540"
	},
	{
		chainId: 1,
		address: "0x80C62FE4487E1351b47Ba49809EBD60ED085bf52",
		name: "Clover Finance",
		symbol: "CLV",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15278/thumb/clover.png?1645084454"
	},
	{
		chainId: 1,
		address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
		name: "Compound",
		symbol: "COMP",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xc00e94Cb662C3520282E6f5717214004A7f26888/logo.png"
	},
	{
		chainId: 1,
		address: "0xDDB3422497E61e13543BeA06989C0789117555c5",
		name: "COTI",
		symbol: "COTI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2962/thumb/Coti.png?1559653863"
	},
	{
		chainId: 1,
		address: "0x3D658390460295FB963f54dC0899cfb1c30776Df",
		name: "Circuits of Value",
		symbol: "COVAL",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/588/thumb/coval-logo.png?1599493950"
	},
	{
		chainId: 1,
		address: "0xD417144312DbF50465b1C641d016962017Ef6240",
		name: "Covalent",
		symbol: "CQT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14168/thumb/covalent-cqt.png?1624545218"
	},
	{
		chainId: 1,
		address: "0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b",
		name: "Cronos",
		symbol: "CRO",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/7310/thumb/oCw2s3GI_400x400.jpeg?1645172042"
	},
	{
		chainId: 1,
		address: "0x08389495D7456E1951ddF7c3a1314A4bfb646d8B",
		name: "Crypterium",
		symbol: "CRPT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/1901/thumb/crypt.png?1547036205"
	},
	{
		chainId: 1,
		address: "0xD533a949740bb3306d119CC777fa900bA034cd52",
		name: "Curve DAO Token",
		symbol: "CRV",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xD533a949740bb3306d119CC777fa900bA034cd52/logo.png"
	},
	{
		chainId: 1,
		address: "0x491604c0FDF08347Dd1fa4Ee062a822A5DD06B5D",
		name: "Cartesi",
		symbol: "CTSI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11038/thumb/cartesi.png?1592288021"
	},
	{
		chainId: 1,
		address: "0x321C2fE4446C7c963dc41Dd58879AF648838f98D",
		name: "Cryptex Finance",
		symbol: "CTX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14932/thumb/glossy_icon_-_C200px.png?1619073171"
	},
	{
		chainId: 1,
		address: "0xDf801468a808a32656D2eD2D2d80B72A129739f4",
		name: "Somnium Space CUBEs",
		symbol: "CUBE",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/10687/thumb/CUBE_icon.png?1617026861"
	},
	{
		chainId: 1,
		address: "0x41e5560054824eA6B0732E656E3Ad64E20e94E45",
		name: "Civic",
		symbol: "CVC",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/788/thumb/civic.png?1547034556"
	},
	{
		chainId: 1,
		address: "0x4e3FBD56CD56c3e72c1403e103b45Db9da5B9D2B",
		name: "Convex Finance",
		symbol: "CVX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15585/thumb/convex.png?1621256328"
	},
	{
		chainId: 1,
		address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
		name: "Dai Stablecoin",
		symbol: "DAI",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png"
	},
	{
		chainId: 1,
		address: "0x081131434f93063751813C619Ecca9C4dC7862a3",
		name: "Mines of Dalarnia",
		symbol: "DAR",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/19837/thumb/dar.png?1636014223"
	},
	{
		chainId: 1,
		address: "0x3A880652F47bFaa771908C07Dd8673A787dAEd3A",
		name: "DerivaDAO",
		symbol: "DDX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13453/thumb/ddx_logo.png?1608741641"
	},
	{
		chainId: 1,
		address: "0x3597bfD533a99c9aa083587B074434E61Eb0A258",
		name: "Dent",
		symbol: "DENT",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/1152/thumb/gLCEA2G.png?1604543239"
	},
	{
		chainId: 1,
		address: "0xfB7B4564402E5500dB5bB6d63Ae671302777C75a",
		name: "DexTools",
		symbol: "DEXT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11603/thumb/dext.png?1605790188"
	},
	{
		chainId: 1,
		address: "0x84cA8bc7997272c7CfB4D0Cd3D55cd942B3c9419",
		name: "DIA",
		symbol: "DIA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11955/thumb/image.png?1646041751"
	},
	{
		chainId: 1,
		address: "0x0AbdAce70D3790235af448C88547603b945604ea",
		name: "district0x",
		symbol: "DNT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/849/thumb/district0x.png?1547223762"
	},
	{
		chainId: 1,
		address: "0x1494CA1F11D487c2bBe4543E90080AeBa4BA3C2b",
		name: "DeFi Pulse Index",
		symbol: "DPI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12465/thumb/defi_pulse_index_set.png?1600051053"
	},
	{
		chainId: 1,
		address: "0x3Ab6Ed69Ef663bd986Ee59205CCaD8A20F98b4c2",
		name: "Drep",
		symbol: "DREP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14578/thumb/KotgsCgS_400x400.jpg?1617094445"
	},
	{
		chainId: 1,
		address: "0x92D6C1e31e14520e676a687F0a93788B716BEff5",
		name: "dYdX",
		symbol: "DYDX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17500/thumb/hjnIm9bV.jpg?1628009360"
	},
	{
		chainId: 1,
		address: "0x961C8c0B1aaD0c0b10a51FeF6a867E3091BCef17",
		name: "DeFi Yield Protocol",
		symbol: "DYP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13480/thumb/DYP_Logo_Symbol-8.png?1655809066"
	},
	{
		chainId: 1,
		address: "0xe6fd75ff38Adca4B97FBCD938c86b98772431867",
		name: "Elastos",
		symbol: "ELA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2780/thumb/Elastos.png?1597048112"
	},
	{
		chainId: 1,
		address: "0x761D38e5ddf6ccf6Cf7c55759d5210750B5D60F3",
		name: "Dogelon Mars",
		symbol: "ELON",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14962/thumb/6GxcPRo3_400x400.jpg?1619157413"
	},
	{
		chainId: 1,
		address: "0xF629cBd94d3791C9250152BD8dfBDF380E2a3B9c",
		name: "Enjin Coin",
		symbol: "ENJ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/1102/thumb/enjin-coin-logo.png?1547035078"
	},
	{
		chainId: 1,
		address: "0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72",
		name: "Ethereum Name Service",
		symbol: "ENS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/19785/thumb/acatxTm8_400x400.jpg?1635850140"
	},
	{
		chainId: 1,
		address: "0xBBc2AE13b23d715c30720F079fcd9B4a74093505",
		name: "Ethernity Chain",
		symbol: "ERN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14238/thumb/LOGO_HIGH_QUALITY.png?1647831402"
	},
	{
		chainId: 1,
		address: "0xd9Fcd98c322942075A5C3860693e9f4f03AAE07b",
		name: "Euler",
		symbol: "EUL",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/26149/thumb/YCvKDfl8_400x400.jpeg?1656041509"
	},
	{
		chainId: 1,
		address: "0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c",
		name: "Euro Coin",
		symbol: "EUROC",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/26045/thumb/euro-coin.png?1655394420"
	},
	{
		chainId: 1,
		address: "0xa0246c9032bC3A600820415aE600c6388619A14D",
		name: "Harvest Finance",
		symbol: "FARM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12304/thumb/Harvest.png?1613016180"
	},
	{
		chainId: 1,
		address: "0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85",
		name: "Fetch ai",
		symbol: "FET",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/5681/thumb/Fetch.jpg?1572098136"
	},
	{
		chainId: 1,
		address: "0xef3A930e1FfFFAcd2fc13434aC81bD278B0ecC8d",
		name: "Stafi",
		symbol: "FIS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12423/thumb/stafi_logo.jpg?1599730991"
	},
	{
		chainId: 1,
		address: "0x41545f8b9472D758bB669ed8EaEEEcD7a9C4Ec29",
		name: "Forta",
		symbol: "FORT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/25060/thumb/Forta_lgo_%281%29.png?1655353696"
	},
	{
		chainId: 1,
		address: "0x77FbA179C79De5B7653F68b5039Af940AdA60ce0",
		name: "Ampleforth Governance Token",
		symbol: "FORTH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14917/thumb/photo_2021-04-22_00.00.03.jpeg?1619020835"
	},
	{
		chainId: 1,
		address: "0xc770EEfAd204B5180dF6a14Ee197D99d808ee52d",
		name: "ShapeShift FOX Token",
		symbol: "FOX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9988/thumb/FOX.png?1574330622"
	},
	{
		chainId: 1,
		address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
		name: "Frax",
		symbol: "FRAX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13422/thumb/frax_logo.png?1608476506"
	},
	{
		chainId: 1,
		address: "0x4E15361FD6b4BB609Fa63C81A2be19d873717870",
		name: "Fantom",
		symbol: "FTM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4001/thumb/Fantom.png?1558015016"
	},
	{
		chainId: 1,
		address: "0x8c15Ef5b4B21951d50E53E4fbdA8298FFAD25057",
		name: "Function X",
		symbol: "FX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/8186/thumb/47271330_590071468072434_707260356350705664_n.jpg?1556096683"
	},
	{
		chainId: 1,
		address: "0x3432B6A60D23Ca0dFCa7761B7ab56459D9C964D0",
		name: "Frax Share",
		symbol: "FXS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13423/thumb/frax_share.png?1608478989"
	},
	{
		chainId: 1,
		address: "0x5fAa989Af96Af85384b8a938c2EdE4A7378D9875",
		name: "Project Galaxy",
		symbol: "GAL",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/24530/thumb/GAL-Token-Icon.png?1651483533"
	},
	{
		chainId: 1,
		address: "0x15D4c048F83bd7e37d49eA4C83a07267Ec4203dA",
		name: "Gala",
		symbol: "GALA",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/12493/thumb/GALA-COINGECKO.png?1600233435"
	},
	{
		chainId: 1,
		address: "0xdab396cCF3d84Cf2D07C4454e10C8A6F5b008D2b",
		name: "Goldfinch",
		symbol: "GFI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/19081/thumb/GOLDFINCH.png?1634369662"
	},
	{
		chainId: 1,
		address: "0x3F382DbD960E3a9bbCeaE22651E88158d2791550",
		name: "Aavegotchi",
		symbol: "GHST",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12467/thumb/ghst_200.png?1600750321"
	},
	{
		chainId: 1,
		address: "0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429",
		name: "Golem",
		symbol: "GLM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/542/thumb/Golem_Submark_Positive_RGB.png?1606392013"
	},
	{
		chainId: 1,
		address: "0x6810e776880C02933D47DB1b9fc05908e5386b96",
		name: "Gnosis Token",
		symbol: "GNO",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6810e776880C02933D47DB1b9fc05908e5386b96/logo.png"
	},
	{
		chainId: 1,
		address: "0xccC8cb5229B0ac8069C51fd58367Fd1e622aFD97",
		name: "Gods Unchained",
		symbol: "GODS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17139/thumb/10631.png?1635718182"
	},
	{
		chainId: 1,
		address: "0xc944E90C64B2c07662A292be6244BDf05Cda44a7",
		name: "The Graph",
		symbol: "GRT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13397/thumb/Graph_Token.png?1608145566"
	},
	{
		chainId: 1,
		address: "0xDe30da39c46104798bB5aA3fe8B9e0e1F348163F",
		name: "Gitcoin",
		symbol: "GTC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15810/thumb/gitcoin.png?1621992929"
	},
	{
		chainId: 1,
		address: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
		name: "Gemini Dollar",
		symbol: "GUSD",
		decimals: 2,
		logoURI: "https://assets.coingecko.com/coins/images/5992/thumb/gemini-dollar-gusd.png?1536745278"
	},
	{
		chainId: 1,
		address: "0xC08512927D12348F6620a698105e1BAac6EcD911",
		name: "GYEN",
		symbol: "GYEN",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/14191/thumb/icon_gyen_200_200.png?1614843343"
	},
	{
		chainId: 1,
		address: "0x71Ab77b7dbB4fa7e017BC15090b2163221420282",
		name: "Highstreet",
		symbol: "HIGH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/18973/thumb/logosq200200Coingecko.png?1634090470"
	},
	{
		chainId: 1,
		address: "0xF5581dFeFD8Fb0e4aeC526bE659CFaB1f8c781dA",
		name: "HOPR",
		symbol: "HOPR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14061/thumb/Shared_HOPR_logo_512px.png?1614073468"
	},
	{
		chainId: 1,
		address: "0xB705268213D593B8FD88d3FDEFF93AFF5CbDcfAE",
		name: "IDEX",
		symbol: "IDEX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2565/thumb/logomark-purple-286x286.png?1638362736"
	},
	{
		chainId: 1,
		address: "0xF57e7e7C23978C3cAEC3C3548E3D615c346e79fF",
		name: "Immutable X",
		symbol: "IMX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17233/thumb/imx.png?1636691817"
	},
	{
		chainId: 1,
		address: "0x0954906da0Bf32d5479e25f46056d22f08464cab",
		name: "Index Cooperative",
		symbol: "INDEX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12729/thumb/index.png?1634894321"
	},
	{
		chainId: 1,
		address: "0xe28b3B32B6c345A34Ff64674606124Dd5Aceca30",
		name: "Injective",
		symbol: "INJ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12882/thumb/Secondary_Symbol.png?1628233237"
	},
	{
		chainId: 1,
		address: "0x41D5D79431A913C4aE7d69a668ecdfE5fF9DFB68",
		name: "Inverse Finance",
		symbol: "INV",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14205/thumb/inverse_finance.jpg?1614921871"
	},
	{
		chainId: 1,
		address: "0x6fB3e0A217407EFFf7Ca062D46c26E5d60a14d69",
		name: "IoTeX",
		symbol: "IOTX",
		decimals: 18,
		logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/2777.png"
	},
	{
		chainId: 1,
		address: "0x23894DC9da6c94ECb439911cAF7d337746575A72",
		name: "Geojam",
		symbol: "JAM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/24648/thumb/ey40AzBN_400x400.jpg?1648507272"
	},
	{
		chainId: 1,
		address: "0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC",
		name: "JasmyCoin",
		symbol: "JASMY",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13876/thumb/JASMY200x200.jpg?1612473259"
	},
	{
		chainId: 1,
		address: "0x4B1E80cAC91e2216EEb63e29B957eB91Ae9C2Be8",
		name: "Jupiter",
		symbol: "JUP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/10351/thumb/logo512.png?1632480932"
	},
	{
		chainId: 1,
		address: "0x85Eee30c52B0b379b046Fb0F85F4f3Dc3009aFEC",
		name: "Keep Network",
		symbol: "KEEP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/3373/thumb/IuNzUb5b_400x400.jpg?1589526336"
	},
	{
		chainId: 1,
		address: "0x4CC19356f2D37338b9802aa8E8fc58B0373296E7",
		name: "SelfKey",
		symbol: "KEY",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2034/thumb/selfkey.png?1548608934"
	},
	{
		chainId: 1,
		address: "0xdd974D5C2e2928deA5F71b9825b8b646686BD200",
		name: "Kyber Network Crystal",
		symbol: "KNC",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdd974D5C2e2928deA5F71b9825b8b646686BD200/logo.png"
	},
	{
		chainId: 1,
		address: "0x1cEB5cB57C4D4E2b2433641b95Dd330A33185A44",
		name: "Keep3rV1",
		symbol: "KP3R",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12966/thumb/kp3r_logo.jpg?1607057458"
	},
	{
		chainId: 1,
		address: "0x464eBE77c293E473B48cFe96dDCf88fcF7bFDAC0",
		name: "KRYLL",
		symbol: "KRL",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2807/thumb/krl.png?1547036979"
	},
	{
		chainId: 1,
		address: "0x037A54AaB062628C9Bbae1FDB1583c195585fe41",
		name: "LCX",
		symbol: "LCX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9985/thumb/zRPSu_0o_400x400.jpg?1574327008"
	},
	{
		chainId: 1,
		address: "0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32",
		name: "Lido DAO",
		symbol: "LDO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13573/thumb/Lido_DAO.png?1609873644"
	},
	{
		chainId: 1,
		address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
		name: "ChainLink Token",
		symbol: "LINK",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x514910771AF9Ca656af840dff83E8264EcF986CA/logo.png"
	},
	{
		chainId: 1,
		address: "0x61E90A50137E1F645c9eF4a0d3A4f01477738406",
		name: "League of Kingdoms",
		symbol: "LOKA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/22572/thumb/loka_64pix.png?1642643271"
	},
	{
		chainId: 1,
		address: "0xA4e8C3Ec456107eA67d3075bF9e3DF3A75823DB0",
		name: "Loom Network",
		symbol: "LOOM",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA4e8C3Ec456107eA67d3075bF9e3DF3A75823DB0/logo.png"
	},
	{
		chainId: 1,
		address: "0x58b6A8A3302369DAEc383334672404Ee733aB239",
		name: "Livepeer",
		symbol: "LPT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/7137/thumb/logo-circle-green.png?1619593365"
	},
	{
		chainId: 1,
		address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
		name: "Liquity",
		symbol: "LQTY",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14665/thumb/200-lqty-icon.png?1617631180"
	},
	{
		chainId: 1,
		address: "0xBBbbCA6A901c926F240b89EacB641d8Aec7AEafD",
		name: "LoopringCoin V2",
		symbol: "LRC",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xBBbbCA6A901c926F240b89EacB641d8Aec7AEafD/logo.png"
	},
	{
		chainId: 1,
		address: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
		name: "Liquity USD",
		symbol: "LUSD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14666/thumb/Group_3.png?1617631327"
	},
	{
		chainId: 1,
		address: "0x0F5D2fB29fb7d3CFeE444a200298f468908cC942",
		name: "Decentraland",
		symbol: "MANA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/878/thumb/decentraland-mana.png?1550108745"
	},
	{
		chainId: 1,
		address: "0x69af81e73A73B40adF4f3d4223Cd9b1ECE623074",
		name: "Mask Network",
		symbol: "MASK",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14051/thumb/Mask_Network.jpg?1614050316"
	},
	{
		chainId: 1,
		address: "0x08d967bb0134F2d07f7cfb6E246680c53927DD30",
		name: "MATH",
		symbol: "MATH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11335/thumb/2020-05-19-token-200.png?1589940590"
	},
	{
		chainId: 1,
		address: "0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0",
		name: "Polygon",
		symbol: "MATIC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4713/thumb/matic-token-icon.png?1624446912"
	},
	{
		chainId: 1,
		address: "0x949D48EcA67b17269629c7194F4b727d4Ef9E5d6",
		name: "Merit Circle",
		symbol: "MC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/19304/thumb/Db4XqML.png?1634972154"
	},
	{
		chainId: 1,
		address: "0xfC98e825A2264D890F9a1e68ed50E1526abCcacD",
		name: "Moss Carbon Credit",
		symbol: "MCO2",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14414/thumb/ENtxnThA_400x400.jpg?1615948522"
	},
	{
		chainId: 1,
		address: "0x814e0908b12A99FeCf5BC101bB5d0b8B5cDf7d26",
		name: "Measurable Data Token",
		symbol: "MDT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2441/thumb/mdt_logo.png?1569813574"
	},
	{
		chainId: 1,
		address: "0x9E32b13ce7f2E80A01932B42553652E053D6ed8e",
		name: "Metis",
		symbol: "METIS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15595/thumb/metis.jpeg?1660285312"
	},
	{
		chainId: 1,
		address: "0x99D8a9C45b2ecA8864373A26D1459e3Dff1e17F3",
		name: "Magic Internet Money",
		symbol: "MIM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/16786/thumb/mimlogopng.png?1624979612"
	},
	{
		chainId: 1,
		address: "0x09a3EcAFa817268f77BE1283176B946C4ff2E608",
		name: "Mirror Protocol",
		symbol: "MIR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13295/thumb/mirror_logo_transparent.png?1611554658"
	},
	{
		chainId: 1,
		address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
		name: "Maker",
		symbol: "MKR",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2/logo.png"
	},
	{
		chainId: 1,
		address: "0xec67005c4E498Ec7f55E092bd1d35cbC47C91892",
		name: "Melon",
		symbol: "MLN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/605/thumb/melon.png?1547034295"
	},
	{
		chainId: 1,
		address: "0x275f5Ad03be0Fa221B4C6649B8AeE09a42D9412A",
		name: "Monavale",
		symbol: "MONA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13298/thumb/monavale_logo.jpg?1607232721"
	},
	{
		chainId: 1,
		address: "0x33349B282065b0284d756F0577FB39c158F935e6",
		name: "Maple",
		symbol: "MPL",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14097/thumb/photo_2021-05-03_14.20.41.jpeg?1620022863"
	},
	{
		chainId: 1,
		address: "0xF433089366899D83a9f26A773D59ec7eCF30355e",
		name: "Metal",
		symbol: "MTL",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/763/thumb/Metal.png?1592195010"
	},
	{
		chainId: 1,
		address: "0x65Ef703f5594D2573eb71Aaf55BC0CB548492df4",
		name: "Multichain",
		symbol: "MULTI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/22087/thumb/1_Wyot-SDGZuxbjdkaOeT2-A.png?1640764238"
	},
	{
		chainId: 1,
		address: "0xe2f2a5C287993345a840Db3B0845fbC70f5935a5",
		name: "mStable USD",
		symbol: "MUSD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11576/thumb/mStable_USD.png?1595591803"
	},
	{
		chainId: 1,
		address: "0xB6Ca7399B4F9CA56FC27cBfF44F4d2e4Eef1fc81",
		name: "Muse DAO",
		symbol: "MUSE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13230/thumb/muse_logo.png?1606460453"
	},
	{
		chainId: 1,
		address: "0xAE788F80F2756A86aa2F410C651F2aF83639B95b",
		name: "GensoKishi Metaverse",
		symbol: "MV",
		decimals: 18,
		logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/17704.png"
	},
	{
		chainId: 1,
		address: "0x5Ca381bBfb58f0092df149bD3D243b08B9a8386e",
		name: "MXC",
		symbol: "MXC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4604/thumb/mxc.png?1655534336"
	},
	{
		chainId: 1,
		address: "0x9E46A38F5DaaBe8683E10793b06749EEF7D733d1",
		name: "PolySwarm",
		symbol: "NCT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2843/thumb/ImcYCVfX_400x400.jpg?1628519767"
	},
	{
		chainId: 1,
		address: "0x04abEdA201850aC0124161F037Efd70c74ddC74C",
		name: "Nest Protocol",
		symbol: "NEST",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11284/thumb/52954052.png?1589868539"
	},
	{
		chainId: 1,
		address: "0x5Cf04716BA20127F1E2297AdDCf4B5035000c9eb",
		name: "NKN",
		symbol: "NKN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/3375/thumb/nkn.png?1548329212"
	},
	{
		chainId: 1,
		address: "0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671",
		name: "Numeraire",
		symbol: "NMR",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671/logo.png"
	},
	{
		chainId: 1,
		address: "0x4fE83213D56308330EC302a8BD641f1d0113A4Cc",
		name: "NuCypher",
		symbol: "NU",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/3318/thumb/photo1198982838879365035.jpg?1547037916"
	},
	{
		chainId: 1,
		address: "0x967da4048cD07aB37855c090aAF366e4ce1b9F48",
		name: "Ocean Protocol",
		symbol: "OCEAN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/3687/thumb/ocean-protocol-logo.jpg?1547038686"
	},
	{
		chainId: 1,
		address: "0x8207c1FfC5B6804F6024322CcF34F29c3541Ae26",
		name: "Origin Protocol",
		symbol: "OGN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/3296/thumb/op.jpg?1547037878"
	},
	{
		chainId: 1,
		address: "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07",
		name: "OMG Network",
		symbol: "OMG",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/776/thumb/OMG_Network.jpg?1591167168"
	},
	{
		chainId: 1,
		address: "0x6F59e0461Ae5E2799F1fB3847f05a63B16d0DbF8",
		name: "ORCA Alliance",
		symbol: "ORCA",
		decimals: 18,
		logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/5183.png"
	},
	{
		chainId: 1,
		address: "0x0258F474786DdFd37ABCE6df6BBb1Dd5dfC4434a",
		name: "Orion Protocol",
		symbol: "ORN",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/11841/thumb/orion_logo.png?1594943318"
	},
	{
		chainId: 1,
		address: "0x4575f41308EC1483f3d399aa9a2826d74Da13Deb",
		name: "Orchid",
		symbol: "OXT",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x4575f41308EC1483f3d399aa9a2826d74Da13Deb/logo.png"
	},
	{
		chainId: 1,
		address: "0xc1D204d77861dEf49b6E769347a883B15EC397Ff",
		name: "PayperEx",
		symbol: "PAX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/1601/thumb/pax.png?1547035800"
	},
	{
		chainId: 1,
		address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
		name: "PAX Gold",
		symbol: "PAXG",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9519/thumb/paxg.PNG?1568542565"
	},
	{
		chainId: 1,
		address: "0xbC396689893D065F41bc2C6EcbeE5e0085233447",
		name: "Perpetual Protocol",
		symbol: "PERP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12381/thumb/60d18e06844a844ad75901a9_mark_only_03.png?1628674771"
	},
	{
		chainId: 1,
		address: "0x3a4f40631a4f906c2BaD353Ed06De7A5D3fCb430",
		name: "PlayDapp",
		symbol: "PLA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14316/thumb/54023228.png?1615366911"
	},
	{
		chainId: 1,
		address: "0xD8912C10681D8B21Fd3742244f44658dBA12264E",
		name: "Pluton",
		symbol: "PLU",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/1241/thumb/pluton.png?1548331624"
	},
	{
		chainId: 1,
		address: "0x83e6f1E41cdd28eAcEB20Cb649155049Fac3D5Aa",
		name: "Polkastarter",
		symbol: "POLS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12648/thumb/polkastarter.png?1609813702"
	},
	{
		chainId: 1,
		address: "0x9992eC3cF6A55b00978cdDF2b27BC6882d88D1eC",
		name: "Polymath",
		symbol: "POLY",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2784/thumb/inKkF01.png?1605007034"
	},
	{
		chainId: 1,
		address: "0x57B946008913B82E4dF85f501cbAeD910e58D26C",
		name: "Marlin",
		symbol: "POND",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/8903/thumb/POND_200x200.png?1622515451"
	},
	{
		chainId: 1,
		address: "0x595832F8FC6BF59c85C527fEC3740A1b7a361269",
		name: "Power Ledger",
		symbol: "POWR",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/1104/thumb/power-ledger.png?1547035082"
	},
	{
		chainId: 1,
		address: "0x226bb599a12C826476e3A771454697EA52E9E220",
		name: "Propy",
		symbol: "PRO",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/869/thumb/propy.png?1548332100"
	},
	{
		chainId: 1,
		address: "0x362bc847A3a9637d3af6624EeC853618a43ed7D2",
		name: "PARSIQ",
		symbol: "PRQ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11973/thumb/DsNgK0O.png?1596590280"
	},
	{
		chainId: 1,
		address: "0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
		name: "pSTAKE Finance",
		symbol: "PSTAKE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/23931/thumb/PSTAKE_Dark.png?1645709930"
	},
	{
		chainId: 1,
		address: "0x4a220E6096B25EADb88358cb44068A3248254675",
		name: "Quant",
		symbol: "QNT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/3370/thumb/5ZOu7brX_400x400.jpg?1612437252"
	},
	{
		chainId: 1,
		address: "0x4123a133ae3c521FD134D7b13A2dEC35b56c2463",
		name: "Qredo",
		symbol: "QRDO",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/17541/thumb/qrdo.png?1630637735"
	},
	{
		chainId: 1,
		address: "0x99ea4dB9EE77ACD40B119BD1dC4E33e1C070b80d",
		name: "Quantstamp",
		symbol: "QSP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/1219/thumb/0_E0kZjb4dG4hUnoDD_.png?1604815917"
	},
	{
		chainId: 1,
		address: "0x6c28AeF8977c9B773996d0e8376d2EE379446F2f",
		name: "Quickswap",
		symbol: "QUICK",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13970/thumb/1_pOU6pBMEmiL-ZJVb0CYRjQ.png?1613386659"
	},
	{
		chainId: 1,
		address: "0x31c8EAcBFFdD875c74b94b077895Bd78CF1E64A3",
		name: "Radicle",
		symbol: "RAD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14013/thumb/radicle.png?1614402918"
	},
	{
		chainId: 1,
		address: "0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919",
		name: "Rai Reflex Index",
		symbol: "RAI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14004/thumb/RAI-logo-coin.png?1613592334"
	},
	{
		chainId: 1,
		address: "0xba5BDe662c17e2aDFF1075610382B9B691296350",
		name: "SuperRare",
		symbol: "RARE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17753/thumb/RARE.jpg?1629220534"
	},
	{
		chainId: 1,
		address: "0xFca59Cd816aB1eaD66534D82bc21E7515cE441CF",
		name: "Rarible",
		symbol: "RARI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11845/thumb/Rari.png?1594946953"
	},
	{
		chainId: 1,
		address: "0xA4EED63db85311E22dF4473f87CcfC3DaDCFA3E3",
		name: "Rubic",
		symbol: "RBC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12629/thumb/200x200.png?1607952509"
	},
	{
		chainId: 1,
		address: "0x6123B0049F904d730dB3C36a31167D9d4121fA6B",
		name: "Ribbon Finance",
		symbol: "RBN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15823/thumb/RBN_64x64.png?1633529723"
	},
	{
		chainId: 1,
		address: "0x408e41876cCCDC0F92210600ef50372656052a38",
		name: "Republic Token",
		symbol: "REN",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x408e41876cCCDC0F92210600ef50372656052a38/logo.png"
	},
	{
		chainId: 1,
		address: "0x1985365e9f78359a9B6AD760e32412f4a445E862",
		name: "Reputation Augur v1",
		symbol: "REP",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x1985365e9f78359a9B6AD760e32412f4a445E862/logo.png"
	},
	{
		chainId: 1,
		address: "0x221657776846890989a759BA2973e427DfF5C9bB",
		name: "Reputation Augur v2",
		symbol: "REPv2",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x221657776846890989a759BA2973e427DfF5C9bB/logo.png"
	},
	{
		chainId: 1,
		address: "0x8f8221aFbB33998d8584A2B05749bA73c37a938a",
		name: "Request",
		symbol: "REQ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/1031/thumb/Request_icon_green.png?1643250951"
	},
	{
		chainId: 1,
		address: "0x557B933a7C2c45672B610F8954A3deB39a51A8Ca",
		name: "REVV",
		symbol: "REVV",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12373/thumb/REVV_TOKEN_Refined_2021_%281%29.png?1627652390"
	},
	{
		chainId: 1,
		address: "0xD291E7a03283640FDc51b121aC401383A46cC623",
		name: "Rari Governance Token",
		symbol: "RGT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12900/thumb/Rari_Logo_Transparent.png?1613978014"
	},
	{
		chainId: 1,
		address: "0x607F4C5BB672230e8672085532f7e901544a7375",
		name: "iExec RLC",
		symbol: "RLC",
		decimals: 9,
		logoURI: "https://assets.coingecko.com/coins/images/646/thumb/pL1VuXm.png?1604543202"
	},
	{
		chainId: 1,
		address: "0xf1f955016EcbCd7321c7266BccFB96c68ea5E49b",
		name: "Rally",
		symbol: "RLY",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12843/thumb/image.png?1611212077"
	},
	{
		chainId: 1,
		address: "0x6De037ef9aD2725EB40118Bb1702EBb27e4Aeb24",
		name: "Render Token",
		symbol: "RNDR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11636/thumb/rndr.png?1638840934"
	},
	{
		chainId: 1,
		address: "0xfA5047c9c78B8877af97BDcb85Db743fD7313d4a",
		name: "Rook",
		symbol: "ROOK",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13005/thumb/keeper_dao_logo.jpg?1604316506"
	},
	{
		chainId: 1,
		address: "0x3845badAde8e6dFF049820680d1F14bD3903a5d0",
		name: "The Sandbox",
		symbol: "SAND",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12129/thumb/sandbox_logo.jpg?1597397942"
	},
	{
		chainId: 1,
		address: "0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE",
		name: "Shiba Inu",
		symbol: "SHIB",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11939/thumb/shiba.png?1622619446"
	},
	{
		chainId: 1,
		address: "0x7C84e62859D0715eb77d1b1C4154Ecd6aBB21BEC",
		name: "Shping",
		symbol: "SHPING",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2588/thumb/r_yabKKi_400x400.jpg?1639470164"
	},
	{
		chainId: 1,
		address: "0x00c83aeCC790e8a4453e5dD3B0B4b3680501a7A7",
		name: "SKALE",
		symbol: "SKL",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13245/thumb/SKALE_token_300x300.png?1606789574"
	},
	{
		chainId: 1,
		address: "0xCC8Fa225D80b9c7D42F96e9570156c65D6cAAa25",
		name: "Smooth Love Potion",
		symbol: "SLP",
		decimals: 0,
		logoURI: "https://assets.coingecko.com/coins/images/10366/thumb/SLP.png?1578640057"
	},
	{
		chainId: 1,
		address: "0x744d70FDBE2Ba4CF95131626614a1763DF805B9E",
		name: "Status",
		symbol: "SNT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/779/thumb/status.png?1548610778"
	},
	{
		chainId: 1,
		address: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
		name: "Synthetix Network Token",
		symbol: "SNX",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F/logo.png"
	},
	{
		chainId: 1,
		address: "0x23B608675a2B2fB1890d3ABBd85c5775c51691d5",
		name: "Unisocks",
		symbol: "SOCKS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/10717/thumb/qFrcoiM.png?1582525244"
	},
	{
		chainId: 1,
		address: "0xD31a59c85aE9D8edEFeC411D448f90841571b89c",
		name: "SOL Wormhole ",
		symbol: "SOL",
		decimals: 9,
		logoURI: "https://assets.coingecko.com/coins/images/22876/thumb/SOL_wh_small.png?1644224316"
	},
	{
		chainId: 1,
		address: "0x090185f2135308BaD17527004364eBcC2D37e5F6",
		name: "Spell Token",
		symbol: "SPELL",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15861/thumb/abracadabra-3.png?1622544862"
	},
	{
		chainId: 1,
		address: "0xAf5191B0De278C7286d6C7CC6ab6BB8A73bA2Cd6",
		name: "Stargate Finance",
		symbol: "STG",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/24413/thumb/STG_LOGO.png?1647654518"
	},
	{
		chainId: 1,
		address: "0xB64ef51C888972c908CFacf59B47C1AfBC0Ab8aC",
		name: "Storj Token",
		symbol: "STORJ",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xB64ef51C888972c908CFacf59B47C1AfBC0Ab8aC/logo.png"
	},
	{
		chainId: 1,
		address: "0x006BeA43Baa3f7A6f765F14f10A1a1b08334EF45",
		name: "Stox",
		symbol: "STX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/1230/thumb/stox-token.png?1547035256"
	},
	{
		chainId: 1,
		address: "0x0763fdCCF1aE541A5961815C0872A8c5Bc6DE4d7",
		name: "SUKU",
		symbol: "SUKU",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11969/thumb/UmfW5S6f_400x400.jpg?1596602238"
	},
	{
		chainId: 1,
		address: "0xe53EC727dbDEB9E2d5456c3be40cFF031AB40A55",
		name: "SuperFarm",
		symbol: "SUPER",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14040/thumb/6YPdWn6.png?1613975899"
	},
	{
		chainId: 1,
		address: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		name: "Synth sUSD",
		symbol: "sUSD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"
	},
	{
		chainId: 1,
		address: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
		name: "Sushi",
		symbol: "SUSHI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12271/thumb/512x512_Logo_no_chop.png?1606986688"
	},
	{
		chainId: 1,
		address: "0x0bb217E40F8a5Cb79Adf04E1aAb60E5abd0dfC1e",
		name: "SWFTCOIN",
		symbol: "SWFTC",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/2346/thumb/SWFTCoin.jpg?1618392022"
	},
	{
		chainId: 1,
		address: "0x8CE9137d39326AD0cD6491fb5CC0CbA0e089b6A9",
		name: "Swipe",
		symbol: "SXP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9368/thumb/swipe.png?1566792311"
	},
	{
		chainId: 1,
		address: "0xf293d23BF2CDc05411Ca0edDD588eb1977e8dcd4",
		name: "Sylo",
		symbol: "SYLO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/6430/thumb/SYLO.svg?1589527756"
	},
	{
		chainId: 1,
		address: "0x0f2D719407FdBeFF09D87557AbB7232601FD9F29",
		name: "Synapse",
		symbol: "SYN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/18024/thumb/syn.png?1635002049"
	},
	{
		chainId: 1,
		address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
		name: "Threshold Network",
		symbol: "T",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/22228/thumb/nFPNiSbL_400x400.jpg?1641220340"
	},
	{
		chainId: 1,
		address: "0x8dAEBADE922dF735c38C80C7eBD708Af50815fAa",
		name: "tBTC",
		symbol: "TBTC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11224/thumb/tBTC.png?1589620754"
	},
	{
		chainId: 1,
		address: "0x485d17A6f1B8780392d53D64751824253011A260",
		name: "ChronoTech",
		symbol: "TIME",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/604/thumb/time-32x32.png?1627130666"
	},
	{
		chainId: 1,
		address: "0x888888848B652B3E3a0f34c96E00EEC0F3a23F72",
		name: "Alien Worlds",
		symbol: "TLM",
		decimals: 4,
		logoURI: "https://assets.coingecko.com/coins/images/14676/thumb/kY-C4o7RThfWrDQsLCAG4q4clZhBDDfJQVhWUEKxXAzyQYMj4Jmq1zmFwpRqxhAJFPOa0AsW_PTSshoPuMnXNwq3rU7Imp15QimXTjlXMx0nC088mt1rIwRs75GnLLugWjSllxgzvQ9YrP4tBgclK4_rb17hjnusGj_c0u2fx0AvVokjSNB-v2poTj0xT9BZRCbzRE3-lF1.jpg?1617700061"
	},
	{
		chainId: 1,
		address: "0x2e9d63788249371f1DFC918a52f8d799F4a38C94",
		name: "Tokemak",
		symbol: "TOKE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17495/thumb/tokemak-avatar-200px-black.png?1628131614"
	},
	{
		chainId: 1,
		address: "0x2Ab6Bb8408ca3199B8Fa6C92d5b455F820Af03c4",
		name: "TE FOOD",
		symbol: "TONE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2325/thumb/tec.png?1547036538"
	},
	{
		chainId: 1,
		address: "0xaA7a9CA87d3694B5755f213B5D04094b8d0F0A6F",
		name: "OriginTrail",
		symbol: "TRAC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/1877/thumb/TRAC.jpg?1635134367"
	},
	{
		chainId: 1,
		address: "0x88dF592F8eb5D7Bd38bFeF7dEb0fBc02cf3778a0",
		name: "Tellor",
		symbol: "TRB",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9644/thumb/Blk_icon_current.png?1584980686"
	},
	{
		chainId: 1,
		address: "0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B",
		name: "Tribe",
		symbol: "TRIBE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14575/thumb/tribe.PNG?1617487954"
	},
	{
		chainId: 1,
		address: "0x4C19596f5aAfF459fA38B0f7eD92F11AE6543784",
		name: "TrueFi",
		symbol: "TRU",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/13180/thumb/truefi_glyph_color.png?1617610941"
	},
	{
		chainId: 1,
		address: "0xd084B83C305daFD76AE3E1b4E1F1fe2eCcCb3988",
		name: "The Virtua Kolect",
		symbol: "TVK",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13330/thumb/virtua_original.png?1656043619"
	},
	{
		chainId: 1,
		address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
		name: "UMA Voting Token v1",
		symbol: "UMA",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828/logo.png"
	},
	{
		chainId: 1,
		address: "0x441761326490cACF7aF299725B6292597EE822c2",
		name: "Unifi Protocol DAO",
		symbol: "UNFI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13152/thumb/logo-2.png?1605748967"
	},
	{
		address: "0x1757f2E7BEE5abE1A79532000d05e32D90dD79fF",
		chainId: 421613,
		name: "Wrapped Ether",
		symbol: "WETH",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
	},
	{
		address: "0x179522635726710Dd7D2035a81d856de4Aa7836c",
		chainId: 421613,
		name: "USD//C",
		symbol: "USDC",
		decimals: 6,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png"
	},
	{
		chainId: 1,
		address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
		name: "Uniswap",
		symbol: "UNI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12504/thumb/uniswap-uni.png?1600306604"
	},
	{
		chainId: 1,
		address: "0x70D2b7C19352bB76e4409858FF5746e500f2B67c",
		name: "Pawtocol",
		symbol: "UPI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12186/thumb/pawtocol.jpg?1597962008"
	},
	{
		chainId: 1,
		address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
		name: "USDCoin",
		symbol: "USDC",
		decimals: 6,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png"
	},
	{
		chainId: 1,
		address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
		name: "Tether USD",
		symbol: "USDT",
		decimals: 6,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
	},
	{
		chainId: 1,
		address: "0x3C4B6E6e1eA3D4863700D7F76b36B7f3D3f13E3d",
		name: "Voyager Token",
		symbol: "VGX",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/794/thumb/Voyager-vgx.png?1575693595"
	},
	{
		chainId: 1,
		address: "0xEDB171C18cE90B633DB442f2A6F72874093b49Ef",
		name: "Wrapped Ampleforth",
		symbol: "WAMPL",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/20825/thumb/photo_2021-11-25_02-05-11.jpg?1637811951"
	},
	{
		chainId: 1,
		address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
		name: "Wrapped BTC",
		symbol: "WBTC",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png"
	},
	{
		chainId: 1,
		address: "0xc221b7E65FfC80DE234bbB6667aBDd46593D34F0",
		name: "Wrapped Centrifuge",
		symbol: "WCFG",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17106/thumb/WCFG.jpg?1626266462"
	},
	{
		chainId: 1,
		address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
		name: "Wrapped Ether",
		symbol: "WETH",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
	},
	{
		chainId: 1,
		address: "0x4691937a7508860F876c9c0a2a617E7d9E945D4B",
		name: "WOO Network",
		symbol: "WOO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12921/thumb/w2UiemF__400x400.jpg?1603670367"
	},
	{
		chainId: 1,
		address: "0xA2cd3D43c775978A96BdBf12d733D5A1ED94fb18",
		name: "Chain",
		symbol: "XCN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/24210/thumb/Chain_icon_200x200.png?1646895054"
	},
	{
		chainId: 1,
		address: "0x55296f69f40Ea6d20E478533C15A6B08B654E758",
		name: "XYO Network",
		symbol: "XYO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4519/thumb/XYO_Network-logo.png?1547039819"
	},
	{
		chainId: 1,
		address: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
		name: "yearn finance",
		symbol: "YFI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11849/thumb/yfi-192x192.png?1598325330"
	},
	{
		chainId: 1,
		address: "0xa1d0E215a23d7030842FC67cE582a6aFa3CCaB83",
		name: "DFI money",
		symbol: "YFII",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11902/thumb/YFII-logo.78631676.png?1598677348"
	},
	{
		chainId: 1,
		address: "0x25f8087EAD173b73D6e8B84329989A8eEA16CF73",
		name: "Yield Guild Games",
		symbol: "YGG",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17358/thumb/le1nzlO6_400x400.jpg?1632465691"
	},
	{
		chainId: 1,
		address: "0xE41d2489571d322189246DaFA5ebDe1F4699F498",
		name: "0x Protocol Token",
		symbol: "ZRX",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xE41d2489571d322189246DaFA5ebDe1F4699F498/logo.png"
	},
	{
		chainId: 1,
		address: "0xb1191f691a355b43542bea9b8847bc73e7abb137",
		name: "Kirobo",
		symbol: "KIRO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12688/thumb/QmScxyKBwqbGJZmp38EwaoRpXbzPkq3tvuMjeuJE1YLZeG.png?1601672684"
	},
	{
		chainId: 5,
		address: "0xba232b47a7dDFCCc221916cf08Da03a4973D3A1D",
		name: "Kirobo",
		symbol: "KIRO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12688/thumb/QmScxyKBwqbGJZmp38EwaoRpXbzPkq3tvuMjeuJE1YLZeG.png?1601672684"
	},
	{
		chainId: 5,
		address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
		name: "Uniswap",
		symbol: "UNI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12504/thumb/uniswap-uni.png?1600306604"
	},
	{
		chainId: 5,
		address: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
		name: "Wrapped Ether",
		symbol: "WETH",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
	},
	{
		chainId: 10,
		address: "0x76FB31fb4af56892A25e32cFC43De717950c9278",
		name: "Aave",
		symbol: "AAVE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12645/thumb/AAVE.png?1601374110"
	},
	{
		chainId: 10,
		address: "0x3e7eF8f50246f725885102E8238CBba33F276747",
		name: "BarnBridge",
		symbol: "BOND",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12811/thumb/barnbridge.jpg?1602728853"
	},
	{
		chainId: 10,
		address: "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
		name: "Binance USD",
		symbol: "BUSD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9576/thumb/BUSD.png?1568947766"
	},
	{
		chainId: 10,
		address: "0x0994206dfE8De6Ec6920FF4D779B0d950605Fb53",
		name: "Curve DAO Token",
		symbol: "CRV",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xD533a949740bb3306d119CC777fa900bA034cd52/logo.png"
	},
	{
		chainId: 10,
		address: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
		name: "Dai Stablecoin",
		symbol: "DAI",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png"
	},
	{
		chainId: 10,
		address: "0x65559aA14915a70190438eF90104769e5E890A00",
		name: "Ethereum Name Service",
		symbol: "ENS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/19785/thumb/acatxTm8_400x400.jpg?1635850140"
	},
	{
		chainId: 10,
		address: "0x350a791Bfc2C21F9Ed5d10980Dad2e2638ffa7f6",
		name: "ChainLink Token",
		symbol: "LINK",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x514910771AF9Ca656af840dff83E8264EcF986CA/logo.png"
	},
	{
		chainId: 10,
		address: "0xFEaA9194F9F8c1B65429E31341a103071464907E",
		name: "LoopringCoin V2",
		symbol: "LRC",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xBBbbCA6A901c926F240b89EacB641d8Aec7AEafD/logo.png"
	},
	{
		chainId: 10,
		address: "0xc40F949F8a4e094D1b49a23ea9241D289B7b2819",
		name: "Liquity USD",
		symbol: "LUSD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14666/thumb/Group_3.png?1617631327"
	},
	{
		chainId: 10,
		address: "0x3390108E913824B8eaD638444cc52B9aBdF63798",
		name: "Mask Network",
		symbol: "MASK",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14051/thumb/Mask_Network.jpg?1614050316"
	},
	{
		chainId: 10,
		address: "0xab7bAdEF82E9Fe11f6f33f87BC9bC2AA27F2fCB5",
		name: "Maker",
		symbol: "MKR",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2/logo.png"
	},
	{
		chainId: 10,
		address: "0x4200000000000000000000000000000000000042",
		name: "Optimism",
		symbol: "OP",
		decimals: 18,
		logoURI: "https://ethereum-optimism.github.io/data/OP/logo.png"
	},
	{
		chainId: 10,
		address: "0x9e1028F5F1D5eDE59748FFceE5532509976840E0",
		name: "Perpetual Protocol",
		symbol: "PERP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12381/thumb/60d18e06844a844ad75901a9_mark_only_03.png?1628674771"
	},
	{
		chainId: 10,
		address: "0x7FB688CCf682d58f86D7e38e03f9D22e7705448B",
		name: "Rai Reflex Index",
		symbol: "RAI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14004/thumb/RAI-logo-coin.png?1613592334"
	},
	{
		chainId: 10,
		address: "0xB548f63D4405466B36C0c0aC3318a22fDcec711a",
		name: "Rari Governance Token",
		symbol: "RGT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12900/thumb/Rari_Logo_Transparent.png?1613978014"
	},
	{
		chainId: 10,
		address: "0x8700dAec35aF8Ff88c16BdF0418774CB3D7599B4",
		name: "Synthetix Network Token",
		symbol: "SNX",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F/logo.png"
	},
	{
		chainId: 10,
		address: "0xE7798f023fC62146e8Aa1b36Da45fb70855a77Ea",
		name: "UMA Voting Token v1",
		symbol: "UMA",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828/logo.png"
	},
	{
		chainId: 10,
		address: "0x6fd9d7AD17242c41f7131d257212c54A0e816691",
		name: "Uniswap",
		symbol: "UNI",
		decimals: 18,
		logoURI: "ipfs://QmXttGpZrECX5qCyXbBQiqgQNytVGeZW5Anewvh2jc4psg"
	},
	{
		chainId: 10,
		address: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
		name: "USDCoin",
		symbol: "USDC",
		decimals: 6,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png"
	},
	{
		chainId: 10,
		address: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58",
		name: "Tether USD",
		symbol: "USDT",
		decimals: 6,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
	},
	{
		chainId: 10,
		address: "0x68f180fcCe6836688e9084f035309E29Bf0A2095",
		name: "Wrapped BTC",
		symbol: "WBTC",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png"
	},
	{
		chainId: 10,
		address: "0x4200000000000000000000000000000000000006",
		name: "Wrapped Ether",
		symbol: "WETH",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
	},
	{
		chainId: 56,
		address: "0x111111111117dC0aa78b770fA6A738034120C302",
		name: "1inch",
		symbol: "1INCH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13469/thumb/1inch-token.png?1608803028"
	},
	{
		chainId: 56,
		address: "0xfb6115445Bff7b52FeB98650C87f44907E58f802",
		name: "Aave",
		symbol: "AAVE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12645/thumb/AAVE.png?1601374110"
	},
	{
		chainId: 56,
		address: "0xBc7d6B50616989655AfD682fb42743507003056D",
		name: "Alchemy Pay",
		symbol: "ACH",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/12390/thumb/ACH_%281%29.png?1599691266"
	},
	{
		chainId: 56,
		address: "0x6bfF4Fb161347ad7de4A625AE5aa3A1CA7077819",
		name: "Ambire AdEx",
		symbol: "ADX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/847/thumb/Ambire_AdEx_Symbol_color.png?1655432540"
	},
	{
		chainId: 56,
		address: "0x33d08D8C7a168333a85285a68C0042b39fC3741D",
		name: "AIOZ Network",
		symbol: "AIOZ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14631/thumb/aioz_logo.png?1617413126"
	},
	{
		chainId: 56,
		address: "0x82D2f8E02Afb160Dd5A480a617692e62de9038C4",
		name: "Aleph im",
		symbol: "ALEPH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11676/thumb/Monochram-aleph.png?1608483725"
	},
	{
		chainId: 56,
		address: "0xAC51066d7bEC65Dc4589368da368b212745d63E8",
		name: "My Neighbor Alice",
		symbol: "ALICE",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/14375/thumb/alice_logo.jpg?1615782968"
	},
	{
		chainId: 56,
		address: "0xa1faa113cbE53436Df28FF0aEe54275c13B40975",
		name: "Alpha Venture DAO",
		symbol: "ALPHA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12738/thumb/AlphaToken_256x256.png?1617160876"
	},
	{
		chainId: 56,
		address: "0xf307910A4c7bbc79691fD374889b36d8531B08e3",
		name: "Ankr",
		symbol: "ANKR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4324/thumb/U85xTl2.png?1608111978"
	},
	{
		chainId: 56,
		address: "0x6F769E65c14Ebd1f68817F5f1DcDb61Cfa2D6f7e",
		name: "ARPA Chain",
		symbol: "ARPA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/8506/thumb/9u0a23XY_400x400.jpg?1559027357"
	},
	{
		chainId: 56,
		address: "0xA2120b9e674d3fC3875f415A7DF52e382F141225",
		name: "Automata",
		symbol: "ATA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15985/thumb/ATA.jpg?1622535745"
	},
	{
		chainId: 56,
		address: "0x8b1f4432F943c465A973FeDC6d7aa50Fc96f1f65",
		name: "Axelar",
		symbol: "AXL",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/27277/large/V-65_xQ1_400x400.jpeg"
	},
	{
		chainId: 56,
		address: "0x715D400F88C167884bbCc41C5FeA407ed4D2f8A0",
		name: "Axie Infinity",
		symbol: "AXS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13029/thumb/axie_infinity_logo.png?1604471082"
	},
	{
		chainId: 56,
		address: "0x935a544Bf5816E3A7C13DB2EFe3009Ffda0aCdA2",
		name: "Bluzelle",
		symbol: "BLZ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2848/thumb/ColorIcon_3x.png?1622516510"
	},
	{
		chainId: 56,
		address: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56",
		name: "Binance USD",
		symbol: "BUSD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9576/thumb/BUSD.png?1568947766"
	},
	{
		chainId: 56,
		address: "0xaEC945e04baF28b135Fa7c640f624f8D90F1C3a6",
		name: "Coin98",
		symbol: "C98",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17117/thumb/logo.png?1626412904"
	},
	{
		chainId: 56,
		address: "0xf9CeC8d50f6c8ad3Fb6dcCEC577e05aA32B224FE",
		name: "Chromia",
		symbol: "CHR",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/5000/thumb/Chromia.png?1559038018"
	},
	{
		chainId: 56,
		address: "0x09E889BB4D5b474f561db0491C38702F367A4e4d",
		name: "Clover Finance",
		symbol: "CLV",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15278/thumb/clover.png?1645084454"
	},
	{
		chainId: 56,
		address: "0x52CE071Bd9b1C4B00A0b92D298c512478CaD67e8",
		name: "Compound",
		symbol: "COMP",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xc00e94Cb662C3520282E6f5717214004A7f26888/logo.png"
	},
	{
		chainId: 56,
		address: "0xd15CeE1DEaFBad6C0B3Fd7489677Cc102B141464",
		name: "Circuits of Value",
		symbol: "COVAL",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/588/thumb/coval-logo.png?1599493950"
	},
	{
		chainId: 56,
		address: "0x8dA443F84fEA710266C8eB6bC34B71702d033EF2",
		name: "Cartesi",
		symbol: "CTSI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11038/thumb/cartesi.png?1592288021"
	},
	{
		chainId: 56,
		address: "0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3",
		name: "Dai Stablecoin",
		symbol: "DAI",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png"
	},
	{
		chainId: 56,
		address: "0x23CE9e926048273eF83be0A3A8Ba9Cb6D45cd978",
		name: "Mines of Dalarnia",
		symbol: "DAR",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/19837/thumb/dar.png?1636014223"
	},
	{
		chainId: 56,
		address: "0xe91a8D2c584Ca93C7405F15c22CdFE53C29896E3",
		name: "DexTools",
		symbol: "DEXT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11603/thumb/dext.png?1605790188"
	},
	{
		chainId: 56,
		address: "0x99956D38059cf7bEDA96Ec91Aa7BB2477E0901DD",
		name: "DIA",
		symbol: "DIA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11955/thumb/image.png?1646041751"
	},
	{
		chainId: 56,
		address: "0xEC583f25A049CC145dA9A256CDbE9B6201a705Ff",
		name: "Drep",
		symbol: "DREP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14578/thumb/KotgsCgS_400x400.jpg?1617094445"
	},
	{
		chainId: 56,
		address: "0x961C8c0B1aaD0c0b10a51FeF6a867E3091BCef17",
		name: "DeFi Yield Protocol",
		symbol: "DYP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13480/thumb/DYP_Logo_Symbol-8.png?1655809066"
	},
	{
		chainId: 56,
		address: "0x7bd6FaBD64813c48545C9c0e312A0099d9be2540",
		name: "Dogelon Mars",
		symbol: "ELON",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14962/thumb/6GxcPRo3_400x400.jpg?1619157413"
	},
	{
		chainId: 56,
		address: "0x4B5C23cac08a567ecf0c1fFcA8372A45a5D33743",
		name: "Harvest Finance",
		symbol: "FARM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12304/thumb/Harvest.png?1613016180"
	},
	{
		chainId: 56,
		address: "0x031b41e504677879370e9DBcF937283A8691Fa7f",
		name: "Fetch ai",
		symbol: "FET",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/5681/thumb/Fetch.jpg?1572098136"
	},
	{
		chainId: 56,
		address: "0x90C97F71E18723b0Cf0dfa30ee176Ab653E89F40",
		name: "Frax",
		symbol: "FRAX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13422/thumb/frax_logo.png?1608476506"
	},
	{
		chainId: 56,
		address: "0xAD29AbB318791D579433D831ed122aFeAf29dcfe",
		name: "Fantom",
		symbol: "FTM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4001/thumb/Fantom.png?1558015016"
	},
	{
		chainId: 56,
		address: "0xe48A3d7d0Bc88d552f730B62c006bC925eadB9eE",
		name: "Frax Share",
		symbol: "FXS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13423/thumb/frax_share.png?1608478989"
	},
	{
		chainId: 56,
		address: "0xe4Cc45Bb5DBDA06dB6183E8bf016569f40497Aa5",
		name: "Project Galaxy",
		symbol: "GAL",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/24530/thumb/GAL-Token-Icon.png?1651483533"
	},
	{
		chainId: 56,
		address: "0x44Ec807ce2F4a6F2737A92e985f318d035883e47",
		name: "Hashflow",
		symbol: "HFT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/26136/large/hashflow-icon-cmc.png"
	},
	{
		chainId: 56,
		address: "0x5f4Bde007Dc06b867f86EBFE4802e34A1fFEEd63",
		name: "Highstreet",
		symbol: "HIGH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/18973/thumb/logosq200200Coingecko.png?1634090470"
	},
	{
		chainId: 56,
		address: "0xa2B726B1145A4773F68593CF171187d8EBe4d495",
		name: "Injective",
		symbol: "INJ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12882/thumb/Secondary_Symbol.png?1628233237"
	},
	{
		chainId: 56,
		address: "0x0231f91e02DebD20345Ae8AB7D71A41f8E140cE7",
		name: "Jupiter",
		symbol: "JUP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/10351/thumb/logo512.png?1632480932"
	},
	{
		chainId: 56,
		address: "0xF8A0BF9cF54Bb92F17374d9e9A321E6a111a51bD",
		name: "ChainLink Token",
		symbol: "LINK",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x514910771AF9Ca656af840dff83E8264EcF986CA/logo.png"
	},
	{
		chainId: 56,
		address: "0x2eD9a5C8C13b93955103B9a7C167B67Ef4d568a3",
		name: "Mask Network",
		symbol: "MASK",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14051/thumb/Mask_Network.jpg?1614050316"
	},
	{
		chainId: 56,
		address: "0xF218184Af829Cf2b0019F8E6F0b2423498a36983",
		name: "MATH",
		symbol: "MATH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11335/thumb/2020-05-19-token-200.png?1589940590"
	},
	{
		chainId: 56,
		address: "0xCC42724C6683B7E57334c4E856f4c9965ED682bD",
		name: "Polygon",
		symbol: "MATIC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4713/thumb/matic-token-icon.png?1624446912"
	},
	{
		chainId: 56,
		address: "0x949D48EcA67b17269629c7194F4b727d4Ef9E5d6",
		name: "Merit Circle",
		symbol: "MC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/19304/thumb/Db4XqML.png?1634972154"
	},
	{
		chainId: 56,
		address: "0xe552Fb52a4F19e44ef5A967632DBc320B0820639",
		name: "Metis",
		symbol: "METIS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15595/thumb/metis.jpeg?1660285312"
	},
	{
		chainId: 56,
		address: "0xfE19F0B51438fd612f6FD59C1dbB3eA319f433Ba",
		name: "Magic Internet Money",
		symbol: "MIM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/16786/thumb/mimlogopng.png?1624979612"
	},
	{
		chainId: 56,
		address: "0x5B6DcF557E2aBE2323c48445E8CC948910d8c2c9",
		name: "Mirror Protocol",
		symbol: "MIR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13295/thumb/mirror_logo_transparent.png?1611554658"
	},
	{
		chainId: 56,
		address: "0x9Fb9a33956351cf4fa040f65A13b835A3C8764E3",
		name: "Multichain",
		symbol: "MULTI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/22087/thumb/1_Wyot-SDGZuxbjdkaOeT2-A.png?1640764238"
	},
	{
		chainId: 56,
		address: "0x98f8669F6481EbB341B522fCD3663f79A3d1A6A7",
		name: "Nest Protocol",
		symbol: "NEST",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11284/thumb/52954052.png?1589868539"
	},
	{
		chainId: 56,
		address: "0x4e7f408be2d4E9D60F49A64B89Bb619c84C7c6F5",
		name: "Perpetual Protocol",
		symbol: "PERP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12381/thumb/60d18e06844a844ad75901a9_mark_only_03.png?1628674771"
	},
	{
		chainId: 56,
		address: "0x7e624FA0E1c4AbFD309cC15719b7E2580887f570",
		name: "Polkastarter",
		symbol: "POLS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12648/thumb/polkastarter.png?1609813702"
	},
	{
		chainId: 56,
		address: "0xd21d29B38374528675C34936bf7d5Dd693D2a577",
		name: "PARSIQ",
		symbol: "PRQ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11973/thumb/DsNgK0O.png?1596590280"
	},
	{
		chainId: 56,
		address: "0x4C882ec256823eE773B25b414d36F92ef58a7c0C",
		name: "pSTAKE Finance",
		symbol: "PSTAKE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/23931/thumb/PSTAKE_Dark.png?1645709930"
	},
	{
		chainId: 56,
		address: "0x833F307aC507D47309fD8CDD1F835BeF8D702a93",
		name: "REVV",
		symbol: "REVV",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12373/thumb/REVV_TOKEN_Refined_2021_%281%29.png?1627652390"
	},
	{
		chainId: 56,
		address: "0xfA54fF1a158B5189Ebba6ae130CEd6bbd3aEA76e",
		name: "SOL Wormhole ",
		symbol: "SOL",
		decimals: 9,
		logoURI: "https://assets.coingecko.com/coins/images/22876/thumb/SOL_wh_small.png?1644224316"
	},
	{
		chainId: 56,
		address: "0xB0D502E938ed5f4df2E681fE6E419ff29631d62b",
		name: "Stargate Finance",
		symbol: "STG",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/24413/thumb/STG_LOGO.png?1647654518"
	},
	{
		chainId: 56,
		address: "0x51BA0b044d96C3aBfcA52B64D733603CCC4F0d4D",
		name: "SuperFarm",
		symbol: "SUPER",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14040/thumb/6YPdWn6.png?1613975899"
	},
	{
		chainId: 56,
		address: "0x947950BcC74888a40Ffa2593C5798F11Fc9124C4",
		name: "Sushi",
		symbol: "SUSHI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12271/thumb/512x512_Logo_no_chop.png?1606986688"
	},
	{
		chainId: 56,
		address: "0xE64E30276C2F826FEbd3784958d6Da7B55DfbaD3",
		name: "SWFTCOIN",
		symbol: "SWFTC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2346/thumb/SWFTCoin.jpg?1618392022"
	},
	{
		chainId: 56,
		address: "0x47BEAd2563dCBf3bF2c9407fEa4dC236fAbA485A",
		name: "Swipe",
		symbol: "SXP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9368/thumb/swipe.png?1566792311"
	},
	{
		chainId: 56,
		address: "0xa4080f1778e69467E905B8d6F72f6e441f9e9484",
		name: "Synapse",
		symbol: "SYN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/18024/thumb/syn.png?1635002049"
	},
	{
		chainId: 56,
		address: "0x3b198e26E473b8faB2085b37978e36c9DE5D7f68",
		name: "ChronoTech",
		symbol: "TIME",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/604/thumb/time-32x32.png?1627130666"
	},
	{
		chainId: 56,
		address: "0x2222227E22102Fe3322098e4CBfE18cFebD57c95",
		name: "Alien Worlds",
		symbol: "TLM",
		decimals: 4,
		logoURI: "https://assets.coingecko.com/coins/images/14676/thumb/kY-C4o7RThfWrDQsLCAG4q4clZhBDDfJQVhWUEKxXAzyQYMj4Jmq1zmFwpRqxhAJFPOa0AsW_PTSshoPuMnXNwq3rU7Imp15QimXTjlXMx0nC088mt1rIwRs75GnLLugWjSllxgzvQ9YrP4tBgclK4_rb17hjnusGj_c0u2fx0AvVokjSNB-v2poTj0xT9BZRCbzRE3-lF1.jpg?1617700061"
	},
	{
		chainId: 56,
		address: "0x728C5baC3C3e370E372Fc4671f9ef6916b814d8B",
		name: "Unifi Protocol DAO",
		symbol: "UNFI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13152/thumb/logo-2.png?1605748967"
	},
	{
		chainId: 56,
		address: "0xBf5140A22578168FD562DCcF235E5D43A02ce9B1",
		name: "Uniswap",
		symbol: "UNI",
		decimals: 18,
		logoURI: "ipfs://QmXttGpZrECX5qCyXbBQiqgQNytVGeZW5Anewvh2jc4psg"
	},
	{
		chainId: 56,
		address: "0x0D35A2B85c5A63188d566D104bEbf7C694334Ee4",
		name: "Pawtocol",
		symbol: "UPI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12186/thumb/pawtocol.jpg?1597962008"
	},
	{
		chainId: 56,
		address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
		name: "USDCoin",
		symbol: "USDC",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png"
	},
	{
		chainId: 56,
		address: "0x55d398326f99059fF775485246999027B3197955",
		name: "Tether USD",
		symbol: "USDT",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
	},
	{
		chainId: 56,
		address: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
		name: "Wrapped BNB",
		symbol: "WBNB",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/smartchain/assets/0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c/logo.png"
	},
	{
		chainId: 56,
		address: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
		name: "Wrapped Ether",
		symbol: "WETH",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
	},
	{
		chainId: 56,
		address: "0x4691937a7508860F876c9c0a2a617E7d9E945D4B",
		name: "WOO Network",
		symbol: "WOO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12921/thumb/w2UiemF__400x400.jpg?1603670367"
	},
	{
		chainId: 56,
		address: "0x7324c7C0d95CEBC73eEa7E85CbAac0dBdf88a05b",
		name: "Chain",
		symbol: "XCN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/24210/thumb/Chain_icon_200x200.png?1646895054"
	},
	{
		chainId: 137,
		address: "0x9c2C5fd7b07E95EE044DDeba0E97a665F142394f",
		name: "1inch",
		symbol: "1INCH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13469/thumb/1inch-token.png?1608803028"
	},
	{
		chainId: 137,
		address: "0xD6DF932A45C0f255f85145f286eA0b292B21C90B",
		name: "Aave",
		symbol: "AAVE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12645/thumb/AAVE.png?1601374110"
	},
	{
		chainId: 137,
		address: "0xdDa7b23D2D72746663E7939743f929a3d85FC975",
		name: "Ambire AdEx",
		symbol: "ADX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/847/thumb/Ambire_AdEx_Symbol_color.png?1655432540"
	},
	{
		chainId: 137,
		address: "0x6a6bD53d677F8632631662C48bD47b1D4D6524ee",
		name: "Adventure Gold",
		symbol: "AGLD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/18125/thumb/lpgblc4h_400x400.jpg?1630570955"
	},
	{
		chainId: 137,
		address: "0xe2341718c6C0CbFa8e6686102DD8FbF4047a9e9B",
		name: "AIOZ Network",
		symbol: "AIOZ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14631/thumb/aioz_logo.png?1617413126"
	},
	{
		chainId: 137,
		address: "0x95c300e7740D2A88a44124B424bFC1cB2F9c3b89",
		name: "Alchemix",
		symbol: "ALCX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14113/thumb/Alchemix.png?1614409874"
	},
	{
		chainId: 137,
		address: "0x82dCf1Df86AdA26b2dCd9ba6334CeDb8c2448e9e",
		name: "Aleph im",
		symbol: "ALEPH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11676/thumb/Monochram-aleph.png?1608483725"
	},
	{
		chainId: 137,
		address: "0xbFc70507384047Aa74c29Cdc8c5Cb88D0f7213AC",
		name: "Alethea Artificial Liquid Intelligence",
		symbol: "ALI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/22062/thumb/alethea-logo-transparent-colored.png?1642748848"
	},
	{
		chainId: 137,
		address: "0x50858d870FAF55da2fD90FB6DF7c34b5648305C6",
		name: "My Neighbor Alice",
		symbol: "ALICE",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/14375/thumb/alice_logo.jpg?1615782968"
	},
	{
		chainId: 137,
		address: "0x3AE490db48d74B1bC626400135d4616377D0109f",
		name: "Alpha Venture DAO",
		symbol: "ALPHA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12738/thumb/AlphaToken_256x256.png?1617160876"
	},
	{
		chainId: 137,
		address: "0x0621d647cecbFb64b79E44302c1933cB4f27054d",
		name: "Amp",
		symbol: "AMP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12409/thumb/amp-200x200.png?1599625397"
	},
	{
		chainId: 137,
		address: "0x101A023270368c0D50BFfb62780F4aFd4ea79C35",
		name: "Ankr",
		symbol: "ANKR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4324/thumb/U85xTl2.png?1608111978"
	},
	{
		chainId: 137,
		address: "0x2b8504ab5eFc246d0eC5Ec7E74565683227497de",
		name: "Aragon",
		symbol: "ANT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/681/thumb/JelZ58cv_400x400.png?1601449653"
	},
	{
		chainId: 137,
		address: "0xB7b31a6BC18e48888545CE79e83E06003bE70930",
		name: "ApeCoin",
		symbol: "APE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/24383/small/apecoin.jpg?1647476455"
	},
	{
		chainId: 137,
		address: "0x45C27821E80F8789b60Fd8B600C73815d34DDa6C",
		name: "API3",
		symbol: "API3",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13256/thumb/api3.jpg?1606751424"
	},
	{
		chainId: 137,
		address: "0xEE800B277A96B0f490a1A732e1D6395FAD960A26",
		name: "ARPA Chain",
		symbol: "ARPA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/8506/thumb/9u0a23XY_400x400.jpg?1559027357"
	},
	{
		chainId: 137,
		address: "0x04bEa9FCE76943E90520489cCAb84E84C0198E29",
		name: "AirSwap",
		symbol: "AST",
		decimals: 4,
		logoURI: "https://assets.coingecko.com/coins/images/1019/thumb/Airswap.png?1630903484"
	},
	{
		chainId: 137,
		address: "0x0df0f72EE0e5c9B7ca761ECec42754992B2Da5BF",
		name: "Automata",
		symbol: "ATA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15985/thumb/ATA.jpg?1622535745"
	},
	{
		chainId: 137,
		address: "0x5eB8D998371971D01954205c7AFE90A7AF6a95AC",
		name: "Audius",
		symbol: "AUDIO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12913/thumb/AudiusCoinLogo_2x.png?1603425727"
	},
	{
		chainId: 137,
		address: "0x61BDD9C7d4dF4Bf47A4508c0c8245505F2Af5b7b",
		name: "Axie Infinity",
		symbol: "AXS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13029/thumb/axie_infinity_logo.png?1604471082"
	},
	{
		chainId: 137,
		address: "0x1FcbE5937B0cc2adf69772D228fA4205aCF4D9b2",
		name: "Badger DAO",
		symbol: "BADGER",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13287/thumb/badger_dao_logo.jpg?1607054976"
	},
	{
		chainId: 137,
		address: "0x9a71012B13CA4d3D0Cdc72A177DF3ef03b0E76A3",
		name: "Balancer",
		symbol: "BAL",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xba100000625a3754423978a60c9317c58a424e3D/logo.png"
	},
	{
		chainId: 137,
		address: "0xA8b1E0764f85f53dfe21760e8AfE5446D82606ac",
		name: "Band Protocol",
		symbol: "BAND",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9545/thumb/band-protocol.png?1568730326"
	},
	{
		chainId: 137,
		address: "0x3Cef98bb43d732E2F285eE605a8158cDE967D219",
		name: "Basic Attention Token",
		symbol: "BAT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/677/thumb/basic-attention-token.png?1547034427"
	},
	{
		chainId: 137,
		address: "0x91c89A94567980f0e9723b487b0beD586eE96aa7",
		name: "Biconomy",
		symbol: "BICO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/21061/thumb/biconomy_logo.jpg?1638269749"
	},
	{
		chainId: 137,
		address: "0x438B28C5AA5F00a817b7Def7cE2Fb3d5d1970974",
		name: "Bluzelle",
		symbol: "BLZ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2848/thumb/ColorIcon_3x.png?1622516510"
	},
	{
		chainId: 137,
		address: "0xc26D47d5c33aC71AC5CF9F776D63Ba292a4F7842",
		name: "Bancor Network Token",
		symbol: "BNT",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x1F573D6Fb3F13d689FF844B4cE37794d79a7FF1C/logo.png"
	},
	{
		chainId: 137,
		address: "0xa4B2B20b2C73c7046ED19AC6bfF5E5285c58F20a",
		name: "Boba Network",
		symbol: "BOBA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/20285/thumb/BOBA.png?1636811576"
	},
	{
		chainId: 137,
		address: "0xA041544fe2BE56CCe31Ebb69102B965E06aacE80",
		name: "BarnBridge",
		symbol: "BOND",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12811/thumb/barnbridge.jpg?1602728853"
	},
	{
		chainId: 137,
		address: "0xdAb529f40E671A1D4bF91361c21bf9f0C9712ab7",
		name: "Binance USD",
		symbol: "BUSD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9576/thumb/BUSD.png?1568947766"
	},
	{
		chainId: 137,
		address: "0x91a4635F620766145C099E15889Bd2766906A559",
		name: "Celer Network",
		symbol: "CELR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4379/thumb/Celr.png?1554705437"
	},
	{
		chainId: 137,
		address: "0x594C984E3318e91313f881B021A0C4203fF5E59F",
		name: "Chromia",
		symbol: "CHR",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/5000/thumb/Chromia.png?1559038018"
	},
	{
		chainId: 137,
		address: "0xf1938Ce12400f9a761084E7A80d37e732a4dA056",
		name: "Chiliz",
		symbol: "CHZ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/8834/thumb/Chiliz.png?1561970540"
	},
	{
		chainId: 137,
		address: "0x8505b9d2254A7Ae468c0E9dd10Ccea3A837aef5c",
		name: "Compound",
		symbol: "COMP",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xc00e94Cb662C3520282E6f5717214004A7f26888/logo.png"
	},
	{
		chainId: 137,
		address: "0x93B0fF1C8828F6eB039D345Ff681eD735086d925",
		name: "Covalent",
		symbol: "CQT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14168/thumb/covalent-cqt.png?1624545218"
	},
	{
		chainId: 137,
		address: "0xAdA58DF0F643D959C2A47c9D4d4c1a4deFe3F11C",
		name: "Cronos",
		symbol: "CRO",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/7310/thumb/oCw2s3GI_400x400.jpeg?1645172042"
	},
	{
		chainId: 137,
		address: "0x172370d5Cd63279eFa6d502DAB29171933a610AF",
		name: "Curve DAO Token",
		symbol: "CRV",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xD533a949740bb3306d119CC777fa900bA034cd52/logo.png"
	},
	{
		chainId: 137,
		address: "0x2727Ab1c2D22170ABc9b595177B2D5C6E1Ab7B7B",
		name: "Cartesi",
		symbol: "CTSI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11038/thumb/cartesi.png?1592288021"
	},
	{
		chainId: 137,
		address: "0x8c208BC2A808a088a78398fed8f2640cab0b6EDb",
		name: "Cryptex Finance",
		symbol: "CTX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14932/thumb/glossy_icon_-_C200px.png?1619073171"
	},
	{
		chainId: 137,
		address: "0x276C9cbaa4BDf57d7109a41e67BD09699536FA3d",
		name: "Somnium Space CUBEs",
		symbol: "CUBE",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/10687/thumb/CUBE_icon.png?1617026861"
	},
	{
		chainId: 137,
		address: "0x66Dc5A08091d1968e08C16aA5b27BAC8398b02Be",
		name: "Civic",
		symbol: "CVC",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/788/thumb/civic.png?1547034556"
	},
	{
		chainId: 137,
		address: "0x4257EA7637c355F81616050CbB6a9b709fd72683",
		name: "Convex Finance",
		symbol: "CVX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15585/thumb/convex.png?1621256328"
	},
	{
		chainId: 137,
		address: "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063",
		name: "Dai Stablecoin",
		symbol: "DAI",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png"
	},
	{
		chainId: 137,
		address: "0x26f5FB1e6C8a65b3A873fF0a213FA16EFF5a7828",
		name: "DerivaDAO",
		symbol: "DDX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13453/thumb/ddx_logo.png?1608741641"
	},
	{
		chainId: 137,
		address: "0xff835562C761205659939B64583dd381a6AA4D92",
		name: "DexTools",
		symbol: "DEXT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11603/thumb/dext.png?1605790188"
	},
	{
		chainId: 137,
		address: "0x993f2CafE9dbE525243f4A78BeBC69DAc8D36000",
		name: "DIA",
		symbol: "DIA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11955/thumb/image.png?1646041751"
	},
	{
		chainId: 137,
		address: "0x85955046DF4668e1DD369D2DE9f3AEB98DD2A369",
		name: "DeFi Pulse Index",
		symbol: "DPI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12465/thumb/defi_pulse_index_set.png?1600051053"
	},
	{
		chainId: 137,
		address: "0x4C3bF0a3DE9524aF68327d1D2558a3B70d17D42a",
		name: "dYdX",
		symbol: "DYDX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17500/thumb/hjnIm9bV.jpg?1628009360"
	},
	{
		chainId: 137,
		address: "0xE0339c80fFDE91F3e20494Df88d4206D86024cdF",
		name: "Dogelon Mars",
		symbol: "ELON",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14962/thumb/6GxcPRo3_400x400.jpg?1619157413"
	},
	{
		chainId: 137,
		address: "0x7eC26842F195c852Fa843bB9f6D8B583a274a157",
		name: "Enjin Coin",
		symbol: "ENJ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/1102/thumb/enjin-coin-logo.png?1547035078"
	},
	{
		chainId: 137,
		address: "0xbD7A5Cf51d22930B8B3Df6d834F9BCEf90EE7c4f",
		name: "Ethereum Name Service",
		symbol: "ENS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/19785/thumb/acatxTm8_400x400.jpg?1635850140"
	},
	{
		chainId: 137,
		address: "0x0E50BEA95Fe001A370A4F1C220C49AEdCB982DeC",
		name: "Ethernity Chain",
		symbol: "ERN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14238/thumb/LOGO_HIGH_QUALITY.png?1647831402"
	},
	{
		chainId: 137,
		address: "0x8a037dbcA8134FFc72C362e394e35E0Cad618F85",
		name: "Euro Coin",
		symbol: "EUROC",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/26045/thumb/euro-coin.png?1655394420"
	},
	{
		chainId: 137,
		address: "0x176f5AB638cf4Ff3B6239Ba609C3fadAA46ef5B0",
		name: "Harvest Finance",
		symbol: "FARM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12304/thumb/Harvest.png?1613016180"
	},
	{
		chainId: 137,
		address: "0x7583FEDDbceFA813dc18259940F76a02710A8905",
		name: "Fetch ai",
		symbol: "FET",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/5681/thumb/Fetch.jpg?1572098136"
	},
	{
		chainId: 137,
		address: "0x7A7B94F18EF6AD056CDa648588181CDA84800f94",
		name: "Stafi",
		symbol: "FIS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12423/thumb/stafi_logo.jpg?1599730991"
	},
	{
		chainId: 137,
		address: "0x9ff62d1FC52A907B6DCbA8077c2DDCA6E6a9d3e1",
		name: "Forta",
		symbol: "FORT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/25060/thumb/Forta_lgo_%281%29.png?1655353696"
	},
	{
		chainId: 137,
		address: "0x5eCbA59DAcc1ADc5bDEA35f38A732823fc3dE977",
		name: "Ampleforth Governance Token",
		symbol: "FORTH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14917/thumb/photo_2021-04-22_00.00.03.jpeg?1619020835"
	},
	{
		chainId: 137,
		address: "0x65A05DB8322701724c197AF82C9CaE41195B0aA8",
		name: "ShapeShift FOX Token",
		symbol: "FOX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9988/thumb/FOX.png?1574330622"
	},
	{
		chainId: 137,
		address: "0x104592a158490a9228070E0A8e5343B499e125D0",
		name: "Frax",
		symbol: "FRAX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13422/thumb/frax_logo.png?1608476506"
	},
	{
		chainId: 137,
		address: "0xC9c1c1c20B3658F8787CC2FD702267791f224Ce1",
		name: "Fantom",
		symbol: "FTM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4001/thumb/Fantom.png?1558015016"
	},
	{
		chainId: 137,
		address: "0x3e121107F6F22DA4911079845a470757aF4e1A1b",
		name: "Frax Share",
		symbol: "FXS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13423/thumb/frax_share.png?1608478989"
	},
	{
		chainId: 137,
		address: "0x09E1943Dd2A4e82032773594f50CF54453000b97",
		name: "Gala",
		symbol: "GALA",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/12493/thumb/GALA-COINGECKO.png?1600233435"
	},
	{
		chainId: 137,
		address: "0x385Eeac5cB85A38A9a07A70c73e0a3271CfB54A7",
		name: "Aavegotchi",
		symbol: "GHST",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12467/thumb/ghst_200.png?1600750321"
	},
	{
		chainId: 137,
		address: "0x0B220b82F3eA3B7F6d9A1D8ab58930C064A2b5Bf",
		name: "Golem",
		symbol: "GLM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/542/thumb/Golem_Submark_Positive_RGB.png?1606392013"
	},
	{
		chainId: 137,
		address: "0x5FFD62D3C3eE2E81C00A7b9079FB248e7dF024A8",
		name: "Gnosis Token",
		symbol: "GNO",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6810e776880C02933D47DB1b9fc05908e5386b96/logo.png"
	},
	{
		chainId: 137,
		address: "0xF88fc6b493eda7650E4bcf7A290E8d108F677CfE",
		name: "Gods Unchained",
		symbol: "GODS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17139/thumb/10631.png?1635718182"
	},
	{
		chainId: 137,
		address: "0x5fe2B58c013d7601147DcdD68C143A77499f5531",
		name: "The Graph",
		symbol: "GRT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13397/thumb/Graph_Token.png?1608145566"
	},
	{
		chainId: 137,
		address: "0xdb95f9188479575F3F718a245EcA1B3BF74567EC",
		name: "Gitcoin",
		symbol: "GTC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15810/thumb/gitcoin.png?1621992929"
	},
	{
		chainId: 137,
		address: "0xC8A94a3d3D2dabC3C1CaffFFDcA6A7543c3e3e65",
		name: "Gemini Dollar",
		symbol: "GUSD",
		decimals: 2,
		logoURI: "https://assets.coingecko.com/coins/images/5992/thumb/gemini-dollar-gusd.png?1536745278"
	},
	{
		chainId: 137,
		address: "0x482bc619eE7662759CDc0685B4E78f464Da39C73",
		name: "GYEN",
		symbol: "GYEN",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/14191/thumb/icon_gyen_200_200.png?1614843343"
	},
	{
		chainId: 137,
		address: "0x6cCBF3627b2C83AFEF05bf2F035E7f7B210Fe30D",
		name: "HOPR",
		symbol: "HOPR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14061/thumb/Shared_HOPR_logo_512px.png?1614073468"
	},
	{
		chainId: 137,
		address: "0x9Cb74C8032b007466865f060ad2c46145d45553D",
		name: "IDEX",
		symbol: "IDEX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2565/thumb/logomark-purple-286x286.png?1638362736"
	},
	{
		chainId: 137,
		address: "0xFA46dAf9909e116DBc40Fe1cC95fC0Bb1f452aBE",
		name: "Illuvium",
		symbol: "ILV",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14468/large/ILV.JPG"
	},
	{
		chainId: 137,
		address: "0x183070C90B34A63292cC908Ce1b263Cb56D49A7F",
		name: "Immutable X",
		symbol: "IMX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17233/thumb/imx.png?1636691817"
	},
	{
		chainId: 137,
		address: "0xfBd8A3b908e764dBcD51e27992464B4432A1132b",
		name: "Index Cooperative",
		symbol: "INDEX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12729/thumb/index.png?1634894321"
	},
	{
		chainId: 137,
		address: "0x4E8dc2149EaC3f3dEf36b1c281EA466338249371",
		name: "Injective",
		symbol: "INJ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12882/thumb/Secondary_Symbol.png?1628233237"
	},
	{
		chainId: 137,
		address: "0xF18Ac368001b0DdC80aA6a8374deb49e868EFDb8",
		name: "Inverse Finance",
		symbol: "INV",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14205/thumb/inverse_finance.jpg?1614921871"
	},
	{
		chainId: 137,
		address: "0xf6372cDb9c1d3674E83842e3800F2A62aC9F3C66",
		name: "IoTeX",
		symbol: "IOTX",
		decimals: 18,
		logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/2777.png"
	},
	{
		chainId: 137,
		address: "0xb87f5c1E81077FfcfE821dA240fd20C99c533aF1",
		name: "JasmyCoin",
		symbol: "JASMY",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13876/thumb/JASMY200x200.jpg?1612473259"
	},
	{
		chainId: 137,
		address: "0x42f37A1296b2981F7C3cAcEd84c5096b2Eb0C72C",
		name: "Keep Network",
		symbol: "KEEP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/3373/thumb/IuNzUb5b_400x400.jpg?1589526336"
	},
	{
		chainId: 137,
		address: "0x324b28d6565f784d596422B0F2E5aB6e9CFA1Dc7",
		name: "Kyber Network Crystal",
		symbol: "KNC",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdd974D5C2e2928deA5F71b9825b8b646686BD200/logo.png"
	},
	{
		chainId: 137,
		address: "0x53AEc293212E3B792563Bc16f1be26956adb12e9",
		name: "Keep3rV1",
		symbol: "KP3R",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12966/thumb/kp3r_logo.jpg?1607057458"
	},
	{
		chainId: 137,
		address: "0xE8A51D0dD1b4525189ddA2187F90ddF0932b5482",
		name: "LCX",
		symbol: "LCX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9985/thumb/zRPSu_0o_400x400.jpg?1574327008"
	},
	{
		chainId: 137,
		address: "0xC3C7d422809852031b44ab29EEC9F1EfF2A58756",
		name: "Lido DAO",
		symbol: "LDO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13573/thumb/Lido_DAO.png?1609873644"
	},
	{
		chainId: 137,
		address: "0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39",
		name: "ChainLink Token",
		symbol: "LINK",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x514910771AF9Ca656af840dff83E8264EcF986CA/logo.png"
	},
	{
		chainId: 137,
		address: "0x465b67CB20A7E8bC4c51b4C7DA591C1945b41427",
		name: "League of Kingdoms",
		symbol: "LOKA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/22572/thumb/loka_64pix.png?1642643271"
	},
	{
		chainId: 137,
		address: "0x66EfB7cC647e0efab02eBA4316a2d2941193F6b3",
		name: "Loom Network",
		symbol: "LOOM",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA4e8C3Ec456107eA67d3075bF9e3DF3A75823DB0/logo.png"
	},
	{
		chainId: 137,
		address: "0x3962F4A0A0051DccE0be73A7e09cEf5756736712",
		name: "Livepeer",
		symbol: "LPT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/7137/thumb/logo-circle-green.png?1619593365"
	},
	{
		chainId: 137,
		address: "0x8Ab2Fec94d17ae69FB90E7c773f2C85Ed1802c01",
		name: "Liquity",
		symbol: "LQTY",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14665/thumb/200-lqty-icon.png?1617631180"
	},
	{
		chainId: 137,
		address: "0x84e1670F61347CDaeD56dcc736FB990fBB47ddC1",
		name: "LoopringCoin V2",
		symbol: "LRC",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xBBbbCA6A901c926F240b89EacB641d8Aec7AEafD/logo.png"
	},
	{
		chainId: 137,
		address: "0x23001f892c0C82b79303EDC9B9033cD190BB21c7",
		name: "Liquity USD",
		symbol: "LUSD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14666/thumb/Group_3.png?1617631327"
	},
	{
		chainId: 137,
		address: "0xA1c57f48F0Deb89f569dFbE6E2B7f46D33606fD4",
		name: "Decentraland",
		symbol: "MANA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/878/thumb/decentraland-mana.png?1550108745"
	},
	{
		chainId: 137,
		address: "0x2B9E7ccDF0F4e5B24757c1E1a80e311E34Cb10c7",
		name: "Mask Network",
		symbol: "MASK",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14051/thumb/Mask_Network.jpg?1614050316"
	},
	{
		chainId: 137,
		address: "0x347ACCAFdA7F8c5BdeC57fa34a5b663CBd1aeca7",
		name: "MATH",
		symbol: "MATH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11335/thumb/2020-05-19-token-200.png?1589940590"
	},
	{
		chainId: 137,
		address: "0x0000000000000000000000000000000000001010",
		name: "Polygon",
		symbol: "MATIC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4713/thumb/matic-token-icon.png?1624446912"
	},
	{
		chainId: 137,
		address: "0xAa7DbD1598251f856C12f63557A4C4397c253Cea",
		name: "Moss Carbon Credit",
		symbol: "MCO2",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14414/thumb/ENtxnThA_400x400.jpg?1615948522"
	},
	{
		chainId: 137,
		address: "0x1B9D40715E757Bdb9bdEC3215B898E46d8a3b71a",
		name: "Metis",
		symbol: "METIS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15595/thumb/metis.jpeg?1660285312"
	},
	{
		chainId: 137,
		address: "0x01288e04435bFcd4718FF203D6eD18146C17Cd4b",
		name: "Magic Internet Money",
		symbol: "MIM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/16786/thumb/mimlogopng.png?1624979612"
	},
	{
		chainId: 137,
		address: "0x1C5cccA2CB59145A4B25F452660cbA6436DDce9b",
		name: "Mirror Protocol",
		symbol: "MIR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13295/thumb/mirror_logo_transparent.png?1611554658"
	},
	{
		chainId: 137,
		address: "0x6f7C932e7684666C9fd1d44527765433e01fF61d",
		name: "Maker",
		symbol: "MKR",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2/logo.png"
	},
	{
		chainId: 137,
		address: "0xa9f37D84c856fDa3812ad0519Dad44FA0a3Fe207",
		name: "Melon",
		symbol: "MLN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/605/thumb/melon.png?1547034295"
	},
	{
		chainId: 137,
		address: "0x6968105460f67c3BF751bE7C15f92F5286Fd0CE5",
		name: "Monavale",
		symbol: "MONA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13298/thumb/monavale_logo.jpg?1607232721"
	},
	{
		chainId: 137,
		address: "0xA3c322Ad15218fBFAEd26bA7f616249f7705D945",
		name: "GensoKishi Metaverse",
		symbol: "MV",
		decimals: 18,
		logoURI: "https://s2.coinmarketcap.com/static/img/coins/64x64/17704.png"
	},
	{
		chainId: 137,
		address: "0x4985E0B13554fB521840e893574D3848C10Fcc6f",
		name: "PolySwarm",
		symbol: "NCT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2843/thumb/ImcYCVfX_400x400.jpg?1628519767"
	},
	{
		chainId: 137,
		address: "0x0Bf519071b02F22C17E7Ed5F4002ee1911f46729",
		name: "Numeraire",
		symbol: "NMR",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671/logo.png"
	},
	{
		chainId: 137,
		address: "0x282d8efCe846A88B159800bd4130ad77443Fa1A1",
		name: "Ocean Protocol",
		symbol: "OCEAN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/3687/thumb/ocean-protocol-logo.jpg?1547038686"
	},
	{
		chainId: 137,
		address: "0xa63Beffd33AB3a2EfD92a39A7D2361CEE14cEbA8",
		name: "Origin Protocol",
		symbol: "OGN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/3296/thumb/op.jpg?1547037878"
	},
	{
		chainId: 137,
		address: "0x62414D03084EeB269E18C970a21f45D2967F0170",
		name: "OMG Network",
		symbol: "OMG",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/776/thumb/OMG_Network.jpg?1591167168"
	},
	{
		chainId: 137,
		address: "0x0EE392bA5ef1354c9bd75a98044667d307C0e773",
		name: "Orion Protocol",
		symbol: "ORN",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/11841/thumb/orion_logo.png?1594943318"
	},
	{
		chainId: 137,
		address: "0x9880e3dDA13c8e7D4804691A45160102d31F6060",
		name: "Orchid",
		symbol: "OXT",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x4575f41308EC1483f3d399aa9a2826d74Da13Deb/logo.png"
	},
	{
		chainId: 137,
		address: "0x553d3D295e0f695B9228246232eDF400ed3560B5",
		name: "PAX Gold",
		symbol: "PAXG",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9519/thumb/paxg.PNG?1568542565"
	},
	{
		chainId: 137,
		address: "0x263534a4Fe3cb249dF46810718B7B612a30ebbff",
		name: "Perpetual Protocol",
		symbol: "PERP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12381/thumb/60d18e06844a844ad75901a9_mark_only_03.png?1628674771"
	},
	{
		chainId: 137,
		address: "0x8765f05ADce126d70bcdF1b0a48Db573316662eB",
		name: "PlayDapp",
		symbol: "PLA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14316/thumb/54023228.png?1615366911"
	},
	{
		chainId: 137,
		address: "0x7dc0cb65EC6019330a6841e9c274f2EE57A6CA6C",
		name: "Pluton",
		symbol: "PLU",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/1241/thumb/pluton.png?1548331624"
	},
	{
		chainId: 137,
		address: "0x8dc302e2141DA59c934d900886DbF1518Fd92cd4",
		name: "Polkastarter",
		symbol: "POLS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12648/thumb/polkastarter.png?1609813702"
	},
	{
		chainId: 137,
		address: "0xcB059C5573646047D6d88dDdb87B745C18161d3b",
		name: "Polymath",
		symbol: "POLY",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2784/thumb/inKkF01.png?1605007034"
	},
	{
		chainId: 137,
		address: "0x73580A2416A57f1C4b6391DBA688A9e4f7DBECE0",
		name: "Marlin",
		symbol: "POND",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/8903/thumb/POND_200x200.png?1622515451"
	},
	{
		chainId: 137,
		address: "0x0AaB8DC887D34f00D50E19aee48371a941390d14",
		name: "Power Ledger",
		symbol: "POWR",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/1104/thumb/power-ledger.png?1547035082"
	},
	{
		chainId: 137,
		address: "0x82FFdFD1d8699E8886a4e77CeFA9dd9710a7FefD",
		name: "Propy",
		symbol: "PRO",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/869/thumb/propy.png?1548332100"
	},
	{
		chainId: 137,
		address: "0x9377Eeb7419486FD4D485671d50baa4BF77c2222",
		name: "PARSIQ",
		symbol: "PRQ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11973/thumb/DsNgK0O.png?1596590280"
	},
	{
		chainId: 137,
		address: "0x36B77a184bE8ee56f5E81C56727B20647A42e28E",
		name: "Quant",
		symbol: "QNT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/3370/thumb/5ZOu7brX_400x400.jpg?1612437252"
	},
	{
		chainId: 137,
		address: "0x831753DD7087CaC61aB5644b308642cc1c33Dc13",
		name: "Quickswap",
		symbol: "QUICK",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13970/thumb/1_pOU6pBMEmiL-ZJVb0CYRjQ.png?1613386659"
	},
	{
		chainId: 137,
		address: "0x2f81e176471CC57fDC76f7d332FB4511bF2bebDD",
		name: "Radicle",
		symbol: "RAD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14013/thumb/radicle.png?1614402918"
	},
	{
		chainId: 137,
		address: "0x00e5646f60AC6Fb446f621d146B6E1886f002905",
		name: "Rai Reflex Index",
		symbol: "RAI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14004/thumb/RAI-logo-coin.png?1613592334"
	},
	{
		chainId: 137,
		address: "0x780053837cE2CeEaD2A90D9151aA21FC89eD49c2",
		name: "Rarible",
		symbol: "RARI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11845/thumb/Rari.png?1594946953"
	},
	{
		chainId: 137,
		address: "0xc3cFFDAf8F3fdF07da6D5e3A89B8723D5E385ff8",
		name: "Rubic",
		symbol: "RBC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12629/thumb/200x200.png?1607952509"
	},
	{
		chainId: 137,
		address: "0x19782D3Dc4701cEeeDcD90f0993f0A9126ed89d0",
		name: "Republic Token",
		symbol: "REN",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x408e41876cCCDC0F92210600ef50372656052a38/logo.png"
	},
	{
		chainId: 137,
		address: "0x6563c1244820CfBd6Ca8820FBdf0f2847363F733",
		name: "Reputation Augur v2",
		symbol: "REPv2",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x221657776846890989a759BA2973e427DfF5C9bB/logo.png"
	},
	{
		chainId: 137,
		address: "0xAdf2F2Ed91755eA3f4bcC9107a494879f633ae7C",
		name: "Request",
		symbol: "REQ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/1031/thumb/Request_icon_green.png?1643250951"
	},
	{
		chainId: 137,
		address: "0x70c006878a5A50Ed185ac4C87d837633923De296",
		name: "REVV",
		symbol: "REVV",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12373/thumb/REVV_TOKEN_Refined_2021_%281%29.png?1627652390"
	},
	{
		chainId: 137,
		address: "0x3b9dB434F08003A89554CDB43b3e0b1f8734BdE7",
		name: "Rari Governance Token",
		symbol: "RGT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12900/thumb/Rari_Logo_Transparent.png?1613978014"
	},
	{
		chainId: 137,
		address: "0xbe662058e00849C3Eef2AC9664f37fEfdF2cdbFE",
		name: "iExec RLC",
		symbol: "RLC",
		decimals: 9,
		logoURI: "https://assets.coingecko.com/coins/images/646/thumb/pL1VuXm.png?1604543202"
	},
	{
		chainId: 137,
		address: "0x76b8D57e5ac6afAc5D415a054453d1DD2c3C0094",
		name: "Rally",
		symbol: "RLY",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12843/thumb/image.png?1611212077"
	},
	{
		chainId: 137,
		address: "0x61299774020dA444Af134c82fa83E3810b309991",
		name: "Render Token",
		symbol: "RNDR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11636/thumb/rndr.png?1638840934"
	},
	{
		chainId: 137,
		address: "0xF92501c8213da1D6C74A76372CCc720Dc8818407",
		name: "Rook",
		symbol: "ROOK",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13005/thumb/keeper_dao_logo.jpg?1604316506"
	},
	{
		chainId: 137,
		address: "0xBbba073C31bF03b8ACf7c28EF0738DeCF3695683",
		name: "The Sandbox",
		symbol: "SAND",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12129/thumb/sandbox_logo.jpg?1597397942"
	},
	{
		chainId: 137,
		address: "0x6f8a06447Ff6FcF75d803135a7de15CE88C1d4ec",
		name: "Shiba Inu",
		symbol: "SHIB",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11939/thumb/shiba.png?1622619446"
	},
	{
		chainId: 137,
		address: "0x0C7304fBAf2A320a1c50c46FE03752722F729946",
		name: "Smooth Love Potion",
		symbol: "SLP",
		decimals: 0,
		logoURI: "https://assets.coingecko.com/coins/images/10366/thumb/SLP.png?1578640057"
	},
	{
		chainId: 137,
		address: "0x50B728D8D964fd00C2d0AAD81718b71311feF68a",
		name: "Synthetix Network Token",
		symbol: "SNX",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F/logo.png"
	},
	{
		chainId: 137,
		address: "0xcdB3C70CD25FD15307D84C4F9D37d5C043B33Fb2",
		name: "Spell Token",
		symbol: "SPELL",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15861/thumb/abracadabra-3.png?1622544862"
	},
	{
		chainId: 137,
		address: "0xd72357dAcA2cF11A5F155b9FF7880E595A3F5792",
		name: "Storj Token",
		symbol: "STORJ",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xB64ef51C888972c908CFacf59B47C1AfBC0Ab8aC/logo.png"
	},
	{
		chainId: 137,
		address: "0xB36e3391B22a970d31A9b620Ae1A414C6c256d2a",
		name: "Stox",
		symbol: "STX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/1230/thumb/stox-token.png?1547035256"
	},
	{
		chainId: 137,
		address: "0x60Ea918FC64360269Da4efBDA11d8fC6514617C6",
		name: "SUKU",
		symbol: "SUKU",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11969/thumb/UmfW5S6f_400x400.jpg?1596602238"
	},
	{
		chainId: 137,
		address: "0xa1428174F516F527fafdD146b883bB4428682737",
		name: "SuperFarm",
		symbol: "SUPER",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14040/thumb/6YPdWn6.png?1613975899"
	},
	{
		chainId: 137,
		address: "0xF81b4Bec6Ca8f9fe7bE01CA734F55B2b6e03A7a0",
		name: "Synth sUSD",
		symbol: "sUSD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"
	},
	{
		chainId: 137,
		address: "0x0b3F868E0BE5597D5DB7fEB59E1CADBb0fdDa50a",
		name: "Sushi",
		symbol: "SUSHI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12271/thumb/512x512_Logo_no_chop.png?1606986688"
	},
	{
		chainId: 137,
		address: "0x6aBB753C1893194DE4a83c6e8B4EadFc105Fd5f5",
		name: "Swipe",
		symbol: "SXP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9368/thumb/swipe.png?1566792311"
	},
	{
		chainId: 137,
		address: "0xe1708AbDE4847B4929b70547E5197F1Ba1db2250",
		name: "Tokemak",
		symbol: "TOKE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17495/thumb/tokemak-avatar-200px-black.png?1628131614"
	},
	{
		chainId: 137,
		address: "0xA7b98d63a137bF402b4570799ac4caD0BB1c4B1c",
		name: "OriginTrail",
		symbol: "TRAC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/1877/thumb/TRAC.jpg?1635134367"
	},
	{
		chainId: 137,
		address: "0xE3322702BEdaaEd36CdDAb233360B939775ae5f1",
		name: "Tellor",
		symbol: "TRB",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9644/thumb/Blk_icon_current.png?1584980686"
	},
	{
		chainId: 137,
		address: "0x8676815789211E799a6DC86d02748ADF9cF86836",
		name: "Tribe",
		symbol: "TRIBE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14575/thumb/tribe.PNG?1617487954"
	},
	{
		chainId: 137,
		address: "0x5b77bCA482bd3E7958b1103d123888EfCCDaF803",
		name: "TrueFi",
		symbol: "TRU",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/13180/thumb/truefi_glyph_color.png?1617610941"
	},
	{
		chainId: 137,
		address: "0x5667dcC0ab74D1b1355C3b2061893399331B57e2",
		name: "The Virtua Kolect",
		symbol: "TVK",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13330/thumb/virtua_original.png?1656043619"
	},
	{
		chainId: 137,
		address: "0x3066818837c5e6eD6601bd5a91B0762877A6B731",
		name: "UMA Voting Token v1",
		symbol: "UMA",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828/logo.png"
	},
	{
		chainId: 137,
		address: "0xb33EaAd8d922B1083446DC23f610c2567fB5180f",
		name: "Uniswap",
		symbol: "UNI",
		decimals: 18,
		logoURI: "ipfs://QmXttGpZrECX5qCyXbBQiqgQNytVGeZW5Anewvh2jc4psg"
	},
	{
		chainId: 137,
		address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174",
		name: "USDCoin",
		symbol: "USDC",
		decimals: 6,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png"
	},
	{
		chainId: 137,
		address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
		name: "Tether USD",
		symbol: "USDT",
		decimals: 6,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
	},
	{
		chainId: 137,
		address: "0xd0258a3fD00f38aa8090dfee343f10A9D4d30D3F",
		name: "Voxies",
		symbol: "VOXEL",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/21260/large/voxies.png"
	},
	{
		chainId: 137,
		address: "0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6",
		name: "Wrapped BTC",
		symbol: "WBTC",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png"
	},
	{
		chainId: 137,
		address: "0x90bb6fEB70A9a43CfAaA615F856BA309FD759A90",
		name: "Wrapped Centrifuge",
		symbol: "WCFG",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17106/thumb/WCFG.jpg?1626266462"
	},
	{
		chainId: 137,
		address: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619",
		name: "Wrapped Ether",
		symbol: "WETH",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
	},
	{
		chainId: 137,
		address: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
		name: "Wrapped Matic",
		symbol: "WMATIC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4713/thumb/matic-token-icon.png?1624446912"
	},
	{
		chainId: 137,
		address: "0x1B815d120B3eF02039Ee11dC2d33DE7aA4a8C603",
		name: "WOO Network",
		symbol: "WOO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12921/thumb/w2UiemF__400x400.jpg?1603670367"
	},
	{
		chainId: 137,
		address: "0xd2507e7b5794179380673870d88B22F94da6abe0",
		name: "XYO Network",
		symbol: "XYO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4519/thumb/XYO_Network-logo.png?1547039819"
	},
	{
		chainId: 137,
		address: "0xDA537104D6A5edd53c6fBba9A898708E465260b6",
		name: "yearn finance",
		symbol: "YFI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11849/thumb/yfi-192x192.png?1598325330"
	},
	{
		chainId: 137,
		address: "0xb8cb8a7F4C2885C03e57E973C74827909Fdc2032",
		name: "DFI money",
		symbol: "YFII",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11902/thumb/YFII-logo.78631676.png?1598677348"
	},
	{
		chainId: 137,
		address: "0x82617aA52dddf5Ed9Bb7B370ED777b3182A30fd1",
		name: "Yield Guild Games",
		symbol: "YGG",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17358/thumb/le1nzlO6_400x400.jpg?1632465691"
	},
	{
		chainId: 137,
		address: "0x5559Edb74751A0edE9DeA4DC23aeE72cCA6bE3D5",
		name: "0x Protocol Token",
		symbol: "ZRX",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xE41d2489571d322189246DaFA5ebDe1F4699F498/logo.png"
	},
	{
		chainId: 42161,
		address: "0x6314C31A7a1652cE482cffe247E9CB7c3f4BB9aF",
		name: "1inch",
		symbol: "1INCH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13469/thumb/1inch-token.png?1608803028"
	},
	{
		chainId: 42161,
		address: "0xba5DdD1f9d7F570dc94a51479a000E3BCE967196",
		name: "Aave",
		symbol: "AAVE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12645/thumb/AAVE.png?1601374110"
	},
	{
		chainId: 42161,
		address: "0xb7910E8b16e63EFD51d5D1a093d56280012A3B9C",
		name: "Adventure Gold",
		symbol: "AGLD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/18125/thumb/lpgblc4h_400x400.jpg?1630570955"
	},
	{
		chainId: 42161,
		address: "0xeC76E8fe6e2242e6c2117caA244B9e2DE1569923",
		name: "AIOZ Network",
		symbol: "AIOZ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14631/thumb/aioz_logo.png?1617413126"
	},
	{
		chainId: 42161,
		address: "0xe7dcD50836d0A28c959c72D72122fEDB8E245A6C",
		name: "Aleph im",
		symbol: "ALEPH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11676/thumb/Monochram-aleph.png?1608483725"
	},
	{
		chainId: 42161,
		address: "0xeF6124368c0B56556667e0de77eA008DfC0a71d1",
		name: "Alethea Artificial Liquid Intelligence",
		symbol: "ALI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/22062/thumb/alethea-logo-transparent-colored.png?1642748848"
	},
	{
		chainId: 42161,
		address: "0xC9CBf102c73fb77Ec14f8B4C8bd88e050a6b2646",
		name: "Alpha Venture DAO",
		symbol: "ALPHA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12738/thumb/AlphaToken_256x256.png?1617160876"
	},
	{
		chainId: 42161,
		address: "0x1bfc5d35bf0f7B9e15dc24c78b8C02dbC1e95447",
		name: "Ankr",
		symbol: "ANKR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4324/thumb/U85xTl2.png?1608111978"
	},
	{
		chainId: 42161,
		address: "0x74885b4D524d497261259B38900f54e6dbAd2210",
		name: "ApeCoin",
		symbol: "APE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/24383/small/apecoin.jpg?1647476455"
	},
	{
		chainId: 42161,
		address: "0xF01dB12F50D0CDF5Fe360ae005b9c52F92CA7811",
		name: "API3",
		symbol: "API3",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13256/thumb/api3.jpg?1606751424"
	},
	{
		chainId: 42161,
		address: "0x912CE59144191C1204E64559FE8253a0e49E6548",
		name: "Arbitrum",
		symbol: "ARB",
		decimals: 18,
		logoURI: "https://arbitrum.foundation/logo.png"
	},
	{
		chainId: 42161,
		address: "0xAC9Ac2C17cdFED4AbC80A53c5553388575714d03",
		name: "Automata",
		symbol: "ATA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15985/thumb/ATA.jpg?1622535745"
	},
	{
		chainId: 42161,
		address: "0x23ee2343B892b1BB63503a4FAbc840E0e2C6810f",
		name: "Axelar",
		symbol: "AXL",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/27277/large/V-65_xQ1_400x400.jpeg"
	},
	{
		chainId: 42161,
		address: "0xe88998Fb579266628aF6a03e3821d5983e5D0089",
		name: "Axie Infinity",
		symbol: "AXS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13029/thumb/axie_infinity_logo.png?1604471082"
	},
	{
		chainId: 42161,
		address: "0xBfa641051Ba0a0Ad1b0AcF549a89536A0D76472E",
		name: "Badger DAO",
		symbol: "BADGER",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13287/thumb/badger_dao_logo.jpg?1607054976"
	},
	{
		chainId: 42161,
		address: "0x040d1EdC9569d4Bab2D15287Dc5A4F10F56a56B8",
		name: "Balancer",
		symbol: "BAL",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xba100000625a3754423978a60c9317c58a424e3D/logo.png"
	},
	{
		chainId: 42161,
		address: "0x3450687EF141dCd6110b77c2DC44B008616AeE75",
		name: "Basic Attention Token",
		symbol: "BAT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/677/thumb/basic-attention-token.png?1547034427"
	},
	{
		chainId: 42161,
		address: "0xa68Ec98D7ca870cF1Dd0b00EBbb7c4bF60A8e74d",
		name: "Biconomy",
		symbol: "BICO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/21061/thumb/biconomy_logo.jpg?1638269749"
	},
	{
		chainId: 42161,
		address: "0x406C8dB506653D882295875F633bEC0bEb921C2A",
		name: "BitDAO",
		symbol: "BIT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17627/thumb/rI_YptK8.png?1653983088"
	},
	{
		chainId: 42161,
		address: "0xEf171a5BA71348eff16616fd692855c2Fe606EB2",
		name: "Blur",
		symbol: "BLUR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/28453/large/blur.png?1670745921"
	},
	{
		chainId: 42161,
		address: "0x0D81E50bC677fa67341c44D7eaA9228DEE64A4e1",
		name: "BarnBridge",
		symbol: "BOND",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12811/thumb/barnbridge.jpg?1602728853"
	},
	{
		chainId: 42161,
		address: "0x31190254504622cEFdFA55a7d3d272e6462629a2",
		name: "Binance USD",
		symbol: "BUSD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9576/thumb/BUSD.png?1568947766"
	},
	{
		chainId: 42161,
		address: "0x1DEBd73E752bEaF79865Fd6446b0c970EaE7732f",
		name: "Coinbase Wrapped Staked ETH",
		symbol: "cbETH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/27008/large/cbeth.png"
	},
	{
		chainId: 42161,
		address: "0x3a8B787f78D775AECFEEa15706D4221B40F345AB",
		name: "Celer Network",
		symbol: "CELR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4379/thumb/Celr.png?1554705437"
	},
	{
		chainId: 42161,
		address: "0x354A6dA3fcde098F8389cad84b0182725c6C91dE",
		name: "Compound",
		symbol: "COMP",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xc00e94Cb662C3520282E6f5717214004A7f26888/logo.png"
	},
	{
		chainId: 42161,
		address: "0x6FE14d3CC2f7bDdffBa5CdB3BBE7467dd81ea101",
		name: "COTI",
		symbol: "COTI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2962/thumb/Coti.png?1559653863"
	},
	{
		chainId: 42161,
		address: "0x8ea3156f834A0dfC78F1A5304fAC2CdA676F354C",
		name: "Cronos",
		symbol: "CRO",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/7310/thumb/oCw2s3GI_400x400.jpeg?1645172042"
	},
	{
		chainId: 42161,
		address: "0x11cDb42B0EB46D95f990BeDD4695A6e3fA034978",
		name: "Curve DAO Token",
		symbol: "CRV",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xD533a949740bb3306d119CC777fa900bA034cd52/logo.png"
	},
	{
		chainId: 42161,
		address: "0x319f865b287fCC10b30d8cE6144e8b6D1b476999",
		name: "Cartesi",
		symbol: "CTSI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11038/thumb/cartesi.png?1592288021"
	},
	{
		chainId: 42161,
		address: "0x84F5c2cFba754E76DD5aE4fB369CfC920425E12b",
		name: "Cryptex Finance",
		symbol: "CTX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14932/thumb/glossy_icon_-_C200px.png?1619073171"
	},
	{
		chainId: 42161,
		address: "0x9DfFB23CAd3322440bCcFF7aB1C58E781dDBF144",
		name: "Civic",
		symbol: "CVC",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/788/thumb/civic.png?1547034556"
	},
	{
		chainId: 42161,
		address: "0xaAFcFD42c9954C6689ef1901e03db742520829c5",
		name: "Convex Finance",
		symbol: "CVX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15585/thumb/convex.png?1621256328"
	},
	{
		chainId: 42161,
		address: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1",
		name: "Dai Stablecoin",
		symbol: "DAI",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png"
	},
	{
		chainId: 42161,
		address: "0x3Be7cB2e9413Ef8F42b4A202a0114EB59b64e227",
		name: "DexTools",
		symbol: "DEXT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11603/thumb/dext.png?1605790188"
	},
	{
		chainId: 42161,
		address: "0xca642467C6Ebe58c13cB4A7091317f34E17ac05e",
		name: "DIA",
		symbol: "DIA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11955/thumb/image.png?1646041751"
	},
	{
		chainId: 42161,
		address: "0xE3696a02b2C9557639E29d829E9C45EFa49aD47A",
		name: "district0x",
		symbol: "DNT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/849/thumb/district0x.png?1547223762"
	},
	{
		chainId: 42161,
		address: "0x4667cf53C4eDF659E402B733BEA42B18B68dd74c",
		name: "DeFi Pulse Index",
		symbol: "DPI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12465/thumb/defi_pulse_index_set.png?1600051053"
	},
	{
		chainId: 42161,
		address: "0x51863cB90Ce5d6dA9663106F292fA27c8CC90c5a",
		name: "dYdX",
		symbol: "DYDX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17500/thumb/hjnIm9bV.jpg?1628009360"
	},
	{
		chainId: 42161,
		address: "0x3e4Cff6E50F37F731284A92d44AE943e17077fD4",
		name: "Dogelon Mars",
		symbol: "ELON",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14962/thumb/6GxcPRo3_400x400.jpg?1619157413"
	},
	{
		chainId: 42161,
		address: "0x7fa9549791EFc9030e1Ed3F25D18014163806758",
		name: "Enjin Coin",
		symbol: "ENJ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/1102/thumb/enjin-coin-logo.png?1547035078"
	},
	{
		chainId: 42161,
		address: "0xfeA31d704DEb0975dA8e77Bf13E04239e70d7c28",
		name: "Ethereum Name Service",
		symbol: "ENS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/19785/thumb/acatxTm8_400x400.jpg?1635850140"
	},
	{
		chainId: 42161,
		address: "0x2354c8e9Ea898c751F1A15Addeb048714D667f96",
		name: "Ethernity Chain",
		symbol: "ERN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14238/thumb/LOGO_HIGH_QUALITY.png?1647831402"
	},
	{
		chainId: 42161,
		address: "0x863708032B5c328e11aBcbC0DF9D79C71Fc52a48",
		name: "Euro Coin",
		symbol: "EUROC",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/26045/thumb/euro-coin.png?1655394420"
	},
	{
		chainId: 42161,
		address: "0x8553d254Cb6934b16F87D2e486b64BbD24C83C70",
		name: "Harvest Finance",
		symbol: "FARM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12304/thumb/Harvest.png?1613016180"
	},
	{
		chainId: 42161,
		address: "0x4BE87C766A7CE11D5Cc864b6C3Abb7457dCC4cC9",
		name: "Fetch ai",
		symbol: "FET",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/5681/thumb/Fetch.jpg?1572098136"
	},
	{
		chainId: 42161,
		address: "0x849B40AB2469309117Ed1038c5A99894767C7282",
		name: "Stafi",
		symbol: "FIS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12423/thumb/stafi_logo.jpg?1599730991"
	},
	{
		chainId: 42161,
		address: "0x3A1429d50E0cBBc45c997aF600541Fe1cc3D2923",
		name: "Forta",
		symbol: "FORT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/25060/thumb/Forta_lgo_%281%29.png?1655353696"
	},
	{
		chainId: 42161,
		address: "0xf929de51D91C77E42f5090069E0AD7A09e513c73",
		name: "ShapeShift FOX Token",
		symbol: "FOX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9988/thumb/FOX.png?1574330622"
	},
	{
		chainId: 42161,
		address: "0x7468a5d8E02245B00E8C0217fCE021C70Bc51305",
		name: "Frax",
		symbol: "FRAX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13422/thumb/frax_logo.png?1608476506"
	},
	{
		chainId: 42161,
		address: "0xd42785D323e608B9E99fa542bd8b1000D4c2Df37",
		name: "Fantom",
		symbol: "FTM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4001/thumb/Fantom.png?1558015016"
	},
	{
		chainId: 42161,
		address: "0xd9f9d2Ee2d3EFE420699079f16D9e924affFdEA4",
		name: "Frax Share",
		symbol: "FXS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13423/thumb/frax_share.png?1608478989"
	},
	{
		chainId: 42161,
		address: "0x2Ed5C8fA0D7Ad71025638aFe5fd72E4fbc5A2667",
		name: "Gala",
		symbol: "GALA",
		decimals: 8,
		logoURI: "https://assets.coingecko.com/coins/images/12493/thumb/GALA-COINGECKO.png?1600233435"
	},
	{
		chainId: 42161,
		address: "0xa0b862F60edEf4452F25B4160F177db44DeB6Cf1",
		name: "Gnosis Token",
		symbol: "GNO",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6810e776880C02933D47DB1b9fc05908e5386b96/logo.png"
	},
	{
		chainId: 42161,
		address: "0x9623063377AD1B27544C965cCd7342f7EA7e88C7",
		name: "The Graph",
		symbol: "GRT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13397/thumb/Graph_Token.png?1608145566"
	},
	{
		chainId: 42161,
		address: "0x7f9a7DB853Ca816B9A138AEe3380Ef34c437dEe0",
		name: "Gitcoin",
		symbol: "GTC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15810/thumb/gitcoin.png?1621992929"
	},
	{
		chainId: 42161,
		address: "0x589d35656641d6aB57A545F08cf473eCD9B6D5F7",
		name: "GYEN",
		symbol: "GYEN",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/14191/thumb/icon_gyen_200_200.png?1614843343"
	},
	{
		chainId: 42161,
		address: "0xd12Eeb0142D4Efe7Af82e4f29E5Af382615bcEeA",
		name: "Highstreet",
		symbol: "HIGH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/18973/thumb/logosq200200Coingecko.png?1634090470"
	},
	{
		chainId: 42161,
		address: "0x177F394A3eD18FAa85c1462Ae626438a70294EF7",
		name: "HOPR",
		symbol: "HOPR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14061/thumb/Shared_HOPR_logo_512px.png?1614073468"
	},
	{
		chainId: 42161,
		address: "0x61cA9D186f6b9a793BC08F6C79fd35f205488673",
		name: "Illuvium",
		symbol: "ILV",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14468/large/ILV.JPG"
	},
	{
		chainId: 42161,
		address: "0x3cFD99593a7F035F717142095a3898e3Fca7783e",
		name: "Immutable X",
		symbol: "IMX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/17233/thumb/imx.png?1636691817"
	},
	{
		chainId: 42161,
		address: "0x2A2053cb633CAD465B4A8975eD3d7f09DF608F80",
		name: "Injective",
		symbol: "INJ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12882/thumb/Secondary_Symbol.png?1628233237"
	},
	{
		chainId: 42161,
		address: "0x13Ad51ed4F1B7e9Dc168d8a00cB3f4dDD85EfA60",
		name: "Lido DAO",
		symbol: "LDO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13573/thumb/Lido_DAO.png?1609873644"
	},
	{
		chainId: 42161,
		address: "0xf97f4df75117a78c1A5a0DBb814Af92458539FB4",
		name: "ChainLink Token",
		symbol: "LINK",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x514910771AF9Ca656af840dff83E8264EcF986CA/logo.png"
	},
	{
		chainId: 42161,
		address: "0x289ba1701C2F088cf0faf8B3705246331cB8A839",
		name: "Livepeer",
		symbol: "LPT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/7137/thumb/logo-circle-green.png?1619593365"
	},
	{
		chainId: 42161,
		address: "0xfb9E5D956D889D91a82737B9bFCDaC1DCE3e1449",
		name: "Liquity",
		symbol: "LQTY",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14665/thumb/200-lqty-icon.png?1617631180"
	},
	{
		chainId: 42161,
		address: "0x46d0cE7de6247b0A95f67b43B589b4041BaE7fbE",
		name: "LoopringCoin V2",
		symbol: "LRC",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xBBbbCA6A901c926F240b89EacB641d8Aec7AEafD/logo.png"
	},
	{
		chainId: 42161,
		address: "0x93b346b6BC2548dA6A1E7d98E9a421B42541425b",
		name: "Liquity USD",
		symbol: "LUSD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14666/thumb/Group_3.png?1617631327"
	},
	{
		chainId: 42161,
		address: "0x442d24578A564EF628A65e6a7E3e7be2a165E231",
		name: "Decentraland",
		symbol: "MANA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/878/thumb/decentraland-mana.png?1550108745"
	},
	{
		chainId: 42161,
		address: "0x533A7B414CD1236815a5e09F1E97FC7d5c313739",
		name: "Mask Network",
		symbol: "MASK",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14051/thumb/Mask_Network.jpg?1614050316"
	},
	{
		chainId: 42161,
		address: "0x99F40b01BA9C469193B360f72740E416B17Ac332",
		name: "MATH",
		symbol: "MATH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11335/thumb/2020-05-19-token-200.png?1589940590"
	},
	{
		chainId: 42161,
		address: "0x561877b6b3DD7651313794e5F2894B2F18bE0766",
		name: "Polygon",
		symbol: "MATIC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4713/thumb/matic-token-icon.png?1624446912"
	},
	{
		chainId: 42161,
		address: "0x7F728F3595db17B0B359f4FC47aE80FAd2e33769",
		name: "Metis",
		symbol: "METIS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15595/thumb/metis.jpeg?1660285312"
	},
	{
		chainId: 42161,
		address: "0xB20A02dfFb172C474BC4bDa3fD6f4eE70C04daf2",
		name: "Magic Internet Money",
		symbol: "MIM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/16786/thumb/mimlogopng.png?1624979612"
	},
	{
		chainId: 42161,
		address: "0x2e9a6Df78E42a30712c10a9Dc4b1C8656f8F2879",
		name: "Maker",
		symbol: "MKR",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2/logo.png"
	},
	{
		chainId: 42161,
		address: "0x8f5c1A99b1df736Ad685006Cb6ADCA7B7Ae4b514",
		name: "Melon",
		symbol: "MLN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/605/thumb/melon.png?1547034295"
	},
	{
		chainId: 42161,
		address: "0x29024832eC3baBF5074D4F46102aA988097f0Ca0",
		name: "Maple",
		symbol: "MPL",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14097/thumb/photo_2021-05-03_14.20.41.jpeg?1620022863"
	},
	{
		chainId: 42161,
		address: "0x91b468Fe3dce581D7a6cFE34189F1314b6862eD6",
		name: "MXC",
		symbol: "MXC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4604/thumb/mxc.png?1655534336"
	},
	{
		chainId: 42161,
		address: "0x53236015A675fcB937485F1AE58040e4Fb920d5b",
		name: "PolySwarm",
		symbol: "NCT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2843/thumb/ImcYCVfX_400x400.jpg?1628519767"
	},
	{
		chainId: 42161,
		address: "0xBE06ca305A5Cb49ABf6B1840da7c42690406177b",
		name: "NKN",
		symbol: "NKN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/3375/thumb/nkn.png?1548329212"
	},
	{
		chainId: 42161,
		address: "0x597701b32553b9fa473e21362D480b3a6B569711",
		name: "Numeraire",
		symbol: "NMR",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671/logo.png"
	},
	{
		chainId: 42161,
		address: "0x933d31561e470478079FEB9A6Dd2691fAD8234DF",
		name: "Ocean Protocol",
		symbol: "OCEAN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/3687/thumb/ocean-protocol-logo.jpg?1547038686"
	},
	{
		chainId: 42161,
		address: "0x6FEb262FEb0f775B5312D2e009923f7f58AE423E",
		name: "Origin Protocol",
		symbol: "OGN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/3296/thumb/op.jpg?1547037878"
	},
	{
		chainId: 42161,
		address: "0xfEb4DfC8C4Cf7Ed305bb08065D08eC6ee6728429",
		name: "PAX Gold",
		symbol: "PAXG",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9519/thumb/paxg.PNG?1568542565"
	},
	{
		chainId: 42161,
		address: "0x35E6A59F786d9266c7961eA28c7b768B33959cbB",
		name: "Pepe",
		symbol: "PEPE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/29850/large/pepe-token.jpeg?1682922725"
	},
	{
		chainId: 42161,
		address: "0x753D224bCf9AAFaCD81558c32341416df61D3DAC",
		name: "Perpetual Protocol",
		symbol: "PERP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12381/thumb/60d18e06844a844ad75901a9_mark_only_03.png?1628674771"
	},
	{
		chainId: 42161,
		address: "0xeeeB5EaC2dB7A7Fc28134aA3248580d48b016b64",
		name: "Polkastarter",
		symbol: "POLS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12648/thumb/polkastarter.png?1609813702"
	},
	{
		chainId: 42161,
		address: "0xE12F29704F635F4A6E7Ae154838d21F9B33809e9",
		name: "Polymath",
		symbol: "POLY",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/2784/thumb/inKkF01.png?1605007034"
	},
	{
		chainId: 42161,
		address: "0xdA0a57B710768ae17941a9Fa33f8B720c8bD9ddD",
		name: "Marlin",
		symbol: "POND",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/8903/thumb/POND_200x200.png?1622515451"
	},
	{
		chainId: 42161,
		address: "0x4e91F2AF1ee0F84B529478f19794F5AFD423e4A6",
		name: "Power Ledger",
		symbol: "POWR",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/1104/thumb/power-ledger.png?1547035082"
	},
	{
		chainId: 42161,
		address: "0x8d8e1b6ffc6832E8D2eF0DE8a3d957cAE7ac5067",
		name: "Prime",
		symbol: "PRIME",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/29053/large/PRIMELOGOOO.png?1676976222"
	},
	{
		chainId: 42161,
		address: "0x82164a8B646401a8776F9dC5c8Cba35DcAf60Cd2",
		name: "PARSIQ",
		symbol: "PRQ",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11973/thumb/DsNgK0O.png?1596590280"
	},
	{
		chainId: 42161,
		address: "0xC7557C73e0eCa2E1BF7348bB6874Aee63C7eFF85",
		name: "Quant",
		symbol: "QNT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/3370/thumb/5ZOu7brX_400x400.jpg?1612437252"
	},
	{
		chainId: 42161,
		address: "0xaeF5bbcbFa438519a5ea80B4c7181B4E78d419f2",
		name: "Rai Reflex Index",
		symbol: "RAI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14004/thumb/RAI-logo-coin.png?1613592334"
	},
	{
		chainId: 42161,
		address: "0xCF8600347Dc375C5f2FdD6Dab9BB66e0b6773cd7",
		name: "Rarible",
		symbol: "RARI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11845/thumb/Rari.png?1594946953"
	},
	{
		chainId: 42161,
		address: "0x2E9AE8f178d5Ea81970C7799A377B3985cbC335F",
		name: "Rubic",
		symbol: "RBC",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12629/thumb/200x200.png?1607952509"
	},
	{
		chainId: 42161,
		address: "0x9fA891e1dB0a6D1eEAC4B929b5AAE1011C79a204",
		name: "Republic Token",
		symbol: "REN",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x408e41876cCCDC0F92210600ef50372656052a38/logo.png"
	},
	{
		chainId: 42161,
		address: "0xef888bcA6AB6B1d26dbeC977C455388ecd794794",
		name: "Rari Governance Token",
		symbol: "RGT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12900/thumb/Rari_Logo_Transparent.png?1613978014"
	},
	{
		chainId: 42161,
		address: "0xC8a4EeA31E9B6b61c406DF013DD4FEc76f21E279",
		name: "Render Token",
		symbol: "RNDR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11636/thumb/rndr.png?1638840934"
	},
	{
		chainId: 1,
		address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
		name: "Rocket Pool ETH",
		symbol: "rETH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/20764/standard/reth.png?1696520159"
	},
	{
		chainId: 42161,
		address: "0xd1318eb19DBF2647743c720ed35174efd64e3DAC",
		name: "The Sandbox",
		symbol: "SAND",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12129/thumb/sandbox_logo.jpg?1597397942"
	},
	{
		chainId: 42161,
		address: "0x5033833c9fe8B9d3E09EEd2f73d2aaF7E3872fd1",
		name: "Shiba Inu",
		symbol: "SHIB",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11939/thumb/shiba.png?1622619446"
	},
	{
		chainId: 42161,
		address: "0x4F9b7DEDD8865871dF65c5D26B1c2dD537267878",
		name: "SKALE",
		symbol: "SKL",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13245/thumb/SKALE_token_300x300.png?1606789574"
	},
	{
		chainId: 42161,
		address: "0x707F635951193dDaFBB40971a0fCAAb8A6415160",
		name: "Status",
		symbol: "SNT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/779/thumb/status.png?1548610778"
	},
	{
		chainId: 42161,
		address: "0xcBA56Cd8216FCBBF3fA6DF6137F3147cBcA37D60",
		name: "Synthetix Network Token",
		symbol: "SNX",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F/logo.png"
	},
	{
		chainId: 42161,
		address: "0xb2BE52744a804Cc732d606817C2572C5A3B264e7",
		name: "Unisocks",
		symbol: "SOCKS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/10717/thumb/qFrcoiM.png?1582525244"
	},
	{
		chainId: 42161,
		address: "0xb74Da9FE2F96B9E0a5f4A3cf0b92dd2bEC617124",
		name: "SOL Wormhole ",
		symbol: "SOL",
		decimals: 9,
		logoURI: "https://assets.coingecko.com/coins/images/22876/thumb/SOL_wh_small.png?1644224316"
	},
	{
		chainId: 42161,
		address: "0x3E6648C5a70A150A88bCE65F4aD4d506Fe15d2AF",
		name: "Spell Token",
		symbol: "SPELL",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15861/thumb/abracadabra-3.png?1622544862"
	},
	{
		chainId: 42161,
		address: "0xe018C7a3d175Fb0fE15D70Da2c874d3CA16313EC",
		name: "Stargate Finance",
		symbol: "STG",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/24413/thumb/STG_LOGO.png?1647654518"
	},
	{
		chainId: 42161,
		address: "0x7f9cf5a2630a0d58567122217dF7609c26498956",
		name: "SuperFarm",
		symbol: "SUPER",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14040/thumb/6YPdWn6.png?1613975899"
	},
	{
		chainId: 42161,
		address: "0xA970AF1a584579B618be4d69aD6F73459D112F95",
		name: "Synth sUSD",
		symbol: "sUSD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"
	},
	{
		chainId: 42161,
		address: "0xd4d42F0b6DEF4CE0383636770eF773390d85c61A",
		name: "Sushi",
		symbol: "SUSHI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12271/thumb/512x512_Logo_no_chop.png?1606986688"
	},
	{
		chainId: 42161,
		address: "0x1bCfc0B4eE1471674cd6A9F6B363A034375eAD84",
		name: "Synapse",
		symbol: "SYN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/18024/thumb/syn.png?1635002049"
	},
	{
		chainId: 42161,
		address: "0x0945Cae3ae47cb384b2d47BC448Dc6A9dEC21F55",
		name: "Threshold Network",
		symbol: "T",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/22228/thumb/nFPNiSbL_400x400.jpg?1641220340"
	},
	{
		chainId: 42161,
		address: "0x7E2a1eDeE171C5B19E6c54D73752396C0A572594",
		name: "tBTC",
		symbol: "tBTC",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/uniswap/assets/master/blockchains/ethereum/assets/0x18084fbA666a33d37592fA2633fD49a74DD93a88/logo.png"
	},
	{
		chainId: 42161,
		address: "0xd58D345Fd9c82262E087d2D0607624B410D88242",
		name: "Tellor",
		symbol: "TRB",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9644/thumb/Blk_icon_current.png?1584980686"
	},
	{
		chainId: 42161,
		address: "0xBfAE6fecD8124ba33cbB2180aAb0Fe4c03914A5A",
		name: "Tribe",
		symbol: "TRIBE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14575/thumb/tribe.PNG?1617487954"
	},
	{
		chainId: 42161,
		address: "0xd693Ec944A85eeca4247eC1c3b130DCa9B0C3b22",
		name: "UMA Voting Token v1",
		symbol: "UMA",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828/logo.png"
	},
	{
		chainId: 42161,
		address: "0xFa7F8980b0f1E64A2062791cc3b0871572f1F7f0",
		name: "Uniswap",
		symbol: "UNI",
		decimals: 18,
		logoURI: "ipfs://QmXttGpZrECX5qCyXbBQiqgQNytVGeZW5Anewvh2jc4psg"
	},
	{
		chainId: 42161,
		address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
		name: "USDCoin",
		symbol: "USDC",
		decimals: 6,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png"
	},
	{
		chainId: 42161,
		address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
		name: "Bridged USDC",
		symbol: "USDC.e",
		decimals: 6,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png"
	},
	{
		chainId: 42161,
		address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
		name: "Tether USD",
		symbol: "USDT",
		decimals: 6,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
	},
	{
		chainId: 42161,
		address: "0x1c8Ec4DE3c2BFD3050695D89853EC6d78AE650bb",
		name: "Wrapped Ampleforth",
		symbol: "WAMPL",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/20825/thumb/photo_2021-11-25_02-05-11.jpg?1637811951"
	},
	{
		chainId: 42161,
		address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
		name: "Wrapped BTC",
		symbol: "WBTC",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png"
	},
	{
		chainId: 42161,
		address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
		name: "Wrapped Ether",
		symbol: "WETH",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
	},
	{
		chainId: 42161,
		address: "0xcAFcD85D8ca7Ad1e1C6F82F651fA15E33AEfD07b",
		name: "WOO Network",
		symbol: "WOO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12921/thumb/w2UiemF__400x400.jpg?1603670367"
	},
	{
		chainId: 42161,
		address: "0x58BbC087e36Db40a84b22c1B93a042294deEAFEd",
		name: "Chain",
		symbol: "XCN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/24210/thumb/Chain_icon_200x200.png?1646895054"
	},
	{
		chainId: 42161,
		address: "0x82e3A8F066a6989666b031d916c43672085b1582",
		name: "yearn finance",
		symbol: "YFI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11849/thumb/yfi-192x192.png?1598325330"
	},
	{
		chainId: 42161,
		address: "0xBD591Bd4DdB64b77B5f76Eab8f03d02519235Ae2",
		name: "0x Protocol Token",
		symbol: "ZRX",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xE41d2489571d322189246DaFA5ebDe1F4699F498/logo.png"
	},
	{
		chainId: 43114,
		address: "0xd501281565bf7789224523144Fe5D98e8B28f267",
		name: "1inch",
		symbol: "1INCH",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13469/thumb/1inch-token.png?1608803028"
	},
	{
		chainId: 43114,
		address: "0x63a72806098Bd3D9520cC43356dD78afe5D386D9",
		name: "Aave",
		symbol: "AAVE",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12645/thumb/AAVE.png?1601374110"
	},
	{
		chainId: 43114,
		address: "0x2147EFFF675e4A4eE1C2f918d181cDBd7a8E208f",
		name: "Alpha Venture DAO",
		symbol: "ALPHA",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12738/thumb/AlphaToken_256x256.png?1617160876"
	},
	{
		chainId: 43114,
		address: "0x20CF1b6E9d856321ed4686877CF4538F2C84B4dE",
		name: "Ankr",
		symbol: "ANKR",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/4324/thumb/U85xTl2.png?1608111978"
	},
	{
		chainId: 43114,
		address: "0x44c784266cf024a60e8acF2427b9857Ace194C5d",
		name: "Axelar",
		symbol: "AXL",
		decimals: 6,
		logoURI: "https://assets.coingecko.com/coins/images/27277/large/V-65_xQ1_400x400.jpeg"
	},
	{
		chainId: 43114,
		address: "0x98443B96EA4b0858FDF3219Cd13e98C7A4690588",
		name: "Basic Attention Token",
		symbol: "BAT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/677/thumb/basic-attention-token.png?1547034427"
	},
	{
		chainId: 43114,
		address: "0x9C9e5fD8bbc25984B178FdCE6117Defa39d2db39",
		name: "Binance USD",
		symbol: "BUSD",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/9576/thumb/BUSD.png?1568947766"
	},
	{
		chainId: 43114,
		address: "0xc3048E19E76CB9a3Aa9d77D8C03c29Fc906e2437",
		name: "Compound",
		symbol: "COMP",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xc00e94Cb662C3520282E6f5717214004A7f26888/logo.png"
	},
	{
		chainId: 43114,
		address: "0x6b289CCeAA8639e3831095D75A3e43520faBf552",
		name: "Cartesi",
		symbol: "CTSI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11038/thumb/cartesi.png?1592288021"
	},
	{
		chainId: 43114,
		address: "0xd586E7F844cEa2F87f50152665BCbc2C279D8d70",
		name: "DAI.e Token",
		symbol: "DAI.e",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/avalanchec/assets/0xd586E7F844cEa2F87f50152665BCbc2C279D8d70/logo.png"
	},
	{
		chainId: 43114,
		address: "0x961C8c0B1aaD0c0b10a51FeF6a867E3091BCef17",
		name: "DeFi Yield Protocol",
		symbol: "DYP",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13480/thumb/DYP_Logo_Symbol-8.png?1655809066"
	},
	{
		chainId: 43114,
		address: "0xD24C2Ad096400B6FBcd2ad8B24E7acBc21A1da64",
		name: "Frax",
		symbol: "FRAX",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13422/thumb/frax_logo.png?1608476506"
	},
	{
		chainId: 43114,
		address: "0x214DB107654fF987AD859F34125307783fC8e387",
		name: "Frax Share",
		symbol: "FXS",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13423/thumb/frax_share.png?1608478989"
	},
	{
		chainId: 43114,
		address: "0x8a0cAc13c7da965a312f08ea4229c37869e85cB9",
		name: "The Graph",
		symbol: "GRT",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/13397/thumb/Graph_Token.png?1608145566"
	},
	{
		chainId: 43114,
		address: "0x5947BB275c521040051D82396192181b413227A3",
		name: "ChainLink Token",
		symbol: "LINK",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x514910771AF9Ca656af840dff83E8264EcF986CA/logo.png"
	},
	{
		chainId: 43114,
		address: "0x130966628846BFd36ff31a822705796e8cb8C18D",
		name: "Magic Internet Money",
		symbol: "MIM",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/16786/thumb/mimlogopng.png?1624979612"
	},
	{
		chainId: 43114,
		address: "0x88128fd4b259552A9A1D457f435a6527AAb72d42",
		name: "Maker",
		symbol: "MKR",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2/logo.png"
	},
	{
		chainId: 43114,
		address: "0x9Fb9a33956351cf4fa040f65A13b835A3C8764E3",
		name: "Multichain",
		symbol: "MULTI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/22087/thumb/1_Wyot-SDGZuxbjdkaOeT2-A.png?1640764238"
	},
	{
		chainId: 43114,
		address: "0x97Cd1CFE2ed5712660bb6c14053C0EcB031Bff7d",
		name: "Rai Reflex Index",
		symbol: "RAI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/14004/thumb/RAI-logo-coin.png?1613592334"
	},
	{
		chainId: 43114,
		address: "0xBeC243C995409E6520D7C41E404da5dEba4b209B",
		name: "Synthetix Network Token",
		symbol: "SNX",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F/logo.png"
	},
	{
		chainId: 43114,
		address: "0xFE6B19286885a4F7F55AdAD09C3Cd1f906D2478F",
		name: "SOL Wormhole ",
		symbol: "SOL",
		decimals: 9,
		logoURI: "https://assets.coingecko.com/coins/images/22876/thumb/SOL_wh_small.png?1644224316"
	},
	{
		chainId: 43114,
		address: "0xCE1bFFBD5374Dac86a2893119683F4911a2F7814",
		name: "Spell Token",
		symbol: "SPELL",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/15861/thumb/abracadabra-3.png?1622544862"
	},
	{
		chainId: 43114,
		address: "0x2F6F07CDcf3588944Bf4C42aC74ff24bF56e7590",
		name: "Stargate Finance",
		symbol: "STG",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/24413/thumb/STG_LOGO.png?1647654518"
	},
	{
		chainId: 43114,
		address: "0x37B608519F91f70F2EeB0e5Ed9AF4061722e4F76",
		name: "Sushi",
		symbol: "SUSHI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12271/thumb/512x512_Logo_no_chop.png?1606986688"
	},
	{
		chainId: 43114,
		address: "0x1f1E7c893855525b303f99bDF5c3c05Be09ca251",
		name: "Synapse",
		symbol: "SYN",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/18024/thumb/syn.png?1635002049"
	},
	{
		chainId: 43114,
		address: "0x3Bd2B1c7ED8D396dbb98DED3aEbb41350a5b2339",
		name: "UMA Voting Token v1",
		symbol: "UMA",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828/logo.png"
	},
	{
		chainId: 43114,
		address: "0x8eBAf22B6F053dFFeaf46f4Dd9eFA95D89ba8580",
		name: "UNI.e Token",
		symbol: "UNI.e",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/avalanchec/assets/0x8eBAf22B6F053dFFeaf46f4Dd9eFA95D89ba8580/logo.png"
	},
	{
		chainId: 43114,
		address: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
		name: "USDC Token",
		symbol: "USDC",
		decimals: 6,
		logoURI: "https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/avalanchec/assets/0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E/logo.png"
	},
	{
		chainId: 43114,
		address: "0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7",
		name: "Tether USD",
		symbol: "USDT",
		decimals: 6,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
	},
	{
		chainId: 43114,
		address: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
		name: "Wrapped AVAX",
		symbol: "WAVAX",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/Uniswap/assets/master/blockchains/avalanchec/assets/0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7/logo.png"
	},
	{
		chainId: 43114,
		address: "0x50b7545627a5162F82A992c33b87aDc75187B218",
		name: "Wrapped BTC",
		symbol: "WBTC",
		decimals: 8,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png"
	},
	{
		chainId: 43114,
		address: "0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB",
		name: "Wrapped Ether",
		symbol: "WETH",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
	},
	{
		chainId: 43114,
		address: "0xaBC9547B534519fF73921b1FBA6E672b5f58D083",
		name: "WOO Network",
		symbol: "WOO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12921/thumb/w2UiemF__400x400.jpg?1603670367"
	},
	{
		chainId: 43114,
		address: "0x9eAaC1B23d935365bD7b542Fe22cEEe2922f52dc",
		name: "yearn finance",
		symbol: "YFI",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/11849/thumb/yfi-192x192.png?1598325330"
	},
	{
		chainId: 43114,
		address: "0x596fA47043f99A4e0F122243B841E55375cdE0d2",
		name: "0x Protocol Token",
		symbol: "ZRX",
		decimals: 18,
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xE41d2489571d322189246DaFA5ebDe1F4699F498/logo.png"
	},
	{
		chainId: 11155111,
		address: "0x85a39f55778D98e81237e917d1f7fb4b74Bdc2Af",
		name: "Kirobo",
		symbol: "KIRO",
		decimals: 18,
		logoURI: "https://assets.coingecko.com/coins/images/12688/thumb/QmScxyKBwqbGJZmp38EwaoRpXbzPkq3tvuMjeuJE1YLZeG.png?1601672684"
	}
];

var yTokensArbitrum = [
	{
		decimals: 18,
		symbol: "MIM3CRV-f",
		name: "Curve.fi Factory USD Metapool: MIM",
		chainId: 42161,
		address: "0x30dF229cefa463e991e29D42DB0bae2e122B2AC7",
		value: "0x30dF229cefa463e991e29D42DB0bae2e122B2AC7"
	},
	{
		decimals: 18,
		symbol: "crv3crypto",
		name: "Curve.fi USD-BTC-ETH",
		chainId: 42161,
		address: "0x8e0B8c8BB9db49a46697F3a5Bb8A308e744821D2",
		value: "0x8e0B8c8BB9db49a46697F3a5Bb8A308e744821D2"
	},
	{
		decimals: 18,
		symbol: "2CRV",
		name: "Curve.fi USDC/USDT",
		chainId: 42161,
		address: "0x7f90122BF0700F9E7e1F688fe926940E8839F353",
		value: "0x7f90122BF0700F9E7e1F688fe926940E8839F353"
	},
	{
		decimals: 18,
		symbol: "VSTFRAX-f",
		name: "Curve.fi Factory Plain Pool: VST+FRAX",
		chainId: 42161,
		address: "0x59bF0545FCa0E5Ad48E13DA269faCD2E8C886Ba4",
		value: "0x59bF0545FCa0E5Ad48E13DA269faCD2E8C886Ba4"
	},
	{
		decimals: 18,
		symbol: "PHP",
		name: "Philippine Peso",
		chainId: 42161,
		address: "0xFa247d0D55a324ca19985577a2cDcFC383D87953",
		value: "0xFa247d0D55a324ca19985577a2cDcFC383D87953"
	}
];

var yTokensMainnet = [
	{
		decimals: 18,
		symbol: "XAIFRAXBP3CRV-f",
		name: "Curve.fi Factory USD Metapool: XAI/FRAXBP",
		chainId: 1,
		address: "0x326290A1B0004eeE78fa6ED4F1d8f4b2523ab669",
		value: "0x326290A1B0004eeE78fa6ED4F1d8f4b2523ab669"
	},
	{
		decimals: 18,
		symbol: "crvTETH",
		name: "Curve T-ETH",
		chainId: 1,
		address: "0xCb08717451aaE9EF950a2524E33B6DCaBA60147B",
		value: "0xCb08717451aaE9EF950a2524E33B6DCaBA60147B"
	},
	{
		decimals: 18,
		symbol: "pUSDFRAXBP3CRV-f",
		name: "Curve.fi Factory USD Metapool: pUSDFRAXBP-A100",
		chainId: 1,
		address: "0xE60986759872393a8360A4a7abEAb3A6e0BA7848",
		value: "0xE60986759872393a8360A4a7abEAb3A6e0BA7848"
	},
	{
		decimals: 18,
		symbol: "st-frxETH-f",
		name: "Curve.fi Factory Plain Pool: stETH/frxETH",
		chainId: 1,
		address: "0x4d9f9D15101EEC665F77210cB999639f760F831E",
		value: "0x4d9f9D15101EEC665F77210cB999639f760F831E"
	},
	{
		decimals: 18,
		symbol: "TBTCSBTC23CRV-f",
		name: "Curve.fi Factory USD Metapool: tBTC/wBTC/sBTC",
		chainId: 1,
		address: "0xF95AAa7EBB1620e46221B73588502960Ef63dBa0",
		value: "0xF95AAa7EBB1620e46221B73588502960Ef63dBa0"
	},
	{
		decimals: 18,
		symbol: "crvGEARETH-f",
		name: "Curve.fi Factory Crypto Pool: Curve GEAR/ETH",
		chainId: 1,
		address: "0x5Be6C45e2d074fAa20700C49aDA3E88a1cc0025d",
		value: "0x5Be6C45e2d074fAa20700C49aDA3E88a1cc0025d"
	},
	{
		decimals: 18,
		symbol: "UST_whv23CRV-f",
		name: "Curve.fi Factory USD Metapool: wormhole v2 UST-3Pool",
		chainId: 1,
		address: "0xCEAF7747579696A2F0bb206a14210e3c9e6fB269",
		value: "0xCEAF7747579696A2F0bb206a14210e3c9e6fB269"
	},
	{
		decimals: 18,
		symbol: "husd3CRV",
		name: "Curve.fi HUSD/3Crv",
		chainId: 1,
		address: "0x5B5CFE992AdAC0C9D48E05854B2d91C73a003858",
		value: "0x5B5CFE992AdAC0C9D48E05854B2d91C73a003858"
	},
	{
		decimals: 18,
		symbol: "LQTY",
		name: "LQTY",
		chainId: 1,
		address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
		value: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
		logoURI: "https://assets.coingecko.com/coins/images/14665/thumb/200-lqty-icon.png?1617631180"
	},
	{
		decimals: 18,
		symbol: "HBTC",
		name: "Huobi BTC",
		chainId: 1,
		address: "0x0316EB71485b0Ab14103307bf65a021042c6d380",
		value: "0x0316EB71485b0Ab14103307bf65a021042c6d380"
	},
	{
		decimals: 18,
		symbol: "EURT-f",
		name: "Curve.fi Factory Plain Pool: Euro Tether",
		chainId: 1,
		address: "0xFD5dB7463a3aB53fD211b4af195c5BCCC1A03890",
		value: "0xFD5dB7463a3aB53fD211b4af195c5BCCC1A03890"
	},
	{
		decimals: 18,
		symbol: "eCRV",
		name: "Curve.fi ETH/sETH",
		chainId: 1,
		address: "0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c",
		value: "0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c"
	},
	{
		decimals: 8,
		symbol: "WBTC",
		name: "Wrapped BTC",
		chainId: 1,
		address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
		value: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png"
	},
	{
		decimals: 18,
		symbol: "yDAI+yUSDC+yUSDT+yTUSD",
		name: "Curve.fi yDAI/yUSDC/yUSDT/yTUSD",
		chainId: 1,
		address: "0xdF5e0e81Dff6FAF3A7e52BA697820c5e32D806A8",
		value: "0xdF5e0e81Dff6FAF3A7e52BA697820c5e32D806A8"
	},
	{
		decimals: 18,
		symbol: "ibAUDUSDC-f",
		name: "Curve.fi Factory Crypto Pool: ibAUD/USDC",
		chainId: 1,
		address: "0x54c8Ecf46A81496eEB0608BD3353388b5D7a2a33",
		value: "0x54c8Ecf46A81496eEB0608BD3353388b5D7a2a33"
	},
	{
		decimals: 18,
		symbol: "OCEAN",
		name: "Ocean Token",
		chainId: 1,
		address: "0x967da4048cD07aB37855c090aAF366e4ce1b9F48",
		value: "0x967da4048cD07aB37855c090aAF366e4ce1b9F48",
		logoURI: "https://assets.coingecko.com/coins/images/3687/thumb/ocean-protocol-logo.jpg?1547038686"
	},
	{
		decimals: 18,
		symbol: "ankrCRV",
		name: "Curve.fi ETH/aETH",
		chainId: 1,
		address: "0xaA17A236F2bAdc98DDc0Cf999AbB47D47Fc0A6Cf",
		value: "0xaA17A236F2bAdc98DDc0Cf999AbB47D47Fc0A6Cf"
	},
	{
		decimals: 18,
		symbol: "multibtc3CRV-f",
		name: "Curve.fi Factory USD Metapool: multiBTC+WBTC/sBTC",
		chainId: 1,
		address: "0x2863a328A0B7fC6040f11614FA0728587DB8e353",
		value: "0x2863a328A0B7fC6040f11614FA0728587DB8e353"
	},
	{
		decimals: 18,
		symbol: "alfrxETH-f",
		name: "Curve.fi Factory Plain Pool: alETHfrxETH",
		chainId: 1,
		address: "0xB657B895B265C38c53FFF00166cF7F6A3C70587d",
		value: "0xB657B895B265C38c53FFF00166cF7F6A3C70587d"
	},
	{
		decimals: 18,
		symbol: "crvCVXETH",
		name: "Curve CVX-ETH",
		chainId: 1,
		address: "0x3A283D9c08E8b55966afb64C515f5143cf907611",
		value: "0x3A283D9c08E8b55966afb64C515f5143cf907611"
	},
	{
		decimals: 18,
		symbol: "D3-f",
		name: "Curve.fi Factory Plain Pool: d3pool",
		chainId: 1,
		address: "0xBaaa1F5DbA42C3389bDbc2c9D2dE134F5cD0Dc89",
		value: "0xBaaa1F5DbA42C3389bDbc2c9D2dE134F5cD0Dc89"
	},
	{
		decimals: 18,
		symbol: "ALCX",
		name: "Alchemix",
		chainId: 1,
		address: "0xdBdb4d16EdA451D0503b854CF79D55697F90c8DF",
		value: "0xdBdb4d16EdA451D0503b854CF79D55697F90c8DF",
		logoURI: "https://assets.coingecko.com/coins/images/14113/thumb/Alchemix.png?1614409874"
	},
	{
		decimals: 18,
		symbol: "crvFRAX",
		name: "Curve.fi FRAX/USDC",
		chainId: 1,
		address: "0x3175Df0976dFA876431C2E9eE6Bc45b65d3473CC",
		value: "0x3175Df0976dFA876431C2E9eE6Bc45b65d3473CC"
	},
	{
		decimals: 18,
		symbol: "ust3CRV",
		name: "Curve.fi UST/3Crv",
		chainId: 1,
		address: "0x94e131324b6054c0D789b190b2dAC504e4361b53",
		value: "0x94e131324b6054c0D789b190b2dAC504e4361b53"
	},
	{
		decimals: 18,
		symbol: "PALETH-f",
		name: "Curve.fi Factory Crypto Pool: PAL/ETH",
		chainId: 1,
		address: "0xbE4f3AD6C9458b901C81b734CB22D9eaE9Ad8b50",
		value: "0xbE4f3AD6C9458b901C81b734CB22D9eaE9Ad8b50"
	},
	{
		decimals: 18,
		symbol: "FEI3CRV3CRV-f",
		name: "Curve.fi Factory USD Metapool: FEI Metapool",
		chainId: 1,
		address: "0x06cb22615BA53E60D67Bf6C341a0fD5E718E1655",
		value: "0x06cb22615BA53E60D67Bf6C341a0fD5E718E1655"
	},
	{
		decimals: 18,
		symbol: "ibAUD+sAUD-f",
		name: "Curve.fi Factory Plain Pool: ibAUD/sAUD",
		chainId: 1,
		address: "0x3F1B0278A9ee595635B61817630cC19DE792f506",
		value: "0x3F1B0278A9ee595635B61817630cC19DE792f506"
	},
	{
		decimals: 6,
		symbol: "USDT",
		name: "Tether USD",
		chainId: 1,
		address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
		value: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
	},
	{
		decimals: 18,
		symbol: "B-auraBAL-STABLE",
		name: "Balancer auraBAL Stable Pool",
		chainId: 1,
		address: "0x3dd0843A028C86e0b760b1A76929d1C5Ef93a2dd",
		value: "0x3dd0843A028C86e0b760b1A76929d1C5Ef93a2dd"
	},
	{
		decimals: 18,
		symbol: "WETH",
		name: "Wrapped Ether",
		chainId: 1,
		address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
		value: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
	},
	{
		decimals: 18,
		symbol: "tbtc/sbtcCrv",
		name: "Curve.fi tBTC/sbtcCrv",
		chainId: 1,
		address: "0x64eda51d3Ad40D56b9dFc5554E06F94e1Dd786Fd",
		value: "0x64eda51d3Ad40D56b9dFc5554E06F94e1Dd786Fd"
	},
	{
		decimals: 18,
		symbol: "crvUSDUSDT-f",
		name: "Curve.fi Factory Plain Pool: crvUSD/USDT",
		chainId: 1,
		address: "0x390f3595bCa2Df7d23783dFd126427CCeb997BF4",
		value: "0x390f3595bCa2Df7d23783dFd126427CCeb997BF4"
	},
	{
		decimals: 18,
		symbol: "eursCRV",
		name: "Curve.fi EURS/sEUR",
		chainId: 1,
		address: "0x194eBd173F6cDacE046C53eACcE9B953F28411d1",
		value: "0x194eBd173F6cDacE046C53eACcE9B953F28411d1"
	},
	{
		decimals: 18,
		symbol: "yCRV",
		name: "Yearn CRV",
		chainId: 1,
		address: "0xFCc5c47bE19d06BF83eB04298b026F81069ff65b",
		value: "0xFCc5c47bE19d06BF83eB04298b026F81069ff65b"
	},
	{
		decimals: 18,
		symbol: "ib3CRV",
		name: "Curve.fi cyDAI/cyUSDC/cyUSDT",
		chainId: 1,
		address: "0x5282a4eF67D9C33135340fB3289cc1711c13638C",
		value: "0x5282a4eF67D9C33135340fB3289cc1711c13638C"
	},
	{
		decimals: 18,
		symbol: "MIM",
		name: "Magic Internet Money",
		chainId: 1,
		address: "0x99D8a9C45b2ecA8864373A26D1459e3Dff1e17F3",
		value: "0x99D8a9C45b2ecA8864373A26D1459e3Dff1e17F3",
		logoURI: "https://assets.coingecko.com/coins/images/16786/thumb/mimlogopng.png?1624979612"
	},
	{
		decimals: 18,
		symbol: "cDAI+cUSDC+USDT",
		name: "Curve.fi cDAI/cUSDC/USDT",
		chainId: 1,
		address: "0x9fC689CCaDa600B6DF723D9E47D84d76664a1F23",
		value: "0x9fC689CCaDa600B6DF723D9E47D84d76664a1F23"
	},
	{
		decimals: 18,
		symbol: "CTRETH-f",
		name: "Curve.fi Factory Crypto Pool: Concentrator CTR/ETH",
		chainId: 1,
		address: "0x3f0e7916681452D23Cd36B1281457DA721F2E5dF",
		value: "0x3f0e7916681452D23Cd36B1281457DA721F2E5dF"
	},
	{
		decimals: 18,
		symbol: "bLUSDLUSD3-f",
		name: "Curve.fi Factory Crypto Pool: bLUSD_LUSD3CRV",
		chainId: 1,
		address: "0x5ca0313D44551e32e0d7a298EC024321c4BC59B4",
		value: "0x5ca0313D44551e32e0d7a298EC024321c4BC59B4"
	},
	{
		decimals: 18,
		symbol: "RAI3CRV",
		name: "RAI3CRV",
		chainId: 1,
		address: "0x6BA5b4e438FA0aAf7C1bD179285aF65d13bD3D90",
		value: "0x6BA5b4e438FA0aAf7C1bD179285aF65d13bD3D90"
	},
	{
		decimals: 18,
		symbol: "MIM-3LP3CRV-f",
		name: "Curve.fi Factory USD Metapool: Magic Internet Money 3Pool",
		chainId: 1,
		address: "0x5a6A4D54456819380173272A5E8E9B9904BdF41B",
		value: "0x5a6A4D54456819380173272A5E8E9B9904BdF41B"
	},
	{
		decimals: 18,
		symbol: "hCRV",
		name: "Curve.fi hBTC/wBTC",
		chainId: 1,
		address: "0xb19059ebb43466C323583928285a49f558E572Fd",
		value: "0xb19059ebb43466C323583928285a49f558E572Fd"
	},
	{
		decimals: 18,
		symbol: "yvecrv-f",
		name: "Curve.fi Factory Plain Pool: yveCRV",
		chainId: 1,
		address: "0x7E46fd8a30869aa9ed55af031067Df666EfE87da",
		value: "0x7E46fd8a30869aa9ed55af031067Df666EfE87da"
	},
	{
		decimals: 18,
		symbol: "gusd3CRV",
		name: "Curve.fi GUSD/3Crv",
		chainId: 1,
		address: "0xD2967f45c4f384DEEa880F807Be904762a3DeA07",
		value: "0xD2967f45c4f384DEEa880F807Be904762a3DeA07"
	},
	{
		decimals: 18,
		symbol: "BUSD3CRV-f",
		name: "Curve.fi Factory USD Metapool: Binance USD",
		chainId: 1,
		address: "0x4807862AA8b2bF68830e4C8dc86D0e9A998e085a",
		value: "0x4807862AA8b2bF68830e4C8dc86D0e9A998e085a"
	},
	{
		decimals: 18,
		symbol: "ibCHFUSDC-f",
		name: "Curve.fi Factory Crypto Pool: ibCHF/USDC",
		chainId: 1,
		address: "0x08ceA8E5B4551722dEB97113C139Dd83C26c5398",
		value: "0x08ceA8E5B4551722dEB97113C139Dd83C26c5398"
	},
	{
		decimals: 18,
		symbol: "JPEGpETH-f",
		name: "Curve.fi Factory Crypto Pool: JPEG/pETH",
		chainId: 1,
		address: "0x23E7817bC73645063FB2fa85c1d098EfFE84bE90",
		value: "0x23E7817bC73645063FB2fa85c1d098EfFE84bE90"
	},
	{
		decimals: 18,
		symbol: "JPEGpETH-f",
		name: "Curve.fi Factory Crypto Pool: JPEG/pETH",
		chainId: 1,
		address: "0xDA68f66fC0f10Ee61048E70106Df4BDB26bAF595",
		value: "0xDA68f66fC0f10Ee61048E70106Df4BDB26bAF595"
	},
	{
		decimals: 18,
		symbol: "dusd3CRV",
		name: "Curve.fi DUSD/3Crv",
		chainId: 1,
		address: "0x3a664Ab939FD8482048609f652f9a0B0677337B9",
		value: "0x3a664Ab939FD8482048609f652f9a0B0677337B9"
	},
	{
		decimals: 18,
		symbol: "crvRenWBTC",
		name: "Curve.fi renBTC/wBTC",
		chainId: 1,
		address: "0x49849C98ae39Fff122806C06791Fa73784FB3675",
		value: "0x49849C98ae39Fff122806C06791Fa73784FB3675"
	},
	{
		decimals: 18,
		symbol: "agEUREUROC-f",
		name: "Curve.fi Factory Plain Pool: agEUR/EUROC",
		chainId: 1,
		address: "0xBa3436Fd341F2C8A928452Db3C5A3670d1d5Cc73",
		value: "0xBa3436Fd341F2C8A928452Db3C5A3670d1d5Cc73"
	},
	{
		decimals: 18,
		symbol: "BTRFLYETH-f",
		name: "Curve.fi Factory Crypto Pool: BTRFLY/ETH",
		chainId: 1,
		address: "0x7483Dd57f6488b0e194A151C57Df6Ec85C00aCE9",
		value: "0x7483Dd57f6488b0e194A151C57Df6Ec85C00aCE9"
	},
	{
		decimals: 18,
		symbol: "saCRV",
		name: "Curve.fi aDAI/aSUSD",
		chainId: 1,
		address: "0x02d341CcB60fAaf662bC0554d13778015d1b285C",
		value: "0x02d341CcB60fAaf662bC0554d13778015d1b285C"
	},
	{
		decimals: 8,
		symbol: "renBTC",
		name: "renBTC",
		chainId: 1,
		address: "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D",
		value: "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D"
	},
	{
		decimals: 18,
		symbol: "STGUSDC-f",
		name: "Curve.fi Factory Crypto Pool: STG/USDC",
		chainId: 1,
		address: "0xdf55670e27bE5cDE7228dD0A6849181891c9ebA1",
		value: "0xdf55670e27bE5cDE7228dD0A6849181891c9ebA1"
	},
	{
		decimals: 18,
		symbol: "sUSD",
		name: "Synth sUSD",
		chainId: 1,
		address: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		value: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"
	},
	{
		decimals: 18,
		symbol: "LUSD",
		name: "LUSD Stablecoin",
		chainId: 1,
		address: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
		value: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
		logoURI: "https://assets.coingecko.com/coins/images/14666/thumb/Group_3.png?1617631327"
	},
	{
		decimals: 18,
		symbol: "a3CRV",
		name: "Curve.fi aDAI/aUSDC/aUSDT",
		chainId: 1,
		address: "0xFd2a8fA60Abd58Efe3EeE34dd494cD491dC14900",
		value: "0xFd2a8fA60Abd58Efe3EeE34dd494cD491dC14900"
	},
	{
		decimals: 6,
		symbol: "USDT",
		name: "Tether USD",
		chainId: 1,
		address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
		value: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
	},
	{
		decimals: 18,
		symbol: "usdn3CRV",
		name: "Curve.fi USDN/3Crv",
		chainId: 1,
		address: "0x4f3E8F405CF5aFC05D68142F3783bDfE13811522",
		value: "0x4f3E8F405CF5aFC05D68142F3783bDfE13811522"
	},
	{
		decimals: 18,
		symbol: "LOOKS",
		name: "LooksRare Token",
		chainId: 1,
		address: "0xf4d2888d29D722226FafA5d9B24F9164c092421E",
		value: "0xf4d2888d29D722226FafA5d9B24F9164c092421E"
	},
	{
		decimals: 18,
		symbol: "usdk3CRV",
		name: "Curve.fi USDK/3Crv",
		chainId: 1,
		address: "0x97E2768e8E73511cA874545DC5Ff8067eB19B787",
		value: "0x97E2768e8E73511cA874545DC5Ff8067eB19B787"
	},
	{
		decimals: 18,
		symbol: "crvTricrypto",
		name: "Curve.fi USD-BTC-ETH",
		chainId: 1,
		address: "0xcA3d75aC011BF5aD07a98d02f18225F9bD9A6BDF",
		value: "0xcA3d75aC011BF5aD07a98d02f18225F9bD9A6BDF"
	},
	{
		decimals: 18,
		symbol: "CLEVETH-f",
		name: "Curve.fi Factory Crypto Pool: CLEV/ETH",
		chainId: 1,
		address: "0x6C280dB098dB673d30d5B34eC04B6387185D3620",
		value: "0x6C280dB098dB673d30d5B34eC04B6387185D3620"
	},
	{
		decimals: 18,
		symbol: "pBTC/sbtcCRV",
		name: "Curve.fi pBTC/sbtcCRV",
		chainId: 1,
		address: "0xDE5331AC4B3630f94853Ff322B66407e0D6331E8",
		value: "0xDE5331AC4B3630f94853Ff322B66407e0D6331E8"
	},
	{
		decimals: 18,
		symbol: "agEUR-VEUR-f",
		name: "Curve.fi Factory Plain Pool: agEUR/VEUR",
		chainId: 1,
		address: "0xF05CFb8b4382c69f3B451C5FB55210B232E0edFA",
		value: "0xF05CFb8b4382c69f3B451C5FB55210B232E0edFA"
	},
	{
		decimals: 18,
		symbol: "crvUSDETHCRV",
		name: "TriCRV",
		chainId: 1,
		address: "0x4eBdF703948ddCEA3B11f675B4D1Fba9d2414A14",
		value: "0x4eBdF703948ddCEA3B11f675B4D1Fba9d2414A14"
	},
	{
		decimals: 18,
		symbol: "bb-a-USD",
		name: "Balancer Aave Boosted StablePool (USD)",
		chainId: 1,
		address: "0x7B50775383d3D6f0215A8F290f2C9e2eEBBEceb2",
		value: "0x7B50775383d3D6f0215A8F290f2C9e2eEBBEceb2"
	},
	{
		decimals: 18,
		symbol: "sdCRVCRV-f",
		name: "Curve.fi Factory Plain Pool: sdCRV",
		chainId: 1,
		address: "0xf7b55C3732aD8b2c2dA7c24f30A69f55c54FB717",
		value: "0xf7b55C3732aD8b2c2dA7c24f30A69f55c54FB717"
	},
	{
		decimals: 18,
		symbol: "crvUSDTUSD-f",
		name: "Curve.fi Factory Plain Pool: crvUSD/TUSD",
		chainId: 1,
		address: "0x34D655069F4cAc1547E4C8cA284FfFF5ad4A8db0",
		value: "0x34D655069F4cAc1547E4C8cA284FfFF5ad4A8db0"
	},
	{
		decimals: 18,
		symbol: "cvxcrv-f",
		name: "Curve.fi Factory Plain Pool: cvxCRV",
		chainId: 1,
		address: "0x9D0464996170c6B9e75eED71c68B99dDEDf279e8",
		value: "0x9D0464996170c6B9e75eED71c68B99dDEDf279e8"
	},
	{
		decimals: 18,
		symbol: "RAI",
		name: "Rai Reflex Index",
		chainId: 1,
		address: "0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919",
		value: "0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919",
		logoURI: "https://assets.coingecko.com/coins/images/14004/thumb/RAI-logo-coin.png?1613592334"
	},
	{
		decimals: 18,
		symbol: "ibCHF+sCHF-f",
		name: "Curve.fi Factory Plain Pool: ibCHF/sCHF",
		chainId: 1,
		address: "0x9c2C8910F113181783c249d8F6Aa41b51Cde0f0c",
		value: "0x9c2C8910F113181783c249d8F6Aa41b51Cde0f0c"
	},
	{
		decimals: 18,
		symbol: "sUSD",
		name: "Synth sUSD",
		chainId: 1,
		address: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		value: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"
	},
	{
		decimals: 18,
		symbol: "SUSHI",
		name: "SushiToken",
		chainId: 1,
		address: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
		value: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
		logoURI: "https://assets.coingecko.com/coins/images/12271/thumb/512x512_Logo_no_chop.png?1606986688"
	},
	{
		decimals: 18,
		symbol: "TUSD",
		name: "TrueUSD",
		chainId: 1,
		address: "0x0000000000085d4780B73119b644AE5ecd22b376",
		value: "0x0000000000085d4780B73119b644AE5ecd22b376"
	},
	{
		decimals: 18,
		symbol: "COMP",
		name: "Compound",
		chainId: 1,
		address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
		value: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xc00e94Cb662C3520282E6f5717214004A7f26888/logo.png"
	},
	{
		decimals: 18,
		symbol: "yDAI+yUSDC+yUSDT+yTUSD",
		name: "Curve.fi yDAI/yUSDC/yUSDT/yTUSD",
		chainId: 1,
		address: "0xdF5e0e81Dff6FAF3A7e52BA697820c5e32D806A8",
		value: "0xdF5e0e81Dff6FAF3A7e52BA697820c5e32D806A8"
	},
	{
		decimals: 18,
		symbol: "EURT-f",
		name: "Curve.fi Factory Plain Pool: Euro Tether",
		chainId: 1,
		address: "0xFD5dB7463a3aB53fD211b4af195c5BCCC1A03890",
		value: "0xFD5dB7463a3aB53fD211b4af195c5BCCC1A03890"
	},
	{
		decimals: 18,
		symbol: "alUSD3CRV-f",
		name: "Curve.fi Factory USD Metapool: Alchemix USD",
		chainId: 1,
		address: "0x43b4FdFD4Ff969587185cDB6f0BD875c5Fc83f8c",
		value: "0x43b4FdFD4Ff969587185cDB6f0BD875c5Fc83f8c"
	},
	{
		decimals: 2,
		symbol: "GUSD",
		name: "Gemini dollar",
		chainId: 1,
		address: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
		value: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
		logoURI: "https://assets.coingecko.com/coins/images/5992/thumb/gemini-dollar-gusd.png?1536745278"
	},
	{
		decimals: 18,
		symbol: "GHO/bb-a-USD",
		name: "Balancer GHO/bb-a-USD Stable Pool",
		chainId: 1,
		address: "0xc2B021133D1b0cF07dba696fd5DD89338428225B",
		value: "0xc2B021133D1b0cF07dba696fd5DD89338428225B"
	},
	{
		decimals: 18,
		symbol: "alUSDFRAXB3CRV-f",
		name: "Curve.fi Factory USD Metapool: alUSDFRAXBP",
		chainId: 1,
		address: "0xB30dA2376F63De30b42dC055C93fa474F31330A5",
		value: "0xB30dA2376F63De30b42dC055C93fa474F31330A5"
	},
	{
		decimals: 18,
		symbol: "ibKRW+sKRW-f",
		name: "Curve.fi Factory Plain Pool: ibKRW/sKRW",
		chainId: 1,
		address: "0x8461A004b50d321CB22B7d034969cE6803911899",
		value: "0x8461A004b50d321CB22B7d034969cE6803911899"
	},
	{
		decimals: 18,
		symbol: "sdYFIYFI-f",
		name: "Curve.fi Factory Plain Pool: sdYFI",
		chainId: 1,
		address: "0x79E281BC69A03DaBCcD66858c65EF6724e50aebe",
		value: "0x79E281BC69A03DaBCcD66858c65EF6724e50aebe"
	},
	{
		decimals: 18,
		symbol: "ibKRW+sKRW-f",
		name: "Curve.fi Factory Plain Pool: ibKRW/sKRW",
		chainId: 1,
		address: "0x8461A004b50d321CB22B7d034969cE6803911899",
		value: "0x8461A004b50d321CB22B7d034969cE6803911899"
	},
	{
		decimals: 18,
		symbol: "USDC+LP-f",
		name: "Curve.fi Factory Crypto Pool: USDC+",
		chainId: 1,
		address: "0xfed2B54453F75634bcdaEA5e5b11a3f99b9C28Fa",
		value: "0xfed2B54453F75634bcdaEA5e5b11a3f99b9C28Fa"
	},
	{
		decimals: 18,
		symbol: "ALCX",
		name: "Alchemix",
		chainId: 1,
		address: "0xdBdb4d16EdA451D0503b854CF79D55697F90c8DF",
		value: "0xdBdb4d16EdA451D0503b854CF79D55697F90c8DF",
		logoURI: "https://assets.coingecko.com/coins/images/14113/thumb/Alchemix.png?1614409874"
	},
	{
		decimals: 18,
		symbol: "crvWSBTC",
		name: "Curve.fi wBTC/sBTC",
		chainId: 1,
		address: "0x051d7e5609917Bd9b73f04BAc0DED8Dd46a74301",
		value: "0x051d7e5609917Bd9b73f04BAc0DED8Dd46a74301"
	},
	{
		decimals: 18,
		symbol: "eCRV",
		name: "Curve.fi ETH/sETH",
		chainId: 1,
		address: "0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c",
		value: "0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c"
	},
	{
		decimals: 18,
		symbol: "yETH-f",
		name: "Curve.fi Factory Plain Pool: yETH",
		chainId: 1,
		address: "0x69ACcb968B19a53790f43e57558F5E443A91aF22",
		value: "0x69ACcb968B19a53790f43e57558F5E443A91aF22"
	},
	{
		decimals: 18,
		symbol: "ibJPY+sJPY-f",
		name: "Curve.fi Factory Plain Pool: ibJPY/sJPY",
		chainId: 1,
		address: "0x8818a9bb44Fbf33502bE7c15c500d0C783B73067",
		value: "0x8818a9bb44Fbf33502bE7c15c500d0C783B73067"
	},
	{
		decimals: 18,
		symbol: "ibGBP+sGBP-f",
		name: "Curve.fi Factory Plain Pool: ibGBP/sGBP",
		chainId: 1,
		address: "0xD6Ac1CB9019137a896343Da59dDE6d097F710538",
		value: "0xD6Ac1CB9019137a896343Da59dDE6d097F710538"
	},
	{
		decimals: 18,
		symbol: "3EURpool-f",
		name: "Curve.fi Factory Plain Pool: 3EURpool",
		chainId: 1,
		address: "0xb9446c4Ef5EBE66268dA6700D26f96273DE3d571",
		value: "0xb9446c4Ef5EBE66268dA6700D26f96273DE3d571"
	},
	{
		decimals: 18,
		symbol: "COMP",
		name: "Compound",
		chainId: 1,
		address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
		value: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xc00e94Cb662C3520282E6f5717214004A7f26888/logo.png"
	},
	{
		decimals: 18,
		symbol: "steCRV",
		name: "Curve.fi ETH/stETH",
		chainId: 1,
		address: "0x06325440D014e39736583c165C2963BA99fAf14E",
		value: "0x06325440D014e39736583c165C2963BA99fAf14E"
	},
	{
		decimals: 18,
		symbol: "pETH-ETH-f",
		name: "Curve.fi Factory Pool: pETH",
		chainId: 1,
		address: "0x9848482da3Ee3076165ce6497eDA906E66bB85C5",
		value: "0x9848482da3Ee3076165ce6497eDA906E66bB85C5"
	},
	{
		decimals: 18,
		symbol: "stETH-ng-f",
		name: "Curve.fi Factory Pool: stETH-ng",
		chainId: 1,
		address: "0x21E27a5E5513D6e65C4f830167390997aA84843a",
		value: "0x21E27a5E5513D6e65C4f830167390997aA84843a"
	},
	{
		decimals: 18,
		symbol: "crvPlain3andSUSD",
		name: "Curve.fi DAI/USDC/USDT/sUSD",
		chainId: 1,
		address: "0xC25a3A3b969415c80451098fa907EC722572917F",
		value: "0xC25a3A3b969415c80451098fa907EC722572917F"
	},
	{
		decimals: 18,
		symbol: "eCRV",
		name: "Curve.fi ETH/sETH",
		chainId: 1,
		address: "0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c",
		value: "0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c"
	},
	{
		decimals: 18,
		symbol: "crvPlain3andSUSD",
		name: "Curve.fi DAI/USDC/USDT/sUSD",
		chainId: 1,
		address: "0xC25a3A3b969415c80451098fa907EC722572917F",
		value: "0xC25a3A3b969415c80451098fa907EC722572917F"
	},
	{
		decimals: 18,
		symbol: "rETHwstETH-f",
		name: "Curve.fi Factory Plain Pool: rETH/wstETH",
		chainId: 1,
		address: "0x447Ddd4960d9fdBF6af9a790560d0AF76795CB08",
		value: "0x447Ddd4960d9fdBF6af9a790560d0AF76795CB08"
	},
	{
		decimals: 18,
		symbol: "ibbtc/sbtcCRV-f",
		name: "Curve.fi Factory BTC Metapool: ibBTC",
		chainId: 1,
		address: "0xFbdCA68601f835b27790D98bbb8eC7f05FDEaA9B",
		value: "0xFbdCA68601f835b27790D98bbb8eC7f05FDEaA9B"
	},
	{
		decimals: 18,
		symbol: "LUSD3CRV-f",
		name: "Curve.fi Factory USD Metapool: Liquity",
		chainId: 1,
		address: "0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA",
		value: "0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA"
	},
	{
		decimals: 18,
		symbol: "STETHETH_C-f",
		name: "Curve.fi Factory Plain Pool: stETH concentrated",
		chainId: 1,
		address: "0x828b154032950C8ff7CF8085D841723Db2696056",
		value: "0x828b154032950C8ff7CF8085D841723Db2696056"
	},
	{
		decimals: 18,
		symbol: "yCRV-f",
		name: "Curve.fi Factory Plain Pool: yCRV",
		chainId: 1,
		address: "0x0309A528bBa0394dC4A2Ce59123C52E317A54604",
		value: "0x0309A528bBa0394dC4A2Ce59123C52E317A54604"
	},
	{
		decimals: 18,
		symbol: "hCRV",
		name: "Curve.fi hBTC/wBTC",
		chainId: 1,
		address: "0xb19059ebb43466C323583928285a49f558E572Fd",
		value: "0xb19059ebb43466C323583928285a49f558E572Fd"
	},
	{
		decimals: 18,
		symbol: "gusd3CRV",
		name: "Curve.fi GUSD/3Crv",
		chainId: 1,
		address: "0xD2967f45c4f384DEEa880F807Be904762a3DeA07",
		value: "0xD2967f45c4f384DEEa880F807Be904762a3DeA07"
	},
	{
		decimals: 18,
		symbol: "ETH MATIC-f",
		name: "Curve.fi Factory Crypto Pool: PAIR_ETH_MATIC",
		chainId: 1,
		address: "0xD8eb58D76aF99547333cfEeb6a0f9bd1A63b6492",
		value: "0xD8eb58D76aF99547333cfEeb6a0f9bd1A63b6492"
	},
	{
		decimals: 18,
		symbol: "dusd3CRV",
		name: "Curve.fi DUSD/3Crv",
		chainId: 1,
		address: "0x3a664Ab939FD8482048609f652f9a0B0677337B9",
		value: "0x3a664Ab939FD8482048609f652f9a0B0677337B9"
	},
	{
		decimals: 18,
		symbol: "LINK",
		name: "ChainLink Token",
		chainId: 1,
		address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
		value: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x514910771AF9Ca656af840dff83E8264EcF986CA/logo.png"
	},
	{
		decimals: 18,
		symbol: "DOLA3POOL3CRV-f",
		name: "Curve.fi Factory USD Metapool: DOLA-3pool Curve LP",
		chainId: 1,
		address: "0xAA5A67c256e27A5d80712c51971408db3370927D",
		value: "0xAA5A67c256e27A5d80712c51971408db3370927D"
	},
	{
		decimals: 18,
		symbol: "ibEUR+sEUR-f",
		name: "Curve.fi Factory Plain Pool: ibEUR/sEUR",
		chainId: 1,
		address: "0x19b080FE1ffA0553469D20Ca36219F17Fcf03859",
		value: "0x19b080FE1ffA0553469D20Ca36219F17Fcf03859"
	},
	{
		decimals: 18,
		symbol: "crvUSDCWETHINV",
		name: "TricryptoINV",
		chainId: 1,
		address: "0x5426178799ee0a0181A89b4f57eFddfAb49941Ec",
		value: "0x5426178799ee0a0181A89b4f57eFddfAb49941Ec"
	},
	{
		decimals: 18,
		symbol: "crvCRVETH",
		name: "Curve CRV-ETH",
		chainId: 1,
		address: "0xEd4064f376cB8d68F770FB1Ff088a3d0F3FF5c4d",
		value: "0xEd4064f376cB8d68F770FB1Ff088a3d0F3FF5c4d"
	},
	{
		decimals: 18,
		symbol: "YFIETH-f",
		name: "Curve.fi Factory Crypto Pool: YFI/ETH",
		chainId: 1,
		address: "0x29059568bB40344487d62f7450E78b8E6C74e0e5",
		value: "0x29059568bB40344487d62f7450E78b8E6C74e0e5"
	},
	{
		decimals: 18,
		symbol: "ibGBPUSDC-f",
		name: "Curve.fi Factory Crypto Pool: ibGBP/USDC",
		chainId: 1,
		address: "0x22CF19EB64226e0E1A79c69b345b31466fD273A7",
		value: "0x22CF19EB64226e0E1A79c69b345b31466fD273A7"
	},
	{
		decimals: 18,
		symbol: "yDAI+yUSDC+yUSDT+yBUSD",
		name: "Curve.fi yDAI/yUSDC/yUSDT/yBUSD",
		chainId: 1,
		address: "0x3B3Ac5386837Dc563660FB6a0937DFAa5924333B",
		value: "0x3B3Ac5386837Dc563660FB6a0937DFAa5924333B"
	},
	{
		decimals: 18,
		symbol: "yCRV-f",
		name: "Curve.fi Factory Plain Pool: yCRV",
		chainId: 1,
		address: "0x99f5aCc8EC2Da2BC0771c32814EFF52b712de1E5",
		value: "0x99f5aCc8EC2Da2BC0771c32814EFF52b712de1E5"
	},
	{
		decimals: 18,
		symbol: "USDM3CRV-f",
		name: "Curve.fi Factory USD Metapool: USDM",
		chainId: 1,
		address: "0x5B3b5DF2BF2B6543f78e053bD91C4Bdd820929f1",
		value: "0x5B3b5DF2BF2B6543f78e053bD91C4Bdd820929f1"
	},
	{
		decimals: 18,
		symbol: "hyUSDeUSD-f",
		name: "Curve.fi Factory Crypto Pool: hyUSD/eUSD",
		chainId: 1,
		address: "0xc794C6A95f30d0ebF7B3Bbe85e8a0A95C9e411c1",
		value: "0xc794C6A95f30d0ebF7B3Bbe85e8a0A95C9e411c1"
	},
	{
		decimals: 18,
		symbol: "cbETHfrxET-f",
		name: "Curve.fi Factory Crypto Pool: cbETH/frxETH",
		chainId: 1,
		address: "0x548E063CE6F3BaC31457E4f5b4e2345286274257",
		value: "0x548E063CE6F3BaC31457E4f5b4e2345286274257"
	},
	{
		decimals: 18,
		symbol: "SUSHI",
		name: "SushiToken",
		chainId: 1,
		address: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
		value: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
		logoURI: "https://assets.coingecko.com/coins/images/12271/thumb/512x512_Logo_no_chop.png?1606986688"
	},
	{
		decimals: 18,
		symbol: "crvCRVETH",
		name: "Curve CRV-ETH",
		chainId: 1,
		address: "0xEd4064f376cB8d68F770FB1Ff088a3d0F3FF5c4d",
		value: "0xEd4064f376cB8d68F770FB1Ff088a3d0F3FF5c4d"
	},
	{
		decimals: 18,
		symbol: "crvRenWBTC",
		name: "Curve.fi renBTC/wBTC",
		chainId: 1,
		address: "0x49849C98ae39Fff122806C06791Fa73784FB3675",
		value: "0x49849C98ae39Fff122806C06791Fa73784FB3675"
	},
	{
		decimals: 18,
		symbol: "LDOETH-f",
		name: "Curve.fi Factory Crypto Pool: LDO/ETH",
		chainId: 1,
		address: "0xb79565c01b7Ae53618d9B847b9443aAf4f9011e7",
		value: "0xb79565c01b7Ae53618d9B847b9443aAf4f9011e7"
	},
	{
		decimals: 18,
		symbol: "alETH+ETH-f",
		name: "Curve.fi Factory Pool: alETH",
		chainId: 1,
		address: "0xC4C319E2D4d66CcA4464C0c2B32c9Bd23ebe784e",
		value: "0xC4C319E2D4d66CcA4464C0c2B32c9Bd23ebe784e"
	},
	{
		decimals: 18,
		symbol: "ibCHF+sCHF-f",
		name: "Curve.fi Factory Plain Pool: ibCHF/sCHF",
		chainId: 1,
		address: "0x9c2C8910F113181783c249d8F6Aa41b51Cde0f0c",
		value: "0x9c2C8910F113181783c249d8F6Aa41b51Cde0f0c"
	},
	{
		decimals: 18,
		symbol: "SNX",
		name: "Synthetix Network Token",
		chainId: 1,
		address: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
		value: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F/logo.png"
	},
	{
		decimals: 18,
		symbol: "TUSD",
		name: "TrueUSD",
		chainId: 1,
		address: "0x0000000000085d4780B73119b644AE5ecd22b376",
		value: "0x0000000000085d4780B73119b644AE5ecd22b376"
	},
	{
		decimals: 18,
		symbol: "crvCVXETH",
		name: "Curve CVX-ETH",
		chainId: 1,
		address: "0x3A283D9c08E8b55966afb64C515f5143cf907611",
		value: "0x3A283D9c08E8b55966afb64C515f5143cf907611"
	},
	{
		decimals: 18,
		symbol: "ankrCRV",
		name: "Curve.fi ETH/aETH",
		chainId: 1,
		address: "0xaA17A236F2bAdc98DDc0Cf999AbB47D47Fc0A6Cf",
		value: "0xaA17A236F2bAdc98DDc0Cf999AbB47D47Fc0A6Cf"
	},
	{
		decimals: 18,
		symbol: "OHMFRAXBP-f",
		name: "Curve.fi Factory Crypto Pool: OHM/FRAXBP",
		chainId: 1,
		address: "0x5271045F7B73c17825A7A7aee6917eE46b0B7520",
		value: "0x5271045F7B73c17825A7A7aee6917eE46b0B7520"
	},
	{
		decimals: 18,
		symbol: "rCRV",
		name: "Curve.fi ETH/rETH",
		chainId: 1,
		address: "0x53a901d48795C58f485cBB38df08FA96a24669D5",
		value: "0x53a901d48795C58f485cBB38df08FA96a24669D5"
	},
	{
		decimals: 18,
		symbol: "crvUSDTWBTCWETH",
		name: "TricryptoUSDT",
		chainId: 1,
		address: "0xf5f5B97624542D72A9E06f04804Bf81baA15e2B4",
		value: "0xf5f5B97624542D72A9E06f04804Bf81baA15e2B4"
	},
	{
		decimals: 18,
		symbol: "YFIETH-f",
		name: "Curve.fi Factory Crypto Pool: YFI/ETH",
		chainId: 1,
		address: "0x29059568bB40344487d62f7450E78b8E6C74e0e5",
		value: "0x29059568bB40344487d62f7450E78b8E6C74e0e5"
	},
	{
		decimals: 18,
		symbol: "OETHCRV-f",
		name: "Curve.fi Factory Pool: OETH",
		chainId: 1,
		address: "0x94B17476A93b3262d87B9a326965D1E91f9c13E7",
		value: "0x94B17476A93b3262d87B9a326965D1E91f9c13E7"
	},
	{
		decimals: 18,
		symbol: "agEUREUROC-f",
		name: "Curve.fi Factory Plain Pool: agEUR/EUROC",
		chainId: 1,
		address: "0xBa3436Fd341F2C8A928452Db3C5A3670d1d5Cc73",
		value: "0xBa3436Fd341F2C8A928452Db3C5A3670d1d5Cc73"
	},
	{
		decimals: 18,
		symbol: "sUSD",
		name: "Synth sUSD",
		chainId: 1,
		address: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		value: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"
	},
	{
		decimals: 18,
		symbol: "crvUSDUSDC-f",
		name: "Curve.fi Factory Plain Pool: crvUSD/USDC",
		chainId: 1,
		address: "0x4DEcE678ceceb27446b35C672dC7d61F30bAD69E",
		value: "0x4DEcE678ceceb27446b35C672dC7d61F30bAD69E"
	},
	{
		decimals: 18,
		symbol: "sdFXSFXS-f",
		name: "Curve.fi Factory Plain Pool: sdFXS",
		chainId: 1,
		address: "0x8c524635d52bd7b1Bd55E062303177a7d916C046",
		value: "0x8c524635d52bd7b1Bd55E062303177a7d916C046"
	},
	{
		decimals: 18,
		symbol: "crvEURSUSDC",
		name: "Curve EURS-USDC",
		chainId: 1,
		address: "0x3D229E1B4faab62F621eF2F6A610961f7BD7b23B",
		value: "0x3D229E1B4faab62F621eF2F6A610961f7BD7b23B"
	},
	{
		decimals: 18,
		symbol: "rETHfrxETH-f",
		name: "Curve.fi Factory Crypto Pool: rETH/frxETH",
		chainId: 1,
		address: "0xbA6c373992AD8ec1f7520E5878E5540Eb36DeBf1",
		value: "0xbA6c373992AD8ec1f7520E5878E5540Eb36DeBf1"
	},
	{
		decimals: 18,
		symbol: "crv3crypto",
		name: "Curve.fi USD-BTC-ETH",
		chainId: 1,
		address: "0xc4AD29ba4B3c580e6D59105FFf484999997675Ff",
		value: "0xc4AD29ba4B3c580e6D59105FFf484999997675Ff"
	},
	{
		decimals: 18,
		symbol: "ypaxCrv",
		name: "Curve.fi DAI/USDC/USDT/PAX",
		chainId: 1,
		address: "0xD905e2eaeBe188fc92179b6350807D8bd91Db0D8",
		value: "0xD905e2eaeBe188fc92179b6350807D8bd91Db0D8"
	},
	{
		decimals: 18,
		symbol: "crvUSDFRAX-f",
		name: "Curve.fi Factory Plain Pool: crvUSD/Frax",
		chainId: 1,
		address: "0x0CD6f267b2086bea681E922E19D40512511BE538",
		value: "0x0CD6f267b2086bea681E922E19D40512511BE538"
	},
	{
		decimals: 18,
		symbol: "3EURpool-f",
		name: "Curve.fi Factory Plain Pool: 3EURpool",
		chainId: 1,
		address: "0xb9446c4Ef5EBE66268dA6700D26f96273DE3d571",
		value: "0xb9446c4Ef5EBE66268dA6700D26f96273DE3d571"
	},
	{
		decimals: 6,
		symbol: "USDT",
		name: "Tether USD",
		chainId: 1,
		address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
		value: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
	},
	{
		decimals: 18,
		symbol: "crvRenWSBTC",
		name: "Curve.fi renBTC/wBTC/sBTC",
		chainId: 1,
		address: "0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3",
		value: "0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3"
	},
	{
		decimals: 18,
		symbol: "sBTC",
		name: "Synth sBTC",
		chainId: 1,
		address: "0xfE18be6b3Bd88A2D2A7f928d00292E7a9963CfC6",
		value: "0xfE18be6b3Bd88A2D2A7f928d00292E7a9963CfC6"
	},
	{
		decimals: 18,
		symbol: "ETH+ETH-f",
		name: "Curve.fi Factory Crypto Pool: ETH+/ETH",
		chainId: 1,
		address: "0xe8a5677171c87fCB65b76957f2852515B404C7b1",
		value: "0xe8a5677171c87fCB65b76957f2852515B404C7b1"
	},
	{
		decimals: 18,
		symbol: "3Crv",
		name: "Curve.fi DAI/USDC/USDT",
		chainId: 1,
		address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
		value: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490"
	},
	{
		decimals: 18,
		symbol: "RAI",
		name: "Rai Reflex Index",
		chainId: 1,
		address: "0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919",
		value: "0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919",
		logoURI: "https://assets.coingecko.com/coins/images/14004/thumb/RAI-logo-coin.png?1613592334"
	},
	{
		decimals: 18,
		symbol: "bb-a-USD",
		name: "Balancer Aave v3 Boosted StablePool",
		chainId: 1,
		address: "0xfeBb0bbf162E64fb9D0dfe186E517d84C395f016",
		value: "0xfeBb0bbf162E64fb9D0dfe186E517d84C395f016"
	},
	{
		decimals: 18,
		symbol: "RSRcrvFRAX-f",
		name: "Curve.fi Factory Crypto Pool: RSR+FRAX/USDC (FRAXBP)",
		chainId: 1,
		address: "0x3F436954afb722F5D14D868762a23faB6b0DAbF0",
		value: "0x3F436954afb722F5D14D868762a23faB6b0DAbF0"
	},
	{
		decimals: 18,
		symbol: "USDP",
		name: "USDP Stablecoin",
		chainId: 1,
		address: "0x1456688345527bE1f37E9e627DA0837D6f08C925",
		value: "0x1456688345527bE1f37E9e627DA0837D6f08C925"
	},
	{
		decimals: 18,
		symbol: "yCRV",
		name: "Yearn CRV",
		chainId: 1,
		address: "0x4c1317326fD8EFDeBdBE5e1cd052010D97723bd6",
		value: "0x4c1317326fD8EFDeBdBE5e1cd052010D97723bd6"
	},
	{
		decimals: 18,
		symbol: "EURN/EURT-f",
		name: "Curve.fi Factory Plain Pool: Neutrino EUR",
		chainId: 1,
		address: "0x3Fb78e61784C9c637D560eDE23Ad57CA1294c14a",
		value: "0x3Fb78e61784C9c637D560eDE23Ad57CA1294c14a"
	},
	{
		decimals: 18,
		symbol: "musd3CRV",
		name: "Curve.fi MUSD/3Crv",
		chainId: 1,
		address: "0x1AEf73d49Dedc4b1778d0706583995958Dc862e6",
		value: "0x1AEf73d49Dedc4b1778d0706583995958Dc862e6"
	},
	{
		decimals: 18,
		symbol: "usdn3CRV",
		name: "Curve.fi USDN/3Crv",
		chainId: 1,
		address: "0x4f3E8F405CF5aFC05D68142F3783bDfE13811522",
		value: "0x4f3E8F405CF5aFC05D68142F3783bDfE13811522"
	},
	{
		decimals: 18,
		symbol: "bBTC/sbtcCRV",
		name: "Curve.fi bBTC/sbtcCRV",
		chainId: 1,
		address: "0x410e3E86ef427e30B9235497143881f717d93c2A",
		value: "0x410e3E86ef427e30B9235497143881f717d93c2A"
	},
	{
		decimals: 18,
		symbol: "pax-usdp3CRV-f",
		name: "Curve.fi Factory USD Metapool: Paxos Dollar (USDP)",
		chainId: 1,
		address: "0xc270b3B858c335B6BA5D5b10e2Da8a09976005ad",
		value: "0xc270b3B858c335B6BA5D5b10e2Da8a09976005ad"
	},
	{
		decimals: 18,
		symbol: "sdYFIpool-f",
		name: "Curve.fi Factory Plain Pool: sdYFI/YFI",
		chainId: 1,
		address: "0x852b90239C5034b5bb7a5e54eF1bEF3Ce3359CC8",
		value: "0x852b90239C5034b5bb7a5e54eF1bEF3Ce3359CC8"
	},
	{
		decimals: 18,
		symbol: "musd3CRV",
		name: "Curve.fi MUSD/3Crv",
		chainId: 1,
		address: "0x1AEf73d49Dedc4b1778d0706583995958Dc862e6",
		value: "0x1AEf73d49Dedc4b1778d0706583995958Dc862e6"
	},
	{
		decimals: 6,
		symbol: "USDC",
		name: "USD Coin",
		chainId: 1,
		address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
		value: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png"
	},
	{
		decimals: 18,
		symbol: "eCRV",
		name: "Curve.fi ETH/sETH",
		chainId: 1,
		address: "0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c",
		value: "0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c"
	},
	{
		decimals: 18,
		symbol: "wstETH-rETH-sfrxETH-BPT",
		name: "wstETH-rETH-sfrxETH StablePool",
		chainId: 1,
		address: "0x5aEe1e99fE86960377DE9f88689616916D5DcaBe",
		value: "0x5aEe1e99fE86960377DE9f88689616916D5DcaBe"
	},
	{
		decimals: 18,
		symbol: "STG/FRAXBP-f",
		name: "Curve.fi Factory Crypto Pool: STG/FRAX-USDC",
		chainId: 1,
		address: "0x9de1c3D446237ab9BaFF74127eb4F303802a2683",
		value: "0x9de1c3D446237ab9BaFF74127eb4F303802a2683"
	},
	{
		decimals: 18,
		symbol: "ibJPYUSDC-f",
		name: "Curve.fi Factory Crypto Pool: ibJPY/USDC",
		chainId: 1,
		address: "0x127091edE112aEd7Bae281747771b3150Bb047bB",
		value: "0x127091edE112aEd7Bae281747771b3150Bb047bB"
	},
	{
		decimals: 18,
		symbol: "sdAGAG-f",
		name: "Curve.fi Factory Plain Pool: sdANGLE",
		chainId: 1,
		address: "0x48fF31bBbD8Ab553Ebe7cBD84e1eA3dBa8f54957",
		value: "0x48fF31bBbD8Ab553Ebe7cBD84e1eA3dBa8f54957"
	},
	{
		decimals: 18,
		symbol: "ibEURUSDC-f",
		name: "Curve.fi Factory Crypto Pool: ibEUR/USDC",
		chainId: 1,
		address: "0x8682Fbf0CbF312C891532BA9F1A91e44f81ad7DF",
		value: "0x8682Fbf0CbF312C891532BA9F1A91e44f81ad7DF"
	},
	{
		decimals: 8,
		symbol: "WBTC",
		name: "Wrapped BTC",
		chainId: 1,
		address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
		value: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png"
	},
	{
		decimals: 18,
		symbol: "alUSD3CRV-f",
		name: "Curve.fi Factory USD Metapool: Alchemix USD",
		chainId: 1,
		address: "0x43b4FdFD4Ff969587185cDB6f0BD875c5Fc83f8c",
		value: "0x43b4FdFD4Ff969587185cDB6f0BD875c5Fc83f8c"
	},
	{
		decimals: 18,
		symbol: "FUD",
		name: "FIAT-USDC-DAI Stable Pool",
		chainId: 1,
		address: "0x178E029173417b1F9C8bC16DCeC6f697bC323746",
		value: "0x178E029173417b1F9C8bC16DCeC6f697bC323746"
	},
	{
		decimals: 18,
		symbol: "B-staFiETH-WETH-Stable",
		name: "Balancer staFiETH-WETH Stable Pool",
		chainId: 1,
		address: "0xB08885e6026bab4333A80024Ec25a1a3e1FF2b8A",
		value: "0xB08885e6026bab4333A80024Ec25a1a3e1FF2b8A"
	},
	{
		decimals: 18,
		symbol: "msETHWETH-f",
		name: "Curve.fi Factory Plain Pool: msETH/WETH",
		chainId: 1,
		address: "0xa4c567c662349BeC3D0fB94C4e7f85bA95E208e4",
		value: "0xa4c567c662349BeC3D0fB94C4e7f85bA95E208e4"
	},
	{
		decimals: 18,
		symbol: "cDAI+cUSDC",
		name: "Curve.fi cDAI/cUSDC",
		chainId: 1,
		address: "0x845838DF265Dcd2c412A1Dc9e959c7d08537f8a2",
		value: "0x845838DF265Dcd2c412A1Dc9e959c7d08537f8a2"
	},
	{
		decimals: 18,
		symbol: "3Crv",
		name: "Curve.fi DAI/USDC/USDT",
		chainId: 1,
		address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
		value: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490"
	},
	{
		decimals: 18,
		symbol: "LUSD3CRV-f",
		name: "Curve.fi Factory USD Metapool: Liquity",
		chainId: 1,
		address: "0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA",
		value: "0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA"
	},
	{
		decimals: 18,
		symbol: "FRAX",
		name: "Frax",
		chainId: 1,
		address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
		value: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
		logoURI: "https://assets.coingecko.com/coins/images/13422/thumb/frax_logo.png?1608476506"
	},
	{
		decimals: 18,
		symbol: "FRAX3CRV-f",
		name: "Curve.fi Factory USD Metapool: Frax",
		chainId: 1,
		address: "0xd632f22692FaC7611d2AA1C0D552930D43CAEd3B",
		value: "0xd632f22692FaC7611d2AA1C0D552930D43CAEd3B"
	},
	{
		decimals: 18,
		symbol: "crvUSDSUSD-f",
		name: "Curve.fi Factory Plain Pool: crvUSD/SUSD",
		chainId: 1,
		address: "0x94cC50e4521bD271C1a997a3A4Dc815C2F920b41",
		value: "0x94cC50e4521bD271C1a997a3A4Dc815C2F920b41"
	},
	{
		decimals: 18,
		symbol: "eCRV",
		name: "Curve.fi ETH/sETH",
		chainId: 1,
		address: "0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c",
		value: "0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c"
	},
	{
		decimals: 18,
		symbol: "1INCH",
		name: "1INCH Token",
		chainId: 1,
		address: "0x111111111117dC0aa78b770fA6A738034120C302",
		value: "0x111111111117dC0aa78b770fA6A738034120C302",
		logoURI: "https://assets.coingecko.com/coins/images/13469/thumb/1inch-token.png?1608803028"
	},
	{
		decimals: 18,
		symbol: "crvEURTUSD",
		name: "Curve EURT-3Crv",
		chainId: 1,
		address: "0x3b6831c0077a1e44ED0a21841C3bC4dC11bCE833",
		value: "0x3b6831c0077a1e44ED0a21841C3bC4dC11bCE833"
	},
	{
		decimals: 18,
		symbol: "HBTC",
		name: "Huobi BTC",
		chainId: 1,
		address: "0x0316EB71485b0Ab14103307bf65a021042c6d380",
		value: "0x0316EB71485b0Ab14103307bf65a021042c6d380"
	},
	{
		decimals: 18,
		symbol: "rCRV",
		name: "Curve.fi ETH/rETH",
		chainId: 1,
		address: "0x53a901d48795C58f485cBB38df08FA96a24669D5",
		value: "0x53a901d48795C58f485cBB38df08FA96a24669D5"
	},
	{
		decimals: 18,
		symbol: "rsv3CRV",
		name: "Curve.fi RSV/3Crv",
		chainId: 1,
		address: "0xC2Ee6b0334C261ED60C72f6054450b61B8f18E35",
		value: "0xC2Ee6b0334C261ED60C72f6054450b61B8f18E35"
	},
	{
		decimals: 18,
		symbol: "wstETH",
		name: "Wrapped liquid staked Ether 2.0",
		chainId: 1,
		address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
		value: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0"
	},
	{
		decimals: 18,
		symbol: "crvUSDMIM-f",
		name: "Curve.fi Factory Plain Pool: crvUSD/MIM",
		chainId: 1,
		address: "0xBe426b0f37c112dd20d5866769c8034171567b31",
		value: "0xBe426b0f37c112dd20d5866769c8034171567b31"
	},
	{
		decimals: 18,
		symbol: "usdp3CRV",
		name: "Curve.fi USDP/3Crv",
		chainId: 1,
		address: "0x7Eb40E450b9655f4B3cC4259BCC731c63ff55ae6",
		value: "0x7Eb40E450b9655f4B3cC4259BCC731c63ff55ae6"
	},
	{
		decimals: 18,
		symbol: "B-stETH-STABLE",
		name: "Balancer stETH Stable Pool",
		chainId: 1,
		address: "0x32296969Ef14EB0c6d29669C550D4a0449130230",
		value: "0x32296969Ef14EB0c6d29669C550D4a0449130230"
	},
	{
		decimals: 18,
		symbol: "APEUSDBP3CRV-f",
		name: "Curve.fi Factory USD Metapool: apeUSDFRAXBP",
		chainId: 1,
		address: "0x04b727C7e246CA70d496ecF52E6b6280f3c8077D",
		value: "0x04b727C7e246CA70d496ecF52E6b6280f3c8077D"
	},
	{
		decimals: 18,
		symbol: "crvEURTUSD",
		name: "Curve EURT-3Crv",
		chainId: 1,
		address: "0x3b6831c0077a1e44ED0a21841C3bC4dC11bCE833",
		value: "0x3b6831c0077a1e44ED0a21841C3bC4dC11bCE833"
	},
	{
		decimals: 18,
		symbol: "SUSHI",
		name: "SushiToken",
		chainId: 1,
		address: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
		value: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
		logoURI: "https://assets.coingecko.com/coins/images/12271/thumb/512x512_Logo_no_chop.png?1606986688"
	},
	{
		decimals: 18,
		symbol: "ICE",
		name: "IceToken",
		chainId: 1,
		address: "0xf16e81dce15B08F326220742020379B855B87DF9",
		value: "0xf16e81dce15B08F326220742020379B855B87DF9"
	},
	{
		decimals: 18,
		symbol: "ibEUR+sEUR-f",
		name: "Curve.fi Factory Plain Pool: ibEUR/sEUR",
		chainId: 1,
		address: "0x19b080FE1ffA0553469D20Ca36219F17Fcf03859",
		value: "0x19b080FE1ffA0553469D20Ca36219F17Fcf03859"
	},
	{
		decimals: 18,
		symbol: "DOLA",
		name: "Dola USD Stablecoin",
		chainId: 1,
		address: "0x865377367054516e17014CcdED1e7d814EDC9ce4",
		value: "0x865377367054516e17014CcdED1e7d814EDC9ce4"
	},
	{
		decimals: 18,
		symbol: "crvSPELLETH",
		name: "Curve SPELL-ETH",
		chainId: 1,
		address: "0x8282BD15dcA2EA2bDf24163E8f2781B30C43A2ef",
		value: "0x8282BD15dcA2EA2bDf24163E8f2781B30C43A2ef"
	},
	{
		decimals: 18,
		symbol: "eursCRV",
		name: "Curve.fi EURS/sEUR",
		chainId: 1,
		address: "0x194eBd173F6cDacE046C53eACcE9B953F28411d1",
		value: "0x194eBd173F6cDacE046C53eACcE9B953F28411d1"
	},
	{
		decimals: 18,
		symbol: "cDAI+cUSDC",
		name: "Curve.fi cDAI/cUSDC",
		chainId: 1,
		address: "0x845838DF265Dcd2c412A1Dc9e959c7d08537f8a2",
		value: "0x845838DF265Dcd2c412A1Dc9e959c7d08537f8a2"
	},
	{
		decimals: 18,
		symbol: "B-yBAL-STABLE",
		name: "Balancer yBAL Stable Pool",
		chainId: 1,
		address: "0xD61e198e139369a40818FE05F5d5e6e045Cd6eaF",
		value: "0xD61e198e139369a40818FE05F5d5e6e045Cd6eaF"
	},
	{
		decimals: 18,
		symbol: "msUSDFRAX3CRV-f",
		name: "Curve.fi Factory USD Metapool: msUSD/FRAXBP",
		chainId: 1,
		address: "0xc3b19502F8c02be75F3f77fd673503520DEB51dD",
		value: "0xc3b19502F8c02be75F3f77fd673503520DEB51dD"
	},
	{
		decimals: 18,
		symbol: "crvRenWSBTC",
		name: "Curve.fi renBTC/wBTC/sBTC",
		chainId: 1,
		address: "0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3",
		value: "0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3"
	},
	{
		decimals: 18,
		symbol: "YFI",
		name: "yearn.finance",
		chainId: 1,
		address: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
		value: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
		logoURI: "https://assets.coingecko.com/coins/images/11849/thumb/yfi-192x192.png?1598325330"
	},
	{
		decimals: 18,
		symbol: "bb-a-USD",
		name: "Balancer Aave Boosted StablePool (USD)",
		chainId: 1,
		address: "0x7B50775383d3D6f0215A8F290f2C9e2eEBBEceb2",
		value: "0x7B50775383d3D6f0215A8F290f2C9e2eEBBEceb2"
	},
	{
		decimals: 18,
		symbol: "crvCRVUSDTBTCWSTETH",
		name: "TricryptoLLAMA",
		chainId: 1,
		address: "0x2889302a794dA87fBF1D6Db415C1492194663D13",
		value: "0x2889302a794dA87fBF1D6Db415C1492194663D13"
	},
	{
		decimals: 18,
		symbol: "OHMETH-f",
		name: "Curve.fi Factory Crypto Pool: OHM/ETH",
		chainId: 1,
		address: "0x3660BD168494d61ffDac21E403d0F6356cF90fD7",
		value: "0x3660BD168494d61ffDac21E403d0F6356cF90fD7"
	},
	{
		decimals: 18,
		symbol: "crv3crypto",
		name: "Curve.fi USD-BTC-ETH",
		chainId: 1,
		address: "0xc4AD29ba4B3c580e6D59105FFf484999997675Ff",
		value: "0xc4AD29ba4B3c580e6D59105FFf484999997675Ff"
	},
	{
		decimals: 18,
		symbol: "ibEURUSDC-f",
		name: "Curve.fi Factory Crypto Pool: ibEUR/USDC",
		chainId: 1,
		address: "0x8682Fbf0CbF312C891532BA9F1A91e44f81ad7DF",
		value: "0x8682Fbf0CbF312C891532BA9F1A91e44f81ad7DF"
	},
	{
		decimals: 6,
		symbol: "USDT",
		name: "Tether USD",
		chainId: 1,
		address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
		value: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
	},
	{
		decimals: 18,
		symbol: "FXSETH-f",
		name: "Curve.fi Factory Crypto Pool: FXS/ETH",
		chainId: 1,
		address: "0x90244F43D548a4f8dFecfAD91a193465B1fad6F7",
		value: "0x90244F43D548a4f8dFecfAD91a193465B1fad6F7"
	},
	{
		decimals: 18,
		symbol: "SNX",
		name: "Synthetix Network Token",
		chainId: 1,
		address: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
		value: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F/logo.png"
	},
	{
		decimals: 18,
		symbol: "crvUSDUSDP-f",
		name: "Curve.fi Factory Plain Pool: crvUSD/USDP",
		chainId: 1,
		address: "0xCa978A0528116DDA3cbA9ACD3e68bc6191CA53D0",
		value: "0xCa978A0528116DDA3cbA9ACD3e68bc6191CA53D0"
	},
	{
		decimals: 18,
		symbol: "OUSD3CRV-f",
		name: "Curve.fi Factory USD Metapool: Origin Dollar",
		chainId: 1,
		address: "0x87650D7bbfC3A9F10587d7778206671719d9910D",
		value: "0x87650D7bbfC3A9F10587d7778206671719d9910D"
	},
	{
		decimals: 18,
		symbol: "crvUSDGUSD-f",
		name: "Curve.fi Factory Plain Pool: crvUSD/GUSD",
		chainId: 1,
		address: "0xeCDd0cE505da71cd9dE855CD6804BA1e8C7bdB07",
		value: "0xeCDd0cE505da71cd9dE855CD6804BA1e8C7bdB07"
	},
	{
		decimals: 18,
		symbol: "cbETH/ETH-f",
		name: "Curve.fi Factory Crypto Pool: cbETH/ETH",
		chainId: 1,
		address: "0x5b6C539b224014A09B3388e51CaAA8e354c959C8",
		value: "0x5b6C539b224014A09B3388e51CaAA8e354c959C8"
	},
	{
		decimals: 18,
		symbol: "ibKRWUSDC-f",
		name: "Curve.fi Factory Crypto Pool: ibKRW/USDC",
		chainId: 1,
		address: "0x80CAcCdBD3f07BbdB558DB4a9e146D099933D677",
		value: "0x80CAcCdBD3f07BbdB558DB4a9e146D099933D677"
	},
	{
		decimals: 18,
		symbol: "UNI",
		name: "Uniswap",
		chainId: 1,
		address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
		value: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
		logoURI: "https://assets.coingecko.com/coins/images/12504/thumb/uniswap-uni.png?1600306604"
	},
	{
		decimals: 18,
		symbol: "TUSD",
		name: "TrueUSD",
		chainId: 1,
		address: "0x0000000000085d4780B73119b644AE5ecd22b376",
		value: "0x0000000000085d4780B73119b644AE5ecd22b376"
	},
	{
		decimals: 18,
		symbol: "WETH",
		name: "Wrapped Ether",
		chainId: 1,
		address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
		value: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
	},
	{
		decimals: 6,
		symbol: "USDC",
		name: "USD Coin",
		chainId: 1,
		address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
		value: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png"
	},
	{
		decimals: 18,
		symbol: "MIM-3LP3CRV-f",
		name: "Curve.fi Factory USD Metapool: Magic Internet Money 3Pool",
		chainId: 1,
		address: "0x5a6A4D54456819380173272A5E8E9B9904BdF41B",
		value: "0x5a6A4D54456819380173272A5E8E9B9904BdF41B"
	},
	{
		decimals: 18,
		symbol: "sUSD",
		name: "Synth sUSD",
		chainId: 1,
		address: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		value: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"
	},
	{
		decimals: 18,
		symbol: "sdCRVlp-f",
		name: "Curve.fi Factory Plain Pool: sdCRV/CRV",
		chainId: 1,
		address: "0xCA0253A98D16e9C1e3614caFDA19318EE69772D0",
		value: "0xCA0253A98D16e9C1e3614caFDA19318EE69772D0"
	},
	{
		decimals: 18,
		symbol: "ib3CRV",
		name: "Curve.fi cyDAI/cyUSDC/cyUSDT",
		chainId: 1,
		address: "0x5282a4eF67D9C33135340fB3289cc1711c13638C",
		value: "0x5282a4eF67D9C33135340fB3289cc1711c13638C"
	},
	{
		decimals: 18,
		symbol: "cvxcrv-crv-f",
		name: "Curve.fi Factory Plain Pool: cvxCrv/Crv",
		chainId: 1,
		address: "0x971add32Ea87f10bD192671630be3BE8A11b8623",
		value: "0x971add32Ea87f10bD192671630be3BE8A11b8623"
	},
	{
		decimals: 18,
		symbol: "crvUSDCWBTCWETH",
		name: "TricryptoUSDC",
		chainId: 1,
		address: "0x7F86Bf177Dd4F3494b841a37e810A34dD56c829B",
		value: "0x7F86Bf177Dd4F3494b841a37e810A34dD56c829B"
	},
	{
		decimals: 18,
		symbol: "KP3RETH-f",
		name: "Curve.fi Factory Crypto Pool: KP3R/ETH",
		chainId: 1,
		address: "0x4647B6D835f3B393C7A955df51EEfcf0db961606",
		value: "0x4647B6D835f3B393C7A955df51EEfcf0db961606"
	},
	{
		decimals: 18,
		symbol: "SUSHI",
		name: "SushiToken",
		chainId: 1,
		address: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
		value: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
		logoURI: "https://assets.coingecko.com/coins/images/12271/thumb/512x512_Logo_no_chop.png?1606986688"
	},
	{
		decimals: 18,
		symbol: "FRAX3CRV-f",
		name: "Curve.fi Factory USD Metapool: Frax",
		chainId: 1,
		address: "0xd632f22692FaC7611d2AA1C0D552930D43CAEd3B",
		value: "0xd632f22692FaC7611d2AA1C0D552930D43CAEd3B"
	},
	{
		decimals: 18,
		symbol: "saCRV",
		name: "Curve.fi aDAI/aSUSD",
		chainId: 1,
		address: "0x02d341CcB60fAaf662bC0554d13778015d1b285C",
		value: "0x02d341CcB60fAaf662bC0554d13778015d1b285C"
	},
	{
		decimals: 18,
		symbol: "COMP",
		name: "Compound",
		chainId: 1,
		address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
		value: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xc00e94Cb662C3520282E6f5717214004A7f26888/logo.png"
	},
	{
		decimals: 18,
		symbol: "ibGBP+sGBP-f",
		name: "Curve.fi Factory Plain Pool: ibGBP/sGBP",
		chainId: 1,
		address: "0xD6Ac1CB9019137a896343Da59dDE6d097F710538",
		value: "0xD6Ac1CB9019137a896343Da59dDE6d097F710538"
	},
	{
		decimals: 18,
		symbol: "crvRenWBTC",
		name: "Curve.fi renBTC/wBTC",
		chainId: 1,
		address: "0x49849C98ae39Fff122806C06791Fa73784FB3675",
		value: "0x49849C98ae39Fff122806C06791Fa73784FB3675"
	},
	{
		decimals: 18,
		symbol: "ETHxWETH-f",
		name: "Curve.fi Factory Plain Pool: ETHx/WETH",
		chainId: 1,
		address: "0xd82C2eB10F4895CABED6EDa6eeee234bd1A9838B",
		value: "0xd82C2eB10F4895CABED6EDa6eeee234bd1A9838B"
	},
	{
		decimals: 18,
		symbol: "yBAL",
		name: "Yearn BAL",
		chainId: 1,
		address: "0x98E86Ed5b0E48734430BfBe92101156C75418cad",
		value: "0x98E86Ed5b0E48734430BfBe92101156C75418cad"
	},
	{
		decimals: 18,
		symbol: "B-cbETH-wstETH-Stable",
		name: "Balancer cbETH-wstETH Stable Pool",
		chainId: 1,
		address: "0x9c6d47Ff73e0F5E51BE5FD53236e3F595C5793F2",
		value: "0x9c6d47Ff73e0F5E51BE5FD53236e3F595C5793F2"
	},
	{
		decimals: 18,
		symbol: "bb-a-USD",
		name: "Balancer Aave Boosted StablePool",
		chainId: 1,
		address: "0xA13a9247ea42D743238089903570127DdA72fE44",
		value: "0xA13a9247ea42D743238089903570127DdA72fE44"
	},
	{
		decimals: 18,
		symbol: "clevCVX-f",
		name: "Curve.fi Factory Plain Pool: Clever clevCVX/CVX",
		chainId: 1,
		address: "0xF9078Fb962A7D13F55d40d49C8AA6472aBD1A5a6",
		value: "0xF9078Fb962A7D13F55d40d49C8AA6472aBD1A5a6"
	},
	{
		decimals: 18,
		symbol: "yCRV-f",
		name: "Curve.fi Factory Plain Pool: yCRV",
		chainId: 1,
		address: "0x453D92C7d4263201C69aACfaf589Ed14202d83a4",
		value: "0x453D92C7d4263201C69aACfaf589Ed14202d83a4"
	},
	{
		decimals: 18,
		symbol: "pax-usdp3CRV-f",
		name: "Curve.fi Factory USD Metapool: Paxos Dollar (USDP)",
		chainId: 1,
		address: "0xc270b3B858c335B6BA5D5b10e2Da8a09976005ad",
		value: "0xc270b3B858c335B6BA5D5b10e2Da8a09976005ad"
	},
	{
		decimals: 18,
		symbol: "sUSD",
		name: "Synth sUSD",
		chainId: 1,
		address: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		value: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"
	},
	{
		decimals: 18,
		symbol: "B-rETH-STABLE",
		name: "Balancer rETH Stable Pool",
		chainId: 1,
		address: "0x1E19CF2D73a72Ef1332C882F20534B6519Be0276",
		value: "0x1E19CF2D73a72Ef1332C882F20534B6519Be0276"
	},
	{
		decimals: 18,
		symbol: "DYDXETH-f",
		name: "Curve.fi Factory Crypto Pool: DYDX/ETH",
		chainId: 1,
		address: "0x4aCc1BF7D6a591016641325aA6664A1Cd178F002",
		value: "0x4aCc1BF7D6a591016641325aA6664A1Cd178F002"
	},
	{
		decimals: 18,
		symbol: "dETHfrxETH-f",
		name: "Curve.fi Factory Plain Pool: Stakehouse dETH / frxETH",
		chainId: 1,
		address: "0x7C0d189E1FecB124487226dCbA3748bD758F98E4",
		value: "0x7C0d189E1FecB124487226dCbA3748bD758F98E4"
	},
	{
		decimals: 18,
		symbol: "xETHETH-f",
		name: "Curve.fi Factory Crypto Pool: xETH/ETH",
		chainId: 1,
		address: "0x16eAd9a10b1A77007E6E329B076aD1Fe97a6F7C0",
		value: "0x16eAd9a10b1A77007E6E329B076aD1Fe97a6F7C0"
	},
	{
		decimals: 18,
		symbol: "DOLAFRAXBP3CRV-f",
		name: "Curve.fi Factory USD Metapool: DOLA/FRAXBP",
		chainId: 1,
		address: "0xE57180685E3348589E9521aa53Af0BCD497E884d",
		value: "0xE57180685E3348589E9521aa53Af0BCD497E884d"
	},
	{
		decimals: 18,
		symbol: "ETHwBETHCRV",
		name: "Curve.fi ETH/wBETH",
		chainId: 1,
		address: "0xBfAb6FA95E0091ed66058ad493189D2cB29385E6",
		value: "0xBfAb6FA95E0091ed66058ad493189D2cB29385E6"
	},
	{
		decimals: 18,
		symbol: "DOLA-USDC BSP",
		name: "DOLA USDC Stable Pool",
		chainId: 1,
		address: "0xFf4ce5AAAb5a627bf82f4A571AB1cE94Aa365eA6",
		value: "0xFf4ce5AAAb5a627bf82f4A571AB1cE94Aa365eA6"
	},
	{
		decimals: 18,
		symbol: "crvTETH",
		name: "Curve T-ETH",
		chainId: 1,
		address: "0xCb08717451aaE9EF950a2524E33B6DCaBA60147B",
		value: "0xCb08717451aaE9EF950a2524E33B6DCaBA60147B"
	},
	{
		decimals: 18,
		symbol: "DOLA3POOL3CRV-f",
		name: "Curve.fi Factory USD Metapool: DOLA-3pool Curve LP",
		chainId: 1,
		address: "0xAA5A67c256e27A5d80712c51971408db3370927D",
		value: "0xAA5A67c256e27A5d80712c51971408db3370927D"
	},
	{
		decimals: 18,
		symbol: "MIM-UST-f",
		name: "Curve.fi Factory Plain Pool: MIM-UST",
		chainId: 1,
		address: "0x55A8a39bc9694714E2874c1ce77aa1E599461E18",
		value: "0x55A8a39bc9694714E2874c1ce77aa1E599461E18"
	},
	{
		decimals: 18,
		symbol: "AAVE",
		name: "Aave Token",
		chainId: 1,
		address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
		value: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
		logoURI: "https://assets.coingecko.com/coins/images/12645/thumb/AAVE.png?1601374110"
	},
	{
		decimals: 18,
		symbol: "DAI",
		name: "Dai Stablecoin",
		chainId: 1,
		address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
		value: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png"
	},
	{
		decimals: 18,
		symbol: "frxETHCRV",
		name: "Curve.fi ETH/frxETH",
		chainId: 1,
		address: "0xf43211935C781D5ca1a41d2041F397B8A7366C7A",
		value: "0xf43211935C781D5ca1a41d2041F397B8A7366C7A"
	},
	{
		decimals: 18,
		symbol: "steCRV",
		name: "Curve.fi ETH/stETH",
		chainId: 1,
		address: "0x06325440D014e39736583c165C2963BA99fAf14E",
		value: "0x06325440D014e39736583c165C2963BA99fAf14E"
	},
	{
		decimals: 18,
		symbol: "YFI",
		name: "yearn.finance",
		chainId: 1,
		address: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
		value: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
		logoURI: "https://assets.coingecko.com/coins/images/11849/thumb/yfi-192x192.png?1598325330"
	},
	{
		decimals: 18,
		symbol: "HEGIC",
		name: "Hegic",
		chainId: 1,
		address: "0x584bC13c7D411c00c01A62e8019472dE68768430",
		value: "0x584bC13c7D411c00c01A62e8019472dE68768430"
	},
	{
		decimals: 18,
		symbol: "TRYB3POOL-f",
		name: "Curve.fi Factory Crypto Pool: TRYB/USD (3crv)",
		chainId: 1,
		address: "0x6E0e681441BE6cB1d8405752462488BD4D691E3A",
		value: "0x6E0e681441BE6cB1d8405752462488BD4D691E3A"
	},
	{
		decimals: 18,
		symbol: "LUSDcrvUSD-f",
		name: "Curve.fi Factory Plain Pool: LUSD/crvUSD",
		chainId: 1,
		address: "0x9978c6B08d28d3B74437c917c5dD7C026df9d55C",
		value: "0x9978c6B08d28d3B74437c917c5dD7C026df9d55C"
	},
	{
		decimals: 18,
		symbol: "DOLAFRAXBP3CRV-f",
		name: "Curve.fi Factory USD Metapool: DOLA/FRAXBP",
		chainId: 1,
		address: "0xE57180685E3348589E9521aa53Af0BCD497E884d",
		value: "0xE57180685E3348589E9521aa53Af0BCD497E884d"
	},
	{
		decimals: 18,
		symbol: "cvxFXSFXS-f",
		name: "Curve.fi Factory Crypto Pool: cvxFxs/Fxs",
		chainId: 1,
		address: "0xF3A43307DcAFa93275993862Aae628fCB50dC768",
		value: "0xF3A43307DcAFa93275993862Aae628fCB50dC768"
	},
	{
		decimals: 18,
		symbol: "STBT3CRV-f",
		name: "Curve.fi Factory USD Metapool: STBT/3CRV",
		chainId: 1,
		address: "0x892D701d94a43bDBCB5eA28891DaCA2Fa22A690b",
		value: "0x892D701d94a43bDBCB5eA28891DaCA2Fa22A690b"
	},
	{
		decimals: 18,
		symbol: "xFraxTplLP-f",
		name: "Curve.fi Factory Plain Pool: Stax Frax/Temple xLP + LP",
		chainId: 1,
		address: "0xdaDfD00A2bBEb1abc4936b1644a3033e1B653228",
		value: "0xdaDfD00A2bBEb1abc4936b1644a3033e1B653228"
	},
	{
		decimals: 18,
		symbol: "oBTC/sbtcCRV",
		name: "Curve.fi oBTC/sbtcCRV",
		chainId: 1,
		address: "0x2fE94ea3d5d4a175184081439753DE15AeF9d614",
		value: "0x2fE94ea3d5d4a175184081439753DE15AeF9d614"
	},
	{
		decimals: 18,
		symbol: "linkCRV",
		name: "Curve.fi LINK/sLINK",
		chainId: 1,
		address: "0xcee60cFa923170e4f8204AE08B4fA6A3F5656F3a",
		value: "0xcee60cFa923170e4f8204AE08B4fA6A3F5656F3a"
	},
	{
		decimals: 18,
		symbol: "sUSD",
		name: "Synth sUSD",
		chainId: 1,
		address: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		value: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"
	},
	{
		decimals: 18,
		symbol: "TUSD3CRV-f",
		name: "Curve.fi Factory USD Metapool: TrueUSD",
		chainId: 1,
		address: "0xEcd5e75AFb02eFa118AF914515D6521aaBd189F1",
		value: "0xEcd5e75AFb02eFa118AF914515D6521aaBd189F1"
	},
	{
		decimals: 18,
		symbol: "crvUSDDOLA-f",
		name: "Curve.fi Factory Plain Pool: crvUSD/DOLA",
		chainId: 1,
		address: "0x8272E1A3dBef607C04AA6e5BD3a1A134c8ac063B",
		value: "0x8272E1A3dBef607C04AA6e5BD3a1A134c8ac063B"
	},
	{
		decimals: 18,
		symbol: "GHO/LUSD",
		name: "Balancer GHO/LUSD Stable Pool",
		chainId: 1,
		address: "0x3FA8C89704e5d07565444009e5d9e624B40Be813",
		value: "0x3FA8C89704e5d07565444009e5d9e624B40Be813"
	}
];

var yVaultsArbitrum = [
	{
		address: "0x1dBa7641dc69188D6086a73B972aC4bda29Ec35d",
		name: "Curve MIM Pool Vault",
		symbol: "yvCurve-MIM",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x30dF229cefa463e991e29D42DB0bae2e122B2AC7"
		],
		chainId: 42161,
		value: "0x1dBa7641dc69188D6086a73B972aC4bda29Ec35d",
		underlyingToken: "0x30dF229cefa463e991e29D42DB0bae2e122B2AC7"
	},
	{
		address: "0x630c9050E6b0014C6Fe4C214D4840909345aDB7D",
		name: "Curve FRAX-VST Pool Vault",
		symbol: "yvCurve-FRAX+VST",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x59bF0545FCa0E5Ad48E13DA269faCD2E8C886Ba4"
		],
		chainId: 42161,
		value: "0x630c9050E6b0014C6Fe4C214D4840909345aDB7D",
		underlyingToken: "0x59bF0545FCa0E5Ad48E13DA269faCD2E8C886Ba4"
	},
	{
		address: "0x976a1C749cd8153909e0B04EebE931eF8957b15b",
		name: "PHPTest",
		symbol: "yPHP",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xFa247d0D55a324ca19985577a2cDcFC383D87953"
		],
		chainId: 42161,
		value: "0x976a1C749cd8153909e0B04EebE931eF8957b15b",
		underlyingToken: "0xFa247d0D55a324ca19985577a2cDcFC383D87953"
	},
	{
		address: "0x239e14A19DFF93a17339DCC444f74406C17f8E67",
		name: "Curve Tricrypto Pool Vault",
		symbol: "yvCurve-Tricrypto",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x8e0B8c8BB9db49a46697F3a5Bb8A308e744821D2"
		],
		chainId: 42161,
		value: "0x239e14A19DFF93a17339DCC444f74406C17f8E67",
		underlyingToken: "0x8e0B8c8BB9db49a46697F3a5Bb8A308e744821D2"
	},
	{
		address: "0x49448d2B94fb9C4e41a30aD8315D32f46004A34b",
		name: "2CRV yVault",
		symbol: "yv2CRV",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x7f90122BF0700F9E7e1F688fe926940E8839F353"
		],
		chainId: 42161,
		value: "0x49448d2B94fb9C4e41a30aD8315D32f46004A34b",
		underlyingToken: "0x7f90122BF0700F9E7e1F688fe926940E8839F353"
	}
];

var yVaultsMainnet = [
	{
		address: "0x1025b1641d1F23C289412Dd5E5701e9810103a93",
		name: "Curve ibAUD-USDC Pool yVault",
		symbol: "yvCurve-ibAUD-USDC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x54c8Ecf46A81496eEB0608BD3353388b5D7a2a33"
		],
		chainId: 1,
		value: "0x1025b1641d1F23C289412Dd5E5701e9810103a93",
		underlyingToken: "0x54c8Ecf46A81496eEB0608BD3353388b5D7a2a33"
	},
	{
		address: "0x3149950258FbBcE1638d6C23ac93A692604Ef864",
		name: "crvRenWBTC yVault",
		symbol: "yvcrvRenWBTC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x49849C98ae39Fff122806C06791Fa73784FB3675"
		],
		chainId: 1,
		value: "0x3149950258FbBcE1638d6C23ac93A692604Ef864",
		underlyingToken: "0x49849C98ae39Fff122806C06791Fa73784FB3675"
	},
	{
		address: "0x378cb52b00F9D0921cb46dFc099CFf73b42419dC",
		name: "LUSD yVault",
		symbol: "yvLUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x5f98805A4E8be255a32880FDeC7F6728C6568bA0"
		],
		chainId: 1,
		value: "0x378cb52b00F9D0921cb46dFc099CFf73b42419dC",
		underlyingToken: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
		logoURI: "https://assets.coingecko.com/coins/images/14666/thumb/Group_3.png?1617631327"
	},
	{
		address: "0x39CAF13a104FF567f71fd2A4c68C026FDB6E740B",
		name: "Curve Aave Pool yVault",
		symbol: "yvCurve-Aave",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xFd2a8fA60Abd58Efe3EeE34dd494cD491dC14900"
		],
		chainId: 1,
		value: "0x39CAF13a104FF567f71fd2A4c68C026FDB6E740B",
		underlyingToken: "0xFd2a8fA60Abd58Efe3EeE34dd494cD491dC14900"
	},
	{
		address: "0x0ff3773a6984aD900f7FB23A9acbf07AC3aDFB06",
		name: "Curve Y Pool yVault",
		symbol: "yUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xdF5e0e81Dff6FAF3A7e52BA697820c5e32D806A8"
		],
		chainId: 1,
		value: "0x0ff3773a6984aD900f7FB23A9acbf07AC3aDFB06",
		underlyingToken: "0xdF5e0e81Dff6FAF3A7e52BA697820c5e32D806A8"
	},
	{
		address: "0x7F7DF0e9a040DdA05FC609143cc8dA7cC6c59587",
		name: "sUSD yVault",
		symbol: "yvsUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x57Ab1ec28D129707052df4dF418D58a2D46d5f51"
		],
		chainId: 1,
		value: "0x7F7DF0e9a040DdA05FC609143cc8dA7cC6c59587",
		underlyingToken: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"
	},
	{
		address: "0x3D27705c64213A5DcD9D26880c1BcFa72d5b6B0E",
		name: "Curve USDK Pool yVault",
		symbol: "yvCurve-USDK",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x97E2768e8E73511cA874545DC5Ff8067eB19B787"
		],
		chainId: 1,
		value: "0x3D27705c64213A5DcD9D26880c1BcFa72d5b6B0E",
		underlyingToken: "0x97E2768e8E73511cA874545DC5Ff8067eB19B787"
	},
	{
		address: "0x04D549bAfE83B8BdCCC8dF38F15b90199D20f1eE",
		name: "Curve tBTC Factory yVault",
		symbol: "yvCurve-tBTC-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xF95AAa7EBB1620e46221B73588502960Ef63dBa0"
		],
		chainId: 1,
		value: "0x04D549bAfE83B8BdCCC8dF38F15b90199D20f1eE",
		underlyingToken: "0xF95AAa7EBB1620e46221B73588502960Ef63dBa0"
	},
	{
		address: "0x1133b2E2F51becCF25b2f8d0cA48c1d93DD5ab12",
		name: "OCEAN yVault",
		symbol: "yvOCEAN",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x967da4048cD07aB37855c090aAF366e4ce1b9F48"
		],
		chainId: 1,
		value: "0x1133b2E2F51becCF25b2f8d0cA48c1d93DD5ab12",
		underlyingToken: "0x967da4048cD07aB37855c090aAF366e4ce1b9F48",
		logoURI: "https://assets.coingecko.com/coins/images/3687/thumb/ocean-protocol-logo.jpg?1547038686"
	},
	{
		address: "0x4213458C69c19E6792510E1153cb0c5834665fdC",
		name: "Balancer Boosted Aave USD Pool yVault",
		symbol: "yvBalancer-BoostedAaveUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x7B50775383d3D6f0215A8F290f2C9e2eEBBEceb2"
		],
		chainId: 1,
		value: "0x4213458C69c19E6792510E1153cb0c5834665fdC",
		underlyingToken: "0x7B50775383d3D6f0215A8F290f2C9e2eEBBEceb2"
	},
	{
		address: "0xa5cA62D95D24A4a350983D5B8ac4EB8638887396",
		name: "sUSD yVault",
		symbol: "yvsUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x57Ab1ec28D129707052df4dF418D58a2D46d5f51"
		],
		chainId: 1,
		value: "0xa5cA62D95D24A4a350983D5B8ac4EB8638887396",
		underlyingToken: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"
	},
	{
		address: "0x4962B6C40B5E9433E029c5c423F6b1ce7fF28b0f",
		name: "sUSD yVault",
		symbol: "yvsUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x57Ab1ec28D129707052df4dF418D58a2D46d5f51"
		],
		chainId: 1,
		value: "0x4962B6C40B5E9433E029c5c423F6b1ce7fF28b0f",
		underlyingToken: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"
	},
	{
		address: "0xA696a63cc78DfFa1a63E9E50587C197387FF6C7E",
		name: "WBTC yVault",
		symbol: "yvWBTC",
		decimals: 8,
		isVault: true,
		underlyingTokens: [
			"0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
		],
		chainId: 1,
		value: "0xA696a63cc78DfFa1a63E9E50587C197387FF6C7E",
		underlyingToken: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png"
	},
	{
		address: "0x5c0A86A32c129538D62C106Eb8115a8b02358d57",
		name: "Curve rETH-wstETH Pool yVault",
		symbol: "yvCurve-rETHwstETH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x447Ddd4960d9fdBF6af9a790560d0AF76795CB08"
		],
		chainId: 1,
		value: "0x5c0A86A32c129538D62C106Eb8115a8b02358d57",
		underlyingToken: "0x447Ddd4960d9fdBF6af9a790560d0AF76795CB08"
	},
	{
		address: "0x2E2b268cbC86917D2809CE2715A19E58a210FceE",
		name: "Curve HBTC Factory yVault",
		symbol: "yvCurve-HBTC-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xb19059ebb43466C323583928285a49f558E572Fd"
		],
		chainId: 1,
		value: "0x2E2b268cbC86917D2809CE2715A19E58a210FceE",
		underlyingToken: "0xb19059ebb43466C323583928285a49f558E572Fd"
	},
	{
		address: "0xC1f3C276Bf73396C020E8354bcA581846171649d",
		name: "wstETH yVault",
		symbol: "yvwstETH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0"
		],
		chainId: 1,
		value: "0xC1f3C276Bf73396C020E8354bcA581846171649d",
		underlyingToken: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0"
	},
	{
		address: "0x3B27F92C0e212C671EA351827EDF93DB27cc0c65",
		name: "USDT yVault",
		symbol: "yvUSDT",
		decimals: 6,
		isVault: true,
		underlyingTokens: [
			"0xdAC17F958D2ee523a2206206994597C13D831ec7"
		],
		chainId: 1,
		value: "0x3B27F92C0e212C671EA351827EDF93DB27cc0c65",
		underlyingToken: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
	},
	{
		address: "0xf2db9a7c0ACd427A680D640F02d90f6186E71725",
		name: "Curve LINK Pool yVault",
		symbol: "yvCurve-LINK",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xcee60cFa923170e4f8204AE08B4fA6A3F5656F3a"
		],
		chainId: 1,
		value: "0xf2db9a7c0ACd427A680D640F02d90f6186E71725",
		underlyingToken: "0xcee60cFa923170e4f8204AE08B4fA6A3F5656F3a"
	},
	{
		address: "0x944d749017053e0D37ec206c9898716A21e0B2E2",
		name: "Curve mUSD Factory yVault",
		symbol: "yvCurve-mUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x1AEf73d49Dedc4b1778d0706583995958Dc862e6"
		],
		chainId: 1,
		value: "0x944d749017053e0D37ec206c9898716A21e0B2E2",
		underlyingToken: "0x1AEf73d49Dedc4b1778d0706583995958Dc862e6"
	},
	{
		address: "0xD1a075C806e40D79e32eA09553E7080d5d9d4b29",
		name: "SUSHI yVault",
		symbol: "yvSUSHI",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x6B3595068778DD592e39A122f4f5a5cF09C90fE2"
		],
		chainId: 1,
		value: "0xD1a075C806e40D79e32eA09553E7080d5d9d4b29",
		underlyingToken: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
		logoURI: "https://assets.coingecko.com/coins/images/12271/thumb/512x512_Logo_no_chop.png?1606986688"
	},
	{
		address: "0x2DfB14E32e2F8156ec15a2c21c3A6c053af52Be8",
		name: "Curve MIM Pool yVault",
		symbol: "yvCurve-MIM",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x5a6A4D54456819380173272A5E8E9B9904BdF41B"
		],
		chainId: 1,
		value: "0x2DfB14E32e2F8156ec15a2c21c3A6c053af52Be8",
		underlyingToken: "0x5a6A4D54456819380173272A5E8E9B9904BdF41B"
	},
	{
		address: "0xdCD90C7f6324cfa40d7169ef80b12031770B4325",
		name: "Curve stETH Pool yVault",
		symbol: "yvCurve-stETH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x06325440D014e39736583c165C2963BA99fAf14E"
		],
		chainId: 1,
		value: "0xdCD90C7f6324cfa40d7169ef80b12031770B4325",
		underlyingToken: "0x06325440D014e39736583c165C2963BA99fAf14E"
	},
	{
		address: "0xDb26d8815EdA864Dfa43306766f2F8CA50C03F9E",
		name: "Curve msUSD-FRAXBP Factory yVault",
		symbol: "yvCurve-msUSD-FRAXBP-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xc3b19502F8c02be75F3f77fd673503520DEB51dD"
		],
		chainId: 1,
		value: "0xDb26d8815EdA864Dfa43306766f2F8CA50C03F9E",
		underlyingToken: "0xc3b19502F8c02be75F3f77fd673503520DEB51dD"
	},
	{
		address: "0xfb5137Aa9e079DB4b7C2929229caf503d0f6DA96",
		name: "Curve DOLA-crvUSD Factory yVault",
		symbol: "yvCurve-DOLA-crvUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x8272E1A3dBef607C04AA6e5BD3a1A134c8ac063B"
		],
		chainId: 1,
		value: "0xfb5137Aa9e079DB4b7C2929229caf503d0f6DA96",
		underlyingToken: "0x8272E1A3dBef607C04AA6e5BD3a1A134c8ac063B"
	},
	{
		address: "0xe11ba472F74869176652C35D30dB89854b5ae84D",
		name: "HEGIC yVault",
		symbol: "yvHEGIC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x584bC13c7D411c00c01A62e8019472dE68768430"
		],
		chainId: 1,
		value: "0xe11ba472F74869176652C35D30dB89854b5ae84D",
		underlyingToken: "0x584bC13c7D411c00c01A62e8019472dE68768430"
	},
	{
		address: "0x321d570790fd2f109Fe4e55aa419Adf2fce0c842",
		name: "Curve agEUR-EUROC Factory yVault",
		symbol: "yvCurve-agEUR-EUROC-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xBa3436Fd341F2C8A928452Db3C5A3670d1d5Cc73"
		],
		chainId: 1,
		value: "0x321d570790fd2f109Fe4e55aa419Adf2fce0c842",
		underlyingToken: "0xBa3436Fd341F2C8A928452Db3C5A3670d1d5Cc73"
	},
	{
		address: "0x67e019bfbd5a67207755D04467D6A70c0B75bF60",
		name: "Curve ibEUR Pool yVault",
		symbol: "yvCurve-ibEUR",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x19b080FE1ffA0553469D20Ca36219F17Fcf03859"
		],
		chainId: 1,
		value: "0x67e019bfbd5a67207755D04467D6A70c0B75bF60",
		underlyingToken: "0x19b080FE1ffA0553469D20Ca36219F17Fcf03859"
	},
	{
		address: "0xD6A4180c819324A9E432CA07C689EcBF00088cd6",
		name: "Curve EURS Factory yVault",
		symbol: "yvCurve-EURS-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x194eBd173F6cDacE046C53eACcE9B953F28411d1"
		],
		chainId: 1,
		value: "0xD6A4180c819324A9E432CA07C689EcBF00088cd6",
		underlyingToken: "0x194eBd173F6cDacE046C53eACcE9B953F28411d1"
	},
	{
		address: "0x5e69e8b51B71C8596817fD442849BD44219bb095",
		name: "Curve ibBTC Pool yVault",
		symbol: "yvCurve-ibBTC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xFbdCA68601f835b27790D98bbb8eC7f05FDEaA9B"
		],
		chainId: 1,
		value: "0x5e69e8b51B71C8596817fD442849BD44219bb095",
		underlyingToken: "0xFbdCA68601f835b27790D98bbb8eC7f05FDEaA9B"
	},
	{
		address: "0xe1747F4D30479D7a2DCFEa5af69fb86B8f71cCeC",
		name: "Curve TRYb Factory yVault",
		symbol: "yvCurve-TRYb-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x6E0e681441BE6cB1d8405752462488BD4D691E3A"
		],
		chainId: 1,
		value: "0xe1747F4D30479D7a2DCFEa5af69fb86B8f71cCeC",
		underlyingToken: "0x6E0e681441BE6cB1d8405752462488BD4D691E3A"
	},
	{
		address: "0x04c8bfe2eb09a1e2e9fA97A2fd970E06d87B43de",
		name: "Curve GEAR-ETH Factory yVault",
		symbol: "yvCurve-GEAR-ETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x5Be6C45e2d074fAa20700C49aDA3E88a1cc0025d"
		],
		chainId: 1,
		value: "0x04c8bfe2eb09a1e2e9fA97A2fd970E06d87B43de",
		underlyingToken: "0x5Be6C45e2d074fAa20700C49aDA3E88a1cc0025d"
	},
	{
		address: "0x6d765CbE5bC922694afE112C140b8878b9FB0390",
		name: "SUSHI yVault",
		symbol: "yvSUSHI",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x6B3595068778DD592e39A122f4f5a5cF09C90fE2"
		],
		chainId: 1,
		value: "0x6d765CbE5bC922694afE112C140b8878b9FB0390",
		underlyingToken: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
		logoURI: "https://assets.coingecko.com/coins/images/12271/thumb/512x512_Logo_no_chop.png?1606986688"
	},
	{
		address: "0x7788A5492bc948e1d8c2caa53b2e0a60ed5403b0",
		name: "Curve OHM-FRAXBP Factory yVault",
		symbol: "yvCurve-OHM-FRAXBP-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x5271045F7B73c17825A7A7aee6917eE46b0B7520"
		],
		chainId: 1,
		value: "0x7788A5492bc948e1d8c2caa53b2e0a60ed5403b0",
		underlyingToken: "0x5271045F7B73c17825A7A7aee6917eE46b0B7520"
	},
	{
		address: "0x63c5c0604Ec410130C69C958aCab81794f7a622F",
		name: "Curve MATIC-ETH Factory yVault",
		symbol: "yvCurve-MATIC-ETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xD8eb58D76aF99547333cfEeb6a0f9bd1A63b6492"
		],
		chainId: 1,
		value: "0x63c5c0604Ec410130C69C958aCab81794f7a622F",
		underlyingToken: "0xD8eb58D76aF99547333cfEeb6a0f9bd1A63b6492"
	},
	{
		address: "0x1E6462678462c95e1F8AFE2558D7FF8692affBD0",
		name: "Curve FEI Pool yVault",
		symbol: "yvCurve-FEI",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x06cb22615BA53E60D67Bf6C341a0fD5E718E1655"
		],
		chainId: 1,
		value: "0x1E6462678462c95e1F8AFE2558D7FF8692affBD0",
		underlyingToken: "0x06cb22615BA53E60D67Bf6C341a0fD5E718E1655"
	},
	{
		address: "0xdADbB5472474E612A6fA9d82d3395DEA5829a52a",
		name: "Curve frxETH Factory yVault",
		symbol: "yvCurve-frxETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xf43211935C781D5ca1a41d2041F397B8A7366C7A"
		],
		chainId: 1,
		value: "0xdADbB5472474E612A6fA9d82d3395DEA5829a52a",
		underlyingToken: "0xf43211935C781D5ca1a41d2041F397B8A7366C7A"
	},
	{
		address: "0xE6570a24Ce63dD588195B98aAD9F91B121d5F3D7",
		name: "Curve FXS-ETH Factory yVault",
		symbol: "yvCurve-FXS-ETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x90244F43D548a4f8dFecfAD91a193465B1fad6F7"
		],
		chainId: 1,
		value: "0xE6570a24Ce63dD588195B98aAD9F91B121d5F3D7",
		underlyingToken: "0x90244F43D548a4f8dFecfAD91a193465B1fad6F7"
	},
	{
		address: "0xe5F625e8f4D2A038AE9583Da254945285E5a77a4",
		name: "Curve DOLA-FRAXBP Factory yVault",
		symbol: "yvCurve-DOLA-FRXBP-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xE57180685E3348589E9521aa53Af0BCD497E884d"
		],
		chainId: 1,
		value: "0xe5F625e8f4D2A038AE9583Da254945285E5a77a4",
		underlyingToken: "0xE57180685E3348589E9521aa53Af0BCD497E884d"
	},
	{
		address: "0xd9788f3931Ede4D5018184E198699dC6d66C1915",
		name: "AAVE yVault",
		symbol: "yvAAVE",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9"
		],
		chainId: 1,
		value: "0xd9788f3931Ede4D5018184E198699dC6d66C1915",
		underlyingToken: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
		logoURI: "https://assets.coingecko.com/coins/images/12645/thumb/AAVE.png?1601374110"
	},
	{
		address: "0x849dC56ceCa7Cf55AbF5ec87910DA21c5C7dA581",
		name: "Curve ETH+ Factory yVault",
		symbol: "yvCurve-ETH+-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xe8a5677171c87fCB65b76957f2852515B404C7b1"
		],
		chainId: 1,
		value: "0x849dC56ceCa7Cf55AbF5ec87910DA21c5C7dA581",
		underlyingToken: "0xe8a5677171c87fCB65b76957f2852515B404C7b1"
	},
	{
		address: "0xca46d6e44499AfbD8795f8F86910F068a6bF1a7c",
		name: "Curve DYDX-ETH Factory yVault",
		symbol: "yvCurve-DYDX-ETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x4aCc1BF7D6a591016641325aA6664A1Cd178F002"
		],
		chainId: 1,
		value: "0xca46d6e44499AfbD8795f8F86910F068a6bF1a7c",
		underlyingToken: "0x4aCc1BF7D6a591016641325aA6664A1Cd178F002"
	},
	{
		address: "0xc869206adAfD3D874dB22e8BbA662E05F6257613",
		name: "Curve clevCVX Factory yVault",
		symbol: "yvCurve-clevCVX-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xF9078Fb962A7D13F55d40d49C8AA6472aBD1A5a6"
		],
		chainId: 1,
		value: "0xc869206adAfD3D874dB22e8BbA662E05F6257613",
		underlyingToken: "0xF9078Fb962A7D13F55d40d49C8AA6472aBD1A5a6"
	},
	{
		address: "0x4Fdd1B06eF986238446be0F3EA163C1b6Fe28cC1",
		name: "GUSD yVault",
		symbol: "yvGUSD",
		decimals: 2,
		isVault: true,
		underlyingTokens: [
			"0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd"
		],
		chainId: 1,
		value: "0x4Fdd1B06eF986238446be0F3EA163C1b6Fe28cC1",
		underlyingToken: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
		logoURI: "https://assets.coingecko.com/coins/images/5992/thumb/gemini-dollar-gusd.png?1536745278"
	},
	{
		address: "0x63bD3Bbb6c5cb6E457C3f3cbb2D8aa2536E319F1",
		name: "Curve GUSD Factory yVault",
		symbol: "yvCurve-GUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xD2967f45c4f384DEEa880F807Be904762a3DeA07"
		],
		chainId: 1,
		value: "0x63bD3Bbb6c5cb6E457C3f3cbb2D8aa2536E319F1",
		underlyingToken: "0xD2967f45c4f384DEEa880F807Be904762a3DeA07"
	},
	{
		address: "0x4C4A6A22bCE915C724A66b82128577F1B24831eD",
		name: "Curve EURT Pool yVault",
		symbol: "yvCurve-EURT",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xFD5dB7463a3aB53fD211b4af195c5BCCC1A03890"
		],
		chainId: 1,
		value: "0x4C4A6A22bCE915C724A66b82128577F1B24831eD",
		underlyingToken: "0xFD5dB7463a3aB53fD211b4af195c5BCCC1A03890"
	},
	{
		address: "0x015d78C7aD1289F5aA1DEC25bD6b67ba31fAc1Cf",
		name: "crvTETH yVault",
		symbol: "yvcrvTETH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xCb08717451aaE9EF950a2524E33B6DCaBA60147B"
		],
		chainId: 1,
		value: "0x015d78C7aD1289F5aA1DEC25bD6b67ba31fAc1Cf",
		underlyingToken: "0xCb08717451aaE9EF950a2524E33B6DCaBA60147B"
	},
	{
		address: "0x6a7A0481e476827857704B87bdeE7922D058cbE4",
		name: "Curve hyUSD-eUSD Factory yVault",
		symbol: "yvCurve-hyUSD-eUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xc794C6A95f30d0ebF7B3Bbe85e8a0A95C9e411c1"
		],
		chainId: 1,
		value: "0x6a7A0481e476827857704B87bdeE7922D058cbE4",
		underlyingToken: "0xc794C6A95f30d0ebF7B3Bbe85e8a0A95C9e411c1"
	},
	{
		address: "0xD4108Bb1185A5c30eA3f4264Fd7783473018Ce17",
		name: "DOLA yVault - Unlisted",
		symbol: "yvDOLA-U",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x865377367054516e17014CcdED1e7d814EDC9ce4"
		],
		chainId: 1,
		value: "0xD4108Bb1185A5c30eA3f4264Fd7783473018Ce17",
		underlyingToken: "0x865377367054516e17014CcdED1e7d814EDC9ce4"
	},
	{
		address: "0x2a38B9B0201Ca39B17B460eD2f11e4929559071E",
		name: "Curve GUSD Pool yVault",
		symbol: "yvCurve-GUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xD2967f45c4f384DEEa880F807Be904762a3DeA07"
		],
		chainId: 1,
		value: "0x2a38B9B0201Ca39B17B460eD2f11e4929559071E",
		underlyingToken: "0xD2967f45c4f384DEEa880F807Be904762a3DeA07"
	},
	{
		address: "0x1635b506a88fBF428465Ad65d00e8d6B6E5846C3",
		name: "Curve CVX-ETH Pool yVault",
		symbol: "yvCurve-CVXETH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x3A283D9c08E8b55966afb64C515f5143cf907611"
		],
		chainId: 1,
		value: "0x1635b506a88fBF428465Ad65d00e8d6B6E5846C3",
		underlyingToken: "0x3A283D9c08E8b55966afb64C515f5143cf907611"
	},
	{
		address: "0x2E919d27D515868f3D5Bc9110fa738f9449FC6ad",
		name: "Curve yveCRV Pool Vault",
		symbol: "yvCurve-yveCRV",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x7E46fd8a30869aa9ed55af031067Df666EfE87da"
		],
		chainId: 1,
		value: "0x2E919d27D515868f3D5Bc9110fa738f9449FC6ad",
		underlyingToken: "0x7E46fd8a30869aa9ed55af031067Df666EfE87da"
	},
	{
		address: "0x8cdf57760Be305F32e03B3d231e5A81e550C6295",
		name: "Curve USDN Factory yVault",
		symbol: "yvCurve-USDN-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x4f3E8F405CF5aFC05D68142F3783bDfE13811522"
		],
		chainId: 1,
		value: "0x8cdf57760Be305F32e03B3d231e5A81e550C6295",
		underlyingToken: "0x4f3E8F405CF5aFC05D68142F3783bDfE13811522"
	},
	{
		address: "0xBCBB5b54Fa51e7b7Dc920340043B203447842A6b",
		name: "Curve EURT-USD Pool yVault",
		symbol: "yvCurve-EURTUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x3b6831c0077a1e44ED0a21841C3bC4dC11bCE833"
		],
		chainId: 1,
		value: "0xBCBB5b54Fa51e7b7Dc920340043B203447842A6b",
		underlyingToken: "0x3b6831c0077a1e44ED0a21841C3bC4dC11bCE833"
	},
	{
		address: "0xbda3A6CB2aaef41805F6317841d7B8654eC8b124",
		name: "crvRenWBTC yVault",
		symbol: "yvcrvRenWBTC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x49849C98ae39Fff122806C06791Fa73784FB3675"
		],
		chainId: 1,
		value: "0xbda3A6CB2aaef41805F6317841d7B8654eC8b124",
		underlyingToken: "0x49849C98ae39Fff122806C06791Fa73784FB3675"
	},
	{
		address: "0x5B8C556B8b2a78696F0B9B830B3d67623122E270",
		name: "Curve stETH Factory yVault",
		symbol: "yvCurve-stETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x06325440D014e39736583c165C2963BA99fAf14E"
		],
		chainId: 1,
		value: "0x5B8C556B8b2a78696F0B9B830B3d67623122E270",
		underlyingToken: "0x06325440D014e39736583c165C2963BA99fAf14E"
	},
	{
		address: "0x30FCf7c6cDfC46eC237783D94Fc78553E79d4E9C",
		name: "Curve DUSD Pool yVault",
		symbol: "yvCurve-DUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x3a664Ab939FD8482048609f652f9a0B0677337B9"
		],
		chainId: 1,
		value: "0x30FCf7c6cDfC46eC237783D94Fc78553E79d4E9C",
		underlyingToken: "0x3a664Ab939FD8482048609f652f9a0B0677337B9"
	},
	{
		address: "0xD347e7A3DdF5Ce4C42E19a4F30eEAA761795C72B",
		name: "Curve ibEUR Factory yVault",
		symbol: "yvCurve-ibEUR-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x19b080FE1ffA0553469D20Ca36219F17Fcf03859"
		],
		chainId: 1,
		value: "0xD347e7A3DdF5Ce4C42E19a4F30eEAA761795C72B",
		underlyingToken: "0x19b080FE1ffA0553469D20Ca36219F17Fcf03859"
	},
	{
		address: "0x6E9455D109202b426169F0d8f01A3332DAE160f3",
		name: "LP Yearn CRV Vault v2",
		symbol: "lp-yCRVv2",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x99f5aCc8EC2Da2BC0771c32814EFF52b712de1E5"
		],
		chainId: 1,
		value: "0x6E9455D109202b426169F0d8f01A3332DAE160f3",
		underlyingToken: "0x99f5aCc8EC2Da2BC0771c32814EFF52b712de1E5"
	},
	{
		address: "0x56A5Fd5104a4956898753dfb060ff32882Ae0eb4",
		name: "ALCX yVault",
		symbol: "yvALCX",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xdBdb4d16EdA451D0503b854CF79D55697F90c8DF"
		],
		chainId: 1,
		value: "0x56A5Fd5104a4956898753dfb060ff32882Ae0eb4",
		underlyingToken: "0xdBdb4d16EdA451D0503b854CF79D55697F90c8DF",
		logoURI: "https://assets.coingecko.com/coins/images/14113/thumb/Alchemix.png?1614409874"
	},
	{
		address: "0x8cc94ccd0f3841a468184aCA3Cc478D2148E1757",
		name: "Curve mUSD Pool yVault",
		symbol: "yvCurve-mUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x1AEf73d49Dedc4b1778d0706583995958Dc862e6"
		],
		chainId: 1,
		value: "0x8cc94ccd0f3841a468184aCA3Cc478D2148E1757",
		underlyingToken: "0x1AEf73d49Dedc4b1778d0706583995958Dc862e6"
	},
	{
		address: "0x0F6121fB28C7C42916d663171063c62684598f9F",
		name: "HBTC yVault",
		symbol: "yvHBTC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x0316EB71485b0Ab14103307bf65a021042c6d380"
		],
		chainId: 1,
		value: "0x0F6121fB28C7C42916d663171063c62684598f9F",
		underlyingToken: "0x0316EB71485b0Ab14103307bf65a021042c6d380"
	},
	{
		address: "0x6FAfCA7f49B4Fd9dC38117469cd31A1E5aec91F5",
		name: "Curve USDM Pool yVault",
		symbol: "yvCurve-USDM",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x5B3b5DF2BF2B6543f78e053bD91C4Bdd820929f1"
		],
		chainId: 1,
		value: "0x6FAfCA7f49B4Fd9dC38117469cd31A1E5aec91F5",
		underlyingToken: "0x5B3b5DF2BF2B6543f78e053bD91C4Bdd820929f1"
	},
	{
		address: "0x718AbE90777F5B778B52D553a5aBaa148DD0dc5D",
		name: "Curve alETH Pool yVault",
		symbol: "yvCurve-alETH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xC4C319E2D4d66CcA4464C0c2B32c9Bd23ebe784e"
		],
		chainId: 1,
		value: "0x718AbE90777F5B778B52D553a5aBaa148DD0dc5D",
		underlyingToken: "0xC4C319E2D4d66CcA4464C0c2B32c9Bd23ebe784e"
	},
	{
		address: "0xAbD64D5AB5A4b129df4f6f37A8d461c2510b5503",
		name: "Curve 3Crv Factory yVault",
		symbol: "yvCurve-3Crv-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490"
		],
		chainId: 1,
		value: "0xAbD64D5AB5A4b129df4f6f37A8d461c2510b5503",
		underlyingToken: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490"
	},
	{
		address: "0x7845Ebf66c9575Fc5f5A0dBb9a34a706Ad997a3f",
		name: "Curve TriCryptoUSDT Factory yVault",
		symbol: "yvCurve-3CryptoUSDT-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xf5f5B97624542D72A9E06f04804Bf81baA15e2B4"
		],
		chainId: 1,
		value: "0x7845Ebf66c9575Fc5f5A0dBb9a34a706Ad997a3f",
		underlyingToken: "0xf5f5B97624542D72A9E06f04804Bf81baA15e2B4"
	},
	{
		address: "0x6f0Ace0F94f4B9890Dfa99A4175B3Ef0288C16B3",
		name: "Curve CRV-ETH Factory yVault",
		symbol: "yvCurve-CRV-ETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xEd4064f376cB8d68F770FB1Ff088a3d0F3FF5c4d"
		],
		chainId: 1,
		value: "0x6f0Ace0F94f4B9890Dfa99A4175B3Ef0288C16B3",
		underlyingToken: "0xEd4064f376cB8d68F770FB1Ff088a3d0F3FF5c4d"
	},
	{
		address: "0xAd86Df2e8F989c828B25A7Da5EB1Ec363283fA3F",
		name: "Curve LUSD Factory yVault",
		symbol: "yvCurve-LUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA"
		],
		chainId: 1,
		value: "0xAd86Df2e8F989c828B25A7Da5EB1Ec363283fA3F",
		underlyingToken: "0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA"
	},
	{
		address: "0x5faF6a2D186448Dfa667c51CB3D695c7A6E52d8E",
		name: "Curve stETH-WETH Pool yVault",
		symbol: "yvCurve-stETH-WETH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x828b154032950C8ff7CF8085D841723Db2696056"
		],
		chainId: 1,
		value: "0x5faF6a2D186448Dfa667c51CB3D695c7A6E52d8E",
		underlyingToken: "0x828b154032950C8ff7CF8085D841723Db2696056"
	},
	{
		address: "0x59518884EeBFb03e90a18ADBAAAB770d4666471e",
		name: "Curve ibJPY Pool yVault",
		symbol: "yvCurve-ibJPY",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x8818a9bb44Fbf33502bE7c15c500d0C783B73067"
		],
		chainId: 1,
		value: "0x59518884EeBFb03e90a18ADBAAAB770d4666471e",
		underlyingToken: "0x8818a9bb44Fbf33502bE7c15c500d0C783B73067"
	},
	{
		address: "0x3466c90017F82DDA939B01E8DBd9b0f97AEF8DfC",
		name: "sUSD yVault",
		symbol: "yvsUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x57Ab1ec28D129707052df4dF418D58a2D46d5f51"
		],
		chainId: 1,
		value: "0x3466c90017F82DDA939B01E8DBd9b0f97AEF8DfC",
		underlyingToken: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"
	},
	{
		address: "0x8b9C0c24307344B6D7941ab654b2Aeee25347473",
		name: "Curve EURN Pool yVault",
		symbol: "yvCurve-EURN",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x3Fb78e61784C9c637D560eDE23Ad57CA1294c14a"
		],
		chainId: 1,
		value: "0x8b9C0c24307344B6D7941ab654b2Aeee25347473",
		underlyingToken: "0x3Fb78e61784C9c637D560eDE23Ad57CA1294c14a"
	},
	{
		address: "0xd6A528faAd34Fe51c6F181acF43C1E20db4f84aC",
		name: "Balancer DOLA-USDC Factory yVault",
		symbol: "yvBal-DOLA-USDC-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xFf4ce5AAAb5a627bf82f4A571AB1cE94Aa365eA6"
		],
		chainId: 1,
		value: "0xd6A528faAd34Fe51c6F181acF43C1E20db4f84aC",
		underlyingToken: "0xFf4ce5AAAb5a627bf82f4A571AB1cE94Aa365eA6"
	},
	{
		address: "0xAA4f7562D3C25Bd2fCB8FEd615182667C0A7086C",
		name: "Balancer stafiETH Factory yVault",
		symbol: "yvBal-stafiETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xB08885e6026bab4333A80024Ec25a1a3e1FF2b8A"
		],
		chainId: 1,
		value: "0xAA4f7562D3C25Bd2fCB8FEd615182667C0A7086C",
		underlyingToken: "0xB08885e6026bab4333A80024Ec25a1a3e1FF2b8A"
	},
	{
		address: "0xDdb166C6CB38CEDe52d12c405b6e906c1fB6f9d7",
		name: "crvRenWSBTC yVault",
		symbol: "yvcrvRenWSBTC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3"
		],
		chainId: 1,
		value: "0xDdb166C6CB38CEDe52d12c405b6e906c1fB6f9d7",
		underlyingToken: "0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3"
	},
	{
		address: "0x8078198Fc424986ae89Ce4a910Fc109587b6aBF3",
		name: "Curve 3Crypto Factory yVault",
		symbol: "yvCurve-3Crypto-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xc4AD29ba4B3c580e6D59105FFf484999997675Ff"
		],
		chainId: 1,
		value: "0x8078198Fc424986ae89Ce4a910Fc109587b6aBF3",
		underlyingToken: "0xc4AD29ba4B3c580e6D59105FFf484999997675Ff"
	},
	{
		address: "0xbE4afE6737CCf34cA21cdeF461E5C7547Adc8C77",
		name: "Curve ibGBP Factory yVault",
		symbol: "yvCurve-ibGBP-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xD6Ac1CB9019137a896343Da59dDE6d097F710538"
		],
		chainId: 1,
		value: "0xbE4afE6737CCf34cA21cdeF461E5C7547Adc8C77",
		underlyingToken: "0xD6Ac1CB9019137a896343Da59dDE6d097F710538"
	},
	{
		address: "0x133cb5cF617a33F5D02cFFfF579435776ef29FB0",
		name: "Curve multiBTC Factory yVault",
		symbol: "yvCurve-multiBTC-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x2863a328A0B7fC6040f11614FA0728587DB8e353"
		],
		chainId: 1,
		value: "0x133cb5cF617a33F5D02cFFfF579435776ef29FB0",
		underlyingToken: "0x2863a328A0B7fC6040f11614FA0728587DB8e353"
	},
	{
		address: "0xdb25cA703181E7484a155DD612b06f57E12Be5F0",
		name: "YFI yVault",
		symbol: "yvYFI",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e"
		],
		chainId: 1,
		value: "0xdb25cA703181E7484a155DD612b06f57E12Be5F0",
		underlyingToken: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
		logoURI: "https://assets.coingecko.com/coins/images/11849/thumb/yfi-192x192.png?1598325330"
	},
	{
		address: "0xb32747B4045479B77a8b8Eb44029ba12580214F8",
		name: "SUSHI yVault",
		symbol: "yvSUSHI",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x6B3595068778DD592e39A122f4f5a5cF09C90fE2"
		],
		chainId: 1,
		value: "0xb32747B4045479B77a8b8Eb44029ba12580214F8",
		underlyingToken: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
		logoURI: "https://assets.coingecko.com/coins/images/12271/thumb/512x512_Logo_no_chop.png?1606986688"
	},
	{
		address: "0x5359680A80c1FB2175cD33efF32f762e43cD8C41",
		name: "Curve ibKRW Factory yVault",
		symbol: "yvCurve-ibKRW-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x8461A004b50d321CB22B7d034969cE6803911899"
		],
		chainId: 1,
		value: "0x5359680A80c1FB2175cD33efF32f762e43cD8C41",
		underlyingToken: "0x8461A004b50d321CB22B7d034969cE6803911899"
	},
	{
		address: "0x4A3FE75762017DB0eD73a71C9A06db7768DB5e66",
		name: "COMP yVault",
		symbol: "yvCOMP",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xc00e94Cb662C3520282E6f5717214004A7f26888"
		],
		chainId: 1,
		value: "0x4A3FE75762017DB0eD73a71C9A06db7768DB5e66",
		underlyingToken: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xc00e94Cb662C3520282E6f5717214004A7f26888/logo.png"
	},
	{
		address: "0xAE6eD98B1Bd9aAdd3185160324e0e011159B61D3",
		name: "Curve Compound Factory yVault",
		symbol: "yvCurve-Compound-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x845838DF265Dcd2c412A1Dc9e959c7d08537f8a2"
		],
		chainId: 1,
		value: "0xAE6eD98B1Bd9aAdd3185160324e0e011159B61D3",
		underlyingToken: "0x845838DF265Dcd2c412A1Dc9e959c7d08537f8a2"
	},
	{
		address: "0xaA379c2aA72529d5ec0da8A41e2F41ED7Fe4b48C",
		name: "Curve TriCryptoUSDC Factory yVault",
		symbol: "yvCurve-3CryptoUSDC-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x7F86Bf177Dd4F3494b841a37e810A34dD56c829B"
		],
		chainId: 1,
		value: "0xaA379c2aA72529d5ec0da8A41e2F41ED7Fe4b48C",
		underlyingToken: "0x7F86Bf177Dd4F3494b841a37e810A34dD56c829B"
	},
	{
		address: "0x5a770DbD3Ee6bAF2802D29a901Ef11501C44797A",
		name: "Curve sUSD Pool yVault",
		symbol: "yvCurve-sUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xC25a3A3b969415c80451098fa907EC722572917F"
		],
		chainId: 1,
		value: "0x5a770DbD3Ee6bAF2802D29a901Ef11501C44797A",
		underlyingToken: "0xC25a3A3b969415c80451098fa907EC722572917F"
	},
	{
		address: "0x790a60024bC3aea28385b60480f15a0771f26D09",
		name: "Curve YFI-ETH Pool yVault",
		symbol: "yvCurve-YFIETH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x29059568bB40344487d62f7450E78b8E6C74e0e5"
		],
		chainId: 1,
		value: "0x790a60024bC3aea28385b60480f15a0771f26D09",
		underlyingToken: "0x29059568bB40344487d62f7450E78b8E6C74e0e5"
	},
	{
		address: "0xd88dBBA3f9c4391Ee46f5FF548f289054db6E51C",
		name: "Curve DOLA Pool yVault",
		symbol: "yvCurve-DOLA",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xAA5A67c256e27A5d80712c51971408db3370927D"
		],
		chainId: 1,
		value: "0xd88dBBA3f9c4391Ee46f5FF548f289054db6E51C",
		underlyingToken: "0xAA5A67c256e27A5d80712c51971408db3370927D"
	},
	{
		address: "0xe92AE2cF5b373c1713eB5855D4D3aF81D8a8aCAE",
		name: "Curve Stax Frax/Temple xLP + LP yVault - Unlisted",
		symbol: "yvCurvexFraxTplLP-U",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xdaDfD00A2bBEb1abc4936b1644a3033e1B653228"
		],
		chainId: 1,
		value: "0xe92AE2cF5b373c1713eB5855D4D3aF81D8a8aCAE",
		underlyingToken: "0xdaDfD00A2bBEb1abc4936b1644a3033e1B653228"
	},
	{
		address: "0x986b4AFF588a109c09B50A03f42E4110E29D353F",
		name: "Curve sETH Pool yVault",
		symbol: "yvCurve-sETH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c"
		],
		chainId: 1,
		value: "0x986b4AFF588a109c09B50A03f42E4110E29D353F",
		underlyingToken: "0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c"
	},
	{
		address: "0xbf91b696a35b539b1142e2f921A2A88BB019506a",
		name: "Curve ETHx-WETH Factory yVault",
		symbol: "yvCurve-ETHx-WETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xd82C2eB10F4895CABED6EDa6eeee234bd1A9838B"
		],
		chainId: 1,
		value: "0xbf91b696a35b539b1142e2f921A2A88BB019506a",
		underlyingToken: "0xd82C2eB10F4895CABED6EDa6eeee234bd1A9838B"
	},
	{
		address: "0xf8768814b88281DE4F532a3beEfA5b85B69b9324",
		name: "Curve TUSD Pool yVault",
		symbol: "yvCurve-TUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xEcd5e75AFb02eFa118AF914515D6521aaBd189F1"
		],
		chainId: 1,
		value: "0xf8768814b88281DE4F532a3beEfA5b85B69b9324",
		underlyingToken: "0xEcd5e75AFb02eFa118AF914515D6521aaBd189F1"
	},
	{
		address: "0xD2C65E20C3fDE3F18097e7414e65596e0C83B1a9",
		name: "ICE yVault",
		symbol: "yvICE",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xf16e81dce15B08F326220742020379B855B87DF9"
		],
		chainId: 1,
		value: "0xD2C65E20C3fDE3F18097e7414e65596e0C83B1a9",
		underlyingToken: "0xf16e81dce15B08F326220742020379B855B87DF9"
	},
	{
		address: "0x91aE8fEaBe09182Fe5F91Fc273040b7D8F7aeFE7",
		name: "Curve Paxos Factory yVault",
		symbol: "yvCurve-USDP-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xc270b3B858c335B6BA5D5b10e2Da8a09976005ad"
		],
		chainId: 1,
		value: "0x91aE8fEaBe09182Fe5F91Fc273040b7D8F7aeFE7",
		underlyingToken: "0xc270b3B858c335B6BA5D5b10e2Da8a09976005ad"
	},
	{
		address: "0x8B58Aa42A4Aa222b684078459CE03Dd0A43342B1",
		name: "USDP yVault",
		symbol: "yvUSDP",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x1456688345527bE1f37E9e627DA0837D6f08C925"
		],
		chainId: 1,
		value: "0x8B58Aa42A4Aa222b684078459CE03Dd0A43342B1",
		underlyingToken: "0x1456688345527bE1f37E9e627DA0837D6f08C925"
	},
	{
		address: "0x4cb5483D87028518c5F35a49c151612a062bfCD0",
		name: "Balancer GHO-bb-a-USD Factory yVault",
		symbol: "yvBal-GHO-bb-a-USD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xc2B021133D1b0cF07dba696fd5DD89338428225B"
		],
		chainId: 1,
		value: "0x4cb5483D87028518c5F35a49c151612a062bfCD0",
		underlyingToken: "0xc2B021133D1b0cF07dba696fd5DD89338428225B"
	},
	{
		address: "0x9E0E0AF468FbD041Cab7883c5eEf16D1A99a47C3",
		name: "Curve sdANGLE Factory yVault",
		symbol: "yvCurve-sdANGLE-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x48fF31bBbD8Ab553Ebe7cBD84e1eA3dBa8f54957"
		],
		chainId: 1,
		value: "0x9E0E0AF468FbD041Cab7883c5eEf16D1A99a47C3",
		underlyingToken: "0x48fF31bBbD8Ab553Ebe7cBD84e1eA3dBa8f54957"
	},
	{
		address: "0x83f798e925BcD4017Eb265844FDDAbb448f1707D",
		name: "iearn USDT",
		symbol: "yUSDT",
		decimals: 6,
		isVault: true,
		underlyingTokens: [
			"0xdAC17F958D2ee523a2206206994597C13D831ec7"
		],
		chainId: 1,
		value: "0x83f798e925BcD4017Eb265844FDDAbb448f1707D",
		underlyingToken: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
	},
	{
		address: "0x5331009B82853e9FB711bC0b300E1b374724AdaC",
		name: "Curve sdYFI Factory yVault",
		symbol: "yvCurve-sdYFI-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x79E281BC69A03DaBCcD66858c65EF6724e50aebe"
		],
		chainId: 1,
		value: "0x5331009B82853e9FB711bC0b300E1b374724AdaC",
		underlyingToken: "0x79E281BC69A03DaBCcD66858c65EF6724e50aebe"
	},
	{
		address: "0x1C6a9783F812b3Af3aBbf7de64c3cD7CC7D1af44",
		name: "Curve UST Pool yVault",
		symbol: "yvCurve-UST",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x94e131324b6054c0D789b190b2dAC504e4361b53"
		],
		chainId: 1,
		value: "0x1C6a9783F812b3Af3aBbf7de64c3cD7CC7D1af44",
		underlyingToken: "0x94e131324b6054c0D789b190b2dAC504e4361b53"
	},
	{
		address: "0x150F76e1339A918BaA38338ED9bd695Bd0924Bcf",
		name: "Curve alETH-frxETH Factory yVault",
		symbol: "yvCurve-alETH-frxETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xB657B895B265C38c53FFF00166cF7F6A3C70587d"
		],
		chainId: 1,
		value: "0x150F76e1339A918BaA38338ED9bd695Bd0924Bcf",
		underlyingToken: "0xB657B895B265C38c53FFF00166cF7F6A3C70587d"
	},
	{
		address: "0xC2ADaD1Bd59a1DA3D35bd86cDb555694372f488F",
		name: "Curve MIM-crvUSD Factory yVault",
		symbol: "yvCurve-MIM-crvUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xBe426b0f37c112dd20d5866769c8034171567b31"
		],
		chainId: 1,
		value: "0xC2ADaD1Bd59a1DA3D35bd86cDb555694372f488F",
		underlyingToken: "0xBe426b0f37c112dd20d5866769c8034171567b31"
	},
	{
		address: "0x3e720ba935Bf137d45a3c98938DB1f4C8517298E",
		name: "Curve VEUR-agEUR Factory yVault",
		symbol: "yvCurve-VEUR-agEUR-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xF05CFb8b4382c69f3B451C5FB55210B232E0edFA"
		],
		chainId: 1,
		value: "0x3e720ba935Bf137d45a3c98938DB1f4C8517298E",
		underlyingToken: "0xF05CFb8b4382c69f3B451C5FB55210B232E0edFA"
	},
	{
		address: "0x5fA5B62c8AF877CB37031e0a3B2f34A78e3C56A6",
		name: "Curve LUSD Pool yVault",
		symbol: "yvCurve-LUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA"
		],
		chainId: 1,
		value: "0x5fA5B62c8AF877CB37031e0a3B2f34A78e3C56A6",
		underlyingToken: "0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA"
	},
	{
		address: "0x3D980E50508CFd41a13837A60149927a11c03731",
		name: "Curve triCrypto Pool yVault",
		symbol: "yvCurve-triCrypto",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xcA3d75aC011BF5aD07a98d02f18225F9bD9A6BDF"
		],
		chainId: 1,
		value: "0x3D980E50508CFd41a13837A60149927a11c03731",
		underlyingToken: "0xcA3d75aC011BF5aD07a98d02f18225F9bD9A6BDF"
	},
	{
		address: "0x6AEfd381C0AEF49bAafF58eBc70534B3941c61Bf",
		name: "Curve YFI-ETH Pool yVault",
		symbol: "yvCurve-YFIETH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x29059568bB40344487d62f7450E78b8E6C74e0e5"
		],
		chainId: 1,
		value: "0x6AEfd381C0AEF49bAafF58eBc70534B3941c61Bf",
		underlyingToken: "0x29059568bB40344487d62f7450E78b8E6C74e0e5"
	},
	{
		address: "0x49b3E44e54b6220aF892DbA48ae45F1Ea6bC4aE9",
		name: "TUSD yVault",
		symbol: "yvTUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x0000000000085d4780B73119b644AE5ecd22b376"
		],
		chainId: 1,
		value: "0x49b3E44e54b6220aF892DbA48ae45F1Ea6bC4aE9",
		underlyingToken: "0x0000000000085d4780B73119b644AE5ecd22b376"
	},
	{
		address: "0x77e829FFF18C14AD9bb88963acB0010A0506de88",
		name: "Curve StaFi rETH Factory yVault",
		symbol: "yvCurve-StaFi-rETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x53a901d48795C58f485cBB38df08FA96a24669D5"
		],
		chainId: 1,
		value: "0x77e829FFF18C14AD9bb88963acB0010A0506de88",
		underlyingToken: "0x53a901d48795C58f485cBB38df08FA96a24669D5"
	},
	{
		address: "0xc97232527B62eFb0D8ed38CF3EA103A6CcA4037e",
		name: "LP Yearn CRV Vault",
		symbol: "lp-yCRV",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x453D92C7d4263201C69aACfaf589Ed14202d83a4"
		],
		chainId: 1,
		value: "0xc97232527B62eFb0D8ed38CF3EA103A6CcA4037e",
		underlyingToken: "0x453D92C7d4263201C69aACfaf589Ed14202d83a4"
	},
	{
		address: "0xB5dE7250128775a317B3f775a7AFcEC73571B732",
		name: "Curve sETH Factory yVault",
		symbol: "yvCurve-sETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c"
		],
		chainId: 1,
		value: "0xB5dE7250128775a317B3f775a7AFcEC73571B732",
		underlyingToken: "0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c"
	},
	{
		address: "0x2D5D4869381C4Fce34789BC1D38aCCe747E295AE",
		name: "Curve RAI Pool yVault",
		symbol: "yvCurve-RAI",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x6BA5b4e438FA0aAf7C1bD179285aF65d13bD3D90"
		],
		chainId: 1,
		value: "0x2D5D4869381C4Fce34789BC1D38aCCe747E295AE",
		underlyingToken: "0x6BA5b4e438FA0aAf7C1bD179285aF65d13bD3D90"
	},
	{
		address: "0xdA816459F1AB5631232FE5e97a05BBBb94970c95",
		name: "DAI yVault",
		symbol: "yvDAI",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x6B175474E89094C44Da98b954EedeAC495271d0F"
		],
		chainId: 1,
		value: "0xdA816459F1AB5631232FE5e97a05BBBb94970c95",
		underlyingToken: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x6B175474E89094C44Da98b954EedeAC495271d0F/logo.png"
	},
	{
		address: "0xF29AE508698bDeF169B89834F76704C3B205aedf",
		name: "SNX yVault",
		symbol: "yvSNX",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F"
		],
		chainId: 1,
		value: "0xF29AE508698bDeF169B89834F76704C3B205aedf",
		underlyingToken: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F/logo.png"
	},
	{
		address: "0xcE0F1Ef5aAAB82547acc699d3Ab93c069bb6e547",
		name: "sUSD-hedging yVault",
		symbol: "yvsUSD-h",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x57Ab1ec28D129707052df4dF418D58a2D46d5f51"
		],
		chainId: 1,
		value: "0xcE0F1Ef5aAAB82547acc699d3Ab93c069bb6e547",
		underlyingToken: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"
	},
	{
		address: "0xe9Dc63083c464d6EDcCFf23444fF3CFc6886f6FB",
		name: "Curve oBTC Pool yVault",
		symbol: "yvCurve-oBTC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x2fE94ea3d5d4a175184081439753DE15AeF9d614"
		],
		chainId: 1,
		value: "0xe9Dc63083c464d6EDcCFf23444fF3CFc6886f6FB",
		underlyingToken: "0x2fE94ea3d5d4a175184081439753DE15AeF9d614"
	},
	{
		address: "0xc97511a1dDB162C8742D39FF320CfDCd13fBcf7e",
		name: "Curve Paxos Pool yVault",
		symbol: "yvCurve-USDP",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xc270b3B858c335B6BA5D5b10e2Da8a09976005ad"
		],
		chainId: 1,
		value: "0xc97511a1dDB162C8742D39FF320CfDCd13fBcf7e",
		underlyingToken: "0xc270b3B858c335B6BA5D5b10e2Da8a09976005ad"
	},
	{
		address: "0xF614d3864EF53510909a94c618a5EC1Ff75103BF",
		name: "Curve cbETH Factory yVault",
		symbol: "yvCurve-cbETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x5b6C539b224014A09B3388e51CaAA8e354c959C8"
		],
		chainId: 1,
		value: "0xF614d3864EF53510909a94c618a5EC1Ff75103BF",
		underlyingToken: "0x5b6C539b224014A09B3388e51CaAA8e354c959C8"
	},
	{
		address: "0xb37094c1B5614Bd6EcE40AFb295C26F4377069d3",
		name: "Curve FRAX Factory yVault",
		symbol: "yvCurve-FRAX-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xd632f22692FaC7611d2AA1C0D552930D43CAEd3B"
		],
		chainId: 1,
		value: "0xb37094c1B5614Bd6EcE40AFb295C26F4377069d3",
		underlyingToken: "0xd632f22692FaC7611d2AA1C0D552930D43CAEd3B"
	},
	{
		address: "0xF5f33812c93C5f2Ae2F28c041eEb393212439502",
		name: "Curve GUSD-crvUSD Factory yVault",
		symbol: "yvCurve-GUSD-crvUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xeCDd0cE505da71cd9dE855CD6804BA1e8C7bdB07"
		],
		chainId: 1,
		value: "0xF5f33812c93C5f2Ae2F28c041eEb393212439502",
		underlyingToken: "0xeCDd0cE505da71cd9dE855CD6804BA1e8C7bdB07"
	},
	{
		address: "0x801Ab06154Bf539dea4385a39f5fa8534fB53073",
		name: "Curve EURS-USDC Pool yVault",
		symbol: "yvCurve-EURSUSDC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x3D229E1B4faab62F621eF2F6A610961f7BD7b23B"
		],
		chainId: 1,
		value: "0x801Ab06154Bf539dea4385a39f5fa8534fB53073",
		underlyingToken: "0x3D229E1B4faab62F621eF2F6A610961f7BD7b23B"
	},
	{
		address: "0xe8b96C38a0b370eAfb11D9b8Df4131415423577a",
		name: "Curve STBT Factory yVault",
		symbol: "yvCurve-STBT-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x892D701d94a43bDBCB5eA28891DaCA2Fa22A690b"
		],
		chainId: 1,
		value: "0xe8b96C38a0b370eAfb11D9b8Df4131415423577a",
		underlyingToken: "0x892D701d94a43bDBCB5eA28891DaCA2Fa22A690b"
	},
	{
		address: "0x00e8Eb340f8AF587EEA6200D2081E31dC87285ac",
		name: "Curve XAI-FRAXBP Factory yVault",
		symbol: "yvCurve-XAI-FRAXBP-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x326290A1B0004eeE78fa6ED4F1d8f4b2523ab669"
		],
		chainId: 1,
		value: "0x00e8Eb340f8AF587EEA6200D2081E31dC87285ac",
		underlyingToken: "0x326290A1B0004eeE78fa6ED4F1d8f4b2523ab669"
	},
	{
		address: "0x6A5468752f8DB94134B6508dAbAC54D3b45efCE6",
		name: "Curve CRV-ETH Pool yVault",
		symbol: "yvCurve-CRVETH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xEd4064f376cB8d68F770FB1Ff088a3d0F3FF5c4d"
		],
		chainId: 1,
		value: "0x6A5468752f8DB94134B6508dAbAC54D3b45efCE6",
		underlyingToken: "0xEd4064f376cB8d68F770FB1Ff088a3d0F3FF5c4d"
	},
	{
		address: "0x3c5DF3077BcF800640B5DAE8c91106575a4826E6",
		name: "Curve pBTC Pool yVault",
		symbol: "yvCurve-pBTC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xDE5331AC4B3630f94853Ff322B66407e0D6331E8"
		],
		chainId: 1,
		value: "0x3c5DF3077BcF800640B5DAE8c91106575a4826E6",
		underlyingToken: "0xDE5331AC4B3630f94853Ff322B66407e0D6331E8"
	},
	{
		address: "0xe80Cc7b2b69f32999766c1a0035ab77E8fb5B99C",
		name: "Curve cvxFXS Factory yVault",
		symbol: "yvCurve-cvxFXS-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xF3A43307DcAFa93275993862Aae628fCB50dC768"
		],
		chainId: 1,
		value: "0xe80Cc7b2b69f32999766c1a0035ab77E8fb5B99C",
		underlyingToken: "0xF3A43307DcAFa93275993862Aae628fCB50dC768"
	},
	{
		address: "0x1b905331F7dE2748F4D6a0678e1521E20347643F",
		name: "Curve ibAUD Pool yVault",
		symbol: "yvCurve-ibAUD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x3F1B0278A9ee595635B61817630cC19DE792f506"
		],
		chainId: 1,
		value: "0x1b905331F7dE2748F4D6a0678e1521E20347643F",
		underlyingToken: "0x3F1B0278A9ee595635B61817630cC19DE792f506"
	},
	{
		address: "0x98fA691998a9e6f410702dEA8BC08a9d500AaAFe",
		name: "Curve STG-FRAXBP Factory yVault",
		symbol: "yvCurve-STG-FRAXBP-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x9de1c3D446237ab9BaFF74127eb4F303802a2683"
		],
		chainId: 1,
		value: "0x98fA691998a9e6f410702dEA8BC08a9d500AaAFe",
		underlyingToken: "0x9de1c3D446237ab9BaFF74127eb4F303802a2683"
	},
	{
		address: "0xa258C4606Ca8206D8aA700cE2143D7db854D168c",
		name: "WETH yVault",
		symbol: "yvWETH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"
		],
		chainId: 1,
		value: "0xa258C4606Ca8206D8aA700cE2143D7db854D168c",
		underlyingToken: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
	},
	{
		address: "0x8a0889d47f9Aa0Fac1cC718ba34E26b867437880",
		name: "Staked Yearn CRV Vault",
		symbol: "st-yCRV",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x4c1317326fD8EFDeBdBE5e1cd052010D97723bd6"
		],
		chainId: 1,
		value: "0x8a0889d47f9Aa0Fac1cC718ba34E26b867437880",
		underlyingToken: "0x4c1317326fD8EFDeBdBE5e1cd052010D97723bd6"
	},
	{
		address: "0xE22Ef63F2bD31eb69bF5917589a5daE3445c27b2",
		name: "Balancer Boosted Aave USD Pool yVault",
		symbol: "yvBB-A-USD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x7B50775383d3D6f0215A8F290f2C9e2eEBBEceb2"
		],
		chainId: 1,
		value: "0xE22Ef63F2bD31eb69bF5917589a5daE3445c27b2",
		underlyingToken: "0x7B50775383d3D6f0215A8F290f2C9e2eEBBEceb2"
	},
	{
		address: "0x054AF22E1519b020516D72D749221c24756385C9",
		name: "Curve HUSD Pool yVault",
		symbol: "yvCurve-HUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x5B5CFE992AdAC0C9D48E05854B2d91C73a003858"
		],
		chainId: 1,
		value: "0x054AF22E1519b020516D72D749221c24756385C9",
		underlyingToken: "0x5B5CFE992AdAC0C9D48E05854B2d91C73a003858"
	},
	{
		address: "0x2Ab6578239eD541Ef7cC7D11a45D740cE9F0a1F4",
		name: "Curve CTR-ETH Factory yVault",
		symbol: "yvCurve-CTR-ETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x3f0e7916681452D23Cd36B1281457DA721F2E5dF"
		],
		chainId: 1,
		value: "0x2Ab6578239eD541Ef7cC7D11a45D740cE9F0a1F4",
		underlyingToken: "0x3f0e7916681452D23Cd36B1281457DA721F2E5dF"
	},
	{
		address: "0x2147935D9739da4E691b8Ae2e1437492A394eBf5",
		name: "WETH ubiVault",
		symbol: "ubiWETH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"
		],
		chainId: 1,
		value: "0x2147935D9739da4E691b8Ae2e1437492A394eBf5",
		underlyingToken: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png"
	},
	{
		address: "0x132d8D2C76Db3812403431fAcB00F3453Fc42125",
		name: "Curve ankrETH Pool yVault",
		symbol: "yvCurve-ankrETH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xaA17A236F2bAdc98DDc0Cf999AbB47D47Fc0A6Cf"
		],
		chainId: 1,
		value: "0x132d8D2C76Db3812403431fAcB00F3453Fc42125",
		underlyingToken: "0xaA17A236F2bAdc98DDc0Cf999AbB47D47Fc0A6Cf"
	},
	{
		address: "0x01B01C4A1F4C522aD341A9da5eaA48aF207ab3Ec",
		name: "Curve pUSD-FRAXBP Factory yVault",
		symbol: "yvCurve-pUSD-FRAXBP-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xE60986759872393a8360A4a7abEAb3A6e0BA7848"
		],
		chainId: 1,
		value: "0x01B01C4A1F4C522aD341A9da5eaA48aF207ab3Ec",
		underlyingToken: "0xE60986759872393a8360A4a7abEAb3A6e0BA7848"
	},
	{
		address: "0x445F62Ee351E57cACBF3161F66562Ff2B1261db4",
		name: "Curve TUSD-crvUSD Factory yVault",
		symbol: "yvCurve-TUSD-crvUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x34D655069F4cAc1547E4C8cA284FfFF5ad4A8db0"
		],
		chainId: 1,
		value: "0x445F62Ee351E57cACBF3161F66562Ff2B1261db4",
		underlyingToken: "0x34D655069F4cAc1547E4C8cA284FfFF5ad4A8db0"
	},
	{
		address: "0x04d73c87b20d372cB3240C72eEFB9d79bA5e4959",
		name: "Curve UST Wormhole Pool yVault",
		symbol: "yvCurve-UST",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xCEAF7747579696A2F0bb206a14210e3c9e6fB269"
		],
		chainId: 1,
		value: "0x04d73c87b20d372cB3240C72eEFB9d79bA5e4959",
		underlyingToken: "0xCEAF7747579696A2F0bb206a14210e3c9e6fB269"
	},
	{
		address: "0x9894acf19de6F00D4056DbFDDF2dd7444F993D87",
		name: "Balancer wstETH-rETH-sfrxETH Factory yVault",
		symbol: "yvBal-wstETH-rETH-sfrxETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x5aEe1e99fE86960377DE9f88689616916D5DcaBe"
		],
		chainId: 1,
		value: "0x9894acf19de6F00D4056DbFDDF2dd7444F993D87",
		underlyingToken: "0x5aEe1e99fE86960377DE9f88689616916D5DcaBe"
	},
	{
		address: "0x58900d761Ae3765B75DDFc235c1536B527F25d8F",
		name: "Curve yETH Factory yVault",
		symbol: "yvCurve-yETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x69ACcb968B19a53790f43e57558F5E443A91aF22"
		],
		chainId: 1,
		value: "0x58900d761Ae3765B75DDFc235c1536B527F25d8F",
		underlyingToken: "0x69ACcb968B19a53790f43e57558F5E443A91aF22"
	},
	{
		address: "0x9F8B5c0fc18B79DdFc05b21c43da7E324Cf3B8Eb",
		name: "Curve ibEUR-USDC Factory yVault",
		symbol: "yvCurve-ibEUR-USDC-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x8682Fbf0CbF312C891532BA9F1A91e44f81ad7DF"
		],
		chainId: 1,
		value: "0x9F8B5c0fc18B79DdFc05b21c43da7E324Cf3B8Eb",
		underlyingToken: "0x8682Fbf0CbF312C891532BA9F1A91e44f81ad7DF"
	},
	{
		address: "0x341bb10D8f5947f3066502DC8125d9b8949FD3D6",
		name: "Curve STG-USDC Pool yVault",
		symbol: "yvCurve-STG-USDC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xdf55670e27bE5cDE7228dD0A6849181891c9ebA1"
		],
		chainId: 1,
		value: "0x341bb10D8f5947f3066502DC8125d9b8949FD3D6",
		underlyingToken: "0xdf55670e27bE5cDE7228dD0A6849181891c9ebA1"
	},
	{
		address: "0x73a052500105205d34Daf004eAb301916DA8190f",
		name: "iearn TUSD",
		symbol: "yTUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x0000000000085d4780B73119b644AE5ecd22b376"
		],
		chainId: 1,
		value: "0x73a052500105205d34Daf004eAb301916DA8190f",
		underlyingToken: "0x0000000000085d4780B73119b644AE5ecd22b376"
	},
	{
		address: "0x5b2384D566D2E4a0b29B8eccB642C63199cd393c",
		name: "Curve sUSD Factory yVault",
		symbol: "yvCurve-sUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xC25a3A3b969415c80451098fa907EC722572917F"
		],
		chainId: 1,
		value: "0x5b2384D566D2E4a0b29B8eccB642C63199cd393c",
		underlyingToken: "0xC25a3A3b969415c80451098fa907EC722572917F"
	},
	{
		address: "0x3a51269E0707A3416044bad5066858A12198fCf5",
		name: "Curve CLEV-ETH Factory yVault",
		symbol: "yvCurve-CLEV-ETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x6C280dB098dB673d30d5B34eC04B6387185D3620"
		],
		chainId: 1,
		value: "0x3a51269E0707A3416044bad5066858A12198fCf5",
		underlyingToken: "0x6C280dB098dB673d30d5B34eC04B6387185D3620"
	},
	{
		address: "0xd6627F7dE81eB517A32F0F81537Ea2636B27B8CC",
		name: "Curve wBETH Factory yVault",
		symbol: "yvCurve-wBETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xBfAb6FA95E0091ed66058ad493189D2cB29385E6"
		],
		chainId: 1,
		value: "0xd6627F7dE81eB517A32F0F81537Ea2636B27B8CC",
		underlyingToken: "0xBfAb6FA95E0091ed66058ad493189D2cB29385E6"
	},
	{
		address: "0x490bD0886F221A5F79713D3E84404355A9293C50",
		name: "Curve ibCHF Pool yVault",
		symbol: "yvCurve-ibCHF",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x9c2C8910F113181783c249d8F6Aa41b51Cde0f0c"
		],
		chainId: 1,
		value: "0x490bD0886F221A5F79713D3E84404355A9293C50",
		underlyingToken: "0x9c2C8910F113181783c249d8F6Aa41b51Cde0f0c"
	},
	{
		address: "0xd02b103f7f5dba89Ad316E2b3Fe247F280CcE5b2",
		name: "Curve xETHETH-f Factory yVault",
		symbol: "yvCurve-xETHETH-f-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x16eAd9a10b1A77007E6E329B076aD1Fe97a6F7C0"
		],
		chainId: 1,
		value: "0xd02b103f7f5dba89Ad316E2b3Fe247F280CcE5b2",
		underlyingToken: "0x16eAd9a10b1A77007E6E329B076aD1Fe97a6F7C0"
	},
	{
		address: "0x7cA00559B978CFde81297849be6151d3ccB408A9",
		name: "Curve USDC-crvUSD Factory yVault",
		symbol: "yvCurve-USDC-crvUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x4DEcE678ceceb27446b35C672dC7d61F30bAD69E"
		],
		chainId: 1,
		value: "0x7cA00559B978CFde81297849be6151d3ccB408A9",
		underlyingToken: "0x4DEcE678ceceb27446b35C672dC7d61F30bAD69E"
	},
	{
		address: "0xE2CaD35CFD1A9B5acD557558f44B096ef8340C1B",
		name: "Curve TriCryptoLLAMA Factory yVault",
		symbol: "yvCurve-TriCryptoLLAMA-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x2889302a794dA87fBF1D6Db415C1492194663D13"
		],
		chainId: 1,
		value: "0xE2CaD35CFD1A9B5acD557558f44B096ef8340C1B",
		underlyingToken: "0x2889302a794dA87fBF1D6Db415C1492194663D13"
	},
	{
		address: "0xFD0877d9095789cAF24c98F7CCe092fa8E120775",
		name: "TUSD yVault",
		symbol: "yvTUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x0000000000085d4780B73119b644AE5ecd22b376"
		],
		chainId: 1,
		value: "0xFD0877d9095789cAF24c98F7CCe092fa8E120775",
		underlyingToken: "0x0000000000085d4780B73119b644AE5ecd22b376"
	},
	{
		address: "0xE5eDcE53e39Cbc6d819E2C340BCF295e0084ff7c",
		name: "Curve ibEUR-USDC Pool yVault",
		symbol: "yvCurve-ibEUR-USDC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x8682Fbf0CbF312C891532BA9F1A91e44f81ad7DF"
		],
		chainId: 1,
		value: "0xE5eDcE53e39Cbc6d819E2C340BCF295e0084ff7c",
		underlyingToken: "0x8682Fbf0CbF312C891532BA9F1A91e44f81ad7DF"
	},
	{
		address: "0x571B384636BA518697d745AC218aD4cEE5EE0ABC",
		name: "Curve sBTCv2 Factory yVault",
		symbol: "yvCurve-sBTCv2-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x051d7e5609917Bd9b73f04BAc0DED8Dd46a74301"
		],
		chainId: 1,
		value: "0x571B384636BA518697d745AC218aD4cEE5EE0ABC",
		underlyingToken: "0x051d7e5609917Bd9b73f04BAc0DED8Dd46a74301"
	},
	{
		address: "0x6B5ce31AF687a671a804d8070Ddda99Cab926dfE",
		name: "Curve ibGBP-USDC Pool yVault",
		symbol: "yvCurve-ibGBP-USDC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x22CF19EB64226e0E1A79c69b345b31466fD273A7"
		],
		chainId: 1,
		value: "0x6B5ce31AF687a671a804d8070Ddda99Cab926dfE",
		underlyingToken: "0x22CF19EB64226e0E1A79c69b345b31466fD273A7"
	},
	{
		address: "0x708c42E0236fe8f5916C5638a462Ee83DA99d07b",
		name: "Curve LDO-ETH Factory yVault",
		symbol: "yvCurve-LDO-ETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xb79565c01b7Ae53618d9B847b9443aAf4f9011e7"
		],
		chainId: 1,
		value: "0x708c42E0236fe8f5916C5638a462Ee83DA99d07b",
		underlyingToken: "0xb79565c01b7Ae53618d9B847b9443aAf4f9011e7"
	},
	{
		address: "0xF6B9DFE6bc42ed2eaB44D6B829017f7B78B29f88",
		name: "Curve ibKRW-USDC Pool yVault",
		symbol: "yvCurve-ibKRW-USDC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x80CAcCdBD3f07BbdB558DB4a9e146D099933D677"
		],
		chainId: 1,
		value: "0xF6B9DFE6bc42ed2eaB44D6B829017f7B78B29f88",
		underlyingToken: "0x80CAcCdBD3f07BbdB558DB4a9e146D099933D677"
	},
	{
		address: "0x5CBF567cb0C3D319A052C91eFB3B3318899338DF",
		name: "Curve pETH Factory yVault",
		symbol: "yvCurve-pETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x9848482da3Ee3076165ce6497eDA906E66bB85C5"
		],
		chainId: 1,
		value: "0x5CBF567cb0C3D319A052C91eFB3B3318899338DF",
		underlyingToken: "0x9848482da3Ee3076165ce6497eDA906E66bB85C5"
	},
	{
		address: "0x27b7b1ad7288079A66d12350c828D3C00A6F07d7",
		name: "Curve Iron Bank Pool yVault",
		symbol: "yvCurve-IronBank",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x5282a4eF67D9C33135340fB3289cc1711c13638C"
		],
		chainId: 1,
		value: "0x27b7b1ad7288079A66d12350c828D3C00A6F07d7",
		underlyingToken: "0x5282a4eF67D9C33135340fB3289cc1711c13638C"
	},
	{
		address: "0xa8eF50905352aCD611F53640b001E48F2eA31d63",
		name: "Curve cvxCRVv2 Factory yVault",
		symbol: "yvCurve-cvxCRVv2-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x971add32Ea87f10bD192671630be3BE8A11b8623"
		],
		chainId: 1,
		value: "0xa8eF50905352aCD611F53640b001E48F2eA31d63",
		underlyingToken: "0x971add32Ea87f10bD192671630be3BE8A11b8623"
	},
	{
		address: "0xB364D19c3FF37e0fa4B94bf4cf626729533C1c26",
		name: "FRAX yVault",
		symbol: "yvFRAX",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x853d955aCEf822Db058eb8505911ED77F175b99e"
		],
		chainId: 1,
		value: "0xB364D19c3FF37e0fa4B94bf4cf626729533C1c26",
		underlyingToken: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
		logoURI: "https://assets.coingecko.com/coins/images/13422/thumb/frax_logo.png?1608476506"
	},
	{
		address: "0xA9412Ffd7E0866755ae0dda3318470A61F62abe8",
		name: "Balancer FUD Auto-Compounding yVault",
		symbol: "yvBlpFUD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x178E029173417b1F9C8bC16DCeC6f697bC323746"
		],
		chainId: 1,
		value: "0xA9412Ffd7E0866755ae0dda3318470A61F62abe8",
		underlyingToken: "0x178E029173417b1F9C8bC16DCeC6f697bC323746"
	},
	{
		address: "0x9A39f31DD5EDF5919A5C0c2433cE053fAD2E0336",
		name: "Curve ibJPY-USDC Pool yVault",
		symbol: "yvCurve-ibJPY-USDC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x127091edE112aEd7Bae281747771b3150Bb047bB"
		],
		chainId: 1,
		value: "0x9A39f31DD5EDF5919A5C0c2433cE053fAD2E0336",
		underlyingToken: "0x127091edE112aEd7Bae281747771b3150Bb047bB"
	},
	{
		address: "0x5383C1Ab5beac04d6A6E6872Cc6a422f2Dc25576",
		name: "Curve USDC+ Factory yVault",
		symbol: "yvCurve-USDC+-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xfed2B54453F75634bcdaEA5e5b11a3f99b9C28Fa"
		],
		chainId: 1,
		value: "0x5383C1Ab5beac04d6A6E6872Cc6a422f2Dc25576",
		underlyingToken: "0xfed2B54453F75634bcdaEA5e5b11a3f99b9C28Fa"
	},
	{
		address: "0x0DAa35A1735152EDb928239c1712883Dd8Eb976f",
		name: "Yearn LQTY",
		symbol: "yLQTY",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D"
		],
		chainId: 1,
		value: "0x0DAa35A1735152EDb928239c1712883Dd8Eb976f",
		underlyingToken: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
		logoURI: "https://assets.coingecko.com/coins/images/14665/thumb/200-lqty-icon.png?1617631180"
	},
	{
		address: "0x0e8A7717A4FD7694682E7005957dD5d7598bF14A",
		name: "yExperimentalWBTC",
		symbol: "yExptWBTC",
		decimals: 8,
		isVault: true,
		underlyingTokens: [
			"0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
		],
		chainId: 1,
		value: "0x0e8A7717A4FD7694682E7005957dD5d7598bF14A",
		underlyingToken: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png"
	},
	{
		address: "0x79F4a9ed7a6196c67a2D6BCE8eC55E9F18802018",
		name: "Curve oETH Factory yVault",
		symbol: "yvCurve-oETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x94B17476A93b3262d87B9a326965D1E91f9c13E7"
		],
		chainId: 1,
		value: "0x79F4a9ed7a6196c67a2D6BCE8eC55E9F18802018",
		underlyingToken: "0x94B17476A93b3262d87B9a326965D1E91f9c13E7"
	},
	{
		address: "0xD6Ea40597Be05c201845c0bFd2e96A60bACde267",
		name: "Curve Compound Pool yVault",
		symbol: "yvCurve-Compound",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x845838DF265Dcd2c412A1Dc9e959c7d08537f8a2"
		],
		chainId: 1,
		value: "0xD6Ea40597Be05c201845c0bFd2e96A60bACde267",
		underlyingToken: "0x845838DF265Dcd2c412A1Dc9e959c7d08537f8a2"
	},
	{
		address: "0xd395DEC4F1733ff09b750D869eEfa7E0D37C3eE6",
		name: "Curve DOLA-FRAXBP Pool yVault - Unlisted",
		symbol: "yvCurve-DOLA-FRAXBP-U",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xE57180685E3348589E9521aa53Af0BCD497E884d"
		],
		chainId: 1,
		value: "0xd395DEC4F1733ff09b750D869eEfa7E0D37C3eE6",
		underlyingToken: "0xE57180685E3348589E9521aa53Af0BCD497E884d"
	},
	{
		address: "0xb09F2a67a731466182518fae980feAe96479d80b",
		name: "KP3RETH-f yVault",
		symbol: "yvKP3RETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x4647B6D835f3B393C7A955df51EEfcf0db961606"
		],
		chainId: 1,
		value: "0xb09F2a67a731466182518fae980feAe96479d80b",
		underlyingToken: "0x4647B6D835f3B393C7A955df51EEfcf0db961606"
	},
	{
		address: "0x03eaE26089A8c28DDC4c81d65bEfE014C793A60d",
		name: "Curve stETH-frxETH Factory yVault",
		symbol: "yvCurve-stETH-frxETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x4d9f9D15101EEC665F77210cB999639f760F831E"
		],
		chainId: 1,
		value: "0x03eaE26089A8c28DDC4c81d65bEfE014C793A60d",
		underlyingToken: "0x4d9f9D15101EEC665F77210cB999639f760F831E"
	},
	{
		address: "0x8fA3A9ecd9EFb07A8CE90A6eb014CF3c0E3B32Ef",
		name: "Curve BBTC Pool yVault",
		symbol: "yvCurve-BBTC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x410e3E86ef427e30B9235497143881f717d93c2A"
		],
		chainId: 1,
		value: "0x8fA3A9ecd9EFb07A8CE90A6eb014CF3c0E3B32Ef",
		underlyingToken: "0x410e3E86ef427e30B9235497143881f717d93c2A"
	},
	{
		address: "0xcE71767158421482C39E72f209A7A8ef3A0c669d",
		name: "Balancer rETH Factory yVault",
		symbol: "yvBal-rETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x1E19CF2D73a72Ef1332C882F20534B6519Be0276"
		],
		chainId: 1,
		value: "0xcE71767158421482C39E72f209A7A8ef3A0c669d",
		underlyingToken: "0x1E19CF2D73a72Ef1332C882F20534B6519Be0276"
	},
	{
		address: "0x8176b059BD8f63aeB7e20282b12D243b4626E2AE",
		name: "Curve FRAX-crvUSD Factory yVault",
		symbol: "yvCurve-FRAX-crvUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x0CD6f267b2086bea681E922E19D40512511BE538"
		],
		chainId: 1,
		value: "0x8176b059BD8f63aeB7e20282b12D243b4626E2AE",
		underlyingToken: "0x0CD6f267b2086bea681E922E19D40512511BE538"
	},
	{
		address: "0xB512D68A3194ba294A5b8146FA9beCd6a5Fea137",
		name: "Curve sUSD-crvUSD Factory yVault",
		symbol: "yvCurve-sUSD-crvUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x94cC50e4521bD271C1a997a3A4Dc815C2F920b41"
		],
		chainId: 1,
		value: "0xB512D68A3194ba294A5b8146FA9beCd6a5Fea137",
		underlyingToken: "0x94cC50e4521bD271C1a997a3A4Dc815C2F920b41"
	},
	{
		address: "0xCA31DcB9D30e70BF709B41e3935c3f7cdBC6D255",
		name: "Curve EURT-USD Factory yVault",
		symbol: "yvCurve-EURT-USD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x3b6831c0077a1e44ED0a21841C3bC4dC11bCE833"
		],
		chainId: 1,
		value: "0xCA31DcB9D30e70BF709B41e3935c3f7cdBC6D255",
		underlyingToken: "0x3b6831c0077a1e44ED0a21841C3bC4dC11bCE833"
	},
	{
		address: "0x75A291F0232ADD37d72Dd1Dcff55B715755ECDEe",
		name: "Curve CVX-ETH Factory yVault",
		symbol: "yvCurve-CVX-ETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x3A283D9c08E8b55966afb64C515f5143cf907611"
		],
		chainId: 1,
		value: "0x75A291F0232ADD37d72Dd1Dcff55B715755ECDEe",
		underlyingToken: "0x3A283D9c08E8b55966afb64C515f5143cf907611"
	},
	{
		address: "0x883A777f2594004419fc08b388D7d3bdC1c0D6c1",
		name: "Balancer bb-a-USD Factory yVault",
		symbol: "yvBal-bb-a-USD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xfeBb0bbf162E64fb9D0dfe186E517d84C395f016"
		],
		chainId: 1,
		value: "0x883A777f2594004419fc08b388D7d3bdC1c0D6c1",
		underlyingToken: "0xfeBb0bbf162E64fb9D0dfe186E517d84C395f016"
	},
	{
		address: "0x8Aa95B71D8e0e1C7949bd84223E0C7911D85171C",
		name: "Curve RSR-FRAXBP Factory yVault",
		symbol: "yvCurve-RSR-FRAXBP-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x3F436954afb722F5D14D868762a23faB6b0DAbF0"
		],
		chainId: 1,
		value: "0x8Aa95B71D8e0e1C7949bd84223E0C7911D85171C",
		underlyingToken: "0x3F436954afb722F5D14D868762a23faB6b0DAbF0"
	},
	{
		address: "0x0d4EA8536F9A13e4FBa16042a46c30f092b06aA5",
		name: "Curve EURT Pool yVault",
		symbol: "yvCurve-EURT",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xFD5dB7463a3aB53fD211b4af195c5BCCC1A03890"
		],
		chainId: 1,
		value: "0x0d4EA8536F9A13e4FBa16042a46c30f092b06aA5",
		underlyingToken: "0xFD5dB7463a3aB53fD211b4af195c5BCCC1A03890"
	},
	{
		address: "0x67B9F46BCbA2DF84ECd41cC6511ca33507c9f4E9",
		name: "Curve DOLA Pool yVault - Unlisted",
		symbol: "yvCurve-DOLA-U",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xAA5A67c256e27A5d80712c51971408db3370927D"
		],
		chainId: 1,
		value: "0x67B9F46BCbA2DF84ECd41cC6511ca33507c9f4E9",
		underlyingToken: "0xAA5A67c256e27A5d80712c51971408db3370927D"
	},
	{
		address: "0x8414Db07a7F743dEbaFb402070AB01a4E0d2E45e",
		name: "Curve sBTC Pool yVault",
		symbol: "yvCurve-sBTC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3"
		],
		chainId: 1,
		value: "0x8414Db07a7F743dEbaFb402070AB01a4E0d2E45e",
		underlyingToken: "0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3"
	},
	{
		address: "0xE14d13d8B3b85aF791b2AADD661cDBd5E6097Db1",
		name: "YFI yVault",
		symbol: "yvYFI",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e"
		],
		chainId: 1,
		value: "0xE14d13d8B3b85aF791b2AADD661cDBd5E6097Db1",
		underlyingToken: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
		logoURI: "https://assets.coingecko.com/coins/images/11849/thumb/yfi-192x192.png?1598325330"
	},
	{
		address: "0xa8E0c42F45C877e611C76F2D4bF57476f2014381",
		name: "Curve Iron Bank Factory yVault",
		symbol: "yvCurve-IronBank-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x5282a4eF67D9C33135340fB3289cc1711c13638C"
		],
		chainId: 1,
		value: "0xa8E0c42F45C877e611C76F2D4bF57476f2014381",
		underlyingToken: "0x5282a4eF67D9C33135340fB3289cc1711c13638C"
	},
	{
		address: "0x5737022626C282a89D105fD2e89ed6928EbDAe93",
		name: "eCRV yVault",
		symbol: "yveCRV",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c"
		],
		chainId: 1,
		value: "0x5737022626C282a89D105fD2e89ed6928EbDAe93",
		underlyingToken: "0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c"
	},
	{
		address: "0xC116dF49c02c5fD147DE25Baa105322ebF26Bd97",
		name: "Curve RSV Pool yVault",
		symbol: "yvCurve-RSV",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xC2Ee6b0334C261ED60C72f6054450b61B8f18E35"
		],
		chainId: 1,
		value: "0xC116dF49c02c5fD147DE25Baa105322ebF26Bd97",
		underlyingToken: "0xC2Ee6b0334C261ED60C72f6054450b61B8f18E35"
	},
	{
		address: "0x5AB64C599FcC59f0f2726A300b03166A395578Da",
		name: "Curve 3EUR Pool yVault",
		symbol: "yvCurve-3EUR",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xb9446c4Ef5EBE66268dA6700D26f96273DE3d571"
		],
		chainId: 1,
		value: "0x5AB64C599FcC59f0f2726A300b03166A395578Da",
		underlyingToken: "0xb9446c4Ef5EBE66268dA6700D26f96273DE3d571"
	},
	{
		address: "0x84E13785B5a27879921D6F685f041421C7F482dA",
		name: "Curve 3pool yVault",
		symbol: "yvCurve-3pool",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490"
		],
		chainId: 1,
		value: "0x84E13785B5a27879921D6F685f041421C7F482dA",
		underlyingToken: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490"
	},
	{
		address: "0x6c6371E15499FedCdadEE06ADc5b55680b3d0785",
		name: "Curve cbETH-frxETH Factory yVault",
		symbol: "yvCurve-cbETH-frxETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x548E063CE6F3BaC31457E4f5b4e2345286274257"
		],
		chainId: 1,
		value: "0x6c6371E15499FedCdadEE06ADc5b55680b3d0785",
		underlyingToken: "0x548E063CE6F3BaC31457E4f5b4e2345286274257"
	},
	{
		address: "0x5B707472eeF1553646740a7e5BEcFD41B9B4Ef4C",
		name: "COMP yVault",
		symbol: "yvCOMP",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xc00e94Cb662C3520282E6f5717214004A7f26888"
		],
		chainId: 1,
		value: "0x5B707472eeF1553646740a7e5BEcFD41B9B4Ef4C",
		underlyingToken: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xc00e94Cb662C3520282E6f5717214004A7f26888/logo.png"
	},
	{
		address: "0x1C97e67Dc7ca179aE82E0c4AFF4Af9ff66612A43",
		name: "Curve PAL-ETH Factory yVault",
		symbol: "yvCurve-PAL-ETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xbE4f3AD6C9458b901C81b734CB22D9eaE9Ad8b50"
		],
		chainId: 1,
		value: "0x1C97e67Dc7ca179aE82E0c4AFF4Af9ff66612A43",
		underlyingToken: "0xbE4f3AD6C9458b901C81b734CB22D9eaE9Ad8b50"
	},
	{
		address: "0x2e5c7e9B1Da0D9Cb2832eBb06241d18552A85400",
		name: "Curve ibCHF-USDC Pool yVault",
		symbol: "yvCurve-ibCHF-USDC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x08ceA8E5B4551722dEB97113C139Dd83C26c5398"
		],
		chainId: 1,
		value: "0x2e5c7e9B1Da0D9Cb2832eBb06241d18552A85400",
		underlyingToken: "0x08ceA8E5B4551722dEB97113C139Dd83C26c5398"
	},
	{
		address: "0x2807387F1212cB2852aB97cdAa3627dACa5E4661",
		name: "MIM yVault",
		symbol: "yvMIM",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x99D8a9C45b2ecA8864373A26D1459e3Dff1e17F3"
		],
		chainId: 1,
		value: "0x2807387F1212cB2852aB97cdAa3627dACa5E4661",
		underlyingToken: "0x99D8a9C45b2ecA8864373A26D1459e3Dff1e17F3",
		logoURI: "https://assets.coingecko.com/coins/images/16786/thumb/mimlogopng.png?1624979612"
	},
	{
		address: "0x23D3D0f1c697247d5e0a9efB37d8b0ED0C464f7f",
		name: "Curve tBTC Pool yVault",
		symbol: "yvCurve-tBTC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x64eda51d3Ad40D56b9dFc5554E06F94e1Dd786Fd"
		],
		chainId: 1,
		value: "0x23D3D0f1c697247d5e0a9efB37d8b0ED0C464f7f",
		underlyingToken: "0x64eda51d3Ad40D56b9dFc5554E06F94e1Dd786Fd"
	},
	{
		address: "0x0e880118C29F095143dDA28e64d95333A9e75A47",
		name: "eCRV yVault",
		symbol: "yveCRV",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c"
		],
		chainId: 1,
		value: "0x0e880118C29F095143dDA28e64d95333A9e75A47",
		underlyingToken: "0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c"
	},
	{
		address: "0xf4fDbc7C66Dc9832D672Ffe6242B6A386CeAd5DE",
		name: "sUSD yVault",
		symbol: "yvsUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x57Ab1ec28D129707052df4dF418D58a2D46d5f51"
		],
		chainId: 1,
		value: "0xf4fDbc7C66Dc9832D672Ffe6242B6A386CeAd5DE",
		underlyingToken: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		logoURI: "https://assets.coingecko.com/coins/images/5013/thumb/sUSD.png?1616150765"
	},
	{
		address: "0x2D59aa422A7AaE58038CF8aE6eD07330Cc7d3ae8",
		name: "Curve bLUSD Factory yVault",
		symbol: "yvCurve-bLUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x5ca0313D44551e32e0d7a298EC024321c4BC59B4"
		],
		chainId: 1,
		value: "0x2D59aa422A7AaE58038CF8aE6eD07330Cc7d3ae8",
		underlyingToken: "0x5ca0313D44551e32e0d7a298EC024321c4BC59B4"
	},
	{
		address: "0x3221BFBE308144f19089CB197b7C11c2Bf495906",
		name: "Curve BTRFLY-ETH Factory yVault",
		symbol: "yvCurve-BTRFLY-ETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x7483Dd57f6488b0e194A151C57Df6Ec85C00aCE9"
		],
		chainId: 1,
		value: "0x3221BFBE308144f19089CB197b7C11c2Bf495906",
		underlyingToken: "0x7483Dd57f6488b0e194A151C57Df6Ec85C00aCE9"
	},
	{
		address: "0x241AdD131B9aaa7527132b752252b99420937ADc",
		name: "Curve USDT-crvUSD Factory yVault",
		symbol: "yvCurve-USDT-crvUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x390f3595bCa2Df7d23783dFd126427CCeb997BF4"
		],
		chainId: 1,
		value: "0x241AdD131B9aaa7527132b752252b99420937ADc",
		underlyingToken: "0x390f3595bCa2Df7d23783dFd126427CCeb997BF4"
	},
	{
		address: "0x30B801F933e676Cb25892D1838FDCC00A1dde4cf",
		name: "Curve JPEG-pETH Factory yVault",
		symbol: "yvCurve-JPEG-pETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xDA68f66fC0f10Ee61048E70106Df4BDB26bAF595"
		],
		chainId: 1,
		value: "0x30B801F933e676Cb25892D1838FDCC00A1dde4cf",
		underlyingToken: "0xDA68f66fC0f10Ee61048E70106Df4BDB26bAF595"
	},
	{
		address: "0x528D50dC9a333f01544177a924893FA1F5b9F748",
		name: "Curve ibKRW Pool yVault",
		symbol: "yvCurve-ibKRW",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x8461A004b50d321CB22B7d034969cE6803911899"
		],
		chainId: 1,
		value: "0x528D50dC9a333f01544177a924893FA1F5b9F748",
		underlyingToken: "0x8461A004b50d321CB22B7d034969cE6803911899"
	},
	{
		address: "0xa669d6C2Df33F41940c2646A9BF3031e2524d515",
		name: "Curve sdCRVv2 Factory yVault",
		symbol: "yvCurve-sdCRVv2-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xCA0253A98D16e9C1e3614caFDA19318EE69772D0"
		],
		chainId: 1,
		value: "0xa669d6C2Df33F41940c2646A9BF3031e2524d515",
		underlyingToken: "0xCA0253A98D16e9C1e3614caFDA19318EE69772D0"
	},
	{
		address: "0xF56fB6cc29F0666BDD1662FEaAE2A3C935ee3469",
		name: "Curve USDP-crvUSD Factory yVault",
		symbol: "yvCurve-USDP-crvUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xCa978A0528116DDA3cbA9ACD3e68bc6191CA53D0"
		],
		chainId: 1,
		value: "0xF56fB6cc29F0666BDD1662FEaAE2A3C935ee3469",
		underlyingToken: "0xCa978A0528116DDA3cbA9ACD3e68bc6191CA53D0"
	},
	{
		address: "0xB4AdA607B9d6b2c9Ee07A275e9616B84AC560139",
		name: "Curve FRAX Pool yVault",
		symbol: "yvCurve-FRAX",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xd632f22692FaC7611d2AA1C0D552930D43CAEd3B"
		],
		chainId: 1,
		value: "0xB4AdA607B9d6b2c9Ee07A275e9616B84AC560139",
		underlyingToken: "0xd632f22692FaC7611d2AA1C0D552930D43CAEd3B"
	},
	{
		address: "0x1bE5d71F2dA660BFdee8012dDc58D024448A0A59",
		name: "Curve (iearn fork) USDT",
		symbol: "ycUSDT",
		decimals: 6,
		isVault: true,
		underlyingTokens: [
			"0xdAC17F958D2ee523a2206206994597C13D831ec7"
		],
		chainId: 1,
		value: "0x1bE5d71F2dA660BFdee8012dDc58D024448A0A59",
		underlyingToken: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
	},
	{
		address: "0x671a912C10bba0CFA74Cfc2d6Fba9BA1ed9530B2",
		name: "LINK yVault",
		symbol: "yvLINK",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x514910771AF9Ca656af840dff83E8264EcF986CA"
		],
		chainId: 1,
		value: "0x671a912C10bba0CFA74Cfc2d6Fba9BA1ed9530B2",
		underlyingToken: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x514910771AF9Ca656af840dff83E8264EcF986CA/logo.png"
	},
	{
		address: "0x82c83ddA32DB09F63F9A59A129278f3fdC3EeE67",
		name: "Curve 3EUR Factory yVault",
		symbol: "yvCurve-3EUR-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xb9446c4Ef5EBE66268dA6700D26f96273DE3d571"
		],
		chainId: 1,
		value: "0x82c83ddA32DB09F63F9A59A129278f3fdC3EeE67",
		underlyingToken: "0xb9446c4Ef5EBE66268dA6700D26f96273DE3d571"
	},
	{
		address: "0x8072B1d66389a1AA039e21Aac35A92464005baF5",
		name: "Curve rETH-frxETH Factory yVault",
		symbol: "yvCurve-rETH-frxETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xbA6c373992AD8ec1f7520E5878E5540Eb36DeBf1"
		],
		chainId: 1,
		value: "0x8072B1d66389a1AA039e21Aac35A92464005baF5",
		underlyingToken: "0xbA6c373992AD8ec1f7520E5878E5540Eb36DeBf1"
	},
	{
		address: "0xAD2f9A55518Dba12E8AB069502820923351667C5",
		name: "Curve msETH Factory yVault",
		symbol: "yvCurve-msETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xa4c567c662349BeC3D0fB94C4e7f85bA95E208e4"
		],
		chainId: 1,
		value: "0xAD2f9A55518Dba12E8AB069502820923351667C5",
		underlyingToken: "0xa4c567c662349BeC3D0fB94C4e7f85bA95E208e4"
	},
	{
		address: "0xcd68c3fC3e94C5AcC10366556b836855D96bfa93",
		name: "Curve dETH Factory yVault",
		symbol: "yvCurve-dETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x7C0d189E1FecB124487226dCbA3748bD758F98E4"
		],
		chainId: 1,
		value: "0xcd68c3fC3e94C5AcC10366556b836855D96bfa93",
		underlyingToken: "0x7C0d189E1FecB124487226dCbA3748bD758F98E4"
	},
	{
		address: "0x32413274504908460f0c373C7f20F429Fb80ed3A",
		name: "saCRV yVault",
		symbol: "yvsaCRV",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x02d341CcB60fAaf662bC0554d13778015d1b285C"
		],
		chainId: 1,
		value: "0x32413274504908460f0c373C7f20F429Fb80ed3A",
		underlyingToken: "0x02d341CcB60fAaf662bC0554d13778015d1b285C"
	},
	{
		address: "0x7e113c504263354ba99290dadAd00D1e1F2b6476",
		name: "Curve sdFXS Factory yVault",
		symbol: "yvCurve-sdFXS-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x8c524635d52bd7b1Bd55E062303177a7d916C046"
		],
		chainId: 1,
		value: "0x7e113c504263354ba99290dadAd00D1e1F2b6476",
		underlyingToken: "0x8c524635d52bd7b1Bd55E062303177a7d916C046"
	},
	{
		address: "0xD631734272c437e1730De3CD2193c060e8DfB39E",
		name: "crvSPELLETH yVault",
		symbol: "yvcrvSPELLETH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x8282BD15dcA2EA2bDf24163E8f2781B30C43A2ef"
		],
		chainId: 1,
		value: "0xD631734272c437e1730De3CD2193c060e8DfB39E",
		underlyingToken: "0x8282BD15dcA2EA2bDf24163E8f2781B30C43A2ef"
	},
	{
		address: "0x4856A7EFBbFcaE92AB13c5e2e322Fc77647bB856",
		name: "RAI yVault",
		symbol: "yvRAI",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919"
		],
		chainId: 1,
		value: "0x4856A7EFBbFcaE92AB13c5e2e322Fc77647bB856",
		underlyingToken: "0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919",
		logoURI: "https://assets.coingecko.com/coins/images/14004/thumb/RAI-logo-coin.png?1613592334"
	},
	{
		address: "0x16825039dfe2a5b01F3E1E6a2BBF9a576c6F95c4",
		name: "Curve d3pool Pool yVault",
		symbol: "yvCurve-d3pool",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xBaaa1F5DbA42C3389bDbc2c9D2dE134F5cD0Dc89"
		],
		chainId: 1,
		value: "0x16825039dfe2a5b01F3E1E6a2BBF9a576c6F95c4",
		underlyingToken: "0xBaaa1F5DbA42C3389bDbc2c9D2dE134F5cD0Dc89"
	},
	{
		address: "0x20F6A2ec303dF7120eAe3346dE5aD877f80Beb64",
		name: "Balancer auraBAL Factory yVault",
		symbol: "yvBal-auraBAL-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x3dd0843A028C86e0b760b1A76929d1C5Ef93a2dd"
		],
		chainId: 1,
		value: "0x20F6A2ec303dF7120eAe3346dE5aD877f80Beb64",
		underlyingToken: "0x3dd0843A028C86e0b760b1A76929d1C5Ef93a2dd"
	},
	{
		address: "0x7047F90229a057C13BF847C0744D646CFb6c9E1A",
		name: "Curve renBTC Pool yVault",
		symbol: "yvCurve-renBTC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x49849C98ae39Fff122806C06791Fa73784FB3675"
		],
		chainId: 1,
		value: "0x7047F90229a057C13BF847C0744D646CFb6c9E1A",
		underlyingToken: "0x49849C98ae39Fff122806C06791Fa73784FB3675"
	},
	{
		address: "0x6D2F347DCFc55C6AC80e515a58344acd7FeF0B84",
		name: "bCRV yVault",
		symbol: "yvbCRV",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x3B3Ac5386837Dc563660FB6a0937DFAa5924333B"
		],
		chainId: 1,
		value: "0x6D2F347DCFc55C6AC80e515a58344acd7FeF0B84",
		underlyingToken: "0x3B3Ac5386837Dc563660FB6a0937DFAa5924333B"
	},
	{
		address: "0xC8cA30Aa2E486846f7304D3B9334f96d32000F8d",
		name: "Curve apeUSD-FRAXBP Factory yVault",
		symbol: "yvCurve-apeUSD-FBP-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x04b727C7e246CA70d496ecF52E6b6280f3c8077D"
		],
		chainId: 1,
		value: "0xC8cA30Aa2E486846f7304D3B9334f96d32000F8d",
		underlyingToken: "0x04b727C7e246CA70d496ecF52E6b6280f3c8077D"
	},
	{
		address: "0x93cF0b02D0A2B61551d107378AFf60CEAe40c342",
		name: "Curve sdYFIv2 Factory yVault",
		symbol: "yvCurve-sdYFIv2-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x852b90239C5034b5bb7a5e54eF1bEF3Ce3359CC8"
		],
		chainId: 1,
		value: "0x93cF0b02D0A2B61551d107378AFf60CEAe40c342",
		underlyingToken: "0x852b90239C5034b5bb7a5e54eF1bEF3Ce3359CC8"
	},
	{
		address: "0x507c6dE33f50c0505F77F598c0B3CA7b5fEB3D68",
		name: "Curve alUSD-FRAXBP Factory yVault",
		symbol: "yvCurve-alUSD-FRAXBP-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xB30dA2376F63De30b42dC055C93fa474F31330A5"
		],
		chainId: 1,
		value: "0x507c6dE33f50c0505F77F598c0B3CA7b5fEB3D68",
		underlyingToken: "0xB30dA2376F63De30b42dC055C93fa474F31330A5"
	},
	{
		address: "0x7AB4a7BE740131BdE216521B54ADddD672F44A05",
		name: "Curve agEUR-EUROC Pool yVault",
		symbol: "yvCurve-agEUREUROC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xBa3436Fd341F2C8A928452Db3C5A3670d1d5Cc73"
		],
		chainId: 1,
		value: "0x7AB4a7BE740131BdE216521B54ADddD672F44A05",
		underlyingToken: "0xBa3436Fd341F2C8A928452Db3C5A3670d1d5Cc73"
	},
	{
		address: "0xc325849908D482550b87f96ef60271B95f92C861",
		name: "Balancer cbETH-wstETH Factory yVault",
		symbol: "yvBal-cbETH-wstETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x9c6d47Ff73e0F5E51BE5FD53236e3F595C5793F2"
		],
		chainId: 1,
		value: "0xc325849908D482550b87f96ef60271B95f92C861",
		underlyingToken: "0x9c6d47Ff73e0F5E51BE5FD53236e3F595C5793F2"
	},
	{
		address: "0x4B5BfD52124784745c1071dcB244C6688d2533d3",
		name: "Curve Y Pool yVault",
		symbol: "yUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xdF5e0e81Dff6FAF3A7e52BA697820c5e32D806A8"
		],
		chainId: 1,
		value: "0x4B5BfD52124784745c1071dcB244C6688d2533d3",
		underlyingToken: "0xdF5e0e81Dff6FAF3A7e52BA697820c5e32D806A8"
	},
	{
		address: "0x7356f09C294Cb9c6428AC7327B24B0f29419C181",
		name: "SNX yVault",
		symbol: "yvSNX",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F"
		],
		chainId: 1,
		value: "0x7356f09C294Cb9c6428AC7327B24B0f29419C181",
		underlyingToken: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F/logo.png"
	},
	{
		address: "0xFBEB78a723b8087fD2ea7Ef1afEc93d35E8Bed42",
		name: "UNI yVault",
		symbol: "yvUNI",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984"
		],
		chainId: 1,
		value: "0xFBEB78a723b8087fD2ea7Ef1afEc93d35E8Bed42",
		underlyingToken: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
		logoURI: "https://assets.coingecko.com/coins/images/12504/thumb/uniswap-uni.png?1600306604"
	},
	{
		address: "0x595a68a8c9D5C230001848B69b1947ee2A607164",
		name: "Curve ibGBP Pool yVault",
		symbol: "yvCurve-ibGBP",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xD6Ac1CB9019137a896343Da59dDE6d097F710538"
		],
		chainId: 1,
		value: "0x595a68a8c9D5C230001848B69b1947ee2A607164",
		underlyingToken: "0xD6Ac1CB9019137a896343Da59dDE6d097F710538"
	},
	{
		address: "0xC8BE5E2aE51c3F75FcfBD900505Ec63Ce7dE320c",
		name: "Balancer stETH Factory yVault",
		symbol: "yvBal-stETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x32296969Ef14EB0c6d29669C550D4a0449130230"
		],
		chainId: 1,
		value: "0xC8BE5E2aE51c3F75FcfBD900505Ec63Ce7dE320c",
		underlyingToken: "0x32296969Ef14EB0c6d29669C550D4a0449130230"
	},
	{
		address: "0xB8C3B7A2A618C552C23B1E4701109a9E756Bab67",
		name: "1INCH yVault",
		symbol: "yv1INCH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x111111111117dC0aa78b770fA6A738034120C302"
		],
		chainId: 1,
		value: "0xB8C3B7A2A618C552C23B1E4701109a9E756Bab67",
		underlyingToken: "0x111111111117dC0aa78b770fA6A738034120C302",
		logoURI: "https://assets.coingecko.com/coins/images/13469/thumb/1inch-token.png?1608803028"
	},
	{
		address: "0x5b189D92983E941273b26e3b46e5a16206c08827",
		name: "eCRV yVault",
		symbol: "yveCRV",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c"
		],
		chainId: 1,
		value: "0x5b189D92983E941273b26e3b46e5a16206c08827",
		underlyingToken: "0xA3D87FffcE63B53E0d54fAa1cc983B7eB0b74A9c"
	},
	{
		address: "0x4560b99C904aAD03027B5178CCa81584744AC01f",
		name: "Curve cvxCRV Pool yVault",
		symbol: "yvCurve-cvxCRV",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x9D0464996170c6B9e75eED71c68B99dDEDf279e8"
		],
		chainId: 1,
		value: "0x4560b99C904aAD03027B5178CCa81584744AC01f",
		underlyingToken: "0x9D0464996170c6B9e75eED71c68B99dDEDf279e8"
	},
	{
		address: "0xC4dAf3b5e2A9e93861c3FBDd25f1e943B8D87417",
		name: "Curve USDP Pool yVault",
		symbol: "yvCurve-USDP",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x7Eb40E450b9655f4B3cC4259BCC731c63ff55ae6"
		],
		chainId: 1,
		value: "0xC4dAf3b5e2A9e93861c3FBDd25f1e943B8D87417",
		underlyingToken: "0x7Eb40E450b9655f4B3cC4259BCC731c63ff55ae6"
	},
	{
		address: "0x61f46C65E403429266e8b569F23f70dD75d9BeE7",
		name: "LP Yearn CRV Vault",
		symbol: "lp-yCRV",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x0309A528bBa0394dC4A2Ce59123C52E317A54604"
		],
		chainId: 1,
		value: "0x61f46C65E403429266e8b569F23f70dD75d9BeE7",
		underlyingToken: "0x0309A528bBa0394dC4A2Ce59123C52E317A54604"
	},
	{
		address: "0xd6b2f4F0586BCfc9B1bf5cD8E22546aDD7B81a64",
		name: "Curve T-ETH Factory yVault",
		symbol: "yvCurve-T-ETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xCb08717451aaE9EF950a2524E33B6DCaBA60147B"
		],
		chainId: 1,
		value: "0xd6b2f4F0586BCfc9B1bf5cD8E22546aDD7B81a64",
		underlyingToken: "0xCb08717451aaE9EF950a2524E33B6DCaBA60147B"
	},
	{
		address: "0xa354F35829Ae975e850e23e9615b11Da1B3dC4DE",
		name: "USDC yVault",
		symbol: "yvUSDC",
		decimals: 6,
		isVault: true,
		underlyingTokens: [
			"0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
		],
		chainId: 1,
		value: "0xa354F35829Ae975e850e23e9615b11Da1B3dC4DE",
		underlyingToken: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png"
	},
	{
		address: "0x5F208d3a8b13062adE45a33Ca9Bc8de64D520CB9",
		name: "Curve stETHv2 Factory yVault",
		symbol: "yvCurve-stETHv2-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x21E27a5E5513D6e65C4f830167390997aA84843a"
		],
		chainId: 1,
		value: "0x5F208d3a8b13062adE45a33Ca9Bc8de64D520CB9",
		underlyingToken: "0x21E27a5E5513D6e65C4f830167390997aA84843a"
	},
	{
		address: "0x25212Df29073FfFA7A67399AcEfC2dd75a831A1A",
		name: "Curve EURS Pool yVault",
		symbol: "yvCurve-EURS",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x194eBd173F6cDacE046C53eACcE9B953F28411d1"
		],
		chainId: 1,
		value: "0x25212Df29073FfFA7A67399AcEfC2dd75a831A1A",
		underlyingToken: "0x194eBd173F6cDacE046C53eACcE9B953F28411d1"
	},
	{
		address: "0x80bbeE2fa460dA291e796B9045e93d19eF948C6A",
		name: "Curve Pax Pool yVault",
		symbol: "yvCurve-Pax",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xD905e2eaeBe188fc92179b6350807D8bd91Db0D8"
		],
		chainId: 1,
		value: "0x80bbeE2fa460dA291e796B9045e93d19eF948C6A",
		underlyingToken: "0xD905e2eaeBe188fc92179b6350807D8bd91Db0D8"
	},
	{
		address: "0xbD65955F752B2eF093B34B05e5FFb439AE8e5049",
		name: "COMP yVault",
		symbol: "yvCOMP",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xc00e94Cb662C3520282E6f5717214004A7f26888"
		],
		chainId: 1,
		value: "0xbD65955F752B2eF093B34B05e5FFb439AE8e5049",
		underlyingToken: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xc00e94Cb662C3520282E6f5717214004A7f26888/logo.png"
	},
	{
		address: "0x3C26DE7e22613A31b77E93F011d804D8A7821581",
		name: "LOOKS yVault",
		symbol: "yvLOOKS",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xf4d2888d29D722226FafA5d9B24F9164c092421E"
		],
		chainId: 1,
		value: "0x3C26DE7e22613A31b77E93F011d804D8A7821581",
		underlyingToken: "0xf4d2888d29D722226FafA5d9B24F9164c092421E"
	},
	{
		address: "0x497590d2d57f05cf8B42A36062fA53eBAe283498",
		name: "SUSHI yVault",
		symbol: "yvSUSHI",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x6B3595068778DD592e39A122f4f5a5cF09C90fE2"
		],
		chainId: 1,
		value: "0x497590d2d57f05cf8B42A36062fA53eBAe283498",
		underlyingToken: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
		logoURI: "https://assets.coingecko.com/coins/images/12271/thumb/512x512_Logo_no_chop.png?1606986688"
	},
	{
		address: "0xE537B5cc158EB71037D4125BDD7538421981E6AA",
		name: "Curve 3Crypto Pool yVault",
		symbol: "yvCurve-3Crypto",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xc4AD29ba4B3c580e6D59105FFf484999997675Ff"
		],
		chainId: 1,
		value: "0xE537B5cc158EB71037D4125BDD7538421981E6AA",
		underlyingToken: "0xc4AD29ba4B3c580e6D59105FFf484999997675Ff"
	},
	{
		address: "0x72FaEA467BD88db6720A861e56A3a72B4Aa579DF",
		name: "Curve ibCHF Factory yVault",
		symbol: "yvCurve-ibCHF-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x9c2C8910F113181783c249d8F6Aa41b51Cde0f0c"
		],
		chainId: 1,
		value: "0x72FaEA467BD88db6720A861e56A3a72B4Aa579DF",
		underlyingToken: "0x9c2C8910F113181783c249d8F6Aa41b51Cde0f0c"
	},
	{
		address: "0x6949145469362F9eeaB3c96Ea41b51D9B4cC2b21",
		name: "Curve TriCryptoINV Factory yVault",
		symbol: "yvCurve-TriCryptoINV-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x5426178799ee0a0181A89b4f57eFddfAb49941Ec"
		],
		chainId: 1,
		value: "0x6949145469362F9eeaB3c96Ea41b51D9B4cC2b21",
		underlyingToken: "0x5426178799ee0a0181A89b4f57eFddfAb49941Ec"
	},
	{
		address: "0x3f34A7eF4f17528CbFFb7817060941BCdaC924fa",
		name: "Curve TriCRV Factory yVault",
		symbol: "yvCurve-TriCRV-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x4eBdF703948ddCEA3B11f675B4D1Fba9d2414A14"
		],
		chainId: 1,
		value: "0x3f34A7eF4f17528CbFFb7817060941BCdaC924fa",
		underlyingToken: "0x4eBdF703948ddCEA3B11f675B4D1Fba9d2414A14"
	},
	{
		address: "0x27B5739e22ad9033bcBf192059122d163b60349D",
		name: "Staked Yearn CRV Vault",
		symbol: "st-yCRV",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xFCc5c47bE19d06BF83eB04298b026F81069ff65b"
		],
		chainId: 1,
		value: "0x27B5739e22ad9033bcBf192059122d163b60349D",
		underlyingToken: "0xFCc5c47bE19d06BF83eB04298b026F81069ff65b"
	},
	{
		address: "0xD725F5742047B4B4A3110D0b38284227fcaB041e",
		name: "LP Yearn BAL Vault",
		symbol: "lp-yBAL",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xD61e198e139369a40818FE05F5d5e6e045Cd6eaF"
		],
		chainId: 1,
		value: "0xD725F5742047B4B4A3110D0b38284227fcaB041e",
		underlyingToken: "0xD61e198e139369a40818FE05F5d5e6e045Cd6eaF"
	},
	{
		address: "0xc5F3D11580c41cD07104e9AF154Fc6428bb93c73",
		name: "Balancer Boosted Aave USD Pool yVault",
		symbol: "yvBalancer-BoostedAaveUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xA13a9247ea42D743238089903570127DdA72fE44"
		],
		chainId: 1,
		value: "0xc5F3D11580c41cD07104e9AF154Fc6428bb93c73",
		underlyingToken: "0xA13a9247ea42D743238089903570127DdA72fE44"
	},
	{
		address: "0x873fB544277FD7b977B196a826459a69E27eA4ea",
		name: "RAI yVault",
		symbol: "yvRAI",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919"
		],
		chainId: 1,
		value: "0x873fB544277FD7b977B196a826459a69E27eA4ea",
		underlyingToken: "0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919",
		logoURI: "https://assets.coingecko.com/coins/images/14004/thumb/RAI-logo-coin.png?1613592334"
	},
	{
		address: "0xBF7AA989192b020a8d3e1C65a558e123834325cA",
		name: "HBTC yVault",
		symbol: "yvHBTC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x0316EB71485b0Ab14103307bf65a021042c6d380"
		],
		chainId: 1,
		value: "0xBF7AA989192b020a8d3e1C65a558e123834325cA",
		underlyingToken: "0x0316EB71485b0Ab14103307bf65a021042c6d380"
	},
	{
		address: "0xb4D1Be44BfF40ad6e506edf43156577a3f8672eC",
		name: "Curve sAave Pool yVault",
		symbol: "yvCurve-sAave",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x02d341CcB60fAaf662bC0554d13778015d1b285C"
		],
		chainId: 1,
		value: "0xb4D1Be44BfF40ad6e506edf43156577a3f8672eC",
		underlyingToken: "0x02d341CcB60fAaf662bC0554d13778015d1b285C"
	},
	{
		address: "0x4CbB6A5EC00cEEC252a7091559484F7adb83165f",
		name: "Curve alUSD Factory yVault",
		symbol: "yvCurve-alUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x43b4FdFD4Ff969587185cDB6f0BD875c5Fc83f8c"
		],
		chainId: 1,
		value: "0x4CbB6A5EC00cEEC252a7091559484F7adb83165f",
		underlyingToken: "0x43b4FdFD4Ff969587185cDB6f0BD875c5Fc83f8c"
	},
	{
		address: "0xBfedbcbe27171C418CDabC2477042554b1904857",
		name: "Curve rETH Pool yVault",
		symbol: "yvCurve-rETH",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x53a901d48795C58f485cBB38df08FA96a24669D5"
		],
		chainId: 1,
		value: "0xBfedbcbe27171C418CDabC2477042554b1904857",
		underlyingToken: "0x53a901d48795C58f485cBB38df08FA96a24669D5"
	},
	{
		address: "0x28a5b95C101df3Ded0C0d9074DB80C438774B6a9",
		name: "Curve USDT Pool yVault",
		symbol: "yvCurve-USDT",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x9fC689CCaDa600B6DF723D9E47D84d76664a1F23"
		],
		chainId: 1,
		value: "0x28a5b95C101df3Ded0C0d9074DB80C438774B6a9",
		underlyingToken: "0x9fC689CCaDa600B6DF723D9E47D84d76664a1F23"
	},
	{
		address: "0x9777d7E2b60bB01759D0E2f8be2095df444cb07E",
		name: "Curve (iearn fork) USDC",
		symbol: "ycUSDC",
		decimals: 6,
		isVault: true,
		underlyingTokens: [
			"0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
		],
		chainId: 1,
		value: "0x9777d7E2b60bB01759D0E2f8be2095df444cb07E",
		underlyingToken: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png"
	},
	{
		address: "0xE6354ed5bC4b393a5Aad09f21c46E101e692d447",
		name: "iearn USDT",
		symbol: "yUSDT",
		decimals: 6,
		isVault: true,
		underlyingTokens: [
			"0xdAC17F958D2ee523a2206206994597C13D831ec7"
		],
		chainId: 1,
		value: "0xE6354ed5bC4b393a5Aad09f21c46E101e692d447",
		underlyingToken: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
		logoURI: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png"
	},
	{
		address: "0xd8C620991b8E626C099eAaB29B1E3eEa279763bb",
		name: "Curve MIM-UST Pool yVault",
		symbol: "yvCurve-MIMUST",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x55A8a39bc9694714E2874c1ce77aa1E599461E18"
		],
		chainId: 1,
		value: "0xd8C620991b8E626C099eAaB29B1E3eEa279763bb",
		underlyingToken: "0x55A8a39bc9694714E2874c1ce77aa1E599461E18"
	},
	{
		address: "0x2fB06235aB90812e5BaE28404024C9498fF9414d",
		name: "Curve JPEG-pETH Factory yVault",
		symbol: "yvCurve-JPEG-pETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x23E7817bC73645063FB2fa85c1d098EfFE84bE90"
		],
		chainId: 1,
		value: "0x2fB06235aB90812e5BaE28404024C9498fF9414d",
		underlyingToken: "0x23E7817bC73645063FB2fa85c1d098EfFE84bE90"
	},
	{
		address: "0x625b7DF2fa8aBe21B0A976736CDa4775523aeD1E",
		name: "Curve HBTC Pool yVault",
		symbol: "yvCurve-HBTC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xb19059ebb43466C323583928285a49f558E572Fd"
		],
		chainId: 1,
		value: "0x625b7DF2fa8aBe21B0A976736CDa4775523aeD1E",
		underlyingToken: "0xb19059ebb43466C323583928285a49f558E572Fd"
	},
	{
		address: "0x1A5ebfF0E881Aec34837845e4D0EB430a1B4b737",
		name: "Curve FRAXBP Factory yVault",
		symbol: "yvCurve-FRAXBP-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x3175Df0976dFA876431C2E9eE6Bc45b65d3473CC"
		],
		chainId: 1,
		value: "0x1A5ebfF0E881Aec34837845e4D0EB430a1B4b737",
		underlyingToken: "0x3175Df0976dFA876431C2E9eE6Bc45b65d3473CC"
	},
	{
		address: "0xfb9A680825f29972629b2295E050f74CB2f4992b",
		name: "Balancer GHO-LUSD Factory yVault",
		symbol: "yvBal-GHO-LUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x3FA8C89704e5d07565444009e5d9e624B40Be813"
		],
		chainId: 1,
		value: "0xfb9A680825f29972629b2295E050f74CB2f4992b",
		underlyingToken: "0x3FA8C89704e5d07565444009e5d9e624B40Be813"
	},
	{
		address: "0x65346970F0f66CCAd8a5bfc3a03C96836C1897bE",
		name: "Curve DUSD Factory yVault",
		symbol: "yvCurve-DUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x3a664Ab939FD8482048609f652f9a0B0677337B9"
		],
		chainId: 1,
		value: "0x65346970F0f66CCAd8a5bfc3a03C96836C1897bE",
		underlyingToken: "0x3a664Ab939FD8482048609f652f9a0B0677337B9"
	},
	{
		address: "0xA74d4B67b3368E83797a35382AFB776bAAE4F5C8",
		name: "Curve alUSD Pool yVault",
		symbol: "yvCurve-alUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x43b4FdFD4Ff969587185cDB6f0BD875c5Fc83f8c"
		],
		chainId: 1,
		value: "0xA74d4B67b3368E83797a35382AFB776bAAE4F5C8",
		underlyingToken: "0x43b4FdFD4Ff969587185cDB6f0BD875c5Fc83f8c"
	},
	{
		address: "0x8472E9914C0813C4b465927f82E213EA34839173",
		name: "sBTC yVault",
		symbol: "yvsBTC",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xfE18be6b3Bd88A2D2A7f928d00292E7a9963CfC6"
		],
		chainId: 1,
		value: "0x8472E9914C0813C4b465927f82E213EA34839173",
		underlyingToken: "0xfE18be6b3Bd88A2D2A7f928d00292E7a9963CfC6"
	},
	{
		address: "0xF59D66c1d593Fb10e2f8c2a6fD2C958792434B9c",
		name: "Curve OUSD Pool yVault",
		symbol: "yvCurve-OUSD",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x87650D7bbfC3A9F10587d7778206671719d9910D"
		],
		chainId: 1,
		value: "0xF59D66c1d593Fb10e2f8c2a6fD2C958792434B9c",
		underlyingToken: "0x87650D7bbfC3A9F10587d7778206671719d9910D"
	},
	{
		address: "0x429EA2d8d5B06CA40dD986FaC0734BA0E0CaC022",
		name: "Curve sdCRV Factory yVault",
		symbol: "yvCurve-sdCRV-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xf7b55C3732aD8b2c2dA7c24f30A69f55c54FB717"
		],
		chainId: 1,
		value: "0x429EA2d8d5B06CA40dD986FaC0734BA0E0CaC022",
		underlyingToken: "0xf7b55C3732aD8b2c2dA7c24f30A69f55c54FB717"
	},
	{
		address: "0xa540744DEDBDA9eF64cf753F0E851EfE4a419EA9",
		name: "Curve MIM Factory yVault",
		symbol: "yvCurve-MIM-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x5a6A4D54456819380173272A5E8E9B9904BdF41B"
		],
		chainId: 1,
		value: "0xa540744DEDBDA9eF64cf753F0E851EfE4a419EA9",
		underlyingToken: "0x5a6A4D54456819380173272A5E8E9B9904BdF41B"
	},
	{
		address: "0xc09cfb625e586B117282399433257a1C0841edf3",
		name: "Staked Yearn BAL Vault",
		symbol: "st-yBAL",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x98E86Ed5b0E48734430BfBe92101156C75418cad"
		],
		chainId: 1,
		value: "0xc09cfb625e586B117282399433257a1C0841edf3",
		underlyingToken: "0x98E86Ed5b0E48734430BfBe92101156C75418cad"
	},
	{
		address: "0x3B96d491f067912D18563d56858Ba7d6EC67a6fa",
		name: "Curve USDN Pool yVault",
		symbol: "yvCurve-USDN",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x4f3E8F405CF5aFC05D68142F3783bDfE13811522"
		],
		chainId: 1,
		value: "0x3B96d491f067912D18563d56858Ba7d6EC67a6fa",
		underlyingToken: "0x4f3E8F405CF5aFC05D68142F3783bDfE13811522"
	},
	{
		address: "0xe2277cC76f806925DC6c9a5E4E5933605f43c3c4",
		name: "Curve LUSD-crvUSD Factory yVault",
		symbol: "yvCurve-LUSD-crvUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x9978c6B08d28d3B74437c917c5dD7C026df9d55C"
		],
		chainId: 1,
		value: "0xe2277cC76f806925DC6c9a5E4E5933605f43c3c4",
		underlyingToken: "0x9978c6B08d28d3B74437c917c5dD7C026df9d55C"
	},
	{
		address: "0x19b8Bc5CcF9700e16f2780bEA152F01C449f45D0",
		name: "ALCX yVault",
		symbol: "yvALCX",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xdBdb4d16EdA451D0503b854CF79D55697F90c8DF"
		],
		chainId: 1,
		value: "0x19b8Bc5CcF9700e16f2780bEA152F01C449f45D0",
		underlyingToken: "0xdBdb4d16EdA451D0503b854CF79D55697F90c8DF",
		logoURI: "https://assets.coingecko.com/coins/images/14113/thumb/Alchemix.png?1614409874"
	},
	{
		address: "0x3408324Dbb537886CADc180f6FfCf674eE215F67",
		name: "renBTC yVault",
		symbol: "yvrenBTC",
		decimals: 8,
		isVault: true,
		underlyingTokens: [
			"0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D"
		],
		chainId: 1,
		value: "0x3408324Dbb537886CADc180f6FfCf674eE215F67",
		underlyingToken: "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D"
	},
	{
		address: "0xE510E87d0eF7d987Ed1baF8E1D7Aaef5b9e3db42",
		name: "Curve OHM-ETH Factory yVault",
		symbol: "yvCurve-OHM-ETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x3660BD168494d61ffDac21E403d0F6356cF90fD7"
		],
		chainId: 1,
		value: "0xE510E87d0eF7d987Ed1baF8E1D7Aaef5b9e3db42",
		underlyingToken: "0x3660BD168494d61ffDac21E403d0F6356cF90fD7"
	},
	{
		address: "0x774B4Cbc2703cE83fB3b828b7C782d1CD983b04A",
		name: "Curve ankrETH Factory yVault",
		symbol: "yvCurve-ankrETH-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0xaA17A236F2bAdc98DDc0Cf999AbB47D47Fc0A6Cf"
		],
		chainId: 1,
		value: "0x774B4Cbc2703cE83fB3b828b7C782d1CD983b04A",
		underlyingToken: "0xaA17A236F2bAdc98DDc0Cf999AbB47D47Fc0A6Cf"
	},
	{
		address: "0x2a82DcdcBfB88e92021B8BcC3DA22703a2E4459c",
		name: "Curve BUSD Factory yVault",
		symbol: "yvCurve-BUSD-f",
		decimals: 18,
		isVault: true,
		underlyingTokens: [
			"0x4807862AA8b2bF68830e4C8dc86D0e9A998e085a"
		],
		chainId: 1,
		value: "0x2a82DcdcBfB88e92021B8BcC3DA22703a2E4459c",
		underlyingToken: "0x4807862AA8b2bF68830e4C8dc86D0e9A998e085a"
	}
];

var aTokensGoerli = [
	{
		chainId: "5",
		aTokenAddress: "0x5fDF09EE06219f96EffE1b4CC47f44A630C5A358",
		stableDebtTokenAddress: "0x2ab21c55DAC613a3C2E2D40De0e5df270BaFec4C",
		variableDebtTokenAddress: "0x299D037785b53305494A8Ef3e89c47e7E23efe58",
		underlyingAssetAddress: "0x0B7a69d978DdA361Db5356D4Bd0206496aFbDD96",
		aTokenSymbol: "aAAVE"
	},
	{
		chainId: "5",
		aTokenAddress: "0x41355876CEC93c43cE4e784ce1b5f5e62557D2e2",
		stableDebtTokenAddress: "0x14DA7b36d17812cc5fD8C171D3c573f5E78823e3",
		variableDebtTokenAddress: "0xE34A49958A50346d9616fB5f8C601A67CD07aC84",
		underlyingAssetAddress: "0x515614aA3d8f09152b1289848383A260c7D053Ff",
		aTokenSymbol: "aBAT"
	},
	{
		chainId: "5",
		aTokenAddress: "0xabd2878A23cba83F1e9790635e09e494b8E21333",
		stableDebtTokenAddress: "0xB14F9C379eBeBE76C8881D7104bcb50d50aFC1c2",
		variableDebtTokenAddress: "0xD078EAEA33DCA2bE04Ef1511F7c73D78F06f9abe",
		underlyingAssetAddress: "0xa7c3Bf25FFeA8605B516Cf878B7435fe1768c89b",
		aTokenSymbol: "aBUSD"
	},
	{
		chainId: "5",
		aTokenAddress: "0x31f30d9A5627eAfeC4433Ae2886Cf6cc3D25E772",
		stableDebtTokenAddress: "0x80bECEc53542B4C85ccf9D51c1cbaB4A5C624637",
		variableDebtTokenAddress: "0x40e63a0143da87aC2cd22EC08CE55535cB53ee80",
		underlyingAssetAddress: "0x75Ab5AB1Eef154C0352Fc31D2428Cef80C7F8B33",
		aTokenSymbol: "aDAI"
	},
	{
		chainId: "5",
		aTokenAddress: "0x3DB016c45090337e989C882F47Cf1Dc51fB6dE1B",
		stableDebtTokenAddress: "0x8733524Ca21c3089e787C7972A4DF0d5f50b315b",
		variableDebtTokenAddress: "0x2861E9f276b82BCbef0e973fF4E17Dd25bCE8346",
		underlyingAssetAddress: "0x1057DCaa0b66dFBcEc5241fD51F4326C210f201F",
		aTokenSymbol: "aENJ"
	},
	{
		chainId: "5",
		aTokenAddress: "0x7D5e39D49Ca107b49Fd4c6cF777B04bdA79a675C",
		stableDebtTokenAddress: "0x62d1Fc8a330F4A01De9770B38695F339bB987164",
		variableDebtTokenAddress: "0x4758f759257CC24292d90c2c0A1D27Cd7D4f5B19",
		underlyingAssetAddress: "0x54Bc1D59873A5ABde98cf76B6EcF4075ff65d685",
		aTokenSymbol: "aKNC"
	},
	{
		chainId: "5",
		aTokenAddress: "0x8c8cc9b893b6962409BCEaAFCA95d1044ce809bc",
		stableDebtTokenAddress: "0x8fc66637ab88f13c92F60D6BD509cc151187D93f",
		variableDebtTokenAddress: "0xb0B37762c1d2aa2370D1da9e0276d45240BbD632",
		underlyingAssetAddress: "0x7337e7FF9abc45c0e43f130C136a072F4794d40b",
		aTokenSymbol: "aLINK"
	},
	{
		chainId: "5",
		aTokenAddress: "0x71d4C18Ce2bd9889E17099B1552D0b92FAe15731",
		stableDebtTokenAddress: "0x935bb070195A5cFe2E30890f4D672b1e361a20a6",
		variableDebtTokenAddress: "0x6E67bbCE6d126b9B09F974723cC2df83506F2a13",
		underlyingAssetAddress: "0x8d9EAc6f25470EFfD68f0AD22993CB2813c0c9B9",
		aTokenSymbol: "aMANA"
	},
	{
		chainId: "5",
		aTokenAddress: "0xd77332d9FA5299010b403bB4f768ACb2d2E8A8a6",
		stableDebtTokenAddress: "0x2e5549073cbC537f77393bE12c2e4220bc7146f1",
		variableDebtTokenAddress: "0x80911c6784E6487A2E5670CAeBa6DdE3c80836A7",
		underlyingAssetAddress: "0x90be02599452FBC1a3D47E9EB62895330cfA05Ed",
		aTokenSymbol: "aMKR"
	},
	{
		chainId: "5",
		aTokenAddress: "0x2A4B55A3229470BE6Bc78f1b534Cfe8064107407",
		stableDebtTokenAddress: "0xfBf071aDd7414B81E7b6eBF1a4Def16Cc523221f",
		variableDebtTokenAddress: "0x5e8d588EFf65787657Eb48eBD64E739b1C7eF177",
		underlyingAssetAddress: "0x3160F3f3B55eF85d0D27f04A2d74d426c32de842",
		aTokenSymbol: "aREN"
	},
	{
		chainId: "5",
		aTokenAddress: "0x1Fad08D99F66fe709f4c4d7D81268d6fd380a20f",
		stableDebtTokenAddress: "0x8E2890B0c234Cea38FDfe7d70E6B496004d81f35",
		variableDebtTokenAddress: "0x50b60ff9591883b14ABCC5395e0218641c8aFFd3",
		underlyingAssetAddress: "0xFc1Ab0379db4B6ad8Bf5Bc1382e108a341E2EaBb",
		aTokenSymbol: "aSNX"
	},
	{
		chainId: "5",
		aTokenAddress: "0xb997a147657a9295137e54c6C19ECF9e97Eb4b36",
		stableDebtTokenAddress: "0x07836D13e93342EA05477244c2f38B9C41C99A0D",
		variableDebtTokenAddress: "0xA2b3b3Bc809d45a535da603485D9CFcE7658BEC1",
		underlyingAssetAddress: "0x4e62eB262948671590b8D967BDE048557bdd03eD",
		aTokenSymbol: "aSUSD"
	},
	{
		chainId: "5",
		aTokenAddress: "0x37416BA913324Bc0eEB60f27d5897d8A6A75028b",
		stableDebtTokenAddress: "0x5C5B7b4cf294c060204Cf3123502d264C0c88f26",
		variableDebtTokenAddress: "0x485e3336934d45cC41112D04287ED1f3C9c84B3f",
		underlyingAssetAddress: "0xc048C1b6ac47393F073dA2b3d5D1cc43b94891Fd",
		aTokenSymbol: "aTUSD"
	},
	{
		chainId: "5",
		aTokenAddress: "0x6Ea7776f7d217b41Dc44684Da6f9FcD4eb9642C3",
		stableDebtTokenAddress: "0xE36213372341F7422ec42D375EEAd34946420db2",
		variableDebtTokenAddress: "0x111f523Fc4b9451871980324c1A32CA14E90D375",
		underlyingAssetAddress: "0x981D8AcaF6af3a46785e7741d22fBE81B25Ebf1e",
		aTokenSymbol: "aUNI"
	},
	{
		chainId: "5",
		aTokenAddress: "0x935c0F6019b05C787573B5e6176681282A3f3E05",
		stableDebtTokenAddress: "0x82f69F0aa86BC4A2daD63b2DA13A43548F15dE23",
		variableDebtTokenAddress: "0xcfc2d9b9498cBd6F71E5E46d46082C76C4F6C695",
		underlyingAssetAddress: "0x9FD21bE27A2B059a288229361E2fA632D8D2d074",
		aTokenSymbol: "aUSDC"
	},
	{
		chainId: "5",
		aTokenAddress: "0xDCb84F51dd4BeA1ce4b6118F087B260a71BB656c",
		stableDebtTokenAddress: "0xe92E940B939a6108C9C4dE3aF29A55286Cd6cC92",
		variableDebtTokenAddress: "0x5684765693E499E40BB90d36f8BdEf69B755D740",
		underlyingAssetAddress: "0x65E2fe35C30eC218b46266F89847c63c2eDa7Dc7",
		aTokenSymbol: "aUSDT"
	},
	{
		chainId: "5",
		aTokenAddress: "0x2f8274ce7fB939014e657e480e9ed3e1131f242B",
		stableDebtTokenAddress: "0x5744FE36A565637C10911f020779a048fA9ac5d4",
		variableDebtTokenAddress: "0xdb2276bAC9F27A7AF8d608fFE21036303aa3486A",
		underlyingAssetAddress: "0xf4423F4152966eBb106261740da907662A3569C5",
		aTokenSymbol: "aWBTC"
	},
	{
		chainId: "5",
		aTokenAddress: "0x22404B0e2a7067068AcdaDd8f9D586F834cCe2c5",
		stableDebtTokenAddress: "0x2D9038076C16F152B6Ab5391644DB8e3E88C3723",
		variableDebtTokenAddress: "0xE3F7fEe1F71F1227007575931B62B94076549989",
		underlyingAssetAddress: "0xCCa7d1416518D095E729904aAeA087dBA749A4dC",
		aTokenSymbol: "aWETH"
	},
	{
		chainId: "5",
		aTokenAddress: "0xAF299560160896eF72219F0e2Ea67d4653cE8251",
		stableDebtTokenAddress: "0x4D6f1069B958ea197A1e38151e15bB33f403f78F",
		variableDebtTokenAddress: "0xcCef241f5aa65f7344928cF460b7c7703fC8873d",
		underlyingAssetAddress: "0x6c260F702B6Bb9AC989DA4B0fcbE7fddF8f749c4",
		aTokenSymbol: "aYFI"
	},
	{
		chainId: "5",
		aTokenAddress: "0x22af6D8C0cD02a4EbdF6f79B6181DcC565f0b18e",
		stableDebtTokenAddress: "0x1d5094E61854380D458400e1B3f8b323CC87fD6C",
		variableDebtTokenAddress: "0x97431382542b21fe7a2D293737799f5B7afbF0a9",
		underlyingAssetAddress: "0xAcFd03DdF9C68015E1943FB02b60c5df56C4CB9e",
		aTokenSymbol: "aZRX"
	},
	{
		chainId: "5",
		aTokenAddress: "0x8C1d95Ed70e16664b0CFF72c31a536a68474A4eA",
		stableDebtTokenAddress: "0xD97DfD88bA230fE7947683B5b5af280FAF6a2E87",
		variableDebtTokenAddress: "0x710F5Ae6370ebb29c4aF779a5cB22C84C46b682c",
		underlyingAssetAddress: "0x45E18E77b15A02a31507e948A546a509A50a2376",
		aTokenSymbol: "axSUSHI"
	}
];

var aTokensMainnet = [
	{
		aTokenAddress: "0x3Ed3B47Dd13EC9a98b44e6204A523E766B225811",
		aTokenSymbol: "aUSDT",
		stableDebtTokenAddress: "0xe91D55AB2240594855aBd11b3faAE801Fd4c4687",
		variableDebtTokenAddress: "0x531842cEbbdD378f8ee36D171d6cC9C4fcf475Ec",
		underlyingAssetAddress: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
		decimals: 6,
		chainId: "1"
	},
	{
		aTokenAddress: "0x9ff58f4fFB29fA2266Ab25e75e2A8b3503311656",
		aTokenSymbol: "aWBTC",
		stableDebtTokenAddress: "0x51B039b9AFE64B78758f8Ef091211b5387eA717c",
		variableDebtTokenAddress: "0x9c39809Dec7F95F5e0713634a4D0701329B3b4d2",
		underlyingAssetAddress: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
		decimals: 8,
		chainId: "1"
	},
	{
		aTokenAddress: "0x030bA81f1c18d280636F32af80b9AAd02Cf0854e",
		aTokenSymbol: "aWETH",
		stableDebtTokenAddress: "0x4e977830ba4bd783C0BB7F15d3e243f73FF57121",
		variableDebtTokenAddress: "0xF63B34710400CAd3e044cFfDcAb00a0f32E33eCf",
		underlyingAssetAddress: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0x5165d24277cD063F5ac44Efd447B27025e888f37",
		aTokenSymbol: "aYFI",
		stableDebtTokenAddress: "0xca823F78C2Dd38993284bb42Ba9b14152082F7BD",
		variableDebtTokenAddress: "0x7EbD09022Be45AD993BAA1CEc61166Fcc8644d97",
		underlyingAssetAddress: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0xDf7FF54aAcAcbFf42dfe29DD6144A69b629f8C9e",
		aTokenSymbol: "aZRX",
		stableDebtTokenAddress: "0x071B4323a24E73A5afeEbe34118Cd21B8FAAF7C3",
		variableDebtTokenAddress: "0x85791D117A392097590bDeD3bD5abB8d5A20491A",
		underlyingAssetAddress: "0xE41d2489571d322189246DaFA5ebDe1F4699F498",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0xB9D7CB55f463405CDfBe4E90a6D2Df01C2B92BF1",
		aTokenSymbol: "aUNI",
		stableDebtTokenAddress: "0xD939F7430dC8D5a427f156dE1012A56C18AcB6Aa",
		variableDebtTokenAddress: "0x5BdB050A92CADcCfCDcCCBFC17204a1C9cC0Ab73",
		underlyingAssetAddress: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0xFFC97d72E13E01096502Cb8Eb52dEe56f74DAD7B",
		aTokenSymbol: "aAAVE",
		stableDebtTokenAddress: "0x079D6a3E844BcECf5720478A718Edb6575362C5f",
		variableDebtTokenAddress: "0xF7DBA49d571745D9d7fcb56225B05BEA803EBf3C",
		underlyingAssetAddress: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0x05Ec93c0365baAeAbF7AefFb0972ea7ECdD39CF1",
		aTokenSymbol: "aBAT",
		stableDebtTokenAddress: "0x277f8676FAcf4dAA5a6EA38ba511B7F65AA02f9F",
		variableDebtTokenAddress: "0xfc218A6Dfe6901CB34B1a5281FC6f1b8e7E56877",
		underlyingAssetAddress: "0x0D8775F648430679A709E98d2b0Cb6250d2887EF",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0xA361718326c15715591c299427c62086F69923D9",
		aTokenSymbol: "aBUSD",
		stableDebtTokenAddress: "0x4A7A63909A72D268b1D8a93a9395d098688e0e5C",
		variableDebtTokenAddress: "0xbA429f7011c9fa04cDd46a2Da24dc0FF0aC6099c",
		underlyingAssetAddress: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0x028171bCA77440897B824Ca71D1c56caC55b68A3",
		aTokenSymbol: "aDAI",
		stableDebtTokenAddress: "0x778A13D3eeb110A4f7bb6529F99c000119a08E92",
		variableDebtTokenAddress: "0x6C3c78838c761c6Ac7bE9F59fe808ea2A6E4379d",
		underlyingAssetAddress: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0xaC6Df26a590F08dcC95D5a4705ae8abbc88509Ef",
		aTokenSymbol: "aENJ",
		stableDebtTokenAddress: "0x943DcCA156b5312Aa24c1a08769D67FEce4ac14C",
		variableDebtTokenAddress: "0x38995F292a6E31b78203254fE1cdd5Ca1010A446",
		underlyingAssetAddress: "0xF629cBd94d3791C9250152BD8dfBDF380E2a3B9c",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0x39C6b3e42d6A679d7D776778Fe880BC9487C2EDA",
		aTokenSymbol: "aKNC",
		stableDebtTokenAddress: "0x9915dfb872778B2890a117DA1F35F335eb06B54f",
		variableDebtTokenAddress: "0x6B05D1c608015Ccb8e205A690cB86773A96F39f1",
		underlyingAssetAddress: "0xdd974D5C2e2928deA5F71b9825b8b646686BD200",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0xa06bC25B5805d5F8d82847D191Cb4Af5A3e873E0",
		aTokenSymbol: "aLINK",
		stableDebtTokenAddress: "0xFB4AEc4Cc858F2539EBd3D37f2a43eAe5b15b98a",
		variableDebtTokenAddress: "0x0b8f12b1788BFdE65Aa1ca52E3e9F3Ba401be16D",
		underlyingAssetAddress: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0xa685a61171bb30d4072B338c80Cb7b2c865c873E",
		aTokenSymbol: "aMANA",
		stableDebtTokenAddress: "0xD86C74eA2224f4B8591560652b50035E4e5c0a3b",
		variableDebtTokenAddress: "0x0A68976301e46Ca6Ce7410DB28883E309EA0D352",
		underlyingAssetAddress: "0x0F5D2fB29fb7d3CFeE444a200298f468908cC942",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0xc713e5E149D5D0715DcD1c156a020976e7E56B88",
		aTokenSymbol: "aMKR",
		stableDebtTokenAddress: "0xC01C8E4b12a89456a9fD4e4e75B72546Bf53f0B5",
		variableDebtTokenAddress: "0xba728eAd5e496BE00DCF66F650b6d7758eCB50f8",
		underlyingAssetAddress: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0xCC12AbE4ff81c9378D670De1b57F8e0Dd228D77a",
		aTokenSymbol: "aREN",
		stableDebtTokenAddress: "0x3356Ec1eFA75d9D150Da1EC7d944D9EDf73703B7",
		variableDebtTokenAddress: "0xcd9D82d33bd737De215cDac57FE2F7f04DF77FE0",
		underlyingAssetAddress: "0x408e41876cCCDC0F92210600ef50372656052a38",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0x35f6B052C598d933D69A4EEC4D04c73A191fE6c2",
		aTokenSymbol: "aSNX",
		stableDebtTokenAddress: "0x8575c8ae70bDB71606A53AeA1c6789cB0fBF3166",
		variableDebtTokenAddress: "0x267EB8Cf715455517F9BD5834AeAE3CeA1EBdbD8",
		underlyingAssetAddress: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0x6C5024Cd4F8A59110119C56f8933403A539555EB",
		aTokenSymbol: "aSUSD",
		stableDebtTokenAddress: "0x30B0f7324feDF89d8eff397275F8983397eFe4af",
		variableDebtTokenAddress: "0xdC6a3Ab17299D9C2A412B0e0a4C1f55446AE0817",
		underlyingAssetAddress: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0x101cc05f4A51C0319f570d5E146a8C625198e636",
		aTokenSymbol: "aTUSD",
		stableDebtTokenAddress: "0x7f38d60D94652072b2C44a18c0e14A481EC3C0dd",
		variableDebtTokenAddress: "0x01C0eb1f8c6F1C1bF74ae028697ce7AA2a8b0E92",
		underlyingAssetAddress: "0x0000000000085d4780B73119b644AE5ecd22b376",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0xBcca60bB61934080951369a648Fb03DF4F96263C",
		aTokenSymbol: "aUSDC",
		stableDebtTokenAddress: "0xE4922afAB0BbaDd8ab2a88E0C79d884Ad337fcA6",
		variableDebtTokenAddress: "0x619beb58998eD2278e08620f97007e1116D5D25b",
		underlyingAssetAddress: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
		decimals: 6,
		chainId: "1"
	},
	{
		aTokenAddress: "0x8dAE6Cb04688C62d939ed9B68d32Bc62e49970b1",
		aTokenSymbol: "aCRV",
		stableDebtTokenAddress: "0x9288059a74f589C919c7Cf1Db433251CdFEB874B",
		variableDebtTokenAddress: "0x00ad8eBF64F141f1C81e9f8f792d3d1631c6c684",
		underlyingAssetAddress: "0xD533a949740bb3306d119CC777fa900bA034cd52",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0xD37EE7e4f452C6638c96536e68090De8cBcdb583",
		aTokenSymbol: "aGUSD",
		stableDebtTokenAddress: "0xf8aC64ec6Ff8E0028b37EB89772d21865321bCe0",
		variableDebtTokenAddress: "0x279AF5b99540c1A3A7E3CDd326e19659401eF99e",
		underlyingAssetAddress: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
		decimals: 2,
		chainId: "1"
	},
	{
		aTokenAddress: "0x272F97b7a56a387aE942350bBC7Df5700f8a4576",
		aTokenSymbol: "aBAL",
		stableDebtTokenAddress: "0xe569d31590307d05DA3812964F1eDd551D665a0b",
		variableDebtTokenAddress: "0x13210D4Fe0d5402bd7Ecbc4B5bC5cFcA3b71adB0",
		underlyingAssetAddress: "0xba100000625a3754423978a60c9317c58a424e3D",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0xF256CC7847E919FAc9B808cC216cAc87CCF2f47a",
		aTokenSymbol: "aXSUSHI",
		stableDebtTokenAddress: "0x73Bfb81D7dbA75C904f430eA8BAe82DB0D41187B",
		variableDebtTokenAddress: "0xfAFEDF95E21184E3d880bd56D4806c4b8d31c69A",
		underlyingAssetAddress: "0x8798249c2E607446EfB7Ad49eC89dD1865Ff4272",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0x514cd6756CCBe28772d4Cb81bC3156BA9d1744aa",
		aTokenSymbol: "aRENFIL",
		stableDebtTokenAddress: "0xcAad05C49E14075077915cB5C820EB3245aFb950",
		variableDebtTokenAddress: "0x348e2eBD5E962854871874E444F4122399c02755",
		underlyingAssetAddress: "0xD5147bc8e386d91Cc5DBE72099DAC6C9b99276F5",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0xc9BC48c72154ef3e5425641a3c747242112a46AF",
		aTokenSymbol: "aRAI",
		stableDebtTokenAddress: "0x9C72B8476C33AE214ee3e8C20F0bc28496a62032",
		variableDebtTokenAddress: "0xB5385132EE8321977FfF44b60cDE9fE9AB0B4e6b",
		underlyingAssetAddress: "0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0x1E6bb68Acec8fefBD87D192bE09bb274170a0548",
		aTokenSymbol: "aAMPL",
		stableDebtTokenAddress: "0x18152C9f77DAdc737006e9430dB913159645fa87",
		variableDebtTokenAddress: "0xf013D90E4e4E3Baf420dFea60735e75dbd42f1e1",
		underlyingAssetAddress: "0xD46bA6D942050d489DBd938a2C909A5d5039A161",
		decimals: 9,
		chainId: "1"
	},
	{
		aTokenAddress: "0x2e8F4bdbE3d47d7d7DE490437AeA9915D930F1A3",
		aTokenSymbol: "aUSDP",
		stableDebtTokenAddress: "0x2387119bc85A74e0BBcbe190d80676CB16F10D4F",
		variableDebtTokenAddress: "0xFDb93B3b10936cf81FA59A02A7523B6e2149b2B7",
		underlyingAssetAddress: "0x8E870D67F660D95d5be530380D0eC0bd388289E1",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0x6F634c6135D2EBD550000ac92F494F9CB8183dAe",
		aTokenSymbol: "aDPI",
		stableDebtTokenAddress: "0xa3953F07f389d719F99FC378ebDb9276177d8A6e",
		variableDebtTokenAddress: "0x4dDff5885a67E4EffeC55875a3977D7E60F82ae0",
		underlyingAssetAddress: "0x1494CA1F11D487c2bBe4543E90080AeBa4BA3C2b",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0xd4937682df3C8aEF4FE912A96A74121C0829E664",
		aTokenSymbol: "aFRAX",
		stableDebtTokenAddress: "0x3916e3B6c84b161df1b2733dFfc9569a1dA710c2",
		variableDebtTokenAddress: "0xfE8F19B17fFeF0fDbfe2671F248903055AFAA8Ca",
		underlyingAssetAddress: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
		decimals: 18,
		chainId: "1"
	},
	{
		aTokenAddress: "0x683923dB55Fead99A79Fa01A27EeC3cB19679cC3",
		aTokenSymbol: "aFEI",
		stableDebtTokenAddress: "0xd89cF9E8A858F8B4b31Faf793505e112d6c17449",
		variableDebtTokenAddress: "0xC2e10006AccAb7B45D9184FcF5b7EC7763f5BaAe",
		underlyingAssetAddress: "0x956F47F50A910163D8BF957Cf5846D573E7f87CA",
		decimals: 18,
		chainId: "1"
	}
];

var LENDING_POOL_ADDRESSES$1 = [{
  address: '0x7d2768dE32b0b80b7a3454c06BdAc94A69DDc7A9',
  chainId: 1
}, {
  address: '0x4bd5643ac6f66a5237E18bfA7d47cF22f1c9F210',
  chainId: 5
}];
var PROTOCOL_DATA_PROVIDER_ADDRESSES$1 = [{
  address: '0x057835Ad21a177dbdd3090bB1CAE03EaCF78Fc6d',
  chainId: 1
}, {
  address: '0x927F584d4321C1dCcBf5e2902368124b02419a1E',
  chainId: 5
}];
var PRICE_ORACLE_ADDRESSES$1 = [{
  address: '0xa50ba011c48153de246e5192c8f9258a2ba79ca9',
  chainId: 1
}, {
  address: '0xc1c6f3b788FE7F4bB896a2Fad65F5a8c0Ad509C9',
  chainId: 5
}];
var A_TOKENS$1 = {
  1: aTokensMainnet,
  5: aTokensGoerli,
  42161: [],
  421613: [],
  11155111: []
};

var curvePoolsMainnet = [
	{
		id: "0",
		address: "0xbEbc44782C7dB0a1A60Cb6fe97d0b483032FF1C7",
		coinsAddresses: [
			"0x6B175474E89094C44Da98b954EedeAC495271d0F",
			"0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
			"0xdAC17F958D2ee523a2206206994597C13D831ec7",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"6",
			"6",
			"0"
		],
		virtualPrice: "1022642939362272111",
		amplificationCoefficient: "2000",
		assetType: "0",
		totalSupply: "651442782983255959409817577",
		lpTokenAddress: "0x6c3f90f043a72fa612cbac8115ee7e52bde6e490",
		name: "Curve.fi DAI/USDC/USDT",
		symbol: "3Crv",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/3pool/swap",
				"https://classic.curve.fi/3pool"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/3pool/deposit",
				"https://classic.curve.fi/3pool/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/3pool/withdraw",
				"https://classic.curve.fi/3pool/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "113635737362494352895490433"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "111974333596757"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "440689089779868"
			}
		],
		usdTotal: 667080757.0409865,
		isMetaPool: false,
		usdTotalExcludingBasePool: 667080757.0409865,
		gaugeAddress: "0xbfcf63294ad7105dea65aa58f8ae5be2d9d0952a",
		chainId: 1
	},
	{
		id: "1",
		address: "0xDeBF20617708857ebe4F679508E7b7863a8A8EeE",
		coinsAddresses: [
			"0x028171bCA77440897B824Ca71D1c56caC55b68A3",
			"0xBcca60bB61934080951369a648Fb03DF4F96263C",
			"0x3Ed3B47Dd13EC9a98b44e6204A523E766B225811",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"6",
			"6",
			"0"
		],
		virtualPrice: "1099575046205757809",
		amplificationCoefficient: "2000",
		assetType: "0",
		totalSupply: "23212121087549835303110807",
		lpTokenAddress: "0xFd2a8fA60Abd58Efe3EeE34dd494cD491dC14900",
		name: "Curve.fi aDAI/aUSDC/aUSDT",
		symbol: "a3CRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/aave/swap",
				"https://classic.curve.fi/aave"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/aave/deposit",
				"https://classic.curve.fi/aave/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/aave/withdraw",
				"https://classic.curve.fi/aave/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x028171bCA77440897B824Ca71D1c56caC55b68A3",
				usdPrice: 0.999324,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "aDAI",
				poolBalance: "4557975897830465823202232"
			},
			{
				address: "0xBcca60bB61934080951369a648Fb03DF4F96263C",
				usdPrice: 1.006,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "aUSDC",
				poolBalance: "4487185092213"
			},
			{
				address: "0x3Ed3B47Dd13EC9a98b44e6204A523E766B225811",
				usdPrice: 1.003,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "aUSDT",
				poolBalance: "16481825729628"
			}
		],
		usdTotal: 25600274.115706693,
		isMetaPool: false,
		usdTotalExcludingBasePool: 25600274.115706693,
		gaugeAddress: "0xd662908ada2ea1916b3318327a97eb18ad588b5d",
		chainId: 1
	},
	{
		id: "2",
		address: "0xA96A65c051bF88B4095Ee1f2451C2A9d43F53Ae2",
		coinsAddresses: [
			"0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
			"0xE95A203B1a91a908F9B9CE46459d101078c2c3cb",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1056036356962788484",
		amplificationCoefficient: "10",
		assetType: "1",
		totalSupply: "3368980637711626609973",
		lpTokenAddress: "0xaA17A236F2bAdc98DDc0Cf999AbB47D47Fc0A6Cf",
		name: "Curve.fi ETH/aETH",
		symbol: "ankrCRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/ankreth/swap",
				"https://classic.curve.fi/ankreth"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/ankreth/deposit",
				"https://classic.curve.fi/ankreth/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/ankreth/withdraw",
				"https://classic.curve.fi/ankreth/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "eth",
		coins: [
			{
				address: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
				usdPrice: 1123.52,
				poolBalance: "1096225692508289822139",
				decimals: 18,
				symbol: "ETH",
				isBasePoolLpToken: false
			},
			{
				address: "0xE95A203B1a91a908F9B9CE46459d101078c2c3cb",
				usdPrice: 1116.6669056335165,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "aETHс",
				poolBalance: "2281978121818565631595"
			}
		],
		usdTotal: 3779840.938061435,
		isMetaPool: false,
		usdTotalExcludingBasePool: 3779840.938061435,
		gaugeAddress: "0x6d10ed2cf043e6fcf51a0e7b4c2af3fa06695707",
		chainId: 1
	},
	{
		id: "3",
		address: "0x79a8C46DeA5aDa233ABaFFD40F3A0A2B1e5A4F27",
		coinsAddresses: [
			"0xC2cB1040220768554cf699b0d863A3cd4324ce32",
			"0x26EA744E5B887E5205727f55dFBE8685e3b21951",
			"0xE6354ed5bC4b393a5Aad09f21c46E101e692d447",
			"0x04bC0Ab673d88aE9dbC9DA2380cB6B79C4BCa9aE"
		],
		decimals: [
			"18",
			"6",
			"6",
			"18"
		],
		virtualPrice: "1136855533552108225",
		amplificationCoefficient: "500",
		assetType: "0",
		totalSupply: "5490851132414858773155044",
		lpTokenAddress: "0x3b3ac5386837dc563660fb6a0937dfaa5924333b",
		name: "Curve.fi yDAI/yUSDC/yUSDT/yBUSD",
		symbol: "yDAI+yUSDC+yUSDT+yBUSD",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/busd/swap",
				"https://classic.curve.fi/busd"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/busd/deposit",
				"https://classic.curve.fi/busd/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/busd/withdraw",
				"https://classic.curve.fi/busd/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xC2cB1040220768554cf699b0d863A3cd4324ce32",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "yDAI",
				poolBalance: "1230708493548875636789969"
			},
			{
				address: "0x26EA744E5B887E5205727f55dFBE8685e3b21951",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "yUSDC",
				poolBalance: "1171567248324"
			},
			{
				address: "0xE6354ed5bC4b393a5Aad09f21c46E101e692d447",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "yUSDT",
				poolBalance: "2169162385269"
			},
			{
				address: "0x04bC0Ab673d88aE9dbC9DA2380cB6B79C4BCa9aE",
				usdPrice: 1.002,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "yBUSD",
				poolBalance: "1151165413980996805946921"
			}
		],
		usdTotal: 5730767.159816749,
		isMetaPool: false,
		usdTotalExcludingBasePool: 5730767.159816749,
		gaugeAddress: "0x69fb7c45726cfe2badee8317005d3f94be838840",
		chainId: 1
	},
	{
		id: "4",
		address: "0xA2B47E3D5c44877cca798226B7B8118F9BFb7A56",
		coinsAddresses: [
			"0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643",
			"0x39AA39c021dfbaE8faC545936693aC917d5E7563",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"8",
			"8",
			"0",
			"0"
		],
		virtualPrice: "1111148996715455722",
		amplificationCoefficient: "4500",
		assetType: "0",
		totalSupply: "39662048524143180441957848",
		lpTokenAddress: "0x845838df265dcd2c412a1dc9e959c7d08537f8a2",
		name: "Curve.fi cDAI/cUSDC",
		symbol: "cDAI+cUSDC",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/compound/swap",
				"https://classic.curve.fi/compound"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/compound/deposit",
				"https://classic.curve.fi/compound/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/compound/withdraw",
				"https://classic.curve.fi/compound/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643",
				usdPrice: 0.02213429,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "cDAI",
				poolBalance: "138663815249723320"
			},
			{
				address: "0x39AA39c021dfbaE8faC545936693aC917d5E7563",
				usdPrice: 0.0227057174630131,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "cUSDC",
				poolBalance: "59175627718671731"
			}
		],
		usdTotal: 44128501.82920405,
		isMetaPool: false,
		usdTotalExcludingBasePool: 44128501.82920405,
		gaugeAddress: "0x7ca5b0a2910b33e9759dc7ddb0413949071d7575",
		chainId: 1
	},
	{
		id: "5",
		address: "0x0Ce6a5fF5217e38315f87032CF90686C96627CAA",
		coinsAddresses: [
			"0xdB25f211AB05b1c97D595516F45794528a807ad8",
			"0xD71eCFF9342A5Ced620049e616c5035F1dB98620",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"2",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1004837642495550352",
		amplificationCoefficient: "100",
		assetType: "3",
		totalSupply: "5573105388686742935562589",
		lpTokenAddress: "0x194eBd173F6cDacE046C53eACcE9B953F28411d1",
		name: "Curve.fi EURS/sEUR",
		symbol: "eursCRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/eurs/swap",
				"https://classic.curve.fi/eurs"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/eurs/deposit",
				"https://classic.curve.fi/eurs/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/eurs/withdraw",
				"https://classic.curve.fi/eurs/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "other",
		coins: [
			{
				address: "0xdB25f211AB05b1c97D595516F45794528a807ad8",
				usdPrice: 1.017,
				decimals: "2",
				isBasePoolLpToken: false,
				symbol: "EURS",
				poolBalance: "396382834"
			},
			{
				address: "0xD71eCFF9342A5Ced620049e616c5035F1dB98620",
				usdPrice: 1.02717,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "sEUR",
				poolBalance: "1641966934529021777927302"
			}
		],
		usdTotal: 5717792.597920175,
		isMetaPool: false,
		usdTotalExcludingBasePool: 5717792.597920175,
		gaugeAddress: "0x90bb609649e0451e5ad952683d64bd2d1f245840",
		chainId: 1
	},
	{
		id: "6",
		address: "0x4CA9b3063Ec5866A4B82E437059D2C43d1be596F",
		coinsAddresses: [
			"0x0316EB71485b0Ab14103307bf65a021042c6d380",
			"0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"8",
			"0",
			"0"
		],
		virtualPrice: "1010006218529448406",
		amplificationCoefficient: "1000",
		assetType: "2",
		totalSupply: "225388172852452189282",
		lpTokenAddress: "0xb19059ebb43466c323583928285a49f558e572fd",
		name: "Curve.fi hBTC/wBTC",
		symbol: "hCRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/hbtc/swap",
				"https://classic.curve.fi/hbtc"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/hbtc/deposit",
				"https://classic.curve.fi/hbtc/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/hbtc/withdraw",
				"https://classic.curve.fi/hbtc/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "btc",
		coins: [
			{
				address: "0x0316EB71485b0Ab14103307bf65a021042c6d380",
				usdPrice: 16057.268741659198,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "HBTC",
				poolBalance: "32812283975107019101"
			},
			{
				address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
				usdPrice: 15973.32,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "WBTC",
				poolBalance: "19494787680"
			}
		],
		usdTotal: 3640840.481262907,
		isMetaPool: false,
		usdTotalExcludingBasePool: 3640840.481262907,
		gaugeAddress: "0x4c18e409dc8619bfb6a1cb56d114c3f592e0ae79",
		chainId: 1
	},
	{
		id: "7",
		address: "0x2dded6Da1BF5DBdF597C45fcFaa3194e53EcfeAF",
		coinsAddresses: [
			"0x8e595470Ed749b85C6F7669de83EAe304C2ec68F",
			"0x76Eb2FE28b36B3ee97F3Adae0C69606eeDB2A37c",
			"0x48759F220ED983dB51fA7A8C0D2AAb8f3ce4166a",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"8",
			"8",
			"8",
			"0"
		],
		virtualPrice: "1058229665334902942",
		amplificationCoefficient: "6000",
		assetType: "0",
		totalSupply: "9907283395156475493753582",
		lpTokenAddress: "0x5282a4eF67D9C33135340fB3289cc1711c13638C",
		name: "Curve.fi cyDAI/cyUSDC/cyUSDT",
		symbol: "ib3CRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/ib/swap",
				"https://classic.curve.fi/ib"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/ib/deposit",
				"https://classic.curve.fi/ib/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/ib/withdraw",
				"https://classic.curve.fi/ib/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x8e595470Ed749b85C6F7669de83EAe304C2ec68F",
				usdPrice: 0.010616448941327605,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "iDAI",
				poolBalance: "21694742141372529"
			},
			{
				address: "0x76Eb2FE28b36B3ee97F3Adae0C69606eeDB2A37c",
				usdPrice: 0.010641916333184938,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "iUSDC",
				poolBalance: "9871560122148747"
			},
			{
				address: "0x48759F220ED983dB51fA7A8C0D2AAb8f3ce4166a",
				usdPrice: 0.010779834973995588,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "iUSDT",
				poolBalance: "66303388719338446"
			}
		],
		usdTotal: 10501130.277482107,
		isMetaPool: false,
		usdTotalExcludingBasePool: 10501130.277482107,
		gaugeAddress: "0xf5194c3325202f456c95c1cf0ca36f8475c1949f",
		chainId: 1
	},
	{
		id: "8",
		address: "0xF178C0b5Bb7e7aBF4e12A4838C7b7c5bA2C623c0",
		coinsAddresses: [
			"0x514910771AF9Ca656af840dff83E8264EcF986CA",
			"0xbBC455cb4F1B9e4bFC4B73970d360c8f032EfEE6",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1002724224498611053",
		amplificationCoefficient: "100",
		assetType: "3",
		totalSupply: "319578402792083636685957",
		lpTokenAddress: "0xcee60cFa923170e4f8204AE08B4fA6A3F5656F3a",
		name: "Curve.fi LINK/sLINK",
		symbol: "linkCRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/link/swap",
				"https://classic.curve.fi/link"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/link/deposit",
				"https://classic.curve.fi/link/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/link/withdraw",
				"https://classic.curve.fi/link/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "other",
		coins: [
			{
				address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
				usdPrice: 5.76,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "LINK",
				poolBalance: "192181361362023116863687"
			},
			{
				address: "0xbBC455cb4F1B9e4bFC4B73970d360c8f032EfEE6",
				usdPrice: 5.782340681035073,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "sLINK",
				poolBalance: "128333171441493002280341"
			}
		],
		usdTotal: 1849030.7593976464,
		isMetaPool: false,
		usdTotalExcludingBasePool: 1849030.7593976464,
		gaugeAddress: "0xfd4d8a17df4c27c1dd245d153ccf4499e806c87d",
		chainId: 1
	},
	{
		id: "9",
		address: "0x06364f10B501e868329afBc005b3492902d6C763",
		coinsAddresses: [
			"0x99d1Fa417f94dcD62BfE781a1213c092a47041Bc",
			"0x9777d7E2b60bB01759D0E2f8be2095df444cb07E",
			"0x1bE5d71F2dA660BFdee8012dDc58D024448A0A59",
			"0x8E870D67F660D95d5be530380D0eC0bd388289E1"
		],
		decimals: [
			"18",
			"6",
			"6",
			"18"
		],
		virtualPrice: "1039859318423721237",
		amplificationCoefficient: "200",
		assetType: "0",
		totalSupply: "301032995077683932361470",
		lpTokenAddress: "0xd905e2eaebe188fc92179b6350807d8bd91db0d8",
		name: "Curve.fi DAI/USDC/USDT/PAX",
		symbol: "ypaxCrv",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/pax/swap",
				"https://classic.curve.fi/pax"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/pax/deposit",
				"https://classic.curve.fi/pax/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/pax/withdraw",
				"https://classic.curve.fi/pax/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x99d1Fa417f94dcD62BfE781a1213c092a47041Bc",
				usdPrice: 1.0179785763336944,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "ycDAI",
				poolBalance: "66528454341895561932684"
			},
			{
				address: "0x9777d7E2b60bB01759D0E2f8be2095df444cb07E",
				usdPrice: 1.0257646634112652,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "ycUSDC",
				poolBalance: "70582422328"
			},
			{
				address: "0x1bE5d71F2dA660BFdee8012dDc58D024448A0A59",
				usdPrice: 1.0112281533049012,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "ycUSDT",
				poolBalance: "95390153697"
			},
			{
				address: "0x8E870D67F660D95d5be530380D0eC0bd388289E1",
				usdPrice: 0.9981,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "USDP",
				poolBalance: "75863744881027850501065"
			}
		],
		usdTotal: 312306.30865091865,
		isMetaPool: false,
		usdTotalExcludingBasePool: 312306.30865091865,
		gaugeAddress: "0x64e3c23bfc40722d3b649844055f1d51c1ac041d",
		chainId: 1
	},
	{
		id: "10",
		address: "0x93054188d876f558f4a66B2EF1d97d16eDf0895B",
		coinsAddresses: [
			"0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D",
			"0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"8",
			"8",
			"0",
			"0"
		],
		virtualPrice: "1023346299364298924",
		amplificationCoefficient: "1000",
		assetType: "2",
		totalSupply: "964041469231153417338",
		lpTokenAddress: "0x49849c98ae39fff122806c06791fa73784fb3675",
		name: "Curve.fi renBTC/wBTC",
		symbol: "crvRenWBTC",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/ren/swap",
				"https://classic.curve.fi/ren"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/ren/deposit",
				"https://classic.curve.fi/ren/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/ren/withdraw",
				"https://classic.curve.fi/ren/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "btc",
		coins: [
			{
				address: "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D",
				usdPrice: 16236.763813696798,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "renBTC",
				poolBalance: "8385787354"
			},
			{
				address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
				usdPrice: 15973.32,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "WBTC",
				poolBalance: "90378076823"
			}
		],
		usdTotal: 15797959.907371458,
		isMetaPool: false,
		usdTotalExcludingBasePool: 15797959.907371458,
		gaugeAddress: "0xb1f2cdec61db658f091671f5f199635aef202cac",
		chainId: 1
	},
	{
		id: "11",
		address: "0xEB16Ae0052ed37f479f7fe63849198Df1765a733",
		coinsAddresses: [
			"0x028171bCA77440897B824Ca71D1c56caC55b68A3",
			"0x6C5024Cd4F8A59110119C56f8933403A539555EB",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1081409022369385247",
		amplificationCoefficient: "100",
		assetType: "0",
		totalSupply: "1729253218535941585335520",
		lpTokenAddress: "0x02d341CcB60fAaf662bC0554d13778015d1b285C",
		name: "Curve.fi aDAI/aSUSD",
		symbol: "saCRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/saave/swap",
				"https://classic.curve.fi/saave"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/saave/deposit",
				"https://classic.curve.fi/saave/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/saave/withdraw",
				"https://classic.curve.fi/saave/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x028171bCA77440897B824Ca71D1c56caC55b68A3",
				usdPrice: 0.999324,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "aDAI",
				poolBalance: "1118864135903744092634932"
			},
			{
				address: "0x6C5024Cd4F8A59110119C56f8933403A539555EB",
				usdPrice: 1.0031219688221868,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "aSUSD",
				poolBalance: "751537138123592851186395"
			}
		],
		usdTotal: 1871991.1973854033,
		isMetaPool: false,
		usdTotalExcludingBasePool: 1871991.1973854033,
		gaugeAddress: "0x462253b8f74b72304c145db0e4eebd326b22ca39",
		chainId: 1
	},
	{
		id: "12",
		address: "0x7fC77b5c7614E1533320Ea6DDc2Eb61fa00A9714",
		coinsAddresses: [
			"0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D",
			"0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
			"0xfE18be6b3Bd88A2D2A7f928d00292E7a9963CfC6",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"8",
			"8",
			"18",
			"0"
		],
		virtualPrice: "1016021260928825566",
		amplificationCoefficient: "100",
		assetType: "2",
		totalSupply: "1082717368161550146980",
		lpTokenAddress: "0x075b1bb99792c9e1041ba13afef80c91a1e70fb3",
		name: "Curve.fi renBTC/wBTC/sBTC",
		symbol: "crvRenWSBTC",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/sbtc/swap",
				"https://classic.curve.fi/sbtc"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/sbtc/deposit",
				"https://classic.curve.fi/sbtc/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/sbtc/withdraw",
				"https://classic.curve.fi/sbtc/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "btc",
		coins: [
			{
				address: "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D",
				usdPrice: 16236.763813696798,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "renBTC",
				poolBalance: "19078306409"
			},
			{
				address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
				usdPrice: 15973.32,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "WBTC",
				poolBalance: "55216276001"
			},
			{
				address: "0xfE18be6b3Bd88A2D2A7f928d00292E7a9963CfC6",
				usdPrice: 16042.888085908799,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "sBTC",
				poolBalance: "358241909191020078591"
			}
		],
		usdTotal: 17664806.86583948,
		isMetaPool: false,
		usdTotalExcludingBasePool: 17664806.86583948,
		gaugeAddress: "0x705350c4bcd35c9441419ddd5d2f097d7a55410f",
		chainId: 1
	},
	{
		id: "13",
		address: "0xc5424B857f758E906013F3555Dad202e4bdB4567",
		coinsAddresses: [
			"0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
			"0x5e74C9036fb86BD7eCdcb084a0673EFc32eA31cb",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1016127724272466456",
		amplificationCoefficient: "256",
		assetType: "1",
		totalSupply: "13918788959118470156294",
		lpTokenAddress: "0xa3d87fffce63b53e0d54faa1cc983b7eb0b74a9c",
		name: "Curve.fi ETH/sETH",
		symbol: "eCRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/seth/swap",
				"https://classic.curve.fi/seth"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/seth/deposit",
				"https://classic.curve.fi/seth/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/seth/withdraw",
				"https://classic.curve.fi/seth/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "eth",
		coins: [
			{
				address: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
				usdPrice: 1123.52,
				poolBalance: "10041307681756591784598",
				decimals: 18,
				symbol: "ETH",
				isBasePoolLpToken: false
			},
			{
				address: "0x5e74C9036fb86BD7eCdcb084a0673EFc32eA31cb",
				usdPrice: 1128.4613471407768,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "sETH",
				poolBalance: "4107826238702924972573"
			}
		],
		usdTotal: 15917133.137754096,
		isMetaPool: false,
		usdTotalExcludingBasePool: 15917133.137754096,
		gaugeAddress: "0x3c0ffff15ea30c35d7a85b85c0782d6c94e1d238",
		chainId: 1
	},
	{
		id: "14",
		address: "0xDC24316b9AE028F1497c275EB9192a3Ea0f67022",
		coinsAddresses: [
			"0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
			"0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1057526487141361750",
		amplificationCoefficient: "50",
		assetType: "1",
		totalSupply: "678731450953530787116292",
		lpTokenAddress: "0x06325440D014e39736583c165C2963BA99fAf14E",
		name: "Curve.fi ETH/stETH",
		symbol: "steCRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/steth/swap",
				"https://classic.curve.fi/steth"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/steth/deposit",
				"https://classic.curve.fi/steth/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/steth/withdraw",
				"https://classic.curve.fi/steth/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "eth",
		coins: [
			{
				address: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
				usdPrice: 1123.52,
				poolBalance: "246080388564346409368451",
				decimals: 18,
				symbol: "ETH",
				isBasePoolLpToken: false
			},
			{
				address: "0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84",
				usdPrice: 1106.2260202903078,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "stETH",
				poolBalance: "472469969361839539422751"
			}
		],
		usdTotal: 799134812.0736458,
		isMetaPool: false,
		usdTotalExcludingBasePool: 799134812.0736458,
		gaugeAddress: "0x182b723a58739a9c974cfdb385ceadb237453c28",
		chainId: 1
	},
	{
		id: "15",
		address: "0xA5407eAE9Ba41422680e2e00537571bcC53efBfD",
		coinsAddresses: [
			"0x6B175474E89094C44Da98b954EedeAC495271d0F",
			"0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
			"0xdAC17F958D2ee523a2206206994597C13D831ec7",
			"0x57Ab1ec28D129707052df4dF418D58a2D46d5f51"
		],
		decimals: [
			"18",
			"6",
			"6",
			"18"
		],
		virtualPrice: "1058842402449106446",
		amplificationCoefficient: "100",
		assetType: "0",
		totalSupply: "54311661177548321976488148",
		lpTokenAddress: "0xc25a3a3b969415c80451098fa907ec722572917f",
		name: "Curve.fi DAI/USDC/USDT/sUSD",
		symbol: "crvPlain3andSUSD",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/susdv2/swap",
				"https://classic.curve.fi/susdv2"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/susdv2/deposit",
				"https://classic.curve.fi/susdv2/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/susdv2/withdraw",
				"https://classic.curve.fi/susdv2/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "14604149751026679543955588"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "14932698961667"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "17100871974448"
			},
			{
				address: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
				usdPrice: 1.0061236277506873,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "sUSD",
				poolBalance: "10877413547827505178972700"
			}
		],
		usdTotal: 57642656.78765389,
		isMetaPool: false,
		usdTotalExcludingBasePool: 57642656.78765389,
		gaugeAddress: "0xa90996896660decc6e997655e065b23788857849",
		chainId: 1
	},
	{
		id: "16",
		address: "0x52EA46506B9CC5Ef470C5bf89f17Dc28bB35D85C",
		coinsAddresses: [
			"0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643",
			"0x39AA39c021dfbaE8faC545936693aC917d5E7563",
			"0xdAC17F958D2ee523a2206206994597C13D831ec7",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"8",
			"8",
			"6",
			"0"
		],
		virtualPrice: "2931296926145059371",
		amplificationCoefficient: "2000",
		assetType: "0",
		totalSupply: "143883891300111978016656",
		lpTokenAddress: "0x9fc689ccada600b6df723d9e47d84d76664a1f23",
		name: "Curve.fi cDAI/cUSDC/USDT",
		symbol: "cDAI+cUSDC+USDT",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/usdt/swap",
				"https://classic.curve.fi/usdt"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/usdt/deposit",
				"https://classic.curve.fi/usdt/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/usdt/withdraw",
				"https://classic.curve.fi/usdt/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643",
				usdPrice: 0.02213429,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "cDAI",
				poolBalance: "312529381882996"
			},
			{
				address: "0x39AA39c021dfbaE8faC545936693aC917d5E7563",
				usdPrice: 0.0227057174630131,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "cUSDC",
				poolBalance: "336181117045820"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "276505208831"
			}
		],
		usdTotal: 422290.2083614461,
		isMetaPool: false,
		usdTotalExcludingBasePool: 422290.2083614461,
		gaugeAddress: "0xbc89cd85491d81c6ad2954e6d0362ee29fca8f53",
		chainId: 1
	},
	{
		id: "17",
		address: "0x45F783CCE6B7FF23B2ab2D70e416cdb7D6055f51",
		coinsAddresses: [
			"0x16de59092dAE5CcF4A1E6439D611fd0653f0Bd01",
			"0xd6aD7a6750A7593E092a9B218d66C0A814a3436e",
			"0x83f798e925BcD4017Eb265844FDDAbb448f1707D",
			"0x73a052500105205d34Daf004eAb301916DA8190f"
		],
		decimals: [
			"18",
			"6",
			"6",
			"18"
		],
		virtualPrice: "1142180819301074068",
		amplificationCoefficient: "2048",
		assetType: "0",
		totalSupply: "8779173860236240934727369",
		lpTokenAddress: "0xdf5e0e81dff6faf3a7e52ba697820c5e32d806a8",
		name: "Curve.fi yDAI/yUSDC/yUSDT/yTUSD",
		symbol: "yDAI+yUSDC+yUSDT+yTUSD",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/iearn/swap",
				"https://classic.curve.fi/iearn"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/iearn/deposit",
				"https://classic.curve.fi/iearn/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/iearn/withdraw",
				"https://classic.curve.fi/iearn/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x16de59092dAE5CcF4A1E6439D611fd0653f0Bd01",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "yDAI",
				poolBalance: "1404093736534232082291630"
			},
			{
				address: "0xd6aD7a6750A7593E092a9B218d66C0A814a3436e",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "yUSDC",
				poolBalance: "1183790511046"
			},
			{
				address: "0x83f798e925BcD4017Eb265844FDDAbb448f1707D",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "yUSDT",
				poolBalance: "5081197367616"
			},
			{
				address: "0x73a052500105205d34Daf004eAb301916DA8190f",
				usdPrice: 0.9785544807351984,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "yTUSD",
				poolBalance: "1285697872502557945550681"
			}
		],
		usdTotal: 8936500.50778254,
		isMetaPool: false,
		usdTotalExcludingBasePool: 8936500.50778254,
		gaugeAddress: "0xfa712ee4788c042e2b7bb55e6cb8ec569c4530c1",
		chainId: 1
	},
	{
		id: "18",
		address: "0x8038C01A0390a8c547446a0b2c18fc9aEFEcc10c",
		coinsAddresses: [
			"0x5BC25f649fc4e26069dDF4cF4010F9f706c23831",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1022279505146196552",
		amplificationCoefficient: "200",
		underlyingDecimals: [
			"18",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "99739221631706136142093",
		lpTokenAddress: "0x3a664ab939fd8482048609f652f9a0b0677337b9",
		name: "Curve.fi DUSD/3Crv",
		symbol: "dusd3CRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/dusd/swap",
				"https://classic.curve.fi/dusd"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/dusd/deposit",
				"https://classic.curve.fi/dusd/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/dusd/withdraw",
				"https://classic.curve.fi/dusd/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x5BC25f649fc4e26069dDF4cF4010F9f706c23831",
				usdPrice: 0.9962182592500776,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DUSD",
				poolBalance: "69369844042026362965055"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "31906840356106851256666"
			}
		],
		usdTotal: 101780.27374549535,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x5BC25f649fc4e26069dDF4cF4010F9f706c23831",
				usdPrice: 0.9962182592500776,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DUSD",
				poolBalance: "69369844042026362965055"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "5565734129664596307913"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "5484360683"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "21584392063"
			}
		],
		usdTotalExcludingBasePool: 69107.50527599687,
		gaugeAddress: "0xaea6c312f4b3e04d752946d329693f7293bc2e6d",
		chainId: 1
	},
	{
		id: "19",
		address: "0x4f062658EaAF2C1ccf8C8e36D6824CDf41167956",
		coinsAddresses: [
			"0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"2",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1030405116771762493",
		amplificationCoefficient: "1000",
		underlyingDecimals: [
			"2",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "17259595921438266061339238",
		lpTokenAddress: "0xd2967f45c4f384deea880f807be904762a3dea07",
		name: "Curve.fi GUSD/3Crv",
		symbol: "gusd3CRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/gusd/swap",
				"https://classic.curve.fi/gusd"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/gusd/deposit",
				"https://classic.curve.fi/gusd/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/gusd/withdraw",
				"https://classic.curve.fi/gusd/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
				usdPrice: 1.0012660019727615,
				decimals: "2",
				isBasePoolLpToken: false,
				symbol: "GUSD",
				poolBalance: "747924924"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "10077179861140128001506112"
			}
		],
		usdTotal: 17807801.941018753,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
				usdPrice: 1.0012660019727615,
				decimals: "2",
				isBasePoolLpToken: false,
				symbol: "GUSD",
				poolBalance: "747924924"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "1757833218768762305337617"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "1732132934712"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "6817027276313"
			}
		],
		usdTotalExcludingBasePool: 7488717.984292615,
		gaugeAddress: "0xc5cfada84e902ad92dd40194f0883ad49639b023",
		chainId: 1
	},
	{
		id: "20",
		address: "0x3eF6A01A0f81D6046290f3e2A8c5b843e738E604",
		coinsAddresses: [
			"0xdF574c24545E5FfEcb9a659c229253D4111d87e1",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"8",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1054369962038525227",
		amplificationCoefficient: "200",
		underlyingDecimals: [
			"8",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "27476001216240353276826",
		lpTokenAddress: "0x5B5CFE992AdAC0C9D48E05854B2d91C73a003858",
		name: "Curve.fi HUSD/3Crv",
		symbol: "husd3CRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/husd/swap",
				"https://classic.curve.fi/husd"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/husd/deposit",
				"https://classic.curve.fi/husd/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/husd/withdraw",
				"https://classic.curve.fi/husd/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xdF574c24545E5FfEcb9a659c229253D4111d87e1",
				usdPrice: 0.07828567476811867,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "HUSD",
				poolBalance: "3119966163750"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "190714597377779898273"
			}
		],
		usdTotal: 2637.779291479947,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0xdF574c24545E5FfEcb9a659c229253D4111d87e1",
				usdPrice: 0.07828567476811867,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "HUSD",
				poolBalance: "3119966163750"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "33267685919505056065"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "32781298"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "129014926"
			}
		],
		usdTotalExcludingBasePool: 2442.4865638286738,
		gaugeAddress: "0x2db0e83599a91b508ac268a6197b8b14f5e72840",
		chainId: 1
	},
	{
		id: "21",
		address: "0xE7a24EF0C5e95Ffb0f6684b813A78F2a3AD7D171",
		coinsAddresses: [
			"0x0E2EC54fC0B509F445631Bf4b91AB8168230C752",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1011532803039661487",
		amplificationCoefficient: "5",
		underlyingDecimals: [
			"18",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "36360840319108742830714",
		lpTokenAddress: "0x6d65b498cb23deaba52db31c93da9bffb340fb8f",
		name: "Curve.fi LinkUSD/3Crv",
		symbol: "LinkUSD3CRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/linkusd/swap",
				"https://classic.curve.fi/linkusd"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/linkusd/deposit",
				"https://classic.curve.fi/linkusd/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/linkusd/withdraw",
				"https://classic.curve.fi/linkusd/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x0E2EC54fC0B509F445631Bf4b91AB8168230C752",
				usdPrice: 0.940540359566019,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "LINKUSD",
				poolBalance: "21724023155121949232364"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "14820497610326311203719"
			}
		],
		usdTotal: 35608.58625371316,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x0E2EC54fC0B509F445631Bf4b91AB8168230C752",
				usdPrice: 0.940540359566019,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "LINKUSD",
				poolBalance: "21724023155121949232364"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "2585243428925673507152"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "2547446049"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "10025794702"
			}
		],
		usdTotalExcludingBasePool: 20432.320549538923,
		chainId: 1
	},
	{
		id: "22",
		address: "0x8474DdbE98F5aA3179B3B3F5942D724aFcdec9f6",
		coinsAddresses: [
			"0xe2f2a5C287993345a840Db3B0845fbC70f5935a5",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1018636149854079478",
		amplificationCoefficient: "200",
		underlyingDecimals: [
			"18",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "2799582401934857914681857",
		lpTokenAddress: "0x1aef73d49dedc4b1778d0706583995958dc862e6",
		name: "Curve.fi MUSD/3Crv",
		symbol: "musd3CRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/musd/swap",
				"https://classic.curve.fi/musd"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/musd/deposit",
				"https://classic.curve.fi/musd/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/musd/withdraw",
				"https://classic.curve.fi/musd/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xe2f2a5C287993345a840Db3B0845fbC70f5935a5",
				usdPrice: 1.0016975146130052,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "mUSD",
				poolBalance: "1317522743522641660512342"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "1500303041855330658563644"
			}
		],
		usdTotal: 2856077.2814022535,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0xe2f2a5C287993345a840Db3B0845fbC70f5935a5",
				usdPrice: 1.0016975146130052,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "mUSD",
				poolBalance: "1317522743522641660512342"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "261708390793249134851126"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "257882100613"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "1014927479711"
			}
		],
		usdTotalExcludingBasePool: 1319759.257632738,
		gaugeAddress: "0x5f626c30ec1215f4edcc9982265e8b1f411d1352",
		chainId: 1
	},
	{
		id: "23",
		address: "0xC18cC39da8b11dA8c3541C598eE022258F9744da",
		coinsAddresses: [
			"0x196f4727526eA7FB1e17b2071B3d8eAA38486988",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1029390083335817967",
		amplificationCoefficient: "200",
		underlyingDecimals: [
			"18",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "20669414070765636657611",
		lpTokenAddress: "0xc2ee6b0334c261ed60c72f6054450b61b8f18e35",
		name: "Curve.fi RSV/3Crv",
		symbol: "rsv3CRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/rsv/swap",
				"https://classic.curve.fi/rsv"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/rsv/deposit",
				"https://classic.curve.fi/rsv/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/rsv/withdraw",
				"https://classic.curve.fi/rsv/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x196f4727526eA7FB1e17b2071B3d8eAA38486988",
				usdPrice: 1.0051212049493914,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "RSV",
				poolBalance: "7100390539158131036717"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "13869050429328508920341"
			}
		],
		usdTotal: 21338.731996403127,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x196f4727526eA7FB1e17b2071B3d8eAA38486988",
				usdPrice: 1.0051212049493914,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "RSV",
				poolBalance: "7100390539158131036717"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "2419275818571579489737"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "2383904957"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "9382158141"
			}
		],
		usdTotalExcludingBasePool: 7136.753094329879,
		gaugeAddress: "0x4dc4a289a8e33600d8bd4cf5f6313e43a37adec7",
		chainId: 1
	},
	{
		id: "24",
		address: "0x3E01dD8a5E1fb3481F0F589056b428Fc308AF0Fb",
		coinsAddresses: [
			"0x1c48f86ae57291F7686349F12601910BD8D470bb",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "2078315149581511819",
		amplificationCoefficient: "200",
		underlyingDecimals: [
			"18",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "92079457724872318689535",
		lpTokenAddress: "0x97e2768e8e73511ca874545dc5ff8067eb19b787",
		name: "Curve.fi USDK/3Crv",
		symbol: "usdk3CRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/usdk/swap",
				"https://classic.curve.fi/usdk"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/usdk/deposit",
				"https://classic.curve.fi/usdk/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/usdk/withdraw",
				"https://classic.curve.fi/usdk/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x1c48f86ae57291F7686349F12601910BD8D470bb",
				usdPrice: 0.9999131008127681,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "USDK",
				poolBalance: "105282238261963094761170"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "84186498641335730973643"
			}
		],
		usdTotal: 191480.496499773,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x1c48f86ae57291F7686349F12601910BD8D470bb",
				usdPrice: 0.9999131008127681,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "USDK",
				poolBalance: "105282238261963094761170"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "14685241895328063284051"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "14470537290"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "56950621646"
			}
		],
		usdTotalExcludingBasePool: 105273.0893210282,
		gaugeAddress: "0xc2b1df84112619d190193e48148000e3990bf627",
		chainId: 1
	},
	{
		id: "25",
		address: "0x0f9cb53Ebe405d49A0bbdBD291A65Ff571bC83e1",
		coinsAddresses: [
			"0x674C6Ad92Fd080e4004b2312b45f796a192D27a0",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1064454955028284869",
		amplificationCoefficient: "250",
		underlyingDecimals: [
			"18",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "9406559756729139418446138",
		lpTokenAddress: "0x4f3e8f405cf5afc05d68142f3783bdfe13811522",
		name: "Curve.fi USDN/3Crv",
		symbol: "usdn3CRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/usdn/swap",
				"https://classic.curve.fi/usdn"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/usdn/deposit",
				"https://classic.curve.fi/usdn/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/usdn/withdraw",
				"https://classic.curve.fi/usdn/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x674C6Ad92Fd080e4004b2312b45f796a192D27a0",
				usdPrice: 0.8970105006804071,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "USDN",
				poolBalance: "9423218466650958210751017"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "636964442465334140594958"
			}
		],
		usdTotal: 9104980.776748952,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x674C6Ad92Fd080e4004b2312b45f796a192D27a0",
				usdPrice: 0.8970105006804071,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "USDN",
				poolBalance: "9423218466650958210751017"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "111110178796928674484254"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "109485699793"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "430894758073"
			}
		],
		usdTotalExcludingBasePool: 8452725.914791433,
		gaugeAddress: "0xf98450b5602fa59cc66e1379dffb6fddc724cfc4",
		chainId: 1
	},
	{
		id: "26",
		address: "0x42d7025938bEc20B69cBae5A77421082407f053A",
		coinsAddresses: [
			"0x1456688345527bE1f37E9e627DA0837D6f08C925",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1009339182676231390",
		amplificationCoefficient: "100",
		underlyingDecimals: [
			"18",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "4060596476717699943509542",
		lpTokenAddress: "0x7Eb40E450b9655f4B3cC4259BCC731c63ff55ae6",
		name: "Curve.fi USDP/3Crv",
		symbol: "usdp3CRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/usdp/swap",
				"https://classic.curve.fi/usdp"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/usdp/deposit",
				"https://classic.curve.fi/usdp/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/usdp/withdraw",
				"https://classic.curve.fi/usdp/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x1456688345527bE1f37E9e627DA0837D6f08C925",
				usdPrice: 0.9970575581670778,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "USDP",
				poolBalance: "2424970101972795837146252"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "1637182278589860961312273"
			}
		],
		usdTotal: 4094317.8340045298,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x1456688345527bE1f37E9e627DA0837D6f08C925",
				usdPrice: 0.9970575581670778,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "USDP",
				poolBalance: "2424970101972795837146252"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "285585196864709766385332"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "281409817424"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "1107523771852"
			}
		],
		usdTotalExcludingBasePool: 2417834.768501165,
		gaugeAddress: "0x055be5ddb7a925bfef3417fc157f53ca77ca7222",
		chainId: 1
	},
	{
		id: "27",
		address: "0x890f4e345B1dAED0367A877a1612f86A1f86985f",
		coinsAddresses: [
			"0xa47c8bf37f92aBed4A126BDA807A7b7498661acD",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1067474650917107125",
		amplificationCoefficient: "100",
		underlyingDecimals: [
			"18",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "297302631552091288824147",
		lpTokenAddress: "0x94e131324b6054c0D789b190b2dAC504e4361b53",
		name: "Curve.fi UST/3Crv",
		symbol: "ust3CRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/ust/swap",
				"https://classic.curve.fi/ust"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/ust/deposit",
				"https://classic.curve.fi/ust/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/ust/withdraw",
				"https://classic.curve.fi/ust/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xa47c8bf37f92aBed4A126BDA807A7b7498661acD",
				usdPrice: 0.021183797569128218,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "UST",
				poolBalance: "389764817174525084421776"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "1330375409115353795710"
			}
		],
		usdTotal: 9619.010241309074,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0xa47c8bf37f92aBed4A126BDA807A7b7498661acD",
				usdPrice: 0.021183797569128218,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "UST",
				poolBalance: "389764817174525084421776"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "232066721027192763595"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "228673805"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "899974554"
			}
		],
		usdTotalExcludingBasePool: 8256.69898659341,
		gaugeAddress: "0x3b7020743bc2a4ca9eaf9d0722d42e20d6935855",
		chainId: 1
	},
	{
		id: "28",
		address: "0x071c661B4DeefB59E2a3DdB20Db036821eeE8F4b",
		coinsAddresses: [
			"0x9BE89D2a4cd102D8Fecc6BF9dA793be995C22541",
			"0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"8",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1017222106161124367",
		amplificationCoefficient: "200",
		underlyingDecimals: [
			"8",
			"8",
			"8",
			"18",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "2",
		totalSupply: "24605069875425434344",
		lpTokenAddress: "0x410e3E86ef427e30B9235497143881f717d93c2A",
		name: "Curve.fi bBTC/sbtcCRV",
		symbol: "bBTC/sbtcCRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/bbtc/swap",
				"https://classic.curve.fi/bbtc"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/bbtc/deposit",
				"https://classic.curve.fi/bbtc/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/bbtc/withdraw",
				"https://classic.curve.fi/bbtc/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "btc",
		coins: [
			{
				address: "0x9BE89D2a4cd102D8Fecc6BF9dA793be995C22541",
				usdPrice: 16058.809808743661,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "BBTC",
				poolBalance: "1145066807"
			},
			{
				address: "0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3",
				usdPrice: 16315.252147321007,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "sbtcCrv",
				poolBalance: "13364490230043994820"
			}
		],
		usdTotal: 401929.12864275975,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x9BE89D2a4cd102D8Fecc6BF9dA793be995C22541",
				usdPrice: 16058.809808743661,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "BBTC",
				poolBalance: "1145066807"
			},
			{
				address: "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D",
				usdPrice: 16236.763813696798,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "renBTC",
				poolBalance: "235492518"
			},
			{
				address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
				usdPrice: 15973.32,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "WBTC",
				poolBalance: "681560491"
			},
			{
				address: "0xfE18be6b3Bd88A2D2A7f928d00292E7a9963CfC6",
				usdPrice: 16042.888085908799,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "sBTC",
				poolBalance: "4421948549237023916"
			}
		],
		usdTotalExcludingBasePool: 183884.10071918386,
		gaugeAddress: "0xdfc7adfa664b08767b735de28f9e84cd30492aee",
		chainId: 1
	},
	{
		id: "29",
		address: "0xd81dA8D904b52208541Bade1bD6595D8a251F8dd",
		coinsAddresses: [
			"0x8064d9Ae6cDf087b1bcd5BDf3531bD5d8C537a68",
			"0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1007479200495595935",
		amplificationCoefficient: "200",
		underlyingDecimals: [
			"18",
			"8",
			"8",
			"18",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "2",
		totalSupply: "25107650416390388361",
		lpTokenAddress: "0x2fE94ea3d5d4a175184081439753DE15AeF9d614",
		name: "Curve.fi oBTC/sbtcCRV",
		symbol: "oBTC/sbtcCRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/obtc/swap",
				"https://classic.curve.fi/obtc"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/obtc/deposit",
				"https://classic.curve.fi/obtc/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/obtc/withdraw",
				"https://classic.curve.fi/obtc/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "btc",
		coins: [
			{
				address: "0x8064d9Ae6cDf087b1bcd5BDf3531bD5d8C537a68",
				usdPrice: 16035.022842474391,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "oBTC",
				poolBalance: "13427794658128831815"
			},
			{
				address: "0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3",
				usdPrice: 16315.252147321007,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "sbtcCrv",
				poolBalance: "11680740910665404367"
			}
		],
		usdTotal: 405889.22729218553,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x8064d9Ae6cDf087b1bcd5BDf3531bD5d8C537a68",
				usdPrice: 16035.022842474391,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "oBTC",
				poolBalance: "13427794658128831815"
			},
			{
				address: "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D",
				usdPrice: 16236.763813696798,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "renBTC",
				poolBalance: "205823570"
			},
			{
				address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
				usdPrice: 15973.32,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "WBTC",
				poolBalance: "595692868"
			},
			{
				address: "0xfE18be6b3Bd88A2D2A7f928d00292E7a9963CfC6",
				usdPrice: 16042.888085908799,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "sBTC",
				poolBalance: "3864841414438327753"
			}
		],
		usdTotalExcludingBasePool: 215314.99406715142,
		gaugeAddress: "0x11137b10c210b579405c21a07489e28f3c040ab1",
		chainId: 1
	},
	{
		id: "30",
		address: "0x7F55DDe206dbAD629C080068923b36fe9D6bDBeF",
		coinsAddresses: [
			"0x5228a22e72ccC52d415EcFd199F99D0665E7733b",
			"0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1009507786582024095",
		amplificationCoefficient: "200",
		underlyingDecimals: [
			"18",
			"8",
			"8",
			"18",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "2",
		totalSupply: "21456249285685826634",
		lpTokenAddress: "0xDE5331AC4B3630f94853Ff322B66407e0D6331E8",
		name: "Curve.fi pBTC/sbtcCRV",
		symbol: "pBTC/sbtcCRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/pbtc/swap",
				"https://classic.curve.fi/pbtc"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/pbtc/deposit",
				"https://classic.curve.fi/pbtc/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/pbtc/withdraw",
				"https://classic.curve.fi/pbtc/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "btc",
		coins: [
			{
				address: "0x5228a22e72ccC52d415EcFd199F99D0665E7733b",
				usdPrice: 16024.510280013345,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "pBTC",
				poolBalance: "12066556482568123083"
			},
			{
				address: "0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3",
				usdPrice: 16315.252147321007,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "sbtcCrv",
				poolBalance: "9443114683809297922"
			}
		],
		usdTotal: 347427.45552169275,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x5228a22e72ccC52d415EcFd199F99D0665E7733b",
				usdPrice: 16024.510280013345,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "pBTC",
				poolBalance: "12066556482568123083"
			},
			{
				address: "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D",
				usdPrice: 16236.763813696798,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "renBTC",
				poolBalance: "166394888"
			},
			{
				address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
				usdPrice: 15973.32,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "WBTC",
				poolBalance: "481578704"
			},
			{
				address: "0xfE18be6b3Bd88A2D2A7f928d00292E7a9963CfC6",
				usdPrice: 16042.888085908799,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "sBTC",
				poolBalance: "3124471383313802769"
			}
		],
		usdTotalExcludingBasePool: 193360.65839927454,
		gaugeAddress: "0xd7d147c6bb90a718c3de8c0568f9b560c79fa416",
		chainId: 1
	},
	{
		id: "31",
		address: "0xC25099792E9349C7DD09759744ea681C7de2cb66",
		coinsAddresses: [
			"0x8dAEBADE922dF735c38C80C7eBD708Af50815fAa",
			"0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1011855076080594610",
		amplificationCoefficient: "150",
		underlyingDecimals: [
			"18",
			"8",
			"8",
			"18",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "2",
		totalSupply: "86300064033928747612",
		lpTokenAddress: "0x64eda51d3Ad40D56b9dFc5554E06F94e1Dd786Fd",
		name: "Curve.fi tBTC/sbtcCrv",
		symbol: "tbtc/sbtcCrv",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/tbtc/swap",
				"https://classic.curve.fi/tbtc"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/tbtc/deposit",
				"https://classic.curve.fi/tbtc/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/tbtc/withdraw",
				"https://classic.curve.fi/tbtc/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "btc",
		coins: [
			{
				address: "0x8dAEBADE922dF735c38C80C7eBD708Af50815fAa",
				usdPrice: 16048.16620091469,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "TBTC",
				poolBalance: "43858112610110658315"
			},
			{
				address: "0x075b1bb99792c9E1041bA13afEf80C91a1e70fB3",
				usdPrice: 16315.252147321007,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "sbtcCrv",
				poolBalance: "42779666901417642228"
			}
		],
		usdTotal: 1401803.3327005198,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x8dAEBADE922dF735c38C80C7eBD708Af50815fAa",
				usdPrice: 16048.16620091469,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "TBTC",
				poolBalance: "43858112610110658315"
			},
			{
				address: "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D",
				usdPrice: 16236.763813696798,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "renBTC",
				poolBalance: "753810382"
			},
			{
				address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
				usdPrice: 15973.32,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "WBTC",
				poolBalance: "2181671750"
			},
			{
				address: "0xfE18be6b3Bd88A2D2A7f928d00292E7a9963CfC6",
				usdPrice: 16042.888085908799,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "sBTC",
				poolBalance: "14154635360973595869"
			}
		],
		usdTotalExcludingBasePool: 703842.2804254883,
		gaugeAddress: "0x6828bcf74279ee32f2723ec536c22c51eed383c6",
		chainId: 1
	},
	{
		id: "32",
		address: "0xEcd5e75AFb02eFa118AF914515D6521aaBd189F1",
		coinsAddresses: [
			"0x0000000000085d4780B73119b644AE5ecd22b376",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1007097605026111345",
		amplificationCoefficient: "600",
		underlyingDecimals: [
			"18",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "35381394859277725885874667",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/tusd/swap",
				"https://classic.curve.fi/tusd"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/tusd/deposit",
				"https://classic.curve.fi/tusd/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/tusd/withdraw",
				"https://classic.curve.fi/tusd/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x0000000000085d4780B73119b644AE5ecd22b376",
				usdPrice: 1.0015450976879605,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "TUSD",
				poolBalance: "14729195830055305861327129"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "20441386866203539569474360"
			}
		],
		usdTotal: 35684039.06012048,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x0000000000085d4780B73119b644AE5ecd22b376",
				usdPrice: 1.0015450976879605,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "TUSD",
				poolBalance: "14729195830055305861327129"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "3565734597005662047921165"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "3513602010686"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "13828223149011"
			}
		],
		usdTotalExcludingBasePool: 14751953.876477841,
		gaugeAddress: "0x359fd5d6417ae3d8d6497d9b2e7a890798262ba4",
		chainId: 1
	},
	{
		id: "33",
		address: "0xEd279fDD11cA84bEef15AF5D39BB4d4bEE23F0cA",
		coinsAddresses: [
			"0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1017301941987312156",
		amplificationCoefficient: "500",
		underlyingDecimals: [
			"18",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "61873314404171802286862132",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/lusd/swap",
				"https://classic.curve.fi/lusd"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/lusd/deposit",
				"https://classic.curve.fi/lusd/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/lusd/withdraw",
				"https://classic.curve.fi/lusd/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
				usdPrice: 1.0399841981066111,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "LUSD",
				poolBalance: "5004492751184211261223360"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "56804635286074515329294608"
			}
		],
		usdTotal: 63372831.78927829,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
				usdPrice: 1.0399841981066111,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "LUSD",
				poolBalance: "5004492751184211261223360"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "9908831266469886818059355"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "9763959855748"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "38427293498992"
			}
		],
		usdTotalExcludingBasePool: 5204593.38077066,
		gaugeAddress: "0x9b8519a9a00100720ccdc8a120fbed319ca47a14",
		chainId: 1
	},
	{
		id: "34",
		address: "0xd632f22692FaC7611d2AA1C0D552930D43CAEd3B",
		coinsAddresses: [
			"0x853d955aCEf822Db058eb8505911ED77F175b99e",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1008947548363215258",
		amplificationCoefficient: "1500",
		underlyingDecimals: [
			"18",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "417364928491946968882800803",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/frax/swap",
				"https://classic.curve.fi/frax"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/frax/deposit",
				"https://classic.curve.fi/frax/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/frax/withdraw",
				"https://classic.curve.fi/frax/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
				usdPrice: 1.0006972361613427,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "FRAX",
				poolBalance: "245529357589595909695896974"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "171686458645172530746217938"
			}
		],
		usdTotal: 421508365.3544126,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
				usdPrice: 1.0006972361613427,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "FRAX",
				poolBalance: "245529357589595909695896974"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "29948474114573215257427596"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "29510614433923"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "116142739108086"
			}
		],
		usdTotalExcludingBasePool: 245700549.53637862,
		gaugeAddress: "0x72e158d38dbd50a483501c24f792bdaaa3e7d55c",
		chainId: 1
	},
	{
		id: "35",
		address: "0x4807862AA8b2bF68830e4C8dc86D0e9A998e085a",
		coinsAddresses: [
			"0x4Fabb145d64652a948d72533023f6E7A623C7C53",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1009068135155409120",
		amplificationCoefficient: "5000",
		underlyingDecimals: [
			"18",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "21241227396962178435336010",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/busdv2/swap",
				"https://classic.curve.fi/busdv2"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/busdv2/deposit",
				"https://classic.curve.fi/busdv2/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/busdv2/withdraw",
				"https://classic.curve.fi/busdv2/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
				usdPrice: 1.0017419058572385,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "BUSD",
				poolBalance: "3683841630294217252176005"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "17358575967408258352739044"
			}
		],
		usdTotal: 21465529.518676464,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
				usdPrice: 1.0017419058572385,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "BUSD",
				poolBalance: "3683841630294217252176005"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "3027978252496830676389941"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "2983707897166"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "11742758140508"
			}
		],
		usdTotalExcludingBasePool: 3690258.535607166,
		gaugeAddress: "0xd4b22fedca85e684919955061fdf353b9d38389b",
		chainId: 1
	},
	{
		id: "36",
		address: "0xF9440930043eb3997fc70e1339dBb11F341de7A8",
		coinsAddresses: [
			"0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
			"0x9559Aaa82d9649C7A7b220E7c461d2E74c9a3593",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1018321793537937522",
		amplificationCoefficient: "10",
		assetType: "1",
		totalSupply: "1933430232349537384465",
		lpTokenAddress: "0x53a901d48795C58f485cBB38df08FA96a24669D5",
		name: "Curve.fi ETH/rETH",
		symbol: "rCRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/reth/swap",
				"https://classic.curve.fi/reth"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/reth/deposit",
				"https://classic.curve.fi/reth/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/reth/withdraw",
				"https://classic.curve.fi/reth/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "eth",
		coins: [
			{
				address: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
				usdPrice: 1123.52,
				poolBalance: "485254266524507127615",
				decimals: 18,
				symbol: "ETH",
				isBasePoolLpToken: false
			},
			{
				address: "0x9559Aaa82d9649C7A7b220E7c461d2E74c9a3593",
				usdPrice: 957.42,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "rETH",
				poolBalance: "1472424898931781636013"
			}
		],
		usdTotal: 1954921.9202608806,
		isMetaPool: false,
		usdTotalExcludingBasePool: 1954921.9202608806,
		gaugeAddress: "0x824f13f1a2f29cfeea81154b46c0fc820677a637",
		chainId: 1
	},
	{
		id: "37",
		address: "0x43b4FdFD4Ff969587185cDB6f0BD875c5Fc83f8c",
		coinsAddresses: [
			"0xBC6DA0FE9aD5f3b0d58160288917AA56653660E9",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1010429819272092005",
		amplificationCoefficient: "200",
		underlyingDecimals: [
			"18",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "75873259360862324608728581",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/alusd/swap",
				"https://classic.curve.fi/alusd"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/alusd/deposit",
				"https://classic.curve.fi/alusd/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/alusd/withdraw",
				"https://classic.curve.fi/alusd/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xBC6DA0FE9aD5f3b0d58160288917AA56653660E9",
				usdPrice: 0.9936122069084513,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "alUSD",
				poolBalance: "56016993323231858626237417"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "20240527943277417353808130"
			}
		],
		usdTotal: 76385572.97477832,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0xBC6DA0FE9aD5f3b0d58160288917AA56653660E9",
				usdPrice: 0.9936122069084513,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "alUSD",
				poolBalance: "56016993323231858626237417"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "3530697365173848621697379"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "3479077038379"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "13692345773084"
			}
		],
		usdTotalExcludingBasePool: 55659168.36027239,
		gaugeAddress: "0x9582c4adacb3bce56fea3e590f05c3ca2fb9c477",
		chainId: 1
	},
	{
		id: "38",
		address: "0x80466c64868E1ab14a1Ddf27A676C3fcBE638Fe5",
		coinsAddresses: [
			"0xdAC17F958D2ee523a2206206994597C13D831ec7",
			"0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
			"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"6",
			"8",
			"18",
			"0"
		],
		virtualPrice: "1021409415641949446",
		amplificationCoefficient: "3645",
		assetType: "4",
		totalSupply: "388906141703128150591",
		lpTokenAddress: "0xcA3d75aC011BF5aD07a98d02f18225F9bD9A6BDF",
		name: "Curve.fi USD-BTC-ETH",
		symbol: "crvTricrypto",
		priceOracle: 16137.088371917262,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/tricrypto/swap",
				"https://classic.curve.fi/tricrypto"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/tricrypto/deposit",
				"https://classic.curve.fi/tricrypto/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/tricrypto/withdraw",
				"https://classic.curve.fi/tricrypto/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "102068102441"
			},
			{
				address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
				usdPrice: 15973.32,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "WBTC",
				poolBalance: "654070285"
			},
			{
				address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
				usdPrice: 1122.25,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "WETH",
				poolBalance: "93514713742809640251"
			}
		],
		usdTotal: 311593.7976892711,
		isMetaPool: false,
		usdTotalExcludingBasePool: 311593.7976892711,
		gaugeAddress: "0x6955a55416a06839309018a8b0cb72c4ddc11f15",
		chainId: 1
	},
	{
		id: "39",
		address: "0x618788357D0EBd8A37e763ADab3bc575D54c2C7d",
		coinsAddresses: [
			"0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "982681604944574607",
		amplificationCoefficient: "100",
		underlyingDecimals: [
			"18",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "1667733916098463615077893",
		lpTokenAddress: "0x6BA5b4e438FA0aAf7C1bD179285aF65d13bD3D90",
		name: "RAI3CRV",
		symbol: "RAI3CRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/rai/swap",
				"https://classic.curve.fi/rai"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/rai/deposit",
				"https://classic.curve.fi/rai/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/rai/withdraw",
				"https://classic.curve.fi/rai/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919",
				usdPrice: 2.8322802157607976,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "RAI",
				poolBalance: "245070505892438843583462"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "926859947268608049067911"
			}
		],
		usdTotal: 1643217.6937329555,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x03ab458634910AaD20eF5f1C8ee96F1D6ac54919",
				usdPrice: 2.8322802157607976,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "RAI",
				poolBalance: "245070505892438843583462"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "161678686587488211468104"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "159314874067"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "627003747965"
			}
		],
		usdTotalExcludingBasePool: 694108.3453056446,
		gaugeAddress: "0x66ec719045bbd62db5ebb11184c18237d3cc2e62",
		chainId: 1
	},
	{
		id: "40",
		address: "0x5a6A4D54456819380173272A5E8E9B9904BdF41B",
		coinsAddresses: [
			"0x99D8a9C45b2ecA8864373A26D1459e3Dff1e17F3",
			"0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1008457509884435737",
		amplificationCoefficient: "2000",
		underlyingDecimals: [
			"18",
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "85372487172861204589150672",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/mim/swap",
				"https://classic.curve.fi/mim"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/mim/deposit",
				"https://classic.curve.fi/mim/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/mim/withdraw",
				"https://classic.curve.fi/mim/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x99D8a9C45b2ecA8864373A26D1459e3Dff1e17F3",
				usdPrice: 1.0005826716659343,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "MIM",
				poolBalance: "55613876954044135313838989"
			},
			{
				address: "0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490",
				usdPrice: 1.0240051382350377,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "3Crv",
				poolBalance: "29807718112756981613086570"
			}
		],
		usdTotal: 86169538.09090276,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0x99D8a9C45b2ecA8864373A26D1459e3Dff1e17F3",
				usdPrice: 1.0005826716659343,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "MIM",
				poolBalance: "55613876954044135313838989"
			},
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1.003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "5199569502213029064525907"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "5123549540961"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "20164374380464"
			}
		],
		usdTotalExcludingBasePool: 55646281.58437801,
		gaugeAddress: "0xd8b712d29381748db89c36bca0138d7c75866ddf",
		chainId: 1
	},
	{
		id: "41",
		address: "0xFD5dB7463a3aB53fD211b4af195c5BCCC1A03890",
		coinsAddresses: [
			"0xC581b735A1688071A1746c968e0798D642EDE491",
			"0xD71eCFF9342A5Ced620049e616c5035F1dB98620",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"6",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1008246714343003052",
		amplificationCoefficient: "100",
		assetType: "0",
		totalSupply: "20031636943644062971808",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/eurt/swap",
				"https://classic.curve.fi/eurt"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/eurt/deposit",
				"https://classic.curve.fi/eurt/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/eurt/withdraw",
				"https://classic.curve.fi/eurt/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xC581b735A1688071A1746c968e0798D642EDE491",
				usdPrice: 1.0183885698538886,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "EURT",
				poolBalance: "13436323639"
			},
			{
				address: "0xD71eCFF9342A5Ced620049e616c5035F1dB98620",
				usdPrice: 1.02717,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "sEUR",
				poolBalance: "6772690880168872498708"
			}
		],
		usdTotal: 20640.103306198267,
		isMetaPool: false,
		usdTotalExcludingBasePool: 20640.103306198267,
		gaugeAddress: "0xe8060ad8971450e624d5289a10017dd30f5da85f",
		chainId: 1
	},
	{
		id: "42",
		address: "0x4e0915C88bC70750D68C481540F081fEFaF22273",
		coinsAddresses: [
			"0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
			"0xdAC17F958D2ee523a2206206994597C13D831ec7",
			"0xa693B19d2931d498c5B318dF961919BB4aee87a5",
			"0x853d955aCEf822Db058eb8505911ED77F175b99e"
		],
		decimals: [
			"6",
			"6",
			"6",
			"18"
		],
		virtualPrice: "1007295095340865542",
		amplificationCoefficient: "500",
		assetType: "0",
		totalSupply: "60580236462619794517962",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/4pool/swap",
				"https://classic.curve.fi/4pool"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/4pool/deposit",
				"https://classic.curve.fi/4pool/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/4pool/withdraw",
				"https://classic.curve.fi/4pool/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "700110759"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "696532475"
			},
			{
				address: "0xa693B19d2931d498c5B318dF961919BB4aee87a5",
				usdPrice: 0.021519,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "UST",
				poolBalance: "104997717858"
			},
			{
				address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
				usdPrice: 1.0006972361613427,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "FRAX",
				poolBalance: "700089078796658765403"
			}
		],
		usdTotal: 4357.362863279859,
		isMetaPool: false,
		usdTotalExcludingBasePool: 4357.362863279859,
		gaugeAddress: "0x34883134a39b206a451c2d3b0e7cac44be4d9181",
		chainId: 1
	},
	{
		id: "43",
		address: "0x1005F7406f32a61BD760CfA14aCCd2737913d546",
		coinsAddresses: [
			"0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
			"0xdAC17F958D2ee523a2206206994597C13D831ec7",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"6",
			"6",
			"0",
			"0"
		],
		virtualPrice: "1000533124895073405",
		amplificationCoefficient: "1500",
		assetType: "0",
		totalSupply: "230417545302969142309",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/2pool/swap",
				"https://classic.curve.fi/2pool"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/2pool/deposit",
				"https://classic.curve.fi/2pool/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/2pool/withdraw",
				"https://classic.curve.fi/2pool/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "69405262"
			},
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "161149571"
			}
		],
		usdTotal: 230.71598257099998,
		isMetaPool: false,
		usdTotalExcludingBasePool: 230.71598257099998,
		gaugeAddress: "0x9f330db38caaae5b61b410e2f0aad63fff2109d8",
		chainId: 1
	},
	{
		id: "44",
		address: "0xDcEF968d416a41Cdac0ED8702fAC8128A64241A2",
		coinsAddresses: [
			"0x853d955aCEf822Db058eb8505911ED77F175b99e",
			"0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"6",
			"0",
			"0"
		],
		virtualPrice: "1000986606447015083",
		amplificationCoefficient: "1500",
		assetType: "0",
		totalSupply: "461676060068304583005020310",
		lpTokenAddress: "0x3175Df0976dFA876431C2E9eE6Bc45b65d3473CC",
		name: "Curve.fi FRAX/USDC",
		symbol: "crvFRAX",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/fraxusdc/swap",
				"https://classic.curve.fi/fraxusdc"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/fraxusdc/deposit",
				"https://classic.curve.fi/fraxusdc/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/fraxusdc/withdraw",
				"https://classic.curve.fi/fraxusdc/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
				usdPrice: 1.0006972361613427,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "FRAX",
				poolBalance: "343377821018196617586539612"
			},
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "118801302468309"
			}
		],
		usdTotal: 462418538.92032254,
		isMetaPool: false,
		usdTotalExcludingBasePool: 462418538.92032254,
		gaugeAddress: "0xcfc25170633581bf896cb6cdee170e3e3aa59503",
		chainId: 1
	},
	{
		id: "45",
		address: "0xa1F8A6807c402E4A15ef4EBa36528A3FED24E577",
		coinsAddresses: [
			"0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
			"0x5E8422345238F34275888049021821E8E08CAa1f",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1000386213435288290",
		amplificationCoefficient: "120",
		assetType: "0",
		totalSupply: "22560867147419980388513",
		lpTokenAddress: "0xf43211935C781D5ca1a41d2041F397B8A7366C7A",
		name: "Curve.fi ETH/frxETH",
		symbol: "frxETHCRV",
		priceOracle: 1.0002741549898762,
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/frxeth/swap",
				"https://classic.curve.fi/frxeth"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/frxeth/deposit",
				"https://classic.curve.fi/frxeth/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/frxeth/withdraw",
				"https://classic.curve.fi/frxeth/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
				usdPrice: 1123.52,
				poolBalance: "11471848840525899597563",
				decimals: 18,
				symbol: "ETH",
				isBasePoolLpToken: false
			},
			{
				address: "0x5E8422345238F34275888049021821E8E08CAa1f",
				usdPrice: 1123.52,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "frxETH",
				poolBalance: "11097757246060514495248"
			}
		],
		usdTotal: 25357403.830401562,
		isMetaPool: false,
		usdTotalExcludingBasePool: 25357403.830401562,
		gaugeAddress: "0x2932a86df44fe8d2a706d8e9c5d51c24883423f5",
		chainId: 1
	},
	{
		id: "factory-crvusd-0",
		address: "0x4DEcE678ceceb27446b35C672dC7d61F30bAD69E",
		coinsAddresses: [
			"0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"6",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1004132965213954546",
		amplificationCoefficient: "500",
		assetType: "0",
		totalSupply: "41196839005554177676363318",
		name: "Curve.fi Factory Plain Pool: crvUSD/USDC",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "crvUSDUSDC-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-0/swap",
				"https://classic.curve.fi/factory-crvusd-0"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-0/deposit",
				"https://classic.curve.fi/factory-crvusd-0/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-0/withdraw",
				"https://classic.curve.fi/factory-crvusd-0/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0x4DEcE678ceceb27446b35C672dC7d61F30bAD69E",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "16546083497566"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "24822741909929606517816883"
			}
		],
		usdTotal: 41364805.15737636,
		isMetaPool: false,
		usdTotalExcludingBasePool: 41364805.15737636,
		gaugeAddress: "0x95f00391cb5eebcd190eb58728b4ce23dbfa6ac1",
		gaugeRewards: [
			{
				gaugeAddress: "0x95f00391cb5eebcd190eb58728b4ce23dbfa6ac1",
				tokenPrice: 0.480011,
				name: "Curve DAO Token",
				symbol: "CRV",
				decimals: "18",
				tokenAddress: "0xD533a949740bb3306d119CC777fa900bA034cd52",
				apy: 0
			}
		],
		gaugeCrvApy: [
			2.906430927088741,
			7.266077317721853
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-1",
		address: "0x390f3595bCa2Df7d23783dFd126427CCeb997BF4",
		coinsAddresses: [
			"0xdAC17F958D2ee523a2206206994597C13D831ec7",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"6",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1004095907337789738",
		amplificationCoefficient: "500",
		assetType: "0",
		totalSupply: "44464948712443342988066848",
		name: "Curve.fi Factory Plain Pool: crvUSD/USDT",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "crvUSDUSDT-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-1/swap",
				"https://classic.curve.fi/factory-crvusd-1"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-1/deposit",
				"https://classic.curve.fi/factory-crvusd-1/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-1/withdraw",
				"https://classic.curve.fi/factory-crvusd-1/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0x390f3595bCa2Df7d23783dFd126427CCeb997BF4",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1.001,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "17734945154195"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "26914094043544511631070735"
			}
		],
		usdTotal: 44644475.06573687,
		isMetaPool: false,
		usdTotalExcludingBasePool: 44644475.06573687,
		gaugeAddress: "0x4e6bb6b7447b7b2aa268c16ab87f4bb48bf57939",
		gaugeRewards: [
			{
				gaugeAddress: "0x4e6bb6b7447b7b2aa268c16ab87f4bb48bf57939",
				tokenPrice: 0.480011,
				name: "Curve DAO Token",
				symbol: "CRV",
				decimals: "18",
				tokenAddress: "0xD533a949740bb3306d119CC777fa900bA034cd52",
				apy: 0
			}
		],
		gaugeCrvApy: [
			3.0764246253499024,
			7.691061563374756
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-2",
		address: "0xCa978A0528116DDA3cbA9ACD3e68bc6191CA53D0",
		coinsAddresses: [
			"0x8E870D67F660D95d5be530380D0eC0bd388289E1",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1002009517695379886",
		amplificationCoefficient: "500",
		assetType: "0",
		totalSupply: "4906937125136374224994666",
		name: "Curve.fi Factory Plain Pool: crvUSD/USDP",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "crvUSDUSDP-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-2/swap",
				"https://classic.curve.fi/factory-crvusd-2"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-2/deposit",
				"https://classic.curve.fi/factory-crvusd-2/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-2/withdraw",
				"https://classic.curve.fi/factory-crvusd-2/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0xCa978A0528116DDA3cbA9ACD3e68bc6191CA53D0",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x8E870D67F660D95d5be530380D0eC0bd388289E1",
				usdPrice: 0.999494,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "USDP",
				poolBalance: "2015596761188965182503220"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "2901365514547118185275247"
			}
		],
		usdTotal: 4913538.521569328,
		isMetaPool: false,
		usdTotalExcludingBasePool: 4913538.521569328,
		gaugeAddress: "0x5c07440a172805d566faf7ebaf16ef068ac05f43",
		gaugeRewards: [
			{
				gaugeAddress: "0x5c07440a172805d566faf7ebaf16ef068ac05f43",
				tokenPrice: 0.480011,
				name: "Curve DAO Token",
				symbol: "CRV",
				decimals: "18",
				tokenAddress: "0xD533a949740bb3306d119CC777fa900bA034cd52",
				apy: 0
			}
		],
		gaugeCrvApy: [
			4.682778627196075,
			11.706946567990189
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-3",
		address: "0x34D655069F4cAc1547E4C8cA284FfFF5ad4A8db0",
		coinsAddresses: [
			"0x0000000000085d4780B73119b644AE5ecd22b376",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1001278567834946916",
		amplificationCoefficient: "500",
		assetType: "0",
		totalSupply: "12315279458358766390143775",
		name: "Curve.fi Factory Plain Pool: crvUSD/TUSD",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "crvUSDTUSD-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-3/swap",
				"https://classic.curve.fi/factory-crvusd-3"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-3/deposit",
				"https://classic.curve.fi/factory-crvusd-3/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-3/withdraw",
				"https://classic.curve.fi/factory-crvusd-3/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0x34D655069F4cAc1547E4C8cA284FfFF5ad4A8db0",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x0000000000085d4780B73119b644AE5ecd22b376",
				usdPrice: 0.9985769930916261,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "TUSD",
				poolBalance: "6914355861744441107331669"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "5416853718914847719006760"
			}
		],
		usdTotal: 12316882.390197862,
		isMetaPool: false,
		usdTotalExcludingBasePool: 12316882.390197862,
		gaugeAddress: "0xfcaf4ec80a94a5409141af16a1dca950a6973a39",
		gaugeRewards: [
			{
				gaugeAddress: "0xfcaf4ec80a94a5409141af16a1dca950a6973a39",
				tokenPrice: 0.480011,
				name: "Curve DAO Token",
				symbol: "CRV",
				decimals: "18",
				tokenAddress: "0xD533a949740bb3306d119CC777fa900bA034cd52",
				apy: 0
			}
		],
		gaugeCrvApy: [
			4.884615283024376,
			12.211538207560938
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-4",
		address: "0x0CD6f267b2086bea681E922E19D40512511BE538",
		coinsAddresses: [
			"0x853d955aCEf822Db058eb8505911ED77F175b99e",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1000738513522608727",
		amplificationCoefficient: "500",
		assetType: "0",
		totalSupply: "5664219910944255811751344",
		name: "Curve.fi Factory Plain Pool: crvUSD/Frax",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "crvUSDFRAX-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-4/swap",
				"https://classic.curve.fi/factory-crvusd-4"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-4/deposit",
				"https://classic.curve.fi/factory-crvusd-4/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-4/withdraw",
				"https://classic.curve.fi/factory-crvusd-4/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0x0CD6f267b2086bea681E922E19D40512511BE538",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x853d955aCEf822Db058eb8505911ED77F175b99e",
				usdPrice: 0.9982626916596676,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "FRAX",
				poolBalance: "3593267690490649192116946"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "2075572048577558612638278"
			}
		],
		usdTotal: 5660877.455840777,
		isMetaPool: false,
		usdTotalExcludingBasePool: 5660877.455840777,
		gaugeAddress: "0x96424e6b5eaafe0c3b36ca82068d574d44be4e3c",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			5.13654298549503,
			12.841357463737575
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-5",
		address: "0x58B94400bdAd7b9ac8d5335E12eF96E8B4966b4a",
		coinsAddresses: [
			"0x6B175474E89094C44Da98b954EedeAC495271d0F",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: 0,
		amplificationCoefficient: "500",
		assetType: "0",
		totalSupply: "0",
		name: "Curve.fi Factory Plain Pool: crvUSD/DAI",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "crvUSDDAI-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-5/swap",
				"https://classic.curve.fi/factory-crvusd-5"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-5/deposit",
				"https://classic.curve.fi/factory-crvusd-5/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-5/withdraw",
				"https://classic.curve.fi/factory-crvusd-5/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0x58B94400bdAd7b9ac8d5335E12eF96E8B4966b4a",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
				usdPrice: 1,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DAI",
				poolBalance: "0"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "0"
			}
		],
		usdTotal: 0,
		isMetaPool: false,
		usdTotalExcludingBasePool: 0,
		gaugeAddress: "0x42144499fd4d017723b3a723953b229e64eb1ffd",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			null,
			null
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-6",
		address: "0xBe426b0f37c112dd20d5866769c8034171567b31",
		coinsAddresses: [
			"0x99D8a9C45b2ecA8864373A26D1459e3Dff1e17F3",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1000418956984429872",
		amplificationCoefficient: "1000",
		assetType: "0",
		totalSupply: "655017283288089776430362",
		name: "Curve.fi Factory Plain Pool: crvUSD/MIM",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "crvUSDMIM-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-6/swap",
				"https://classic.curve.fi/factory-crvusd-6"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-6/deposit",
				"https://classic.curve.fi/factory-crvusd-6/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-6/withdraw",
				"https://classic.curve.fi/factory-crvusd-6/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0xBe426b0f37c112dd20d5866769c8034171567b31",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x99D8a9C45b2ecA8864373A26D1459e3Dff1e17F3",
				usdPrice: 0.9989289161103447,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "MIM",
				poolBalance: "403245998384917666041248"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "252064108413004395082575"
			}
		],
		usdTotal: 654669.3543652701,
		isMetaPool: false,
		usdTotalExcludingBasePool: 654669.3543652701,
		gaugeAddress: "0x533b5aee744647c20e33653f03676c471bb8e67b",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			5.676619926586074,
			14.191549816465185
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-7",
		address: "0x94cC50e4521bD271C1a997a3A4Dc815C2F920b41",
		coinsAddresses: [
			"0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1000298928140877445",
		amplificationCoefficient: "500",
		assetType: "0",
		totalSupply: "2972431687733665716032844",
		name: "Curve.fi Factory Plain Pool: crvUSD/SUSD",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "crvUSDSUSD-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-7/swap",
				"https://classic.curve.fi/factory-crvusd-7"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-7/deposit",
				"https://classic.curve.fi/factory-crvusd-7/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-7/withdraw",
				"https://classic.curve.fi/factory-crvusd-7/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0x94cC50e4521bD271C1a997a3A4Dc815C2F920b41",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
				usdPrice: 0.9987760848271293,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "sUSD",
				poolBalance: "1549065087358160636504113"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "1424260381248567436308770"
			}
		],
		usdTotal: 2970249.504914821,
		isMetaPool: false,
		usdTotalExcludingBasePool: 2970249.504914821,
		gaugeAddress: "0x512a68dd5433563bad526c8c2838c39debc9a756",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			1.2203258346227224,
			3.0508145865568057
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-8",
		address: "0x86152dF0a0E321Afb3B0B9C4deb813184F365ADa",
		coinsAddresses: [
			"0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1001028130581062794",
		amplificationCoefficient: "100",
		assetType: "0",
		totalSupply: "284230251043671873899761",
		name: "Curve.fi Factory Plain Pool: crvUSD/GHO",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "crvUSDGHO-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-8/swap",
				"https://classic.curve.fi/factory-crvusd-8"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-8/deposit",
				"https://classic.curve.fi/factory-crvusd-8/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-8/withdraw",
				"https://classic.curve.fi/factory-crvusd-8/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0x86152dF0a0E321Afb3B0B9C4deb813184F365ADa",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f",
				usdPrice: 0.9773028791317238,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "GHO",
				poolBalance: "220584572679100847626367"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "64537710461925397145821"
			}
		],
		usdTotal: 280062.1771411179,
		isMetaPool: false,
		usdTotalExcludingBasePool: 280062.1771411179,
		gaugeAddress: "0xfc58c946a2d541cfa29ad8c16fc2994323e34458",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			4.508800634784037,
			11.272001586960092
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-9",
		address: "0x1982Fe483f4bff067A2183c98fA231423d41E92B",
		coinsAddresses: [
			"0x8D6CeBD76f18E1558D4DB88138e2DeFB3909fAD6",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1000475245782211559",
		amplificationCoefficient: "100",
		assetType: "0",
		totalSupply: "341230068976011865147457",
		name: "Curve.fi Factory Plain Pool: crvUSD/MAI",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "crvUSDMAI-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-9/swap",
				"https://classic.curve.fi/factory-crvusd-9"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-9/deposit",
				"https://classic.curve.fi/factory-crvusd-9/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-9/withdraw",
				"https://classic.curve.fi/factory-crvusd-9/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0x1982Fe483f4bff067A2183c98fA231423d41E92B",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x8D6CeBD76f18E1558D4DB88138e2DeFB3909fAD6",
				usdPrice: 0.8846718241608162,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "MAI",
				poolBalance: "311508748957918873729825"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "33012873027684355108483"
			}
		],
		usdTotal: 308568.53412478894,
		isMetaPool: false,
		usdTotalExcludingBasePool: 308568.53412478894,
		gaugeAddress: "0x71873000399db5fddcd8d953e0e6570a0cb4c50c",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			5.931162245616933,
			14.827905614042331
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-10",
		address: "0xA8a02c7D9ada50444F8c658F43Dc440675B21797",
		coinsAddresses: [
			"0xd7C9F0e536dC865Ae858b0C0453Fe76D13c3bEAc",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1000647086444841410",
		amplificationCoefficient: "100",
		assetType: "0",
		totalSupply: "962175718507547653147352",
		name: "Curve.fi Factory Plain Pool: crvUSD/XAI",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "crvUSDXAI-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-10/swap",
				"https://classic.curve.fi/factory-crvusd-10"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-10/deposit",
				"https://classic.curve.fi/factory-crvusd-10/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-10/withdraw",
				"https://classic.curve.fi/factory-crvusd-10/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0xA8a02c7D9ada50444F8c658F43Dc440675B21797",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xd7C9F0e536dC865Ae858b0C0453Fe76D13c3bEAc",
				usdPrice: 0.990380650461888,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "XAI",
				poolBalance: "643817780865993949100741"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "319588585051211497800973"
			}
		],
		usdTotal: 956948.469592822,
		isMetaPool: false,
		usdTotalExcludingBasePool: 956948.469592822,
		gaugeAddress: "0x9dc22ca10bb8210c8788827204da091eb6ca04a5",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			5.605845640176577,
			14.014614100441442
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-11",
		address: "0xfC636D819d1a98433402eC9dEC633d864014F28C",
		coinsAddresses: [
			"0xb40b6608B2743E691C9B54DdBDEe7bf03cd79f1c",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1084031932274820124",
		amplificationCoefficient: "100",
		assetType: "0",
		totalSupply: "504642588191961077390360",
		name: "Curve.fi Factory Plain Pool: crvUSD/UZD",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "crvUSDUZD-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-11/swap",
				"https://classic.curve.fi/factory-crvusd-11"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-11/deposit",
				"https://classic.curve.fi/factory-crvusd-11/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-11/withdraw",
				"https://classic.curve.fi/factory-crvusd-11/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0xfC636D819d1a98433402eC9dEC633d864014F28C",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xb40b6608B2743E691C9B54DdBDEe7bf03cd79f1c",
				usdPrice: 0.0000342593842025837,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "UZD",
				poolBalance: "2578658410999591082850357"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "39008674411226494818"
			}
		],
		usdTotal: 127.31960386675246,
		isMetaPool: false,
		usdTotalExcludingBasePool: 127.31960386675246,
		gaugeAddress: "0xe39c817fe25ac1a8bd343a74037e3c90b09beeef",
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-12",
		address: "0x8272E1A3dBef607C04AA6e5BD3a1A134c8ac063B",
		coinsAddresses: [
			"0x865377367054516e17014CcdED1e7d814EDC9ce4",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1000858510982406653",
		amplificationCoefficient: "200",
		assetType: "0",
		totalSupply: "2309640960602651100796380",
		name: "Curve.fi Factory Plain Pool: crvUSD/DOLA",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "crvUSDDOLA-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-12/swap",
				"https://classic.curve.fi/factory-crvusd-12"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-12/deposit",
				"https://classic.curve.fi/factory-crvusd-12/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-12/withdraw",
				"https://classic.curve.fi/factory-crvusd-12/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0x8272E1A3dBef607C04AA6e5BD3a1A134c8ac063B",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x865377367054516e17014CcdED1e7d814EDC9ce4",
				usdPrice: 0.994355,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DOLA",
				poolBalance: "1366534950168914234413211"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "945286309372395047027143"
			}
		],
		usdTotal: 2303323.973690035,
		isMetaPool: false,
		usdTotalExcludingBasePool: 2303323.973690035,
		gaugeAddress: "0xecad6745058377744c09747b2715c0170b5699e5",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			6.9168626989372655,
			17.292156747343164
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-13",
		address: "0xeCDd0cE505da71cd9dE855CD6804BA1e8C7bdB07",
		coinsAddresses: [
			"0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"2",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1000328477372456859",
		amplificationCoefficient: "500",
		assetType: "0",
		totalSupply: "1431153523396963409169330",
		name: "Curve.fi Factory Plain Pool: crvUSD/GUSD",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "crvUSDGUSD-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-13/swap",
				"https://classic.curve.fi/factory-crvusd-13"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-13/deposit",
				"https://classic.curve.fi/factory-crvusd-13/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-13/withdraw",
				"https://classic.curve.fi/factory-crvusd-13/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0xeCDd0cE505da71cd9dE855CD6804BA1e8C7bdB07",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
				usdPrice: 1.0006713109400147,
				decimals: "2",
				isBasePoolLpToken: false,
				symbol: "GUSD",
				poolBalance: "53316650"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "898556653160086104956109"
			}
		],
		usdTotal: 1431336.5944295954,
		isMetaPool: false,
		usdTotalExcludingBasePool: 1431336.5944295954,
		gaugeAddress: "0xde14d2b848a7a1373e155cc4db9b649f4be24296",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			4.526144872589334,
			11.315362181473335
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-14",
		address: "0xAe9e8c9A548505c9ad22a412354186151363c09e",
		coinsAddresses: [
			"0xA0d69E286B938e21CBf7E51D71F6A4c8918f482F",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: 0,
		amplificationCoefficient: "500",
		assetType: "0",
		totalSupply: "0",
		name: "Curve.fi Factory Plain Pool: crvUSD/eUSD",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "crvUSDeUSD-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-14/swap",
				"https://classic.curve.fi/factory-crvusd-14"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-14/deposit",
				"https://classic.curve.fi/factory-crvusd-14/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-14/withdraw",
				"https://classic.curve.fi/factory-crvusd-14/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0xAe9e8c9A548505c9ad22a412354186151363c09e",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xA0d69E286B938e21CBf7E51D71F6A4c8918f482F",
				usdPrice: 1.001,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "eUSD",
				poolBalance: "0"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "0"
			}
		],
		usdTotal: 0,
		isMetaPool: false,
		usdTotalExcludingBasePool: 0,
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-15",
		address: "0x9c3B46C0Ceb5B9e304FCd6D88Fc50f7DD24B31Bc",
		coinsAddresses: [
			"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
			"0x5E8422345238F34275888049021821E8E08CAa1f",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1000188638695665470",
		amplificationCoefficient: "1000",
		assetType: "1",
		totalSupply: "24546098575420139518552",
		name: "Curve.fi Factory Plain Pool: frxETH/WETH",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "frxeth-ng-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-15/swap",
				"https://classic.curve.fi/factory-crvusd-15"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-15/deposit",
				"https://classic.curve.fi/factory-crvusd-15/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-15/withdraw",
				"https://classic.curve.fi/factory-crvusd-15/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0x9c3B46C0Ceb5B9e304FCd6D88Fc50f7DD24B31Bc",
		assetTypeName: "eth",
		coins: [
			{
				address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
				usdPrice: 1633.51,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "WETH",
				poolBalance: "5751944898945990483498"
			},
			{
				address: "0x5E8422345238F34275888049021821E8E08CAa1f",
				usdPrice: 1632.5084960631546,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "frxETH",
				poolBalance: "18803610668492206868188"
			}
		],
		usdTotal: 40092913.68485457,
		isMetaPool: false,
		usdTotalExcludingBasePool: 40092913.68485457,
		gaugeAddress: "0x4e21418095d32d15c6e2b96a9910772613a50d50",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			3.888814420311535,
			9.722036050778836
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-16",
		address: "0xB7ECB2AA52AA64a717180E030241bC75Cd946726",
		coinsAddresses: [
			"0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
			"0x18084fbA666a33d37592fA2633fD49a74DD93a88",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"8",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1000504236578089748",
		amplificationCoefficient: "300",
		assetType: "2",
		totalSupply: "388566142343173827282",
		name: "Curve.fi Factory Plain Pool: tBTC/WBTC",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "2BTC-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-16/swap",
				"https://classic.curve.fi/factory-crvusd-16"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-16/deposit",
				"https://classic.curve.fi/factory-crvusd-16/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-16/withdraw",
				"https://classic.curve.fi/factory-crvusd-16/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0xB7ECB2AA52AA64a717180E030241bC75Cd946726",
		assetTypeName: "btc",
		coins: [
			{
				address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
				usdPrice: 27434,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "WBTC",
				poolBalance: "25360905403"
			},
			{
				address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
				usdPrice: 27489.6265501,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "tBTC",
				poolBalance: "135218981814677741482"
			}
		],
		usdTotal: 10674630.100829273,
		isMetaPool: false,
		usdTotalExcludingBasePool: 10674630.100829273,
		gaugeAddress: "0x5010263ac1978297f56048c7d2b02316a3435404",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			0.5388566388933498,
			1.3471415972333745
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-17",
		address: "0x3de254A0f838a844F727fee81040e0FA7884B935",
		coinsAddresses: [
			"0x4591DBfF62656E7859Afe5e45f6f47D3669fBB28",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1000332149649429855",
		amplificationCoefficient: "100",
		assetType: "0",
		totalSupply: "9796827785152794603495569",
		name: "Curve.fi Factory Plain Pool: mkUSD/crvUSD",
		implementationAddress: "0x67fe41A94e779CcFa22cff02cc2957DC9C0e4286",
		symbol: "mkcrvUSD-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-17/swap",
				"https://classic.curve.fi/factory-crvusd-17"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-17/deposit",
				"https://classic.curve.fi/factory-crvusd-17/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-17/withdraw",
				"https://classic.curve.fi/factory-crvusd-17/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0x3de254A0f838a844F727fee81040e0FA7884B935",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x4591DBfF62656E7859Afe5e45f6f47D3669fBB28",
				usdPrice: 0.997867032181803,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "mkUSD",
				poolBalance: "5123442778061858383687611"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "4676740024707908999781705"
			}
		],
		usdTotal: 9785379.85472921,
		isMetaPool: false,
		usdTotalExcludingBasePool: 9785379.85472921,
		gaugeAddress: "0x0e5bdb5afe132d1c6a6c67f6d8eb6133dd607e36",
		gaugeRewards: [
			{
				gaugeAddress: "0x0e5bdb5afe132d1c6a6c67f6d8eb6133dd607e36",
				tokenPrice: 0.480011,
				name: "Curve DAO Token",
				symbol: "CRV",
				decimals: "18",
				tokenAddress: "0xD533a949740bb3306d119CC777fa900bA034cd52",
				apy: 0
			}
		],
		gaugeCrvApy: [
			5.65198583805072,
			14.1299645951268
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-18",
		address: "0x143B33AF57172E2FBF67F30B3A4d49e7f0199EeC",
		coinsAddresses: [
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x83F20F44975D03b1b09e64809B757c47f942BEeA",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: 0,
		amplificationCoefficient: "50",
		assetType: "0",
		totalSupply: "0",
		name: "Curve.fi Factory Plain Pool: crvUSD<>sDAI",
		implementationAddress: "0x0C9D8c7e486e822C29488Ff51BFf0167B4650953",
		symbol: "crvsDAI-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-18/swap",
				"https://classic.curve.fi/factory-crvusd-18"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-18/deposit",
				"https://classic.curve.fi/factory-crvusd-18/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-18/withdraw",
				"https://classic.curve.fi/factory-crvusd-18/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0x143B33AF57172E2FBF67F30B3A4d49e7f0199EeC",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "0"
			},
			{
				address: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "sDAI",
				poolBalance: "0"
			}
		],
		usdTotal: 0,
		isMetaPool: false,
		usdTotalExcludingBasePool: 0,
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-19",
		address: "0xb7be2211430D8b59BFCBcA029c2f3a2577369A19",
		coinsAddresses: [
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x25eC98773D7b4ceD4cAFaB96A2A1c0945f145e10",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: 0,
		amplificationCoefficient: "50",
		assetType: "0",
		totalSupply: "0",
		name: "Curve.fi Factory Plain Pool: crvUSD<>stUSDT",
		implementationAddress: "0x7Ca46A636b02D4aBC66883D7FF164bDE506DC66a",
		symbol: "crvstUSDT-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-19/swap",
				"https://classic.curve.fi/factory-crvusd-19"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-19/deposit",
				"https://classic.curve.fi/factory-crvusd-19/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-19/withdraw",
				"https://classic.curve.fi/factory-crvusd-19/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0xb7be2211430D8b59BFCBcA029c2f3a2577369A19",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "0"
			},
			{
				address: "0x25eC98773D7b4ceD4cAFaB96A2A1c0945f145e10",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "stUSDT",
				poolBalance: "0"
			}
		],
		usdTotal: 0,
		isMetaPool: false,
		usdTotalExcludingBasePool: 0,
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-20",
		address: "0xAcfFeB3DD13Ca770976deB3deaD62D4Eb5cf0ac4",
		coinsAddresses: [
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x83F20F44975D03b1b09e64809B757c47f942BEeA",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1000237021990594318",
		amplificationCoefficient: "500",
		assetType: "0",
		totalSupply: "21984015259980778203638",
		name: "Curve.fi Factory Plain Pool: crvUSD-sDAI",
		implementationAddress: "0x0C9D8c7e486e822C29488Ff51BFf0167B4650953",
		symbol: "crvsDAI-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-20/swap",
				"https://classic.curve.fi/factory-crvusd-20"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-20/deposit",
				"https://classic.curve.fi/factory-crvusd-20/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-20/withdraw",
				"https://classic.curve.fi/factory-crvusd-20/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0xAcfFeB3DD13Ca770976deB3deaD62D4Eb5cf0ac4",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "11874432970704999324894"
			},
			{
				address: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
				usdPrice: 1.0360555459239373,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "sDAI",
				poolBalance: "9754089368288073531667"
			}
		],
		usdTotal: 21970.3730574365,
		isMetaPool: false,
		usdTotalExcludingBasePool: 21970.3730574365,
		gaugeAddress: "0x731d19d122d6187cd64c44708dd8665fe8126fa8",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			0,
			0
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-21",
		address: "0xB9eC78Bd89d3Ef17537f130CC72750FD4DE85f82",
		coinsAddresses: [
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x25eC98773D7b4ceD4cAFaB96A2A1c0945f145e10",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1000215143687691768",
		amplificationCoefficient: "500",
		assetType: "0",
		totalSupply: "21991625195572291723076",
		name: "Curve.fi Factory Plain Pool: crvUSD-stUSDT",
		implementationAddress: "0x7Ca46A636b02D4aBC66883D7FF164bDE506DC66a",
		symbol: "crvstUSDT-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-21/swap",
				"https://classic.curve.fi/factory-crvusd-21"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-21/deposit",
				"https://classic.curve.fi/factory-crvusd-21/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-21/withdraw",
				"https://classic.curve.fi/factory-crvusd-21/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0xB9eC78Bd89d3Ef17537f130CC72750FD4DE85f82",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "11000999481363505864610"
			},
			{
				address: "0x25eC98773D7b4ceD4cAFaB96A2A1c0945f145e10",
				usdPrice: 0.9987726450299316,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "stUSDT",
				poolBalance: "10995357074996172320233"
			}
		],
		usdTotal: 21973.74671547818,
		isMetaPool: false,
		usdTotalExcludingBasePool: 21973.74671547818,
		gaugeAddress: "0x188a85362cc5e245a377294aa270c7758a203918",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			0,
			0
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-crvusd-22",
		address: "0x707EAe1CcFee0B8fef07D3F18EAFD1246762d587",
		coinsAddresses: [
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x530824DA86689C9C17CdC2871Ff29B058345b44a",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1000259475050006151",
		amplificationCoefficient: "500",
		assetType: "0",
		totalSupply: "2399999999999999999999",
		name: "Curve.fi Factory Plain Pool: crvUSD-STBT",
		implementationAddress: "0x7Ca46A636b02D4aBC66883D7FF164bDE506DC66a",
		symbol: "crvSTBT-f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-22/swap",
				"https://classic.curve.fi/factory-crvusd-22"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-22/deposit",
				"https://classic.curve.fi/factory-crvusd-22/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-crvusd-22/withdraw",
				"https://classic.curve.fi/factory-crvusd-22/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0x707EAe1CcFee0B8fef07D3F18EAFD1246762d587",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991714721245769,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "1200000000000000000000"
			},
			{
				address: "0x530824DA86689C9C17CdC2871Ff29B058345b44a",
				usdPrice: 0.998097,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "STBT",
				poolBalance: "1200622740281236023106"
			}
		],
		usdTotal: 2397.343721755973,
		isMetaPool: false,
		usdTotalExcludingBasePool: 2397.343721755973,
		gaugeAddress: "0xd32f4be8f777ac27c6aad544457de6d4f17a1bfa",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			null,
			null
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-0",
		address: "0x7F86Bf177Dd4F3494b841a37e810A34dD56c829B",
		coinsAddresses: [
			"0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
			"0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
			"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"
		],
		decimals: [
			"6",
			"8",
			"18"
		],
		virtualPrice: "1002049320687773948",
		amplificationCoefficient: "1707629",
		name: "TricryptoUSDC",
		symbol: "crvUSDCWBTCWETH",
		totalSupply: "40325750544246135325473",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-0/swap",
				"https://classic.curve.fi/factory-tricrypto-0"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-0/deposit",
				"https://classic.curve.fi/factory-tricrypto-0/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-0/withdraw",
				"https://classic.curve.fi/factory-tricrypto-0/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x7F86Bf177Dd4F3494b841a37e810A34dD56c829B",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "14312782429165"
			},
			{
				address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
				usdPrice: 27410,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "WBTC",
				poolBalance: "52272267260"
			},
			{
				address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
				usdPrice: 1631.83,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "WETH",
				poolBalance: "8818508828745618373595"
			}
		],
		usdTotal: 43030918.14714296,
		isMetaPool: false,
		usdTotalExcludingBasePool: 43030918.14714296,
		gaugeAddress: "0x85d44861d024cb7603ba906f2dc9569fc02083f6",
		gaugeRewards: [
			{
				gaugeAddress: "0x85d44861d024cb7603ba906f2dc9569fc02083f6",
				tokenPrice: 0.478919,
				name: "Curve DAO Token",
				symbol: "CRV",
				decimals: "18",
				tokenAddress: "0xD533a949740bb3306d119CC777fa900bA034cd52",
				apy: 0
			}
		],
		gaugeCrvApy: [
			4.431697423947198,
			11.079243559867995
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-1",
		address: "0xf5f5B97624542D72A9E06f04804Bf81baA15e2B4",
		coinsAddresses: [
			"0xdAC17F958D2ee523a2206206994597C13D831ec7",
			"0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
			"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"
		],
		decimals: [
			"6",
			"8",
			"18"
		],
		virtualPrice: "1000900458907466861",
		amplificationCoefficient: "2700000",
		name: "TricryptoUSDT",
		symbol: "crvUSDTWBTCWETH",
		totalSupply: "41222678711938281586777",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-1/swap",
				"https://classic.curve.fi/factory-tricrypto-1"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-1/deposit",
				"https://classic.curve.fi/factory-tricrypto-1/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-1/withdraw",
				"https://classic.curve.fi/factory-tricrypto-1/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0xf5f5B97624542D72A9E06f04804Bf81baA15e2B4",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "14572444944327"
			},
			{
				address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
				usdPrice: 27410,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "WBTC",
				poolBalance: "53231045482"
			},
			{
				address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
				usdPrice: 1631.83,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "WETH",
				poolBalance: "9053790155050165445199"
			}
		],
		usdTotal: 43937320.89965871,
		isMetaPool: false,
		usdTotalExcludingBasePool: 43937320.89965871,
		gaugeAddress: "0xf29fff074f5cf755b55fbb3eb10a29203ac91ea2",
		gaugeRewards: [
			{
				gaugeAddress: "0xf29fff074f5cf755b55fbb3eb10a29203ac91ea2",
				tokenPrice: 0.478919,
				name: "Curve DAO Token",
				symbol: "CRV",
				decimals: "18",
				tokenAddress: "0xD533a949740bb3306d119CC777fa900bA034cd52",
				apy: 0
			}
		],
		gaugeCrvApy: [
			4.772158925727808,
			11.93039731431952
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-2",
		address: "0x2889302a794dA87fBF1D6Db415C1492194663D13",
		coinsAddresses: [
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x18084fbA666a33d37592fA2633fD49a74DD93a88",
			"0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: "1000504566900150811",
		amplificationCoefficient: "1707629",
		name: "TricryptoLLAMA",
		symbol: "crvCRVUSDTBTCWSTETH",
		totalSupply: "7913805871387971939835",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-2/swap",
				"https://classic.curve.fi/factory-tricrypto-2"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-2/deposit",
				"https://classic.curve.fi/factory-tricrypto-2/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-2/withdraw",
				"https://classic.curve.fi/factory-tricrypto-2/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x2889302a794dA87fBF1D6Db415C1492194663D13",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991719863324405,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "2936257317440661995758528"
			},
			{
				address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
				usdPrice: 27465.577886500003,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "tBTC",
				poolBalance: "106937751703241119644"
			},
			{
				address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
				usdPrice: 1860.675622021752,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "wstETH",
				poolBalance: "1580735265939650836554",
				ethLsdApy: 0.0413666701092736
			}
		],
		usdTotal: 8812168.778866895,
		isMetaPool: false,
		usdTotalExcludingBasePool: 8812168.778866895,
		gaugeAddress: "0x60d3d7ebbc44dc810a743703184f062d00e6db7e",
		gaugeRewards: [
			{
				gaugeAddress: "0x60d3d7ebbc44dc810a743703184f062d00e6db7e",
				tokenPrice: 1860.675622021752,
				name: "Wrapped liquid staked Ether 2.0",
				symbol: "wstETH",
				decimals: "18",
				tokenAddress: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
				apy: 14.892469835537284
			}
		],
		gaugeCrvApy: [
			8.690297408408142,
			21.725743521020355
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-3",
		address: "0x5426178799ee0a0181A89b4f57eFddfAb49941Ec",
		coinsAddresses: [
			"0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
			"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
			"0x41D5D79431A913C4aE7d69a668ecdfE5fF9DFB68"
		],
		decimals: [
			"6",
			"18",
			"18"
		],
		virtualPrice: "1005732812033081605",
		amplificationCoefficient: "2700000",
		name: "TricryptoINV",
		symbol: "crvUSDCWETHINV",
		totalSupply: "6748231185078228861625",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-3/swap",
				"https://classic.curve.fi/factory-tricrypto-3"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-3/deposit",
				"https://classic.curve.fi/factory-tricrypto-3/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-3/withdraw",
				"https://classic.curve.fi/factory-tricrypto-3/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x5426178799ee0a0181A89b4f57eFddfAb49941Ec",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC",
				poolBalance: "257197581891"
			},
			{
				address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
				usdPrice: 1631.83,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "WETH",
				poolBalance: "156614209918334815189"
			},
			{
				address: "0x41D5D79431A913C4aE7d69a668ecdfE5fF9DFB68",
				usdPrice: 32.982997,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "INV",
				poolBalance: "7760668537862057403932"
			}
		],
		usdTotal: 768735.455164335,
		isMetaPool: false,
		usdTotalExcludingBasePool: 768735.455164335,
		gaugeAddress: "0x4fc86cd0f9b650280fa783e3116258e0e0496a2c",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			21.33466555061164,
			53.3366638765291
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-4",
		address: "0x4eBdF703948ddCEA3B11f675B4D1Fba9d2414A14",
		coinsAddresses: [
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
			"0xD533a949740bb3306d119CC777fa900bA034cd52"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: "1028141344419732828",
		amplificationCoefficient: "2700000",
		name: "TriCRV",
		symbol: "crvUSDETHCRV",
		totalSupply: "761527509793526851269900",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-4/swap",
				"https://classic.curve.fi/factory-tricrypto-4"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-4/deposit",
				"https://classic.curve.fi/factory-tricrypto-4/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-4/withdraw",
				"https://classic.curve.fi/factory-tricrypto-4/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x4eBdF703948ddCEA3B11f675B4D1Fba9d2414A14",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991719863324405,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "7214657052706881079056766"
			},
			{
				address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
				usdPrice: 1631.83,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "WETH",
				poolBalance: "4415054540492461107365"
			},
			{
				address: "0xD533a949740bb3306d119CC777fa900bA034cd52",
				usdPrice: 0.478919,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "CRV",
				poolBalance: "15068233187134979689424074"
			}
		],
		usdTotal: 21629764.838621795,
		isMetaPool: false,
		usdTotalExcludingBasePool: 21629764.838621795,
		gaugeAddress: "0x8d867bef70c6733ff25cc0d1caa8aa6c38b24817",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			10.112235893127853,
			25.28058973281963
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-5",
		address: "0x9847a74fB7C3c4362220f616E15b83A58527F7E4",
		coinsAddresses: [
			"0x43833f0C2025dFA80b5556574FAA11CBf7F3f4eB",
			"0xb2F30A7C980f052f02563fb518dcc39e6bf38175",
			"0x57Ab1ec28D129707052df4dF418D58a2D46d5f51"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: "1010099985144784812",
		amplificationCoefficient: "2700000",
		name: "sUSD/snxUSD/wUSDA",
		symbol: "3SPool",
		totalSupply: "44207583258517825077",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-5/swap",
				"https://classic.curve.fi/factory-tricrypto-5"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-5/deposit",
				"https://classic.curve.fi/factory-tricrypto-5/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-5/withdraw",
				"https://classic.curve.fi/factory-tricrypto-5/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x9847a74fB7C3c4362220f616E15b83A58527F7E4",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0x43833f0C2025dFA80b5556574FAA11CBf7F3f4eB",
				usdPrice: 0.7811830977008868,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "wUSDA",
				poolBalance: "56232503906786529849"
			},
			{
				address: "0xb2F30A7C980f052f02563fb518dcc39e6bf38175",
				usdPrice: 1.240029803762669,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "snxUSD",
				poolBalance: "35059280808531602448"
			},
			{
				address: "0x57Ab1ec28D129707052df4dF418D58a2D46d5f51",
				usdPrice: 0.9986082904448784,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "sUSD",
				poolBalance: "45155983534882994609"
			}
		],
		usdTotal: 132.49557421557108,
		isMetaPool: false,
		usdTotalExcludingBasePool: 132.49557421557108,
		gaugeAddress: "0x5832c01c465e7c51b22ecb4f02d63081dbed2b28",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			null,
			null
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-6",
		address: "0xdcafD1914afDBC5788B701F47283CaeEAa5FBAed",
		coinsAddresses: [
			"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
			"0x943c5F4F54509d1e78B1fCD93B92c43ce83d3141",
			"0x43833f0C2025dFA80b5556574FAA11CBf7F3f4eB"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: "1042432191787963741",
		amplificationCoefficient: "2700000",
		name: "WETH/AMPH/wUSDA",
		symbol: "AMPHDUP",
		totalSupply: "24967637017789312016",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-6/swap",
				"https://classic.curve.fi/factory-tricrypto-6"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-6/deposit",
				"https://classic.curve.fi/factory-tricrypto-6/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-6/withdraw",
				"https://classic.curve.fi/factory-tricrypto-6/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0xdcafD1914afDBC5788B701F47283CaeEAa5FBAed",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
				usdPrice: 1631.83,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "WETH",
				poolBalance: "60247805738930422"
			},
			{
				address: "0x943c5F4F54509d1e78B1fCD93B92c43ce83d3141",
				usdPrice: 0.03418120538996841,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "AMPH",
				poolBalance: "2853463149120650531379"
			},
			{
				address: "0x43833f0C2025dFA80b5556574FAA11CBf7F3f4eB",
				usdPrice: 0.9426654815809963,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "wUSDA",
				poolBalance: "102459078727613498677"
			}
		],
		usdTotal: 292.4336236028688,
		isMetaPool: false,
		usdTotalExcludingBasePool: 292.4336236028688,
		gaugeAddress: "0xfb3fd2825fe128c3aa7576a2b87be19880015cae",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			null,
			null
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-7",
		address: "0x05CA1ff6fF45e55906c86Ad0d3FB2EbFaE9E0891",
		coinsAddresses: [
			"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
			"0x943c5F4F54509d1e78B1fCD93B92c43ce83d3141",
			"0x43833f0C2025dFA80b5556574FAA11CBf7F3f4eB"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: 0,
		amplificationCoefficient: "2700000",
		name: "AMPH/WETH/wUSDA",
		symbol: "AMPHDUP",
		totalSupply: "0",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-7/swap",
				"https://classic.curve.fi/factory-tricrypto-7"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-7/deposit",
				"https://classic.curve.fi/factory-tricrypto-7/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-7/withdraw",
				"https://classic.curve.fi/factory-tricrypto-7/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x05CA1ff6fF45e55906c86Ad0d3FB2EbFaE9E0891",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
				usdPrice: 1631.83,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "WETH",
				poolBalance: "0"
			},
			{
				address: "0x943c5F4F54509d1e78B1fCD93B92c43ce83d3141",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "AMPH",
				poolBalance: "0"
			},
			{
				address: "0x43833f0C2025dFA80b5556574FAA11CBf7F3f4eB",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "wUSDA",
				poolBalance: "0"
			}
		],
		usdTotal: 0,
		isMetaPool: false,
		usdTotalExcludingBasePool: 0,
		gaugeAddress: "0xfbb82a8df175ab3ee94eae2fec1c43467d6cf222",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			null,
			null
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-8",
		address: "0x037164C912f9733A0973B18EE339FBeF66cfd2C2",
		coinsAddresses: [
			"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
			"0x43833f0C2025dFA80b5556574FAA11CBf7F3f4eB",
			"0x943c5F4F54509d1e78B1fCD93B92c43ce83d3141"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: 0,
		amplificationCoefficient: "2700000",
		name: "AMPH/wUSDA/WETH",
		symbol: "AMPHDUP",
		totalSupply: "0",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-8/swap",
				"https://classic.curve.fi/factory-tricrypto-8"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-8/deposit",
				"https://classic.curve.fi/factory-tricrypto-8/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-8/withdraw",
				"https://classic.curve.fi/factory-tricrypto-8/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x037164C912f9733A0973B18EE339FBeF66cfd2C2",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
				usdPrice: 1631.83,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "WETH",
				poolBalance: "0"
			},
			{
				address: "0x43833f0C2025dFA80b5556574FAA11CBf7F3f4eB",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "wUSDA",
				poolBalance: "0"
			},
			{
				address: "0x943c5F4F54509d1e78B1fCD93B92c43ce83d3141",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "AMPH",
				poolBalance: "0"
			}
		],
		usdTotal: 0,
		isMetaPool: false,
		usdTotalExcludingBasePool: 0,
		gaugeAddress: "0x23376482abc1403e24306d6d09da10df7f9c570f",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			null,
			null
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-9",
		address: "0x3921e2cb3Ac3bC009Fa4ec5Ea1ee0bc7FA4Be4C1",
		coinsAddresses: [
			"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
			"0x43833f0C2025dFA80b5556574FAA11CBf7F3f4eB",
			"0x943c5F4F54509d1e78B1fCD93B92c43ce83d3141"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: 0,
		amplificationCoefficient: "2700000",
		name: "AMPH/wUSDA/WETH",
		symbol: "AMPHDUP",
		totalSupply: "0",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-9/swap",
				"https://classic.curve.fi/factory-tricrypto-9"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-9/deposit",
				"https://classic.curve.fi/factory-tricrypto-9/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-9/withdraw",
				"https://classic.curve.fi/factory-tricrypto-9/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x3921e2cb3Ac3bC009Fa4ec5Ea1ee0bc7FA4Be4C1",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
				usdPrice: 1631.83,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "WETH",
				poolBalance: "0"
			},
			{
				address: "0x43833f0C2025dFA80b5556574FAA11CBf7F3f4eB",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "wUSDA",
				poolBalance: "0"
			},
			{
				address: "0x943c5F4F54509d1e78B1fCD93B92c43ce83d3141",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "AMPH",
				poolBalance: "0"
			}
		],
		usdTotal: 0,
		isMetaPool: false,
		usdTotalExcludingBasePool: 0,
		gaugeAddress: "0xa6aae326b8901a610db0d25e863b2a1b2f10cd4e",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			null,
			null
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-10",
		address: "0x38AB39c82BE45f660AFa4A74E85dAd4b4aDd0492",
		coinsAddresses: [
			"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
			"0x43833f0C2025dFA80b5556574FAA11CBf7F3f4eB",
			"0x943c5F4F54509d1e78B1fCD93B92c43ce83d3141"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: 0,
		amplificationCoefficient: "1707629",
		name: "AMPH/wUSDA/WETH",
		symbol: "AMPHDUP",
		totalSupply: "0",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-10/swap",
				"https://classic.curve.fi/factory-tricrypto-10"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-10/deposit",
				"https://classic.curve.fi/factory-tricrypto-10/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-10/withdraw",
				"https://classic.curve.fi/factory-tricrypto-10/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x38AB39c82BE45f660AFa4A74E85dAd4b4aDd0492",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
				usdPrice: 1631.83,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "WETH",
				poolBalance: "0"
			},
			{
				address: "0x43833f0C2025dFA80b5556574FAA11CBf7F3f4eB",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "wUSDA",
				poolBalance: "0"
			},
			{
				address: "0x943c5F4F54509d1e78B1fCD93B92c43ce83d3141",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "AMPH",
				poolBalance: "0"
			}
		],
		usdTotal: 0,
		isMetaPool: false,
		usdTotalExcludingBasePool: 0,
		gaugeAddress: "0xbb091d9a2ea48f35360420e5bee935663042bbc3",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			null,
			null
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-11",
		address: "0x86bF09aCB47AB31686bE413d614E9ded3666a1d3",
		coinsAddresses: [
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x5E8422345238F34275888049021821E8E08CAa1f",
			"0x6f80310CA7F2C654691D1383149Fa1A57d8AB1f8"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: "1002199079179203419",
		amplificationCoefficient: "2700000",
		name: "TriSILO",
		symbol: "crvUSDETHSILO",
		totalSupply: "12240369482712670843352",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-11/swap",
				"https://classic.curve.fi/factory-tricrypto-11"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-11/deposit",
				"https://classic.curve.fi/factory-tricrypto-11/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-11/withdraw",
				"https://classic.curve.fi/factory-tricrypto-11/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x86bF09aCB47AB31686bE413d614E9ded3666a1d3",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991719863324405,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "54602718557758631064770"
			},
			{
				address: "0x5E8422345238F34275888049021821E8E08CAa1f",
				usdPrice: 1630.013991953164,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "frxETH",
				poolBalance: "33491386549923032636"
			},
			{
				address: "0x6f80310CA7F2C654691D1383149Fa1A57d8AB1f8",
				usdPrice: 0.053819987265776144,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "Silo",
				poolBalance: "1009445657139138317059990"
			}
		],
		usdTotal: 163477.2878595149,
		isMetaPool: false,
		usdTotalExcludingBasePool: 163477.2878595149,
		gaugeAddress: "0xb901a92f2c385afa0a019e8a307a59a570239ca4",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			38.380144938041816,
			95.95036234510454
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-12",
		address: "0x50120e3348287C6d001E455f5b00FeA07A875541",
		coinsAddresses: [
			"0xFE77ff4Cff74DCb6Aa570869F4f075c727054575",
			"0x5Ac4a1E420f0F510ef94DB86CDbaB59d5C0F2c83",
			"0x943c5F4F54509d1e78B1fCD93B92c43ce83d3141"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: "1000014578381757544",
		amplificationCoefficient: "2700000",
		name: "3AMPH",
		symbol: "3AMPH",
		totalSupply: "1711024552639623471981",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-12/swap",
				"https://classic.curve.fi/factory-tricrypto-12"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-12/deposit",
				"https://classic.curve.fi/factory-tricrypto-12/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-12/withdraw",
				"https://classic.curve.fi/factory-tricrypto-12/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x50120e3348287C6d001E455f5b00FeA07A875541",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xFE77ff4Cff74DCb6Aa570869F4f075c727054575",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "oAMPH",
				poolBalance: "11005336666666000000"
			},
			{
				address: "0x5Ac4a1E420f0F510ef94DB86CDbaB59d5C0F2c83",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "vAMPH",
				poolBalance: "1100533336666600000000"
			},
			{
				address: "0x943c5F4F54509d1e78B1fCD93B92c43ce83d3141",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "AMPH",
				poolBalance: "413599999999975010000000"
			}
		],
		usdTotal: 0,
		isMetaPool: false,
		usdTotalExcludingBasePool: 0,
		gaugeAddress: "0x2b7822e663c856153ea1a36acead03dd3b7c6561",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			null,
			null
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-13",
		address: "0x6A62EE3e5c4b412Cd9167D3aFd5E481e1E30715a",
		coinsAddresses: [
			"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0xa21Af1050F7B26e0cfF45ee51548254C41ED6b5c"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: "1003153541581345615",
		amplificationCoefficient: "2700000",
		name: "TriOSAK",
		symbol: "OSAKETHcrvUSD",
		totalSupply: "227982739427157583984155",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-13/swap",
				"https://classic.curve.fi/factory-tricrypto-13"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-13/deposit",
				"https://classic.curve.fi/factory-tricrypto-13/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-13/withdraw",
				"https://classic.curve.fi/factory-tricrypto-13/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x6A62EE3e5c4b412Cd9167D3aFd5E481e1E30715a",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
				usdPrice: 1631.83,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "WETH",
				poolBalance: "5263013418102101472"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991719863324405,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "8647437989440007429732"
			},
			{
				address: "0xa21Af1050F7B26e0cfF45ee51548254C41ED6b5c",
				usdPrice: 3.2587599408759997e-8,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "OSAK",
				poolBalance: "262831897935074574790872926963"
			}
		],
		usdTotal: 25793.681580409233,
		isMetaPool: false,
		usdTotalExcludingBasePool: 25793.681580409233,
		gaugeAddress: "0x8c94e9a3b68316fba06ba6666acdfc2dc7b7f623",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			0,
			0
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-14",
		address: "0x2570f1bD5D2735314FC102eb12Fc1aFe9e6E7193",
		coinsAddresses: [
			"0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
			"0xae78736Cd615f374D3085123A210448E74Fc6393",
			"0xac3E018457B222d93114458476f3E3416Abbe38F"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: "1000408662225744463",
		amplificationCoefficient: "27000000",
		name: "TryLSD",
		symbol: "TryLSD",
		totalSupply: "36368832082815854152",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-14/swap",
				"https://classic.curve.fi/factory-tricrypto-14"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-14/deposit",
				"https://classic.curve.fi/factory-tricrypto-14/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-14/withdraw",
				"https://classic.curve.fi/factory-tricrypto-14/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x2570f1bD5D2735314FC102eb12Fc1aFe9e6E7193",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
				usdPrice: 1860.675622021752,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "wstETH",
				poolBalance: "33925888251561859452",
				ethLsdApy: 0.0413666701092736
			},
			{
				address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
				usdPrice: 1772.61,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "rETH",
				poolBalance: "39206078958699443769",
				ethLsdApy: 0.03285942921078596
			},
			{
				address: "0xac3E018457B222d93114458476f3E3416Abbe38F",
				usdPrice: 1719.356324476935,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "sfrxETH",
				poolBalance: "36069808052406484252",
				ethLsdApy: 0.03981080465316096
			}
		],
		usdTotal: 194639.0134456697,
		isMetaPool: false,
		usdTotalExcludingBasePool: 194639.0134456697,
		gaugeAddress: "0xea012f5b25fa0d8e46123b85f585d0a5075e96b5",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			null,
			null
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-15",
		address: "0x56aEFfd9935ACabF21543701212d67aD529F7f2e",
		coinsAddresses: [
			"0x5E8422345238F34275888049021821E8E08CAa1f",
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x73968b9a57c6E53d41345FD57a6E6ae27d6CDB2F"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: 0,
		amplificationCoefficient: "2700000",
		name: "triSDT",
		symbol: "triSDT",
		totalSupply: "0",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-15/swap",
				"https://classic.curve.fi/factory-tricrypto-15"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-15/deposit",
				"https://classic.curve.fi/factory-tricrypto-15/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-15/withdraw",
				"https://classic.curve.fi/factory-tricrypto-15/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x56aEFfd9935ACabF21543701212d67aD529F7f2e",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0x5E8422345238F34275888049021821E8E08CAa1f",
				usdPrice: 1630.013991953164,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "frxETH",
				poolBalance: "0"
			},
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991719863324405,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "0"
			},
			{
				address: "0x73968b9a57c6E53d41345FD57a6E6ae27d6CDB2F",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "SDT",
				poolBalance: "0"
			}
		],
		usdTotal: 0,
		isMetaPool: false,
		usdTotalExcludingBasePool: 0,
		gaugeAddress: "0x33dc66f2808d8df2798e9e02ce15f8658ac6d0f8",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			null,
			null
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-16",
		address: "0x954313005C56b555bdC41B84D6c63B69049d7847",
		coinsAddresses: [
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0x5E8422345238F34275888049021821E8E08CAa1f",
			"0x73968b9a57c6E53d41345FD57a6E6ae27d6CDB2F"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: "1000019378924002489",
		amplificationCoefficient: "2700000",
		name: "triSDT",
		symbol: "triSDT",
		totalSupply: "12785374305977221548",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-16/swap",
				"https://classic.curve.fi/factory-tricrypto-16"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-16/deposit",
				"https://classic.curve.fi/factory-tricrypto-16/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-16/withdraw",
				"https://classic.curve.fi/factory-tricrypto-16/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x954313005C56b555bdC41B84D6c63B69049d7847",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991719863324405,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "100921592228098905494"
			},
			{
				address: "0x5E8422345238F34275888049021821E8E08CAa1f",
				usdPrice: 1630.013991953164,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "frxETH",
				poolBalance: "60796524561532685"
			},
			{
				address: "0x73968b9a57c6E53d41345FD57a6E6ae27d6CDB2F",
				usdPrice: 0.2943996603664951,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "SDT",
				poolBalance: "340637710031170854134"
			}
		],
		usdTotal: 300.220839609002,
		isMetaPool: false,
		usdTotalExcludingBasePool: 300.220839609002,
		gaugeAddress: "0x2dd2b7e07dd433b758b98a3889a63cbf48ef0d99",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			210.26099119631465,
			525.6524779907866
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-17",
		address: "0x1Ac76b6e2926ff475969d22a2258449a4600E006",
		coinsAddresses: [
			"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
			"0x43833f0C2025dFA80b5556574FAA11CBf7F3f4eB",
			"0x943c5F4F54509d1e78B1fCD93B92c43ce83d3141"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: 0,
		amplificationCoefficient: "2700000",
		name: "AMPH/WETH/wUSDA",
		symbol: "AMPHDUP",
		totalSupply: "0",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-17/swap",
				"https://classic.curve.fi/factory-tricrypto-17"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-17/deposit",
				"https://classic.curve.fi/factory-tricrypto-17/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-17/withdraw",
				"https://classic.curve.fi/factory-tricrypto-17/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x1Ac76b6e2926ff475969d22a2258449a4600E006",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
				usdPrice: 1631.83,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "WETH",
				poolBalance: "0"
			},
			{
				address: "0x43833f0C2025dFA80b5556574FAA11CBf7F3f4eB",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "wUSDA",
				poolBalance: "0"
			},
			{
				address: "0x943c5F4F54509d1e78B1fCD93B92c43ce83d3141",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "AMPH",
				poolBalance: "0"
			}
		],
		usdTotal: 0,
		isMetaPool: false,
		usdTotalExcludingBasePool: 0,
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-18",
		address: "0xC7DE47b9Ca2Fc753D6a2F167D8b3e19c6D18b19a",
		coinsAddresses: [
			"0x865377367054516e17014CcdED1e7d814EDC9ce4",
			"0xAD038Eb671c44b853887A7E32528FaB35dC5D710",
			"0x41D5D79431A913C4aE7d69a668ecdfE5fF9DFB68"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: "1003563414227141440",
		amplificationCoefficient: "2700000",
		name: "TriDBR",
		symbol: "crvDBRINV",
		totalSupply: "133887161025198258666030",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-18/swap",
				"https://classic.curve.fi/factory-tricrypto-18"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-18/deposit",
				"https://classic.curve.fi/factory-tricrypto-18/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-18/withdraw",
				"https://classic.curve.fi/factory-tricrypto-18/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0xC7DE47b9Ca2Fc753D6a2F167D8b3e19c6D18b19a",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0x865377367054516e17014CcdED1e7d814EDC9ce4",
				usdPrice: 0.993478,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DOLA",
				poolBalance: "196911306620888129635706"
			},
			{
				address: "0xAD038Eb671c44b853887A7E32528FaB35dC5D710",
				usdPrice: 0.09328105447492173,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "DBR",
				poolBalance: "2083727730240240725654849"
			},
			{
				address: "0x41D5D79431A913C4aE7d69a668ecdfE5fF9DFB68",
				usdPrice: 32.982997,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "INV",
				poolBalance: "5911794289385357853795"
			}
		],
		usdTotal: 584988.064305966,
		isMetaPool: false,
		usdTotalExcludingBasePool: 584988.064305966,
		gaugeAddress: "0x5ccde4bec0f4006c3826b51edf0d227d12ea33fa",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			null,
			null
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-19",
		address: "0x5b3BA844b3859f56524e99Ae54857b36c8Ae3eFE",
		coinsAddresses: [
			"0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
			"0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
			"0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: "1000120334403525528",
		amplificationCoefficient: "2700000",
		name: "TriLDO",
		symbol: "crvUSDETHLDO",
		totalSupply: "2350932279362046274462",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-19/swap",
				"https://classic.curve.fi/factory-tricrypto-19"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-19/deposit",
				"https://classic.curve.fi/factory-tricrypto-19/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-19/withdraw",
				"https://classic.curve.fi/factory-tricrypto-19/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x5b3BA844b3859f56524e99Ae54857b36c8Ae3eFE",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E",
				usdPrice: 0.9991719863324405,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "crvUSD",
				poolBalance: "32268189185169845610064"
			},
			{
				address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
				usdPrice: 1631.83,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "WETH",
				poolBalance: "19546143983207051786"
			},
			{
				address: "0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32",
				usdPrice: 1.5570428757025636,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "LDO",
				poolBalance: "20607226447978973462330"
			}
		],
		usdTotal: 96223.789948429,
		isMetaPool: false,
		usdTotalExcludingBasePool: 96223.789948429,
		gaugeAddress: "0xab79226e4fbd6d299316c0964be9f417c8f920c9",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			0,
			0
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-20",
		address: "0x8e2b641271544300e59d14E27520DEA204056D66",
		coinsAddresses: [
			"0xE72B141DF173b999AE7c1aDcbF60Cc9833Ce56a8",
			"0xA0d69E286B938e21CBf7E51D71F6A4c8918f482F",
			"0x320623b8E4fF03373931769A31Fc52A4E78B5d70"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: 0,
		amplificationCoefficient: "2700000",
		name: "TriRSR",
		symbol: "crvRSReUSD",
		totalSupply: "0",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-20/swap",
				"https://classic.curve.fi/factory-tricrypto-20"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-20/deposit",
				"https://classic.curve.fi/factory-tricrypto-20/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-20/withdraw",
				"https://classic.curve.fi/factory-tricrypto-20/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0x8e2b641271544300e59d14E27520DEA204056D66",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xE72B141DF173b999AE7c1aDcbF60Cc9833Ce56a8",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "ETH+",
				poolBalance: "0"
			},
			{
				address: "0xA0d69E286B938e21CBf7E51D71F6A4c8918f482F",
				usdPrice: 1.001,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "eUSD",
				poolBalance: "0"
			},
			{
				address: "0x320623b8E4fF03373931769A31Fc52A4E78B5d70",
				usdPrice: null,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "RSR",
				poolBalance: "0"
			}
		],
		usdTotal: 0,
		isMetaPool: false,
		usdTotalExcludingBasePool: 0,
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	},
	{
		id: "factory-tricrypto-21",
		address: "0xDB6925eA42897ca786a045B252D95aA7370f44b4",
		coinsAddresses: [
			"0xE72B141DF173b999AE7c1aDcbF60Cc9833Ce56a8",
			"0xA0d69E286B938e21CBf7E51D71F6A4c8918f482F",
			"0x320623b8E4fF03373931769A31Fc52A4E78B5d70"
		],
		decimals: [
			"18",
			"18",
			"18"
		],
		virtualPrice: "1000014395659820855",
		amplificationCoefficient: "2700000",
		name: "TriRSR",
		symbol: "crvRSReUSDETH+",
		totalSupply: "597222394892944420152981",
		implementationAddress: "0x66442B0C5260B92cAa9c234ECf2408CBf6b19a6f",
		poolUrls: {
			swap: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-21/swap",
				"https://classic.curve.fi/factory-tricrypto-21"
			],
			deposit: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-21/deposit",
				"https://classic.curve.fi/factory-tricrypto-21/deposit"
			],
			withdraw: [
				"https://curve.fi/#/ethereum/pools/factory-tricrypto-21/withdraw",
				"https://classic.curve.fi/factory-tricrypto-21/withdraw"
			]
		},
		implementation: "tricrypto-1",
		lpTokenAddress: "0xDB6925eA42897ca786a045B252D95aA7370f44b4",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xE72B141DF173b999AE7c1aDcbF60Cc9833Ce56a8",
				usdPrice: 1639.8217272047984,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "ETH+",
				poolBalance: "521508319895473540329"
			},
			{
				address: "0xA0d69E286B938e21CBf7E51D71F6A4c8918f482F",
				usdPrice: 1.001,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "eUSD",
				poolBalance: "856586546653246582225133"
			},
			{
				address: "0x320623b8E4fF03373931769A31Fc52A4E78B5d70",
				usdPrice: 0.0017990356387957902,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "RSR",
				poolBalance: "476855429044186739468058184"
			}
		],
		usdTotal: 2570503.7184863165,
		isMetaPool: false,
		usdTotalExcludingBasePool: 2570503.7184863165,
		usesRateOracle: false,
		isBroken: false,
		chainId: 1
	}
];

var curvePoolsArbitrum = [
	{
		id: "0",
		address: "0x7f90122BF0700F9E7e1F688fe926940E8839F353",
		coinsAddresses: [
			"0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
			"0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"6",
			"6",
			"0",
			"0"
		],
		virtualPrice: "1014230985707546798",
		amplificationCoefficient: "2000",
		assetType: "0",
		totalSupply: "9607123446582214155681901",
		name: "Curve.fi USDC/USDT",
		poolUrls: {
			swap: [
				"https://curve.fi/#/arbitrum/pools/2pool/swap",
				"https://arbitrum.curve.fi/2pool"
			],
			deposit: [
				"https://curve.fi/#/arbitrum/pools/2pool/deposit",
				"https://arbitrum.curve.fi/2pool/deposit"
			],
			withdraw: [
				"https://curve.fi/#/arbitrum/pools/2pool/withdraw",
				"https://arbitrum.curve.fi/2pool/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0x7f90122BF0700F9E7e1F688fe926940E8839F353",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC.e",
				poolBalance: "5503096756636"
			},
			{
				address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
				usdPrice: 0.998655,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "4240787085652"
			}
		],
		usdTotal: 9738179.9836578,
		isMetaPool: false,
		usdTotalExcludingBasePool: 9738179.9836578,
		gaugeAddress: "0xce5f24b7a95e9cba7df4b54e911b4a3dc8cdaf6f",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			1.9458208366541279,
			4.8645520916353195
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 42161
	},
	{
		id: "1",
		address: "0x3E01dD8a5E1fb3481F0F589056b428Fc308AF0Fb",
		coinsAddresses: [
			"0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
			"0xDBf31dF14B66535aF65AaC99C32e9eA844e14501",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"8",
			"8",
			"0",
			"0"
		],
		virtualPrice: "1001661096138534428",
		amplificationCoefficient: "200",
		assetType: "0",
		totalSupply: "14833177421319792636",
		name: "Curve.fi WBTC/renBTC",
		poolUrls: {
			swap: [
				"https://curve.fi/#/arbitrum/pools/ren/swap",
				"https://arbitrum.curve.fi/ren"
			],
			deposit: [
				"https://curve.fi/#/arbitrum/pools/ren/deposit",
				"https://arbitrum.curve.fi/ren/deposit"
			],
			withdraw: [
				"https://curve.fi/#/arbitrum/pools/ren/withdraw",
				"https://arbitrum.curve.fi/ren/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0x3E01dD8a5E1fb3481F0F589056b428Fc308AF0Fb",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
				usdPrice: 27429,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "WBTC",
				poolBalance: "1101030628"
			},
			{
				address: "0xDBf31dF14B66535aF65AaC99C32e9eA844e14501",
				usdPrice: 27990,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "renBTC",
				poolBalance: "385861777"
			}
		],
		usdTotal: 410004.40233642,
		isMetaPool: false,
		usdTotalExcludingBasePool: 410004.40233642,
		gaugeAddress: "0xc2b1df84112619d190193e48148000e3990bf627",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			3.8962243071189464,
			9.740560767797366
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 42161
	},
	{
		id: "2",
		address: "0x960ea3e3C7FB317332d990873d354E18d7645590",
		coinsAddresses: [
			"0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
			"0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
			"0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"6",
			"8",
			"18",
			"0"
		],
		virtualPrice: "1037805614575258807",
		amplificationCoefficient: "1707629",
		assetType: "0",
		totalSupply: "3100921846676516508664",
		name: "Curve.fi USD-BTC-ETH",
		lpTokenAddress: "0x8e0B8c8BB9db49a46697F3a5Bb8A308e744821D2",
		symbol: "crv3crypto",
		priceOracle: 27523.33757075064,
		poolUrls: {
			swap: [
				"https://curve.fi/#/arbitrum/pools/tricrypto/swap",
				"https://arbitrum.curve.fi/tricrypto"
			],
			deposit: [
				"https://curve.fi/#/arbitrum/pools/tricrypto/deposit",
				"https://arbitrum.curve.fi/tricrypto/deposit"
			],
			withdraw: [
				"https://curve.fi/#/arbitrum/pools/tricrypto/withdraw",
				"https://arbitrum.curve.fi/tricrypto/withdraw"
			]
		},
		implementation: "",
		zapAddress: "0xf97c707024ef0dd3e77a0824555a46b622bfb500",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
				usdPrice: 0.998655,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "1133988084956"
			},
			{
				address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
				usdPrice: 27429,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "WBTC",
				poolBalance: "4157398173"
			},
			{
				address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
				usdPrice: 1616.13,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "WETH",
				poolBalance: "706897166523946001849"
			}
		],
		usdTotal: 3415233.333588249,
		isMetaPool: false,
		usdTotalExcludingBasePool: 3415233.333588249,
		gaugeAddress: "0x555766f3da968ecbefa690ffd49a2ac02f47aa5f",
		usesRateOracle: false,
		isBroken: false,
		chainId: 42161
	},
	{
		id: "3",
		address: "0x30dF229cefa463e991e29D42DB0bae2e122B2AC7",
		coinsAddresses: [
			"0xFEa7a6a0B346362BF88A9e4A88416B77a57D6c2A",
			"0x7f90122BF0700F9E7e1F688fe926940E8839F353",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1016856388785511412",
		amplificationCoefficient: "2000",
		underlyingDecimals: [
			"18",
			"6",
			"6",
			"0",
			"0",
			"0",
			"0",
			"0"
		],
		assetType: "0",
		totalSupply: "3076861199123745251500384",
		name: "Curve.fi Factory USD Metapool: MIM",
		poolUrls: {
			swap: [
			],
			deposit: [
			],
			withdraw: [
			]
		},
		implementation: "",
		lpTokenAddress: "0x30dF229cefa463e991e29D42DB0bae2e122B2AC7",
		assetTypeName: "usd",
		coins: [
			{
				address: "0xFEa7a6a0B346362BF88A9e4A88416B77a57D6c2A",
				usdPrice: 0.994916,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "MIM",
				poolBalance: "2271753663062725847702826"
			},
			{
				address: "0x7f90122BF0700F9E7e1F688fe926940E8839F353",
				usdPrice: 1.0093909711111868,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "2CRV",
				poolBalance: "845145862896730802299807"
			}
		],
		usdTotal: 3113286.6707196482,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0xFEa7a6a0B346362BF88A9e4A88416B77a57D6c2A",
				usdPrice: 0.994916,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "MIM",
				poolBalance: "2271753663062725847702826"
			},
			{
				address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC.e",
				poolBalance: "484111553562"
			},
			{
				address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
				usdPrice: 0.998655,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "373065224028"
			}
		],
		usdTotalExcludingBasePool: 2260204.0674397154,
		usesRateOracle: false,
		isBroken: false,
		chainId: 42161
	},
	{
		id: "4",
		address: "0xC9B8a3FDECB9D5b218d02555a8Baf332E5B740d5",
		coinsAddresses: [
			"0x17FC002b466eEc40DaE837Fc4bE5c67993ddBd6F",
			"0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"6",
			"0",
			"0"
		],
		virtualPrice: "1010780073086985812",
		amplificationCoefficient: "200",
		assetType: "0",
		totalSupply: "1436640549870163832030352",
		name: "Curve.fi Factory Plain Pool: FRAXBP",
		poolUrls: {
			swap: [
				"https://curve.fi/#/arbitrum/pools/factory-v2-41/swap",
				"https://arbitrum.curve.fi/factory-v2-41"
			],
			deposit: [
				"https://curve.fi/#/arbitrum/pools/factory-v2-41/deposit",
				"https://arbitrum.curve.fi/factory-v2-41/deposit"
			],
			withdraw: [
				"https://curve.fi/#/arbitrum/pools/factory-v2-41/withdraw",
				"https://arbitrum.curve.fi/factory-v2-41/withdraw"
			]
		},
		implementation: "",
		lpTokenAddress: "0xC9B8a3FDECB9D5b218d02555a8Baf332E5B740d5",
		assetTypeName: "usd",
		coins: [
			{
				address: "0x17FC002b466eEc40DaE837Fc4bE5c67993ddBd6F",
				usdPrice: 0.993981,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "FRAX",
				poolBalance: "799147389007425633327546"
			},
			{
				address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC.e",
				poolBalance: "653017201897"
			}
		],
		usdTotal: 1447354.52276999,
		isMetaPool: false,
		usdTotalExcludingBasePool: 1447354.52276999,
		gaugeAddress: "0x95285ea6ff14f80a2fd3989a6bab993bd6b5fa13",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			1.0534069337631786,
			2.6335173344079466
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 42161
	},
	{
		id: "5",
		address: "0x6eB2dc694eB516B16Dc9FBc678C60052BbdD7d80",
		coinsAddresses: [
			"0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
			"0x5979D7b546E38E414F7E9822514be443A4800529",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"18",
			"18",
			"0",
			"0"
		],
		virtualPrice: "1027552377812812442",
		amplificationCoefficient: "50",
		assetType: "0",
		totalSupply: "1939818215791007756140",
		name: "Curve.fi ETH/wstETH",
		lpTokenAddress: "0xDbcD16e622c95AcB2650b38eC799f76BFC557a0b",
		symbol: "wstETHCRV",
		priceOracle: 0,
		poolUrls: {
			swap: [
				"https://curve.fi/#/arbitrum/pools/wsteth/swap",
				"https://arbitrum.curve.fi/wsteth"
			],
			deposit: [
				"https://curve.fi/#/arbitrum/pools/wsteth/deposit",
				"https://arbitrum.curve.fi/wsteth/deposit"
			],
			withdraw: [
				"https://curve.fi/#/arbitrum/pools/wsteth/withdraw",
				"https://arbitrum.curve.fi/wsteth/withdraw"
			]
		},
		implementation: "",
		assetTypeName: "eth",
		coins: [
			{
				address: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
				usdPrice: 1615.16,
				poolBalance: "981271300454466437119",
				decimals: 18,
				symbol: "ETH",
				isBasePoolLpToken: false
			},
			{
				address: "0x5979D7b546E38E414F7E9822514be443A4800529",
				usdPrice: 1842.34468433796,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "wstETH",
				poolBalance: "886294815738068736994"
			}
		],
		usdTotal: 3217770.6961733587,
		isMetaPool: false,
		usdTotalExcludingBasePool: 3217770.6961733587,
		gaugeAddress: "0x098ef55011b6b8c99845128114a9d9159777d697",
		gaugeRewards: [
			{
				gaugeAddress: "0x098ef55011b6b8c99845128114a9d9159777d697",
				tokenPrice: 1.53,
				name: "Lido DAO Token",
				symbol: "LDO",
				decimals: "18",
				apy: 0,
				metaData: {
					rate: "1240079365079365",
					periodFinish: 1687774470
				},
				tokenAddress: "0x13Ad51ed4F1B7e9Dc168d8a00cB3f4dDD85EfA60"
			}
		],
		gaugeCrvApy: [
			0,
			0
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 42161
	},
	{
		id: "crypto-0",
		address: "0x960ea3e3C7FB317332d990873d354E18d7645590",
		coinsAddresses: [
			"0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
			"0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
			"0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"6",
			"8",
			"18",
			"0",
			"0",
			"0",
			"0",
			"0"
		],
		virtualPrice: "1037805143929062883",
		amplificationCoefficient: "1707629",
		lpTokenAddress: "0x8e0B8c8BB9db49a46697F3a5Bb8A308e744821D2",
		name: "Curve.fi USD-BTC-ETH",
		symbol: "crv3crypto",
		totalSupply: "3100921846676516508664",
		priceOracle: 27510.457441356284,
		poolUrls: {
			swap: [
				"https://curve.fi/#/arbitrum/pools/tricrypto/swap",
				"https://arbitrum.curve.fi/tricrypto"
			],
			deposit: [
				"https://curve.fi/#/arbitrum/pools/tricrypto/deposit",
				"https://arbitrum.curve.fi/tricrypto/deposit"
			],
			withdraw: [
				"https://curve.fi/#/arbitrum/pools/tricrypto/withdraw",
				"https://arbitrum.curve.fi/tricrypto/withdraw"
			]
		},
		implementation: "",
		zapAddress: "0xf97c707024ef0dd3e77a0824555a46b622bfb500",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
				usdPrice: 0.998655,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "1134531494888"
			},
			{
				address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
				usdPrice: 27429,
				decimals: "8",
				isBasePoolLpToken: false,
				symbol: "WBTC",
				poolBalance: "4157398173"
			},
			{
				address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
				usdPrice: 1616.13,
				decimals: "18",
				isBasePoolLpToken: false,
				symbol: "WETH",
				poolBalance: "706561556489682480016"
			}
		],
		usdTotal: 3415233.623189216,
		isMetaPool: false,
		usdTotalExcludingBasePool: 3415233.623189216,
		gaugeAddress: "0x555766f3da968ecbefa690ffd49a2ac02f47aa5f",
		usesRateOracle: false,
		isBroken: false,
		chainId: 42161
	},
	{
		id: "crypto-1",
		address: "0xA827a652Ead76c6B0b3D19dba05452E06e25c27e",
		coinsAddresses: [
			"0xD22a58f79e9481D1a88e00c343885A588b34b68B",
			"0x7f90122BF0700F9E7e1F688fe926940E8839F353",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000",
			"0x0000000000000000000000000000000000000000"
		],
		decimals: [
			"2",
			"18",
			"0",
			"0",
			"0",
			"0",
			"0",
			"0"
		],
		virtualPrice: "1014655423269049062",
		amplificationCoefficient: "200000000",
		lpTokenAddress: "0x3dFe1324A0ee9d86337d06aEB829dEb4528DB9CA",
		name: "Curve EURS-2Crv",
		symbol: "crvEURSUSD",
		totalSupply: "7189813339717293413289",
		priceOracle: 0.9456411453112988,
		poolUrls: {
			swap: [
				"https://curve.fi/#/arbitrum/pools/eursusd/swap",
				"https://arbitrum.curve.fi/eursusd"
			],
			deposit: [
				"https://curve.fi/#/arbitrum/pools/eursusd/deposit",
				"https://arbitrum.curve.fi/eursusd/deposit"
			],
			withdraw: [
				"https://curve.fi/#/arbitrum/pools/eursusd/withdraw",
				"https://arbitrum.curve.fi/eursusd/withdraw"
			]
		},
		implementation: "",
		zapAddress: "0x25e2e8d104bc1a70492e2be32da7c1f8367f9d2c",
		assetTypeName: "unknown",
		coins: [
			{
				address: "0xD22a58f79e9481D1a88e00c343885A588b34b68B",
				usdPrice: 1.059,
				decimals: "2",
				isBasePoolLpToken: false,
				symbol: "EURS",
				poolBalance: "740652"
			},
			{
				address: "0x7f90122BF0700F9E7e1F688fe926940E8839F353",
				usdPrice: 1.0093909711111868,
				decimals: "18",
				isBasePoolLpToken: true,
				symbol: "2CRV",
				poolBalance: "7152952635507455896438"
			}
		],
		usdTotal: 15063.630487067194,
		isMetaPool: true,
		underlyingCoins: [
			{
				address: "0xD22a58f79e9481D1a88e00c343885A588b34b68B",
				usdPrice: 1.059,
				decimals: "2",
				isBasePoolLpToken: false,
				symbol: "EURS",
				poolBalance: "740652"
			},
			{
				address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
				usdPrice: 1,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDC.e",
				poolBalance: "4097312860"
			},
			{
				address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
				usdPrice: 0.998655,
				decimals: "6",
				isBasePoolLpToken: false,
				symbol: "USDT",
				poolBalance: "3157464285"
			}
		],
		usdTotalExcludingBasePool: 7843.50468,
		gaugeAddress: "0x6339ef8df0c2d3d3e7ee697e241666a916b81587",
		gaugeRewards: [
		],
		gaugeCrvApy: [
			0,
			0
		],
		usesRateOracle: false,
		isBroken: false,
		chainId: 42161
	}
];

var votingEscrowContract = [{
  value: '0x5f3b5DfEb7B28CDbD7FAba78963EE202a494e2A2',
  address: '0x5f3b5DfEb7B28CDbD7FAba78963EE202a494e2A2',
  name: 'CRV Voting Escrow',
  chainId: 1,
  decimals: 18
}];
var curvePools = curvePoolsMainnet.concat(curvePoolsArbitrum);
var ETH_ADDRESS = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';
var supportedPools = curvePools.map(function (pool) {
  return {
    chainId: pool.chainId,
    address: pool.address,
    value: pool.address,
    name: pool.name,
    decimalsList: pool.decimals,
    coins: pool.coins,
    assetTypeName: pool.assetTypeName,
    symbol: pool.symbol,
    implementation: pool.implementation,
    lpTokenAddress: pool.lpTokenAddress,
    gaugeAddress: pool.gaugeAddress
  };
});
var supportedGauges = curvePools.filter(function (pool) {
  return Boolean(pool.gaugeAddress);
}).map(function (pool) {
  return {
    chainId: pool.chainId,
    address: pool.gaugeAddress,
    value: pool.gaugeAddress,
    name: pool.name,
    symbol: pool.symbol
  };
});
var getSupportedTokens$1 = function getSupportedTokens(address, chainId) {
  var _curvePools$find;
  return (_curvePools$find = curvePools.find(function (pool) {
    return pool.address === address && pool.chainId === Number(chainId);
  })) === null || _curvePools$find === void 0 ? void 0 : _curvePools$find.coins.map(function (coin) {
    return {
      value: coin.address,
      name: coin.symbol,
      symbol: coin.symbol,
      decimals: Number(coin.decimals)
    };
  });
};
var getSupportedIndexes = function getSupportedIndexes(address, chainId) {
  var _pools$find;
  if (chainId !== '1' && chainId !== '42161') return [];
  var pools = chainId === '1' ? curvePoolsMainnet : curvePoolsArbitrum;
  var supporteIndexes = (_pools$find = pools.find(function (pool) {
    return pool.address === address;
  })) === null || _pools$find === void 0 ? void 0 : _pools$find.coins.map(function (coin, index) {
    return {
      address: coin.address,
      value: "".concat(index),
      name: coin.symbol,
      symbol: coin.symbol,
      decimals: Number(coin.decimals)
    };
  });
  return supporteIndexes;
};
var getLPTokenFromGauge = function getLPTokenFromGauge(chainId, gaugeAddress) {
  var _pools$find2;
  if (chainId !== '1' && chainId !== '42161') return;
  var pools = chainId === '1' ? curvePoolsMainnet : curvePoolsArbitrum;
  return (_pools$find2 = pools.find(function (pool) {
    return pool.gaugeAddress === gaugeAddress;
  })) === null || _pools$find2 === void 0 ? void 0 : _pools$find2.lpTokenAddress;
};
var getLPTokenFromPool = function getLPTokenFromPool(chainId, mainContractAddress) {
  var _pools$find3;
  if (chainId !== '1' && chainId !== '42161') return;
  var pools = chainId === '1' ? curvePoolsMainnet : curvePoolsArbitrum;
  return (_pools$find3 = pools.find(function (pool) {
    return pool.address === mainContractAddress;
  })) === null || _pools$find3 === void 0 ? void 0 : _pools$find3.lpTokenAddress;
};
var getSupportedCurveTokens = function getSupportedCurveTokens(chainId, prevAddresses) {
  var coins = [];
  var addressSet = prevAddresses ? prevAddresses : new Set();
  curvePools.forEach(function (pool) {
    if (pool.chainId !== Number(chainId)) return;
    pool.coins.forEach(function (coin) {
      if (addressSet.has(coin.address)) return;
      addressSet.add(coin.address);
      coins.push({
        chainId: pool.chainId,
        value: coin.address,
        name: coin.symbol,
        symbol: coin.symbol,
        decimals: Number(coin.decimals),
        address: coin.address,
        type: 'CURVE'
      });
    });
  });
  return coins;
};

var mainnetTokensJson = [
	{
		token: {
			symbol: "USDT",
			address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
			decimal: 6,
			xfer_disabled: false
		},
		name: "Tether USD",
		icon: "https://get.celer.app/cbridge-icons/USDT.png",
		inbound_lmt: "5000000000000",
		inbound_epoch_cap: "10000000000000",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	},
	{
		token: {
			symbol: "USDC",
			address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
			decimal: 6,
			xfer_disabled: false
		},
		name: "USD Coin",
		icon: "https://get.celer.app/cbridge-icons/USDC.png",
		inbound_lmt: "5000000000000",
		inbound_epoch_cap: "10000000000000",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	},
	{
		token: {
			symbol: "WETH",
			address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
			decimal: 18,
			xfer_disabled: false,
			display_symbol: "ETH"
		},
		name: "ETH",
		icon: "https://get.celer.app/cbridge-icons/ETH.png",
		balance: "--"
	},
	{
		token: {
			symbol: "WETH",
			address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
			decimal: 18,
			xfer_disabled: false
		},
		name: "Wrapped ETH",
		icon: "https://get.celer.app/cbridge-icons/WETH.png",
		inbound_lmt: "2000000000000000000000",
		inbound_epoch_cap: "5000000000000000000000",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	},
	{
		token: {
			symbol: "ANML",
			address: "0x38B0e3A59183814957D83dF2a97492AED1F003e2",
			decimal: 18,
			xfer_disabled: false
		},
		name: "Animal Concerts Token",
		icon: "https://get.celer.app/cbridge-icons/ANML.png",
		inbound_lmt: "",
		inbound_epoch_cap: "",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	},
	{
		token: {
			symbol: "AVG",
			address: "0xa41F142b6eb2b164f8164CAE0716892Ce02f311f",
			decimal: 18,
			xfer_disabled: false
		},
		name: "Avocado DAO Token",
		icon: "https://get.celer.app/cbridge-icons/AVG.png",
		inbound_lmt: "",
		inbound_epoch_cap: "",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	},
	{
		token: {
			symbol: "DF",
			address: "0x431ad2ff6a9C365805eBaD47Ee021148d6f7DBe0",
			decimal: 18,
			xfer_disabled: false
		},
		name: "dForce",
		icon: "https://get.celer.app/cbridge-icons/DF.png",
		inbound_lmt: "",
		inbound_epoch_cap: "",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	},
	{
		token: {
			symbol: "DODO",
			address: "0x43Dfc4159D86F3A37A5A4B3D4580b888ad7d4DDd",
			decimal: 18,
			xfer_disabled: false
		},
		name: "DODO Bird",
		icon: "https://get.celer.app/cbridge-icons/DODO.jpg",
		inbound_lmt: "",
		inbound_epoch_cap: "",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	},
	{
		token: {
			symbol: "DOMI",
			address: "0x45C2F8c9B4c0bDC76200448cc26C48ab6ffef83F",
			decimal: 18,
			xfer_disabled: false
		},
		name: "Domi",
		icon: "https://get.celer.app/cbridge-icons/Domi.png",
		inbound_lmt: "",
		inbound_epoch_cap: "",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	},
	{
		token: {
			symbol: "GHX",
			address: "0x728f30fa2f100742C7949D1961804FA8E0B1387d",
			decimal: 18,
			xfer_disabled: false
		},
		name: "GamerCoin",
		icon: "https://get.celer.app/cbridge-icons/GHX.png",
		inbound_lmt: "",
		inbound_epoch_cap: "",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	},
	{
		token: {
			symbol: "LUSD",
			address: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
			decimal: 18,
			xfer_disabled: false
		},
		name: "Liquity USD",
		icon: "https://get.celer.app/cbridge-icons/LUSD.png",
		inbound_lmt: "",
		inbound_epoch_cap: "",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	},
	{
		token: {
			symbol: "MASK",
			address: "0x69af81e73A73B40adF4f3d4223Cd9b1ECE623074",
			decimal: 18,
			xfer_disabled: false
		},
		name: "Mask Network",
		icon: "https://get.celer.app/cbridge-icons/MASK.png",
		inbound_lmt: "",
		inbound_epoch_cap: "",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	},
	{
		token: {
			symbol: "MCB",
			address: "0x4e352cF164E64ADCBad318C3a1e222E9EBa4Ce42",
			decimal: 18,
			xfer_disabled: false
		},
		name: "MCDEX Token",
		icon: "https://get.celer.app/cbridge-icons/MCB.png",
		inbound_lmt: "",
		inbound_epoch_cap: "",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	},
	{
		token: {
			symbol: "PSP",
			address: "0xcAfE001067cDEF266AfB7Eb5A286dCFD277f3dE5",
			decimal: 18,
			xfer_disabled: false
		},
		name: "ParaSwap",
		icon: "https://get.celer.app/cbridge-icons/PSP.png",
		inbound_lmt: "",
		inbound_epoch_cap: "",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	},
	{
		token: {
			symbol: "REVA",
			address: "0x33CcE3a8BA0bf7Ec56B2CCD2aD9306748a84E4cf",
			decimal: 18,
			xfer_disabled: false
		},
		name: "Reva Token",
		icon: "https://get.celer.app/cbridge-icons/WREVA.png",
		inbound_lmt: "",
		inbound_epoch_cap: "",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	},
	{
		token: {
			symbol: "SOS",
			address: "0x3b484b82567a09e2588A13D54D032153f0c0aEe0",
			decimal: 18,
			xfer_disabled: false
		},
		name: "OpenDAO",
		icon: "https://get.celer.app/cbridge-icons/SOS.png",
		inbound_lmt: "",
		inbound_epoch_cap: "",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	},
	{
		token: {
			symbol: "USX",
			address: "0x0a5E677a6A24b2F1A2Bf4F3bFfC443231d2fDEc8",
			decimal: 18,
			xfer_disabled: false
		},
		name: "dForce USD",
		icon: "https://i.postimg.cc/zXtTRBJw/142.png",
		inbound_lmt: "",
		inbound_epoch_cap: "",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	},
	{
		token: {
			symbol: "iZi",
			address: "0x9ad37205d608B8b219e6a2573f922094CEc5c200",
			decimal: 18,
			xfer_disabled: false
		},
		name: "Izumi Finance",
		icon: "https://get.celer.app/cbridge-icons/IZI.png",
		inbound_lmt: "",
		inbound_epoch_cap: "",
		transfer_disabled: false,
		liq_add_disabled: false,
		liq_rm_disabled: false,
		liq_agg_rm_src_disabled: false,
		delay_threshold: "",
		delay_period: 0,
		balance: "--"
	}
];

var celerBridgeMainnetTokens = mainnetTokensJson.map(function (cToken) {
  return {
    value: cToken.token.address,
    address: cToken.token.address,
    decimals: cToken.token.decimal,
    symbol: cToken.token.symbol,
    chainId: 1,
    name: cToken.name,
    logoURI: cToken.icon,
    type: 'CELER_BRIDGE'
  };
});

function ownKeys$t(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$t(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$t(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$t(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var tokenTypes = ['DEFAULT', 'AAVE_V2', 'AAVE_V3', 'CURVE', 'CURVE_LP', 'CURVE_GAUGE', 'YEARN_VAULTS', 'RADIANT_V2', 'COMPOUND', 'YEARN_TOKENS', 'CELER_BRIDGE'];
var getAaveTokens = function getAaveTokens(_ref4) {
  var chainId = _ref4.chainId;
  if (chainId === '5') return aaveGoerliErc20.map(function (token) {
    return _objectSpread$t(_objectSpread$t({
      value: token.address
    }, token), {}, {
      type: 'AAVE_V2'
    });
  });
  if (chainId === '1') return aaveMainnetErc20.map(function (token) {
    return _objectSpread$t(_objectSpread$t({
      value: token.address
    }, token), {}, {
      type: 'AAVE_V2'
    });
  });
  return [];
};
var getCompoundTokens = function getCompoundTokens(_ref6) {
  var chainId = _ref6.chainId;
  return cTokens.filter(function (ct) {
    return ct.chainId === Number(chainId);
  }).map(function (token) {
    return _objectSpread$t(_objectSpread$t({
      value: token.address
    }, token), {}, {
      type: 'COMPOUND'
    });
  });
};
var getCurveLPTokens = function getCurveLPTokens(_ref7) {
  var chainId = _ref7.chainId;
  if (chainId === '1') return curveLPTokens.map(function (token) {
    return _objectSpread$t(_objectSpread$t({
      value: token.address
    }, token), {}, {
      type: 'CURVE_LP'
    });
  });
  if (chainId === '42161') return curveLPTokensArbitrum.map(function (token) {
    return _objectSpread$t(_objectSpread$t({
      value: token.address
    }, token), {}, {
      type: 'CURVE_LP'
    });
  });
  return [];
};
var getCurveGaugeTokens = function getCurveGaugeTokens(_ref8) {
  var chainId = _ref8.chainId;
  if (chainId === '1') return curveGaugeTokens.map(function (token) {
    return _objectSpread$t(_objectSpread$t({
      value: token.address
    }, token), {}, {
      type: 'CURVE_GAUGE'
    });
  });
  if (chainId === '42161') return curveGaugeTokensArbitrum.map(function (token) {
    return _objectSpread$t(_objectSpread$t({
      value: token.address
    }, token), {}, {
      type: 'CURVE_GAUGE'
    });
  });
  return [];
};
var getAaveV3Tokens = function getAaveV3Tokens(_ref9) {
  var chainId = _ref9.chainId;
  if (chainId == '1') return aaveV3MainnetErc20$1.map(function (token) {
    return _objectSpread$t(_objectSpread$t({
      value: token.address
    }, token), {}, {
      type: 'AAVE_V3'
    });
  });
  if (chainId == '42161') return aaveV3ArbitrumErc20$1.map(function (token) {
    return _objectSpread$t(_objectSpread$t({
      value: token.address
    }, token), {}, {
      type: 'AAVE_V3'
    });
  });
  return [];
};
var getYearnVaults = function getYearnVaults(_ref10) {
  var chainId = _ref10.chainId;
  if (chainId == '1') return yVaultsMainnet.map(function (token) {
    return _objectSpread$t(_objectSpread$t({}, token), {}, {
      type: 'YEARN_VAULTS'
    });
  });
  if (chainId == '42161') return yVaultsArbitrum.map(function (token) {
    return _objectSpread$t(_objectSpread$t({}, token), {}, {
      type: 'YEARN_VAULTS'
    });
  });
  return [];
};
var getYearnTokens = function getYearnTokens(_ref11) {
  var chainId = _ref11.chainId;
  if (chainId == '1') return yTokensMainnet.map(function (token) {
    return _objectSpread$t(_objectSpread$t({}, token), {}, {
      type: 'YEARN_TOKENS'
    });
  });
  if (chainId == '42161') return yTokensArbitrum.map(function (token) {
    return _objectSpread$t(_objectSpread$t({}, token), {}, {
      type: 'YEARN_TOKENS'
    });
  });
  return [];
};
var getRadiantV2Tokens = function getRadiantV2Tokens(_ref12) {
  var chainId = _ref12.chainId;
  if (chainId === '42161') return RadiantV2RTokens.map(function (token) {
    return _objectSpread$t(_objectSpread$t({
      value: token.address
    }, token), {}, {
      type: 'RADIANT_V2'
    });
  });
  return [];
};
var getAllCurrencies = function getAllCurrencies(_ref13) {
  var chainId = _ref13.chainId;
  var eth = ETHAddresses.filter(function (item) {
    return item.chainId === Number(chainId);
  }).map(function (contract) {
    return {
      value: contract.address,
      name: contract.name,
      decimals: contract.decimals,
      symbol: contract.symbol,
      logoURI: contract.logoURI,
      type: 'DEFAULT'
    };
  });
  var tokens = getSupportedTokens({
    chainId: chainId
  });
  return eth.concat(tokens);
};
var getSupportedTokens = function getSupportedTokens(_ref14) {
  var chainId = _ref14.chainId;
  // If chainId is undefined, return all tokens
  var tokenAddresses = new Set();
  var uniswapDefaults = uniswapDefaultErc20;
  var tokens = uniswapDefaults.map(function (contract) {
    return _objectSpread$t(_objectSpread$t({}, contract), {}, {
      type: 'DEFAULT'
    });
  }).concat(getAaveTokens({
    chainId: chainId
  }).map(function (token) {
    return _objectSpread$t(_objectSpread$t({}, token), {}, {
      chainId: Number(chainId)
    });
  })).concat(getAaveV3Tokens({
    chainId: chainId
  }).map(function (token) {
    return _objectSpread$t(_objectSpread$t({}, token), {}, {
      chainId: Number(chainId)
    });
  })).concat(getCompoundTokens({
    chainId: chainId
  })).concat(getCurveLPTokens({
    chainId: chainId
  })).concat(getCurveGaugeTokens({
    chainId: chainId
  })).filter(function (contract) {
    if (chainId && contract.chainId !== Number(chainId)) return false;
    return true;
  })
  // .filter((contract) => {
  //   if (tokenAddresses.has(contract.address)) return false
  //   tokenAddresses.add(contract.address)
  //   return true
  // })
  .map(function (contract) {
    return {
      value: contract.address,
      address: contract.address,
      name: contract.name,
      decimals: contract.decimals,
      symbol: contract.symbol,
      default: contract.name === 'Kirobo' ? true : contract.type === 'DEFAULT',
      logoURI: contract.logoURI,
      chainId: Number(contract.chainId),
      type: contract.type
    };
  });
  if (chainId) {
    return tokens.concat(getSupportedCurveTokens(chainId, tokenAddresses)).concat(getYearnVaults({
      chainId: chainId
    })).concat(getYearnTokens({
      chainId: chainId
    }));
  }
  return tokens;
};
var getSupportedContracts = function getSupportedContracts(_ref15) {
  var contracts = _ref15.contracts,
    chainId = _ref15.chainId;
  return contracts.filter(function (contract) {
    return contract.chainId === Number(chainId);
  }).map(function (contract) {
    return {
      value: contract.address,
      name: contract.name,
      decimals: contract.decimals,
      chainId: contract.chainId
    };
  });
};

var _format$3 = "hh-sol-artifact-1";
var contractName$3 = "IUniswapV3Pool";
var sourceName$3 = "contracts/interfaces/IUniswapV3Pool.sol";
var abi$4 = [
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "int24",
				name: "tickLower",
				type: "int24"
			},
			{
				indexed: true,
				internalType: "int24",
				name: "tickUpper",
				type: "int24"
			},
			{
				indexed: false,
				internalType: "uint128",
				name: "amount",
				type: "uint128"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		name: "Burn",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				indexed: true,
				internalType: "int24",
				name: "tickLower",
				type: "int24"
			},
			{
				indexed: true,
				internalType: "int24",
				name: "tickUpper",
				type: "int24"
			},
			{
				indexed: false,
				internalType: "uint128",
				name: "amount0",
				type: "uint128"
			},
			{
				indexed: false,
				internalType: "uint128",
				name: "amount1",
				type: "uint128"
			}
		],
		name: "Collect",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint128",
				name: "amount0",
				type: "uint128"
			},
			{
				indexed: false,
				internalType: "uint128",
				name: "amount1",
				type: "uint128"
			}
		],
		name: "CollectProtocol",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "paid0",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "paid1",
				type: "uint256"
			}
		],
		name: "Flash",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint16",
				name: "observationCardinalityNextOld",
				type: "uint16"
			},
			{
				indexed: false,
				internalType: "uint16",
				name: "observationCardinalityNextNew",
				type: "uint16"
			}
		],
		name: "IncreaseObservationCardinalityNext",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint160",
				name: "sqrtPriceX96",
				type: "uint160"
			},
			{
				indexed: false,
				internalType: "int24",
				name: "tick",
				type: "int24"
			}
		],
		name: "Initialize",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "int24",
				name: "tickLower",
				type: "int24"
			},
			{
				indexed: true,
				internalType: "int24",
				name: "tickUpper",
				type: "int24"
			},
			{
				indexed: false,
				internalType: "uint128",
				name: "amount",
				type: "uint128"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		name: "Mint",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint8",
				name: "feeProtocol0Old",
				type: "uint8"
			},
			{
				indexed: false,
				internalType: "uint8",
				name: "feeProtocol1Old",
				type: "uint8"
			},
			{
				indexed: false,
				internalType: "uint8",
				name: "feeProtocol0New",
				type: "uint8"
			},
			{
				indexed: false,
				internalType: "uint8",
				name: "feeProtocol1New",
				type: "uint8"
			}
		],
		name: "SetFeeProtocol",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				indexed: false,
				internalType: "int256",
				name: "amount0",
				type: "int256"
			},
			{
				indexed: false,
				internalType: "int256",
				name: "amount1",
				type: "int256"
			},
			{
				indexed: false,
				internalType: "uint160",
				name: "sqrtPriceX96",
				type: "uint160"
			},
			{
				indexed: false,
				internalType: "uint128",
				name: "liquidity",
				type: "uint128"
			},
			{
				indexed: false,
				internalType: "int24",
				name: "tick",
				type: "int24"
			}
		],
		name: "Swap",
		type: "event"
	},
	{
		inputs: [
			{
				internalType: "int24",
				name: "tickLower",
				type: "int24"
			},
			{
				internalType: "int24",
				name: "tickUpper",
				type: "int24"
			},
			{
				internalType: "uint128",
				name: "amount",
				type: "uint128"
			}
		],
		name: "burn",
		outputs: [
			{
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "int24",
				name: "tickLower",
				type: "int24"
			},
			{
				internalType: "int24",
				name: "tickUpper",
				type: "int24"
			},
			{
				internalType: "uint128",
				name: "amount0Requested",
				type: "uint128"
			},
			{
				internalType: "uint128",
				name: "amount1Requested",
				type: "uint128"
			}
		],
		name: "collect",
		outputs: [
			{
				internalType: "uint128",
				name: "amount0",
				type: "uint128"
			},
			{
				internalType: "uint128",
				name: "amount1",
				type: "uint128"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "uint128",
				name: "amount0Requested",
				type: "uint128"
			},
			{
				internalType: "uint128",
				name: "amount1Requested",
				type: "uint128"
			}
		],
		name: "collectProtocol",
		outputs: [
			{
				internalType: "uint128",
				name: "amount0",
				type: "uint128"
			},
			{
				internalType: "uint128",
				name: "amount1",
				type: "uint128"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "factory",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "fee",
		outputs: [
			{
				internalType: "uint24",
				name: "",
				type: "uint24"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "feeGrowthGlobal0X128",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "feeGrowthGlobal1X128",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "flash",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint16",
				name: "observationCardinalityNext",
				type: "uint16"
			}
		],
		name: "increaseObservationCardinalityNext",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint160",
				name: "sqrtPriceX96",
				type: "uint160"
			}
		],
		name: "initialize",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "liquidity",
		outputs: [
			{
				internalType: "uint128",
				name: "",
				type: "uint128"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "maxLiquidityPerTick",
		outputs: [
			{
				internalType: "uint128",
				name: "",
				type: "uint128"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "int24",
				name: "tickLower",
				type: "int24"
			},
			{
				internalType: "int24",
				name: "tickUpper",
				type: "int24"
			},
			{
				internalType: "uint128",
				name: "amount",
				type: "uint128"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "mint",
		outputs: [
			{
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "index",
				type: "uint256"
			}
		],
		name: "observations",
		outputs: [
			{
				internalType: "uint32",
				name: "blockTimestamp",
				type: "uint32"
			},
			{
				internalType: "int56",
				name: "tickCumulative",
				type: "int56"
			},
			{
				internalType: "uint160",
				name: "secondsPerLiquidityCumulativeX128",
				type: "uint160"
			},
			{
				internalType: "bool",
				name: "initialized",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint32[]",
				name: "secondsAgos",
				type: "uint32[]"
			}
		],
		name: "observe",
		outputs: [
			{
				internalType: "int56[]",
				name: "tickCumulatives",
				type: "int56[]"
			},
			{
				internalType: "uint160[]",
				name: "secondsPerLiquidityCumulativeX128s",
				type: "uint160[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "positions",
		outputs: [
			{
				internalType: "uint128",
				name: "_liquidity",
				type: "uint128"
			},
			{
				internalType: "uint256",
				name: "feeGrowthInside0LastX128",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "feeGrowthInside1LastX128",
				type: "uint256"
			},
			{
				internalType: "uint128",
				name: "tokensOwed0",
				type: "uint128"
			},
			{
				internalType: "uint128",
				name: "tokensOwed1",
				type: "uint128"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "protocolFees",
		outputs: [
			{
				internalType: "uint128",
				name: "token0",
				type: "uint128"
			},
			{
				internalType: "uint128",
				name: "token1",
				type: "uint128"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint8",
				name: "feeProtocol0",
				type: "uint8"
			},
			{
				internalType: "uint8",
				name: "feeProtocol1",
				type: "uint8"
			}
		],
		name: "setFeeProtocol",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "slot0",
		outputs: [
			{
				internalType: "uint160",
				name: "sqrtPriceX96",
				type: "uint160"
			},
			{
				internalType: "int24",
				name: "tick",
				type: "int24"
			},
			{
				internalType: "uint16",
				name: "observationIndex",
				type: "uint16"
			},
			{
				internalType: "uint16",
				name: "observationCardinality",
				type: "uint16"
			},
			{
				internalType: "uint16",
				name: "observationCardinalityNext",
				type: "uint16"
			},
			{
				internalType: "uint8",
				name: "feeProtocol",
				type: "uint8"
			},
			{
				internalType: "bool",
				name: "unlocked",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "int24",
				name: "tickLower",
				type: "int24"
			},
			{
				internalType: "int24",
				name: "tickUpper",
				type: "int24"
			}
		],
		name: "snapshotCumulativesInside",
		outputs: [
			{
				internalType: "int56",
				name: "tickCumulativeInside",
				type: "int56"
			},
			{
				internalType: "uint160",
				name: "secondsPerLiquidityInsideX128",
				type: "uint160"
			},
			{
				internalType: "uint32",
				name: "secondsInside",
				type: "uint32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "bool",
				name: "zeroForOne",
				type: "bool"
			},
			{
				internalType: "int256",
				name: "amountSpecified",
				type: "int256"
			},
			{
				internalType: "uint160",
				name: "sqrtPriceLimitX96",
				type: "uint160"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "swap",
		outputs: [
			{
				internalType: "int256",
				name: "amount0",
				type: "int256"
			},
			{
				internalType: "int256",
				name: "amount1",
				type: "int256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "int16",
				name: "wordPosition",
				type: "int16"
			}
		],
		name: "tickBitmap",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "tickSpacing",
		outputs: [
			{
				internalType: "int24",
				name: "",
				type: "int24"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "int24",
				name: "tick",
				type: "int24"
			}
		],
		name: "ticks",
		outputs: [
			{
				internalType: "uint128",
				name: "liquidityGross",
				type: "uint128"
			},
			{
				internalType: "int128",
				name: "liquidityNet",
				type: "int128"
			},
			{
				internalType: "uint256",
				name: "feeGrowthOutside0X128",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "feeGrowthOutside1X128",
				type: "uint256"
			},
			{
				internalType: "int56",
				name: "tickCumulativeOutside",
				type: "int56"
			},
			{
				internalType: "uint160",
				name: "secondsPerLiquidityOutsideX128",
				type: "uint160"
			},
			{
				internalType: "uint32",
				name: "secondsOutside",
				type: "uint32"
			},
			{
				internalType: "bool",
				name: "initialized",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "token0",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "token1",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	}
];
var bytecode$4 = "0x";
var deployedBytecode$3 = "0x";
var linkReferences$3 = {
};
var deployedLinkReferences$3 = {
};
var IUniswapV3PoolJson = {
	_format: _format$3,
	contractName: contractName$3,
	sourceName: sourceName$3,
	abi: abi$4,
	bytecode: bytecode$4,
	deployedBytecode: deployedBytecode$3,
	linkReferences: linkReferences$3,
	deployedLinkReferences: deployedLinkReferences$3
};

var _format$2 = "hh-sol-artifact-1";
var contractName$2 = "NonfungiblePositionManager";
var sourceName$2 = "contracts/NonfungiblePositionManager.sol";
var abi$3 = [
	{
		inputs: [
			{
				internalType: "address",
				name: "_factory",
				type: "address"
			},
			{
				internalType: "address",
				name: "_WETH9",
				type: "address"
			},
			{
				internalType: "address",
				name: "_tokenDescriptor_",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "approved",
				type: "address"
			},
			{
				indexed: true,
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "operator",
				type: "address"
			},
			{
				indexed: false,
				internalType: "bool",
				name: "approved",
				type: "bool"
			}
		],
		name: "ApprovalForAll",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		name: "Collect",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint128",
				name: "liquidity",
				type: "uint128"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		name: "DecreaseLiquidity",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint128",
				name: "liquidity",
				type: "uint128"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		name: "IncreaseLiquidity",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: true,
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		inputs: [
		],
		name: "DOMAIN_SEPARATOR",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "PERMIT_TYPEHASH",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "WETH9",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "baseURI",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "burn",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "tokenId",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "recipient",
						type: "address"
					},
					{
						internalType: "uint128",
						name: "amount0Max",
						type: "uint128"
					},
					{
						internalType: "uint128",
						name: "amount1Max",
						type: "uint128"
					}
				],
				internalType: "struct INonfungiblePositionManager.CollectParams",
				name: "params",
				type: "tuple"
			}
		],
		name: "collect",
		outputs: [
			{
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token0",
				type: "address"
			},
			{
				internalType: "address",
				name: "token1",
				type: "address"
			},
			{
				internalType: "uint24",
				name: "fee",
				type: "uint24"
			},
			{
				internalType: "uint160",
				name: "sqrtPriceX96",
				type: "uint160"
			}
		],
		name: "createAndInitializePoolIfNecessary",
		outputs: [
			{
				internalType: "address",
				name: "pool",
				type: "address"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "tokenId",
						type: "uint256"
					},
					{
						internalType: "uint128",
						name: "liquidity",
						type: "uint128"
					},
					{
						internalType: "uint256",
						name: "amount0Min",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amount1Min",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "deadline",
						type: "uint256"
					}
				],
				internalType: "struct INonfungiblePositionManager.DecreaseLiquidityParams",
				name: "params",
				type: "tuple"
			}
		],
		name: "decreaseLiquidity",
		outputs: [
			{
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "factory",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "getApproved",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "tokenId",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amount0Desired",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amount1Desired",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amount0Min",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amount1Min",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "deadline",
						type: "uint256"
					}
				],
				internalType: "struct INonfungiblePositionManager.IncreaseLiquidityParams",
				name: "params",
				type: "tuple"
			}
		],
		name: "increaseLiquidity",
		outputs: [
			{
				internalType: "uint128",
				name: "liquidity",
				type: "uint128"
			},
			{
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "operator",
				type: "address"
			}
		],
		name: "isApprovedForAll",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "token0",
						type: "address"
					},
					{
						internalType: "address",
						name: "token1",
						type: "address"
					},
					{
						internalType: "uint24",
						name: "fee",
						type: "uint24"
					},
					{
						internalType: "int24",
						name: "tickLower",
						type: "int24"
					},
					{
						internalType: "int24",
						name: "tickUpper",
						type: "int24"
					},
					{
						internalType: "uint256",
						name: "amount0Desired",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amount1Desired",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amount0Min",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amount1Min",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "recipient",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "deadline",
						type: "uint256"
					}
				],
				internalType: "struct INonfungiblePositionManager.MintParams",
				name: "params",
				type: "tuple"
			}
		],
		name: "mint",
		outputs: [
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			},
			{
				internalType: "uint128",
				name: "liquidity",
				type: "uint128"
			},
			{
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes[]",
				name: "data",
				type: "bytes[]"
			}
		],
		name: "multicall",
		outputs: [
			{
				internalType: "bytes[]",
				name: "results",
				type: "bytes[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "name",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "ownerOf",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "permit",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "positions",
		outputs: [
			{
				internalType: "uint96",
				name: "nonce",
				type: "uint96"
			},
			{
				internalType: "address",
				name: "operator",
				type: "address"
			},
			{
				internalType: "address",
				name: "token0",
				type: "address"
			},
			{
				internalType: "address",
				name: "token1",
				type: "address"
			},
			{
				internalType: "uint24",
				name: "fee",
				type: "uint24"
			},
			{
				internalType: "int24",
				name: "tickLower",
				type: "int24"
			},
			{
				internalType: "int24",
				name: "tickUpper",
				type: "int24"
			},
			{
				internalType: "uint128",
				name: "liquidity",
				type: "uint128"
			},
			{
				internalType: "uint256",
				name: "feeGrowthInside0LastX128",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "feeGrowthInside1LastX128",
				type: "uint256"
			},
			{
				internalType: "uint128",
				name: "tokensOwed0",
				type: "uint128"
			},
			{
				internalType: "uint128",
				name: "tokensOwed1",
				type: "uint128"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "refundETH",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "safeTransferFrom",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "_data",
				type: "bytes"
			}
		],
		name: "safeTransferFrom",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "selfPermit",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "nonce",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "expiry",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "selfPermitAllowed",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "nonce",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "expiry",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "selfPermitAllowedIfNecessary",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "selfPermitIfNecessary",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "operator",
				type: "address"
			},
			{
				internalType: "bool",
				name: "approved",
				type: "bool"
			}
		],
		name: "setApprovalForAll",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes4",
				name: "interfaceId",
				type: "bytes4"
			}
		],
		name: "supportsInterface",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amountMinimum",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			}
		],
		name: "sweepToken",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "index",
				type: "uint256"
			}
		],
		name: "tokenByIndex",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "index",
				type: "uint256"
			}
		],
		name: "tokenOfOwnerByIndex",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "tokenURI",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "tokenId",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amount0Owed",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amount1Owed",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "uniswapV3MintCallback",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountMinimum",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			}
		],
		name: "unwrapWETH9",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		stateMutability: "payable",
		type: "receive"
	}
];
var bytecode$3 = "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";
var deployedBytecode$2 = "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";
var linkReferences$2 = {
};
var deployedLinkReferences$2 = {
};
var NonfungiblePositionManagerABI = {
	_format: _format$2,
	contractName: contractName$2,
	sourceName: sourceName$2,
	abi: abi$3,
	bytecode: bytecode$3,
	deployedBytecode: deployedBytecode$2,
	linkReferences: linkReferences$2,
	deployedLinkReferences: deployedLinkReferences$2
};

var _CHAIN_IDS_TO_NAMES;
/**
 * List of all the networks supported by the Uniswap Interface
 */
var SupportedChainId = /*#__PURE__*/function (SupportedChainId) {
  SupportedChainId[SupportedChainId["MAINNET"] = 1] = "MAINNET";
  SupportedChainId[SupportedChainId["ROPSTEN"] = 3] = "ROPSTEN";
  SupportedChainId[SupportedChainId["RINKEBY"] = 4] = "RINKEBY";
  SupportedChainId[SupportedChainId["GOERLI"] = 5] = "GOERLI";
  SupportedChainId[SupportedChainId["KOVAN"] = 42] = "KOVAN";
  SupportedChainId[SupportedChainId["ARBITRUM_ONE"] = 42161] = "ARBITRUM_ONE";
  SupportedChainId[SupportedChainId["ARBITRUM_RINKEBY"] = 421611] = "ARBITRUM_RINKEBY";
  SupportedChainId[SupportedChainId["ARBITRUM_GOERLI"] = 421613] = "ARBITRUM_GOERLI";
  SupportedChainId[SupportedChainId["OPTIMISM"] = 10] = "OPTIMISM";
  SupportedChainId[SupportedChainId["OPTIMISTIC_KOVAN"] = 69] = "OPTIMISTIC_KOVAN";
  SupportedChainId[SupportedChainId["POLYGON"] = 137] = "POLYGON";
  SupportedChainId[SupportedChainId["POLYGON_MUMBAI"] = 80001] = "POLYGON_MUMBAI";
  return SupportedChainId;
}({});
(_CHAIN_IDS_TO_NAMES = {}, _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.MAINNET, 'mainnet'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.ROPSTEN, 'ropsten'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.RINKEBY, 'rinkeby'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.GOERLI, 'goerli'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.KOVAN, 'kovan'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.POLYGON, 'polygon'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.POLYGON_MUMBAI, 'polygon_mumbai'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.ARBITRUM_ONE, 'arbitrum'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.ARBITRUM_RINKEBY, 'arbitrum_rinkeby'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.ARBITRUM_GOERLI, 'arbitrum_goerli'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.OPTIMISM, 'optimism'), _defineProperty(_CHAIN_IDS_TO_NAMES, SupportedChainId.OPTIMISTIC_KOVAN, 'optimistic_kovan'), _CHAIN_IDS_TO_NAMES);

/**
 * Array of all the supported chain IDs
 */
Object.values(SupportedChainId).filter(function (id) {
  return typeof id === 'number';
});
[SupportedChainId.MAINNET, SupportedChainId.POLYGON, SupportedChainId.OPTIMISM, SupportedChainId.ARBITRUM_ONE];

/**
 * All the chain IDs that are running the Ethereum protocol.
 */
[SupportedChainId.MAINNET, SupportedChainId.ROPSTEN, SupportedChainId.RINKEBY, SupportedChainId.GOERLI, SupportedChainId.KOVAN, SupportedChainId.POLYGON, SupportedChainId.POLYGON_MUMBAI];
/**
 * Controls some L2 specific behavior, e.g. slippage tolerance, special UI behavior.
 * The expectation is that all of these networks have immediate transaction confirmation.
 */
var L2_CHAIN_IDS = [SupportedChainId.ARBITRUM_ONE, SupportedChainId.ARBITRUM_RINKEBY, SupportedChainId.ARBITRUM_GOERLI, SupportedChainId.OPTIMISM, SupportedChainId.OPTIMISTIC_KOVAN];

var DEFAULT_NETWORKS = [SupportedChainId.MAINNET, SupportedChainId.ROPSTEN, SupportedChainId.RINKEBY, SupportedChainId.GOERLI, SupportedChainId.KOVAN];
function constructSameAddressMap(address) {
  var additionalNetworks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return DEFAULT_NETWORKS.concat(additionalNetworks).reduce(function (memo, chainId) {
    memo[chainId] = address;
    return memo;
  }, {});
}

var _objectSpread2$1, _ENS_REGISTRAR_ADDRES, _TICK_LENS_ADDRESSES;
function ownKeys$s(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$s(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$s(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$s(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var UNI_ADDRESS = constructSameAddressMap('0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984');
_objectSpread$s(_objectSpread$s({}, constructSameAddressMap('0x1F98415757620B543A52E61c46B32eB19261F984', [SupportedChainId.OPTIMISTIC_KOVAN, SupportedChainId.OPTIMISM, SupportedChainId.POLYGON_MUMBAI, SupportedChainId.POLYGON])), {}, (_objectSpread2$1 = {}, _defineProperty(_objectSpread2$1, SupportedChainId.ARBITRUM_ONE, '0xadF885960B47eA2CD9B55E6DAc6B42b7Cb2806dB'), _defineProperty(_objectSpread2$1, SupportedChainId.ARBITRUM_RINKEBY, '0xa501c031958F579dB7676fF1CE78AD305794d579'), _objectSpread2$1));
var V2_ROUTER_ADDRESS = constructSameAddressMap('0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D');
var V3_ROUTER_ADDRESS = constructSameAddressMap('0xE592427A0AEce92De3Edee1F18E0157C05861564', [SupportedChainId.OPTIMISM, SupportedChainId.OPTIMISTIC_KOVAN, SupportedChainId.ARBITRUM_ONE, SupportedChainId.ARBITRUM_RINKEBY, SupportedChainId.ARBITRUM_GOERLI, SupportedChainId.POLYGON, SupportedChainId.POLYGON_MUMBAI]);
constructSameAddressMap('0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45', [SupportedChainId.OPTIMISM, SupportedChainId.OPTIMISTIC_KOVAN, SupportedChainId.ARBITRUM_ONE, SupportedChainId.ARBITRUM_RINKEBY, SupportedChainId.ARBITRUM_GOERLI, SupportedChainId.POLYGON, SupportedChainId.POLYGON_MUMBAI]);

/**
 * The oldest V0 governance address
 */
constructSameAddressMap('0x5e4be8Bc9637f0EAA1A755019e06A68ce081D58F');
/**
 * The older V1 governance address
 */
_defineProperty({}, SupportedChainId.MAINNET, '0xC4e172459f1E7939D522503B81AFAaC1014CE6F6');
/**
 * The latest governor bravo that is currently admin of timelock
 */
_defineProperty({}, SupportedChainId.MAINNET, '0x408ED6354d4973f66138C91495F2f2FCbd8724C3');
constructSameAddressMap('0x1a9C8182C09F50C8318d769245beA52c32BE35BC');
_defineProperty({}, SupportedChainId.MAINNET, '0x090D4613473dEE047c3f2706764f49E0821D256e');
_defineProperty({}, SupportedChainId.MAINNET, '0xeca4B0bDBf7c55E9b7925919d03CbF8Dc82537E8');
constructSameAddressMap(FACTORY_ADDRESS$1, [SupportedChainId.OPTIMISM, SupportedChainId.OPTIMISTIC_KOVAN, SupportedChainId.ARBITRUM_ONE, SupportedChainId.ARBITRUM_RINKEBY, SupportedChainId.ARBITRUM_GOERLI, SupportedChainId.POLYGON_MUMBAI, SupportedChainId.POLYGON]);
constructSameAddressMap('0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6', [SupportedChainId.OPTIMISM, SupportedChainId.OPTIMISTIC_KOVAN, SupportedChainId.ARBITRUM_ONE, SupportedChainId.ARBITRUM_RINKEBY, SupportedChainId.ARBITRUM_GOERLI, SupportedChainId.POLYGON_MUMBAI, SupportedChainId.POLYGON]);
var NONFUNGIBLE_POSITION_MANAGER_ADDRESSES$1 = constructSameAddressMap('0xC36442b4a4522E871399CD717aBDD847Ab11FE88', [SupportedChainId.OPTIMISM, SupportedChainId.OPTIMISTIC_KOVAN, SupportedChainId.ARBITRUM_ONE, SupportedChainId.ARBITRUM_RINKEBY, SupportedChainId.ARBITRUM_GOERLI, SupportedChainId.POLYGON_MUMBAI, SupportedChainId.POLYGON]);
(_ENS_REGISTRAR_ADDRES = {}, _defineProperty(_ENS_REGISTRAR_ADDRES, SupportedChainId.MAINNET, '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e'), _defineProperty(_ENS_REGISTRAR_ADDRES, SupportedChainId.ROPSTEN, '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e'), _defineProperty(_ENS_REGISTRAR_ADDRES, SupportedChainId.GOERLI, '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e'), _defineProperty(_ENS_REGISTRAR_ADDRES, SupportedChainId.RINKEBY, '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e'), _ENS_REGISTRAR_ADDRES);
_defineProperty({}, SupportedChainId.MAINNET, '0x65770b5283117639760beA3F867b69b3697a91dd');
constructSameAddressMap('0xA5644E29708357803b5A882D272c41cC0dF92B34', [SupportedChainId.ARBITRUM_ONE, SupportedChainId.ARBITRUM_RINKEBY, SupportedChainId.ARBITRUM_GOERLI, SupportedChainId.POLYGON_MUMBAI, SupportedChainId.POLYGON]);
(_TICK_LENS_ADDRESSES = {}, _defineProperty(_TICK_LENS_ADDRESSES, SupportedChainId.ARBITRUM_ONE, '0xbfd8137f7d1516D3ea5cA83523914859ec47F573'), _defineProperty(_TICK_LENS_ADDRESSES, SupportedChainId.ARBITRUM_RINKEBY, '0xbfd8137f7d1516D3ea5cA83523914859ec47F573'), _TICK_LENS_ADDRESSES);

config();
var ALCHEMY_ID = '9j9SdF5HiwChoVUJLk-DaKNxU4Xm6ok1'; //"9j9SdF5HiwChoVUJLk-DaKNxU4Xm6ok1"//process.env.ALCHEMY_ID
var RPCs = {
  '1': "https://eth-mainnet.g.alchemy.com/v2/".concat(ALCHEMY_ID),
  '5': "https://eth-goerli.g.alchemy.com/v2/".concat(ALCHEMY_ID),
  '42161': "https://rpc.ankr.com/arbitrum",
  '421613': 'https://goerli-rollup.arbitrum.io/rpc',
  '11155111': 'https://sepolia.gateway.tenderly.co/19XD817c4zNXz6xBFYnyLb'
};

/* eslint-disable no-restricted-imports */
var providerMainnet = new ethers.providers.JsonRpcProvider(RPCs['1']);
var providerGoerli = new ethers.providers.JsonRpcProvider(RPCs['5']);
var providerArbitrum = new ethers.providers.JsonRpcProvider(RPCs['42161']);
var providerArbitrumTestnet = new ethers.providers.JsonRpcProvider(RPCs['421613']);
var providerSepolia = new ethers.providers.JsonRpcProvider(RPCs['11155111']);
var provider = {
  '1': providerMainnet,
  '5': providerGoerli,
  '42161': providerArbitrum,
  '421613': providerArbitrumTestnet,
  '11155111': providerSepolia
};

var DEFAULT_ADDRESS = '0xD4a0281cEeebA1CEeFB4eAbF63ca6A608E143Fdc';
var Config = /*#__PURE__*/function () {
  function Config(_ref) {
    var _this = this;
    var _chainId = _ref.chainId,
      _account = _ref.account,
      _provider = _ref.provider,
      signer = _ref.signer;
    _classCallCheck(this, Config);
    _defineProperty(this, "signer", undefined);
    _defineProperty(this, "setLibrary", function (_ref2) {
      var chainId = _ref2.chainId,
        account = _ref2.account,
        provider$1 = _ref2.provider;
      _this.chainId = Number(chainId);
      _this.library = provider$1 || provider[chainId];
      if (!_this.library && !provider[chainId]) {
        console.error('Provider not found');
      }
      if (account && _this.library) {
        _this._account = account;
        _this.signer = _this.library.getSigner(account);
      }
    });
    _defineProperty(this, "setChainId", function (_ref3) {
      var chainId = _ref3.chainId;
      _this.chainId = Number(chainId);
    });
    _defineProperty(this, "setAccount", function (_ref4) {
      var account = _ref4.account;
      _this._account = account;
    });
    _defineProperty(this, "getLastBlock", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var blockNumber, block, blockTimestamp;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.library.getBlockNumber();
          case 2:
            blockNumber = _context.sent;
            _context.next = 5;
            return _this.library.getBlock(blockNumber);
          case 5:
            block = _context.sent;
            blockTimestamp = BigNumber.from(block.timestamp);
            return _context.abrupt("return", {
              blockNumber: blockNumber,
              blockTimestamp: blockTimestamp
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    this._account = _account || DEFAULT_ADDRESS;
    this.chainId = Number(_chainId);
    this.library = _provider || provider[_chainId];
    if (!this.library && !provider[_chainId]) {
      console.error('Provider not found');
    }
    if (_account && this.library) {
      this.signer = signer || this.library.getSigner(_account);
    }
  }
  _createClass(Config, [{
    key: "account",
    get: function get() {
      return this._account;
    }
  }]);
  return Config;
}();

var abi$2 = [
	{
		inputs: [
		],
		name: "WETH",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "tokenA",
				type: "address"
			},
			{
				internalType: "address",
				name: "tokenB",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amountADesired",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountBDesired",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountBMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "addLiquidity",
		outputs: [
			{
				internalType: "uint256",
				name: "amountA",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountB",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amountTokenDesired",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountTokenMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountETHMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "addLiquidityETH",
		outputs: [
			{
				internalType: "uint256",
				name: "amountToken",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountETH",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "factory",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveOut",
				type: "uint256"
			}
		],
		name: "getAmountIn",
		outputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveOut",
				type: "uint256"
			}
		],
		name: "getAmountOut",
		outputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			}
		],
		name: "getAmountsIn",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			}
		],
		name: "getAmountsOut",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountA",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveA",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveB",
				type: "uint256"
			}
		],
		name: "quote",
		outputs: [
			{
				internalType: "uint256",
				name: "amountB",
				type: "uint256"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "tokenA",
				type: "address"
			},
			{
				internalType: "address",
				name: "tokenB",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountBMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "removeLiquidity",
		outputs: [
			{
				internalType: "uint256",
				name: "amountA",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountB",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountTokenMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountETHMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "removeLiquidityETH",
		outputs: [
			{
				internalType: "uint256",
				name: "amountToken",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountETH",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountTokenMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountETHMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "removeLiquidityETHSupportingFeeOnTransferTokens",
		outputs: [
			{
				internalType: "uint256",
				name: "amountETH",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountTokenMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountETHMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "approveMax",
				type: "bool"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "removeLiquidityETHWithPermit",
		outputs: [
			{
				internalType: "uint256",
				name: "amountToken",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountETH",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountTokenMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountETHMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "approveMax",
				type: "bool"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "removeLiquidityETHWithPermitSupportingFeeOnTransferTokens",
		outputs: [
			{
				internalType: "uint256",
				name: "amountETH",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "tokenA",
				type: "address"
			},
			{
				internalType: "address",
				name: "tokenB",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountBMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "approveMax",
				type: "bool"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "removeLiquidityWithPermit",
		outputs: [
			{
				internalType: "uint256",
				name: "amountA",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountB",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapETHForExactTokens",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactETHForTokens",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactETHForTokensSupportingFeeOnTransferTokens",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactTokensForETH",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactTokensForETHSupportingFeeOnTransferTokens",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactTokensForTokens",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountInMax",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapTokensForExactETH",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountInMax",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapTokensForExactTokens",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];
var evm = {
	bytecode: {
		linkReferences: {
		},
		object: "",
		opcodes: "",
		sourceMap: ""
	},
	deployedBytecode: {
		immutableReferences: {
		},
		linkReferences: {
		},
		object: "",
		opcodes: "",
		sourceMap: ""
	}
};
var bytecode$2 = "";
var IUniswapV2Router02Json = {
	abi: abi$2,
	evm: evm,
	"interface": [
	{
		inputs: [
		],
		name: "WETH",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "tokenA",
				type: "address"
			},
			{
				internalType: "address",
				name: "tokenB",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amountADesired",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountBDesired",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountBMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "addLiquidity",
		outputs: [
			{
				internalType: "uint256",
				name: "amountA",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountB",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amountTokenDesired",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountTokenMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountETHMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "addLiquidityETH",
		outputs: [
			{
				internalType: "uint256",
				name: "amountToken",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountETH",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "factory",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveOut",
				type: "uint256"
			}
		],
		name: "getAmountIn",
		outputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveOut",
				type: "uint256"
			}
		],
		name: "getAmountOut",
		outputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			}
		],
		name: "getAmountsIn",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			}
		],
		name: "getAmountsOut",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountA",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveA",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "reserveB",
				type: "uint256"
			}
		],
		name: "quote",
		outputs: [
			{
				internalType: "uint256",
				name: "amountB",
				type: "uint256"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "tokenA",
				type: "address"
			},
			{
				internalType: "address",
				name: "tokenB",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountBMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "removeLiquidity",
		outputs: [
			{
				internalType: "uint256",
				name: "amountA",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountB",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountTokenMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountETHMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "removeLiquidityETH",
		outputs: [
			{
				internalType: "uint256",
				name: "amountToken",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountETH",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountTokenMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountETHMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "removeLiquidityETHSupportingFeeOnTransferTokens",
		outputs: [
			{
				internalType: "uint256",
				name: "amountETH",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountTokenMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountETHMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "approveMax",
				type: "bool"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "removeLiquidityETHWithPermit",
		outputs: [
			{
				internalType: "uint256",
				name: "amountToken",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountETH",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountTokenMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountETHMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "approveMax",
				type: "bool"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "removeLiquidityETHWithPermitSupportingFeeOnTransferTokens",
		outputs: [
			{
				internalType: "uint256",
				name: "amountETH",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "tokenA",
				type: "address"
			},
			{
				internalType: "address",
				name: "tokenB",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountAMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountBMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "approveMax",
				type: "bool"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "removeLiquidityWithPermit",
		outputs: [
			{
				internalType: "uint256",
				name: "amountA",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountB",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapETHForExactTokens",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactETHForTokens",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactETHForTokensSupportingFeeOnTransferTokens",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactTokensForETH",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactTokensForETHSupportingFeeOnTransferTokens",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactTokensForTokens",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapExactTokensForTokensSupportingFeeOnTransferTokens",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountInMax",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapTokensForExactETH",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountInMax",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			}
		],
		name: "swapTokensForExactTokens",
		outputs: [
			{
				internalType: "uint256[]",
				name: "amounts",
				type: "uint256[]"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
],
	bytecode: bytecode$2
};

var uniswapV2PairContract = [
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			}
		],
		name: "Burn",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		name: "Mint",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0In",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1In",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount0Out",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount1Out",
				type: "uint256"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			}
		],
		name: "Swap",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint112",
				name: "reserve0",
				type: "uint112"
			},
			{
				indexed: false,
				internalType: "uint112",
				name: "reserve1",
				type: "uint112"
			}
		],
		name: "Sync",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		constant: true,
		inputs: [
		],
		name: "DOMAIN_SEPARATOR",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "MINIMUM_LIQUIDITY",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "pure",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "PERMIT_TYPEHASH",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		payable: false,
		stateMutability: "pure",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			}
		],
		name: "burn",
		outputs: [
			{
				internalType: "uint256",
				name: "amount0",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amount1",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				internalType: "uint8",
				name: "",
				type: "uint8"
			}
		],
		payable: false,
		stateMutability: "pure",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "factory",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "getReserves",
		outputs: [
			{
				internalType: "uint112",
				name: "reserve0",
				type: "uint112"
			},
			{
				internalType: "uint112",
				name: "reserve1",
				type: "uint112"
			},
			{
				internalType: "uint32",
				name: "blockTimestampLast",
				type: "uint32"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			},
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "initialize",
		outputs: [
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "kLast",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			}
		],
		name: "mint",
		outputs: [
			{
				internalType: "uint256",
				name: "liquidity",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "name",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		payable: false,
		stateMutability: "pure",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			}
		],
		name: "nonces",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "permit",
		outputs: [
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "price0CumulativeLast",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "price1CumulativeLast",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			}
		],
		name: "skim",
		outputs: [
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				internalType: "uint256",
				name: "amount0Out",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amount1Out",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "swap",
		outputs: [
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		payable: false,
		stateMutability: "pure",
		type: "function"
	},
	{
		constant: false,
		inputs: [
		],
		name: "sync",
		outputs: [
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "token0",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "token1",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	}
];

var getPlugin$1 = function getPlugin(_ref) {
  var plugins = _ref.plugins,
    methodName = _ref.methodName;
  for (var pluginKey in plugins) {
    var key = pluginKey;
    if (new plugins[key]({
      chainId: '1'
    }).method === methodName) {
      return plugins[key];
    }
  }
  return;
};

var MULTICALL_ADDRESS = '0x5ba1e12693dc8f9c48aad8770482f4739beed696';
var MULTICALL_ADDRESSES$1 = [{
  address: MULTICALL_ADDRESS,
  chainId: 1
}, {
  address: MULTICALL_ADDRESS,
  chainId: 5
}, {
  address: '0xBF69a56D35B8d6f5A8e0e96B245a72F735751e54',
  chainId: 42161
}, {
  address: '0x961E16D26D3f1fc042F192a2e5054120938c1CD5',
  chainId: 421613
}];
var WETH_ADDRESSES = [{
  address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
  chainId: 1
}, {
  address: '0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6',
  chainId: 5
}, {
  address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
  chainId: 42161
}, {
  address: '0x1757f2E7BEE5abE1A79532000d05e32D90dD79fF',
  chainId: 421613
}];

// Convert WETH_ADDRESSES array to a map
var WETH_ADDRESS_MAP = WETH_ADDRESSES.reduce(function (map, _ref) {
  var address = _ref.address,
    chainId = _ref.chainId;
  map[chainId] = address;
  return map;
}, {});

/**
 * Parses a CurrencyAmount from the passed string.
 * Returns the CurrencyAmount, or undefined if parsing fails.
 */
function weiToCurrency(value, currency) {
  if (!value || !currency) {
    return undefined;
  }
  try {
    var currecyAmount = CurrencyAmount.fromRawAmount(currency, JSBI.BigInt(value));
    return currecyAmount;
  } catch (error) {
    // fails if the user specifies too many decimal places of precision (or maybe exceed max uint?)
    console.debug("Failed to parse input amount: \"".concat(value, "\""), error);
  }
  return undefined;
}
function tryParseCurrencyAmount(value, currency) {
  if (!value || !currency) {
    return undefined;
  }
  try {
    var typedValueParsed = parseUnits(value, currency.decimals).toString();
    var currecyAmount = CurrencyAmount.fromRawAmount(currency, JSBI.BigInt(typedValueParsed));
    return currecyAmount;
  } catch (error) {
    // fails if the user specifies too many decimal places of precision (or maybe exceed max uint?)
    console.debug("Failed to parse input amount: \"".concat(value, "\""), error);
  }
  return undefined;
}

// Unique ID creation requires a high quality random # generator.  In node.js
// this is pretty straight-forward - we use the crypto API.

var crypto = require$$0;
var rng$2 = function nodeRNG() {
  return crypto.randomBytes(16);
};

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];
for (var i$1 = 0; i$1 < 256; ++i$1) {
  byteToHex[i$1] = (i$1 + 0x100).toString(16).substr(1);
}
function bytesToUuid$2(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return [bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], '-', bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]], bth[buf[i++]]].join('');
}
var bytesToUuid_1 = bytesToUuid$2;

var rng$1 = rng$2;
var bytesToUuid$1 = bytesToUuid_1;

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1$1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng$1();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }
  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }
  return buf ? buf : bytesToUuid$1(b);
}
var v1_1 = v1$1;

var rng = rng$2;
var bytesToUuid = bytesToUuid_1;
function v4$1(options, buf, offset) {
  var i = buf && offset || 0;
  if (typeof options == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};
  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }
  return buf || bytesToUuid(rnds);
}
var v4_1 = v4$1;

var v1 = v1_1;
var v4 = v4_1;
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
var uuid_1 = uuid;

var _excluded$5 = ["key", "fctType", "appType", "value", "ioType"];
function ownKeys$r(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$r(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$r(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$r(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$c(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$c(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$c() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper$8(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$8(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray$8(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$8(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen); }
function _arrayLikeToArray$8(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var maxValue = '115792089237316195423570985008687907853269984665640564039457584007913129639935'; //'BigNumber.from(2).pow(256).sub(1).toString()

var isVariable = function isVariable(value) {
  if (!value) return false;
  if (_typeof(value) !== 'object') return false;
  if ('id' in value) {
    return true;
  }
  return false;
};
var getOutputVariable = function getOutputVariable(_ref) {
  var innerIndex = _ref.innerIndex,
    nodeId = _ref.nodeId,
    pluginType = _ref.pluginType;
  if (typeof innerIndex !== 'number') {
    console.error('wrong output param');
    return undefined;
  }
  if (pluginType === 'COMPUTED_VARIABLE') return {
    id: nodeId,
    type: 'computed'
  };
  var variable = {
    type: 'output',
    id: {
      innerIndex: innerIndex,
      nodeId: nodeId
    }
  };
  return variable;
};
var tokenDestinations = ['erc20', 'curve_pool', 'curve_gauge', 'yearn_vault', 'ctoken', 'curve_voting_escrow', 'aave_pool_v3', 'aave_lending_pool_v2'];
var FctParam = /*#__PURE__*/function () {
  function FctParam(_ref2) {
    var _this = this;
    var fctType = _ref2.fctType,
      appType = _ref2.appType,
      _value = _ref2.value,
      mode = _ref2.mode,
      required = _ref2.required,
      innerIndex = _ref2.innerIndex,
      destination = _ref2.destination,
      description = _ref2.description,
      options = _ref2.options,
      risk = _ref2.risk,
      messageType = _ref2.messageType,
      readonly = _ref2.readonly,
      innerType = _ref2.innerType,
      decimals = _ref2.decimals,
      hidden = _ref2.hidden,
      key = _ref2.key,
      virtual = _ref2.virtual;
    _classCallCheck(this, FctParam);
    _defineProperty(this, "mode", 'ALL');
    _defineProperty(this, "required", true);
    _defineProperty(this, "readonly", false);
    _defineProperty(this, "isMultiParam", false);
    _defineProperty(this, "subscribe", function (_ref3) {
      var callback = _ref3.callback,
        id = _ref3.id;
      _this.observers.set(id, callback);
    });
    _defineProperty(this, "unsubscribe", function (_ref4) {
      var id = _ref4.id;
      _this.observers.delete(id);
    });
    _defineProperty(this, "observers", new Map());
    _defineProperty(this, "_isLoading", false);
    _defineProperty(this, "_virtual", false);
    _defineProperty(this, "_hidden", false);
    _defineProperty(this, "isConnectable", function (param) {
      return isConnectable({
        from: param,
        to: _this
      });
    });
    _defineProperty(this, "getOutputVariable", function (nodeId, pluginType) {
      if (typeof _this.innerIndex !== 'number') return undefined;
      if (pluginType === 'VALIDATION_VARIABLE') return {
        id: nodeId,
        type: 'validation'
      };
      if (pluginType === 'COMPUTED_VARIABLE') return {
        id: nodeId,
        type: 'computed'
      };
      var variable = {
        type: 'output',
        id: {
          innerIndex: _this.innerIndex,
          nodeId: nodeId
        }
      };
      return variable;
    });
    _defineProperty(this, "set", function (_ref5) {
      var value = _ref5.value;
      _this.value = value;
      _this.updateSubsciptions();
    });
    _defineProperty(this, "setString", function (_ref6) {
      var value = _ref6.value;
      return _this._setString({
        value: value
      });
    });
    _defineProperty(this, "getString", function () {
      if (!_this.value) return _this.value;
      if (isVariable(_this.value)) return _this.value;
      if (typeof _this.value === 'string') return _this.value;
      try {
        var stringValue = JSON.stringify(_this.value);
        return stringValue;
      } catch (e) {
        console.error(e);
        return _this.value;
      }
    });
    _defineProperty(this, "setQuiet", function (_ref7) {
      var value = _ref7.value;
      _this.value = value;
    });
    _defineProperty(this, "get", function () {
      return _this.value;
    });
    _defineProperty(this, "setEstimated", function (_ref8) {
      var value = _ref8.value;
      _this.estimatedValue = value;
      _this.updateSubsciptions();
    });
    _defineProperty(this, "setEstimatedString", function (_ref9) {
      var value = _ref9.value;
      if (isVariable(value)) return;
      if (!value) {
        _this.estimatedValue = value;
        _this.updateSubsciptions();
        return;
      }
      if (_this.fctType === 'string[]' || _this.fctType === 'address[]' || _this.fctType === 'bool') {
        try {
          _this.estimatedValue = JSON.parse(value);
        } catch (e) {
          console.error({
            setParamError: e
          });
          _this.estimatedValue = value;
        }
        _this.updateSubsciptions();
        return;
      }
      _this.estimatedValue = value;
      _this.updateSubsciptions();
      return;
    });
    _defineProperty(this, "getEstimated", function () {
      return _this.estimatedValue;
    });
    _defineProperty(this, "isValid", function () {
      return true;
    });
    _defineProperty(this, "reset", function () {
      _this.value = undefined;
    });
    _defineProperty(this, "updateSubsciptions", function () {
      var _iterator = _createForOfIteratorHelper$8(_this.observers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var observer = _step.value;
          observer[1](_this, _this.isLoading, undefined);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    _defineProperty(this, "_setString", function (_ref10) {
      var value = _ref10.value;
      if (!value) {
        _this.value = value;
        _this.updateSubsciptions();
        return;
      }
      if (isVariable(value)) {
        _this.value = value;
        _this.updateSubsciptions();
        return;
      }
      if (_this.appType === 'string[]' || _this.appType === 'integer[]' || _this.appType === 'number[]' || _this.appType === 'address[]' || _this.fctType === 'tuple[]') {
        try {
          _this.value = JSON.parse(value);
        } catch (e) {
          console.error({
            setParamError: e
          });
          _this.value = value;
        }
        _this.updateSubsciptions();
        return;
      }
      _this.value = value;
      _this.updateSubsciptions();
      return;
    });
    this.value = _value;
    this.appType = appType;
    this._fctType = fctType;
    this.innerIndex = innerIndex;
    this.destination = destination;
    this.description = description;
    this.innerType = innerType || fctType;
    this.risk = risk;
    this._messageType = messageType;
    if (key) this.key = key;
    if (mode) this.mode = mode;
    if (virtual) this.virtual = virtual;
    if (typeof required === 'boolean') this.required = required;
    if (typeof readonly === 'boolean') this.readonly = readonly;
    if (typeof hidden === 'boolean') this.hidden = hidden;
    if (decimals) this.decimals = decimals;
    if (Array.isArray(options)) this.options = options;
  }
  _createClass(FctParam, [{
    key: "label",
    get: function get() {
      return this._label;
    },
    set: function set(label) {
      this._label = label;
      this.updateSubsciptions();
    }
  }, {
    key: "isLoading",
    get: function get() {
      return this._isLoading;
    },
    set: function set(isLoading) {
      this._isLoading = isLoading;
      this.updateSubsciptions();
    }
  }, {
    key: "hidden",
    get: function get() {
      return this._hidden;
    },
    set: function set(isHidden) {
      this._hidden = isHidden;
      this.updateSubsciptions();
    }
  }, {
    key: "virtual",
    get: function get() {
      return this._virtual;
    },
    set: function set(isVirtual) {
      this._virtual = isVirtual;
    }
  }, {
    key: "decimals",
    get: function get() {
      return this._decimals;
    },
    set: function set(label) {
      this._decimals = label;
      this.updateSubsciptions();
    }
  }, {
    key: "getJsonParam",
    value: function getJsonParam(_ref11) {
      var key = _ref11.key,
        ioType = _ref11.ioType;
      var fctType = this.fctType,
        appType = this.appType,
        label = this.label,
        hidden = this.hidden,
        required = this.required,
        estimatedValue = this.estimatedValue,
        messageType = this.messageType,
        decimals = this.decimals,
        nodeId = this.nodeId,
        mode = this.mode,
        description = this.description,
        destination = this.destination,
        risk = this.risk,
        readonly = this.readonly,
        innerIndex = this.innerIndex,
        isMultiParam = this.isMultiParam,
        virtual = this.virtual;
      return {
        get key() {
          return key;
        },
        get ioType() {
          return ioType;
        },
        get appType() {
          return appType;
        },
        get fctType() {
          return fctType;
        },
        value: this.getString(),
        label: label,
        hidden: hidden,
        required: required,
        estimatedValue: estimatedValue,
        messageType: messageType,
        decimals: decimals,
        nodeId: nodeId,
        mode: mode,
        description: description,
        destination: destination,
        risk: risk,
        readonly: readonly,
        innerIndex: innerIndex,
        isMultiParam: isMultiParam,
        virtual: virtual
      };
    }
  }, {
    key: "setJsonParam",
    value: function setJsonParam(param) {
      var _this2 = this;
      param.key;
        param.fctType;
        param.appType;
        var value = param.value;
        param.ioType;
        var rest = _objectWithoutProperties(param, _excluded$5);
      this._setString({
        value: value
      });
      Object.keys(rest).forEach(function (key) {
        var paramKey = key;
        if (paramKey in _this2) {
          _this2[paramKey] = param[paramKey];
        }
      });
    }
  }, {
    key: "fctType",
    get: function get() {
      return this._fctType;
    }
  }, {
    key: "isVariable",
    get: function get() {
      var value = this.value;
      if (!value) return false;
      return isVariable(value);
    }
  }, {
    key: "messageType",
    get: function get() {
      return this._messageType;
    }
  }]);
  return FctParam;
}();
var isConnectable = function isConnectable(_ref12) {
  var from = _ref12.from,
    to = _ref12.to;
  if (to.pluginType === 'COMPUTED_VARIABLE' && to.key !== 'value1' && from.decimals !== to.decimals) {
    return false;
  }
  if (from.destination && (to.destination || to.fctType === 'bytes')) {
    if (tokenDestinations.includes(from.destination) && (to.destination === 'erc20' || to.fctType === 'bytes')) return true;
    return from.destination === to.destination;
  }
  if (from.fctType === 'bytes') {
    return true;
  }
  if (to.fctType === 'bytes' && to.hashed) {
    return true;
  }
  if (from.fctType === to.fctType) return true;
  if (from.appType !== to.appType) return false;
  var isFromArray = from.fctType.includes('[]');
  var isToArray = to.fctType.includes('[]');
  if (isFromArray !== isToArray) return false;
  var getNumber = function getNumber(value) {
    var parsedValue = value.match(/\d+/);
    return parsedValue ? parsedValue[0] : undefined;
  };
  var isLessEqual = function isLessEqual(value1, value2) {
    var number1 = getNumber(value1);
    var number2 = getNumber(value2);
    if (!number1 || !number2) return false;
    return Number(number1) <= Number(number2);
  };
  if (from.fctType.includes('uint') && to.fctType.includes('uint')) {
    return isLessEqual(from.fctType, to.fctType);
  }
  if (from.fctType.includes('int') && to.fctType.includes('int')) {
    if (to.fctType.includes('uint')) return from.fctType === to.fctType;
    return isLessEqual(from.fctType, to.fctType);
  }
  if (from.fctType.includes('bytes') && to.fctType.includes('bytes')) {
    if (!getNumber(to.fctType)) return true;
    return isLessEqual(from.fctType, to.fctType);
  }
  return from.fctType === to.fctType;
};
var FctAmount = /*#__PURE__*/function (_ref13) {
  _inherits(FctAmount, _ref13);
  var _super = _createSuper$c(FctAmount);
  function FctAmount() {
    var _this3;
    _classCallCheck(this, FctAmount);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this3 = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this3), "isValid", function () {
      if (!_this3.value) return true;
      var value = _this3.value;
      if (_this3.isVariable) return true;
      try {
        JSBI.BigInt(value).toString();
        return true;
      } catch (e) {
        console.error({
          error: e
        });
        return false;
      }
    });
    return _this3;
  }
  return _createClass(FctAmount);
}(FctParam);
var FctAmount128 = /*#__PURE__*/function (_ref14) {
  _inherits(FctAmount128, _ref14);
  var _super2 = _createSuper$c(FctAmount128);
  function FctAmount128() {
    var _this4;
    _classCallCheck(this, FctAmount128);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this4 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this4), "isValid", function () {
      if (!_this4.value) return true;
      var value = _this4.value;
      if (_this4.isVariable) return true;
      try {
        JSBI.BigInt(value).toString();
        return true;
      } catch (e) {
        console.error({
          error: e
        });
        return false;
      }
    });
    return _this4;
  }
  return _createClass(FctAmount128);
}(FctParam);
var FctInt256 = /*#__PURE__*/function (_FctParam) {
  _inherits(FctInt256, _FctParam);
  var _super3 = _createSuper$c(FctInt256);
  function FctInt256(args) {
    var _this5;
    _classCallCheck(this, FctInt256);
    _this5 = _super3.call(this, _objectSpread$r({
      fctType: 'int256',
      appType: 'integer'
    }, args));
    _defineProperty(_assertThisInitialized(_this5), "isValid", function () {
      if (!_this5.value) return true;
      var value = _this5.value;
      if (_this5.isVariable) return true;
      try {
        JSBI.BigInt(value).toString();
        return true;
      } catch (e) {
        console.error({
          error: e
        });
        return false;
      }
    });
    return _this5;
  }
  return _createClass(FctInt256);
}(FctParam);
var FctValue = /*#__PURE__*/function (_FctAmount) {
  _inherits(FctValue, _FctAmount);
  var _super4 = _createSuper$c(FctValue);
  function FctValue(args) {
    _classCallCheck(this, FctValue);
    return _super4.call(this, _objectSpread$r({
      fctType: 'uint256',
      appType: 'integer'
    }, args));
  }
  return _createClass(FctValue);
}(FctAmount);
var FctTimestamp = /*#__PURE__*/function (_FctAmount2) {
  _inherits(FctTimestamp, _FctAmount2);
  var _super5 = _createSuper$c(FctTimestamp);
  function FctTimestamp(args) {
    _classCallCheck(this, FctTimestamp);
    return _super5.call(this, _objectSpread$r({
      fctType: 'uint256',
      appType: 'timestamp'
    }, args));
  }
  return _createClass(FctTimestamp);
}(FctAmount);
var FctDecimals = /*#__PURE__*/function (_FctAmount3) {
  _inherits(FctDecimals, _FctAmount3);
  var _super6 = _createSuper$c(FctDecimals);
  function FctDecimals(args) {
    _classCallCheck(this, FctDecimals);
    return _super6.call(this, _objectSpread$r({
      fctType: 'uint256',
      appType: 'decimals'
    }, args));
  }
  return _createClass(FctDecimals);
}(FctAmount);
var FctValue18 = /*#__PURE__*/function (_FctAmount4) {
  _inherits(FctValue18, _FctAmount4);
  var _super7 = _createSuper$c(FctValue18);
  function FctValue18(args) {
    var _this6;
    _classCallCheck(this, FctValue18);
    _this6 = _super7.call(this, _objectSpread$r({
      fctType: 'uint256',
      appType: 'integer18'
    }, args));
    _this6.decimals = 18;
    return _this6;
  }
  return _createClass(FctValue18);
}(FctAmount);
var FctValue27 = /*#__PURE__*/function (_FctAmount5) {
  _inherits(FctValue27, _FctAmount5);
  var _super8 = _createSuper$c(FctValue27);
  function FctValue27(args) {
    var _this7;
    _classCallCheck(this, FctValue27);
    _this7 = _super8.call(this, _objectSpread$r({
      fctType: 'uint256',
      appType: 'integer27'
    }, args));
    _this7.decimals = 27;
    return _this7;
  }
  return _createClass(FctValue27);
}(FctAmount);
var FctBps = /*#__PURE__*/function (_FctAmount6) {
  _inherits(FctBps, _FctAmount6);
  var _super9 = _createSuper$c(FctBps);
  function FctBps(args) {
    var _this8;
    _classCallCheck(this, FctBps);
    _this8 = _super9.call(this, _objectSpread$r({
      fctType: 'uint256',
      appType: 'bps'
    }, args));
    _this8.decimals = 4;
    return _this8;
  }
  return _createClass(FctBps);
}(FctAmount);
var FctUinteger32Bps = /*#__PURE__*/function (_FctParam2) {
  _inherits(FctUinteger32Bps, _FctParam2);
  var _super10 = _createSuper$c(FctUinteger32Bps);
  function FctUinteger32Bps(args) {
    var _this9;
    _classCallCheck(this, FctUinteger32Bps);
    _this9 = _super10.call(this, _objectSpread$r({
      fctType: 'uint32',
      appType: 'bps'
    }, args));
    _this9.decimals = 4;
    return _this9;
  }
  return _createClass(FctUinteger32Bps);
}(FctParam);
var FctPercent = /*#__PURE__*/function (_FctParam3) {
  _inherits(FctPercent, _FctParam3);
  var _super11 = _createSuper$c(FctPercent);
  function FctPercent(args) {
    var _this10;
    _classCallCheck(this, FctPercent);
    _this10 = _super11.call(this, _objectSpread$r({
      fctType: 'uint256',
      appType: 'integer'
    }, args));
    _defineProperty(_assertThisInitialized(_this10), "isValid", function () {
      if (!_this10.value) return true;
      if (_this10.isVariable) return true;
      try {
        var amount = parseFloat(_this10.value);
        if (amount >= 0) {
          return true;
        }
        return false;
      } catch (e) {
        console.error({
          error: e
        });
        return false;
      }
    });
    return _this10;
  }
  return _createClass(FctPercent);
}(FctParam);
var FctValue8 = /*#__PURE__*/function (_FctParam4) {
  _inherits(FctValue8, _FctParam4);
  var _super12 = _createSuper$c(FctValue8);
  function FctValue8(args) {
    _classCallCheck(this, FctValue8);
    return _super12.call(this, _objectSpread$r({
      fctType: 'uint8',
      appType: 'integer'
    }, args));
  }
  return _createClass(FctValue8);
}(FctParam);
var FctUInt80 = /*#__PURE__*/function (_FctParam5) {
  _inherits(FctUInt80, _FctParam5);
  var _super13 = _createSuper$c(FctUInt80);
  function FctUInt80(args) {
    _classCallCheck(this, FctUInt80);
    return _super13.call(this, _objectSpread$r({
      fctType: 'uint80',
      appType: 'integer'
    }, args));
  }
  return _createClass(FctUInt80);
}(FctParam);
var FctValue16 = /*#__PURE__*/function (_FctParam6) {
  _inherits(FctValue16, _FctParam6);
  var _super14 = _createSuper$c(FctValue16);
  function FctValue16(args) {
    _classCallCheck(this, FctValue16);
    return _super14.call(this, _objectSpread$r({
      fctType: 'uint16',
      appType: 'integer'
    }, args));
  }
  return _createClass(FctValue16);
}(FctParam);
var FctValue24 = /*#__PURE__*/function (_FctParam7) {
  _inherits(FctValue24, _FctParam7);
  var _super15 = _createSuper$c(FctValue24);
  function FctValue24(args) {
    _classCallCheck(this, FctValue24);
    return _super15.call(this, _objectSpread$r({
      fctType: 'uint24',
      appType: 'integer'
    }, args));
  }
  return _createClass(FctValue24);
}(FctParam);
var FctValue40 = /*#__PURE__*/function (_FctParam8) {
  _inherits(FctValue40, _FctParam8);
  var _super16 = _createSuper$c(FctValue40);
  function FctValue40(args) {
    _classCallCheck(this, FctValue40);
    return _super16.call(this, _objectSpread$r({
      fctType: 'uint40',
      appType: 'integer'
    }, args));
  }
  return _createClass(FctValue40);
}(FctParam);
var FctValue128 = /*#__PURE__*/function (_FctParam9) {
  _inherits(FctValue128, _FctParam9);
  var _super17 = _createSuper$c(FctValue128);
  function FctValue128(args) {
    _classCallCheck(this, FctValue128);
    return _super17.call(this, _objectSpread$r({
      fctType: 'uint128',
      appType: 'integer'
    }, args));
  }
  return _createClass(FctValue128);
}(FctParam);
var FctValue128_27 = /*#__PURE__*/function (_FctAmount7) {
  _inherits(FctValue128_27, _FctAmount7);
  var _super18 = _createSuper$c(FctValue128_27);
  function FctValue128_27(args) {
    var _this11;
    _classCallCheck(this, FctValue128_27);
    _this11 = _super18.call(this, _objectSpread$r({
      fctType: 'uint256',
      appType: 'integer27'
    }, args));
    _this11.decimals = 27;
    return _this11;
  }
  return _createClass(FctValue128_27);
}(FctAmount128);
var FctValue160 = /*#__PURE__*/function (_FctParam10) {
  _inherits(FctValue160, _FctParam10);
  var _super19 = _createSuper$c(FctValue160);
  function FctValue160(args) {
    _classCallCheck(this, FctValue160);
    return _super19.call(this, _objectSpread$r({
      fctType: 'uint160',
      appType: 'integer'
    }, args));
  }
  return _createClass(FctValue160);
}(FctParam);
var FctAddress = /*#__PURE__*/function (_ref15) {
  _inherits(FctAddress, _ref15);
  var _super20 = _createSuper$c(FctAddress);
  function FctAddress(args) {
    var _this12;
    _classCallCheck(this, FctAddress);
    _this12 = _super20.call(this, _objectSpread$r({
      fctType: 'address',
      appType: 'address'
    }, args));
    _defineProperty(_assertThisInitialized(_this12), "isValid", function () {
      if (!_this12.value) return true;
      if (_this12.isVariable) return true;
      var value = _this12.value;
      if (value === 'NATIVE') return true;
      if (!utils.isAddress(value)) {
        return false;
      }
      return true;
    });
    return _this12;
  }
  return _createClass(FctAddress);
}(FctParam);
var FctAddressList = /*#__PURE__*/function (_FctParam11) {
  _inherits(FctAddressList, _FctParam11);
  var _super21 = _createSuper$c(FctAddressList);
  function FctAddressList(args) {
    var _this13;
    _classCallCheck(this, FctAddressList);
    _this13 = _super21.call(this, _objectSpread$r({
      fctType: 'address[]',
      appType: 'address[]'
    }, args));
    _defineProperty(_assertThisInitialized(_this13), "paramFctType", 'address');
    _defineProperty(_assertThisInitialized(_this13), "paramAppType", 'address');
    _defineProperty(_assertThisInitialized(_this13), "setString", function (_ref16) {
      var value = _ref16.value;
      if (!value) {
        _this13.value = value;
        return;
      }
      if (isVariable(value)) {
        return;
      }
      if (typeof value !== 'string') return;
      var params = [];
      try {
        JSON.parse(value);
        console.error("wrong value: ".concat(value, " for ").concat(_this13.key, " param"));
      } catch (error) {
        value.split(',').forEach(function (param) {
          params.push(param);
        });
        _this13.value = params;
      }
    });
    return _this13;
  }
  return _createClass(FctAddressList);
}(FctParam);
var FctValueList = /*#__PURE__*/function (_ref17) {
  _inherits(FctValueList, _ref17);
  var _super22 = _createSuper$c(FctValueList);
  function FctValueList(args) {
    var _this14;
    _classCallCheck(this, FctValueList);
    _this14 = _super22.call(this, _objectSpread$r({
      fctType: 'uint256[]',
      appType: 'integer[]'
    }, args));
    _defineProperty(_assertThisInitialized(_this14), "paramFctType", 'uint256');
    _defineProperty(_assertThisInitialized(_this14), "paramAppType", 'integer');
    _defineProperty(_assertThisInitialized(_this14), "setString", function (_ref18) {
      var value = _ref18.value;
      if (!value) {
        _this14.value = value;
        return;
      }
      if (isVariable(value)) {
        _this14.value = value;
        return;
      }
      if (typeof value !== 'string') return;
      var params = [];
      try {
        JSON.parse(value);
        console.error("wrong value: ".concat(value, " for ").concat(_this14.key, " param"));
      } catch (error) {
        value.split(',').forEach(function (param) {
          params.push(param);
        });
        _this14.value = params;
      }
    });
    return _this14;
  }
  return _createClass(FctValueList);
}(FctParam);
var FDBackBase = '0xFDB0000000000000000000000000000000000000';
var FDBackBaseBytes = '0xFDB0000000000000000000000000000000000000000000000000000000000000';
var FDBase = '0xFD00000000000000000000000000000000000000';
var FDBaseBytes = '0xFD00000000000000000000000000000000000000000000000000000000000000';
var getOutputVariableOnChain = function getOutputVariableOnChain(_ref19) {
  var _innerIndex;
  var index = _ref19.index,
    innerIndex = _ref19.innerIndex,
    _ref19$type = _ref19.type,
    type = _ref19$type === void 0 ? 'uint256' : _ref19$type;
  var outputIndexHex = (index + 1).toString(16).padStart(4, '0');
  var base;
  var innerIndexHex;
  innerIndex = (_innerIndex = innerIndex) !== null && _innerIndex !== void 0 ? _innerIndex : 0;
  if (innerIndex < 0) {
    innerIndexHex = ((innerIndex + 1) * -1).toString(16).padStart(4, '0');
    if (type.includes('bytes')) {
      base = FDBackBaseBytes;
    } else {
      base = FDBackBase;
    }
  } else {
    innerIndexHex = innerIndex.toString(16).padStart(4, '0');
    if (type.includes('bytes')) {
      base = FDBaseBytes;
    } else {
      base = FDBase;
    }
  }
  return (innerIndexHex + outputIndexHex).padStart(base.length, base);
};
var FctValueListN = /*#__PURE__*/function (_ref20) {
  _inherits(FctValueListN, _ref20);
  var _super23 = _createSuper$c(FctValueListN);
  function FctValueListN(args) {
    var _this15;
    _classCallCheck(this, FctValueListN);
    _this15 = _super23.call(this, _objectSpread$r({
      fctType: 'uint256[n]',
      appType: 'integer[]'
    }, args));
    _defineProperty(_assertThisInitialized(_this15), "setString", function (_ref21) {
      var value = _ref21.value;
      if (!value) {
        _this15.value = value;
        return;
      }
      if (isVariable(value)) {
        return;
      }
      if (typeof value !== 'string') return;
      var params = [];
      try {
        JSON.parse(value);
        console.error("wrong value: ".concat(value, " for ").concat(_this15.key, " param"));
      } catch (error) {
        value.split(',').forEach(function (param) {
          params.push(param);
        });
        _this15.value = params;
      }
    });
    return _this15;
  }
  _createClass(FctValueListN, [{
    key: "fctType",
    get: function get() {
      try {
        var _value2 = this.value;
        var parsedValue = typeof _value2 === 'string' ? JSON.parse(_value2) : _value2;
        var length = parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.length;
        if (length) {
          return "uint256[".concat(length, "]");
        }
        return this._fctType;
      } catch (e) {
        return this._fctType;
      }
    }
  }]);
  return FctValueListN;
}(FctParam);
var FctBytes32 = /*#__PURE__*/function (_ref22) {
  _inherits(FctBytes32, _ref22);
  var _super24 = _createSuper$c(FctBytes32);
  function FctBytes32(args) {
    var _this16;
    _classCallCheck(this, FctBytes32);
    _this16 = _super24.call(this, _objectSpread$r({
      fctType: 'bytes32',
      appType: 'bytes32'
    }, args));
    if (args.messageType) {
      _this16.appType = args.messageType;
      return _possibleConstructorReturn(_this16);
    }
    _this16.appType = 'bytes32';
    return _possibleConstructorReturn(_this16);
  }
  _createClass(FctBytes32, [{
    key: "messageType",
    get: function get() {
      if (this._messageType === 'stringOrBytes32' && this.value && typeof this.value === 'string') {
        if (utils.isBytesLike(this.value)) {
          return 'bytes32';
        }
        return 'string';
      }
      return 'bytes32';
    }
  }]);
  return FctBytes32;
}(FctParam);
var FctBytes32List = /*#__PURE__*/function (_FctParam12) {
  _inherits(FctBytes32List, _FctParam12);
  var _super25 = _createSuper$c(FctBytes32List);
  function FctBytes32List(args) {
    _classCallCheck(this, FctBytes32List);
    return _super25.call(this, _objectSpread$r({
      fctType: 'bytes32[]',
      appType: 'string[]'
    }, args));
  }
  return _createClass(FctBytes32List);
}(FctParam);
var FctBytes4 = /*#__PURE__*/function (_FctParam13) {
  _inherits(FctBytes4, _FctParam13);
  var _super26 = _createSuper$c(FctBytes4);
  function FctBytes4(args) {
    _classCallCheck(this, FctBytes4);
    return _super26.call(this, _objectSpread$r({
      fctType: 'bytes4',
      appType: 'string'
    }, args));
  }
  return _createClass(FctBytes4);
}(FctParam);
var FctBytes = /*#__PURE__*/function (_FctParam14) {
  _inherits(FctBytes, _FctParam14);
  var _super27 = _createSuper$c(FctBytes);
  function FctBytes(args) {
    var _this17;
    _classCallCheck(this, FctBytes);
    _this17 = _super27.call(this, _objectSpread$r({
      fctType: 'bytes',
      appType: 'bytes'
    }, args));
    if (args.messageType) {
      _this17.appType = args.messageType;
      return _possibleConstructorReturn(_this17);
    }
    _this17.appType = 'bytes';
    return _possibleConstructorReturn(_this17);
  }
  _createClass(FctBytes, [{
    key: "messageType",
    get: function get() {
      if (this._messageType === 'stringOrBytes' && this.value && typeof this.value === 'string') {
        if (utils.isBytesLike(this.value)) {
          return 'bytes';
        }
        return 'string';
      }
      return 'bytes';
    }
  }]);
  return FctBytes;
}(FctParam);
var FctBytesList = /*#__PURE__*/function (_FctParam15) {
  _inherits(FctBytesList, _FctParam15);
  var _super28 = _createSuper$c(FctBytesList);
  function FctBytesList(args) {
    _classCallCheck(this, FctBytesList);
    return _super28.call(this, _objectSpread$r({
      fctType: 'bytes[]',
      appType: 'string[]'
    }, args));
  }
  return _createClass(FctBytesList);
}(FctParam);
var FctString = /*#__PURE__*/function (_FctParam16) {
  _inherits(FctString, _FctParam16);
  var _super29 = _createSuper$c(FctString);
  function FctString(args) {
    _classCallCheck(this, FctString);
    return _super29.call(this, _objectSpread$r({
      fctType: 'string',
      appType: 'string'
    }, args));
  }
  return _createClass(FctString);
}(FctParam);
var FctTupleArray = /*#__PURE__*/function (_FctParam17) {
  _inherits(FctTupleArray, _FctParam17);
  var _super30 = _createSuper$c(FctTupleArray);
  function FctTupleArray(args) {
    var _this18;
    _classCallCheck(this, FctTupleArray);
    var argParams = args.params;
    if (!argParams) {
      return _possibleConstructorReturn(_this18);
    }
    var appTypes = Object.keys(argParams).map(function (key) {
      var param = argParams[key];
      return "".concat(key, " ").concat(param.paramAppType);
    });
    _this18 = _super30.call(this, _objectSpread$r({
      fctType: 'tuple[]',
      appType: appTypes.join()
    }, args));
    _defineProperty(_assertThisInitialized(_this18), "tupleInterface", '');
    _defineProperty(_assertThisInitialized(_this18), "tupleType", '');
    _defineProperty(_assertThisInitialized(_this18), "params", {});
    _defineProperty(_assertThisInitialized(_this18), "setString", function (_ref23) {
      var value = _ref23.value;
      if (!value) {
        _this18.value = value;
        return;
      }
      if (isVariable(value)) {
        _this18.value = value;
        return;
      }
      if (typeof value !== 'string') return;
      try {
        JSON.parse(value);
        console.error("wrong value: ".concat(value, " for ").concat(_this18.key, " param"));
      } catch (error) {
        var params = [];
        var subParam = [];
        Object.keys(_this18.params).forEach(function (key) {
          _this18.params[key].set({
            value: []
          });
        });
        value.split(',').forEach(function (param, i) {
          var paramIndex = i % Object.keys(_this18.params).length;
          var paramKey = Object.keys(_this18.params)[paramIndex];
          var tupleParam = _this18.params[paramKey];
          switch (tupleParam.paramFctType) {
            case 'address':
              if (!param) break;
              if (!utils.isAddress(param)) {
                console.error("wrong value: ".concat(param, " should be ").concat(tupleParam.paramFctType, " type"));
                return;
              }
              break;
            case 'uint256':
              if (!param) break;
              try {
                JSBI.BigInt(param).toString();
                break;
              } catch (e) {
                console.error("wrong value: ".concat(param, " should be ").concat(tupleParam.paramFctType, " type"));
                return;
              }
          }
          if (paramIndex === 0) {
            if (subParam.length) {
              params.push(subParam);
            }
            subParam = [];
          }
          var prevTupleValue = tupleParam.value || [];
          tupleParam.set({
            value: [].concat(_toConsumableArray(prevTupleValue), [param])
          });
          subParam.push({
            name: paramKey,
            type: tupleParam.paramFctType,
            value: param,
            virtual: tupleParam.virtual
          });
        });
        params.push(subParam);
        _this18.value = params;
      }
    });
    _defineProperty(_assertThisInitialized(_this18), "getFctParams", function () {
      if (!_this18.value) return _this18.value;
      if (isVariable(_this18.value)) return _this18.value;
      var value = _this18.value;
      return value === null || value === void 0 ? void 0 : value.map(function (p) {
        return p.filter(function (p) {
          return !p.virtual;
        });
      });
    });
    _this18.params = argParams;
    _this18.tupleInterface = '(';
    _this18.tupleType = '(';
    Object.keys(argParams).forEach(function (key) {
      var param = argParams[key];
      if (param.virtual) return;
      _this18.tupleInterface += "".concat(param.paramFctType, " ").concat(param.key, ",");
      _this18.tupleType += "".concat(param.paramFctType, ",");
    });
    _this18.tupleInterface = _this18.tupleInterface.slice(0, -1);
    _this18.tupleInterface += ')[]';
    _this18.tupleType = _this18.tupleType.slice(0, -1);
    _this18.tupleType += ')[]';
    return _this18;
  }
  return _createClass(FctTupleArray);
}(FctParam);
var FctBoolean = /*#__PURE__*/function (_FctParam18) {
  _inherits(FctBoolean, _FctParam18);
  var _super31 = _createSuper$c(FctBoolean);
  function FctBoolean(args) {
    _classCallCheck(this, FctBoolean);
    return _super31.call(this, _objectSpread$r({
      fctType: 'bool',
      appType: 'string'
    }, args));
  }
  return _createClass(FctBoolean);
}(FctParam);
var FctInteger24 = /*#__PURE__*/function (_FctParam19) {
  _inherits(FctInteger24, _FctParam19);
  var _super32 = _createSuper$c(FctInteger24);
  function FctInteger24(args) {
    _classCallCheck(this, FctInteger24);
    return _super32.call(this, _objectSpread$r({
      fctType: 'int24',
      appType: 'integer'
    }, args));
  }
  return _createClass(FctInteger24);
}(FctParam);
var FctInteger64 = /*#__PURE__*/function (_FctParam20) {
  _inherits(FctInteger64, _FctParam20);
  var _super33 = _createSuper$c(FctInteger64);
  function FctInteger64(args) {
    _classCallCheck(this, FctInteger64);
    return _super33.call(this, _objectSpread$r({
      fctType: 'int64',
      appType: 'integer'
    }, args));
  }
  return _createClass(FctInteger64);
}(FctParam);
var FctInteger32 = /*#__PURE__*/function (_FctParam21) {
  _inherits(FctInteger32, _FctParam21);
  var _super34 = _createSuper$c(FctInteger32);
  function FctInteger32(args) {
    _classCallCheck(this, FctInteger32);
    return _super34.call(this, _objectSpread$r({
      fctType: 'int32',
      appType: 'integer'
    }, args));
  }
  return _createClass(FctInteger32);
}(FctParam);
var FctUinteger64 = /*#__PURE__*/function (_FctParam22) {
  _inherits(FctUinteger64, _FctParam22);
  var _super35 = _createSuper$c(FctUinteger64);
  function FctUinteger64(args) {
    _classCallCheck(this, FctUinteger64);
    return _super35.call(this, _objectSpread$r({
      fctType: 'uint64',
      appType: 'integer'
    }, args));
  }
  return _createClass(FctUinteger64);
}(FctParam);
var FctUinteger32 = /*#__PURE__*/function (_FctParam23) {
  _inherits(FctUinteger32, _FctParam23);
  var _super36 = _createSuper$c(FctUinteger32);
  function FctUinteger32(args) {
    _classCallCheck(this, FctUinteger32);
    return _super36.call(this, _objectSpread$r({
      fctType: 'uint32',
      appType: 'integer'
    }, args));
  }
  return _createClass(FctUinteger32);
}(FctParam);
var FctInteger128 = /*#__PURE__*/function (_FctParam24) {
  _inherits(FctInteger128, _FctParam24);
  var _super37 = _createSuper$c(FctInteger128);
  function FctInteger128(args) {
    _classCallCheck(this, FctInteger128);
    return _super37.call(this, _objectSpread$r({
      fctType: 'int128',
      appType: 'integer'
    }, args));
  }
  return _createClass(FctInteger128);
}(FctParam);
var FctCustom = /*#__PURE__*/function (_FctParam25) {
  _inherits(FctCustom, _FctParam25);
  var _super38 = _createSuper$c(FctCustom);
  function FctCustom(args) {
    _classCallCheck(this, FctCustom);
    return _super38.call(this, _objectSpread$r({
      fctType: 'unknown',
      appType: 'string'
    }, args));
  }
  return _createClass(FctCustom);
}(FctParam);
var FctCustomArray = /*#__PURE__*/function (_FctParam26) {
  _inherits(FctCustomArray, _FctParam26);
  var _super39 = _createSuper$c(FctCustomArray);
  function FctCustomArray(args) {
    var _this19;
    _classCallCheck(this, FctCustomArray);
    _this19 = _super39.call(this, _objectSpread$r({
      fctType: 'unknown',
      appType: 'string[]'
    }, args));
    _defineProperty(_assertThisInitialized(_this19), "paramAppType", 'string');
    _defineProperty(_assertThisInitialized(_this19), "paramFctType", 'unknown');
    return _this19;
  }
  return _createClass(FctCustomArray);
}(FctParam);
var paramsSchemas = [FctAddress, FctBytes32, FctBoolean, FctAddressList, FctValue, FctBytes, FctValueList, FctValue8, FctValue16, FctValue24, FctValue40, FctValue128, FctValue160, FctString, FctBytes4, FctBytes32List, FctInteger24, FctInteger32, FctInteger64, FctUinteger32, FctUinteger64, FctInteger128, FctValueListN, FctTimestamp, FctDecimals, FctBps, FctValue18, FctValue27, FctInt256, FctCustom, FctBytesList, FctUInt80, FctCustomArray, FctTupleArray, FctUinteger32Bps];

/**
 * Recursion call create perfomance issue here
 */

var ERRORS = /*#__PURE__*/function (ERRORS) {
  ERRORS["PARAM_NOT_DEFINED"] = "PARAM_NOT_DEFINED";
  ERRORS["INVALID_VALUE"] = "INVALID_VALUE";
  ERRORS["RANGE_ERROR"] = "RANGE_ERROR";
  ERRORS["INVALID_TRADE"] = "INVALID_TRADE";
  ERRORS["PATH_NOT_FOUNDED"] = "PATH_NOT_FOUNDED";
  return ERRORS;
}({});

function _createForOfIteratorHelper$7(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$7(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray$7(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$7(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen); }
function _arrayLikeToArray$7(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Input = /*#__PURE__*/function () {
  function Input(_fctParams, chainId) {
    var _this = this;
    _classCallCheck(this, Input);
    _defineProperty(this, "_warnings", new Map());
    _defineProperty(this, "_errors", new Map());
    _defineProperty(this, "subscribe", function (_ref) {
      var callback = _ref.callback,
        id = _ref.id;
      _this.observers.set(id, callback);
    });
    _defineProperty(this, "unsubscribe", function (_ref2) {
      var id = _ref2.id;
      _this.observers.delete(id);
    });
    _defineProperty(this, "updateSubscriptions", function () {
      var _iterator = _createForOfIteratorHelper$7(_this.observers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var observer = _step.value;
          observer[1](_this.params, _this._errors, _this.chainId);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    _defineProperty(this, "observers", new Map());
    _defineProperty(this, "get", function () {
      return _this.params;
    });
    _defineProperty(this, "validate", function (params, errors) {
      return true;
    });
    this._params = _fctParams.input;
    this._methodParams = _fctParams.input.methodParams;
    this.paramsList.forEach(function (element) {
      element.param.subscribe({
        callback: _this.updateSubscriptions,
        id: element.key
      });
    });
    this.chainId = chainId;
  }
  _createClass(Input, [{
    key: "params",
    get: function get() {
      return this._params;
    }
  }, {
    key: "paramsList",
    get: function get() {
      var list = [];
      var setParamsList = function setParamsList(inputParams, prevKey) {
        for (var key in inputParams) {
          var name = key;
          var fctParam = inputParams[key];
          var uniqueKey = prevKey ? "".concat(prevKey, ".").concat(name) : name;
          if (fctParam instanceof FctParam) {
            list.push({
              param: fctParam,
              key: uniqueKey
            });
          } else {
            setParamsList(inputParams[key], uniqueKey ? uniqueKey : undefined);
          }
        }
      };
      setParamsList(this.params);
      return list;
    }
  }, {
    key: "methodParams",
    get: function get() {
      return this._methodParams;
    }
  }, {
    key: "set",
    value: function set(params) {
      var setParams = function setParams(params, inputParams) {
        for (var key in params) {
          var fctParam = inputParams[key];
          if (!fctParam) continue;
          if (fctParam instanceof FctParam) {
            fctParam === null || fctParam === void 0 ? void 0 : fctParam.set({
              value: params[key]
            });
          } else {
            setParams(params[key], inputParams[key]);
          }
        }
      };
      setParams(params, this.params);
      return this.isValid;
    }
  }, {
    key: "setMethodParams",
    value: function setMethodParams(params) {
      var _this2 = this;
      Object.keys(this.params.methodParams).forEach(function (paramKey, i) {
        if (_this2.params.methodParams[paramKey].fctType === 'tuple[]') {
          var paramValue = params[i];
          if (!paramValue) return;
          if (_typeof(paramValue) !== 'object' || !('length' in paramValue)) return;
          var tupleParam = _this2.params.methodParams[paramKey];
          if (tupleParam.setString && typeof tupleParam.setString === 'function') tupleParam.setString({
            value: paramValue.join(',')
          });
          return;
        }
        if (typeof params[i] === 'boolean') {
          _this2.params.methodParams[paramKey].value = String(params[i]);
          return;
        }
        _this2.params.methodParams[paramKey].value = params[i];
      });
    }
  }, {
    key: "warnings",
    get: function get() {
      this._warnings.clear();
      var _iterator2 = _createForOfIteratorHelper$7(this.paramsList),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _step2.value,
            param = _step2$value.param,
            key = _step2$value.key;
          var risk = param.risk;
          var isDanger = risk === null || risk === void 0 ? void 0 : risk.isDanger(param.value);
          if (risk && isDanger) {
            this._warnings.set(key, risk.description);
            continue;
          }
          this._warnings.delete(key);
          continue;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (this._warnings.size > 0) return this._warnings;
      return;
    }
  }, {
    key: "errors",
    get: function get() {
      this._errors.clear();
      var _iterator3 = _createForOfIteratorHelper$7(this.paramsList),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _step3.value,
            param = _step3$value.param,
            key = _step3$value.key;
          var variable = param.value;
          if (param.value === undefined && param.required && !(variable !== null && variable !== void 0 && variable.id) && (key.includes('methodParams') || key === 'to')) {
            this._errors.set(key, ERRORS.PARAM_NOT_DEFINED);
            continue;
          }
          if (param.isValid()) {
            this._errors.delete(key);
            continue;
          }
          this._errors.set(key, ERRORS.INVALID_VALUE);
          continue;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (this._errors.size > 0) return this._errors;
      return;
    }
  }, {
    key: "isValid",
    get: function get() {
      if (!this.errors) return true;
      if (this.errors.size > 0) return false;
      return true;
    }
  }]);
  return Input;
}();

function _createForOfIteratorHelper$6(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray$6(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }
function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Output = /*#__PURE__*/function () {
  function Output(params, chainId) {
    var _this = this;
    _classCallCheck(this, Output);
    _defineProperty(this, "get", function () {
      return _this._params;
    });
    _defineProperty(this, "subscribe", function (_ref) {
      var callback = _ref.callback,
        id = _ref.id;
      _this.observers.set(id, callback);
    });
    _defineProperty(this, "unsubscribe", function (_ref2) {
      var id = _ref2.id;
      _this.observers.delete(id);
    });
    _defineProperty(this, "updateSubscriptions", function () {
      var _iterator = _createForOfIteratorHelper$6(_this.observers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var observer = _step.value;
          observer[1](_this.params, undefined, _this.chainId);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    _defineProperty(this, "observers", new Map());
    this._params = params;
    // this.paramsList.forEach((element) => {
    //   element.param.subscribe({ callback: this.updateSubscriptions, id: element.key })
    // })
    this.chainId = chainId;
  }
  _createClass(Output, [{
    key: "paramsList",
    get: function get() {
      var list = [];
      var setParamsList = function setParamsList(outputParams, prevKey) {
        for (var key in outputParams) {
          var name = key;
          var fctParam = outputParams[key];
          var uniqueKey = prevKey ? "".concat(prevKey, ".").concat(name) : name;
          if (fctParam instanceof FctParam) {
            list.push({
              param: fctParam,
              key: uniqueKey
            });
          } else {
            setParamsList(outputParams[key], uniqueKey ? uniqueKey : undefined);
          }
        }
      };
      setParamsList(this.params);
      return list;
    }
  }, {
    key: "params",
    get: function get() {
      return this._params;
    }
  }, {
    key: "setOutputParams",
    value: function setOutputParams(params) {
      var _this2 = this;
      Object.keys(this.params).forEach(function (paramKey, i) {
        if (typeof params[i] === 'boolean') {
          _this2.params[paramKey].value = String(params[i]);
          return;
        }
        _this2.params[paramKey].value = params[i];
      });
    }
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var setParams;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setParams = function setParams(params, outputParams) {
                for (var key in params) {
                  var fctParam = outputParams[key];
                  if (!fctParam) continue;
                  if (fctParam instanceof FctParam) {
                    fctParam === null || fctParam === void 0 ? void 0 : fctParam.set({
                      value: params[key]
                    });
                  } else {
                    setParams(params[key], outputParams[key]);
                  }
                }
              };
              setParams(params, this.params);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function set(_x) {
        return _set.apply(this, arguments);
      }
      return set;
    }()
  }]);
  return Output;
}();

var GAS_LIMIT_OVERHEAD = '27500';
var MIN_GAS_LIMIT = '21000';
var generateRandomUint64Number = function generateRandomUint64Number() {
  return BigNumber.from(utils.randomBytes(8)).toString();
};
var paramKeyToName = function paramKeyToName(_ref) {
  var key = _ref.key;
  return key.split('.').slice(-1)[0];
};
var getMethodParams = function getMethodParams(_ref2) {
  var params = _ref2.params;
  var methodParams = [];
  for (var _key2 in params) {
    var paramKey = _key2;
    var param = params[paramKey];
    if (param.virtual) continue;
    if (param instanceof FctTupleArray) {
      methodParams.push({
        name: paramKey.replace("_tuple[]", ''),
        type: param.fctType,
        value: param.getFctParams(),
        customType: true,
        messageType: param.messageType,
        innerIndex: param.innerIndex,
        virtual: param.virtual,
        estimatedValue: param.estimatedValue,
        isTupleArray: true,
        tupleType: param.tupleType
      });
      continue;
    }
    if (param instanceof FctParam) {
      var value = param.value;
      // if (param.hashed && param.fctType === 'bytes32' && typeof param.value === 'string' && !ethUtils.isBytesLike(param.value)) {
      //   value = ethUtils.id(param.value)
      // }

      // if (param.hashed && param.fctType === 'bytes' && typeof param.value === 'string' && !ethUtils.isBytesLike(param.value)) {
      //   const coder = ethUtils.defaultAbiCoder
      //   value = coder.encode(['string'], [param.value])
      // }
      methodParams.push({
        name: paramKey,
        type: param.fctType,
        value: value,
        customType: false,
        messageType: param.messageType,
        innerIndex: param.innerIndex,
        virtual: param.virtual,
        estimatedValue: param.estimatedValue
      });
    } else {
      var nestedParams = param;
      //methodParams.push(getMethodParams({ params: nestedParams }))
      var values = getMethodParams({
        params: nestedParams
      });
      var isNotVirtual = values.find(function (value) {
        return !value.virtual;
      });
      if (!isNotVirtual) continue;
      var _paramKey$split = paramKey.split('_'),
        _paramKey$split2 = _slicedToArray(_paramKey$split, 2),
        name = _paramKey$split2[0],
        type = _paramKey$split2[1];
      methodParams.push({
        name: name,
        type: type === 'tuple' ? "tuple" : "tuple[]",
        value: values,
        customType: true,
        innerIndex: 0
      });
    }
  }
  return methodParams;
};
var getContractInterface = function getContractInterface(_ref3) {
  var method = _ref3.method,
    params = _ref3.params;
  if (!method.length && !params.length) return '';
  var args = '';
  var setInterfaceArgs = function setInterfaceArgs(params, args) {
    for (var paramKey in params) {
      if (params[paramKey]) if (params[paramKey].isTupleArray) {
        var type = params[paramKey].tupleType;
        args += "".concat(type, " ").concat(params[paramKey].name, ",");
        continue;
      }
      if (!params[paramKey].customType) {
        var _type = params[paramKey].type;
        args += "".concat(_type, " ").concat(params[paramKey].name, ",");
      } else if (params[paramKey]) {
        var withTuple = setInterfaceArgs(params[paramKey].value, '(');
        var parsed = withTuple.replace(/,\s*$/, '');
        parsed += ") ".concat(params[paramKey].name, ",");
        args += parsed;
      }
    }
    return args;
  };
  var newArgs = setInterfaceArgs(params, args);
  return "".concat(method, "(").concat(newArgs.replace(/,$/, ''), ")");
};
var getContractInterfaceReturns = function getContractInterfaceReturns(_ref4) {
  var params = _ref4.params;
  if (!params || !Object.keys(params).length) return "";
  var returns = "(";
  for (var _i = 0, _Object$keys = Object.keys(params); _i < _Object$keys.length; _i++) {
    var paramKey = _Object$keys[_i];
    var param = params[paramKey];
    if (param && param instanceof FctTupleArray) {
      returns += param.tupleInterface;
      continue;
    }
    if (paramKey.includes("tuple")) {
      var tuple = "(";
      for (var _i2 = 0, _Object$keys2 = Object.keys(params[paramKey]); _i2 < _Object$keys2.length; _i2++) {
        var tupleParamKey = _Object$keys2[_i2];
        var tupleParam = params[paramKey];
        tuple += "".concat(tupleParam[tupleParamKey].innerType, " ").concat(tupleParamKey, ",");
      }
      if (paramKey.includes("tuple[]")) {
        tuple += ")[]";
      } else {
        tuple += ")";
      }
      returns += tuple;
      continue;
    }
    if (!(params[paramKey] instanceof FctParam)) return "";
    var paramType = params[paramKey].innerType;
    if (paramType.includes("[]")) {
      return "returns (".concat(paramType, " ").concat(paramKey, ")");
    }
    returns += "".concat(paramType, " ").concat(paramKey, ",");
  }
  return "returns ".concat(returns.replace(/,$/, ''), ")");
};
var getMethodInterface = function getMethodInterface(_ref5) {
  var method = _ref5.method,
    params = _ref5.params;
  if (method === 'magic') return 'magic';
  if (!method.length && !params.length) return '';
  var args = '';
  var setInterfaceArgs = function setInterfaceArgs(params, args) {
    for (var paramKey in params) {
      if (params[paramKey].isTupleArray) {
        var type = params[paramKey].tupleType;
        args += "".concat(type, " ").concat(params[paramKey].name, ",");
        continue;
      }
      if (!params[paramKey].customType) {
        var _type2 = params[paramKey].hashed && params[paramKey].type === 'string' ? 'bytes32' : params[paramKey].type;
        args += "".concat(_type2, ",");
      } else if (params[paramKey]) {
        var _type3 = params[paramKey].type;
        var withTuple = setInterfaceArgs(params[paramKey].value, '(');
        var parsed = withTuple.replace(/,\s*$/, '');
        parsed += _type3.includes('{}') ? ")[]," : "),";
        args += parsed;
      }
    }
    return args;
  };
  var newArgs = setInterfaceArgs(params, args);
  return "".concat(method, "(").concat(newArgs.replace(/,$/, ''), ")");
};
var getMethodDescription = function getMethodDescription(_ref6) {
  var methodInterface = _ref6.methodInterface,
    type = _ref6.type,
    protocol = _ref6.protocol;
  return "".concat(protocol, " ").concat(type, ": ").concat(methodInterface).trim();
};
var FctParamsFactory = /*#__PURE__*/function () {
  function FctParamsFactory() {
    _classCallCheck(this, FctParamsFactory);
  }
  _createClass(FctParamsFactory, [{
    key: "create",
    value: function create(schema) {
      return schema;
    }
  }]);
  return FctParamsFactory;
}();
var fctParamsFactory = new FctParamsFactory();
var currencyToWei = function currencyToWei(value, decimals) {
  try {
    if (value !== null && value !== void 0 && value.toString() && decimals) {
      var _toBN;
      var val = value.toString();
      var _val$split = val.split('.'),
        _val$split2 = _slicedToArray(_val$split, 2),
        whole = _val$split2[0],
        fraction = _val$split2[1];
      if (!whole) whole = '0';
      if (!fraction) fraction = '0';
      while (fraction.length < decimals) fraction += '0';
      var toBN = utils$1.toBN;
      var wei = toBN(whole).mul(toBN(+"1e".concat(decimals))).add(toBN(fraction));
      return (_toBN = toBN(wei === null || wei === void 0 ? void 0 : wei.toString())) === null || _toBN === void 0 ? void 0 : _toBN.toString();
    }
    return utils$1.toWei((value === null || value === void 0 ? void 0 : value.toString()) || '0', 'ether');
  } catch (e) {
    console.error(e);
    return '0';
  }
};

var kiroboMulticallContracts = [{
  chainId: 1,
  address: '0x50Bb8165Dd11d41ef2fE90f96b5041F90966E8A7'
}, {
  chainId: 5,
  address: '0x23D560eF20B57A87489D3Ec72D3789E73DF90424'
}, {
  chainId: 11155111,
  address: '0xc074EEC205576C657a8EBDFeA8FCCd1a2924f193'
}];
var kiroboMulticallSimulateContracts = {
  '1': '0x6dCF1c82be9dBe11850377e41f3c0f5c84Bd4020',
  '5': '0x3D577F4B778189B2e53e6F26e49b6bEb16030851',
  '42161': '',
  '421613': '',
  '11155111': '0xc074EEC205576C657a8EBDFeA8FCCd1a2924f193'
};
var kiroboMulticallContractsMap = {
  '1': '0x50Bb8165Dd11d41ef2fE90f96b5041F90966E8A7',
  '5': '0x23D560eF20B57A87489D3Ec72D3789E73DF90424',
  '42161': '',
  '421613': '',
  '11155111': '0xc074EEC205576C657a8EBDFeA8FCCd1a2924f193'
};

var gasLimit = {
	"1": {
	MAGIC: {
		magic: "0"
	},
	UTILITY: {
		deposit: "44000",
		withdraw: "40000",
		"": "15000",
		getEthBalance: "20000"
	},
	SUSHISWAP: {
		swapExactETHForTokens: "150000",
		swapExactTokensForTokens: "150000",
		swapExactTokensForETH: "150000",
		swap: "150000",
		getAmountsIn: "50000",
		getAmountsOut: "50000",
		addLiquidity: "150000",
		addLiquidityETH: "150000",
		removeLiquidity: "150000",
		removeLiquidityETH: "150000"
	},
	UNISWAP: {
		swapExactETHForTokens: "150000",
		swapExactTokensForTokens: "150000",
		swapExactTokensForETH: "150000",
		getAmountsIn: "50000",
		getAmountsOut: "50000",
		addLiquidity: "150000",
		addLiquidityETH: "150000",
		removeLiquidity: "150000",
		removeLiquidityETH: "150000",
		swap: "150000",
		swapTokensForExactTokens: "150000",
		swapTokensForExactETH: "150000",
		swapETHForExactTokens: "150000",
		getReserves: "FAILED",
		swapTo_noSlippageProtection: "FAILED",
		swap_noSlippageProtection: "FAILED",
		addLiquidity_noMinProtection: "300000",
		addLiquidityTo_noMinProtection: "3000000",
		simpleRemoveLiquidity: "300000",
		simulateSwap: "90000"
	},
	"1INCH": {
		unoswap: "165280"
	},
	ERC20: {
		transfer: "150000",
		approve: "40000",
		transferFrom: "150000",
		allowance: "30000",
		balanceOf: "30000",
		decimals: "30000",
		name: "30000",
		symbol: "30000",
		totalSupply: "30000"
	},
	ERC721: {
		approve: "50000",
		safeTransferFrom: "50000",
		setApprovalForAll: "50000",
		transferFrom: "50000",
		balanceOf: "40000",
		getApproved: "30000",
		isApprovedForAll: "30000",
		name: "30000",
		ownerOf: "30000",
		symbol: "30000",
		totalSupply: "30000",
		supportsInterface: "30000",
		tokenURI: "30000"
	},
	ERC1155: {
		safeBatchTransferFrom: "70000",
		safeTransferFrom: "70000",
		setApprovalForAll: "50000",
		balanceOf: "30000",
		balanceOfBatch: "30000",
		isApprovedForAll: "30000",
		supportsInterface: "30000",
		uri: "30000"
	},
	COMPOUND_V2: {
		borrow: "150000",
		mint: "100000",
		redeem: "100000",
		enterMarkets: "90000",
		claimComp: "150000",
		getAccountLiquidity: "100000",
		markets: "60000",
		borrowBalanceCurrent: "100000",
		repayBorrow: "130000",
		exitMarket: "150000",
		repayBorrowETH: "130000",
		mintERC20: "130000",
		mintETH: "130000",
		repayBorrowERC20: "130000"
	},
	COMPOUND_V3: {
		collateralBalanceOf: "40000",
		isBorrowCollateralized: "40000",
		userBasic: "40000",
		borrowBalanceOf: "40000",
		supply: "130000",
		supplyFrom: "130000",
		supplyTo: "130000",
		withdraw: "100000",
		withdrawFrom: "100000",
		withdrawTo: "100000",
		getAssetInfoByAddress: "30000",
		getPrice: "60000"
	},
	AAVE: {
		borrow: "430000",
		deposit: "390000",
		repay: "310000",
		withdraw: "350000",
		swapBorrowRateMode: "200000",
		flashLoan: "FAILED",
		getUserAccountData: "60000",
		getReserveData: "60000",
		getUserReserveData: "120000",
		getReserveConfigurationData: "50000",
		getAssetReserveData: "55000",
		getReserveTokensAddresses: "57000",
		getAssetPrice: "57000",
		apyLessThan: "57000",
		apyBetween: "57000",
		apyGreaterThan: "57000"
	},
	CURVE: {
		exchange: "330000",
		exchange_with_best_rate: "2000000",
		add_liquidity: "280000",
		remove_liquidity: "210000",
		remove_liquidity_one_coin: "140000",
		deposit: "550000",
		withdraw: "390000",
		get_best_rate: "1800000",
		get_exchange_amount: "110000",
		calc_token_amount: "90000",
		get_dy: "70000",
		exchangeOnPool: "210000",
		votingEscrowCreateLock: "FAILED",
		increaseAmountVotingEscrow: "FAILED",
		increaseUnlockTimeVotingEscrow: "FAILED",
		withdrawVotingEscrow: "270000",
		lockedVotingEscrow: "40000"
	},
	YEARN: {
		deposit: "80616",
		withdraw: "80542"
	},
	TOKEN_VALIDATOR: {
		between: "40000",
		betweenEqual: "40000",
		equal: "40000",
		equalAddress: "40000",
		equalBytes32: "40000",
		greaterEqual: "40000",
		greaterThan: "40000",
		lessEqual: "40000",
		lessThan: "40000"
	},
	TOKEN_MATH: {
		add: "40000",
		sub: "40000",
		mul: "40000",
		div: "40000",
		mulAndDiv: "40000",
		mod: "40000"
	},
	UNISWAP_V3: {
		exactInput: "140000",
		exactInputSingle: "140000",
		exactOutput: "140000",
		exactOutputSingle: "140000",
		mint: "480000",
		burn: "110000",
		increaseLiquidity: "210000",
		decreaseLiquidity: "170000",
		collect: "130000",
		positions: "60000",
		slot0: "35000",
		ticks: "40000",
		protocolFees: "40000",
		simpleSwapExactInput: "140000",
		simpleSwapExactOutput: "140000"
	},
	FCT_UNISWAP: {
		swap_noSlippageProtection: "180000",
		swapTo_noSlippageProtection: "180000",
		simulateSwap: "90000",
		addLiquidity_noMinProtection: "300000",
		addLiquidityTo_noMinProtection: "3000000",
		simpleRemoveLiquidity: "300000"
	}
},
	"5": {
	MAGIC: {
		magic: "0"
	},
	UNISWAP: {
		swapExactETHForTokens: "150000",
		swapExactTokensForTokens: "150000",
		swapExactTokensForETH: "150000",
		getAmountsIn: "50000",
		getAmountsOut: "50000",
		addLiquidity: "150000",
		addLiquidityETH: "150000",
		removeLiquidity: "150000",
		removeLiquidityETH: "150000",
		swap: "150000",
		swapTokensForExactTokens: "150000",
		swapTokensForExactETH: "150000",
		swapETHForExactTokens: "150000",
		getReserves: "FAILED",
		swapTo_noSlippageProtection: "FAILED",
		swap_noSlippageProtection: "FAILED",
		addLiquidity_noMinProtection: "300000",
		addLiquidityTo_noMinProtection: "3000000",
		simpleRemoveLiquidity: "300000",
		simulateSwap: "50000"
	},
	UTILITY: {
		deposit: "44000",
		withdraw: "40000",
		"": "15000",
		getEthBalance: "20000"
	},
	SUSHISWAP: {
		swapExactETHForTokens: "150000",
		swapExactTokensForTokens: "150000",
		swapExactTokensForETH: "150000",
		swap: "150000",
		getAmountsIn: "50000",
		getAmountsOut: "50000",
		addLiquidity: "150000",
		addLiquidityETH: "150000",
		removeLiquidity: "150000",
		removeLiquidityETH: "150000"
	},
	"1INCH": {
		unoswap: "2866"
	},
	ERC20: {
		transfer: "150000",
		approve: "40000",
		transferFrom: "150000",
		allowance: "30000",
		balanceOf: "30000",
		decimals: "30000",
		name: "30000",
		symbol: "30000",
		totalSupply: "30000"
	},
	MATH: {
		add: "93534",
		div: "93558",
		mod: "93600",
		mul: "93576",
		mulAndDiv: "94124",
		sub: "93616"
	},
	VALIDATOR: {
		between: "94058",
		betweenEqual: "94154",
		equal: "2684",
		greaterEqual: "93622",
		greaterThan: "93660",
		lessEqual: "93620",
		lessThan: "93528",
		equalAddress: "94684",
		equalBytes: "93534",
		equalValue: "93488"
	},
	ERC721: {
		approve: "50000",
		safeTransferFrom: "50000",
		setApprovalForAll: "50000",
		transferFrom: "50000",
		balanceOf: "40000",
		getApproved: "30000",
		isApprovedForAll: "30000",
		name: "30000",
		ownerOf: "30000",
		symbol: "30000",
		totalSupply: "30000",
		supportsInterface: "30000",
		tokenURI: "30000"
	},
	ERC1155: {
		safeBatchTransferFrom: "70000",
		safeTransferFrom: "70000",
		setApprovalForAll: "50000",
		balanceOf: "30000",
		balanceOfBatch: "30000",
		isApprovedForAll: "30000",
		supportsInterface: "30000",
		uri: "30000"
	},
	COMPOUND_V2: {
		borrow: "150000",
		mint: "100000",
		redeem: "100000",
		enterMarkets: "90000",
		claimComp: "150000",
		getAccountLiquidity: "100000",
		markets: "60000",
		borrowBalanceCurrent: "100000",
		repayBorrow: "130000",
		exitMarket: "150000",
		repayBorrowETH: "130000",
		mintERC20: "130000",
		mintETH: "130000",
		repayBorrowERC20: "130000"
	},
	COMPOUND_V3: {
		collateralBalanceOf: "40000",
		isBorrowCollateralized: "40000",
		userBasic: "40000",
		borrowBalanceOf: "40000",
		supply: "130000",
		supplyFrom: "130000",
		supplyTo: "130000",
		withdraw: "100000",
		withdrawFrom: "100000",
		withdrawTo: "100000",
		getAssetInfoByAddress: "30000",
		getPrice: "60000"
	},
	AAVE: {
		borrow: "430000",
		deposit: "390000",
		repay: "310000",
		withdraw: "350000",
		swapBorrowRateMode: "200000",
		flashLoan: "FAILED",
		getUserAccountData: "60000",
		getReserveData: "60000",
		getUserReserveData: "120000",
		getReserveConfigurationData: "50000",
		getAssetReserveData: "55000",
		getReserveTokensAddresses: "57000",
		getAssetPrice: "57000",
		apyLessThan: "57000",
		apyBetween: "57000",
		apyGreaterThan: "57000"
	},
	YEARN: {
		deposit: "80616",
		withdraw: "80542"
	},
	TOKEN_VALIDATOR: {
		between: "40000",
		betweenEqual: "40000",
		equal: "40000",
		equalAddress: "40000",
		equalBytes32: "40000",
		greaterEqual: "40000",
		greaterThan: "40000",
		lessEqual: "40000",
		lessThan: "40000"
	},
	TOKEN_MATH: {
		add: "40000",
		sub: "40000",
		mul: "40000",
		div: "40000",
		mulAndDiv: "40000",
		mod: "40000"
	},
	FCT_UNISWAP: {
		swap_noSlippageProtection: "180000",
		swapTo_noSlippageProtection: "180000",
		simulateSwap: "90000",
		addLiquidity_noMinProtection: "300000",
		addLiquidityTo_noMinProtection: "3000000",
		simpleRemoveLiquidity: "300000"
	},
	UNISWAP_V3: {
		exactInput: "140000",
		exactInputSingle: "140000",
		exactOutput: "140000",
		exactOutputSingle: "140000",
		mint: "480000",
		burn: "110000",
		increaseLiquidity: "210000",
		decreaseLiquidity: "170000",
		collect: "130000",
		positions: "60000",
		slot0: "35000",
		ticks: "40000",
		protocolFees: "40000",
		simpleSwapExactInput: "140000",
		simpleSwapExactOutput: "140000"
	}
},
	"42161": {
	UNISWAP: {
		addLiquidity: "337258"
	},
	UTILITY: {
		deposit: "690000",
		withdraw: "780000",
		"": "580000",
		getEthBalance: "850873"
	},
	ERC20: {
		transfer: "1150000",
		approve: "1010000",
		transferFrom: "1450000",
		allowance: "990000",
		balanceOf: "850000"
	},
	ERC721: {
		approve: "950000",
		transferFrom: "1750000",
		safeTransferFrom: "1950000"
	},
	UNISWAP_V3: {
		exactInput: "2300000",
		exactInputSingle: "2300000",
		exactOutput: "2300000",
		exactOutputSingle: "2300000",
		mint: "2700000",
		burn: "2500000",
		increaseLiquidity: "1900000",
		decreaseLiquidity: "1900000",
		collect: "1500000",
		positions: "1100000",
		slot0: "1100000",
		protocolFees: "1100000"
	},
	COMPOUND_V3: {
		supply: "1200000",
		supplyFrom: "1200000",
		supplyTo: "1200000",
		withdraw: "1190000",
		withdrawFrom: "1190000",
		withdrawTo: "1190000",
		collateralBalanceOf: "1450000",
		isBorrowCollateralized: "1300000",
		userBasic: "1300000",
		borrowBalanceOf: "1300000",
		getAssetInfoByAddress: "1200000"
	},
	AaveV3: {
		supply: "2500000",
		borrow: "2500000",
		repay: "1200000",
		repayWithATokens: "1200000",
		setUserEMode: "700000",
		setUserUseReserveAsCollateral: "900000",
		swapBorrowRateMode: "1300000",
		withdraw: "2300000",
		getReserveData: "1400000",
		getReserveNormalizedIncome: "1400000",
		getReserveNormalizedVariableDebt: "1400000",
		getUserAccountData: "1400000",
		getUserEMode: "1400000"
	},
	GMX: {
		multicall: "1400000"
	}
},
	"421613": {
	UNISWAP: {
		addLiquidity: "337258"
	},
	UTILITY: {
		deposit: "690000",
		withdraw: "780000",
		"": "580000",
		getEthBalance: "850873"
	},
	ERC20: {
		transfer: "1150000",
		approve: "1010000",
		transferFrom: "1450000",
		allowance: "990000",
		balanceOf: "850000"
	},
	ERC721: {
		approve: "950000",
		transferFrom: "1750000",
		safeTransferFrom: "1950000"
	},
	UNISWAP_V3: {
		exactInput: "2300000",
		exactInputSingle: "2300000",
		exactOutput: "2300000",
		exactOutputSingle: "2300000",
		mint: "2700000",
		burn: "2500000",
		increaseLiquidity: "1900000",
		decreaseLiquidity: "1900000",
		collect: "1500000",
		positions: "1100000",
		slot0: "1100000",
		protocolFees: "1100000"
	},
	COMPOUND_V3: {
		supply: "1200000",
		supplyFrom: "1200000",
		supplyTo: "1200000",
		withdraw: "1190000",
		withdrawFrom: "1190000",
		withdrawTo: "1190000",
		collateralBalanceOf: "1450000",
		isBorrowCollateralized: "1300000",
		userBasic: "1300000",
		borrowBalanceOf: "1300000",
		getAssetInfoByAddress: "1200000"
	},
	AaveV3: {
		supply: "2500000",
		borrow: "2500000",
		repay: "1200000",
		repayWithATokens: "1200000",
		setUserEMode: "700000",
		setUserUseReserveAsCollateral: "900000",
		swapBorrowRateMode: "1300000",
		withdraw: "2300000",
		getReserveData: "1400000",
		getReserveNormalizedIncome: "1400000",
		getReserveNormalizedVariableDebt: "1400000",
		getUserAccountData: "1400000",
		getUserEMode: "1400000"
	}
},
	"11155111": {
	MAGIC: {
		magic: "0"
	},
	UTILITY: {
		deposit: "44000",
		withdraw: "40000",
		"": "15000",
		getEthBalance: "20000"
	},
	SUSHISWAP: {
		swapExactETHForTokens: "150000",
		swapExactTokensForTokens: "150000",
		swapExactTokensForETH: "150000",
		swap: "150000",
		getAmountsIn: "50000",
		getAmountsOut: "50000",
		addLiquidity: "150000",
		addLiquidityETH: "150000",
		removeLiquidity: "150000",
		removeLiquidityETH: "150000"
	},
	UNISWAP: {
		swapExactETHForTokens: "150000",
		swapExactTokensForTokens: "150000",
		swapExactTokensForETH: "150000",
		getAmountsIn: "50000",
		getAmountsOut: "50000",
		addLiquidity: "150000",
		addLiquidityETH: "150000",
		removeLiquidity: "150000",
		removeLiquidityETH: "150000",
		swap: "150000",
		swapTokensForExactTokens: "150000",
		swapTokensForExactETH: "150000",
		swapETHForExactTokens: "150000",
		getReserves: "FAILED",
		swapTo_noSlippageProtection: "FAILED",
		swap_noSlippageProtection: "FAILED",
		addLiquidity_noMinProtection: "300000",
		addLiquidityTo_noMinProtection: "3000000",
		simpleRemoveLiquidity: "300000",
		simulateSwap: "90000"
	},
	"1INCH": {
		unoswap: "165280"
	},
	ERC20: {
		transfer: "150000",
		approve: "40000",
		transferFrom: "150000",
		allowance: "30000",
		balanceOf: "30000",
		decimals: "30000",
		name: "30000",
		symbol: "30000",
		totalSupply: "30000"
	},
	ERC721: {
		approve: "50000",
		safeTransferFrom: "50000",
		setApprovalForAll: "50000",
		transferFrom: "50000",
		balanceOf: "40000",
		getApproved: "30000",
		isApprovedForAll: "30000",
		name: "30000",
		ownerOf: "30000",
		symbol: "30000",
		totalSupply: "30000",
		supportsInterface: "30000",
		tokenURI: "30000"
	},
	ERC1155: {
		safeBatchTransferFrom: "70000",
		safeTransferFrom: "70000",
		setApprovalForAll: "50000",
		balanceOf: "30000",
		balanceOfBatch: "30000",
		isApprovedForAll: "30000",
		supportsInterface: "30000",
		uri: "30000"
	},
	COMPOUND_V2: {
		borrow: "150000",
		mint: "100000",
		redeem: "100000",
		enterMarkets: "90000",
		claimComp: "150000",
		getAccountLiquidity: "100000",
		markets: "60000",
		borrowBalanceCurrent: "100000",
		repayBorrow: "130000",
		exitMarket: "150000",
		repayBorrowETH: "130000",
		mintERC20: "130000",
		mintETH: "130000",
		repayBorrowERC20: "130000"
	},
	COMPOUND_V3: {
		collateralBalanceOf: "40000",
		isBorrowCollateralized: "40000",
		userBasic: "40000",
		borrowBalanceOf: "40000",
		supply: "130000",
		supplyFrom: "130000",
		supplyTo: "130000",
		withdraw: "100000",
		withdrawFrom: "100000",
		withdrawTo: "100000",
		getAssetInfoByAddress: "30000",
		getPrice: "60000"
	},
	AAVE: {
		borrow: "430000",
		deposit: "390000",
		repay: "310000",
		withdraw: "350000",
		swapBorrowRateMode: "200000",
		flashLoan: "FAILED",
		getUserAccountData: "60000",
		getReserveData: "60000",
		getUserReserveData: "120000",
		getReserveConfigurationData: "50000",
		getAssetReserveData: "55000",
		getReserveTokensAddresses: "57000",
		getAssetPrice: "57000",
		apyLessThan: "57000",
		apyBetween: "57000",
		apyGreaterThan: "57000"
	},
	CURVE: {
		exchange: "330000",
		exchange_with_best_rate: "2000000",
		add_liquidity: "280000",
		remove_liquidity: "210000",
		remove_liquidity_one_coin: "140000",
		deposit: "550000",
		withdraw: "390000",
		get_best_rate: "1800000",
		get_exchange_amount: "110000",
		calc_token_amount: "90000",
		get_dy: "70000",
		exchangeOnPool: "210000",
		votingEscrowCreateLock: "FAILED",
		increaseAmountVotingEscrow: "FAILED",
		increaseUnlockTimeVotingEscrow: "FAILED",
		withdrawVotingEscrow: "270000",
		lockedVotingEscrow: "40000"
	},
	YEARN: {
		deposit: "80616",
		withdraw: "80542"
	},
	TOKEN_VALIDATOR: {
		between: "40000",
		betweenEqual: "40000",
		equal: "40000",
		equalAddress: "40000",
		equalBytes32: "40000",
		greaterEqual: "40000",
		greaterThan: "40000",
		lessEqual: "40000",
		lessThan: "40000"
	},
	TOKEN_MATH: {
		add: "40000",
		sub: "40000",
		mul: "40000",
		div: "40000",
		mulAndDiv: "40000",
		mod: "40000"
	},
	UNISWAP_V3: {
		exactInput: "140000",
		exactInputSingle: "140000",
		exactOutput: "140000",
		exactOutputSingle: "140000",
		mint: "480000",
		burn: "110000",
		increaseLiquidity: "210000",
		decreaseLiquidity: "170000",
		collect: "130000",
		positions: "60000",
		slot0: "35000",
		ticks: "40000",
		protocolFees: "40000",
		simpleSwapExactInput: "140000",
		simpleSwapExactOutput: "140000"
	},
	FCT_UNISWAP: {
		swap_noSlippageProtection: "180000",
		swapTo_noSlippageProtection: "180000",
		simulateSwap: "90000",
		addLiquidity_noMinProtection: "300000",
		addLiquidityTo_noMinProtection: "3000000",
		simpleRemoveLiquidity: "300000"
	}
}
};

function _createForOfIteratorHelper$5(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray$5(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }
function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var uid = uuid_1.v4();
var Plugin = /*#__PURE__*/function () {
  function Plugin(_protocol, _type, _method, _name, chainId, _params, requiredApprovals, assetFlow, initParams, _walletAddress, _vaultAddress, _provider) {
    var _this = this;
    _classCallCheck(this, Plugin);
    _defineProperty(this, "setMethod", function (method) {
      _this._method = method;
    });
    _defineProperty(this, "_supportedContracts", []);
    _defineProperty(this, "calculateValuesOnUserInput", undefined);
    _defineProperty(this, "setMethodParams", function (params) {
      _this.input.setMethodParams(params);
    });
    _defineProperty(this, "setOutputParams", function (params) {
      _this.output.setOutputParams(params);
    });
    _defineProperty(this, "estimateGasOnParams", undefined);
    _defineProperty(this, "getOutputValues", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
        var _yield$_this$getParam, _inputParams$to;
        var provider, execute, abi, walletSigner, withAutoApprovals, plugin, inputParams, setOutputIsLoading, _plugin$input$methodP, value1, value2, operator, computeOperation, validateValueOperation1, _error, _plugin$input$methodP2, _value, _value2, value3, value4, operator1, operator2, operator3, _computeOperation, computedValueOperation1, computedValueOperation2, computedValueOperation3, _plugin$input$params, _to, _value3, parsedValue, sendEthRes, trxEthData, _error2, to, pluginMethodInterface, contract, methodParamsToValues, methodParamsList, value, singerAddress, trx, _contract$callStatic, res, encodedData, trxData, _error3, outputParams, params;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              provider = _ref.provider, execute = _ref.execute, _ref.setEstimated, abi = _ref.abi, walletSigner = _ref.walletSigner, withAutoApprovals = _ref.withAutoApprovals;
              if (!(_this.method === 'magic')) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return", {});
            case 3:
              if (!_this.getParamsOnCreate) {
                _context2.next = 21;
                break;
              }
              _context2.next = 6;
              return _this.getParamsOnCreate({
                chainId: _this.chainId,
                params: _this.input.params
              });
            case 6:
              _context2.t3 = _yield$_this$getParam = _context2.sent;
              _context2.t2 = _context2.t3 === null;
              if (_context2.t2) {
                _context2.next = 10;
                break;
              }
              _context2.t2 = _yield$_this$getParam === void 0;
            case 10:
              if (!_context2.t2) {
                _context2.next = 14;
                break;
              }
              _context2.t4 = void 0;
              _context2.next = 15;
              break;
            case 14:
              _context2.t4 = _yield$_this$getParam.plugin;
            case 15:
              _context2.t1 = _context2.t4;
              if (_context2.t1) {
                _context2.next = 18;
                break;
              }
              _context2.t1 = _this;
            case 18:
              _context2.t0 = _context2.t1;
              _context2.next = 22;
              break;
            case 21:
              _context2.t0 = _this;
            case 22:
              plugin = _context2.t0;
              inputParams = plugin.input.params;
              setOutputIsLoading = function setOutputIsLoading(isLoadIng) {
                _this.output.paramsList.forEach(function (_ref3) {
                  var param = _ref3.param;
                  param.isLoading = isLoadIng;
                });
              };
              if (!plugin.beforeSimulate) {
                _context2.next = 29;
                break;
              }
              if (walletSigner && withAutoApprovals && plugin.getRequiredApprovals().length) {
                provider.signer = walletSigner;
              }
              _context2.next = 29;
              return plugin.beforeSimulate({
                provider: provider,
                chainId: plugin.chainId,
                input: plugin.input.params,
                output: plugin.output.params
              });
            case 29:
              _this.currentGasLimit = undefined;
              if (!(plugin.name === 'validate' && plugin.protocol === 'VALIDATION_VARIABLE')) {
                _context2.next = 40;
                break;
              }
              _plugin$input$methodP = plugin.input.methodParams, value1 = _plugin$input$methodP.value1, value2 = _plugin$input$methodP.value2, operator = _plugin$input$methodP.operator;
              computeOperation = function computeOperation(value1, operator, value2) {
                switch (operator) {
                  case 'equal':
                    return value1 === value2 ? '1' : '0';
                  case 'greater than':
                    return BigNumber.from(value1 || '0').gt(value2 || '0') ? '1' : '0';
                  case 'greater equal than':
                    return BigNumber.from(value1 || '0').gte(value2 || '0') ? '1' : '0';
                  case 'or':
                    return Boolean(value1) || Boolean(value2) ? '1' : '0';
                  case 'or not':
                    return Boolean(value1) || !Boolean(value2) ? '1' : '0';
                  case 'and':
                    return Boolean(value1) && Boolean(value2) ? '1' : '0';
                  case 'and not':
                    return Boolean(value1) && !Boolean(value2) ? '1' : '0';
                  case 'not equal':
                    return value1 !== value2 ? '1' : '0';
                  default:
                    return '0';
                }
              };
              validateValueOperation1 = computeOperation(value1.value, operator.value, value2.value);
              if (!(validateValueOperation1 === '0')) {
                _context2.next = 38;
                break;
              }
              _error = 'validation failed';
              _this.setError(_error);
              //this.output.paramsList.forEach(({ param }) => param.setEstimated({ value: undefined }))
              throw _error;
            case 38:
              _this.currentGasLimit = '10000';
              return _context2.abrupt("return", {
                result: validateValueOperation1
              });
            case 40:
              if (!(plugin.name === 'compute' && plugin.protocol === 'COMPUTED_VARIABLE')) {
                _context2.next = 48;
                break;
              }
              _plugin$input$methodP2 = plugin.input.methodParams, _value = _plugin$input$methodP2.value1, _value2 = _plugin$input$methodP2.value2, value3 = _plugin$input$methodP2.value3, value4 = _plugin$input$methodP2.value4, operator1 = _plugin$input$methodP2.operator1, operator2 = _plugin$input$methodP2.operator2, operator3 = _plugin$input$methodP2.operator3;
              _computeOperation = function _computeOperation(value1, operator, value2) {
                switch (operator) {
                  case '*':
                    return BigNumber.from(value1 || '0').mul(value2 || '0').toString();
                  case '**':
                    return BigNumber.from(value1 || '0').pow(value2 || '0').toString();
                  case '*(10**X)':
                    return BigNumber.from(value1 || '0').mul(BigNumber.from('10').pow(value2 || '0')).toString();
                  case '/(10**X)':
                    return BigNumber.from(value1 || '0').div(BigNumber.from('10').pow(value2 || '0')).toString();
                  case '%':
                    return BigNumber.from(value1 || '0').mod(value2 || '0').toString();
                  case '/':
                    if (!value2) return BigNumber.from('0').toString();
                    return BigNumber.from(value1 || '0').div(value2).toString();
                  case '-':
                    return BigNumber.from(value1 || '0').sub(value2 || '0').toString();
                  case '+':
                    return BigNumber.from(value1 || '0').add(value2 || '0').toString();
                  default:
                    return BigNumber.from(value1 || '0').add(value2 || '0').toString();
                }
              };
              computedValueOperation1 = _computeOperation(_value.value, operator1.value, _value2.value);
              computedValueOperation2 = _computeOperation(computedValueOperation1, operator2.value, value3.value);
              computedValueOperation3 = _computeOperation(computedValueOperation2, operator3.value, value4.value);
              _this.currentGasLimit = '10000';
              return _context2.abrupt("return", {
                result: computedValueOperation3
              });
            case 48:
              if (!(plugin.name === 'sendETH')) {
                _context2.next = 72;
                break;
              }
              setOutputIsLoading(true);
              _plugin$input$params = plugin.input.params, _to = _plugin$input$params.to, _value3 = _plugin$input$params.value;
              _context2.next = 53;
              return plugin.variableToValue(_value3, provider.provider);
            case 53:
              parsedValue = _context2.sent;
              _context2.prev = 54;
              _context2.next = 57;
              return provider.signer.sendTransaction({
                to: _to === null || _to === void 0 ? void 0 : _to.value,
                value: parsedValue
              });
            case 57:
              sendEthRes = _context2.sent;
              _context2.next = 60;
              return provider.provider.getTransaction(sendEthRes.hash);
            case 60:
              trxEthData = _context2.sent;
              setOutputIsLoading(false);
              _this.currentGasLimit = trxEthData.gasLimit.sub(21000).toString();
              return _context2.abrupt("return", {});
            case 66:
              _context2.prev = 66;
              _context2.t5 = _context2["catch"](54);
              _error2 = new Error(_context2.t5);
              _this.setError(_context2.t5.reason || _context2.t5.message || _context2.t5);
              //this.output.paramsList.forEach(({ param }) => param.setEstimated({ value: undefined }))
              setOutputIsLoading(false);
              throw _error2;
            case 72:
              to = plugin.protocol === 'KIROBO_MULTICALL_CSV' ? kiroboMulticallSimulateContracts[plugin.chainId] : (_inputParams$to = inputParams.to) === null || _inputParams$to === void 0 ? void 0 : _inputParams$to.value;
              if (!(typeof to !== 'string')) {
                _context2.next = 75;
                break;
              }
              return _context2.abrupt("return", "invalid contract address: ".concat(to));
            case 75:
              pluginMethodInterface = new utils.Interface(["function ".concat(plugin.contractInterface, " payable ").concat(plugin.contractInterfaceReturns)]); //console.log({ pluginMethodInterface })
              contract = abi ? new Contract(to, abi, provider.signer) : new Contract(to, pluginMethodInterface, provider.signer);
              setOutputIsLoading(true);
              methodParamsToValues = /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(methodParams) {
                  var list, _iterator, _step, param, _value4, _value5, coder;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        list = [];
                        _iterator = _createForOfIteratorHelper$5(methodParams);
                        _context.prev = 2;
                        _iterator.s();
                      case 4:
                        if ((_step = _iterator.n()).done) {
                          _context.next = 31;
                          break;
                        }
                        param = _step.value;
                        if (!(param.type === 'tuple[]')) {
                          _context.next = 10;
                          break;
                        }
                        _value4 = param.value;
                        list.push(_value4 === null || _value4 === void 0 ? void 0 : _value4.map(function (nestedParam) {
                          return nestedParam.map(function (p) {
                            return p.value;
                          });
                        }));
                        return _context.abrupt("continue", 29);
                      case 10:
                        if (!(typeof param.type === 'string' && param.type.includes('tuple'))) {
                          _context.next = 17;
                          break;
                        }
                        _context.t0 = list;
                        _context.next = 14;
                        return methodParamsToValues(param.value);
                      case 14:
                        _context.t1 = _context.sent;
                        _context.t0.push.call(_context.t0, _context.t1);
                        return _context.abrupt("continue", 29);
                      case 17:
                        if (!param.virtual) {
                          _context.next = 19;
                          break;
                        }
                        return _context.abrupt("continue", 29);
                      case 19:
                        if (param.value) {
                          _context.next = 22;
                          break;
                        }
                        list.push(param.value);
                        return _context.abrupt("continue", 29);
                      case 22:
                        _context.next = 24;
                        return plugin.variableToValue(param, provider.provider);
                      case 24:
                        _value5 = _context.sent;
                        // if (param.hashed) {
                        //   value = utils.id(param.value as string)
                        // }

                        console.log({
                          param: param
                        });
                        if (param.type === 'bytes32' && param.messageType === 'string' && typeof param.value === 'string') {
                          _value5 = utils.id(param.value);
                        }
                        if (param.type === 'bytes' && param.messageType === 'string' && typeof param.value === 'string') {
                          coder = utils.defaultAbiCoder;
                          _value5 = coder.encode(['string'], [param.value]);
                        }
                        list.push(_value5);
                      case 29:
                        _context.next = 4;
                        break;
                      case 31:
                        _context.next = 36;
                        break;
                      case 33:
                        _context.prev = 33;
                        _context.t2 = _context["catch"](2);
                        _iterator.e(_context.t2);
                      case 36:
                        _context.prev = 36;
                        _iterator.f();
                        return _context.finish(36);
                      case 39:
                        return _context.abrupt("return", list);
                      case 40:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee, null, [[2, 33, 36, 39]]);
                }));
                return function methodParamsToValues(_x2) {
                  return _ref4.apply(this, arguments);
                };
              }();
              _context2.next = 81;
              return methodParamsToValues(plugin.methodParams);
            case 81:
              methodParamsList = _context2.sent;
              value = !(inputParams !== null && inputParams !== void 0 && inputParams.value) ? '0x0' : inputParams.value.isVariable ? inputParams.value.estimatedValue : inputParams.value.value;
              _context2.next = 85;
              return provider.signer.getAddress();
            case 85:
              singerAddress = _context2.sent;
              _context2.prev = 86;
              console.log({
                methodParamsList: JSON.stringify(methodParamsList),
                method: plugin.method
              });
              _context2.next = 90;
              return (_contract$callStatic = contract.callStatic)[plugin.method].apply(_contract$callStatic, _toConsumableArray(methodParamsList).concat([{
                from: singerAddress,
                value: value
              }]));
            case 90:
              trx = _context2.sent;
              if (!(trx && execute)) {
                _context2.next = 100;
                break;
              }
              _context2.next = 94;
              return contract[plugin.method].apply(contract, _toConsumableArray(methodParamsList).concat([{
                from: singerAddress,
                value: value
              }]));
            case 94:
              res = _context2.sent;
              encodedData = pluginMethodInterface.encodeFunctionData(plugin.method, methodParamsList);
              _context2.next = 98;
              return provider.provider.getTransaction(res.hash);
            case 98:
              trxData = _context2.sent;
              _this.currentGasLimit = trxData.gasLimit.add(GAS_LIMIT_OVERHEAD).add(encodedData.length - 10).mul(115).div(100).toString();
            case 100:
              _this.setError(undefined);
              setOutputIsLoading(false);
              _context2.next = 110;
              break;
            case 104:
              _context2.prev = 104;
              _context2.t6 = _context2["catch"](86);
              _error3 = new Error(_context2.t6);
              _this.setError(_context2.t6.reason || _context2.t6.message || _context2.t6);
              //this.output.paramsList.forEach(({ param }) => param.setEstimated({ value: undefined }))
              setOutputIsLoading(false);
              throw _error3;
            case 110:
              outputParams = trx; //pluginMethodInterface.decodeFunctionResult(this.method, receipt.logsBloom)
              if (Object.keys(_this.output.params).length === 1) {
                outputParams = [outputParams];
              }
              params = {};
              Object.keys(_this.output.params).forEach(function (key, i) {
                var setParam = function setParam(outputParam) {
                  var currentOutputParam = outputParams[i];
                  if (key.includes("tuple") && !key.includes("tuple[]") && _typeof(currentOutputParam) === 'object' && !(currentOutputParam instanceof BigNumber)) {
                    var tupleParam = currentOutputParam;
                    Object.keys(outputParam).forEach(function (key) {
                      params[key] = tupleParam[key].toString();
                    });
                  }
                  if (key.includes("tuple[]") && _typeof(currentOutputParam) === 'object' && !(currentOutputParam instanceof BigNumber)) {
                    params[outputKey] = currentOutputParam.map(function (p) {
                      var tupleParam = p;
                      var paramObject = {};
                      Object.keys(outputParam).forEach(function (key) {
                        paramObject[key] = tupleParam[key];
                      });
                      return paramObject;
                    });
                  }
                  if (!(outputParam instanceof FctParam)) return;
                  var value = outputParams[i] ? outputParams[i].toString() : undefined;
                  params[outputKey] = value;
                  outputParam.setEstimated({
                    value: value
                  });
                };
                var outputKey = key;
                var outputParam = _this.output.params[outputKey];
                setParam(outputParam);
              });
              return _context2.abrupt("return", params);
            case 115:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[54, 66], [86, 104]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getCalldata", function () {
      var _inputParams$to2;
      var inputParams = _this.input.params;
      var to = (_inputParams$to2 = inputParams.to) === null || _inputParams$to2 === void 0 ? void 0 : _inputParams$to2.value;
      if (typeof to !== 'string') {
        console.error("invalid contract address: ".concat(to));
        return;
      }
      var methodParamsData = JSON.parse(_this.toJSONWithMeta())['input']['methodParams'];
      var trxParams = Object.keys(methodParamsData).map(function (methodParamKey) {
        var param = methodParamsData[methodParamKey];
        var value = param.value;
        if (!value) return value;
        if (isVariable(value)) {
          var variable = value;
          if (variable.type === 'output') {
            return getOutputVariableOnChain({
              index: variable.id.index || 0,
              innerIndex: variable.id.innerIndex,
              type: param.fctType
            });
          } else {
            console.error('only output variables with index supported');
          }
        }
        if (param.hashed) {
          return utils.id(param.value);
        }
        return value;
      });
      var trxParamsTypes = Object.keys(methodParamsData).map(function (methodParamKey) {
        var param = methodParamsData[methodParamKey];
        return param.fctType;
      });
      var abiCoder = new utils.AbiCoder();
      return {
        target: {
          value: to,
          type: 'address'
        },
        callType: {
          value: utils.id('view only'),
          type: 'bytes32'
        },
        value: {
          value: '0x0',
          type: 'uint256'
        },
        method: {
          value: utils.id(_this.methodInterface),
          type: 'bytes32'
        },
        data: {
          value: abiCoder.encode(trxParamsTypes, trxParams),
          type: 'bytes'
        }
      };
    });
    _defineProperty(this, "variableToValue", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(param, provider) {
        var value, blockNumber, block, blockTimestamp, blockNumberNum, gasPrice;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              value = param.value;
              if (!(_typeof(value) === 'object' && value.type === 'output')) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return", param.estimatedValue);
            case 3:
              if (!(_typeof(value) === 'object' && 'id' in value)) {
                _context4.next = 28;
                break;
              }
              _context4.t0 = value.id;
              _context4.next = _context4.t0 === 'blockTimestamp' ? 7 : _context4.t0 === 'blockNumber' ? 15 : _context4.t0 === 'gasPrice' ? 20 : _context4.t0 === 'minerAddress' ? 24 : _context4.t0 === 'originAddress' ? 25 : _context4.t0 === 'flowHash' ? 26 : 27;
              break;
            case 7:
              _context4.next = 9;
              return provider.getBlockNumber();
            case 9:
              blockNumber = _context4.sent;
              _context4.next = 12;
              return provider.getBlock(blockNumber);
            case 12:
              block = _context4.sent;
              blockTimestamp = block.timestamp + 1000;
              return _context4.abrupt("return", String(blockTimestamp));
            case 15:
              _context4.next = 17;
              return provider.getBlockNumber();
            case 17:
              _context4.t1 = _context4.sent;
              blockNumberNum = _context4.t1 + 1000;
              return _context4.abrupt("return", String(blockNumberNum));
            case 20:
              _context4.next = 22;
              return provider.getGasPrice();
            case 22:
              gasPrice = _context4.sent;
              return _context4.abrupt("return", gasPrice.toString());
            case 24:
              return _context4.abrupt("return", DEFAULT_ADDRESS);
            case 25:
              return _context4.abrupt("return", DEFAULT_ADDRESS);
            case 26:
              return _context4.abrupt("return", '0');
            case 27:
              return _context4.abrupt("return", value);
            case 28:
              if (!(_typeof(value) === 'object' && !value.length)) {
                _context4.next = 31;
                break;
              }
              _context4.next = 31;
              return Promise.all(Object.keys(value).map( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return _this.variableToValue(param.value[key], provider);
                      case 2:
                        value[key.replace('_tuple', '').replace('{}', '')] = _context3.sent;
                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x5) {
                  return _ref6.apply(this, arguments);
                };
              }()));
            case 31:
              return _context4.abrupt("return", value);
            case 32:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x3, _x4) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getRequiredApprovals", function () {
      if (_this.requiredApprovals) {
        // TODO: this.requiredApprovals to Promise function
        return _this.requiredApprovals(_this.input.get(), _this.chainId, _this.walletAddress, _this.vaultAddress, _this.provider, _this.method).map(function (data) {
          var params = Object.keys(data.params).map(function (key) {
            var dataKey = key;
            return data.params[dataKey];
          });
          return {
            to: data.to,
            from: data.from,
            protocol: data.protocol,
            method: data.method,
            params: params
          };
        });
      }
      return [];
    });
    _defineProperty(this, "getAssetFlow", function () {
      if (!_this.assetFlow) return [];
      return _this.assetFlow(_this.input.get(), _this.chainId, _this.walletAddress, _this.vaultAddress, _this.provider, _this.method);
    });
    _defineProperty(this, "subscribe", function (_ref7) {
      var callback = _ref7.callback,
        id = _ref7.id;
      _this.observers.set(id, callback);
    });
    _defineProperty(this, "unsubscribe", function (_ref8) {
      var id = _ref8.id;
      _this.observers.delete(id);
    });
    _defineProperty(this, "updateSubscriptions", function () {
      var _iterator2 = _createForOfIteratorHelper$5(_this.observers),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var observer = _step2.value;
          observer[1](_this.toJSON(), _this.error, _this.chainId, _this._currentGasLimit);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    });
    _defineProperty(this, "observers", new Map());
    this._protocol = _protocol;
    this._type = _type;
    this._method = _method;
    this._name = _name;
    this.requiredApprovals = requiredApprovals;
    this.assetFlow = assetFlow;
    this._walletAddress = _walletAddress;
    this._vaultAddress = _vaultAddress;
    this._provider = _provider;
    var newParams = fctParamsFactory.create(_params);
    this.input = new Input(newParams, chainId);
    this.chainId = chainId;
    if (initParams) this.input.set(initParams);
    this.output = new Output(newParams['output'], chainId);
    this.initMethodParams = this.methodParams;
    this.input.subscribe({
      callback: this.updateSubscriptions,
      id: uid
    });
    this.output.subscribe({
      callback: this.updateSubscriptions,
      id: uid
    });
  }
  _createClass(Plugin, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9) {
        var call;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              call = _ref9.call;
              if (this.input.isValid) {
                _context5.next = 4;
                break;
              }
              console.error(this.input.errors);
              return _context5.abrupt("return", undefined);
            case 4:
              return _context5.abrupt("return", call);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function create(_x6) {
        return _create.apply(this, arguments);
      }
      return create;
    }()
  }, {
    key: "gasLimit",
    get: function get() {
      if (this.currentGasLimit) return this.currentGasLimit;
      if (this.estimateGasOnParams) return this.estimateGasOnParams(this.input.get(), this.method, this.chainId);
      var limits = gasLimit[this.chainId];
      var protocolLimits = limits[this.protocol];
      if (protocolLimits) {
        return protocolLimits[this.method] !== 'FAILED' ? protocolLimits[this.method] : undefined;
      }
      return undefined;
    }
  }, {
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "protocol",
    get: function get() {
      return this._protocol;
    }
  }, {
    key: "method",
    get: function get() {
      return this._method;
    }
  }, {
    key: "provider",
    get: function get() {
      return this._provider;
    }
  }, {
    key: "walletAddress",
    get: function get() {
      return this._walletAddress;
    }
  }, {
    key: "vaultAddress",
    get: function get() {
      return this._vaultAddress;
    }
  }, {
    key: "name",
    get: function get() {
      if (this._name) return this._name;
      return this.method;
    }
  }, {
    key: "setName",
    value: function setName(name) {
      this._name = name;
      this.updateSubscriptions();
    }
  }, {
    key: "description",
    get: function get() {
      if (this._description) return this._description;
      return getMethodDescription({
        protocol: this.protocol,
        type: this.type,
        methodInterface: this.methodInterface
      });
    }
  }, {
    key: "supportedContracts",
    get: function get() {
      return this._supportedContracts;
    }
  }, {
    key: "falseMeansFail",
    get: function get() {
      return this._falseMeansFail || false;
    }
  }, {
    key: "usePureMethod",
    get: function get() {
      return this._usePureMethod || false;
    }
  }, {
    key: "methodParams",
    get: function get() {
      var params = this.input.methodParams;
      return getMethodParams({
        params: params
      });
    }
  }, {
    key: "getMethodParams",
    value: function getMethodParams$1(_ref10) {
      var params = _ref10.params;
      // const params = this.input.methodParams
      return getMethodParams({
        params: params
      });
    }
  }, {
    key: "contractInterface",
    get: function get() {
      return getContractInterface({
        method: this.method,
        params: this.methodParams
      });
    }
  }, {
    key: "contractInterfaceReturns",
    get: function get() {
      return getContractInterfaceReturns({
        params: this.output.params
      });
    }
  }, {
    key: "methodInterface",
    get: function get() {
      return getMethodInterface({
        method: this.method,
        params: this.initMethodParams
      });
    }
  }, {
    key: "methodInterfaceHash",
    get: function get() {
      return id(this.methodInterface);
    }
  }, {
    key: "toJSONWithMeta",
    value: function toJSONWithMeta() {
      var input = this.inputParamsTo('META');
      var output = this.outputParamsTo('META');
      var json = JSON.stringify({
        type: this.type,
        name: this.name,
        protocol: this.protocol,
        method: this.method,
        methodInterface: this.methodInterface,
        methodInterfaceHash: this.methodInterfaceHash,
        contractInterface: this.contractInterface,
        contractInterfaceReturns: this.contractInterfaceReturns,
        input: input,
        output: output
      });
      return json;
    }
  }, {
    key: "fromJSONWithMeta",
    value: function fromJSONWithMeta(jsonWithMeta) {
      var pluginJson = JSON.parse(jsonWithMeta);
      if (!pluginJson.input) {
        console.error('wrong json format');
        return false;
      }
      try {
        if (pluginJson.name) this._name = pluginJson.name;
        var _params2 = pluginJson.inputList;
        this.input.paramsList.forEach(function (_ref11) {
          var param = _ref11.param,
            key = _ref11.key;
          var data = _params2.find(function (param) {
            return param.key === key;
          });
          if (data) param.setJsonParam(data);
        });
        var outParams = pluginJson.outputList;
        this.output.paramsList.forEach(function (_ref12) {
          var param = _ref12.param,
            key = _ref12.key;
          var data = outParams.find(function (param) {
            return param.key === key;
          });
          if (data) param.setJsonParam(data);
        });
        this.input.updateSubscriptions();
        return true;
      } catch (e) {
        console.error(this.input.errors);
        return false;
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var input = this.inputParamsTo('VALUES');
      var output = this.outputParamsTo('VALUES');
      var inputWithMeta = this.inputParamsTo('META');
      var outputWithMeta = this.outputParamsTo('META');
      var paramsList = this.input.paramsList;
      var inputList = paramsList.map(function (_ref13) {
        var key = _ref13.key,
          param = _ref13.param;
        var data = param.getJsonParam({
          key: key,
          ioType: 'INPUT'
        });
        return data;
      });
      var outputList = this.output.paramsList.map(function (_ref14) {
        var key = _ref14.key,
          param = _ref14.param;
        var data = param.getJsonParam({
          key: key,
          ioType: 'OUTPUT'
        });
        return data;
      });
      var json = JSON.stringify({
        type: this.type,
        name: this.name,
        protocol: this.protocol,
        method: this.method,
        methodInterface: this.methodInterface,
        methodInterfaceHash: this.methodInterfaceHash,
        contractInterface: this.contractInterface,
        contractInterfaceReturns: this.contractInterfaceReturns,
        input: input,
        output: output,
        inputWithMeta: inputWithMeta,
        outputWithMeta: outputWithMeta,
        inputList: inputList,
        outputList: outputList
      });
      return json;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      var pluginJson = JSON.parse(json);
      if (!pluginJson.input) {
        console.error('wrong json format');
        return false;
      }
      try {
        if (pluginJson.name) this._name = pluginJson.name;
        var _params3 = pluginJson.inputList;
        this.input.paramsList.forEach(function (_ref15) {
          var param = _ref15.param,
            key = _ref15.key;
          var paramData = _params3.find(function (param) {
            return param.key === key;
          });
          if (!paramData) return;
          param.setJsonParam(paramData);
        });
        var outputParams = pluginJson.outputList;
        this.output.paramsList.forEach(function (_ref16) {
          var param = _ref16.param,
            key = _ref16.key;
          var paramData = outputParams.find(function (param) {
            return param.key === key;
          });
          if (!paramData) return;
          param.setJsonParam(paramData);
        });
        this.input.updateSubscriptions();
        return true;
      } catch (e) {
        console.error(this.input.errors);
        return false;
      }
    }
  }, {
    key: "inputParamsTo",
    value: function inputParamsTo(type) {
      var values = {};
      var setParams = function setParams(params, input) {
        for (var _key in params) {
          var paramKey = _key;
          var param = params[paramKey];
          if (param instanceof FctParam) {
            input[paramKey] = type === 'VALUES' ? param.getString() : param.getJsonParam({
              key: _key,
              ioType: 'INPUT'
            });
          } else {
            if (!input[paramKey]) {
              input[paramKey] = {};
            }
            setParams(params[_key], input[paramKey]);
          }
        }
      };
      setParams(this.input.params, values);
      return values;
    }
  }, {
    key: "error",
    get: function get() {
      return this._error;
    }
  }, {
    key: "setError",
    value: function setError(e) {
      this._error = e;
      this.updateSubscriptions();
    }
  }, {
    key: "currentGasLimit",
    get: function get() {
      return this._currentGasLimit;
    },
    set: function set(gasLimit) {
      this._currentGasLimit = gasLimit;
      this.updateSubscriptions();
    }
  }, {
    key: "outputParamsTo",
    value: function outputParamsTo(type) {
      var output = {};
      var setParams = function setParams(params, input) {
        for (var _key2 in params) {
          var paramKey = _key2;
          var param = params[paramKey];
          if (param instanceof FctParam) {
            output[paramKey] = type === 'VALUES' ? param.getString() : param.getJsonParam({
              key: _key2,
              ioType: 'OUTPUT'
            });
          } else {
            if (!output[paramKey]) {
              output[paramKey] = {};
            }
            setParams(params[_key2], output[paramKey]);
          }
        }
      };
      setParams(this.output.params);
      return output;
    }
  }]);
  return Plugin;
}();

function _createSuper$b(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$b(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$b() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var createPlugin = function createPlugin(_ref2) {
  var getParams = _ref2.getParams,
    protocol = _ref2.protocol,
    type = _ref2.type,
    method = _ref2.method,
    validate = _ref2.validate,
    onCreate = _ref2.onCreate,
    onChange = _ref2.onChange,
    getSubscribtions = _ref2.getSubscribtions,
    name = _ref2.name,
    description = _ref2.description,
    initParams = _ref2.initParams,
    supportedContracts = _ref2.supportedContracts,
    falseMeansFail = _ref2.falseMeansFail,
    toEns = _ref2.toEns,
    getParamsOnCreate = _ref2.getParamsOnCreate,
    requiredApprovals = _ref2.requiredApprovals,
    calculateValuesOnUserInput = _ref2.calculateValuesOnUserInput,
    beforeSimulate = _ref2.beforeSimulate,
    setValuesAsync = _ref2.setValuesAsync,
    assetFlow = _ref2.assetFlow,
    overrideSetMethodParams = _ref2.overrideSetMethodParams,
    estimateGasOnParams = _ref2.estimateGasOnParams,
    payerIndex = _ref2.payerIndex,
    usePureMethod = _ref2.usePureMethod;
  var NewPlugin = /*#__PURE__*/function (_Plugin2) {
    _inherits(NewPlugin, _Plugin2);
    var _super2 = _createSuper$b(NewPlugin);
    function NewPlugin(args) {
      var _params$input$to;
      var _thisSuper, _thisSuper2, _this2;
      _classCallCheck(this, NewPlugin);
      var argsInitParams = args === null || args === void 0 ? void 0 : args.initParams;
      var init = initParams;
      if (argsInitParams) {
        init = deepmerge(initParams, argsInitParams);
      }
      var chainId = (args === null || args === void 0 ? void 0 : args.chainId) || '1';
      var _params = getParams({
        chainId: chainId,
        vaultAddress: args === null || args === void 0 ? void 0 : args.vaultAddress,
        walletAddress: args === null || args === void 0 ? void 0 : args.walletAddress
      });
      _this2 = _super2.call(this, protocol, type, method, name, chainId, _params, requiredApprovals, assetFlow, init, args.walletAddress, args.vaultAddress, args.provider);
      _defineProperty(_assertThisInitialized(_this2), "create", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _params$value, _params$to;
        var params, callType, _paramsOnCreate$param, _paramsOnCreate$param2, paramsOnCreate, _call, call;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              params = _this2.input.get();
              callType = type === 'ACTION' || type === 'LIBRARY' ? type : 'VIEW_ONLY';
              if (!getParamsOnCreate) {
                _context2.next = 11;
                break;
              }
              _context2.next = 5;
              return getParamsOnCreate({
                chainId: _this2.chainId,
                params: params
              });
            case 5:
              paramsOnCreate = _context2.sent;
              if (paramsOnCreate) {
                _context2.next = 9;
                break;
              }
              console.log(_this2.input.errors);
              return _context2.abrupt("return");
            case 9:
              _call = {
                value: (_paramsOnCreate$param = paramsOnCreate.params.value) === null || _paramsOnCreate$param === void 0 ? void 0 : _paramsOnCreate$param.value,
                to: (_paramsOnCreate$param2 = paramsOnCreate.params.to) === null || _paramsOnCreate$param2 === void 0 ? void 0 : _paramsOnCreate$param2.value,
                toENS: _this2.toEns,
                method: paramsOnCreate.method,
                params: _this2.getMethodParams({
                  params: paramsOnCreate.params.methodParams
                }),
                options: {
                  gasLimit: _this2.gasLimit || paramsOnCreate.gasLimit || '0',
                  falseMeansFail: _this2.falseMeansFail,
                  payerIndex: _this2.payerIndex,
                  usePureMethod: _this2.usePureMethod,
                  callType: callType
                }
              };
              return _context2.abrupt("return", _get((_thisSuper = _assertThisInitialized(_this2), _getPrototypeOf(NewPlugin.prototype)), "create", _thisSuper).call(_thisSuper, {
                call: _call
              }));
            case 11:
              call = {
                value: (_params$value = params.value) === null || _params$value === void 0 ? void 0 : _params$value.value,
                to: (_params$to = params.to) === null || _params$to === void 0 ? void 0 : _params$to.value,
                method: _this2.method,
                params: _this2.methodParams,
                toENS: _this2.toEns,
                options: {
                  gasLimit: _this2.gasLimit || '0',
                  falseMeansFail: _this2.falseMeansFail,
                  payerIndex: _this2.payerIndex,
                  usePureMethod: _this2.usePureMethod,
                  callType: callType
                }
              };
              return _context2.abrupt("return", _get((_thisSuper2 = _assertThisInitialized(_this2), _getPrototypeOf(NewPlugin.prototype)), "create", _thisSuper2).call(_thisSuper2, {
                call: call
              }));
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })));
      var options = (_params$input$to = _params.input.to) === null || _params$input$to === void 0 ? void 0 : _params$input$to.options;
      if (options && options.length) {
        _this2._supportedContracts = options.map(function (option) {
          return {
            address: option.value,
            name: option.name,
            chainId: option.chainId
          };
        });
        if (options.length === 1) {
          var _this2$input$params$t;
          (_this2$input$params$t = _this2.input.params.to) === null || _this2$input$params$t === void 0 ? void 0 : _this2$input$params$t.set({
            value: options[0].value
          });
        }
      } else if (supportedContracts) {
        var _this2$input$params$t2;
        var pluginContracts = getSupportedContracts({
          chainId: chainId,
          contracts: supportedContracts
        });
        if (pluginContracts && pluginContracts.length === 1) (_this2$input$params$t2 = _this2.input.params.to) === null || _this2$input$params$t2 === void 0 ? void 0 : _this2$input$params$t2.set({
          value: pluginContracts[0].value
        });
        _this2._supportedContracts = supportedContracts;
      }
      if (name) {
        _this2._name = name;
      }
      _this2.toEns = toEns;
      _this2.payerIndex = payerIndex;
      if (validate) _this2.input.validate = validate;
      if (description) _this2._description = description;
      if (getSubscribtions) getSubscribtions({
        chainId: _this2.chainId,
        input: _this2.input.params,
        output: _this2.output.params,
        setMethod: _this2.setMethod,
        walletAddress: args.walletAddress,
        vaultAddress: args.vaultAddress
      }).forEach(function (subscription) {
        _this2.input.subscribe(subscription);
      });
      if (onCreate) {
        onCreate({
          chainId: chainId,
          input: _this2.input.params,
          output: _this2.output.params
        });
      }
      if (setValuesAsync) {
        _this2.setValuesAsync = setValuesAsync;
      }
      if (onChange) {
        _this2.input.subscribe({
          callback: function callback() {
            return onChange({
              chainId: chainId,
              input: _this2.input.params,
              output: _this2.output.params
            });
          },
          id: uuid_1.v4()
        });
      }
      if (calculateValuesOnUserInput) {
        _this2.calculateValuesOnUserInput = calculateValuesOnUserInput({
          chainId: chainId,
          input: _this2.input.params,
          output: _this2.output.params,
          account: args.vaultAddress,
          provider: _this2.provider,
          setMethod: _this2.setMethod
        });
      }
      if (overrideSetMethodParams) {
        _this2.setMethodParams = overrideSetMethodParams({
          chainId: chainId,
          input: _this2.input.params,
          output: _this2.output.params
        });
      }
      if (beforeSimulate) {
        _this2.beforeSimulate = beforeSimulate;
      }
      if (estimateGasOnParams) {
        _this2.estimateGasOnParams = estimateGasOnParams;
      }
      if (getParamsOnCreate) {
        _this2.getParamsOnCreate = getParamsOnCreate;
      }
      if (falseMeansFail) _this2._falseMeansFail = falseMeansFail;
      if (usePureMethod) _this2._usePureMethod = usePureMethod;
      return _this2;
    }
    return _createClass(NewPlugin);
  }(Plugin);
  return NewPlugin;
};

var amountOutMinRisk = {
  description: 'Transaction may be frontrun',
  isDanger: function isDanger(param) {
    if (!param) return true;
    if (typeof param === 'string') {
      if (parseFloat(param) <= 0) return true;
      return false;
    }
    return true;
  }
};
({
  input: {
    to: new FctAddress({
      destination: 'uniswap_router'
    }),
    methodParams: {
      amountOut: new FctValue({
        destination: 'wei_amount'
      }),
      path: new FctAddressList({
        destination: 'ERC20_List'
      }),
      to: new FctAddress({}),
      deadline: new FctTimestamp({})
    }
  },
  output: {
    amountIn: new FctValue({
      destination: 'wei_amount',
      innerIndex: 2
    }),
    amountOut: new FctValue({
      destination: 'wei_amount',
      innerIndex: -1
    })
  }
});
var swapExactEthForTokensParams = {
  input: {
    to: new FctAddress({
      destination: 'uniswap_router'
    }),
    value: new FctValue({
      destination: 'wei_amount'
    }),
    methodParams: {
      amountOutMin: new FctValue({
        destination: 'wei_amount',
        risk: amountOutMinRisk
      }),
      path: new FctAddressList({
        destination: 'ERC20_List'
      }),
      to: new FctAddress({}),
      deadline: new FctTimestamp({})
    }
  },
  output: {
    amountIn: new FctValue({
      destination: 'wei_amount',
      innerIndex: 2
    }),
    amountOut: new FctValue({
      destination: 'wei_amount',
      innerIndex: -1
    })
  }
};
var swapExactTokensForEthParams = {
  input: {
    to: new FctAddress({
      destination: 'uniswap_router'
    }),
    methodParams: {
      amountIn: new FctValue({
        destination: 'wei_amount'
      }),
      amountOutMin: new FctValue({
        destination: 'wei_amount',
        risk: amountOutMinRisk
      }),
      path: new FctAddressList({
        destination: 'ERC20_List'
      }),
      to: new FctAddress({}),
      deadline: new FctTimestamp({})
    }
  },
  output: {
    amountIn: new FctValue({
      destination: 'wei_amount',
      innerIndex: 2
    }),
    amountOut: new FctValue({
      destination: 'wei_amount',
      innerIndex: -1
    })
  }
};
var swapExactTokensForTokensParams = {
  input: {
    to: new FctAddress({
      destination: 'uniswap_router'
    }),
    methodParams: {
      amountIn: new FctValue({
        destination: 'wei_amount'
      }),
      amountOutMin: new FctValue({
        destination: 'wei_amount',
        risk: amountOutMinRisk
      }),
      path: new FctAddressList({
        destination: 'ERC20_List'
      }),
      to: new FctAddress({}),
      deadline: new FctTimestamp({})
    }
  },
  output: {
    amountIn: new FctValue({
      destination: 'wei_amount',
      innerIndex: 2
    }),
    amountOut: new FctValue({
      destination: 'wei_amount',
      innerIndex: -1
    })
  }
};
({
  input: {
    to: new FctAddress({
      destination: 'uniswap_router'
    }),
    methodParams: {
      amountIn: new FctValue({
        destination: 'wei_amount'
      }),
      amountInMax: new FctValue({
        destination: 'wei_amount'
      }),
      path: new FctAddressList({
        destination: 'ERC20_List'
      }),
      to: new FctAddress({}),
      deadline: new FctTimestamp({})
    }
  },
  output: {
    amountIn: new FctValue({
      destination: 'wei_amount',
      innerIndex: 2
    }),
    amountOut: new FctValue({
      destination: 'wei_amount',
      innerIndex: -1
    })
  }
});
({
  input: {
    to: new FctAddress({
      destination: 'uniswap_router'
    }),
    methodParams: {
      amountOut: new FctValue({
        destination: 'wei_amount'
      }),
      amountInMax: new FctValue({
        destination: 'wei_amount'
      }),
      path: new FctAddressList({
        destination: 'ERC20_List'
      }),
      to: new FctAddress({}),
      deadline: new FctTimestamp({})
    }
  },
  output: {
    amountIn: new FctValue({
      destination: 'wei_amount',
      innerIndex: 2
    }),
    amountOut: new FctValue({
      destination: 'wei_amount',
      innerIndex: -1
    })
  }
});

/* eslint-disable no-restricted-imports */
var AddLiquidity$2 = createPlugin({
  protocol: 'UNISWAP',
  type: 'ACTION',
  method: 'addLiquidity',
  description: 'Add liquidity on Uniswap',
  supportedContracts: ROUTER_V2_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        methodParams: {
          tokenA: new FctAddress({
            destination: 'erc20',
            options: getSupportedTokens({
              chainId: chainId
            })
          }),
          tokenB: new FctAddress({
            destination: 'erc20',
            options: getSupportedTokens({
              chainId: chainId
            })
          }),
          amountADesired: new FctValue({
            destination: 'wei_amount'
          }),
          amountBDesired: new FctValue({
            destination: 'wei_amount'
          }),
          amountAMin: new FctValue({
            destination: 'wei_amount',
            risk: amountOutMinRisk
          }),
          amountBMin: new FctValue({
            destination: 'wei_amount',
            risk: amountOutMinRisk
          }),
          to: new FctAddress({}),
          deadline: new FctTimestamp({})
        }
      },
      output: {
        amountA: new FctValue({
          destination: 'wei_amount',
          innerIndex: 0
        }),
        amountB: new FctValue({
          destination: 'wei_amount',
          innerIndex: 1
        }),
        liquidity: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2
        })
      }
    };
  },
  initParams: {
    methodParams: {
      amountAMin: '0',
      amountBMin: '0',
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  },
  requiredApprovals: function requiredApprovals(params) {
    return [{
      to: params.methodParams.tokenA.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amountADesired.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }, {
      to: params.methodParams.tokenB.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amountBDesired.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
  // async assetFlow(params, chainId, walletAddress, vaultAddress, provider, method) {
  //   const {
  //     to,
  //     methodParams: { tokenA, tokenB, amountADesired, amountBDesired, amountAMin, amountBMin },
  //   } = params

  //   if (
  //     !tokenA.value ||
  //     !tokenB.value ||
  //     !to.value ||
  //     !amountADesired.value ||
  //     !amountBDesired.value ||
  //     !amountAMin.value ||
  //     !amountBMin.value ||
  //     !vaultAddress
  //   )
  //     return []
  //   if (
  //     typeof amountADesired.value !== 'string' ||
  //     typeof amountBDesired.value !== 'string' ||
  //     typeof amountAMin.value !== 'string' ||
  //     typeof amountBMin.value !== 'string' ||
  //     typeof tokenA.value !== 'string' ||
  //     typeof tokenB.value !== 'string' ||
  //     typeof to.value !== 'string'
  //   )
  //     return []

  //   function calculateLPTokens(
  //     reserveA: number,
  //     reserveB: number,
  //     previousReserveA: number,
  //     previousReserveB: number
  //   ): number {
  //     return Math.sqrt(reserveA * reserveB) - Math.sqrt(previousReserveA * previousReserveB)
  //   }

  //   return [
  //     {
  //       address: vaultAddress,
  //       toSpend: [
  //         {
  //           token: tokenA.value,
  //           amount: amountADesired.value,
  //         },
  //         {
  //           token: tokenB.value,
  //           amount: amountBDesired.value,
  //         },
  //       ],
  //       toReceive: [],
  //     },
  //   ]
  // },
});

/* eslint-disable no-restricted-imports */
var AddLiquidityETH$1 = createPlugin({
  protocol: 'UNISWAP',
  type: 'ACTION',
  method: 'addLiquidityETH',
  description: 'Add liquidity on Uniswap',
  supportedContracts: ROUTER_V2_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        value: new FctValue({
          destination: 'wei_amount'
        }),
        methodParams: {
          token: new FctAddress({
            destination: 'erc20',
            options: getSupportedTokens({
              chainId: chainId
            })
          }),
          amountTokenDesired: new FctValue({}),
          amountTokenMin: new FctValue({
            destination: 'wei_amount',
            risk: amountOutMinRisk
          }),
          amountETHMin: new FctValue({
            destination: 'wei_amount',
            risk: amountOutMinRisk
          }),
          to: new FctAddress({}),
          deadline: new FctTimestamp({})
        }
      },
      output: {
        amountA: new FctValue({
          destination: 'wei_amount',
          innerIndex: 0
        }),
        amountB: new FctValue({
          destination: 'wei_amount',
          innerIndex: 1
        }),
        liquidity: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2
        })
      }
    };
  },
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      },
      amountTokenMin: '0',
      amountETHMin: '0'
    }
  },
  requiredApprovals: function requiredApprovals(params) {
    return [{
      to: params === null || params === void 0 ? void 0 : params.methodParams.token.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amountTokenDesired.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var _USDC, _UNI, _objectSpread2, _USDC2;
function _createSuper$a(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$a(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$a() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys$q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$q(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$q(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var USDC_MAINNET = new Token(SupportedChainId.MAINNET, '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', 6, 'USDC', 'USD//C');
var USDC_ROPSTEN = new Token(SupportedChainId.ROPSTEN, '0x07865c6e87b9f70255377e024ace6630c1eaa37f', 6, 'USDC', 'USD//C');
var USDC_RINKEBY = new Token(SupportedChainId.RINKEBY, '0x4DBCdF9B62e891a7cec5A2568C3F4FAF9E8Abe2b', 6, 'tUSDC', 'test USD//C');
var USDC_GOERLI = new Token(SupportedChainId.GOERLI, '0x07865c6e87b9f70255377e024ace6630c1eaa37f', 6, 'USDC', 'USD//C');
var USDC_KOVAN = new Token(SupportedChainId.KOVAN, '0x31eeb2d0f9b6fd8642914ab10f4dd473677d80df', 6, 'USDC', 'USD//C');
var USDC_OPTIMISM = new Token(SupportedChainId.OPTIMISM, '0x7F5c764cBc14f9669B88837ca1490cCa17c31607', 6, 'USDC', 'USD//C');
var USDC_OPTIMISTIC_KOVAN = new Token(SupportedChainId.OPTIMISTIC_KOVAN, '0x3b8e53b3ab8e01fb57d0c9e893bc4d655aa67d84', 6, 'USDC', 'USD//C');
var USDC_ARBITRUM = new Token(SupportedChainId.ARBITRUM_ONE, '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8', 6, 'USDC', 'USD//C');
var USDC_ARBITRUM_RINKEBY = new Token(SupportedChainId.ARBITRUM_RINKEBY, '0x09b98f8b2395d076514037ff7d39a091a536206c', 6, 'USDC', 'USD//C');
var USDC_ARBITRUM_GOERLI = new Token(SupportedChainId.ARBITRUM_GOERLI, '0x179522635726710Dd7D2035a81d856de4Aa7836c', 6, 'USDC', 'USD//C');
var USDC_POLYGON = new Token(SupportedChainId.POLYGON, '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', 6, 'USDC', 'USD//C');
var USDC_POLYGON_MUMBAI = new Token(SupportedChainId.POLYGON_MUMBAI, '0xe11a86849d99f524cac3e7a0ec1241828e332c62', 6, 'USDC', 'USD//C');
new Token(SupportedChainId.MAINNET, '0xD46bA6D942050d489DBd938a2C909A5d5039A161', 9, 'AMPL', 'Ampleforth');
new Token(SupportedChainId.MAINNET, '0x6B175474E89094C44Da98b954EedeAC495271d0F', 18, 'DAI', 'Dai Stablecoin');
new Token(SupportedChainId.ARBITRUM_ONE, '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1', 18, 'DAI', 'Dai stable coin');
new Token(SupportedChainId.OPTIMISM, '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1', 18, 'DAI', 'Dai stable coin');
(_USDC = {}, _defineProperty(_USDC, SupportedChainId.MAINNET, USDC_MAINNET), _defineProperty(_USDC, SupportedChainId.ARBITRUM_ONE, USDC_ARBITRUM), _defineProperty(_USDC, SupportedChainId.OPTIMISM, USDC_OPTIMISM), _defineProperty(_USDC, SupportedChainId.ARBITRUM_RINKEBY, USDC_ARBITRUM_RINKEBY), _defineProperty(_USDC, SupportedChainId.ARBITRUM_GOERLI, USDC_ARBITRUM_GOERLI), _defineProperty(_USDC, SupportedChainId.OPTIMISTIC_KOVAN, USDC_OPTIMISTIC_KOVAN), _defineProperty(_USDC, SupportedChainId.POLYGON, USDC_POLYGON), _defineProperty(_USDC, SupportedChainId.POLYGON_MUMBAI, USDC_POLYGON_MUMBAI), _defineProperty(_USDC, SupportedChainId.GOERLI, USDC_GOERLI), _defineProperty(_USDC, SupportedChainId.RINKEBY, USDC_RINKEBY), _defineProperty(_USDC, SupportedChainId.KOVAN, USDC_KOVAN), _defineProperty(_USDC, SupportedChainId.ROPSTEN, USDC_ROPSTEN), _USDC);
new Token(SupportedChainId.POLYGON, '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063', 18, 'DAI', 'Dai Stablecoin');
new Token(SupportedChainId.POLYGON, '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', 6, 'USDT', 'Tether USD');
new Token(SupportedChainId.POLYGON, '0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6', 8, 'WBTC', 'Wrapped BTC');
new Token(SupportedChainId.MAINNET, '0xdAC17F958D2ee523a2206206994597C13D831ec7', 6, 'USDT', 'Tether USD');
new Token(SupportedChainId.ARBITRUM_ONE, '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9', 6, 'USDT', 'Tether USD');
new Token(SupportedChainId.OPTIMISM, '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58', 6, 'USDT', 'Tether USD');
new Token(SupportedChainId.MAINNET, '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599', 8, 'WBTC', 'Wrapped BTC');
new Token(SupportedChainId.ARBITRUM_ONE, '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f', 8, 'WBTC', 'Wrapped BTC');
new Token(SupportedChainId.OPTIMISM, '0x68f180fcCe6836688e9084f035309E29Bf0A2095', 8, 'WBTC', 'Wrapped BTC');
new Token(SupportedChainId.MAINNET, '0x956F47F50A910163D8BF957Cf5846D573E7f87CA', 18, 'FEI', 'Fei USD');
new Token(SupportedChainId.MAINNET, '0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B', 18, 'TRIBE', 'Tribe');
new Token(SupportedChainId.MAINNET, '0x853d955aCEf822Db058eb8505911ED77F175b99e', 18, 'FRAX', 'Frax');
new Token(SupportedChainId.MAINNET, '0x3432B6A60D23Ca0dFCa7761B7ab56459D9C964D0', 18, 'FXS', 'Frax Share');
new Token(SupportedChainId.MAINNET, '0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D', 8, 'renBTC', 'renBTC');
new Token(SupportedChainId.MAINNET, '0xAa6E8127831c9DE45ae56bB1b0d4D4Da6e5665BD', 18, 'ETH2x-FLI', 'ETH 2x Flexible Leverage Index');
new Token(SupportedChainId.MAINNET, '0xFe2e637202056d30016725477c5da089Ab0A043A', 18, 'sETH2', 'StakeWise Staked ETH2');
new Token(SupportedChainId.MAINNET, '0x20BC832ca081b91433ff6c17f85701B6e92486c5', 18, 'rETH2', 'StakeWise Reward ETH2');
new Token(SupportedChainId.MAINNET, '0x48C3399719B582dD63eB5AADf12A40B4C3f52FA2', 18, 'SWISE', 'StakeWise');
new Token(SupportedChainId.POLYGON_MUMBAI, '0xa6fa4fb5f76172d178d61b04b0ecd319c5d1c0aa', 18, 'WETH', 'Wrapped Ether');
new Token(SupportedChainId.POLYGON, '0x7ceb23fd6bc0add59e62ac25578270cff1b9f619', 18, 'WETH', 'Wrapped Ether');
(_UNI = {}, _defineProperty(_UNI, SupportedChainId.MAINNET, new Token(SupportedChainId.MAINNET, UNI_ADDRESS[1], 18, 'UNI', 'Uniswap')), _defineProperty(_UNI, SupportedChainId.RINKEBY, new Token(SupportedChainId.RINKEBY, UNI_ADDRESS[4], 18, 'UNI', 'Uniswap')), _defineProperty(_UNI, SupportedChainId.ROPSTEN, new Token(SupportedChainId.ROPSTEN, UNI_ADDRESS[3], 18, 'UNI', 'Uniswap')), _defineProperty(_UNI, SupportedChainId.GOERLI, new Token(SupportedChainId.GOERLI, UNI_ADDRESS[5], 18, 'UNI', 'Uniswap')), _defineProperty(_UNI, SupportedChainId.KOVAN, new Token(SupportedChainId.KOVAN, UNI_ADDRESS[42], 18, 'UNI', 'Uniswap')), _UNI);
var WRAPPED_NATIVE_CURRENCY = _objectSpread$q(_objectSpread$q({}, WETH9), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, SupportedChainId.OPTIMISM, new Token(SupportedChainId.OPTIMISM, '0x4200000000000000000000000000000000000006', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_objectSpread2, SupportedChainId.OPTIMISTIC_KOVAN, new Token(SupportedChainId.OPTIMISTIC_KOVAN, '0x4200000000000000000000000000000000000006', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_objectSpread2, SupportedChainId.ARBITRUM_ONE, new Token(SupportedChainId.ARBITRUM_ONE, '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_objectSpread2, SupportedChainId.ARBITRUM_RINKEBY, new Token(SupportedChainId.ARBITRUM_RINKEBY, '0xB47e6A5f8b33b3F17603C83a0535A9dcD7E32681', 18, 'WETH', 'Wrapped Ether')), _defineProperty(_objectSpread2, SupportedChainId.POLYGON, new Token(SupportedChainId.POLYGON, '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270', 18, 'WMATIC', 'Wrapped MATIC')), _defineProperty(_objectSpread2, SupportedChainId.POLYGON_MUMBAI, new Token(SupportedChainId.POLYGON_MUMBAI, '0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889', 18, 'WMATIC', 'Wrapped MATIC')), _objectSpread2));
function isMatic(chainId) {
  return chainId === SupportedChainId.POLYGON_MUMBAI || chainId === SupportedChainId.POLYGON;
}
var MaticNativeCurrency = /*#__PURE__*/function (_NativeCurrency) {
  _inherits(MaticNativeCurrency, _NativeCurrency);
  var _super = _createSuper$a(MaticNativeCurrency);
  function MaticNativeCurrency(chainId) {
    _classCallCheck(this, MaticNativeCurrency);
    if (!isMatic(chainId)) throw new Error('Not matic');
    return _super.call(this, chainId, 18, 'MATIC', 'Polygon Matic');
  }
  _createClass(MaticNativeCurrency, [{
    key: "equals",
    value: function equals(other) {
      return other.isNative && other.chainId === this.chainId;
    }
  }, {
    key: "wrapped",
    get: function get() {
      if (!isMatic(this.chainId)) throw new Error('Not matic');
      var wrapped = WRAPPED_NATIVE_CURRENCY[this.chainId];
      if (!wrapped) throw new Error('WRAPPED_NATIVE_CURRENCY error ');
      return wrapped;
    }
  }]);
  return MaticNativeCurrency;
}(NativeCurrency);
var ExtendedEther = /*#__PURE__*/function (_Ether) {
  _inherits(ExtendedEther, _Ether);
  var _super2 = _createSuper$a(ExtendedEther);
  function ExtendedEther() {
    _classCallCheck(this, ExtendedEther);
    return _super2.apply(this, arguments);
  }
  _createClass(ExtendedEther, [{
    key: "wrapped",
    get: function get() {
      var wrapped = WRAPPED_NATIVE_CURRENCY[this.chainId];
      if (wrapped) return wrapped;
      throw new Error('Unsupported chain ID');
    }
  }], [{
    key: "onChain",
    value: function onChain(chainId) {
      var _this$_cachedExtended;
      return (_this$_cachedExtended = this._cachedExtendedEther[chainId]) !== null && _this$_cachedExtended !== void 0 ? _this$_cachedExtended : this._cachedExtendedEther[chainId] = new ExtendedEther(chainId);
    }
  }]);
  return ExtendedEther;
}(Ether);
_defineProperty(ExtendedEther, "_cachedExtendedEther", {});
var cachedNativeCurrency = {};
function nativeOnChain(chainId) {
  var _cachedNativeCurrency;
  return (_cachedNativeCurrency = cachedNativeCurrency[chainId]) !== null && _cachedNativeCurrency !== void 0 ? _cachedNativeCurrency : cachedNativeCurrency[chainId] = isMatic(chainId) ? new MaticNativeCurrency(chainId) : ExtendedEther.onChain(chainId);
}
({
  USDC: (_USDC2 = {}, _defineProperty(_USDC2, SupportedChainId.MAINNET, USDC_MAINNET.address), _defineProperty(_USDC2, SupportedChainId.ARBITRUM_ONE, USDC_ARBITRUM.address), _defineProperty(_USDC2, SupportedChainId.OPTIMISM, USDC_OPTIMISM.address), _defineProperty(_USDC2, SupportedChainId.ARBITRUM_RINKEBY, USDC_ARBITRUM_RINKEBY.address), _defineProperty(_USDC2, SupportedChainId.OPTIMISTIC_KOVAN, USDC_OPTIMISTIC_KOVAN.address), _defineProperty(_USDC2, SupportedChainId.POLYGON, USDC_POLYGON.address), _defineProperty(_USDC2, SupportedChainId.POLYGON_MUMBAI, USDC_POLYGON_MUMBAI.address), _defineProperty(_USDC2, SupportedChainId.GOERLI, USDC_GOERLI.address), _defineProperty(_USDC2, SupportedChainId.RINKEBY, USDC_RINKEBY.address), _defineProperty(_USDC2, SupportedChainId.KOVAN, USDC_KOVAN.address), _defineProperty(_USDC2, SupportedChainId.ROPSTEN, USDC_ROPSTEN.address), _USDC2)
});

// "address": "0x1757f2E7BEE5abE1A79532000d05e32D90dD79fF",
// "chainId": 421613,

var ETH = function ETH(_ref2) {
  var chainId = _ref2.chainId;
  return WETH9[chainId];
};

/* eslint-disable no-restricted-imports */
var RemoveLiquidityETH$1 = createPlugin({
  protocol: 'UNISWAP',
  type: 'ACTION',
  method: 'removeLiquidityETH',
  description: 'Remove liquidity on Uniswap',
  supportedContracts: ROUTER_V2_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        // value: new FctValue({ destination: 'wei_amount' }),
        methodParams: {
          token: new FctAddress({
            destination: 'erc20',
            options: getSupportedTokens({
              chainId: chainId
            })
          }),
          liquidity: new FctValue({
            destination: 'wei_amount'
          }),
          amountTokenMin: new FctValue({
            destination: 'wei_amount',
            risk: amountOutMinRisk
          }),
          amountETHMin: new FctValue({
            destination: 'wei_amount',
            risk: amountOutMinRisk
          }),
          to: new FctAddress({}),
          deadline: new FctTimestamp({})
        }
      },
      output: {
        amountA: new FctValue({
          destination: 'wei_amount',
          innerIndex: 0
        }),
        amountB: new FctValue({
          destination: 'wei_amount',
          innerIndex: 1
        })
      }
    };
  },
  initParams: {
    methodParams: {
      amountTokenMin: '0',
      amountETHMin: '0',
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  },
  requiredApprovals: function requiredApprovals(params, chainId) {
    var token0 = ETH({
      chainId: Number(chainId) || 1
    }).address;
    var token1 = params === null || params === void 0 ? void 0 : params.methodParams.token.value;
    var getToken = function getToken() {
      if (token0 && typeof token0 === 'string' && token1 && typeof token1 === 'string') {
        var pairAddress = getCreate2Address(FACTORY_ADDRESS_MAP[Number(chainId)], keccak256(['bytes'], [pack(['address', 'address'], token0 < token1 ? [token0, token1] : [token1, token0])]), INIT_CODE_HASH);
        return pairAddress;
      }
      return undefined;
    };
    return [{
      to: getToken(),
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.liquidity.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

/* eslint-disable no-restricted-imports */
var UniswapV2SwapETHForExactTokens = createPlugin({
  protocol: 'UNISWAP',
  type: 'ACTION',
  method: 'swapETHForExactTokens',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        value: new FctValue({
          destination: 'wei_amount'
        }),
        methodParams: {
          amountOut: new FctValue({
            destination: 'wei_amount'
          }),
          path: new FctAddressList({
            destination: 'ERC20_List',
            options: getAllCurrencies({
              chainId: chainId
            })
          }),
          to: new FctAddress({}),
          deadline: new FctTimestamp({})
        }
      },
      output: {
        amountIn: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2,
          innerType: 'uint256[]'
        }),
        amountOut: new FctValue({
          destination: 'wei_amount',
          innerIndex: -1,
          innerType: 'uint256[]'
        })
      }
    };
  },
  supportedContracts: ROUTER_V2_ADDRESSES,
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  }
});

/* eslint-disable no-restricted-imports */
var UniswapV2SwapExactETHForTokens = createPlugin({
  protocol: 'UNISWAP',
  type: 'ACTION',
  method: 'swapExactETHForTokens',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        value: new FctValue({
          destination: 'wei_amount'
        }),
        methodParams: {
          amountOutMin: new FctValue({
            destination: 'wei_amount',
            risk: amountOutMinRisk
          }),
          path: new FctAddressList({
            destination: 'ERC20_List',
            options: getAllCurrencies({
              chainId: chainId
            })
          }),
          to: new FctAddress({}),
          deadline: new FctTimestamp({})
        }
      },
      output: {
        amountIn: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2,
          innerType: 'uint256[]'
        }),
        amountOut: new FctValue({
          destination: 'wei_amount',
          innerIndex: -1,
          innerType: 'uint256[]'
        })
      }
    };
  },
  supportedContracts: ROUTER_V2_ADDRESSES,
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  }
});

/* eslint-disable no-restricted-imports */
var UniswapV2SwapExactTokensForETH = createPlugin({
  protocol: 'UNISWAP',
  type: 'ACTION',
  method: 'swapExactTokensForETH',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        methodParams: {
          amountIn: new FctValue({
            destination: 'wei_amount'
          }),
          amountOutMin: new FctValue({
            destination: 'wei_amount',
            risk: amountOutMinRisk
          }),
          path: new FctAddressList({
            destination: 'ERC20_List',
            options: getAllCurrencies({
              chainId: chainId
            })
          }),
          to: new FctAddress({}),
          deadline: new FctTimestamp({})
        }
      },
      output: {
        amountIn: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2,
          innerType: 'uint256[]'
        }),
        amountOut: new FctValue({
          destination: 'wei_amount',
          innerIndex: -1,
          innerType: 'uint256[]'
        })
      }
    };
  },
  supportedContracts: ROUTER_V2_ADDRESSES,
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  },
  requiredApprovals: function requiredApprovals(params) {
    var token = params !== null && params !== void 0 && params.methodParams.path.value && Array.isArray(params === null || params === void 0 ? void 0 : params.methodParams.path.value) ? params === null || params === void 0 ? void 0 : params.methodParams.path.value[0] : undefined;
    return [{
      to: token,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amountIn.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

/* eslint-disable no-restricted-imports */
var UniswapV2SwapTokensForExactETH = createPlugin({
  protocol: 'UNISWAP',
  type: 'ACTION',
  method: 'swapTokensForExactETH',
  supportedContracts: ROUTER_V2_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        methodParams: {
          amountOut: new FctValue({
            destination: 'wei_amount'
          }),
          amountInMax: new FctValue({
            destination: 'wei_amount'
          }),
          path: new FctAddressList({
            destination: 'ERC20_List',
            options: getAllCurrencies({
              chainId: chainId
            })
          }),
          to: new FctAddress({}),
          deadline: new FctTimestamp({})
        }
      },
      output: {
        amountIn: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2,
          innerType: 'uint256[]'
        }),
        amountOut: new FctValue({
          destination: 'wei_amount',
          innerIndex: -1,
          innerType: 'uint256[]'
        })
      }
    };
  },
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  },
  requiredApprovals: function requiredApprovals(params) {
    var token = params !== null && params !== void 0 && params.methodParams.path.value && Array.isArray(params === null || params === void 0 ? void 0 : params.methodParams.path.value) ? params === null || params === void 0 ? void 0 : params.methodParams.path.value[0] : undefined;
    return [{
      to: token,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amountInMax.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

/* eslint-disable no-restricted-imports */
var RemoveLiquidity$1 = createPlugin({
  protocol: 'UNISWAP',
  type: 'ACTION',
  method: 'removeLiquidity',
  description: 'Remove liquidity on Sushiswap',
  supportedContracts: ROUTER_V2_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        methodParams: {
          tokenA: new FctAddress({
            destination: 'erc20',
            options: getSupportedTokens({
              chainId: chainId
            })
          }),
          tokenB: new FctAddress({
            destination: 'erc20',
            options: getSupportedTokens({
              chainId: chainId
            })
          }),
          liquidity: new FctValue({
            destination: 'wei_amount'
          }),
          amountAMin: new FctValue({
            destination: 'wei_amount',
            risk: amountOutMinRisk
          }),
          amountBMin: new FctValue({
            destination: 'wei_amount',
            risk: amountOutMinRisk
          }),
          to: new FctAddress({}),
          deadline: new FctTimestamp({})
        }
      },
      output: {
        amountA: new FctValue({
          destination: 'wei_amount',
          innerIndex: 0
        }),
        amountB: new FctValue({
          destination: 'wei_amount',
          innerIndex: 1
        })
      }
    };
  },
  initParams: {
    methodParams: {
      amountAMin: '0',
      amountBMin: '0',
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  },
  requiredApprovals: function requiredApprovals(params, chainId) {
    var token0 = params === null || params === void 0 ? void 0 : params.methodParams.tokenA.value;
    var token1 = params === null || params === void 0 ? void 0 : params.methodParams.tokenB.value;
    var getToken = function getToken() {
      if (token0 && typeof token0 === 'string' && token1 && typeof token1 === 'string') {
        var pairAddress = getCreate2Address(FACTORY_ADDRESS_MAP[chainId], keccak256(['bytes'], [pack(['address', 'address'], token0 < token1 ? [token0, token1] : [token1, token0])]), INIT_CODE_HASH);
        return pairAddress;
      }
      return undefined;
    };
    return [{
      to: getToken(),
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.liquidity.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var getToken$3 = function getToken(swapToken, chainId) {
  switch (swapToken.address) {
    case '0x0000000000000000000000000000000000000000':
      return Ether.onChain(chainId);
    case '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee':
      return Ether.onChain(chainId);
    case 'NATIVE':
      return Ether.onChain(chainId);
    default:
      return new Token(chainId, getAddress(swapToken.address), swapToken.decimals);
  }
};
var getIsNative = function getIsNative(address) {
  switch (address.toLowerCase()) {
    case '0x0000000000000000000000000000000000000000':
      return true;
    case '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee':
      return true;
    case 'NATIVE':
      return true;
    default:
      return false;
  }
};

var SimpleRemoveLiquidity = createPlugin({
  protocol: 'UNISWAP',
  type: 'ACTION',
  method: 'simpleRemoveLiquidity',
  description: 'Remove liquidity from Uniswap',
  supportedContracts: ROUTER_V2_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        methodParams: {
          tokenA: new FctAddress({
            destination: 'erc20',
            options: getAllCurrencies({
              chainId: chainId
            })
          }),
          tokenB: new FctAddress({
            destination: 'erc20',
            options: getSupportedTokens({
              chainId: chainId
            })
          }),
          liquidity: new FctValue({
            destination: 'wei_amount'
          }),
          to: new FctAddress({}),
          deadline: new FctTimestamp({})
        }
      },
      output: {
        amountA: new FctValue({
          destination: 'wei_amount',
          innerIndex: 0
        }),
        amountB: new FctValue({
          destination: 'wei_amount',
          innerIndex: 1
        })
      }
    };
  },
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  },
  getParamsOnCreate: function () {
    var _getParamsOnCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var chainId, params, _params$methodParams, to, deadline, tokenA, tokenB, liquidity, requiredParamsExact, _i, _requiredParamsExact, param, requiredParams, _i2, _requiredParams, _param, isCurrencyANative, isCurrencyBNative, _plugin, plugin;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            chainId = _ref2.chainId, params = _ref2.params;
            _params$methodParams = params.methodParams, to = _params$methodParams.to, deadline = _params$methodParams.deadline, tokenA = _params$methodParams.tokenA, tokenB = _params$methodParams.tokenB, liquidity = _params$methodParams.liquidity;
            requiredParamsExact = [{
              value: tokenA.value,
              key: 'tokenA'
            }, {
              value: tokenB.value,
              key: 'tokenB'
            }, {
              value: to.value,
              key: 'to'
            }];
            _i = 0, _requiredParamsExact = requiredParamsExact;
          case 4:
            if (!(_i < _requiredParamsExact.length)) {
              _context.next = 15;
              break;
            }
            param = _requiredParamsExact[_i];
            if (param.value) {
              _context.next = 9;
              break;
            }
            console.error("wrong param ".concat(param.key, ": ").concat(param.value));
            return _context.abrupt("return");
          case 9:
            if (!(typeof param.value !== 'string')) {
              _context.next = 12;
              break;
            }
            console.error("wrong param ".concat(param.key, ": should be a string"));
            return _context.abrupt("return");
          case 12:
            _i++;
            _context.next = 4;
            break;
          case 15:
            requiredParams = [{
              value: to.value,
              key: 'to'
            }];
            _i2 = 0, _requiredParams = requiredParams;
          case 17:
            if (!(_i2 < _requiredParams.length)) {
              _context.next = 25;
              break;
            }
            _param = _requiredParams[_i2];
            if (_param.value) {
              _context.next = 22;
              break;
            }
            console.error("wrong param ".concat(_param.key, ": ").concat(_param.value));
            return _context.abrupt("return");
          case 22:
            _i2++;
            _context.next = 17;
            break;
          case 25:
            isCurrencyANative = getIsNative(tokenA.value);
            isCurrencyBNative = getIsNative(tokenB.value);
            if (!isCurrencyBNative) {
              _context.next = 30;
              break;
            }
            console.error("wrong param currencyB: ".concat(tokenB.value));
            return _context.abrupt("return");
          case 30:
            if (!isCurrencyANative) {
              _context.next = 33;
              break;
            }
            _plugin = new RemoveLiquidityETH$1({
              chainId: chainId,
              initParams: {
                to: params.to.value,
                methodParams: {
                  token: tokenB.value,
                  liquidity: liquidity.value,
                  amountTokenMin: '0',
                  amountETHMin: '0',
                  to: to.value,
                  deadline: deadline.value
                }
              }
            });
            return _context.abrupt("return", {
              plugin: _plugin,
              params: _plugin.input.params,
              method: _plugin.method,
              gasLimit: _plugin.gasLimit
            });
          case 33:
            plugin = new RemoveLiquidity$1({
              chainId: chainId,
              initParams: {
                to: params.to.value,
                methodParams: {
                  tokenA: tokenA.value,
                  tokenB: tokenB.value,
                  liquidity: liquidity.value,
                  amountAMin: '0',
                  amountBMin: '0',
                  to: to.value,
                  deadline: deadline.value
                }
              }
            });
            return _context.abrupt("return", {
              plugin: plugin,
              params: plugin.input.params,
              method: plugin.method,
              gasLimit: plugin.gasLimit
            });
          case 35:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function getParamsOnCreate(_x) {
      return _getParamsOnCreate.apply(this, arguments);
    }
    return getParamsOnCreate;
  }(),
  requiredApprovals: function requiredApprovals(params, chainId) {
    var currencyA = params === null || params === void 0 ? void 0 : params.methodParams.tokenA.value;
    var token0 = getIsNative(currencyA) ? ETH({
      chainId: Number(chainId) || 1
    }).address : currencyA;
    var token1 = params === null || params === void 0 ? void 0 : params.methodParams.tokenB.value;
    console.log({
      token0: token0,
      isNative: getIsNative(currencyA),
      currencyA: currencyA
    });
    var getToken = function getToken() {
      if (token0 && typeof token0 === 'string' && token1 && typeof token1 === 'string') {
        var pairAddress = getCreate2Address(FACTORY_ADDRESS_MAP[Number(chainId)], keccak256(['bytes'], [pack(['address', 'address'], token0 < token1 ? [token0, token1] : [token1, token0])]), INIT_CODE_HASH);
        return pairAddress;
      }
      return undefined;
    };
    return [{
      to: getToken(),
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.liquidity.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var isV3SingleInput = function isV3SingleInput(params) {
  var _ref;
  return (_ref = params && 'params_tuple' in params && 'sqrtPriceLimitX96' in params['params_tuple']) !== null && _ref !== void 0 ? _ref : false;
};
var getMethodName = function getMethodName(_ref2) {
  var isExactInput = _ref2.isExactInput,
    isInputNative = _ref2.isInputNative,
    isOutputNative = _ref2.isOutputNative,
    protocol = _ref2.protocol,
    params = _ref2.params;
  if (protocol === 'V2') {
    if (isExactInput) {
      if (isInputNative) {
        return 'swapExactETHForTokens';
      }
      if (isOutputNative) {
        return 'swapExactTokensForETH';
      }
      return 'swapExactTokensForTokens';
    }
    if (isInputNative) {
      return 'swapETHForExactTokens';
    }
    if (isOutputNative) {
      return 'swapTokensForExactETH';
    }
    return 'swapTokensForExactTokens';
  }
  if (protocol === 'V3') {
    if (isExactInput) {
      // Only "single" methods have this param
      if (isV3SingleInput(params)) {
        return 'exactInputSingle';
      }
      return 'exactInput';
    }
    if (isV3SingleInput(params)) {
      return 'exactOutputSingle';
    }
    return 'exactOutput';
  }
  throw new Error('Invalid protocol');
};

/* eslint-disable no-restricted-imports */
var params$3 = {
  input: {
    to: new FctAddress({
      destination: 'sushiswap_router'
    }),
    methodParams: {
      tokenA: new FctAddress({
        destination: 'erc20'
      }),
      tokenB: new FctAddress({
        destination: 'erc20'
      }),
      amountADesired: new FctValue({
        destination: 'wei_amount'
      }),
      amountBDesired: new FctValue({
        destination: 'wei_amount'
      }),
      amountAMin: new FctValue({
        destination: 'wei_amount'
      }),
      amountBMin: new FctValue({
        destination: 'wei_amount'
      }),
      to: new FctAddress({}),
      deadline: new FctTimestamp({})
    }
  },
  output: {
    amountA: new FctValue({
      innerIndex: 0
    }),
    amountB: new FctValue({
      innerIndex: 1
    }),
    liquidity: new FctValue({
      innerIndex: 2
    })
  }
};
var AddLiquidity$1 = createPlugin({
  protocol: 'SUSHISWAP',
  type: 'ACTION',
  method: 'addLiquidity',
  description: 'Add liquidity on Sushiswap',
  supportedContracts: ROUTER_ADDRESSES,
  getParams: function getParams() {
    return params$3;
  },
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  },
  requiredApprovals: function requiredApprovals(params) {
    return [{
      to: params.methodParams.tokenA.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amountADesired.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }, {
      to: params.methodParams.tokenB.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amountBDesired.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

/* eslint-disable no-restricted-imports */
var params$2 = {
  input: {
    to: new FctAddress({
      destination: 'sushiswap_router'
    }),
    value: new FctValue({
      destination: 'wei_amount'
    }),
    methodParams: {
      token: new FctAddress({
        destination: 'erc20'
      }),
      amountTokenDesired: new FctValue({
        destination: 'wei_amount'
      }),
      amountTokenMin: new FctValue({
        destination: 'wei_amount'
      }),
      amountETHMin: new FctValue({
        destination: 'wei_amount'
      }),
      to: new FctAddress({}),
      deadline: new FctTimestamp({})
    }
  },
  output: {
    amountA: new FctValue({
      innerIndex: 0,
      destination: 'wei_amount'
    }),
    amountB: new FctValue({
      innerIndex: 1,
      destination: 'wei_amount'
    }),
    liquidity: new FctValue({
      innerIndex: 2,
      destination: 'wei_amount'
    })
  }
};
var AddLiquidityETH = createPlugin({
  protocol: 'SUSHISWAP',
  type: 'ACTION',
  method: 'addLiquidityETH',
  description: 'Add liquidity on Sushiswap',
  supportedContracts: ROUTER_ADDRESSES,
  getParams: function getParams() {
    return params$2;
  },
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  },
  requiredApprovals: function requiredApprovals(params) {
    return [{
      to: params === null || params === void 0 ? void 0 : params.methodParams.token.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amountTokenDesired.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

/* eslint-disable no-restricted-imports */
var params$1 = {
  input: {
    to: new FctAddress({
      destination: 'sushiswap_router'
    }),
    methodParams: {
      token: new FctAddress({
        destination: 'erc20'
      }),
      liquidity: new FctValue({
        destination: 'wei_amount'
      }),
      amountTokenMin: new FctValue({
        destination: 'wei_amount'
      }),
      amountETHMin: new FctValue({
        destination: 'wei_amount'
      }),
      to: new FctAddress({}),
      deadline: new FctTimestamp({})
    }
  },
  output: {
    amountA: new FctValue({
      innerIndex: 0,
      destination: 'wei_amount'
    }),
    amountB: new FctValue({
      innerIndex: 1,
      destination: 'wei_amount'
    })
  }
};
var RemoveLiquidityETH = createPlugin({
  protocol: 'SUSHISWAP',
  type: 'ACTION',
  method: 'removeLiquidityETH',
  description: 'Remove liquidity on Sushiswap',
  supportedContracts: ROUTER_ADDRESSES,
  getParams: function getParams() {
    return params$1;
  },
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  },
  requiredApprovals: function requiredApprovals(params, chainId) {
    var token0 = '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2';
    var token1 = params === null || params === void 0 ? void 0 : params.methodParams.token.value;
    var getToken = function getToken() {
      if (token1 && typeof token1 === 'string') {
        var pairAddress = getCreate2Address$1(FACTORY_ADDRESS$2[chainId], keccak256(['bytes'], [pack(['address', 'address'], token0 < token1 ? [token0, token1] : [token1, token0])]), INIT_CODE_HASH$1[chainId]);
        return pairAddress;
      }
      return undefined;
    };
    return [{
      to: getToken(),
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.liquidity.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

function ownKeys$p(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$p(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$p(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$p(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SwapExactETHForTokens = createPlugin({
  protocol: 'SUSHISWAP',
  type: 'ACTION',
  method: 'swapExactETHForTokens',
  getParams: function getParams() {
    return _objectSpread$p(_objectSpread$p({}, swapExactEthForTokensParams), {}, {
      to: new FctAddress({
        destination: 'sushiswap_router'
      })
    });
  },
  supportedContracts: ROUTER_ADDRESSES,
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  }
});

function ownKeys$o(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$o(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$o(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$o(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SwapExactTokensForETH = createPlugin({
  protocol: 'SUSHISWAP',
  type: 'ACTION',
  method: 'swapExactTokensForETH',
  getParams: function getParams() {
    return _objectSpread$o(_objectSpread$o({}, swapExactTokensForEthParams), {}, {
      to: new FctAddress({
        destination: 'sushiswap_router'
      })
    });
  },
  supportedContracts: ROUTER_ADDRESSES,
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  },
  requiredApprovals: function requiredApprovals(params) {
    var token = params !== null && params !== void 0 && params.methodParams.path.value && Array.isArray(params === null || params === void 0 ? void 0 : params.methodParams.path.value) ? params === null || params === void 0 ? void 0 : params.methodParams.path.value[0] : undefined;
    return [{
      to: token,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amountIn.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

/* eslint-disable no-restricted-imports */
var params = {
  input: {
    to: new FctAddress({
      destination: 'sushiswap_router'
    }),
    methodParams: {
      tokenA: new FctAddress({
        destination: 'erc20'
      }),
      tokenB: new FctAddress({
        destination: 'erc20'
      }),
      liquidity: new FctValue({
        destination: 'wei_amount'
      }),
      amountAMin: new FctValue({
        destination: 'wei_amount'
      }),
      amountBMin: new FctValue({
        destination: 'wei_amount'
      }),
      to: new FctAddress({}),
      deadline: new FctTimestamp({})
    }
  },
  output: {
    amountA: new FctValue({
      innerIndex: 0,
      destination: 'wei_amount'
    }),
    amountB: new FctValue({
      innerIndex: 1,
      destination: 'wei_amount'
    })
  }
};
var RemoveLiquidity = createPlugin({
  protocol: 'SUSHISWAP',
  type: 'ACTION',
  method: 'removeLiquidity',
  description: 'Remove liquidity on Sushiswap',
  supportedContracts: ROUTER_ADDRESSES,
  getParams: function getParams() {
    return params;
  },
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  },
  requiredApprovals: function requiredApprovals(params, chainId) {
    var token0 = params === null || params === void 0 ? void 0 : params.methodParams.tokenA.value;
    var token1 = params === null || params === void 0 ? void 0 : params.methodParams.tokenB.value;
    var getToken = function getToken() {
      if (token0 && typeof token0 === 'string' && token1 && typeof token1 === 'string') {
        var pairAddress = getCreate2Address$1(FACTORY_ADDRESS$2[chainId], keccak256(['bytes'], [pack(['address', 'address'], token0 < token1 ? [token0, token1] : [token1, token0])]), INIT_CODE_HASH$1[chainId]);
        return pairAddress;
      }
      return undefined;
    };
    return [{
      to: getToken(),
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.liquidity.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var getToken$2 = function getToken(swapToken, chainId) {
  switch (swapToken.address) {
    case '0x0000000000000000000000000000000000000000':
      return Ether$1.onChain(chainId);
    case '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee':
      return Ether$1.onChain(chainId);
    case 'NATIVE':
      return Ether$1.onChain(chainId);
    default:
      return new Token$1(chainId, getAddress(swapToken.address), swapToken.decimals);
  }
};

function ownKeys$n(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$n(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$n(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$n(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SwapExactTokensForTokens = createPlugin({
  protocol: 'SUSHISWAP',
  type: 'ACTION',
  method: 'swapExactTokensForTokens',
  getParams: function getParams() {
    return _objectSpread$n(_objectSpread$n({}, swapExactTokensForTokensParams), {}, {
      to: new FctAddress({
        destination: 'sushiswap_router'
      })
    });
  },
  supportedContracts: ROUTER_ADDRESSES,
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  },
  requiredApprovals: function requiredApprovals(params) {
    var token = params !== null && params !== void 0 && params.methodParams.path.value && Array.isArray(params === null || params === void 0 ? void 0 : params.methodParams.path.value) ? params === null || params === void 0 ? void 0 : params.methodParams.path.value[0] : undefined;
    return [{
      to: token,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amountIn.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var SimpleSwap$1 = createPlugin({
  protocol: 'SUSHISWAP',
  type: 'ACTION',
  method: 'simpleSwap',
  name: 'swap',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        methodParams: {
          addressIn: new FctAddress({
            options: getAllCurrencies({
              chainId: chainId
            }),
            destination: 'erc20'
          }),
          amountIn: new FctValue({
            destination: 'wei_amount'
          }),
          decimalsIn: new FctDecimals({
            destination: 'wei_amount'
          }),
          addressOut: new FctAddress({
            options: getAllCurrencies({
              chainId: chainId
            }),
            destination: 'erc20'
          }),
          amountOut: new FctValue({
            destination: 'wei_amount',
            risk: amountOutMinRisk
          }),
          decimalsOut: new FctDecimals({
            destination: 'wei_amount'
          }),
          path: new FctAddressList({
            destination: 'ERC20_List',
            options: getAllCurrencies({
              chainId: chainId
            })
          }),
          to: new FctAddress({}),
          deadline: new FctTimestamp({})
        }
      },
      output: {
        amountIn: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2
        }),
        amountOut: new FctValue({
          destination: 'wei_amount',
          innerIndex: -1
        })
      }
    };
  },
  getParamsOnCreate: function () {
    var _getParamsOnCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var chainId, params, _params$methodParams, to, deadline, path, _params$methodParams2, addressIn, amountIn, decimalsIn, _params$methodParams3, addressOut, decimalsOut, amountOut, requiredParams, _i, _requiredParams, param, inputToken, outputToken, _plugin, _plugin2, plugin;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            chainId = _ref2.chainId, params = _ref2.params;
            _params$methodParams = params.methodParams, to = _params$methodParams.to, deadline = _params$methodParams.deadline;
            path = params.methodParams.path;
            _params$methodParams2 = params.methodParams, addressIn = _params$methodParams2.addressIn, amountIn = _params$methodParams2.amountIn, decimalsIn = _params$methodParams2.decimalsIn;
            _params$methodParams3 = params.methodParams, addressOut = _params$methodParams3.addressOut, decimalsOut = _params$methodParams3.decimalsOut, amountOut = _params$methodParams3.amountOut;
            requiredParams = [{
              value: addressIn.value,
              key: 'addressIn'
            }, {
              value: decimalsIn.value,
              key: 'decimalsIn'
            }, {
              value: amountOut.value,
              key: 'amountOut'
            }, {
              value: decimalsOut.value,
              key: 'decimalsOut'
            }, {
              value: to.value,
              key: 'to'
            }];
            _i = 0, _requiredParams = requiredParams;
          case 7:
            if (!(_i < _requiredParams.length)) {
              _context.next = 18;
              break;
            }
            param = _requiredParams[_i];
            if (param.value) {
              _context.next = 12;
              break;
            }
            console.error("wrong param ".concat(param.key, ": ").concat(param.value));
            return _context.abrupt("return");
          case 12:
            if (!(typeof param.value !== 'string')) {
              _context.next = 15;
              break;
            }
            console.error("wrong param ".concat(param.key, ": should be a string"));
            return _context.abrupt("return");
          case 15:
            _i++;
            _context.next = 7;
            break;
          case 18:
            if (path.value) {
              _context.next = 21;
              break;
            }
            console.error("wrong param path: ".concat(path.value));
            return _context.abrupt("return");
          case 21:
            if (!(!Array.isArray(path.value) || typeof path.value[0] !== 'string')) {
              _context.next = 24;
              break;
            }
            console.error("wrong param path: should be an array of strings");
            return _context.abrupt("return");
          case 24:
            if (amountIn.value) {
              _context.next = 27;
              break;
            }
            console.error("wrong param amountIn: ".concat(amountIn.value));
            return _context.abrupt("return");
          case 27:
            inputToken = getToken$2({
              address: addressIn.value,
              decimals: Number(decimalsIn.value)
            }, Number(chainId));
            outputToken = getToken$2({
              address: addressOut.value,
              decimals: Number(decimalsOut.value)
            }, Number(chainId));
            if (!inputToken.isNative) {
              _context.next = 32;
              break;
            }
            _plugin = new SwapExactETHForTokens({
              chainId: chainId,
              initParams: {
                to: params.to.value,
                value: amountIn.value,
                methodParams: {
                  amountOutMin: amountOut.value,
                  path: path.value,
                  to: to.value,
                  deadline: deadline.value
                }
              }
            });
            return _context.abrupt("return", {
              params: _plugin.input.params,
              method: _plugin.method,
              gasLimit: _plugin.gasLimit
            });
          case 32:
            if (!outputToken.isNative) {
              _context.next = 35;
              break;
            }
            _plugin2 = new SwapExactTokensForETH({
              chainId: chainId,
              initParams: {
                to: params.to.value,
                methodParams: {
                  amountIn: amountIn.value,
                  amountOutMin: amountOut.value,
                  path: path.value,
                  to: to.value,
                  deadline: deadline.value
                }
              }
            });
            return _context.abrupt("return", {
              params: _plugin2.input.params,
              method: _plugin2.method,
              gasLimit: _plugin2.gasLimit
            });
          case 35:
            plugin = new SwapExactTokensForTokens({
              chainId: chainId,
              initParams: {
                to: params.to.value,
                methodParams: {
                  amountIn: amountIn.value,
                  amountOutMin: amountOut.value,
                  path: path.value,
                  to: to.value,
                  deadline: deadline.value
                }
              }
            });
            return _context.abrupt("return", {
              params: plugin.input.params,
              method: plugin.method,
              gasLimit: plugin.gasLimit
            });
          case 37:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function getParamsOnCreate(_x) {
      return _getParamsOnCreate.apply(this, arguments);
    }
    return getParamsOnCreate;
  }(),
  supportedContracts: ROUTER_ADDRESSES,
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  }
});

var GetAmountsIn$1 = createPlugin({
  protocol: 'SUSHISWAP',
  type: 'GETTER',
  method: 'getAmountsIn',
  supportedContracts: ROUTER_ADDRESSES,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        methodParams: {
          amountOut: new FctValue({}),
          path: new FctAddressList({})
        }
      },
      output: {
        amountIn: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2
        }),
        amountOut: new FctValue({
          destination: 'wei_amount',
          innerIndex: -1
        })
      }
    };
  }
});

var GetAmountsOut$1 = createPlugin({
  protocol: 'SUSHISWAP',
  type: 'GETTER',
  method: 'getAmountsOut',
  supportedContracts: ROUTER_ADDRESSES,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        methodParams: {
          amountIn: new FctValue({}),
          path: new FctAddressList({})
        }
      },
      output: {
        amountIn: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2
        }),
        amountOut: new FctValue({
          destination: 'wei_amount',
          innerIndex: -1
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var actions$n = {
  SwapExactTokensForTokens: SwapExactTokensForTokens,
  SwapExactETHForTokens: SwapExactETHForTokens,
  SwapExactTokensForETH: SwapExactTokensForETH,
  SimpleSwap: SimpleSwap$1,
  AddLiquidity: AddLiquidity$1,
  RemoveLiquidity: RemoveLiquidity,
  AddLiquidityETH: AddLiquidityETH,
  RemoveLiquidityETH: RemoveLiquidityETH
};
var getters$k = {
  GetAmountsOut: GetAmountsOut$1,
  GetAmountsIn: GetAmountsIn$1
};
var Sushiswap$1 = {
  actions: actions$n,
  getters: getters$k
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

(function (global, undefined$1) {

  if (global.setImmediate) {
    return;
  }
  var nextHandle = 1; // Spec says greater than zero
  var tasksByHandle = {};
  var currentlyRunningATask = false;
  var doc = global.document;
  var registerImmediate;
  function setImmediate(callback) {
    // Callback can either be a function or a string
    if (typeof callback !== "function") {
      callback = new Function("" + callback);
    }
    // Copy function arguments
    var args = new Array(arguments.length - 1);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i + 1];
    }
    // Store and register the task
    var task = {
      callback: callback,
      args: args
    };
    tasksByHandle[nextHandle] = task;
    registerImmediate(nextHandle);
    return nextHandle++;
  }
  function clearImmediate(handle) {
    delete tasksByHandle[handle];
  }
  function run(task) {
    var callback = task.callback;
    var args = task.args;
    switch (args.length) {
      case 0:
        callback();
        break;
      case 1:
        callback(args[0]);
        break;
      case 2:
        callback(args[0], args[1]);
        break;
      case 3:
        callback(args[0], args[1], args[2]);
        break;
      default:
        callback.apply(undefined$1, args);
        break;
    }
  }
  function runIfPresent(handle) {
    // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
    // So if we're currently running a task, we'll need to delay this invocation.
    if (currentlyRunningATask) {
      // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
      // "too much recursion" error.
      setTimeout(runIfPresent, 0, handle);
    } else {
      var task = tasksByHandle[handle];
      if (task) {
        currentlyRunningATask = true;
        try {
          run(task);
        } finally {
          clearImmediate(handle);
          currentlyRunningATask = false;
        }
      }
    }
  }
  function installNextTickImplementation() {
    registerImmediate = function registerImmediate(handle) {
      process.nextTick(function () {
        runIfPresent(handle);
      });
    };
  }
  function canUsePostMessage() {
    // The test against `importScripts` prevents this implementation from being installed inside a web worker,
    // where `global.postMessage` means something completely different and can't be used for this purpose.
    if (global.postMessage && !global.importScripts) {
      var postMessageIsAsynchronous = true;
      var oldOnMessage = global.onmessage;
      global.onmessage = function () {
        postMessageIsAsynchronous = false;
      };
      global.postMessage("", "*");
      global.onmessage = oldOnMessage;
      return postMessageIsAsynchronous;
    }
  }
  function installPostMessageImplementation() {
    // Installs an event handler on `global` for the `message` event: see
    // * https://developer.mozilla.org/en/DOM/window.postMessage
    // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

    var messagePrefix = "setImmediate$" + Math.random() + "$";
    var onGlobalMessage = function onGlobalMessage(event) {
      if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
        runIfPresent(+event.data.slice(messagePrefix.length));
      }
    };
    if (global.addEventListener) {
      global.addEventListener("message", onGlobalMessage, false);
    } else {
      global.attachEvent("onmessage", onGlobalMessage);
    }
    registerImmediate = function registerImmediate(handle) {
      global.postMessage(messagePrefix + handle, "*");
    };
  }
  function installMessageChannelImplementation() {
    var channel = new MessageChannel();
    channel.port1.onmessage = function (event) {
      var handle = event.data;
      runIfPresent(handle);
    };
    registerImmediate = function registerImmediate(handle) {
      channel.port2.postMessage(handle);
    };
  }
  function installReadyStateChangeImplementation() {
    var html = doc.documentElement;
    registerImmediate = function registerImmediate(handle) {
      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var script = doc.createElement("script");
      script.onreadystatechange = function () {
        runIfPresent(handle);
        script.onreadystatechange = null;
        html.removeChild(script);
        script = null;
      };
      html.appendChild(script);
    };
  }
  function installSetTimeoutImplementation() {
    registerImmediate = function registerImmediate(handle) {
      setTimeout(runIfPresent, 0, handle);
    };
  }

  // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
  var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
  attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

  // Don't get fooled by e.g. browserify environments.
  if ({}.toString.call(global.process) === "[object process]") {
    // For Node.js before 0.9
    installNextTickImplementation();
  } else if (canUsePostMessage()) {
    // For non-IE10 modern browsers
    installPostMessageImplementation();
  } else if (global.MessageChannel) {
    // For web workers, where supported
    installMessageChannelImplementation();
  } else if (doc && "onreadystatechange" in doc.createElement("script")) {
    // For IE 6–8
    installReadyStateChangeImplementation();
  } else {
    // For older browsers
    installSetTimeoutImplementation();
  }
  attachTo.setImmediate = setImmediate;
  attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof commonjsGlobal === "undefined" ? commonjsGlobal : commonjsGlobal : self);

var TradeState$1 = /*#__PURE__*/function (TradeState) {
  TradeState[TradeState["LOADING"] = 0] = "LOADING";
  TradeState[TradeState["INVALID"] = 1] = "INVALID";
  TradeState[TradeState["NO_ROUTE_FOUND"] = 2] = "NO_ROUTE_FOUND";
  TradeState[TradeState["VALID"] = 3] = "VALID";
  TradeState[TradeState["SYNCING"] = 4] = "SYNCING";
  return TradeState;
}({});

function getClientSideSmartOrderRouterTrade$1(_x) {
  return _getClientSideSmartOrderRouterTrade$1.apply(this, arguments);
}
function _getClientSideSmartOrderRouterTrade$1() {
  _getClientSideSmartOrderRouterTrade$1 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var account, chainId, currencyIn, currencyOut, amount, sushiswapPair, sushiswapPairFactory, trade;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref.library, account = _ref.account, chainId = _ref.chainId, currencyIn = _ref.currencyIn, currencyOut = _ref.currencyOut, amount = _ref.amount;
          sushiswapPair = new SushiswapPair({
            fromTokenContractAddress: currencyIn,
            toTokenContractAddress: currencyOut,
            ethereumAddress: account,
            chainId: chainId,
            settings: new SushiswapPairSettings({
              slippage: 0.05
            })
          });
          _context.next = 4;
          return sushiswapPair.createFactory();
        case 4:
          sushiswapPairFactory = _context.sent;
          _context.next = 7;
          return sushiswapPairFactory.trade(amount);
        case 7:
          trade = _context.sent;
          if (!(!currencyIn || !currencyOut)) {
            _context.next = 10;
            break;
          }
          return _context.abrupt("return", {
            state: TradeState$1.INVALID,
            trade: undefined
          });
        case 10:
          if (trade) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", {
            state: TradeState$1.LOADING,
            trade: undefined
          });
        case 12:
          if (!trade) {
            _context.next = 14;
            break;
          }
          return _context.abrupt("return", {
            state: TradeState$1.VALID,
            trade: trade
          });
        case 14:
          return _context.abrupt("return", {
            state: TradeState$1.INVALID,
            trade: undefined
          });
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getClientSideSmartOrderRouterTrade$1.apply(this, arguments);
}

var FIVE_TENTHS_PERCENT$1 = new Percent(50, 10000); // .50%
var DEFAULT_AUTO_SLIPPAGE$1 = FIVE_TENTHS_PERCENT$1;
var DEFAULT_SLIPPAGE$1 = {
  auto: true,
  allowed: DEFAULT_AUTO_SLIPPAGE$1
};

/** Returns the allowed slippage, and whether it is auto-slippage. */
function getSlippage$1() {
  return DEFAULT_SLIPPAGE$1;
  // let shouldUseAutoSlippage: boolean = false;
  // selectAtom(autoSlippageAtom, (atomValue) => {
  //   shouldUseAutoSlippage = atomValue.valueOf()
  // })
  // const autoSlippage = useAutoSlippageTolerance(shouldUseAutoSlippage ? trade : undefined)
  // const maxSlippageValue = useAtomValue(maxSlippageAtom)
  // const maxSlippage = useMemo(() => toPercent(maxSlippageValue), [maxSlippageValue])
  // return useMemo(() => {
  //   const auto = shouldUseAutoSlippage || !maxSlippage
  //   const allowed = shouldUseAutoSlippage ? autoSlippage : maxSlippage ?? autoSlippage
  //   const warning = auto ? undefined : getSlippageWarning(allowed)
  //   if (auto && allowed === DEFAULT_AUTO_SLIPPAGE) {
  //     return DEFAULT_SLIPPAGE
  //   }
  //   return { auto, allowed, warning }
  // }, [autoSlippage, maxSlippage, shouldUseAutoSlippage])
}

new Percent(1, 2);
new Percent(1, 100);

var _format$1 = "hh-sol-artifact-1";
var contractName$1 = "SwapRouter";
var sourceName$1 = "contracts/SwapRouter.sol";
var abi$1 = [
	{
		inputs: [
			{
				internalType: "address",
				name: "_factory",
				type: "address"
			},
			{
				internalType: "address",
				name: "_WETH9",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
		],
		name: "WETH9",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "bytes",
						name: "path",
						type: "bytes"
					},
					{
						internalType: "address",
						name: "recipient",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "deadline",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amountIn",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amountOutMinimum",
						type: "uint256"
					}
				],
				internalType: "struct ISwapRouter.ExactInputParams",
				name: "params",
				type: "tuple"
			}
		],
		name: "exactInput",
		outputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "tokenIn",
						type: "address"
					},
					{
						internalType: "address",
						name: "tokenOut",
						type: "address"
					},
					{
						internalType: "uint24",
						name: "fee",
						type: "uint24"
					},
					{
						internalType: "address",
						name: "recipient",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "deadline",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amountIn",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amountOutMinimum",
						type: "uint256"
					},
					{
						internalType: "uint160",
						name: "sqrtPriceLimitX96",
						type: "uint160"
					}
				],
				internalType: "struct ISwapRouter.ExactInputSingleParams",
				name: "params",
				type: "tuple"
			}
		],
		name: "exactInputSingle",
		outputs: [
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "bytes",
						name: "path",
						type: "bytes"
					},
					{
						internalType: "address",
						name: "recipient",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "deadline",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amountOut",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amountInMaximum",
						type: "uint256"
					}
				],
				internalType: "struct ISwapRouter.ExactOutputParams",
				name: "params",
				type: "tuple"
			}
		],
		name: "exactOutput",
		outputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "tokenIn",
						type: "address"
					},
					{
						internalType: "address",
						name: "tokenOut",
						type: "address"
					},
					{
						internalType: "uint24",
						name: "fee",
						type: "uint24"
					},
					{
						internalType: "address",
						name: "recipient",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "deadline",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amountOut",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amountInMaximum",
						type: "uint256"
					},
					{
						internalType: "uint160",
						name: "sqrtPriceLimitX96",
						type: "uint160"
					}
				],
				internalType: "struct ISwapRouter.ExactOutputSingleParams",
				name: "params",
				type: "tuple"
			}
		],
		name: "exactOutputSingle",
		outputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "factory",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes[]",
				name: "data",
				type: "bytes[]"
			}
		],
		name: "multicall",
		outputs: [
			{
				internalType: "bytes[]",
				name: "results",
				type: "bytes[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "refundETH",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "selfPermit",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "nonce",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "expiry",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "selfPermitAllowed",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "nonce",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "expiry",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "selfPermitAllowedIfNecessary",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "deadline",
				type: "uint256"
			},
			{
				internalType: "uint8",
				name: "v",
				type: "uint8"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "s",
				type: "bytes32"
			}
		],
		name: "selfPermitIfNecessary",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amountMinimum",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			}
		],
		name: "sweepToken",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amountMinimum",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "feeBips",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "feeRecipient",
				type: "address"
			}
		],
		name: "sweepTokenWithFee",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "amount0Delta",
				type: "int256"
			},
			{
				internalType: "int256",
				name: "amount1Delta",
				type: "int256"
			},
			{
				internalType: "bytes",
				name: "_data",
				type: "bytes"
			}
		],
		name: "uniswapV3SwapCallback",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountMinimum",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			}
		],
		name: "unwrapWETH9",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountMinimum",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "feeBips",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "feeRecipient",
				type: "address"
			}
		],
		name: "unwrapWETH9WithFee",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		stateMutability: "payable",
		type: "receive"
	}
];
var bytecode$1 = "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";
var deployedBytecode$1 = "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";
var linkReferences$1 = {
};
var deployedLinkReferences$1 = {
};
var SwapRouterJSON = {
	_format: _format$1,
	contractName: contractName$1,
	sourceName: sourceName$1,
	abi: abi$1,
	bytecode: bytecode$1,
	deployedBytecode: deployedBytecode$1,
	linkReferences: linkReferences$1,
	deployedLinkReferences: deployedLinkReferences$1
};

var erc20Abi = [
	{
		constant: true,
		inputs: [
		],
		name: "name",
		outputs: [
			{
				name: "",
				type: "string"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_spender",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_from",
				type: "address"
			},
			{
				name: "_to",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				name: "",
				type: "uint8"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				name: "_owner",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				name: "balance",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: true,
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				name: "",
				type: "string"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		constant: false,
		inputs: [
			{
				name: "_to",
				type: "address"
			},
			{
				name: "_value",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				name: "",
				type: "bool"
			}
		],
		payable: false,
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		constant: true,
		inputs: [
			{
				name: "_owner",
				type: "address"
			},
			{
				name: "_spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				name: "",
				type: "uint256"
			}
		],
		payable: false,
		stateMutability: "view",
		type: "function"
	},
	{
		payable: true,
		stateMutability: "payable",
		type: "fallback"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	}
];

// returns the checksummed address if the address is valid, otherwise returns false
function isAddress(value) {
  try {
    return getAddress$1(value);
  } catch (_unused) {
    return false;
  }
}

// account is not optional
function getSigner(library, account) {
  return library.getSigner(account).connectUnchecked();
}

// account is optional
function getProviderOrSigner(library, account) {
  return account ? getSigner(library, account) : library;
}

// account is optional
function getContract$1(address, ABI, library, account) {
  if (!isAddress(address) || address === AddressZero$2) {
    throw Error("Invalid 'address' parameter '".concat(address, "'."));
  }
  return new Contract$1(address, ABI, getProviderOrSigner(library, account));
}

/* eslint-disable react/display-name */
var IUniswapV2Router02ABI$2 = IUniswapV2Router02Json.abi;
var IUniswapV3RouterABI = SwapRouterJSON.abi;

// returns null on errors
function getUniswapContract(library, account, chainId, addressOrAddressMap, ABI) {
  var withSignerIfPossible = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  return function () {
    if (!addressOrAddressMap || !ABI || !library || !chainId) return null;
    var address;
    if (typeof addressOrAddressMap === 'string') address = addressOrAddressMap;else address = addressOrAddressMap[chainId];
    if (!address) return null;
    try {
      return getContract$1(address, ABI, library, withSignerIfPossible && account ? account : undefined);
    } catch (error) {
      console.error('Failed to get contract', error);
      return null;
    }
  };
}

// export function getPairContract(pairAddress?: string, withSignerIfPossible?: boolean): Contract | null {
//   return getContract(pairAddress, IUniswapV2PairABI, withSignerIfPossible)
// }

function getV2RouterContract(library, account, chainId) {
  return getUniswapContract(library, account, chainId, V2_ROUTER_ADDRESS, IUniswapV2Router02ABI$2, true)();
}
function getV3RouterContract(library, account, chainId) {
  return getUniswapContract(library, account, chainId, V3_ROUTER_ADDRESS, IUniswapV3RouterABI, true)();
}

// export function getInterfaceMulticall() {
//   return getContract<UniswapInterfaceMulticall>(MULTICALL_ADDRESS, MulticallABI, false) as UniswapInterfaceMulticall
// }

// export function getV3NFTPositionManagerContract(withSignerIfPossible?: boolean): NonfungiblePositionManager | null {
//   return getContract<NonfungiblePositionManager>(
//     NONFUNGIBLE_POSITION_MANAGER_ADDRESSES,
//     NFTPositionManagerABI,
//     withSignerIfPossible
//   )
// }

// export function getTickLens(): TickLens | null {
//   const { chainId } = getActiveWeb3React()
//   const address = chainId ? TICK_LENS_ADDRESSES[chainId] : undefined
//   return getContract(address, TickLensABI) as TickLens | null
// }

function toHex$1(currencyAmount) {
  return currencyAmount.quotient.toString(10);
}

var ZERO_HEX$2 = '0x0';
var getV2SwapCallParamsFromTrade$1 = function getV2SwapCallParamsFromTrade(trade, options) {
  var _trade$fromToken = trade.fromToken,
    chainId = _trade$fromToken.chainId,
    contractAddress = _trade$fromToken.contractAddress,
    decimals = _trade$fromToken.decimals;
  var currencyIn = new Token$1(chainId, contractAddress, decimals);
  var currencInAmount = CurrencyAmount$1.fromRawAmount(currencyIn, currencyToWei(trade.baseConvertRequest, decimals));
  var _trade$toToken = trade.toToken,
    toTokenContractAddress = _trade$toToken.contractAddress,
    toDecimals = _trade$toToken.decimals;
  var currencyOut = new Token$1(chainId, toTokenContractAddress, toDecimals);
  var currencOutAmount = CurrencyAmount$1.fromRawAmount(currencyOut, currencyToWei(trade.minAmountConvertQuote, toDecimals));
  var to = validateAndParseAddress(options.recipient);
  var amountIn = toHex$1(currencInAmount);
  var amountOut = toHex$1(currencOutAmount);
  var path = trade.routePath;
  var paramsIn = {
    amountIn: amountIn,
    amountOutMin: amountOut,
    path: path,
    to: to
  };
  return {
    params: paramsIn,
    value: ZERO_HEX$2
  };
};

/**
 * Returns the swap calls that can be used to make the trade
 * @param trade trade to execute
 * @param allowedSlippage user allowed slippage
 * @param recipientAddressOrName the ENS name or address of the recipient of the swap output
 * @param signatureData the signature data of the permit of the input token amount, if available
 */
function getSwapCallV2Params$1(_ref) {
  var library = _ref.library,
    account = _ref.account,
    chainId = _ref.chainId,
    trade = _ref.trade,
    deadline = _ref.deadline;
  var recipient = account;
  var routerContract = getV2RouterContract(library, account, chainId);
  if (!trade || !recipient || !library || !account || !chainId || !deadline) return undefined;
  if (!routerContract) return undefined;
  var params = getV2SwapCallParamsFromTrade$1(trade, {
    feeOnTransfer: false,
    recipient: recipient,
    deadline: deadline.toNumber()
  });
  return {
    address: routerContract.address,
    params: params.params,
    value: params.value
  };
}

// "inputs": [
//   {
//     "internalType": "uint256",
//     "name": "amountIn",
//     "type": "uint256"
//   },
//   {
//     "internalType": "uint256",
//     "name": "amountOutMin",
//     "type": "uint256"
//   },
//   {
//     "internalType": "address[]",
//     "name": "path",
//     "type": "address[]"
//   },
//   {
//     "internalType": "address",
//     "name": "to",
//     "type": "address"
//   },
//   {
//     "internalType": "uint256",
//     "name": "deadline",
//     "type": "uint256"
//   }
// ],

// eslint-disable-next-line no-restricted-imports
var getSwapCallback$2 = function getSwapCallback(_ref) {
  var library = _ref.library,
    account = _ref.account,
    chainId = _ref.chainId,
    trade = _ref.trade,
    deadline = _ref.deadline;
  var swapCalls = getSwapCallV2Params$1({
    library: library,
    account: account,
    chainId: chainId,
    trade: trade,
    deadline: deadline
  });
  return swapCalls;
};

var ZERO_ADDRESS$1 = '0x0000000000000000000000000000000000000000';

// 30 minutes, denominated in seconds
var DEFAULT_DEADLINE_FROM_NOW = 60 * 30;
var L2_DEADLINE_FROM_NOW = 60 * 5;

// used for rewards deadlines
JSBI.BigInt(60 * 60 * 24 * 7);
JSBI.BigInt(0);

// one basis JSBI.BigInt
var BIPS_BASE = JSBI.BigInt(10000);
new Percent$1(JSBI.BigInt(1), BIPS_BASE);

// used for warning states
new Percent$1(JSBI.BigInt(100), BIPS_BASE); // 1%
new Percent$1(JSBI.BigInt(300), BIPS_BASE); // 3%
new Percent$1(JSBI.BigInt(500), BIPS_BASE); // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
new Percent$1(JSBI.BigInt(1000), BIPS_BASE); // 10%
// for non expert mode disable swaps above this
new Percent$1(JSBI.BigInt(1500), BIPS_BASE); // 15%

new Percent$1(JSBI.BigInt(50), BIPS_BASE);
new Percent$1('0');
new Percent$1(JSBI.BigInt(200), BIPS_BASE);
new Percent$1('1');

/** Returns the default transaction TTL for the chain, in minutes. */
function getDefaultTransactionTtl$1(_ref) {
  var chainId = _ref.chainId;
  if (chainId && L2_CHAIN_IDS.includes(chainId)) return L2_DEADLINE_FROM_NOW / 60;
  return DEFAULT_DEADLINE_FROM_NOW / 60;
}

// combines the block timestamp with the user setting to give the deadline that should be used for any submitted transaction
function getTransactionDeadline$1(_ref2) {
  var chainId = _ref2.chainId,
    blockTimestamp = _ref2.blockTimestamp;
  var defaultTtl = getDefaultTransactionTtl$1({
    chainId: chainId
  });
  //const blockTimestamp = useCurrentBlockTimestamp()
  return blockTimestamp === null || blockTimestamp === void 0 ? void 0 : blockTimestamp.add(defaultTtl /* in seconds */ * 60);
}

var getSwapCall$2 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var library, account, swapInfo, chainId, blockTimestamp, trade, deadline, swapCalls;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          library = _ref.library, account = _ref.account, swapInfo = _ref.swapInfo, chainId = _ref.chainId, blockTimestamp = _ref.blockTimestamp;
          trade = swapInfo.trade, swapInfo.slippage;
          deadline = getTransactionDeadline$1({
            chainId: chainId,
            blockTimestamp: blockTimestamp
          });
          swapCalls = getSwapCallback$2({
            library: library,
            account: account,
            chainId: chainId,
            trade: trade === null || trade === void 0 ? void 0 : trade.trade,
            deadline: deadline
            //feeOptions,
          });
          return _context.abrupt("return", swapCalls);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSwapCall(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var Field$1 = /*#__PURE__*/function (Field) {
  Field["INPUT"] = "INPUT";
  Field["OUTPUT"] = "OUTPUT";
  return Field;
}({});

function ownKeys$m(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$m(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$m(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$m(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$9(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$9(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$9() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var IUniswapV2Router02ABI$1 = IUniswapV2Router02Json.abi;
var INVALID_TRADE$1 = {
  state: TradeState$1.INVALID,
  trade: undefined
};
var getMinAmount = function minimumAmountOut(amount, slippageTolerance, currency) {
  var slippageAdjustedAmountOut = new Fraction(JSBI$1.BigInt(1)).add(slippageTolerance).invert().multiply(amount).quotient;
  return CurrencyAmount$1.fromRawAmount(currency, slippageAdjustedAmountOut);
};
var REJECT_PREV_REQUEST_ERROR$4 = 'reject previous values';
var Sushiswap = /*#__PURE__*/function (_Config) {
  _inherits(Sushiswap, _Config);
  var _super = _createSuper$9(Sushiswap);
  function Sushiswap() {
    var _this;
    _classCallCheck(this, Sushiswap);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "promiseReject", undefined);
    _defineProperty(_assertThisInitialized(_this), "getSwapParams", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var input, output, values;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              input = _ref.input, output = _ref.output;
              _context.prev = 1;
              _context.next = 4;
              return _this.setLastInputValuesV2({
                input: input,
                output: output
              });
            case 4:
              values = _context.sent;
              return _context.abrupt("return", values);
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              if (!(_context.t0 === REJECT_PREV_REQUEST_ERROR$4)) {
                _context.next = 12;
                break;
              }
              return _context.abrupt("return", undefined);
            case 12:
              throw new Error(_context.t0);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 8]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getPairAddress", function (_ref3) {
      var token0 = _ref3.token0,
        token1 = _ref3.token1;
      var pairAddress = getCreate2Address$1(FACTORY_ADDRESS$2[_this.chainId], keccak256(['bytes'], [pack(['address', 'address'], token0 < token1 ? [token0, token1] : [token1, token0])]), INIT_CODE_HASH$1[_this.chainId]);
      return pairAddress;
    });
    _defineProperty(_assertThisInitialized(_this), "isPairExist", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
        var token0, token1, pairAddress, contract;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              token0 = _ref4.token0, token1 = _ref4.token1;
              pairAddress = _this.getPairAddress({
                token0: token0,
                token1: token1
              });
              _context2.prev = 2;
              contract = new ethers.Contract(pairAddress, uniswapV2PairContract, _this.library);
              _context2.next = 6;
              return contract.factory();
            case 6:
              return _context2.abrupt("return", true);
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](2);
              console.error({
                error: _context2.t0
              });
              return _context2.abrupt("return", false);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2, 9]]);
      }));
      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getPathAmountOut", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref6) {
        var amountIn, path, contract, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              amountIn = _ref6.amountIn, path = _ref6.path;
              _context3.prev = 1;
              contract = new ethers.Contract(SUSHISWAP_ROUTER_ADDRESS[String(_this.chainId)], IUniswapV2Router02ABI$1, _this.library);
              _context3.next = 5;
              return contract.getAmountsOut(amountIn, path);
            case 5:
              res = _context3.sent;
              return _context3.abrupt("return", res);
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](1);
              return _context3.abrupt("return");
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 9]]);
      }));
      return function (_x3) {
        return _ref7.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getAmountParams", /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref8) {
        var input, output, path;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              input = _ref8.input, output = _ref8.output;
              _context4.prev = 1;
              _context4.next = 4;
              return _this.getLastInputValuesV2({
                input: input,
                output: output
              });
            case 4:
              path = _context4.sent;
              return _context4.abrupt("return", path);
            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](1);
              if (!(_context4.t0 === REJECT_PREV_REQUEST_ERROR$4)) {
                _context4.next = 12;
                break;
              }
              return _context4.abrupt("return", undefined);
            case 12:
              throw new Error(_context4.t0);
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[1, 8]]);
      }));
      return function (_x4) {
        return _ref9.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getToken", function (swapToken) {
      var chainId = _this.chainId;
      switch (swapToken.address) {
        case '0x0000000000000000000000000000000000000000':
          return Ether$1.onChain(chainId);
        case '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee':
          return Ether$1.onChain(chainId);
        case 'NATIVE':
          return Ether$1.onChain(chainId);
        default:
          return new Token$1(chainId, getAddress(swapToken.address), swapToken.decimals);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getTokenAddress", function (swapToken) {
      var token = _this.getToken(swapToken);
      if (token.isNative) {
        return _this.chainId === 5 ? WETH.GORLI().contractAddress : WETH.MAINNET().contractAddress;
      }
      return getAddress(swapToken.address);
    });
    _defineProperty(_assertThisInitialized(_this), "getLastInputValuesV2", /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref10) {
        var _this$promiseReject, _this2;
        var input, output;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              input = _ref10.input, output = _ref10.output;
              (_this$promiseReject = (_this2 = _this).promiseReject) === null || _this$promiseReject === void 0 ? void 0 : _this$promiseReject.call(_this2, REJECT_PREV_REQUEST_ERROR$4);
              return _context6.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(resolve, regect) {
                  var _values$trade, _values$trade$trade;
                  var currencyIn, currencyOut, isExactIn, values, path, methodName, initParams;
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _this.promiseReject = regect;
                        currencyIn = _this.getToken(input.currency);
                        currencyOut = _this.getToken(output.currency);
                        isExactIn = input.amount ? true : false;
                        _context5.next = 6;
                        return _this.getSwapInfo({
                          amount: input.amount || output.amount || '0',
                          currencyIn: currencyIn,
                          currencyOut: currencyOut,
                          isExactIn: isExactIn,
                          currencyInAddress: _this.getTokenAddress(input.currency),
                          currencyOutAddress: _this.getTokenAddress(output.currency)
                        });
                      case 6:
                        values = _context5.sent;
                        path = values === null || values === void 0 ? void 0 : (_values$trade = values.trade) === null || _values$trade === void 0 ? void 0 : (_values$trade$trade = _values$trade.trade) === null || _values$trade$trade === void 0 ? void 0 : _values$trade$trade.routePath;
                        methodName = isExactIn ? 'getAmountsOut' : 'getAmountsIn';
                        initParams = {
                          inputAmount: values.INPUT.amount,
                          outputAmount: values.OUTPUT.amount,
                          methodName: methodName,
                          plugin: getPlugin$1({
                            plugins: Sushiswap$1.getters,
                            methodName: methodName
                          })
                        };
                        if (isExactIn) {
                          resolve(_objectSpread$m(_objectSpread$m({}, initParams), {}, {
                            params: {
                              methodParams: {
                                path: path,
                                amountIn: values === null || values === void 0 ? void 0 : values.INPUT.amount
                              }
                            }
                          }));
                        }
                        resolve(_objectSpread$m(_objectSpread$m({}, initParams), {}, {
                          params: {
                            methodParams: {
                              path: path,
                              amountOut: values === null || values === void 0 ? void 0 : values.OUTPUT.amount
                            }
                          }
                        }));
                      case 12:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x6, _x7) {
                  return _ref12.apply(this, arguments);
                };
              }()));
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x5) {
        return _ref11.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "setLastInputValuesV2", /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref13) {
        var _this$promiseReject2, _this3;
        var input, output;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              input = _ref13.input, output = _ref13.output;
              (_this$promiseReject2 = (_this3 = _this).promiseReject) === null || _this$promiseReject2 === void 0 ? void 0 : _this$promiseReject2.call(_this3, REJECT_PREV_REQUEST_ERROR$4);
              return _context8.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(resolve, regect) {
                  var values;
                  return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        _this.promiseReject = regect;
                        _context7.next = 3;
                        return _this.getSwapValuesV2({
                          input: input,
                          output: output
                        });
                      case 3:
                        values = _context7.sent;
                        _this.values = values;
                        resolve(values);
                      case 6:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x9, _x10) {
                  return _ref15.apply(this, arguments);
                };
              }()));
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      return function (_x8) {
        return _ref14.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getSwapValuesV2", /*#__PURE__*/function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref16) {
        var input, output;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              input = _ref16.input, output = _ref16.output;
              return _context9.abrupt("return", _this.getSwapValues({
                input: input,
                output: output
              }));
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      return function (_x11) {
        return _ref17.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getSwapValuesV3", /*#__PURE__*/function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref18) {
        var input, output;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              input = _ref18.input, output = _ref18.output;
              return _context10.abrupt("return", _this.getSwapValues({
                input: input,
                output: output
              }));
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      return function (_x12) {
        return _ref19.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getSwapValues", /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref20) {
        var _swapInfo$trade;
        var input, output, _assertThisInitialize, library, account, chainId, currencyIn, currencyOut, isExactIn, _yield$_this$getLastB, blockTimestamp, swapInfo, swapCall, getTradeState, isExactEthInput, methodName, swap;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              input = _ref20.input, output = _ref20.output;
              if (input.currency) {
                _context11.next = 3;
                break;
              }
              throw new Error('input currency required');
            case 3:
              if (output.currency) {
                _context11.next = 5;
                break;
              }
              throw new Error('output currency required');
            case 5:
              if (!(!input.amount && !output.amount)) {
                _context11.next = 7;
                break;
              }
              return _context11.abrupt("return", {
                inputAmount: '0',
                outputAmount: '0',
                state: 'INVALID',
                params: undefined,
                INPUT: {
                  currency: undefined,
                  amount: undefined
                },
                OUTPUT: {
                  currency: undefined,
                  amount: undefined
                },
                trade: undefined,
                slippage: undefined,
                type: undefined
              });
            case 7:
              _assertThisInitialize = _assertThisInitialized(_this), library = _assertThisInitialize.library, account = _assertThisInitialize.account, chainId = _assertThisInitialize.chainId;
              currencyIn = _this.getToken(input.currency);
              currencyOut = _this.getToken(output.currency);
              isExactIn = Boolean(input.amount);
              _context11.next = 13;
              return _this.getLastBlock();
            case 13:
              _yield$_this$getLastB = _context11.sent;
              blockTimestamp = _yield$_this$getLastB.blockTimestamp;
              _context11.next = 17;
              return _this.getSwapInfo({
                amount: input.amount || output.amount || '0',
                currencyIn: currencyIn,
                currencyOut: currencyOut,
                isExactIn: isExactIn,
                currencyInAddress: _this.getTokenAddress(input.currency),
                currencyOutAddress: _this.getTokenAddress(output.currency)
              });
            case 17:
              swapInfo = _context11.sent;
              _context11.next = 20;
              return getSwapCall$2({
                library: library,
                chainId: chainId,
                account: account,
                swapInfo: swapInfo,
                blockTimestamp: blockTimestamp
              });
            case 20:
              swapCall = _context11.sent;
              getTradeState = function getTradeState(stateindex) {
                switch (stateindex) {
                  case 3:
                    return 'VALID';
                  default:
                    return 'INVALID';
                }
              };
              isExactEthInput = _this.getToken(input.currency).isNative && isExactIn;
              methodName = getMethodName({
                isExactInput: isExactIn,
                isInputNative: input.currency.address === 'NATIVE',
                isOutputNative: output.currency.address === 'NATIVE',
                protocol: 'V2'
              });
              swap = _objectSpread$m(_objectSpread$m({}, swapInfo), {}, {
                inputAmount: swapInfo.INPUT.amount,
                outputAmount: swapInfo.OUTPUT.amount,
                state: getTradeState((swapInfo === null || swapInfo === void 0 ? void 0 : (_swapInfo$trade = swapInfo.trade) === null || _swapInfo$trade === void 0 ? void 0 : _swapInfo$trade.state) || 0),
                params: {
                  methodParams: swapCall === null || swapCall === void 0 ? void 0 : swapCall.params,
                  value: isExactEthInput ? swapCall === null || swapCall === void 0 ? void 0 : swapCall.params.amountIn : undefined
                },
                methodName: methodName,
                plugin: getPlugin$1({
                  plugins: Sushiswap$1.actions,
                  methodName: methodName
                })
              });
              return _context11.abrupt("return", swap);
            case 26:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
      return function (_x13) {
        return _ref21.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getSwapInfo", /*#__PURE__*/function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref22) {
        var _ref24, _trade2, _trade2$trade, _trade3, _trade3$trade, _ref26;
        var amount, currencyIn, currencyOut, currencyInAddress, currencyOutAddress, isExactIn, parsedAmount, parsedAmountString, trade, slippage, _ref25, _trade, _amountIn, _amountOut, amountIn, amountOut;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              amount = _ref22.amount, currencyIn = _ref22.currencyIn, currencyOut = _ref22.currencyOut, currencyInAddress = _ref22.currencyInAddress, currencyOutAddress = _ref22.currencyOutAddress, isExactIn = _ref22.isExactIn;
              parsedAmount = weiToCurrency(amount, (_ref24 = isExactIn ? currencyIn : currencyOut) !== null && _ref24 !== void 0 ? _ref24 : undefined);
              parsedAmountString = parsedAmount ? parsedAmount.toSignificant(9) : '0';
              slippage = getSlippage$1();
              if (!(_this.chainId !== 5)) {
                _context12.next = 10;
                break;
              }
              _context12.next = 7;
              return _this.getBestTrade({
                currencyIn: currencyInAddress,
                currencyOut: currencyOutAddress,
                amount: parsedAmountString
              });
            case 7:
              trade = _context12.sent;
              _context12.next = 16;
              break;
            case 10:
              _context12.next = 12;
              return _this.getGoerliTrade({
                token0: currencyInAddress,
                token1: currencyOutAddress,
                token0Decimals: currencyIn.decimals,
                token1Decimals: currencyOut.decimals,
                amount: amount,
                slippage: slippage
              });
            case 12:
              _trade = _context12.sent;
              _amountIn = amount;
              _amountOut = _trade === null || _trade === void 0 ? void 0 : _trade.trade.expectedConvertQuote;
              return _context12.abrupt("return", (_ref25 = {}, _defineProperty(_ref25, Field$1.INPUT, {
                currency: currencyIn,
                amount: _amountIn
              }), _defineProperty(_ref25, Field$1.OUTPUT, {
                currency: currencyOut,
                amount: _amountOut
              }), _defineProperty(_ref25, "trade", _trade), _defineProperty(_ref25, "slippage", slippage), _defineProperty(_ref25, "type", isExactIn ? UNISWAP_TYPE.EXACT_INPUT : UNISWAP_TYPE.EXACT_OUTPUT), _ref25));
            case 16:
              amountIn = isExactIn ? amount : currencyToWei(((_trade2 = trade) === null || _trade2 === void 0 ? void 0 : (_trade2$trade = _trade2.trade) === null || _trade2$trade === void 0 ? void 0 : _trade2$trade.expectedConvertQuote) || '0', currencyIn === null || currencyIn === void 0 ? void 0 : currencyIn.decimals);
              amountOut = isExactIn ? currencyToWei(((_trade3 = trade) === null || _trade3 === void 0 ? void 0 : (_trade3$trade = _trade3.trade) === null || _trade3$trade === void 0 ? void 0 : _trade3$trade.expectedConvertQuote) || '0', currencyOut === null || currencyOut === void 0 ? void 0 : currencyOut.decimals) : amount;
              return _context12.abrupt("return", (_ref26 = {}, _defineProperty(_ref26, Field$1.INPUT, {
                currency: currencyIn,
                amount: amountIn
              }), _defineProperty(_ref26, Field$1.OUTPUT, {
                currency: currencyOut,
                amount: amountOut
              }), _defineProperty(_ref26, "trade", trade), _defineProperty(_ref26, "slippage", slippage), _defineProperty(_ref26, "type", isExactIn ? UNISWAP_TYPE.EXACT_INPUT : UNISWAP_TYPE.EXACT_OUTPUT), _ref26));
            case 19:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      return function (_x14) {
        return _ref23.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getGoerliTrade", /*#__PURE__*/function () {
      var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref27) {
        var _weiToCurrency;
        var token0, token1, token0Decimals, token1Decimals, amount, slippage, path, amounts, tokenIn, tokenOut, amountOut, minAmount;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              token0 = _ref27.token0, token1 = _ref27.token1, token0Decimals = _ref27.token0Decimals, token1Decimals = _ref27.token1Decimals, amount = _ref27.amount, slippage = _ref27.slippage;
              _context13.next = 3;
              return _this.getGoerliPath({
                token0: token0,
                token1: token1
              });
            case 3:
              path = _context13.sent;
              if (path) {
                _context13.next = 6;
                break;
              }
              return _context13.abrupt("return");
            case 6:
              _context13.next = 8;
              return _this.getPathAmountOut({
                amountIn: amount,
                path: path
              });
            case 8:
              amounts = _context13.sent;
              if (amounts) {
                _context13.next = 11;
                break;
              }
              return _context13.abrupt("return");
            case 11:
              tokenIn = new Token$1(_this.chainId, token0, token0Decimals || 18);
              tokenOut = new Token$1(_this.chainId, token1, token1Decimals || 18);
              amountOut = amounts[amounts.length - 1].toString();
              minAmount = getMinAmount(amountOut, slippage.allowed, tokenOut);
              return _context13.abrupt("return", {
                trade: {
                  fromToken: {
                    chainId: _this.chainId,
                    contractAddress: tokenIn.address,
                    decimals: tokenIn.decimals,
                    symbol: tokenIn.symbol || '',
                    name: tokenIn.name || ''
                  },
                  toToken: {
                    chainId: _this.chainId,
                    contractAddress: tokenOut.address,
                    decimals: tokenOut.decimals,
                    symbol: tokenOut.symbol || '',
                    name: tokenOut.name || ''
                  },
                  routePath: path,
                  baseConvertRequest: (_weiToCurrency = weiToCurrency(amount, tokenIn)) === null || _weiToCurrency === void 0 ? void 0 : _weiToCurrency.toExact(),
                  minAmountConvertQuote: minAmount.toExact() || '0',
                  expectedConvertQuote: amountOut
                  //...trade,
                },

                routePath: path,
                state: TradeState$1.VALID
              });
            case 16:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      return function (_x15) {
        return _ref28.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getGoerliPath", /*#__PURE__*/function () {
      var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref29) {
        var token0, token1, weth, isExist, isToken0WethExist, isWethToken1Exist;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              token0 = _ref29.token0, token1 = _ref29.token1;
              weth = WETH.GORLI();
              _context14.next = 4;
              return _this.isPairExist({
                token0: token0,
                token1: token1
              });
            case 4:
              isExist = _context14.sent;
              if (!isExist) {
                _context14.next = 7;
                break;
              }
              return _context14.abrupt("return", [token0, token1]);
            case 7:
              if (!(!isExist && getAddress(weth.contractAddress) !== getAddress(token0) && getAddress(weth.contractAddress) !== getAddress(token1))) {
                _context14.next = 16;
                break;
              }
              _context14.next = 10;
              return _this.isPairExist({
                token0: token0,
                token1: weth.contractAddress
              });
            case 10:
              isToken0WethExist = _context14.sent;
              _context14.next = 13;
              return _this.isPairExist({
                token0: weth.contractAddress,
                token1: token1
              });
            case 13:
              isWethToken1Exist = _context14.sent;
              if (!(isToken0WethExist && isWethToken1Exist)) {
                _context14.next = 16;
                break;
              }
              return _context14.abrupt("return", [token0, weth.contractAddress, token1]);
            case 16:
              return _context14.abrupt("return");
            case 17:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      return function (_x16) {
        return _ref30.apply(this, arguments);
      };
    }());
    /**
     * Returns the best v2+v3 trade for a desired swap.
     * @param tradeType whether the swap is an exact in/out
     * @param amountSpecified the exact amount to swap in/out
     * @param otherCurrency the desired output/payment currency
     */
    _defineProperty(_assertThisInitialized(_this), "getBestTrade", /*#__PURE__*/function () {
      var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref31) {
        var currencyIn, currencyOut, amount, _assertThisInitialize2, library, clientSORTradeObject, tradeObject, lastTrade, state, trade;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              currencyIn = _ref31.currencyIn, currencyOut = _ref31.currencyOut, amount = _ref31.amount;
              _assertThisInitialize2 = _assertThisInitialized(_this), library = _assertThisInitialize2.library;
              _context15.next = 4;
              return getClientSideSmartOrderRouterTrade$1({
                library: library,
                account: _this.account,
                chainId: _this.chainId,
                currencyIn: currencyIn,
                currencyOut: currencyOut,
                amount: amount
              });
            case 4:
              clientSORTradeObject = _context15.sent;
              tradeObject = clientSORTradeObject;
              lastTrade = tradeObject === null || tradeObject === void 0 ? void 0 : tradeObject.trade;
              if (tradeObject) {
                _context15.next = 9;
                break;
              }
              return _context15.abrupt("return");
            case 9:
              state = tradeObject.state, trade = tradeObject.trade; // If the trade is in a settled state, return it.
              if (!(state === TradeState$1.INVALID)) {
                _context15.next = 12;
                break;
              }
              return _context15.abrupt("return", INVALID_TRADE$1);
            case 12:
              if (!(state !== TradeState$1.LOADING && state !== TradeState$1.SYNCING || trade)) {
                _context15.next = 14;
                break;
              }
              return _context15.abrupt("return", tradeObject);
            case 14:
              return _context15.abrupt("return", {
                state: state,
                trade: lastTrade
              });
            case 15:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
      return function (_x17) {
        return _ref32.apply(this, arguments);
      };
    }());
    return _this;
  }
  return _createClass(Sushiswap);
}(Config);

var getTokenDecimals = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var address, provider, decimals;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          address = _ref.address, provider = _ref.provider;
          _context.prev = 1;
          _context.next = 4;
          return new ethers.Contract(address, ['function decimals() view returns (uint8 decimals)'], provider).decimals();
        case 4:
          decimals = _context.sent;
          return _context.abrupt("return", decimals);
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](1);
          console.error(_context.t0);
          return _context.abrupt("return", 18);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 8]]);
  }));
  return function getTokenDecimals(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getSwapPath = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var _suhsiRes$params, _suhsiRes$params$meth, _res$params, _res$params$methodPar, _uniswapV3Res$params;
    var chainId, tokenIn, tokenOut, protocol, helper, service, sushiswapHelper, tokenInDecimals, tokenOutDecimals, amountIn, suhsiRes, suhsiPath, uniswapHelper, tokenInDecimalsUniV2, tokenOutDecimalsUniV2, amountInUniV2, res, resPath, inchHelper, tokenInDecimalsInch, amountInInch, inchRes, inchPath, uniswapV3Helper, tokenInDecimalsUniV3, tokenOutDecimalsUniV3, amountInUniV3, uniswapV3Res, methodParams, path, uniswapV3ResPath;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          chainId = _ref3.chainId, tokenIn = _ref3.tokenIn, tokenOut = _ref3.tokenOut, protocol = _ref3.protocol, helper = _ref3.helper, service = _ref3.service;
          _context2.t0 = protocol;
          _context2.next = _context2.t0 === 'SUSHISWAP' ? 4 : _context2.t0 === 'UNISWAP_V2' ? 20 : _context2.t0 === '1INCH' ? 36 : _context2.t0 === 'UNISWAP_V3' ? 55 : 80;
          break;
        case 4:
          sushiswapHelper = helper || new Sushiswap({
            chainId: chainId
          });
          _context2.next = 7;
          return getTokenDecimals({
            address: tokenIn.address,
            provider: sushiswapHelper.library
          });
        case 7:
          tokenInDecimals = _context2.sent;
          _context2.next = 10;
          return getTokenDecimals({
            address: tokenOut.address,
            provider: sushiswapHelper.library
          });
        case 10:
          tokenOutDecimals = _context2.sent;
          amountIn = tokenIn.amount || '1' + '0'.repeat(tokenInDecimals);
          _context2.next = 14;
          return sushiswapHelper.getSwapParams({
            input: {
              currency: {
                address: tokenIn.address,
                decimals: tokenInDecimals
              },
              amount: amountIn
            },
            output: {
              currency: {
                address: tokenOut.address,
                decimals: tokenOutDecimals
              },
              amount: tokenOut.amount
            }
          });
        case 14:
          suhsiRes = _context2.sent;
          suhsiPath = suhsiRes === null || suhsiRes === void 0 ? void 0 : (_suhsiRes$params = suhsiRes.params) === null || _suhsiRes$params === void 0 ? void 0 : (_suhsiRes$params$meth = _suhsiRes$params.methodParams) === null || _suhsiRes$params$meth === void 0 ? void 0 : _suhsiRes$params$meth.path;
          if (!(!suhsiRes || suhsiRes && suhsiRes.state === 'INVALID' || !suhsiPath)) {
            _context2.next = 19;
            break;
          }
          console.error('Invalid Trade');
          return _context2.abrupt("return");
        case 19:
          return _context2.abrupt("return", {
            path: suhsiPath,
            amountIn: suhsiRes.inputAmount,
            amountOut: suhsiRes.outputAmount
          });
        case 20:
          uniswapHelper = helper || new Uniswap({
            chainId: chainId
          });
          _context2.next = 23;
          return getTokenDecimals({
            address: tokenIn.address,
            provider: uniswapHelper.library
          });
        case 23:
          tokenInDecimalsUniV2 = _context2.sent;
          _context2.next = 26;
          return getTokenDecimals({
            address: tokenOut.address,
            provider: uniswapHelper.library
          });
        case 26:
          tokenOutDecimalsUniV2 = _context2.sent;
          amountInUniV2 = tokenIn.amount || tokenOut.amount ? tokenIn.amount : '1' + '0'.repeat(tokenInDecimalsUniV2);
          _context2.next = 30;
          return uniswapHelper.getSwapParams({
            input: {
              currency: {
                address: tokenIn.address,
                decimals: tokenInDecimalsUniV2
              },
              amount: amountInUniV2
            },
            output: {
              currency: {
                address: tokenOut.address,
                decimals: tokenOutDecimalsUniV2
              },
              amount: tokenOut.amount
            }
          });
        case 30:
          res = _context2.sent;
          resPath = res === null || res === void 0 ? void 0 : (_res$params = res.params) === null || _res$params === void 0 ? void 0 : (_res$params$methodPar = _res$params.methodParams) === null || _res$params$methodPar === void 0 ? void 0 : _res$params$methodPar.path;
          if (!(!res || res && res.state === 'INVALID' || !resPath)) {
            _context2.next = 35;
            break;
          }
          console.error('Invalid Trade');
          return _context2.abrupt("return");
        case 35:
          return _context2.abrupt("return", {
            path: resPath,
            amountIn: res.inputAmount,
            amountOut: res.outputAmount
          });
        case 36:
          inchHelper = helper;
          if (inchHelper) {
            _context2.next = 40;
            break;
          }
          console.error('Invalid Helper');
          return _context2.abrupt("return");
        case 40:
          _context2.next = 42;
          return getTokenDecimals({
            address: tokenIn.address,
            provider: inchHelper.library
          });
        case 42:
          tokenInDecimalsInch = _context2.sent;
          _context2.next = 45;
          return getTokenDecimals({
            address: tokenOut.address,
            provider: inchHelper.library
          });
        case 45:
          _context2.sent;
          amountInInch = tokenIn.amount ? tokenIn.amount : '1' + '0'.repeat(tokenInDecimalsInch);
          _context2.next = 49;
          return inchHelper.getSwapParams({
            input: {
              currency: {
                address: tokenIn.address
              },
              amount: amountInInch
            },
            output: {
              currency: {
                address: tokenOut.address
              }
            },
            service: service
          });
        case 49:
          inchRes = _context2.sent;
          if (!(!inchRes || inchRes && inchRes.state === 'INVALID')) {
            _context2.next = 53;
            break;
          }
          console.error('Invalid Trade');
          return _context2.abrupt("return");
        case 53:
          inchPath = inchRes.params.methodParams.pools;
          return _context2.abrupt("return", {
            path: inchPath,
            amountIn: inchRes.inputAmount,
            amountOut: inchRes.outputAmount,
            value: inchRes.params.value
          });
        case 55:
          uniswapV3Helper = helper || new UniswapV3$1({
            chainId: chainId
          });
          _context2.next = 58;
          return getTokenDecimals({
            address: tokenIn.address,
            provider: uniswapV3Helper.library
          });
        case 58:
          tokenInDecimalsUniV3 = _context2.sent;
          _context2.next = 61;
          return getTokenDecimals({
            address: tokenOut.address,
            provider: uniswapV3Helper.library
          });
        case 61:
          tokenOutDecimalsUniV3 = _context2.sent;
          amountInUniV3 = tokenIn.amount || tokenOut.amount ? tokenIn.amount : '1' + '0'.repeat(tokenInDecimalsUniV3);
          _context2.next = 65;
          return uniswapV3Helper.getSwapParams({
            input: {
              currency: {
                address: tokenIn.address,
                decimals: tokenInDecimalsUniV3
              },
              amount: amountInUniV3
            },
            output: {
              currency: {
                address: tokenOut.address,
                decimals: tokenOutDecimalsUniV3
              },
              amount: tokenOut.amount
            }
          });
        case 65:
          uniswapV3Res = _context2.sent;
          if (!(!uniswapV3Res || uniswapV3Res && uniswapV3Res.state === 'INVALID')) {
            _context2.next = 69;
            break;
          }
          console.error('Invalid Trade');
          return _context2.abrupt("return");
        case 69:
          methodParams = uniswapV3Res === null || uniswapV3Res === void 0 ? void 0 : (_uniswapV3Res$params = uniswapV3Res.params) === null || _uniswapV3Res$params === void 0 ? void 0 : _uniswapV3Res$params.methodParams;
          if (!(methodParams !== null && methodParams !== void 0 && methodParams.params_tuple && 'fee' in (methodParams === null || methodParams === void 0 ? void 0 : methodParams.params_tuple))) {
            _context2.next = 78;
            break;
          }
          _context2.next = 73;
          return uniswapV3Helper.isPairExist({
            token0: methodParams.params_tuple.tokenIn,
            token1: methodParams === null || methodParams === void 0 ? void 0 : methodParams.params_tuple.tokenOut
          });
        case 73:
          path = _context2.sent;
          if (path) {
            _context2.next = 77;
            break;
          }
          console.error('Invalid Trade');
          return _context2.abrupt("return");
        case 77:
          return _context2.abrupt("return", {
            path: path.path,
            amountIn: uniswapV3Res.inputAmount,
            amountOut: uniswapV3Res.outputAmount,
            fee: methodParams === null || methodParams === void 0 ? void 0 : methodParams.params_tuple.fee
          });
        case 78:
          uniswapV3ResPath = methodParams !== null && methodParams !== void 0 && methodParams.params_tuple && 'path' in (methodParams === null || methodParams === void 0 ? void 0 : methodParams.params_tuple) ? methodParams.params_tuple.path : undefined;
          return _context2.abrupt("return", {
            path: uniswapV3ResPath,
            amountIn: uniswapV3Res.inputAmount,
            amountOut: uniswapV3Res.outputAmount
          });
        case 80:
          return _context2.abrupt("return");
        case 81:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getSwapPath(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var SimpleSwapExactInput$1 = createPlugin({
  protocol: 'UNISWAP',
  type: 'LIBRARY',
  method: 'swapExactTokensForTokens',
  name: 'simpleSwapExactInputV2',
  supportedContracts: ROUTER_V2_ADDRESSES,
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  },
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        value: new FctValue({
          required: false,
          readonly: true,
          decimals: 18
        }),
        addressIn: new FctAddress({
          destination: 'erc20',
          mode: 'INPUT',
          options: getAllCurrencies({
            chainId: chainId
          })
        }),
        amountIn: new FctValue({
          destination: 'wei_amount'
        }),
        addressOut: new FctAddress({
          destination: 'erc20',
          mode: 'INPUT',
          options: getAllCurrencies({
            chainId: chainId
          })
        }),
        amountOut: new FctValue({
          destination: 'wei_amount',
          readonly: true
        }),
        methodParams: {
          amountIn: new FctValue({
            destination: 'wei_amount',
            readonly: true
          }),
          amountOutMin: new FctValue({
            destination: 'wei_amount',
            readonly: true
          }),
          path: new FctAddressList({
            destination: 'ERC20_List',
            readonly: true,
            options: getSupportedTokens({
              chainId: chainId
            })
          }),
          to: new FctAddress({
            required: false
          }),
          deadline: new FctTimestamp({})
        }
      },
      output: {
        amountIn: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2,
          innerType: 'uint256[]'
        }),
        amountOut: new FctValue({
          destination: 'wei_amount',
          innerIndex: -1,
          innerType: 'uint256[]'
        })
      }
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref2) {
    var input = _ref2.input,
      provider = _ref2.provider,
      setMethod = _ref2.setMethod;
    var isExactIn = true;
    var getPathParams = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
        var service, uniswapService, tokenInAddress, tokenOutAddress, amount, decimalsIn, decimalsOut, initParamsExactIn, res, swapPath, method, isNativeToken, _input$methodParams, amountIn, amountOutMin, paramsExactIn;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              service = _ref3.service;
              if (service) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              uniswapService = service;
              tokenInAddress = input.addressIn.value;
              tokenOutAddress = input.addressOut.value;
              if (!(!tokenInAddress || !tokenOutAddress || typeof tokenInAddress !== 'string' || typeof tokenOutAddress !== 'string')) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return");
            case 8:
              amount = input.amountIn.value ;
              if (amount) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return");
            case 11:
              if (!provider) {
                _context.next = 17;
                break;
              }
              _context.next = 14;
              return getTokenDecimals({
                address: tokenInAddress,
                provider: provider
              });
            case 14:
              _context.t0 = _context.sent;
              _context.next = 18;
              break;
            case 17:
              _context.t0 = 18;
            case 18:
              decimalsIn = _context.t0;
              if (!provider) {
                _context.next = 25;
                break;
              }
              _context.next = 22;
              return getTokenDecimals({
                address: tokenOutAddress,
                provider: provider
              });
            case 22:
              _context.t1 = _context.sent;
              _context.next = 26;
              break;
            case 25:
              _context.t1 = 18;
            case 26:
              decimalsOut = _context.t1;
              initParamsExactIn = {
                value: undefined,
                amountOut: undefined,
                methodParams: {
                  path: undefined,
                  amountOut: undefined,
                  amountOutMin: undefined
                }
              };
              _context.prev = 29;
              _context.next = 32;
              return uniswapService.create({
                cmd: 'simulateSwap',
                token_in: tokenInAddress,
                token_in_decimals: decimalsIn,
                token_out: tokenOutAddress,
                token_out_decimals: decimalsOut,
                token_amount: amount,
                type: 'in' 
              });
            case 32:
              res = _context.sent;
              swapPath = res.path;
              if (swapPath) {
                _context.next = 36;
                break;
              }
              return _context.abrupt("return", {
                params: initParamsExactIn ,
                error: 'invalid trade'
              });
            case 36:
              method = getMethodName({
                isExactInput: isExactIn,
                protocol: 'V2',
                isInputNative: getIsNative(tokenInAddress),
                isOutputNative: getIsNative(tokenOutAddress)
              });
              if (setMethod) setMethod(method);
              isNativeToken = method === 'swapETHForExactTokens' || method === 'swapExactETHForTokens';
              _input$methodParams = input.methodParams, amountIn = _input$methodParams.amountIn, amountOutMin = _input$methodParams.amountOutMin;
              amountIn.virtual = false;
              amountOutMin.virtual = false;
              amountOutMin.readonly = true;
              _context.t2 = method;
              _context.next = _context.t2 === 'swapExactETHForTokens' ? 46 : _context.t2 === 'swapETHForExactTokens' ? 49 : _context.t2 === 'swapExactTokensForETH' ? 52 : _context.t2 === 'swapExactTokensForTokens' ? 54 : _context.t2 === 'swapTokensForExactTokens' ? 56 : _context.t2 === 'swapTokensForExactETH' ? 59 : 62;
              break;
            case 46:
              amountIn.virtual = true;
              amountOutMin.readonly = false;
              return _context.abrupt("break", 62);
            case 49:
              amountIn.virtual = true;
              amountOutMin.virtual = true;
              return _context.abrupt("break", 62);
            case 52:
              amountOutMin.readonly = false;
              return _context.abrupt("break", 62);
            case 54:
              amountOutMin.readonly = false;
              return _context.abrupt("break", 62);
            case 56:
              amountIn.virtual = true;
              amountOutMin.virtual = true;
              return _context.abrupt("break", 62);
            case 59:
              amountIn.virtual = true;
              amountOutMin.virtual = true;
              return _context.abrupt("break", 62);
            case 62:
              paramsExactIn = {
                value: isNativeToken ? res.inputAmount : '0',
                amountOut: res.outputAmount,
                isExactIn: String(isExactIn),
                methodParams: {
                  path: swapPath,
                  amountOut: res.outputAmount,
                  amountOutMin: res.outputAmount,
                  amountIn: undefined,
                  amountInMax: undefined
                }
              };
              ({
                value: isNativeToken ? res.inputAmount : '0',
                amountIn: res.inputAmount,
                isExactIn: String(isExactIn),
                methodParams: {
                  path: swapPath,
                  amountIn: res.inputAmount,
                  amountInMax: res.inputAmount,
                  amountOut: undefined,
                  amountOutMin: undefined
                }
              });
              return _context.abrupt("return", {
                params: paramsExactIn ,
                error: undefined
              });
            case 67:
              _context.prev = 67;
              _context.t3 = _context["catch"](29);
              return _context.abrupt("return", {
                params: initParamsExactIn ,
                error: _context.t3.message
              });
            case 70:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[29, 67]]);
      }));
      return function getPathParams(_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    return {
      get: getPathParams,
      depParamKeys: ['addressIn', 'addressOut', 'isExactIn', 'amountIn']
    };
  },
  requiredApprovals: function requiredApprovals(params, chainId, _b, _c, _d, method) {
    if (method === 'swapETHForExactTokens') return [];
    if (method === 'swapExactETHForTokens') return [];
    var _params$methodParams = params.methodParams,
      path = _params$methodParams.path,
      amountIn = _params$methodParams.amountIn;
    return [{
      to: path.value && path.value.length ? path.value[0] : undefined,
      params: {
        spender: ROUTER_V2_ADDRESS[chainId],
        amount: amountIn.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      amountIn = params.amountIn,
      amountOut = params.amountOut,
      addressIn = params.addressIn,
      addressOut = params.addressOut;
    if (!to.value || !amountIn.value || !amountOut.value || !addressIn.value || !addressOut.value || !vaultAddress) return [];
    if (typeof to.value !== 'string' || typeof amountIn.value !== 'string' || typeof amountOut.value !== 'string' || typeof addressIn.value !== 'string' || typeof addressOut.value !== 'string') return [];
    return [{
      address: vaultAddress,
      toSpend: [{
        token: addressIn.value,
        amount: amountIn.value
      }],
      toReceive: [{
        token: addressOut.value,
        amount: amountOut.value
      }]
    }];
  }
});

var SimpleSwapExactOutput$1 = createPlugin({
  protocol: 'UNISWAP',
  type: 'LIBRARY',
  method: 'swapExactTokensForTokens',
  name: 'simpleSwapExactOutputV2',
  supportedContracts: ROUTER_V2_ADDRESSES,
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  },
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        value: new FctValue({
          required: false,
          readonly: true,
          decimals: 18
        }),
        addressIn: new FctAddress({
          destination: 'erc20',
          mode: 'INPUT',
          options: getAllCurrencies({
            chainId: chainId
          })
        }),
        amountIn: new FctValue({
          destination: 'wei_amount',
          readonly: true
        }),
        addressOut: new FctAddress({
          destination: 'erc20',
          mode: 'INPUT',
          options: getAllCurrencies({
            chainId: chainId
          })
        }),
        amountOut: new FctValue({
          destination: 'wei_amount'
        }),
        methodParams: {
          amountOut: new FctValue({
            destination: 'wei_amount',
            readonly: true
          }),
          amountInMax: new FctValue({
            destination: 'wei_amount',
            readonly: true
          }),
          path: new FctAddressList({
            destination: 'ERC20_List',
            readonly: true,
            options: getSupportedTokens({
              chainId: chainId
            })
          }),
          to: new FctAddress({
            required: false
          }),
          deadline: new FctTimestamp({})
        }
      },
      output: {
        amountIn: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2,
          innerType: 'uint256[]'
        }),
        amountOut: new FctValue({
          destination: 'wei_amount',
          innerIndex: -1,
          innerType: 'uint256[]'
        })
      }
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref2) {
    var input = _ref2.input,
      provider = _ref2.provider,
      setMethod = _ref2.setMethod;
    var isExactIn = false;
    var getPathParams = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
        var service, uniswapService, tokenInAddress, tokenOutAddress, amount, decimalsIn, decimalsOut, initParamsExactOut, res, swapPath, method, isNativeToken, _input$methodParams, amountInMax, amountOut, paramsExactOut;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              service = _ref3.service;
              if (service) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              uniswapService = service;
              tokenInAddress = input.addressIn.value;
              tokenOutAddress = input.addressOut.value;
              if (!(!tokenInAddress || !tokenOutAddress || typeof tokenInAddress !== 'string' || typeof tokenOutAddress !== 'string')) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return");
            case 8:
              amount = input.amountOut.value;
              if (amount) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return");
            case 11:
              if (!provider) {
                _context.next = 17;
                break;
              }
              _context.next = 14;
              return getTokenDecimals({
                address: tokenInAddress,
                provider: provider
              });
            case 14:
              _context.t0 = _context.sent;
              _context.next = 18;
              break;
            case 17:
              _context.t0 = 18;
            case 18:
              decimalsIn = _context.t0;
              if (!provider) {
                _context.next = 25;
                break;
              }
              _context.next = 22;
              return getTokenDecimals({
                address: tokenOutAddress,
                provider: provider
              });
            case 22:
              _context.t1 = _context.sent;
              _context.next = 26;
              break;
            case 25:
              _context.t1 = 18;
            case 26:
              decimalsOut = _context.t1;
              initParamsExactOut = {
                value: undefined,
                amountIn: undefined,
                methodParams: {
                  path: undefined,
                  amountIn: undefined,
                  amountInMax: undefined
                }
              };
              _context.prev = 29;
              _context.next = 32;
              return uniswapService.create({
                cmd: 'simulateSwap',
                token_in: tokenInAddress,
                token_in_decimals: decimalsIn,
                token_out: tokenOutAddress,
                token_out_decimals: decimalsOut,
                token_amount: amount,
                type: 'out'
              });
            case 32:
              res = _context.sent;
              swapPath = res.path;
              if (swapPath) {
                _context.next = 36;
                break;
              }
              return _context.abrupt("return", {
                params: initParamsExactOut,
                error: 'invalid trade'
              });
            case 36:
              method = getMethodName({
                isExactInput: isExactIn,
                protocol: 'V2',
                isInputNative: getIsNative(tokenInAddress),
                isOutputNative: getIsNative(tokenOutAddress)
              });
              if (setMethod) setMethod(method);
              isNativeToken = method === 'swapETHForExactTokens' || method === 'swapExactETHForTokens';
              _input$methodParams = input.methodParams, amountInMax = _input$methodParams.amountInMax, amountOut = _input$methodParams.amountOut;
              amountInMax.virtual = false;
              amountOut.virtual = false;
              amountInMax.readonly = true;
              _context.t2 = method;
              _context.next = _context.t2 === 'swapExactETHForTokens' ? 46 : _context.t2 === 'swapETHForExactTokens' ? 49 : _context.t2 === 'swapExactTokensForETH' ? 51 : _context.t2 === 'swapExactTokensForTokens' ? 54 : _context.t2 === 'swapTokensForExactTokens' ? 57 : _context.t2 === 'swapTokensForExactETH' ? 59 : 61;
              break;
            case 46:
              amountInMax.virtual = true;
              amountOut.virtual = true;
              return _context.abrupt("break", 61);
            case 49:
              amountInMax.virtual = true;
              return _context.abrupt("break", 61);
            case 51:
              amountOut.virtual = true;
              amountInMax.virtual = true;
              return _context.abrupt("break", 61);
            case 54:
              amountOut.virtual = true;
              amountInMax.virtual = true;
              return _context.abrupt("break", 61);
            case 57:
              amountInMax.readonly = false;
              return _context.abrupt("break", 61);
            case 59:
              amountInMax.readonly = false;
              return _context.abrupt("break", 61);
            case 61:
              ({
                value: isNativeToken ? res.inputAmount : '0',
                amountOut: res.outputAmount,
                isExactIn: String(isExactIn),
                methodParams: {
                  path: swapPath,
                  amountOut: res.outputAmount,
                  amountOutMin: res.outputAmount,
                  amountIn: undefined,
                  amountInMax: undefined
                }
              });
              paramsExactOut = {
                value: isNativeToken ? res.inputAmount : '0',
                amountIn: res.inputAmount,
                isExactIn: String(isExactIn),
                methodParams: {
                  path: swapPath,
                  amountIn: res.inputAmount,
                  amountInMax: res.inputAmount,
                  amountOut: undefined,
                  amountOutMin: undefined
                }
              };
              return _context.abrupt("return", {
                params: paramsExactOut,
                error: undefined
              });
            case 66:
              _context.prev = 66;
              _context.t3 = _context["catch"](29);
              return _context.abrupt("return", {
                params: initParamsExactOut,
                error: _context.t3.message
              });
            case 69:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[29, 66]]);
      }));
      return function getPathParams(_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    return {
      get: getPathParams,
      depParamKeys: ['addressIn', 'addressOut', 'isExactIn', 'amountOut']
    };
  },
  requiredApprovals: function requiredApprovals(params, chainId, _b, _c, _d, method) {
    if (method === 'swapETHForExactTokens') return [];
    if (method === 'swapExactETHForTokens') return [];
    var _params$methodParams = params.methodParams,
      path = _params$methodParams.path,
      amountInMax = _params$methodParams.amountInMax;
    return [{
      to: path.value && path.value.length ? path.value[0] : undefined,
      params: {
        spender: ROUTER_V2_ADDRESS[chainId],
        amount: amountInMax.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      amountIn = params.amountIn,
      amountOut = params.amountOut,
      addressIn = params.addressIn,
      addressOut = params.addressOut;
    if (!to.value || !amountIn.value || !amountOut.value || !addressIn.value || !addressOut.value || !vaultAddress) return [];
    if (typeof to.value !== 'string' || typeof amountIn.value !== 'string' || typeof amountOut.value !== 'string' || typeof addressIn.value !== 'string' || typeof addressOut.value !== 'string') return [];
    return [{
      address: vaultAddress,
      toSpend: [{
        token: addressIn.value,
        amount: amountIn.value
      }],
      toReceive: [{
        token: addressOut.value,
        amount: amountOut.value
      }]
    }];
  }
});

/* eslint-disable no-restricted-imports */
var UniswapV2SwapExactTokensForTokens = createPlugin({
  protocol: 'UNISWAP',
  type: 'ACTION',
  method: 'swapExactTokensForTokens',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        methodParams: {
          amountIn: new FctValue({
            destination: 'wei_amount'
          }),
          amountOutMin: new FctValue({
            destination: 'wei_amount',
            risk: amountOutMinRisk
          }),
          path: new FctAddressList({
            destination: 'ERC20_List',
            options: getSupportedTokens({
              chainId: chainId
            })
          }),
          to: new FctAddress({}),
          deadline: new FctTimestamp({})
        }
      },
      output: {
        amountIn: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2,
          innerType: 'uint256[]'
        }),
        amountOut: new FctValue({
          destination: 'wei_amount',
          innerIndex: -1,
          innerType: 'uint256[]'
        })
      }
    };
  },
  supportedContracts: ROUTER_V2_ADDRESSES,
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  },
  requiredApprovals: function requiredApprovals(params) {
    var token = params !== null && params !== void 0 && params.methodParams.path.value && Array.isArray(params === null || params === void 0 ? void 0 : params.methodParams.path.value) ? params === null || params === void 0 ? void 0 : params.methodParams.path.value[0] : undefined;
    return [{
      to: token,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amountIn.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

/* eslint-disable no-restricted-imports */
var UniswapV2SwapTokensForExactTokens = createPlugin({
  protocol: 'UNISWAP',
  type: 'ACTION',
  method: 'swapTokensForExactTokens',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        methodParams: {
          amountOut: new FctValue({
            destination: 'wei_amount'
          }),
          amountInMax: new FctValue({
            destination: 'wei_amount'
          }),
          path: new FctAddressList({
            destination: 'ERC20_List',
            options: getSupportedTokens({
              chainId: chainId
            })
          }),
          to: new FctAddress({}),
          deadline: new FctTimestamp({})
        }
      },
      output: {
        amountIn: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2,
          innerType: 'uint256[]'
        }),
        amountOut: new FctValue({
          destination: 'wei_amount',
          innerIndex: -1,
          innerType: 'uint256[]'
        })
      }
    };
  },
  supportedContracts: ROUTER_V2_ADDRESSES,
  initParams: {
    methodParams: {
      deadline: {
        type: 'global',
        id: 'blockTimestamp'
      }
    }
  },
  requiredApprovals: function requiredApprovals(params) {
    var token = params !== null && params !== void 0 && params.methodParams.path.value && Array.isArray(params === null || params === void 0 ? void 0 : params.methodParams.path.value) ? params === null || params === void 0 ? void 0 : params.methodParams.path.value[0] : undefined;
    return [{
      to: token,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amountInMax.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var GetAmountsIn = createPlugin({
  protocol: 'UNISWAP',
  type: 'GETTER',
  method: 'getAmountsIn',
  supportedContracts: ROUTER_V2_ADDRESSES,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        methodParams: {
          amountOut: new FctValue({
            destination: 'wei_amount'
          }),
          path: new FctAddressList({
            destination: 'ERC20_List'
          })
        }
      },
      output: {
        amountIn: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2
        }),
        amountOut: new FctValue({
          destination: 'wei_amount',
          innerIndex: -1
        })
      }
    };
  }
});

var GetAmountsOut = createPlugin({
  protocol: 'UNISWAP',
  type: 'GETTER',
  method: 'getAmountsOut',
  supportedContracts: ROUTER_V2_ADDRESSES,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        methodParams: {
          amountIn: new FctValue({
            destination: 'wei_amount'
          }),
          path: new FctAddressList({
            destination: 'ERC20_List'
          })
        }
      },
      output: {
        amountIn: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2
        }),
        amountOut: new FctValue({
          destination: 'wei_amount',
          innerIndex: -1
        })
      }
    };
  }
});

var GetReserves = createPlugin({
  protocol: 'UNISWAP',
  type: 'GETTER',
  method: 'getReserves',
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_pool_v2'
        }),
        // TODO: Add Uniswap V2 pools to options
        methodParams: {}
      },
      output: {
        reserve0: new FctValue({
          destination: 'wei_amount',
          innerIndex: 0
        }),
        reserve1: new FctValue({
          destination: 'wei_amount',
          innerIndex: 1
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var actions$m = {
  SimpleSwapExactInput: SimpleSwapExactInput$1,
  SimpleSwapExactOutput: SimpleSwapExactOutput$1,
  AddLiquidity: AddLiquidity$2,
  RemoveLiquidity: RemoveLiquidity$1,
  AddLiquidityETH: AddLiquidityETH$1,
  RemoveLiquidityETH: RemoveLiquidityETH$1,
  UniswapV2SwapExactETHForTokens: UniswapV2SwapExactETHForTokens,
  UniswapV2SwapETHForExactTokens: UniswapV2SwapETHForExactTokens,
  UniswapV2SwapExactTokensForETH: UniswapV2SwapExactTokensForETH,
  UniswapV2SwapTokensForExactETH: UniswapV2SwapTokensForExactETH,
  UniswapV2SwapExactTokensForTokens: UniswapV2SwapExactTokensForTokens,
  UniswapV2SwapTokensForExactTokens: UniswapV2SwapTokensForExactTokens,
  SimpleRemoveLiquidity: SimpleRemoveLiquidity
};
var getters$j = {
  GetAmountsIn: GetAmountsIn,
  GetAmountsOut: GetAmountsOut,
  GetReserves: GetReserves
};
var Uniswap$1 = {
  actions: actions$m,
  getters: getters$j
};

/**
 * Returns query arguments for the Routing API query or undefined if the
 * query should be skipped. Input arguments do not need to be memoized, as they will
 * be destructured.
 */
function getRoutingAPIArguments(_ref) {
  var tokenIn = _ref.tokenIn,
    tokenOut = _ref.tokenOut,
    amount = _ref.amount,
    tradeType = _ref.tradeType,
    useClientSideRouter = _ref.useClientSideRouter;
  return !tokenIn || !tokenOut || !amount || tokenIn.equals(tokenOut) ? undefined : {
    amount: amount.quotient.toString(),
    tokenInAddress: tokenIn.wrapped.address,
    tokenInChainId: tokenIn.wrapped.chainId,
    tokenInDecimals: tokenIn.wrapped.decimals,
    tokenInSymbol: tokenIn.wrapped.symbol,
    tokenOutAddress: tokenOut.wrapped.address,
    tokenOutChainId: tokenOut.wrapped.chainId,
    tokenOutDecimals: tokenOut.wrapped.decimals,
    tokenOutSymbol: tokenOut.wrapped.symbol,
    useClientSideRouter: useClientSideRouter,
    type: tradeType === TradeType$1.EXACT_INPUT ? 'exactIn' : 'exactOut'
  };
}

var _excluded$4 = ["gasUseEstimateUSD"];
function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TradeState = /*#__PURE__*/function (TradeState) {
  TradeState[TradeState["LOADING"] = 0] = "LOADING";
  TradeState[TradeState["INVALID"] = 1] = "INVALID";
  TradeState[TradeState["NO_ROUTE_FOUND"] = 2] = "NO_ROUTE_FOUND";
  TradeState[TradeState["VALID"] = 3] = "VALID";
  TradeState[TradeState["SYNCING"] = 4] = "SYNCING";
  return TradeState;
}({});

// from https://github.com/Uniswap/routing-api/blob/main/lib/handlers/schema.ts

var InterfaceTrade = /*#__PURE__*/function (_Trade) {
  _inherits(InterfaceTrade, _Trade);
  var _super = _createSuper$8(InterfaceTrade);
  function InterfaceTrade(_ref) {
    var _this;
    var gasUseEstimateUSD = _ref.gasUseEstimateUSD,
      routes = _objectWithoutProperties(_ref, _excluded$4);
    _classCallCheck(this, InterfaceTrade);
    _this = _super.call(this, routes);
    _this.gasUseEstimateUSD = gasUseEstimateUSD;
    return _this;
  }
  return _createClass(InterfaceTrade);
}(Trade);

/**
 * Transforms a Routing API quote into an array of routes that can be used to create
 * a `Trade`.
 */
function computeRoutes(currencyIn, currencyOut, tradeType, quoteResult) {
  if (!quoteResult || !quoteResult.route || !currencyIn || !currencyOut) return undefined;
  if (quoteResult.route.length === 0) return [];
  var parsedTokenIn = parseToken(quoteResult.route[0][0].tokenIn);
  var parsedTokenOut = parseToken(quoteResult.route[0][quoteResult.route[0].length - 1].tokenOut);
  if (parsedTokenIn.address !== currencyIn.wrapped.address) return undefined;
  if (parsedTokenOut.address !== currencyOut.wrapped.address) return undefined;
  var parsedCurrencyIn = currencyIn.isNative ? nativeOnChain(currencyIn.chainId) : parsedTokenIn;
  var parsedCurrencyOut = currencyOut.isNative ? nativeOnChain(currencyOut.chainId) : parsedTokenOut;
  try {
    return quoteResult.route.map(function (route) {
      if (route.length === 0) {
        throw new Error('Expected route to have at least one pair or pool');
      }
      var rawAmountIn = route[0].amountIn;
      var rawAmountOut = route[route.length - 1].amountOut;
      if (!rawAmountIn || !rawAmountOut) {
        throw new Error('Expected both amountIn and amountOut to be present');
      }
      return {
        routev3: isV3Route(route) ? new Route(route.map(parsePool), parsedCurrencyIn, parsedCurrencyOut) : null,
        routev2: !isV3Route(route) ? new Route$1(route.map(parsePair), parsedCurrencyIn, parsedCurrencyOut) : null,
        inputAmount: CurrencyAmount.fromRawAmount(parsedCurrencyIn, rawAmountIn),
        outputAmount: CurrencyAmount.fromRawAmount(parsedCurrencyOut, rawAmountOut)
      };
    });
  } catch (e) {
    // `Route` constructor may throw if inputs/outputs are temporarily out of sync
    // (RTK-Query always returns the latest data which may not be the right inputs/outputs)
    // This is not fatal and will fix itself in future render cycles
    console.error(e);
    return undefined;
  }
}
function transformRoutesToTrade(route, tradeType, gasUseEstimateUSD) {
  var _route$filter$map, _route$filter$map2;
  return new InterfaceTrade({
    v2Routes: (_route$filter$map = route === null || route === void 0 ? void 0 : route.filter(function (r) {
      return r.routev2 !== null;
    }).map(function (_ref) {
      var routev2 = _ref.routev2,
        inputAmount = _ref.inputAmount,
        outputAmount = _ref.outputAmount;
      return {
        routev2: routev2,
        inputAmount: inputAmount,
        outputAmount: outputAmount
      };
    })) !== null && _route$filter$map !== void 0 ? _route$filter$map : [],
    v3Routes: (_route$filter$map2 = route === null || route === void 0 ? void 0 : route.filter(function (r) {
      return r.routev3 !== null;
    }).map(function (_ref2) {
      var routev3 = _ref2.routev3,
        inputAmount = _ref2.inputAmount,
        outputAmount = _ref2.outputAmount;
      return {
        routev3: routev3,
        inputAmount: inputAmount,
        outputAmount: outputAmount
      };
    })) !== null && _route$filter$map2 !== void 0 ? _route$filter$map2 : [],
    tradeType: tradeType,
    gasUseEstimateUSD: gasUseEstimateUSD
  });
}
var parseToken = function parseToken(_ref3) {
  var address = _ref3.address,
    chainId = _ref3.chainId,
    decimals = _ref3.decimals,
    symbol = _ref3.symbol;
  return new Token(chainId, address, parseInt(decimals.toString()), symbol);
};
var parsePool = function parsePool(_ref4) {
  var fee = _ref4.fee,
    sqrtRatioX96 = _ref4.sqrtRatioX96,
    liquidity = _ref4.liquidity,
    tickCurrent = _ref4.tickCurrent,
    tokenIn = _ref4.tokenIn,
    tokenOut = _ref4.tokenOut;
  return new Pool(parseToken(tokenIn), parseToken(tokenOut), parseInt(fee), sqrtRatioX96, liquidity, parseInt(tickCurrent));
};
var parsePair = function parsePair(_ref5) {
  var reserve0 = _ref5.reserve0,
    reserve1 = _ref5.reserve1;
  return new Pair(CurrencyAmount.fromRawAmount(parseToken(reserve0.token), reserve0.quotient), CurrencyAmount.fromRawAmount(parseToken(reserve1.token), reserve1.quotient));
};
function isV3Route(route) {
  return route[0].type === 'v3-pool';
}

var _DistributionPercents;
var STABLECOIN_AMOUNT_OUT = _defineProperty({}, SupportedChainId.MAINNET, CurrencyAmount.fromRawAmount(USDC_MAINNET, 100000e6));

/**

/**
 *
 * @param fiatValue string representation of a USD amount
 * @returns CurrencyAmount where currency is stablecoin on active chain
 */
function getStablecoinAmountFromFiatValue(fiatValue, chainId) {
  var _STABLECOIN_AMOUNT_OU2;
  var stablecoin = chainId ? (_STABLECOIN_AMOUNT_OU2 = STABLECOIN_AMOUNT_OUT[chainId]) === null || _STABLECOIN_AMOUNT_OU2 === void 0 ? void 0 : _STABLECOIN_AMOUNT_OU2.currency : undefined;
  return function () {
    if (fiatValue === null || fiatValue === undefined || !chainId || !stablecoin) {
      return undefined;
    }

    // trim for decimal precision when parsing
    var parsedForDecimals = parseFloat(fiatValue).toFixed(stablecoin.decimals).toString();
    try {
      // parse USD string into CurrencyAmount based on stablecoin decimals
      return tryParseCurrencyAmount(parsedForDecimals, stablecoin);
    } catch (error) {
      return undefined;
    }
  };
}

/**
 * Reduces client-side latency by increasing the minimum percentage of the input token to use for each route in a split route while SOR is used client-side.
 * Defaults are defined in https://github.com/Uniswap/smart-order-router/blob/309e6f6603984d3b5aef0733b0cfaf129c29f602/src/routers/alpha-router/config.ts#L83.
 */
var DistributionPercents = (_DistributionPercents = {}, _defineProperty(_DistributionPercents, SupportedChainId.MAINNET, 10), _defineProperty(_DistributionPercents, SupportedChainId.OPTIMISM, 10), _defineProperty(_DistributionPercents, SupportedChainId.OPTIMISTIC_KOVAN, 10), _defineProperty(_DistributionPercents, SupportedChainId.ARBITRUM_ONE, 25), _defineProperty(_DistributionPercents, SupportedChainId.ARBITRUM_RINKEBY, 25), _DistributionPercents);
var DEFAULT_DISTRIBUTION_PERCENT = 10;
function getConfig(chainId, protocol) {
  var _ref;
  return {
    // Limit to only V2 and V3.
    protocols: protocol === 'V2' ? [Protocol.V2] : [Protocol.V3],
    distributionPercent: (_ref = chainId && DistributionPercents[chainId]) !== null && _ref !== void 0 ? _ref : DEFAULT_DISTRIBUTION_PERCENT
  };
}
function getClientSideSmartOrderRouterTrade(_x) {
  return _getClientSideSmartOrderRouterTrade.apply(this, arguments);
}
function _getClientSideSmartOrderRouterTrade() {
  _getClientSideSmartOrderRouterTrade = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var _getStablecoinAmountF, _quoteResult$data, _quoteResult$data2, _quoteResult$data3, _quoteResult$data4;
    var library, tradeType, protocol, amountSpecified, otherCurrency, _ref3, _ref4, currencyIn, currencyOut, queryArgs, chainId, params, config, getQuoteResult, quoteResult, route, gasUseEstimateUSD, getTrade, trade, otherAmount;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          library = _ref2.library, tradeType = _ref2.tradeType, protocol = _ref2.protocol, amountSpecified = _ref2.amountSpecified, otherCurrency = _ref2.otherCurrency;
          _ref3 = tradeType === TradeType$1.EXACT_INPUT ? [amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency, otherCurrency] : [otherCurrency, amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency], _ref4 = _slicedToArray(_ref3, 2), currencyIn = _ref4[0], currencyOut = _ref4[1];
          queryArgs = getRoutingAPIArguments({
            tokenIn: currencyIn,
            tokenOut: currencyOut,
            amount: amountSpecified,
            tradeType: tradeType,
            useClientSideRouter: true
          });
          chainId = amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency.chainId;
          params = chainId && library && {
            chainId: chainId,
            provider: library
          };
          config = getConfig(chainId, protocol);
          getQuoteResult = /*#__PURE__*/function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var _quoteResult;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (!(!queryArgs || !params)) {
                      _context.next = 2;
                      break;
                    }
                    return _context.abrupt("return", {
                      error: undefined
                    });
                  case 2:
                    _context.prev = 2;
                    _context.next = 5;
                    return import('./clientSideSmartOrderRouter-08485ef0.js');
                  case 5:
                    _context.next = 7;
                    return _context.sent.getClientSideQuote(queryArgs, params, config);
                  case 7:
                    _quoteResult = _context.sent;
                    return _context.abrupt("return", new Promise(function (resolve) {
                      return setImmediate(function () {
                        return resolve(_quoteResult);
                      });
                    }));
                  case 11:
                    _context.prev = 11;
                    _context.t0 = _context["catch"](2);
                    console.error({
                      error: _context.t0
                    });
                    return _context.abrupt("return", {
                      error: true
                    });
                  case 15:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[2, 11]]);
            }));
            return function getQuoteResult() {
              return _ref5.apply(this, arguments);
            };
          }();
          _context2.next = 9;
          return getQuoteResult();
        case 9:
          quoteResult = _context2.sent;
          route = computeRoutes(currencyIn, currencyOut, tradeType, quoteResult.data);
          gasUseEstimateUSD = (_getStablecoinAmountF = getStablecoinAmountFromFiatValue(quoteResult === null || quoteResult === void 0 ? void 0 : (_quoteResult$data = quoteResult.data) === null || _quoteResult$data === void 0 ? void 0 : _quoteResult$data.gasUseEstimateUSD, chainId)()) !== null && _getStablecoinAmountF !== void 0 ? _getStablecoinAmountF : null;
          getTrade = function getTrade() {
            if (route) {
              try {
                return route && transformRoutesToTrade(route, tradeType, gasUseEstimateUSD);
              } catch (e) {
                console.debug('transformRoutesToTrade failed: ', e);
              }
            }
            return;
          };
          trade = getTrade();
          if (!(!currencyIn || !currencyOut)) {
            _context2.next = 16;
            break;
          }
          return _context2.abrupt("return", {
            state: TradeState.INVALID,
            trade: undefined
          });
        case 16:
          if (trade) {
            _context2.next = 18;
            break;
          }
          return _context2.abrupt("return", {
            state: TradeState.LOADING,
            trade: undefined
          });
        case 18:
          otherAmount = undefined;
          if (!((_quoteResult$data2 = quoteResult.data) !== null && _quoteResult$data2 !== void 0 && _quoteResult$data2.route)) {
            _context2.next = 27;
            break;
          }
          _context2.t0 = tradeType;
          _context2.next = _context2.t0 === TradeType$1.EXACT_INPUT ? 23 : _context2.t0 === TradeType$1.EXACT_OUTPUT ? 25 : 27;
          break;
        case 23:
          otherAmount = CurrencyAmount.fromRawAmount(currencyOut, (_quoteResult$data3 = quoteResult.data) === null || _quoteResult$data3 === void 0 ? void 0 : _quoteResult$data3.amount);
          return _context2.abrupt("break", 27);
        case 25:
          otherAmount = CurrencyAmount.fromRawAmount(currencyIn, (_quoteResult$data4 = quoteResult.data) === null || _quoteResult$data4 === void 0 ? void 0 : _quoteResult$data4.amount);
          return _context2.abrupt("break", 27);
        case 27:
          if (!(!otherAmount || !route || route.length === 0)) {
            _context2.next = 29;
            break;
          }
          return _context2.abrupt("return", {
            state: TradeState.NO_ROUTE_FOUND,
            trade: undefined
          });
        case 29:
          if (!trade) {
            _context2.next = 31;
            break;
          }
          return _context2.abrupt("return", {
            state: TradeState.VALID,
            trade: trade
          });
        case 31:
          return _context2.abrupt("return", {
            state: TradeState.INVALID,
            trade: undefined
          });
        case 32:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getClientSideSmartOrderRouterTrade.apply(this, arguments);
}

var FIVE_TENTHS_PERCENT = new Percent$1(50, 10000); // .50%
var DEFAULT_AUTO_SLIPPAGE = FIVE_TENTHS_PERCENT;
function toPercent(maxSlippage) {
  var numerator = Math.floor(maxSlippage * 100);
  return new Percent$1(numerator, 10000);
}
var DEFAULT_SLIPPAGE = {
  auto: true,
  allowed: DEFAULT_AUTO_SLIPPAGE
};

/** Returns the allowed slippage, and whether it is auto-slippage. */
function getSlippage(maxSlippage) {
  if (!maxSlippage) return DEFAULT_SLIPPAGE;
  if (maxSlippage > 100) return {
    auto: true,
    allowed: toPercent(100)
  };
  if (maxSlippage < 0) return {
    auto: true,
    allowed: toPercent(0)
  };
  return {
    auto: true,
    allowed: toPercent(maxSlippage)
  };
  // let shouldUseAutoSlippage: boolean = false;
  // selectAtom(autoSlippageAtom, (atomValue) => {
  //   shouldUseAutoSlippage = atomValue.valueOf()
  // })
  // const autoSlippage = useAutoSlippageTolerance(shouldUseAutoSlippage ? trade : undefined)
  // const maxSlippageValue = useAtomValue(maxSlippageAtom)
  // const maxSlippage = useMemo(() => toPercent(maxSlippageValue), [maxSlippageValue])
  // return useMemo(() => {
  //   const auto = shouldUseAutoSlippage || !maxSlippage
  //   const allowed = shouldUseAutoSlippage ? autoSlippage : maxSlippage ?? autoSlippage
  //   const warning = auto ? undefined : getSlippageWarning(allowed)
  //   if (auto && allowed === DEFAULT_AUTO_SLIPPAGE) {
  //     return DEFAULT_SLIPPAGE
  //   }
  //   return { auto, allowed, warning }
  // }, [autoSlippage, maxSlippage, shouldUseAutoSlippage])
}

new Percent$1(1, 2);
new Percent$1(1, 100);

var isProduction = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }
  if (isProduction) {
    throw new Error(prefix);
  }
  var provided = typeof message === 'function' ? message() : message;
  var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
  throw new Error(value);
}

function toHex(currencyAmount) {
  return currencyAmount.quotient.toString(10);
}

var ZERO_HEX$1 = '0x0';
var getV2SwapCallParamsFromTrade = function getV2SwapCallParamsFromTrade(trade, options) {
  var etherIn = trade.inputAmount.currency.isNative;
  var etherOut = trade.outputAmount.currency.isNative; // the router does not support both ether in and out

  !!(etherIn && etherOut) ? invariant(false, 'ETHER_IN_OUT') : void 0;
  !(!('ttl' in options) || options.ttl > 0) ? invariant(false, 'TTL') : void 0;
  var to = validateAndParseAddress$1(options.recipient);
  var amountIn = toHex(trade.maximumAmountIn(options.allowedSlippage));
  var amountOut = toHex(trade.minimumAmountOut(options.allowedSlippage));
  var path = trade.routes[0].path.map(function (token) {
    return token.address;
  });
  // const deadline =
  //   'ttl' in options
  //     ? '0x' + (Math.floor(new Date().getTime() / 1000) + options.ttl).toString(16)
  //     : '0x' + options.deadline.toString(16)

  var paramsIn = {
    amountIn: amountIn,
    amountOutMin: amountOut,
    path: path,
    to: to
  };
  var paramsOut = {
    amountOut: amountOut,
    amountInMax: amountIn,
    path: path,
    to: to
  };
  if (trade.tradeType === TradeType$1.EXACT_INPUT) {
    return {
      params: paramsIn,
      value: ZERO_HEX$1
    };
  } else {
    return {
      params: paramsOut,
      value: ZERO_HEX$1
    };
  }
};

/**
 * Returns the swap calls that can be used to make the trade
 * @param trade trade to execute
 * @param allowedSlippage user allowed slippage
 * @param recipientAddressOrName the ENS name or address of the recipient of the swap output
 * @param signatureData the signature data of the permit of the input token amount, if available
 */
function getSwapCallV2Params(_ref) {
  var library = _ref.library,
    account = _ref.account,
    chainId = _ref.chainId,
    trade = _ref.trade,
    allowedSlippage = _ref.allowedSlippage,
    deadline = _ref.deadline;
  var recipient = account;
  var routerContract = getV2RouterContract(library, account, chainId);
  if (!trade || !recipient || !library || !account || !chainId || !deadline) return undefined;
  if (!routerContract) return undefined;
  var params = getV2SwapCallParamsFromTrade(trade, {
    feeOnTransfer: false,
    allowedSlippage: allowedSlippage,
    recipient: recipient,
    deadline: deadline.toNumber()
  });
  return {
    address: routerContract.address,
    params: params.params,
    value: params.value
  };
}

// eslint-disable-next-line no-restricted-imports
var getSwapCallback$1 = function getSwapCallback(_ref) {
  var library = _ref.library,
    account = _ref.account,
    chainId = _ref.chainId,
    trade = _ref.trade,
    allowedSlippage = _ref.allowedSlippage,
    deadline = _ref.deadline,
    protocol = _ref.protocol;
  if (protocol === 'V2') {
    var swapCalls = getSwapCallV2Params({
      library: library,
      account: account,
      chainId: chainId,
      trade: trade,
      allowedSlippage: allowedSlippage,
      deadline: deadline
    });
    return swapCalls;
  }
  return undefined;
};

/** Returns the default transaction TTL for the chain, in minutes. */
function getDefaultTransactionTtl(_ref) {
  var chainId = _ref.chainId;
  if (chainId && L2_CHAIN_IDS.includes(chainId)) return L2_DEADLINE_FROM_NOW / 60;
  return DEFAULT_DEADLINE_FROM_NOW / 60;
}

// combines the block timestamp with the user setting to give the deadline that should be used for any submitted transaction
function getTransactionDeadline(_ref2) {
  var chainId = _ref2.chainId,
    blockTimestamp = _ref2.blockTimestamp;
  var defaultTtl = getDefaultTransactionTtl({
    chainId: chainId
  });
  //const blockTimestamp = useCurrentBlockTimestamp()
  return blockTimestamp === null || blockTimestamp === void 0 ? void 0 : blockTimestamp.add(defaultTtl /* in seconds */ * 60);
}

var getSwapCall$1 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var library, account, swapInfo, chainId, blockTimestamp, protocol, trade, slippage, deadline;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          library = _ref.library, account = _ref.account, swapInfo = _ref.swapInfo, chainId = _ref.chainId, blockTimestamp = _ref.blockTimestamp, protocol = _ref.protocol;
          trade = swapInfo.trade, slippage = swapInfo.slippage;
          deadline = getTransactionDeadline({
            chainId: chainId,
            blockTimestamp: blockTimestamp
          });
          return _context.abrupt("return", getSwapCallback$1({
            library: library,
            account: account,
            chainId: chainId,
            trade: trade.trade,
            allowedSlippage: slippage.allowed,
            deadline: deadline,
            protocol: protocol
            //feeOptions,
          }));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSwapCall(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var Field = /*#__PURE__*/function (Field) {
  Field["INPUT"] = "INPUT";
  Field["OUTPUT"] = "OUTPUT";
  return Field;
}({});

function ownKeys$l(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$l(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$l(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$l(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var IUniswapV2Router02ABI = IUniswapV2Router02Json.abi;
var INVALID_TRADE = {
  state: TradeState.INVALID,
  trade: undefined
};
var UNISWAP_TYPE = /*#__PURE__*/function (UNISWAP_TYPE) {
  UNISWAP_TYPE["EXACT_INPUT"] = "EXACT_INPUT";
  UNISWAP_TYPE["EXACT_OUTPUT"] = "EXACT_OUTPUT";
  return UNISWAP_TYPE;
}({});
var REJECT_PREV_REQUEST_ERROR$3 = 'reject previous values';
var Uniswap = /*#__PURE__*/function (_Config) {
  _inherits(Uniswap, _Config);
  var _super = _createSuper$7(Uniswap);
  function Uniswap() {
    var _this;
    _classCallCheck(this, Uniswap);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "MINIMUM_LIQUIDITY", Math.pow(10, 3));
    _defineProperty(_assertThisInitialized(_this), "promiseReject", undefined);
    _defineProperty(_assertThisInitialized(_this), "getSwapParams", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var input, output, slippage, swapValues;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              input = _ref.input, output = _ref.output, slippage = _ref.slippage;
              _context.prev = 1;
              _context.next = 4;
              return _this.getLastSwapParamsV2({
                input: input,
                output: output,
                slippage: slippage
              });
            case 4:
              swapValues = _context.sent;
              return _context.abrupt("return", swapValues);
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              if (!(_context.t0 === REJECT_PREV_REQUEST_ERROR$3)) {
                _context.next = 12;
                break;
              }
              return _context.abrupt("return", undefined);
            case 12:
              throw new Error(_context.t0);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 8]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getAmountParams", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
        var input, output, path;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              input = _ref3.input, output = _ref3.output;
              _context2.prev = 1;
              _context2.next = 4;
              return _this.getLastInputValuesV2({
                input: input,
                output: output
              });
            case 4:
              path = _context2.sent;
              return _context2.abrupt("return", path);
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              if (!(_context2.t0 === REJECT_PREV_REQUEST_ERROR$3)) {
                _context2.next = 12;
                break;
              }
              return _context2.abrupt("return", undefined);
            case 12:
              throw new Error(_context2.t0);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1, 8]]);
      }));
      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getPairAddress", function (_ref5) {
      var token0 = _ref5.token0,
        token1 = _ref5.token1;
      var isToken0Native = getIsNative(token0);
      var inputToken = token0;
      if (isToken0Native) {
        inputToken = WETH9[Number(_this.chainId)].address;
      }
      var isToken1Native = getIsNative(token1);
      var outputToken = token1;
      if (isToken1Native) {
        outputToken = WETH9[Number(_this.chainId)].address;
      }
      var pairAddress = getCreate2Address$1(FACTORY_ADDRESS_MAP[Number(_this.chainId)], keccak256(['bytes'], [pack(['address', 'address'], inputToken < outputToken ? [inputToken, outputToken] : [outputToken, inputToken])]), INIT_CODE_HASH);
      return pairAddress;
    });
    _defineProperty(_assertThisInitialized(_this), "isPairExist", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref6) {
        var token0, token1, pairAddress, contract;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              token0 = _ref6.token0, token1 = _ref6.token1;
              pairAddress = _this.getPairAddress({
                token0: token0,
                token1: token1
              });
              _context3.prev = 2;
              contract = new ethers.Contract(pairAddress, uniswapV2PairContract, _this.library);
              _context3.next = 6;
              return contract.factory();
            case 6:
              return _context3.abrupt("return", true);
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](2);
              return _context3.abrupt("return", false);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2, 9]]);
      }));
      return function (_x3) {
        return _ref7.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getTotalSupply", /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref8) {
        var token0, token1, pairAddress, isExist, contract, totalSupply;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              token0 = _ref8.token0, token1 = _ref8.token1;
              pairAddress = _this.getPairAddress({
                token0: token0,
                token1: token1
              });
              _context4.next = 4;
              return _this.isPairExist({
                token0: token0,
                token1: token1
              });
            case 4:
              isExist = _context4.sent;
              if (isExist) {
                _context4.next = 7;
                break;
              }
              return _context4.abrupt("return");
            case 7:
              contract = new ethers.Contract(pairAddress, ['function totalSupply() view returns (uint256)'], _this.library);
              _context4.next = 10;
              return contract.totalSupply();
            case 10:
              totalSupply = _context4.sent;
              return _context4.abrupt("return", totalSupply);
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x4) {
        return _ref9.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getReserves", /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref10) {
        var token0, token1, pairAddress, isExist, contract, reserves;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              token0 = _ref10.token0, token1 = _ref10.token1;
              pairAddress = _this.getPairAddress({
                token0: token0,
                token1: token1
              });
              _context5.next = 4;
              return _this.isPairExist({
                token0: token0,
                token1: token1
              });
            case 4:
              isExist = _context5.sent;
              if (isExist) {
                _context5.next = 7;
                break;
              }
              return _context5.abrupt("return", undefined);
            case 7:
              contract = new ethers.Contract(pairAddress, ['function getReserves() view returns (uint112 reserve0, uint112 reserve1, uint32 blockTimestampLast)'], _this.library);
              _context5.next = 10;
              return contract.getReserves();
            case 10:
              reserves = _context5.sent;
              if (!(!reserves || !reserves.length)) {
                _context5.next = 13;
                break;
              }
              return _context5.abrupt("return", undefined);
            case 13:
              return _context5.abrupt("return", token0 < token1 ? [reserves[0].toString(), reserves[1].toString(), token0, token1] : [reserves[1].toString(), reserves[0].toString(), token0, token1]);
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x5) {
        return _ref11.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getLPTokenBalance", /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref12) {
        var token0, token1, address, pairAddress, isExist, contract, balance;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              token0 = _ref12.token0, token1 = _ref12.token1, address = _ref12.address;
              pairAddress = _this.getPairAddress({
                token0: token0,
                token1: token1
              });
              _context6.next = 4;
              return _this.isPairExist({
                token0: token0,
                token1: token1
              });
            case 4:
              isExist = _context6.sent;
              if (isExist) {
                _context6.next = 7;
                break;
              }
              return _context6.abrupt("return", undefined);
            case 7:
              contract = new ethers.Contract(pairAddress, ['function balanceOf(address _owner) view returns (uint256 balance)'], _this.library);
              _context6.next = 10;
              return contract.balanceOf(address);
            case 10:
              balance = _context6.sent;
              if (balance) {
                _context6.next = 13;
                break;
              }
              return _context6.abrupt("return", undefined);
            case 13:
              return _context6.abrupt("return", balance.toString());
            case 14:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x6) {
        return _ref13.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getToken1LiquidityRate", /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref14) {
        var token0, token1, isToken0Native, inputToken, isToken1Native, outputToken, isExist, reserves, precision, rateEth;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              token0 = _ref14.token0, token1 = _ref14.token1;
              isToken0Native = getIsNative(token0);
              inputToken = token0;
              if (isToken0Native) {
                inputToken = WETH9[Number(_this.chainId)].address;
              }
              isToken1Native = getIsNative(token1);
              outputToken = token1;
              if (isToken1Native) {
                outputToken = WETH9[Number(_this.chainId)].address;
              }
              _context7.next = 9;
              return _this.isPairExist({
                token0: inputToken,
                token1: outputToken
              });
            case 9:
              isExist = _context7.sent;
              if (isExist) {
                _context7.next = 12;
                break;
              }
              return _context7.abrupt("return", undefined);
            case 12:
              _context7.next = 14;
              return _this.getReserves({
                token0: inputToken,
                token1: outputToken
              });
            case 14:
              reserves = _context7.sent;
              if (reserves) {
                _context7.next = 17;
                break;
              }
              return _context7.abrupt("return", undefined);
            case 17:
              precision = 18;
              rateEth = new BigDecimal(reserves[1]).divide(new BigDecimal(reserves[0]), precision).getValue();
              return _context7.abrupt("return", rateEth);
            case 20:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function (_x7) {
        return _ref15.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "estimateLiquidityOutputOnAddLiquidity", /*#__PURE__*/function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref16) {
        var token0, token1, amount0, amount1, totalSupplyBignum, totalSupply, amount0BN, amount1BN, reserves, a0, a1, compareTo;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              token0 = _ref16.token0, token1 = _ref16.token1, amount0 = _ref16.amount0, amount1 = _ref16.amount1;
              _context8.next = 3;
              return _this.getTotalSupply({
                token0: token0,
                token1: token1
              });
            case 3:
              totalSupplyBignum = _context8.sent;
              totalSupply = totalSupplyBignum ? totalSupplyBignum.toString() : undefined;
              if (!(!totalSupply || totalSupply === '0')) {
                _context8.next = 11;
                break;
              }
              amount0BN = new BN(amount0);
              amount1BN = new BN(amount1);
              return _context8.abrupt("return", amount0BN.multipliedBy(amount1BN).sqrt().minus(_this.MINIMUM_LIQUIDITY).toFixed(0));
            case 11:
              _context8.next = 13;
              return _this.getReserves({
                token0: token0,
                token1: token1
              });
            case 13:
              reserves = _context8.sent;
              if (reserves) {
                _context8.next = 16;
                break;
              }
              return _context8.abrupt("return", undefined);
            case 16:
              a0 = new BigDecimal(amount0).multiply(new BigDecimal(totalSupply)).divide(new BigDecimal(reserves[0]), 18).floor().getValue();
              a1 = new BigDecimal(amount1).multiply(new BigDecimal(totalSupply)).divide(new BigDecimal(reserves[1]), 18).floor().getValue();
              compareTo = BigDecimal.compareTo(a0, a1);
              return _context8.abrupt("return", compareTo < 1 ? a0 : a1);
            case 20:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      return function (_x8) {
        return _ref17.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "estimateTokensAmountOnRemoveLiquidity", /*#__PURE__*/function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref18) {
        var token0, token1, liquidity, totalSupplyBignum, totalSupply, reserves, a0, a1;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              token0 = _ref18.token0, token1 = _ref18.token1, liquidity = _ref18.liquidity;
              _context9.next = 3;
              return _this.getTotalSupply({
                token0: token0,
                token1: token1
              });
            case 3:
              totalSupplyBignum = _context9.sent;
              totalSupply = totalSupplyBignum ? totalSupplyBignum.toString() : undefined;
              if (!(!totalSupply || totalSupply === '0')) {
                _context9.next = 7;
                break;
              }
              return _context9.abrupt("return", undefined);
            case 7:
              _context9.next = 9;
              return _this.getReserves({
                token0: token0,
                token1: token1
              });
            case 9:
              reserves = _context9.sent;
              if (reserves) {
                _context9.next = 12;
                break;
              }
              return _context9.abrupt("return", undefined);
            case 12:
              a0 = new BigDecimal(liquidity).multiply(new BigDecimal(reserves[0])).divide(new BigDecimal(totalSupply), 18).floor().getValue();
              a1 = new BigDecimal(liquidity).multiply(new BigDecimal(reserves[1])).divide(new BigDecimal(totalSupply), 18).floor().getValue();
              return _context9.abrupt("return", [a0, a1]);
            case 15:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      return function (_x9) {
        return _ref19.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getPathAmountOut", /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref20) {
        var amountIn, path, contract, res;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              amountIn = _ref20.amountIn, path = _ref20.path;
              _context10.prev = 1;
              //console.log({ token0, token1 })
              contract = new ethers.Contract(ROUTER_V2_ADDRESS[String(_this.chainId)], IUniswapV2Router02ABI, _this.library);
              _context10.next = 5;
              return contract.getAmountsOut(amountIn, path);
            case 5:
              res = _context10.sent;
              return _context10.abrupt("return", res);
            case 9:
              _context10.prev = 9;
              _context10.t0 = _context10["catch"](1);
              console.error({
                error: _context10.t0
              });
              return _context10.abrupt("return");
            case 13:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[1, 9]]);
      }));
      return function (_x10) {
        return _ref21.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getPathAmountIn", /*#__PURE__*/function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref22) {
        var amountOut, path, contract, res;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              amountOut = _ref22.amountOut, path = _ref22.path;
              _context11.prev = 1;
              //console.log({ token0, token1 })
              contract = new ethers.Contract(ROUTER_V2_ADDRESS[String(_this.chainId)], IUniswapV2Router02ABI, _this.library);
              _context11.next = 5;
              return contract.getAmountsIn(amountOut, path);
            case 5:
              res = _context11.sent;
              return _context11.abrupt("return", res);
            case 9:
              _context11.prev = 9;
              _context11.t0 = _context11["catch"](1);
              console.error({
                error: _context11.t0
              });
              return _context11.abrupt("return");
            case 13:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[1, 9]]);
      }));
      return function (_x11) {
        return _ref23.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getToken", function (swapToken) {
      var chainId = _this.chainId;
      return getToken$3(swapToken, chainId);
    });
    _defineProperty(_assertThisInitialized(_this), "getLastInputValuesV2", /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref24) {
        var _this$promiseReject, _this2;
        var input, output;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              input = _ref24.input, output = _ref24.output;
              (_this$promiseReject = (_this2 = _this).promiseReject) === null || _this$promiseReject === void 0 ? void 0 : _this$promiseReject.call(_this2, REJECT_PREV_REQUEST_ERROR$3);
              return _context13.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(resolve, regect) {
                  var _values$trade, _values$trade2, _values$trade3, _values$trade5;
                  var currencyIn, currencyOut, invalideTrade, isExactIn, methodName, tradeType, amount, amountSpecified, values, path, initParams, _values$trade4;
                  return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) switch (_context12.prev = _context12.next) {
                      case 0:
                        _this.promiseReject = regect;
                        currencyIn = _this.getToken(input.currency);
                        currencyOut = _this.getToken(output.currency);
                        invalideTrade = _this.validateSwapInput({
                          input: input,
                          output: output
                        });
                        isExactIn = input.amount ? true : false;
                        methodName = isExactIn ? 'getAmountsOut' : 'getAmountsIn';
                        if (!invalideTrade) {
                          _context12.next = 8;
                          break;
                        }
                        return _context12.abrupt("return", resolve(_objectSpread$l(_objectSpread$l({}, invalideTrade), {}, {
                          methodName: methodName
                        })));
                      case 8:
                        tradeType = isExactIn ? TradeType$1.EXACT_INPUT : TradeType$1.EXACT_OUTPUT;
                        amount = isExactIn ? input.amount : output.amount;
                        amountSpecified = weiToCurrency(amount, isExactIn ? currencyIn : currencyOut);
                        _context12.next = 13;
                        return _this.getBestTrade({
                          tradeType: tradeType,
                          amountSpecified: amountSpecified,
                          otherCurrency: isExactIn ? currencyOut : currencyIn,
                          protocol: 'V2'
                        });
                      case 13:
                        values = _context12.sent;
                        path = values === null || values === void 0 ? void 0 : (_values$trade = values.trade) === null || _values$trade === void 0 ? void 0 : _values$trade.routes[0].path.map(function (token) {
                          return token.address;
                        });
                        initParams = {
                          inputAmount: values === null || values === void 0 ? void 0 : (_values$trade2 = values.trade) === null || _values$trade2 === void 0 ? void 0 : _values$trade2.inputAmount.quotient.toString(10),
                          outputAmount: values === null || values === void 0 ? void 0 : (_values$trade3 = values.trade) === null || _values$trade3 === void 0 ? void 0 : _values$trade3.outputAmount.quotient.toString(10),
                          methodName: methodName,
                          protocol: 'UNISWAP',
                          plugin: getPlugin$1({
                            plugins: Uniswap$1.getters,
                            methodName: methodName
                          }),
                          state: _this.getTradeState((values === null || values === void 0 ? void 0 : values.state) || 0)
                        };
                        if (isExactIn) {
                          resolve(_objectSpread$l(_objectSpread$l({}, initParams), {}, {
                            params: {
                              methodParams: {
                                path: path,
                                amountIn: values === null || values === void 0 ? void 0 : (_values$trade4 = values.trade) === null || _values$trade4 === void 0 ? void 0 : _values$trade4.inputAmount.quotient.toString(10)
                              }
                            }
                          }));
                        }
                        resolve(_objectSpread$l(_objectSpread$l({}, initParams), {}, {
                          params: {
                            methodParams: {
                              path: path,
                              amountOut: values === null || values === void 0 ? void 0 : (_values$trade5 = values.trade) === null || _values$trade5 === void 0 ? void 0 : _values$trade5.outputAmount.quotient.toString(10)
                            }
                          }
                        }));
                      case 18:
                      case "end":
                        return _context12.stop();
                    }
                  }, _callee12);
                }));
                return function (_x13, _x14) {
                  return _ref26.apply(this, arguments);
                };
              }()));
            case 3:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      return function (_x12) {
        return _ref25.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getLastSwapParamsV2", /*#__PURE__*/function () {
      var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref27) {
        var _this$promiseReject2, _this3;
        var input, output, slippage;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              input = _ref27.input, output = _ref27.output, slippage = _ref27.slippage;
              (_this$promiseReject2 = (_this3 = _this).promiseReject) === null || _this$promiseReject2 === void 0 ? void 0 : _this$promiseReject2.call(_this3, REJECT_PREV_REQUEST_ERROR$3);
              return _context15.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(resolve, regect) {
                  var values;
                  return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) switch (_context14.prev = _context14.next) {
                      case 0:
                        _this.promiseReject = regect;
                        _context14.next = 3;
                        return _this.getSwapValuesV2({
                          input: input,
                          output: output,
                          slippage: slippage
                        });
                      case 3:
                        values = _context14.sent;
                        resolve(values);
                      case 5:
                      case "end":
                        return _context14.stop();
                    }
                  }, _callee14);
                }));
                return function (_x16, _x17) {
                  return _ref29.apply(this, arguments);
                };
              }()));
            case 3:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
      return function (_x15) {
        return _ref28.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getSwapValuesV2", /*#__PURE__*/function () {
      var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref30) {
        var input, output, slippage;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              input = _ref30.input, output = _ref30.output, slippage = _ref30.slippage;
              return _context16.abrupt("return", _this.getSwapValues({
                input: input,
                output: output,
                protocol: 'V2',
                slippage: slippage
              }));
            case 2:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }));
      return function (_x18) {
        return _ref31.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getSwapValuesV3", /*#__PURE__*/function () {
      var _ref33 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_ref32) {
        var input, output;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              input = _ref32.input, output = _ref32.output;
              return _context17.abrupt("return", _this.getSwapValues({
                input: input,
                output: output,
                protocol: 'V3'
              }));
            case 2:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }));
      return function (_x19) {
        return _ref33.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getTradeState", function (stateindex) {
      switch (stateindex) {
        case 3:
          return 'VALID';
        default:
          return 'INVALID';
      }
    });
    _defineProperty(_assertThisInitialized(_this), "validateSwapInput", function (_ref34) {
      var _input$currency$addre, _output$currency$addr;
      var input = _ref34.input,
        output = _ref34.output;
      var invalidTrade = {
        inputAmount: '0',
        outputAmount: '0',
        state: 'INVALID',
        params: undefined,
        INPUT: {
          currency: undefined,
          amount: undefined
        },
        OUTPUT: {
          currency: undefined,
          amount: undefined
        },
        trade: undefined,
        slippage: undefined,
        type: undefined,
        methodName: undefined,
        protocol: 'UNISWAP'
      };
      var WETH_ADDRESS = WETH_ADDRESS_MAP[_this.chainId];
      if (input.currency.address === WETH_ADDRESS && getIsNative(output.currency.address) || getIsNative(input.currency.address) && output.currency.address === WETH_ADDRESS) {
        console.error('To wrap or unwrap ETH, please use the Ether Wrap/Unwrap Plugin');
        return invalidTrade;
      }
      if (((_input$currency$addre = input.currency.address) === null || _input$currency$addre === void 0 ? void 0 : _input$currency$addre.toLowerCase()) === ((_output$currency$addr = output.currency.address) === null || _output$currency$addr === void 0 ? void 0 : _output$currency$addr.toLowerCase())) {
        console.error('Invalid trade');
        return invalidTrade;
      }
      if (!input.currency) {
        console.error('input currency required');
        return invalidTrade;
      }
      if (!output.currency) {
        console.error('output currency required');
        return invalidTrade;
      }
      if (!input.amount && !output.amount) {
        return invalidTrade;
      }
      return undefined;
    });
    _defineProperty(_assertThisInitialized(_this), "getSwapValues", /*#__PURE__*/function () {
      var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref35) {
        var _swapInfo$INPUT$amoun, _swapInfo$OUTPUT$amou, _swapInfo$trade;
        var input, output, protocol, slippage, invalideTrade, _assertThisInitialize, library, account, chainId, currencyIn, currencyOut, isExactIn, _yield$_this$getLastB, blockTimestamp, swapInfo, swapCall, isExactEthInput, params, methodName, swap;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              input = _ref35.input, output = _ref35.output, protocol = _ref35.protocol, slippage = _ref35.slippage;
              invalideTrade = _this.validateSwapInput({
                input: input,
                output: output
              });
              if (!invalideTrade) {
                _context18.next = 4;
                break;
              }
              return _context18.abrupt("return", invalideTrade);
            case 4:
              _assertThisInitialize = _assertThisInitialized(_this), library = _assertThisInitialize.library, account = _assertThisInitialize.account, chainId = _assertThisInitialize.chainId;
              currencyIn = _this.getToken(input.currency);
              currencyOut = _this.getToken(output.currency);
              isExactIn = Boolean(input.amount);
              _context18.next = 10;
              return _this.getLastBlock();
            case 10:
              _yield$_this$getLastB = _context18.sent;
              blockTimestamp = _yield$_this$getLastB.blockTimestamp;
              _context18.next = 14;
              return _this.getSwapInfo({
                amount: input.amount || output.amount || '0',
                currencyIn: currencyIn,
                currencyOut: currencyOut,
                isExactIn: isExactIn,
                protocol: protocol,
                slippage: slippage
              });
            case 14:
              swapInfo = _context18.sent;
              _context18.next = 17;
              return getSwapCall$1({
                library: library,
                chainId: chainId,
                account: account,
                swapInfo: swapInfo,
                blockTimestamp: blockTimestamp,
                protocol: protocol
              });
            case 17:
              swapCall = _context18.sent;
              isExactEthInput = _this.getToken(input.currency).isNative && isExactIn;
              params = swapCall === null || swapCall === void 0 ? void 0 : swapCall.params;
              methodName = getMethodName({
                isExactInput: isExactIn,
                isInputNative: _this.getToken(input.currency).isNative,
                isOutputNative: _this.getToken(output.currency).isNative,
                protocol: protocol,
                params: params
              });
              swap = _objectSpread$l(_objectSpread$l({}, swapInfo), {}, {
                inputAmount: (_swapInfo$INPUT$amoun = swapInfo.INPUT.amount) === null || _swapInfo$INPUT$amoun === void 0 ? void 0 : _swapInfo$INPUT$amoun.quotient.toString(10),
                outputAmount: (_swapInfo$OUTPUT$amou = swapInfo.OUTPUT.amount) === null || _swapInfo$OUTPUT$amou === void 0 ? void 0 : _swapInfo$OUTPUT$amou.quotient.toString(10),
                state: _this.getTradeState((swapInfo === null || swapInfo === void 0 ? void 0 : (_swapInfo$trade = swapInfo.trade) === null || _swapInfo$trade === void 0 ? void 0 : _swapInfo$trade.state) || 0),
                params: {
                  methodParams: swapCall === null || swapCall === void 0 ? void 0 : swapCall.params,
                  value: isExactEthInput && protocol === 'V2' ? params.amountIn : undefined
                },
                methodName: methodName,
                protocol: 'UNISWAP',
                plugin: getPlugin$1({
                  plugins: _objectSpread$l({}, Uniswap$1.actions),
                  methodName: methodName
                })
              });
              return _context18.abrupt("return", swap);
            case 23:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }));
      return function (_x20) {
        return _ref36.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getSwapInfo", /*#__PURE__*/function () {
      var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(_ref37) {
        var _ref39, _trade$trade, _trade$trade2, _ref40;
        var amount, currencyIn, currencyOut, protocol, isExactIn, slippage, parsedAmount, hasAmounts, trade, amountIn, amountOut;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              amount = _ref37.amount, currencyIn = _ref37.currencyIn, currencyOut = _ref37.currencyOut, protocol = _ref37.protocol, isExactIn = _ref37.isExactIn, slippage = _ref37.slippage;
              parsedAmount = weiToCurrency(amount, (_ref39 = isExactIn ? currencyIn : currencyOut) !== null && _ref39 !== void 0 ? _ref39 : undefined);
              hasAmounts = currencyIn || currencyOut;
              _context19.next = 5;
              return _this.getBestTrade({
                tradeType: isExactIn ? TradeType$1.EXACT_INPUT : TradeType$1.EXACT_OUTPUT,
                protocol: protocol,
                amountSpecified: hasAmounts ? parsedAmount : undefined,
                otherCurrency: isExactIn ? currencyOut : currencyIn
              });
            case 5:
              trade = _context19.sent;
              amountIn = isExactIn ? parsedAmount : trade === null || trade === void 0 ? void 0 : (_trade$trade = trade.trade) === null || _trade$trade === void 0 ? void 0 : _trade$trade.inputAmount; //isWrapping || isExactIn ? parsedAmount : trade.trade?.inputAmount
              amountOut = !isExactIn ? parsedAmount : trade === null || trade === void 0 ? void 0 : (_trade$trade2 = trade.trade) === null || _trade$trade2 === void 0 ? void 0 : _trade$trade2.outputAmount; //isWrapping || !isExactIn ? parsedAmount : trade.trade?.outputAmount
              return _context19.abrupt("return", (_ref40 = {}, _defineProperty(_ref40, Field.INPUT, {
                currency: currencyIn,
                amount: amountIn
              }), _defineProperty(_ref40, Field.OUTPUT, {
                currency: currencyOut,
                amount: amountOut
              }), _defineProperty(_ref40, "trade", trade), _defineProperty(_ref40, "slippage", getSlippage(slippage)), _defineProperty(_ref40, "type", isExactIn ? UNISWAP_TYPE.EXACT_INPUT : UNISWAP_TYPE.EXACT_OUTPUT), _ref40));
            case 9:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }));
      return function (_x21) {
        return _ref38.apply(this, arguments);
      };
    }());
    /**
     * Returns the best v2+v3 trade for a desired swap.
     * @param tradeType whether the swap is an exact in/out
     * @param amountSpecified the exact amount to swap in/out
     * @param otherCurrency the desired output/payment currency
     */
    _defineProperty(_assertThisInitialized(_this), "getBestTrade", /*#__PURE__*/function () {
      var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(_ref41) {
        var _lastTrade$inputAmoun, _lastTrade$outputAmou;
        var tradeType, amountSpecified, protocol, otherCurrency, _assertThisInitialize2, library, clientSORTradeObject, tradeObject, lastTrade, state, trade, _ref43, _ref44, currencyIn, currencyOut, isStale;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              tradeType = _ref41.tradeType, amountSpecified = _ref41.amountSpecified, protocol = _ref41.protocol, otherCurrency = _ref41.otherCurrency;
              _assertThisInitialize2 = _assertThisInitialized(_this), library = _assertThisInitialize2.library;
              _context20.next = 4;
              return getClientSideSmartOrderRouterTrade({
                library: library,
                tradeType: tradeType,
                protocol: protocol,
                amountSpecified: amountSpecified,
                otherCurrency: otherCurrency
              });
            case 4:
              clientSORTradeObject = _context20.sent;
              tradeObject = clientSORTradeObject;
              lastTrade = tradeObject === null || tradeObject === void 0 ? void 0 : tradeObject.trade; // Return the last trade while syncing/loading to avoid jank from clearing the last trade while loading.
              // If the trade is unsettled and not stale, return the last trade as a placeholder during settling.
              if (tradeObject) {
                _context20.next = 9;
                break;
              }
              return _context20.abrupt("return");
            case 9:
              state = tradeObject.state, trade = tradeObject.trade; // If the trade is in a settled state, return it.
              if (!(state === TradeState.INVALID)) {
                _context20.next = 12;
                break;
              }
              return _context20.abrupt("return", INVALID_TRADE);
            case 12:
              if (!(state !== TradeState.LOADING && state !== TradeState.SYNCING || trade)) {
                _context20.next = 14;
                break;
              }
              return _context20.abrupt("return", tradeObject);
            case 14:
              _ref43 = tradeType === TradeType$1.EXACT_INPUT ? [amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency, otherCurrency] : [otherCurrency, amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency], _ref44 = _slicedToArray(_ref43, 2), currencyIn = _ref44[0], currencyOut = _ref44[1]; // If the trade currencies have switched, consider it stale - do not return the last trade.
              isStale = currencyIn && !(lastTrade !== null && lastTrade !== void 0 && (_lastTrade$inputAmoun = lastTrade.inputAmount) !== null && _lastTrade$inputAmoun !== void 0 && _lastTrade$inputAmoun.currency.equals(currencyIn)) || currencyOut && !(lastTrade !== null && lastTrade !== void 0 && (_lastTrade$outputAmou = lastTrade.outputAmount) !== null && _lastTrade$outputAmou !== void 0 && _lastTrade$outputAmou.currency.equals(currencyOut));
              if (!isStale) {
                _context20.next = 18;
                break;
              }
              return _context20.abrupt("return", tradeObject);
            case 18:
              return _context20.abrupt("return", {
                state: state,
                trade: lastTrade
              });
            case 19:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      return function (_x22) {
        return _ref42.apply(this, arguments);
      };
    }());
    return _this;
  }
  return _createClass(Uniswap);
}(Config);

var SWAP_ROUTER_ADDRESS = '0xE592427A0AEce92De3Edee1F18E0157C05861564';
var SWAP_ROUTER_ADDRESSES = [{
  address: SWAP_ROUTER_ADDRESS,
  chainId: 1
}, {
  address: SWAP_ROUTER_ADDRESS,
  chainId: 5
}, {
  address: SWAP_ROUTER_ADDRESS,
  chainId: 42161
}, {
  address: SWAP_ROUTER_ADDRESS,
  chainId: 421613
}, {
  address: '0x3bFA4769FB09eefC5a80d6E87c3B9C650f7Ae48E',
  chainId: 11155111
}];
var NONFUNGIBLE_POSITION_MANAGER_ADDRESS = '0xC36442b4a4522E871399CD717aBDD847Ab11FE88';
var NONFUNGIBLE_POSITION_MANAGER_ADDRESSES = [{
  address: NONFUNGIBLE_POSITION_MANAGER_ADDRESS,
  chainId: 1
}, {
  address: NONFUNGIBLE_POSITION_MANAGER_ADDRESS,
  chainId: 5
}, {
  address: NONFUNGIBLE_POSITION_MANAGER_ADDRESS,
  chainId: 42161
}, {
  address: NONFUNGIBLE_POSITION_MANAGER_ADDRESS,
  chainId: 421613
}];
var FACTORY_ADDRESS = '0x1F98431c8aD98523631AE4a59f267346ea31F984';

var IncreaseLiquidity = createPlugin({
  protocol: 'UNISWAP_V3',
  type: 'ACTION',
  method: 'increaseLiquidity',
  supportedContracts: NONFUNGIBLE_POSITION_MANAGER_ADDRESSES,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          params_tuple: {
            tokenId: new FctValue({
              destination: 'eip712_tokenId'
            }),
            amount0Desired: new FctValue({
              destination: 'wei_amount'
            }),
            amount1Desired: new FctValue({
              destination: 'wei_amount'
            }),
            amount0Min: new FctValue({
              destination: 'wei_amount'
            }),
            amount1Min: new FctValue({
              destination: 'wei_amount'
            }),
            deadline: new FctTimestamp({})
          }
        }
      },
      output: {
        liquidity: new FctValue({
          innerIndex: 0
        }),
        amount0: new FctValue({
          innerIndex: 1
        }),
        amount1: new FctValue({
          innerIndex: 2
        })
      }
    };
  },
  initParams: {
    methodParams: {
      params_tuple: {
        deadline: {
          type: 'global',
          id: 'blockTimestamp'
        },
        amount0Min: '0',
        amount1Min: '0'
      }
    }
  }
});

// P = (sqrtPriceX96 / 2^96) ^ 2
// Price of ETH = 1 / P x 1e12

/* 
  P = 1.0001 ** tick
  P = (sqrtPriceX96 / 2e96) ** 2

  L = sqrt((amount0 * amount1))

*/

var Mint$1 = createPlugin({
  protocol: 'UNISWAP_V3',
  type: 'ACTION',
  method: 'mint',
  supportedContracts: NONFUNGIBLE_POSITION_MANAGER_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          params_tuple: {
            token0: new FctAddress({
              destination: 'erc20',
              options: getAllCurrencies({
                chainId: chainId
              })
            }),
            token1: new FctAddress({
              destination: 'erc20',
              options: getAllCurrencies({
                chainId: chainId
              })
            }),
            fee: new FctValue24({}),
            tickLower: new FctInteger24({}),
            tickUpper: new FctInteger24({}),
            amount0Desired: new FctValue({
              destination: 'wei_amount'
            }),
            amount1Desired: new FctValue({
              destination: 'wei_amount'
            }),
            amount0Min: new FctValue({
              destination: 'wei_amount'
            }),
            amount1Min: new FctValue({
              destination: 'wei_amount'
            }),
            recipient: new FctAddress({}),
            deadline: new FctTimestamp({})
          }
        }
      },
      output: {
        tokenId: new FctValue({
          innerIndex: 0,
          destination: 'eip712_tokenId'
        }),
        liquidity: new FctValue({
          innerIndex: 1
        }),
        amount0: new FctValue({
          innerIndex: 2,
          destination: 'wei_amount'
        }),
        amount1: new FctValue({
          innerIndex: 3,
          destination: 'wei_amount'
        })
      }
    };
  },
  initParams: {
    methodParams: {
      params_tuple: {
        deadline: {
          type: 'global',
          id: 'blockTimestamp'
        }
      }
    }
  },
  requiredApprovals: function requiredApprovals(params) {
    var token0 = params === null || params === void 0 ? void 0 : params.methodParams['params_tuple'].token0.value;
    var token1 = params === null || params === void 0 ? void 0 : params.methodParams['params_tuple'].token1.value;
    return [{
      to: token0,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams['params_tuple'].amount0Desired.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }, {
      to: token1,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams['params_tuple'].amount1Desired.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

// import util from 'util'

var ZERO_HEX = '0x0';
var getV3SwapCallParamsFromTrade = function getV3SwapCallParamsFromTrade(trade, options) {
  !(!('ttl' in options) || options.ttl > 0) ? invariant(false, 'TTL') : void 0;
  var recipient = validateAndParseAddress$1(options.recipient);
  var amountIn = toHex(trade.maximumAmountIn(options.allowedSlippage));
  var amountOut = toHex(trade.minimumAmountOut(options.allowedSlippage));

  // If there is only one pool in the route, we use ExactInputSingle
  if (trade.routes[0].pools.length === 1) {
    var route = trade.routes[0];
    var pool = route.pools[0];
    var tokenIn = route.input.address;
    var tokenOut = route.output.address;
    if (trade.tradeType === TradeType$1.EXACT_INPUT) {
      var paramsExactInputSingle = {
        params_tuple: {
          tokenIn: tokenIn,
          tokenOut: tokenOut,
          fee: pool.fee,
          recipient: recipient,
          amountIn: amountIn,
          amountOutMinimum: amountOut,
          // This sqrtPriceLimitX96 value is what 1inch uses inside their swapper contract
          // sqrtPriceLimitX96: BigInt(4295128739 + 1).toString(),

          // Uniswap by default uses "0" as the sqrtPriceLimitX96
          sqrtPriceLimitX96: '0'
        }
      };
      return {
        params: paramsExactInputSingle,
        value: ZERO_HEX
      };
    }
    var paramsExactOutputSingle = {
      params_tuple: {
        tokenIn: tokenIn,
        tokenOut: tokenOut,
        fee: pool.fee,
        recipient: recipient,
        amountOut: amountOut,
        amountInMaximum: amountIn,
        // This sqrtPriceLimitX96 value is what 1inch uses inside their swapper contract
        // sqrtPriceLimitX96: (BigInt('1461446703485210103287273052203988822378723970342') - BigInt(1)).toString(),

        // Uniswap by default uses "0" as the sqrtPriceLimitX96
        sqrtPriceLimitX96: '0'
      }
    };
    return {
      params: paramsExactOutputSingle,
      value: ZERO_HEX
    };
  }
  var types = trade.routes[0].path.reduce(function (acc, token, index) {
    if (index === trade.routes[0].path.length - 1) {
      return [].concat(_toConsumableArray(acc), ['address']);
    }
    return [].concat(_toConsumableArray(acc), ['address', 'uint24']);
  }, []);
  var values = trade.routes[0].path.reduce(function (acc, token, index) {
    if (index === trade.routes[0].path.length - 1) {
      return [].concat(_toConsumableArray(acc), [token.address]);
    }
    var pool = trade.routes[0].pools[index];
    return [].concat(_toConsumableArray(acc), [token.address, pool.fee.toString()]);
  }, []);
  if (trade.tradeType === TradeType$1.EXACT_INPUT) {
    var paramsExactInput = {
      params_tuple: {
        path: utils.solidityPack(types, values),
        recipient: recipient,
        amountIn: amountIn,
        amountOutMinimum: amountOut
      }
    };
    return {
      params: paramsExactInput,
      value: ZERO_HEX
    };
  }
  var paramsExactOutput = {
    params_tuple: {
      path: utils.solidityPack(types, values.reverse()),
      recipient: recipient,
      amountOut: amountOut,
      amountInMaximum: amountIn
    }
  };
  return {
    params: paramsExactOutput,
    value: ZERO_HEX
  };
};

/**
 * Returns the swap calls that can be used to make the trade on V3 protocol
 * @param trade trade to execute
 * @param allowedSlippage user allowed slippage
 * @param recipientAddressOrName the ENS name or address of the recipient of the swap output
 * @param signatureData the signature data of the permit of the input token amount, if available
 */
function getSwapCallV3Params(_ref) {
  var library = _ref.library,
    account = _ref.account,
    chainId = _ref.chainId,
    trade = _ref.trade,
    allowedSlippage = _ref.allowedSlippage,
    deadline = _ref.deadline;
  var recipient = account;
  var routerContract = getV3RouterContract(library, account, chainId);
  if (!trade || !recipient || !library || !account || !chainId || !deadline) return undefined;
  if (!routerContract) return undefined;
  var params = getV3SwapCallParamsFromTrade(trade, {
    feeOnTransfer: false,
    allowedSlippage: allowedSlippage,
    recipient: recipient,
    deadline: deadline.toNumber()
  });
  return {
    address: routerContract.address,
    params: params.params,
    value: params.value
  };
}

// eslint-disable-next-line no-restricted-imports
var getSwapCallback = function getSwapCallback(_ref) {
  var library = _ref.library,
    account = _ref.account,
    chainId = _ref.chainId,
    trade = _ref.trade,
    allowedSlippage = _ref.allowedSlippage,
    deadline = _ref.deadline,
    protocol = _ref.protocol;
  if (protocol === 'V3') {
    var swapCalls = getSwapCallV3Params({
      library: library,
      account: account,
      chainId: chainId,
      trade: trade,
      allowedSlippage: allowedSlippage,
      deadline: deadline
    });
    return swapCalls;
  }
  return undefined;
};

var getSwapCall = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var library, account, swapInfo, chainId, blockTimestamp, protocol, trade, slippage, deadline;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          library = _ref.library, account = _ref.account, swapInfo = _ref.swapInfo, chainId = _ref.chainId, blockTimestamp = _ref.blockTimestamp, protocol = _ref.protocol;
          trade = swapInfo.trade, slippage = swapInfo.slippage;
          deadline = getTransactionDeadline({
            chainId: chainId,
            blockTimestamp: blockTimestamp
          });
          return _context.abrupt("return", getSwapCallback({
            library: library,
            account: account,
            chainId: chainId,
            trade: trade.trade,
            allowedSlippage: slippage.allowed,
            deadline: deadline,
            protocol: protocol
          }));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSwapCall(_x) {
    return _ref2.apply(this, arguments);
  };
}();

function ownKeys$k(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$k(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$k(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$k(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var MULTICALL_ADDRESSES = {
  1: '0x5BA1e12693Dc8F9c48aAD8770482f4739bEeD696',
  3: '0x5BA1e12693Dc8F9c48aAD8770482f4739bEeD696'
};
var getToken$1 = function getToken(swapToken, chainId) {
  return new Token(chainId, getAddress(swapToken.address), swapToken.decimals);
};
var multicall = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(calls, provider, chainId) {
    var multicallContract, _yield$multicallContr, _yield$multicallContr2, returnData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          multicallContract = new ethers.Contract(MULTICALL_ADDRESSES[chainId], ['function aggregate((address target, bytes callData)[] calls) external view returns (uint256 blockNumber, bytes[] returnData)'], provider);
          _context.next = 3;
          return multicallContract.aggregate(calls);
        case 3:
          _yield$multicallContr = _context.sent;
          _yield$multicallContr2 = _slicedToArray(_yield$multicallContr, 2);
          returnData = _yield$multicallContr2[1];
          return _context.abrupt("return", calls.map(function (call, i) {
            var returnTypes = call.returnTypes;
            var types = returnTypes.map(function (type) {
              return type.type;
            });
            var decoded = ethers.utils.defaultAbiCoder.decode(types, returnData[i]);
            var decodedData = decoded.reduce(function (acc, value, i) {
              var name = returnTypes[i].name;
              value = BigNumber.isBigNumber(value) ? value.toString() : value;
              return _objectSpread$k(_objectSpread$k({}, acc), {}, _defineProperty({}, name, value));
            }, {});
            return decodedData;
          }));
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function multicall(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

function ownKeys$j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$j(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper$4(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }
function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var IUniswapV3PoolABI = IUniswapV3PoolJson.abi;
var REJECT_PREV_REQUEST_ERROR$2 = 'reject previous values';
var UniswapV3$1 = /*#__PURE__*/function (_Config) {
  _inherits(UniswapV3, _Config);
  var _super = _createSuper$6(UniswapV3);
  function UniswapV3(_ref) {
    var _this;
    var _chainId = _ref.chainId,
      _account = _ref.account,
      provider = _ref.provider;
    _classCallCheck(this, UniswapV3);
    _this = _super.call(this, {
      chainId: _chainId,
      account: _account,
      provider: provider
    });
    _defineProperty(_assertThisInitialized(_this), "promiseReject", undefined);
    _defineProperty(_assertThisInitialized(_this), "getSwapParams", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var input, output, slippage, swapValues;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              input = _ref2.input, output = _ref2.output, slippage = _ref2.slippage;
              _context.prev = 1;
              _context.next = 4;
              return _this.getLastSwapParamsV3({
                input: input,
                output: output,
                slippage: slippage
              });
            case 4:
              swapValues = _context.sent;
              return _context.abrupt("return", swapValues);
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              if (!(_context.t0 === REJECT_PREV_REQUEST_ERROR$2)) {
                _context.next = 12;
                break;
              }
              return _context.abrupt("return", undefined);
            case 12:
              throw new Error(_context.t0);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 8]]);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "mintPosition", function (_ref4) {
      var configuredPool = _ref4.configuredPool,
        tokenA = _ref4.tokenA,
        tokenB = _ref4.tokenB,
        priceUpper = _ref4.priceUpper,
        priceLower = _ref4.priceLower,
        isPriceInverted = _ref4.isPriceInverted;
      var decimalDiff = configuredPool.token1.decimals - configuredPool.token0.decimals;
      var tickUpper = _this.priceToTick(priceUpper, decimalDiff, isPriceInverted, TICK_SPACINGS[configuredPool.fee]);
      var tickLower = _this.priceToTick(priceLower, decimalDiff, isPriceInverted, TICK_SPACINGS[configuredPool.fee]);
      if (isPriceInverted) {
        var _ref5 = [tickLower, tickUpper];
        tickUpper = _ref5[0];
        tickLower = _ref5[1];
      }
      if (tokenA && tokenA.amount) {
        var position = Position.fromAmount0({
          pool: configuredPool,
          tickUpper: tickUpper,
          tickLower: tickLower,
          amount0: tokenA.amount,
          useFullPrecision: true
        });
        return {
          amount0: position.amount0.quotient.toString(),
          amount1: position.amount1.quotient.toString(),
          liquidity: position.liquidity.toString(),
          tickLower: position.tickLower,
          tickUpper: position.tickUpper,
          plugin: Mint$1,
          params: {
            methodParams: {
              params_tuple: {
                token0: configuredPool.token0.address,
                token1: configuredPool.token1.address,
                fee: configuredPool.fee,
                tickLower: position.tickLower,
                tickUpper: position.tickUpper,
                amount0Desired: position.amount0.quotient.toString(),
                amount1Desired: position.amount1.quotient.toString(),
                amount0Min: '0',
                amount1Min: '0',
                recipient: _this.account,
                deadline: {
                  type: 'global',
                  id: 'blockTimestamp'
                }
              }
            }
          }
        };
      }
      if (tokenB && tokenB.amount) {
        var _position = Position.fromAmount1({
          pool: configuredPool,
          tickUpper: tickUpper,
          tickLower: tickLower,
          amount1: tokenB.amount
        });
        return {
          amount0: _position.amount0.quotient.toString(),
          amount1: _position.amount1.quotient.toString(),
          liquidity: _position.liquidity.toString(),
          tickLower: _position.tickLower,
          tickUpper: _position.tickUpper,
          plugin: Mint$1,
          params: {
            methodParams: {
              params_tuple: {
                token0: configuredPool.token0.address,
                token1: configuredPool.token1.address,
                fee: configuredPool.fee,
                tickLower: _position.tickLower,
                tickUpper: _position.tickUpper,
                amount0Desired: _position.amount0.quotient.toString(),
                amount1Desired: _position.amount1.quotient.toString(),
                amount0Min: '0',
                amount1Min: '0',
                recipient: _this.account,
                deadline: {
                  type: 'global',
                  id: 'blockTimestamp'
                }
              }
            }
          }
        };
      }
      return undefined;
    });
    _defineProperty(_assertThisInitialized(_this), "getAddLiquidity", function (_ref6) {
      var configuredPool = _ref6.configuredPool,
        tokenA = _ref6.tokenA,
        tokenB = _ref6.tokenB,
        tokenId = _ref6.tokenId,
        tickLower = _ref6.tickLower,
        tickUpper = _ref6.tickUpper;
      if (tokenA && tokenA.amount) {
        var position = Position.fromAmount0({
          pool: configuredPool,
          tickUpper: tickUpper,
          tickLower: tickLower,
          amount0: tokenA.amount,
          useFullPrecision: true
        });
        return {
          amount0: position.amount0.quotient.toString(),
          amount1: position.amount1.quotient.toString(),
          plugin: IncreaseLiquidity,
          params: {
            methodParams: {
              params_tuple: {
                tokenId: tokenId,
                amount0Desired: position.amount0.quotient.toString(),
                amount1Desired: position.amount1.quotient.toString(),
                amount0Min: '0',
                amount1Min: '0',
                deadline: {
                  type: 'global',
                  id: 'blockTimestamp'
                }
              }
            }
          }
        };
      }
      if (tokenB && tokenB.amount) {
        var _position2 = Position.fromAmount1({
          pool: configuredPool,
          tickUpper: tickUpper,
          tickLower: tickLower,
          amount1: tokenB.amount
        });
        return {
          amount0: _position2.amount0.quotient.toString(),
          amount1: _position2.amount1.quotient.toString(),
          plugin: IncreaseLiquidity,
          params: {
            methodParams: {
              params_tuple: {
                tokenId: tokenId,
                amount0Desired: _position2.amount0.quotient.toString(),
                amount1Desired: _position2.amount1.quotient.toString(),
                amount0Min: '0',
                amount1Min: '0',
                deadline: {
                  type: 'global',
                  id: 'blockTimestamp'
                }
              }
            }
          }
        };
      }
      return undefined;
    });
    _defineProperty(_assertThisInitialized(_this), "fees", [500, 3000, 10000]);
    _defineProperty(_assertThisInitialized(_this), "isPairExist", /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref7) {
        var token0, token1, token0Contract, token1Contract, decimals0, decimals1, _iterator, _step, fee, pool;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              token0 = _ref7.token0, token1 = _ref7.token1;
              token0Contract = new ethers.Contract(token0, ['function decimals() view returns (uint8 decimals)'], _this.library);
              token1Contract = new ethers.Contract(token1, ['function decimals() view returns (uint8 decimals)'], _this.library);
              decimals0 = 18;
              _context2.prev = 4;
              _context2.next = 7;
              return token0Contract.decimals();
            case 7:
              decimals0 = _context2.sent;
              _context2.next = 13;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](4);
              console.error(_context2.t0);
            case 13:
              decimals1 = 18;
              _context2.prev = 14;
              _context2.next = 17;
              return token1Contract.decimals();
            case 17:
              decimals1 = _context2.sent;
              _context2.next = 23;
              break;
            case 20:
              _context2.prev = 20;
              _context2.t1 = _context2["catch"](14);
              console.error(_context2.t1);
            case 23:
              _iterator = _createForOfIteratorHelper$4(_this.fees);
              _context2.prev = 24;
              _iterator.s();
            case 26:
              if ((_step = _iterator.n()).done) {
                _context2.next = 35;
                break;
              }
              fee = _step.value;
              _context2.next = 30;
              return _this.getPoolInstance({
                tokenA: {
                  address: token0,
                  decimals: decimals0
                },
                tokenB: {
                  address: token1,
                  decimals: decimals1
                },
                fee: fee
              });
            case 30:
              pool = _context2.sent;
              if (!pool) {
                _context2.next = 33;
                break;
              }
              return _context2.abrupt("return", {
                path: "".concat(token0, "00").concat(BigNumber.from(pool.fee).toHexString().replace('0x', '')).concat(token1.replace('0x', '')),
                fee: pool.fee
              });
            case 33:
              _context2.next = 26;
              break;
            case 35:
              _context2.next = 40;
              break;
            case 37:
              _context2.prev = 37;
              _context2.t2 = _context2["catch"](24);
              _iterator.e(_context2.t2);
            case 40:
              _context2.prev = 40;
              _iterator.f();
              return _context2.finish(40);
            case 43:
              return _context2.abrupt("return", false);
            case 44:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[4, 10], [14, 20], [24, 37, 40, 43]]);
      }));
      return function (_x2) {
        return _ref8.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getPoolInstance", /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref9) {
        var tokenA, tokenB, fee, poolAddress, token0, token1, tickSpacing, poolContract, _yield$Promise$all, _yield$Promise$all2, liquidity, slot0, pool;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              tokenA = _ref9.tokenA, tokenB = _ref9.tokenB, fee = _ref9.fee;
              poolAddress = _this.getPoolAddress({
                tokenA: tokenA,
                tokenB: tokenB,
                fee: fee
              });
              token0 = _this.getToken(tokenA);
              token1 = _this.getToken(tokenB);
              tickSpacing = TICK_SPACINGS[fee];
              poolContract = new ethers.Contract(poolAddress, IUniswapV3PoolABI, _this.library);
              _context3.prev = 6;
              _context3.next = 9;
              return Promise.all([poolContract.liquidity(), poolContract.slot0()]);
            case 9:
              _yield$Promise$all = _context3.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              liquidity = _yield$Promise$all2[0];
              slot0 = _yield$Promise$all2[1];
              pool = new Pool(token0, token1, fee, slot0.sqrtPriceX96.toString(), liquidity.toString(), slot0.tick);
              return _context3.abrupt("return", {
                tickSpacing: tickSpacing,
                price: pool.priceOf(token0).quotient.toString(),
                priceNormalised: pool.priceOf(token0).toSignificant(),
                invertedPrice: pool.token1Price.toFixed(),
                invertedPriceNormalised: pool.priceOf(token1).toSignificant(),
                priceDecimals: pool.token0.decimals - pool.token1.decimals,
                tick: pool.tickCurrent,
                configuredPool: pool,
                fee: pool.fee
              });
            case 17:
              _context3.prev = 17;
              _context3.t0 = _context3["catch"](6);
              console.error('Pool not found');
              return _context3.abrupt("return");
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[6, 17]]);
      }));
      return function (_x3) {
        return _ref10.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getPosition", /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(tokenId) {
        var position;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this.NFTManagerContract.positions(tokenId);
            case 2:
              position = _context4.sent;
              return _context4.abrupt("return", _objectSpread$j({}, position));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x4) {
        return _ref11.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getPoolAddress", function (_ref12) {
      var tokenA = _ref12.tokenA,
        tokenB = _ref12.tokenB,
        fee = _ref12.fee;
      return computePoolAddress({
        factoryAddress: FACTORY_ADDRESS,
        tokenA: _this.getToken(tokenA),
        tokenB: _this.getToken(tokenB),
        fee: fee
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getUserPositions", /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(account) {
        var balance, tokenIDsCalls, tokenIDs, positionsCalls, positions;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this.NFTManagerContract.balanceOf(account);
            case 2:
              balance = _context5.sent;
              if (!(balance.toNumber() === 0)) {
                _context5.next = 5;
                break;
              }
              return _context5.abrupt("return", []);
            case 5:
              tokenIDsCalls = Array.from(Array(balance.toNumber()).keys()).map(function (i) {
                return {
                  target: _this.NFTManagerContract.address,
                  callData: _this.NFTManagerContract.interface.encodeFunctionData('tokenOfOwnerByIndex', [account, i]),
                  returnTypes: [{
                    name: 'tokenId',
                    type: 'uint256'
                  }]
                };
              });
              _context5.next = 8;
              return multicall(tokenIDsCalls, _this.library, _this.chainId);
            case 8:
              tokenIDs = _context5.sent;
              positionsCalls = tokenIDs.map(function (value) {
                return {
                  target: _this.NFTManagerContract.address,
                  callData: _this.NFTManagerContract.interface.encodeFunctionData('positions', [value.tokenId]),
                  returnTypes: [{
                    name: 'nonce',
                    type: 'uint96'
                  }, {
                    name: 'operator',
                    type: 'address'
                  }, {
                    name: 'token0',
                    type: 'address'
                  }, {
                    name: 'token1',
                    type: 'address'
                  }, {
                    name: 'fee',
                    type: 'uint24'
                  }, {
                    name: 'tickLower',
                    type: 'int24'
                  }, {
                    name: 'tickUpper',
                    type: 'int24'
                  }, {
                    name: 'liquidity',
                    type: 'uint128'
                  }, {
                    name: 'feeGrowthInside0LastX128',
                    type: 'uint256'
                  }, {
                    name: 'feeGrowthInside1LastX128',
                    type: 'uint256'
                  }, {
                    name: 'tokensOwed0',
                    type: 'uint128'
                  }, {
                    name: 'tokensOwed1',
                    type: 'uint128'
                  }]
                };
              });
              _context5.next = 12;
              return multicall(positionsCalls, _this.library, _this.chainId);
            case 12:
              positions = _context5.sent;
              return _context5.abrupt("return", positions.map(function (position, i) {
                return _objectSpread$j(_objectSpread$j({}, position), {}, {
                  tokenId: tokenIDs[i].tokenId
                });
              }));
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x5) {
        return _ref13.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "priceToTick", function (price, decimalDiff) {
      var isPriceInverted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var tickSpacing = arguments.length > 3 ? arguments[3] : undefined;
      var p = !isPriceInverted ? parseFloat(price) : 1 / parseFloat(price);
      return nearestUsableTick(Math.floor(Math.log(p * Math.pow(10, decimalDiff)) / Math.log(1.0001)), tickSpacing);
    });
    _defineProperty(_assertThisInitialized(_this), "getToken", function (swapToken) {
      var chainId = _this.chainId;
      return getToken$1(swapToken, chainId);
    });
    _defineProperty(_assertThisInitialized(_this), "getLastSwapParamsV3", /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref14) {
        var _this$promiseReject, _this2;
        var input, output, slippage;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              input = _ref14.input, output = _ref14.output, slippage = _ref14.slippage;
              (_this$promiseReject = (_this2 = _this).promiseReject) === null || _this$promiseReject === void 0 ? void 0 : _this$promiseReject.call(_this2, REJECT_PREV_REQUEST_ERROR$2);
              return _context7.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(resolve, regect) {
                  var values;
                  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        _this.promiseReject = regect;
                        _context6.next = 3;
                        return _this.getSwapValuesV3({
                          input: input,
                          output: output,
                          slippage: slippage
                        });
                      case 3:
                        values = _context6.sent;
                        resolve(values);
                      case 5:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x7, _x8) {
                  return _ref16.apply(this, arguments);
                };
              }()));
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function (_x6) {
        return _ref15.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getSwapValuesV3", /*#__PURE__*/function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref17) {
        var input, output, slippage;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              input = _ref17.input, output = _ref17.output, slippage = _ref17.slippage;
              return _context8.abrupt("return", _this.getSwapValues({
                input: input,
                output: output,
                protocol: 'V3',
                slippage: slippage
              }));
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      return function (_x9) {
        return _ref18.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getTradeState", function (stateindex) {
      switch (stateindex) {
        case 3:
          return 'VALID';
        default:
          return 'INVALID';
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getSwapValues", /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref19) {
        var _swapInfo$INPUT$amoun, _swapInfo$OUTPUT$amou, _swapInfo$trade;
        var input, output, protocol, slippage, _assertThisInitialize, library, account, chainId, currencyIn, currencyOut, isExactIn, _yield$_this$getLastB, blockTimestamp, swapInfo, swapCall, params, methodName, swap;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              input = _ref19.input, output = _ref19.output, protocol = _ref19.protocol, slippage = _ref19.slippage;
              if (input.currency) {
                _context9.next = 3;
                break;
              }
              throw new Error('input currency required');
            case 3:
              if (output.currency) {
                _context9.next = 5;
                break;
              }
              throw new Error('output currency required');
            case 5:
              if (!(!input.amount && !output.amount)) {
                _context9.next = 7;
                break;
              }
              return _context9.abrupt("return", {
                inputAmount: '0',
                outputAmount: '0',
                state: 'INVALID',
                params: undefined,
                INPUT: {
                  currency: undefined,
                  amount: undefined
                },
                OUTPUT: {
                  currency: undefined,
                  amount: undefined
                },
                trade: undefined,
                slippage: undefined,
                type: undefined,
                methodName: undefined,
                protocol: 'UNISWAP'
              });
            case 7:
              _assertThisInitialize = _assertThisInitialized(_this), library = _assertThisInitialize.library, account = _assertThisInitialize.account, chainId = _assertThisInitialize.chainId;
              currencyIn = _this.getToken(input.currency);
              currencyOut = _this.getToken(output.currency);
              isExactIn = Boolean(input.amount);
              _context9.next = 13;
              return _this.getLastBlock();
            case 13:
              _yield$_this$getLastB = _context9.sent;
              blockTimestamp = _yield$_this$getLastB.blockTimestamp;
              _context9.next = 17;
              return _this.getSwapInfo({
                amount: input.amount || output.amount || '0',
                currencyIn: currencyIn,
                currencyOut: currencyOut,
                isExactIn: isExactIn,
                protocol: protocol,
                slippage: slippage
              });
            case 17:
              swapInfo = _context9.sent;
              _context9.next = 20;
              return getSwapCall({
                library: library,
                chainId: chainId,
                account: account,
                swapInfo: swapInfo,
                blockTimestamp: blockTimestamp,
                protocol: protocol
              });
            case 20:
              swapCall = _context9.sent;
              params = swapCall === null || swapCall === void 0 ? void 0 : swapCall.params;
              methodName = getMethodName({
                isExactInput: isExactIn,
                isInputNative: _this.getToken(input.currency).isNative,
                isOutputNative: _this.getToken(output.currency).isNative,
                protocol: protocol,
                params: params
              });
              swap = _objectSpread$j(_objectSpread$j({}, swapInfo), {}, {
                inputAmount: (_swapInfo$INPUT$amoun = swapInfo.INPUT.amount) === null || _swapInfo$INPUT$amoun === void 0 ? void 0 : _swapInfo$INPUT$amoun.quotient.toString(10),
                outputAmount: (_swapInfo$OUTPUT$amou = swapInfo.OUTPUT.amount) === null || _swapInfo$OUTPUT$amou === void 0 ? void 0 : _swapInfo$OUTPUT$amou.quotient.toString(10),
                state: _this.getTradeState((swapInfo === null || swapInfo === void 0 ? void 0 : (_swapInfo$trade = swapInfo.trade) === null || _swapInfo$trade === void 0 ? void 0 : _swapInfo$trade.state) || 0),
                params: {
                  methodParams: swapCall === null || swapCall === void 0 ? void 0 : swapCall.params
                },
                methodName: methodName,
                protocol: 'UNISWAP'
              });
              return _context9.abrupt("return", swap);
            case 25:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      return function (_x10) {
        return _ref20.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getSwapInfo", /*#__PURE__*/function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref21) {
        var _ref23, _trade$trade, _trade$trade2, _ref24;
        var amount, currencyIn, currencyOut, protocol, isExactIn, slippage, parsedAmount, hasAmounts, trade, amountIn, amountOut;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              amount = _ref21.amount, currencyIn = _ref21.currencyIn, currencyOut = _ref21.currencyOut, protocol = _ref21.protocol, isExactIn = _ref21.isExactIn, slippage = _ref21.slippage;
              parsedAmount = weiToCurrency(amount, (_ref23 = isExactIn ? currencyIn : currencyOut) !== null && _ref23 !== void 0 ? _ref23 : undefined);
              hasAmounts = currencyIn || currencyOut;
              _context10.next = 5;
              return _this.getBestTrade({
                tradeType: isExactIn ? TradeType$1.EXACT_INPUT : TradeType$1.EXACT_OUTPUT,
                protocol: protocol,
                amountSpecified: hasAmounts ? parsedAmount : undefined,
                otherCurrency: isExactIn ? currencyOut : currencyIn
              });
            case 5:
              trade = _context10.sent;
              amountIn = isExactIn ? parsedAmount : trade === null || trade === void 0 ? void 0 : (_trade$trade = trade.trade) === null || _trade$trade === void 0 ? void 0 : _trade$trade.inputAmount; //isWrapping || isExactIn ? parsedAmount : trade.trade?.inputAmount
              amountOut = !isExactIn ? parsedAmount : trade === null || trade === void 0 ? void 0 : (_trade$trade2 = trade.trade) === null || _trade$trade2 === void 0 ? void 0 : _trade$trade2.outputAmount; //isWrapping || !isExactIn ? parsedAmount : trade.trade?.outputAmount
              return _context10.abrupt("return", (_ref24 = {}, _defineProperty(_ref24, Field.INPUT, {
                currency: currencyIn,
                amount: amountIn
              }), _defineProperty(_ref24, Field.OUTPUT, {
                currency: currencyOut,
                amount: amountOut
              }), _defineProperty(_ref24, "trade", trade), _defineProperty(_ref24, "slippage", getSlippage(slippage)), _defineProperty(_ref24, "type", isExactIn ? UNISWAP_TYPE.EXACT_INPUT : UNISWAP_TYPE.EXACT_OUTPUT), _ref24));
            case 9:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      return function (_x11) {
        return _ref22.apply(this, arguments);
      };
    }());
    /**
     * Returns the best v2+v3 trade for a desired swap.
     * @param tradeType whether the swap is an exact in/out
     * @param amountSpecified the exact amount to swap in/out
     * @param otherCurrency the desired output/payment currency
     */
    _defineProperty(_assertThisInitialized(_this), "getBestTrade", /*#__PURE__*/function () {
      var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref25) {
        var _lastTrade$inputAmoun, _lastTrade$outputAmou;
        var tradeType, amountSpecified, protocol, otherCurrency, _assertThisInitialize2, library, clientSORTradeObject, tradeObject, lastTrade, state, trade, _ref27, _ref28, currencyIn, currencyOut, isStale;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              tradeType = _ref25.tradeType, amountSpecified = _ref25.amountSpecified, protocol = _ref25.protocol, otherCurrency = _ref25.otherCurrency;
              _assertThisInitialize2 = _assertThisInitialized(_this), library = _assertThisInitialize2.library;
              _context11.next = 4;
              return getClientSideSmartOrderRouterTrade({
                library: library,
                tradeType: tradeType,
                protocol: protocol,
                amountSpecified: amountSpecified,
                otherCurrency: otherCurrency
              });
            case 4:
              clientSORTradeObject = _context11.sent;
              tradeObject = clientSORTradeObject;
              lastTrade = tradeObject === null || tradeObject === void 0 ? void 0 : tradeObject.trade; // Return the last trade while syncing/loading to avoid jank from clearing the last trade while loading.
              // If the trade is unsettled and not stale, return the last trade as a placeholder during settling.
              if (tradeObject) {
                _context11.next = 9;
                break;
              }
              return _context11.abrupt("return");
            case 9:
              state = tradeObject.state, trade = tradeObject.trade; // If the trade is in a settled state, return it.
              if (!(state === TradeState.INVALID)) {
                _context11.next = 12;
                break;
              }
              return _context11.abrupt("return", INVALID_TRADE);
            case 12:
              if (!(state !== TradeState.LOADING && state !== TradeState.SYNCING || trade)) {
                _context11.next = 14;
                break;
              }
              return _context11.abrupt("return", tradeObject);
            case 14:
              _ref27 = tradeType === TradeType$1.EXACT_INPUT ? [amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency, otherCurrency] : [otherCurrency, amountSpecified === null || amountSpecified === void 0 ? void 0 : amountSpecified.currency], _ref28 = _slicedToArray(_ref27, 2), currencyIn = _ref28[0], currencyOut = _ref28[1]; // If the trade currencies have switched, consider it stale - do not return the last trade.
              isStale = currencyIn && !(lastTrade !== null && lastTrade !== void 0 && (_lastTrade$inputAmoun = lastTrade.inputAmount) !== null && _lastTrade$inputAmoun !== void 0 && _lastTrade$inputAmoun.currency.equals(currencyIn)) || currencyOut && !(lastTrade !== null && lastTrade !== void 0 && (_lastTrade$outputAmou = lastTrade.outputAmount) !== null && _lastTrade$outputAmou !== void 0 && _lastTrade$outputAmou.currency.equals(currencyOut));
              if (!isStale) {
                _context11.next = 18;
                break;
              }
              return _context11.abrupt("return", tradeObject);
            case 18:
              return _context11.abrupt("return", {
                state: state,
                trade: lastTrade
              });
            case 19:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
      return function (_x12) {
        return _ref26.apply(this, arguments);
      };
    }());
    _this.NFTManagerContract = new ethers.Contract(NONFUNGIBLE_POSITION_MANAGER_ADDRESSES$1[_this.chainId], NonfungiblePositionManagerABI.abi, _this.library);
    return _this;
  }
  return _createClass(UniswapV3);
}(Config);

var Tokens = /*#__PURE__*/_createClass(function Tokens() {
  _classCallCheck(this, Tokens);
});
_defineProperty(Tokens, "aaveGoerliErc20", aaveGoerliErc20);
_defineProperty(Tokens, "aaveMainnetErc20", aaveMainnetErc20);
_defineProperty(Tokens, "uniswapDefaultErc20", uniswapDefaultErc20);

var OneInchRouterABI = [
	{
		inputs: [
			{
				internalType: "contract IWETH",
				name: "weth",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
		],
		name: "AccessDenied",
		type: "error"
	},
	{
		inputs: [
		],
		name: "AdvanceNonceFailed",
		type: "error"
	},
	{
		inputs: [
		],
		name: "AlreadyFilled",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ArbitraryStaticCallFailed",
		type: "error"
	},
	{
		inputs: [
		],
		name: "BadPool",
		type: "error"
	},
	{
		inputs: [
		],
		name: "BadSignature",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ETHTransferFailed",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ETHTransferFailed",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyPools",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EthDepositRejected",
		type: "error"
	},
	{
		inputs: [
		],
		name: "GetAmountCallFailed",
		type: "error"
	},
	{
		inputs: [
		],
		name: "IncorrectDataLength",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InsufficientBalance",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidMsgValue",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidMsgValue",
		type: "error"
	},
	{
		inputs: [
		],
		name: "InvalidatedOrder",
		type: "error"
	},
	{
		inputs: [
		],
		name: "MakingAmountExceeded",
		type: "error"
	},
	{
		inputs: [
		],
		name: "MakingAmountTooLow",
		type: "error"
	},
	{
		inputs: [
		],
		name: "OnlyOneAmountShouldBeZero",
		type: "error"
	},
	{
		inputs: [
		],
		name: "OrderExpired",
		type: "error"
	},
	{
		inputs: [
		],
		name: "PermitLengthTooLow",
		type: "error"
	},
	{
		inputs: [
		],
		name: "PredicateIsNotTrue",
		type: "error"
	},
	{
		inputs: [
		],
		name: "PrivateOrder",
		type: "error"
	},
	{
		inputs: [
		],
		name: "RFQBadSignature",
		type: "error"
	},
	{
		inputs: [
		],
		name: "RFQPrivateOrder",
		type: "error"
	},
	{
		inputs: [
		],
		name: "RFQSwapWithZeroAmount",
		type: "error"
	},
	{
		inputs: [
		],
		name: "RFQZeroTargetIsForbidden",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ReentrancyDetected",
		type: "error"
	},
	{
		inputs: [
		],
		name: "RemainingAmountIsZero",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ReservesCallFailed",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ReturnAmountIsNotEnough",
		type: "error"
	},
	{
		inputs: [
		],
		name: "SafePermitBadLength",
		type: "error"
	},
	{
		inputs: [
		],
		name: "SafeTransferFailed",
		type: "error"
	},
	{
		inputs: [
		],
		name: "SafeTransferFromFailed",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "bool",
				name: "success",
				type: "bool"
			},
			{
				internalType: "bytes",
				name: "res",
				type: "bytes"
			}
		],
		name: "SimulationResults",
		type: "error"
	},
	{
		inputs: [
		],
		name: "SwapAmountTooLarge",
		type: "error"
	},
	{
		inputs: [
		],
		name: "SwapWithZeroAmount",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TakingAmountExceeded",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TakingAmountIncreased",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TakingAmountTooHigh",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TransferFromMakerToTakerFailed",
		type: "error"
	},
	{
		inputs: [
		],
		name: "TransferFromTakerToMakerFailed",
		type: "error"
	},
	{
		inputs: [
		],
		name: "UnknownOrder",
		type: "error"
	},
	{
		inputs: [
		],
		name: "WrongAmount",
		type: "error"
	},
	{
		inputs: [
		],
		name: "WrongGetter",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ZeroAddress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ZeroMinReturn",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ZeroReturnAmount",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ZeroTargetIsForbidden",
		type: "error"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "maker",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "newNonce",
				type: "uint256"
			}
		],
		name: "NonceIncreased",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "maker",
				type: "address"
			},
			{
				indexed: false,
				internalType: "bytes32",
				name: "orderHash",
				type: "bytes32"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "remainingRaw",
				type: "uint256"
			}
		],
		name: "OrderCanceled",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "maker",
				type: "address"
			},
			{
				indexed: false,
				internalType: "bytes32",
				name: "orderHash",
				type: "bytes32"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "remaining",
				type: "uint256"
			}
		],
		name: "OrderFilled",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "bytes32",
				name: "orderHash",
				type: "bytes32"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "makingAmount",
				type: "uint256"
			}
		],
		name: "OrderFilledRFQ",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "previousOwner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "newOwner",
				type: "address"
			}
		],
		name: "OwnershipTransferred",
		type: "event"
	},
	{
		inputs: [
			{
				internalType: "uint8",
				name: "amount",
				type: "uint8"
			}
		],
		name: "advanceNonce",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "offsets",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "and",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "target",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "arbitraryStaticCall",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "salt",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "makerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "takerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "maker",
						type: "address"
					},
					{
						internalType: "address",
						name: "receiver",
						type: "address"
					},
					{
						internalType: "address",
						name: "allowedSender",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "makingAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "takingAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "offsets",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "interactions",
						type: "bytes"
					}
				],
				internalType: "struct OrderLib.Order",
				name: "order",
				type: "tuple"
			}
		],
		name: "cancelOrder",
		outputs: [
			{
				internalType: "uint256",
				name: "orderRemaining",
				type: "uint256"
			},
			{
				internalType: "bytes32",
				name: "orderHash",
				type: "bytes32"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "orderInfo",
				type: "uint256"
			}
		],
		name: "cancelOrderRFQ",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "orderInfo",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "additionalMask",
				type: "uint256"
			}
		],
		name: "cancelOrderRFQ",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "salt",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "makerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "takerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "maker",
						type: "address"
					},
					{
						internalType: "address",
						name: "receiver",
						type: "address"
					},
					{
						internalType: "address",
						name: "allowedSender",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "makingAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "takingAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "offsets",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "interactions",
						type: "bytes"
					}
				],
				internalType: "struct OrderLib.Order",
				name: "order",
				type: "tuple"
			}
		],
		name: "checkPredicate",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract IClipperExchangeInterface",
				name: "clipperExchange",
				type: "address"
			},
			{
				internalType: "contract IERC20",
				name: "srcToken",
				type: "address"
			},
			{
				internalType: "contract IERC20",
				name: "dstToken",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "inputAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "outputAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "goodUntil",
				type: "uint256"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "vs",
				type: "bytes32"
			}
		],
		name: "clipperSwap",
		outputs: [
			{
				internalType: "uint256",
				name: "returnAmount",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract IClipperExchangeInterface",
				name: "clipperExchange",
				type: "address"
			},
			{
				internalType: "address payable",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "contract IERC20",
				name: "srcToken",
				type: "address"
			},
			{
				internalType: "contract IERC20",
				name: "dstToken",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "inputAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "outputAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "goodUntil",
				type: "uint256"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "vs",
				type: "bytes32"
			}
		],
		name: "clipperSwapTo",
		outputs: [
			{
				internalType: "uint256",
				name: "returnAmount",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract IClipperExchangeInterface",
				name: "clipperExchange",
				type: "address"
			},
			{
				internalType: "address payable",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "contract IERC20",
				name: "srcToken",
				type: "address"
			},
			{
				internalType: "contract IERC20",
				name: "dstToken",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "inputAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "outputAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "goodUntil",
				type: "uint256"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "vs",
				type: "bytes32"
			},
			{
				internalType: "bytes",
				name: "permit",
				type: "bytes"
			}
		],
		name: "clipperSwapToWithPermit",
		outputs: [
			{
				internalType: "uint256",
				name: "returnAmount",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "destroy",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "eq",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "salt",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "makerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "takerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "maker",
						type: "address"
					},
					{
						internalType: "address",
						name: "receiver",
						type: "address"
					},
					{
						internalType: "address",
						name: "allowedSender",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "makingAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "takingAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "offsets",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "interactions",
						type: "bytes"
					}
				],
				internalType: "struct OrderLib.Order",
				name: "order",
				type: "tuple"
			},
			{
				internalType: "bytes",
				name: "signature",
				type: "bytes"
			},
			{
				internalType: "bytes",
				name: "interaction",
				type: "bytes"
			},
			{
				internalType: "uint256",
				name: "makingAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "takingAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "skipPermitAndThresholdAmount",
				type: "uint256"
			}
		],
		name: "fillOrder",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "info",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "makerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "takerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "maker",
						type: "address"
					},
					{
						internalType: "address",
						name: "allowedSender",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "makingAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "takingAmount",
						type: "uint256"
					}
				],
				internalType: "struct OrderRFQLib.OrderRFQ",
				name: "order",
				type: "tuple"
			},
			{
				internalType: "bytes",
				name: "signature",
				type: "bytes"
			},
			{
				internalType: "uint256",
				name: "flagsAndAmount",
				type: "uint256"
			}
		],
		name: "fillOrderRFQ",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "info",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "makerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "takerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "maker",
						type: "address"
					},
					{
						internalType: "address",
						name: "allowedSender",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "makingAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "takingAmount",
						type: "uint256"
					}
				],
				internalType: "struct OrderRFQLib.OrderRFQ",
				name: "order",
				type: "tuple"
			},
			{
				internalType: "bytes32",
				name: "r",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "vs",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "flagsAndAmount",
				type: "uint256"
			}
		],
		name: "fillOrderRFQCompact",
		outputs: [
			{
				internalType: "uint256",
				name: "filledMakingAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "filledTakingAmount",
				type: "uint256"
			},
			{
				internalType: "bytes32",
				name: "orderHash",
				type: "bytes32"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "info",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "makerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "takerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "maker",
						type: "address"
					},
					{
						internalType: "address",
						name: "allowedSender",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "makingAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "takingAmount",
						type: "uint256"
					}
				],
				internalType: "struct OrderRFQLib.OrderRFQ",
				name: "order",
				type: "tuple"
			},
			{
				internalType: "bytes",
				name: "signature",
				type: "bytes"
			},
			{
				internalType: "uint256",
				name: "flagsAndAmount",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "target",
				type: "address"
			}
		],
		name: "fillOrderRFQTo",
		outputs: [
			{
				internalType: "uint256",
				name: "filledMakingAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "filledTakingAmount",
				type: "uint256"
			},
			{
				internalType: "bytes32",
				name: "orderHash",
				type: "bytes32"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "info",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "makerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "takerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "maker",
						type: "address"
					},
					{
						internalType: "address",
						name: "allowedSender",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "makingAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "takingAmount",
						type: "uint256"
					}
				],
				internalType: "struct OrderRFQLib.OrderRFQ",
				name: "order",
				type: "tuple"
			},
			{
				internalType: "bytes",
				name: "signature",
				type: "bytes"
			},
			{
				internalType: "uint256",
				name: "flagsAndAmount",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "target",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "permit",
				type: "bytes"
			}
		],
		name: "fillOrderRFQToWithPermit",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "salt",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "makerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "takerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "maker",
						type: "address"
					},
					{
						internalType: "address",
						name: "receiver",
						type: "address"
					},
					{
						internalType: "address",
						name: "allowedSender",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "makingAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "takingAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "offsets",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "interactions",
						type: "bytes"
					}
				],
				internalType: "struct OrderLib.Order",
				name: "order_",
				type: "tuple"
			},
			{
				internalType: "bytes",
				name: "signature",
				type: "bytes"
			},
			{
				internalType: "bytes",
				name: "interaction",
				type: "bytes"
			},
			{
				internalType: "uint256",
				name: "makingAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "takingAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "skipPermitAndThresholdAmount",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "target",
				type: "address"
			}
		],
		name: "fillOrderTo",
		outputs: [
			{
				internalType: "uint256",
				name: "actualMakingAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "actualTakingAmount",
				type: "uint256"
			},
			{
				internalType: "bytes32",
				name: "orderHash",
				type: "bytes32"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "salt",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "makerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "takerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "maker",
						type: "address"
					},
					{
						internalType: "address",
						name: "receiver",
						type: "address"
					},
					{
						internalType: "address",
						name: "allowedSender",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "makingAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "takingAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "offsets",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "interactions",
						type: "bytes"
					}
				],
				internalType: "struct OrderLib.Order",
				name: "order",
				type: "tuple"
			},
			{
				internalType: "bytes",
				name: "signature",
				type: "bytes"
			},
			{
				internalType: "bytes",
				name: "interaction",
				type: "bytes"
			},
			{
				internalType: "uint256",
				name: "makingAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "takingAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "skipPermitAndThresholdAmount",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "target",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "permit",
				type: "bytes"
			}
		],
		name: "fillOrderToWithPermit",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "gt",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "salt",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "makerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "takerAsset",
						type: "address"
					},
					{
						internalType: "address",
						name: "maker",
						type: "address"
					},
					{
						internalType: "address",
						name: "receiver",
						type: "address"
					},
					{
						internalType: "address",
						name: "allowedSender",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "makingAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "takingAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "offsets",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "interactions",
						type: "bytes"
					}
				],
				internalType: "struct OrderLib.Order",
				name: "order",
				type: "tuple"
			}
		],
		name: "hashOrder",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "increaseNonce",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "maker",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "slot",
				type: "uint256"
			}
		],
		name: "invalidatorForOrderRFQ",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "lt",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		name: "nonce",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "makerAddress",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "makerNonce",
				type: "uint256"
			}
		],
		name: "nonceEquals",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "offsets",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "or",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "owner",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "orderHash",
				type: "bytes32"
			}
		],
		name: "remaining",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "orderHash",
				type: "bytes32"
			}
		],
		name: "remainingRaw",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32[]",
				name: "orderHashes",
				type: "bytes32[]"
			}
		],
		name: "remainingsRaw",
		outputs: [
			{
				internalType: "uint256[]",
				name: "",
				type: "uint256[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "renounceOwnership",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract IERC20",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "rescueFunds",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "target",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "simulate",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract IAggregationExecutor",
				name: "executor",
				type: "address"
			},
			{
				components: [
					{
						internalType: "contract IERC20",
						name: "srcToken",
						type: "address"
					},
					{
						internalType: "contract IERC20",
						name: "dstToken",
						type: "address"
					},
					{
						internalType: "address payable",
						name: "srcReceiver",
						type: "address"
					},
					{
						internalType: "address payable",
						name: "dstReceiver",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "amount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "minReturnAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "flags",
						type: "uint256"
					}
				],
				internalType: "struct GenericRouter.SwapDescription",
				name: "desc",
				type: "tuple"
			},
			{
				internalType: "bytes",
				name: "permit",
				type: "bytes"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "swap",
		outputs: [
			{
				internalType: "uint256",
				name: "returnAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "spentAmount",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "time",
				type: "uint256"
			}
		],
		name: "timestampBelow",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "timeNonceAccount",
				type: "uint256"
			}
		],
		name: "timestampBelowAndNonceEquals",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "newOwner",
				type: "address"
			}
		],
		name: "transferOwnership",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "minReturn",
				type: "uint256"
			},
			{
				internalType: "uint256[]",
				name: "pools",
				type: "uint256[]"
			}
		],
		name: "uniswapV3Swap",
		outputs: [
			{
				internalType: "uint256",
				name: "returnAmount",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "amount0Delta",
				type: "int256"
			},
			{
				internalType: "int256",
				name: "amount1Delta",
				type: "int256"
			},
			{
				internalType: "bytes",
				name: "",
				type: "bytes"
			}
		],
		name: "uniswapV3SwapCallback",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "minReturn",
				type: "uint256"
			},
			{
				internalType: "uint256[]",
				name: "pools",
				type: "uint256[]"
			}
		],
		name: "uniswapV3SwapTo",
		outputs: [
			{
				internalType: "uint256",
				name: "returnAmount",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "contract IERC20",
				name: "srcToken",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "minReturn",
				type: "uint256"
			},
			{
				internalType: "uint256[]",
				name: "pools",
				type: "uint256[]"
			},
			{
				internalType: "bytes",
				name: "permit",
				type: "bytes"
			}
		],
		name: "uniswapV3SwapToWithPermit",
		outputs: [
			{
				internalType: "uint256",
				name: "returnAmount",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract IERC20",
				name: "srcToken",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "minReturn",
				type: "uint256"
			},
			{
				internalType: "uint256[]",
				name: "pools",
				type: "uint256[]"
			}
		],
		name: "unoswap",
		outputs: [
			{
				internalType: "uint256",
				name: "returnAmount",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "contract IERC20",
				name: "srcToken",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "minReturn",
				type: "uint256"
			},
			{
				internalType: "uint256[]",
				name: "pools",
				type: "uint256[]"
			}
		],
		name: "unoswapTo",
		outputs: [
			{
				internalType: "uint256",
				name: "returnAmount",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "contract IERC20",
				name: "srcToken",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "minReturn",
				type: "uint256"
			},
			{
				internalType: "uint256[]",
				name: "pools",
				type: "uint256[]"
			},
			{
				internalType: "bytes",
				name: "permit",
				type: "bytes"
			}
		],
		name: "unoswapToWithPermit",
		outputs: [
			{
				internalType: "uint256",
				name: "returnAmount",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		stateMutability: "payable",
		type: "receive"
	}
];

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var REJECT_PREV_REQUEST_ERROR$1 = 'reject previous values';
var isNative$1 = function isNative(address) {
  switch (address.toLowerCase()) {
    case '0x0000000000000000000000000000000000000000':
      return true;
    case '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee':
      return true;
    case 'NATIVE':
      return true;
    default:
      return false;
  }
};
var getTokenAddress = function getTokenAddress(address) {
  switch (address.toLowerCase()) {
    case '0x0000000000000000000000000000000000000000':
      return '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
    case '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee':
      return '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
    case 'NATIVE':
      return '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
    default:
      return address;
  }
};
var toNativeAddress = function toNativeAddress(address) {
  switch (address.toLowerCase()) {
    case '0x0000000000000000000000000000000000000000':
      return '0x0000000000000000000000000000000000000000';
    case '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee':
      return '0x0000000000000000000000000000000000000000';
    case 'NATIVE':
      return '0x0000000000000000000000000000000000000000';
    default:
      return address;
  }
};
var OneInchHelper = /*#__PURE__*/function (_Config) {
  _inherits(OneInchHelper, _Config);
  var _super = _createSuper$5(OneInchHelper);
  function OneInchHelper() {
    var _this;
    _classCallCheck(this, OneInchHelper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "promiseReject", undefined);
    _defineProperty(_assertThisInitialized(_this), "getSwapParams", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var swapValues;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.getSwap(params);
            case 3:
              swapValues = _context.sent;
              return _context.abrupt("return", swapValues);
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              throw new Error(_context.t0);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getSwap", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
        var _this$promiseReject, _this2;
        var input, output, slippage, service;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              input = _ref2.input, output = _ref2.output, slippage = _ref2.slippage, service = _ref2.service;
              (_this$promiseReject = (_this2 = _this).promiseReject) === null || _this$promiseReject === void 0 ? void 0 : _this$promiseReject.call(_this2, REJECT_PREV_REQUEST_ERROR$1);
              return _context3.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
                  var query, queryParams, url, response, data, OneInchRouterInterface, decodedTx;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _this.promiseReject = reject;
                        query = {
                          src: getTokenAddress(input.currency.address),
                          dst: getTokenAddress(output.currency.address),
                          amount: input.amount,
                          from: _this.account,
                          slippage: slippage || '1',
                          disableEstimate: 'true'
                        };
                        queryParams = new URLSearchParams(query);
                        url = "https://api.1inch.dev/swap/v5.2/".concat(_this.chainId, "/swap?").concat(queryParams);
                        _context2.prev = 4;
                        if (!service) {
                          _context2.next = 11;
                          break;
                        }
                        _context2.next = 8;
                        return service.create({
                          cmd: 'simulateSwap',
                          token_in: getTokenAddress(input.currency.address),
                          token_out: getTokenAddress(output.currency.address),
                          token_amount: input.amount,
                          slippage: slippage || '1'
                        });
                      case 8:
                        _context2.t0 = _context2.sent;
                        _context2.next = 16;
                        break;
                      case 11:
                        _context2.next = 13;
                        return fetch(url, {
                          method: 'GET',
                          headers: {
                            'Content-type': 'application/json',
                            Authorization: 'Bearer Xpd0MS4ypsyssHKL6LtTTQ8slIUyeQYP',
                            'Access-Control-Allow-Origin': '*',
                            'Access-Control-Allow-Methods': 'POST,GET,OPTIONS, PUT, DELETE'
                          }
                        });
                      case 13:
                        _context2.next = 15;
                        return _context2.sent.json();
                      case 15:
                        _context2.t0 = _context2.sent;
                      case 16:
                        response = _context2.t0;
                        data = response;
                        OneInchRouterInterface = new Interface(OneInchRouterABI);
                        decodedTx = OneInchRouterInterface.parseTransaction({
                          data: data.tx.data,
                          value: data.tx.value
                        });
                        if (decodedTx.name === 'swap') {
                          resolve({
                            params: {
                              value: isNative$1(input.currency.address) ? decodedTx.args['desc']['amount'].toString() : "0x0",
                              methodParams: {
                                executor: decodedTx.args['executor'],
                                desc_tuple: {
                                  srcToken: decodedTx.args['desc']['srcToken'],
                                  dstToken: decodedTx.args['desc']['dstToken'],
                                  srcReceiver: decodedTx.args['desc']['srcReceiver'],
                                  dstReceiver: _this.account,
                                  amount: decodedTx.args['desc']['amount'].toString(),
                                  minReturnAmount: decodedTx.args['desc']['minReturnAmount'].toString(),
                                  flags: decodedTx.args['desc']['flags'].toString()
                                },
                                permit: decodedTx.args['permit'],
                                data: decodedTx.args['data']
                              }
                            },
                            state: 'VALID',
                            methodName: decodedTx.name,
                            inputAmount: decodedTx.args['desc']['amount'].toString(),
                            outputAmount: decodedTx.args['desc']['minReturnAmount'].toString(),
                            protocol: '1INCH'
                          });
                        }
                        resolve({
                          params: {
                            value: isNative$1(input.currency.address) ? decodedTx.args['amount'].toString() : "0x0",
                            methodParams: {
                              srcToken: decodedTx.args['srcToken'] ? decodedTx.args['srcToken'] : toNativeAddress(input.currency.address),
                              amount: decodedTx.args['amount'].toString(),
                              minReturn: decodedTx.args['minReturn'].toString(),
                              pools: decodedTx.args['pools'].map(function (pool) {
                                return pool.toString();
                              })
                            }
                          },
                          state: 'VALID',
                          methodName: decodedTx.name,
                          inputAmount: decodedTx.args['amount'].toString(),
                          outputAmount: decodedTx.args['minReturn'].toString(),
                          protocol: '1INCH'
                        });
                        _context2.next = 27;
                        break;
                      case 24:
                        _context2.prev = 24;
                        _context2.t1 = _context2["catch"](4);
                        reject(_context2.t1);
                      case 27:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, null, [[4, 24]]);
                }));
                return function (_x3, _x4) {
                  return _ref4.apply(this, arguments);
                };
              }()));
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    return _this;
  }
  return _createClass(OneInchHelper);
}(Config);

var SimpleSwap1Inch = createPlugin({
  protocol: '1INCH',
  type: 'ACTION',
  method: 'unoswap',
  name: 'simpleSwap1Inch',
  supportedContracts: [{
    address: '0x1111111254EEB25477B68fb85Ed929f73A960582',
    chainId: 1
  }, {
    address: '0x1111111254EEB25477B68fb85Ed929f73A960582',
    chainId: 42161
  }],
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        value: new FctValue({
          required: false,
          decimals: 18
        }),
        currencyIn: new FctAddress({
          mode: 'INPUT',
          destination: 'erc20',
          options: getAllCurrencies({
            chainId: chainId
          })
        }),
        currencyOut: new FctAddress({
          mode: 'INPUT',
          destination: 'erc20',
          options: getAllCurrencies({
            chainId: chainId
          })
        }),
        amountIn: new FctValue({
          mode: 'INPUT',
          destination: 'wei_amount'
        }),
        amountOut: new FctValue({
          readonly: true,
          destination: 'wei_amount'
        }),
        methodParams: {
          srcToken: new FctAddress({
            readonly: true,
            destination: 'erc20'
          }),
          amount: new FctValue({
            readonly: true,
            destination: 'wei_amount'
          }),
          minReturn: new FctValue({
            destination: 'wei_amount'
          }),
          pools: new FctValueList({
            readonly: true
          }),
          executor: new FctAddress({
            readonly: true
          }),
          desc_tuple: {
            srcToken: new FctAddress({
              readonly: true,
              destination: 'erc20'
            }),
            dstToken: new FctAddress({
              readonly: true,
              destination: 'erc20'
            }),
            srcReceiver: new FctAddress({
              readonly: true
            }),
            dstReceiver: new FctAddress({}),
            amount: new FctValue({
              readonly: true,
              destination: 'wei_amount'
            }),
            minReturnAmount: new FctValue({
              readonly: true
            }),
            flags: new FctValue({
              readonly: true
            })
          },
          permit: new FctBytes({
            readonly: true
          }),
          data: new FctBytes({
            readonly: true
          })
        }
      },
      output: {
        returnAmount: new FctValue({})
      }
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref2) {
    var chainId = _ref2.chainId,
      input = _ref2.input,
      provider = _ref2.provider,
      setMethod = _ref2.setMethod,
      account = _ref2.account;
    var helper = new OneInchHelper({
      chainId: chainId,
      provider: provider,
      account: account
    });
    var _input$methodParams = input.methodParams,
      srcToken = _input$methodParams.srcToken,
      amount = _input$methodParams.amount,
      minReturn = _input$methodParams.minReturn,
      pools = _input$methodParams.pools,
      executor = _input$methodParams.executor,
      permit = _input$methodParams.permit,
      data = _input$methodParams.data,
      desc_tuple = _input$methodParams.desc_tuple;
    var unoswapMethodParams = {
      srcToken: srcToken,
      amount: amount,
      minReturn: minReturn,
      pools: pools
    };
    var getPathParams = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
        var service, tokenInAddress, tokenOutAddress, amountIn, amount, initParams, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              service = _ref3.service;
              tokenInAddress = input === null || input === void 0 ? void 0 : input.currencyIn.value;
              tokenOutAddress = input === null || input === void 0 ? void 0 : input.currencyOut.value;
              if (!(!tokenInAddress || !tokenOutAddress || typeof tokenInAddress !== 'string' || typeof tokenOutAddress !== 'string')) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              amountIn = input === null || input === void 0 ? void 0 : input.amountIn;
              if (amountIn) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return");
            case 8:
              amount = undefined;
              if (typeof amountIn.value === 'string') {
                amount = amountIn.value;
              }
              if (amount) {
                _context.next = 12;
                break;
              }
              return _context.abrupt("return");
            case 12:
              initParams = {
                value: undefined,
                amountOut: undefined,
                methodParams: {
                  srcToken: undefined,
                  amount: undefined,
                  minReturn: undefined,
                  pools: undefined,
                  executor: undefined,
                  desc_tuple: {
                    srcToken: undefined,
                    dstToken: undefined,
                    srcReceiver: undefined,
                    dstReceiver: undefined,
                    amount: undefined,
                    minReturnAmount: undefined,
                    flags: undefined
                  },
                  permit: undefined,
                  data: undefined
                }
              };
              _context.prev = 13;
              _context.next = 16;
              return helper.getSwapParams({
                input: {
                  currency: {
                    address: tokenInAddress
                  },
                  amount: amount
                },
                output: {
                  currency: {
                    address: tokenOutAddress
                  }
                },
                service: service
              });
            case 16:
              res = _context.sent;
              if (res) {
                _context.next = 19;
                break;
              }
              return _context.abrupt("return", {
                params: initParams,
                error: 'invalid trade'
              });
            case 19:
              if (res.methodName === 'swap') {
                if (setMethod) setMethod('swap');
                Object.keys(desc_tuple).forEach(function (key) {
                  var decTupleKey = key;
                  desc_tuple[decTupleKey].virtual = false;
                  desc_tuple[decTupleKey].required = true;
                });
                executor.virtual = false;
                permit.virtual = false;
                data.virtual = false;
                Object.keys(unoswapMethodParams).forEach(function (key) {
                  var unoswapKey = key;
                  unoswapMethodParams[unoswapKey].virtual = true;
                  unoswapMethodParams[unoswapKey].value = undefined;
                  unoswapMethodParams[unoswapKey].required = false;
                });
                minReturn.readonly = true;
                desc_tuple.minReturnAmount.readonly = false;
              }
              if (res.methodName === 'uniswapV3Swap') {
                if (setMethod) setMethod('uniswapV3Swap');
                Object.keys(desc_tuple).forEach(function (key) {
                  var decTupleKey = key;
                  desc_tuple[decTupleKey].virtual = true;
                  desc_tuple[decTupleKey].value = undefined;
                  desc_tuple[decTupleKey].required = false;
                });
                executor.virtual = true;
                executor.required = false;
                permit.virtual = true;
                permit.required = false;
                data.virtual = true;
                data.required = false;
                executor.value = undefined;
                permit.value = undefined;
                data.value = undefined;
                minReturn.readonly = false;
                desc_tuple.minReturnAmount.readonly = true;
                Object.keys(unoswapMethodParams).forEach(function (key) {
                  var unoswapKey = key;
                  unoswapMethodParams[unoswapKey].virtual = false;
                  unoswapMethodParams[unoswapKey].required = true;
                });
                srcToken.virtual = true;
                srcToken.required = false;
                srcToken.value = undefined;
              }
              if (res.methodName === 'unoswap') {
                if (setMethod) setMethod('unoswap');
                Object.keys(desc_tuple).forEach(function (key) {
                  var decTupleKey = key;
                  desc_tuple[decTupleKey].virtual = true;
                  desc_tuple[decTupleKey].value = undefined;
                  desc_tuple[decTupleKey].required = false;
                });
                executor.virtual = true;
                executor.required = false;
                permit.virtual = true;
                permit.required = false;
                data.virtual = true;
                data.required = false;
                executor.value = undefined;
                permit.value = undefined;
                data.value = undefined;
                minReturn.readonly = false;
                desc_tuple.minReturnAmount.readonly = true;
                Object.keys(unoswapMethodParams).forEach(function (key) {
                  var unoswapKey = key;
                  unoswapMethodParams[unoswapKey].virtual = false;
                  unoswapMethodParams[unoswapKey].required = true;
                });
              }
              if (res.params.methodParams.minReturn) {
                res.params.methodParams.minReturn = '0';
              }
              if (res.params.methodParams.desc_tuple && _typeof(res.params.methodParams.desc_tuple) === 'object' && 'minReturnAmount' in res.params.methodParams.desc_tuple) {
                res.params.methodParams.desc_tuple.minReturnAmount = '1';
              }
              return _context.abrupt("return", {
                params: {
                  amountOut: res.outputAmount,
                  value: res.params.value,
                  methodParams: res.params.methodParams
                },
                error: undefined
              });
            case 27:
              _context.prev = 27;
              _context.t0 = _context["catch"](13);
              return _context.abrupt("return", {
                params: initParams,
                error: _context.t0.message
              });
            case 30:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[13, 27]]);
      }));
      return function getPathParams(_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    return {
      get: getPathParams,
      depParamKeys: ['currencyIn', 'currencyOut', 'amountIn']
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var currencyIn = params.currencyIn,
      amountIn = params.amountIn;
    if (currencyIn.value && typeof currencyIn.value === 'string' && isNative$1(currencyIn.value)) return [];
    return [{
      to: currencyIn.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: amountIn.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var actions$l = {
  SimpleSwap1Inch: SimpleSwap1Inch
};
var Inch = {
  actions: actions$l
};

var Borrow$3 = createPlugin({
  protocol: 'AAVE',
  type: 'ACTION',
  method: 'borrow',
  supportedContracts: LENDING_POOL_ADDRESSES$1,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_lending_pool_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveTokens({
              chainId: chainId
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          interestRateMode: new FctValue({
            options: [{
              value: '1'
            }, {
              value: '2'
            }]
          }),
          referralCode: new FctValue16({}),
          onBehalfOf: new FctAddress({})
        }
      },
      output: {}
    };
  },
  initParams: {
    methodParams: {
      referralCode: '0' // Aave has disabled referral codes, 0 by default
    }
  },

  requiredApprovals: function requiredApprovals(params, chainId, _walletAddress, vaultAddress) {
    var _params$methodParams = params.methodParams,
      amount = _params$methodParams.amount,
      onBehalfOf = _params$methodParams.onBehalfOf,
      asset = _params$methodParams.asset;
    var assetValue = asset.value;
    if (assetValue && typeof assetValue != 'string') {
      return [];
    }
    var fromTokenData = A_TOKENS$1[chainId].find(function (token) {
      return token.underlyingAssetAddress.toLowerCase() === assetValue.toLowerCase();
    });
    if (!fromTokenData) {
      return [];
    }
    if (!vaultAddress) return [];
    var value;
    if (typeof amount.value === 'string') {
      value = amount.value;
    }
    if (!value && typeof amount.estimatedValue === 'string') {
      value = amount.estimatedValue;
    }
    if (!value) return [];
    return [{
      to: fromTokenData.aTokenAddress,
      from: onBehalfOf.value,
      params: {
        delegatee: vaultAddress,
        amount: value
      },
      method: 'approveDelegation',
      protocol: 'AAVE'
    }];
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var _A_TOKENS$chainId;
    var to = params.to,
      _params$methodParams2 = params.methodParams,
      amount = _params$methodParams2.amount,
      interestRateMode = _params$methodParams2.interestRateMode,
      asset = _params$methodParams2.asset,
      onBehalfOf = _params$methodParams2.onBehalfOf;
    if (!asset.value || !to.value || !amount.value || !onBehalfOf.value || !interestRateMode.value || !vaultAddress) return [];
    if (typeof amount.value !== 'string' || typeof interestRateMode.value !== 'string' || typeof asset.value !== 'string' || typeof to.value !== 'string') return [];
    var tokenData = (_A_TOKENS$chainId = A_TOKENS$1[chainId]) === null || _A_TOKENS$chainId === void 0 ? void 0 : _A_TOKENS$chainId.find(function (token) {
      return token.underlyingAssetAddress.toLowerCase() === asset.value.toLowerCase();
    });
    if (!tokenData) return [];
    var debtToken = interestRateMode.value === '1' ? tokenData.stableDebtTokenAddress : tokenData.variableDebtTokenAddress;
    return [{
      address: vaultAddress,
      toSpend: [],
      toReceive: [{
        token: asset.value,
        amount: amount.value
      }, {
        token: debtToken,
        amount: amount.value
      }]
    }];
  }
});

var Deposit$4 = createPlugin({
  protocol: 'AAVE',
  type: 'ACTION',
  method: 'deposit',
  supportedContracts: LENDING_POOL_ADDRESSES$1,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_lending_pool_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveTokens({
              chainId: chainId
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          onBehalfOf: new FctAddress({}),
          referralCode: new FctValue16({})
        }
      },
      output: {}
    };
  },
  initParams: {
    methodParams: {
      referralCode: '0' // Aave has disabled referral codes, 0 by default
    }
  },

  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams = params.methodParams,
      asset = _params$methodParams.asset,
      amount = _params$methodParams.amount,
      onBehalfOf = _params$methodParams.onBehalfOf;
    var value;
    if (typeof amount.value === 'string') {
      value = amount.value;
    }
    if (!value && typeof amount.estimatedValue === 'string') {
      value = amount.estimatedValue;
    }
    if (!value) return [];
    return [{
      to: asset.value,
      from: onBehalfOf.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var _A_TOKENS$chainId;
    var to = params.to,
      _params$methodParams2 = params.methodParams,
      amount = _params$methodParams2.amount,
      asset = _params$methodParams2.asset,
      onBehalfOf = _params$methodParams2.onBehalfOf;
    if (!asset.value || !to.value || !amount.value || !onBehalfOf.value || !vaultAddress) return [];
    if (typeof amount.value !== 'string' || typeof asset.value !== 'string' || typeof to.value !== 'string') return [];
    var aToken = (_A_TOKENS$chainId = A_TOKENS$1[chainId]) === null || _A_TOKENS$chainId === void 0 ? void 0 : _A_TOKENS$chainId.find(function (token) {
      return token.underlyingAssetAddress.toLowerCase() === asset.value.toLowerCase();
    });
    if (!aToken) return [];
    return [{
      address: vaultAddress,
      toSpend: [{
        token: asset.value,
        amount: amount.value
      }],
      toReceive: [{
        token: aToken.aTokenAddress,
        amount: amount.value
      }]
    }];
  }
});

var Repay$2 = createPlugin({
  protocol: 'AAVE',
  type: 'ACTION',
  method: 'repay',
  supportedContracts: LENDING_POOL_ADDRESSES$1,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_lending_pool_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveTokens({
              chainId: chainId
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          rateMode: new FctValue({
            options: [{
              value: '1'
            }, {
              value: '2'
            }]
          }),
          onBehalfOf: new FctAddress({})
        }
      },
      output: {
        value: new FctValue({
          innerIndex: 0
        })
      }
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams = params.methodParams,
      asset = _params$methodParams.asset,
      amount = _params$methodParams.amount,
      onBehalfOf = _params$methodParams.onBehalfOf;
    var value;
    if (typeof amount.value === 'string') {
      value = amount.value;
    }
    if (!value && typeof amount.estimatedValue === 'string') {
      value = amount.estimatedValue;
    }
    if (!value) return [];
    return [{
      to: asset.value,
      from: onBehalfOf.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      _params$methodParams2 = params.methodParams,
      amount = _params$methodParams2.amount,
      asset = _params$methodParams2.asset,
      onBehalfOf = _params$methodParams2.onBehalfOf,
      rateMode = _params$methodParams2.rateMode;
    if (!asset.value || !to.value || !amount.value || !onBehalfOf.value || !rateMode.value || !vaultAddress) return [];
    if (typeof amount.value !== 'string' || typeof asset.value !== 'string' || typeof rateMode.value !== 'string' || typeof to.value !== 'string') return [];
    var assetData = A_TOKENS$1[chainId].find(function (token) {
      return token.underlyingAssetAddress.toLowerCase() === asset.value.toLowerCase();
    });
    if (!assetData) return [];
    var debtToken = rateMode.value === '1' ? assetData.stableDebtTokenAddress : assetData.variableDebtTokenAddress;
    return [{
      address: vaultAddress,
      toSpend: [{
        token: asset.value,
        amount: amount.value
      }, {
        token: debtToken,
        amount: amount.value
      }],
      toReceive: []
    }];
  }
});

var SwapBorrowRateMode$2 = createPlugin({
  protocol: 'AAVE',
  type: 'ACTION',
  method: 'swapBorrowRateMode',
  supportedContracts: LENDING_POOL_ADDRESSES$1,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_lending_pool_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveTokens({
              chainId: chainId
            })
          }),
          rateMode: new FctValue({
            options: [{
              value: '1',
              name: 'Stable'
            }, {
              value: '2',
              name: 'Variable'
            }]
          })
        }
      },
      output: {}
    };
  }
});

var Withdraw$6 = createPlugin({
  protocol: 'AAVE',
  type: 'ACTION',
  method: 'withdraw',
  supportedContracts: LENDING_POOL_ADDRESSES$1,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_lending_pool_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveTokens({
              chainId: chainId
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          to: new FctAddress({})
        }
      },
      output: {
        value: new FctValue({
          innerIndex: 0
        })
      }
    };
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var _A_TOKENS$chainId;
    var to = params.to,
      _params$methodParams = params.methodParams,
      amount = _params$methodParams.amount,
      receiver = _params$methodParams.to,
      asset = _params$methodParams.asset;
    if (!asset.value || !to.value || !amount.value || !receiver.value || !vaultAddress) return [];
    if (typeof amount.value !== 'string' || typeof receiver.value !== 'string' || typeof asset.value !== 'string' || typeof to.value !== 'string') return [];
    var aToken = (_A_TOKENS$chainId = A_TOKENS$1[chainId]) === null || _A_TOKENS$chainId === void 0 ? void 0 : _A_TOKENS$chainId.find(function (token) {
      return token.underlyingAssetAddress.toLowerCase() === asset.value.toLowerCase();
    });
    if (!aToken) return [];
    return [{
      address: vaultAddress,
      toSpend: [{
        token: aToken.aTokenAddress,
        amount: amount.value
      }],
      toReceive: [{
        token: asset.value,
        amount: amount.value
      }]
    }];
  }
});

var GetAssetPrice$1 = createPlugin({
  protocol: 'AAVE',
  type: 'ORACLE',
  method: 'getAssetPrice',
  supportedContracts: PRICE_ORACLE_ADDRESSES$1,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          asset: new FctAddress({
            options: getAaveTokens({
              chainId: chainId
            })
          })
        }
      },
      output: {
        price: new FctValue18({
          innerIndex: 0
        })
      }
    };
  }
});

var GetAssetReserveData$1 = createPlugin({
  protocol: 'AAVE',
  type: 'GETTER',
  method: 'getReserveData',
  name: 'getAssetReserveData',
  supportedContracts: PROTOCOL_DATA_PROVIDER_ADDRESSES$1,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_protocol_data_provider_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveTokens({
              chainId: chainId
            })
          })
        }
      },
      output: {
        availableLiquidity: new FctValue({
          innerIndex: 0
        }),
        totalStableDebt: new FctValue({
          innerIndex: 1
        }),
        totalVariableDebt: new FctValue({
          innerIndex: 2
        }),
        supplyRate: new FctValue27({
          innerIndex: 3
        }),
        variableBorrowRate: new FctValue27({
          innerIndex: 4
        }),
        stableBorrowRate: new FctValue27({
          innerIndex: 5
        }),
        averageStableBorrowRate: new FctValue({
          innerIndex: 6
        }),
        liquidityIndex: new FctValue({
          innerIndex: 7
        }),
        variableBorrowIndex: new FctValue({
          innerIndex: 8
        }),
        lastUpdateTimestamp: new FctValue40({
          innerIndex: 9
        })
      }
    };
  }
});

var GetReserveConfigurationData$1 = createPlugin({
  protocol: 'AAVE',
  type: 'GETTER',
  method: 'getReserveConfigurationData',
  supportedContracts: PROTOCOL_DATA_PROVIDER_ADDRESSES$1,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_protocol_data_provider_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveTokens({
              chainId: chainId
            })
          })
        }
      },
      output: {
        decimals: new FctDecimals({
          innerIndex: 0
        }),
        ltv: new FctBps({
          innerIndex: 1
        }),
        liquidationThreshold: new FctBps({
          innerIndex: 2
        }),
        liquidationBonus: new FctValue({
          innerIndex: 3
        }),
        reserveFactor: new FctValue({
          innerIndex: 4
        }),
        usageAsCollateralEnabled: new FctBoolean({
          innerIndex: 5
        }),
        borrowingEnabled: new FctBoolean({
          innerIndex: 6
        }),
        stableBorrowRateEnabled: new FctBoolean({
          innerIndex: 7
        }),
        isActive: new FctBoolean({
          innerIndex: 8
        }),
        isFrozen: new FctBoolean({
          innerIndex: 9
        })
      }
    };
  }
});

// Get reserve data response
var GetReserveData$2 = createPlugin({
  protocol: 'AAVE',
  type: 'GETTER',
  method: 'getReserveData',
  supportedContracts: LENDING_POOL_ADDRESSES$1,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_lending_pool_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveTokens({
              chainId: chainId
            })
          })
        }
      },
      output: {
        configuration: new FctValue({
          innerIndex: 0
        }),
        liquidityIndex: new FctValue128_27({
          innerIndex: 1
        }),
        variableBorrowIndex: new FctValue128_27({
          innerIndex: 2
        }),
        currentLiquidityRate: new FctValue128_27({
          innerIndex: 3
        }),
        currentVariableBorrowRate: new FctValue128_27({
          innerIndex: 4
        }),
        currentStableBorrowRate: new FctValue128_27({
          innerIndex: 5
        }),
        lastUpdateTimestamp: new FctValue40({
          innerIndex: 6
        }),
        aTokenAddress: new FctAddress({
          innerIndex: 7
        }),
        stableDebtTokenAddress: new FctAddress({
          innerIndex: 8
        }),
        variableDebtTokenAddress: new FctAddress({
          innerIndex: 9
        }),
        interestRateStrategyAddress: new FctAddress({
          innerIndex: 10
        }),
        id: new FctValue8({
          innerIndex: 11
        })
      }
    };
  }
});

var GetReserveTokensAddresses$1 = createPlugin({
  protocol: 'AAVE',
  type: 'GETTER',
  method: 'getReserveTokensAddresses',
  supportedContracts: PROTOCOL_DATA_PROVIDER_ADDRESSES$1,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_protocol_data_provider_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveTokens({
              chainId: chainId
            })
          })
        }
      },
      output: {
        aTokenAddress: new FctAddress({
          innerIndex: 0
        }),
        stableDebtTokenAddress: new FctAddress({
          innerIndex: 1
        }),
        variableDebtTokenAddress: new FctAddress({
          innerIndex: 2
        })
      }
    };
  }
});

var GetUserAccountData$2 = createPlugin({
  protocol: 'AAVE',
  type: 'GETTER',
  method: 'getUserAccountData',
  supportedContracts: LENDING_POOL_ADDRESSES$1,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_lending_pool_v2'
        }),
        methodParams: {
          user: new FctAddress({})
        }
      },
      output: {
        totalCollateralETH: new FctValue18({
          innerIndex: 0
        }),
        totalDebtETH: new FctValue18({
          innerIndex: 1
        }),
        availableBorrowsETH: new FctValue18({
          innerIndex: 2
        }),
        currentLiquidationThreshold: new FctBps({
          innerIndex: 3
        }),
        ltv: new FctBps({
          innerIndex: 4
        }),
        healthFactor: new FctValue18({
          innerIndex: 5
        })
      }
    };
  }
});

var GetUserReserveData$1 = createPlugin({
  protocol: 'AAVE',
  type: 'GETTER',
  method: 'getUserReserveData',
  supportedContracts: PROTOCOL_DATA_PROVIDER_ADDRESSES$1,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_protocol_data_provider_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveTokens({
              chainId: chainId
            })
          }),
          user: new FctAddress({})
        }
      },
      output: {
        currentATokenBalance: new FctValue18({
          innerIndex: 0
        }),
        currentStableDebt: new FctValue18({
          innerIndex: 1
        }),
        currentVariableDebt: new FctValue18({
          innerIndex: 2
        }),
        principalStableDebt: new FctValue18({
          innerIndex: 3
        }),
        scaledVariableDebt: new FctValue18({
          innerIndex: 4
        }),
        stableBorrowRate: new FctValue27({
          innerIndex: 5
        }),
        liquidityRate: new FctValue27({
          innerIndex: 6
        }),
        stableRateLastUpdated: new FctValue40({
          innerIndex: 7
        }),
        usageAsCollateralEnabled: new FctBoolean({
          innerIndex: 8
        })
      }
    };
  },
  initParams: {
    to: '0x057835Ad21a177dbdd3090bB1CAE03EaCF78Fc6d'
  }
});

var RAY$2 = new BN(Math.pow(10, 27));
var SECONDS_PER_YEAR$1 = 31536000;
var getAssetRateByApy = function getAssetRateByApy(_ref) {
  var apy = _ref.apy;
  var APYDecimal = new Decimal(apy).div(100);
  var rate = APYDecimal.plus(1).pow(new Decimal(1).div(SECONDS_PER_YEAR$1)).minus(1).times(SECONDS_PER_YEAR$1).mul(new Decimal(RAY$2.toString()));
  return {
    rate: rate.toFixed()
  };
};

// PureValidator: "0x1716898d72BE098F4828B435a3918cBFda562Efc",
// PureSafeMath: "0x850c7E3eBf05d0A617DAe4beE14A4A5C03CAb9da",

var supportedContracts$2 = [{
  chainId: 5,
  address: '0x1716898d72BE098F4828B435a3918cBFda562Efc'
}];

var ApyBetween$1 = createPlugin({
  protocol: 'AAVE',
  type: 'VALIDATOR',
  method: 'between',
  name: 'apyBetween',
  description: 'Check if a value is between two numbers',
  supportedContracts: supportedContracts$2,
  onCreate: function onCreate(_ref) {
    _ref.chainId;
      var input = _ref.input;
    input.rateValue.subscribe({
      callback: function callback(_ref2) {
        var value = _ref2.value;
        input.methodParams.value.set({
          value: value
        });
      },
      id: 'change_value1_on_rateValue_change'
    });
    input.methodParams.value.set({
      value: input.rateValue.value
    });
    var setValue = function setValue(_ref3) {
      var value = _ref3.value,
        param = _ref3.param;
      if (!value) {
        param.set({
          value: undefined
        });
        return;
      }
      if (input.minApyValue.isVariable) {
        console.error('should be real value');
        return;
      }
      var rate = getAssetRateByApy({
        apy: value
      });
      param.set({
        value: rate.rate
      });
    };
    input.minApyValue.subscribe({
      callback: function callback(_ref4) {
        var value = _ref4.value;
        setValue({
          value: value,
          param: input.methodParams.minValue
        });
      },
      id: 'change_minValue_on_minApyValue_change'
    });
    setValue({
      value: input.minApyValue.value,
      param: input.methodParams.minValue
    });
    input.maxApyValue.subscribe({
      callback: function callback(_ref5) {
        var value = _ref5.value;
        setValue({
          value: value,
          param: input.methodParams.maxValue
        });
      },
      id: 'change_maxValue_on_maxApyValue_change'
    });
    setValue({
      value: input.maxApyValue.value,
      param: input.methodParams.maxValue
    });
  },
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        rateValue: new FctValue27({
          mode: 'VARIABLE'
        }),
        minApyValue: new FctPercent({
          destination: 'percent',
          mode: 'INPUT'
        }),
        maxApyValue: new FctPercent({
          destination: 'percent',
          mode: 'INPUT'
        }),
        methodParams: {
          minValue: new FctValue({
            readonly: true
          }),
          maxValue: new FctValue({
            readonly: true
          }),
          value: new FctValue({
            readonly: true
          })
        }
      },
      output: {
        value: new FctValue({
          innerIndex: 0,
          description: 'Result of minValue subtraction from value'
        })
      }
    };
  },
  validate: function validate(params, errors) {
    var minValue = params.methodParams.minValue.value;
    var maxValue = params.methodParams.maxValue.value;
    if (_typeof(minValue) === 'object') return true;
    if (_typeof(maxValue) === 'object') return true;
    var minValueBN = BigNumber.from(minValue);
    var maxValueBN = BigNumber.from(maxValue);
    if (minValueBN.gt(maxValueBN)) {
      errors.set('minValue', ERRORS.RANGE_ERROR);
      return false;
    }
    errors.delete('minValue');
    return true;
  }
});

/* eslint-disable no-restricted-imports */
var ApyGreaterThan$1 = createPlugin({
  protocol: 'AAVE',
  type: 'VALIDATOR',
  method: 'greaterThan',
  name: 'apyGreaterThan',
  description: 'Check if a value is greater than a number',
  supportedContracts: supportedContracts$2,
  onCreate: function onCreate(_ref) {
    _ref.chainId;
      var input = _ref.input;
    input.rateValue.subscribe({
      callback: function callback(_ref2) {
        var value = _ref2.value;
        input.methodParams.value1.set({
          value: value
        });
      },
      id: 'change_value1_on_rateValue_change'
    });
    input.methodParams.value1.set({
      value: input.rateValue.value
    });
    var setValue2 = function setValue2(_ref3) {
      var value = _ref3.value;
      if (!value) {
        input.methodParams.value2.set({
          value: undefined
        });
        return;
      }
      if (input.apyValue.isVariable) {
        console.error('should be real value');
        return;
      }
      var rate = getAssetRateByApy({
        apy: value
      });
      input.methodParams.value2.set({
        value: rate.rate
      });
    };
    input.apyValue.subscribe({
      callback: setValue2,
      id: 'change_value2_on_apyValue_change'
    });
    setValue2({
      value: input.apyValue.value
    });
  },
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        rateValue: new FctValue27({
          mode: 'VARIABLE'
        }),
        apyValue: new FctPercent({
          destination: 'percent',
          mode: 'INPUT'
        }),
        methodParams: {
          value1: new FctValue({
            readonly: true
          }),
          value2: new FctValue({
            readonly: true
          })
        }
      },
      output: {
        value: new FctValue({
          innerIndex: 0,
          description: 'Returns value2 subtraction from value1'
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var ApyLessThan$1 = createPlugin({
  protocol: 'AAVE',
  type: 'VALIDATOR',
  method: 'lessThan',
  description: 'Check if a value is less than a number',
  name: 'apyLessThan',
  supportedContracts: supportedContracts$2,
  onCreate: function onCreate(_ref) {
    _ref.chainId;
      var input = _ref.input;
    input.rateValue.subscribe({
      callback: function callback(_ref2) {
        var value = _ref2.value;
        input.methodParams.value1.set({
          value: value
        });
      },
      id: 'change_value1_on_rateValue_change'
    });
    input.methodParams.value1.set({
      value: input.rateValue.value
    });
    var setValue2 = function setValue2(_ref3) {
      var value = _ref3.value;
      if (!value) {
        input.methodParams.value2.set({
          value: undefined
        });
        return;
      }
      if (input.apyValue.isVariable) {
        console.error('should be real value');
        return;
      }
      var rate = getAssetRateByApy({
        apy: value
      });
      input.methodParams.value2.set({
        value: rate.rate
      });
    };
    input.apyValue.subscribe({
      callback: setValue2,
      id: 'change_value_on_apyValue_change'
    });
    setValue2({
      value: input.apyValue.value
    });
  },
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        rateValue: new FctValue27({
          mode: 'VARIABLE'
        }),
        apyValue: new FctPercent({
          destination: 'percent',
          mode: 'INPUT'
        }),
        methodParams: {
          value1: new FctValue({
            readonly: true
          }),
          value2: new FctValue({
            readonly: true
          })
        }
      },
      output: {
        value: new FctValue({
          innerIndex: 0,
          description: 'Returns value1 subtraction from value2'
        })
      }
    };
  }
});

var actions$k = {
  Borrow: Borrow$3,
  Deposit: Deposit$4,
  Repay: Repay$2,
  Withdraw: Withdraw$6,
  SwapBorrowRateMode: SwapBorrowRateMode$2
};
var getters$i = {
  GetUserAccountData: GetUserAccountData$2,
  GetReserveData: GetReserveData$2,
  GetUserReserveData: GetUserReserveData$1,
  GetReserveConfigurationData: GetReserveConfigurationData$1,
  GetAssetReserveData: GetAssetReserveData$1,
  GetReserveTokensAddresses: GetReserveTokensAddresses$1,
  GetAssetPrice: GetAssetPrice$1,
  ApyLessThan: ApyLessThan$1,
  ApyBetween: ApyBetween$1,
  ApyGreaterThan: ApyGreaterThan$1
};
var AaveV2 = {
  actions: actions$k,
  getters: getters$i
};

var aaveV3ArbitrumErc20 = [
	{
		aTokenAddress: "0x82E64f49Ed5EC1bC6e43DAD4FC8Af9bb3A2312EE",
		stableDebtTokenAddress: "0xd94112B5B62d53C9402e7A60289c6810dEF1dC9B",
		variableDebtTokenAddress: "0x8619d80FB0141ba7F184CbF22fd724116D9f7ffC",
		underlyingAssetAddress: "0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1"
	},
	{
		aTokenAddress: "0x191c10Aa4AF7C30e871E70C95dB0E4eb77237530",
		stableDebtTokenAddress: "0x89D976629b7055ff1ca02b927BA3e020F22A44e4",
		variableDebtTokenAddress: "0x953A573793604aF8d41F306FEb8274190dB4aE0e",
		underlyingAssetAddress: "0xf97f4df75117a78c1A5a0DBb814Af92458539FB4"
	},
	{
		aTokenAddress: "0x625E7708f30cA75bfd92586e17077590C60eb4cD",
		stableDebtTokenAddress: "0x307ffe186F84a3bc2613D1eA417A5737D69A7007",
		variableDebtTokenAddress: "0xFCCf3cAbbe80101232d343252614b6A3eE81C989",
		underlyingAssetAddress: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8"
	},
	{
		aTokenAddress: "0x078f358208685046a11C85e8ad32895DED33A249",
		stableDebtTokenAddress: "0x633b207Dd676331c413D4C013a6294B0FE47cD0e",
		variableDebtTokenAddress: "0x92b42c66840C7AD907b4BF74879FF3eF7c529473",
		underlyingAssetAddress: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f"
	},
	{
		aTokenAddress: "0xe50fA9b3c56FfB159cB0FCA61F5c9D750e8128c8",
		stableDebtTokenAddress: "0xD8Ad37849950903571df17049516a5CD4cbE55F6",
		variableDebtTokenAddress: "0x0c84331e39d6658Cd6e6b9ba04736cC4c4734351",
		underlyingAssetAddress: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1"
	},
	{
		aTokenAddress: "0x6ab707Aca953eDAeFBc4fD23bA73294241490620",
		stableDebtTokenAddress: "0x70eFfc565DB6EEf7B927610155602d31b670e802",
		variableDebtTokenAddress: "0xfb00AC187a8Eb5AFAE4eACE434F493Eb62672df7",
		underlyingAssetAddress: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9"
	},
	{
		aTokenAddress: "0xf329e36C7bF6E5E86ce2150875a84Ce77f477375",
		stableDebtTokenAddress: "0xfAeF6A702D15428E588d4C0614AEFb4348D83D48",
		variableDebtTokenAddress: "0xE80761Ea617F66F96274eA5e8c37f03960ecC679",
		underlyingAssetAddress: "0xba5DdD1f9d7F570dc94a51479a000E3BCE967196"
	},
	{
		aTokenAddress: "0x6d80113e533a2C0fe82EaBD35f1875DcEA89Ea97",
		stableDebtTokenAddress: "0xF15F26710c827DDe8ACBA678682F3Ce24f2Fb56E",
		variableDebtTokenAddress: "0x4a1c3aD6Ed28a636ee1751C69071f6be75DEb8B8",
		underlyingAssetAddress: "0xD22a58f79e9481D1a88e00c343885A588b34b68B"
	},
	{
		aTokenAddress: "0x513c7E3a9c69cA3e22550eF58AC1C0088e918FFf",
		stableDebtTokenAddress: "0x08Cb71192985E936C7Cd166A8b268035e400c3c3",
		variableDebtTokenAddress: "0x77CA01483f379E58174739308945f044e1a764dc",
		underlyingAssetAddress: "0x5979D7b546E38E414F7E9822514be443A4800529"
	},
	{
		aTokenAddress: "0xc45A479877e1e9Dfe9FcD4056c699575a1045dAA",
		stableDebtTokenAddress: "0x78246294a4c6fBf614Ed73CcC9F8b875ca8eE841",
		variableDebtTokenAddress: "0x34e2eD44EF7466D5f9E0b782B5c08b57475e7907",
		underlyingAssetAddress: "0x3F56e0c36d275367b8C502090EDF38289b3dEa0d"
	}
];

var aaveV3MainnetErc20 = [
	{
		aTokenAddress: "0x4d5F47FA6A74757f35C14fD3a6Ef8E3C9BC514E8",
		stableDebtTokenAddress: "0x102633152313C81cD80419b6EcF66d14Ad68949A",
		variableDebtTokenAddress: "0xeA51d7853EEFb32b6ee06b1C12E6dcCA88Be0fFE",
		underlyingAssetAddress: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2"
	},
	{
		aTokenAddress: "0x0B925eD163218f6662a35e0f0371Ac234f9E9371",
		stableDebtTokenAddress: "0x39739943199c0fBFe9E5f1B5B160cd73a64CB85D",
		variableDebtTokenAddress: "0xC96113eED8cAB59cD8A66813bCB0cEb29F06D2e4",
		underlyingAssetAddress: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0"
	},
	{
		aTokenAddress: "0x5Ee5bf7ae06D1Be5997A1A72006FE6C607eC6DE8",
		stableDebtTokenAddress: "0xA1773F1ccF6DB192Ad8FE826D15fe1d328B03284",
		variableDebtTokenAddress: "0x40aAbEf1aa8f0eEc637E0E7d92fbfFB2F26A8b7B",
		underlyingAssetAddress: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
	},
	{
		aTokenAddress: "0x98C23E9d8f34FEFb1B7BD6a91B7FF122F4e16F5c",
		stableDebtTokenAddress: "0xB0fe3D292f4bd50De902Ba5bDF120Ad66E9d7a39",
		variableDebtTokenAddress: "0x72E95b8931767C79bA4EeE721354d6E99a61D004",
		underlyingAssetAddress: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
	},
	{
		aTokenAddress: "0x018008bfb33d285247A21d44E50697654f754e63",
		stableDebtTokenAddress: "0x413AdaC9E2Ef8683ADf5DDAEce8f19613d60D1bb",
		variableDebtTokenAddress: "0xcF8d0c70c850859266f5C338b38F9D663181C314",
		underlyingAssetAddress: "0x6B175474E89094C44Da98b954EedeAC495271d0F"
	},
	{
		aTokenAddress: "0x5E8C8A7243651DB1384C0dDfDbE39761E8e7E51a",
		stableDebtTokenAddress: "0x63B1129ca97D2b9F97f45670787Ac12a9dF1110a",
		variableDebtTokenAddress: "0x4228F8895C7dDA20227F6a5c6751b8Ebf19a6ba8",
		underlyingAssetAddress: "0x514910771AF9Ca656af840dff83E8264EcF986CA"
	},
	{
		aTokenAddress: "0xA700b4eB416Be35b2911fd5Dee80678ff64fF6C9",
		stableDebtTokenAddress: "0x268497bF083388B1504270d0E717222d3A87D6F2",
		variableDebtTokenAddress: "0xBae535520Abd9f8C85E58929e0006A2c8B372F74",
		underlyingAssetAddress: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9"
	},
	{
		aTokenAddress: "0x977b6fc5dE62598B08C85AC8Cf2b745874E8b78c",
		stableDebtTokenAddress: "0x82bE6012cea6D147B968eBAea5ceEcF6A5b4F493",
		variableDebtTokenAddress: "0x0c91bcA95b5FE69164cE583A2ec9429A569798Ed",
		underlyingAssetAddress: "0xBe9895146f7AF43049ca1c1AE358B0541Ea49704"
	},
	{
		aTokenAddress: "0x23878914EFE38d27C4D67Ab83ed1b93A74D4086a",
		stableDebtTokenAddress: "0x822Fa72Df1F229C3900f5AD6C3Fa2C424D691622",
		variableDebtTokenAddress: "0x6df1C1E379bC5a00a7b4C6e67A203333772f45A8",
		underlyingAssetAddress: "0xdAC17F958D2ee523a2206206994597C13D831ec7"
	},
	{
		aTokenAddress: "0xCc9EE9483f662091a1de4795249E24aC0aC2630f",
		stableDebtTokenAddress: "0x1d1906f909CAe494c7441604DAfDDDbD0485A925",
		variableDebtTokenAddress: "0xae8593DD575FE29A9745056aA91C4b746eee62C8",
		underlyingAssetAddress: "0xae78736Cd615f374D3085123A210448E74Fc6393"
	},
	{
		aTokenAddress: "0x3Fe6a295459FAe07DF8A0ceCC36F37160FE86AA9",
		stableDebtTokenAddress: "0x37A6B708FDB1483C231961b9a7F145261E815fc3",
		variableDebtTokenAddress: "0x33652e48e4B74D18520f11BfE58Edd2ED2cEc5A2",
		underlyingAssetAddress: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0"
	},
	{
		aTokenAddress: "0x7B95Ec873268a6BFC6427e7a28e396Db9D0ebc65",
		stableDebtTokenAddress: "0x90D9CD005E553111EB8C9c31Abe9706a186b6048",
		variableDebtTokenAddress: "0x1b7D3F4b3c032a5AE656e30eeA4e8E1Ba376068F",
		underlyingAssetAddress: "0xD533a949740bb3306d119CC777fa900bA034cd52"
	},
	{
		aTokenAddress: "0x8A458A9dc9048e005d22849F470891b840296619",
		stableDebtTokenAddress: "0x0496372BE7e426D28E89DEBF01f19F014d5938bE",
		variableDebtTokenAddress: "0x6Efc73E54E41b27d2134fF9f98F15550f30DF9B1",
		underlyingAssetAddress: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2"
	},
	{
		aTokenAddress: "0xC7B4c17861357B8ABB91F25581E7263E08DCB59c",
		stableDebtTokenAddress: "0x478E1ec1A2BeEd94c1407c951E4B9e22d53b2501",
		variableDebtTokenAddress: "0x8d0de040e8aAd872eC3c33A3776dE9152D3c34ca",
		underlyingAssetAddress: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F"
	},
	{
		aTokenAddress: "0x2516E7B3F76294e03C42AA4c5b5b4DCE9C436fB8",
		stableDebtTokenAddress: "0xB368d45aaAa07ee2c6275Cb320D140b22dE43CDD",
		variableDebtTokenAddress: "0x3D3efceb4Ff0966D34d9545D3A2fa2dcdBf451f2",
		underlyingAssetAddress: "0xba100000625a3754423978a60c9317c58a424e3D"
	},
	{
		aTokenAddress: "0xF6D2224916DDFbbab6e6bd0D1B7034f4Ae0CaB18",
		stableDebtTokenAddress: "0x2FEc76324A0463c46f32e74A86D1cf94C02158DC",
		variableDebtTokenAddress: "0xF64178Ebd2E2719F2B1233bCb5Ef6DB4bCc4d09a",
		underlyingAssetAddress: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984"
	},
	{
		aTokenAddress: "0x9A44fd41566876A39655f74971a3A6eA0a17a454",
		stableDebtTokenAddress: "0xa0a5bF5781Aeb548db9d4226363B9e89287C5FD2",
		variableDebtTokenAddress: "0xc30808705C01289A3D306ca9CAB081Ba9114eC82",
		underlyingAssetAddress: "0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32"
	}
];

var POOL_ADDRESSES = [{
  address: '0x87870Bca3F3fD6335C3F4ce8392D69350B4fA4E2',
  chainId: 1
}, {
  address: '0x794a61358D6845594F94dc1DB02A252b5b4814aD',
  chainId: 42161
}, {
  address: '0x6Ae43d3271ff6888e7Fc43Fd7321a503ff738951',
  chainId: 11155111
}];
var A_TOKENS = {
  1: aaveV3MainnetErc20,
  5: [],
  42161: aaveV3ArbitrumErc20,
  421613: [],
  11155111: []
};

var Borrow$2 = createPlugin({
  protocol: 'AaveV3',
  type: 'ACTION',
  method: 'borrow',
  supportedContracts: POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_pool_v3'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveV3Tokens({
              chainId: chainId
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          interestRateMode: new FctValue({
            options: [{
              value: '1'
            }, {
              value: '2'
            }]
          }),
          referralCode: new FctValue16({
            required: false,
            readonly: true
          }),
          onBehalfOf: new FctAddress({})
        }
      },
      output: {}
    };
  },
  initParams: {
    methodParams: {
      referralCode: '0' // Aave has disabled referral codes, 0 by default
    }
  },

  requiredApprovals: function requiredApprovals(params, chainId, _walletAddress, vaultAddress) {
    var _params$methodParams = params.methodParams,
      amount = _params$methodParams.amount,
      onBehalfOf = _params$methodParams.onBehalfOf,
      asset = _params$methodParams.asset;
    var assetValue = asset.value;
    if (assetValue && typeof assetValue != 'string') {
      return [];
    }
    var fromTokenData = A_TOKENS[chainId].find(function (token) {
      return token.underlyingAssetAddress.toLowerCase() === assetValue.toLowerCase();
    });
    if (!fromTokenData) {
      return [];
    }
    if (!vaultAddress) return [];
    var value;
    if (typeof amount.value === 'string') {
      value = amount.value;
    }
    if (!value && typeof amount.estimatedValue === 'string') {
      value = amount.estimatedValue;
    }
    if (!value) return [];
    return [{
      to: fromTokenData.aTokenAddress,
      from: onBehalfOf.value,
      params: {
        delegatee: vaultAddress,
        amount: value
      },
      method: 'approveDelegation',
      protocol: 'AAVE'
    }];
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      _params$methodParams2 = params.methodParams,
      amount = _params$methodParams2.amount,
      asset = _params$methodParams2.asset,
      onBehalfOf = _params$methodParams2.onBehalfOf,
      interestRateMode = _params$methodParams2.interestRateMode;
    if (!interestRateMode.value || !asset.value || !to.value || !amount.value || !onBehalfOf.value || !vaultAddress) return [];
    if (typeof interestRateMode.value !== 'string' || typeof amount.value !== 'string' || typeof asset.value !== 'string' || typeof to.value !== 'string') return [];
    var assetData = A_TOKENS[chainId].find(function (token) {
      return token.underlyingAssetAddress.toLowerCase() === asset.value.toLowerCase();
    });
    if (!assetData) return [];
    var debtToken = interestRateMode.value === '1' ? assetData.stableDebtTokenAddress : assetData.variableDebtTokenAddress;
    return [{
      address: vaultAddress,
      toSpend: [],
      toReceive: [{
        token: asset.value,
        amount: amount.value
      }, {
        token: debtToken,
        amount: amount.value
      }]
    }, {
      address: to.value,
      toSpend: [{
        token: asset.value,
        amount: amount.value
      }],
      toReceive: []
    }];
  }
});

var Repay$1 = createPlugin({
  protocol: 'AaveV3',
  type: 'ACTION',
  method: 'repay',
  supportedContracts: POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_pool_v3'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveV3Tokens({
              chainId: chainId
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          interestRateMode: new FctValue({
            options: [{
              value: '1'
            }, {
              value: '2'
            }]
          }),
          onBehalfOf: new FctAddress({})
        }
      },
      output: {
        amountRepaid: new FctValue({
          innerIndex: 0
        })
      }
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams = params.methodParams,
      asset = _params$methodParams.asset,
      amount = _params$methodParams.amount,
      onBehalfOf = _params$methodParams.onBehalfOf;
    var value;
    if (typeof amount.value === 'string') {
      value = amount.value;
    }
    if (!value && typeof amount.estimatedValue === 'string') {
      value = amount.estimatedValue;
    }
    if (!value) return [];
    return [{
      to: asset.value,
      from: onBehalfOf.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      _params$methodParams2 = params.methodParams,
      amount = _params$methodParams2.amount,
      asset = _params$methodParams2.asset,
      onBehalfOf = _params$methodParams2.onBehalfOf,
      interestRateMode = _params$methodParams2.interestRateMode;
    if (!interestRateMode.value || !asset.value || !to.value || !amount.value || !onBehalfOf.value || !vaultAddress) return [];
    if (typeof interestRateMode.value !== 'string' || typeof amount.value !== 'string' || typeof asset.value !== 'string' || typeof to.value !== 'string') return [];
    var assetData = A_TOKENS[chainId].find(function (token) {
      return token.underlyingAssetAddress.toLowerCase() === asset.value.toLowerCase();
    });
    if (!assetData) return [];
    var debtToken = interestRateMode.value === '1' ? assetData.stableDebtTokenAddress : assetData.variableDebtTokenAddress;
    return [{
      address: vaultAddress,
      toSpend: [
      // NOTE: I am not sure if this is entirely correct.
      // It might be that we need to do offchain calls.
      {
        token: asset.value,
        amount: amount.value
      }, {
        token: debtToken,
        amount: amount.value
      }],
      toReceive: []
    }, {
      address: to.value,
      toSpend: [],
      toReceive: [{
        token: asset.value,
        amount: amount.value
      }]
    }];
  }
});

var RepayWithATokens = createPlugin({
  protocol: 'AaveV3',
  type: 'ACTION',
  method: 'repayWithATokens',
  supportedContracts: POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_pool_v3'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveV3Tokens({
              chainId: chainId
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          interestRateMode: new FctValue({
            options: [{
              value: '1'
            }, {
              value: '2'
            }]
          })
        }
      },
      output: {
        amountRepaid: new FctValue({
          innerIndex: 0
        })
      }
    };
  }
  // TODO: assetFlow needs to find the aToken address for the asset and return correct assetFlow
});

var SetUserEMode = createPlugin({
  protocol: 'AaveV3',
  type: 'ACTION',
  method: 'setUserEMode',
  supportedContracts: POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_pool_v3'
        }),
        methodParams: {
          categoryId: new FctValue8({})
        }
      },
      output: {}
    };
  }
});

var SetUserUseReserveAsCollateral = createPlugin({
  protocol: 'AaveV3',
  type: 'ACTION',
  method: 'setUserUseReserveAsCollateral',
  supportedContracts: POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_pool_v3'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveV3Tokens({
              chainId: chainId
            })
          }),
          useAsCollateral: new FctBoolean({})
        }
      },
      output: {}
    };
  }
});

var Supply$1 = createPlugin({
  protocol: 'AaveV3',
  type: 'ACTION',
  method: 'supply',
  supportedContracts: POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_pool_v3'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveV3Tokens({
              chainId: chainId
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          onBehalfOf: new FctAddress({}),
          referralCode: new FctValue16({})
        }
      },
      output: {}
    };
  },
  initParams: {
    methodParams: {
      referralCode: '0' // Aave has disabled referral codes, 0 by default
    }
  },

  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams = params.methodParams,
      asset = _params$methodParams.asset,
      amount = _params$methodParams.amount,
      onBehalfOf = _params$methodParams.onBehalfOf;
    var value;
    if (typeof amount.value === 'string') {
      value = amount.value;
    }
    if (!value && typeof amount.estimatedValue === 'string') {
      value = amount.estimatedValue;
    }
    if (!value) return [];
    return [{
      to: asset.value,
      from: onBehalfOf.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      _params$methodParams2 = params.methodParams,
      amount = _params$methodParams2.amount,
      asset = _params$methodParams2.asset,
      onBehalfOf = _params$methodParams2.onBehalfOf;
    if (!asset.value || !to.value || !amount.value || !onBehalfOf.value || !vaultAddress) return [];
    if (typeof amount.value !== 'string' || typeof asset.value !== 'string' || typeof to.value !== 'string') return [];
    return [{
      address: vaultAddress,
      toSpend: [{
        token: asset.value,
        amount: amount.value
      }],
      toReceive: []
    }, {
      address: to.value,
      toSpend: [],
      toReceive: [{
        token: asset.value,
        amount: amount.value
      }]
    }];
  }
});

var SwapBorrowRateMode$1 = createPlugin({
  protocol: 'AaveV3',
  type: 'ACTION',
  method: 'swapBorrowRateMode',
  supportedContracts: POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_pool_v3'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveV3Tokens({
              chainId: chainId
            })
          }),
          interestRateMode: new FctValue({
            options: [{
              value: '1'
            }, {
              value: '2'
            }]
          })
        }
      },
      output: {}
    };
  }
});

var Withdraw$5 = createPlugin({
  protocol: 'AaveV3',
  type: 'ACTION',
  method: 'withdraw',
  supportedContracts: POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_pool_v3'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveV3Tokens({
              chainId: chainId
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          to: new FctAddress({})
        }
      },
      output: {
        amountWithdrawn: new FctValue({
          innerIndex: 0
        })
      }
    };
  }
});

var GetReserveData$1 = createPlugin({
  protocol: 'AaveV3',
  type: 'GETTER',
  method: 'getReserveData',
  supportedContracts: POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_pool_v3'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveV3Tokens({
              chainId: chainId
            })
          })
        }
      },
      output: {
        configuration: new FctValue({
          innerIndex: 0
        }),
        liquidityIndex: new FctValue128_27({
          innerIndex: 1
        }),
        currentLiquidityRate: new FctValue128_27({
          innerIndex: 2
        }),
        variableBorrowIndex: new FctValue128_27({
          innerIndex: 3
        }),
        currentVariableBorrowRate: new FctValue128_27({
          innerIndex: 4
        }),
        currentStableBorrowRate: new FctValue128_27({
          innerIndex: 5
        }),
        lastUpdateTimestamp: new FctValue40({
          innerIndex: 6
        }),
        id: new FctValue16({
          innerIndex: 7
        }),
        aTokenAddress: new FctAddress({
          innerIndex: 8
        }),
        stableDebtTokenAddress: new FctAddress({
          innerIndex: 9
        }),
        variableDebtTokenAddress: new FctAddress({
          innerIndex: 10
        }),
        interestRateStrategyAddress: new FctAddress({
          innerIndex: 11
        }),
        accruedToTreasury: new FctValue128({
          innerIndex: 12
        }),
        unbacked: new FctValue128({
          innerIndex: 13
        }),
        isolationModeTotalDebt: new FctValue128({
          innerIndex: 14
        })
      }
    };
  }
});

var GetReserveNormalizedIncome = createPlugin({
  protocol: 'AaveV3',
  type: 'GETTER',
  method: 'getReserveNormalizedIncome',
  supportedContracts: POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_pool_v3'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveV3Tokens({
              chainId: chainId
            })
          })
        }
      },
      output: {
        normalizedIncome: new FctValue27({
          innerIndex: 0
        })
      }
    };
  }
});

var GetReserveNormalizedVariableDebt = createPlugin({
  protocol: 'AaveV3',
  type: 'GETTER',
  method: 'getReserveNormalizedVariableDebt',
  supportedContracts: POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_pool_v3'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getAaveV3Tokens({
              chainId: chainId
            })
          })
        }
      },
      output: {
        normalizedVariableDebt: new FctValue27({
          innerIndex: 0
        })
      }
    };
  }
});

var GetUserAccountData$1 = createPlugin({
  protocol: 'AaveV3',
  type: 'GETTER',
  method: 'getUserAccountData',
  supportedContracts: POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_pool_v3'
        }),
        methodParams: {
          user: new FctAddress({})
        }
      },
      output: {
        totalCollateralBase: new FctValue({
          innerIndex: 0
        }),
        totalDebtBase: new FctValue({
          innerIndex: 1
        }),
        availableBorrowsBase: new FctValue({
          innerIndex: 2
        }),
        currentLiquidationThreshold: new FctBps({
          innerIndex: 3
        }),
        ltv: new FctBps({
          innerIndex: 4
        }),
        healthFactor: new FctValue({
          innerIndex: 5
        })
      }
    };
  }
});

var GetUserEMode = createPlugin({
  protocol: 'AaveV3',
  type: 'GETTER',
  method: 'getUserEMode',
  supportedContracts: POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_pool_v3'
        }),
        methodParams: {
          user: new FctAddress({})
        }
      },
      output: {
        eMode: new FctValue({
          innerIndex: 0
        })
      }
    };
  }
});

var actions$j = {
  Borrow: Borrow$2,
  Repay: Repay$1,
  RepayWithATokens: RepayWithATokens,
  SetUserEMode: SetUserEMode,
  SetUserUseReserveAsCollateral: SetUserUseReserveAsCollateral,
  Supply: Supply$1,
  SwapBorrowRateMode: SwapBorrowRateMode$1,
  Withdraw: Withdraw$5
};
var getters$h = {
  GetReserveData: GetReserveData$1,
  GetReserveNormalizedIncome: GetReserveNormalizedIncome,
  GetReserveNormalizedVariableDebt: GetReserveNormalizedVariableDebt,
  GetUserAccountData: GetUserAccountData$1,
  GetUserEMode: GetUserEMode
};
var AaveV3 = {
  actions: actions$j,
  getters: getters$h
};

var arbitrumPairsGoerli = [
	{
		value: "0x9b2C6EeFAFf544deDA38C7256854d6e44DbCbEcB",
		address: "0x9b2C6EeFAFf544deDA38C7256854d6e44DbCbEcB",
		name: "SPY / USD",
		symbol: "SPY / USD",
		decimals: 8
	},
	{
		value: "0xBA862EC11ef2E9b12bcc1537B5762F351fE1fd03",
		address: "0xBA862EC11ef2E9b12bcc1537B5762F351fE1fd03",
		name: "ETH-USD 30-Day Realized Vol",
		symbol: "ETH-USD 30-Day Realized Vol",
		decimals: 5
	},
	{
		value: "0x8bdFc91FB3f89F4c211461B06afDe84Dc55bedc2",
		address: "0x8bdFc91FB3f89F4c211461B06afDe84Dc55bedc2",
		name: "BTC-USD 1-Day Realized Vol",
		symbol: "BTC-USD 1-Day Realized Vol",
		decimals: 5
	},
	{
		value: "0x103b53E977DA6E4Fa92f76369c8b7e20E7fb7fe1",
		address: "0x103b53E977DA6E4Fa92f76369c8b7e20E7fb7fe1",
		name: "DAI / USD",
		symbol: "DAI / USD",
		decimals: 8
	},
	{
		value: "0x66765301a65dc76F1eec04494E55d939E23f59Bb",
		address: "0x66765301a65dc76F1eec04494E55d939E23f59Bb",
		name: "BTC / ETH",
		symbol: "BTC / ETH",
		decimals: 18
	},
	{
		value: "0x6550bc2301936011c1334555e62A87705A81C12C",
		address: "0x6550bc2301936011c1334555e62A87705A81C12C",
		name: "BTC / USD",
		symbol: "BTC / USD",
		decimals: 8
	},
	{
		value: "0x2eE9BFB2D319B31A573EA15774B755715988E99D",
		address: "0x2eE9BFB2D319B31A573EA15774B755715988E99D",
		name: "ARB / USD",
		symbol: "ARB / USD",
		decimals: 8
	},
	{
		value: "0x025600F206C83854D33209Adceb23840f2963700",
		address: "0x025600F206C83854D33209Adceb23840f2963700",
		name: "30-Day ETH APR",
		symbol: "30-Day ETH APR",
		decimals: 7
	},
	{
		value: "0x90F64B16c9d7bD03801b9Ec4038749065Aecc810",
		address: "0x90F64B16c9d7bD03801b9Ec4038749065Aecc810",
		name: "ETH-USD 7-Day Realized Vol",
		symbol: "ETH-USD 7-Day Realized Vol",
		decimals: 5
	},
	{
		value: "0x4da69F028a5790fCCAfe81a75C0D24f46ceCDd69",
		address: "0x4da69F028a5790fCCAfe81a75C0D24f46ceCDd69",
		name: "L2 Sequencer Uptime Status Feed",
		symbol: "L2 Sequencer Uptime Status Feed",
		decimals: 0
	},
	{
		value: "0x1B8e08a5457b12ae3CbC4233e645AEE2fA809e39",
		address: "0x1B8e08a5457b12ae3CbC4233e645AEE2fA809e39",
		name: "ETH-USD 1-Day Realized Vol",
		symbol: "ETH-USD 1-Day Realized Vol",
		decimals: 5
	},
	{
		value: "0x3aDfcAA2E172258E1190f92151d517F11f5c3FBE",
		address: "0x3aDfcAA2E172258E1190f92151d517F11f5c3FBE",
		name: "BTC-USD 7-Day Realized Vol",
		symbol: "BTC-USD 7-Day Realized Vol",
		decimals: 5
	},
	{
		value: "0x0a023a3423D9b27A0BE48c768CCF2dD7877fEf5E",
		address: "0x0a023a3423D9b27A0BE48c768CCF2dD7877fEf5E",
		name: "USDT / USD",
		symbol: "USDT / USD",
		decimals: 8
	},
	{
		value: "0x62CAe0FA2da220f43a51F86Db2EDb36DcA9A5A08",
		address: "0x62CAe0FA2da220f43a51F86Db2EDb36DcA9A5A08",
		name: "ETH / USD",
		symbol: "ETH / USD",
		decimals: 8
	},
	{
		value: "0x1692Bdd32F31b831caAc1b0c9fAF68613682813b",
		address: "0x1692Bdd32F31b831caAc1b0c9fAF68613682813b",
		name: "USDC / USD",
		symbol: "USDC / USD",
		decimals: 8
	},
	{
		value: "0x1AdDb2368414B3b4cF1BCe7A887d2De7Bfb6886f",
		address: "0x1AdDb2368414B3b4cF1BCe7A887d2De7Bfb6886f",
		name: "LINK / ETH",
		symbol: "LINK / ETH",
		decimals: 18
	},
	{
		value: "0x683677Fe19c36006163292b721a46AFaeaD9683C",
		address: "0x683677Fe19c36006163292b721a46AFaeaD9683C",
		name: "90-Day ETH APR",
		symbol: "90-Day ETH APR",
		decimals: 7
	},
	{
		value: "0x9c4E6b6A9b1EeEE7DA00A827C81C31480025bE25",
		address: "0x9c4E6b6A9b1EeEE7DA00A827C81C31480025bE25",
		name: "BTC-USD 30-Day Realized Vol",
		symbol: "BTC-USD 30-Day Realized Vol",
		decimals: 5
	},
	{
		value: "0xd28Ba6CA3bB72bF371b80a2a0a33cBcf9073C954",
		address: "0xd28Ba6CA3bB72bF371b80a2a0a33cBcf9073C954",
		name: "LINK / USD",
		symbol: "LINK / USD",
		decimals: 8
	}
];

var arbitrumPairsMainnet = [
	{
		value: "0x8d0CC5f38f9E802475f2CFf4F9fc7000C2E1557c",
		address: "0x8d0CC5f38f9E802475f2CFf4F9fc7000C2E1557c",
		type: "Equities",
		name: "AAPL / USD",
		symbol: "AAPL / USD",
		decimals: 8
	},
	{
		value: "0x46306F3795342117721D8DEd50fbcF6DF2b3cc10",
		address: "0x46306F3795342117721D8DEd50fbcF6DF2b3cc10",
		type: "Equities",
		name: "SPY / USD",
		symbol: "SPY / USD",
		decimals: 8
	},
	{
		value: "0x205aaD468a11fd5D34fA7211bC6Bad5b3deB9b98",
		address: "0x205aaD468a11fd5D34fA7211bC6Bad5b3deB9b98",
		type: "Crypto (USD)",
		name: "OP / USD",
		symbol: "OP / USD",
		decimals: 8
	},
	{
		value: "0x221912ce795669f628c51c69b7d0873eDA9C03bB",
		address: "0x221912ce795669f628c51c69b7d0873eDA9C03bB",
		type: "Crypto (USD)",
		name: "APE / USD",
		symbol: "APE / USD",
		decimals: 8
	},
	{
		value: "0xC56765f04B248394CF1619D20dB8082Edbfa75b1",
		address: "0xC56765f04B248394CF1619D20dB8082Edbfa75b1",
		type: "Commodities",
		name: "XAG / USD",
		symbol: "XAG / USD",
		decimals: 8
	},
	{
		value: "0xF3272CAfe65b190e76caAF483db13424a3e23dD2",
		address: "0xF3272CAfe65b190e76caAF483db13424a3e23dD2",
		type: "Crypto (ETH)",
		name: "rETH-ETH Exchange Rate",
		symbol: "rETH-ETH Exchange Rate",
		decimals: 18
	},
	{
		value: "0x87121F6c9A9F6E90E59591E4Cf4804873f54A95b",
		address: "0x87121F6c9A9F6E90E59591E4Cf4804873f54A95b",
		type: "Crypto (Stablecoin)",
		name: "MIM / USD",
		symbol: "MIM / USD",
		decimals: 8
	},
	{
		value: "0xb523AE262D20A936BC152e6023996e46FDC2A95D",
		address: "0xb523AE262D20A936BC152e6023996e46FDC2A95D",
		type: "Crypto (ETH)",
		name: "WSTETH / ETH",
		symbol: "WSTETH / ETH",
		decimals: 18
	},
	{
		value: "0x3609baAa0a9b1f0FE4d6CC01884585d0e191C3E3",
		address: "0x3609baAa0a9b1f0FE4d6CC01884585d0e191C3E3",
		type: "Equities",
		name: "TSLA / USD",
		symbol: "TSLA / USD",
		decimals: 8
	},
	{
		value: "0x1D1a83331e9D255EB1Aaf75026B60dFD00A252ba",
		address: "0x1D1a83331e9D255EB1Aaf75026B60dFD00A252ba",
		type: "Equities",
		name: "GOOGL / USD",
		symbol: "GOOGL / USD",
		decimals: 8
	},
	{
		value: "0x8D0e319eBAA8DF32e088e469062F85abF2eBe599",
		address: "0x8D0e319eBAA8DF32e088e469062F85abF2eBe599",
		type: "NFTs",
		name: "NFT Blue Chip Total Market Cap-USD",
		symbol: "NFT Blue Chip Total Market Cap-USD",
		decimals: 8
	},
	{
		value: "0xD6aB2298946840262FcC278fF31516D39fF611eF",
		address: "0xD6aB2298946840262FcC278fF31516D39fF611eF",
		type: "Crypto (ETH)",
		name: "RETH / ETH",
		symbol: "RETH / ETH",
		decimals: 18
	},
	{
		value: "0x0017abAc5b6f291F9164e35B1234CA1D697f9CF4",
		address: "0x0017abAc5b6f291F9164e35B1234CA1D697f9CF4",
		type: "Crypto",
		name: "WBTC / BTC",
		symbol: "WBTC / BTC",
		decimals: 8
	},
	{
		value: "0x761aaeBf021F19F198D325D7979965D0c7C9e53b",
		address: "0x761aaeBf021F19F198D325D7979965D0c7C9e53b",
		type: "Crypto (USD)",
		name: "OHMv2 / USD",
		symbol: "OHMv2 / USD",
		decimals: 8
	},
	{
		value: "0xB4AD57B52aB9141de9926a3e0C8dc6264c2ef205",
		address: "0xB4AD57B52aB9141de9926a3e0C8dc6264c2ef205",
		type: "Crypto (USD)",
		name: "XRP / USD",
		symbol: "XRP / USD",
		decimals: 8
	},
	{
		value: "0x48C4721354A3B29D80EF03C65E6644A37338a0B1",
		address: "0x48C4721354A3B29D80EF03C65E6644A37338a0B1",
		type: "Crypto",
		name: "OHM Index",
		symbol: "OHM Index",
		decimals: 9
	},
	{
		value: "0xcC3370Bde6AFE51e1205a5038947b9836371eCCb",
		address: "0xcC3370Bde6AFE51e1205a5038947b9836371eCCb",
		type: "Forex",
		name: "CNY / USD",
		symbol: "CNY / USD",
		decimals: 8
	},
	{
		value: "0xbF539d4c2106dd4D9AB6D56aed3d9023529Db145",
		address: "0xbF539d4c2106dd4D9AB6D56aed3d9023529Db145",
		type: "Crypto (USD)",
		name: "KNC / USD",
		symbol: "KNC / USD",
		decimals: 8
	},
	{
		value: "0x0411D28c94d85A36bC72Cb0f875dfA8371D8fFfF",
		address: "0x0411D28c94d85A36bC72Cb0f875dfA8371D8fFfF",
		type: "Crypto (Stablecoin)",
		name: "LUSD / USD",
		symbol: "LUSD / USD",
		decimals: 8
	},
	{
		value: "0xdA76130d2dDDE18bCEF6e2b66B5268B5658E3061",
		address: "0xdA76130d2dDDE18bCEF6e2b66B5268B5658E3061",
		type: "Crypto (USD)",
		name: "PEPE / USD",
		symbol: "PEPE / USD",
		decimals: 8
	},
	{
		value: "0x85bb02E0Ae286600d1c68Bb6Ce22Cc998d411916",
		address: "0x85bb02E0Ae286600d1c68Bb6Ce22Cc998d411916",
		type: "Forex",
		name: "KRW / USD",
		symbol: "KRW / USD",
		decimals: 8
	},
	{
		value: "0xc373B9DB0707fD451Bc56bA5E9b029ba26629DF0",
		address: "0xc373B9DB0707fD451Bc56bA5E9b029ba26629DF0",
		type: "Crypto (USD)",
		name: "DPX / USD",
		symbol: "DPX / USD",
		decimals: 8
	},
	{
		value: "0x50834F3163758fcC1Df9973b6e91f0F0F0434aD3",
		address: "0x50834F3163758fcC1Df9973b6e91f0F0F0434aD3",
		type: "Crypto (Stablecoin)",
		name: "USDC / USD",
		symbol: "USDC / USD",
		decimals: 8
	},
	{
		value: "0xa6bC5bAF2000424e90434bA7104ee399dEe80DEc",
		address: "0xa6bC5bAF2000424e90434bA7104ee399dEe80DEc",
		type: "Crypto (USD)",
		name: "DOT / USD",
		symbol: "DOT / USD",
		decimals: 8
	},
	{
		value: "0x2BA975D4D7922cD264267Af16F3bD177F206FE3c",
		address: "0x2BA975D4D7922cD264267Af16F3bD177F206FE3c",
		type: "Crypto (USD)",
		name: "PAXG / USD",
		symbol: "PAXG / USD",
		decimals: 8
	},
	{
		value: "0x639Fe6ab55C921f74e7fac1ee960C0B6293ba612",
		address: "0x639Fe6ab55C921f74e7fac1ee960C0B6293ba612",
		type: "Crypto (ETH)",
		name: "ETH / USD",
		symbol: "ETH / USD",
		decimals: 8
	},
	{
		value: "0x054296f0D036b95531B4E14aFB578B80CFb41252",
		address: "0x054296f0D036b95531B4E14aFB578B80CFb41252",
		type: "Crypto (USD)",
		name: "SNX / USD",
		symbol: "SNX / USD",
		decimals: 8
	},
	{
		value: "0xaD1d5344AaDE45F43E596773Bcc4c423EAbdD034",
		address: "0xaD1d5344AaDE45F43E596773Bcc4c423EAbdD034",
		type: "Crypto (USD)",
		name: "AAVE / USD",
		symbol: "AAVE / USD",
		decimals: 8
	},
	{
		value: "0xc5a90A6d7e4Af242dA238FFe279e9f2BA0c64B2e",
		address: "0xc5a90A6d7e4Af242dA238FFe279e9f2BA0c64B2e",
		type: "Crypto (ETH)",
		name: "BTC / ETH",
		symbol: "BTC / ETH",
		decimals: 18
	},
	{
		value: "0x851175a919f36c8e30197c09a9A49dA932c2CC00",
		address: "0x851175a919f36c8e30197c09a9A49dA932c2CC00",
		type: "Crypto (USD)",
		name: "CVX / USD",
		symbol: "CVX / USD",
		decimals: 8
	},
	{
		value: "0x9854e9a850e7C354c1de177eA953a6b1fba8Fc22",
		address: "0x9854e9a850e7C354c1de177eA953a6b1fba8Fc22",
		type: "Forex",
		name: "AUD / USD",
		symbol: "AUD / USD",
		decimals: 8
	},
	{
		value: "0xF0b7159BbFc341Cc41E7Cb182216F62c6d40533D",
		address: "0xF0b7159BbFc341Cc41E7Cb182216F62c6d40533D",
		type: "Crypto (USD)",
		name: "RPL / USD",
		symbol: "RPL / USD",
		decimals: 8
	},
	{
		value: "0xb2A824043730FE05F3DA2efaFa1CBbe83fa548D6",
		address: "0xb2A824043730FE05F3DA2efaFa1CBbe83fa548D6",
		type: "Crypto (USD)",
		name: "ARB / USD",
		symbol: "ARB / USD",
		decimals: 8
	},
	{
		value: "0x256654437f1ADA8057684b18d742eFD14034C400",
		address: "0x256654437f1ADA8057684b18d742eFD14034C400",
		type: "Crypto (USD)",
		name: "CAKE / USD",
		symbol: "CAKE / USD",
		decimals: 8
	},
	{
		value: "0x594b919AD828e693B935705c3F816221729E7AE8",
		address: "0x594b919AD828e693B935705c3F816221729E7AE8",
		type: "Commodities",
		name: "WTI / USD",
		symbol: "WTI / USD",
		decimals: 8
	},
	{
		value: "0xe74d69E233faB0d8F48921f2D93aDfDe44cEb3B7",
		address: "0xe74d69E233faB0d8F48921f2D93aDfDe44cEb3B7",
		type: "Crypto (USD)",
		name: "STG / USD",
		symbol: "STG / USD",
		decimals: 8
	},
	{
		value: "0x66853E19d73c0F9301fe099c324A1E9726953433",
		address: "0x66853E19d73c0F9301fe099c324A1E9726953433",
		type: "Crypto (USD)",
		name: "PENDLE / USD",
		symbol: "PENDLE / USD",
		decimals: 8
	},
	{
		value: "0xE89E98CE4E19071E59Ed4780E0598b541CE76486",
		address: "0xE89E98CE4E19071E59Ed4780E0598b541CE76486",
		type: "Crypto (USD)",
		name: "GNS / USD",
		symbol: "GNS / USD",
		decimals: 8
	},
	{
		value: "0x80dd57c45B73f3c70feAF1BFe1bcdF384703E558",
		address: "0x80dd57c45B73f3c70feAF1BFe1bcdF384703E558",
		type: "Crypto",
		name: "ibBTC PricePerShare",
		symbol: "ibBTC PricePerShare",
		decimals: 18
	},
	{
		value: "0xf6DA27749484843c4F02f5Ad1378ceE723dD61d4",
		address: "0xf6DA27749484843c4F02f5Ad1378ceE723dD61d4",
		type: "Forex",
		name: "CAD / USD",
		symbol: "CAD / USD",
		decimals: 8
	},
	{
		value: "0xe7C53FFd03Eb6ceF7d208bC4C13446c76d1E5884",
		address: "0xe7C53FFd03Eb6ceF7d208bC4C13446c76d1E5884",
		type: "Crypto (USD)",
		name: "COMP / USD",
		symbol: "COMP / USD",
		decimals: 8
	},
	{
		value: "0xBE5eA816870D11239c543F84b71439511D70B94f",
		address: "0xBE5eA816870D11239c543F84b71439511D70B94f",
		type: "Crypto (USD)",
		name: "BAL / USD",
		symbol: "BAL / USD",
		decimals: 8
	},
	{
		value: "0xdE9f0894670c4EFcacF370426F10C3AD2Cdf147e",
		address: "0xdE9f0894670c4EFcacF370426F10C3AD2Cdf147e",
		type: "Crypto (USD)",
		name: "MKR / USD",
		symbol: "MKR / USD",
		decimals: 8
	},
	{
		value: "0x5C3e80763862CB777Aa07BDDBcCE0123104e1c34",
		address: "0x5C3e80763862CB777Aa07BDDBcCE0123104e1c34",
		type: "Crypto (ETH)",
		name: "frxETH-ETH Exchange Rate High",
		symbol: "frxETH-ETH Exchange Rate High",
		decimals: 18
	},
	{
		value: "0xd6a77691f071E98Df7217BED98f38ae6d2313EBA",
		address: "0xd6a77691f071E98Df7217BED98f38ae6d2313EBA",
		type: "Equities",
		name: "AMZN / USD",
		symbol: "AMZN / USD",
		decimals: 8
	},
	{
		value: "0x0809E3d38d1B4214958faf06D8b1B1a2b73f2ab8",
		address: "0x0809E3d38d1B4214958faf06D8b1B1a2b73f2ab8",
		type: "Crypto (Stablecoin)",
		name: "FRAX / USD",
		symbol: "FRAX / USD",
		decimals: 8
	},
	{
		value: "0xfF82AAF635645fD0bcc7b619C3F28004cDb58574",
		address: "0xfF82AAF635645fD0bcc7b619C3F28004cDb58574",
		type: "Forex",
		name: "PHP / USD",
		symbol: "PHP / USD",
		decimals: 8
	},
	{
		value: "0xDde33fb9F21739602806580bdd73BAd831DcA867",
		address: "0xDde33fb9F21739602806580bdd73BAd831DcA867",
		type: "Equities",
		name: "MSFT / USD",
		symbol: "MSFT / USD",
		decimals: 8
	},
	{
		value: "0x47E55cCec6582838E173f252D08Afd8116c2202d",
		address: "0x47E55cCec6582838E173f252D08Afd8116c2202d",
		type: "Crypto (USD)",
		name: "MAGIC / USD",
		symbol: "MAGIC / USD",
		decimals: 8
	},
	{
		value: "0x04b7384473A2aDF1903E3a98aCAc5D62ba8C2702",
		address: "0x04b7384473A2aDF1903E3a98aCAc5D62ba8C2702",
		type: "Forex",
		name: "BRL / USD",
		symbol: "BRL / USD",
		decimals: 8
	},
	{
		value: "0x98E5a52fB741347199C08a7a3fcF017364284431",
		address: "0x98E5a52fB741347199C08a7a3fcF017364284431",
		type: "Crypto (ETH)",
		name: "sfrxETH-frxETH Exchange Rate",
		symbol: "sfrxETH-frxETH Exchange Rate",
		decimals: 18
	},
	{
		value: "0x745Ab5b69E01E2BE1104Ca84937Bb71f96f5fB21",
		address: "0x745Ab5b69E01E2BE1104Ca84937Bb71f96f5fB21",
		type: "Crypto (USD)",
		name: "YFI / USD",
		symbol: "YFI / USD",
		decimals: 8
	},
	{
		value: "0x02DEd5a7EDDA750E3Eb240b54437a54d57b74dBE",
		address: "0x02DEd5a7EDDA750E3Eb240b54437a54d57b74dBE",
		type: "Crypto (USD)",
		name: "PEPE / USD",
		symbol: "PEPE / USD",
		decimals: 18
	},
	{
		value: "0x484A1b29ED1Ea038dBd75D7c7293714343363122",
		address: "0x484A1b29ED1Ea038dBd75D7c7293714343363122",
		type: "Crypto (USD)",
		name: "IOTX / USD",
		symbol: "IOTX / USD",
		decimals: 8
	},
	{
		value: "0x8FCb0F3715A82D83270777b3a5f3a7CF95Ce8Eec",
		address: "0x8FCb0F3715A82D83270777b3a5f3a7CF95Ce8Eec",
		type: "Crypto (Stablecoin)",
		name: "BUSD / USD",
		symbol: "BUSD / USD",
		decimals: 8
	},
	{
		value: "0xFeaC1A3936514746e70170c0f539e70b23d36F19",
		address: "0xFeaC1A3936514746e70170c0f539e70b23d36F19",
		type: "Crypto (USD)",
		name: "FTM / USD",
		symbol: "FTM / USD",
		decimals: 8
	},
	{
		value: "0x052d4200b624b07262F574af26C71A6553996Ab5",
		address: "0x052d4200b624b07262F574af26C71A6553996Ab5",
		type: "Crypto (ETH)",
		name: "StaFi Staked ETH rETH-ETH Exchange Rate",
		symbol: "StaFi Staked ETH rETH-ETH Exchange Rate",
		decimals: 18
	},
	{
		value: "0xCDA67618e51762235eacA373894F0C79256768fa",
		address: "0xCDA67618e51762235eacA373894F0C79256768fa",
		type: "Crypto (USD)",
		name: "ATOM / USD",
		symbol: "ATOM / USD",
		decimals: 8
	},
	{
		value: "0x9C4424Fd84C6661F97D8d6b3fc3C1aAc2BeDd137",
		address: "0x9C4424Fd84C6661F97D8d6b3fc3C1aAc2BeDd137",
		type: "Forex",
		name: "GBP / USD",
		symbol: "GBP / USD",
		decimals: 8
	},
	{
		value: "0xaebDA2c976cfd1eE1977Eac079B4382acb849325",
		address: "0xaebDA2c976cfd1eE1977Eac079B4382acb849325",
		type: "Crypto (USD)",
		name: "CRV / USD",
		symbol: "CRV / USD",
		decimals: 8
	},
	{
		value: "0xA14d53bC1F1c0F31B4aA3BD109344E5009051a84",
		address: "0xA14d53bC1F1c0F31B4aA3BD109344E5009051a84",
		type: "Forex",
		name: "EUR / USD",
		symbol: "EUR / USD",
		decimals: 8
	},
	{
		value: "0x4763b84cdBc5211B9e0a57D5E39af3B3b2440012",
		address: "0x4763b84cdBc5211B9e0a57D5E39af3B3b2440012",
		type: "Currency",
		name: "Total Marketcap USD",
		symbol: "Total Marketcap USD",
		decimals: 8
	},
	{
		value: "0x0518673439245BB95A58688Bc31cd513F3D5bDd6",
		address: "0x0518673439245BB95A58688Bc31cd513F3D5bDd6",
		type: "Crypto (ETH)",
		name: "cbETH-ETH Exchange Rate",
		symbol: "cbETH-ETH Exchange Rate",
		decimals: 18
	},
	{
		value: "0xF0d38324d1F86a176aC727A4b0c43c9F9d9c5EB1",
		address: "0xF0d38324d1F86a176aC727A4b0c43c9F9d9c5EB1",
		type: "Forex",
		name: "SGD / USD",
		symbol: "SGD / USD",
		decimals: 8
	},
	{
		value: "0x5e2b5C5C07cCA3437c4D724225Bb42c7E55d1597",
		address: "0x5e2b5C5C07cCA3437c4D724225Bb42c7E55d1597",
		type: "Crypto (USD)",
		name: "WOO / USD",
		symbol: "WOO / USD",
		decimals: 8
	},
	{
		value: "0x7519bCA20e21725557Bb98d9032124f8885a26C2",
		address: "0x7519bCA20e21725557Bb98d9032124f8885a26C2",
		type: "Crypto (USD)",
		name: "BTC-USD Total Marketcap",
		symbol: "BTC-USD Total Marketcap",
		decimals: 8
	},
	{
		value: "0xE8f8AfE4b56c6C421F691bfAc225cE61b2C7CD05",
		address: "0xE8f8AfE4b56c6C421F691bfAc225cE61b2C7CD05",
		type: "Forex",
		name: "TRY / USD",
		symbol: "TRY / USD",
		decimals: 8
	},
	{
		value: "0x24ceA4b8ce57cdA5058b924B9B9987992450590c",
		address: "0x24ceA4b8ce57cdA5058b924B9B9987992450590c",
		type: "Crypto (USD)",
		name: "SOL / USD",
		symbol: "SOL / USD",
		decimals: 8
	},
	{
		value: "0x6ce185860a4963106506C203335A2910413708e9",
		address: "0x6ce185860a4963106506C203335A2910413708e9",
		type: "Crypto (USD)",
		name: "BTC / USD",
		symbol: "BTC / USD",
		decimals: 8
	},
	{
		value: "0x20d0Fcab0ECFD078B036b6CAf1FaC69A6453b352",
		address: "0x20d0Fcab0ECFD078B036b6CAf1FaC69A6453b352",
		type: "Crypto (USD)",
		name: "RDNT / USD",
		symbol: "RDNT / USD",
		decimals: 8
	},
	{
		value: "0x86E53CF1B870786351Da77A57575e79CB55812CB",
		address: "0x86E53CF1B870786351Da77A57575e79CB55812CB",
		type: "Crypto (USD)",
		name: "LINK / USD",
		symbol: "LINK / USD",
		decimals: 8
	},
	{
		value: "0x6970460aabF80C5BE983C6b74e5D06dEDCA95D4A",
		address: "0x6970460aabF80C5BE983C6b74e5D06dEDCA95D4A",
		type: "Crypto (USD)",
		name: "BNB / USD",
		symbol: "BNB / USD",
		decimals: 8
	},
	{
		value: "0x5B58aA6E0651Ae311864876A55411F481aD86080",
		address: "0x5B58aA6E0651Ae311864876A55411F481aD86080",
		type: "Crypto (USD)",
		name: "AXS / USD",
		symbol: "AXS / USD",
		decimals: 8
	},
	{
		value: "0x52099D4523531f678Dfc568a7B1e5038aadcE1d6",
		address: "0x52099D4523531f678Dfc568a7B1e5038aadcE1d6",
		type: "Crypto (USD)",
		name: "MATIC / USD",
		symbol: "MATIC / USD",
		decimals: 8
	},
	{
		value: "0x9E3fc57b2d644621CA7eFcb5dd28abD121CB0aDF",
		address: "0x9E3fc57b2d644621CA7eFcb5dd28abD121CB0aDF",
		type: "Crypto (NFT)",
		name: "Bored Ape Yacht Club Floor Price / ETH ",
		symbol: "Bored Ape Yacht Club Floor Price / ETH ",
		decimals: 18
	},
	{
		value: "0xcd1bd86fDc33080DCF1b5715B6FCe04eC6F85845",
		address: "0xcd1bd86fDc33080DCF1b5715B6FCe04eC6F85845",
		type: "Equities",
		name: "META / USD",
		symbol: "META / USD",
		decimals: 8
	},
	{
		value: "0xded2c52b75B24732e9107377B7Ba93eC1fFa4BAf",
		address: "0xded2c52b75B24732e9107377B7Ba93eC1fFa4BAf",
		type: "Crypto (ETH)",
		name: "STETH / ETH",
		symbol: "STETH / ETH",
		decimals: 18
	},
	{
		value: "0xB1f70A229FE7cceD0428245db8B1f6C48c7Ea82a",
		address: "0xB1f70A229FE7cceD0428245db8B1f6C48c7Ea82a",
		type: "Crypto (ETH)",
		name: "ETH-USD Total Marketcap",
		symbol: "ETH-USD Total Marketcap",
		decimals: 8
	},
	{
		value: "0xA43A34030088E6510FecCFb77E88ee5e7ed0fE64",
		address: "0xA43A34030088E6510FecCFb77E88ee5e7ed0fE64",
		type: "Crypto (USD)",
		name: "LDO / USD",
		symbol: "LDO / USD",
		decimals: 8
	},
	{
		value: "0x3f3f5dF88dC9F13eac63DF89EC16ef6e7E25DdE7",
		address: "0x3f3f5dF88dC9F13eac63DF89EC16ef6e7E25DdE7",
		type: "Crypto (Stablecoin)",
		name: "USDT / USD",
		symbol: "USDT / USD",
		decimals: 8
	},
	{
		value: "0x07C5b924399cc23c24a95c8743DE4006a32b7f2a",
		address: "0x07C5b924399cc23c24a95c8743DE4006a32b7f2a",
		type: "Crypto (ETH)",
		name: "STETH / USD",
		symbol: "STETH / USD",
		decimals: 8
	},
	{
		value: "0x6fAbee62266Da6686EE2744C6f15bb8352d2f28D",
		address: "0x6fAbee62266Da6686EE2744C6f15bb8352d2f28D",
		type: "Crypto (Stablecoin)",
		name: "TUSD / USD",
		symbol: "TUSD / USD",
		decimals: 8
	},
	{
		value: "0xe32AccC8c4eC03F6E75bd3621BfC9Fbb234E1FC3",
		address: "0xe32AccC8c4eC03F6E75bd3621BfC9Fbb234E1FC3",
		type: "Forex",
		name: "CHF / USD",
		symbol: "CHF / USD",
		decimals: 8
	},
	{
		value: "0xDB98056FecFff59D032aB628337A4887110df3dB",
		address: "0xDB98056FecFff59D032aB628337A4887110df3dB",
		type: "Crypto (USD)",
		name: "GMX / USD",
		symbol: "GMX / USD",
		decimals: 8
	},
	{
		value: "0xc5C8E77B397E531B8EC06BFb0048328B30E9eCfB",
		address: "0xc5C8E77B397E531B8EC06BFb0048328B30E9eCfB",
		type: "Crypto (Stablecoin)",
		name: "DAI / USD",
		symbol: "DAI / USD",
		decimals: 8
	},
	{
		value: "0xb7c8Fb1dB45007F98A68Da0588e1AA524C317f27",
		address: "0xb7c8Fb1dB45007F98A68Da0588e1AA524C317f27",
		type: "Crypto (ETH)",
		name: "LINK / ETH",
		symbol: "LINK / ETH",
		decimals: 18
	},
	{
		value: "0x04180965a782E487d0632013ABa488A472243542",
		address: "0x04180965a782E487d0632013ABa488A472243542",
		type: "Crypto (USD)",
		name: "JOE / USD",
		symbol: "JOE / USD",
		decimals: 8
	},
	{
		value: "0x4bC735Ef24bf286983024CAd5D03f0738865Aaef",
		address: "0x4bC735Ef24bf286983024CAd5D03f0738865Aaef",
		type: "Crypto (USD)",
		name: "1INCH / USD",
		symbol: "1INCH / USD",
		decimals: 8
	},
	{
		value: "0x3dD6e51CB9caE717d5a8778CF79A04029f9cFDF8",
		address: "0x3dD6e51CB9caE717d5a8778CF79A04029f9cFDF8",
		type: "Forex",
		name: "JPY / USD",
		symbol: "JPY / USD",
		decimals: 8
	},
	{
		value: "0xd0C7101eACbB49F3deCcCc166d238410D6D46d57",
		address: "0xd0C7101eACbB49F3deCcCc166d238410D6D46d57",
		type: "Crypto (USD)",
		name: "WBTC / USD",
		symbol: "WBTC / USD",
		decimals: 8
	},
	{
		value: "0xB1552C5e96B312d0Bf8b554186F846C40614a540",
		address: "0xB1552C5e96B312d0Bf8b554186F846C40614a540",
		type: "Crypto (ETH)",
		name: "wstETH-stETH Exchange Rate",
		symbol: "wstETH-stETH Exchange Rate",
		decimals: 18
	},
	{
		value: "0xbcD8bEA7831f392bb019ef3a672CC15866004536",
		address: "0xbcD8bEA7831f392bb019ef3a672CC15866004536",
		type: "Crypto",
		name: "CV Index",
		symbol: "CV Index",
		decimals: 18
	},
	{
		value: "0xBF5C3fB2633e924598A46B9D07a174a9DBcF57C0",
		address: "0xBF5C3fB2633e924598A46B9D07a174a9DBcF57C0",
		type: "Crypto (USD)",
		name: "NEAR / USD",
		symbol: "NEAR / USD",
		decimals: 8
	},
	{
		value: "0x9A7FB1b3950837a8D9b40517626E11D4127C098C",
		address: "0x9A7FB1b3950837a8D9b40517626E11D4127C098C",
		type: "Crypto (USD)",
		name: "DOGE / USD",
		symbol: "DOGE / USD",
		decimals: 8
	},
	{
		value: "0xa668682974E3f121185a3cD94f00322beC674275",
		address: "0xa668682974E3f121185a3cD94f00322beC674275",
		type: "Crypto (ETH)",
		name: "CBETH / ETH",
		symbol: "CBETH / ETH",
		decimals: 18
	},
	{
		value: "0xA33a06c119EC08F92735F9ccA37e07Af08C4f281",
		address: "0xA33a06c119EC08F92735F9ccA37e07Af08C4f281",
		type: "Crypto (USD)",
		name: "DODO / USD",
		symbol: "DODO / USD",
		decimals: 8
	},
	{
		value: "0x59644ec622243878d1464A9504F9e9a31294128a",
		address: "0x59644ec622243878d1464A9504F9e9a31294128a",
		type: "Crypto (Stablecoin)",
		name: "MIMATIC / USD",
		symbol: "MIMATIC / USD",
		decimals: 8
	},
	{
		value: "0x8bf61728eeDCE2F32c456454d87B5d6eD6150208",
		address: "0x8bf61728eeDCE2F32c456454d87B5d6eD6150208",
		type: "Crypto (USD)",
		name: "AVAX / USD",
		symbol: "AVAX / USD",
		decimals: 8
	},
	{
		value: "0xdE89a55d04DEd40A410877ab87d4F567ee66a1f0",
		address: "0xdE89a55d04DEd40A410877ab87d4F567ee66a1f0",
		type: "Forex",
		name: "SEK / USD",
		symbol: "SEK / USD",
		decimals: 8
	},
	{
		value: "0x1F954Dc24a49708C26E0C1777f16750B5C6d5a2c",
		address: "0x1F954Dc24a49708C26E0C1777f16750B5C6d5a2c",
		type: "Commodities",
		name: "XAU / USD",
		symbol: "XAU / USD",
		decimals: 8
	},
	{
		value: "0x4Ee1f9ec1048979930aC832a3C1d18a0b4955a02",
		address: "0x4Ee1f9ec1048979930aC832a3C1d18a0b4955a02",
		type: "Crypto (Stablecoin)",
		name: "USDD / USD",
		symbol: "USDD / USD",
		decimals: 8
	},
	{
		value: "0xb2A8BA74cbca38508BA1632761b56C897060147C",
		address: "0xb2A8BA74cbca38508BA1632761b56C897060147C",
		type: "Crypto (USD)",
		name: "SUSHI / USD",
		symbol: "SUSHI / USD",
		decimals: 8
	},
	{
		value: "0xD9f615A9b820225edbA2d821c4A696a0924051c6",
		address: "0xD9f615A9b820225edbA2d821c4A696a0924051c6",
		type: "Crypto (USD)",
		name: "ADA / USD",
		symbol: "ADA / USD",
		decimals: 8
	},
	{
		value: "0x9C917083fDb403ab5ADbEC26Ee294f6EcAda2720",
		address: "0x9C917083fDb403ab5ADbEC26Ee294f6EcAda2720",
		type: "Crypto (USD)",
		name: "UNI / USD",
		symbol: "UNI / USD",
		decimals: 8
	},
	{
		value: "0x383b3624478124697BEF675F07cA37570b73992f",
		address: "0x383b3624478124697BEF675F07cA37570b73992f",
		type: "Crypto (USD)",
		name: "SPELL / USD",
		symbol: "SPELL / USD",
		decimals: 8
	},
	{
		value: "0x36a121448D74Fa81450c992A1a44B9b7377CD3a5",
		address: "0x36a121448D74Fa81450c992A1a44B9b7377CD3a5",
		type: "Crypto (USD)",
		name: "FXS / USD",
		symbol: "FXS / USD",
		decimals: 8
	},
	{
		value: "0x1bD872f3A606471787B1a304cE0356e4e87Af930",
		address: "0x1bD872f3A606471787B1a304cE0356e4e87Af930",
		type: "Crypto (ETH)",
		name: "frxETH-ETH Exchange Rate Low",
		symbol: "frxETH-ETH Exchange Rate Low",
		decimals: 18
	}
];

var ethereumPairsGoerli = [
	{
		value: "0xF549af21578Cfe2385FFD3488B3039fd9e52f006",
		address: "0xF549af21578Cfe2385FFD3488B3039fd9e52f006",
		name: "ETH / USD",
		symbol: "ETH / USD",
		decimals: 8
	},
	{
		value: "0x4b531A318B0e44B549F3b2f824721b3D0d51930A",
		address: "0x4b531A318B0e44B549F3b2f824721b3D0d51930A",
		name: "VeeFriends Floor Price",
		symbol: "VeeFriends Floor Price",
		decimals: 18
	},
	{
		value: "0x9F6d70CDf08d893f0063742b51d3E9D1e18b7f74",
		address: "0x9F6d70CDf08d893f0063742b51d3E9D1e18b7f74",
		name: "Azuki Floor Price",
		symbol: "Azuki Floor Price",
		decimals: 18
	},
	{
		value: "0xB677bfBc9B09a3469695f40477d05bc9BcB15F50",
		address: "0xB677bfBc9B09a3469695f40477d05bc9BcB15F50",
		name: "BAYC Floor Price",
		symbol: "BAYC Floor Price",
		decimals: 18
	},
	{
		value: "0x3de1bE9407645533CD0CbeCf88dFE5297E7125e6",
		address: "0x3de1bE9407645533CD0CbeCf88dFE5297E7125e6",
		name: "Stader Labs PoR",
		symbol: "Stader Labs PoR",
		decimals: 18
	},
	{
		value: "0x7b219F57a8e9C7303204Af681e9fA69d17ef626f",
		address: "0x7b219F57a8e9C7303204Af681e9fA69d17ef626f",
		name: "XAU / USD",
		symbol: "XAU / USD",
		decimals: 18
	},
	{
		value: "0x870bc8BfEe8A7Bbd63Dc1ef09F2fF37DeBCfEF35",
		address: "0x870bc8BfEe8A7Bbd63Dc1ef09F2fF37DeBCfEF35",
		name: "Cryptoadz Floor Price",
		symbol: "Cryptoadz Floor Price",
		decimals: 18
	},
	{
		value: "0xCbDcc8788019226d09FcCEb4C727C48A062D8124",
		address: "0xCbDcc8788019226d09FcCEb4C727C48A062D8124",
		name: "MAYC Floor Price",
		symbol: "MAYC Floor Price",
		decimals: 18
	},
	{
		value: "0x47Db76c9c97F4bcFd54D8872FDb848Cab696092d",
		address: "0x47Db76c9c97F4bcFd54D8872FDb848Cab696092d",
		name: "LINK / USD",
		symbol: "LINK / USD",
		decimals: 8
	},
	{
		value: "0xb4c4a493AB6356497713A78FFA6c60FB53517c63",
		address: "0xb4c4a493AB6356497713A78FFA6c60FB53517c63",
		name: "LINK / ETH",
		symbol: "LINK / ETH",
		decimals: 18
	},
	{
		value: "0xe69BA7C8177bF69B7EE4b4C8a2DA1B52C9c15B8B",
		address: "0xe69BA7C8177bF69B7EE4b4C8a2DA1B52C9c15B8B",
		name: "ETHx Liquid Staking Balance PoR",
		symbol: "ETHx Liquid Staking Balance PoR",
		decimals: 18
	},
	{
		value: "0xD3e3Cf81fA419e0937c39ac2A86E74E24559c499",
		address: "0xD3e3Cf81fA419e0937c39ac2A86E74E24559c499",
		name: "ETHx Supply",
		symbol: "ETHx Supply",
		decimals: 18
	},
	{
		value: "0x0a12ec21c43ab2b4f69693Da1b0149e7652689c0",
		address: "0x0a12ec21c43ab2b4f69693Da1b0149e7652689c0",
		name: "BTC / USD",
		symbol: "BTC / USD",
		decimals: 8
	},
	{
		value: "0xEDA76D1C345AcA04c6910f5824EC337C8a8F36d2",
		address: "0xEDA76D1C345AcA04c6910f5824EC337C8a8F36d2",
		name: "Doodles Floor Price",
		symbol: "Doodles Floor Price",
		decimals: 18
	},
	{
		value: "0xAE45DCb3eB59E27f05C170752B218C6174394Df8",
		address: "0xAE45DCb3eB59E27f05C170752B218C6174394Df8",
		name: "CZK / USD",
		symbol: "CZK / USD",
		decimals: 8
	},
	{
		value: "0x943C6B6124Fe7b34E0973A7b627a903f192D8B1F",
		address: "0x943C6B6124Fe7b34E0973A7b627a903f192D8B1F",
		name: "Optimism Healthcheck",
		symbol: "Optimism Healthcheck",
		decimals: 0
	},
	{
		value: "0xcd3BBd46c6c6354e3B03780F99E9836d3AC7740b",
		address: "0xcd3BBd46c6c6354e3B03780F99E9836d3AC7740b",
		name: "StakeStar PoR",
		symbol: "StakeStar PoR",
		decimals: 18
	},
	{
		value: "0x2748A42aBd328835DFDA748bdD1D77Ce3c3312EE",
		address: "0x2748A42aBd328835DFDA748bdD1D77Ce3c3312EE",
		name: "World of Women Floor Price",
		symbol: "World of Women Floor Price",
		decimals: 18
	},
	{
		value: "0xdC5f59e61e51b90264b38F0202156F07956E2577",
		address: "0xdC5f59e61e51b90264b38F0202156F07956E2577",
		name: "SNX / USD",
		symbol: "SNX / USD",
		decimals: 8
	},
	{
		value: "0xDe9C980F79b636B46b9c3bc04cfCC94A29D18D19",
		address: "0xDe9C980F79b636B46b9c3bc04cfCC94A29D18D19",
		name: "Swell PoR",
		symbol: "Swell PoR",
		decimals: 18
	},
	{
		value: "0x982B232303af1EFfB49939b81AD6866B2E4eeD0B",
		address: "0x982B232303af1EFfB49939b81AD6866B2E4eeD0B",
		name: "JPY / USD",
		symbol: "JPY / USD",
		decimals: 8
	},
	{
		value: "0x0d79df66BE487753B02D015Fb622DED7f0E9798d",
		address: "0x0d79df66BE487753B02D015Fb622DED7f0E9798d",
		name: "DAI / USD",
		symbol: "DAI / USD",
		decimals: 8
	},
	{
		value: "0xD4a33860578De61DBAbDc8BFdb98FD742fA7028e",
		address: "0xD4a33860578De61DBAbDc8BFdb98FD742fA7028e",
		name: "ETH / USD",
		symbol: "ETH / USD",
		decimals: 8
	},
	{
		value: "0xAb5c49580294Aff77670F839ea425f5b78ab3Ae7",
		address: "0xAb5c49580294Aff77670F839ea425f5b78ab3Ae7",
		name: "USDC / USD",
		symbol: "USDC / USD",
		decimals: 8
	},
	{
		value: "0x13F38938A18ff26394c5ac8df94E349A97AaAb4e",
		address: "0x13F38938A18ff26394c5ac8df94E349A97AaAb4e",
		name: "CoolCats Floor Price",
		symbol: "CoolCats Floor Price",
		decimals: 18
	},
	{
		value: "0x48731cF7e84dc94C5f84577882c14Be11a5B7456",
		address: "0x48731cF7e84dc94C5f84577882c14Be11a5B7456",
		name: "LINK / USD",
		symbol: "LINK / USD",
		decimals: 8
	},
	{
		value: "0xE42f272EdF974e9c70a6d38dCb47CAB2A28CED3F",
		address: "0xE42f272EdF974e9c70a6d38dCb47CAB2A28CED3F",
		name: "CloneX Floor Price",
		symbol: "CloneX Floor Price",
		decimals: 18
	},
	{
		value: "0x5c13b249846540F81c093Bc342b5d963a7518145",
		address: "0x5c13b249846540F81c093Bc342b5d963a7518145",
		name: "CryptoPunks Floor Price",
		symbol: "CryptoPunks Floor Price",
		decimals: 18
	},
	{
		value: "0xA39434A63A52E749F02807ae27335515BA4b07F7",
		address: "0xA39434A63A52E749F02807ae27335515BA4b07F7",
		name: "BTC / USD",
		symbol: "BTC / USD",
		decimals: 8
	},
	{
		value: "0x7A65Cf6C2ACE993f09231EC1Ea7363fb29C13f2F",
		address: "0x7A65Cf6C2ACE993f09231EC1Ea7363fb29C13f2F",
		name: "FORTH / USD",
		symbol: "FORTH / USD",
		decimals: 8
	},
	{
		value: "0x44390589104C9164407A0E0562a9DBe6C24A0E05",
		address: "0x44390589104C9164407A0E0562a9DBe6C24A0E05",
		name: "EUR / USD",
		symbol: "EUR / USD",
		decimals: 8
	},
	{
		value: "0x779877A7B0D9E8603169DdbD7836e478b4624789",
		address: "0x779877A7B0D9E8603169DdbD7836e478b4624789",
		name: "BTC / ETH",
		symbol: "BTC / ETH",
		decimals: 18
	},
	{
		value: "0x73D9c953DaaB1c829D01E1FC0bd92e28ECfB66DB",
		address: "0x73D9c953DaaB1c829D01E1FC0bd92e28ECfB66DB",
		name: "GBP / USD",
		symbol: "GBP / USD",
		decimals: 8
	}
];

var ethereumPairsMainnet = [
	{
		value: "0x8b6d9085f310396C6E4f0012783E9f850eaa8a82",
		address: "0x8b6d9085f310396C6E4f0012783E9f850eaa8a82",
		type: "Crypto (USD)",
		name: "UST / USD",
		symbol: "UST / USD",
		decimals: 8
	},
	{
		value: "0x0e773A17a01E2c92F5d4c53435397E2bd48e215F",
		address: "0x0e773A17a01E2c92F5d4c53435397E2bd48e215F",
		type: "Crypto (ETH)",
		name: "GTC / ETH",
		symbol: "GTC / ETH",
		decimals: 18
	},
	{
		value: "0xad35Bd71b9aFE6e4bDc266B345c198eaDEf9Ad94",
		address: "0xad35Bd71b9aFE6e4bDc266B345c198eaDEf9Ad94",
		type: "Crypto (Stablecoin)",
		name: "sUSD / USD",
		symbol: "sUSD / USD",
		decimals: 8
	},
	{
		value: "0xAB4D1bc99781A445BC1D065663d9A831f787124e",
		address: "0xAB4D1bc99781A445BC1D065663d9A831f787124e",
		type: "Crypto",
		name: "BTC Interest Rate Benchmark Curve 1 Week",
		symbol: "BTC Interest Rate Benchmark Curve 1 Week",
		decimals: 8
	},
	{
		value: "0xE6A7b525609bF47889ac9d0e964ebB640750a01C",
		address: "0xE6A7b525609bF47889ac9d0e964ebB640750a01C",
		type: "Crypto (NFT)",
		name: "JPEGd Mutant Ape Floor Price ETH",
		symbol: "JPEGd Mutant Ape Floor Price ETH",
		decimals: 18
	},
	{
		value: "0xBcE206caE7f0ec07b545EddE332A47C2F75bbeb3",
		address: "0xBcE206caE7f0ec07b545EddE332A47C2F75bbeb3",
		type: "Forex",
		name: "JPY / USD",
		symbol: "JPY / USD",
		decimals: 8
	},
	{
		value: "0xb49f677943BC038e9857d61E7d053CaA2C1734C1",
		address: "0xb49f677943BC038e9857d61E7d053CaA2C1734C1",
		type: "Forex",
		name: "EUR / USD",
		symbol: "EUR / USD",
		decimals: 8
	},
	{
		value: "0xad4A9bED9a5E2c1c9a6E43D35Db53c83873dd901",
		address: "0xad4A9bED9a5E2c1c9a6E43D35Db53c83873dd901",
		type: "US Treasuries",
		name: "STBT PoR",
		symbol: "STBT PoR",
		decimals: 18
	},
	{
		value: "0xDC3EA94CD0AC27d9A86C180091e7f78C683d3699",
		address: "0xDC3EA94CD0AC27d9A86C180091e7f78C683d3699",
		type: "Crypto (USD)",
		name: "SNX / USD",
		symbol: "SNX / USD",
		decimals: 8
	},
	{
		value: "0x8c110B94C5f1d347fAcF5E1E938AB2db60E3c9a8",
		address: "0x8c110B94C5f1d347fAcF5E1E938AB2db60E3c9a8",
		type: "Crypto (USD)",
		name: "SPELL / USD",
		symbol: "SPELL / USD",
		decimals: 8
	},
	{
		value: "0x1d32df460AE5D738A88Faa44DDA2cA3764627461",
		address: "0x1d32df460AE5D738A88Faa44DDA2cA3764627461",
		type: "Crypto",
		name: "BTC Interest Rate Benchmark Curve 1 Day",
		symbol: "BTC Interest Rate Benchmark Curve 1 Day",
		decimals: 8
	},
	{
		value: "0x5fB3912d73d55E656E2Dfb35B11696006f5A5745",
		address: "0x5fB3912d73d55E656E2Dfb35B11696006f5A5745",
		type: "Crypto (NFT)",
		name: "JPEGd Milady Floor Price ETH",
		symbol: "JPEGd Milady Floor Price ETH",
		decimals: 18
	},
	{
		value: "0x38C5ae3ee324ee027D88c5117ee58d07c9b4699b",
		address: "0x38C5ae3ee324ee027D88c5117ee58d07c9b4699b",
		type: "Crypto (USD)",
		name: "HBAR / USD",
		symbol: "HBAR / USD",
		decimals: 8
	},
	{
		value: "0xF6f5b570aB6E39E55558AfD8E1E30c5f20E6527E",
		address: "0xF6f5b570aB6E39E55558AfD8E1E30c5f20E6527E",
		type: "Fiat",
		name: "GBPT PoR",
		symbol: "GBPT PoR",
		decimals: 18
	},
	{
		value: "0xf3584F4dd3b467e73C2339EfD008665a70A4185c",
		address: "0xf3584F4dd3b467e73C2339EfD008665a70A4185c",
		type: "Commodities",
		name: "WTI / USD",
		symbol: "WTI / USD",
		decimals: 8
	},
	{
		value: "0xAc559F25B1619171CbC396a50854A3240b6A4e99",
		address: "0xAc559F25B1619171CbC396a50854A3240b6A4e99",
		type: "Crypto (ETH)",
		name: "ETH / BTC",
		symbol: "ETH / BTC",
		decimals: 8
	},
	{
		value: "0xFF3EEb22B5E3dE6e705b44749C2559d704923FD7",
		address: "0xFF3EEb22B5E3dE6e705b44749C2559d704923FD7",
		type: "Crypto (USD)",
		name: "AVAX / USD",
		symbol: "AVAX / USD",
		decimals: 8
	},
	{
		value: "0xEEf0C605546958c1f899b6fB336C20671f9cD49F",
		address: "0xEEf0C605546958c1f899b6fB336C20671f9cD49F",
		type: "Crypto (Stablecoin)",
		name: "CRVUSD / USD",
		symbol: "CRVUSD / USD",
		decimals: 8
	},
	{
		value: "0xD10aBbC76679a20055E167BB80A24ac851b37056",
		address: "0xD10aBbC76679a20055E167BB80A24ac851b37056",
		type: "Crypto (USD)",
		name: "APE / USD",
		symbol: "APE / USD",
		decimals: 8
	},
	{
		value: "0x91b99C9b75aF469a71eE1AB528e8da994A5D7030",
		address: "0x91b99C9b75aF469a71eE1AB528e8da994A5D7030",
		type: "Forex",
		name: "IDR / USD",
		symbol: "IDR / USD",
		decimals: 8
	},
	{
		value: "0x773616E4d11A78F511299002da57A0a94577F1f4",
		address: "0x773616E4d11A78F511299002da57A0a94577F1f4",
		type: "Crypto (Stablecoin)",
		name: "DAI / ETH",
		symbol: "DAI / ETH",
		decimals: 18
	},
	{
		value: "0x8B4fC5b68cD50eAc1dD33f695901624a4a1A0A8b",
		address: "0x8B4fC5b68cD50eAc1dD33f695901624a4a1A0A8b",
		type: "Crypto (ETH)",
		name: "AXS / ETH",
		symbol: "AXS / ETH",
		decimals: 18
	},
	{
		value: "0x7A364e8770418566e3eb2001A96116E6138Eb32F",
		address: "0x7A364e8770418566e3eb2001A96116E6138Eb32F",
		type: "Crypto (Stablecoin)",
		name: "MIM / USD",
		symbol: "MIM / USD",
		decimals: 8
	},
	{
		value: "0x9f2ba149c2A0Ee76043d83558C4E79E9F3E5731B",
		address: "0x9f2ba149c2A0Ee76043d83558C4E79E9F3E5731B",
		type: "Crypto (NFT)",
		name: "Pudgy Penguins Floor Price",
		symbol: "Pudgy Penguins Floor Price",
		decimals: 18
	},
	{
		value: "0xEb0adf5C06861d6c07174288ce4D0a8128164003",
		address: "0xEb0adf5C06861d6c07174288ce4D0a8128164003",
		type: "Crypto (USD)",
		name: "CAKE / USD",
		symbol: "CAKE / USD",
		decimals: 8
	},
	{
		value: "0xF0985f7E2CaBFf22CecC5a71282a89582c382EFE",
		address: "0xF0985f7E2CaBFf22CecC5a71282a89582c382EFE",
		type: "Crypto (ETH)",
		name: "FTT / ETH",
		symbol: "FTT / ETH",
		decimals: 18
	},
	{
		value: "0x2c1d072e956AFFC0D435Cb7AC38EF18d24d9127c",
		address: "0x2c1d072e956AFFC0D435Cb7AC38EF18d24d9127c",
		type: "Crypto (USD)",
		name: "LINK / USD",
		symbol: "LINK / USD",
		decimals: 8
	},
	{
		value: "0x639c3c1e3b5aa262b87e407779c866cC1406DDe6",
		address: "0x639c3c1e3b5aa262b87e407779c866cC1406DDe6",
		type: "Crypto (NFT)",
		name: "JPEGd Chromie Floor Price ETH",
		symbol: "JPEGd Chromie Floor Price ETH",
		decimals: 18
	},
	{
		value: "0x3D7aE7E594f2f2091Ad8798313450130d0Aba3a0",
		address: "0x3D7aE7E594f2f2091Ad8798313450130d0Aba3a0",
		type: "Crypto (Stablecoin)",
		name: "LUSD / USD",
		symbol: "LUSD / USD",
		decimals: 8
	},
	{
		value: "0xffa4Bb3a24B60C0262DBAaD60d77a3c3fa6173e8",
		address: "0xffa4Bb3a24B60C0262DBAaD60d77a3c3fa6173e8",
		type: "Crypto (ETH)",
		name: "SWAP / ETH",
		symbol: "SWAP / ETH",
		decimals: 18
	},
	{
		value: "0x483d36F6a1d063d580c7a24F9A42B346f3a69fbb",
		address: "0x483d36F6a1d063d580c7a24F9A42B346f3a69fbb",
		type: "Crypto (USD)",
		name: "RAI / USD",
		symbol: "RAI / USD",
		decimals: 8
	},
	{
		value: "0x05140252A265F2817aF6caF4a7F79a77F87E0a7c",
		address: "0x05140252A265F2817aF6caF4a7F79a77F87E0a7c",
		type: "Crypto",
		name: "BTC Interest Rate Benchmark Curve 5 Month",
		symbol: "BTC Interest Rate Benchmark Curve 5 Month",
		decimals: 8
	},
	{
		value: "0x3f12643D3f6f874d39C2a4c9f2Cd6f2DbAC877FC",
		address: "0x3f12643D3f6f874d39C2a4c9f2Cd6f2DbAC877FC",
		type: "Crypto (Stablecoin)",
		name: "GHO / USD",
		symbol: "GHO / USD",
		decimals: 8
	},
	{
		value: "0x15c8eA24Ba2d36671Fa22aD4Cff0a8eafe144352",
		address: "0x15c8eA24Ba2d36671Fa22aD4Cff0a8eafe144352",
		type: "Crypto (ETH)",
		name: "ATOM / ETH",
		symbol: "ATOM / ETH",
		decimals: 18
	},
	{
		value: "0xC1438AA3823A6Ba0C159CfA8D98dF5A994bA120b",
		address: "0xC1438AA3823A6Ba0C159CfA8D98dF5A994bA120b",
		type: "Crypto (ETH)",
		name: "BAL / ETH",
		symbol: "BAL / ETH",
		decimals: 18
	},
	{
		value: "0x6bD37CB175B222E7ddFb90CCA170e0f2b21F2849",
		address: "0x6bD37CB175B222E7ddFb90CCA170e0f2b21F2849",
		type: "Crypto (NFT)",
		name: "JPEGd Otherdeed Floor Price ETH",
		symbol: "JPEGd Otherdeed Floor Price ETH",
		decimals: 18
	},
	{
		value: "0x2465CefD3b488BE410b941b1d4b2767088e2A028",
		address: "0x2465CefD3b488BE410b941b1d4b2767088e2A028",
		type: "Crypto (USD)",
		name: "DOGE / USD",
		symbol: "DOGE / USD",
		decimals: 8
	},
	{
		value: "0x7D476f061F8212A8C9317D5784e72B4212436E93",
		address: "0x7D476f061F8212A8C9317D5784e72B4212436E93",
		type: "Crypto (USD)",
		name: "OMG / USD",
		symbol: "OMG / USD",
		decimals: 8
	},
	{
		value: "0x029849bbc0b1d93b85a8b6190e979fd38F5760E2",
		address: "0x029849bbc0b1d93b85a8b6190e979fd38F5760E2",
		type: "Crypto (ETH)",
		name: "DPI / ETH",
		symbol: "DPI / ETH",
		decimals: 18
	},
	{
		value: "0x553303d460EE0afB37EdFf9bE42922D8FF63220e",
		address: "0x553303d460EE0afB37EdFf9bE42922D8FF63220e",
		type: "Crypto (USD)",
		name: "UNI / USD",
		symbol: "UNI / USD",
		decimals: 8
	},
	{
		value: "0xCc70F09A6CC17553b2E31954cD36E4A2d89501f7",
		address: "0xCc70F09A6CC17553b2E31954cD36E4A2d89501f7",
		type: "Crypto (USD)",
		name: "SUSHI / USD",
		symbol: "SUSHI / USD",
		decimals: 8
	},
	{
		value: "0x35f08E1b5a18F1F085AA092aAed10EDd47457484",
		address: "0x35f08E1b5a18F1F085AA092aAed10EDd47457484",
		type: "Crypto (NFT)",
		name: "JPEGd Cryptopunks Floor Price ETH",
		symbol: "JPEGd Cryptopunks Floor Price ETH",
		decimals: 18
	},
	{
		value: "0xBAEbEFc1D023c0feCcc047Bff42E75F15Ff213E6",
		address: "0xBAEbEFc1D023c0feCcc047Bff42E75F15Ff213E6",
		type: "Crypto (USD)",
		name: "IMX / USD",
		symbol: "IMX / USD",
		decimals: 8
	},
	{
		value: "0x027828052840a43Cc2D0187BcfA6e3D6AcE60336",
		address: "0x027828052840a43Cc2D0187BcfA6e3D6AcE60336",
		type: "Crypto (NFT)",
		name: "Doodles Floor Price",
		symbol: "Doodles Floor Price",
		decimals: 18
	},
	{
		value: "0xDdf0B85C600DAF9e308AFed9F597ACA212354764",
		address: "0xDdf0B85C600DAF9e308AFed9F597ACA212354764",
		type: "Crypto (NFT)",
		name: "World of Women Floor Price",
		symbol: "World of Women Floor Price",
		decimals: 18
	},
	{
		value: "0x8e0b7e6062272B5eF4524250bFFF8e5Bd3497757",
		address: "0x8e0b7e6062272B5eF4524250bFFF8e5Bd3497757",
		type: "Crypto (Stablecoin)",
		name: "SUSD / ETH",
		symbol: "SUSD / ETH",
		decimals: 18
	},
	{
		value: "0x82A44D92D6c329826dc557c5E1Be6ebeC5D5FeB9",
		address: "0x82A44D92D6c329826dc557c5E1Be6ebeC5D5FeB9",
		type: "Crypto (ETH)",
		name: "MANA / ETH",
		symbol: "MANA / ETH",
		decimals: 18
	},
	{
		value: "0x60cbE8D88EF519cF3C62414D76f50818D211fea1",
		address: "0x60cbE8D88EF519cF3C62414D76f50818D211fea1",
		type: "Crypto (ETH)",
		name: "Swell ETH PoR",
		symbol: "Swell ETH PoR",
		decimals: 18
	},
	{
		value: "0xAed0c38402a5d19df6E4c03F4E2DceD6e29c1ee9",
		address: "0xAed0c38402a5d19df6E4c03F4E2DceD6e29c1ee9",
		type: "Crypto (Stablecoin)",
		name: "DAI / USD",
		symbol: "DAI / USD",
		decimals: 8
	},
	{
		value: "0x7bAC85A8a13A4BcD8abb3eB7d6b4d632c5a57676",
		address: "0x7bAC85A8a13A4BcD8abb3eB7d6b4d632c5a57676",
		type: "Crypto (USD)",
		name: "MATIC / USD",
		symbol: "MATIC / USD",
		decimals: 8
	},
	{
		value: "0x2885d15b8Af22648b98B122b22FDF4D2a56c6023",
		address: "0x2885d15b8Af22648b98B122b22FDF4D2a56c6023",
		type: "Crypto (USD)",
		name: "ZRX / USD",
		symbol: "ZRX / USD",
		decimals: 8
	},
	{
		value: "0xa20623070413d42a5C01Db2c8111640DD7A5A03a",
		address: "0xa20623070413d42a5C01Db2c8111640DD7A5A03a",
		type: "Crypto (ETH)",
		name: "UST / ETH",
		symbol: "UST / ETH",
		decimals: 18
	},
	{
		value: "0x9b0FC4bb9981e5333689d69BdBF66351B9861E62",
		address: "0x9b0FC4bb9981e5333689d69BdBF66351B9861E62",
		type: "Crypto (ETH)",
		name: "OCEAN / ETH",
		symbol: "OCEAN / ETH",
		decimals: 18
	},
	{
		value: "0x7F0D2c2838c6AC24443d13e23d99490017bDe370",
		address: "0x7F0D2c2838c6AC24443d13e23d99490017bDe370",
		type: "Crypto (Stablecoin)",
		name: "FEI / ETH",
		symbol: "FEI / ETH",
		decimals: 18
	},
	{
		value: "0x81243627cC533Ca6CF6F23c3f61add1D0f626674",
		address: "0x81243627cC533Ca6CF6F23c3f61add1D0f626674",
		type: "Fiat",
		name: "TUSD PoR",
		symbol: "TUSD PoR",
		decimals: 18
	},
	{
		value: "0x2c881B6f3f6B5ff6C975813F87A4dad0b241C15b",
		address: "0x2c881B6f3f6B5ff6C975813F87A4dad0b241C15b",
		type: "Crypto (ETH)",
		name: "OGN / ETH",
		symbol: "OGN / ETH",
		decimals: 18
	},
	{
		value: "0xa34317DB73e77d453b1B8d04550c44D10e981C8e",
		address: "0xa34317DB73e77d453b1B8d04550c44D10e981C8e",
		type: "Forex",
		name: "CAD / USD",
		symbol: "CAD / USD",
		decimals: 8
	},
	{
		value: "0x2dE2EB5Fb9B8d7df45A9e144030c36128682c288",
		address: "0x2dE2EB5Fb9B8d7df45A9e144030c36128682c288",
		type: "Crypto (NFT)",
		name: "JPEGd Fidenza Floor Price ETH",
		symbol: "JPEGd Fidenza Floor Price ETH",
		decimals: 18
	},
	{
		value: "0x5c0Ab2d9b5a7ed9f470386e82BB36A3613cDd4b5",
		address: "0x5c0Ab2d9b5a7ed9f470386e82BB36A3613cDd4b5",
		type: "Forex",
		name: "GBP / USD",
		symbol: "GBP / USD",
		decimals: 8
	},
	{
		value: "0x14d04Fff8D21bd62987a5cE9ce543d2F1edF5D3E",
		address: "0x14d04Fff8D21bd62987a5cE9ce543d2F1edF5D3E",
		type: "Crypto (Stablecoin)",
		name: "FRAX / ETH",
		symbol: "FRAX / ETH",
		decimals: 18
	},
	{
		value: "0x58921Ac140522867bf50b9E009599Da0CA4A2379",
		address: "0x58921Ac140522867bf50b9E009599Da0CA4A2379",
		type: "Crypto (ETH)",
		name: "BADGER / ETH",
		symbol: "BADGER / ETH",
		decimals: 18
	},
	{
		value: "0x0ed39A19D2a68b722408d84e4d970827f61E6c0A",
		address: "0x0ed39A19D2a68b722408d84e4d970827f61E6c0A",
		type: "Crypto (Stablecoin)",
		name: "USDD / USD",
		symbol: "USDD / USD",
		decimals: 8
	},
	{
		value: "0x614715d2Af89E6EC99A233818275142cE88d1Cfd",
		address: "0x614715d2Af89E6EC99A233818275142cE88d1Cfd",
		type: "Crypto (Stablecoin)",
		name: "BUSD / ETH",
		symbol: "BUSD / ETH",
		decimals: 18
	},
	{
		value: "0x6f9D4D55Eb44915674d9f708AE17F23b2ae79AAc",
		address: "0x6f9D4D55Eb44915674d9f708AE17F23b2ae79AAc",
		type: "Crypto (NFT)",
		name: "JPEGd Meebits Floor Price ETH",
		symbol: "JPEGd Meebits Floor Price ETH",
		decimals: 18
	},
	{
		value: "0x4E155eD98aFE9034b7A5962f6C84c86d869daA9d",
		address: "0x4E155eD98aFE9034b7A5962f6C84c86d869daA9d",
		type: "Crypto (USD)",
		name: "RPL / USD",
		symbol: "RPL / USD",
		decimals: 8
	},
	{
		value: "0x32d1463EB53b73C095625719Afa544D5426354cB",
		address: "0x32d1463EB53b73C095625719Afa544D5426354cB",
		type: "Equities",
		name: "IB01 / USD",
		symbol: "IB01 / USD",
		decimals: 8
	},
	{
		value: "0x9a51192e065ECC6BDEafE5e194ce54702DE4f1f5",
		address: "0x9a51192e065ECC6BDEafE5e194ce54702DE4f1f5",
		type: "Economic index",
		name: "Consumer Price Index",
		symbol: "Consumer Price Index",
		decimals: 18
	},
	{
		value: "0xD4CE430C3b67b3E2F7026D86E7128588629e2455",
		address: "0xD4CE430C3b67b3E2F7026D86E7128588629e2455",
		type: "Crypto (ETH)",
		name: "REP / ETH",
		symbol: "REP / ETH",
		decimals: 18
	},
	{
		value: "0xd27e6D02b72eB6FCe04Ad5690C419196B4EF2885",
		address: "0xd27e6D02b72eB6FCe04Ad5690C419196B4EF2885",
		type: "Equities",
		name: "IBTA / USD",
		symbol: "IBTA / USD",
		decimals: 8
	},
	{
		value: "0xe7015CCb7E5F788B8c1010FC22343473EaaC3741",
		address: "0xe7015CCb7E5F788B8c1010FC22343473EaaC3741",
		type: "Crypto (ETH)",
		name: "KP3R / ETH",
		symbol: "KP3R / ETH",
		decimals: 18
	},
	{
		value: "0xB9E1E3A9feFf48998E45Fa90847ed4D467E8BcfD",
		address: "0xB9E1E3A9feFf48998E45Fa90847ed4D467E8BcfD",
		type: "Crypto (Stablecoin)",
		name: "FRAX / USD",
		symbol: "FRAX / USD",
		decimals: 8
	},
	{
		value: "0xa175FA75795c6Fb2aFA48B72d22054ee0DeDa4aC",
		address: "0xa175FA75795c6Fb2aFA48B72d22054ee0DeDa4aC",
		type: "Crypto",
		name: "Orchid",
		symbol: "Orchid",
		decimals: 5
	},
	{
		value: "0xdbd020CAeF83eFd542f4De03e3cF0C28A4428bd5",
		address: "0xdbd020CAeF83eFd542f4De03e3cF0C28A4428bd5",
		type: "Crypto (USD)",
		name: "COMP / USD",
		symbol: "COMP / USD",
		decimals: 8
	},
	{
		value: "0x9B97304EA12EFed0FAd976FBeCAad46016bf269e",
		address: "0x9B97304EA12EFed0FAd976FBeCAad46016bf269e",
		type: "Crypto (ETH)",
		name: "PAXG / ETH",
		symbol: "PAXG / ETH",
		decimals: 18
	},
	{
		value: "0xf817B69EA583CAFF291E287CaE00Ea329d22765C",
		address: "0xf817B69EA583CAFF291E287CaE00Ea329d22765C",
		type: "Crypto (ETH)",
		name: "UMA / ETH",
		symbol: "UMA / ETH",
		decimals: 18
	},
	{
		value: "0x393CC05baD439c9B36489384F11487d9C8410471",
		address: "0x393CC05baD439c9B36489384F11487d9C8410471",
		type: "Crypto (USD)",
		name: "RDNT / USD",
		symbol: "RDNT / USD",
		decimals: 8
	},
	{
		value: "0x478909D4D798f3a1F11fFB25E4920C959B4aDe0b",
		address: "0x478909D4D798f3a1F11fFB25E4920C959B4aDe0b",
		type: "Crypto (USD)",
		name: "DYDX / USD",
		symbol: "DYDX / USD",
		decimals: 8
	},
	{
		value: "0x2Da4983a622a8498bb1a21FaE9D8F6C664939962",
		address: "0x2Da4983a622a8498bb1a21FaE9D8F6C664939962",
		type: "Crypto (ETH)",
		name: "ZRX / ETH",
		symbol: "ZRX / ETH",
		decimals: 18
	},
	{
		value: "0x5586bF404C7A22A4a4077401272cE5945f80189C",
		address: "0x5586bF404C7A22A4a4077401272cE5945f80189C",
		type: "Commodities",
		name: "CacheGold PoR USD",
		symbol: "CacheGold PoR USD",
		decimals: 8
	},
	{
		value: "0x352f2Bc3039429fC2fe62004a1575aE74001CfcE",
		address: "0x352f2Bc3039429fC2fe62004a1575aE74001CfcE",
		type: "Crypto (NFT)",
		name: "Bored Ape Yacht Club Floor Price / ETH",
		symbol: "Bored Ape Yacht Club Floor Price / ETH",
		decimals: 18
	},
	{
		value: "0xa89f5d2365ce98B3cD68012b6f503ab1416245Fc",
		address: "0xa89f5d2365ce98B3cD68012b6f503ab1416245Fc",
		type: "Crypto (Stablecoin)",
		name: "GUSD / USD",
		symbol: "GUSD / USD",
		decimals: 8
	},
	{
		value: "0x0A8cD0115B1EE87EbA5b8E06A9a15ED93e230f7a",
		address: "0x0A8cD0115B1EE87EbA5b8E06A9a15ED93e230f7a",
		type: "Crypto",
		name: "HBTC PoR",
		symbol: "HBTC PoR",
		decimals: 18
	},
	{
		value: "0x86392dC19c0b719886221c78AB11eb8Cf5c52812",
		address: "0x86392dC19c0b719886221c78AB11eb8Cf5c52812",
		type: "Crypto (ETH)",
		name: "STETH / ETH",
		symbol: "STETH / ETH",
		decimals: 18
	},
	{
		value: "0xec1D1B3b0443256cc3860e24a46F108e699484Aa",
		address: "0xec1D1B3b0443256cc3860e24a46F108e699484Aa",
		type: "Crypto (USD)",
		name: "MKR / USD",
		symbol: "MKR / USD",
		decimals: 8
	},
	{
		value: "0x89c7926c7c15fD5BFDB1edcFf7E7fC8283B578F6",
		address: "0x89c7926c7c15fD5BFDB1edcFf7E7fC8283B578F6",
		type: "Crypto (ETH)",
		name: "ALPHA / ETH",
		symbol: "ALPHA / ETH",
		decimals: 18
	},
	{
		value: "0xc7de7f4d4C9c991fF62a07D18b3E31e349833A18",
		address: "0xc7de7f4d4C9c991fF62a07D18b3E31e349833A18",
		type: "Crypto (ETH)",
		name: "APE / ETH",
		symbol: "APE / ETH",
		decimals: 18
	},
	{
		value: "0x7A9f34a0Aa917D438e9b6E630067062B7F8f6f3d",
		address: "0x7A9f34a0Aa917D438e9b6E630067062B7F8f6f3d",
		type: "Crypto (USD)",
		name: "STG / USD",
		symbol: "STG / USD",
		decimals: 8
	},
	{
		value: "0x833D8Eb16D306ed1FbB5D7A2E019e106B960965A",
		address: "0x833D8Eb16D306ed1FbB5D7A2E019e106B960965A",
		type: "Crypto (Stablecoin)",
		name: "BUSD / USD",
		symbol: "BUSD / USD",
		decimals: 8
	},
	{
		value: "0x194a9AaF2e0b67c35915cD01101585A33Fe25CAa",
		address: "0x194a9AaF2e0b67c35915cD01101585A33Fe25CAa",
		type: "Crypto (ETH)",
		name: "ALCX / ETH",
		symbol: "ALCX / ETH",
		decimals: 18
	},
	{
		value: "0xDaeA8386611A157B08829ED4997A8A62B557014C",
		address: "0xDaeA8386611A157B08829ED4997A8A62B557014C",
		type: "Crypto (ETH)",
		name: "MLN / ETH",
		symbol: "MLN / ETH",
		decimals: 18
	},
	{
		value: "0x17D054eCac33D91F7340645341eFB5DE9009F1C1",
		address: "0x17D054eCac33D91F7340645341eFB5DE9009F1C1",
		type: "Crypto (ETH)",
		name: "GRT / ETH",
		symbol: "GRT / ETH",
		decimals: 18
	},
	{
		value: "0x7Bf3ad9582De40942C1EF876571d9864D71c548b",
		address: "0x7Bf3ad9582De40942C1EF876571d9864D71c548b",
		type: "Crypto (NFT)",
		name: "JPEGd Bored Ape Kennel Club Floor Price ETH",
		symbol: "JPEGd Bored Ape Kennel Club Floor Price ETH",
		decimals: 18
	},
	{
		value: "0x5C00128d4d1c2F4f652C267d7bcdD7aC99C16E16",
		address: "0x5C00128d4d1c2F4f652C267d7bcdD7aC99C16E16",
		type: "Crypto (USD)",
		name: "ENS / USD",
		symbol: "ENS / USD",
		decimals: 8
	},
	{
		value: "0xbA9B2a360eb8aBdb677d6d7f27E12De11AA052ef",
		address: "0xbA9B2a360eb8aBdb677d6d7f27E12De11AA052ef",
		type: "Crypto (ETH)",
		name: "ORN / ETH",
		symbol: "ORN / ETH",
		decimals: 18
	},
	{
		value: "0x169E633A2D1E6c10dD91238Ba11c4A708dfEF37C",
		address: "0x169E633A2D1E6c10dD91238Ba11c4A708dfEF37C",
		type: "Crypto",
		name: "Fast Gas / Gwei",
		symbol: "Fast Gas / Gwei",
		decimals: 0
	},
	{
		value: "0x8fFfFfd4AfB6115b954Bd326cbe7B4BA576818f6",
		address: "0x8fFfFfd4AfB6115b954Bd326cbe7B4BA576818f6",
		type: "Crypto (Stablecoin)",
		name: "USDC / USD",
		symbol: "USDC / USD",
		decimals: 8
	},
	{
		value: "0x4e844125952D32AcdF339BE976c98E22F6F318dB",
		address: "0x4e844125952D32AcdF339BE976c98E22F6F318dB",
		type: "Crypto (ETH)",
		name: "LDO / ETH",
		symbol: "LDO / ETH",
		decimals: 18
	},
	{
		value: "0x56a4857acbcfe3a66965c251628B1c9f1c408C19",
		address: "0x56a4857acbcfe3a66965c251628B1c9f1c408C19",
		type: "Crypto (USD)",
		name: "MANA / USD",
		symbol: "MANA / USD",
		decimals: 8
	},
	{
		value: "0x449d117117838fFA61263B61dA6301AA2a88B13A",
		address: "0x449d117117838fFA61263B61dA6301AA2a88B13A",
		type: "Forex",
		name: "CHF / USD",
		symbol: "CHF / USD",
		decimals: 8
	},
	{
		value: "0xEe9F2375b4bdF6387aa8265dD4FB8F16512A1d46",
		address: "0xEe9F2375b4bdF6387aa8265dD4FB8F16512A1d46",
		type: "Crypto (Stablecoin)",
		name: "USDT / ETH",
		symbol: "USDT / ETH",
		decimals: 18
	},
	{
		value: "0x77F9710E7d0A19669A13c055F62cd80d313dF022",
		address: "0x77F9710E7d0A19669A13c055F62cd80d313dF022",
		type: "Forex",
		name: "AUD / USD",
		symbol: "AUD / USD",
		decimals: 8
	},
	{
		value: "0x8f83670260F8f7708143b836a2a6F11eF0aBac01",
		address: "0x8f83670260F8f7708143b836a2a6F11eF0aBac01",
		type: "Crypto (ETH)",
		name: "ANT / ETH",
		symbol: "ANT / ETH",
		decimals: 18
	},
	{
		value: "0x8a12Be339B0cD1829b91Adc01977caa5E9ac121e",
		address: "0x8a12Be339B0cD1829b91Adc01977caa5E9ac121e",
		type: "Crypto (ETH)",
		name: "CRV / ETH",
		symbol: "CRV / ETH",
		decimals: 18
	},
	{
		value: "0x3a08ebBaB125224b7b6474384Ee39fBb247D2200",
		address: "0x3a08ebBaB125224b7b6474384Ee39fBb247D2200",
		type: "Crypto (Stablecoin)",
		name: "PAX / ETH",
		symbol: "PAX / ETH",
		decimals: 18
	},
	{
		value: "0x66a47b7206130e6FF64854EF0E1EDfa237E65339",
		address: "0x66a47b7206130e6FF64854EF0E1EDfa237E65339",
		type: "Crypto (USD)",
		name: "BADGER / USD",
		symbol: "BADGER / USD",
		decimals: 8
	},
	{
		value: "0xdeb288F737066589598e9214E782fa5A8eD689e8",
		address: "0xdeb288F737066589598e9214E782fa5A8eD689e8",
		type: "Crypto (ETH)",
		name: "BTC / ETH",
		symbol: "BTC / ETH",
		decimals: 18
	},
	{
		value: "0x547a514d5e3769680Ce22B2361c10Ea13619e8a9",
		address: "0x547a514d5e3769680Ce22B2361c10Ea13619e8a9",
		type: "Crypto (USD)",
		name: "AAVE / USD",
		symbol: "AAVE / USD",
		decimals: 8
	},
	{
		value: "0x0d16d4528239e9ee52fa531af613AcdB23D88c94",
		address: "0x0d16d4528239e9ee52fa531af613AcdB23D88c94",
		type: "Crypto (ETH)",
		name: "BAT / ETH",
		symbol: "BAT / ETH",
		decimals: 18
	},
	{
		value: "0x1E6cF0D433de4FE882A437ABC654F58E1e78548c",
		address: "0x1E6cF0D433de4FE882A437ABC654F58E1e78548c",
		type: "Crypto (USD)",
		name: "BNT / USD",
		symbol: "BNT / USD",
		decimals: 8
	},
	{
		value: "0xA97477aB5ab6ED2f6A2B5Cbe59D71e88ad334b90",
		address: "0xA97477aB5ab6ED2f6A2B5Cbe59D71e88ad334b90",
		type: "Crypto (NFT)",
		name: "BEANZ Official Floor Price",
		symbol: "BEANZ Official Floor Price",
		decimals: 18
	},
	{
		value: "0x9cB2A01A7E64992d32A34db7cEea4c919C391f6A",
		address: "0x9cB2A01A7E64992d32A34db7cEea4c919C391f6A",
		type: "Crypto (ETH)",
		name: "NMR / ETH",
		symbol: "NMR / ETH",
		decimals: 18
	},
	{
		value: "0x01435677FB11763550905594A16B645847C1d0F3",
		address: "0x01435677FB11763550905594A16B645847C1d0F3",
		type: "Forex",
		name: "KRW / USD",
		symbol: "KRW / USD",
		decimals: 8
	},
	{
		value: "0x90c2098473852E2F07678Fe1B6d595b1bd9b16Ed",
		address: "0x90c2098473852E2F07678Fe1B6d595b1bd9b16Ed",
		type: "Crypto (ETH)",
		name: "OHM / ETH",
		symbol: "OHM / ETH",
		decimals: 18
	},
	{
		value: "0x611E0d2709416E002A3f38085e4e1cf77c015921",
		address: "0x611E0d2709416E002A3f38085e4e1cf77c015921",
		type: "Crypto (ETH)",
		name: "FARM / ETH",
		symbol: "FARM / ETH",
		decimals: 18
	},
	{
		value: "0xcDa3708C5c2907FCca52BB3f9d3e4c2028b89319",
		address: "0xcDa3708C5c2907FCca52BB3f9d3e4c2028b89319",
		type: "Crypto (USD)",
		name: "ONT / USD",
		symbol: "ONT / USD",
		decimals: 8
	},
	{
		value: "0x9cd36E0E8D3C27d630D00406ACFC3463154951Af",
		address: "0x9cd36E0E8D3C27d630D00406ACFC3463154951Af",
		type: "Crypto (NFT)",
		name: "Moonbirds Floor Price",
		symbol: "Moonbirds Floor Price",
		decimals: 18
	},
	{
		value: "0x4ad7B025127e89263242aB68F0f9c4E5C033B489",
		address: "0x4ad7B025127e89263242aB68F0f9c4E5C033B489",
		type: "Crypto (ETH)",
		name: "RAI / ETH",
		symbol: "RAI / ETH",
		decimals: 18
	},
	{
		value: "0xd962fC30A72A84cE50161031391756Bf2876Af5D",
		address: "0xd962fC30A72A84cE50161031391756Bf2876Af5D",
		type: "Crypto (USD)",
		name: "CVX / USD",
		symbol: "CVX / USD",
		decimals: 8
	},
	{
		value: "0x01D391A48f4F7339aC64CA2c83a07C22F95F587a",
		address: "0x01D391A48f4F7339aC64CA2c83a07C22F95F587a",
		type: "Crypto (Stablecoin)",
		name: "EURT / USD",
		symbol: "EURT / USD",
		decimals: 8
	},
	{
		value: "0xEC8761a0A73c34329CA5B1D3Dc7eD07F30e836e2",
		address: "0xEC8761a0A73c34329CA5B1D3Dc7eD07F30e836e2",
		type: "Crypto (USD)",
		name: "Total Marketcap / USD",
		symbol: "Total Marketcap / USD",
		decimals: 8
	},
	{
		value: "0xd75AAaE4AF0c398ca13e2667Be57AF2ccA8B5de6",
		address: "0xd75AAaE4AF0c398ca13e2667Be57AF2ccA8B5de6",
		type: "Crypto (USD)",
		name: "OXT / USD",
		symbol: "OXT / USD",
		decimals: 8
	},
	{
		value: "0x160AC928A16C93eD4895C2De6f81ECcE9a7eB7b4",
		address: "0x160AC928A16C93eD4895C2De6f81ECcE9a7eB7b4",
		type: "Crypto (ETH)",
		name: "LRC / ETH",
		symbol: "LRC / ETH",
		decimals: 18
	},
	{
		value: "0x3886BA987236181D98F2401c507Fb8BeA7871dF2",
		address: "0x3886BA987236181D98F2401c507Fb8BeA7871dF2",
		type: "Crypto (Stablecoin)",
		name: "TUSD / ETH",
		symbol: "TUSD / ETH",
		decimals: 18
	},
	{
		value: "0xDb299D394817D8e7bBe297E84AFfF7106CF92F5f",
		address: "0xDb299D394817D8e7bBe297E84AFfF7106CF92F5f",
		type: "Crypto",
		name: "APY TVL",
		symbol: "APY TVL",
		decimals: 8
	},
	{
		value: "0xec746eCF986E2927Abd291a2A1716c940100f8Ba",
		address: "0xec746eCF986E2927Abd291a2A1716c940100f8Ba",
		type: "Crypto (Stablecoin)",
		name: "TUSD / USD",
		symbol: "TUSD / USD",
		decimals: 8
	},
	{
		value: "0x9441D7556e7820B5ca42082cfa99487D56AcA958",
		address: "0x9441D7556e7820B5ca42082cfa99487D56AcA958",
		type: "Crypto (USD)",
		name: "BAT / USD",
		symbol: "BAT / USD",
		decimals: 8
	},
	{
		value: "0x0606Be69451B1C9861Ac6b3626b99093b713E801",
		address: "0x0606Be69451B1C9861Ac6b3626b99093b713E801",
		type: "Crypto (ETH)",
		name: "FIL / ETH",
		symbol: "FIL / ETH",
		decimals: 18
	},
	{
		value: "0x9a72298ae3886221820B1c878d12D872087D3a23",
		address: "0x9a72298ae3886221820B1c878d12D872087D3a23",
		type: "Crypto (ETH)",
		name: "OHMv2 / ETH",
		symbol: "OHMv2 / ETH",
		decimals: 18
	},
	{
		value: "0x1B39Ee86Ec5979ba5C322b826B3ECb8C79991699",
		address: "0x1B39Ee86Ec5979ba5C322b826B3ECb8C79991699",
		type: "Crypto (ETH)",
		name: "COMP / ETH",
		symbol: "COMP / ETH",
		decimals: 18
	},
	{
		value: "0xc04611C43842220fd941515F86d1DDdB15F04e46",
		address: "0xc04611C43842220fd941515F86d1DDdB15F04e46",
		type: "Equities",
		name: "SHV / USD",
		symbol: "SHV / USD",
		decimals: 8
	},
	{
		value: "0xF4E1B57FB228879D057ac5AE33973e8C53e4A0e0",
		address: "0xF4E1B57FB228879D057ac5AE33973e8C53e4A0e0",
		type: "Equities",
		name: "CSPX / USD",
		symbol: "CSPX / USD",
		decimals: 8
	},
	{
		value: "0x96d15851CBac05aEe4EFD9eA3a3DD9BDEeC9fC28",
		address: "0x96d15851CBac05aEe4EFD9eA3a3DD9BDEeC9fC28",
		type: "Crypto (Stablecoin)",
		name: "GUSD / ETH",
		symbol: "GUSD / ETH",
		decimals: 18
	},
	{
		value: "0x536218f9E9Eb48863970252233c8F271f554C2d0",
		address: "0x536218f9E9Eb48863970252233c8F271f554C2d0",
		type: "Crypto (ETH)",
		name: "RETH / ETH",
		symbol: "RETH / ETH",
		decimals: 18
	},
	{
		value: "0x6Ebc52C8C1089be9eB3945C4350B68B8E4C2233f",
		address: "0x6Ebc52C8C1089be9eB3945C4350B68B8E4C2233f",
		type: "Crypto (USD)",
		name: "FXS / USD",
		symbol: "FXS / USD",
		decimals: 8
	},
	{
		value: "0xAF2Ce23Ef2dD9BB6F03668cA6eAd55aEa1e56FBa",
		address: "0xAF2Ce23Ef2dD9BB6F03668cA6eAd55aEa1e56FBa",
		type: "Crypto",
		name: "HOPE PoR",
		symbol: "HOPE PoR",
		decimals: 8
	},
	{
		value: "0xD2A593BF7594aCE1faD597adb697b5645d5edDB2",
		address: "0xD2A593BF7594aCE1faD597adb697b5645d5edDB2",
		type: "Crypto (USD)",
		name: "DPI / USD",
		symbol: "DPI / USD",
		decimals: 8
	},
	{
		value: "0x759bBC1be8F90eE6457C44abc7d443842a976d02",
		address: "0x759bBC1be8F90eE6457C44abc7d443842a976d02",
		type: "Crypto (USD)",
		name: "RSR / USD",
		symbol: "RSR / USD",
		decimals: 8
	},
	{
		value: "0x86cF33a451dE9dc61a2862FD94FF4ad4Bd65A5d2",
		address: "0x86cF33a451dE9dc61a2862FD94FF4ad4Bd65A5d2",
		type: "Crypto (USD)",
		name: "GRT / USD",
		symbol: "GRT / USD",
		decimals: 8
	},
	{
		value: "0xCC1f5d9e6956447630d703C8e93b2345c2DE3D13",
		address: "0xCC1f5d9e6956447630d703C8e93b2345c2DE3D13",
		type: "Crypto (USD)",
		name: "Calculated XSUSHI / USD",
		symbol: "Calculated XSUSHI / USD",
		decimals: 8
	},
	{
		value: "0xBE456fd14720C3aCCc30A2013Bffd782c9Cb75D5",
		address: "0xBE456fd14720C3aCCc30A2013Bffd782c9Cb75D5",
		type: "Fiat",
		name: "TUSD Reserves",
		symbol: "TUSD Reserves",
		decimals: 18
	},
	{
		value: "0x1B58B67B2b2Df71b4b0fb6691271E83A0fa36aC5",
		address: "0x1B58B67B2b2Df71b4b0fb6691271E83A0fa36aC5",
		type: "Crypto",
		name: "CV / Index",
		symbol: "CV / Index",
		decimals: 18
	},
	{
		value: "0x775a0B15042ceE8925D3D81481c7b94ffBfc24a7",
		address: "0x775a0B15042ceE8925D3D81481c7b94ffBfc24a7",
		type: "Crypto",
		name: "BTC Interest Rate Benchmark Curve 4 Month",
		symbol: "BTC Interest Rate Benchmark Curve 4 Month",
		decimals: 8
	},
	{
		value: "0x7c5d4F8345e66f68099581Db340cd65B078C41f4",
		address: "0x7c5d4F8345e66f68099581Db340cd65B078C41f4",
		type: "Crypto (ETH)",
		name: "YFI / ETH",
		symbol: "YFI / ETH",
		decimals: 18
	},
	{
		value: "0x26929b85fE284EeAB939831002e1928183a10fb1",
		address: "0x26929b85fE284EeAB939831002e1928183a10fb1",
		type: "Crypto (USD)",
		name: "TRU / USD",
		symbol: "TRU / USD",
		decimals: 8
	},
	{
		value: "0x01cE1210Fe8153500F60f7131d63239373D7E26C",
		address: "0x01cE1210Fe8153500F60f7131d63239373D7E26C",
		type: "Crypto (USD)",
		name: "PERP / USD",
		symbol: "PERP / USD",
		decimals: 8
	},
	{
		value: "0x021264d59DAbD26E7506Ee7278407891Bb8CDCCc",
		address: "0x021264d59DAbD26E7506Ee7278407891Bb8CDCCc",
		type: "Crypto (NFT)",
		name: "CloneX Floor Price",
		symbol: "CloneX Floor Price",
		decimals: 18
	},
	{
		value: "0x656c0544eF4C98A6a98491833A89204Abb045d6b",
		address: "0x656c0544eF4C98A6a98491833A89204Abb045d6b",
		type: "Crypto (ETH)",
		name: "KNC / ETH",
		symbol: "KNC / ETH",
		decimals: 18
	},
	{
		value: "0xa81FE04086865e63E12dD3776978E49DEEa2ea4e",
		address: "0xa81FE04086865e63E12dD3776978E49DEEa2ea4e",
		type: "Crypto",
		name: "WBTC PoR",
		symbol: "WBTC PoR",
		decimals: 8
	},
	{
		value: "0x8dD1CD88F43aF196ae478e91b9F5E4Ac69A97C61",
		address: "0x8dD1CD88F43aF196ae478e91b9F5E4Ac69A97C61",
		type: "Crypto (ETH)",
		name: "SHIB / ETH",
		symbol: "SHIB / ETH",
		decimals: 18
	},
	{
		value: "0x79291A9d692Df95334B1a0B3B4AE6bC606782f8c",
		address: "0x79291A9d692Df95334B1a0B3B4AE6bC606782f8c",
		type: "Crypto (ETH)",
		name: "SNX / ETH",
		symbol: "SNX / ETH",
		decimals: 18
	},
	{
		value: "0x7eed379bf00005CfeD29feD4009669dE9Bcc21ce",
		address: "0x7eed379bf00005CfeD29feD4009669dE9Bcc21ce",
		type: "Crypto (USD)",
		name: "ANKR / USD",
		symbol: "ANKR / USD",
		decimals: 8
	},
	{
		value: "0x14e613AC84a31f709eadbdF89C6CC390fDc9540A",
		address: "0x14e613AC84a31f709eadbdF89C6CC390fDc9540A",
		type: "Crypto (USD)",
		name: "BNB / USD",
		symbol: "BNB / USD",
		decimals: 8
	},
	{
		value: "0x3b41D5571468904D4e53b6a8d93A6BaC43f02dC9",
		address: "0x3b41D5571468904D4e53b6a8d93A6BaC43f02dC9",
		type: "Crypto (ETH)",
		name: "PERP / ETH",
		symbol: "PERP / ETH",
		decimals: 18
	},
	{
		value: "0x37260ecF9Eb9AB1F813909a25CC8ADde99eD00fa",
		address: "0x37260ecF9Eb9AB1F813909a25CC8ADde99eD00fa",
		type: "Crypto",
		name: "BTC Interest Rate Benchmark Curve 3 Week",
		symbol: "BTC Interest Rate Benchmark Curve 3 Week",
		decimals: 8
	},
	{
		value: "0xd88b089f47d6f82e84589601fd7c329472077E08",
		address: "0xd88b089f47d6f82e84589601fd7c329472077E08",
		type: "Crypto (NFT)",
		name: "JPEGd Ringers Floor Price ETH",
		symbol: "JPEGd Ringers Floor Price ETH",
		decimals: 18
	},
	{
		value: "0xCc72039A141c6e34a779eF93AEF5eB4C82A893c7",
		address: "0xCc72039A141c6e34a779eF93AEF5eB4C82A893c7",
		type: "Crypto (ETH)",
		name: "Nexus wETH Reserves",
		symbol: "Nexus wETH Reserves",
		decimals: 18
	},
	{
		value: "0x23905C55dC11D609D5d11Dc604905779545De9a7",
		address: "0x23905C55dC11D609D5d11Dc604905779545De9a7",
		type: "Crypto (USD)",
		name: "ENJ / USD",
		symbol: "ENJ / USD",
		decimals: 8
	},
	{
		value: "0x32EaFC72772821936BCc9b8A32dC394fEFcDBfD9",
		address: "0x32EaFC72772821936BCc9b8A32dC394fEFcDBfD9",
		type: "Crypto",
		name: "Arbitrum Healthcheck",
		symbol: "Arbitrum Healthcheck",
		decimals: 0
	},
	{
		value: "0xFb0CfD6c19e25DB4a08D8a204a387cEa48Cc138f",
		address: "0xFb0CfD6c19e25DB4a08D8a204a387cEa48Cc138f",
		type: "Crypto (USD)",
		name: "SXP / USD",
		symbol: "SXP / USD",
		decimals: 8
	},
	{
		value: "0x8917800a6BDd8fA8b7c94E25aE2219Db28050622",
		address: "0x8917800a6BDd8fA8b7c94E25aE2219Db28050622",
		type: "Crypto",
		name: "eFIL PoR",
		symbol: "eFIL PoR",
		decimals: 18
	},
	{
		value: "0xeb988B77b94C186053282BfcD8B7ED55142D3cAB",
		address: "0xeb988B77b94C186053282BfcD8B7ED55142D3cAB",
		type: "Crypto (USD)",
		name: "XCN / USD",
		symbol: "XCN / USD",
		decimals: 8
	},
	{
		value: "0xfdFD9C85aD200c506Cf9e21F1FD8dd01932FBB23",
		address: "0xfdFD9C85aD200c506Cf9e21F1FD8dd01932FBB23",
		type: "Crypto",
		name: "WBTC / BTC",
		symbol: "WBTC / BTC",
		decimals: 8
	},
	{
		value: "0x35E3f7E558C04cE7eEE1629258EcbbA03B36Ec56",
		address: "0x35E3f7E558C04cE7eEE1629258EcbbA03B36Ec56",
		type: "Crypto (USD)",
		name: "SAND / USD",
		symbol: "SAND / USD",
		decimals: 8
	},
	{
		value: "0x4ffC43a60e009B551865A93d232E33Fce9f01507",
		address: "0x4ffC43a60e009B551865A93d232E33Fce9f01507",
		type: "Crypto (USD)",
		name: "SOL / USD",
		symbol: "SOL / USD",
		decimals: 8
	},
	{
		value: "0x6e3A4376B4C8D3ba49602f8542D9D3C4A87ba901",
		address: "0x6e3A4376B4C8D3ba49602f8542D9D3C4A87ba901",
		type: "Crypto (NFT)",
		name: "Otherdeed for Otherside Floor Price",
		symbol: "Otherdeed for Otherside Floor Price",
		decimals: 18
	},
	{
		value: "0x9320f0429180ce49C6D4d10A4633c8c92cdb53cB",
		address: "0x9320f0429180ce49C6D4d10A4633c8c92cdb53cB",
		type: "Crypto",
		name: "BTC Interest Rate Benchmark Curve 3 Month",
		symbol: "BTC Interest Rate Benchmark Curve 3 Month",
		decimals: 8
	},
	{
		value: "0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419",
		address: "0x5f4eC3Df9cbd43714FE2740f5E3616155c5b8419",
		type: "Crypto (ETH)",
		name: "ETH / USD",
		symbol: "ETH / USD",
		decimals: 8
	},
	{
		value: "0x3147D7203354Dc06D9fd350c7a2437bcA92387a4",
		address: "0x3147D7203354Dc06D9fd350c7a2437bcA92387a4",
		type: "Crypto (ETH)",
		name: "REN / ETH",
		symbol: "REN / ETH",
		decimals: 18
	},
	{
		value: "0xA8B9A447C73191744D5B79BcE864F343455E1150",
		address: "0xA8B9A447C73191744D5B79BcE864F343455E1150",
		type: "Crypto (NFT)",
		name: "Azuki Floor Price / ETH",
		symbol: "Azuki Floor Price / ETH",
		decimals: 18
	},
	{
		value: "0x01B6710B01cF3dd8Ae64243097d91aFb03728Fdd",
		address: "0x01B6710B01cF3dd8Ae64243097d91aFb03728Fdd",
		type: "Crypto (NFT)",
		name: "CryptoPunks Floor Price / ETH",
		symbol: "CryptoPunks Floor Price / ETH",
		decimals: 18
	},
	{
		value: "0x09023c0DA49Aaf8fc3fA3ADF34C6A7016D38D5e3",
		address: "0x09023c0DA49Aaf8fc3fA3ADF34C6A7016D38D5e3",
		type: "Crypto (Stablecoin)",
		name: "USDP / USD",
		symbol: "USDP / USD",
		decimals: 8
	},
	{
		value: "0x24551a8Fb2A7211A25a17B1481f043A8a8adC7f2",
		address: "0x24551a8Fb2A7211A25a17B1481f043A8a8adC7f2",
		type: "Crypto (ETH)",
		name: "MKR / ETH",
		symbol: "MKR / ETH",
		decimals: 18
	},
	{
		value: "0x6AF09DF7563C363B5763b9102712EbeD3b9e859B",
		address: "0x6AF09DF7563C363B5763b9102712EbeD3b9e859B",
		type: "Crypto (USD)",
		name: "LTC / USD",
		symbol: "LTC / USD",
		decimals: 8
	},
	{
		value: "0x4C01bcfb622F9aF8053E013e18373E50e6e8632E",
		address: "0x4C01bcfb622F9aF8053E013e18373E50e6e8632E",
		type: "Crypto",
		name: "BTC Interest Rate Benchmark Curve 1 Month",
		symbol: "BTC Interest Rate Benchmark Curve 1 Month",
		decimals: 8
	},
	{
		value: "0x875D60C44cfbC38BaA4Eb2dDB76A767dEB91b97e",
		address: "0x875D60C44cfbC38BaA4Eb2dDB76A767dEB91b97e",
		type: "Crypto (ETH)",
		name: "RUNE / ETH",
		symbol: "RUNE / ETH",
		decimals: 18
	},
	{
		value: "0x3E7d1eAB13ad0104d2750B8863b489D65364e32D",
		address: "0x3E7d1eAB13ad0104d2750B8863b489D65364e32D",
		type: "Crypto (Stablecoin)",
		name: "USDT / USD",
		symbol: "USDT / USD",
		decimals: 8
	},
	{
		value: "0xF49f8F5b931B0e4B4246E4CcA7cD2083997Aa83d",
		address: "0xF49f8F5b931B0e4B4246E4CcA7cD2083997Aa83d",
		type: "Crypto (NFT)",
		name: "CoolCats Floor Price",
		symbol: "CoolCats Floor Price",
		decimals: 18
	},
	{
		value: "0xB09fC5fD3f11Cf9eb5E1C5Dba43114e3C9f477b5",
		address: "0xB09fC5fD3f11Cf9eb5E1C5Dba43114e3C9f477b5",
		type: "Forex",
		name: "TRY / USD",
		symbol: "TRY / USD",
		decimals: 8
	},
	{
		value: "0x1823C89715Fe3fB96A24d11c917aCA918894A090",
		address: "0x1823C89715Fe3fB96A24d11c917aCA918894A090",
		type: "Crypto (NFT)",
		name: "MAYC Floor Price",
		symbol: "MAYC Floor Price",
		decimals: 18
	},
	{
		value: "0x5cB4280b9ca8B0363aA4f4ef609dF403e522ea67",
		address: "0x5cB4280b9ca8B0363aA4f4ef609dF403e522ea67",
		type: "Crypto",
		name: "BTC Interest Rate Benchmark Curve 2 Week",
		symbol: "BTC Interest Rate Benchmark Curve 2 Week",
		decimals: 8
	},
	{
		value: "0x72AFAECF99C9d9C8215fF44C77B94B99C28741e8",
		address: "0x72AFAECF99C9d9C8215fF44C77B94B99C28741e8",
		type: "Crypto (ETH)",
		name: "1INCH / ETH",
		symbol: "1INCH / ETH",
		decimals: 18
	},
	{
		value: "0xCd627aA160A6fA45Eb793D19Ef54f5062F20f33f",
		address: "0xCd627aA160A6fA45Eb793D19Ef54f5062F20f33f",
		type: "Crypto (USD)",
		name: "CRV / USD",
		symbol: "CRV / USD",
		decimals: 8
	},
	{
		value: "0x492575FDD11a0fCf2C6C719867890a7648d526eB",
		address: "0x492575FDD11a0fCf2C6C719867890a7648d526eB",
		type: "Crypto (ETH)",
		name: "AMPL / ETH",
		symbol: "AMPL / ETH",
		decimals: 18
	},
	{
		value: "0xAE48c91dF1fE419994FFDa27da09D5aC69c30f55",
		address: "0xAE48c91dF1fE419994FFDa27da09D5aC69c30f55",
		type: "Crypto (USD)",
		name: "ADA / USD",
		symbol: "ADA / USD",
		decimals: 8
	},
	{
		value: "0xf8fF43E991A81e6eC886a3D281A2C6cC19aE70Fc",
		address: "0xf8fF43E991A81e6eC886a3D281A2C6cC19aE70Fc",
		type: "Crypto (USD)",
		name: "KNC / USD",
		symbol: "KNC / USD",
		decimals: 8
	},
	{
		value: "0x2DE7E4a9488488e0058B95854CC2f7955B35dC9b",
		address: "0x2DE7E4a9488488e0058B95854CC2f7955B35dC9b",
		type: "Crypto (ETH)",
		name: "FTM / ETH",
		symbol: "FTM / ETH",
		decimals: 18
	},
	{
		value: "0x1C07AFb8E2B827c5A4739C6d59Ae3A5035f28734",
		address: "0x1C07AFb8E2B827c5A4739C6d59Ae3A5035f28734",
		type: "Crypto (USD)",
		name: "DOT / USD",
		symbol: "DOT / USD",
		decimals: 8
	},
	{
		value: "0xaC9962D846D431254C7B3Da3AA12519a1E2Eb5e7",
		address: "0xaC9962D846D431254C7B3Da3AA12519a1E2Eb5e7",
		type: "Crypto (NFT)",
		name: "JPEGd Pudgy Penguins Floor Price ETH",
		symbol: "JPEGd Pudgy Penguins Floor Price ETH",
		decimals: 18
	},
	{
		value: "0xDC530D9457755926550b59e8ECcdaE7624181557",
		address: "0xDC530D9457755926550b59e8ECcdaE7624181557",
		type: "Crypto (ETH)",
		name: "LINK / ETH",
		symbol: "LINK / ETH",
		decimals: 18
	},
	{
		value: "0xe5Dc0A609Ab8bCF15d3f35cFaa1Ff40f521173Ea",
		address: "0xe5Dc0A609Ab8bCF15d3f35cFaa1Ff40f521173Ea",
		type: "Crypto (ETH)",
		name: "WNXM / ETH",
		symbol: "WNXM / ETH",
		decimals: 18
	},
	{
		value: "0xdF2917806E30300537aEB49A7663062F4d1F2b5F",
		address: "0xdF2917806E30300537aEB49A7663062F4d1F2b5F",
		type: "Crypto (USD)",
		name: "BAL / USD",
		symbol: "BAL / USD",
		decimals: 8
	},
	{
		value: "0xD6aA3D25116d8dA79Ea0246c4826EB951872e02e",
		address: "0xD6aA3D25116d8dA79Ea0246c4826EB951872e02e",
		type: "Crypto (ETH)",
		name: "UNI / ETH",
		symbol: "UNI / ETH",
		decimals: 18
	},
	{
		value: "0x84a24deCA415Acc0c395872a9e6a63E27D6225c8",
		address: "0x84a24deCA415Acc0c395872a9e6a63E27D6225c8",
		type: "Crypto (ETH)",
		name: "TRIBE / ETH",
		symbol: "TRIBE / ETH",
		decimals: 18
	},
	{
		value: "0xf600984CCa37cd562E74E3EE514289e3613ce8E4",
		address: "0xf600984CCa37cd562E74E3EE514289e3613ce8E4",
		type: "Crypto (ETH)",
		name: "ILV / ETH",
		symbol: "ILV / ETH",
		decimals: 18
	},
	{
		value: "0x134fE0a225Fb8e6683617C13cEB6B3319fB4fb82",
		address: "0x134fE0a225Fb8e6683617C13cEB6B3319fB4fb82",
		type: "Crypto (USD)",
		name: "WING / USD",
		symbol: "WING / USD",
		decimals: 8
	},
	{
		value: "0xFaA8F6073845DBe5627dAA3208F78A3043F99bcA",
		address: "0xFaA8F6073845DBe5627dAA3208F78A3043F99bcA",
		type: "Crypto (NFT)",
		name: "Cryptoadz Floor Price",
		symbol: "Cryptoadz Floor Price",
		decimals: 18
	},
	{
		value: "0x96284a8f283aEE951f359f44006C2d1b72e85957",
		address: "0x96284a8f283aEE951f359f44006C2d1b72e85957",
		type: "Crypto",
		name: "BTC Interest Rate Benchmark Curve 2 Month",
		symbol: "BTC Interest Rate Benchmark Curve 2 Month",
		decimals: 8
	},
	{
		value: "0x0CA05B24795eb4f5bA5237e1D4470048cc0fE235",
		address: "0x0CA05B24795eb4f5bA5237e1D4470048cc0fE235",
		type: "Crypto (NFT)",
		name: "JPEGd Bored Ape Floor Price ETH",
		symbol: "JPEGd Bored Ape Floor Price ETH",
		decimals: 18
	},
	{
		value: "0xe25277fF4bbF9081C75Ab0EB13B4A13a721f3E13",
		address: "0xe25277fF4bbF9081C75Ab0EB13B4A13a721f3E13",
		type: "Forex",
		name: "SGD / USD",
		symbol: "SGD / USD",
		decimals: 8
	},
	{
		value: "0xA027702dbb89fbd58938e4324ac03B58d812b0E1",
		address: "0xA027702dbb89fbd58938e4324ac03B58d812b0E1",
		type: "Crypto (USD)",
		name: "YFI / USD",
		symbol: "YFI / USD",
		decimals: 8
	},
	{
		value: "0xe572CeF69f43c2E488b33924AF04BDacE19079cf",
		address: "0xe572CeF69f43c2E488b33924AF04BDacE19079cf",
		type: "Crypto (ETH)",
		name: "SUSHI / ETH",
		symbol: "SUSHI / ETH",
		decimals: 18
	},
	{
		value: "0x75FbD83b4bd51dEe765b2a01e8D3aa1B020F9d33",
		address: "0x75FbD83b4bd51dEe765b2a01e8D3aa1B020F9d33",
		type: "Crypto (ETH)",
		name: "CEL / ETH",
		symbol: "CEL / ETH",
		decimals: 18
	},
	{
		value: "0xc929ad75B72593967DE83E7F7Cda0493458261D9",
		address: "0xc929ad75B72593967DE83E7F7Cda0493458261D9",
		type: "Crypto (USD)",
		name: "1INCH / USD",
		symbol: "1INCH / USD",
		decimals: 8
	},
	{
		value: "0x3977CFc9e4f29C184D4675f4EB8e0013236e5f3e",
		address: "0x3977CFc9e4f29C184D4675f4EB8e0013236e5f3e",
		type: "Forex",
		name: "NZD / USD",
		symbol: "NZD / USD",
		decimals: 8
	},
	{
		value: "0xe20CA8D7546932360e37E9D72c1a47334af57706",
		address: "0xe20CA8D7546932360e37E9D72c1a47334af57706",
		type: "Crypto (USD)",
		name: "AMPL / USD",
		symbol: "AMPL / USD",
		decimals: 18
	},
	{
		value: "0xF017fcB346A1885194689bA23Eff2fE6fA5C483b",
		address: "0xF017fcB346A1885194689bA23Eff2fE6fA5C483b",
		type: "Crypto (ETH)",
		name: "CBETH / ETH",
		symbol: "CBETH / ETH",
		decimals: 18
	},
	{
		value: "0xA9cdBbDE36803af377735233e6BD261cDA5aD11d",
		address: "0xA9cdBbDE36803af377735233e6BD261cDA5aD11d",
		type: "Crypto (NFT)",
		name: "JPEGd Azuki Floor Price ETH",
		symbol: "JPEGd Azuki Floor Price ETH",
		decimals: 18
	},
	{
		value: "0x4cba1e1fdc738D0fe8DB3ee07728E2Bc4DA676c6",
		address: "0x4cba1e1fdc738D0fe8DB3ee07728E2Bc4DA676c6",
		type: "Crypto (ETH)",
		name: "RLC / ETH",
		symbol: "RLC / ETH",
		decimals: 18
	},
	{
		value: "0xCfE54B5cD566aB89272946F602D76Ea879CAb4a8",
		address: "0xCfE54B5cD566aB89272946F602D76Ea879CAb4a8",
		type: "Crypto (ETH)",
		name: "STETH / USD",
		symbol: "STETH / USD",
		decimals: 8
	},
	{
		value: "0x24D9aB51950F3d62E9144fdC2f3135DAA6Ce8D1B",
		address: "0x24D9aB51950F3d62E9144fdC2f3135DAA6Ce8D1B",
		type: "Crypto (ETH)",
		name: "ENJ / ETH",
		symbol: "ENJ / ETH",
		decimals: 18
	},
	{
		value: "0xF4030086522a5bEEa4988F8cA5B36dbC97BeE88c",
		address: "0xF4030086522a5bEEa4988F8cA5B36dbC97BeE88c",
		type: "Crypto (USD)",
		name: "BTC / USD",
		symbol: "BTC / USD",
		decimals: 8
	},
	{
		value: "0xF05D9B6C08757EAcb1fbec18e36A1B7566a13DEB",
		address: "0xF05D9B6C08757EAcb1fbec18e36A1B7566a13DEB",
		type: "Crypto (ETH)",
		name: "Calculated XSUSHI / ETH",
		symbol: "Calculated XSUSHI / ETH",
		decimals: 18
	},
	{
		value: "0x379589227b15F1a12195D3f2d90bBc9F31f95235",
		address: "0x379589227b15F1a12195D3f2d90bBc9F31f95235",
		type: "Commodities",
		name: "XAG / USD",
		symbol: "XAG / USD",
		decimals: 8
	},
	{
		value: "0x6Df09E975c830ECae5bd4eD9d90f3A95a4f88012",
		address: "0x6Df09E975c830ECae5bd4eD9d90f3A95a4f88012",
		type: "Crypto (ETH)",
		name: "AAVE / ETH",
		symbol: "AAVE / ETH",
		decimals: 18
	},
	{
		value: "0x35bf6767577091E7f04707c0290b3f889e968307",
		address: "0x35bf6767577091E7f04707c0290b3f889e968307",
		type: "Crypto (NFT)",
		name: "VeeFriends Floor Price",
		symbol: "VeeFriends Floor Price",
		decimals: 18
	},
	{
		value: "0x13E6C463BEC76873E4e63ce5169e9a95b7e06801",
		address: "0x13E6C463BEC76873E4e63ce5169e9a95b7e06801",
		type: "Crypto (NFT)",
		name: "JPEGd CloneX Floor Price ETH",
		symbol: "JPEGd CloneX Floor Price ETH",
		decimals: 18
	},
	{
		value: "0x986b5E1e1755e3C2440e960477f25201B0a8bbD4",
		address: "0x986b5E1e1755e3C2440e960477f25201B0a8bbD4",
		type: "Crypto (Stablecoin)",
		name: "USDC / ETH",
		symbol: "USDC / ETH",
		decimals: 18
	},
	{
		value: "0xe2F95bC12FE8a3C35684Be7586C39fD7c0E5b403",
		address: "0xe2F95bC12FE8a3C35684Be7586C39fD7c0E5b403",
		type: "Crypto (USD)",
		name: "HIGH / USD",
		symbol: "HIGH / USD",
		decimals: 8
	},
	{
		value: "0x214eD9Da11D2fbe465a6fc601a91E62EbEc1a0D6",
		address: "0x214eD9Da11D2fbe465a6fc601a91E62EbEc1a0D6",
		type: "Commodities",
		name: "XAU / USD",
		symbol: "XAU / USD",
		decimals: 8
	},
	{
		value: "0xC9CbF687f43176B302F03f5e58470b77D07c61c6",
		address: "0xC9CbF687f43176B302F03f5e58470b77D07c61c6",
		type: "Crypto (ETH)",
		name: "CVX / ETH",
		symbol: "CVX / ETH",
		decimals: 18
	},
	{
		value: "0x456834f736094Fb0AAD40a9BBc9D4a0f37818A54",
		address: "0x456834f736094Fb0AAD40a9BBc9D4a0f37818A54",
		type: "Crypto (USD)",
		name: "FOR / USD",
		symbol: "FOR / USD",
		decimals: 8
	},
	{
		value: "0xeF8A4aF35cd47424672E3C590aBD37FBB7A7759a",
		address: "0xeF8A4aF35cd47424672E3C590aBD37FBB7A7759a",
		type: "Forex",
		name: "CNY / USD",
		symbol: "CNY / USD",
		decimals: 8
	}
];

var getPairs = function getPairs(_ref) {
  var chainId = _ref.chainId;
  var pairsList = [];
  switch (chainId) {
    case '1':
      pairsList = ethereumPairsMainnet;
      break;
    case '5':
      pairsList = ethereumPairsGoerli;
      break;
    case '42161':
      pairsList = arbitrumPairsMainnet;
      break;
    case '421613':
      pairsList = arbitrumPairsGoerli;
      break;
    case '11155111':
      pairsList = [];
      break;
  }
  return pairsList;
};
// export const pairsGoerli = [
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     name: 'BTC/ETH',
//     decimals: 18,
//     value: '0x779877A7B0D9E8603169DdbD7836e478b4624789',
//     logoURI: 'https://prismic-io.s3.amazonaws.com/data-chain-link/19a58483-b100-4d09-ab0d-7d221a491090_BTC.svg',
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     name: 'BTC/USD',
//     decimals: 8,
//     value: '0xA39434A63A52E749F02807ae27335515BA4b07F7',
//     logoURI: 'https://prismic-io.s3.amazonaws.com/data-chain-link/19a58483-b100-4d09-ab0d-7d221a491090_BTC.svg',
//   },
//   {
//     category: 'Foreign Exchange',
//     name: 'CZK/USD',
//     decimals: 8,
//     value: '0xAE45DCb3eB59E27f05C170752B218C6174394Df8',
//   },
//   {
//     category: 'Stablecoins',
//     name: 'DAI/USD',
//     decimals: 8,
//     value: '0x0d79df66BE487753B02D015Fb622DED7f0E9798d',
//     logoURI: 'https://assets.coingecko.com/coins/images/9956/thumb/4943.png?1636636734',
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     name: 'ETH/USD',
//     decimals: 8,
//     value: '0xD4a33860578De61DBAbDc8BFdb98FD742fA7028e',
//     logoURI:
//       'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png',
//   },
//   {
//     category: 'Foreign Exchange',
//     name: 'EUR/USD',
//     decimals: 8,
//     value: '0x44390589104C9164407A0E0562a9DBe6C24A0E05',
//     logoURI: 'https://assets.coingecko.com/coins/images/9956/thumb/4943.png?1636636734',
//   },
//   {
//     category: 'Foreign Exchange',
//     name: 'GBP/USD',
//     decimals: 8,
//     value: '0x73D9c953DaaB1c829D01E1FC0bd92e28ECfB66DB',
//   },
//   {
//     category: 'Foreign Exchange',
//     name: 'JPY/USD',
//     decimals: 8,
//     value: '0x982B232303af1EFfB49939b81AD6866B2E4eeD0B',
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     name: 'LINK/ETH',
//     decimals: 18,
//     value: '0xb4c4a493AB6356497713A78FFA6c60FB53517c63',
//     logoURI: 'https://assets.coingecko.com/coins/images/877/thumb/chainlink-new-logo.png?1547034700',
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     name: 'LINK/USD',
//     decimals: 8,
//     value: '0x48731cF7e84dc94C5f84577882c14Be11a5B7456',
//     logoURI: 'https://assets.coingecko.com/coins/images/877/thumb/chainlink-new-logo.png?1547034700',
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     name: 'SNX/USD',
//     decimals: 8,
//     value: '0xdC5f59e61e51b90264b38F0202156F07956E2577',
//     logoURI: 'https://assets.coingecko.com/coins/images/3406/thumb/SNX.png?1598631139',
//   },
//   {
//     category: 'Stablecoins',
//     name: 'USDC/USD',
//     decimals: 8,
//     value: '0xAb5c49580294Aff77670F839ea425f5b78ab3Ae7',
//     logoURI: 'https://assets.coingecko.com/coins/images/6319/thumb/USD_Coin_icon.png?1547042389',
//   },
//   {
//     category: 'Commodities',
//     name: 'XAU/USD',
//     decimals: 18,
//     value: '0x7b219F57a8e9C7303204Af681e9fA69d17ef626f',
//   },
// ]
// export const pairsMainnet = [
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x37bC7498f4FF12C19678ee8fE19d713b87F6a9e6',
//     name: 'ETH / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/7e81db43-5e57-406d-91d9-6f2df24901ca_ETH.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xAe74faA92cB67A95ebCAB07358bC222e33A34dA7',
//     name: 'BTC / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/19a58483-b100-4d09-ab0d-7d221a491090_BTC.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xDfd03BfC3465107Ce570a0397b247F546a42D0fA',
//     name: 'LINK / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/ad14983c-eec5-448e-b04c-d1396e644596_LINK.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0xa964273552C1dBa201f5f000215F5BD5576e8f93',
//     name: 'USDT / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/ee56cf5d-74c7-4721-b2ea-8e7068bf8b0a_USDT.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0xDEc0a100eaD1fAa37407f0Edc76033426CF90b82',
//     name: 'DAI / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/3a06977b-5aa0-4a79-bb5e-767172fed456_DAI.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0x789190466E21a8b78b8027866CBBDc151542A26C',
//     name: 'USDC / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/8e2c6748-6f19-4981-817c-7763ef1d8bff_USDC.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0x158228e08C52F3e2211Ccbc8ec275FA93f6033FC',
//     name: 'DAI / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/3a06977b-5aa0-4a79-bb5e-767172fed456_DAI.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xbba12740DE905707251525477bAD74985DeC46D2',
//     name: 'LINK / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/ad14983c-eec5-448e-b04c-d1396e644596_LINK.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0xe5BbBdb2Bb953371841318E1Edfbf727447CeF2E',
//     name: 'USDC / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/8e2c6748-6f19-4981-817c-7763ef1d8bff_USDC.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0x7De0d6fce0C128395C488cb4Df667cdbfb35d7DE',
//     name: 'USDT / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/ee56cf5d-74c7-4721-b2ea-8e7068bf8b0a_USDT.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xC45eBD0F901bA6B2B8C7e70b717778f055eF5E6D',
//     name: 'BNB / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/4e0b88ab-d683-4678-92aa-496e003d1493_BNB.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xdF0da6B3d19E4427852F2112D0a963d8A158e9c7',
//     name: 'AAVE / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/4e29e655-070f-4c09-81e9-18fe8eed46e3_AAVE.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xe3f0dEdE4B499c07e12475087AB1A084b5F93bc0',
//     name: 'AAVE / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/4e29e655-070f-4c09-81e9-18fe8eed46e3_AAVE.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x68577f915131087199Fe48913d8b416b3984fd38',
//     name: 'UNI / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/c45e9a80-ecdd-4980-b9dc-1b393d64ee31_UNI.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x4B35F7854e1fd8291f4EC714aC3EBB1DeA450585',
//     name: 'MATIC / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/a75ede7c-c911-43b6-82d7-d35452a3ae3e_MATIC.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0x45bb69B89D60878d1e42522342fFCa9F2077dD84',
//     name: 'SUSD / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/fd2c0ca1-6045-4093-bde0-eb080b944ee2_SUSD.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0x9534df8F2C9289bbDB0c736E9FeF402B20f1828E',
//     name: 'TUSD / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/8ff7b68a-7ff5-48ab-9fca-de43c07c9b9f_TUSD.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x81076d6Ff2620Ea9Dd7bA9c1015f0d09A3A732E6',
//     name: 'BTC / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/19a58483-b100-4d09-ab0d-7d221a491090_BTC.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xbE4274DfB7801948e2cc2a913744e9498dDC8d20',
//     name: 'DOT / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/53abc2bf-a078-40d5-9f46-835968837ee4_DOT.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xFFC14A3B26708545BcCf8e915e2e8348123f5460',
//     name: 'MKR / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/cbe67773-3d4f-41fb-a06a-f9c179ea5c4e_MKR.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xBAFe3CB0E563E914806A99D547bdBF2Cfcf5fDF6',
//     name: 'SNX / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/a9f3abc1-9ce3-4e27-9265-dad0bc853189_SNX.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x8a4D74003870064d41D4f84940550911FBfCcF04',
//     name: 'YFI / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/7a1725e8-cbbf-4541-a39f-54a41c56bef9_YFI.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x6B39588D2FC7990CC81544DFd4674C909E9EFeea',
//     name: 'ZRX / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/8a4f2bba-f35f-46b4-b410-a6f09af92618_ZRX.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x821f24DAcA9Ad4910c1EdE316D2713fC923Da698',
//     name: 'BAT / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/8d1d96c9-d127-46da-a183-5b51bc43049e_BAT.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0x5952c7F1Ab270D22d677762Be3dAd0BA9e5cd23d',
//     name: 'BUSD / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/e9d75d1c-8a52-4109-8710-3dcab2431a4f_BUSD.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x6eaC850f531d0588c0114f1E93F843B78669E6d2',
//     name: 'COMP / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/91811f18-2c99-45b3-b586-0fb15a1cc407_COMP.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xB3B1882C0A7eB5097F12547bCD20Dc6FAE7aC8a6',
//     name: 'KNC / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/53a321f2-9130-4963-a16d-21ab045dcee3_KNC.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x46b77070f9256523c2F31c333b72C3E102f8A8A7',
//     name: 'MANA / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/3a8190f9-2eff-47f0-8f48-ac6468b908d9_MANA.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x33CCa8E7420114dB103d61bd39A72ff65E46352D',
//     name: 'DOGE / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/e3d836d6-593e-4a83-b3fb-4e6f080bf011_DOGE.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Foreign Exchange',
//     value: '0x02F878A94a1AE1B15705aCD65b5519A46fe3517e',
//     name: 'EUR / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/2877d82e-e7e0-40c2-aac9-0e4adf49acec_EUR.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x9405e02996Aa6f2176E2748EEfbCedd405870cee',
//     name: 'LRC / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/5974dfe5-0bb9-4025-9cbf-2c1bfb9fdc09_LRC.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x908EDc7E1974Ecab1cA7164424BC4Cac287D83Ad',
//     name: 'MKR / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/cbe67773-3d4f-41fb-a06a-f9c179ea5c4e_MKR.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x06ce8Be8729B6bA18dD3416E3C223a5d4DB5e755',
//     name: 'SNX / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/a9f3abc1-9ce3-4e27-9265-dad0bc853189_SNX.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xbd6C554554834ee97828B6DA732dCa7461DDf9d4',
//     name: 'SUSHI / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/a8e5dbdc-8a2e-4812-96ca-27c91d6535a7_SUSHI.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xd2bdD1E01fd2F8d7d42b209c111c7b32158b5a42',
//     name: '1INCH / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/e73bb4ca-698d-46a1-b14a-c1bbfad64707_1INCH.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xbC3C868763b7C15d0ce527af455041919E9c07B1',
//     name: 'ADA / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/c8123a90-e529-49a5-890b-f319bc2fac4a_ADA.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Foreign Exchange',
//     value: '0x7F7B323291C052De18926396176d384C4A8e19E2',
//     name: 'AUD / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/7bdb9930-38a3-4f49-9d91-4deaa8060bc1_AUD.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Foreign Exchange',
//     value: '0x549aE844Ab6B4a6Eb466F98dFFbc1FC9224e316d',
//     name: 'CAD / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/5cf2fe90-9b7e-4dc7-ac89-535a8d17e3bb_CAD.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x9D6acD34D481512586844fD65328BD358d306752',
//     name: 'COMP / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/91811f18-2c99-45b3-b586-0fb15a1cc407_COMP.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xb4c4a493AB6356497713A78FFA6c60FB53517c63',
//     name: 'CRV / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/5c406350-1db1-42eb-9ffe-d26f998f159e_ICON_CRV.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xDf30249744A419891f822ea4a9E80cd76d7Fbd23',
//     name: 'SOL / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/931ba23b-1755-46be-a466-73af2fcafaf1_ICON_SOL.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xd01BBB3Afed2cb5ca92Ca3834d441dc737F0Da70',
//     name: 'SUSHI / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/a8e5dbdc-8a2e-4812-96ca-27c91d6535a7_SUSHI.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Commodities',
//     value: '0xea5f70faa03f5C30B96029635C8d431d1A3cD1b8',
//     name: 'XAU / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/0e3500e4-44b4-4e00-84d8-04414f1c7d19_XAU.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x71c8D42d35eD9276543FCa95d80Ae0858553Bf44',
//     name: 'ALPHA / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/5ee466b4-713b-4fcd-9107-49ab41d8ea4d_ALPHA.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x2f2c0C1727Ce8C429A237DDFBBb87357893fBD5D',
//     name: 'BAL / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/79480093-f4cb-417c-a02d-9108bca6f752_BAL.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xd054be48Ae13A89a82744373f647A755dF7CaE17',
//     name: 'BCH / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/5d34a285-b051-465b-840e-ca1d4ee33d97_BCH.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x5667eE03110045510897aDa33DC561cEfCBcC904',
//     name: 'BOND / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/381ee9d9-755c-4add-8348-161055b02b7c_BOND.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Foreign Exchange',
//     value: '0x7C8719f3683585A242a67c73F6f3C98362004Da4',
//     name: 'CHF / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/641fc1a9-606e-4aff-a61b-83c40a2e5e2a_CHF.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0x1D244648d5a63618751d006886268Ae3550d0Dfd',
//     name: 'FEI / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/4bc92d69-45e8-49c1-8d5e-e53e376e4a6f_FEI.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x9d78092775DFE715dFe1b0d71aC1a4d6e3652559',
//     name: 'FXS / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/e2f88e60-0c62-4e2c-a8c4-17c78b72fba5_FXS.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Ethereum Gas',
//     value: '0x785433d8b06D77D68dF6be63944742130A4530d1',
//     name: 'Fast Gas / Gwei',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/872fc19c-63a5-4a53-be47-b399ea88570f_Fast+Gas.svg',
//     decimals: 0,
//   },
//   {
//     category: 'Foreign Exchange',
//     value: '0x568B8FD03992F56bF240958D22f5a6fcf7Bd850b',
//     name: 'GBP / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/4850e7d1-ed26-4063-8807-f57d4cb8896d_GBP.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x7a4297b2fd0Ba2F5687EFAC4df487B1C7B71392b',
//     name: 'HT / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/7ead4ad2-8041-46ee-b81b-58e6d2794894_HT.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Foreign Exchange',
//     value: '0x01A1F73b1f4726EB6EB189FFA5CBB91AF8E14025',
//     name: 'JPY / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/33350ae8-4a08-49e7-b0c7-d83cabc2dadb_JPY.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xbC60258F775683eA28048030806Ad3A80c4A33Ae',
//     name: 'KNC / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/53a321f2-9130-4963-a16d-21ab045dcee3_KNC.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xc1D1d0Da0fCf78157EA25D0E64e3BE679813a1F7',
//     name: 'UNI / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/c45e9a80-ecdd-4980-b9dc-1b393d64ee31_UNI.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Commodities',
//     value: '0xdEb43523E2857b7ec29D078c77b73709D958c62F',
//     name: 'XAG / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/fb3c3024-55a5-48a9-ac39-56cf4268ef12_XAG.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x4d839a486EC0B1C9b0D9e9D397993Ba5B150cB34',
//     name: 'XRP / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/58f6763e-c99f-45c0-b217-24155bd6e98b_XRP.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x0fC3657899693648bbA4dbd2d8b33b82E875105D',
//     name: 'AVAX / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/63137341-c4d1-4825-b284-b8a5a8436d15_ICON_AVAX.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x586524Ef790f7357c6cb8461b20d788Da14A636B',
//     name: 'BADGER / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/417888a2-3921-4317-9d0b-2888263d92ed_badger+dao+logo.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x82263275FBF3fa92c6eE81632725b6BFbE4B02Da',
//     name: 'BNT / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/31bf548c-a7af-4cad-8686-457bc5eba320_BNT.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Foreign Exchange',
//     value: '0xfe67209f6FE3BA6cE36d0941700085C194e958DF',
//     name: 'CNY / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/4e285f22-42b0-45f0-ac3f-e5b7027f2c82_CNY.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x7f67Ca2ce5299a67acd83D52A064C5b8e41dDb80',
//     name: 'CRV / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/e72e2be8-eb1b-4fd0-a936-71f09ca44c3a_CRV.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xdBd66e8D31F506e0cc8CB2f346De4C7FA3f655DE',
//     name: 'ENJ / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/2e05da00-7a64-46f5-865e-284c0b2d64fe_ENJ.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x0c7907d97B7F708Ecda1A0B3124D32cd8b1e3920',
//     name: 'ETC / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/2cd2cca0-3407-4887-a334-7b7bceb7ddda_ETC.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0x4bE991B4d560BBa8308110Ed1E0D7F8dA60ACf6A',
//     name: 'FEI / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/4bc92d69-45e8-49c1-8d5e-e53e376e4a6f_FEI.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0x61eB091ea16A32ea5B880d0b3D09d518c340D750',
//     name: 'FRAX / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/a7ef7e4d-df86-459d-9377-e53a9665794e_FRAX_icon.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xbDb80D19dEA36EB7f63bdFD2bdD4033B2b7e8e4d',
//     name: 'FTM / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/1d504edb-562f-4d00-8eba-858da9b21b20_FTM.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x2006d56F8DDB210ad009cf8d71aEe4F6488cFA49',
//     name: 'FTT / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/896956f8-f6bc-4abe-84f4-9b39dc7a68c9_ICON_FTT.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0x9c2C487DAd6C8e5bb49dC6908a29D95a234FaAd8',
//     name: 'GUSD / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/6c5483c4-6d4f-48e5-9f5d-0d321762b962_gemini-b.jpeg?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Foreign Exchange',
//     value: '0x86e345D4113E1105053A81240C75b56B437dA6Ef',
//     name: 'KRW / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/03a738a0-d3b6-48b7-9aba-2958e1d7523a_KRW.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x7898AcCC83587C3C55116c5230C17a6Cd9C71bad',
//     name: 'LDO / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/2c845f93-3578-4a97-a344-247afc231fd6_ICON_LDO.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xFe3d09D8bAd5DA65E0160cF0cB53F6115Fb6EA8b',
//     name: 'LTC / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/ef8bb9cc-f0fb-4e33-9d94-236f2e403bd2_LTC.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x751d87122c81f0eCe576338C400ebB978D039188',
//     name: 'MLN / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/cc4dfc44-de03-48a3-82de-5beb9a60c593_MLN.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Foreign Exchange',
//     value: '0xd48aA1699f49760611D6E1Af7a4588998deD42bD',
//     name: 'NZD / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/34d75e07-3bc7-47eb-a3f6-c177c558d2f2_ICON_NZD.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xC4aA0d2237A823f99fe2Dc74F993eEbDf5524489',
//     name: 'PERP / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/fabac42b-7ea4-49ee-91f9-bb964c73e0b3_PERP.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x8d6d808eC1f8803b54e2286BD6992f5601fCF3a8',
//     name: 'RAI / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/f48761d0-5fcb-42d0-9f4d-45d0badf15d6_RAI-logo-coin.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0x2Abfc56AaA39be7a946ec39aAC5d452e30614dF1',
//     name: 'RAI / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/5c8b96af-369c-41bf-ac64-ac0fd0b3c33e_RAI-logo-coin.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xEe34b3Ce92A6B635450B9cC6FAa976F70a106BE7',
//     name: 'REN / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/cef6d5bd-f2a2-4b0a-a13b-96e7a620d845_REN.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x68a371D12213a1EbDd5fa9a2EE5519E6B73F1E37',
//     name: 'UMA / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/8c9da9f6-b682-430d-bbbb-aae13eaba2a8_UMA.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x8034d486Fc2620F87A9C32a1fB746D20Ed9BFB96',
//     name: 'USDP / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/8006dd9d-fae7-4d31-8329-30778f145320_PAX.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xAa5aa80e416f9d32ffE6C390e24410d02D203F70',
//     name: 'YFI / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/7a1725e8-cbbf-4541-a39f-54a41c56bef9_YFI.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xb2F68c82479928669B0487D1dAeD6Ef47b63411e',
//     name: '1INCH / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/e73bb4ca-698d-46a1-b14a-c1bbfad64707_1INCH.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x910e014bBA427e9FCB48B4D314Dc81f840d7b6E3',
//     name: 'ADX / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/2044b631-2681-459d-9573-ef0cdf11a656_ADX.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x64a119DCf78E7E3FcED89c429f6F47Bf0cd80250',
//     name: 'ALCX / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/8e1cc615-2988-4051-81ea-62f64324e319_ALUSD_ICON.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xb92EE05E7514FfEDDDbcd76F5e3064691F6eC79e',
//     name: 'AMPL / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/73f43d04-e6f1-4b4d-bd7f-da552deb38b5_AMPL.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xd5090674b4653240cd94eE886484ca808c6E6694',
//     name: 'AMPL / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/73f43d04-e6f1-4b4d-bd7f-da552deb38b5_AMPL.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x7b14dF2fb3e02215Fa5525aC8A5abdAaA6314aC0',
//     name: 'ANT / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/81442fe6-83ce-4e7c-8324-ec9ef95cd69e_ANT.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x16423B2B6873225e26564b182b3318aFCdBFcade',
//     name: 'AXS / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/db5746fe-7a56-4475-bcb2-648d51c1653c_Axie+Infinity+.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'NFT Floor Price',
//     value: '0xF0c3668756b9d9590B334768640FC5ACA02aE739',
//     name: 'Azuki',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/06d5f793-d173-4a80-9212-7f3045c4662a_azuki+icon.avif?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x8093150EC164753994A1F65616E04Ae92a9Ef8c5',
//     name: 'BADGER / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/417888a2-3921-4317-9d0b-2888263d92ed_badger+dao+logo.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xbd9350a3a2fd6e3Ad0a053a567f2609a1bf6c505',
//     name: 'BAL / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/79480093-f4cb-417c-a02d-9108bca6f752_BAL.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xF9Bf9ca442e15c607b2d4b6Fe01f7fa59a016554',
//     name: 'BNB / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/4e0b88ab-d683-4678-92aa-496e003d1493_BNB.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x9A4458D02449eF9B42562205718679a8B4204962',
//     name: 'BNT / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/31bf548c-a7af-4cad-8686-457bc5eba320_BNT.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Foreign Exchange',
//     value: '0x0eBDc65E7e9132Cb41ac5cbD0101B799D7aDb475',
//     name: 'BRL / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/68de0df7-6921-44a2-be99-ce0dbaee65b1_ICON_BRL.svg',
//     decimals: 8,
//   },
//   {
//     category: 'NFT Floor Price',
//     value: '0x6DBD8100fBbfF754831Aa90A53c466d431651885',
//     name: 'Bored Ape Yacht Club',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/241f8701-b932-4221-817e-f5d270dfa7d3_BAYC+Icon.avif?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Proof of Reserve',
//     value: '0x6CeA38508B186DE36AAfd0f3B513E708691bc0C4',
//     name: 'CACHE Gold Reserves',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/98261c88-123d-4a34-b404-9cbf6f39a211_cachegold.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x1C026C25271c1bFbA95B65c848F734a23eA62D4e',
//     name: 'CAKE / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/76fb433c-1614-43e3-a7b1-835a244372f9_CAKE.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x720192921a4b6fb026fA52bf03F991b65b740147',
//     name: 'CTSI / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/83a2aebd-3de4-42b1-98da-ab5e15a3db7b_CTSI_ICON.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xf1F7F7BFCc5E9D6BB8D9617756beC06A5Cbe1a49',
//     name: 'CVX / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/86fbe4d4-083f-4209-9969-14d3308d8d99_convex.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'NFT Floor Price',
//     value: '0xB187B5A5A4B0A2Ae32FaEDf0FE4845203E0B7b11',
//     name: 'CloneX',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/606c1dab-8bb5-4205-b142-1df2c358eeb5_clonex+icon.jpeg?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'NFT Floor Price',
//     value: '0xaBd6dc0E14bdC628E62Cc946897C7fEfDCDdcD10',
//     name: 'Cool Cats',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/e0f6ea12-a6ff-4e9f-a7b0-a76412fe3efc_CoolCats+Icon.webp?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'NFT Floor Price',
//     value: '0xc609c4fADdA31980769c9C6716F438f0a6059547',
//     name: 'Cryptoadz',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/1e762137-6300-4328-94e1-a857b2203e48_cryptoadz+icon.jpeg?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'NFT Floor Price',
//     value: '0xF0c85c0F7dC37e1605a0Db446a2A0e33Df7a3358',
//     name: 'Cryptopunks',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/645b21ab-1d7e-49ec-bc22-b36df2d9a6be_Crypto+Punks+Icon.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x7002049FDCa829ED7082EFA03860b078aD4B5Efe',
//     name: 'DASH / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/4f6b3e78-81da-49be-8001-50f2c64d76de_DASH.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x3600713c848dE06c8346900E3deDd3CAc21c06ff',
//     name: 'DODO / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/9ac8c087-d08b-45be-ae10-a8c6e692958f_dodo.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'NFT Floor Price',
//     value: '0x440C8fc45C7f00E09c2F437b95FC123888a3d951',
//     name: 'Doodles',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/9b815783-23e3-49bb-b23d-02bda77f69b1_Screenshot+2022-12-14+at+3.09.16+PM.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xea7C55976844396f3bD4C89F66988b8b5Be5E96a',
//     name: 'EOS / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/008d2931-1bd2-47e9-a544-323c39124095_EOS.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (Other)',
//     value: '0x0f00392FcB466c0E4E4310d81b941e07B4d5a079',
//     name: 'ETH / BTC',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/f4e9d838-b8d2-474d-bbdb-06576a9ad6a1_ETHBTC3.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Proof of Reserve',
//     value: '0x14EAf768906587468f438755CfFb91227C14B8E5',
//     name: 'EURS Reserves',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/322b6a4e-e57e-4c43-b430-a9bdb49292ea_EURS.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x920E5DC12E7500c6571C63D4Bba19c62e99d6883',
//     name: 'EURt / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/ee56cf5d-74c7-4721-b2ea-8e7068bf8b0a_USDT.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x02E59cE2921e982A481c6ddb709B76C33397Eb14',
//     name: 'FOX / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/712b61ed-4299-4d9e-aa37-04f8df1f3571_FOX_Icon.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x56f98706C14DF5C290b02Cec491bB4c20834Bb51',
//     name: 'FRAX / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/18dca0a6-ac9c-4f1c-a8f3-36eedea394be_ICON_FRAX.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Proof of Reserve',
//     value: '0x0a0aba8efAB65fDD3fa7e6afcb8128bCd6ffbdBF',
//     name: 'GBPT PoR',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/743b65a7-eba4-47e6-acd1-e59568c39bfd_poundtoken.jpg?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x299e74895b4De8dF505C43146D0555983859034B',
//     name: 'GNO / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/83faccae-6dce-4abf-bffc-298682017349_GNO.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0x6a805f2580b8D75d40331c26C074c2c42961E7F2',
//     name: 'GUSD / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/9802da94-f52d-434e-8341-687527032523_gemini-dollar-gusd.webp?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Proof of Reserve',
//     value: '0x6aa553CB870a54BD62bb54E11f0B2c919925E726',
//     name: 'HBTC PoR',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/9ba54518-fee1-492a-ac20-27f07ac67b2e_HBTC.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xc1F2929b9449Ef97c5A75fd10fD0542984422f8b',
//     name: 'ILV / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/09257765-667c-411e-8b75-9ec9fb73aef7_ILLUVIUM.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x1a4E4B344125E7ef78de22b55FCeF5a4bc45f605',
//     name: 'INJ / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/38997e1d-9837-49de-893d-b4e3360040c2_INJ.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0x18f0112E30769961AF90FDEe0D1c6B27E6d72D92',
//     name: 'MIM / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/95553c63-d777-457a-be01-1f302ca94d47_M+I+M.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'NFT Floor Price',
//     value: '0xb17Eac46CF1B9C5fe2F707c8A47AFc4d208b3E83',
//     name: 'Mutant Ape Yacht Club',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/8020105d-d5ee-4100-8dc9-0fb475df5f02_MAYC+icon.avif?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xd9701835dC47837B53D5Cfe95eB5a66f42B56901',
//     name: 'NEAR / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/fdbd955f-309f-413b-bec1-93db80fd97d5_ICON_NEAR.webp?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x861334DEC28b3ba71DFFb1ABf4E57D4AD3964b5f',
//     name: 'NMR / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/94588bb8-97f1-4372-9242-13af67bcde09_NMR.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xe4E345594375B54F395B54C41bD8b370A302bf69',
//     name: 'NMR / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/94588bb8-97f1-4372-9242-13af67bcde09_NMR.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x51aa283a37771B33101e88658C440951ee0AE02d',
//     name: 'OGN / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/e2613e69-8e25-4d38-b81e-5f13fa8a74de_OGN.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x34B41725Cf934866A4b89d65395F15af2Cb9aE89',
//     name: 'OMG / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/a6b5c35c-5049-4df4-b84e-fef084765798_OMG.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x8B1668905367a2EFB610e7aA1DC6F4F26d1f7268',
//     name: 'ONT / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/0f3d0cf3-eddf-4a8c-8839-ed5d02f75510_ONT_blue.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x782EE2B86316d04F226Ba416d5dF5358a2D6102f',
//     name: 'ORN / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/4ebae2be-36ab-4e6f-ac9f-6fdd3bb13a80_ORN.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x932354AeA65a17B265bf22D29f7132ECfE86747d',
//     name: 'OXT / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/48323e53-b3c8-4b8a-8bf7-a708577952c5_OXT.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x66d35ccD808317870198793a96b88ab69dCAe53B',
//     name: 'PAXG / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/40392eaf-9bb5-4dd9-9449-e4d9674cbc9f_PAXG.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Proof of Reserve',
//     value: '0xC84E8CF8C30775d4639364C759fd0aBDb941Db9C',
//     name: 'PAXG Reserves',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/40392eaf-9bb5-4dd9-9449-e4d9674cbc9f_PAXG.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x3d0bB55D0D2F255d7A0EAb8A53a91b3369728E36',
//     name: 'REN / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/cef6d5bd-f2a2-4b0a-a13b-96e7a620d845_REN.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xd7Fc11b34D7BaE2E94B958C4ab06D950f0bD4C3E',
//     name: 'RLC / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/db7c1288-eddc-46ec-b602-4a0c09060f1a_RLC.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xDF627aa5B9C024818c6950fDAD7e4C16D93b10Ca',
//     name: 'SAND / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/9a0dc3ab-1340-4c8d-b204-4fb433df3064_ICON_SAND.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x070f15084600Aceace6D639CDDd0e341975D1e30',
//     name: 'SPELL / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/3b8c95ff-9b97-429a-9df9-23848c816f33_SPELL.jpeg?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xCFC1C64e721bC034ab894302B78149b3C7a1066d',
//     name: 'SXP / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/b605ec68-8b1b-4d1f-9903-41660f05df01_SXP.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x20086D92838C475fc3aDE8B745EfB33213793080',
//     name: 'TOMO / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/02002255-0f72-4e3e-8868-531b6ab08453_TOMO.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xc1D757bee6BCDD45093979bFE60d341B833B2dB0',
//     name: 'TRIBE / ETH',
//     logoURI:
//       'https://data-chain-link.cdn.prismic.io/data-chain-link/67213399-aa29-4c39-9792-2f86a32c7e1c_tribe-token-v1-32.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xAbA1EACE8627c15324890315E942A4FBD73b70E0',
//     name: 'TRU / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/581f4500-b7ee-4a47-aa6e-fab8150a93fa_TRU.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Proof of Reserve',
//     value: '0xAC099D59755982757537F13c7c4Ae8c8d9F030B9',
//     name: 'TUSD Reserves',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/6c70d784-e9b7-4a0b-9fc0-1c3a283066e1_TUSD.avif?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Indexes',
//     value: '0x9257D83A0DdA413cA24F66dD32A056Bc2eBAFd2e',
//     name: 'Total Marketcap / USD',
//     logoURI:
//       'https://data-chain-link.cdn.prismic.io/data-chain-link/b8242e45-207e-4e0b-adfe-d563d56fafd3_Total+Marketcap.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Proof of Reserve',
//     value: '0xE7b27118b92d3a23afEa153953FeD8853dbFa8FA',
//     name: 'USDP Reserves',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/781fa6a4-9b85-4b02-a275-ae4d0407a912_paxos-usdp-logo.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'NFT Floor Price',
//     value: '0xe0552DC960366F67Da00CB3d9DF441F24B5C2AC1',
//     name: 'VeeFriends',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/a2fde52e-b8f9-46a4-a98c-708e61619502_VeeFriends+Icon.avif?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Proof of Reserve',
//     value: '0xB622b7D6d9131cF6A1230EBa91E5da58dbea6F59',
//     name: 'WBTC PoR',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/2817feda-4cfe-4988-b0d8-2b37ecfbc0de_WBTC.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xc29d104A418a08407f9f2CDb614c1CDCf82986e0',
//     name: 'WING / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/31f9d33e-be79-4bdd-99c4-03008f8f0a68_WING.svg',
//     decimals: 8,
//   },
//   {
//     category: 'NFT Floor Price',
//     value: '0x45B68d24Df514BF13a838d88bE4363F8011719de',
//     name: 'World of Women',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/18a8d3a3-e481-4c26-adec-6898ecff6169_World+of+Women+Icon.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xD6A3a9Bb4bd49DdB2374CA58Edf47a8bB63Af3d2',
//     name: 'XCN / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/129a6763-f720-48f8-aa22-ac9ae19e2b3e_Chain.jpg?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xf09828103D306f50aF7e3132adb6DeF77c6d96f7',
//     name: 'XMR / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/f8ece53a-081f-4115-b623-0e3748cd01c8_XMR.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x3d47eF9690Bd00C77c568b73140dC20F34453766',
//     name: 'ZRX / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/8a4f2bba-f35f-46b4-b410-a6f09af92618_ZRX.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xd74FF3f1b565597E59D44320F53a5C5c8BA85f7b',
//     name: 'cbETH / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/575602f6-27bf-4cdb-8b98-f491ea1e9523_cbeth.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Proof of Reserve',
//     value: '0xD423C9A9AD8c21C97bdeE2E74F8098625aa4f329',
//     name: 'eFIL Reserves',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/140e34cd-6781-4853-a16d-c675fa04b952_FIL.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0x1187272A0E3A603eC4734CeC73a0880055eCC593',
//     name: 'sUSD / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/f4ea7419-e029-4830-acff-1b721ad98ddb_ICON_SUSD.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (Other)',
//     value: '0xD7623f1d24b35c392862fB67C9716564A117C9DE',
//     name: 'wBTC / BTC',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/2817feda-4cfe-4988-b0d8-2b37ecfbc0de_WBTC.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xb49322fF269d67A5aF0718C19463eC9EE7BF821E',
//     name: 'ALCX / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/f6ed5043-ee67-4aad-b061-caec9f4cf172_alcx.jpeg?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xBbC9Ab3F66d0b934089FdCceda3615a6bb879633',
//     name: 'ANKR / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/3002608b-95b8-4c66-84f9-fa11a65dd51f_ICON_ANKR.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xa99999b1475F24037e8b6947aBBC7710676E77dd',
//     name: 'APE / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/9417affb-45de-4376-a4d7-11be0b4f7b3f_apecoin.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xDF9F750A94bF2Faea84Ab783927290FE5e0F7606',
//     name: 'BAND / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/250ff313-b2e4-457e-9954-d2abc1f82667_BAND.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x382db44bCfb92C398b93e5fF6Cc100FC321140c9',
//     name: 'BIT / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/6c8e3c27-f0f7-4df4-b844-3e14a75401fe_BitDAO.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0x73dc1b226f7DfAc353bdB41A27C4212213e6aF07',
//     name: 'BUSD / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/5ccdec2d-7063-4eb8-9fcb-58c99e7be005_ICON_BUSD.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xd0BB178dEdC71470BA68380CBd99c4A963d01507',
//     name: 'CEL / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/1de02a40-448e-4c67-9e6c-03bac68b817a_celsius_tn.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xb2aD164c008Da54FCEaC79Ef18C0a8fE2d935865',
//     name: 'CRO / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/d4f6f85b-50c6-4b75-8470-ec35fd2a6737_ICON_CRO.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x30F3037f0E13d6bdeD3c5B7809994F47e9656b4a',
//     name: 'CSPR / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/3bd353fb-1c17-4105-902b-24c2df82b330_CASPER.jpeg?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x8d73Ac44Bf11CadCDc050BB2BcCaE8c519555f1a',
//     name: 'CVX - USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/86fbe4d4-083f-4209-9969-14d3308d8d99_convex.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xCBbe4ff0d8add07CCe71afC0CcdF3492b8eaA76A',
//     name: 'ENJ / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/07b36b85-2bd3-42de-8889-353d3d44587d_Enjin.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x9965AD91B4877d29c246445011Ce370b3890C5C2',
//     name: 'FIL / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/140e34cd-6781-4853-a16d-c675fa04b952_FIL.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x3C640c857f1fF57ff4E24CfF1924F14A9bB9F2Ad',
//     name: 'FLOW / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/e1b6578d-015c-46a7-886c-b3baf941ae63_ICON_FLOW.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xf649bC5C0e99BDEb06702e3db242B9F93DE44462',
//     name: 'FOR / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/e9415a79-530f-4a64-9c52-3a593b21cade_Fortube.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xe2d6D8e799Df0a377FD14Ee18b95fd7cAa389017',
//     name: 'FORTH / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/ad43fd4e-6c5a-4054-a11f-6429c3267e1f_forth.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x75d22BEabc2365E039Cf3c6D9a9fFF925e7204d4',
//     name: 'FTT / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/896956f8-f6bc-4abe-84f4-9b39dc7a68c9_ICON_FTT.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x7531f77095Bed9d63cB3E9EA305111a7DCE969A2',
//     name: 'GRT / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/a29cf3e9-cd84-4c40-af40-802e89b23a7d_GRT.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x0F486F358b3D04AeA6800eFa260e01286d8A50F1',
//     name: 'HBAR / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/4fed0709-4a48-44a6-bdd6-3412bb47fb38_ICON_HBAR.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xeA23780dc14d1aC9eb3AB203A9bb7C1A6660615E',
//     name: 'HIGH / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/c5ac3226-2936-4395-8094-d39d7075df51_highstreet.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x3f00247Dc3bc14A8dCfA682318Ce566b1f34343A',
//     name: 'IMX / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/6a79969d-33be-4974-969b-c42827b49e2b_imx+immutable+x.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x61B5793cd5f454D2B25bA1AcB5C1aA1728f67E1c',
//     name: 'KP3R / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/e6617302-94c2-47ea-962c-0470107aa424_ICON_KP3R.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x630163B84674B2B404fB6036A510574F259c5Cb7',
//     name: 'KSM / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/523309ab-7c8b-4e4a-a468-b200c1804dba_ICON_KSM.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xB82A0803DF982412dAeE9D82826395E3F0BeD1A2',
//     name: 'LON / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/8f553f66-7569-4776-b9fb-79260a919c4a_ICON_LON.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x7Be21AeF96E2FAeB8Dc0d07306814319cA034cad',
//     name: 'MANA / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/3a8190f9-2eff-47f0-8f48-ac6468b908d9_MANA.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x4b75FE6e4a53A510AbC39c7328B0b06E74a3F624',
//     name: 'OCEAN / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/aa6840fe-86c6-4ca4-95f0-ea03eba95808_OCEAN.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x9Aae856973A0Cafa084b82F7BC4C6C2893A9139b',
//     name: 'OHMv2/ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/d625b35b-83c2-4618-8809-dbc8ae17e8ff_OHM.webp?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xA1b2e83815723e4e4BBF437E56f65b6AAFd5754b',
//     name: 'OMG / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/a6b5c35c-5049-4df4-b84e-fef084765798_OMG.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xCB00334A422FC8538794f3CE0149540a95f9e228',
//     name: 'PHALA / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/c4503375-7e0c-4fb8-9224-e9d01370a192_PHALA.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x10341666434880065495f5b3C69621CcAc43bc82',
//     name: 'PLA / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/4b1e0ba2-e7a2-42c4-a3dc-2c0b8ecc8d6f_playdapp.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Indexes',
//     value: '0x5a0efD6D1a058A46D3Ac4511861adB8F3540BD49',
//     name: 'Personal Consumption Expenditures (PCE) US Monthly Index',
//     logoURI: '',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x25C32A551C188Cb88a7067c254905191e83C712C',
//     name: 'RARI / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/20590299-c631-4f00-9bcd-73c4d451db3a_ICON_RARI.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xA27CfD69345a6e121284a3C0ae07BB64b707cDD2',
//     name: 'RSR / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/deaf5531-5324-47f6-9c3d-8f45c9ed9c88_Reserve+Rights.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xa8156eFf735Dce35Eb01B119F6a7f4B55944184a',
//     name: 'RUNE / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/db3655f7-7530-47d3-95d6-3997c85ff83b_RUNE.svg',
//     decimals: 18,
//   },
//   {
//     category: 'Foreign Exchange',
//     value: '0xc96129C796F03bb21AC947EfC5329CD1F560305B',
//     name: 'SGD / USD',
//     logoURI:
//       'https://data-chain-link.cdn.prismic.io/data-chain-link/3cf5ab5f-a521-4567-aed7-d76464e21d06_ICON_SGD2.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Foreign Exchange',
//     value: '0xadcD1B19a0190E18d961993c5671d3F5D47c13Ea',
//     name: 'TRY / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/7fd1fffc-6f02-4b50-a676-f3701200eeaf_ICON_TRY.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0x98953e9C76573e06ec265Bdde1dbB89fa02d56d3',
//     name: 'TUSD / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/8ff7b68a-7ff5-48ab-9fca-de43c07c9b9f_TUSD.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xF0aaD281faE14Fe35eE30074D881863c0CdD5B03',
//     name: 'UMEE / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/20726231-07e6-4559-a7d9-6a2cbabe9283_umee.jpeg?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Proof of Reserve',
//     value: '0x646d61986f45DEeC2477a3a355EdBA60B4C16D6B',
//     name: 'US+ PoR (Fluent Finance)',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/e1d77167-d979-42b8-9682-c5fa7a418fb8_New-Fluent-Logo-%5BIsotype-Color%5D.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0xAe395258FbcE63ecEeB2Cc0B73D4875797F4598d',
//     name: 'USDK / USD',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/cf663715-a6ba-4d27-be38-c76e22d30231_ICON_USDK.png?auto=compress,format',
//     decimals: 8,
//   },
//   {
//     category: 'Stablecoins',
//     value: '0xF3d70857B489Ecc6768D0982B773E1Cba9E1f00b',
//     name: 'USDP / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/8006dd9d-fae7-4d31-8329-30778f145320_PAX.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xbd624B453d0a882B87Cbf85FeBdcf493cFFBd8D9',
//     name: 'WMXN / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/c7a75e6c-06f6-4792-ba49-5979dbccbb15_ICON_WNXM.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Commodities',
//     value: '0x0dEaf87519D434DCF74551B2E907aF18D2304946',
//     name: 'WTI / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/edb38688-e23c-4705-8a48-82cc3c8945e6_ICON_WTI.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (USD pairs)',
//     value: '0xAB5041D720ab0CDB3342F5bC7Ac6Cc14B6c70727',
//     name: 'XSUSHI / USD',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/a8e5dbdc-8a2e-4812-96ca-27c91d6535a7_SUSHI.svg',
//     decimals: 8,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x20dF77bB4cE1478e89a7461CAcE8dc016f9198e4',
//     name: 'YFII / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/14fcd0d1-0360-4dc2-b19b-201bf271b895_ICON_YFII.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0x716BB759A5f6faCdfF91F0AfB613133d510e1573',
//     name: 'stETH / ETH',
//     logoURI:
//       'https://images.prismic.io/data-chain-link/d6bdb6d1-4ff7-4084-ba46-a3cc08f65bf9_stETH_icon.png?auto=compress,format',
//     decimals: 18,
//   },
//   {
//     category: 'Cryptocurrency (ETH pairs)',
//     value: '0xdEaa4288c85e7e0be40BCE49E76D4e321d20fC36',
//     name: 'xSush / ETH',
//     logoURI: 'https://data-chain-link.cdn.prismic.io/data-chain-link/a8e5dbdc-8a2e-4812-96ca-27c91d6535a7_SUSHI.svg',
//     decimals: 18,
//   },
// ]

var DataFeedDecimals = createPlugin({
  protocol: 'CHAINLINK',
  type: 'ORACLE',
  method: 'decimals',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'chainlink_datafeed',
          options: getPairs({
            chainId: chainId
          })
        }),
        methodParams: {}
      },
      output: {
        decimals: new FctDecimals({
          innerIndex: 0
        })
      }
    };
  }
});

var LatestRoundData = createPlugin({
  protocol: 'CHAINLINK',
  type: 'ORACLE',
  method: 'latestRoundData',
  name: 'priceFeeds',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'chainlink_datafeed',
          options: getPairs({
            chainId: chainId
          })
        }),
        methodParams: {}
      },
      output: {
        roundId: new FctUInt80({
          innerIndex: 0
        }),
        price: new FctInt256({
          innerIndex: 1,
          destination: 'wei_amount'
        }),
        startedAt: new FctTimestamp({
          innerIndex: 2
        }),
        updatedAt: new FctTimestamp({
          innerIndex: 3
        }),
        answeredInRound: new FctUInt80({
          innerIndex: 4
        })
      }
    };
  }
});

var ChainLink = {
  getters: {
    DataFeedDecimals: DataFeedDecimals,
    LatestRoundData: LatestRoundData
  }
};

function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$i(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var compoundTokens = cTokens.map(function (token) {
  return _objectSpread$i(_objectSpread$i({}, token), {}, {
    value: token.address
  });
});
var isNative = function isNative(address, chainId) {
  if (chainId === '1') return address.toLowerCase() === '0x4Ddc2D193948926D02f9B1fE9e1daa0718270ED5'.toLowerCase();
  return address.toLowerCase() === '0x20572e4c090f15667cF7378e16FaD2eA0e2f3EfF'.toLowerCase();
};
var getCompoundPluginAddressesInput = function getCompoundPluginAddressesInput(_ref) {
  var chainId = _ref.chainId;
  var tokens = {};
  var labels = [];
  var chainTokens = compoundTokens.filter(function (token) {
    return token.chainId === Number(chainId);
  });
  chainTokens.forEach(function (token, index) {
    var address = index > 0 ? new FctAddress({
      required: false,
      hidden: true,
      destination: 'erc20',
      options: chainTokens
    }) : new FctAddress({
      destination: 'erc20',
      options: chainTokens
    });
    tokens["address".concat(index + 1)] = address;
    labels.push("address".concat(index + 1));
  });
  return {
    tokens: tokens,
    labels: labels
  };
};

/* eslint-disable no-restricted-imports */
var Borrow$1 = createPlugin({
  protocol: 'COMPOUND_V2',
  type: 'ACTION',
  method: 'borrow',
  description: 'Borrow ETH or ERC20 tokens',
  supportedContracts: cTokens,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'ctoken',
          options: compoundTokens.filter(function (token) {
            return token.chainId === Number(chainId);
          })
        }),
        methodParams: {
          borrowAmount: new FctValue({
            destination: 'wei_amount'
          })
        }
      },
      output: {
        result: new FctValue({
          innerIndex: 0
        })
      }
    };
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var _compoundTokens$find;
    var to = params.to,
      borrowAmount = params.methodParams.borrowAmount;
    if (!borrowAmount.value || !to.value || !vaultAddress) return [];
    if (typeof borrowAmount.value !== 'string' || typeof to.value !== 'string') return [];

    // Find asset from cToken address
    var asset = (to === null || to === void 0 ? void 0 : to.value) && ((_compoundTokens$find = compoundTokens.find(function (token) {
      return token.address === to.value;
    })) === null || _compoundTokens$find === void 0 ? void 0 : _compoundTokens$find.assetAddress);
    if (!asset) return [];
    return [{
      address: vaultAddress,
      toSpend: [],
      toReceive: [{
        token: asset,
        amount: borrowAmount.value
      }]
    }, {
      address: to.value,
      toSpend: [{
        token: asset,
        amount: borrowAmount.value
      }],
      toReceive: []
    }];
  }
});

function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$h(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ClaimCOMP = createPlugin({
  protocol: 'COMPOUND_V2',
  type: 'ACTION',
  method: 'claimComp',
  description: 'Borrow ETH or ERC20 tokens',
  supportedContracts: [{
    chainId: 1,
    address: '0x3d9819210A31b4961b30EF54bE2aeD79B9c9Cd3B'
  }, {
    chainId: 5,
    address: '0x3cBe63aAcF6A064D32072a630A3eab7545C54d78'
  }],
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: _objectSpread$h(_objectSpread$h({
        to: new FctAddress({
          destination: 'comptroller'
        })
      }, getCompoundPluginAddressesInput({
        chainId: chainId
      }).tokens), {}, {
        methodParams: {
          holder: new FctAddress({}),
          cTokens: new FctAddressList({
            required: false
          })
        }
      }),
      output: {}
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref2) {
    var input = _ref2.input,
      chainId = _ref2.chainId;
    var chainTokens = compoundTokens.filter(function (token) {
      return token.chainId === Number(chainId);
    });
    var getParamsAsync = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var cTokens, tokensHash;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cTokens = [];
              tokensHash = new Set();
              chainTokens.forEach(function (_token, index) {
                var tokenLabel = "address".concat(index + 1);
                var nexTokenLabel = "address".concat(index + 2);
                if (!input[tokenLabel]) return;
                if (!input[tokenLabel].value) {
                  if (!input[nexTokenLabel]) return;
                  if (!input[nexTokenLabel].value) {
                    input[nexTokenLabel].hidden = true;
                    return;
                  }
                  input[tokenLabel].value = input[nexTokenLabel].value;
                  input[nexTokenLabel].value = undefined;
                  return;
                }
                cTokens.push(input[tokenLabel].value);
                tokensHash.add(input[tokenLabel].value);
                if (!input[nexTokenLabel]) return;
                input[nexTokenLabel].options = chainTokens.filter(function (token) {
                  return !tokensHash.has(token.value);
                });
                input[nexTokenLabel].hidden = false;
              });
              return _context.abrupt("return", {
                params: {
                  methodParams: {
                    cTokens: cTokens
                  }
                },
                error: undefined
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getParamsAsync() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      get: getParamsAsync,
      depParamKeys: getCompoundPluginAddressesInput({
        chainId: chainId
      }).labels
    };
  }
  // TODO: How to calculate the assetFlow before it is executed?
});

function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$g(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var EnterMarkets = createPlugin({
  protocol: 'COMPOUND_V2',
  type: 'ACTION',
  method: 'enterMarkets',
  description: 'Borrow ETH or ERC20 tokens',
  supportedContracts: [{
    chainId: 1,
    address: '0x3d9819210A31b4961b30EF54bE2aeD79B9c9Cd3B'
  }, {
    chainId: 5,
    address: '0x3cBe63aAcF6A064D32072a630A3eab7545C54d78'
  }],
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: _objectSpread$g(_objectSpread$g({
        to: new FctAddress({
          destination: 'comptroller'
        })
      }, getCompoundPluginAddressesInput({
        chainId: chainId
      }).tokens), {}, {
        methodParams: {
          cTokens: new FctAddressList({
            readonly: true
          })
        }
      }),
      output: {}
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref2) {
    var input = _ref2.input,
      chainId = _ref2.chainId;
    var chainTokens = compoundTokens.filter(function (token) {
      return token.chainId === Number(chainId);
    });
    var getParamsAsync = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var cTokens, tokensHash;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cTokens = [];
              tokensHash = new Set();
              chainTokens.forEach(function (_token, index) {
                var tokenLabel = "address".concat(index + 1);
                var nexTokenLabel = "address".concat(index + 2);
                if (!input[tokenLabel]) return;
                if (!input[tokenLabel].value) {
                  if (!input[nexTokenLabel]) return;
                  if (!input[nexTokenLabel].value) {
                    input[nexTokenLabel].hidden = true;
                    return;
                  }
                  input[tokenLabel].value = input[nexTokenLabel].value;
                  input[nexTokenLabel].value = undefined;
                  return;
                }
                cTokens.push(input[tokenLabel].value);
                tokensHash.add(input[tokenLabel].value);
                if (!input[nexTokenLabel]) return;
                input[nexTokenLabel].options = chainTokens.filter(function (token) {
                  return !tokensHash.has(token.value);
                });
                input[nexTokenLabel].hidden = false;
              });
              return _context.abrupt("return", {
                params: {
                  methodParams: {
                    cTokens: cTokens
                  }
                },
                error: undefined
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getParamsAsync() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      get: getParamsAsync,
      depParamKeys: getCompoundPluginAddressesInput({
        chainId: chainId
      }).labels
    };
  }
});

/* eslint-disable no-restricted-imports */
var ExitMarket = createPlugin({
  protocol: 'COMPOUND_V2',
  type: 'ACTION',
  method: 'exitMarket',
  description: 'Borrow ETH or ERC20 tokens',
  supportedContracts: [{
    chainId: 1,
    address: '0x3d9819210A31b4961b30EF54bE2aeD79B9c9Cd3B'
  }, {
    chainId: 5,
    address: '0x3cBe63aAcF6A064D32072a630A3eab7545C54d78'
  }],
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'comptroller'
        }),
        methodParams: {
          cToken: new FctAddress({
            destination: 'ctoken',
            options: compoundTokens.filter(function (token) {
              return token.chainId === Number(chainId);
            })
          })
        }
      },
      output: {}
    };
  },
  initParams: {
    to: '0x3d9819210A31b4961b30EF54bE2aeD79B9c9Cd3B'
  }
});

var Mint = createPlugin({
  protocol: 'COMPOUND_V2',
  type: 'ACTION',
  method: 'mint',
  name: 'mint',
  description: 'Mint cTokens',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'ctoken',
          options: compoundTokens.filter(function (token) {
            return token.chainId === Number(chainId);
          })
        }),
        payToken: new FctAddress({
          destination: 'erc20',
          readonly: true
        }),
        value: new FctValue({
          destination: 'wei_amount',
          required: false,
          readonly: true
        }),
        amount: new FctValue({
          destination: 'wei_amount'
        }),
        methodParams: {
          mintAmount: new FctValue({
            destination: 'wei_amount',
            required: false,
            readonly: true
          })
        }
      },
      output: {}
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref2) {
    var input = _ref2.input,
      chainId = _ref2.chainId,
      provider = _ref2.provider;
    var getParamsAsync = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _cTokens$find;
        var to, value, amount, payToken, methodParams, underlyingToken, tokenContract, symbol, decimals;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              to = input.to, value = input.value, amount = input.amount, payToken = input.payToken, methodParams = input.methodParams;
              if (!(!to.value || to.isVariable)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  value: undefined,
                  payToken: undefined,
                  methodParams: {
                    mintAmount: undefined
                  }
                },
                error: undefined
              });
            case 3:
              if (!isNative(to.value, chainId)) {
                _context.next = 15;
                break;
              }
              value.value = amount.value;
              methodParams.mintAmount.value = undefined;
              methodParams.mintAmount.virtual = true;
              methodParams.mintAmount.required = false;
              value.required = true;
              amount.label = 'ETH Amount';
              amount.decimals = 18;
              payToken.label = 'ETH';
              payToken.decimals = 18;
              payToken.value = ZERO_ADDRESS$1;
              return _context.abrupt("return", {
                params: {
                  value: amount.value,
                  payToken: ZERO_ADDRESS$1
                },
                error: undefined
              });
            case 15:
              underlyingToken = (_cTokens$find = cTokens.find(function (cToken) {
                if (typeof to.value === 'string' && cToken.address.toLowerCase() === to.value.toLowerCase()) return true;
                return false;
              })) === null || _cTokens$find === void 0 ? void 0 : _cTokens$find.assetAddress;
              if (!underlyingToken) {
                _context.next = 35;
                break;
              }
              tokenContract = new ethers.Contract(underlyingToken, ['function decimals() view returns (uint8 decimals)', 'function symbol() view returns (string symbol)'], provider);
              _context.next = 20;
              return tokenContract.symbol();
            case 20:
              symbol = _context.sent;
              _context.next = 23;
              return tokenContract.decimals();
            case 23:
              decimals = _context.sent;
              _context.t0 = "";
              _context.next = 27;
              return tokenContract.symbol();
            case 27:
              _context.t1 = _context.sent;
              amount.label = _context.t0.concat.call(_context.t0, _context.t1, " Amount");
              _context.next = 31;
              return tokenContract.decimals();
            case 31:
              amount.decimals = _context.sent;
              payToken.label = symbol;
              payToken.decimals = decimals;
              payToken.value = underlyingToken;
            case 35:
              methodParams.mintAmount.required = true;
              value.required = false;
              value.value = '0';
              methodParams.mintAmount.value = amount.value;
              methodParams.mintAmount.virtual = false;
              return _context.abrupt("return", {
                params: {
                  value: undefined,
                  payToken: underlyingToken,
                  methodParams: {
                    mintAmount: amount.value
                  }
                },
                error: undefined
              });
            case 41:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getParamsAsync() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      get: getParamsAsync,
      depParamKeys: ['to', 'amount']
    };
  },
  requiredApprovals: function requiredApprovals(params, chainId) {
    var _cTokens$find2;
    if (!params.to.value) return [];
    if (isNative(params.to.value, chainId)) return [];
    var underlyingToken = (_cTokens$find2 = cTokens.find(function (cToken) {
      if (typeof (params === null || params === void 0 ? void 0 : params.to.value) === 'string' && cToken.address.toLowerCase() === (params === null || params === void 0 ? void 0 : params.to.value.toLowerCase())) return true;
      return false;
    })) === null || _cTokens$find2 === void 0 ? void 0 : _cTokens$find2.assetAddress;
    return [{
      to: underlyingToken,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params.methodParams.mintAmount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _compoundTokens$find;
      var to, amount, asset, cToken, exchangeRate, cTokens;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            to = params.to, amount = params.amount;
            if (!(!to.value || !amount.value || !vaultAddress)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return", []);
          case 3:
            if (!(typeof to.value !== 'string' || typeof amount.value !== 'string')) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return", []);
          case 5:
            // Find asset from cToken address
            asset = (to === null || to === void 0 ? void 0 : to.value) && (((_compoundTokens$find = compoundTokens.find(function (token) {
              return token.address === to.value;
            })) === null || _compoundTokens$find === void 0 ? void 0 : _compoundTokens$find.assetAddress) || ethers.constants.AddressZero);
            if (asset) {
              _context2.next = 8;
              break;
            }
            return _context2.abrupt("return", []);
          case 8:
            // TODO: cToken amount needs to be calculated off chain.
            cToken = new ethers.Contract(to.value, ['function exchangeRateStored() view returns (uint256 exchangeRate)', 'function reserveFactorMantissa() view returns (uint256)'], new ethers.providers.JsonRpcProvider());
            _context2.next = 11;
            return cToken.exchangeRateStored();
          case 11:
            exchangeRate = _context2.sent;
            // 232198806587247
            cTokens = BigInt(amount.value) * BigInt(Math.pow(10, 18)) / exchangeRate;
            return _context2.abrupt("return", [{
              address: vaultAddress,
              toSpend: [{
                token: asset,
                amount: amount.value
              }],
              toReceive: [{
                token: to.value,
                amount: cTokens.toString()
              }]
            }]);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
});

var Redeem = createPlugin({
  protocol: 'COMPOUND_V2',
  type: 'ACTION',
  method: 'redeem',
  description: 'Redeem cTokens or cETH',
  supportedContracts: cTokens,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'ctoken',
          options: compoundTokens.filter(function (token) {
            return token.chainId === Number(chainId);
          })
        }),
        receiveToken: new FctAddress({
          destination: 'erc20',
          readonly: true
        }),
        methodParams: {
          redeemTokens: new FctValue({
            destination: 'wei_amount'
          })
        }
      },
      output: {
        result: new FctValue({
          innerIndex: 0
        })
      }
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref2) {
    var input = _ref2.input,
      chainId = _ref2.chainId,
      provider = _ref2.provider;
    var getParamsAsync = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _cTokens$find;
        var to, receiveToken, underlyingToken, tokenContract, symbol, decimals;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              to = input.to, receiveToken = input.receiveToken;
              if (!(!to.value || to.isVariable)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  value: undefined,
                  receiveToken: undefined
                },
                error: undefined
              });
            case 3:
              if (!isNative(to.value, chainId)) {
                _context.next = 8;
                break;
              }
              receiveToken.label = 'ETH';
              receiveToken.decimals = 18;
              receiveToken.value = ZERO_ADDRESS$1;
              return _context.abrupt("return", {
                params: {
                  receiveToken: ZERO_ADDRESS$1
                },
                error: undefined
              });
            case 8:
              underlyingToken = (_cTokens$find = cTokens.find(function (cToken) {
                if (typeof to.value === 'string' && cToken.address.toLowerCase() === to.value.toLowerCase()) return true;
                return false;
              })) === null || _cTokens$find === void 0 ? void 0 : _cTokens$find.assetAddress;
              if (!underlyingToken) {
                _context.next = 20;
                break;
              }
              tokenContract = new ethers.Contract(underlyingToken, ['function decimals() view returns (uint8 decimals)', 'function symbol() view returns (string symbol)'], provider);
              _context.next = 13;
              return tokenContract.symbol();
            case 13:
              symbol = _context.sent;
              _context.next = 16;
              return tokenContract.decimals();
            case 16:
              decimals = _context.sent;
              receiveToken.label = symbol;
              receiveToken.decimals = decimals;
              receiveToken.value = underlyingToken;
            case 20:
              return _context.abrupt("return", {
                params: {
                  receiveToken: underlyingToken
                },
                error: undefined
              });
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getParamsAsync() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      get: getParamsAsync,
      depParamKeys: ['to', 'amount']
    };
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var _compoundTokens$find;
    var to = params.to,
      redeemTokens = params.methodParams.redeemTokens;
    if (!redeemTokens.value || !to.value || !vaultAddress) return [];
    if (typeof redeemTokens.value !== 'string' || typeof to.value !== 'string') return [];

    // Find asset from cToken address
    var asset = (to === null || to === void 0 ? void 0 : to.value) && ((_compoundTokens$find = compoundTokens.find(function (token) {
      return token.address === to.value;
    })) === null || _compoundTokens$find === void 0 ? void 0 : _compoundTokens$find.assetAddress);
    if (!asset) return [];
    return [{
      address: vaultAddress,
      toSpend: [],
      toReceive: [{
        token: asset,
        amount: redeemTokens.value
      }]
    }, {
      address: to.value,
      toSpend: [{
        token: asset,
        amount: redeemTokens.value
      }],
      toReceive: []
    }];
  }
});

var RepayBorrow = createPlugin({
  protocol: 'COMPOUND_V2',
  type: 'ACTION',
  method: 'repayBorrow',
  name: 'repayBorrow',
  description: 'Repay borrowed ERC20 tokens or ETH',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'ctoken',
          options: compoundTokens.filter(function (token) {
            return token.chainId === Number(chainId);
          })
        }),
        value: new FctValue({
          destination: 'wei_amount',
          required: false,
          readonly: true
        }),
        amount: new FctValue({
          destination: 'wei_amount'
        }),
        methodParams: {
          repayAmount: new FctValue({
            destination: 'wei_amount',
            required: false,
            readonly: true
          })
        }
      },
      output: {}
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref2) {
    var input = _ref2.input,
      chainId = _ref2.chainId;
    var getParamsAsync = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var to, value, amount, methodParams;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              to = input.to, value = input.value, amount = input.amount, methodParams = input.methodParams;
              if (!(!to.value || to.isVariable)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  value: undefined,
                  methodParams: {
                    repayAmount: undefined
                  }
                },
                error: undefined
              });
            case 3:
              if (!isNative(to.value, chainId)) {
                _context.next = 10;
                break;
              }
              value.value = amount.value;
              methodParams.repayAmount.value = undefined;
              methodParams.repayAmount.virtual = true;
              methodParams.repayAmount.required = false;
              value.required = true;
              return _context.abrupt("return", {
                params: {
                  value: amount.value
                },
                error: undefined
              });
            case 10:
              methodParams.repayAmount.required = true;
              value.required = false;
              value.value = '0';
              methodParams.repayAmount.value = amount.value;
              methodParams.repayAmount.virtual = false;
              return _context.abrupt("return", {
                params: {
                  value: undefined,
                  methodParams: {
                    repayAmount: amount.value
                  }
                },
                error: undefined
              });
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getParamsAsync() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      get: getParamsAsync,
      depParamKeys: ['to', 'amount']
    };
  },
  requiredApprovals: function requiredApprovals(params, chainId) {
    var _cTokens$find;
    if (!params.to.value) return [];
    if (isNative(params.to.value, chainId)) return [];
    var underlyingToken = (_cTokens$find = cTokens.find(function (cToken) {
      if (typeof (params === null || params === void 0 ? void 0 : params.to.value) === 'string' && cToken.address.toLowerCase() === (params === null || params === void 0 ? void 0 : params.to.value.toLocaleLowerCase())) return true;
      return false;
    })) === null || _cTokens$find === void 0 ? void 0 : _cTokens$find.assetAddress;
    return [{
      to: underlyingToken,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params.methodParams.repayAmount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var _compoundTokens$find;
    var to = params.to,
      amount = params.amount;
    if (!amount.value || !to.value || !vaultAddress) return [];
    if (typeof amount.value !== 'string' || typeof to.value !== 'string') return [];

    // Find asset from cToken address
    var asset = (to === null || to === void 0 ? void 0 : to.value) && ((_compoundTokens$find = compoundTokens.find(function (token) {
      return token.address === to.value;
    })) === null || _compoundTokens$find === void 0 ? void 0 : _compoundTokens$find.assetAddress);
    if (!asset) return [];
    return [{
      address: vaultAddress,
      toSpend: [{
        token: asset,
        amount: amount.value
      }],
      toReceive: []
    }, {
      address: to.value,
      toSpend: [],
      toReceive: [{
        token: asset,
        amount: amount.value
      }]
    }];
  }
});

/* eslint-disable no-restricted-imports */
var BorrowBalance = createPlugin({
  protocol: 'COMPOUND_V2',
  type: 'GETTER',
  method: 'borrowBalanceCurrent',
  description: 'Borrow ETH or ERC20 tokens',
  supportedContracts: cTokens,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'ctoken',
          options: compoundTokens.filter(function (token) {
            return token.chainId === Number(chainId);
          })
        }),
        methodParams: {
          account: new FctAddress({})
        }
      },
      output: {
        borrowedAmount: new FctValue({
          innerIndex: 0
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var CollateralFactor = createPlugin({
  protocol: 'COMPOUND_V2',
  type: 'GETTER',
  method: 'markets',
  description: 'Borrow ETH or ERC20 tokens',
  supportedContracts: [{
    chainId: 1,
    address: '0x3d9819210A31b4961b30EF54bE2aeD79B9c9Cd3B'
  }, {
    chainId: 5,
    address: '0x3cBe63aAcF6A064D32072a630A3eab7545C54d78'
  }],
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'comptroller'
        }),
        methodParams: {
          cToken: new FctAddress({
            destination: 'ctoken',
            options: compoundTokens.filter(function (token) {
              return token.chainId === Number(chainId);
            })
          })
        }
      },
      output: {
        isListed: new FctBoolean({
          innerIndex: 0
        }),
        collateralFactor: new FctBoolean({
          innerIndex: 1
        }),
        isComped: new FctBoolean({
          innerIndex: 2
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var GetAccountLiquidity = createPlugin({
  protocol: 'COMPOUND_V2',
  type: 'GETTER',
  method: 'getAccountLiquidity',
  description: 'Get account liquidity that represents the USD value borrowable by a user, before it reaches liquidation',
  supportedContracts: [{
    chainId: 1,
    address: '0x3d9819210A31b4961b30EF54bE2aeD79B9c9Cd3B'
  }, {
    chainId: 5,
    address: '0x3cBe63aAcF6A064D32072a630A3eab7545C54d78'
  }],
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({
          destination: 'comptroller'
        }),
        methodParams: {
          account: new FctAddress({})
        }
      },
      output: {
        liquidity: new FctValue({
          innerIndex: 1,
          destination: 'wei_amount'
        }),
        shortfall: new FctValue({
          innerIndex: 2
        })
      }
    };
  }
});

var GetAssetsIn = createPlugin({
  protocol: 'COMPOUND_V2',
  type: 'GETTER',
  method: 'getAssetsIn',
  description: 'Get the list of markets an account is currently entered into',
  supportedContracts: [{
    chainId: 1,
    address: '0x3d9819210A31b4961b30EF54bE2aeD79B9c9Cd3B'
  }, {
    chainId: 5,
    address: '0x3cBe63aAcF6A064D32072a630A3eab7545C54d78'
  }],
  getParams: function getParams(_ref) {
    _objectDestructuringEmpty(_ref);
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          account: new FctAddress({})
        }
      },
      output: {
        addresses: new FctAddressList({
          innerIndex: 0
        })
      }
    };
  }
});

var actions$i = {
  Mint: Mint,
  Redeem: Redeem,
  Borrow: Borrow$1,
  RepayBorrow: RepayBorrow,
  EnterMarkets: EnterMarkets,
  ExitMarket: ExitMarket,
  ClaimCOMP: ClaimCOMP
};
var getters$g = {
  GetAccountLiquidity: GetAccountLiquidity,
  CollateralFactor: CollateralFactor,
  BorrowBalance: BorrowBalance,
  GetAssetsIn: GetAssetsIn
};
var CompoundV2 = {
  actions: actions$i,
  getters: getters$g
};

var depositAssets = [
	{
		chainId: 1,
		address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
		name: "USDC",
		symbol: "USDC",
		decimals: 6
	},
	{
		chainId: 1,
		address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
		name: "Compound",
		symbol: "COMP",
		decimals: 18
	},
	{
		chainId: 1,
		address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
		name: "Wrapped BTC",
		symbol: "WBTC",
		decimals: 8
	},
	{
		chainId: 1,
		address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
		name: "Wrapped ETH",
		symbol: "WETH",
		decimals: 18
	},
	{
		chainId: 1,
		address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
		name: "Uniswap",
		symbol: "UNI",
		decimals: 18
	},
	{
		chainId: 1,
		address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
		name: "Chainlink",
		symbol: "LINK",
		decimals: 18
	},
	{
		chainId: 5,
		address: "0x07865c6E87B9F70255377e024ace6630C1Eaa37F",
		name: "USDC",
		symbol: "USDC",
		decimals: 6
	},
	{
		chainId: 5,
		address: "0x3587b2F7E0E2D6166d6C14230e7Fe160252B0ba4",
		name: "Compound",
		symbol: "COMP",
		decimals: 18
	},
	{
		chainId: 5,
		address: "0xAAD4992D949f9214458594dF92B44165Fb84dC19",
		name: "Wrapped BTC",
		symbol: "WBTC",
		decimals: 8
	},
	{
		chainId: 5,
		address: "0x42a71137C09AE83D8d05974960fd607d40033499",
		name: "Wrapped ETH",
		symbol: "WETH",
		decimals: 18
	},
	{
		chainId: 42161,
		address: "0x912ce59144191c1204e64559fe8253a0e49e6548",
		name: "Arbitrum",
		symbol: "ARB",
		decimals: 18
	},
	{
		chainId: 42161,
		address: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
		name: "GMX",
		symbol: "GMX",
		decimals: 18
	},
	{
		chainId: 42161,
		address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
		name: "USDC",
		symbol: "USDC.e",
		decimals: 6
	},
	{
		chainId: 42161,
		address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
		name: "Wrapped BTC",
		symbol: "WBTC",
		decimals: 8
	},
	{
		chainId: 42161,
		address: "0x82af49447d8a07e3bd95bd0d56f35241523fbab1",
		name: "Wrapped Ether",
		symbol: "WETH",
		decimals: 18
	},
	{
		chainId: 421613,
		address: "0x8FB1E3fC51F3b789dED7557E680551d93Ea9d892",
		name: "USDC",
		symbol: "USDC.e",
		decimals: 6
	},
	{
		chainId: 421613,
		address: "0x22d5e2dE578677791f6c90e0110Ec629be9d5Fb5",
		name: "Wrapped BTC",
		symbol: "WBTC",
		decimals: 8
	},
	{
		chainId: 421613,
		address: "0xe39Ab88f8A4777030A534146A9Ca3B52bd5D43A3",
		name: "Wrapped Ether",
		symbol: "WETH",
		decimals: 18
	}
];

function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$f(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Supply = createPlugin({
  protocol: 'COMPOUND_V3',
  type: 'ACTION',
  method: 'supply',
  description: "Transfers an asset to the Compound protocol and adds it to the account's balance",
  supportedContracts: cometList,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: depositAssets.filter(function (token) {
              return token.chainId === Number(chainId);
            }).map(function (asset) {
              return _objectSpread$f(_objectSpread$f({}, asset), {}, {
                value: asset.address
              });
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          })
        }
      },
      output: {}
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams = params.methodParams,
      asset = _params$methodParams.asset,
      amount = _params$methodParams.amount;
    return [{
      to: asset.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: amount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      _params$methodParams2 = params.methodParams,
      asset = _params$methodParams2.asset,
      amount = _params$methodParams2.amount;
    if (!amount.value || !asset.value || !to.value || !vaultAddress) return [];
    if (typeof amount.value !== 'string' || typeof asset.value !== 'string' || typeof to.value !== 'string') return [];
    return [{
      address: vaultAddress,
      toSpend: [{
        token: asset.value,
        amount: amount.value
      }],
      toReceive: [{
        token: to.value,
        amount: amount.value
      }]
    }, {
      address: to.value,
      toSpend: [],
      toReceive: [{
        token: asset.value,
        amount: amount.value
      }]
    }];
  }
});

function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$e(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SupplyFrom = createPlugin({
  protocol: 'COMPOUND_V3',
  type: 'ACTION',
  method: 'supplyFrom',
  description: "Transfers an asset to the Compound protocol and adds it to the account's balance",
  supportedContracts: cometList,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          from: new FctAddress({}),
          destination: new FctAddress({}),
          asset: new FctAddress({
            destination: 'erc20',
            options: depositAssets.filter(function (token) {
              return token.chainId === Number(chainId);
            }).map(function (asset) {
              return _objectSpread$e(_objectSpread$e({}, asset), {}, {
                value: asset.address
              });
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          })
        }
      },
      output: {}
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams = params.methodParams,
      asset = _params$methodParams.asset,
      amount = _params$methodParams.amount,
      from = _params$methodParams.from;
    return [{
      to: asset.value,
      from: from.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: amount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      _params$methodParams2 = params.methodParams,
      asset = _params$methodParams2.asset,
      amount = _params$methodParams2.amount,
      from = _params$methodParams2.from,
      destination = _params$methodParams2.destination;
    if (!amount.value || !asset.value || !to.value || !from.value || !destination.value || !vaultAddress) return [];
    if (typeof from.value !== 'string' || typeof amount.value !== 'string' || typeof asset.value !== 'string' || typeof to.value !== 'string' || typeof destination.value !== 'string') return [];
    var flow = [{
      address: from.value,
      toSpend: [{
        token: asset.value,
        amount: amount.value
      }],
      toReceive: []
    }, {
      address: to.value,
      toSpend: [],
      toReceive: [{
        token: asset.value,
        amount: amount.value
      }]
    }];
    if (destination.value.toLowerCase() === from.value.toLowerCase()) {
      flow[0].toReceive = [{
        token: asset.value,
        amount: amount.value
      }];
    } else {
      flow.push({
        address: destination.value,
        toSpend: [],
        toReceive: [{
          token: asset.value,
          amount: amount.value
        }]
      });
    }
    return flow;
  }
});

function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SupplyTo = createPlugin({
  protocol: 'COMPOUND_V3',
  type: 'ACTION',
  method: 'supplyTo',
  description: "Transfers an asset to the Compound protocol and adds it to the account's balance",
  supportedContracts: cometList,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          destination: new FctAddress({}),
          asset: new FctAddress({
            destination: 'erc20',
            options: depositAssets.filter(function (token) {
              return token.chainId === Number(chainId);
            }).map(function (asset) {
              return _objectSpread$d(_objectSpread$d({}, asset), {}, {
                value: asset.address
              });
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          })
        }
      },
      output: {}
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams = params.methodParams,
      asset = _params$methodParams.asset,
      amount = _params$methodParams.amount;
    return [{
      to: asset.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: amount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      _params$methodParams2 = params.methodParams,
      asset = _params$methodParams2.asset,
      amount = _params$methodParams2.amount,
      destination = _params$methodParams2.destination;
    if (!amount.value || !asset.value || !to.value || !destination.value || !vaultAddress) return [];
    if (typeof amount.value !== 'string' || typeof asset.value !== 'string' || typeof to.value !== 'string' || typeof destination.value !== 'string') return [];
    var flow = [{
      address: vaultAddress,
      toSpend: [{
        token: asset.value,
        amount: amount.value
      }],
      toReceive: []
    }, {
      address: to.value,
      toSpend: [],
      toReceive: [{
        token: asset.value,
        amount: amount.value
      }]
    }];
    if (destination.value.toLowerCase() === vaultAddress.toLowerCase()) {
      flow[0].toReceive = [{
        token: asset.value,
        amount: amount.value
      }];
    } else {
      flow.push({
        address: destination.value,
        toSpend: [],
        toReceive: [{
          token: asset.value,
          amount: amount.value
        }]
      });
    }
    return flow;
  }
});

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Withdraw$4 = createPlugin({
  protocol: 'COMPOUND_V3',
  type: 'ACTION',
  method: 'withdraw',
  description: 'Withdraw collateral that is not currently supporting an open borrow.',
  supportedContracts: cometList,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: depositAssets.filter(function (token) {
              return token.chainId === Number(chainId);
            }).map(function (asset) {
              return _objectSpread$c(_objectSpread$c({}, asset), {}, {
                value: asset.address
              });
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          })
        }
      },
      output: {}
    };
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      _params$methodParams = params.methodParams,
      asset = _params$methodParams.asset,
      amount = _params$methodParams.amount;
    if (!amount.value || !asset.value || !to.value || !vaultAddress) return [];
    if (typeof amount.value !== 'string' || typeof asset.value !== 'string' || typeof to.value !== 'string') return [];
    var flow = [{
      address: vaultAddress,
      toSpend: [{
        token: to.value,
        amount: amount.value
      }],
      toReceive: [{
        token: asset.value,
        amount: amount.value
      }]
    }, {
      address: to.value,
      toSpend: [{
        token: asset.value,
        amount: amount.value
      }],
      toReceive: []
    }];
    return flow;
  }
});

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var WithdrawFrom = createPlugin({
  protocol: 'COMPOUND_V3',
  type: 'ACTION',
  method: 'withdrawFrom',
  description: 'Withdraw collateral that is not currently supporting an open borrow.',
  supportedContracts: cometList,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          src: new FctAddress({}),
          to: new FctAddress({}),
          asset: new FctAddress({
            destination: 'erc20',
            options: depositAssets.filter(function (token) {
              return token.chainId === Number(chainId);
            }).map(function (asset) {
              return _objectSpread$b(_objectSpread$b({}, asset), {}, {
                value: asset.address
              });
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          })
        }
      },
      output: {}
    };
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      _params$methodParams = params.methodParams,
      asset = _params$methodParams.asset,
      amount = _params$methodParams.amount,
      src = _params$methodParams.src,
      destination = _params$methodParams.to;
    if (!amount.value || !asset.value || !to.value || !src.value || !destination.value || !vaultAddress) return [];
    if (typeof src.value !== 'string' || typeof amount.value !== 'string' || typeof asset.value !== 'string' || typeof to.value !== 'string' || typeof destination.value !== 'string') return [];
    var flow = [{
      address: destination.value,
      toSpend: [],
      toReceive: [{
        token: asset.value,
        amount: amount.value
      }]
    }, {
      address: to.value,
      toSpend: [{
        token: asset.value,
        amount: amount.value
      }],
      toReceive: []
    }];
    return flow;
  }
});

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var WithdrawTo = createPlugin({
  protocol: 'COMPOUND_V3',
  type: 'ACTION',
  method: 'withdrawTo',
  description: 'Withdraw collateral that is not currently supporting an open borrow.',
  supportedContracts: cometList,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          to: new FctAddress({}),
          asset: new FctAddress({
            destination: 'erc20',
            options: depositAssets.filter(function (token) {
              return token.chainId === Number(chainId);
            }).map(function (asset) {
              return _objectSpread$a(_objectSpread$a({}, asset), {}, {
                value: asset.address
              });
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          })
        }
      },
      output: {}
    };
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      _params$methodParams = params.methodParams,
      asset = _params$methodParams.asset,
      amount = _params$methodParams.amount,
      destination = _params$methodParams.to;
    if (!amount.value || !asset.value || !to.value || !destination.value || !vaultAddress) return [];
    if (typeof amount.value !== 'string' || typeof asset.value !== 'string' || typeof to.value !== 'string' || typeof destination.value !== 'string') return [];
    var flow = [{
      address: destination.value,
      toSpend: [],
      toReceive: [{
        token: asset.value,
        amount: amount.value
      }]
    }, {
      address: to.value,
      toSpend: [{
        token: asset.value,
        amount: amount.value
      }],
      toReceive: []
    }];
    return flow;
  }
});

/* eslint-disable no-restricted-imports */
var AccountData = createPlugin({
  protocol: 'COMPOUND_V3',
  type: 'GETTER',
  method: 'userBasic',
  description: 'The protocol tracks data like the principal and indexes for each account that supplies and borrows.',
  supportedContracts: cometList,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          account: new FctAddress({})
        }
      },
      output: {
        pricinpal: new FctValue({
          innerIndex: 0
        }),
        baseTrackingIndex: new FctValue({
          innerIndex: 1
        }),
        baseTrackingAccrued: new FctValue({
          innerIndex: 2
        }),
        assetsIn: new FctValue({
          innerIndex: 3
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var BorrowBalanceOf = createPlugin({
  protocol: 'COMPOUND_V3',
  type: 'GETTER',
  method: 'borrowBalanceOf',
  description: 'Returns the current balance of borrowed base asset for a specified account in the protocol, including interest.',
  supportedContracts: cometList,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          account: new FctAddress({})
        }
      },
      output: {
        balance: new FctValue({
          innerIndex: 0
        })
      }
    };
  }
});

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var CollateralBalanceOf = createPlugin({
  protocol: 'COMPOUND_V3',
  type: 'GETTER',
  method: 'collateralBalanceOf',
  description: 'Function returns the current balance of a collateral asset for a specified account in the protocol.',
  supportedContracts: cometList,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          account: new FctAddress({}),
          asset: new FctAddress({
            destination: 'erc20',
            options: depositAssets.filter(function (token) {
              return token.chainId === Number(chainId);
            }).map(function (asset) {
              return _objectSpread$9(_objectSpread$9({}, asset), {}, {
                value: asset.address
              });
            })
          })
        }
      },
      output: {
        balance: new FctValue({
          innerIndex: 0
        })
      }
    };
  }
});

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var GetAssetInfo = createPlugin({
  protocol: 'COMPOUND_V3',
  type: 'GETTER',
  method: 'getAssetInfoByAddress',
  description: 'This function returns asset information of a specific asset.',
  supportedContracts: cometList,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: depositAssets.filter(function (token) {
              return token.chainId === Number(chainId);
            }).map(function (asset) {
              return _objectSpread$8(_objectSpread$8({}, asset), {}, {
                value: asset.address
              });
            })
          })
        }
      },
      output: {
        offset: new FctValue({
          innerIndex: 0
        }),
        asset: new FctAddress({
          innerIndex: 1
        }),
        priceFeed: new FctAddress({
          innerIndex: 2
        }),
        scale: new FctValue({
          innerIndex: 3
        }),
        borrowCollateralFactor: new FctValue({
          innerIndex: 4
        }),
        liquidateCollateralFactor: new FctValue({
          innerIndex: 5
        }),
        liquidationFactor: new FctValue({
          innerIndex: 6
        }),
        supplyCap: new FctValue({
          innerIndex: 7
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var GetPrice = createPlugin({
  protocol: 'COMPOUND_V3',
  type: 'GETTER',
  method: 'getPrice',
  description: 'This function returns the price of an asset in USD with 8 decimal places. Requires Chainlink Price Feed address',
  supportedContracts: cometList,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          priceFeed: new FctAddress({})
        }
      },
      output: {
        price: new FctValue({
          innerIndex: 0
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var IsBorrowCollateralized = createPlugin({
  protocol: 'COMPOUND_V3',
  type: 'GETTER',
  method: 'isBorrowCollateralized',
  description: 'Function returns the current balance of a collateral asset for a specified account in the protocol.',
  supportedContracts: cometList,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          account: new FctAddress({})
        }
      },
      output: {
        hasEnoughLiquidity: new FctBoolean({
          innerIndex: 0
        })
      }
    };
  }
});

var actions$h = {
  Supply: Supply,
  SupplyFrom: SupplyFrom,
  SupplyTo: SupplyTo,
  Withdraw: Withdraw$4,
  WithdrawFrom: WithdrawFrom,
  WithdrawTo: WithdrawTo
};
var getters$f = {
  CollateralBalanceOf: CollateralBalanceOf,
  IsBorrowCollateralized: IsBorrowCollateralized,
  AccountData: AccountData,
  BorrowBalanceOf: BorrowBalanceOf,
  GetAssetInfo: GetAssetInfo,
  GetPrice: GetPrice
};
var CompoundV3 = {
  actions: actions$h,
  getters: getters$f
};

// [ ADD: "+",
// SUB: "-",
// MUL: "*",
// DIV: "/",
// POW: "**",
// MOD: "%",
// LSHIFT: "<<",
// RSHIFT: ">>",
// AND: "&",
// OR: "|",
// XOR: "^",
// MAX: "max",
// MIN: "min",
// ADD_DECIMALS: "*(10**X)",
// SUB_DECIMALS: "/(10**X)",
// HASH: "keccak256",]
var operatorOptions$1 = [{
  name: 'ADD',
  value: '+'
}, {
  name: 'SUB',
  value: '-'
}, {
  name: 'MUL',
  value: '*'
}, {
  name: 'DIV',
  value: '/'
}, {
  name: 'POW',
  value: '**'
}, {
  name: 'MOD',
  value: '%'
}, {
  name: 'ADD_DECIMALS',
  value: '*(10**X)'
}, {
  name: 'SUB_DECIMALS',
  value: '/(10**X)'
}
//{ name: 'HASH', value: 'keccak256' },
];

var sameDecimalsOperators = ['+', '-'];
var zeroDecimalsOperators = ['*', '/', '**', '%'];
var floatingDecimalsOperators = ['*(10**X)', '/(10**X)'];
var Compute = createPlugin({
  protocol: 'COMPUTED_VARIABLE',
  type: 'COMPUTED_VARIABLE',
  method: 'compute',
  name: 'compute',
  getParams: function getParams() {
    return {
      input: {
        methodParams: {
          id: new FctString({
            readonly: true
          }),
          value1: new FctValue({
            destination: 'wei_amount'
          }),
          operator1: new FctString({
            options: operatorOptions$1,
            mode: 'INPUT'
          }),
          value2: new FctValue({
            destination: 'wei_amount'
          }),
          operator2: new FctString({
            options: operatorOptions$1,
            required: false,
            mode: 'INPUT'
          }),
          value3: new FctValue({
            destination: 'wei_amount',
            required: false
          }),
          operator3: new FctString({
            options: operatorOptions$1,
            required: false,
            mode: 'INPUT'
          }),
          value4: new FctValue({
            destination: 'wei_amount',
            required: false
          })
        }
      },
      output: {
        result: new FctValue({
          innerIndex: 0
        })
      }
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref) {
    var input = _ref.input,
      output = _ref.output;
    var getParamsAsync = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var error, params, setAndValidateParams, initDecimals, i, labelIndex, valueLabel, operatorLabel;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              error = '';
              params = {
                methodParams: {}
              };
              setAndValidateParams = function setAndValidateParams(fromIndex) {
                if (!fromIndex) return;
                var decimals = input.methodParams.value1.decimals || 0;
                for (var i = 1; i <= 4; i++) {
                  var labelIndex = String(i);
                  var prevValueLabel = "value".concat(String(i - 1));
                  var prevOperatorLabel = "operator".concat(String(i - 1));
                  var valueLabel = "value".concat(labelIndex);
                  var operatorLabel = "operator".concat(labelIndex);
                  if (i <= fromIndex) {
                    input.methodParams[valueLabel].hidden = false;
                    if (operatorLabel !== 'operator4') {
                      input.methodParams[operatorLabel].hidden = false;
                    }
                    if (prevValueLabel === 'value0' || prevOperatorLabel === 'operator0') {
                      params.methodParams[valueLabel] = input.methodParams[valueLabel].value;
                      params.methodParams[operatorLabel] = input.methodParams[operatorLabel].value;
                      continue;
                    }
                    var prevValueParam = input.methodParams[prevValueLabel];
                    var prevOperatorValue = input.methodParams[prevOperatorLabel].value;
                    var newValueParam = input.methodParams[valueLabel];
                    if (prevOperatorValue && !isVariable(prevOperatorValue) && sameDecimalsOperators.includes(prevOperatorValue)) {
                      // if (newValueParam.decimals && newValueParam.decimals !== prevValueParam.decimals) {
                      //   error += `${error ? '\n' : ''}${valueLabel} wrong decimals: ${newValueParam.decimals} should be ${prevValueParam.decimals}`
                      // }

                      var valueDecimals = prevValueParam.decimals || decimals || 0;
                      newValueParam.decimals = valueDecimals;
                      output.result.decimals = valueDecimals;
                      decimals = valueDecimals;
                    }
                    if (prevOperatorValue && !isVariable(prevOperatorValue) && zeroDecimalsOperators.includes(prevOperatorValue)) {
                      // if (newValueParam.decimals && newValueParam.decimals !== 0) {
                      //   error += `${error ? '\n' : ''}${valueLabel} wrong decimals: ${newValueParam.decimals} should be 0`
                      // } else {
                      // }
                      newValueParam.decimals = 0;
                      if (prevOperatorValue === "**" && newValueParam.value && !isVariable(newValueParam.value)) {
                        decimals = decimals * Number(newValueParam.value);
                        output.result.decimals = decimals;
                      }
                    }
                    if (prevOperatorValue && !isVariable(prevOperatorValue) && floatingDecimalsOperators.includes(prevOperatorValue)) {
                      if (prevOperatorValue === '*(10**X)') {
                        decimals = Number(prevValueParam.decimals || decimals || 0) + Number(newValueParam.value);
                      } else {
                        decimals = Number(prevValueParam.decimals || decimals || 0) - Number(newValueParam.value);
                      }
                      if (decimals < 0 || decimals > 64) {
                        error += "".concat(error ? '\n' : '').concat(valueLabel, " wrong decimals amount you have ").concat(decimals, " but result should be more than 0 and lesss than 64");
                        newValueParam.value = undefined;
                        decimals = 0;
                        continue;
                      }
                      // if (newValueParam.decimals && newValueParam.decimals !== 0) {
                      //   error += `${error ? '\n' : ''}${valueLabel} wrong decimals: ${newValueParam.decimals} should be 0`
                      // } else {
                      // }
                      newValueParam.decimals = 0;
                      output.result.decimals = decimals;
                    }
                  } else {
                    input.methodParams[valueLabel].hidden = true;
                    input.methodParams[valueLabel].value = undefined;
                    if (operatorLabel !== 'operator4') {
                      input.methodParams[operatorLabel].hidden = true;
                      input.methodParams[operatorLabel].value = undefined;
                    }
                  }
                  params.methodParams[valueLabel] = input.methodParams[valueLabel].value;
                  if (operatorLabel !== 'operator4') {
                    params.methodParams[operatorLabel] = input.methodParams[operatorLabel].value;
                  }
                }
              };
              initDecimals = input.methodParams.value1.decimals || 0;
              output.result.decimals = initDecimals;
              i = 1;
            case 6:
              if (!(i <= 4)) {
                _context.next = 17;
                break;
              }
              labelIndex = String(i);
              valueLabel = "value".concat(labelIndex);
              operatorLabel = labelIndex !== '4' ? "operator".concat(labelIndex) : undefined;
              if (!(!input.methodParams[valueLabel].value || operatorLabel && !input.methodParams[operatorLabel].value)) {
                _context.next = 13;
                break;
              }
              setAndValidateParams(i);
              return _context.abrupt("break", 17);
            case 13:
              if (i === 4) {
                setAndValidateParams(i);
              }
            case 14:
              i++;
              _context.next = 6;
              break;
            case 17:
              return _context.abrupt("return", {
                params: params,
                error: Boolean(error) ? error : undefined
              });
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getParamsAsync() {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      get: getParamsAsync,
      depParamKeys: ['methodParams.value1', 'methodParams.operator1', 'methodParams.value2', 'methodParams.operator2', 'methodParams.value3', 'methodParams.operator3', 'methodParams.value4']
    };
  },
  onChange: function onChange(_ref3) {
    var input = _ref3.input,
      output = _ref3.output;
    var _input$methodParams = input.methodParams,
      id = _input$methodParams.id,
      value1 = _input$methodParams.value1,
      operator1 = _input$methodParams.operator1,
      value2 = _input$methodParams.value2,
      operator2 = _input$methodParams.operator2,
      value3 = _input$methodParams.value3,
      operator3 = _input$methodParams.operator3,
      value4 = _input$methodParams.value4;
    output.result.set({
      value: {
        id: id.value,
        type: 'computed',
        value1: value1.value || '',
        operator1: operator1.value || '',
        value2: value2.value || '',
        operator2: operator2.value || '',
        value3: value3.value || '',
        operator3: operator3.value || '',
        value4: value4.value || '',
        overflowProtection: true
      }
    });
  }
});

var ComputedVariable = {
  getters: {
    Compute: Compute
  }
};

var AddLiquidity = createPlugin({
  protocol: 'CURVE',
  type: 'ACTION',
  method: 'add_liquidity',
  name: 'addLiquidity',
  description: 'Deposit coins into the pool',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'curve_pool',
          options: supportedPools.filter(function (pool) {
            return pool.chainId === Number(chainId);
          })
        }),
        poolLPToken: new FctAddress({
          destination: 'curve_pool',
          readonly: true
        }),
        poolGaugeToken: new FctAddress({
          destination: 'curve_gauge',
          readonly: true
        }),
        value: new FctValue({
          readonly: true,
          required: false
        }),
        amount1: new FctValue({}),
        amount2: new FctValue({}),
        amount3: new FctValue({}),
        amount4: new FctValue({}),
        methodParams: {
          amounts: new FctValueListN({
            readonly: true
          }),
          minMintAmount: new FctValue({
            destination: 'wei_amount',
            required: false,
            decimals: 18
          })
        }
      },
      output: {}
    };
  },
  initParams: {
    methodParams: {
      minMintAmount: '0'
    }
  },
  overrideSetMethodParams: function overrideSetMethodParams(_ref2) {
    var input = _ref2.input;
    return function (params) {
      var _input$methodParams$a;
      Object.keys(input.methodParams).forEach(function (key, i) {
        var paramKey = key;
        input.methodParams[paramKey].value = params[i];
      });
      (_input$methodParams$a = input.methodParams.amounts.value) === null || _input$methodParams$a === void 0 ? void 0 : _input$methodParams$a.forEach(function (value, i) {
        input["amount".concat(i)].value = value;
      });
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref3) {
    var input = _ref3.input;
    var to = input.to,
      methodParams = input.methodParams,
      poolLPToken = input.poolLPToken,
      poolGaugeToken = input.poolGaugeToken;
    var getParams = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var defaultReturn, pool, i, label;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              defaultReturn = {
                poolLPToken: undefined,
                poolGaugeToken: undefined,
                value: undefined,
                amount1: undefined,
                amount2: undefined,
                amount3: undefined,
                amount4: undefined,
                methodParams: {
                  amounts: undefined,
                  minMintAmount: '0'
                }
              };
              if (!(!to.value || typeof to.value !== 'string')) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", {
                params: defaultReturn,
                error: undefined
              });
            case 3:
              pool = to.options.find(function (p) {
                return p.address === to.value;
              });
              if (pool) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", {
                params: defaultReturn,
                error: undefined
              });
            case 6:
              methodParams.amounts.value = [];
              poolLPToken.value = pool.lpTokenAddress;
              poolLPToken.decimals = 18;
              poolLPToken.label = "Curve LP ".concat(pool.symbol);
              poolGaugeToken.value = pool.gaugeAddress;
              poolGaugeToken.decimals = 18;
              poolGaugeToken.label = "Curve Gauge ".concat(pool.symbol);
              pool.coins.forEach(function (coin, index) {
                var label = "amount".concat(index + 1);
                if (!input[label]) return;
                input[label].decimals = Number(coin.decimals);
                input[label].label = coin.symbol;
                if (!methodParams.amounts.value) return;
                input[label].hidden = false;
                input[label].readonly = false;
                input[label].required = true;
                // if (input[label].value && typeof input[label].value === 'string') {
                //   methodParams.amounts.value.push(input[label].value)
                // }
              });
              i = 1;
            case 15:
              if (!(i < 5)) {
                _context.next = 28;
                break;
              }
              if (!(i <= pool.coins.length)) {
                _context.next = 18;
                break;
              }
              return _context.abrupt("continue", 25);
            case 18:
              label = "amount".concat(i);
              if (input[label]) {
                _context.next = 21;
                break;
              }
              return _context.abrupt("continue", 25);
            case 21:
              input[label].hidden = true;
              input[label].readonly = true;
              input[label].required = false;
              input[label].decimals = 0;
            case 25:
              i++;
              _context.next = 15;
              break;
            case 28:
              if (!(pool.assetTypeName === 'eth' && pool.coins[0].symbol === 'ETH')) {
                _context.next = 30;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  value: input.amount1.value || '0',
                  receiveLPToken: pool.lpTokenAddress,
                  receivedGaugeToken: pool.gaugeAddress,
                  methodParams: {
                    amounts: methodParams.amounts.value
                  }
                },
                error: undefined
              });
            case 30:
              return _context.abrupt("return", {
                params: {
                  value: '0',
                  poolLPToken: pool.lpTokenAddress,
                  poolGaugeToken: pool.gaugeAddress,
                  methodParams: {
                    amounts: methodParams.amounts.value
                  }
                },
                error: undefined
              });
            case 31:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getParams() {
        return _ref4.apply(this, arguments);
      };
    }();
    return {
      get: getParams,
      depParamKeys: ['to', 'amount1', 'amount2', 'amount3', 'amount4']
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var pool = supportedPools.find(function (p) {
      return p.address === params.to.value;
    });
    if (!pool) return [];
    if (pool.assetTypeName === 'eth' && pool.coins[0].symbol === 'ETH') {
      if (!pool.coins[1]) return [];
      if (typeof (params === null || params === void 0 ? void 0 : params.amount2.value) === 'string' && BigNumber.from(params === null || params === void 0 ? void 0 : params.amount2.value).lte('0')) return [];
      return [{
        to: pool.coins[1].address,
        params: {
          spender: params === null || params === void 0 ? void 0 : params.to.value,
          amount: params === null || params === void 0 ? void 0 : params.amount2.value
        },
        method: 'approve',
        protocol: 'ERC20'
      }];
    }
    var approvals = [];
    pool.coins.forEach(function (coin, index) {
      var label = "amount".concat(index + 1);
      if (!params[label]) return;
      if (typeof params[label].value === 'string' && BigNumber.from(params[label].value).lte('0')) return;
      approvals.push({
        to: coin.address,
        params: {
          spender: params === null || params === void 0 ? void 0 : params.to.value,
          amount: params[label].value
        },
        method: 'approve',
        protocol: 'ERC20'
      });
    });
    return approvals;
  },
  // onCreate: ({ input }) => {
  //   const setAmount = (amountNumber: "1" | "2" | "3" | "4") => {
  //     const amountsValue = input.methodParams.amounts.value || []
  //     const amountLabel = `amount${amountNumber}` as const
  //     const inputAmount = input[amountLabel]
  //     const amountIndex = Number(amountNumber) - 1

  //     if(inputAmount.hidden) {
  //       const amounts = amountsValue.slice(0, amountIndex)
  //       input.methodParams.amounts.set({ value: amounts })
  //       return
  //     }

  //     amountsValue[amountIndex] = inputAmount.value || '0'
  //     input.methodParams.amounts.set({ value: amountsValue })
  //   }

  //   input.amount1.subscribe({
  //     callback: () => {
  //       setAmount('1')
  //     },
  //     id: 'set amount1',
  //   })

  //   input.amount2.subscribe({
  //     callback: () => {
  //       setAmount('2')
  //     },
  //     id: 'set amount2',
  //   })

  //   input.amount3.subscribe({
  //     callback: () => {
  //       setAmount('3')
  //     },
  //     id: 'set amount3',
  //   })

  //   input.amount4.subscribe({
  //     callback: () => {
  //       setAmount('4')
  //     },
  //     id: 'set amount4',
  //   })

  //   setAmount('1')
  //   setAmount('2')
  //   setAmount('3')
  //   setAmount('4')
  // },

  getSubscribtions: function getSubscribtions(_ref5) {
    _objectDestructuringEmpty(_ref5);
    return [{
      callback: function callback(params) {
        if (!params) return;
        var input = params;
        var setAmount = function setAmount(amountNumber) {
          var amountsValue = input.methodParams.amounts.value || [];
          var amountLabel = "amount".concat(amountNumber);
          var inputAmount = input[amountLabel];
          var amountIndex = Number(amountNumber) - 1;
          if (inputAmount.hidden) {
            var amounts = amountsValue.slice(0, amountIndex);
            input.methodParams.amounts.setQuiet({
              value: amounts
            });
            return;
          }
          amountsValue[amountIndex] = inputAmount.value;
          input.methodParams.amounts.setQuiet({
            value: amountsValue
          });
          if (amountNumber !== '1') return;
          if (params.amount1.label === 'ETH') {
            params.value.setQuiet({
              value: inputAmount.value
            });
            return;
          }
          params.value.setQuiet({
            value: '0'
          });
          return;
        };
        setAmount('1');
        setAmount('2');
        setAmount('3');
        setAmount('4');
        return;
      },
      id: 'set_amounts_array'
    }];
  },
  assetFlow: function assetFlow(params, chainId, walletAddress, vaultAddress, provider, method) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var to, pool, toSpend, lpTokenAddress, toReceive, PoolContract, lpTokenAmount;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            to = params.to;
            pool = to.options.find(function (p) {
              return p.address === to.value;
            });
            if (!(!pool || !to.value || !vaultAddress)) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return", []);
          case 4:
            if (!(typeof to.value !== 'string')) {
              _context2.next = 6;
              break;
            }
            return _context2.abrupt("return", []);
          case 6:
            toSpend = [];
            pool.coins.forEach(function (coin, index) {
              var label = "amount".concat(index + 1);
              if (!params[label]) return;
              if (typeof params[label].value === 'string' && BigNumber.from(params[label].value).lte('0')) return;
              toSpend.push({
                token: coin.address,
                amount: params[label].value
              });
            });
            lpTokenAddress = getLPTokenFromPool(chainId, to.value);
            toReceive = [];
            if (!lpTokenAddress) {
              _context2.next = 16;
              break;
            }
            PoolContract = new ethers.Contract(to.value, ["function calc_token_amount(uint256[".concat(pool.coins.length, "] amounts, bool deposit) external view returns(uint256)")], provider);
            _context2.next = 14;
            return PoolContract.calc_token_amount(toSpend.map(function (s) {
              return s.amount;
            }), true);
          case 14:
            lpTokenAmount = _context2.sent;
            toReceive.push({
              token: lpTokenAddress,
              amount: lpTokenAmount
            });
          case 16:
            return _context2.abrupt("return", [{
              address: vaultAddress,
              toSpend: toSpend,
              toReceive: toReceive
            }]);
          case 17:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
});

var CreateLock = createPlugin({
  protocol: 'CURVE',
  type: 'ACTION',
  method: 'create_lock',
  name: 'createCurveTokenLock',
  description: 'Deposit CRV into the contract and create a new lock.',
  supportedContracts: votingEscrowContract,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({
          destination: 'curve_voting_escrow',
          options: votingEscrowContract
        }),
        methodParams: {
          value: new FctValue({
            destination: 'wei_amount',
            decimals: 18
          }),
          unlock_time: new FctTimestamp({})
        }
      },
      output: {}
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    return [{
      to: '0xD533a949740bb3306d119CC777fa900bA034cd52',
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.value.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var ExchangeOnPool = createPlugin({
  protocol: 'CURVE',
  type: 'ACTION',
  method: 'exchange',
  name: 'exchangeOnPool',
  description: 'Exchange tokens on Curve Finance using a pool address',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'curve_pool',
          options: supportedPools.filter(function (pool) {
            return pool.chainId === Number(chainId);
          })
        }),
        poolLPToken: new FctAddress({
          destination: 'curve_pool',
          readonly: true
        }),
        poolGaugeToken: new FctAddress({
          destination: 'curve_gauge',
          readonly: true
        }),
        value: new FctValue({
          readonly: true,
          required: false
        }),
        methodParams: {
          index1: new FctInteger128({
            description: 'Index value for the coin to send',
            destination: 'index'
          }),
          index2: new FctInteger128({
            description: 'Index value of the coin to receive',
            destination: 'index'
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          amountMinReceived: new FctValue({
            destination: 'wei_amount',
            required: false
          })
        }
      },
      output: {
        amountReceived: new FctValue({
          destination: 'wei_amount',
          innerIndex: 0
        })
      }
    };
  },
  initParams: {
    methodParams: {
      amountMinReceived: '0'
    }
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref2) {
    var input = _ref2.input,
      output = _ref2.output,
      chainId = _ref2.chainId;
    var poolLPToken = input.poolLPToken,
      poolGaugeToken = input.poolGaugeToken;
    var getParamsAsync = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var address, index1, index2, pool;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              address = input.to.value;
              index1 = input.methodParams.index1;
              index2 = input.methodParams.index2;
              if (address) {
                _context.next = 7;
                break;
              }
              index1.options = [];
              index2.options = [];
              return _context.abrupt("return", {
                params: {
                  poolLPToken: undefined,
                  poolGaugeToken: undefined,
                  value: undefined
                },
                error: undefined
              });
            case 7:
              index1.options = getSupportedIndexes(address, chainId);
              index2.options = getSupportedIndexes(address, chainId);
              pool = input.to.options.find(function (p) {
                return p.address === address;
              });
              if (pool) {
                _context.next = 12;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  value: undefined
                },
                error: undefined
              });
            case 12:
              if (pool.implementation === 'tricrypto-1') {
                index1._fctType = 'uint256';
                index2._fctType = 'uint256';
              } else {
                index1._fctType = 'int128';
                index2._fctType = 'int128';
              }
              if (index1.value) {
                input.methodParams.amount.decimals = Number(pool.coins[Number(index1.value)].decimals);
              }
              if (index2.value) {
                input.methodParams.amountMinReceived.decimals = Number(pool.coins[Number(index2.value)].decimals);
                output.amountReceived.decimals = Number(pool.coins[Number(index2.value)].decimals);
              }
              poolLPToken.value = pool.lpTokenAddress;
              poolLPToken.decimals = 18;
              poolLPToken.label = "Curve LP ".concat(pool.symbol);
              poolGaugeToken.value = pool.gaugeAddress;
              poolGaugeToken.decimals = 18;
              poolGaugeToken.label = "Curve Gauge ".concat(pool.symbol);
              if (!(pool.assetTypeName === 'eth')) {
                _context.next = 24;
                break;
              }
              input.value.required = true;
              return _context.abrupt("return", {
                params: {
                  poolLPToken: pool.lpTokenAddress,
                  poolGaugeToken: pool.gaugeAddress,
                  value: input.methodParams.amount.value
                },
                error: undefined
              });
            case 24:
              input.value.required = false;
              return _context.abrupt("return", {
                params: {
                  poolLPToken: pool.lpTokenAddress,
                  poolGaugeToken: pool.gaugeAddress,
                  value: undefined
                },
                error: undefined
              });
            case 26:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getParamsAsync() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      get: getParamsAsync,
      depParamKeys: ['to', 'methodParams.index1', 'methodParams.index2', 'methodParams.amount']
    };
  },
  requiredApprovals: function requiredApprovals(params, chainId) {
    if (params.methodParams.index1.value === ETH_ADDRESS) return [];
    var getTokenAddress = function getTokenAddress() {
      if (!(params !== null && params !== void 0 && params.to.value) || typeof (params === null || params === void 0 ? void 0 : params.to.value) !== 'string' || !(params !== null && params !== void 0 && params.methodParams.index1.value) || typeof (params === null || params === void 0 ? void 0 : params.methodParams.index1.value) !== 'string') return undefined;
      var coins = getSupportedIndexes(params === null || params === void 0 ? void 0 : params.to.value, chainId);
      if (!coins) return undefined;
      return coins[parseInt(params === null || params === void 0 ? void 0 : params.methodParams.index1.value)].address;
    };
    return [{
      to: getTokenAddress(),
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var IncreaseAmount = createPlugin({
  protocol: 'CURVE',
  type: 'ACTION',
  method: 'increase_amount',
  name: 'increaseCurveTokenLockAmount',
  description: 'Deposit additional CRV into an existing lock.',
  supportedContracts: votingEscrowContract,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({
          destination: 'curve_voting_escrow',
          options: votingEscrowContract
        }),
        methodParams: {
          value: new FctValue({
            destination: 'wei_amount',
            decimals: 18
          })
        }
      },
      output: {}
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    return [{
      to: '0xD533a949740bb3306d119CC777fa900bA034cd52',
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.value.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var IncreaseUnlockTime = createPlugin({
  protocol: 'CURVE',
  type: 'ACTION',
  method: 'increase_unlock_time',
  name: 'increaseCurveTokenLock',
  description: 'Extend the unlock time on a lock that already exists.',
  supportedContracts: votingEscrowContract,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({
          destination: 'curve_voting_escrow',
          options: votingEscrowContract
        }),
        methodParams: {
          unlock_time: new FctTimestamp({})
        }
      },
      output: {}
    };
  }
});

var RemoveLiquidityOneCoin = createPlugin({
  protocol: 'CURVE',
  type: 'ACTION',
  method: 'remove_liquidity_one_coin',
  name: 'removeLiquidityOneCoin',
  description: 'Withdraw a single asset from the pool.',
  supportedContracts: supportedPools,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({
          destination: 'curve_pool',
          options: supportedPools
        }),
        methodParams: {
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          indexOfCoin: new FctInteger128({}),
          minAmount: new FctValue({
            destination: 'wei_amount',
            required: false
          })
        }
      },
      output: {
        amountReceived: new FctValue({
          innerIndex: 0,
          destination: 'wei_amount'
        })
      }
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref) {
    var input = _ref.input,
      chainId = _ref.chainId;
    var getParamsAsync = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var address, indexOfCoin;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              address = input === null || input === void 0 ? void 0 : input.to.value;
              indexOfCoin = input === null || input === void 0 ? void 0 : input.methodParams.indexOfCoin;
              if (address) {
                _context.next = 5;
                break;
              }
              indexOfCoin.options = [];
              return _context.abrupt("return", {
                params: {},
                error: undefined
              });
            case 5:
              if (indexOfCoin) indexOfCoin.options = getSupportedIndexes(address, chainId);
              return _context.abrupt("return", {
                params: {},
                error: undefined
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getParamsAsync() {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      get: getParamsAsync,
      depParamKeys: ['to']
    };
  },
  initParams: {
    methodParams: {
      minAmount: '0'
    }
  }
});

/* eslint-disable no-restricted-imports */
var Stake = createPlugin({
  protocol: 'CURVE',
  type: 'ACTION',
  method: 'deposit',
  name: 'deposit_LP_tokens',
  description: 'Deposit LP tokens into the gauge.',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'curve_gauge',
          options: supportedGauges.filter(function (pool) {
            return pool.chainId === Number(chainId);
          })
        }),
        methodParams: {
          amount: new FctValue({
            destination: 'wei_amount',
            decimals: 18
          }),
          receiver: new FctAddress({})
        }
      },
      output: {}
    };
  },
  requiredApprovals: function requiredApprovals(params, chainId) {
    var toAddress = params !== null && params !== void 0 && params.to.value && typeof (params === null || params === void 0 ? void 0 : params.to.value) === 'string' ? getLPTokenFromGauge(chainId, params === null || params === void 0 ? void 0 : params.to.value) : undefined;
    if (!toAddress) return [];
    return [{
      to: toAddress,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

/* eslint-disable no-restricted-imports */
var Unstake = createPlugin({
  protocol: 'CURVE',
  type: 'ACTION',
  method: 'withdraw',
  name: 'withdraw_LP_tokens',
  description: 'Withdraw LP tokens from the gauge.',
  supportedContracts: supportedGauges,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'curve_gauge',
          options: supportedGauges.filter(function (pool) {
            return pool.chainId === Number(chainId);
          })
        }),
        methodParams: {
          amount: new FctValue({
            destination: 'wei_amount',
            decimals: 18
          })
        }
      },
      output: {}
    };
  }
});

var Withdraw$3 = createPlugin({
  protocol: 'CURVE',
  type: 'ACTION',
  method: 'withdraw',
  name: 'withdrawCurveToken',
  description: 'Withdraw deposited CRV tokens once a lock has expired.',
  supportedContracts: votingEscrowContract,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({
          destination: 'curve_voting_escrow',
          options: votingEscrowContract
        }),
        methodParams: {}
      },
      output: {}
    };
  }
});

var CalculateTokenAmount = createPlugin({
  protocol: 'CURVE',
  type: 'GETTER',
  method: 'calc_token_amount',
  description: 'Estimate the amount of LP tokens minted or burned based on a deposit or withdrawal.',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'curve_pool',
          options: supportedPools.filter(function (pool) {
            return pool.chainId === Number(chainId);
          })
        }),
        amount1: new FctValue({}),
        amount2: new FctValue({}),
        amount3: new FctValue({}),
        amount4: new FctValue({}),
        methodParams: {
          amounts: new FctValueListN({}),
          isDeposit: new FctBoolean({})
        }
      },
      output: {
        expectedAmount: new FctValue18({
          innerIndex: 0,
          destination: 'wei_amount'
        })
      }
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref2) {
    var input = _ref2.input;
    var to = input.to,
      methodParams = input.methodParams;
    var getParams = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var defaultReturn, pool, i, label;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              defaultReturn = {
                amount1: undefined,
                amount2: undefined,
                amount3: undefined,
                amount4: undefined,
                methodParams: {
                  amounts: undefined
                }
              };
              if (!(!to.value || typeof to.value !== 'string')) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", {
                params: defaultReturn,
                error: undefined
              });
            case 3:
              pool = to.options.find(function (p) {
                return p.address === to.value;
              });
              if (pool) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", {
                params: defaultReturn,
                error: undefined
              });
            case 6:
              methodParams.amounts.value = [];
              pool.coins.forEach(function (coin, index) {
                var label = "amount".concat(index + 1);
                if (!input[label]) return;
                input[label].decimals = Number(coin.decimals);
                input[label].label = coin.symbol;
                if (!methodParams.amounts.value) return;
                input[label].hidden = false;
                input[label].readonly = false;
                input[label].required = true;
                if (input[label].value && typeof input[label].value === 'string') {
                  methodParams.amounts.value.push(input[label].value);
                }
              });
              i = 1;
            case 9:
              if (!(i < 5)) {
                _context.next = 22;
                break;
              }
              if (!(i <= pool.coins.length)) {
                _context.next = 12;
                break;
              }
              return _context.abrupt("continue", 19);
            case 12:
              label = "amount".concat(i);
              if (input[label]) {
                _context.next = 15;
                break;
              }
              return _context.abrupt("continue", 19);
            case 15:
              input[label].hidden = true;
              input[label].readonly = true;
              input[label].required = false;
              input[label].decimals = 0;
            case 19:
              i++;
              _context.next = 9;
              break;
            case 22:
              return _context.abrupt("return", {
                params: {
                  methodParams: {
                    amounts: methodParams.amounts.value
                  }
                },
                error: undefined
              });
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getParams() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      get: getParams,
      depParamKeys: ['to', 'amount1', 'amount2', 'amount3', 'amount4']
    };
  },
  getSubscribtions: function getSubscribtions(_ref4) {
    _objectDestructuringEmpty(_ref4);
    return [{
      callback: function callback(params) {
        if (!params) return;
        var input = params;
        var setAmount = function setAmount(amountNumber) {
          var amountsValue = input.methodParams.amounts.value || [];
          var amountLabel = "amount".concat(amountNumber);
          var inputAmount = input[amountLabel];
          var amountIndex = Number(amountNumber) - 1;
          if (inputAmount.hidden) {
            var amounts = amountsValue.slice(0, amountIndex);
            input.methodParams.amounts.setQuiet({
              value: amounts
            });
            return;
          }
          amountsValue[amountIndex] = inputAmount.value || '0';
          input.methodParams.amounts.setQuiet({
            value: amountsValue
          });
        };
        setAmount('1');
        setAmount('2');
        setAmount('3');
        setAmount('4');
        return;
      },
      id: 'set_amounts_array'
    }];
  }
  // onCreate: ({ input }) => {
  //   const setAmount = (amountNumber: "1" | "2" | "3" | "4") => {
  //     const amountsValue = input.methodParams.amounts.value || []
  //     const amountLabel = `amount${amountNumber}` as const
  //     const inputAmount = input[amountLabel]
  //     const amountIndex = Number(amountNumber) - 1

  //     if (inputAmount.hidden) {
  //       const amounts = amountsValue.slice(0, amountIndex)
  //       input.methodParams.amounts.set({ value: amounts })
  //       return
  //     }

  //     amountsValue[amountIndex] = inputAmount.value || '0'
  //     input.methodParams.amounts.set({ value: amountsValue })
  //   }

  //   input.amount1.subscribe({
  //     callback: () => {
  //       setAmount('1')
  //     },
  //     id: 'set amount1',
  //   })

  //   input.amount2.subscribe({
  //     callback: () => {
  //       setAmount('2')
  //     },
  //     id: 'set amount2',
  //   })

  //   input.amount3.subscribe({
  //     callback: () => {
  //       setAmount('3')
  //     },
  //     id: 'set amount3',
  //   })

  //   input.amount4.subscribe({
  //     callback: () => {
  //       setAmount('4')
  //     },
  //     id: 'set amount4',
  //   })

  //   setAmount('1')
  //   setAmount('2')
  //   setAmount('3')
  //   setAmount('4')
  // },
});

/* eslint-disable no-restricted-imports */
var GetBestRate = createPlugin({
  protocol: 'CURVE',
  type: 'GETTER',
  method: 'get_best_rate',
  description: 'Get the best rate for a token exchange on Curve Finance',
  supportedContracts: [{
    address: '0x55B916Ce078eA594c10a874ba67eCc3d62e29822',
    chainId: 1
  }],
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({
          destination: 'curve_exchange'
        }),
        methodParams: {
          from: new FctAddress({
            destination: 'erc20'
          }),
          to: new FctAddress({
            destination: 'erc20'
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          })
        }
      },
      output: {
        poolAddress: new FctAddress({
          innerIndex: 0,
          destination: 'curve_pool'
        }),
        expectedAmount: new FctValue({
          innerIndex: 1,
          destination: 'wei_amount'
        })
      }
    };
  }
});

var GetExchangeAmount = createPlugin({
  protocol: 'CURVE',
  type: 'GETTER',
  method: 'get_exchange_amount',
  description: 'Get the amount of tokens received for a token exchange on Curve Finance',
  supportedContracts: [{
    address: '0x55B916Ce078eA594c10a874ba67eCc3d62e29822',
    chainId: 1
  }],
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'curve_exchange'
        }),
        methodParams: {
          pool: new FctAddress({
            destination: 'curve_pool',
            options: supportedPools.filter(function (pool) {
              return pool.chainId === Number(chainId);
            })
          }),
          from: new FctAddress({
            destination: 'erc20'
          }),
          to: new FctAddress({
            destination: 'erc20'
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          })
        }
      },
      output: {
        toBeReceivedAmount: new FctValue({
          innerIndex: 0,
          destination: 'wei_amount'
        })
      }
    };
  },
  initParams: {
    to: '0x55B916Ce078eA594c10a874ba67eCc3d62e29822'
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref2) {
    var input = _ref2.input,
      chainId = _ref2.chainId;
    var getParamsAsync = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var address, from, to;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              address = input.methodParams.pool.value;
              from = input.methodParams.from;
              to = input.methodParams.to;
              if (address) {
                _context.next = 7;
                break;
              }
              from.options = [];
              to.options = [];
              return _context.abrupt("return", {
                params: {},
                error: undefined
              });
            case 7:
              from.options = getSupportedTokens$1(address, chainId);
              to.options = getSupportedTokens$1(address, chainId);
              return _context.abrupt("return", {
                params: {},
                error: undefined
              });
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getParamsAsync() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      get: getParamsAsync,
      depParamKeys: ['methodParams.pool']
    };
  }
});

var Locked = createPlugin({
  protocol: 'CURVE',
  type: 'GETTER',
  method: 'locked',
  name: 'lockedCurveTokenAmount',
  description: 'Get information about the current CRV lock for an address.',
  supportedContracts: votingEscrowContract,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({
          destination: 'curve_voting_escrow',
          options: votingEscrowContract
        }),
        methodParams: {
          user: new FctAddress({})
        }
      },
      output: {
        amount: new FctValue18({
          destination: 'wei_amount',
          innerIndex: 0
        }),
        end: new FctTimestamp({
          innerIndex: 1
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var actions$g = {
  AddLiquidity: AddLiquidity,
  RemoveLiquidityOneCoin: RemoveLiquidityOneCoin,
  Stake: Stake,
  Unstake: Unstake,
  CreateLock: CreateLock,
  IncreaseAmount: IncreaseAmount,
  IncreaseUnlockTime: IncreaseUnlockTime,
  Withdraw: Withdraw$3,
  ExchangeOnPool: ExchangeOnPool
};
var getters$e = {
  GetExchangeAmount: GetExchangeAmount,
  CalculateTokenAmount: CalculateTokenAmount,
  GetBestRate: GetBestRate,
  Locked: Locked
};
var Curve = {
  actions: actions$g,
  getters: getters$e
};

/* eslint-disable no-restricted-imports */
var Approve$1 = createPlugin({
  protocol: 'ERC20',
  type: 'ACTION',
  method: 'approve',
  falseMeansFail: true,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc20',
          options: getSupportedTokens({
            chainId: chainId
          })
        }),
        methodParams: {
          spender: new FctAddress({}),
          amount: new FctValue({
            destination: 'wei_amount'
          })
        }
      },
      output: {}
    };
  }
});

/* eslint-disable no-restricted-imports */
var SimpleTransfer = createPlugin({
  protocol: 'ERC20',
  type: 'ACTION',
  method: 'transfer',
  name: 'simpleTransfer',
  falseMeansFail: true,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc20',
          options: getSupportedTokens({
            chainId: chainId
          })
        }),
        methodParams: {
          from: new FctAddress({}),
          to: new FctAddress({}),
          amount: new FctValue({
            destination: 'wei_amount'
          })
        }
      },
      output: {}
    };
  },
  overrideSetMethodParams: function overrideSetMethodParams(_ref2) {
    var input = _ref2.input;
    return function (params, method) {
      if (method === 'transferFrom') {
        Object.keys(input.methodParams).forEach(function (key, i) {
          var paramKey = key;
          input.methodParams[paramKey].value = params[i];
        });
      }
      if (method === 'transfer') {
        input.methodParams.to.value = params[0];
        input.methodParams.amount.value = params[1];
      }
    };
  },
  getSubscribtions: function getSubscribtions(_ref3) {
    var setMethod = _ref3.setMethod,
      vaultAddress = _ref3.vaultAddress;
    return [{
      callback: function callback(params) {
        if (!params) return;
        var from = params.methodParams.from;
        var address = from === null || from === void 0 ? void 0 : from.value;
        if (address && vaultAddress && vaultAddress.toLowerCase() === address.toLowerCase()) {
          from.virtual = true;
          setMethod('transfer');
          return;
        }
        from.virtual = false;
        setMethod('transferFrom');
        return;
      },
      id: 'set_method_name'
    }];
  },
  requiredApprovals: function requiredApprovals(params, _chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      _params$methodParams = params.methodParams,
      amount = _params$methodParams.amount,
      from = _params$methodParams.from;
    if (!vaultAddress) return [];
    var address = from.value;
    if (vaultAddress && vaultAddress.toLowerCase() === address.toLowerCase()) return [];
    var value;
    if (typeof amount.value === 'string') {
      value = amount.value;
    }
    if (!value && typeof amount.estimatedValue === 'string') {
      value = amount.estimatedValue;
    }
    if (!value) return [];
    return [{
      to: to.value,
      from: from.value,
      params: {
        spender: vaultAddress,
        amount: value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  assetFlow: function assetFlow(params) {
    var to = params.to,
      _params$methodParams2 = params.methodParams,
      amount = _params$methodParams2.amount,
      from = _params$methodParams2.from,
      receiver = _params$methodParams2.to;
    if (!from.value || !to.value || !amount.value || !receiver.value) return [];
    if (typeof from.value !== 'string' || typeof receiver.value !== 'string') return [];
    return [{
      address: from.value,
      toSpend: [{
        token: to.value,
        amount: amount.value
      }],
      toReceive: []
    }, {
      address: receiver.value,
      toSpend: [],
      toReceive: [{
        token: to.value,
        amount: amount.value
      }]
    }];
  }
});

/* eslint-disable no-restricted-imports */
var Transfer = createPlugin({
  protocol: 'ERC20',
  type: 'ACTION',
  method: 'transfer',
  falseMeansFail: true,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc20',
          options: getSupportedTokens({
            chainId: chainId
          })
        }),
        methodParams: {
          recipient: new FctAddress({}),
          amount: new FctValue({
            destination: 'wei_amount'
          })
        }
      },
      output: {}
    };
  }
});

/* eslint-disable no-restricted-imports */
var TransferFrom$1 = createPlugin({
  protocol: 'ERC20',
  type: 'ACTION',
  method: 'transferFrom',
  falseMeansFail: true,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc20',
          options: getSupportedTokens({
            chainId: chainId
          })
        }),
        methodParams: {
          from: new FctAddress({}),
          to: new FctAddress({}),
          amount: new FctValue({
            destination: 'wei_amount'
          })
        }
      },
      output: {}
    };
  },
  requiredApprovals: function requiredApprovals(params, _chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      _params$methodParams = params.methodParams,
      amount = _params$methodParams.amount,
      from = _params$methodParams.from;
    if (!vaultAddress) return [];
    var address = from.value;
    if (vaultAddress && vaultAddress.toLowerCase() === address.toLowerCase()) return [];
    var value;
    if (typeof amount.value === 'string') {
      value = amount.value;
    }
    if (!value && typeof amount.estimatedValue === 'string') {
      value = amount.estimatedValue;
    }
    if (!value) return [];
    return [{
      to: to.value,
      from: from.value,
      params: {
        spender: vaultAddress,
        amount: value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

/* eslint-disable no-restricted-imports */
var Allowance = createPlugin({
  protocol: 'ERC20',
  type: 'GETTER',
  method: 'allowance',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc20',
          options: getSupportedTokens({
            chainId: chainId
          })
        }),
        methodParams: {
          owner: new FctAddress({}),
          spender: new FctAddress({})
        }
      },
      output: {
        allowance: new FctValue({
          destination: 'wei_amount',
          innerIndex: 0
        })
      }
    };
  }
});

var BalanceOf$2 = createPlugin({
  protocol: 'ERC20',
  type: 'GETTER',
  method: 'balanceOf',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc20',
          options: getSupportedTokens({
            chainId: chainId
          })
        }),
        methodParams: {
          owner: new FctAddress({})
        }
      },
      output: {
        balance: new FctValue({
          destination: 'wei_amount',
          innerIndex: 0
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var Decimals = createPlugin({
  protocol: 'ERC20',
  type: 'GETTER',
  method: 'decimals',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc20',
          options: getSupportedTokens({
            chainId: chainId
          })
        }),
        methodParams: {}
      },
      output: {
        decimals: new FctDecimals({
          innerIndex: 0
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var Name$1 = createPlugin({
  protocol: 'ERC20',
  type: 'GETTER',
  method: 'name',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc20',
          options: getSupportedTokens({
            chainId: chainId
          })
        }),
        methodParams: {}
      },
      output: {
        name: new FctString({
          innerIndex: 0
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var _Symbol$1 = createPlugin({
  protocol: 'ERC20',
  type: 'GETTER',
  method: 'symbol',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc20',
          options: getSupportedTokens({
            chainId: chainId
          })
        }),
        methodParams: {}
      },
      output: {
        symbol: new FctString({
          innerIndex: 0
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var TotalSupply$1 = createPlugin({
  protocol: 'ERC20',
  type: 'GETTER',
  method: 'totalSupply',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc20',
          options: getSupportedTokens({
            chainId: chainId
          })
        }),
        methodParams: {}
      },
      output: {
        totalSupply: new FctValue({
          destination: 'wei_amount',
          innerIndex: 0
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var actions$f = {
  Transfer: Transfer,
  Approve: Approve$1,
  TransferFrom: TransferFrom$1,
  SimpleTransfer: SimpleTransfer
};
var getters$d = {
  Allowance: Allowance,
  BalanceOf: BalanceOf$2,
  Decimals: Decimals,
  Name: Name$1,
  Symbol: _Symbol$1,
  TotalSupply: TotalSupply$1
};
var ERC20 = {
  actions: actions$f,
  getters: getters$d
};

var Approve = createPlugin({
  protocol: 'ERC721',
  type: 'ACTION',
  method: 'approve',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc721'
        }),
        methodParams: {
          to: new FctAddress({}),
          tokenId: new FctValue({})
        }
      },
      output: {}
    };
  }
});

var SafeTransferFrom$1 = createPlugin({
  protocol: 'ERC721',
  type: 'ACTION',
  method: 'safeTransferFrom',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc721'
        }),
        methodParams: {
          from: new FctAddress({}),
          to: new FctAddress({}),
          tokenId: new FctValue({})
        }
      },
      output: {}
    };
  },
  requiredApprovals: function requiredApprovals(params, _chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      tokenId = params.methodParams.tokenId;
    if (!vaultAddress) return [];
    var from = params.methodParams.from.value;
    if (!vaultAddress || typeof from === 'string' && vaultAddress.toLowerCase() === from.toLowerCase()) return [];
    return [{
      to: to.value,
      from: from,
      params: {
        to: vaultAddress,
        tokenId: tokenId.value
      },
      method: 'approve',
      protocol: 'ERC721'
    }];
  }
});

var SetApprovalForAll$1 = createPlugin({
  protocol: 'ERC721',
  type: 'ACTION',
  method: 'setApprovalForAll',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc721'
        }),
        methodParams: {
          operator: new FctAddress({}),
          _approved: new FctBoolean({})
        }
      },
      output: {}
    };
  }
});

var TransferFrom = createPlugin({
  protocol: 'ERC721',
  type: 'ACTION',
  method: 'transferFrom',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc721'
        }),
        methodParams: {
          from: new FctAddress({}),
          to: new FctAddress({}),
          tokenId: new FctValue({})
        }
      },
      output: {}
    };
  },
  requiredApprovals: function requiredApprovals(params, _chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      tokenId = params.methodParams.tokenId;
    if (!vaultAddress) return [];
    var from = params.methodParams.from.value;
    if (!vaultAddress || typeof from === 'string' && vaultAddress.toLowerCase() === from.toLowerCase()) return [];
    return [{
      to: to.value,
      from: from,
      params: {
        to: vaultAddress,
        tokenId: tokenId.value
      },
      method: 'approve',
      protocol: 'ERC721'
    }];
  }
});

var BalanceOf$1 = createPlugin({
  protocol: 'ERC721',
  type: 'GETTER',
  method: 'balanceOf',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc721'
        }),
        methodParams: {
          owner: new FctAddress({})
        }
      },
      output: {
        balance: new FctValue({
          destination: 'wei_amount',
          innerIndex: 0
        })
      }
    };
  }
});

var GetApproved = createPlugin({
  protocol: 'ERC721',
  type: 'GETTER',
  method: 'getApproved',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc721'
        }),
        methodParams: {
          tokenId: new FctValue({})
        }
      },
      output: {
        operator: new FctAddress({
          innerIndex: 0
        })
      }
    };
  }
});

var IsApprovedForAll$1 = createPlugin({
  protocol: 'ERC721',
  type: 'GETTER',
  method: 'isApprovedForAll',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc721'
        }),
        methodParams: {
          owner: new FctAddress({}),
          operator: new FctAddress({})
        }
      },
      output: {
        isApproved: new FctBoolean({
          innerIndex: 0
        })
      }
    };
  }
});

var Name = createPlugin({
  protocol: 'ERC721',
  type: 'GETTER',
  method: 'name',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc721'
        }),
        methodParams: {}
      },
      output: {
        undefined: new FctString({
          innerIndex: 0
        })
      }
    };
  }
});

var OwnerOf = createPlugin({
  protocol: 'ERC721',
  type: 'GETTER',
  method: 'ownerOf',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc721'
        }),
        methodParams: {
          tokenId: new FctValue({})
        }
      },
      output: {
        owner: new FctAddress({
          innerIndex: 0
        })
      }
    };
  }
});

var SupportsInterface$2 = createPlugin({
  protocol: 'ERC721',
  type: 'GETTER',
  method: 'supportsInterface',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc721'
        }),
        methodParams: {
          interfaceId: new FctBytes4({})
        }
      },
      output: {
        isSupports: new FctBoolean({
          innerIndex: 0
        })
      }
    };
  }
});

var _Symbol = createPlugin({
  protocol: 'ERC721',
  type: 'GETTER',
  method: 'symbol',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc721'
        }),
        methodParams: {}
      },
      output: {
        symbol: new FctString({
          innerIndex: 0
        })
      }
    };
  }
});

var TokenURI = createPlugin({
  protocol: 'ERC721',
  type: 'GETTER',
  method: 'tokenURI',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc721'
        }),
        methodParams: {
          tokenId: new FctValue({})
        }
      },
      output: {
        uri: new FctString({
          innerIndex: 0
        })
      }
    };
  }
});

var TotalSupply = createPlugin({
  protocol: 'ERC721',
  type: 'GETTER',
  method: 'totalSupply',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc721'
        }),
        methodParams: {}
      },
      output: {
        totalSupply: new FctValue({
          innerIndex: 0,
          destination: 'wei_amount'
        })
      }
    };
  }
});

var actions$e = {
  Approve: Approve,
  SafeTransferFrom: SafeTransferFrom$1,
  SetApprovalForAll: SetApprovalForAll$1,
  TransferFrom: TransferFrom
};
var getters$c = {
  TotalSupply: TotalSupply,
  BalanceOf: BalanceOf$1,
  GetApproved: GetApproved,
  IsApprovedForAll: IsApprovedForAll$1,
  Name: Name,
  OwnerOf: OwnerOf,
  SupportsInterface: SupportsInterface$2,
  Symbol: _Symbol,
  TokenURI: TokenURI
};
var ERC721 = {
  actions: actions$e,
  getters: getters$c
};

var SafeBatchTransferFrom = createPlugin({
  protocol: 'ERC1155',
  type: 'ACTION',
  method: 'safeBatchTransferFrom',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc1155'
        }),
        methodParams: {
          from: new FctAddress({}),
          to: new FctAddress({}),
          ids: new FctValueList({}),
          amounts: new FctValueList({}),
          data: new FctBytes({
            readonly: true
          })
        }
      },
      output: {}
    };
  },
  initParams: {
    methodParams: {
      data: '0x'
    }
  },
  requiredApprovals: function requiredApprovals(params, _chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      methodParams = params.methodParams;
    var from = methodParams.from.value;
    if (!vaultAddress || typeof from === 'string' && vaultAddress.toLowerCase() === from.toLowerCase()) return [];
    return [{
      to: to.value,
      from: from,
      params: {
        operator: to.value,
        approved: 'true'
      },
      method: 'setApprovalForAll',
      protocol: 'ERC1155'
    }];
  }
});

var SafeTransferFrom = createPlugin({
  protocol: 'ERC1155',
  type: 'ACTION',
  method: 'safeTransferFrom',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc1155'
        }),
        methodParams: {
          from: new FctAddress({}),
          to: new FctAddress({}),
          id: new FctValue({}),
          amount: new FctValue({}),
          data: new FctBytes({
            readonly: true
          })
        }
      },
      output: {}
    };
  },
  initParams: {
    methodParams: {
      data: '0x'
    }
  },
  requiredApprovals: function requiredApprovals(params, _chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      methodParams = params.methodParams;
    var from = methodParams.from.value;
    if (!vaultAddress || typeof from === 'string' && vaultAddress.toLowerCase() === from.toLowerCase()) return [];
    return [{
      to: to.value,
      from: from,
      params: {
        operator: vaultAddress,
        approved: 'true',
        ids: [methodParams.id.value]
      },
      method: 'setApprovalForAll',
      protocol: 'ERC1155'
    }];
  }
});

var SetApprovalForAll = createPlugin({
  protocol: 'ERC1155',
  type: 'ACTION',
  method: 'setApprovalForAll',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc1155'
        }),
        methodParams: {
          operator: new FctAddress({}),
          approved: new FctBoolean({})
        }
      },
      output: {}
    };
  }
});

var BalanceOf = createPlugin({
  protocol: 'ERC1155',
  type: 'GETTER',
  method: 'balanceOf',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc1155'
        }),
        methodParams: {
          account: new FctAddress({}),
          id: new FctValue({})
        }
      },
      output: {
        balance: new FctValue({
          destination: 'wei_amount',
          innerIndex: 0
        })
      }
    };
  }
});

var IsApprovedForAll = createPlugin({
  protocol: 'ERC1155',
  type: 'GETTER',
  method: 'isApprovedForAll',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc1155'
        }),
        methodParams: {
          account: new FctAddress({}),
          operator: new FctAddress({})
        }
      },
      output: {
        isApproved: new FctBoolean({
          innerIndex: 0
        })
      }
    };
  }
});

var SupportsInterface$1 = createPlugin({
  protocol: 'ERC1155',
  type: 'GETTER',
  method: 'supportsInterface',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc1155'
        }),
        methodParams: {
          interfaceId: new FctBytes4({})
        }
      },
      output: {
        isSupports: new FctBoolean({
          innerIndex: 0
        })
      }
    };
  }
});

var Uri = createPlugin({
  protocol: 'ERC1155',
  type: 'GETTER',
  method: 'uri',
  supportedContracts: undefined,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'erc1155'
        }),
        methodParams: {
          id: new FctValue({})
        }
      },
      output: {
        uri: new FctString({
          innerIndex: 0
        })
      }
    };
  }
});

var actions$d = {
  SafeBatchTransferFrom: SafeBatchTransferFrom,
  SafeTransferFrom: SafeTransferFrom,
  SetApprovalForAll: SetApprovalForAll
};
var getters$b = {
  BalanceOf: BalanceOf,
  IsApprovedForAll: IsApprovedForAll,
  SupportsInterface: SupportsInterface$1,
  Uri: Uri
};
var ERC1155 = {
  actions: actions$d,
  getters: getters$b
};

var fctUniswapContracts = [{
  chainId: 1,
  address: '0x7501Ac7b420eF83e856dCD432aa5b81F5e65B292'
}, {
  chainId: 5,
  address: '0xf0464C50e35f437fa18d19338246106a0f962d97'
}, {
  chainId: 11155111,
  address: '0x300C0306F48ddd0b335F092872AC9ab8B4aC8406'
}];
var method$2 = {
  swapExactETHForTokens: 'swap <amount> ETH for <X> Tokens',
  swapExactTokensForETH: 'swap <amount> Tokens for <X> ETH',
  swapETHForExactTokens: 'swap <X> ETH for <amount> Tokens',
  swapTokensForExactETH: 'swap <X> Tokens for <amount> ETH',
  swapExactTokensForTokens: 'swap <amount> Tokens for <X> Tokens',
  swapTokensForExactTokens: 'swap <X> Tokens for <amount> Tokens'
};
var liquidity_method = {
  addLiquidity: 'add tokens to the liquidity pool',
  addLiquidityTokenEth: 'add token and eth to the liquidity pool',
  addLiquidityEthToken: 'add eth and token to the liquidity pool'
};
var ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

var getAddLiquidityGasLimit = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var tokenA, tokenB, chainId, isPairExist, addLiquidityGasLimit;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          tokenA = _ref.tokenA, tokenB = _ref.tokenB, chainId = _ref.chainId;
          _context.next = 3;
          return new Uniswap({
            chainId: chainId,
            account: '0xf08fD75cCed9Eb65cff7451291Bf41e91c8457eD'
          }).isPairExist({
            token0: tokenA,
            token1: tokenB
          });
        case 3:
          isPairExist = _context.sent;
          addLiquidityGasLimit = gasLimit[chainId].UNISWAP.addLiquidity;
          return _context.abrupt("return", isPairExist ? addLiquidityGasLimit : BigNumber.from(addLiquidityGasLimit).mul(BigNumber.from('10')).toString());
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getAddLiquidityGasLimit(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var method$1 = 'addLiquidity_noMinProtection';
var SimpleAddLiquidity = createPlugin({
  protocol: 'UNISWAP',
  type: 'LIBRARY',
  method: method$1,
  description: 'Add liquidity on Uniswap',
  supportedContracts: fctUniswapContracts,
  toEns: '@lib:uniswap_v2',
  initParams: {
    methodParams: {
      method: liquidity_method.addLiquidity,
      amountADesired: '0',
      amountBDesired: '0'
    }
  },
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        methodParams: {
          method: new FctBytes32({
            messageType: 'string',
            options: Object.keys(liquidity_method).map(function (key) {
              var methodKey = key;
              return {
                name: key,
                value: liquidity_method[methodKey]
              };
            })
          }),
          tokenA: new FctAddress({
            destination: 'erc20',
            options: getAllCurrencies({
              chainId: chainId
            })
          }),
          tokenB: new FctAddress({
            destination: 'erc20',
            options: getAllCurrencies({
              chainId: chainId
            })
          }),
          amountADesired: new FctValue({
            destination: 'wei_amount'
          }),
          amountBDesired: new FctValue({
            destination: 'wei_amount'
          })
        }
      },
      output: {
        amountA: new FctValue({
          destination: 'wei_amount',
          innerIndex: 0
        }),
        amountB: new FctValue({
          destination: 'wei_amount',
          innerIndex: 1
        }),
        liquidity: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2
        })
      }
    };
  },
  getParamsOnCreate: function () {
    var _getParamsOnCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var chainId, params, _params$methodParams, amountADesired, amountBDesired, tokenA, tokenB, requiredParamsExact, _i, _requiredParamsExact, param, isCurrencyANative, isCurrencyBNative, gasLimit;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            chainId = _ref2.chainId, params = _ref2.params;
            _params$methodParams = params.methodParams, amountADesired = _params$methodParams.amountADesired, amountBDesired = _params$methodParams.amountBDesired, tokenA = _params$methodParams.tokenA, tokenB = _params$methodParams.tokenB;
            requiredParamsExact = [{
              value: amountADesired.value,
              key: 'amountADesired'
            }, {
              value: amountBDesired.value,
              key: 'amountBDesired'
            }];
            _i = 0, _requiredParamsExact = requiredParamsExact;
          case 4:
            if (!(_i < _requiredParamsExact.length)) {
              _context.next = 12;
              break;
            }
            param = _requiredParamsExact[_i];
            if (param.value) {
              _context.next = 9;
              break;
            }
            console.error("wrong param ".concat(param.key, ": ").concat(param.value));
            return _context.abrupt("return");
          case 9:
            _i++;
            _context.next = 4;
            break;
          case 12:
            isCurrencyANative = false;
            if (typeof tokenA.value === 'string') {
              isCurrencyANative = getIsNative(tokenA.value);
              if (isCurrencyANative) {
                params.methodParams.method.set({
                  value: liquidity_method.addLiquidityEthToken
                });
                tokenA.set({
                  value: ZERO_ADDRESS
                });
              }
            }
            isCurrencyBNative = false;
            if (typeof tokenB.value === 'string') {
              isCurrencyBNative = getIsNative(tokenB.value);
              if (isCurrencyBNative) {
                params.methodParams.method.set({
                  value: liquidity_method.addLiquidityTokenEth
                });
                tokenB.set({
                  value: ZERO_ADDRESS
                });
              }
            }
            if (amountADesired.isVariable && !amountBDesired.isVariable) {
              amountBDesired.set({
                value: maxValue
              });
            }
            if (!amountADesired.isVariable && amountBDesired.isVariable) {
              amountADesired.set({
                value: maxValue
              });
            }
            if (!params.methodParams.method.value) {
              params.methodParams.method.set({
                value: liquidity_method.addLiquidity
              });
            }
            _context.next = 21;
            return getAddLiquidityGasLimit({
              tokenA: tokenA.value,
              tokenB: tokenB.value,
              chainId: chainId
            });
          case 21:
            gasLimit = _context.sent;
            return _context.abrupt("return", {
              params: params,
              method: method$1,
              gasLimit: gasLimit
            });
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function getParamsOnCreate(_x) {
      return _getParamsOnCreate.apply(this, arguments);
    }
    return getParamsOnCreate;
  }(),
  requiredApprovals: function requiredApprovals(params, chainId) {
    return [{
      to: params.methodParams.tokenA.value,
      params: {
        spender: ROUTER_V2_ADDRESS[chainId],
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amountADesired.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }, {
      to: params.methodParams.tokenB.value,
      params: {
        spender: ROUTER_V2_ADDRESS[chainId],
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amountBDesired.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }].filter(function (item) {
      return typeof item.to === 'string' ? !getIsNative(item.to) : true;
    });
  }
});

var method = 'addLiquidityTo_noMinProtection';
var SimpleAddLiquidityTo = createPlugin({
  protocol: 'UNISWAP',
  type: 'LIBRARY',
  method: method,
  description: 'Add liquidity on Uniswap with LP tokens recipient address',
  supportedContracts: fctUniswapContracts,
  toEns: '@lib:uniswap_v2',
  initParams: {
    methodParams: {
      to: ZERO_ADDRESS,
      method: liquidity_method.addLiquidity,
      amountADesired: '0',
      amountBDesired: '0'
    }
  },
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'uniswap_router'
        }),
        methodParams: {
          method: new FctBytes32({
            messageType: 'string',
            options: Object.keys(liquidity_method).map(function (key) {
              var methodKey = key;
              return {
                name: key,
                value: liquidity_method[methodKey]
              };
            })
          }),
          tokenA: new FctAddress({
            destination: 'erc20',
            options: getAllCurrencies({
              chainId: chainId
            })
          }),
          tokenB: new FctAddress({
            destination: 'erc20',
            options: getAllCurrencies({
              chainId: chainId
            })
          }),
          amountADesired: new FctValue({
            destination: 'wei_amount'
          }),
          amountBDesired: new FctValue({
            destination: 'wei_amount'
          }),
          to: new FctAddress({})
        }
      },
      output: {
        amountA: new FctValue({
          destination: 'wei_amount',
          innerIndex: 0
        }),
        amountB: new FctValue({
          destination: 'wei_amount',
          innerIndex: 1
        }),
        liquidity: new FctValue({
          destination: 'wei_amount',
          innerIndex: 2
        })
      }
    };
  },
  getParamsOnCreate: function () {
    var _getParamsOnCreate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var chainId, params, _params$methodParams, amountADesired, amountBDesired, tokenA, tokenB, requiredParamsExact, _i, _requiredParamsExact, param, isCurrencyANative, isCurrencyBNative, gasLimit;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            chainId = _ref2.chainId, params = _ref2.params;
            _params$methodParams = params.methodParams, amountADesired = _params$methodParams.amountADesired, amountBDesired = _params$methodParams.amountBDesired, tokenA = _params$methodParams.tokenA, tokenB = _params$methodParams.tokenB;
            requiredParamsExact = [{
              value: amountADesired.value,
              key: 'amountADesired'
            }, {
              value: amountBDesired.value,
              key: 'amountBDesired'
            }];
            _i = 0, _requiredParamsExact = requiredParamsExact;
          case 4:
            if (!(_i < _requiredParamsExact.length)) {
              _context.next = 12;
              break;
            }
            param = _requiredParamsExact[_i];
            if (param.value) {
              _context.next = 9;
              break;
            }
            console.error("wrong param ".concat(param.key, ": ").concat(param.value));
            return _context.abrupt("return");
          case 9:
            _i++;
            _context.next = 4;
            break;
          case 12:
            isCurrencyANative = false;
            if (typeof tokenA.value === 'string') {
              isCurrencyANative = getIsNative(tokenA.value);
              if (isCurrencyANative) {
                params.methodParams.method.set({
                  value: liquidity_method.addLiquidityEthToken
                });
                tokenA.set({
                  value: ZERO_ADDRESS
                });
              }
            }
            isCurrencyBNative = false;
            if (typeof tokenB.value === 'string') {
              isCurrencyBNative = getIsNative(tokenB.value);
              if (isCurrencyBNative) {
                params.methodParams.method.set({
                  value: liquidity_method.addLiquidityTokenEth
                });
                tokenB.set({
                  value: ZERO_ADDRESS
                });
              }
            }
            if (amountADesired.isVariable && !amountBDesired.isVariable) {
              amountBDesired.set({
                value: maxValue
              });
            }
            if (!amountADesired.isVariable && amountBDesired.isVariable) {
              amountADesired.set({
                value: maxValue
              });
            }
            if (!params.methodParams.method.value) {
              params.methodParams.method.set({
                value: liquidity_method.addLiquidity
              });
            }
            _context.next = 21;
            return getAddLiquidityGasLimit({
              tokenA: tokenA.value,
              tokenB: tokenB.value,
              chainId: chainId
            });
          case 21:
            gasLimit = _context.sent;
            return _context.abrupt("return", {
              params: params,
              method: method,
              gasLimit: gasLimit
            });
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function getParamsOnCreate(_x) {
      return _getParamsOnCreate.apply(this, arguments);
    }
    return getParamsOnCreate;
  }(),
  requiredApprovals: function requiredApprovals(params, chainId) {
    return [{
      to: params.methodParams.tokenA.value,
      params: {
        spender: ROUTER_V2_ADDRESS[chainId],
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amountADesired.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }, {
      to: params.methodParams.tokenB.value,
      params: {
        spender: ROUTER_V2_ADDRESS[chainId],
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amountBDesired.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }].filter(function (item) {
      return typeof item.to === 'string' ? !getIsNative(item.to) : true;
    });
  }
});

var SwapNoSlippageProtection = createPlugin({
  protocol: 'UNISWAP',
  type: 'LIBRARY',
  method: 'swap_noSlippageProtection',
  supportedContracts: fctUniswapContracts,
  toEns: '@lib:uniswap_v2',
  initParams: {
    isExactIn: 'true'
  },
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        addressIn: new FctAddress({
          destination: 'erc20',
          mode: 'INPUT',
          options: getAllCurrencies({
            chainId: chainId
          })
        }),
        amountIn: new FctValue({
          destination: 'wei_amount'
        }),
        addressOut: new FctAddress({
          destination: 'erc20',
          mode: 'INPUT',
          options: getAllCurrencies({
            chainId: chainId
          })
        }),
        amountOut: new FctValue({
          destination: 'wei_amount'
        }),
        isExactIn: new FctBoolean({}),
        snipperMode: new FctBoolean({}),
        methodParams: {
          amount: new FctValue({
            destination: 'wei_amount',
            readonly: true
          }),
          method: new FctBytes32({
            messageType: 'string',
            options: Object.keys(method$2).map(function (key) {
              var methodKey = key;
              return {
                name: key,
                value: method$2[methodKey]
              };
            })
          }),
          path: new FctAddressList({
            destination: 'ERC20_List'
          })
        }
      },
      output: {
        amountIn: new FctValue({
          innerIndex: 0,
          destination: 'wei_amount'
        }),
        amountOut: new FctValue({
          innerIndex: 1,
          destination: 'wei_amount'
        })
      }
    };
  },
  overrideSetMethodParams: function overrideSetMethodParams(_ref2) {
    var input = _ref2.input;
    return function (params) {
      Object.keys(input.methodParams).forEach(function (key, i) {
        var paramKey = key;
        input.methodParams[paramKey].value = params[i];
      });
      var isExactIn = input.isExactIn.value === 'true';
      if (isExactIn) {
        input.amountIn.value = input.methodParams.amount.value;
      } else {
        input.amountOut.value = input.methodParams.amount.value;
      }
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref3) {
    var input = _ref3.input,
      output = _ref3.output,
      provider = _ref3.provider,
      chainId = _ref3.chainId;
    var getPathParams = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
        var service, isSnipperMode, isExactIn, uniswapService, tokenInAddress, tokenOutAddress, defaultReturn, decimalsIn, decimalsOut, amountIn, amountOut, amount, methodName, methodParamValue, path, isSimulationNeeded, res, swapPath, _methodName, _methodParamValue;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              service = _ref4.service;
              if (service) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              isSnipperMode = input.snipperMode.value === 'true';
              isExactIn = input.isExactIn.value === 'true';
              uniswapService = service;
              tokenInAddress = input.addressIn.value;
              tokenOutAddress = input.addressOut.value;
              if (isExactIn) {
                input.amountIn.readonly = false;
                input.amountOut.readonly = true;
              }
              if (!isExactIn) {
                input.amountIn.readonly = true;
                input.amountOut.readonly = false;
              }
              defaultReturn = isExactIn ? {
                params: {
                  amountOut: undefined,
                  methodParams: {
                    path: undefined,
                    method: undefined,
                    amount: undefined
                  }
                },
                error: undefined
              } : {
                params: {
                  amountIn: undefined,
                  methodParams: {
                    path: undefined,
                    method: undefined,
                    amount: undefined
                  }
                },
                error: undefined
              };
              if (!(!tokenInAddress || !tokenOutAddress || typeof tokenInAddress !== 'string' || typeof tokenOutAddress !== 'string')) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return", defaultReturn);
            case 13:
              if (!provider) {
                _context.next = 19;
                break;
              }
              _context.next = 16;
              return getTokenDecimals({
                address: tokenInAddress,
                provider: provider
              });
            case 16:
              _context.t0 = _context.sent;
              _context.next = 20;
              break;
            case 19:
              _context.t0 = 0;
            case 20:
              decimalsIn = _context.t0;
              if (!provider) {
                _context.next = 27;
                break;
              }
              _context.next = 24;
              return getTokenDecimals({
                address: tokenOutAddress,
                provider: provider
              });
            case 24:
              _context.t1 = _context.sent;
              _context.next = 28;
              break;
            case 27:
              _context.t1 = 0;
            case 28:
              decimalsOut = _context.t1;
              amountIn = output.amountIn, amountOut = output.amountOut;
              amountIn.decimals = decimalsIn;
              amountOut.decimals = decimalsOut;
              amount = isExactIn ? input.amountIn.value : input.amountOut.value;
              if (!(amount === undefined)) {
                _context.next = 35;
                break;
              }
              return _context.abrupt("return", defaultReturn);
            case 35:
              if (!isSnipperMode) {
                _context.next = 42;
                break;
              }
              methodName = getMethodName({
                isExactInput: isExactIn,
                protocol: 'V2',
                isInputNative: getIsNative(tokenInAddress),
                isOutputNative: getIsNative(tokenOutAddress)
              });
              methodParamValue = method$2[methodName];
              path = [tokenInAddress, tokenOutAddress].map(function (tokenAddress) {
                if (getIsNative(tokenAddress)) return WETH9[Number(chainId)].address;
                return tokenAddress;
              });
              if (!isExactIn) {
                _context.next = 41;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountOut: '0',
                  methodParams: {
                    path: path,
                    method: methodParamValue,
                    amount: amount
                  }
                },
                isSimulationNeeded: false,
                error: undefined
              });
            case 41:
              return _context.abrupt("return", {
                params: {
                  amountIn: '0',
                  methodParams: {
                    path: path,
                    method: methodParamValue,
                    amount: amount
                  }
                },
                isSimulationNeeded: false,
                error: undefined
              });
            case 42:
              isSimulationNeeded = false;
              if (!amount || isVariable(amount)) {
                isSimulationNeeded = true;
                amount = '1' + '0'.repeat(isExactIn ? decimalsIn : decimalsOut);
              }
              _context.prev = 44;
              _context.next = 47;
              return uniswapService.create({
                cmd: 'simulateSwap',
                protocol: 'uniswap',
                token_in: tokenInAddress,
                token_in_decimals: decimalsIn,
                token_out: tokenOutAddress,
                token_out_decimals: decimalsOut,
                token_amount: amount,
                version: 'v2',
                type: isExactIn ? 'in' : 'out'
              });
            case 47:
              res = _context.sent;
              swapPath = res === null || res === void 0 ? void 0 : res.path;
              if (swapPath) {
                _context.next = 51;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountIn: isExactIn ? amount : undefined,
                  amountOut: isExactIn ? undefined : amount,
                  methodParams: {
                    path: undefined,
                    amount: undefined,
                    method: undefined
                  }
                },
                error: 'invalid trade'
              });
            case 51:
              _methodName = getMethodName({
                isExactInput: isExactIn,
                protocol: 'V2',
                isInputNative: getIsNative(tokenInAddress),
                isOutputNative: getIsNative(tokenOutAddress)
              });
              _methodParamValue = method$2[_methodName];
              if (!isExactIn) {
                _context.next = 55;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountOut: res.outputAmount,
                  methodParams: {
                    path: swapPath,
                    method: _methodParamValue,
                    amount: amount
                  }
                },
                isSimulationNeeded: isSimulationNeeded,
                error: undefined
              });
            case 55:
              return _context.abrupt("return", {
                params: {
                  amountIn: res.inputAmount,
                  methodParams: {
                    path: swapPath,
                    method: _methodParamValue,
                    amount: amount
                  }
                },
                isSimulationNeeded: isSimulationNeeded,
                error: undefined
              });
            case 58:
              _context.prev = 58;
              _context.t2 = _context["catch"](44);
              return _context.abrupt("return", {
                params: {
                  amountIn: isExactIn ? amount : undefined,
                  amountOut: isExactIn ? undefined : amount,
                  methodParams: {
                    path: undefined,
                    amount: undefined,
                    method: undefined
                  }
                },
                error: _context.t2.message
              });
            case 61:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[44, 58]]);
      }));
      return function getPathParams(_x) {
        return _ref5.apply(this, arguments);
      };
    }();
    var getDepParams = function getDepParams() {
      var isExactIn = input.isExactIn.value === 'true';
      return isExactIn ? ['addressIn', 'addressOut', 'isExactIn', 'snipperMode', 'amountIn'] : ['addressIn', 'addressOut', 'isExactIn', 'snipperMode', 'amountOut'];
    };
    return {
      get: getPathParams,
      depParamKeys: getDepParams
    };
  },
  requiredApprovals: function requiredApprovals(params, chainId) {
    var _params$methodParams = params.methodParams,
      amount = _params$methodParams.amount,
      path = _params$methodParams.path;
    if (params.methodParams.method.value === method$2.swapExactETHForTokens || params.methodParams.method.value === method$2.swapETHForExactTokens) {
      return [];
    }
    return [{
      to: path.value && path.value.length ? path.value[0] : params.addressIn.value || undefined,
      params: {
        spender: ROUTER_V2_ADDRESS[chainId],
        amount: params.amountIn.value || amount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  onCreate: function onCreate(_ref6) {
    var input = _ref6.input;
    var setAmountIn = function setAmountIn() {
      if (input.isExactIn.value !== 'true') return;
      input.methodParams.amount.set({
        value: input.amountIn.value
      });
      input.methodParams.amount.setEstimated({
        value: input.amountIn.estimatedValue
      });
    };
    var setAmountOut = function setAmountOut() {
      if (input.isExactIn.value === 'true') return;
      input.methodParams.amount.set({
        value: input.amountOut.value
      });
      input.methodParams.amount.setEstimated({
        value: input.amountOut.estimatedValue
      });
    };
    input.amountIn.subscribe({
      callback: function callback() {
        setAmountIn();
      },
      id: 'set amount by amountIn'
    });
    input.amountOut.subscribe({
      callback: function callback() {
        setAmountOut();
      },
      id: 'set amount by amountOut'
    });
    input.isExactIn.subscribe({
      callback: function callback(_ref7) {
        var value = _ref7.value;
        if (value === 'true') {
          setAmountIn();
        }
        if (value === 'false') {
          setAmountOut();
        }
      },
      id: 'set amount on isExactIn change'
    });
    setAmountIn();
    setAmountOut();
  },
  estimateGasOnParams: function estimateGasOnParams(params, method, chainId) {
    // base gas 140000
    // 80000 gas for every additional token in the path after 2
    var baseGas = BigNumber.from('140000');
    var path = params.methodParams.path;
    if (!path.value || !path.value.length) {
      return chainId === '42161' || chainId === '421613' ? baseGas.mul(13).toString() : baseGas.toString();
    }
    var gasPerToken = BigNumber.from('80000');
    var gas = baseGas.add(gasPerToken.mul(path.value.length - 2));
    if (chainId === '42161' || chainId === '421613') {
      gas = gas.mul(13);
    }
    return gas.toString();
  }
});

var SwapToNoSlippageProtection = createPlugin({
  protocol: 'UNISWAP',
  type: 'LIBRARY',
  method: 'swapTo_noSlippageProtection',
  supportedContracts: fctUniswapContracts,
  toEns: '@lib:uniswap_v2',
  initParams: {
    isExactIn: 'true'
  },
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        addressIn: new FctAddress({
          destination: 'erc20',
          mode: 'INPUT',
          options: getAllCurrencies({
            chainId: chainId
          })
        }),
        amountIn: new FctValue({
          destination: 'wei_amount'
        }),
        addressOut: new FctAddress({
          destination: 'erc20',
          mode: 'INPUT',
          options: getAllCurrencies({
            chainId: chainId
          })
        }),
        amountOut: new FctValue({
          destination: 'wei_amount'
        }),
        methodParams: {
          amount: new FctValue({
            destination: 'wei_amount',
            readonly: true
          }),
          method: new FctBytes32({
            messageType: 'string',
            options: Object.keys(method$2).map(function (key) {
              var methodKey = key;
              return {
                name: key,
                value: method$2[methodKey]
              };
            })
          }),
          to: new FctAddress({}),
          path: new FctAddressList({
            destination: 'ERC20_List'
          })
        },
        isExactIn: new FctBoolean({}),
        snipperMode: new FctBoolean({})
      },
      output: {
        amountIn: new FctValue({
          innerIndex: 0,
          destination: 'wei_amount'
        }),
        amountOut: new FctValue({
          innerIndex: 1,
          destination: 'wei_amount'
        })
      }
    };
  },
  overrideSetMethodParams: function overrideSetMethodParams(_ref2) {
    var input = _ref2.input;
    return function (params) {
      Object.keys(input.methodParams).forEach(function (key, i) {
        var paramKey = key;
        input.methodParams[paramKey].value = params[i];
      });
      var isExactIn = input.isExactIn.value === 'true';
      if (isExactIn) {
        input.amountIn.value = input.methodParams.amount.value;
      } else {
        input.amountOut.value = input.methodParams.amount.value;
      }
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref3) {
    var input = _ref3.input,
      output = _ref3.output,
      provider = _ref3.provider,
      chainId = _ref3.chainId;
    var getPathParams = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
        var service, isSnipperMode, isExactIn, uniswapService, tokenInAddress, tokenOutAddress, defaultReturn, decimalsIn, decimalsOut, amountIn, amountOut, amount, methodName, methodParamValue, path, isSimulationNeeded, res, swapPath, _methodName, _methodParamValue;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              service = _ref4.service;
              if (service) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              isSnipperMode = input.snipperMode.value === 'true';
              isExactIn = input.isExactIn.value === 'true';
              uniswapService = service;
              tokenInAddress = input.addressIn.value;
              tokenOutAddress = input.addressOut.value;
              if (isExactIn) {
                input.amountIn.readonly = false;
                input.amountOut.readonly = true;
              }
              if (!isExactIn) {
                input.amountIn.readonly = true;
                input.amountOut.readonly = false;
              }
              defaultReturn = isExactIn ? {
                params: {
                  amountOut: undefined,
                  methodParams: {
                    path: undefined,
                    method: undefined,
                    amount: undefined
                  }
                },
                error: undefined
              } : {
                params: {
                  amountIn: undefined,
                  methodParams: {
                    path: undefined,
                    method: undefined,
                    amount: undefined
                  }
                },
                error: undefined
              };
              if (!(!tokenInAddress || !tokenOutAddress || typeof tokenInAddress !== 'string' || typeof tokenOutAddress !== 'string')) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return", defaultReturn);
            case 13:
              if (!provider) {
                _context.next = 19;
                break;
              }
              _context.next = 16;
              return getTokenDecimals({
                address: tokenInAddress,
                provider: provider
              });
            case 16:
              _context.t0 = _context.sent;
              _context.next = 20;
              break;
            case 19:
              _context.t0 = 0;
            case 20:
              decimalsIn = _context.t0;
              if (!provider) {
                _context.next = 27;
                break;
              }
              _context.next = 24;
              return getTokenDecimals({
                address: tokenOutAddress,
                provider: provider
              });
            case 24:
              _context.t1 = _context.sent;
              _context.next = 28;
              break;
            case 27:
              _context.t1 = 0;
            case 28:
              decimalsOut = _context.t1;
              amountIn = output.amountIn, amountOut = output.amountOut;
              amountIn.decimals = decimalsIn;
              amountOut.decimals = decimalsOut;
              amount = isExactIn ? input.amountIn.value : input.amountOut.value;
              if (!(amount === undefined)) {
                _context.next = 35;
                break;
              }
              return _context.abrupt("return", defaultReturn);
            case 35:
              if (!isSnipperMode) {
                _context.next = 42;
                break;
              }
              methodName = getMethodName({
                isExactInput: isExactIn,
                protocol: 'V2',
                isInputNative: getIsNative(tokenInAddress),
                isOutputNative: getIsNative(tokenOutAddress)
              });
              methodParamValue = method$2[methodName];
              path = [tokenInAddress, tokenOutAddress].map(function (tokenAddress) {
                if (getIsNative(tokenAddress)) return WETH9[Number(chainId)].address;
                return tokenAddress;
              });
              if (!isExactIn) {
                _context.next = 41;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountOut: '0',
                  methodParams: {
                    path: path,
                    method: methodParamValue,
                    amount: amount
                  }
                },
                isSimulationNeeded: false,
                error: undefined
              });
            case 41:
              return _context.abrupt("return", {
                params: {
                  amountIn: '0',
                  methodParams: {
                    path: path,
                    method: methodParamValue,
                    amount: amount
                  }
                },
                isSimulationNeeded: false,
                error: undefined
              });
            case 42:
              isSimulationNeeded = false;
              if (!amount || isVariable(amount)) {
                isSimulationNeeded = true;
                amount = '1' + '0'.repeat(isExactIn ? decimalsIn : decimalsOut);
              }
              _context.prev = 44;
              _context.next = 47;
              return uniswapService.create({
                cmd: 'simulateSwap',
                protocol: 'uniswap',
                token_in: tokenInAddress,
                token_in_decimals: decimalsIn,
                token_out: tokenOutAddress,
                token_out_decimals: decimalsOut,
                token_amount: amount,
                version: 'v2',
                type: isExactIn ? 'in' : 'out'
              });
            case 47:
              res = _context.sent;
              console.log('1', res);
              swapPath = res === null || res === void 0 ? void 0 : res.path;
              if (swapPath) {
                _context.next = 52;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountIn: isExactIn ? amount : undefined,
                  amountOut: isExactIn ? undefined : amount,
                  methodParams: {
                    path: undefined,
                    amount: undefined,
                    method: undefined
                  }
                },
                error: 'invalid trade'
              });
            case 52:
              _methodName = getMethodName({
                isExactInput: isExactIn,
                protocol: 'V2',
                isInputNative: getIsNative(tokenInAddress),
                isOutputNative: getIsNative(tokenOutAddress)
              });
              _methodParamValue = method$2[_methodName];
              if (!isExactIn) {
                _context.next = 56;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountOut: res.outputAmount,
                  methodParams: {
                    path: swapPath,
                    method: _methodParamValue,
                    amount: amount
                  }
                },
                isSimulationNeeded: isSimulationNeeded,
                error: undefined
              });
            case 56:
              return _context.abrupt("return", {
                params: {
                  amountIn: res.inputAmount,
                  methodParams: {
                    path: swapPath,
                    method: _methodParamValue,
                    amount: amount
                  }
                },
                isSimulationNeeded: isSimulationNeeded,
                error: undefined
              });
            case 59:
              _context.prev = 59;
              _context.t2 = _context["catch"](44);
              return _context.abrupt("return", {
                params: {
                  amountIn: isExactIn ? amount : undefined,
                  amountOut: isExactIn ? undefined : amount,
                  methodParams: {
                    path: undefined,
                    amount: undefined,
                    method: undefined
                  }
                },
                error: _context.t2.message
              });
            case 62:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[44, 59]]);
      }));
      return function getPathParams(_x) {
        return _ref5.apply(this, arguments);
      };
    }();
    var getDepParams = function getDepParams() {
      var isExactIn = input.isExactIn.value === 'true';
      return isExactIn ? ['addressIn', 'addressOut', 'isExactIn', 'snipperMode', 'amountIn'] : ['addressIn', 'addressOut', 'isExactIn', 'snipperMode', 'amountOut'];
    };
    return {
      get: getPathParams,
      depParamKeys: getDepParams
    };
  },
  requiredApprovals: function requiredApprovals(params, chainId) {
    var _params$methodParams = params.methodParams,
      amount = _params$methodParams.amount,
      path = _params$methodParams.path;
    if (params.methodParams.method.value === method$2.swapExactETHForTokens || params.methodParams.method.value === method$2.swapETHForExactTokens) {
      return [];
    }
    return [{
      to: path.value && path.value.length ? path.value[0] : params.addressIn.value || undefined,
      params: {
        spender: ROUTER_V2_ADDRESS[chainId],
        amount: params.amountIn.value || amount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  onCreate: function onCreate(_ref6) {
    var input = _ref6.input;
    var setAmountIn = function setAmountIn() {
      if (input.isExactIn.value !== 'true') return;
      input.methodParams.amount.set({
        value: input.amountIn.value
      });
      input.methodParams.amount.setEstimated({
        value: input.amountIn.estimatedValue
      });
    };
    var setAmountOut = function setAmountOut() {
      if (input.isExactIn.value === 'true') return;
      input.methodParams.amount.set({
        value: input.amountOut.value
      });
      input.methodParams.amount.setEstimated({
        value: input.amountOut.estimatedValue
      });
    };
    input.amountIn.subscribe({
      callback: function callback() {
        setAmountIn();
      },
      id: 'set amount by amountIn'
    });
    input.amountOut.subscribe({
      callback: function callback() {
        setAmountOut();
      },
      id: 'set amount by amountOut'
    });
    input.isExactIn.subscribe({
      callback: function callback(_ref7) {
        var value = _ref7.value;
        if (value === 'true') {
          setAmountIn();
        }
        if (value === 'false') {
          setAmountOut();
        }
      },
      id: 'set amount on isExactIn change'
    });
    setAmountIn();
    setAmountOut();
  },
  estimateGasOnParams: function estimateGasOnParams(params, _, chainId) {
    // base gas 140000
    // 80000 gas for every additional token in the path after 2
    var baseGas = BigNumber.from('140000');
    var path = params.methodParams.path;
    if (!path.value || !path.value.length) {
      return chainId === '42161' || chainId === '421613' ? baseGas.mul(13).toString() : baseGas.toString();
    }
    var gasPerToken = BigNumber.from('80000');
    var gas = baseGas.add(gasPerToken.mul(path.value.length - 2));
    if (chainId === '42161' || chainId === '421613') {
      gas = gas.mul(13);
    }
    return gas.toString();
  }
});

var SimulateSwap = createPlugin({
  protocol: 'UNISWAP',
  type: 'GETTER',
  method: 'simulateSwap',
  supportedContracts: fctUniswapContracts,
  initParams: {
    isExactIn: 'true'
  },
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        addressIn: new FctAddress({
          options: getAllCurrencies({
            chainId: chainId
          })
        }),
        amountIn: new FctValue({
          destination: 'wei_amount'
        }),
        addressOut: new FctAddress({
          options: getAllCurrencies({
            chainId: chainId
          })
        }),
        amountOut: new FctValue({
          destination: 'wei_amount'
        }),
        isExactIn: new FctBoolean({}),
        methodParams: {
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          method: new FctBytes32({
            messageType: 'string',
            options: Object.keys(method$2).map(function (key) {
              var methodKey = key;
              return {
                name: key,
                value: method$2[methodKey]
              };
            })
          }),
          path: new FctAddressList({
            destination: 'ERC20_List',
            options: getAllCurrencies({
              chainId: chainId
            })
          })
        }
      },
      output: {
        amountIn: new FctValue({
          innerIndex: 0,
          destination: 'wei_amount'
        }),
        amountOut: new FctValue({
          innerIndex: 1,
          destination: 'wei_amount'
        }),
        tokenIn: new FctAddress({
          innerIndex: 2,
          destination: 'erc20'
        }),
        tokenOut: new FctAddress({
          innerIndex: -1,
          destination: 'erc20'
        })
      }
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref2) {
    var input = _ref2.input,
      provider = _ref2.provider;
    var getPathParams = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
        var service, isExactIn, uniswapService, tokenInAddress, tokenOutAddress, defaultReturn, amount, decimalsIn, decimalsOut, isSimulationNeeded, res, swapPath, methodName, methodParamValue;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              service = _ref3.service;
              if (service) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              isExactIn = input.isExactIn.value === 'true';
              uniswapService = service;
              tokenInAddress = input.addressIn.value;
              tokenOutAddress = input.addressOut.value;
              if (isExactIn) {
                input.amountIn.readonly = false;
                input.amountOut.readonly = true;
              }
              if (!isExactIn) {
                input.amountIn.readonly = true;
                input.amountOut.readonly = false;
              }
              defaultReturn = isExactIn ? {
                params: {
                  amountOut: undefined,
                  methodParams: {
                    path: undefined,
                    method: undefined,
                    amount: undefined
                  }
                },
                error: undefined
              } : {
                params: {
                  amountIn: undefined,
                  methodParams: {
                    path: undefined,
                    method: undefined,
                    amount: undefined
                  }
                },
                error: undefined
              };
              if (!(!tokenInAddress || !tokenOutAddress || typeof tokenInAddress !== 'string' || typeof tokenOutAddress !== 'string')) {
                _context.next = 12;
                break;
              }
              return _context.abrupt("return", defaultReturn);
            case 12:
              amount = isExactIn ? input.amountIn.value : input.amountOut.value;
              if (!(amount === undefined)) {
                _context.next = 15;
                break;
              }
              return _context.abrupt("return", defaultReturn);
            case 15:
              if (!provider) {
                _context.next = 21;
                break;
              }
              _context.next = 18;
              return getTokenDecimals({
                address: tokenInAddress,
                provider: provider
              });
            case 18:
              _context.t0 = _context.sent;
              _context.next = 22;
              break;
            case 21:
              _context.t0 = 18;
            case 22:
              decimalsIn = _context.t0;
              if (!provider) {
                _context.next = 29;
                break;
              }
              _context.next = 26;
              return getTokenDecimals({
                address: tokenOutAddress,
                provider: provider
              });
            case 26:
              _context.t1 = _context.sent;
              _context.next = 30;
              break;
            case 29:
              _context.t1 = 18;
            case 30:
              decimalsOut = _context.t1;
              isSimulationNeeded = false;
              if (!amount || isVariable(amount)) {
                isSimulationNeeded = true;
                amount = '1' + '0'.repeat(isExactIn ? decimalsIn : decimalsOut);
              }
              _context.prev = 33;
              _context.next = 36;
              return uniswapService.create({
                cmd: 'simulateSwap',
                protocol: 'uniswap',
                token_in: tokenInAddress,
                token_in_decimals: decimalsIn,
                token_out: tokenOutAddress,
                token_out_decimals: decimalsOut,
                token_amount: amount,
                version: 'v2',
                type: isExactIn ? 'in' : 'out'
              });
            case 36:
              res = _context.sent;
              swapPath = res === null || res === void 0 ? void 0 : res.path;
              if (swapPath) {
                _context.next = 40;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountIn: isExactIn ? amount : undefined,
                  amountOut: isExactIn ? undefined : amount,
                  methodParams: {
                    path: undefined,
                    amount: undefined,
                    method: undefined
                  }
                },
                error: 'invalid trade'
              });
            case 40:
              methodName = getMethodName({
                isExactInput: isExactIn,
                protocol: 'V2',
                isInputNative: getIsNative(tokenInAddress),
                isOutputNative: getIsNative(tokenOutAddress)
              });
              methodParamValue = method$2[methodName];
              if (!isExactIn) {
                _context.next = 44;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountOut: res.outputAmount,
                  methodParams: {
                    path: swapPath,
                    method: methodParamValue,
                    amount: amount
                  }
                },
                isSimulationNeeded: isSimulationNeeded,
                error: undefined
              });
            case 44:
              return _context.abrupt("return", {
                params: {
                  amountIn: res.inputAmount,
                  methodParams: {
                    path: swapPath,
                    method: methodParamValue,
                    amount: amount
                  }
                },
                isSimulationNeeded: isSimulationNeeded,
                error: undefined
              });
            case 47:
              _context.prev = 47;
              _context.t2 = _context["catch"](33);
              return _context.abrupt("return", {
                params: {
                  amountIn: isExactIn ? amount : undefined,
                  amountOut: isExactIn ? undefined : amount,
                  methodParams: {
                    path: undefined,
                    amount: undefined,
                    method: undefined
                  }
                },
                error: _context.t2.message
              });
            case 50:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[33, 47]]);
      }));
      return function getPathParams(_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    var getDepParams = function getDepParams() {
      var isExactIn = input.isExactIn.value === 'true';
      return isExactIn ? ['addressIn', 'addressOut', 'isExactIn', 'amountIn'] : ['addressIn', 'addressOut', 'isExactIn', 'amountOut'];
    };
    return {
      get: getPathParams,
      depParamKeys: getDepParams
    };
  },
  onCreate: function onCreate(_ref5) {
    var input = _ref5.input;
    var setAmountIn = function setAmountIn() {
      if (input.isExactIn.value !== 'true') return;
      input.methodParams.amount.set({
        value: input.amountIn.value
      });
    };
    var setAmountOut = function setAmountOut() {
      if (input.isExactIn.value === 'true') return;
      input.methodParams.amount.set({
        value: input.amountOut.value
      });
    };
    input.amountIn.subscribe({
      callback: function callback() {
        setAmountIn();
      },
      id: 'set amount by amountIn'
    });
    input.amountOut.subscribe({
      callback: function callback() {
        setAmountOut();
      },
      id: 'set amount by amountOut'
    });
    input.isExactIn.subscribe({
      callback: function callback(_ref6) {
        var value = _ref6.value;
        if (value === 'true') {
          setAmountIn();
        }
        if (value === 'false') {
          setAmountOut();
        }
      },
      id: 'set amount on isExactIn change'
    });
    setAmountIn();
    setAmountOut();
  }
});

var actions$c = {
  SwapToNoSlippageProtection: SwapToNoSlippageProtection,
  SwapNoSlippageProtection: SwapNoSlippageProtection,
  SimpleAddLiquidity: SimpleAddLiquidity,
  SimpleAddLiquidityTo: SimpleAddLiquidityTo
};
var getters$a = {
  SimulateSwap: SimulateSwap
};
var FCT_UNISWAP = {
  actions: actions$c,
  getters: getters$a
};

var _HIGH_EXECUTION_FEES_, _contracts, _TOKENS;
var exchangeRouterContracts = [{
  address: '0xdB7421cd7E92414029f16d45D8A15c2904052dDf',
  chainId: 421613
}, {
  address: '0x3B070aA6847bd0fB56eFAdB351f49BBb7619dbc2',
  chainId: 42161
}];
var syntheticsReaderContracts = [{
  address: '0x254feb5D92d01013bb6a975f2971872df622e6E7',
  chainId: 421613
}, {
  address: '0x38d91ED96283d62182Fc6d990C24097A918a4d9b',
  chainId: 42161
}];
var AddressZero$1 = ethers.constants.AddressZero;
var NATIVE_TOKEN_ADDRESS = '0x0000000000000000000000000000000000000000';
var ETH_MAINNET = 1;
var ETH_GOERLI = 5;
var AVALANCHE_FUJI = 43113;
var ARBITRUM = 42161;
var ARBITRUM_GOERLI = 421613;
var MAX_EXCEEDING_THRESHOLD = '1000000000';
var MIN_EXCEEDING_THRESHOLD = '0.01';
var TRIGGER_PREFIX_ABOVE = '>';
var TRIGGER_PREFIX_BELOW = '<';
var CHAIN_IDS = [ARBITRUM, ARBITRUM_GOERLI];
var USD_DECIMALS = 30;
var HIGH_EXECUTION_FEES_MAP = (_HIGH_EXECUTION_FEES_ = {}, _defineProperty(_HIGH_EXECUTION_FEES_, ARBITRUM, 3), _defineProperty(_HIGH_EXECUTION_FEES_, ARBITRUM_GOERLI, 3), _defineProperty(_HIGH_EXECUTION_FEES_, AVALANCHE_FUJI, 3), _HIGH_EXECUTION_FEES_);
var contracts = (_contracts = {}, _defineProperty(_contracts, ARBITRUM_GOERLI, {
  // arbitrum testnet
  Vault: AddressZero$1,
  Router: AddressZero$1,
  VaultReader: AddressZero$1,
  Reader: AddressZero$1,
  GlpManager: AddressZero$1,
  RewardRouter: AddressZero$1,
  RewardReader: AddressZero$1,
  GlpRewardRouter: AddressZero$1,
  NATIVE_TOKEN: '0xe39Ab88f8A4777030A534146A9Ca3B52bd5D43A3',
  GLP: AddressZero$1,
  GMX: AddressZero$1,
  ES_GMX: AddressZero$1,
  BN_GMX: AddressZero$1,
  USDG: AddressZero$1,
  ES_GMX_IOU: AddressZero$1,
  StakedGmxTracker: AddressZero$1,
  BonusGmxTracker: AddressZero$1,
  FeeGmxTracker: AddressZero$1,
  StakedGlpTracker: AddressZero$1,
  FeeGlpTracker: AddressZero$1,
  StakedGmxDistributor: AddressZero$1,
  StakedGlpDistributor: AddressZero$1,
  GmxVester: AddressZero$1,
  GlpVester: AddressZero$1,
  OrderBook: AddressZero$1,
  OrderExecutor: AddressZero$1,
  OrderBookReader: AddressZero$1,
  PositionRouter: AddressZero$1,
  PositionManager: AddressZero$1,
  TraderJoeGmxAvaxPool: AddressZero$1,
  ReferralStorage: '0x995E905E471D53B7c5d0dbf6406860Cb3C029e95',
  ReferralReader: AddressZero$1,
  // Synthetics
  DataStore: '0xbA2314b0f71ebC705aeEBeA672cc3bcEc510D03b',
  EventEmitter: '0x2fbE45fCb58B7106CF0a3Be9225D5Ed5A1004cc4',
  ExchangeRouter: '0xdB7421cd7E92414029f16d45D8A15c2904052dDf',
  DepositVault: '0x838a9bdf8736eD522A60F5f715e4F3FC2BC91A08',
  WithdrawalVault: '0xaAac001C2a2727Ff2d484C4Ad7d2079C7094e7Ef',
  OrderVault: '0x82aFd2590814a7Ce3d7ea6b63F80481F8b227bA9',
  SyntheticsReader: '0x254feb5D92d01013bb6a975f2971872df622e6E7',
  SyntheticsRouter: '0xfB8e176df6B5bB7132889C012550bEaa6288014d',
  Timelock: AddressZero$1,
  Multicall: '0x6d85594c9BD6b0833bC85AE62B360654A1e52D70'
}), _defineProperty(_contracts, ARBITRUM, {
  // arbitrum mainnet
  Vault: '0x489ee077994B6658eAfA855C308275EAd8097C4A',
  Router: '0xaBBc5F99639c9B6bCb58544ddf04EFA6802F4064',
  VaultReader: '0xfebB9f4CAC4cD523598fE1C5771181440143F24A',
  Reader: '0x2b43c90D1B727cEe1Df34925bcd5Ace52Ec37694',
  GlpManager: '0x3963FfC9dff443c2A94f21b129D429891E32ec18',
  RewardRouter: '0xA906F338CB21815cBc4Bc87ace9e68c87eF8d8F1',
  GlpRewardRouter: '0xB95DB5B167D75e6d04227CfFFA61069348d271F5',
  RewardReader: '0x8BFb8e82Ee4569aee78D03235ff465Bd436D40E0',
  NATIVE_TOKEN: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
  GLP: '0x4277f8F2c384827B5273592FF7CeBd9f2C1ac258',
  GMX: '0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a',
  ES_GMX: '0xf42Ae1D54fd613C9bb14810b0588FaAa09a426cA',
  BN_GMX: '0x35247165119B69A40edD5304969560D0ef486921',
  USDG: '0x45096e7aA921f27590f8F19e457794EB09678141',
  ES_GMX_IOU: '0x6260101218eC4cCfFF1b778936C6f2400f95A954',
  StakedGmxTracker: '0x908C4D94D34924765f1eDc22A1DD098397c59dD4',
  BonusGmxTracker: '0x4d268a7d4C16ceB5a606c173Bd974984343fea13',
  FeeGmxTracker: '0xd2D1162512F927a7e282Ef43a362659E4F2a728F',
  StakedGlpTracker: '0x1aDDD80E6039594eE970E5872D247bf0414C8903',
  FeeGlpTracker: '0x4e971a87900b931fF39d1Aad67697F49835400b6',
  StakedGmxDistributor: '0x23208B91A98c7C1CD9FE63085BFf68311494F193',
  StakedGlpDistributor: '0x60519b48ec4183a61ca2B8e37869E675FD203b34',
  GmxVester: '0x199070DDfd1CFb69173aa2F7e20906F26B363004',
  GlpVester: '0xA75287d2f8b217273E7FCD7E86eF07D33972042E',
  OrderBook: '0x09f77E8A13De9a35a7231028187e9fD5DB8a2ACB',
  OrderExecutor: '0x7257ac5D0a0aaC04AA7bA2AC0A6Eb742E332c3fB',
  OrderBookReader: '0xa27C20A7CF0e1C68C0460706bB674f98F362Bc21',
  PositionRouter: '0xb87a436B93fFE9D75c5cFA7bAcFff96430b09868',
  PositionManager: '0x75E42e6f01baf1D6022bEa862A28774a9f8a4A0C',
  //UniswapGmxEthPool: '0x80A9ae39310abf666A87C743d6ebBD0E8C42158E',
  ReferralStorage: '0xe6fab3f0c7199b0d34d7fbe83394fc0e0d06e99d',
  ReferralReader: '0x8Aa382760BCdCe8644C33e6C2D52f6304A76F5c8',
  // Synthetics
  DataStore: '0xFD70de6b91282D8017aA4E741e9Ae325CAb992d8',
  EventEmitter: '0xC8ee91A54287DB53897056e12D9819156D3822Fb',
  ExchangeRouter: '0x3B070aA6847bd0fB56eFAdB351f49BBb7619dbc2',
  DepositVault: '0xF89e77e8Dc11691C9e8757e84aaFbCD8A67d7A55',
  WithdrawalVault: '0x0628D46b5D145f183AdB6Ef1f2c97eD1C4701C55',
  OrderVault: '0x31eF83a530Fde1B38EE9A18093A333D8Bbbc40D5',
  SyntheticsReader: '0x38d91ED96283d62182Fc6d990C24097A918a4d9b',
  SyntheticsRouter: '0x7452c558d45f8afC8c83dAe62C3f8A5BE19c71f6',
  Timelock: '0xaa50bD556CE0Fe61D4A57718BA43177a3aB6A597',
  Multicall: '0xcA11bde05977b3631167028862bE2a173976CA11'
}), _contracts);
var BASIS_POINTS_DIVISOR = 10000;
var MAX_ALLOWED_LEVERAGE = 50 * BASIS_POINTS_DIVISOR;
var TOKENS = (_TOKENS = {}, _defineProperty(_TOKENS, ETH_MAINNET, []), _defineProperty(_TOKENS, ETH_GOERLI, []), _defineProperty(_TOKENS, ARBITRUM, [{
  name: 'Ethereum',
  symbol: 'ETH',
  decimals: 18,
  value: ethers.constants.AddressZero,
  isNative: true,
  isShortable: true,
  logoURI: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/ethereum',
  isV1Available: true
}, {
  name: 'Wrapped Ethereum',
  symbol: 'WETH',
  decimals: 18,
  value: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
  isWrapped: true,
  baseSymbol: 'ETH',
  logoURI: 'https://assets.coingecko.com/coins/images/2518/thumb/weth.png?1628852295',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/ethereum',
  isV1Available: true
}, {
  name: 'Bitcoin (WBTC)',
  symbol: 'BTC',
  decimals: 8,
  value: '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f',
  isShortable: true,
  logoURI: 'https://assets.coingecko.com/coins/images/26115/thumb/btcb.png?1655921693',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/wrapped-bitcoin',
  explorerUrl: 'https://arbiscan.io/address/0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
  isV1Available: true
}, {
  name: 'Arbitrum',
  symbol: 'ARB',
  decimals: 18,
  priceDecimals: 3,
  value: '0x912CE59144191C1204E64559FE8253a0e49E6548',
  logoURI: 'https://assets.coingecko.com/coins/images/16547/small/photo_2023-03-29_21.47.00.jpeg?1680097630',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/arbitrum',
  explorerUrl: 'https://arbiscan.io/token/0x912ce59144191c1204e64559fe8253a0e49e6548'
}, {
  name: 'Wrapped SOL (Wormhole)',
  symbol: 'SOL',
  decimals: 9,
  value: '0x2bcC6D6CdBbDC0a4071e48bb3B969b06B3330c07',
  logoURI: 'https://assets.coingecko.com/coins/images/4128/small/solana.png?1640133422',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/solana',
  explorerUrl: 'https://arbiscan.io/token/0x2bCc6D6CdBbDC0a4071e48bb3B969b06B3330c07'
}, {
  name: 'Chainlink',
  symbol: 'LINK',
  decimals: 18,
  priceDecimals: 3,
  value: '0xf97f4df75117a78c1A5a0DBb814Af92458539FB4',
  isStable: false,
  isShortable: true,
  logoURI: 'https://assets.coingecko.com/coins/images/877/thumb/chainlink-new-logo.png?1547034700',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/chainlink',
  explorerUrl: 'https://arbiscan.io/token/0xf97f4df75117a78c1a5a0dbb814af92458539fb4',
  isV1Available: true
}, {
  name: 'Uniswap',
  symbol: 'UNI',
  decimals: 18,
  priceDecimals: 3,
  value: '0xFa7F8980b0f1E64A2062791cc3b0871572f1F7f0',
  isStable: false,
  isShortable: true,
  logoURI: 'https://assets.coingecko.com/coins/images/12504/thumb/uniswap-uni.png?1600306604',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/uniswap',
  explorerUrl: 'https://arbiscan.io/token/0xfa7f8980b0f1e64a2062791cc3b0871572f1f7f0',
  isV1Available: true
}, {
  name: 'Bridged USDC (USDC.e)',
  symbol: 'USDC.e',
  decimals: 6,
  value: '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8',
  isStable: true,
  logoURI: 'https://assets.coingecko.com/coins/images/6319/thumb/USD_Coin_icon.png?1547042389',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/usd-coin',
  explorerUrl: 'https://arbiscan.io/token/0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8',
  isV1Available: true
}, {
  name: 'USD Coin',
  symbol: 'USDC',
  decimals: 6,
  value: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
  isStable: true,
  isV1Available: true,
  logoURI: 'https://assets.coingecko.com/coins/images/6319/thumb/USD_Coin_icon.png?1547042389',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/usd-coin',
  explorerUrl: 'https://arbiscan.io/address/0xaf88d065e77c8cC2239327C5EDb3A432268e5831'
}, {
  name: 'Tether',
  symbol: 'USDT',
  decimals: 6,
  value: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
  isStable: true,
  logoURI: 'https://assets.coingecko.com/coins/images/325/thumb/Tether-logo.png?1598003707',
  explorerUrl: 'https://arbiscan.io/value/0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/tether',
  isV1Available: true
}, {
  name: 'Dai',
  symbol: 'DAI',
  decimals: 18,
  value: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
  isStable: true,
  logoURI: 'https://assets.coingecko.com/coins/images/9956/thumb/4943.png?1636636734',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/dai',
  explorerUrl: 'https://arbiscan.io/token/0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
  isV1Available: true
}, {
  name: 'Frax',
  symbol: 'FRAX',
  decimals: 18,
  value: '0x17FC002b466eEc40DaE837Fc4bE5c67993ddBd6F',
  isStable: true,
  logoURI: 'https://assets.coingecko.com/coins/images/13422/small/frax_logo.png?1608476506',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/frax',
  explorerUrl: 'https://arbiscan.io/token/0x17FC002b466eEc40DaE837Fc4bE5c67993ddBd6F',
  isV1Available: true
}, {
  name: 'Magic Internet Money',
  symbol: 'MIM',
  decimals: 18,
  value: '0xFEa7a6a0B346362BF88A9e4A88416B77a57D6c2A',
  isStable: true,
  isTempHidden: true,
  logoURI: 'https://assets.coingecko.com/coins/images/16786/small/mimlogopng.png',
  isV1Available: true
}, {
  name: 'Bitcoin',
  symbol: 'BTC',
  value: '0x47904963fc8b2340414262125aF798B9655E58Cd',
  isSynthetic: true,
  decimals: 8,
  logoURI: 'https://assets.coingecko.com/coins/images/1/small/bitcoin.png?1547033579',
  //TODO: remove explorerUrl in future
  explorerUrl: 'https://arbiscan.io/address/0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/bitcoin'
}, {
  name: 'Dogecoin',
  symbol: 'DOGE',
  decimals: 8,
  priceDecimals: 4,
  value: '0xC4da4c24fd591125c3F47b340b6f4f76111883d8',
  isSynthetic: true,
  logoURI: 'https://assets.coingecko.com/coins/images/5/small/dogecoin.png?1547792256',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/dogecoin'
}, {
  name: 'Litecoin',
  symbol: 'LTC',
  decimals: 8,
  value: '0xB46A094Bc4B0adBD801E14b9DB95e05E28962764',
  isSynthetic: true,
  logoURI: 'https://assets.coingecko.com/coins/images/2/small/litecoin.png?1547033580',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/litecoin'
}, {
  name: 'XRP',
  symbol: 'XRP',
  decimals: 6,
  priceDecimals: 4,
  value: '0xc14e065b0067dE91534e032868f5Ac6ecf2c6868',
  logoURI: 'https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png?1605778731',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/xrp',
  isSynthetic: true
}, {
  name: 'GMX',
  symbol: 'GMX',
  value: AddressZero$1,
  decimals: 18,
  isPlatformToken: true,
  logoURI: 'https://assets.coingecko.com/coins/images/18323/small/arbit.png?1631532468',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/gmx',
  explorerUrl: 'https://arbiscan.io/address/0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a'
}, {
  name: 'Escrowed GMX',
  symbol: 'esGMX',
  value: AddressZero$1,
  decimals: 18,
  isPlatformToken: true
}, {
  name: 'GMX LP',
  symbol: 'GLP',
  value: AddressZero$1,
  decimals: 18,
  logoURI: 'https://github.com/gmx-io/gmx-assets/blob/main/GMX-Assets/PNG/GLP_LOGO%20ONLY.png?raw=true',
  reservesUrl: 'https://portfolio.nansen.ai/dashboard/gmx?chain=ARBITRUM',
  isPlatformToken: true
}]), _defineProperty(_TOKENS, ARBITRUM_GOERLI, [{
  name: 'Ethereum',
  symbol: 'ETH',
  decimals: 18,
  value: ethers.constants.AddressZero,
  isNative: true,
  isShortable: true,
  logoURI: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880'
}, {
  name: 'Wrapped Ethereum',
  symbol: 'WETH',
  decimals: 18,
  value: '0xe39Ab88f8A4777030A534146A9Ca3B52bd5D43A3',
  isWrapped: true,
  baseSymbol: 'ETH',
  logoURI: 'https://assets.coingecko.com/coins/images/2518/thumb/weth.png?1628852295',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/ethereum',
  explorerUrl: 'https://goerli.arbiscan.io/address/0xe39Ab88f8A4777030A534146A9Ca3B52bd5D43A3'
}, {
  name: 'Bitcoin',
  symbol: 'BTC',
  decimals: 8,
  value: '0xCcF73F4Dcbbb573296BFA656b754Fe94BB957d62',
  isShortable: true,
  logoURI: 'https://assets.coingecko.com/coins/images/7598/thumb/wrapped_bitcoin_wbtc.png?1548822744',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/bitcoin',
  explorerUrl: 'https://goerli.arbiscan.io/address/0xCcF73F4Dcbbb573296BFA656b754Fe94BB957d62'
}, {
  name: 'USD Coin',
  symbol: 'USDC',
  decimals: 6,
  value: '0x04FC936a15352a1b15b3B9c56EA002051e3DB3e5',
  isStable: true,
  logoURI: 'https://assets.coingecko.com/coins/images/6319/thumb/USD_Coin_icon.png?1547042389',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/usd-coin',
  explorerUrl: 'https://goerli.arbiscan.io/address/0x04FC936a15352a1b15b3B9c56EA002051e3DB3e5'
}, {
  name: 'Tether',
  symbol: 'USDT',
  decimals: 6,
  value: '0xBFcBcdCbcc1b765843dCe4DF044B92FE68182a62',
  isStable: true,
  logoURI: 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/tether',
  explorerUrl: 'https://goerli.arbiscan.io/address/0xBFcBcdCbcc1b765843dCe4DF044B92FE68182a62'
}, {
  name: 'Dai',
  symbol: 'DAI',
  value: '0x7b7c6c49fA99b37270077FBFA398748c27046984',
  decimals: 18,
  isStable: true,
  logoURI: 'https://assets.coingecko.com/coins/images/9956/thumb/4943.png?1636636734',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/dai',
  explorerUrl: 'https://goerli.arbiscan.io/address/0x7b7c6c49fA99b37270077FBFA398748c27046984'
}, {
  name: 'Solana',
  symbol: 'SOL',
  decimals: 18,
  value: '0x9A98a11279FaeB0fF695dFEC3C4B8a29138d0a2f',
  isSynthetic: true,
  logoURI: 'https://assets.coingecko.com/coins/images/4128/small/solana.png?1640133422',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/solana'
}, {
  name: 'Test token',
  symbol: 'TEST',
  decimals: 18,
  value: '0x13C52ccB49fE3228356D0C355641961646A0D9B2',
  isSynthetic: true,
  coingeckoUrl: 'https://www.coingecko.com/en/coins/tether'
}, {
  name: 'BNB',
  symbol: 'BNB',
  isSynthetic: true,
  decimals: 18,
  value: '0xa076E6db62f61bd1A4fC283F84739D2b0c80e2a3',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/binancecoin'
}, {
  name: 'Cardano',
  symbol: 'ADA',
  decimals: 18,
  priceDecimals: 4,
  value: '0x5F8a8f06da2848f846A2b5e3e42A4A2eEC5f337B',
  isSynthetic: true,
  coingeckoUrl: 'https://www.coingecko.com/en/coins/cardano'
}, {
  name: 'TRON',
  symbol: 'TRX',
  decimals: 18,
  priceDecimals: 4,
  value: '0x7a9Ba06548D0499f6Debf97809CC351c1e85795D',
  isSynthetic: true,
  coingeckoUrl: 'https://www.coingecko.com/en/coins/tron'
}, {
  name: 'Polygon',
  symbol: 'MATIC',
  decimals: 18,
  priceDecimals: 4,
  value: '0xd98D28787F5598749331052f952196428F61e3aD',
  isSynthetic: true,
  coingeckoUrl: 'https://www.coingecko.com/en/coins/polygon'
}, {
  name: 'Polkadot',
  symbol: 'DOT',
  decimals: 18,
  value: '0x7361D58cBc6495B6419397dFd5ebE2e2017F23E9',
  isSynthetic: true,
  coingeckoUrl: 'https://www.coingecko.com/en/coins/polkadot'
}, {
  name: 'Uniswap',
  symbol: 'UNI',
  decimals: 18,
  priceDecimals: 3,
  value: '0x6DEbb9cC48819941F797a2F0c63f9168C19fD057',
  isSynthetic: true,
  coingeckoUrl: 'https://www.coingecko.com/en/coins/uniswap'
}, {
  name: 'Dogecoin',
  symbol: 'DOGE',
  isSynthetic: true,
  isShortable: true,
  decimals: 8,
  priceDecimals: 4,
  value: '0x3e2fA75b78edF836299127FBAA776304B4712972',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/dogecoin'
}, {
  name: 'Chainlink',
  symbol: 'LINK',
  decimals: 18,
  priceDecimals: 3,
  value: '0x55602A94239a7926D92da5C53Fb96E80372382aa',
  isSynthetic: true,
  coingeckoUrl: 'https://www.coingecko.com/en/coins/chainlink'
}, {
  name: 'XRP',
  symbol: 'XRP',
  decimals: 6,
  priceDecimals: 4,
  value: '0xF1C2093383453831e8c90ecf809691123116dAaC',
  isSynthetic: true,
  logoURI: 'https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png?1605778731',
  coingeckoUrl: 'https://www.coingecko.com/en/coins/xrp'
}]), _TOKENS);

var DataStoreAbi = [
	{
		inputs: [
			{
				internalType: "contract RoleStore",
				name: "_roleStore",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "msgSender",
				type: "address"
			},
			{
				internalType: "string",
				name: "role",
				type: "string"
			}
		],
		name: "Unauthorized",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "setKey",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "value",
				type: "address"
			}
		],
		name: "addAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "setKey",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "value",
				type: "bytes32"
			}
		],
		name: "addBytes32",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "setKey",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "addUint",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "addressArrayValues",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		name: "addressValues",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "int256",
				name: "value",
				type: "int256"
			}
		],
		name: "applyBoundedDeltaToUint",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "int256",
				name: "value",
				type: "int256"
			}
		],
		name: "applyDeltaToInt",
		outputs: [
			{
				internalType: "int256",
				name: "",
				type: "int256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "int256",
				name: "value",
				type: "int256"
			},
			{
				internalType: "string",
				name: "errorMessage",
				type: "string"
			}
		],
		name: "applyDeltaToUint",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "applyDeltaToUint",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "boolArrayValues",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		name: "boolValues",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "bytes32ArrayValues",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		name: "bytes32Values",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "setKey",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "value",
				type: "address"
			}
		],
		name: "containsAddress",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "setKey",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "value",
				type: "bytes32"
			}
		],
		name: "containsBytes32",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "setKey",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "containsUint",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "int256",
				name: "value",
				type: "int256"
			}
		],
		name: "decrementInt",
		outputs: [
			{
				internalType: "int256",
				name: "",
				type: "int256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "decrementUint",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getAddress",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getAddressArray",
		outputs: [
			{
				internalType: "address[]",
				name: "",
				type: "address[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "setKey",
				type: "bytes32"
			}
		],
		name: "getAddressCount",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "setKey",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "start",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "end",
				type: "uint256"
			}
		],
		name: "getAddressValuesAt",
		outputs: [
			{
				internalType: "address[]",
				name: "",
				type: "address[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getBool",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getBoolArray",
		outputs: [
			{
				internalType: "bool[]",
				name: "",
				type: "bool[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getBytes32",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getBytes32Array",
		outputs: [
			{
				internalType: "bytes32[]",
				name: "",
				type: "bytes32[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "setKey",
				type: "bytes32"
			}
		],
		name: "getBytes32Count",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "setKey",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "start",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "end",
				type: "uint256"
			}
		],
		name: "getBytes32ValuesAt",
		outputs: [
			{
				internalType: "bytes32[]",
				name: "",
				type: "bytes32[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getInt",
		outputs: [
			{
				internalType: "int256",
				name: "",
				type: "int256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getIntArray",
		outputs: [
			{
				internalType: "int256[]",
				name: "",
				type: "int256[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getString",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getStringArray",
		outputs: [
			{
				internalType: "string[]",
				name: "",
				type: "string[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getUint",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getUintArray",
		outputs: [
			{
				internalType: "uint256[]",
				name: "",
				type: "uint256[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "setKey",
				type: "bytes32"
			}
		],
		name: "getUintCount",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "setKey",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "start",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "end",
				type: "uint256"
			}
		],
		name: "getUintValuesAt",
		outputs: [
			{
				internalType: "uint256[]",
				name: "",
				type: "uint256[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "int256",
				name: "value",
				type: "int256"
			}
		],
		name: "incrementInt",
		outputs: [
			{
				internalType: "int256",
				name: "",
				type: "int256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "incrementUint",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "intArrayValues",
		outputs: [
			{
				internalType: "int256",
				name: "",
				type: "int256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		name: "intValues",
		outputs: [
			{
				internalType: "int256",
				name: "",
				type: "int256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "setKey",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "value",
				type: "address"
			}
		],
		name: "removeAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "removeAddress",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "removeAddressArray",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "removeBool",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "removeBoolArray",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "setKey",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "value",
				type: "bytes32"
			}
		],
		name: "removeBytes32",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "removeBytes32",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "removeBytes32Array",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "removeInt",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "removeIntArray",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "removeString",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "removeStringArray",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "removeUint",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "setKey",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "removeUint",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "removeUintArray",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "roleStore",
		outputs: [
			{
				internalType: "contract RoleStore",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "value",
				type: "address"
			}
		],
		name: "setAddress",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "address[]",
				name: "value",
				type: "address[]"
			}
		],
		name: "setAddressArray",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "bool",
				name: "value",
				type: "bool"
			}
		],
		name: "setBool",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "bool[]",
				name: "value",
				type: "bool[]"
			}
		],
		name: "setBoolArray",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "bytes32",
				name: "value",
				type: "bytes32"
			}
		],
		name: "setBytes32",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "bytes32[]",
				name: "value",
				type: "bytes32[]"
			}
		],
		name: "setBytes32Array",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "int256",
				name: "value",
				type: "int256"
			}
		],
		name: "setInt",
		outputs: [
			{
				internalType: "int256",
				name: "",
				type: "int256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "int256[]",
				name: "value",
				type: "int256[]"
			}
		],
		name: "setIntArray",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "string",
				name: "value",
				type: "string"
			}
		],
		name: "setString",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "string[]",
				name: "value",
				type: "string[]"
			}
		],
		name: "setStringArray",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "setUint",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "uint256[]",
				name: "value",
				type: "uint256[]"
			}
		],
		name: "setUintArray",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "stringArrayValues",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		name: "stringValues",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		name: "uintArrayValues",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		name: "uintValues",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	}
];

var exchangeRouterAbi = [
	{
		inputs: [
			{
				internalType: "contract Router",
				name: "_router",
				type: "address"
			},
			{
				internalType: "contract RoleStore",
				name: "_roleStore",
				type: "address"
			},
			{
				internalType: "contract DataStore",
				name: "_dataStore",
				type: "address"
			},
			{
				internalType: "contract EventEmitter",
				name: "_eventEmitter",
				type: "address"
			},
			{
				internalType: "contract IDepositHandler",
				name: "_depositHandler",
				type: "address"
			},
			{
				internalType: "contract IWithdrawalHandler",
				name: "_withdrawalHandler",
				type: "address"
			},
			{
				internalType: "contract IOrderHandler",
				name: "_orderHandler",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "adjustedClaimableAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "claimedAmount",
				type: "uint256"
			}
		],
		name: "CollateralAlreadyClaimed",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "DisabledFeature",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			}
		],
		name: "DisabledMarket",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			},
			{
				internalType: "address",
				name: "token",
				type: "address"
			}
		],
		name: "EmptyAddressInMarketTokenBalanceValidation",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyDeposit",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyHoldingAddress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyMarket",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyOrder",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyReceiver",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			}
		],
		name: "EmptyTokenTranferGasLimit",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "marketsLength",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "tokensLength",
				type: "uint256"
			}
		],
		name: "InvalidClaimAffiliateRewardsInput",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "marketsLength",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "tokensLength",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "timeKeysLength",
				type: "uint256"
			}
		],
		name: "InvalidClaimCollateralInput",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "marketsLength",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "tokensLength",
				type: "uint256"
			}
		],
		name: "InvalidClaimFundingFeesInput",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "marketsLength",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "tokensLength",
				type: "uint256"
			}
		],
		name: "InvalidClaimUiFeesInput",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			},
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "balance",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "expectedMinBalance",
				type: "uint256"
			}
		],
		name: "InvalidMarketTokenBalance",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			},
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "balance",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "claimableFundingFeeAmount",
				type: "uint256"
			}
		],
		name: "InvalidMarketTokenBalanceForClaimableFunding",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			},
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "balance",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "collateralAmount",
				type: "uint256"
			}
		],
		name: "InvalidMarketTokenBalanceForCollateralAmount",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "uiFeeFactor",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxUiFeeFactor",
				type: "uint256"
			}
		],
		name: "InvalidUiFeeFactor",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "TokenTransferError",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "msgSender",
				type: "address"
			},
			{
				internalType: "string",
				name: "role",
				type: "string"
			}
		],
		name: "Unauthorized",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "cancelDeposit",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "cancelOrder",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "cancelWithdrawal",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address[]",
				name: "markets",
				type: "address[]"
			},
			{
				internalType: "address[]",
				name: "tokens",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			}
		],
		name: "claimAffiliateRewards",
		outputs: [
			{
				internalType: "uint256[]",
				name: "",
				type: "uint256[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address[]",
				name: "markets",
				type: "address[]"
			},
			{
				internalType: "address[]",
				name: "tokens",
				type: "address[]"
			},
			{
				internalType: "uint256[]",
				name: "timeKeys",
				type: "uint256[]"
			},
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			}
		],
		name: "claimCollateral",
		outputs: [
			{
				internalType: "uint256[]",
				name: "",
				type: "uint256[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address[]",
				name: "markets",
				type: "address[]"
			},
			{
				internalType: "address[]",
				name: "tokens",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			}
		],
		name: "claimFundingFees",
		outputs: [
			{
				internalType: "uint256[]",
				name: "",
				type: "uint256[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address[]",
				name: "markets",
				type: "address[]"
			},
			{
				internalType: "address[]",
				name: "tokens",
				type: "address[]"
			},
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			}
		],
		name: "claimUiFees",
		outputs: [
			{
				internalType: "uint256[]",
				name: "",
				type: "uint256[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "receiver",
						type: "address"
					},
					{
						internalType: "address",
						name: "callbackContract",
						type: "address"
					},
					{
						internalType: "address",
						name: "uiFeeReceiver",
						type: "address"
					},
					{
						internalType: "address",
						name: "market",
						type: "address"
					},
					{
						internalType: "address",
						name: "initialLongToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "initialShortToken",
						type: "address"
					},
					{
						internalType: "address[]",
						name: "longTokenSwapPath",
						type: "address[]"
					},
					{
						internalType: "address[]",
						name: "shortTokenSwapPath",
						type: "address[]"
					},
					{
						internalType: "uint256",
						name: "minMarketTokens",
						type: "uint256"
					},
					{
						internalType: "bool",
						name: "shouldUnwrapNativeToken",
						type: "bool"
					},
					{
						internalType: "uint256",
						name: "executionFee",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "callbackGasLimit",
						type: "uint256"
					}
				],
				internalType: "struct DepositUtils.CreateDepositParams",
				name: "params",
				type: "tuple"
			}
		],
		name: "createDeposit",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						components: [
							{
								internalType: "address",
								name: "receiver",
								type: "address"
							},
							{
								internalType: "address",
								name: "callbackContract",
								type: "address"
							},
							{
								internalType: "address",
								name: "uiFeeReceiver",
								type: "address"
							},
							{
								internalType: "address",
								name: "market",
								type: "address"
							},
							{
								internalType: "address",
								name: "initialCollateralToken",
								type: "address"
							},
							{
								internalType: "address[]",
								name: "swapPath",
								type: "address[]"
							}
						],
						internalType: "struct BaseOrderUtils.CreateOrderParamsAddresses",
						name: "addresses",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "sizeDeltaUsd",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "initialCollateralDeltaAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "triggerPrice",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "acceptablePrice",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "executionFee",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "callbackGasLimit",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "minOutputAmount",
								type: "uint256"
							}
						],
						internalType: "struct BaseOrderUtils.CreateOrderParamsNumbers",
						name: "numbers",
						type: "tuple"
					},
					{
						internalType: "enum Order.OrderType",
						name: "orderType",
						type: "uint8"
					},
					{
						internalType: "enum Order.DecreasePositionSwapType",
						name: "decreasePositionSwapType",
						type: "uint8"
					},
					{
						internalType: "bool",
						name: "isLong",
						type: "bool"
					},
					{
						internalType: "bool",
						name: "shouldUnwrapNativeToken",
						type: "bool"
					},
					{
						internalType: "bytes32",
						name: "referralCode",
						type: "bytes32"
					}
				],
				internalType: "struct BaseOrderUtils.CreateOrderParams",
				name: "params",
				type: "tuple"
			}
		],
		name: "createOrder",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "receiver",
						type: "address"
					},
					{
						internalType: "address",
						name: "callbackContract",
						type: "address"
					},
					{
						internalType: "address",
						name: "uiFeeReceiver",
						type: "address"
					},
					{
						internalType: "address",
						name: "market",
						type: "address"
					},
					{
						internalType: "address[]",
						name: "longTokenSwapPath",
						type: "address[]"
					},
					{
						internalType: "address[]",
						name: "shortTokenSwapPath",
						type: "address[]"
					},
					{
						internalType: "uint256",
						name: "minLongTokenAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "minShortTokenAmount",
						type: "uint256"
					},
					{
						internalType: "bool",
						name: "shouldUnwrapNativeToken",
						type: "bool"
					},
					{
						internalType: "uint256",
						name: "executionFee",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "callbackGasLimit",
						type: "uint256"
					}
				],
				internalType: "struct WithdrawalUtils.CreateWithdrawalParams",
				name: "params",
				type: "tuple"
			}
		],
		name: "createWithdrawal",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "dataStore",
		outputs: [
			{
				internalType: "contract DataStore",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "depositHandler",
		outputs: [
			{
				internalType: "contract IDepositHandler",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "eventEmitter",
		outputs: [
			{
				internalType: "contract EventEmitter",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes[]",
				name: "data",
				type: "bytes[]"
			}
		],
		name: "multicall",
		outputs: [
			{
				internalType: "bytes[]",
				name: "results",
				type: "bytes[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "orderHandler",
		outputs: [
			{
				internalType: "contract IOrderHandler",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "roleStore",
		outputs: [
			{
				internalType: "contract RoleStore",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "router",
		outputs: [
			{
				internalType: "contract Router",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "sendTokens",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "sendWnt",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			},
			{
				internalType: "address",
				name: "callbackContract",
				type: "address"
			}
		],
		name: "setSavedCallbackContract",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "uiFeeFactor",
				type: "uint256"
			}
		],
		name: "setUiFeeFactor",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				components: [
					{
						internalType: "address[]",
						name: "primaryTokens",
						type: "address[]"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props[]",
						name: "primaryPrices",
						type: "tuple[]"
					}
				],
				internalType: "struct OracleUtils.SimulatePricesParams",
				name: "simulatedOracleParams",
				type: "tuple"
			}
		],
		name: "simulateExecuteDeposit",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				components: [
					{
						internalType: "address[]",
						name: "primaryTokens",
						type: "address[]"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props[]",
						name: "primaryPrices",
						type: "tuple[]"
					}
				],
				internalType: "struct OracleUtils.SimulatePricesParams",
				name: "simulatedOracleParams",
				type: "tuple"
			}
		],
		name: "simulateExecuteOrder",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				components: [
					{
						internalType: "address[]",
						name: "primaryTokens",
						type: "address[]"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props[]",
						name: "primaryPrices",
						type: "tuple[]"
					}
				],
				internalType: "struct OracleUtils.SimulatePricesParams",
				name: "simulatedOracleParams",
				type: "tuple"
			}
		],
		name: "simulateExecuteWithdrawal",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "sizeDeltaUsd",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "acceptablePrice",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "triggerPrice",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "minOutputAmount",
				type: "uint256"
			}
		],
		name: "updateOrder",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "withdrawalHandler",
		outputs: [
			{
				internalType: "contract IWithdrawalHandler",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	}
];

var MulticallAbi = [
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "target",
						type: "address"
					},
					{
						internalType: "bytes",
						name: "callData",
						type: "bytes"
					}
				],
				internalType: "struct Multicall3.Call[]",
				name: "calls",
				type: "tuple[]"
			}
		],
		name: "aggregate",
		outputs: [
			{
				internalType: "uint256",
				name: "blockNumber",
				type: "uint256"
			},
			{
				internalType: "bytes[]",
				name: "returnData",
				type: "bytes[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "target",
						type: "address"
					},
					{
						internalType: "bool",
						name: "allowFailure",
						type: "bool"
					},
					{
						internalType: "bytes",
						name: "callData",
						type: "bytes"
					}
				],
				internalType: "struct Multicall3.Call3[]",
				name: "calls",
				type: "tuple[]"
			}
		],
		name: "aggregate3",
		outputs: [
			{
				components: [
					{
						internalType: "bool",
						name: "success",
						type: "bool"
					},
					{
						internalType: "bytes",
						name: "returnData",
						type: "bytes"
					}
				],
				internalType: "struct Multicall3.Result[]",
				name: "returnData",
				type: "tuple[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "target",
						type: "address"
					},
					{
						internalType: "bool",
						name: "allowFailure",
						type: "bool"
					},
					{
						internalType: "uint256",
						name: "value",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "callData",
						type: "bytes"
					}
				],
				internalType: "struct Multicall3.Call3Value[]",
				name: "calls",
				type: "tuple[]"
			}
		],
		name: "aggregate3Value",
		outputs: [
			{
				components: [
					{
						internalType: "bool",
						name: "success",
						type: "bool"
					},
					{
						internalType: "bytes",
						name: "returnData",
						type: "bytes"
					}
				],
				internalType: "struct Multicall3.Result[]",
				name: "returnData",
				type: "tuple[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "target",
						type: "address"
					},
					{
						internalType: "bytes",
						name: "callData",
						type: "bytes"
					}
				],
				internalType: "struct Multicall3.Call[]",
				name: "calls",
				type: "tuple[]"
			}
		],
		name: "blockAndAggregate",
		outputs: [
			{
				internalType: "uint256",
				name: "blockNumber",
				type: "uint256"
			},
			{
				internalType: "bytes32",
				name: "blockHash",
				type: "bytes32"
			},
			{
				components: [
					{
						internalType: "bool",
						name: "success",
						type: "bool"
					},
					{
						internalType: "bytes",
						name: "returnData",
						type: "bytes"
					}
				],
				internalType: "struct Multicall3.Result[]",
				name: "returnData",
				type: "tuple[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getBasefee",
		outputs: [
			{
				internalType: "uint256",
				name: "basefee",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "blockNumber",
				type: "uint256"
			}
		],
		name: "getBlockHash",
		outputs: [
			{
				internalType: "bytes32",
				name: "blockHash",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getBlockNumber",
		outputs: [
			{
				internalType: "uint256",
				name: "blockNumber",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getChainId",
		outputs: [
			{
				internalType: "uint256",
				name: "chainid",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getCurrentBlockCoinbase",
		outputs: [
			{
				internalType: "address",
				name: "coinbase",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getCurrentBlockGasLimit",
		outputs: [
			{
				internalType: "uint256",
				name: "gaslimit",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getCurrentBlockTimestamp",
		outputs: [
			{
				internalType: "uint256",
				name: "timestamp",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "addr",
				type: "address"
			}
		],
		name: "getEthBalance",
		outputs: [
			{
				internalType: "uint256",
				name: "balance",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getLastBlockHash",
		outputs: [
			{
				internalType: "bytes32",
				name: "blockHash",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bool",
				name: "requireSuccess",
				type: "bool"
			},
			{
				components: [
					{
						internalType: "address",
						name: "target",
						type: "address"
					},
					{
						internalType: "bytes",
						name: "callData",
						type: "bytes"
					}
				],
				internalType: "struct Multicall3.Call[]",
				name: "calls",
				type: "tuple[]"
			}
		],
		name: "tryAggregate",
		outputs: [
			{
				components: [
					{
						internalType: "bool",
						name: "success",
						type: "bool"
					},
					{
						internalType: "bytes",
						name: "returnData",
						type: "bytes"
					}
				],
				internalType: "struct Multicall3.Result[]",
				name: "returnData",
				type: "tuple[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bool",
				name: "requireSuccess",
				type: "bool"
			},
			{
				components: [
					{
						internalType: "address",
						name: "target",
						type: "address"
					},
					{
						internalType: "bytes",
						name: "callData",
						type: "bytes"
					}
				],
				internalType: "struct Multicall3.Call[]",
				name: "calls",
				type: "tuple[]"
			}
		],
		name: "tryBlockAndAggregate",
		outputs: [
			{
				internalType: "uint256",
				name: "blockNumber",
				type: "uint256"
			},
			{
				internalType: "bytes32",
				name: "blockHash",
				type: "bytes32"
			},
			{
				components: [
					{
						internalType: "bool",
						name: "success",
						type: "bool"
					},
					{
						internalType: "bytes",
						name: "returnData",
						type: "bytes"
					}
				],
				internalType: "struct Multicall3.Result[]",
				name: "returnData",
				type: "tuple[]"
			}
		],
		stateMutability: "payable",
		type: "function"
	}
];

var SyntheticsReaderAbi = [
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			}
		],
		name: "DisabledMarket",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyMarket",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "x",
				type: "uint256"
			}
		],
		name: "PRBMathUD60x18__Exp2InputTooBig",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "x",
				type: "uint256"
			}
		],
		name: "PRBMathUD60x18__LogInputTooSmall",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "prod1",
				type: "uint256"
			}
		],
		name: "PRBMath__MulDivFixedPointOverflow",
		type: "error"
	},
	{
		inputs: [
		],
		name: "UnableToGetBorrowingFactorEmptyPoolUsd",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "start",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "end",
				type: "uint256"
			}
		],
		name: "getAccountOrders",
		outputs: [
			{
				components: [
					{
						components: [
							{
								internalType: "address",
								name: "account",
								type: "address"
							},
							{
								internalType: "address",
								name: "receiver",
								type: "address"
							},
							{
								internalType: "address",
								name: "callbackContract",
								type: "address"
							},
							{
								internalType: "address",
								name: "uiFeeReceiver",
								type: "address"
							},
							{
								internalType: "address",
								name: "market",
								type: "address"
							},
							{
								internalType: "address",
								name: "initialCollateralToken",
								type: "address"
							},
							{
								internalType: "address[]",
								name: "swapPath",
								type: "address[]"
							}
						],
						internalType: "struct Order.Addresses",
						name: "addresses",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "enum Order.OrderType",
								name: "orderType",
								type: "uint8"
							},
							{
								internalType: "enum Order.DecreasePositionSwapType",
								name: "decreasePositionSwapType",
								type: "uint8"
							},
							{
								internalType: "uint256",
								name: "sizeDeltaUsd",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "initialCollateralDeltaAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "triggerPrice",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "acceptablePrice",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "executionFee",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "callbackGasLimit",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "minOutputAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "updatedAtBlock",
								type: "uint256"
							}
						],
						internalType: "struct Order.Numbers",
						name: "numbers",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "bool",
								name: "isLong",
								type: "bool"
							},
							{
								internalType: "bool",
								name: "shouldUnwrapNativeToken",
								type: "bool"
							},
							{
								internalType: "bool",
								name: "isFrozen",
								type: "bool"
							}
						],
						internalType: "struct Order.Flags",
						name: "flags",
						type: "tuple"
					}
				],
				internalType: "struct Order.Props[]",
				name: "",
				type: "tuple[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				internalType: "contract IReferralStorage",
				name: "referralStorage",
				type: "address"
			},
			{
				internalType: "bytes32[]",
				name: "positionKeys",
				type: "bytes32[]"
			},
			{
				components: [
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "indexTokenPrice",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "longTokenPrice",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "shortTokenPrice",
						type: "tuple"
					}
				],
				internalType: "struct MarketUtils.MarketPrices[]",
				name: "prices",
				type: "tuple[]"
			},
			{
				internalType: "address",
				name: "uiFeeReceiver",
				type: "address"
			}
		],
		name: "getAccountPositionInfoList",
		outputs: [
			{
				components: [
					{
						components: [
							{
								components: [
									{
										internalType: "address",
										name: "account",
										type: "address"
									},
									{
										internalType: "address",
										name: "market",
										type: "address"
									},
									{
										internalType: "address",
										name: "collateralToken",
										type: "address"
									}
								],
								internalType: "struct Position.Addresses",
								name: "addresses",
								type: "tuple"
							},
							{
								components: [
									{
										internalType: "uint256",
										name: "sizeInUsd",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "sizeInTokens",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "collateralAmount",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "borrowingFactor",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "fundingFeeAmountPerSize",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "longTokenClaimableFundingAmountPerSize",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "shortTokenClaimableFundingAmountPerSize",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "increasedAtBlock",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "decreasedAtBlock",
										type: "uint256"
									}
								],
								internalType: "struct Position.Numbers",
								name: "numbers",
								type: "tuple"
							},
							{
								components: [
									{
										internalType: "bool",
										name: "isLong",
										type: "bool"
									}
								],
								internalType: "struct Position.Flags",
								name: "flags",
								type: "tuple"
							}
						],
						internalType: "struct Position.Props",
						name: "position",
						type: "tuple"
					},
					{
						components: [
							{
								components: [
									{
										internalType: "bytes32",
										name: "referralCode",
										type: "bytes32"
									},
									{
										internalType: "address",
										name: "affiliate",
										type: "address"
									},
									{
										internalType: "address",
										name: "trader",
										type: "address"
									},
									{
										internalType: "uint256",
										name: "totalRebateFactor",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "traderDiscountFactor",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "totalRebateAmount",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "traderDiscountAmount",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "affiliateRewardAmount",
										type: "uint256"
									}
								],
								internalType: "struct PositionPricingUtils.PositionReferralFees",
								name: "referral",
								type: "tuple"
							},
							{
								components: [
									{
										internalType: "uint256",
										name: "fundingFeeAmount",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "claimableLongTokenAmount",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "claimableShortTokenAmount",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "latestFundingFeeAmountPerSize",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "latestLongTokenClaimableFundingAmountPerSize",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "latestShortTokenClaimableFundingAmountPerSize",
										type: "uint256"
									}
								],
								internalType: "struct PositionPricingUtils.PositionFundingFees",
								name: "funding",
								type: "tuple"
							},
							{
								components: [
									{
										internalType: "uint256",
										name: "borrowingFeeUsd",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "borrowingFeeAmount",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "borrowingFeeReceiverFactor",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "borrowingFeeAmountForFeeReceiver",
										type: "uint256"
									}
								],
								internalType: "struct PositionPricingUtils.PositionBorrowingFees",
								name: "borrowing",
								type: "tuple"
							},
							{
								components: [
									{
										internalType: "address",
										name: "uiFeeReceiver",
										type: "address"
									},
									{
										internalType: "uint256",
										name: "uiFeeReceiverFactor",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "uiFeeAmount",
										type: "uint256"
									}
								],
								internalType: "struct PositionPricingUtils.PositionUiFees",
								name: "ui",
								type: "tuple"
							},
							{
								components: [
									{
										internalType: "uint256",
										name: "min",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "max",
										type: "uint256"
									}
								],
								internalType: "struct Price.Props",
								name: "collateralTokenPrice",
								type: "tuple"
							},
							{
								internalType: "uint256",
								name: "positionFeeFactor",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "protocolFeeAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "positionFeeReceiverFactor",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "feeReceiverAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "feeAmountForPool",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "positionFeeAmountForPool",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "positionFeeAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "totalCostAmountExcludingFunding",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "totalCostAmount",
								type: "uint256"
							}
						],
						internalType: "struct PositionPricingUtils.PositionFees",
						name: "fees",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "int256",
								name: "priceImpactUsd",
								type: "int256"
							},
							{
								internalType: "uint256",
								name: "priceImpactDiffUsd",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "executionPrice",
								type: "uint256"
							}
						],
						internalType: "struct ReaderPricingUtils.ExecutionPriceResult",
						name: "executionPriceResult",
						type: "tuple"
					},
					{
						internalType: "int256",
						name: "basePnlUsd",
						type: "int256"
					},
					{
						internalType: "int256",
						name: "uncappedBasePnlUsd",
						type: "int256"
					},
					{
						internalType: "int256",
						name: "pnlAfterPriceImpactUsd",
						type: "int256"
					}
				],
				internalType: "struct ReaderUtils.PositionInfo[]",
				name: "",
				type: "tuple[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "start",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "end",
				type: "uint256"
			}
		],
		name: "getAccountPositions",
		outputs: [
			{
				components: [
					{
						components: [
							{
								internalType: "address",
								name: "account",
								type: "address"
							},
							{
								internalType: "address",
								name: "market",
								type: "address"
							},
							{
								internalType: "address",
								name: "collateralToken",
								type: "address"
							}
						],
						internalType: "struct Position.Addresses",
						name: "addresses",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "sizeInUsd",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "sizeInTokens",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "collateralAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "borrowingFactor",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "fundingFeeAmountPerSize",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "longTokenClaimableFundingAmountPerSize",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "shortTokenClaimableFundingAmountPerSize",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "increasedAtBlock",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "decreasedAtBlock",
								type: "uint256"
							}
						],
						internalType: "struct Position.Numbers",
						name: "numbers",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "bool",
								name: "isLong",
								type: "bool"
							}
						],
						internalType: "struct Position.Flags",
						name: "flags",
						type: "tuple"
					}
				],
				internalType: "struct Position.Props[]",
				name: "",
				type: "tuple[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				internalType: "address",
				name: "market",
				type: "address"
			},
			{
				internalType: "bool",
				name: "isLong",
				type: "bool"
			},
			{
				components: [
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "indexTokenPrice",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "longTokenPrice",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "shortTokenPrice",
						type: "tuple"
					}
				],
				internalType: "struct MarketUtils.MarketPrices",
				name: "prices",
				type: "tuple"
			}
		],
		name: "getAdlState",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "",
				type: "bool"
			},
			{
				internalType: "int256",
				name: "",
				type: "int256"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getDeposit",
		outputs: [
			{
				components: [
					{
						components: [
							{
								internalType: "address",
								name: "account",
								type: "address"
							},
							{
								internalType: "address",
								name: "receiver",
								type: "address"
							},
							{
								internalType: "address",
								name: "callbackContract",
								type: "address"
							},
							{
								internalType: "address",
								name: "uiFeeReceiver",
								type: "address"
							},
							{
								internalType: "address",
								name: "market",
								type: "address"
							},
							{
								internalType: "address",
								name: "initialLongToken",
								type: "address"
							},
							{
								internalType: "address",
								name: "initialShortToken",
								type: "address"
							},
							{
								internalType: "address[]",
								name: "longTokenSwapPath",
								type: "address[]"
							},
							{
								internalType: "address[]",
								name: "shortTokenSwapPath",
								type: "address[]"
							}
						],
						internalType: "struct Deposit.Addresses",
						name: "addresses",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "initialLongTokenAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "initialShortTokenAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "minMarketTokens",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "updatedAtBlock",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "executionFee",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "callbackGasLimit",
								type: "uint256"
							}
						],
						internalType: "struct Deposit.Numbers",
						name: "numbers",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "bool",
								name: "shouldUnwrapNativeToken",
								type: "bool"
							}
						],
						internalType: "struct Deposit.Flags",
						name: "flags",
						type: "tuple"
					}
				],
				internalType: "struct Deposit.Props",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				internalType: "address",
				name: "marketKey",
				type: "address"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "min",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "max",
						type: "uint256"
					}
				],
				internalType: "struct Price.Props",
				name: "indexTokenPrice",
				type: "tuple"
			},
			{
				internalType: "uint256",
				name: "positionSizeInUsd",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "positionSizeInTokens",
				type: "uint256"
			},
			{
				internalType: "int256",
				name: "sizeDeltaUsd",
				type: "int256"
			},
			{
				internalType: "bool",
				name: "isLong",
				type: "bool"
			}
		],
		name: "getExecutionPrice",
		outputs: [
			{
				components: [
					{
						internalType: "int256",
						name: "priceImpactUsd",
						type: "int256"
					},
					{
						internalType: "uint256",
						name: "priceImpactDiffUsd",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "executionPrice",
						type: "uint256"
					}
				],
				internalType: "struct ReaderPricingUtils.ExecutionPriceResult",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				internalType: "address",
				name: "key",
				type: "address"
			}
		],
		name: "getMarket",
		outputs: [
			{
				components: [
					{
						internalType: "address",
						name: "marketToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "indexToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "longToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "shortToken",
						type: "address"
					}
				],
				internalType: "struct Market.Props",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				internalType: "bytes32",
				name: "salt",
				type: "bytes32"
			}
		],
		name: "getMarketBySalt",
		outputs: [
			{
				components: [
					{
						internalType: "address",
						name: "marketToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "indexToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "longToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "shortToken",
						type: "address"
					}
				],
				internalType: "struct Market.Props",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				components: [
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "indexTokenPrice",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "longTokenPrice",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "shortTokenPrice",
						type: "tuple"
					}
				],
				internalType: "struct MarketUtils.MarketPrices",
				name: "prices",
				type: "tuple"
			},
			{
				internalType: "address",
				name: "marketKey",
				type: "address"
			}
		],
		name: "getMarketInfo",
		outputs: [
			{
				components: [
					{
						components: [
							{
								internalType: "address",
								name: "marketToken",
								type: "address"
							},
							{
								internalType: "address",
								name: "indexToken",
								type: "address"
							},
							{
								internalType: "address",
								name: "longToken",
								type: "address"
							},
							{
								internalType: "address",
								name: "shortToken",
								type: "address"
							}
						],
						internalType: "struct Market.Props",
						name: "market",
						type: "tuple"
					},
					{
						internalType: "uint256",
						name: "borrowingFactorPerSecondForLongs",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "borrowingFactorPerSecondForShorts",
						type: "uint256"
					},
					{
						components: [
							{
								components: [
									{
										components: [
											{
												internalType: "uint256",
												name: "longToken",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "shortToken",
												type: "uint256"
											}
										],
										internalType: "struct MarketUtils.CollateralType",
										name: "long",
										type: "tuple"
									},
									{
										components: [
											{
												internalType: "uint256",
												name: "longToken",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "shortToken",
												type: "uint256"
											}
										],
										internalType: "struct MarketUtils.CollateralType",
										name: "short",
										type: "tuple"
									}
								],
								internalType: "struct MarketUtils.PositionType",
								name: "fundingFeeAmountPerSize",
								type: "tuple"
							},
							{
								components: [
									{
										components: [
											{
												internalType: "uint256",
												name: "longToken",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "shortToken",
												type: "uint256"
											}
										],
										internalType: "struct MarketUtils.CollateralType",
										name: "long",
										type: "tuple"
									},
									{
										components: [
											{
												internalType: "uint256",
												name: "longToken",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "shortToken",
												type: "uint256"
											}
										],
										internalType: "struct MarketUtils.CollateralType",
										name: "short",
										type: "tuple"
									}
								],
								internalType: "struct MarketUtils.PositionType",
								name: "claimableFundingAmountPerSize",
								type: "tuple"
							}
						],
						internalType: "struct ReaderUtils.BaseFundingValues",
						name: "baseFunding",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "bool",
								name: "longsPayShorts",
								type: "bool"
							},
							{
								internalType: "uint256",
								name: "fundingFactorPerSecond",
								type: "uint256"
							},
							{
								components: [
									{
										components: [
											{
												internalType: "uint256",
												name: "longToken",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "shortToken",
												type: "uint256"
											}
										],
										internalType: "struct MarketUtils.CollateralType",
										name: "long",
										type: "tuple"
									},
									{
										components: [
											{
												internalType: "uint256",
												name: "longToken",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "shortToken",
												type: "uint256"
											}
										],
										internalType: "struct MarketUtils.CollateralType",
										name: "short",
										type: "tuple"
									}
								],
								internalType: "struct MarketUtils.PositionType",
								name: "fundingFeeAmountPerSizeDelta",
								type: "tuple"
							},
							{
								components: [
									{
										components: [
											{
												internalType: "uint256",
												name: "longToken",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "shortToken",
												type: "uint256"
											}
										],
										internalType: "struct MarketUtils.CollateralType",
										name: "long",
										type: "tuple"
									},
									{
										components: [
											{
												internalType: "uint256",
												name: "longToken",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "shortToken",
												type: "uint256"
											}
										],
										internalType: "struct MarketUtils.CollateralType",
										name: "short",
										type: "tuple"
									}
								],
								internalType: "struct MarketUtils.PositionType",
								name: "claimableFundingAmountPerSizeDelta",
								type: "tuple"
							}
						],
						internalType: "struct MarketUtils.GetNextFundingAmountPerSizeResult",
						name: "nextFunding",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "virtualPoolAmountForLongToken",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "virtualPoolAmountForShortToken",
								type: "uint256"
							},
							{
								internalType: "int256",
								name: "virtualInventoryForPositions",
								type: "int256"
							}
						],
						internalType: "struct Reader.VirtualInventory",
						name: "virtualInventory",
						type: "tuple"
					},
					{
						internalType: "bool",
						name: "isDisabled",
						type: "bool"
					}
				],
				internalType: "struct Reader.MarketInfo",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				components: [
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "indexTokenPrice",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "longTokenPrice",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "shortTokenPrice",
						type: "tuple"
					}
				],
				internalType: "struct MarketUtils.MarketPrices[]",
				name: "marketPricesList",
				type: "tuple[]"
			},
			{
				internalType: "uint256",
				name: "start",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "end",
				type: "uint256"
			}
		],
		name: "getMarketInfoList",
		outputs: [
			{
				components: [
					{
						components: [
							{
								internalType: "address",
								name: "marketToken",
								type: "address"
							},
							{
								internalType: "address",
								name: "indexToken",
								type: "address"
							},
							{
								internalType: "address",
								name: "longToken",
								type: "address"
							},
							{
								internalType: "address",
								name: "shortToken",
								type: "address"
							}
						],
						internalType: "struct Market.Props",
						name: "market",
						type: "tuple"
					},
					{
						internalType: "uint256",
						name: "borrowingFactorPerSecondForLongs",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "borrowingFactorPerSecondForShorts",
						type: "uint256"
					},
					{
						components: [
							{
								components: [
									{
										components: [
											{
												internalType: "uint256",
												name: "longToken",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "shortToken",
												type: "uint256"
											}
										],
										internalType: "struct MarketUtils.CollateralType",
										name: "long",
										type: "tuple"
									},
									{
										components: [
											{
												internalType: "uint256",
												name: "longToken",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "shortToken",
												type: "uint256"
											}
										],
										internalType: "struct MarketUtils.CollateralType",
										name: "short",
										type: "tuple"
									}
								],
								internalType: "struct MarketUtils.PositionType",
								name: "fundingFeeAmountPerSize",
								type: "tuple"
							},
							{
								components: [
									{
										components: [
											{
												internalType: "uint256",
												name: "longToken",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "shortToken",
												type: "uint256"
											}
										],
										internalType: "struct MarketUtils.CollateralType",
										name: "long",
										type: "tuple"
									},
									{
										components: [
											{
												internalType: "uint256",
												name: "longToken",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "shortToken",
												type: "uint256"
											}
										],
										internalType: "struct MarketUtils.CollateralType",
										name: "short",
										type: "tuple"
									}
								],
								internalType: "struct MarketUtils.PositionType",
								name: "claimableFundingAmountPerSize",
								type: "tuple"
							}
						],
						internalType: "struct ReaderUtils.BaseFundingValues",
						name: "baseFunding",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "bool",
								name: "longsPayShorts",
								type: "bool"
							},
							{
								internalType: "uint256",
								name: "fundingFactorPerSecond",
								type: "uint256"
							},
							{
								components: [
									{
										components: [
											{
												internalType: "uint256",
												name: "longToken",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "shortToken",
												type: "uint256"
											}
										],
										internalType: "struct MarketUtils.CollateralType",
										name: "long",
										type: "tuple"
									},
									{
										components: [
											{
												internalType: "uint256",
												name: "longToken",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "shortToken",
												type: "uint256"
											}
										],
										internalType: "struct MarketUtils.CollateralType",
										name: "short",
										type: "tuple"
									}
								],
								internalType: "struct MarketUtils.PositionType",
								name: "fundingFeeAmountPerSizeDelta",
								type: "tuple"
							},
							{
								components: [
									{
										components: [
											{
												internalType: "uint256",
												name: "longToken",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "shortToken",
												type: "uint256"
											}
										],
										internalType: "struct MarketUtils.CollateralType",
										name: "long",
										type: "tuple"
									},
									{
										components: [
											{
												internalType: "uint256",
												name: "longToken",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "shortToken",
												type: "uint256"
											}
										],
										internalType: "struct MarketUtils.CollateralType",
										name: "short",
										type: "tuple"
									}
								],
								internalType: "struct MarketUtils.PositionType",
								name: "claimableFundingAmountPerSizeDelta",
								type: "tuple"
							}
						],
						internalType: "struct MarketUtils.GetNextFundingAmountPerSizeResult",
						name: "nextFunding",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "virtualPoolAmountForLongToken",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "virtualPoolAmountForShortToken",
								type: "uint256"
							},
							{
								internalType: "int256",
								name: "virtualInventoryForPositions",
								type: "int256"
							}
						],
						internalType: "struct Reader.VirtualInventory",
						name: "virtualInventory",
						type: "tuple"
					},
					{
						internalType: "bool",
						name: "isDisabled",
						type: "bool"
					}
				],
				internalType: "struct Reader.MarketInfo[]",
				name: "",
				type: "tuple[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				components: [
					{
						internalType: "address",
						name: "marketToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "indexToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "longToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "shortToken",
						type: "address"
					}
				],
				internalType: "struct Market.Props",
				name: "market",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "min",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "max",
						type: "uint256"
					}
				],
				internalType: "struct Price.Props",
				name: "indexTokenPrice",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "min",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "max",
						type: "uint256"
					}
				],
				internalType: "struct Price.Props",
				name: "longTokenPrice",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "min",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "max",
						type: "uint256"
					}
				],
				internalType: "struct Price.Props",
				name: "shortTokenPrice",
				type: "tuple"
			},
			{
				internalType: "bytes32",
				name: "pnlFactorType",
				type: "bytes32"
			},
			{
				internalType: "bool",
				name: "maximize",
				type: "bool"
			}
		],
		name: "getMarketTokenPrice",
		outputs: [
			{
				internalType: "int256",
				name: "",
				type: "int256"
			},
			{
				components: [
					{
						internalType: "int256",
						name: "poolValue",
						type: "int256"
					},
					{
						internalType: "int256",
						name: "longPnl",
						type: "int256"
					},
					{
						internalType: "int256",
						name: "shortPnl",
						type: "int256"
					},
					{
						internalType: "int256",
						name: "netPnl",
						type: "int256"
					},
					{
						internalType: "uint256",
						name: "longTokenAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "shortTokenAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "longTokenUsd",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "shortTokenUsd",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "totalBorrowingFees",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "borrowingFeePoolFactor",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "impactPoolAmount",
						type: "uint256"
					}
				],
				internalType: "struct MarketPoolValueInfo.Props",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "start",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "end",
				type: "uint256"
			}
		],
		name: "getMarkets",
		outputs: [
			{
				components: [
					{
						internalType: "address",
						name: "marketToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "indexToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "longToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "shortToken",
						type: "address"
					}
				],
				internalType: "struct Market.Props[]",
				name: "",
				type: "tuple[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				components: [
					{
						internalType: "address",
						name: "marketToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "indexToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "longToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "shortToken",
						type: "address"
					}
				],
				internalType: "struct Market.Props",
				name: "market",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "min",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "max",
						type: "uint256"
					}
				],
				internalType: "struct Price.Props",
				name: "indexTokenPrice",
				type: "tuple"
			},
			{
				internalType: "bool",
				name: "maximize",
				type: "bool"
			}
		],
		name: "getNetPnl",
		outputs: [
			{
				internalType: "int256",
				name: "",
				type: "int256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				components: [
					{
						internalType: "address",
						name: "marketToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "indexToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "longToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "shortToken",
						type: "address"
					}
				],
				internalType: "struct Market.Props",
				name: "market",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "min",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "max",
						type: "uint256"
					}
				],
				internalType: "struct Price.Props",
				name: "indexTokenPrice",
				type: "tuple"
			},
			{
				internalType: "bool",
				name: "isLong",
				type: "bool"
			},
			{
				internalType: "bool",
				name: "maximize",
				type: "bool"
			}
		],
		name: "getOpenInterestWithPnl",
		outputs: [
			{
				internalType: "int256",
				name: "",
				type: "int256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getOrder",
		outputs: [
			{
				components: [
					{
						components: [
							{
								internalType: "address",
								name: "account",
								type: "address"
							},
							{
								internalType: "address",
								name: "receiver",
								type: "address"
							},
							{
								internalType: "address",
								name: "callbackContract",
								type: "address"
							},
							{
								internalType: "address",
								name: "uiFeeReceiver",
								type: "address"
							},
							{
								internalType: "address",
								name: "market",
								type: "address"
							},
							{
								internalType: "address",
								name: "initialCollateralToken",
								type: "address"
							},
							{
								internalType: "address[]",
								name: "swapPath",
								type: "address[]"
							}
						],
						internalType: "struct Order.Addresses",
						name: "addresses",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "enum Order.OrderType",
								name: "orderType",
								type: "uint8"
							},
							{
								internalType: "enum Order.DecreasePositionSwapType",
								name: "decreasePositionSwapType",
								type: "uint8"
							},
							{
								internalType: "uint256",
								name: "sizeDeltaUsd",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "initialCollateralDeltaAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "triggerPrice",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "acceptablePrice",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "executionFee",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "callbackGasLimit",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "minOutputAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "updatedAtBlock",
								type: "uint256"
							}
						],
						internalType: "struct Order.Numbers",
						name: "numbers",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "bool",
								name: "isLong",
								type: "bool"
							},
							{
								internalType: "bool",
								name: "shouldUnwrapNativeToken",
								type: "bool"
							},
							{
								internalType: "bool",
								name: "isFrozen",
								type: "bool"
							}
						],
						internalType: "struct Order.Flags",
						name: "flags",
						type: "tuple"
					}
				],
				internalType: "struct Order.Props",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				components: [
					{
						internalType: "address",
						name: "marketToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "indexToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "longToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "shortToken",
						type: "address"
					}
				],
				internalType: "struct Market.Props",
				name: "market",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "min",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "max",
						type: "uint256"
					}
				],
				internalType: "struct Price.Props",
				name: "indexTokenPrice",
				type: "tuple"
			},
			{
				internalType: "bool",
				name: "isLong",
				type: "bool"
			},
			{
				internalType: "bool",
				name: "maximize",
				type: "bool"
			}
		],
		name: "getPnl",
		outputs: [
			{
				internalType: "int256",
				name: "",
				type: "int256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				internalType: "address",
				name: "marketAddress",
				type: "address"
			},
			{
				components: [
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "indexTokenPrice",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "longTokenPrice",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "shortTokenPrice",
						type: "tuple"
					}
				],
				internalType: "struct MarketUtils.MarketPrices",
				name: "prices",
				type: "tuple"
			},
			{
				internalType: "bool",
				name: "isLong",
				type: "bool"
			},
			{
				internalType: "bool",
				name: "maximize",
				type: "bool"
			}
		],
		name: "getPnlToPoolFactor",
		outputs: [
			{
				internalType: "int256",
				name: "",
				type: "int256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getPosition",
		outputs: [
			{
				components: [
					{
						components: [
							{
								internalType: "address",
								name: "account",
								type: "address"
							},
							{
								internalType: "address",
								name: "market",
								type: "address"
							},
							{
								internalType: "address",
								name: "collateralToken",
								type: "address"
							}
						],
						internalType: "struct Position.Addresses",
						name: "addresses",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "sizeInUsd",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "sizeInTokens",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "collateralAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "borrowingFactor",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "fundingFeeAmountPerSize",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "longTokenClaimableFundingAmountPerSize",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "shortTokenClaimableFundingAmountPerSize",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "increasedAtBlock",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "decreasedAtBlock",
								type: "uint256"
							}
						],
						internalType: "struct Position.Numbers",
						name: "numbers",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "bool",
								name: "isLong",
								type: "bool"
							}
						],
						internalType: "struct Position.Flags",
						name: "flags",
						type: "tuple"
					}
				],
				internalType: "struct Position.Props",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				internalType: "contract IReferralStorage",
				name: "referralStorage",
				type: "address"
			},
			{
				internalType: "bytes32",
				name: "positionKey",
				type: "bytes32"
			},
			{
				components: [
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "indexTokenPrice",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "longTokenPrice",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "shortTokenPrice",
						type: "tuple"
					}
				],
				internalType: "struct MarketUtils.MarketPrices",
				name: "prices",
				type: "tuple"
			},
			{
				internalType: "uint256",
				name: "sizeDeltaUsd",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "uiFeeReceiver",
				type: "address"
			},
			{
				internalType: "bool",
				name: "usePositionSizeAsSizeDeltaUsd",
				type: "bool"
			}
		],
		name: "getPositionInfo",
		outputs: [
			{
				components: [
					{
						components: [
							{
								components: [
									{
										internalType: "address",
										name: "account",
										type: "address"
									},
									{
										internalType: "address",
										name: "market",
										type: "address"
									},
									{
										internalType: "address",
										name: "collateralToken",
										type: "address"
									}
								],
								internalType: "struct Position.Addresses",
								name: "addresses",
								type: "tuple"
							},
							{
								components: [
									{
										internalType: "uint256",
										name: "sizeInUsd",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "sizeInTokens",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "collateralAmount",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "borrowingFactor",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "fundingFeeAmountPerSize",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "longTokenClaimableFundingAmountPerSize",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "shortTokenClaimableFundingAmountPerSize",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "increasedAtBlock",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "decreasedAtBlock",
										type: "uint256"
									}
								],
								internalType: "struct Position.Numbers",
								name: "numbers",
								type: "tuple"
							},
							{
								components: [
									{
										internalType: "bool",
										name: "isLong",
										type: "bool"
									}
								],
								internalType: "struct Position.Flags",
								name: "flags",
								type: "tuple"
							}
						],
						internalType: "struct Position.Props",
						name: "position",
						type: "tuple"
					},
					{
						components: [
							{
								components: [
									{
										internalType: "bytes32",
										name: "referralCode",
										type: "bytes32"
									},
									{
										internalType: "address",
										name: "affiliate",
										type: "address"
									},
									{
										internalType: "address",
										name: "trader",
										type: "address"
									},
									{
										internalType: "uint256",
										name: "totalRebateFactor",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "traderDiscountFactor",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "totalRebateAmount",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "traderDiscountAmount",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "affiliateRewardAmount",
										type: "uint256"
									}
								],
								internalType: "struct PositionPricingUtils.PositionReferralFees",
								name: "referral",
								type: "tuple"
							},
							{
								components: [
									{
										internalType: "uint256",
										name: "fundingFeeAmount",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "claimableLongTokenAmount",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "claimableShortTokenAmount",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "latestFundingFeeAmountPerSize",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "latestLongTokenClaimableFundingAmountPerSize",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "latestShortTokenClaimableFundingAmountPerSize",
										type: "uint256"
									}
								],
								internalType: "struct PositionPricingUtils.PositionFundingFees",
								name: "funding",
								type: "tuple"
							},
							{
								components: [
									{
										internalType: "uint256",
										name: "borrowingFeeUsd",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "borrowingFeeAmount",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "borrowingFeeReceiverFactor",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "borrowingFeeAmountForFeeReceiver",
										type: "uint256"
									}
								],
								internalType: "struct PositionPricingUtils.PositionBorrowingFees",
								name: "borrowing",
								type: "tuple"
							},
							{
								components: [
									{
										internalType: "address",
										name: "uiFeeReceiver",
										type: "address"
									},
									{
										internalType: "uint256",
										name: "uiFeeReceiverFactor",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "uiFeeAmount",
										type: "uint256"
									}
								],
								internalType: "struct PositionPricingUtils.PositionUiFees",
								name: "ui",
								type: "tuple"
							},
							{
								components: [
									{
										internalType: "uint256",
										name: "min",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "max",
										type: "uint256"
									}
								],
								internalType: "struct Price.Props",
								name: "collateralTokenPrice",
								type: "tuple"
							},
							{
								internalType: "uint256",
								name: "positionFeeFactor",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "protocolFeeAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "positionFeeReceiverFactor",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "feeReceiverAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "feeAmountForPool",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "positionFeeAmountForPool",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "positionFeeAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "totalCostAmountExcludingFunding",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "totalCostAmount",
								type: "uint256"
							}
						],
						internalType: "struct PositionPricingUtils.PositionFees",
						name: "fees",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "int256",
								name: "priceImpactUsd",
								type: "int256"
							},
							{
								internalType: "uint256",
								name: "priceImpactDiffUsd",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "executionPrice",
								type: "uint256"
							}
						],
						internalType: "struct ReaderPricingUtils.ExecutionPriceResult",
						name: "executionPriceResult",
						type: "tuple"
					},
					{
						internalType: "int256",
						name: "basePnlUsd",
						type: "int256"
					},
					{
						internalType: "int256",
						name: "uncappedBasePnlUsd",
						type: "int256"
					},
					{
						internalType: "int256",
						name: "pnlAfterPriceImpactUsd",
						type: "int256"
					}
				],
				internalType: "struct ReaderUtils.PositionInfo",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				components: [
					{
						internalType: "address",
						name: "marketToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "indexToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "longToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "shortToken",
						type: "address"
					}
				],
				internalType: "struct Market.Props",
				name: "market",
				type: "tuple"
			},
			{
				components: [
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "indexTokenPrice",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "longTokenPrice",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "shortTokenPrice",
						type: "tuple"
					}
				],
				internalType: "struct MarketUtils.MarketPrices",
				name: "prices",
				type: "tuple"
			},
			{
				internalType: "bytes32",
				name: "positionKey",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "sizeDeltaUsd",
				type: "uint256"
			}
		],
		name: "getPositionPnlUsd",
		outputs: [
			{
				internalType: "int256",
				name: "",
				type: "int256"
			},
			{
				internalType: "int256",
				name: "",
				type: "int256"
			},
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				components: [
					{
						internalType: "address",
						name: "marketToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "indexToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "longToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "shortToken",
						type: "address"
					}
				],
				internalType: "struct Market.Props",
				name: "market",
				type: "tuple"
			},
			{
				components: [
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "indexTokenPrice",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "longTokenPrice",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "min",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "max",
								type: "uint256"
							}
						],
						internalType: "struct Price.Props",
						name: "shortTokenPrice",
						type: "tuple"
					}
				],
				internalType: "struct MarketUtils.MarketPrices",
				name: "prices",
				type: "tuple"
			},
			{
				internalType: "address",
				name: "tokenIn",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "uiFeeReceiver",
				type: "address"
			}
		],
		name: "getSwapAmountOut",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			},
			{
				internalType: "int256",
				name: "",
				type: "int256"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "feeReceiverAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "feeAmountForPool",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "amountAfterFees",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "uiFeeReceiver",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "uiFeeReceiverFactor",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "uiFeeAmount",
						type: "uint256"
					}
				],
				internalType: "struct SwapPricingUtils.SwapFees",
				name: "fees",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				internalType: "address",
				name: "marketKey",
				type: "address"
			},
			{
				internalType: "address",
				name: "tokenIn",
				type: "address"
			},
			{
				internalType: "address",
				name: "tokenOut",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "min",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "max",
						type: "uint256"
					}
				],
				internalType: "struct Price.Props",
				name: "tokenInPrice",
				type: "tuple"
			},
			{
				components: [
					{
						internalType: "uint256",
						name: "min",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "max",
						type: "uint256"
					}
				],
				internalType: "struct Price.Props",
				name: "tokenOutPrice",
				type: "tuple"
			}
		],
		name: "getSwapPriceImpact",
		outputs: [
			{
				internalType: "int256",
				name: "",
				type: "int256"
			},
			{
				internalType: "int256",
				name: "",
				type: "int256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract DataStore",
				name: "dataStore",
				type: "address"
			},
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getWithdrawal",
		outputs: [
			{
				components: [
					{
						components: [
							{
								internalType: "address",
								name: "account",
								type: "address"
							},
							{
								internalType: "address",
								name: "receiver",
								type: "address"
							},
							{
								internalType: "address",
								name: "callbackContract",
								type: "address"
							},
							{
								internalType: "address",
								name: "uiFeeReceiver",
								type: "address"
							},
							{
								internalType: "address",
								name: "market",
								type: "address"
							},
							{
								internalType: "address[]",
								name: "longTokenSwapPath",
								type: "address[]"
							},
							{
								internalType: "address[]",
								name: "shortTokenSwapPath",
								type: "address[]"
							}
						],
						internalType: "struct Withdrawal.Addresses",
						name: "addresses",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "marketTokenAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "minLongTokenAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "minShortTokenAmount",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "updatedAtBlock",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "executionFee",
								type: "uint256"
							},
							{
								internalType: "uint256",
								name: "callbackGasLimit",
								type: "uint256"
							}
						],
						internalType: "struct Withdrawal.Numbers",
						name: "numbers",
						type: "tuple"
					},
					{
						components: [
							{
								internalType: "bool",
								name: "shouldUnwrapNativeToken",
								type: "bool"
							}
						],
						internalType: "struct Withdrawal.Flags",
						name: "flags",
						type: "tuple"
					}
				],
				internalType: "struct Withdrawal.Props",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	}
];

var GetMarkets = createPlugin({
  protocol: 'SyntheticsReader',
  type: 'GETTER',
  method: 'getMarkets',
  supportedContracts: syntheticsReaderContracts,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          dataStore: new FctAddress({}),
          start: new FctValue({}),
          end: new FctValue({})
        }
      },
      output: {
        'marketData_tuple[]': {
          marketToken: new FctAddress({}),
          indexToken: new FctAddress({}),
          longToken: new FctAddress({}),
          shortToken: new FctAddress({})
        }
      }
    };
  }
});

var TriggerThresholdType = /*#__PURE__*/function (TriggerThresholdType) {
  TriggerThresholdType["Above"] = ">";
  TriggerThresholdType["Below"] = "<";
  return TriggerThresholdType;
}({});
var OrderType = /*#__PURE__*/function (OrderType) {
  OrderType[OrderType["MarketSwap"] = 0] = "MarketSwap";
  OrderType[OrderType["LimitSwap"] = 1] = "LimitSwap";
  OrderType[OrderType["MarketIncrease"] = 2] = "MarketIncrease";
  OrderType[OrderType["LimitIncrease"] = 3] = "LimitIncrease";
  OrderType[OrderType["MarketDecrease"] = 4] = "MarketDecrease";
  OrderType[OrderType["LimitDecrease"] = 5] = "LimitDecrease";
  OrderType[OrderType["StopLossDecrease"] = 6] = "StopLossDecrease";
  OrderType[OrderType["Liquidation"] = 7] = "Liquidation";
  return OrderType;
}({});
var DecreasePositionSwapType = /*#__PURE__*/function (DecreasePositionSwapType) {
  DecreasePositionSwapType[DecreasePositionSwapType["NoSwap"] = 0] = "NoSwap";
  DecreasePositionSwapType[DecreasePositionSwapType["SwapPnlTokenToCollateralToken"] = 1] = "SwapPnlTokenToCollateralToken";
  DecreasePositionSwapType[DecreasePositionSwapType["SwapCollateralTokenToPnlToken"] = 2] = "SwapCollateralTokenToPnlToken";
  return DecreasePositionSwapType;
}({});
var TradeType = /*#__PURE__*/function (TradeType) {
  TradeType["Long"] = "Long";
  TradeType["Short"] = "Short";
  TradeType["Swap"] = "Swap";
  return TradeType;
}({});
var TradeMode = /*#__PURE__*/function (TradeMode) {
  TradeMode["Market"] = "Market";
  TradeMode["Limit"] = "Limit";
  TradeMode["Trigger"] = "Trigger";
  return TradeMode;
}({});

var _GMX_RPC_PROVIDERS, _GMX_FALLBACK_PROVIDE, _ORACLE_KEEPER_URLS;
function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper$3(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }
function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function buildUrl(baseUrl, path, query) {
  var qs = query ? "?".concat(JSON.stringify(query)) : '';
  return "".concat(baseUrl).concat(path).concat(qs);
}
var PRECISION = expandDecimals(1, 30);
var TOKENS_MAP = {};
var V1_TOKENS = {};
var V2_TOKENS = {};
var TOKENS_BY_SYMBOL_MAP = {};
var WRAPPED_TOKENS_MAP = {};
var NATIVE_TOKENS_MAP = {};
var GMX_RPC_PROVIDERS = (_GMX_RPC_PROVIDERS = {}, _defineProperty(_GMX_RPC_PROVIDERS, ARBITRUM, ['https://arb1.arbitrum.io/rpc']), _defineProperty(_GMX_RPC_PROVIDERS, ARBITRUM_GOERLI, ['https://goerli-rollup.arbitrum.io/rpc'
// "https://endpoints.omniatech.io/v1/arbitrum/goerli/public",
// "https://arbitrum-goerli.public.blastapi.io",
]), _GMX_RPC_PROVIDERS);
var GMX_FALLBACK_PROVIDERS = (_GMX_FALLBACK_PROVIDE = {}, _defineProperty(_GMX_FALLBACK_PROVIDE, ARBITRUM, ['https://arb-mainnet.g.alchemy.com/v2/hxBqIr-vfpJ105JPYLei_ibbJLe66k46']), _defineProperty(_GMX_FALLBACK_PROVIDE, ARBITRUM_GOERLI, ['https://arb-goerli.g.alchemy.com/v2/cZfd99JyN42V9Clbs_gOvA3GSBZH1-1j']), _GMX_FALLBACK_PROVIDE);
function getRpcUrl(chainId) {
  return sample(GMX_RPC_PROVIDERS[chainId]);
}
function getFallbackRpcUrl(chainId) {
  return sample(GMX_FALLBACK_PROVIDERS[chainId]);
}
for (var j = 0; j < CHAIN_IDS.length; j++) {
  var _chainId = CHAIN_IDS[j];
  TOKENS_MAP[_chainId] = {};
  TOKENS_BY_SYMBOL_MAP[_chainId] = {};
  V1_TOKENS[_chainId] = [];
  V2_TOKENS[_chainId] = [];
  var tokens = TOKENS[_chainId];
  var wrappedTokenAddress = void 0;
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];
    TOKENS_MAP[_chainId][token.value] = token;
    TOKENS_BY_SYMBOL_MAP[_chainId][token.symbol] = token;
    if (token.isWrapped) {
      WRAPPED_TOKENS_MAP[_chainId] = token;
      wrappedTokenAddress = token.value;
    }
    if (token.isNative) {
      NATIVE_TOKENS_MAP[_chainId] = token;
    }
    if (token.isV1Available && !token.isTempHidden) {
      V1_TOKENS[_chainId].push(token);
    }
    if (!token.isPlatformToken && !token.isTempHidden) {
      V2_TOKENS[_chainId].push(token);
    }
  }
  NATIVE_TOKENS_MAP[_chainId].wrappedAddress = wrappedTokenAddress;
}
var DUST_USD = expandDecimals(1, USD_DECIMALS);
var getContract = function getContract(_ref) {
  var chainId = _ref.chainId,
    name = _ref.name;
  if (chainId === 1) return;
  if (chainId === 5) return;
  var chainIdNumber = Number(chainId);
  if (!contracts[chainIdNumber]) return;
  return contracts[chainIdNumber][name];
};
function getToken(chainId, address) {
  if (!TOKENS_MAP[chainId]) {
    throw new Error("Incorrect chainId ".concat(chainId));
  }
  if (!TOKENS_MAP[chainId][address]) {
    throw new Error("Incorrect address \"".concat(address, "\" for chainId ").concat(chainId));
  }
  return TOKENS_MAP[chainId][address];
}
function getWrappedToken(chainId) {
  return WRAPPED_TOKENS_MAP[chainId];
}
function convertTokenAddress(chainId, address, convertTo) {
  var wrappedToken = getWrappedToken(chainId);
  if (convertTo === 'wrapped' && address === NATIVE_TOKEN_ADDRESS) {
    return wrappedToken.value;
  }
  if (convertTo === 'native' && address === wrappedToken.value) {
    return NATIVE_TOKEN_ADDRESS;
  }
  return address;
}
function getMarketFullName(p) {
  var indexToken = p.indexToken,
    longToken = p.longToken,
    shortToken = p.shortToken,
    isSpotOnly = p.isSpotOnly;
  return "".concat(getMarketIndexName({
    indexToken: indexToken,
    isSpotOnly: isSpotOnly
  }), " [").concat(getMarketPoolName({
    longToken: longToken,
    shortToken: shortToken
  }), "]");
}
function getMarketIndexName(p) {
  var indexToken = p.indexToken,
    isSpotOnly = p.isSpotOnly;
  if (isSpotOnly) {
    return "SWAP-ONLY";
  }
  return "".concat(indexToken.baseSymbol || indexToken.symbol, "/USD");
}
function getMarketPoolName(p) {
  var longToken = p.longToken,
    shortToken = p.shortToken;
  if (longToken.value === shortToken.value) {
    return longToken.symbol;
  }
  return "".concat(longToken.symbol, "-").concat(shortToken.symbol);
}
function hashData(dataTypes, dataValues) {
  var bytes = ethers.utils.defaultAbiCoder.encode(dataTypes, dataValues);
  var hash = ethers.utils.keccak256(ethers.utils.arrayify(bytes));
  return hash;
}
function hashString(string) {
  return hashData(['string'], [string]);
}
var MIN_COLLATERAL_USD_KEY = hashString('MIN_COLLATERAL_USD');
var MIN_POSITION_SIZE_USD_KEY = hashString('MIN_POSITION_SIZE_USD');
function getByKey(obj, key) {
  if (!obj || !key) return undefined;
  if (obj[key]) return obj[key];
  return undefined;
}
function getV2Tokens(chainId) {
  return V2_TOKENS[chainId];
}
function getTokensMap(chainId) {
  return TOKENS_MAP[chainId];
}
var ORACLE_KEEPER_URLS = (_ORACLE_KEEPER_URLS = {}, _defineProperty(_ORACLE_KEEPER_URLS, ARBITRUM, ['https://arbitrum.gmx-oracle.io', 'https://arbitrum-2.gmx-oracle.io']), _defineProperty(_ORACLE_KEEPER_URLS, ARBITRUM_GOERLI, ['https://oracle-api-arb-goerli-xyguy.ondigitalocean.app']), _ORACLE_KEEPER_URLS);
function getOracleKeeperUrl(chainId, index) {
  var urls = ORACLE_KEEPER_URLS[chainId];
  return urls[index || 0];
}
function fetchTickers(chainId, index) {
  return fetch(buildUrl(getOracleKeeperUrl(chainId, index), '/prices/tickers')).then(function (res) {
    return res.json();
  }).then(function (res) {
    if (!res.length) {
      throw new Error('Invalid tickers response');
    }
    return res;
  }).catch(function (e) {
    if (chainId === ARBITRUM_GOERLI) {
      console.error(e);
      return;
    }
    if (index && index > 0) {
      console.error(e);
      return;
    }
    return fetchTickers(chainId, 1);
  });
}
function bigNumberify(n) {
  try {
    return BigNumber.from(n);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('bigNumberify error', e);
    return undefined;
  }
}
function expandDecimals(n, decimals) {
  // @ts-ignore
  return bigNumberify(n).mul(bigNumberify(10).pow(decimals));
}
function parseOraclePrice(price, tokenDecimals, oracleDecimals) {
  return expandDecimals(price, tokenDecimals + oracleDecimals);
}
function convertToContractPrice(price, tokenDecimals) {
  return price.div(expandDecimals(1, tokenDecimals));
}
function convertToContractTokenPrices(prices, tokenDecimals) {
  return {
    min: convertToContractPrice(prices.minPrice, tokenDecimals),
    max: convertToContractPrice(prices.maxPrice, tokenDecimals)
  };
}
function getContractMarketPrices(tokensData, market) {
  var indexToken = getByKey(tokensData, market.indexTokenAddress);
  var longToken = getByKey(tokensData, market.longTokenAddress);
  var shortToken = getByKey(tokensData, market.shortTokenAddress);
  if (!indexToken || !longToken || !shortToken) {
    return undefined;
  }
  return {
    indexTokenPrice: convertToContractTokenPrices(indexToken.prices, indexToken.decimals),
    longTokenPrice: convertToContractTokenPrices(longToken.prices, longToken.decimals),
    shortTokenPrice: convertToContractTokenPrices(shortToken.prices, shortToken.decimals)
  };
}
function getMarketsGraph(markets) {
  var graph = {
    abjacencyList: {},
    edges: []
  };
  var _iterator = _createForOfIteratorHelper$3(markets),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var market = _step.value;
      var longTokenAddress = market.longTokenAddress,
        shortTokenAddress = market.shortTokenAddress,
        marketTokenAddress = market.marketTokenAddress,
        isSameCollaterals = market.isSameCollaterals,
        isDisabled = market.isDisabled;
      if (isSameCollaterals || isDisabled) {
        continue;
      }
      var longShortEdge = {
        marketInfo: market,
        marketAddress: marketTokenAddress,
        from: longTokenAddress,
        to: shortTokenAddress
      };
      var shortLongEdge = {
        marketInfo: market,
        marketAddress: marketTokenAddress,
        from: shortTokenAddress,
        to: longTokenAddress
      };
      graph.abjacencyList[longTokenAddress] = graph.abjacencyList[longTokenAddress] || [];
      graph.abjacencyList[longTokenAddress].push(longShortEdge);
      graph.abjacencyList[shortTokenAddress] = graph.abjacencyList[shortTokenAddress] || [];
      graph.abjacencyList[shortTokenAddress].push(shortLongEdge);
      graph.edges.push(longShortEdge, shortLongEdge);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return graph;
}
function getTokenPoolType(marketInfo, tokenAddress) {
  var longToken = marketInfo.longToken,
    shortToken = marketInfo.shortToken;
  if (tokenAddress === longToken.value || tokenAddress === NATIVE_TOKEN_ADDRESS && longToken.isWrapped) {
    return 'long';
  }
  if (tokenAddress === shortToken.value || tokenAddress === NATIVE_TOKEN_ADDRESS && shortToken.isWrapped) {
    return 'short';
  }
  return undefined;
}
function convertToTokenAmount(usd, tokenDecimals, price) {
  if (!usd || typeof tokenDecimals !== 'number' || !(price !== null && price !== void 0 && price.gt(0))) {
    return undefined;
  }
  return usd.mul(expandDecimals(1, tokenDecimals)).div(price);
}
function getMidPrice(prices) {
  return prices.minPrice.add(prices.maxPrice).div(2);
}
function convertToUsd(tokenAmount, tokenDecimals, price) {
  if (!tokenAmount || typeof tokenDecimals !== 'number' || !price) {
    return undefined;
  }
  return tokenAmount.mul(price).div(expandDecimals(1, tokenDecimals));
}
function getNextPoolAmountsParams(p) {
  var marketInfo = p.marketInfo,
    longToken = p.longToken,
    shortToken = p.shortToken,
    longPoolAmount = p.longPoolAmount,
    shortPoolAmount = p.shortPoolAmount,
    longDeltaUsd = p.longDeltaUsd,
    shortDeltaUsd = p.shortDeltaUsd;
  var longPrice = getMidPrice(longToken.prices);
  var shortPrice = getMidPrice(shortToken.prices);
  var longPoolUsd = convertToUsd(longPoolAmount, longToken.decimals, longPrice);
  var shortPoolUsd = convertToUsd(shortPoolAmount, shortToken.decimals, shortPrice);
  var longPoolUsdAdjustment = convertToUsd(marketInfo.longPoolAmountAdjustment, longToken.decimals, longPrice);
  var shortPoolUsdAdjustment = convertToUsd(marketInfo.shortPoolAmountAdjustment, shortToken.decimals, shortPrice);
  var nextLongPoolUsd = longPoolUsd.add(longDeltaUsd).add(longPoolUsdAdjustment);
  var nextShortPoolUsd = shortPoolUsd.add(shortDeltaUsd).add(shortPoolUsdAdjustment);
  return {
    longPoolUsd: longPoolUsd,
    shortPoolUsd: shortPoolUsd,
    nextLongPoolUsd: nextLongPoolUsd,
    nextShortPoolUsd: nextShortPoolUsd
  };
}
function applyImpactFactor(diff, factor, exponent) {
  // Convert diff and exponent to float js numbers
  var _diff = Number(diff) / Math.pow(10, 30);
  var _exponent = Number(exponent) / Math.pow(10, 30);

  // Pow and convert back to BigNumber with 30 decimals
  var result = bigNumberify(BigInt(Math.round(Math.pow(_diff, _exponent) * Math.pow(10, 30))));
  result = result.mul(factor).div(expandDecimals(1, 30));
  return result;
}
function calculateImpactForSameSideRebalance(p) {
  var currentDiff = p.currentDiff,
    nextDiff = p.nextDiff,
    hasPositiveImpact = p.hasPositiveImpact,
    factor = p.factor,
    exponentFactor = p.exponentFactor;
  var currentImpact = applyImpactFactor(currentDiff, factor, exponentFactor);
  var nextImpact = applyImpactFactor(nextDiff, factor, exponentFactor);
  var deltaDiff = currentImpact.sub(nextImpact).abs();
  return hasPositiveImpact ? deltaDiff : BigNumber.from(0).sub(deltaDiff);
}
function calculateImpactForCrossoverRebalance(p) {
  var currentDiff = p.currentDiff,
    nextDiff = p.nextDiff,
    factorNegative = p.factorNegative,
    factorPositive = p.factorPositive,
    exponentFactor = p.exponentFactor;
  var positiveImpact = applyImpactFactor(currentDiff, factorPositive, exponentFactor);
  var negativeImpactUsd = applyImpactFactor(nextDiff, factorNegative, exponentFactor);
  var deltaDiffUsd = positiveImpact.sub(negativeImpactUsd).abs();
  return positiveImpact.gt(negativeImpactUsd) ? deltaDiffUsd : BigNumber.from(0).sub(deltaDiffUsd);
}
function getPriceImpactUsd(p) {
  var nextLongUsd = p.nextLongUsd,
    nextShortUsd = p.nextShortUsd;
  if (nextLongUsd.lt(0) || nextShortUsd.lt(0)) {
    if (p.fallbackToZero) {
      return BigNumber.from(0);
    } else {
      throw new Error('Negative pool amount');
    }
  }
  var currentDiff = p.currentLongUsd.sub(p.currentShortUsd).abs();
  var nextDiff = nextLongUsd.sub(nextShortUsd).abs();
  var isSameSideRebalance = p.currentLongUsd.lt(p.currentShortUsd) === nextLongUsd.lt(nextShortUsd);
  var impactUsd;
  if (isSameSideRebalance) {
    var hasPositiveImpact = nextDiff.lt(currentDiff);
    var factor = hasPositiveImpact ? p.factorPositive : p.factorNegative;
    impactUsd = calculateImpactForSameSideRebalance({
      currentDiff: currentDiff,
      nextDiff: nextDiff,
      hasPositiveImpact: hasPositiveImpact,
      factor: factor,
      exponentFactor: p.exponentFactor
    });
  } else {
    impactUsd = calculateImpactForCrossoverRebalance({
      currentDiff: currentDiff,
      nextDiff: nextDiff,
      factorPositive: p.factorPositive,
      factorNegative: p.factorNegative,
      exponentFactor: p.exponentFactor
    });
  }
  return impactUsd;
}
function getPriceImpactForSwap(marketInfo, tokenA, tokenB, usdDeltaTokenA, usdDeltaTokenB) {
  var opts = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var tokenAPoolType = getTokenPoolType(marketInfo, tokenA.value);
  var tokenBPoolType = getTokenPoolType(marketInfo, tokenB.value);
  if (tokenAPoolType === undefined || tokenBPoolType === undefined || tokenAPoolType === tokenBPoolType && !marketInfo.isSameCollaterals) {
    throw new Error("Invalid tokens to swap ".concat(marketInfo.marketTokenAddress, " ").concat(tokenA.value, " ").concat(tokenB.value));
  }
  var _ref2 = tokenAPoolType === 'long' ? [tokenA, tokenB] : [tokenB, tokenA],
    _ref3 = _slicedToArray(_ref2, 2),
    longToken = _ref3[0],
    shortToken = _ref3[1];
  var _ref4 = tokenAPoolType === 'long' ? [usdDeltaTokenA, usdDeltaTokenB] : [usdDeltaTokenB, usdDeltaTokenA],
    _ref5 = _slicedToArray(_ref4, 2),
    longDeltaUsd = _ref5[0],
    shortDeltaUsd = _ref5[1];
  var _getNextPoolAmountsPa = getNextPoolAmountsParams({
      marketInfo: marketInfo,
      longToken: longToken,
      shortToken: shortToken,
      longPoolAmount: marketInfo.longPoolAmount,
      shortPoolAmount: marketInfo.shortPoolAmount,
      longDeltaUsd: longDeltaUsd,
      shortDeltaUsd: shortDeltaUsd
    }),
    longPoolUsd = _getNextPoolAmountsPa.longPoolUsd,
    shortPoolUsd = _getNextPoolAmountsPa.shortPoolUsd,
    nextLongPoolUsd = _getNextPoolAmountsPa.nextLongPoolUsd,
    nextShortPoolUsd = _getNextPoolAmountsPa.nextShortPoolUsd;
  var priceImpactUsd = getPriceImpactUsd({
    currentLongUsd: longPoolUsd,
    currentShortUsd: shortPoolUsd,
    nextLongUsd: nextLongPoolUsd,
    nextShortUsd: nextShortPoolUsd,
    factorPositive: marketInfo.swapImpactFactorPositive,
    factorNegative: marketInfo.swapImpactFactorNegative,
    exponentFactor: marketInfo.swapImpactExponentFactor,
    fallbackToZero: opts.fallbackToZero
  });
  if (priceImpactUsd.gt(0)) {
    return priceImpactUsd;
  }
  var virtualInventoryLong = marketInfo.virtualPoolAmountForLongToken;
  var virtualInventoryShort = marketInfo.virtualPoolAmountForShortToken;
  if (!virtualInventoryLong.gt(0) || !virtualInventoryShort.gt(0)) {
    return priceImpactUsd;
  }
  var virtualInventoryParams = getNextPoolAmountsParams({
    marketInfo: marketInfo,
    longToken: longToken,
    shortToken: shortToken,
    longPoolAmount: virtualInventoryLong,
    shortPoolAmount: virtualInventoryShort,
    longDeltaUsd: longDeltaUsd,
    shortDeltaUsd: shortDeltaUsd
  });
  var priceImpactUsdForVirtualInventory = getPriceImpactUsd({
    currentLongUsd: virtualInventoryParams.longPoolUsd,
    currentShortUsd: virtualInventoryParams.shortPoolUsd,
    nextLongUsd: virtualInventoryParams.nextLongPoolUsd,
    nextShortUsd: virtualInventoryParams.nextShortPoolUsd,
    factorPositive: marketInfo.swapImpactFactorPositive,
    factorNegative: marketInfo.swapImpactFactorNegative,
    exponentFactor: marketInfo.swapImpactExponentFactor,
    fallbackToZero: opts.fallbackToZero
  });
  return priceImpactUsdForVirtualInventory.lt(priceImpactUsd) ? priceImpactUsdForVirtualInventory : priceImpactUsd;
}
function applyFactor(value, factor) {
  return value.mul(factor).div(PRECISION);
}
function roundUpMagnitudeDivision(a, b) {
  if (a.lt(0)) {
    return a.sub(b).add(1).div(b);
  }
  return a.add(b).sub(1).div(b);
}
function getSwapFee(marketInfo, swapAmount, forPositiveImpact) {
  var factor = forPositiveImpact ? marketInfo.swapFeeFactorForPositiveImpact : marketInfo.swapFeeFactorForNegativeImpact;
  return applyFactor(swapAmount, factor);
}
function applySwapImpactWithCap(marketInfo, token, priceImpactDeltaUsd) {
  var tokenPoolType = getTokenPoolType(marketInfo, token.value);
  if (!tokenPoolType) {
    throw new Error("Token ".concat(token.value, " is not a collateral of the market ").concat(marketInfo.marketTokenAddress));
  }
  var isLongCollateral = tokenPoolType === 'long';
  var price = priceImpactDeltaUsd.gt(0) ? token.prices.maxPrice : token.prices.minPrice;
  var impactDeltaAmount;
  if (priceImpactDeltaUsd.gt(0)) {
    // round positive impactAmount down, this will be deducted from the swap impact pool for the user
    impactDeltaAmount = convertToTokenAmount(priceImpactDeltaUsd, token.decimals, price);
    var maxImpactAmount = isLongCollateral ? marketInfo.swapImpactPoolAmountLong : marketInfo.swapImpactPoolAmountShort;
    if (impactDeltaAmount.gt(maxImpactAmount)) {
      impactDeltaAmount = maxImpactAmount;
    }
  } else {
    // round negative impactAmount up, this will be deducted from the user
    impactDeltaAmount = roundUpMagnitudeDivision(priceImpactDeltaUsd.mul(expandDecimals(1, token.decimals)), price);
  }
  return impactDeltaAmount;
}
function getPoolUsdWithoutPnl(marketInfo, isLong, priceType) {
  var poolAmount = isLong ? marketInfo.longPoolAmount : marketInfo.shortPoolAmount;
  var token = isLong ? marketInfo.longToken : marketInfo.shortToken;
  var price;
  if (priceType === 'minPrice') {
    var _token$prices;
    price = (_token$prices = token.prices) === null || _token$prices === void 0 ? void 0 : _token$prices.minPrice;
  } else if (priceType === 'maxPrice') {
    var _token$prices2;
    price = (_token$prices2 = token.prices) === null || _token$prices2 === void 0 ? void 0 : _token$prices2.maxPrice;
  } else {
    price = getMidPrice(token.prices);
  }
  return convertToUsd(poolAmount, token.decimals, price);
}
function getReservedUsd(marketInfo, isLong) {
  var indexToken = marketInfo.indexToken;
  if (isLong) {
    return convertToUsd(marketInfo.longInterestInTokens, marketInfo.indexToken.decimals, indexToken.prices.maxPrice);
  } else {
    return marketInfo.shortInterestUsd;
  }
}
function getAvailableUsdLiquidityForCollateral(marketInfo, isLong) {
  var poolUsd = getPoolUsdWithoutPnl(marketInfo, isLong, 'minPrice');
  if (marketInfo.isSpotOnly) {
    return poolUsd;
  }
  var reservedUsd = getReservedUsd(marketInfo, isLong);
  var maxReserveFactor = isLong ? marketInfo.reserveFactorLong : marketInfo.reserveFactorShort;
  if (maxReserveFactor.eq(0)) {
    return BigNumber.from(0);
  }
  var minPoolUsd = reservedUsd.mul(PRECISION).div(maxReserveFactor);
  var liqudiity = poolUsd.sub(minPoolUsd);
  return liqudiity;
}
function getSwapStats(p) {
  var marketInfo = p.marketInfo,
    tokenInAddress = p.tokenInAddress,
    tokenOutAddress = p.tokenOutAddress,
    usdIn = p.usdIn,
    shouldApplyPriceImpact = p.shouldApplyPriceImpact;
  var isWrap = tokenInAddress === NATIVE_TOKEN_ADDRESS;
  var isUnwrap = tokenOutAddress === NATIVE_TOKEN_ADDRESS;
  var tokenIn = getTokenPoolType(marketInfo, tokenInAddress) === 'long' ? marketInfo.longToken : marketInfo.shortToken;
  var tokenOut = getTokenPoolType(marketInfo, tokenOutAddress) === 'long' ? marketInfo.longToken : marketInfo.shortToken;
  var priceIn = tokenIn.prices.minPrice;
  var priceOut = tokenOut.prices.maxPrice;
  var amountIn = convertToTokenAmount(usdIn, tokenIn.decimals, priceIn);
  var priceImpactDeltaUsd;
  try {
    priceImpactDeltaUsd = getPriceImpactForSwap(marketInfo, tokenIn, tokenOut, usdIn, usdIn.mul(-1));
  } catch (e) {
    return {
      swapFeeUsd: BigNumber.from(0),
      swapFeeAmount: BigNumber.from(0),
      isWrap: isWrap,
      isUnwrap: isUnwrap,
      marketAddress: marketInfo.marketTokenAddress,
      tokenInAddress: tokenInAddress,
      tokenOutAddress: tokenOutAddress,
      priceImpactDeltaUsd: BigNumber.from(0),
      amountIn: amountIn,
      amountInAfterFees: amountIn,
      usdIn: usdIn,
      amountOut: BigNumber.from(0),
      usdOut: BigNumber.from(0),
      isOutLiquidity: true
    };
  }
  var swapFeeAmount = getSwapFee(marketInfo, amountIn, priceImpactDeltaUsd.gt(0));
  var swapFeeUsd = getSwapFee(marketInfo, usdIn, priceImpactDeltaUsd.gt(0));
  var amountInAfterFees = amountIn.sub(swapFeeAmount);
  var usdInAfterFees = usdIn.sub(swapFeeUsd);
  var usdOut = usdInAfterFees;
  var amountOut = convertToTokenAmount(usdOut, tokenOut.decimals, priceOut);
  var cappedImpactDeltaUsd;
  if (priceImpactDeltaUsd.gt(0)) {
    var positiveImpactAmount = applySwapImpactWithCap(marketInfo, tokenOut, priceImpactDeltaUsd);
    cappedImpactDeltaUsd = convertToUsd(positiveImpactAmount, tokenOut.decimals, priceOut);
  } else {
    var negativeImpactAmount = applySwapImpactWithCap(marketInfo, tokenIn, priceImpactDeltaUsd);
    cappedImpactDeltaUsd = convertToUsd(negativeImpactAmount, tokenIn.decimals, priceIn);
  }
  if (shouldApplyPriceImpact) {
    usdOut = usdOut.add(cappedImpactDeltaUsd);
  }
  if (usdOut.lt(0)) {
    usdOut = BigNumber.from(0);
  }
  amountOut = convertToTokenAmount(usdOut, tokenOut.decimals, priceOut);
  var liquidity = getAvailableUsdLiquidityForCollateral(marketInfo, getTokenPoolType(marketInfo, tokenOutAddress) === 'long');
  var isOutLiquidity = liquidity.lt(usdOut);
  return {
    swapFeeUsd: swapFeeUsd,
    swapFeeAmount: swapFeeAmount,
    isWrap: isWrap,
    isUnwrap: isUnwrap,
    marketAddress: marketInfo.marketTokenAddress,
    tokenInAddress: tokenInAddress,
    tokenOutAddress: tokenOutAddress,
    priceImpactDeltaUsd: cappedImpactDeltaUsd,
    amountIn: amountIn,
    amountInAfterFees: amountInAfterFees,
    usdIn: usdIn,
    amountOut: amountOut,
    usdOut: usdOut,
    isOutLiquidity: isOutLiquidity
  };
}
var createSwapEstimator = function createSwapEstimator(marketsInfoData) {
  return function (e, usdIn) {
    var marketInfo = marketsInfoData[e.marketAddress];
    var swapStats = getSwapStats({
      marketInfo: marketInfo,
      usdIn: usdIn,
      tokenInAddress: e.from,
      tokenOutAddress: e.to,
      shouldApplyPriceImpact: true
    });
    var isOutLiquidity = swapStats === null || swapStats === void 0 ? void 0 : swapStats.isOutLiquidity;
    var usdOut = swapStats === null || swapStats === void 0 ? void 0 : swapStats.usdOut;
    if (!usdOut || isOutLiquidity) {
      return {
        usdOut: BigNumber.from(0)
      };
    }
    return {
      usdOut: usdOut
    };
  };
};
function getOppositeCollateral(marketInfo, tokenAddress) {
  var poolType = getTokenPoolType(marketInfo, tokenAddress);
  if (poolType === 'long') {
    return marketInfo.shortToken;
  }
  if (poolType === 'short') {
    return marketInfo.longToken;
  }
  return undefined;
}
function getMaxSwapPathLiquidity(p) {
  var marketsInfoData = p.marketsInfoData,
    swapPath = p.swapPath,
    initialCollateralAddress = p.initialCollateralAddress;
  if (swapPath.length === 0) {
    return BigNumber.from(0);
  }
  var minMarketLiquidity = ethers.constants.MaxUint256;
  var tokenInAddress = initialCollateralAddress;
  var _iterator2 = _createForOfIteratorHelper$3(swapPath),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var marketAddress = _step2.value;
      var marketInfo = getByKey(marketsInfoData, marketAddress);
      if (!marketInfo) {
        return BigNumber.from(0);
      }
      var tokenOut = getOppositeCollateral(marketInfo, tokenInAddress);
      if (!tokenOut) {
        return BigNumber.from(0);
      }
      var isTokenOutLong = getTokenPoolType(marketInfo, tokenOut.value) === 'long';
      var liquidity = getAvailableUsdLiquidityForCollateral(marketInfo, isTokenOutLong);
      if (liquidity.lt(minMarketLiquidity)) {
        minMarketLiquidity = liquidity;
      }
      tokenInAddress = tokenOut.value;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  if (minMarketLiquidity.eq(ethers.constants.MaxUint256)) {
    return BigNumber.from(0);
  }
  return minMarketLiquidity;
}
function findAllPaths(marketsInfoData, graph, from, to) {
  var maxDepth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 3;
  var routes = [];
  var edges = graph.abjacencyList[from];
  if (!(edges !== null && edges !== void 0 && edges.length)) {
    return undefined;
  }
  var _iterator3 = _createForOfIteratorHelper$3(edges),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var e = _step3.value;
      dfs(e, [], [], {});
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  function dfs(edge, path, pathEdges, visited) {
    // avoid too deep paths and cycles
    if (path.length >= maxDepth || visited[edge.marketAddress]) {
      return;
    }
    visited[edge.marketAddress] = true;
    pathEdges.push(edge);
    path.push(edge.marketAddress);
    if (edge.to === to) {
      routes.push({
        edged: pathEdges,
        path: path,
        liquidity: getMaxSwapPathLiquidity({
          marketsInfoData: marketsInfoData,
          swapPath: path,
          initialCollateralAddress: from
        })
      });
      return;
    }
    var edges = graph.abjacencyList[edge.to];
    if (!(edges !== null && edges !== void 0 && edges.length)) {
      return;
    }
    var _iterator4 = _createForOfIteratorHelper$3(edges),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var e = _step4.value;
        dfs(e, _toConsumableArray(path), _toConsumableArray(pathEdges), _objectSpread$7({}, visited));
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
  return routes;
}
function getBestSwapPath(routes, usdIn, estimator) {
  if (routes.length === 0) {
    return undefined;
  }
  var bestPath = routes[0].path;
  var bestUsdOut = BigNumber.from(0);
  var _iterator5 = _createForOfIteratorHelper$3(routes),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var route = _step5.value;
      try {
        var pathUsdOut = route.edged.reduce(function (prevUsdOut, edge) {
          var _estimator = estimator(edge, prevUsdOut),
            usdOut = _estimator.usdOut;
          return usdOut;
        }, usdIn);
        if (pathUsdOut.gt(bestUsdOut)) {
          bestPath = route.path;
          bestUsdOut = pathUsdOut;
        }
      } catch (e) {
        continue;
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  return bestPath;
}
function getSwapPathStats(p) {
  var marketsInfoData = p.marketsInfoData,
    swapPath = p.swapPath,
    initialCollateralAddress = p.initialCollateralAddress,
    usdIn = p.usdIn,
    shouldUnwrapNativeToken = p.shouldUnwrapNativeToken,
    shouldApplyPriceImpact = p.shouldApplyPriceImpact,
    wrappedNativeTokenAddress = p.wrappedNativeTokenAddress;
  if (swapPath.length === 0) {
    return undefined;
  }
  var swapSteps = [];
  var usdOut = usdIn;
  var tokenInAddress = initialCollateralAddress;
  var tokenOutAddress = initialCollateralAddress;
  var totalSwapPriceImpactDeltaUsd = BigNumber.from(0);
  var totalSwapFeeUsd = BigNumber.from(0);
  for (var _i = 0; _i < swapPath.length; _i++) {
    var marketAddress = swapPath[_i];
    var marketInfo = marketsInfoData[marketAddress];
    tokenOutAddress = getOppositeCollateral(marketInfo, tokenInAddress).value;
    if (_i === swapPath.length - 1 && shouldUnwrapNativeToken && tokenOutAddress === wrappedNativeTokenAddress) {
      tokenOutAddress = NATIVE_TOKEN_ADDRESS;
    }
    var swapStep = getSwapStats({
      marketInfo: marketInfo,
      tokenInAddress: tokenInAddress,
      tokenOutAddress: tokenOutAddress,
      usdIn: usdOut,
      shouldApplyPriceImpact: shouldApplyPriceImpact
    });
    tokenInAddress = swapStep.tokenOutAddress;
    usdOut = swapStep.usdOut;
    totalSwapPriceImpactDeltaUsd = totalSwapPriceImpactDeltaUsd.add(swapStep.priceImpactDeltaUsd);
    totalSwapFeeUsd = totalSwapFeeUsd.add(swapStep.swapFeeUsd);
    swapSteps.push(swapStep);
  }
  var lastStep = swapSteps[swapSteps.length - 1];
  var targetMarketAddress = lastStep.marketAddress;
  var amountOut = lastStep.amountOut;
  var totalFeesDeltaUsd = BigNumber.from(0).sub(totalSwapFeeUsd).add(totalSwapPriceImpactDeltaUsd);
  return {
    swapPath: swapPath,
    tokenInAddress: tokenInAddress,
    tokenOutAddress: tokenOutAddress,
    targetMarketAddress: targetMarketAddress,
    swapSteps: swapSteps,
    usdOut: usdOut,
    amountOut: amountOut,
    totalSwapFeeUsd: totalSwapFeeUsd,
    totalSwapPriceImpactDeltaUsd: totalSwapPriceImpactDeltaUsd,
    totalFeesDeltaUsd: totalFeesDeltaUsd
  };
}
function getTriggerThresholdType(orderType, isLong) {
  // limit order
  if (orderType === OrderType.LimitIncrease) {
    return isLong ? TriggerThresholdType.Below : TriggerThresholdType.Above;
  }

  // take profit order
  if (orderType === OrderType.LimitDecrease) {
    return isLong ? TriggerThresholdType.Above : TriggerThresholdType.Below;
  }

  // stop loss order
  if (orderType === OrderType.StopLossDecrease) {
    return isLong ? TriggerThresholdType.Below : TriggerThresholdType.Above;
  }
  throw new Error('Invalid trigger order type');
}
function getIsEquivalentTokens(token1, token2) {
  if (token1.value === token2.value) {
    return true;
  }
  if (token1.wrappedAddress === token2.value || token2.wrappedAddress === token1.value) {
    return true;
  }
  return false;
}
function getShouldUseMaxPrice(isIncrease, isLong) {
  return isIncrease ? isLong : !isLong;
}
function getMarkPrice(p) {
  var prices = p.prices,
    isIncrease = p.isIncrease,
    isLong = p.isLong;
  var shouldUseMaxPrice = getShouldUseMaxPrice(isIncrease, isLong);
  return shouldUseMaxPrice ? prices.maxPrice : prices.minPrice;
}
function adjustForDecimals(amount, divDecimals, mulDecimals) {
  return amount.mul(expandDecimals(1, mulDecimals)).div(expandDecimals(1, divDecimals));
}
function getAmountByRatio(p) {
  var fromToken = p.fromToken,
    toToken = p.toToken,
    fromTokenAmount = p.fromTokenAmount,
    ratio = p.ratio,
    shouldInvertRatio = p.shouldInvertRatio;
  if (getIsEquivalentTokens(fromToken, toToken) || fromTokenAmount.eq(0)) {
    return p.fromTokenAmount;
  }
  var _ratio = shouldInvertRatio ? PRECISION.mul(PRECISION).div(ratio) : ratio;
  var adjustedDecimalsRatio = adjustForDecimals(_ratio, fromToken.decimals, toToken.decimals);
  return p.fromTokenAmount.mul(adjustedDecimalsRatio).div(PRECISION);
}
function getSwapAmountsByFromValue(p) {
  var tokenIn = p.tokenIn,
    tokenOut = p.tokenOut,
    amountIn = p.amountIn,
    triggerRatio = p.triggerRatio,
    isLimit = p.isLimit,
    findSwapPath = p.findSwapPath;
  var priceIn = tokenIn.prices.minPrice;
  var priceOut = tokenOut.prices.maxPrice;
  var usdIn = convertToUsd(amountIn, tokenIn.decimals, priceIn);
  var amountOut = BigNumber.from(0);
  var usdOut = BigNumber.from(0);
  var minOutputAmount = BigNumber.from(0);
  var defaultAmounts = {
    amountIn: amountIn,
    usdIn: usdIn,
    amountOut: amountOut,
    usdOut: usdOut,
    minOutputAmount: minOutputAmount,
    priceIn: priceIn,
    priceOut: priceOut,
    swapPathStats: undefined
  };
  if (amountIn.lte(0)) {
    return defaultAmounts;
  }
  if (getIsEquivalentTokens(tokenIn, tokenOut)) {
    amountOut = amountIn;
    usdOut = usdIn;
    minOutputAmount = amountOut;
    return {
      amountIn: amountIn,
      usdIn: usdIn,
      amountOut: amountOut,
      usdOut: usdOut,
      minOutputAmount: minOutputAmount,
      priceIn: priceIn,
      priceOut: priceOut,
      swapPathStats: undefined
    };
  }
  var swapPathStats = findSwapPath(defaultAmounts.usdIn, {
    byLiquidity: isLimit
  });
  if (!swapPathStats) {
    return defaultAmounts;
  }
  if (isLimit) {
    if (!triggerRatio) {
      return defaultAmounts;
    }
    amountOut = getAmountByRatio({
      fromToken: tokenIn,
      toToken: tokenOut,
      fromTokenAmount: amountIn,
      ratio: triggerRatio.ratio,
      shouldInvertRatio: triggerRatio.largestToken.value === tokenOut.value
    });
    usdOut = convertToUsd(amountOut, tokenOut.decimals, priceOut);
    usdOut = usdOut.sub(swapPathStats.totalSwapFeeUsd).add(swapPathStats.totalSwapPriceImpactDeltaUsd);
    amountOut = convertToTokenAmount(usdOut, tokenOut.decimals, priceOut);
    minOutputAmount = amountOut;
  } else {
    usdOut = swapPathStats.usdOut;
    amountOut = swapPathStats.amountOut;
    minOutputAmount = amountOut;
  }
  if (amountOut.lt(0)) {
    amountOut = BigNumber.from(0);
    usdOut = BigNumber.from(0);
    minOutputAmount = BigNumber.from(0);
  }
  return {
    amountIn: amountIn,
    usdIn: usdIn,
    amountOut: amountOut,
    usdOut: usdOut,
    priceIn: priceIn,
    priceOut: priceOut,
    minOutputAmount: minOutputAmount,
    swapPathStats: swapPathStats
  };
}
function getSwapAmountsByToValue(p) {
  var tokenIn = p.tokenIn,
    tokenOut = p.tokenOut,
    amountOut = p.amountOut,
    triggerRatio = p.triggerRatio,
    isLimit = p.isLimit,
    findSwapPath = p.findSwapPath;
  var priceIn = tokenIn.prices.minPrice;
  var priceOut = tokenOut.prices.maxPrice;
  var usdOut = convertToUsd(amountOut, tokenOut.decimals, priceOut);
  var minOutputAmount = amountOut;
  var amountIn = BigNumber.from(0);
  var usdIn = BigNumber.from(0);
  var defaultAmounts = {
    amountIn: amountIn,
    usdIn: usdIn,
    amountOut: amountOut,
    usdOut: usdOut,
    minOutputAmount: minOutputAmount,
    priceIn: priceIn,
    priceOut: priceOut,
    swapPathStats: undefined
  };
  if (amountOut.lte(0)) {
    return defaultAmounts;
  }
  if (getIsEquivalentTokens(tokenIn, tokenOut)) {
    amountIn = amountOut;
    usdIn = usdOut;
    return {
      amountIn: amountIn,
      usdIn: usdIn,
      amountOut: amountOut,
      usdOut: usdOut,
      minOutputAmount: minOutputAmount,
      priceIn: priceIn,
      priceOut: priceOut,
      swapPathStats: undefined
    };
  }
  var baseUsdIn = usdOut;
  var swapPathStats = findSwapPath(baseUsdIn, {
    byLiquidity: isLimit
  });
  if (!swapPathStats) {
    return defaultAmounts;
  }
  if (isLimit) {
    if (!triggerRatio) {
      return defaultAmounts;
    }
    amountIn = getAmountByRatio({
      fromToken: tokenOut,
      toToken: tokenIn,
      fromTokenAmount: amountOut,
      ratio: triggerRatio.ratio,
      shouldInvertRatio: triggerRatio.largestToken.value === tokenIn.value
    });
    usdIn = convertToUsd(amountIn, tokenIn.decimals, priceIn);
    usdIn = usdIn.add(swapPathStats.totalSwapFeeUsd).sub(swapPathStats.totalSwapPriceImpactDeltaUsd);
    amountIn = convertToTokenAmount(usdIn, tokenIn.decimals, priceIn);
  } else {
    var adjustedUsdIn = swapPathStats.usdOut.gt(0) ? baseUsdIn.mul(usdOut).div(swapPathStats.usdOut) : BigNumber.from(0);
    usdIn = adjustedUsdIn;
    amountIn = convertToTokenAmount(usdIn, tokenIn.decimals, priceIn);
  }
  if (amountIn.lt(0)) {
    amountIn = BigNumber.from(0);
    usdIn = BigNumber.from(0);
  }
  return {
    amountIn: amountIn,
    usdIn: usdIn,
    amountOut: amountOut,
    usdOut: usdOut,
    minOutputAmount: minOutputAmount,
    priceIn: priceIn,
    priceOut: priceOut,
    swapPathStats: swapPathStats
  };
}
function getNextOpenInterestParams(p) {
  var currentLongUsd = p.currentLongUsd,
    currentShortUsd = p.currentShortUsd,
    usdDelta = p.usdDelta,
    isLong = p.isLong;
  var nextLongUsd = currentLongUsd;
  var nextShortUsd = currentShortUsd;
  if (isLong) {
    nextLongUsd = currentLongUsd === null || currentLongUsd === void 0 ? void 0 : currentLongUsd.add(usdDelta || 0);
  } else {
    nextShortUsd = currentShortUsd === null || currentShortUsd === void 0 ? void 0 : currentShortUsd.add(usdDelta || 0);
  }
  return {
    currentLongUsd: currentLongUsd,
    currentShortUsd: currentShortUsd,
    nextLongUsd: nextLongUsd,
    nextShortUsd: nextShortUsd
  };
}
function getNextOpenInterestForVirtualInventory(p) {
  var virtualInventory = p.virtualInventory,
    usdDelta = p.usdDelta,
    isLong = p.isLong;
  var currentLongUsd = BigNumber.from(0);
  var currentShortUsd = BigNumber.from(0);
  if (virtualInventory.gt(0)) {
    currentShortUsd = virtualInventory;
  } else {
    currentLongUsd = virtualInventory.mul(-1);
  }
  if (usdDelta.lt(0)) {
    var offset = usdDelta.abs();
    currentLongUsd = currentLongUsd.add(offset);
    currentShortUsd = currentShortUsd.add(offset);
  }
  return getNextOpenInterestParams({
    currentLongUsd: currentLongUsd,
    currentShortUsd: currentShortUsd,
    usdDelta: usdDelta,
    isLong: isLong
  });
}
function getPriceImpactForPosition(marketInfo, sizeDeltaUsd, isLong) {
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var longInterestUsd = marketInfo.longInterestUsd,
    shortInterestUsd = marketInfo.shortInterestUsd;
  var _getNextOpenInterestP = getNextOpenInterestParams({
      currentLongUsd: longInterestUsd,
      currentShortUsd: shortInterestUsd,
      usdDelta: sizeDeltaUsd,
      isLong: isLong
    }),
    currentLongUsd = _getNextOpenInterestP.currentLongUsd,
    currentShortUsd = _getNextOpenInterestP.currentShortUsd,
    nextLongUsd = _getNextOpenInterestP.nextLongUsd,
    nextShortUsd = _getNextOpenInterestP.nextShortUsd;
  var priceImpactUsd = getPriceImpactUsd({
    currentLongUsd: currentLongUsd,
    currentShortUsd: currentShortUsd,
    nextLongUsd: nextLongUsd,
    nextShortUsd: nextShortUsd,
    factorPositive: marketInfo.positionImpactFactorPositive,
    factorNegative: marketInfo.positionImpactFactorNegative,
    exponentFactor: marketInfo.positionImpactExponentFactor,
    fallbackToZero: opts.fallbackToZero
  });
  if (priceImpactUsd.gt(0)) {
    return priceImpactUsd;
  }
  if (!marketInfo.virtualInventoryForPositions.abs().gt(0)) {
    return priceImpactUsd;
  }
  var virtualInventoryParams = getNextOpenInterestForVirtualInventory({
    virtualInventory: marketInfo.virtualInventoryForPositions,
    usdDelta: sizeDeltaUsd,
    isLong: isLong
  });
  var priceImpactUsdForVirtualInventory = getPriceImpactUsd({
    currentLongUsd: virtualInventoryParams.currentLongUsd,
    currentShortUsd: virtualInventoryParams.currentShortUsd,
    nextLongUsd: virtualInventoryParams.nextLongUsd,
    nextShortUsd: virtualInventoryParams.nextShortUsd,
    factorPositive: marketInfo.positionImpactFactorPositive,
    factorNegative: marketInfo.positionImpactFactorNegative,
    exponentFactor: marketInfo.positionImpactExponentFactor,
    fallbackToZero: opts.fallbackToZero
  });
  return priceImpactUsdForVirtualInventory.lt(priceImpactUsd) ? priceImpactUsdForVirtualInventory : priceImpactUsd;
}
function getPositionFee(marketInfo, sizeDeltaUsd, forPositiveImpact, referralInfo) {
  var factor = forPositiveImpact ? marketInfo.positionFeeFactorForPositiveImpact : marketInfo.positionFeeFactorForNegativeImpact;
  var positionFeeUsd = applyFactor(sizeDeltaUsd, factor);
  if (!referralInfo) {
    return {
      positionFeeUsd: positionFeeUsd,
      discountUsd: BigNumber.from(0),
      totalRebateUsd: BigNumber.from(0)
    };
  }
  var totalRebateUsd = applyFactor(positionFeeUsd, referralInfo.totalRebateFactor);
  var discountUsd = applyFactor(totalRebateUsd, referralInfo.discountFactor);
  positionFeeUsd = positionFeeUsd.sub(discountUsd);
  return {
    positionFeeUsd: positionFeeUsd,
    discountUsd: discountUsd,
    totalRebateUsd: totalRebateUsd
  };
}
function getPositionPendingFeesUsd(p) {
  var pendingFundingFeesUsd = p.pendingFundingFeesUsd,
    pendingBorrowingFeesUsd = p.pendingBorrowingFeesUsd;
  return pendingBorrowingFeesUsd.add(pendingFundingFeesUsd);
}
function getLeverage(p) {
  var pnl = p.pnl,
    sizeInUsd = p.sizeInUsd,
    collateralUsd = p.collateralUsd,
    pendingBorrowingFeesUsd = p.pendingBorrowingFeesUsd,
    pendingFundingFeesUsd = p.pendingFundingFeesUsd;
  var totalPendingFeesUsd = getPositionPendingFeesUsd({
    pendingFundingFeesUsd: pendingFundingFeesUsd,
    pendingBorrowingFeesUsd: pendingBorrowingFeesUsd
  });
  var remainingCollateralUsd = collateralUsd.add(pnl || 0).sub(totalPendingFeesUsd);
  if (remainingCollateralUsd.lte(0)) {
    return undefined;
  }
  return sizeInUsd.mul(BASIS_POINTS_DIVISOR).div(remainingCollateralUsd);
}
function getPriceImpactByAcceptablePrice(p) {
  var sizeDeltaUsd = p.sizeDeltaUsd,
    acceptablePrice = p.acceptablePrice,
    markPrice = p.indexPrice,
    isLong = p.isLong,
    isIncrease = p.isIncrease;
  var shouldFlipPriceDiff = isIncrease ? !isLong : isLong;
  var priceDiff = markPrice.sub(acceptablePrice).mul(shouldFlipPriceDiff ? -1 : 1);
  var priceImpactDeltaUsd = sizeDeltaUsd.mul(priceDiff).div(acceptablePrice);
  var priceImpactDeltaAmount = priceImpactDeltaUsd.div(markPrice);
  return {
    priceImpactDeltaUsd: priceImpactDeltaUsd,
    priceImpactDeltaAmount: priceImpactDeltaAmount
  };
}
function getCappedPositionImpactUsd(marketInfo, sizeDeltaUsd, isLong) {
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var priceImpactDeltaUsd = getPriceImpactForPosition(marketInfo, sizeDeltaUsd, isLong, opts);
  if (priceImpactDeltaUsd.lt(0)) {
    return priceImpactDeltaUsd;
  }
  var indexToken = marketInfo.indexToken;
  var impactPoolAmount = marketInfo === null || marketInfo === void 0 ? void 0 : marketInfo.positionImpactPoolAmount;
  var maxPriceImpactUsdBasedOnImpactPool = convertToUsd(impactPoolAmount, indexToken.decimals, indexToken.prices.minPrice);
  var cappedImpactUsd = priceImpactDeltaUsd;
  if (cappedImpactUsd.gt(maxPriceImpactUsdBasedOnImpactPool)) {
    cappedImpactUsd = maxPriceImpactUsdBasedOnImpactPool;
  }
  var maxPriceImpactFactor = marketInfo.maxPositionImpactFactorPositive;
  var maxPriceImpactUsdBasedOnMaxPriceImpactFactor = applyFactor(sizeDeltaUsd.abs(), maxPriceImpactFactor);
  if (cappedImpactUsd.gt(maxPriceImpactUsdBasedOnMaxPriceImpactFactor)) {
    cappedImpactUsd = maxPriceImpactUsdBasedOnMaxPriceImpactFactor;
  }
  return cappedImpactUsd;
}
function getBasisPoints(numerator, denominator) {
  return numerator.mul(BASIS_POINTS_DIVISOR).div(denominator);
}
function getAcceptablePriceInfo(p) {
  var marketInfo = p.marketInfo,
    isIncrease = p.isIncrease,
    isLong = p.isLong,
    indexPrice = p.indexPrice,
    sizeDeltaUsd = p.sizeDeltaUsd,
    maxNegativePriceImpactBps = p.maxNegativePriceImpactBps;
  var indexToken = marketInfo.indexToken;
  var values = {
    acceptablePrice: BigNumber.from(0),
    acceptablePriceDeltaBps: BigNumber.from(0),
    priceImpactDeltaAmount: BigNumber.from(0),
    priceImpactDeltaUsd: BigNumber.from(0),
    priceImpactDiffUsd: BigNumber.from(0)
  };
  if (!sizeDeltaUsd.gt(0)) {
    return values;
  }
  var shouldFlipPriceImpact = getShouldUseMaxPrice(p.isIncrease, p.isLong);

  // For Limit / Trigger orders
  if (maxNegativePriceImpactBps !== null && maxNegativePriceImpactBps !== void 0 && maxNegativePriceImpactBps.gt(0)) {
    var _priceDelta2;
    var _priceDelta = indexPrice.mul(maxNegativePriceImpactBps).div(BASIS_POINTS_DIVISOR);
    _priceDelta = shouldFlipPriceImpact ? (_priceDelta2 = _priceDelta) === null || _priceDelta2 === void 0 ? void 0 : _priceDelta2.mul(-1) : _priceDelta;
    values.acceptablePrice = indexPrice.sub(_priceDelta);
    values.acceptablePriceDeltaBps = maxNegativePriceImpactBps.mul(-1);
    var priceImpact = getPriceImpactByAcceptablePrice({
      sizeDeltaUsd: sizeDeltaUsd,
      acceptablePrice: values.acceptablePrice,
      indexPrice: indexPrice,
      isLong: isLong,
      isIncrease: isIncrease
    });
    values.priceImpactDeltaUsd = priceImpact.priceImpactDeltaUsd;
    values.priceImpactDeltaAmount = priceImpact.priceImpactDeltaAmount;
    return values;
  }
  values.priceImpactDeltaUsd = getCappedPositionImpactUsd(marketInfo, isIncrease ? sizeDeltaUsd : sizeDeltaUsd.mul(-1), isLong, {
    fallbackToZero: !isIncrease
  });
  if (!isIncrease && values.priceImpactDeltaUsd.lt(0)) {
    var minPriceImpactUsd = applyFactor(sizeDeltaUsd, marketInfo.maxPositionImpactFactorNegative).mul(-1);
    if (values.priceImpactDeltaUsd.lt(minPriceImpactUsd)) {
      values.priceImpactDiffUsd = minPriceImpactUsd.sub(values.priceImpactDeltaUsd);
      values.priceImpactDeltaUsd = minPriceImpactUsd;
    }
  }
  if (values.priceImpactDeltaUsd.gt(0)) {
    values.priceImpactDeltaAmount = convertToTokenAmount(values.priceImpactDeltaUsd, indexToken.decimals, indexToken.prices.maxPrice);
  } else {
    values.priceImpactDeltaAmount = roundUpMagnitudeDivision(values.priceImpactDeltaUsd.mul(expandDecimals(1, indexToken.decimals)), indexToken.prices.minPrice);
  }
  var priceImpactForPriceAdjustment = shouldFlipPriceImpact ? values.priceImpactDeltaUsd.mul(-1) : values.priceImpactDeltaUsd;
  values.acceptablePrice = indexPrice.mul(sizeDeltaUsd.add(priceImpactForPriceAdjustment)).div(sizeDeltaUsd);
  var priceDelta = indexPrice.sub(values.acceptablePrice).mul(shouldFlipPriceImpact ? 1 : -1);
  values.acceptablePriceDeltaBps = getBasisPoints(priceDelta, p.indexPrice);
  return values;
}
function getIncreasePositionAmounts(p) {
  var marketInfo = p.marketInfo,
    indexToken = p.indexToken,
    initialCollateralToken = p.initialCollateralToken,
    collateralToken = p.collateralToken,
    initialCollateralAmount = p.initialCollateralAmount,
    indexTokenAmount = p.indexTokenAmount,
    isLong = p.isLong,
    leverage = p.leverage,
    triggerPrice = p.triggerPrice,
    position = p.position,
    savedAcceptablePriceImpactBps = p.savedAcceptablePriceImpactBps,
    findSwapPath = p.findSwapPath,
    userReferralInfo = p.userReferralInfo,
    strategy = p.strategy;
  var values = {
    initialCollateralAmount: BigNumber.from(0),
    initialCollateralUsd: BigNumber.from(0),
    collateralDeltaAmount: BigNumber.from(0),
    collateralDeltaUsd: BigNumber.from(0),
    swapPathStats: undefined,
    indexTokenAmount: BigNumber.from(0),
    sizeDeltaUsd: BigNumber.from(0),
    sizeDeltaInTokens: BigNumber.from(0),
    estimatedLeverage: BigNumber.from(0),
    indexPrice: BigNumber.from(0),
    initialCollateralPrice: BigNumber.from(0),
    collateralPrice: BigNumber.from(0),
    triggerPrice: BigNumber.from(0),
    acceptablePrice: BigNumber.from(0),
    acceptablePriceDeltaBps: BigNumber.from(0),
    positionFeeUsd: BigNumber.from(0),
    feeDiscountUsd: BigNumber.from(0),
    borrowingFeeUsd: BigNumber.from(0),
    fundingFeeUsd: BigNumber.from(0),
    positionPriceImpactDeltaUsd: BigNumber.from(0)
  };
  var isLimit = triggerPrice === null || triggerPrice === void 0 ? void 0 : triggerPrice.gt(0);
  if (triggerPrice !== null && triggerPrice !== void 0 && triggerPrice.gt(0)) {
    values.triggerPrice = triggerPrice;
    values.triggerThresholdType = getTriggerThresholdType(OrderType.LimitIncrease, isLong);
    values.indexPrice = triggerPrice;
    values.initialCollateralPrice = getIsEquivalentTokens(indexToken, initialCollateralToken) ? triggerPrice : initialCollateralToken.prices.minPrice;
    values.collateralPrice = getIsEquivalentTokens(indexToken, collateralToken) ? triggerPrice : collateralToken.prices.minPrice;
  } else {
    values.indexPrice = getMarkPrice({
      prices: indexToken.prices,
      isIncrease: true,
      isLong: isLong
    });
    values.initialCollateralPrice = initialCollateralToken.prices.minPrice;
    values.collateralPrice = collateralToken.prices.minPrice;
  }
  values.borrowingFeeUsd = (position === null || position === void 0 ? void 0 : position.pendingBorrowingFeesUsd) || BigNumber.from(0);
  values.fundingFeeUsd = (position === null || position === void 0 ? void 0 : position.pendingFundingFeesUsd) || BigNumber.from(0);
  if (!values.indexPrice.gt(0) || !values.initialCollateralPrice.gt(0) || !values.collateralPrice.gt(0)) {
    return values;
  }

  // Size and collateral
  if (strategy === 'leverageByCollateral' && leverage && initialCollateralAmount !== null && initialCollateralAmount !== void 0 && initialCollateralAmount.gt(0)) {
    values.estimatedLeverage = leverage;
    values.initialCollateralAmount = initialCollateralAmount;
    values.initialCollateralUsd = convertToUsd(initialCollateralAmount, initialCollateralToken.decimals, values.initialCollateralPrice);

    // TODO: collateralPrice?
    var swapAmounts = getSwapAmountsByFromValue({
      tokenIn: initialCollateralToken,
      tokenOut: collateralToken,
      amountIn: initialCollateralAmount,
      isLimit: false,
      findSwapPath: findSwapPath
    });
    values.swapPathStats = swapAmounts.swapPathStats;
    var baseCollateralUsd = convertToUsd(swapAmounts.amountOut, collateralToken.decimals, values.collateralPrice);
    var baseSizeDeltaUsd = baseCollateralUsd.mul(leverage).div(BASIS_POINTS_DIVISOR);
    var basePriceImpactDeltaUsd = getPriceImpactForPosition(marketInfo, baseSizeDeltaUsd, isLong);
    var basePositionFeeInfo = getPositionFee(marketInfo, baseSizeDeltaUsd, basePriceImpactDeltaUsd.gt(0), userReferralInfo);
    values.sizeDeltaUsd = baseCollateralUsd.sub(basePositionFeeInfo.positionFeeUsd).mul(leverage).div(BASIS_POINTS_DIVISOR);
    values.indexTokenAmount = convertToTokenAmount(values.sizeDeltaUsd, indexToken.decimals, values.indexPrice);
    var positionFeeInfo = getPositionFee(marketInfo, values.sizeDeltaUsd, basePriceImpactDeltaUsd.gt(0), userReferralInfo);
    values.positionFeeUsd = positionFeeInfo.positionFeeUsd;
    values.feeDiscountUsd = positionFeeInfo.discountUsd;
    values.collateralDeltaUsd = baseCollateralUsd.sub(values.positionFeeUsd).sub(values.borrowingFeeUsd).sub(values.fundingFeeUsd);
    values.collateralDeltaAmount = convertToTokenAmount(values.collateralDeltaUsd, collateralToken.decimals, values.collateralPrice);
  } else if (strategy === 'leverageBySize' && leverage && indexTokenAmount !== null && indexTokenAmount !== void 0 && indexTokenAmount.gt(0)) {
    values.estimatedLeverage = leverage;
    values.indexTokenAmount = indexTokenAmount;
    values.sizeDeltaUsd = convertToUsd(indexTokenAmount, indexToken.decimals, values.indexPrice);
    var _basePriceImpactDeltaUsd = getPriceImpactForPosition(marketInfo, values.sizeDeltaUsd, isLong);
    var _positionFeeInfo = getPositionFee(marketInfo, values.sizeDeltaUsd, _basePriceImpactDeltaUsd.gt(0), userReferralInfo);
    values.positionFeeUsd = _positionFeeInfo.positionFeeUsd;
    values.feeDiscountUsd = _positionFeeInfo.discountUsd;
    values.collateralDeltaUsd = values.sizeDeltaUsd.mul(BASIS_POINTS_DIVISOR).div(leverage);
    values.collateralDeltaAmount = convertToTokenAmount(values.collateralDeltaUsd, collateralToken.decimals, values.collateralPrice);
    var _baseCollateralUsd = values.collateralDeltaUsd.add(values.positionFeeUsd).add(values.borrowingFeeUsd).add(values.fundingFeeUsd);
    var baseCollateralAmount = convertToTokenAmount(_baseCollateralUsd, collateralToken.decimals, values.collateralPrice);

    // TODO: collateralPrice?
    var _swapAmounts = getSwapAmountsByToValue({
      tokenIn: initialCollateralToken,
      tokenOut: collateralToken,
      amountOut: baseCollateralAmount,
      isLimit: false,
      findSwapPath: findSwapPath
    });
    values.swapPathStats = _swapAmounts.swapPathStats;
    values.initialCollateralAmount = _swapAmounts.amountIn;
    values.initialCollateralUsd = convertToUsd(values.initialCollateralAmount, initialCollateralToken.decimals, values.initialCollateralPrice);
  } else if (strategy === 'independent') {
    if (indexTokenAmount !== null && indexTokenAmount !== void 0 && indexTokenAmount.gt(0)) {
      values.indexTokenAmount = indexTokenAmount;
      values.sizeDeltaUsd = convertToUsd(indexTokenAmount, indexToken.decimals, values.indexPrice);
      var _basePriceImpactDeltaUsd2 = getPriceImpactForPosition(marketInfo, values.sizeDeltaUsd, isLong);
      var _positionFeeInfo2 = getPositionFee(marketInfo, values.sizeDeltaUsd, _basePriceImpactDeltaUsd2.gt(0), userReferralInfo);
      values.positionFeeUsd = _positionFeeInfo2.positionFeeUsd;
      values.feeDiscountUsd = _positionFeeInfo2.discountUsd;
    }
    if (initialCollateralAmount !== null && initialCollateralAmount !== void 0 && initialCollateralAmount.gt(0)) {
      values.initialCollateralAmount = initialCollateralAmount;
      values.initialCollateralUsd = convertToUsd(initialCollateralAmount, initialCollateralToken.decimals, values.initialCollateralPrice);

      // TODO: collateralPrice?
      var _swapAmounts2 = getSwapAmountsByFromValue({
        tokenIn: initialCollateralToken,
        tokenOut: collateralToken,
        amountIn: initialCollateralAmount,
        isLimit: false,
        findSwapPath: findSwapPath
      });
      values.swapPathStats = _swapAmounts2.swapPathStats;
      var _baseCollateralUsd2 = convertToUsd(_swapAmounts2.amountOut, collateralToken.decimals, values.collateralPrice);
      values.collateralDeltaUsd = _baseCollateralUsd2.sub(values.positionFeeUsd).sub(values.borrowingFeeUsd).sub(values.fundingFeeUsd);
      values.collateralDeltaAmount = convertToTokenAmount(values.collateralDeltaUsd, collateralToken.decimals, values.collateralPrice);
    }
    values.estimatedLeverage = getLeverage({
      sizeInUsd: values.sizeDeltaUsd,
      collateralUsd: values.collateralDeltaUsd,
      pnl: BigNumber.from(0),
      pendingBorrowingFeesUsd: BigNumber.from(0),
      pendingFundingFeesUsd: BigNumber.from(0)
    });
  }
  var acceptablePriceInfo = getAcceptablePriceInfo({
    marketInfo: marketInfo,
    isIncrease: true,
    isLong: isLong,
    indexPrice: values.indexPrice,
    sizeDeltaUsd: values.sizeDeltaUsd
  });
  values.positionPriceImpactDeltaUsd = acceptablePriceInfo.priceImpactDeltaUsd;
  values.acceptablePrice = acceptablePriceInfo.acceptablePrice;
  values.acceptablePriceDeltaBps = acceptablePriceInfo.acceptablePriceDeltaBps;
  if (isLimit) {
    var limitAcceptablePriceInfo = getAcceptablePriceInfo({
      marketInfo: marketInfo,
      isIncrease: true,
      isLong: isLong,
      indexPrice: values.indexPrice,
      sizeDeltaUsd: values.sizeDeltaUsd,
      maxNegativePriceImpactBps: savedAcceptablePriceImpactBps
    });
    values.acceptablePrice = limitAcceptablePriceInfo.acceptablePrice;
    values.acceptablePriceDeltaBps = limitAcceptablePriceInfo.acceptablePriceDeltaBps;
    if (values.positionPriceImpactDeltaUsd.lt(limitAcceptablePriceInfo.priceImpactDeltaUsd)) {
      values.positionPriceImpactDeltaUsd = limitAcceptablePriceInfo.priceImpactDeltaUsd;
    }
  }
  var priceImpactAmount = BigNumber.from(0);
  if (values.positionPriceImpactDeltaUsd.gt(0)) {
    var price = triggerPrice !== null && triggerPrice !== void 0 && triggerPrice.gt(0) ? triggerPrice : indexToken.prices.maxPrice;
    priceImpactAmount = convertToTokenAmount(values.positionPriceImpactDeltaUsd, indexToken.decimals, price);
  } else {
    var _price = triggerPrice !== null && triggerPrice !== void 0 && triggerPrice.gt(0) ? triggerPrice : indexToken.prices.minPrice;
    priceImpactAmount = convertToTokenAmount(values.positionPriceImpactDeltaUsd, indexToken.decimals, _price);
  }
  values.sizeDeltaInTokens = convertToTokenAmount(values.sizeDeltaUsd, indexToken.decimals, values.indexPrice);
  if (isLong) {
    values.sizeDeltaInTokens = values.sizeDeltaInTokens.add(priceImpactAmount);
  } else {
    values.sizeDeltaInTokens = values.sizeDeltaInTokens.sub(priceImpactAmount);
  }
  return values;
}
function getTokenData(tokensData, address, convertTo) {
  if (!address || !(tokensData !== null && tokensData !== void 0 && tokensData[address])) {
    return undefined;
  }
  var token = tokensData[address];
  if (convertTo === 'wrapped' && token.isNative && token.wrappedAddress) {
    return tokensData[token.wrappedAddress];
  }
  if (convertTo === 'native' && token.isWrapped) {
    return tokensData[NATIVE_TOKEN_ADDRESS];
  }
  return token;
}
function adaptToV1TokenInfo(tokenData) {
  var _tokenData$prices, _tokenData$prices2;
  return _objectSpread$7(_objectSpread$7({}, tokenData), {}, {
    minPrice: (_tokenData$prices = tokenData.prices) === null || _tokenData$prices === void 0 ? void 0 : _tokenData$prices.minPrice,
    maxPrice: (_tokenData$prices2 = tokenData.prices) === null || _tokenData$prices2 === void 0 ? void 0 : _tokenData$prices2.maxPrice
  });
}
function adaptToV1InfoTokens(tokensData) {
  var infoTokens = Object.keys(tokensData).reduce(function (acc, address) {
    var tokenData = getTokenData(tokensData, address);
    acc[address] = adaptToV1TokenInfo(tokenData);
    return acc;
  }, {});
  return infoTokens;
}
var getAvailabeTokenData = function getAvailabeTokenData(_ref6) {
  var chainId = _ref6.chainId,
    marketsInfoData = _ref6.marketsInfoData,
    tokensData = _ref6.tokensData;
  var marketsInfo = Object.values(marketsInfoData || {}).filter(function (market) {
    return !market.isDisabled;
  }).sort(function (a, b) {
    return a.indexToken.symbol.localeCompare(b.indexToken.symbol);
  });
  var allMarkets = new Set();
  var tokensMap = getTokensMap(chainId);
  var nativeToken = getByKey(tokensData, NATIVE_TOKEN_ADDRESS);
  var indexTokens = new Set();
  var indexTokensWithPoolValue = {};
  var collaterals = new Set();
  var longTokensWithPoolValue = {};
  var shortTokensWithPoolValue = {};
  var _iterator6 = _createForOfIteratorHelper$3(marketsInfo),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var marketInfo = _step6.value;
      var longToken = marketInfo.longToken;
      var shortToken = marketInfo.shortToken;
      var indexToken = marketInfo.indexToken;
      if (marketInfo.isDisabled || !longToken || !shortToken || !indexToken) {
        continue;
      }
      if ((longToken.isWrapped || shortToken.isWrapped) && nativeToken) {
        collaterals.add(nativeToken);
      }
      collaterals.add(longToken);
      collaterals.add(shortToken);
      var longPoolAmountUsd = convertToUsd(marketInfo.longPoolAmount, marketInfo.longToken.decimals, getMidPrice(marketInfo.longToken.prices));
      var shortPoolAmountUsd = convertToUsd(marketInfo.shortPoolAmount, marketInfo.shortToken.decimals, getMidPrice(marketInfo.shortToken.prices));
      longTokensWithPoolValue[longToken.value] = (longTokensWithPoolValue[longToken.value] || BigNumber.from(0)).add(longPoolAmountUsd);
      shortTokensWithPoolValue[shortToken.value] = (shortTokensWithPoolValue[shortToken.value] || BigNumber.from(0)).add(shortPoolAmountUsd);
      if (!marketInfo.isSpotOnly) {
        indexTokens.add(indexToken);
        allMarkets.add(marketInfo);
        indexTokensWithPoolValue[indexToken.value] = (indexTokensWithPoolValue[indexToken.value] || BigNumber.from(0)).add(marketInfo.poolValueMax);
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  var sortedIndexTokensWithPoolValue = Object.keys(indexTokensWithPoolValue).sort(function (a, b) {
    return indexTokensWithPoolValue[b].gt(indexTokensWithPoolValue[a]) ? 1 : -1;
  });
  var sortedAllMarkets = Array.from(allMarkets).sort(function (a, b) {
    return sortedIndexTokensWithPoolValue.indexOf(a.indexToken.value) - sortedIndexTokensWithPoolValue.indexOf(b.indexToken.value);
  });
  var sortedLongTokens = Object.keys(longTokensWithPoolValue).sort(function (a, b) {
    return longTokensWithPoolValue[b].gt(longTokensWithPoolValue[a]) ? 1 : -1;
  });
  var sortedShortTokens = Object.keys(shortTokensWithPoolValue).sort(function (a, b) {
    return shortTokensWithPoolValue[b].gt(shortTokensWithPoolValue[a]) ? 1 : -1;
  });
  var sortedLongAndShortTokens = sortedLongTokens.concat(sortedShortTokens);
  return {
    tokensMap: tokensMap,
    swapTokens: Array.from(collaterals),
    indexTokens: Array.from(indexTokens),
    infoTokens: adaptToV1InfoTokens(tokensData || {}),
    sortedIndexTokensWithPoolValue: sortedIndexTokensWithPoolValue,
    sortedLongAndShortTokens: sortedLongAndShortTokens,
    sortedAllMarkets: sortedAllMarkets
  };
};
var ACCOUNT_POSITION_LIST_KEY = hashString('ACCOUNT_POSITION_LIST');
function accountPositionListKey(account) {
  return hashData(['bytes32', 'address'], [ACCOUNT_POSITION_LIST_KEY, account]);
}
function getTradeFlags(tradeType, tradeMode) {
  var isLong = tradeType === TradeType.Long;
  var isShort = tradeType === TradeType.Short;
  var isSwap = tradeType === TradeType.Swap;
  var isPosition = isLong || isShort;
  var isMarket = tradeMode === TradeMode.Market;
  var isLimit = tradeMode === TradeMode.Limit;
  var isTrigger = tradeMode === TradeMode.Trigger;
  var isIncrease = isPosition && (isMarket || isLimit);
  return {
    isLong: isLong,
    isShort: isShort,
    isSwap: isSwap,
    isPosition: isPosition,
    isIncrease: isIncrease,
    isMarket: isMarket,
    isLimit: isLimit,
    isTrigger: isTrigger
  };
}
function getPositionKey(account, marketAddress, collateralAddress, isLong) {
  return "".concat(account, ":").concat(marketAddress, ":").concat(collateralAddress, ":").concat(isLong);
}
function hashedPositionKey(account, market, collateralToken, isLong) {
  return hashData(['address', 'address', 'address', 'bool'], [account, market, collateralToken, isLong]);
}
var getKeysAndPricesParams = function getKeysAndPricesParams(p) {
  var account = p.account,
    marketsInfoData = p.marketsInfoData,
    tokensData = p.tokensData,
    existingPositionsKeysSet = p.existingPositionsKeysSet;
  var values = {
    allPositionsKeys: [],
    contractPositionsKeys: [],
    marketsPrices: []
  };
  if (!account || !marketsInfoData || !tokensData) {
    return values;
  }
  var markets = Object.values(marketsInfoData);
  for (var _i2 = 0, _markets = markets; _i2 < _markets.length; _i2++) {
    var market = _markets[_i2];
    var marketPrices = getContractMarketPrices(tokensData, market);
    if (!marketPrices) {
      continue;
    }
    var collaterals = market.isSameCollaterals ? [market.longTokenAddress] : [market.longTokenAddress, market.shortTokenAddress];
    for (var _i3 = 0, _collaterals = collaterals; _i3 < _collaterals.length; _i3++) {
      var collateralAddress = _collaterals[_i3];
      for (var _i4 = 0, _arr = [true, false]; _i4 < _arr.length; _i4++) {
        var isLong = _arr[_i4];
        var _positionKey = getPositionKey(account, market.marketTokenAddress, collateralAddress, isLong);
        values.allPositionsKeys.push(_positionKey);
        var contractPositionKey = hashedPositionKey(account, market.marketTokenAddress, collateralAddress, isLong);
        if (existingPositionsKeysSet !== null && existingPositionsKeysSet !== void 0 && existingPositionsKeysSet.has(contractPositionKey)) {
          values.contractPositionsKeys.push(contractPositionKey);
          values.marketsPrices.push(marketPrices);
        }
      }
    }
  }
  return values;
};
function getFeeItem(feeDeltaUsd, basis) {
  if (!feeDeltaUsd) return undefined;
  return {
    deltaUsd: feeDeltaUsd,
    bps: basis !== null && basis !== void 0 && basis.gt(0) ? getBasisPoints(feeDeltaUsd, basis) : BigNumber.from(0)
  };
}
function getTotalFeeItem(feeItems) {
  var totalFeeItem = {
    deltaUsd: BigNumber.from(0),
    bps: BigNumber.from(0)
  };
  feeItems.filter(Boolean).forEach(function (feeItem) {
    totalFeeItem.deltaUsd = totalFeeItem.deltaUsd.add(feeItem.deltaUsd);
    totalFeeItem.bps = totalFeeItem.bps.add(feeItem.bps);
  });
  return totalFeeItem;
}
function getTradeFees(p) {
  var isIncrease = p.isIncrease,
    initialCollateralUsd = p.initialCollateralUsd,
    sizeDeltaUsd = p.sizeDeltaUsd,
    swapSteps = p.swapSteps,
    positionFeeUsd = p.positionFeeUsd,
    swapPriceImpactDeltaUsd = p.swapPriceImpactDeltaUsd,
    positionPriceImpactDeltaUsd = p.positionPriceImpactDeltaUsd,
    borrowingFeeUsd = p.borrowingFeeUsd,
    fundingFeeUsd = p.fundingFeeUsd,
    feeDiscountUsd = p.feeDiscountUsd,
    swapProfitFeeUsd = p.swapProfitFeeUsd;
  var swapFees = initialCollateralUsd.gt(0) ? swapSteps.map(function (step) {
    return {
      tokenInAddress: step.tokenInAddress,
      tokenOutAddress: step.tokenOutAddress,
      marketAddress: step.marketAddress,
      deltaUsd: step.swapFeeUsd.mul(-1),
      bps: !step.usdIn.eq(0) ? getBasisPoints(step.swapFeeUsd.mul(-1), step.usdIn) : BigNumber.from(0)
    };
  }) : undefined;
  var swapProfitFee = getFeeItem(swapProfitFeeUsd.mul(-1), initialCollateralUsd);
  var swapPriceImpact = getFeeItem(swapPriceImpactDeltaUsd, initialCollateralUsd);
  var positionFeeBeforeDiscount = getFeeItem(positionFeeUsd.add(feeDiscountUsd).mul(-1), sizeDeltaUsd);
  var positionFeeAfterDiscount = getFeeItem(positionFeeUsd.mul(-1), sizeDeltaUsd);
  var borrowFee = getFeeItem(borrowingFeeUsd.mul(-1), initialCollateralUsd);
  var fundingFee = getFeeItem(fundingFeeUsd.mul(-1), initialCollateralUsd);
  var positionPriceImpact = getFeeItem(positionPriceImpactDeltaUsd, sizeDeltaUsd);
  var totalFees = getTotalFeeItem([].concat(_toConsumableArray(swapFees || []), [swapProfitFee, swapPriceImpact, positionFeeAfterDiscount, positionPriceImpact, borrowFee, fundingFee]));
  var payTotalFees = getTotalFeeItem([].concat(_toConsumableArray(swapFees || []), [swapProfitFee, swapPriceImpact, positionFeeAfterDiscount, borrowFee, fundingFee, !isIncrease ? positionPriceImpact : undefined]));
  return {
    totalFees: totalFees,
    payTotalFees: payTotalFees,
    swapFees: swapFees,
    swapProfitFee: swapProfitFee,
    swapPriceImpact: swapPriceImpact,
    positionFee: positionFeeBeforeDiscount,
    positionPriceImpact: positionPriceImpact,
    borrowFee: borrowFee,
    fundingFee: fundingFee,
    feeDiscountUsd: feeDiscountUsd
  };
}
function getIsWrap(token1, token2) {
  return token1.isNative && token2.isWrapped;
}
function getIsUnwrap(token1, token2) {
  return token1.isWrapped && token2.isNative;
}
function estimateExecuteIncreaseOrderGasLimit(gasLimits, order) {
  var _order$swapPath2;
  var swapsCount = ((_order$swapPath2 = order.swapPath) === null || _order$swapPath2 === void 0 ? void 0 : _order$swapPath2.length) || 0;
  return gasLimits.increaseOrder.add(gasLimits.singleSwap.mul(swapsCount)).add(order.callbackGasLimit || 0);
}
function getHighExecutionFee(chainId) {
  return HIGH_EXECUTION_FEES_MAP[chainId] || 3;
}
function getExecutionFee(chainId, gasLimts, tokensData, estimatedGasLimit, gasPrice) {
  var nativeToken = getTokenData(tokensData, NATIVE_TOKEN_ADDRESS);
  if (!nativeToken) return undefined;
  var baseGasLimit = gasLimts.estimatedFeeBaseGasLimit;
  var multiplierFactor = gasLimts.estimatedFeeMultiplierFactor;
  var adjustedGasLimit = baseGasLimit.add(applyFactor(estimatedGasLimit, multiplierFactor));
  var feeTokenAmount = adjustedGasLimit.mul(gasPrice);
  var feeUsd = convertToUsd(feeTokenAmount, nativeToken.decimals, nativeToken.prices.minPrice);
  var isFeeHigh = feeUsd.gt(expandDecimals(getHighExecutionFee(chainId), USD_DECIMALS));
  var warning = isFeeHigh ? "The network cost to send transactions is high at the moment, please check the \"Max Execution Fee\" value before proceeding." : undefined;
  return {
    feeUsd: feeUsd,
    feeTokenAmount: feeTokenAmount,
    feeToken: nativeToken,
    warning: warning
  };
}
var getOptimisticPositions = function getOptimisticPositions(_ref7) {
  var positionsData = _ref7.positionsData,
    allPositionsKeys = _ref7.allPositionsKeys;
  if (!allPositionsKeys) {
    return undefined;
  }
  return allPositionsKeys.reduce(function (acc, key) {
    var position;
    if (getByKey(positionsData, key)) {
      position = _objectSpread$7({}, getByKey(positionsData, key));
    } else {
      return acc;
    }
    if (position.sizeInUsd.gt(0)) {
      acc[key] = position;
    }
    return acc;
  }, {});
};
function getPositionValueUsd(p) {
  var indexToken = p.indexToken,
    sizeInTokens = p.sizeInTokens,
    markPrice = p.markPrice;
  return convertToUsd(sizeInTokens, indexToken.decimals, markPrice);
}
function getPositionPnlUsd(p) {
  var marketInfo = p.marketInfo,
    sizeInUsd = p.sizeInUsd,
    sizeInTokens = p.sizeInTokens,
    markPrice = p.markPrice,
    isLong = p.isLong;
  var positionValueUsd = getPositionValueUsd({
    indexToken: marketInfo.indexToken,
    sizeInTokens: sizeInTokens,
    markPrice: markPrice
  });
  var totalPnl = isLong ? positionValueUsd.sub(sizeInUsd) : sizeInUsd.sub(positionValueUsd);
  if (totalPnl.lte(0)) {
    return totalPnl;
  }
  var poolPnl = isLong ? p.marketInfo.pnlLongMax : p.marketInfo.pnlShortMax;
  var poolUsd = getPoolUsdWithoutPnl(marketInfo, isLong, 'minPrice');
  var cappedPnl = getCappedPoolPnl({
    marketInfo: marketInfo,
    poolUsd: poolUsd,
    isLong: isLong,
    maximize: true
  });
  var WEI_PRECISION = expandDecimals(1, 18);
  if (!cappedPnl.eq(poolPnl) && cappedPnl.gt(0) && poolPnl.gt(0)) {
    totalPnl = totalPnl.mul(cappedPnl.div(WEI_PRECISION)).div(poolPnl.div(WEI_PRECISION));
  }
  return totalPnl;
}
function getCappedPoolPnl(p) {
  var marketInfo = p.marketInfo,
    poolUsd = p.poolUsd,
    isLong = p.isLong,
    maximize = p.maximize;
  var poolPnl;
  if (isLong) {
    poolPnl = maximize ? marketInfo.pnlLongMax : marketInfo.pnlLongMin;
  } else {
    poolPnl = maximize ? marketInfo.pnlShortMax : marketInfo.pnlShortMin;
  }
  if (poolPnl.lt(0)) {
    return poolPnl;
  }
  var maxPnlFactor = isLong ? marketInfo.maxPnlFactorForTradersLong : marketInfo.maxPnlFactorForTradersShort;
  var maxPnl = applyFactor(poolUsd, maxPnlFactor);
  return poolPnl.gt(maxPnl) ? maxPnl : poolPnl;
}
function getLiquidationPrice(p) {
  var sizeInUsd = p.sizeInUsd,
    sizeInTokens = p.sizeInTokens,
    collateralUsd = p.collateralUsd,
    collateralAmount = p.collateralAmount,
    marketInfo = p.marketInfo,
    collateralToken = p.collateralToken,
    pendingFundingFeesUsd = p.pendingFundingFeesUsd,
    pendingBorrowingFeesUsd = p.pendingBorrowingFeesUsd,
    minCollateralUsd = p.minCollateralUsd,
    isLong = p.isLong,
    userReferralInfo = p.userReferralInfo,
    useMaxPriceImpact = p.useMaxPriceImpact;
  if (!sizeInUsd.gt(0) || !sizeInTokens.gt(0)) {
    return undefined;
  }
  var indexToken = marketInfo.indexToken;
  var closingFeeUsd = getPositionFee(marketInfo, sizeInUsd, false, userReferralInfo).positionFeeUsd;
  var totalPendingFeesUsd = getPositionPendingFeesUsd({
    pendingFundingFeesUsd: pendingFundingFeesUsd,
    pendingBorrowingFeesUsd: pendingBorrowingFeesUsd
  });
  var totalFeesUsd = totalPendingFeesUsd.add(closingFeeUsd);
  var maxNegativePriceImpactUsd = applyFactor(sizeInUsd, marketInfo.maxPositionImpactFactorForLiquidations).mul(-1);
  var priceImpactDeltaUsd = BigNumber.from(0);
  if (useMaxPriceImpact) {
    priceImpactDeltaUsd = maxNegativePriceImpactUsd;
  } else {
    priceImpactDeltaUsd = getPriceImpactForPosition(marketInfo, sizeInUsd.mul(-1), isLong, {
      fallbackToZero: true
    });
    if (priceImpactDeltaUsd.lt(maxNegativePriceImpactUsd)) {
      priceImpactDeltaUsd = maxNegativePriceImpactUsd;
    }

    // Ignore positive price impact
    if (priceImpactDeltaUsd.gt(0)) {
      priceImpactDeltaUsd = BigNumber.from(0);
    }
  }
  var liquidationCollateralUsd = applyFactor(sizeInUsd, marketInfo.minCollateralFactor);
  if (liquidationCollateralUsd.lt(minCollateralUsd)) {
    liquidationCollateralUsd = minCollateralUsd;
  }
  var liquidationPrice;
  if (getIsEquivalentTokens(collateralToken, indexToken)) {
    if (isLong) {
      var denominator = sizeInTokens.add(collateralAmount);
      if (denominator.eq(0)) {
        return undefined;
      }
      liquidationPrice = sizeInUsd.add(liquidationCollateralUsd).sub(priceImpactDeltaUsd).add(totalFeesUsd).div(denominator).mul(expandDecimals(1, indexToken.decimals));
    } else {
      var _denominator = sizeInTokens.sub(collateralAmount);
      if (_denominator.eq(0)) {
        return undefined;
      }
      liquidationPrice = sizeInUsd.sub(liquidationCollateralUsd).add(priceImpactDeltaUsd).sub(totalFeesUsd).div(_denominator).mul(expandDecimals(1, indexToken.decimals));
    }
  } else {
    if (sizeInTokens.eq(0)) {
      return undefined;
    }
    var remainingCollateralUsd = collateralUsd.add(priceImpactDeltaUsd).sub(totalPendingFeesUsd).sub(closingFeeUsd);
    if (isLong) {
      liquidationPrice = liquidationCollateralUsd.sub(remainingCollateralUsd).add(sizeInUsd).div(sizeInTokens).mul(expandDecimals(1, indexToken.decimals));
    } else {
      liquidationPrice = liquidationCollateralUsd.sub(remainingCollateralUsd).sub(sizeInUsd).div(sizeInTokens.mul(-1)).mul(expandDecimals(1, indexToken.decimals));
    }
  }
  if (liquidationPrice.lte(0)) {
    return undefined;
  }
  return liquidationPrice;
}
function getPositionNetValue(p) {
  var pnl = p.pnl,
    closingFeeUsd = p.closingFeeUsd,
    collateralUsd = p.collateralUsd;
  var pendingFeesUsd = getPositionPendingFeesUsd(p);
  return collateralUsd.sub(pendingFeesUsd).sub(closingFeeUsd).add(pnl);
}
function getEntryPrice(p) {
  var sizeInUsd = p.sizeInUsd,
    sizeInTokens = p.sizeInTokens,
    indexToken = p.indexToken;
  if (!sizeInTokens.gt(0)) {
    return undefined;
  }
  return sizeInUsd.div(sizeInTokens).mul(expandDecimals(1, indexToken.decimals));
}
function isMarketOrderType(orderType) {
  return [OrderType.MarketDecrease, OrderType.MarketIncrease, OrderType.MarketSwap].includes(orderType);
}
function applySlippageToPrice(allowedSlippage, price, isIncrease, isLong) {
  var shouldIncreasePrice = getShouldUseMaxPrice(isIncrease, isLong);
  var slippageBasisPoints = shouldIncreasePrice ? BASIS_POINTS_DIVISOR + allowedSlippage : BASIS_POINTS_DIVISOR - allowedSlippage;
  return price.mul(slippageBasisPoints).div(BASIS_POINTS_DIVISOR);
}
function isVisibleOrder(orderType) {
  return isLimitOrderType(orderType) || isTriggerDecreaseOrderType(orderType) || isLimitSwapOrderType(orderType);
}
function isLimitOrderType(orderType) {
  return [OrderType.LimitIncrease, OrderType.LimitSwap].includes(orderType);
}
function isTriggerDecreaseOrderType(orderType) {
  return [OrderType.LimitDecrease, OrderType.StopLossDecrease].includes(orderType);
}
function isIncreaseOrderType(orderType) {
  return [OrderType.MarketIncrease, OrderType.LimitIncrease].includes(orderType);
}
function isSwapOrderType(orderType) {
  return [OrderType.MarketSwap, OrderType.LimitSwap].includes(orderType);
}
function isLimitSwapOrderType(orderType) {
  return orderType === OrderType.LimitSwap;
}
function getOrderInfo(marketsInfoData, tokensData, wrappedNativeToken, order) {
  if (isSwapOrderType(order.orderType)) {
    var initialCollateralToken = getByKey(tokensData, order.initialCollateralTokenAddress);
    var _getSwapPathOutputAdd = getSwapPathOutputAddresses({
        marketsInfoData: marketsInfoData,
        swapPath: order.swapPath,
        initialCollateralAddress: order.initialCollateralTokenAddress,
        wrappedNativeTokenAddress: wrappedNativeToken.value,
        shouldUnwrapNativeToken: order.shouldUnwrapNativeToken
      }),
      outTokenAddress = _getSwapPathOutputAdd.outTokenAddress;
    var targetCollateralToken = getByKey(tokensData, outTokenAddress);
    if (!initialCollateralToken || !targetCollateralToken) {
      return undefined;
    }
    var swapPathStats = getSwapPathStats({
      marketsInfoData: marketsInfoData,
      swapPath: order.swapPath,
      initialCollateralAddress: order.initialCollateralTokenAddress,
      wrappedNativeTokenAddress: wrappedNativeToken.value,
      usdIn: convertToUsd(order.initialCollateralDeltaAmount, initialCollateralToken.decimals, initialCollateralToken.prices.minPrice),
      shouldUnwrapNativeToken: order.shouldUnwrapNativeToken,
      shouldApplyPriceImpact: true
    });
    var priceImpactAmount = convertToTokenAmount(swapPathStats === null || swapPathStats === void 0 ? void 0 : swapPathStats.totalSwapPriceImpactDeltaUsd, targetCollateralToken.decimals, targetCollateralToken.prices.minPrice);
    var swapFeeAmount = convertToTokenAmount(swapPathStats === null || swapPathStats === void 0 ? void 0 : swapPathStats.totalSwapFeeUsd, targetCollateralToken.decimals, targetCollateralToken.prices.minPrice);
    var toAmount = order.minOutputAmount.sub(priceImpactAmount || 0).add(swapFeeAmount || 0);
    var triggerRatio = getTokensRatioByAmounts({
      fromToken: initialCollateralToken,
      toToken: targetCollateralToken,
      fromTokenAmount: order.initialCollateralDeltaAmount,
      toTokenAmount: toAmount
    });
    var title = getSwapOrderTitle({
      initialCollateralToken: initialCollateralToken,
      targetCollateralToken: targetCollateralToken,
      minOutputAmount: order.minOutputAmount,
      initialCollateralAmount: order.initialCollateralDeltaAmount
    });
    var orderInfo = _objectSpread$7(_objectSpread$7({}, order), {}, {
      swapPathStats: swapPathStats,
      triggerRatio: triggerRatio,
      title: title,
      initialCollateralToken: initialCollateralToken,
      targetCollateralToken: targetCollateralToken
    });
    return orderInfo;
  } else {
    var marketInfo = getByKey(marketsInfoData, order.marketAddress);
    var indexToken = marketInfo === null || marketInfo === void 0 ? void 0 : marketInfo.indexToken;
    var _initialCollateralToken = getByKey(tokensData, order.initialCollateralTokenAddress);
    var _getSwapPathOutputAdd2 = getSwapPathOutputAddresses({
        marketsInfoData: marketsInfoData,
        swapPath: order.swapPath,
        initialCollateralAddress: order.initialCollateralTokenAddress,
        wrappedNativeTokenAddress: wrappedNativeToken.value,
        shouldUnwrapNativeToken: order.shouldUnwrapNativeToken
      }),
      _outTokenAddress = _getSwapPathOutputAdd2.outTokenAddress;
    var _targetCollateralToken = getByKey(tokensData, _outTokenAddress);
    if (!marketInfo || !indexToken || !_initialCollateralToken || !_targetCollateralToken) {
      return undefined;
    }
    var _title = getPositionOrderTitle({
      orderType: order.orderType,
      isLong: order.isLong,
      indexToken: indexToken,
      sizeDeltaUsd: order.sizeDeltaUsd
    });
    var acceptablePrice = parseContractPrice(order.contractAcceptablePrice, indexToken.decimals);
    var triggerPrice = parseContractPrice(order.contractTriggerPrice, indexToken.decimals);
    var _swapPathStats = getSwapPathStats({
      marketsInfoData: marketsInfoData,
      swapPath: order.swapPath,
      initialCollateralAddress: order.initialCollateralTokenAddress,
      wrappedNativeTokenAddress: wrappedNativeToken.value,
      usdIn: convertToUsd(order.initialCollateralDeltaAmount, _initialCollateralToken.decimals, _initialCollateralToken.prices.minPrice),
      shouldUnwrapNativeToken: order.shouldUnwrapNativeToken,
      shouldApplyPriceImpact: true
    });
    var triggerThresholdType = getTriggerThresholdType(order.orderType, order.isLong);
    var _orderInfo = _objectSpread$7(_objectSpread$7({}, order), {}, {
      title: _title,
      swapPathStats: _swapPathStats,
      marketInfo: marketInfo,
      indexToken: indexToken,
      initialCollateralToken: _initialCollateralToken,
      targetCollateralToken: _targetCollateralToken,
      acceptablePrice: acceptablePrice,
      triggerPrice: triggerPrice,
      triggerThresholdType: triggerThresholdType
    });
    return _orderInfo;
  }
}
function getSwapOrderTitle(p) {
  var initialCollateralToken = p.initialCollateralToken,
    initialCollateralAmount = p.initialCollateralAmount,
    targetCollateralToken = p.targetCollateralToken,
    minOutputAmount = p.minOutputAmount;
  var fromTokenText = formatTokenAmount(initialCollateralAmount, initialCollateralToken.decimals, initialCollateralToken.symbol);
  var toTokenText = formatTokenAmount(minOutputAmount, targetCollateralToken.decimals, targetCollateralToken.symbol);
  return "Swap ".concat(fromTokenText, " for ").concat(toTokenText);
}
function formatTokenAmount(amount, tokenDecimals, symbol) {
  var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _opts$displayDecimals = opts.displayDecimals,
    displayDecimals = _opts$displayDecimals === void 0 ? 4 : _opts$displayDecimals,
    _opts$showAllSignific = opts.showAllSignificant,
    showAllSignificant = _opts$showAllSignific === void 0 ? false : _opts$showAllSignific,
    _opts$fallbackToZero = opts.fallbackToZero,
    fallbackToZero = _opts$fallbackToZero === void 0 ? false : _opts$fallbackToZero,
    _opts$useCommas = opts.useCommas,
    useCommas = _opts$useCommas === void 0 ? false : _opts$useCommas,
    _opts$minThreshold = opts.minThreshold,
    minThreshold = _opts$minThreshold === void 0 ? '0' : _opts$minThreshold,
    maxThreshold = opts.maxThreshold;
  var symbolStr = symbol ? "\xA0".concat(symbol) : '';
  if (!amount || !tokenDecimals) {
    if (fallbackToZero) {
      amount = BigNumber.from(0);
      tokenDecimals = displayDecimals;
    } else {
      return undefined;
    }
  }
  var amountStr;
  if (showAllSignificant) {
    amountStr = formatAmountFree(amount, tokenDecimals, tokenDecimals);
  } else {
    var exceedingInfo = getLimitedDisplay(amount, tokenDecimals, {
      maxThreshold: maxThreshold,
      minThreshold: minThreshold
    });
    var _symbol = exceedingInfo.symbol ? "".concat(exceedingInfo.symbol, " ") : '';
    amountStr = "".concat(_symbol).concat(formatAmount(exceedingInfo.value, tokenDecimals, displayDecimals, useCommas));
  }
  return "".concat(amountStr).concat(symbolStr);
}
var formatAmountFree = function formatAmountFree(amount, tokenDecimals, displayDecimals) {
  if (!amount) {
    return '...';
  }
  var amountStr = ethers.utils.formatUnits(amount, tokenDecimals);
  amountStr = limitDecimals(amountStr, displayDecimals);
  return trimZeroDecimals(amountStr);
};
var trimZeroDecimals = function trimZeroDecimals(amount) {
  if (parseFloat(amount) === parseInt(amount)) {
    return parseInt(amount).toString();
  }
  return amount;
};
function parseContractPrice(price, tokenDecimals) {
  return price.mul(expandDecimals(1, tokenDecimals));
}
function getSwapPathOutputAddresses(p) {
  var marketsInfoData = p.marketsInfoData,
    initialCollateralAddress = p.initialCollateralAddress,
    swapPath = p.swapPath,
    wrappedNativeTokenAddress = p.wrappedNativeTokenAddress,
    shouldUnwrapNativeToken = p.shouldUnwrapNativeToken;
  if (swapPath.length === 0) {
    return {
      outTokenAddress: shouldUnwrapNativeToken && initialCollateralAddress === wrappedNativeTokenAddress ? NATIVE_TOKEN_ADDRESS : initialCollateralAddress,
      outMarketAddress: undefined
    };
  }
  var _swapPath = _toArray(swapPath),
    firstMarketAddress = _swapPath[0],
    marketAddresses = _swapPath.slice(1);
  var outMarket = getByKey(marketsInfoData, firstMarketAddress);
  if (!outMarket) {
    return {
      outTokenAddress: undefined,
      outMarketAddress: undefined
    };
  }
  var outTokenType = getTokenPoolType(outMarket, initialCollateralAddress);
  var outToken = outTokenType === 'long' ? outMarket.shortToken : outMarket.longToken;
  var _iterator7 = _createForOfIteratorHelper$3(marketAddresses),
    _step7;
  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var marketAddress = _step7.value;
      outMarket = getByKey(marketsInfoData, marketAddress);
      if (!outMarket) {
        return {
          outTokenAddress: undefined,
          outMarketAddress: undefined
        };
      }
      outTokenType = outMarket.longTokenAddress === outToken.value ? 'short' : 'long';
      outToken = outTokenType === 'long' ? outMarket.longToken : outMarket.shortToken;
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
  var outTokenAddress = shouldUnwrapNativeToken && outToken.value === wrappedNativeTokenAddress ? NATIVE_TOKEN_ADDRESS : outToken.value;
  return {
    outTokenAddress: outTokenAddress,
    outMarketAddress: outMarket.marketTokenAddress
  };
}
function getTokensRatioByAmounts(p) {
  var fromToken = p.fromToken,
    toToken = p.toToken,
    fromTokenAmount = p.fromTokenAmount,
    toTokenAmount = p.toTokenAmount;
  var adjustedFromAmount = fromTokenAmount.mul(PRECISION).div(expandDecimals(1, fromToken.decimals));
  var adjustedToAmount = toTokenAmount.mul(PRECISION).div(expandDecimals(1, toToken.decimals));
  var _ref8 = adjustedFromAmount.gt(adjustedToAmount) ? [fromToken, toToken, adjustedFromAmount, adjustedToAmount] : [toToken, fromToken, adjustedToAmount, adjustedFromAmount],
    _ref9 = _slicedToArray(_ref8, 4),
    smallestToken = _ref9[0],
    largestToken = _ref9[1],
    largestAmount = _ref9[2],
    smallestAmount = _ref9[3];
  var ratio = smallestAmount.gt(0) ? largestAmount.mul(PRECISION).div(smallestAmount) : BigNumber.from(0);
  return {
    ratio: ratio,
    largestToken: largestToken,
    smallestToken: smallestToken
  };
}
function getPositionOrderTitle(p) {
  var orderType = p.orderType,
    isLong = p.isLong,
    indexToken = p.indexToken,
    sizeDeltaUsd = p.sizeDeltaUsd;
  var longShortText = isLong ? "Long" : "Short";
  var tokenText = "".concat(indexToken.symbol, " ").concat(longShortText);
  var sizeText = formatUsd(sizeDeltaUsd);
  var increaseOrDecreaseText = isIncreaseOrderType(orderType) ? "Increase" : "Decrease";
  return "".concat(increaseOrDecreaseText, " ").concat(tokenText, " by ").concat(sizeText);
}
function formatUsd(usd) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _opts$fallbackToZero2 = opts.fallbackToZero,
    fallbackToZero = _opts$fallbackToZero2 === void 0 ? false : _opts$fallbackToZero2,
    _opts$displayDecimals2 = opts.displayDecimals,
    displayDecimals = _opts$displayDecimals2 === void 0 ? 2 : _opts$displayDecimals2;
  if (!usd) {
    if (fallbackToZero) {
      usd = BigNumber.from(0);
    } else {
      return undefined;
    }
  }
  var exceedingInfo = getLimitedDisplay(usd, USD_DECIMALS, opts);
  var sign = usd.lt(0) ? '-' : '';
  var displayUsd = formatAmount(exceedingInfo.value, USD_DECIMALS, displayDecimals, true);
  return "".concat(exceedingInfo.symbol).concat(sign, "$").concat(displayUsd);
}
var formatAmount = function formatAmount(amount, tokenDecimals, displayDecimals, useCommas, defaultValue) {
  if (!defaultValue) {
    defaultValue = '...';
  }
  if (amount === undefined || amount.toString().length === 0) {
    return defaultValue;
  }
  if (displayDecimals === undefined) {
    displayDecimals = 4;
  }
  var amountStr = ethers.utils.formatUnits(amount, tokenDecimals);
  amountStr = limitDecimals(amountStr, displayDecimals);
  if (displayDecimals !== 0) {
    amountStr = padDecimals(amountStr, displayDecimals);
  }
  if (useCommas) {
    return numberWithCommas(amountStr);
  }
  return amountStr;
};
var limitDecimals = function limitDecimals(amount, maxDecimals) {
  var amountStr = amount.toString();
  if (maxDecimals === undefined) {
    return amountStr;
  }
  if (maxDecimals === 0) {
    return amountStr.split('.')[0];
  }
  var dotIndex = amountStr.indexOf('.');
  if (dotIndex !== -1) {
    var decimals = amountStr.length - dotIndex - 1;
    if (decimals > maxDecimals) {
      amountStr = amountStr.substr(0, amountStr.length - (decimals - maxDecimals));
    }
  }
  return amountStr;
};
function numberWithCommas(x) {
  if (!x) {
    return '...';
  }
  var parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}
var padDecimals = function padDecimals(amount, minDecimals) {
  var amountStr = amount.toString();
  var dotIndex = amountStr.indexOf('.');
  if (dotIndex !== -1) {
    var decimals = amountStr.length - dotIndex - 1;
    if (decimals < minDecimals) {
      amountStr = amountStr.padEnd(amountStr.length + (minDecimals - decimals), '0');
    }
  } else {
    amountStr = amountStr + '.0000';
  }
  return amountStr;
};
function getLimitedDisplay(amount, tokenDecimals) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _opts$maxThreshold = opts.maxThreshold,
    maxThreshold = _opts$maxThreshold === void 0 ? MAX_EXCEEDING_THRESHOLD : _opts$maxThreshold,
    _opts$minThreshold2 = opts.minThreshold,
    minThreshold = _opts$minThreshold2 === void 0 ? MIN_EXCEEDING_THRESHOLD : _opts$minThreshold2;
  var max = expandDecimals(maxThreshold, tokenDecimals);
  var min = ethers.utils.parseUnits(minThreshold, tokenDecimals);
  var absAmount = amount.abs();
  if (absAmount.eq(0)) {
    return {
      symbol: '',
      value: absAmount
    };
  }
  var symbol = absAmount.gt(max) ? TRIGGER_PREFIX_ABOVE : absAmount.lt(min) ? TRIGGER_PREFIX_BELOW : '';
  var value = absAmount.gt(max) ? max : absAmount.lt(min) ? min : absAmount;
  return {
    symbol: symbol,
    value: value
  };
}
var applyAcceptablePrice = function applyAcceptablePrice(p) {
  var marketInfo = p.marketInfo,
    isLong = p.isLong,
    values = p.values,
    isTrigger = p.isTrigger,
    savedAcceptablePriceImpactBps = p.savedAcceptablePriceImpactBps;
  var acceptablePriceInfo = getAcceptablePriceInfo({
    marketInfo: marketInfo,
    isIncrease: false,
    isLong: isLong,
    indexPrice: values.indexPrice,
    sizeDeltaUsd: values.sizeDeltaUsd
  });
  values.positionPriceImpactDeltaUsd = acceptablePriceInfo.priceImpactDeltaUsd;
  values.acceptablePrice = acceptablePriceInfo.acceptablePrice;
  values.acceptablePriceDeltaBps = acceptablePriceInfo.acceptablePriceDeltaBps;
  values.priceImpactDiffUsd = acceptablePriceInfo.priceImpactDiffUsd;
  if (isTrigger) {
    if (values.triggerOrderType === OrderType.StopLossDecrease) {
      if (isLong) {
        values.acceptablePrice = BigNumber.from(0);
      } else {
        values.acceptablePrice = ethers.constants.MaxUint256;
      }
    } else {
      var triggerAcceptablePriceInfo = getAcceptablePriceInfo({
        marketInfo: marketInfo,
        isIncrease: false,
        isLong: isLong,
        indexPrice: values.indexPrice,
        sizeDeltaUsd: values.sizeDeltaUsd,
        maxNegativePriceImpactBps: savedAcceptablePriceImpactBps
      });
      values.acceptablePrice = triggerAcceptablePriceInfo.acceptablePrice;
      values.acceptablePriceDeltaBps = triggerAcceptablePriceInfo.acceptablePriceDeltaBps;
      values.priceImpactDiffUsd = triggerAcceptablePriceInfo.priceImpactDiffUsd;
      if (values.positionPriceImpactDeltaUsd.lt(triggerAcceptablePriceInfo.priceImpactDeltaUsd)) {
        values.positionPriceImpactDeltaUsd = triggerAcceptablePriceInfo.priceImpactDeltaUsd;
      }
    }
  }
  return values;
};
function getIsFullClose(p) {
  var position = p.position,
    sizeDeltaUsd = p.sizeDeltaUsd,
    indexPrice = p.indexPrice,
    remainingCollateralUsd = p.remainingCollateralUsd,
    minCollateralUsd = p.minCollateralUsd,
    minPositionSizeUsd = p.minPositionSizeUsd;
  var marketInfo = position.marketInfo,
    isLong = position.isLong;
  if (position.sizeInUsd.sub(sizeDeltaUsd).lt(DUST_USD)) {
    return true;
  }
  var estimatedPnl = getPositionPnlUsd({
    marketInfo: marketInfo,
    sizeInUsd: position.sizeInUsd,
    sizeInTokens: position.sizeInTokens,
    markPrice: indexPrice,
    isLong: isLong
  });
  var realizedPnl = estimatedPnl.mul(sizeDeltaUsd).div(position.sizeInUsd);
  var estimatedRemainingPnl = estimatedPnl.sub(realizedPnl);
  if (realizedPnl.lt(0)) {
    var estimatedRemainingCollateralUsd = remainingCollateralUsd.sub(realizedPnl);
    var minCollateralFactor = isLong ? marketInfo.minCollateralFactorForOpenInterestLong : marketInfo.minCollateralFactorForOpenInterestShort;
    var minCollateralFactorForMarket = marketInfo.minCollateralFactor;
    if (minCollateralFactorForMarket.gt(minCollateralFactor)) {
      minCollateralFactor = minCollateralFactorForMarket;
    }
    var minCollateralUsdForLeverage = applyFactor(position.sizeInUsd, minCollateralFactor);
    var willCollateralBeSufficient = estimatedRemainingCollateralUsd.gte(minCollateralUsdForLeverage);
    if (!willCollateralBeSufficient) {
      if (estimatedRemainingCollateralUsd.add(estimatedRemainingPnl).lt(minCollateralUsd) || position.sizeInUsd.sub(sizeDeltaUsd).lt(minPositionSizeUsd)) {
        return true;
      }
    }
  }
  return false;
}
function roundUpDivision(a, b) {
  return a.add(b).sub(1).div(b);
}
function estimateCollateralCost(baseUsd, collateralToken, collateralPrice) {
  var amount = convertToTokenAmount(baseUsd, collateralToken.decimals, collateralToken.prices.minPrice);
  var usd = convertToUsd(amount, collateralToken.decimals, collateralPrice);
  return {
    amount: amount,
    usd: usd
  };
}
function payForCollateralCost(p) {
  var initialCostUsd = p.initialCostUsd,
    collateralToken = p.collateralToken,
    collateralPrice = p.collateralPrice,
    outputAmount = p.outputAmount,
    remainingCollateralAmount = p.remainingCollateralAmount;
  var values = {
    outputAmount: BigNumber.from(outputAmount),
    remainingCollateralAmount: BigNumber.from(remainingCollateralAmount),
    paidOutputAmount: BigNumber.from(0),
    paidRemainingCollateralAmount: BigNumber.from(0)
  };
  var remainingCostAmount = convertToTokenAmount(initialCostUsd, collateralToken.decimals, collateralPrice);
  if (remainingCostAmount.eq(0)) {
    return values;
  }
  if (values.outputAmount.gt(0)) {
    if (values.outputAmount.gt(remainingCostAmount)) {
      values.outputAmount = values.outputAmount.sub(remainingCostAmount);
      values.paidOutputAmount = remainingCostAmount;
      remainingCostAmount = BigNumber.from(0);
    } else {
      remainingCostAmount = remainingCostAmount.sub(values.outputAmount);
      values.paidOutputAmount = values.outputAmount;
      values.outputAmount = BigNumber.from(0);
    }
  }
  if (remainingCostAmount.eq(0)) {
    return values;
  }
  if (values.remainingCollateralAmount.gt(remainingCostAmount)) {
    values.remainingCollateralAmount = values.remainingCollateralAmount.sub(remainingCostAmount);
    values.paidRemainingCollateralAmount = remainingCostAmount;
    remainingCostAmount = BigNumber.from(0);
  } else {
    remainingCostAmount = remainingCostAmount.sub(remainingCollateralAmount);
    values.paidRemainingCollateralAmount = values.remainingCollateralAmount;
    values.remainingCollateralAmount = BigNumber.from(0);
  }
  return values;
}
var parseValue = function parseValue(value, tokenDecimals) {
  var pValue = parseFloat(value);
  if (isNaN(pValue)) {
    return undefined;
  }
  value = limitDecimals(value, tokenDecimals);
  var amount = ethers.utils.parseUnits(value, tokenDecimals);
  return bigNumberify(amount);
};
function estimateExecuteDecreaseOrderGasLimit(gasLimits, order) {
  var _order$swapPath3;
  var swapsCount = ((_order$swapPath3 = order.swapPath) === null || _order$swapPath3 === void 0 ? void 0 : _order$swapPath3.length) || 0;
  return gasLimits.decreaseOrder.add(gasLimits.singleSwap.mul(swapsCount)).add(order.callbackGasLimit || 0);
}
function applySlippageToMinOut(allowedSlippage, minOutputAmount) {
  var slippageBasisPoints = BASIS_POINTS_DIVISOR - allowedSlippage;
  return minOutputAmount.mul(slippageBasisPoints).div(BASIS_POINTS_DIVISOR);
}

var POSITION_IMPACT_FACTOR_KEY = hashString('POSITION_IMPACT_FACTOR');
var MAX_POSITION_IMPACT_FACTOR_KEY = hashString('MAX_POSITION_IMPACT_FACTOR');
var POSITION_IMPACT_EXPONENT_FACTOR_KEY = hashString('POSITION_IMPACT_EXPONENT_FACTOR');
var POSITION_FEE_FACTOR_KEY = hashString('POSITION_FEE_FACTOR');
var SWAP_IMPACT_FACTOR_KEY = hashString('SWAP_IMPACT_FACTOR');
var SWAP_IMPACT_EXPONENT_FACTOR_KEY = hashString('SWAP_IMPACT_EXPONENT_FACTOR');
var SWAP_FEE_FACTOR_KEY = hashString('SWAP_FEE_FACTOR');
hashString('FEE_RECEIVER_DEPOSIT_FACTOR');
hashString('BORROWING_FEE_RECEIVER_FACTOR');
hashString('FEE_RECEIVER_WITHDRAWAL_FACTOR');
hashString('FEE_RECEIVER_SWAP_FACTOR');
hashString('FEE_RECEIVER_POSITION_FACTOR');
var OPEN_INTEREST_KEY = hashString('OPEN_INTEREST');
var OPEN_INTEREST_IN_TOKENS_KEY = hashString('OPEN_INTEREST_IN_TOKENS');
var POOL_AMOUNT_KEY = hashString('POOL_AMOUNT');
var MAX_POOL_AMOUNT_KEY = hashString('MAX_POOL_AMOUNT');
var RESERVE_FACTOR_KEY = hashString('RESERVE_FACTOR');
var OPEN_INTEREST_RESERVE_FACTOR_KEY = hashString('OPEN_INTEREST_RESERVE_FACTOR');
hashString('NONCE');
var BORROWING_FACTOR_KEY = hashString('BORROWING_FACTOR');
var BORROWING_EXPONENT_FACTOR_KEY = hashString('BORROWING_EXPONENT_FACTOR');
hashString('CUMULATIVE_BORROWING_FACTOR');
hashString('TOTAL_BORROWING');
var FUNDING_FACTOR_KEY = hashString('FUNDING_FACTOR');
var FUNDING_EXPONENT_FACTOR_KEY = hashString('FUNDING_EXPONENT_FACTOR');
var MAX_PNL_FACTOR_KEY = hashString('MAX_PNL_FACTOR');
hashString('MAX_PNL_FACTOR_FOR_WITHDRAWALS');
hashString('MAX_PNL_FACTOR_FOR_DEPOSITS');
var MAX_PNL_FACTOR_FOR_TRADERS_KEY = hashString('MAX_PNL_FACTOR_FOR_TRADERS');
var MAX_POSITION_IMPACT_FACTOR_FOR_LIQUIDATIONS_KEY = hashString('MAX_POSITION_IMPACT_FACTOR_FOR_LIQUIDATIONS');
var POSITION_IMPACT_POOL_AMOUNT_KEY = hashString('POSITION_IMPACT_POOL_AMOUNT');
var SWAP_IMPACT_POOL_AMOUNT_KEY = hashString('SWAP_IMPACT_POOL_AMOUNT');
hashString('MIN_COLLATERAL_USD');
var MIN_COLLATERAL_FACTOR_KEY = hashString('MIN_COLLATERAL_FACTOR');
var MIN_COLLATERAL_FACTOR_FOR_OPEN_INTEREST_MULTIPLIER_KEY = hashString('MIN_COLLATERAL_FACTOR_FOR_OPEN_INTEREST_MULTIPLIER');
hashString('MIN_POSITION_SIZE_USD');
hashString('MAX_LEVERAGE');
var DEPOSIT_GAS_LIMIT_KEY = hashString('DEPOSIT_GAS_LIMIT');
var WITHDRAWAL_GAS_LIMIT_KEY = hashString('WITHDRAWAL_GAS_LIMIT');
var INCREASE_ORDER_GAS_LIMIT_KEY = hashString('INCREASE_ORDER_GAS_LIMIT');
var DECREASE_ORDER_GAS_LIMIT_KEY = hashString('DECREASE_ORDER_GAS_LIMIT');
var SWAP_ORDER_GAS_LIMIT_KEY = hashString('SWAP_ORDER_GAS_LIMIT');
var SINGLE_SWAP_GAS_LIMIT_KEY = hashString('SINGLE_SWAP_GAS_LIMIT');
hashString('TOKEN_TRANSFER_GAS_LIMIT');
hashString('NATIVE_TOKEN_TRANSFER_GAS_LIMIT');
var ESTIMATED_GAS_FEE_BASE_AMOUNT = hashString('ESTIMATED_GAS_FEE_BASE_AMOUNT');
var ESTIMATED_GAS_FEE_MULTIPLIER_FACTOR = hashString('ESTIMATED_GAS_FEE_MULTIPLIER_FACTOR');
hashString('MARKET_LIST');
hashString('POSITION_LIST');
hashString('ACCOUNT_POSITION_LIST');
hashString('ORDER_LIST');
var ACCOUNT_ORDER_LIST_KEY = hashString('ACCOUNT_ORDER_LIST');
var CLAIMABLE_FUNDING_AMOUNT = hashString('CLAIMABLE_FUNDING_AMOUNT');
var VIRTUAL_TOKEN_ID_KEY = hashString('VIRTUAL_TOKEN_ID');
var VIRTUAL_MARKET_ID_KEY = hashString('VIRTUAL_MARKET_ID');
hashString('VIRTUAL_INVENTORY_FOR_POSITIONS');
hashString('VIRTUAL_INVENTORY_FOR_SWAPS');
var POOL_AMOUNT_ADJUSTMENT_KEY = hashString('POOL_AMOUNT_ADJUSTMENT');
hashString('AFFILIATE_REWARD');
var IS_MARKET_DISABLED_KEY = hashString('IS_MARKET_DISABLED');
function positionImpactFactorKey(market, isPositive) {
  return hashData(['bytes32', 'address', 'bool'], [POSITION_IMPACT_FACTOR_KEY, market, isPositive]);
}
function positionImpactExponentFactorKey(market) {
  return hashData(['bytes32', 'address'], [POSITION_IMPACT_EXPONENT_FACTOR_KEY, market]);
}
function maxPositionImpactFactorKey(market, isPositive) {
  return hashData(['bytes32', 'address', 'bool'], [MAX_POSITION_IMPACT_FACTOR_KEY, market, isPositive]);
}
function positionFeeFactorKey(market, forPositiveImpact) {
  return hashData(['bytes32', 'address', 'bool'], [POSITION_FEE_FACTOR_KEY, market, forPositiveImpact]);
}
function swapImpactFactorKey(market, isPositive) {
  return hashData(['bytes32', 'address', 'bool'], [SWAP_IMPACT_FACTOR_KEY, market, isPositive]);
}
function swapImpactExponentFactorKey(market) {
  return hashData(['bytes32', 'address'], [SWAP_IMPACT_EXPONENT_FACTOR_KEY, market]);
}
function swapFeeFactorKey(market, forPositiveImpact) {
  return hashData(['bytes32', 'address', 'bool'], [SWAP_FEE_FACTOR_KEY, market, forPositiveImpact]);
}
function openInterestKey(market, collateralToken, isLong) {
  return hashData(['bytes32', 'address', 'address', 'bool'], [OPEN_INTEREST_KEY, market, collateralToken, isLong]);
}
function openInterestInTokensKey(market, collateralToken, isLong) {
  return hashData(['bytes32', 'address', 'address', 'bool'], [OPEN_INTEREST_IN_TOKENS_KEY, market, collateralToken, isLong]);
}
function poolAmountKey(market, token) {
  return hashData(['bytes32', 'address', 'address'], [POOL_AMOUNT_KEY, market, token]);
}
function reserveFactorKey(market, isLong) {
  return hashData(['bytes32', 'address', 'bool'], [RESERVE_FACTOR_KEY, market, isLong]);
}
function openInterestReserveFactorKey(market, isLong) {
  return hashData(['bytes32', 'address', 'bool'], [OPEN_INTEREST_RESERVE_FACTOR_KEY, market, isLong]);
}
function borrowingFactorKey(market, isLong) {
  return hashData(['bytes32', 'address', 'bool'], [BORROWING_FACTOR_KEY, market, isLong]);
}
function borrowingExponentFactorKey(market, isLong) {
  return hashData(['bytes32', 'address', 'bool'], [BORROWING_EXPONENT_FACTOR_KEY, market, isLong]);
}
function fundingFactorKey(market) {
  return hashData(['bytes32', 'address'], [FUNDING_FACTOR_KEY, market]);
}
function fundingExponentFactorKey(market) {
  return hashData(['bytes32', 'address'], [FUNDING_EXPONENT_FACTOR_KEY, market]);
}
function maxPnlFactorKey(pnlFactorType, market, isLong) {
  return hashData(['bytes32', 'bytes32', 'address', 'bool'], [MAX_PNL_FACTOR_KEY, pnlFactorType, market, isLong]);
}
function positionImpactPoolAmountKey(market) {
  return hashData(['bytes32', 'address'], [POSITION_IMPACT_POOL_AMOUNT_KEY, market]);
}
function maxPositionImpactFactorForLiquidationsKey(market) {
  return hashData(['bytes32', 'address'], [MAX_POSITION_IMPACT_FACTOR_FOR_LIQUIDATIONS_KEY, market]);
}
function swapImpactPoolAmountKey(market, token) {
  return hashData(['bytes32', 'address', 'address'], [SWAP_IMPACT_POOL_AMOUNT_KEY, market, token]);
}
function depositGasLimitKey(singleToken) {
  return hashData(['bytes32', 'bool'], [DEPOSIT_GAS_LIMIT_KEY, singleToken]);
}
function withdrawalGasLimitKey() {
  return hashData(['bytes32'], [WITHDRAWAL_GAS_LIMIT_KEY]);
}
function singleSwapGasLimitKey() {
  return SINGLE_SWAP_GAS_LIMIT_KEY;
}
function increaseOrderGasLimitKey() {
  return INCREASE_ORDER_GAS_LIMIT_KEY;
}
function decreaseOrderGasLimitKey() {
  return DECREASE_ORDER_GAS_LIMIT_KEY;
}
function swapOrderGasLimitKey() {
  return SWAP_ORDER_GAS_LIMIT_KEY;
}
function accountOrderListKey(account) {
  return hashData(['bytes32', 'address'], [ACCOUNT_ORDER_LIST_KEY, account]);
}
function minCollateralFactorKey(market) {
  return hashData(['bytes32', 'address'], [MIN_COLLATERAL_FACTOR_KEY, market]);
}
function minCollateralFactorForOpenInterest(market, isLong) {
  return hashData(['bytes32', 'address', 'bool'], [MIN_COLLATERAL_FACTOR_FOR_OPEN_INTEREST_MULTIPLIER_KEY, market, isLong]);
}
function claimableFundingAmountKey(market, token, account) {
  return hashData(['bytes32', 'address', 'address', 'address'], [CLAIMABLE_FUNDING_AMOUNT, market, token, account]);
}
function virtualTokenIdKey(token) {
  return hashData(['bytes32', 'address'], [VIRTUAL_TOKEN_ID_KEY, token]);
}
function virtualMarketIdKey(market) {
  return hashData(['bytes32', 'address'], [VIRTUAL_MARKET_ID_KEY, market]);
}
function poolAmountAdjustmentKey(market, token) {
  return hashData(['bytes32', 'address', 'address'], [POOL_AMOUNT_ADJUSTMENT_KEY, market, token]);
}
function isMarketDisabledKey(market) {
  return hashData(['bytes32', 'address'], [IS_MARKET_DISABLED_KEY, market]);
}
function maxPoolAmountKey(market, token) {
  return hashData(['bytes32', 'address', 'address'], [MAX_POOL_AMOUNT_KEY, market, token]);
}

var _format = "hh-sol-artifact-1";
var contractName = "Errors";
var sourceName = "contracts/error/Errors.sol";
var abi = [
	{
		inputs: [
		],
		name: "ActionAlreadySignalled",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ActionNotSignalled",
		type: "error"
	},
	{
		inputs: [
		],
		name: "AdlNotEnabled",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "pnlToPoolFactor",
				type: "int256"
			},
			{
				internalType: "uint256",
				name: "maxPnlFactorForAdl",
				type: "uint256"
			}
		],
		name: "AdlNotRequired",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "bytes[]",
				name: "values",
				type: "bytes[]"
			},
			{
				internalType: "uint256",
				name: "index",
				type: "uint256"
			},
			{
				internalType: "string",
				name: "label",
				type: "string"
			}
		],
		name: "ArrayOutOfBoundsBytes",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256[]",
				name: "values",
				type: "uint256[]"
			},
			{
				internalType: "uint256",
				name: "index",
				type: "uint256"
			},
			{
				internalType: "string",
				name: "label",
				type: "string"
			}
		],
		name: "ArrayOutOfBoundsUint256",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "minOracleBlockNumber",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "prevMinOracleBlockNumber",
				type: "uint256"
			}
		],
		name: "BlockNumbersNotSorted",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "adjustedClaimableAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "claimedAmount",
				type: "uint256"
			}
		],
		name: "CollateralAlreadyClaimed",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256[]",
				name: "compactedValues",
				type: "uint256[]"
			},
			{
				internalType: "uint256",
				name: "index",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "slotIndex",
				type: "uint256"
			},
			{
				internalType: "string",
				name: "label",
				type: "string"
			}
		],
		name: "CompactedArrayOutOfBounds",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "DepositNotFound",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "DisabledFeature",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			}
		],
		name: "DisabledMarket",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			}
		],
		name: "DuplicateTokenPrice",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "index",
				type: "uint256"
			},
			{
				internalType: "string",
				name: "label",
				type: "string"
			}
		],
		name: "DuplicatedIndex",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			}
		],
		name: "DuplicatedMarketInSwapPath",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyAccount",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			},
			{
				internalType: "address",
				name: "token",
				type: "address"
			}
		],
		name: "EmptyAddressInMarketTokenBalanceValidation",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "index",
				type: "uint256"
			}
		],
		name: "EmptyCompactedBlockNumber",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "index",
				type: "uint256"
			}
		],
		name: "EmptyCompactedPrice",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "index",
				type: "uint256"
			}
		],
		name: "EmptyCompactedTimestamp",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyDeposit",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyDepositAmounts",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyDepositAmountsAfterSwap",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyHoldingAddress",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyMarket",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyMarketTokenSupply",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyOrder",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyPosition",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			}
		],
		name: "EmptyPriceFeed",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			}
		],
		name: "EmptyPriceFeedMultiplier",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			}
		],
		name: "EmptyPrimaryPrice",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyReceiver",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "signerIndex",
				type: "uint256"
			}
		],
		name: "EmptySigner",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptySizeDeltaInTokens",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			}
		],
		name: "EmptyTokenTranferGasLimit",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyWithdrawal",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EmptyWithdrawalAmount",
		type: "error"
	},
	{
		inputs: [
		],
		name: "EndOfOracleSimulation",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "collateralAmount",
				type: "uint256"
			},
			{
				internalType: "int256",
				name: "collateralDeltaAmount",
				type: "int256"
			}
		],
		name: "InsufficientCollateralAmount",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "remainingCollateralUsd",
				type: "int256"
			}
		],
		name: "InsufficientCollateralUsd",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "minExecutionFee",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "executionFee",
				type: "uint256"
			}
		],
		name: "InsufficientExecutionFee",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "startingGas",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "minHandleErrorGas",
				type: "uint256"
			}
		],
		name: "InsufficientExecutionGas",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "remainingCostUsd",
				type: "uint256"
			},
			{
				internalType: "string",
				name: "step",
				type: "string"
			}
		],
		name: "InsufficientFundsToPayForCosts",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "balance",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "expected",
				type: "uint256"
			}
		],
		name: "InsufficientMarketTokens",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "outputAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "minOutputAmount",
				type: "uint256"
			}
		],
		name: "InsufficientOutputAmount",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "poolAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "InsufficientPoolAmount",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "reservedUsd",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxReservedUsd",
				type: "uint256"
			}
		],
		name: "InsufficientReserve",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "reservedUsd",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxReservedUsd",
				type: "uint256"
			}
		],
		name: "InsufficientReserveForOpenInterest",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "outputAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "minOutputAmount",
				type: "uint256"
			}
		],
		name: "InsufficientSwapOutputAmount",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "wntAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "executionFee",
				type: "uint256"
			}
		],
		name: "InsufficientWntAmount",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "wntAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "executionFee",
				type: "uint256"
			}
		],
		name: "InsufficientWntAmountForExecutionFee",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "nextPnlToPoolFactor",
				type: "int256"
			},
			{
				internalType: "int256",
				name: "pnlToPoolFactor",
				type: "int256"
			}
		],
		name: "InvalidAdl",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "baseKey",
				type: "bytes32"
			}
		],
		name: "InvalidBaseKey",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "minOracleBlockNumber",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "currentBlockNumber",
				type: "uint256"
			}
		],
		name: "InvalidBlockNumber",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "marketsLength",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "tokensLength",
				type: "uint256"
			}
		],
		name: "InvalidClaimAffiliateRewardsInput",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "marketsLength",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "tokensLength",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "timeKeysLength",
				type: "uint256"
			}
		],
		name: "InvalidClaimCollateralInput",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "marketsLength",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "tokensLength",
				type: "uint256"
			}
		],
		name: "InvalidClaimFeesInput",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "marketsLength",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "tokensLength",
				type: "uint256"
			}
		],
		name: "InvalidClaimFundingFeesInput",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "marketsLength",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "tokensLength",
				type: "uint256"
			}
		],
		name: "InvalidClaimUiFeesInput",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			},
			{
				internalType: "address",
				name: "token",
				type: "address"
			}
		],
		name: "InvalidCollateralTokenForMarket",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "sizeDeltaUsd",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "positionSizeInUsd",
				type: "uint256"
			}
		],
		name: "InvalidDecreaseOrderSize",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "decreasePositionSwapType",
				type: "uint256"
			}
		],
		name: "InvalidDecreasePositionSwapType",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "baseKey",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "InvalidFeeFactor",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			}
		],
		name: "InvalidFeeReceiver",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "int256",
				name: "price",
				type: "int256"
			}
		],
		name: "InvalidFeedPrice",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "keeper",
				type: "address"
			}
		],
		name: "InvalidKeeperForFrozenOrder",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			},
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "balance",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "expectedMinBalance",
				type: "uint256"
			}
		],
		name: "InvalidMarketTokenBalance",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			},
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "balance",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "claimableFundingFeeAmount",
				type: "uint256"
			}
		],
		name: "InvalidMarketTokenBalanceForClaimableFunding",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			},
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "balance",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "collateralAmount",
				type: "uint256"
			}
		],
		name: "InvalidMarketTokenBalanceForCollateralAmount",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "minPrice",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxPrice",
				type: "uint256"
			}
		],
		name: "InvalidMedianMinMaxPrice",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "minOracleBlockNumber",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxOracleBlockNumber",
				type: "uint256"
			}
		],
		name: "InvalidMinMaxBlockNumber",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "msgSender",
				type: "address"
			}
		],
		name: "InvalidNativeTokenSender",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			}
		],
		name: "InvalidOraclePrice",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			}
		],
		name: "InvalidOracleSigner",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "primaryPriceMin",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "primaryPriceMax",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "triggerPrice",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "orderType",
				type: "uint256"
			}
		],
		name: "InvalidOrderPrices",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "tokenOut",
				type: "address"
			},
			{
				internalType: "address",
				name: "expectedTokenOut",
				type: "address"
			}
		],
		name: "InvalidOutputToken",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "poolValue",
				type: "int256"
			}
		],
		name: "InvalidPoolValueForDeposit",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "poolValue",
				type: "int256"
			}
		],
		name: "InvalidPoolValueForWithdrawal",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			}
		],
		name: "InvalidPositionMarket",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "sizeInUsd",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "sizeInTokens",
				type: "uint256"
			}
		],
		name: "InvalidPositionSizeValues",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "primaryTokensLength",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "primaryPricesLength",
				type: "uint256"
			}
		],
		name: "InvalidPrimaryPricesForSimulation",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "recoveredSigner",
				type: "address"
			},
			{
				internalType: "address",
				name: "expectedSigner",
				type: "address"
			}
		],
		name: "InvalidSignature",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "minPrice",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxPrice",
				type: "uint256"
			}
		],
		name: "InvalidSignerMinMaxPrice",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "sizeDeltaUsd",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "positionSizeInUsd",
				type: "uint256"
			}
		],
		name: "InvalidSizeDeltaForAdl",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			}
		],
		name: "InvalidSwapMarket",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "outputToken",
				type: "address"
			},
			{
				internalType: "address",
				name: "expectedOutputToken",
				type: "address"
			}
		],
		name: "InvalidSwapOutputToken",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "timelockDelay",
				type: "uint256"
			}
		],
		name: "InvalidTimelockDelay",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "tokenIn",
				type: "address"
			},
			{
				internalType: "address",
				name: "market",
				type: "address"
			}
		],
		name: "InvalidTokenIn",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "uiFeeFactor",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxUiFeeFactor",
				type: "uint256"
			}
		],
		name: "InvalidUiFeeFactor",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "string",
				name: "reason",
				type: "string"
			}
		],
		name: "LiquidatablePosition",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "salt",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "existingMarketAddress",
				type: "address"
			}
		],
		name: "MarketAlreadyExists",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "key",
				type: "address"
			}
		],
		name: "MarketNotFound",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "index",
				type: "uint256"
			},
			{
				internalType: "string",
				name: "label",
				type: "string"
			}
		],
		name: "MaskIndexOutOfBounds",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "callbackGasLimit",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxCallbackGasLimit",
				type: "uint256"
			}
		],
		name: "MaxCallbackGasLimitExceeded",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "openInterest",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxOpenInterest",
				type: "uint256"
			}
		],
		name: "MaxOpenInterestExceeded",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "oracleSigners",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxOracleSigners",
				type: "uint256"
			}
		],
		name: "MaxOracleSigners",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "poolAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxPoolAmount",
				type: "uint256"
			}
		],
		name: "MaxPoolAmountExceeded",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "oracleTimestamp",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "currentTimestamp",
				type: "uint256"
			}
		],
		name: "MaxPriceAgeExceeded",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "price",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "prevPrice",
				type: "uint256"
			}
		],
		name: "MaxPricesNotSorted",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "price",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "refPrice",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxRefPriceDeviationFactor",
				type: "uint256"
			}
		],
		name: "MaxRefPriceDeviationExceeded",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "signerIndex",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxSignerIndex",
				type: "uint256"
			}
		],
		name: "MaxSignerIndex",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "swapPathLengh",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxSwapPathLength",
				type: "uint256"
			}
		],
		name: "MaxSwapPathLengthExceeded",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "timelockDelay",
				type: "uint256"
			}
		],
		name: "MaxTimelockDelayExceeded",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "received",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "expected",
				type: "uint256"
			}
		],
		name: "MinLongTokens",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "received",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "expected",
				type: "uint256"
			}
		],
		name: "MinMarketTokens",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "oracleSigners",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "minOracleSigners",
				type: "uint256"
			}
		],
		name: "MinOracleSigners",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "positionSizeInUsd",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "minPositionSizeUsd",
				type: "uint256"
			}
		],
		name: "MinPositionSize",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "price",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "prevPrice",
				type: "uint256"
			}
		],
		name: "MinPricesNotSorted",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "received",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "expected",
				type: "uint256"
			}
		],
		name: "MinShortTokens",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "executionPrice",
				type: "int256"
			},
			{
				internalType: "uint256",
				name: "price",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "positionSizeInUsd",
				type: "uint256"
			},
			{
				internalType: "int256",
				name: "priceImpactUsd",
				type: "int256"
			},
			{
				internalType: "uint256",
				name: "sizeDeltaUsd",
				type: "uint256"
			}
		],
		name: "NegativeExecutionPrice",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "tokensWithPricesLength",
				type: "uint256"
			}
		],
		name: "NonEmptyTokensWithPrices",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "market",
				type: "address"
			}
		],
		name: "OpenInterestCannotBeUpdatedForSwapOnlyMarket",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256[]",
				name: "minOracleBlockNumbers",
				type: "uint256[]"
			},
			{
				internalType: "uint256[]",
				name: "maxOracleBlockNumbers",
				type: "uint256[]"
			},
			{
				internalType: "uint256",
				name: "blockNumber",
				type: "uint256"
			}
		],
		name: "OracleBlockNumberNotWithinRange",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256[]",
				name: "oracleBlockNumbers",
				type: "uint256[]"
			},
			{
				internalType: "uint256",
				name: "expectedBlockNumber",
				type: "uint256"
			}
		],
		name: "OracleBlockNumbersAreSmallerThanRequired",
		type: "error"
	},
	{
		inputs: [
		],
		name: "OrderAlreadyFrozen",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "OrderNotFound",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "price",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "acceptablePrice",
				type: "uint256"
			}
		],
		name: "OrderNotFulfillableAtAcceptablePrice",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "orderType",
				type: "uint256"
			}
		],
		name: "OrderNotUpdatable",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "orderType",
				type: "uint256"
			}
		],
		name: "OrderTypeCannotBeCreated",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "pnlToPoolFactor",
				type: "int256"
			},
			{
				internalType: "uint256",
				name: "maxPnlFactor",
				type: "uint256"
			}
		],
		name: "PnlFactorExceededForLongs",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "pnlToPoolFactor",
				type: "int256"
			},
			{
				internalType: "uint256",
				name: "maxPnlFactor",
				type: "uint256"
			}
		],
		name: "PnlFactorExceededForShorts",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "nextPnlToPoolFactor",
				type: "int256"
			},
			{
				internalType: "uint256",
				name: "minPnlFactorForAdl",
				type: "uint256"
			}
		],
		name: "PnlOvercorrected",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "PositionNotFound",
		type: "error"
	},
	{
		inputs: [
		],
		name: "PositionShouldNotBeLiquidated",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "minPrice",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "maxPrice",
				type: "uint256"
			}
		],
		name: "PriceAlreadySet",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "timestamp",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "heartbeatDuration",
				type: "uint256"
			}
		],
		name: "PriceFeedNotUpdated",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "priceImpactUsd",
				type: "int256"
			},
			{
				internalType: "uint256",
				name: "sizeDeltaUsd",
				type: "uint256"
			}
		],
		name: "PriceImpactLargerThanOrderSize",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "requestAge",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "requestExpirationAge",
				type: "uint256"
			},
			{
				internalType: "string",
				name: "requestType",
				type: "string"
			}
		],
		name: "RequestNotYetCancellable",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			}
		],
		name: "SelfTransferNotSupported",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "signalTime",
				type: "uint256"
			}
		],
		name: "SignalTimeNotYetPassed",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountAfterFees",
				type: "uint256"
			},
			{
				internalType: "int256",
				name: "negativeImpactAmount",
				type: "int256"
			}
		],
		name: "SwapPriceImpactExceedsAmountIn",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ThereMustBeAtLeastOneRoleAdmin",
		type: "error"
	},
	{
		inputs: [
		],
		name: "ThereMustBeAtLeastOneTimelockMultiSig",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "TokenTransferError",
		type: "error"
	},
	{
		inputs: [
		],
		name: "UnableToGetBorrowingFactorEmptyPoolUsd",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "market",
				type: "address"
			}
		],
		name: "UnableToGetCachedTokenPrice",
		type: "error"
	},
	{
		inputs: [
		],
		name: "UnableToGetFundingFactorEmptyOpenInterest",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "inputToken",
				type: "address"
			},
			{
				internalType: "address",
				name: "market",
				type: "address"
			}
		],
		name: "UnableToGetOppositeToken",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "estimatedRemainingCollateralUsd",
				type: "int256"
			}
		],
		name: "UnableToWithdrawCollateral",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "msgSender",
				type: "address"
			},
			{
				internalType: "string",
				name: "role",
				type: "string"
			}
		],
		name: "Unauthorized",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "positionBorrowingFactor",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "cumulativeBorrowingFactor",
				type: "uint256"
			}
		],
		name: "UnexpectedBorrowingFactor",
		type: "error"
	},
	{
		inputs: [
		],
		name: "UnexpectedMarket",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "poolValue",
				type: "int256"
			}
		],
		name: "UnexpectedPoolValue",
		type: "error"
	},
	{
		inputs: [
		],
		name: "UnexpectedPositionState",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "market",
				type: "address"
			}
		],
		name: "UnexpectedTokenForVirtualInventory",
		type: "error"
	},
	{
		inputs: [
		],
		name: "UnsupportedOrderType",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "usdDelta",
				type: "int256"
			},
			{
				internalType: "uint256",
				name: "longOpenInterest",
				type: "uint256"
			}
		],
		name: "UsdDeltaExceedsLongOpenInterest",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "usdDelta",
				type: "int256"
			},
			{
				internalType: "uint256",
				name: "poolUsd",
				type: "uint256"
			}
		],
		name: "UsdDeltaExceedsPoolValue",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "int256",
				name: "usdDelta",
				type: "int256"
			},
			{
				internalType: "uint256",
				name: "shortOpenInterest",
				type: "uint256"
			}
		],
		name: "UsdDeltaExceedsShortOpenInterest",
		type: "error"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "WithdrawalNotFound",
		type: "error"
	}
];
var bytecode = "0x60566037600b82828239805160001a607314602a57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220d1757edc5d1f8308aefb387c9807a59afc7704ff6770f17f75680168e4f004c064736f6c63430008120033";
var deployedBytecode = "0x73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220d1757edc5d1f8308aefb387c9807a59afc7704ff6770f17f75680168e4f004c064736f6c63430008120033";
var linkReferences = {
};
var deployedLinkReferences = {
};
var CustomErrors = {
	_format: _format,
	contractName: contractName,
	sourceName: sourceName,
	abi: abi,
	bytecode: bytecode,
	deployedBytecode: deployedBytecode,
	linkReferences: linkReferences,
	deployedLinkReferences: deployedLinkReferences
};

var _CHAIN_BY_CHAIN_ID, _BATCH_CONFIGS;
var MAX_TIMEOUT = 2000;
function sleep(ms) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve();
    }, ms);
  });
}
var CHAIN_BY_CHAIN_ID = (_CHAIN_BY_CHAIN_ID = {}, _defineProperty(_CHAIN_BY_CHAIN_ID, ARBITRUM_GOERLI, arbitrumGoerli), _defineProperty(_CHAIN_BY_CHAIN_ID, ARBITRUM, arbitrum), _CHAIN_BY_CHAIN_ID);
var BATCH_CONFIGS = (_BATCH_CONFIGS = {}, _defineProperty(_BATCH_CONFIGS, ARBITRUM, {
  http: {
    batchSize: 0,
    // disable batches, here batchSize is the number of eth_calls in a batch
    wait: 0 // keep this setting in case batches are enabled in future
  },

  client: {
    multicall: {
      batchSize: 1024 * 1024,
      // here batchSize is the number of bytes in a multicall
      wait: 0 // zero delay means formation of a batch in the current macro-task, like setTimeout(fn, 0)
    }
  }
}), _defineProperty(_BATCH_CONFIGS, ARBITRUM_GOERLI, {
  http: {
    batchSize: 0,
    wait: 0
  },
  client: {
    multicall: {
      batchSize: 1024 * 1024,
      wait: 0
    }
  }
}), _BATCH_CONFIGS);
function executeMulticall(_x, _x2, _x3) {
  return _executeMulticall.apply(this, arguments);
}
function _executeMulticall() {
  _executeMulticall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(chainId, library, request) {
    var multicall;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return Multicall$1.getInstance(chainId);
        case 2:
          multicall = _context3.sent;
          return _context3.abrupt("return", multicall === null || multicall === void 0 ? void 0 : multicall.call(request, MAX_TIMEOUT));
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _executeMulticall.apply(this, arguments);
}
var Multicall$1 = /*#__PURE__*/function () {
  function Multicall(chainId, rpcUrl) {
    _classCallCheck(this, Multicall);
    this.chainId = chainId;
    this.rpcUrl = rpcUrl;
    this.viemClient = Multicall.getViemClient(chainId, rpcUrl);
  }
  _createClass(Multicall, [{
    key: "call",
    value: function () {
      var _call = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, maxTimeout) {
        var _this = this;
        var originalKeys, abis, encodedPayload, contractKeys, response, multicallResult;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              originalKeys = [];
              abis = {};
              encodedPayload = [];
              contractKeys = Object.keys(request);
              contractKeys.forEach(function (contractKey) {
                var contractCallConfig = request[contractKey];
                if (!contractCallConfig) {
                  return;
                }
                Object.keys(contractCallConfig.calls).forEach(function (callKey) {
                  var call = contractCallConfig.calls[callKey];
                  if (!call) {
                    return;
                  }

                  // Add Errors ABI to each contract ABI to correctly parse errors
                  abis[contractCallConfig.contractAddress] = abis[contractCallConfig.contractAddress] || contractCallConfig.abi.concat(CustomErrors.abi);
                  var abi = abis[contractCallConfig.contractAddress];
                  originalKeys.push({
                    contractKey: contractKey,
                    callKey: callKey
                  });
                  encodedPayload.push({
                    address: contractCallConfig.contractAddress,
                    functionName: call.methodName,
                    abi: abi,
                    args: call.params
                  });
                });
              });
              _context.next = 7;
              return Promise.race([this.viemClient.multicall({
                contracts: encodedPayload
              }), sleep(maxTimeout).then(function () {
                return Promise.reject(new Error('multicall timeout'));
              })]).catch(function (_viemError) {
                var e = new Error(_viemError.message.slice(0, 150));

                // eslint-disable-next-line no-console
                console.groupCollapsed('multicall error:');
                // eslint-disable-next-line no-console
                console.error(e);
                // eslint-disable-next-line no-console
                console.groupEnd();
                var rpcUrl = getFallbackRpcUrl(_this.chainId);
                if (!rpcUrl) {
                  throw e;
                }
                var fallbackClient = Multicall.getViemClient(_this.chainId, rpcUrl);

                // eslint-disable-next-line no-console
                console.log("using multicall fallback for chain ".concat(_this.chainId));
                return fallbackClient.multicall({
                  contracts: encodedPayload
                }).catch(function (_viemError) {
                  var e = new Error(_viemError.message.slice(0, 150));
                  // eslint-disable-next-line no-console
                  console.groupCollapsed('multicall fallback error:');
                  // eslint-disable-next-line no-console
                  console.error(e);
                  // eslint-disable-next-line no-console
                  console.groupEnd();
                  throw e;
                });
              });
            case 7:
              response = _context.sent;
              multicallResult = {
                success: true,
                errors: {},
                data: {}
              };
              response.forEach(function (_ref, i) {
                var result = _ref.result,
                  status = _ref.status,
                  error = _ref.error;
                var _originalKeys$i = originalKeys[i],
                  contractKey = _originalKeys$i.contractKey,
                  callKey = _originalKeys$i.callKey;
                if (status === 'success') {
                  var values;
                  if (Array.isArray(result) || _typeof(result) === 'object') {
                    values = result;
                  } else {
                    values = [result];
                  }
                  multicallResult.data[contractKey] = multicallResult.data[contractKey] || {};
                  multicallResult.data[contractKey][callKey] = {
                    contractKey: contractKey,
                    callKey: callKey,
                    returnValues: values,
                    success: true
                  };
                } else {
                  multicallResult.success = false;
                  multicallResult.errors[contractKey] = multicallResult.errors[contractKey] || {};
                  multicallResult.errors[contractKey][callKey] = error;
                  multicallResult.data[contractKey] = multicallResult.data[contractKey] || {};
                  multicallResult.data[contractKey][callKey] = {
                    contractKey: contractKey,
                    callKey: callKey,
                    returnValues: [],
                    success: false,
                    error: error
                  };
                }
              });
              return _context.abrupt("return", multicallResult);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function call(_x4, _x5) {
        return _call.apply(this, arguments);
      }
      return call;
    }()
  }], [{
    key: "getInstance",
    value: function () {
      var _getInstance = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(chainId) {
        var instance, _rpcUrl;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              instance = Multicall.instances[chainId];
              if (!(!instance || instance.chainId !== chainId)) {
                _context2.next = 7;
                break;
              }
              _rpcUrl = getRpcUrl(chainId);
              if (_rpcUrl) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", undefined);
            case 5:
              instance = new Multicall(chainId, _rpcUrl);
              Multicall.instances[chainId] = instance;
            case 7:
              return _context2.abrupt("return", instance);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getInstance(_x6) {
        return _getInstance.apply(this, arguments);
      }
      return getInstance;
    }()
  }, {
    key: "getViemClient",
    value: function getViemClient(chainId, rpcUrl) {
      return createPublicClient({
        transport: http(rpcUrl, {
          // retries works strangely in viem, so we disable them
          retryCount: 0,
          retryDelay: 10000000,
          batch: BATCH_CONFIGS[chainId].http
        }),
        pollingInterval: undefined,
        batch: BATCH_CONFIGS[chainId].client,
        chain: CHAIN_BY_CHAIN_ID[chainId]
      });
    }
  }]);
  return Multicall;
}();
_defineProperty(Multicall$1, "instances", {});

//import { SWRGCMiddlewareConfig } from "lib/swrMiddlewares";

/**
 * A hook to fetch data from contracts via multicall.
 * Preferably wrapped in custom hooks, such as useMarkets, usePositions, etc.
 *
 * @param chainId - on which network the request should be executed
 * @param name - an unique name for the request, used as a part of swr cache key
 * @param params.key - the cache key as an array, if a falsy value is passed, the request will be skipped
 * @param params.request - contract calls config or callback which returns it
 * @param params.parseResponse - optional callback to pre-process and format the response
 */
function runMulticall(_x, _x2, _x3, _x4) {
  return _runMulticall.apply(this, arguments);
}
function _runMulticall() {
  _runMulticall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(chainId, name, library, params) {
    var request, response, _result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          // prettier-ignore
          request = typeof params.request === "function" ? params.request(chainId, params.key) : params.request;
          if (!(Object.keys(request).length === 0)) {
            _context.next = 4;
            break;
          }
          throw new Error("Multicall request is empty");
        case 4:
          _context.next = 6;
          return executeMulticall(chainId, library, request);
        case 6:
          response = _context.sent;
          if (response) {
            _context.next = 9;
            break;
          }
          throw new Error("Multicall response is empty");
        case 9:
          // prettier-ignore
          _result = typeof params.parseResponse === "function" ? params.parseResponse(response, chainId, params.key) : response;
          return _context.abrupt("return", {
            data: _result,
            isLoading: false
          });
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](0);
          // eslint-disable-next-line no-console
          console.error("Multicall request failed: ".concat(name), _context.t0);
          throw _context.t0;
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 13]]);
  }));
  return _runMulticall.apply(this, arguments);
}

function _createForOfIteratorHelper$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }
function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var AddressZero = ethers.constants.AddressZero;
var DEFAULT_COUNT = 1000;
var ALLOWED_SLIPPAGE = 30;
var GMXHelper = /*#__PURE__*/function (_Config) {
  _inherits(GMXHelper, _Config);
  var _super = _createSuper$4(GMXHelper);
  function GMXHelper() {
    var _this;
    _classCallCheck(this, GMXHelper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getMarketsData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var chainId, getMarkets, res, marketData, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            chainId = String(_this.chainId);
            if (!(chainId === '1')) {
              _context.next = 4;
              break;
            }
            console.error('unsupported chain');
            return _context.abrupt("return");
          case 4:
            if (!(chainId === '5')) {
              _context.next = 7;
              break;
            }
            console.error('unsupported chain');
            return _context.abrupt("return");
          case 7:
            getMarkets = new GetMarkets({
              chainId: String(_this.chainId),
              initParams: {
                methodParams: {
                  dataStore: getContract({
                    chainId: _this.chainId,
                    name: 'DataStore'
                  }),
                  start: '0',
                  end: '100'
                }
              }
            });
            if (_this.signer) {
              _context.next = 11;
              break;
            }
            console.error('signer not set');
            return _context.abrupt("return");
          case 11:
            _context.next = 13;
            return getMarkets.getOutputValues({
              provider: {
                provider: _this.library,
                signer: _this.signer
              }
            });
          case 13:
            res = _context.sent;
            _context.prev = 14;
            if (!(_typeof(res) !== 'object')) {
              _context.next = 17;
              break;
            }
            return _context.abrupt("return");
          case 17:
            if ('marketData_tuple[]' in res) {
              _context.next = 19;
              break;
            }
            return _context.abrupt("return");
          case 19:
            marketData = res['marketData_tuple[]'];
            data = marketData.reduce(function (acc, marketValues) {
              try {
                var indexToken = getToken(Number(chainId), convertTokenAddress(Number(chainId), marketValues.indexToken, 'native'));
                var longToken = getToken(Number(chainId), marketValues.longToken);
                var shortToken = getToken(Number(chainId), marketValues.shortToken);
                var isSameCollaterals = marketValues.longToken === marketValues.shortToken;
                var isSpotOnly = marketValues.indexToken === ethers.constants.AddressZero;
                var name = getMarketFullName({
                  indexToken: indexToken,
                  longToken: longToken,
                  shortToken: shortToken,
                  isSpotOnly: isSpotOnly
                });
                acc.marketsData[marketValues.marketToken] = {
                  marketTokenAddress: marketValues.marketToken,
                  indexTokenAddress: marketValues.indexToken,
                  longTokenAddress: marketValues.longToken,
                  shortTokenAddress: marketValues.shortToken,
                  isSameCollaterals: isSameCollaterals,
                  isSpotOnly: isSpotOnly,
                  name: name,
                  data: ''
                };
                acc.marketsAddresses.push(marketValues.marketToken);
              } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('unsupported market', e);
              }
              return acc;
            }, {
              marketsData: {},
              marketsAddresses: []
            });
            return _context.abrupt("return", data);
          case 24:
            _context.prev = 24;
            _context.t0 = _context["catch"](14);
            console.error(_context.t0);
            return _context.abrupt("return", undefined);
          case 28:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[14, 24]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "getTokenBalances", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _yield$runMulticall, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return runMulticall(_this.chainId, 'useTokenBalances', _this.library, {
              key: _this.account ? [_this.account] : null,
              request: function request() {
                return getV2Tokens(_this.chainId).reduce(function (acc, token) {
                  // Skip synthetic tokens
                  if (token.isSynthetic) return acc;
                  var address = token.value;
                  if (address === NATIVE_TOKEN_ADDRESS) {
                    acc[address] = {
                      contractAddress: getContract({
                        chainId: _this.chainId,
                        name: 'Multicall'
                      }),
                      abi: MulticallAbi,
                      calls: {
                        balance: {
                          methodName: 'getEthBalance',
                          params: [_this.account]
                        }
                      }
                    };
                  } else {
                    acc[address] = {
                      contractAddress: address,
                      abi: erc20Abi,
                      calls: {
                        balance: {
                          methodName: 'balanceOf',
                          params: [_this.account]
                        }
                      }
                    };
                  }
                  return acc;
                }, {});
              },
              parseResponse: function parseResponse(res) {
                return Object.keys(res.data).reduce(function (tokenBalances, tokenAddress) {
                  tokenBalances[tokenAddress] = BigNumber.from(res.data[tokenAddress].balance.returnValues[0]);
                  return tokenBalances;
                }, {});
              }
            });
          case 2:
            _yield$runMulticall = _context2.sent;
            data = _yield$runMulticall.data;
            return _context2.abrupt("return", {
              balancesData: data
            });
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    _defineProperty(_assertThisInitialized(_this), "getTokenRecentPrices", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var res;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetchTickers(_this.chainId).then(function (priceItems) {
              var result = {};
              priceItems.forEach(function (priceItem) {
                var tokenConfig;
                try {
                  tokenConfig = getToken(_this.chainId, priceItem.tokenAddress);
                } catch (e) {
                  // ignore unknown token errors

                  return;
                }
                result[tokenConfig.value] = {
                  minPrice: parseOraclePrice(priceItem.minPrice, tokenConfig.decimals, priceItem.oracleDecimals),
                  maxPrice: parseOraclePrice(priceItem.maxPrice, tokenConfig.decimals, priceItem.oracleDecimals)
                };
              });
              var stableTokens = getV2Tokens(_this.chainId).filter(function (token) {
                return token.isStable;
              });
              stableTokens.forEach(function (token) {
                if (!result[token.value]) {
                  result[token.value] = {
                    minPrice: expandDecimals(1, 30),
                    maxPrice: expandDecimals(1, 30)
                  };
                }
              });
              var wrappedToken = getWrappedToken(_this.chainId);
              if (result[wrappedToken.value] && !result[NATIVE_TOKEN_ADDRESS]) {
                result[NATIVE_TOKEN_ADDRESS] = result[wrappedToken.value];
              }
              return {
                pricesData: result,
                updatedAt: Date.now()
              };
            });
          case 2:
            res = _context3.sent;
            return _context3.abrupt("return", res);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    _defineProperty(_assertThisInitialized(_this), "getTokensData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var tokenConfigs, _yield$_this$getToken, balancesData, _yield$_this$getToken2, pricesData, pricesUpdatedAt, tokenAddresses;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            tokenConfigs = getTokensMap(_this.chainId);
            _context4.next = 3;
            return _this.getTokenBalances();
          case 3:
            _yield$_this$getToken = _context4.sent;
            balancesData = _yield$_this$getToken.balancesData;
            _context4.next = 7;
            return _this.getTokenRecentPrices();
          case 7:
            _yield$_this$getToken2 = _context4.sent;
            pricesData = _yield$_this$getToken2.pricesData;
            pricesUpdatedAt = _yield$_this$getToken2.updatedAt;
            tokenAddresses = getV2Tokens(_this.chainId).map(function (token) {
              return token.value;
            });
            if (pricesData) {
              _context4.next = 13;
              break;
            }
            return _context4.abrupt("return", {
              tokensData: undefined,
              pricesUpdatedAt: undefined
            });
          case 13:
            return _context4.abrupt("return", {
              tokensData: tokenAddresses.reduce(function (acc, tokenAddress) {
                var prices = pricesData[tokenAddress];
                var balance = balancesData === null || balancesData === void 0 ? void 0 : balancesData[tokenAddress];
                var tokenConfig = tokenConfigs[tokenAddress];
                if (!prices) {
                  return acc;
                }
                acc[tokenAddress] = _objectSpread$6(_objectSpread$6({}, tokenConfig), {}, {
                  prices: prices,
                  balance: balance
                });
                return acc;
              }, {}),
              pricesUpdatedAt: pricesUpdatedAt
            });
          case 14:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })));
    _defineProperty(_assertThisInitialized(_this), "getMarketsInfo", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var account, markets, marketsData, marketsAddresses, dataStoreAddress, _yield$_this$getToken3, tokensData, pricesUpdatedAt, res;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            account = _this.account;
            _context5.next = 3;
            return _this.getMarketsData();
          case 3:
            markets = _context5.sent;
            if (markets) {
              _context5.next = 6;
              break;
            }
            return _context5.abrupt("return");
          case 6:
            marketsData = markets.marketsData, marketsAddresses = markets.marketsAddresses;
            dataStoreAddress = getContract({
              chainId: _this.chainId,
              name: 'DataStore'
            });
            _context5.next = 10;
            return _this.getTokensData();
          case 10:
            _yield$_this$getToken3 = _context5.sent;
            tokensData = _yield$_this$getToken3.tokensData;
            pricesUpdatedAt = _yield$_this$getToken3.pricesUpdatedAt;
            _context5.next = 15;
            return runMulticall(_this.chainId, 'useMarketsInfo', _this.library, {
              key: marketsAddresses.length > 0 && [marketsAddresses.join('-'), dataStoreAddress, account, pricesUpdatedAt],
              // Refreshed on every prices update
              refreshInterval: null,
              clearUnusedKeys: true,
              keepPreviousData: true,
              request: function request() {
                return marketsAddresses.reduce(function (request, marketAddress) {
                  var _Object$assign;
                  var market = getByKey(marketsData, marketAddress);
                  var marketPrices = getContractMarketPrices(tokensData, market);
                  if (!marketPrices) {
                    return request;
                  }
                  var marketProps = {
                    marketToken: market.marketTokenAddress,
                    indexToken: market.indexTokenAddress,
                    longToken: market.longTokenAddress,
                    shortToken: market.shortTokenAddress
                  };
                  return Object.assign(request, (_Object$assign = {}, _defineProperty(_Object$assign, "".concat(marketAddress, "-reader"), {
                    contractAddress: getContract({
                      chainId: _this.chainId,
                      name: 'SyntheticsReader'
                    }),
                    abi: SyntheticsReaderAbi,
                    calls: {
                      marketInfo: {
                        methodName: 'getMarketInfo',
                        params: [dataStoreAddress, marketPrices, marketAddress]
                      },
                      marketTokenPriceMax: {
                        methodName: 'getMarketTokenPrice',
                        params: [dataStoreAddress, marketProps, marketPrices.indexTokenPrice, marketPrices.longTokenPrice, marketPrices.shortTokenPrice, MAX_PNL_FACTOR_FOR_TRADERS_KEY, true]
                      },
                      marketTokenPriceMin: {
                        methodName: 'getMarketTokenPrice',
                        params: [dataStoreAddress, marketProps, marketPrices.indexTokenPrice, marketPrices.longTokenPrice, marketPrices.shortTokenPrice, MAX_PNL_FACTOR_FOR_TRADERS_KEY, false]
                      }
                    }
                  }), _defineProperty(_Object$assign, "".concat(marketAddress, "-dataStore"), {
                    contractAddress: dataStoreAddress,
                    abi: DataStoreAbi,
                    calls: {
                      isDisabled: {
                        methodName: 'getBool',
                        params: [isMarketDisabledKey(marketAddress)]
                      },
                      longPoolAmount: {
                        methodName: 'getUint',
                        params: [poolAmountKey(marketAddress, market.longTokenAddress)]
                      },
                      shortPoolAmount: {
                        methodName: 'getUint',
                        params: [poolAmountKey(marketAddress, market.shortTokenAddress)]
                      },
                      maxLongPoolAmount: {
                        methodName: 'getUint',
                        params: [maxPoolAmountKey(marketAddress, market.longTokenAddress)]
                      },
                      maxShortPoolAmount: {
                        methodName: 'getUint',
                        params: [maxPoolAmountKey(marketAddress, market.shortTokenAddress)]
                      },
                      longPoolAmountAdjustment: {
                        methodName: 'getUint',
                        params: [poolAmountAdjustmentKey(marketAddress, market.longTokenAddress)]
                      },
                      shortPoolAmountAdjustment: {
                        methodName: 'getUint',
                        params: [poolAmountAdjustmentKey(marketAddress, market.longTokenAddress)]
                      },
                      reserveFactorLong: {
                        methodName: 'getUint',
                        params: [reserveFactorKey(marketAddress, true)]
                      },
                      reserveFactorShort: {
                        methodName: 'getUint',
                        params: [reserveFactorKey(marketAddress, true)]
                      },
                      openInterestReserveFactorLong: {
                        methodName: 'getUint',
                        params: [openInterestReserveFactorKey(marketAddress, true)]
                      },
                      openInterestReserveFactorShort: {
                        methodName: 'getUint',
                        params: [openInterestReserveFactorKey(marketAddress, false)]
                      },
                      positionImpactPoolAmount: {
                        methodName: 'getUint',
                        params: [positionImpactPoolAmountKey(marketAddress)]
                      },
                      swapImpactPoolAmountLong: {
                        methodName: 'getUint',
                        params: [swapImpactPoolAmountKey(marketAddress, market.longTokenAddress)]
                      },
                      swapImpactPoolAmountShort: {
                        methodName: 'getUint',
                        params: [swapImpactPoolAmountKey(marketAddress, market.shortTokenAddress)]
                      },
                      borrowingFactorLong: {
                        methodName: 'getUint',
                        params: [borrowingFactorKey(marketAddress, true)]
                      },
                      borrowingFactorShort: {
                        methodName: 'getUint',
                        params: [borrowingFactorKey(marketAddress, false)]
                      },
                      borrowingExponentFactorLong: {
                        methodName: 'getUint',
                        params: [borrowingExponentFactorKey(marketAddress, true)]
                      },
                      borrowingExponentFactorShort: {
                        methodName: 'getUint',
                        params: [borrowingExponentFactorKey(marketAddress, false)]
                      },
                      fundingFactor: {
                        methodName: 'getUint',
                        params: [fundingFactorKey(marketAddress)]
                      },
                      fundingExponentFactor: {
                        methodName: 'getUint',
                        params: [fundingExponentFactorKey(marketAddress)]
                      },
                      maxPnlFactorForTradersLong: {
                        methodName: 'getUint',
                        params: [maxPnlFactorKey(MAX_PNL_FACTOR_FOR_TRADERS_KEY, marketAddress, true)]
                      },
                      maxPnlFactorForTradersShort: {
                        methodName: 'getUint',
                        params: [maxPnlFactorKey(MAX_PNL_FACTOR_FOR_TRADERS_KEY, marketAddress, false)]
                      },
                      claimableFundingAmountLong: account ? {
                        methodName: 'getUint',
                        params: [claimableFundingAmountKey(marketAddress, market.longTokenAddress, account)]
                      } : undefined,
                      claimableFundingAmountShort: account ? {
                        methodName: 'getUint',
                        params: [claimableFundingAmountKey(marketAddress, market.shortTokenAddress, account)]
                      } : undefined,
                      positionFeeFactorForPositiveImpact: {
                        methodName: 'getUint',
                        params: [positionFeeFactorKey(marketAddress, true)]
                      },
                      positionFeeFactorForNegativeImpact: {
                        methodName: 'getUint',
                        params: [positionFeeFactorKey(marketAddress, false)]
                      },
                      positionImpactFactorPositive: {
                        methodName: 'getUint',
                        params: [positionImpactFactorKey(marketAddress, true)]
                      },
                      positionImpactFactorNegative: {
                        methodName: 'getUint',
                        params: [positionImpactFactorKey(marketAddress, false)]
                      },
                      maxPositionImpactFactorPositive: {
                        methodName: 'getUint',
                        params: [maxPositionImpactFactorKey(marketAddress, true)]
                      },
                      maxPositionImpactFactorNegative: {
                        methodName: 'getUint',
                        params: [maxPositionImpactFactorKey(marketAddress, false)]
                      },
                      maxPositionImpactFactorForLiquidations: {
                        methodName: 'getUint',
                        params: [maxPositionImpactFactorForLiquidationsKey(marketAddress)]
                      },
                      minCollateralFactor: {
                        methodName: 'getUint',
                        params: [minCollateralFactorKey(marketAddress)]
                      },
                      minCollateralFactorForOpenInterestLong: {
                        methodName: 'getUint',
                        params: [minCollateralFactorForOpenInterest(marketAddress, true)]
                      },
                      minCollateralFactorForOpenInterestShort: {
                        methodName: 'getUint',
                        params: [minCollateralFactorForOpenInterest(marketAddress, false)]
                      },
                      positionImpactExponentFactor: {
                        methodName: 'getUint',
                        params: [positionImpactExponentFactorKey(marketAddress)]
                      },
                      swapFeeFactorForPositiveImpact: {
                        methodName: 'getUint',
                        params: [swapFeeFactorKey(marketAddress, true)]
                      },
                      swapFeeFactorForNegativeImpact: {
                        methodName: 'getUint',
                        params: [swapFeeFactorKey(marketAddress, false)]
                      },
                      swapImpactFactorPositive: {
                        methodName: 'getUint',
                        params: [swapImpactFactorKey(marketAddress, true)]
                      },
                      swapImpactFactorNegative: {
                        methodName: 'getUint',
                        params: [swapImpactFactorKey(marketAddress, false)]
                      },
                      swapImpactExponentFactor: {
                        methodName: 'getUint',
                        params: [swapImpactExponentFactorKey(marketAddress)]
                      },
                      longInterestUsingLongToken: {
                        methodName: 'getUint',
                        params: [openInterestKey(marketAddress, market.longTokenAddress, true)]
                      },
                      longInterestUsingShortToken: {
                        methodName: 'getUint',
                        params: [openInterestKey(marketAddress, market.shortTokenAddress, true)]
                      },
                      shortInterestUsingLongToken: {
                        methodName: 'getUint',
                        params: [openInterestKey(marketAddress, market.longTokenAddress, false)]
                      },
                      shortInterestUsingShortToken: {
                        methodName: 'getUint',
                        params: [openInterestKey(marketAddress, market.shortTokenAddress, false)]
                      },
                      longInterestInTokensUsingLongToken: {
                        methodName: 'getUint',
                        params: [openInterestInTokensKey(marketAddress, market.longTokenAddress, true)]
                      },
                      longInterestInTokensUsingShortToken: {
                        methodName: 'getUint',
                        params: [openInterestInTokensKey(marketAddress, market.shortTokenAddress, true)]
                      },
                      shortInterestInTokensUsingLongToken: {
                        methodName: 'getUint',
                        params: [openInterestInTokensKey(marketAddress, market.longTokenAddress, false)]
                      },
                      shortInterestInTokensUsingShortToken: {
                        methodName: 'getUint',
                        params: [openInterestInTokensKey(marketAddress, market.shortTokenAddress, false)]
                      },
                      virtualMarketId: {
                        methodName: 'getBytes32',
                        params: [virtualMarketIdKey(marketAddress)]
                      },
                      virtualLongTokenId: {
                        methodName: 'getBytes32',
                        params: [virtualTokenIdKey(market.longTokenAddress)]
                      },
                      virtualShortTokenId: {
                        methodName: 'getBytes32',
                        params: [virtualTokenIdKey(market.shortTokenAddress)]
                      }
                    }
                  }), _Object$assign));
                }, {});
              },
              parseResponse: function parseResponse(res) {
                return marketsAddresses.reduce(function (acc, marketAddress) {
                  var _dataStoreValues$clai, _dataStoreValues$clai2;
                  var readerErrors = res.errors["".concat(marketAddress, "-reader")];
                  var dataStoreErrors = res.errors["".concat(marketAddress, "-dataStore")];
                  var readerValues = res.data["".concat(marketAddress, "-reader")];
                  var dataStoreValues = res.data["".concat(marketAddress, "-dataStore")];

                  // Skip invalid market
                  if (!readerValues || !dataStoreValues || readerErrors || dataStoreErrors) {
                    return acc;
                  }
                  var longInterestUsingLongToken = BigNumber.from(dataStoreValues.longInterestUsingLongToken.returnValues[0]);
                  var longInterestUsingShortToken = BigNumber.from(dataStoreValues.longInterestUsingShortToken.returnValues[0]);
                  var shortInterestUsingLongToken = BigNumber.from(dataStoreValues.shortInterestUsingLongToken.returnValues[0]);
                  var shortInterestUsingShortToken = BigNumber.from(dataStoreValues.shortInterestUsingShortToken.returnValues[0]);
                  var longInterestUsd = longInterestUsingLongToken.add(longInterestUsingShortToken);
                  var shortInterestUsd = shortInterestUsingLongToken.add(shortInterestUsingShortToken);
                  var longInterestInTokensUsingLongToken = BigNumber.from(dataStoreValues.longInterestInTokensUsingLongToken.returnValues[0]);
                  var longInterestInTokensUsingShortToken = BigNumber.from(dataStoreValues.longInterestInTokensUsingShortToken.returnValues[0]);
                  var shortInterestInTokensUsingLongToken = BigNumber.from(dataStoreValues.shortInterestInTokensUsingLongToken.returnValues[0]);
                  var shortInterestInTokensUsingShortToken = BigNumber.from(dataStoreValues.shortInterestInTokensUsingShortToken.returnValues[0]);
                  var longInterestInTokens = longInterestInTokensUsingLongToken.add(longInterestInTokensUsingShortToken);
                  var shortInterestInTokens = shortInterestInTokensUsingLongToken.add(shortInterestInTokensUsingShortToken);

                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  var _readerValues$marketI = readerValues.marketInfo.returnValues,
                    nextFunding = _readerValues$marketI.nextFunding,
                    virtualInventory = _readerValues$marketI.virtualInventory;

                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  var _readerValues$marketT = _slicedToArray(readerValues.marketTokenPriceMin.returnValues, 2);
                    _readerValues$marketT[0];
                    var poolValueInfoMin = _readerValues$marketT[1];

                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  var _readerValues$marketT2 = _slicedToArray(readerValues.marketTokenPriceMax.returnValues, 2);
                    _readerValues$marketT2[0];
                    var poolValueInfoMax = _readerValues$marketT2[1];
                  var market = getByKey(marketsData, marketAddress);
                  var longToken = getByKey(tokensData, market.longTokenAddress);
                  var shortToken = getByKey(tokensData, market.shortTokenAddress);
                  var indexToken = getByKey(tokensData, convertTokenAddress(_this.chainId, market.indexTokenAddress, 'native'));
                  acc[marketAddress] = _objectSpread$6(_objectSpread$6({}, market), {}, {
                    isDisabled: dataStoreValues.isDisabled.returnValues[0],
                    longToken: longToken,
                    shortToken: shortToken,
                    indexToken: indexToken,
                    longInterestUsd: longInterestUsd,
                    shortInterestUsd: shortInterestUsd,
                    longInterestInTokens: longInterestInTokens,
                    shortInterestInTokens: shortInterestInTokens,
                    longPoolAmount: BigNumber.from(dataStoreValues.longPoolAmount.returnValues[0]),
                    shortPoolAmount: BigNumber.from(dataStoreValues.shortPoolAmount.returnValues[0]),
                    maxLongPoolAmount: BigNumber.from(dataStoreValues.maxLongPoolAmount.returnValues[0]),
                    maxShortPoolAmount: BigNumber.from(dataStoreValues.maxShortPoolAmount.returnValues[0]),
                    longPoolAmountAdjustment: BigNumber.from(dataStoreValues.longPoolAmountAdjustment.returnValues[0]),
                    shortPoolAmountAdjustment: BigNumber.from(dataStoreValues.shortPoolAmountAdjustment.returnValues[0]),
                    poolValueMin: BigNumber.from(poolValueInfoMin.poolValue),
                    poolValueMax: BigNumber.from(poolValueInfoMax.poolValue),
                    reserveFactorLong: BigNumber.from(dataStoreValues.reserveFactorLong.returnValues[0]),
                    reserveFactorShort: BigNumber.from(dataStoreValues.reserveFactorShort.returnValues[0]),
                    openInterestReserveFactorLong: BigNumber.from(dataStoreValues.openInterestReserveFactorLong.returnValues[0]),
                    openInterestReserveFactorShort: BigNumber.from(dataStoreValues.openInterestReserveFactorShort.returnValues[0]),
                    totalBorrowingFees: BigNumber.from(poolValueInfoMax.totalBorrowingFees),
                    positionImpactPoolAmount: BigNumber.from(dataStoreValues.positionImpactPoolAmount.returnValues[0]),
                    swapImpactPoolAmountLong: BigNumber.from(dataStoreValues.swapImpactPoolAmountLong.returnValues[0]),
                    swapImpactPoolAmountShort: BigNumber.from(dataStoreValues.swapImpactPoolAmountShort.returnValues[0]),
                    borrowingFactorLong: BigNumber.from(dataStoreValues.borrowingFactorLong.returnValues[0]),
                    borrowingFactorShort: BigNumber.from(dataStoreValues.borrowingFactorShort.returnValues[0]),
                    borrowingExponentFactorLong: BigNumber.from(dataStoreValues.borrowingExponentFactorLong.returnValues[0]),
                    borrowingExponentFactorShort: BigNumber.from(dataStoreValues.borrowingExponentFactorShort.returnValues[0]),
                    fundingFactor: BigNumber.from(dataStoreValues.fundingFactor.returnValues[0]),
                    fundingExponentFactor: BigNumber.from(dataStoreValues.fundingExponentFactor.returnValues[0]),
                    pnlLongMax: BigNumber.from(poolValueInfoMax.longPnl),
                    pnlLongMin: BigNumber.from(poolValueInfoMin.longPnl),
                    pnlShortMax: BigNumber.from(poolValueInfoMax.shortPnl),
                    pnlShortMin: BigNumber.from(poolValueInfoMin.shortPnl),
                    netPnlMax: BigNumber.from(poolValueInfoMax.netPnl),
                    netPnlMin: BigNumber.from(poolValueInfoMin.netPnl),
                    maxPnlFactorForTradersLong: BigNumber.from(dataStoreValues.maxPnlFactorForTradersLong.returnValues[0]),
                    maxPnlFactorForTradersShort: BigNumber.from(dataStoreValues.maxPnlFactorForTradersShort.returnValues[0]),
                    minCollateralFactor: BigNumber.from(dataStoreValues.minCollateralFactor.returnValues[0]),
                    minCollateralFactorForOpenInterestLong: BigNumber.from(dataStoreValues.minCollateralFactorForOpenInterestLong.returnValues[0]),
                    minCollateralFactorForOpenInterestShort: BigNumber.from(dataStoreValues.minCollateralFactorForOpenInterestShort.returnValues[0]),
                    claimableFundingAmountLong: dataStoreValues.claimableFundingAmountLong ? BigNumber.from((_dataStoreValues$clai = dataStoreValues.claimableFundingAmountLong) === null || _dataStoreValues$clai === void 0 ? void 0 : _dataStoreValues$clai.returnValues[0]) : undefined,
                    claimableFundingAmountShort: dataStoreValues.claimableFundingAmountShort ? BigNumber.from((_dataStoreValues$clai2 = dataStoreValues.claimableFundingAmountShort) === null || _dataStoreValues$clai2 === void 0 ? void 0 : _dataStoreValues$clai2.returnValues[0]) : undefined,
                    positionFeeFactorForPositiveImpact: BigNumber.from(dataStoreValues.positionFeeFactorForPositiveImpact.returnValues[0]),
                    positionFeeFactorForNegativeImpact: BigNumber.from(dataStoreValues.positionFeeFactorForNegativeImpact.returnValues[0]),
                    positionImpactFactorPositive: BigNumber.from(dataStoreValues.positionImpactFactorPositive.returnValues[0]),
                    positionImpactFactorNegative: BigNumber.from(dataStoreValues.positionImpactFactorNegative.returnValues[0]),
                    maxPositionImpactFactorPositive: BigNumber.from(dataStoreValues.maxPositionImpactFactorPositive.returnValues[0]),
                    maxPositionImpactFactorNegative: BigNumber.from(dataStoreValues.maxPositionImpactFactorNegative.returnValues[0]),
                    maxPositionImpactFactorForLiquidations: BigNumber.from(dataStoreValues.maxPositionImpactFactorForLiquidations.returnValues[0]),
                    positionImpactExponentFactor: BigNumber.from(dataStoreValues.positionImpactExponentFactor.returnValues[0]),
                    swapFeeFactorForPositiveImpact: BigNumber.from(dataStoreValues.swapFeeFactorForPositiveImpact.returnValues[0]),
                    swapFeeFactorForNegativeImpact: BigNumber.from(dataStoreValues.swapFeeFactorForNegativeImpact.returnValues[0]),
                    swapImpactFactorPositive: BigNumber.from(dataStoreValues.swapImpactFactorPositive.returnValues[0]),
                    swapImpactFactorNegative: BigNumber.from(dataStoreValues.swapImpactFactorNegative.returnValues[0]),
                    swapImpactExponentFactor: BigNumber.from(dataStoreValues.swapImpactExponentFactor.returnValues[0]),
                    borrowingFactorPerSecondForLongs: BigNumber.from(readerValues.marketInfo.returnValues.borrowingFactorPerSecondForLongs),
                    borrowingFactorPerSecondForShorts: BigNumber.from(readerValues.marketInfo.returnValues.borrowingFactorPerSecondForShorts),
                    fundingFactorPerSecond: BigNumber.from(nextFunding.fundingFactorPerSecond),
                    longsPayShorts: nextFunding.longsPayShorts,
                    virtualPoolAmountForLongToken: BigNumber.from(virtualInventory.virtualPoolAmountForLongToken),
                    virtualPoolAmountForShortToken: BigNumber.from(virtualInventory.virtualPoolAmountForShortToken),
                    virtualInventoryForPositions: BigNumber.from(virtualInventory.virtualInventoryForPositions),
                    virtualMarketId: dataStoreValues.virtualMarketId.returnValues[0],
                    virtualLongTokenId: dataStoreValues.virtualLongTokenId.returnValues[0],
                    virtualShortTokenId: dataStoreValues.virtualShortTokenId.returnValues[0]
                  });
                  return acc;
                }, {});
              }
            });
          case 15:
            res = _context5.sent;
            return _context5.abrupt("return", {
              marketsInfoData: res.data,
              tokensData: tokensData,
              pricesUpdatedAt: pricesUpdatedAt
            });
          case 17:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })));
    _defineProperty(_assertThisInitialized(_this), "getSwapRoutes", function (p) {
      var _findAllPaths;
      if (!p.marketsInfoData) return;
      var fromTokenAddress = p.fromTokenAddress,
        toTokenAddress = p.toTokenAddress,
        marketsInfoData = p.marketsInfoData;
      var chainId = _this.chainId;
      var wrappedToken = getWrappedToken(chainId);
      var isWrap = fromTokenAddress === NATIVE_TOKEN_ADDRESS && toTokenAddress === wrappedToken.value;
      var isUnwrap = fromTokenAddress === wrappedToken.value && toTokenAddress === NATIVE_TOKEN_ADDRESS;
      var isSameToken = fromTokenAddress === toTokenAddress;
      var wrappedFromAddress = convertTokenAddress(chainId, fromTokenAddress, 'wrapped');
      var wrappedToAddress = convertTokenAddress(chainId, toTokenAddress, 'wrapped');
      var graph = getMarketsGraph(Object.values(marketsInfoData));
      var estimator = createSwapEstimator(marketsInfoData);
      var allRoutes = isWrap || isUnwrap || isSameToken ? undefined : (_findAllPaths = findAllPaths(marketsInfoData, graph, wrappedFromAddress, wrappedToAddress)) === null || _findAllPaths === void 0 ? void 0 : _findAllPaths.sort(function (a, b) {
        return b.liquidity.sub(a.liquidity).gt(0) ? 1 : -1;
      }).slice(0, 5);
      var maxLiquidity = BigNumber.from(0);
      var maxLiquidityPath = undefined;
      if (!allRoutes || !marketsInfoData || !wrappedFromAddress) {
        return {
          maxLiquidity: maxLiquidity,
          maxLiquidityPath: maxLiquidityPath
        };
      }
      var _iterator = _createForOfIteratorHelper$2(allRoutes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var route = _step.value;
          var liquidity = getMaxSwapPathLiquidity({
            marketsInfoData: marketsInfoData,
            swapPath: route.path,
            initialCollateralAddress: wrappedFromAddress
          });
          if (liquidity.gt(maxLiquidity)) {
            maxLiquidity = liquidity;
            maxLiquidityPath = route.path;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var findSwapPath = function findSwapPath(usdIn, opts) {
        if (!(allRoutes !== null && allRoutes !== void 0 && allRoutes.length) || !estimator || !marketsInfoData || !fromTokenAddress) {
          return undefined;
        }
        var swapPath = undefined;
        if (opts.byLiquidity) {
          swapPath = allRoutes[0].path;
        } else {
          swapPath = getBestSwapPath(allRoutes, usdIn, estimator);
        }
        if (!swapPath) {
          return undefined;
        }
        var swapPathStats = getSwapPathStats({
          marketsInfoData: marketsInfoData,
          swapPath: swapPath,
          initialCollateralAddress: fromTokenAddress,
          wrappedNativeTokenAddress: wrappedToken.value,
          shouldUnwrapNativeToken: toTokenAddress === NATIVE_TOKEN_ADDRESS,
          shouldApplyPriceImpact: true,
          usdIn: usdIn
        });
        if (!swapPathStats) {
          return undefined;
        }
        return swapPathStats;
      };
      return {
        maxSwapLiquidity: maxLiquidity,
        maxLiquiditySwapPath: maxLiquidityPath,
        findSwapPath: findSwapPath
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getTokenData", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref6) {
        var address, _yield$_this$getToken4, tokensData;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              address = _ref6.address;
              _context6.next = 3;
              return _this.getTokensData();
            case 3:
              _yield$_this$getToken4 = _context6.sent;
              tokensData = _yield$_this$getToken4.tokensData;
              if (tokensData) {
                _context6.next = 7;
                break;
              }
              return _context6.abrupt("return");
            case 7:
              return _context6.abrupt("return", tokensData[address]);
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x) {
        return _ref7.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getPositions", /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref8) {
        var marketsInfoData, tokensData, pricesUpdatedAt, _yield$runMulticall2, existingPositionsKeysSet, keysAndPrices, _yield$runMulticall3, positionsData, optimisticPositionsData;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              marketsInfoData = _ref8.marketsInfoData, tokensData = _ref8.tokensData, pricesUpdatedAt = _ref8.pricesUpdatedAt;
              _context7.next = 3;
              return runMulticall(_this.chainId, 'usePositions-keys', _this.library, {
                key: _this.account ? [_this.account, pricesUpdatedAt] : null,
                // Refresh on every prices update
                refreshInterval: null,
                clearUnusedKeys: true,
                keepPreviousData: true,
                request: function request() {
                  return {
                    dataStore: {
                      contractAddress: getContract({
                        chainId: _this.chainId,
                        name: 'DataStore'
                      }) || '',
                      abi: DataStoreAbi,
                      calls: {
                        keys: {
                          methodName: 'getBytes32ValuesAt',
                          params: [accountPositionListKey(_this.account), 0, 1000]
                        }
                      }
                    }
                  };
                },
                parseResponse: function parseResponse(res) {
                  return new Set(res.data.dataStore.keys.returnValues);
                }
              });
            case 3:
              _yield$runMulticall2 = _context7.sent;
              existingPositionsKeysSet = _yield$runMulticall2.data;
              keysAndPrices = getKeysAndPricesParams({
                marketsInfoData: marketsInfoData,
                tokensData: tokensData,
                account: _this.account,
                existingPositionsKeysSet: existingPositionsKeysSet
              });
              _context7.next = 8;
              return runMulticall(_this.chainId, 'usePositionsData', _this.library, {
                key: keysAndPrices.contractPositionsKeys.length ? [keysAndPrices.contractPositionsKeys.join('-'), pricesUpdatedAt] : null,
                // Refresh on every prices update
                refreshInterval: null,
                clearUnusedKeys: true,
                keepPreviousData: true,
                request: function request() {
                  return {
                    reader: {
                      contractAddress: getContract({
                        chainId: _this.chainId,
                        name: 'SyntheticsReader'
                      }) || '',
                      abi: SyntheticsReaderAbi,
                      calls: {
                        positions: {
                          methodName: 'getAccountPositionInfoList',
                          params: [getContract({
                            chainId: _this.chainId,
                            name: 'DataStore'
                          }), getContract({
                            chainId: _this.chainId,
                            name: 'ReferralStorage'
                          }), keysAndPrices.contractPositionsKeys, keysAndPrices.marketsPrices,
                          // uiFeeReceiver
                          ethers.constants.AddressZero]
                        }
                      }
                    }
                  };
                },
                parseResponse: function parseResponse(res) {
                  var positions = res.data.reader.positions.returnValues;
                  return positions.reduce(function (positionsMap, positionInfo, i) {
                    var position = positionInfo.position,
                      fees = positionInfo.fees;
                    var addresses = position.addresses,
                      numbers = position.numbers,
                      flags = position.flags,
                      data = position.data;
                    var account = addresses.account,
                      marketAddress = addresses.market,
                      collateralTokenAddress = addresses.collateralToken;

                    // Empty position
                    if (BigNumber.from(numbers.increasedAtBlock).eq(0)) {
                      return positionsMap;
                    }
                    var positionKey = getPositionKey(account, marketAddress, collateralTokenAddress, flags.isLong);
                    var contractPositionKey = keysAndPrices.contractPositionsKeys[i];
                    positionsMap[positionKey] = {
                      key: positionKey,
                      contractKey: contractPositionKey,
                      account: account,
                      marketAddress: marketAddress,
                      collateralTokenAddress: collateralTokenAddress,
                      sizeInUsd: BigNumber.from(numbers.sizeInUsd),
                      sizeInTokens: BigNumber.from(numbers.sizeInTokens),
                      collateralAmount: BigNumber.from(numbers.collateralAmount),
                      increasedAtBlock: BigNumber.from(numbers.increasedAtBlock),
                      decreasedAtBlock: BigNumber.from(numbers.decreasedAtBlock),
                      isLong: flags.isLong,
                      pendingBorrowingFeesUsd: BigNumber.from(fees.borrowing.borrowingFeeUsd),
                      fundingFeeAmount: BigNumber.from(fees.funding.fundingFeeAmount),
                      claimableLongTokenAmount: BigNumber.from(fees.funding.claimableLongTokenAmount),
                      claimableShortTokenAmount: BigNumber.from(fees.funding.claimableShortTokenAmount),
                      data: data
                    };
                    return positionsMap;
                  }, {});
                }
              });
            case 8:
              _yield$runMulticall3 = _context7.sent;
              positionsData = _yield$runMulticall3.data;
              optimisticPositionsData = getOptimisticPositions({
                positionsData: positionsData,
                allPositionsKeys: keysAndPrices === null || keysAndPrices === void 0 ? void 0 : keysAndPrices.allPositionsKeys
              });
              return _context7.abrupt("return", {
                positionsData: optimisticPositionsData
              });
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function (_x2) {
        return _ref9.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getIncreaseAmounts", /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref10) {
        var marketsInfoData, fromTokenAddress, toTokenAddress, fromTokenAmount, toTokenAmount, collateralInToken, tradeType, tradeMode, marketAddress, tokensData, toToken, fromToken, market, tradeOptions, swapRoute, values;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              marketsInfoData = _ref10.marketsInfoData, fromTokenAddress = _ref10.fromTokenAddress, toTokenAddress = _ref10.toTokenAddress, fromTokenAmount = _ref10.fromTokenAmount, toTokenAmount = _ref10.toTokenAmount, collateralInToken = _ref10.collateralInToken, tradeType = _ref10.tradeType, tradeMode = _ref10.tradeMode, marketAddress = _ref10.marketAddress, tokensData = _ref10.tokensData;
              if (!(!toTokenAddress || !fromTokenAddress)) {
                _context8.next = 3;
                break;
              }
              return _context8.abrupt("return", undefined);
            case 3:
              _context8.next = 5;
              return _this.getTokenData({
                address: toTokenAddress
              });
            case 5:
              toToken = _context8.sent;
              _context8.next = 8;
              return _this.getTokenData({
                address: fromTokenAddress
              });
            case 8:
              fromToken = _context8.sent;
              if (!(!toToken || !fromToken)) {
                _context8.next = 12;
                break;
              }
              console.error("token not found");
              return _context8.abrupt("return", undefined);
            case 12:
              if (!(!marketsInfoData || !marketAddress)) {
                _context8.next = 14;
                break;
              }
              return _context8.abrupt("return");
            case 14:
              market = marketsInfoData[marketAddress];
              tradeOptions = _this.getSelectedTradeOption({
                tradeType: tradeType,
                tradeMode: tradeMode,
                marketsInfoData: marketsInfoData,
                market: market,
                tokensData: tokensData,
                fromTokenAddress: fromTokenAddress,
                toTokenAddress: toTokenAddress,
                collateralInToken: collateralInToken
              });
              swapRoute = _this.getSwapRoutes({
                marketsInfoData: marketsInfoData,
                fromTokenAddress: fromTokenAddress,
                toTokenAddress: (tradeOptions === null || tradeOptions === void 0 ? void 0 : tradeOptions.collateralAddress) || toTokenAddress
              });
              if (swapRoute) {
                _context8.next = 20;
                break;
              }
              console.error("swapRoute not found");
              return _context8.abrupt("return", undefined);
            case 20:
              if (tradeOptions) {
                _context8.next = 23;
                break;
              }
              console.error('trade error');
              return _context8.abrupt("return");
            case 23:
              if (tradeOptions.marketInfo) {
                _context8.next = 26;
                break;
              }
              console.error('marketInfo error');
              return _context8.abrupt("return");
            case 26:
              if (tradeOptions.collateralToken) {
                _context8.next = 29;
                break;
              }
              console.error('collateralToken error');
              return _context8.abrupt("return");
            case 29:
              if (swapRoute !== null && swapRoute !== void 0 && swapRoute.findSwapPath) {
                _context8.next = 32;
                break;
              }
              console.error('swapRoute error');
              return _context8.abrupt("return");
            case 32:
              values = getIncreasePositionAmounts({
                marketInfo: tradeOptions === null || tradeOptions === void 0 ? void 0 : tradeOptions.marketInfo,
                indexToken: toToken,
                initialCollateralToken: fromToken,
                collateralToken: tradeOptions.collateralToken,
                isLong: tradeOptions.tradeType === TradeType.Long,
                initialCollateralAmount: BigNumber.from(fromTokenAmount),
                indexTokenAmount: BigNumber.from(toTokenAmount),
                leverage: BigNumber.from('15000'),
                triggerPrice: undefined,
                position: undefined,
                findSwapPath: swapRoute.findSwapPath,
                strategy: 'leverageByCollateral',
                userReferralInfo: undefined
                // strategy: isLeverageEnabled
                //   ? focusedInput === 'from'
                //     ? 'leverageByCollateral'
                //     : 'leverageBySize'
                //   : 'independent',
              });
              return _context8.abrupt("return", {
                marketInfo: tradeOptions === null || tradeOptions === void 0 ? void 0 : tradeOptions.marketInfo,
                values: values
              });
            case 34:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      return function (_x3) {
        return _ref11.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getCloseAmounts", /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref12) {
        var closingPositionKey, marketsInfoData, tokensData, pricesUpdatedAt, _yield$_this$getPosit, minCollateralUsd, minPositionSizeUsd, savedAcceptablePriceImpactBps, values, _yield$_this$getPosit2, positionsInfoData, position, collateralToken, marketInfo, indexToken, isLong, pnlToken, markPrice, isTrigger, maxCloseAmount, closeSizeUsd, estimatedCollateralUsd, estimatedCollateralDeltaUsd, profitUsd, profitAmount, positionFeeInfo, estimatedPositionFeeCost, estimatedDiscountCost, borrowFeeCost, fundingFeeCost, swapProfitStats, negativePnlUsd, negativePriceImpactUsd, priceImpactDiffUsd, totalFeesUsd, payedInfo;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              closingPositionKey = _ref12.closingPositionKey, marketsInfoData = _ref12.marketsInfoData, tokensData = _ref12.tokensData, pricesUpdatedAt = _ref12.pricesUpdatedAt;
              _context9.next = 3;
              return _this.getPositionsConstants();
            case 3:
              _yield$_this$getPosit = _context9.sent;
              minCollateralUsd = _yield$_this$getPosit.minCollateralUsd;
              minPositionSizeUsd = _yield$_this$getPosit.minPositionSizeUsd;
              savedAcceptablePriceImpactBps = undefined;
              values = {
                isFullClose: false,
                sizeDeltaUsd: BigNumber.from(0),
                sizeDeltaInTokens: BigNumber.from(0),
                collateralDeltaUsd: BigNumber.from(0),
                collateralDeltaAmount: BigNumber.from(0),
                indexPrice: BigNumber.from(0),
                collateralPrice: BigNumber.from(0),
                triggerPrice: BigNumber.from(0),
                acceptablePrice: BigNumber.from(0),
                positionPriceImpactDeltaUsd: BigNumber.from(0),
                priceImpactDiffUsd: BigNumber.from(0),
                acceptablePriceDeltaBps: BigNumber.from(0),
                estimatedPnl: BigNumber.from(0),
                estimatedPnlPercentage: BigNumber.from(0),
                realizedPnl: BigNumber.from(0),
                positionFeeUsd: BigNumber.from(0),
                borrowingFeeUsd: BigNumber.from(0),
                fundingFeeUsd: BigNumber.from(0),
                feeDiscountUsd: BigNumber.from(0),
                swapProfitFeeUsd: BigNumber.from(0),
                payedOutputUsd: BigNumber.from(0),
                payedRemainingCollateralUsd: BigNumber.from(0),
                payedRemainingCollateralAmount: BigNumber.from(0),
                receiveTokenAmount: BigNumber.from(0),
                receiveUsd: BigNumber.from(0),
                triggerOrderType: undefined,
                triggerThresholdType: undefined,
                decreaseSwapType: DecreasePositionSwapType.NoSwap
              };
              _context9.next = 10;
              return _this.getPositionsInfo({
                tokensData: tokensData,
                marketsInfoData: marketsInfoData,
                pricesUpdatedAt: pricesUpdatedAt
              });
            case 10:
              _yield$_this$getPosit2 = _context9.sent;
              positionsInfoData = _yield$_this$getPosit2.positionsInfoData;
              position = getByKey(positionsInfoData, closingPositionKey);
              if (position) {
                _context9.next = 16;
                break;
              }
              console.error("position not found");
              return _context9.abrupt("return");
            case 16:
              collateralToken = position.collateralToken, marketInfo = position.marketInfo, indexToken = position.indexToken, isLong = position.isLong;
              pnlToken = isLong ? marketInfo.longToken : marketInfo.shortToken;
              values.decreaseSwapType = getIsEquivalentTokens(pnlToken, collateralToken) ? DecreasePositionSwapType.NoSwap : DecreasePositionSwapType.SwapPnlTokenToCollateralToken;
              markPrice = getMarkPrice({
                prices: indexToken.prices,
                isIncrease: false,
                isLong: isLong
              });
              isTrigger = false;
              values.indexPrice = markPrice;
              values.collateralPrice = collateralToken.prices.minPrice;
              maxCloseAmount = formatAmountFree(position === null || position === void 0 ? void 0 : position.sizeInUsd, USD_DECIMALS);
              closeSizeUsd = parseValue(maxCloseAmount || '0', USD_DECIMALS);
              estimatedCollateralUsd = convertToUsd(position.collateralAmount, collateralToken.decimals, values.collateralPrice);
              values.sizeDeltaUsd = closeSizeUsd;
              estimatedCollateralDeltaUsd = BigNumber.from(0);
              values.isFullClose = getIsFullClose({
                position: position,
                sizeDeltaUsd: values.sizeDeltaUsd,
                indexPrice: values.indexPrice,
                remainingCollateralUsd: estimatedCollateralUsd.sub(estimatedCollateralDeltaUsd),
                minCollateralUsd: minCollateralUsd || BigNumber.from('0'),
                minPositionSizeUsd: minPositionSizeUsd || BigNumber.from('0')
              });
              if (values.isFullClose) {
                values.sizeDeltaUsd = position.sizeInUsd;
                values.sizeDeltaInTokens = position.sizeInTokens;
              } else {
                if (position.isLong) {
                  values.sizeDeltaInTokens = roundUpDivision(position.sizeInTokens.mul(values.sizeDeltaUsd), position.sizeInUsd);
                } else {
                  values.sizeDeltaInTokens = position.sizeInTokens.mul(values.sizeDeltaUsd).div(position.sizeInUsd);
                }
              }

              // PNL
              values.estimatedPnl = getPositionPnlUsd({
                marketInfo: marketInfo,
                sizeInUsd: position.sizeInUsd,
                sizeInTokens: position.sizeInTokens,
                markPrice: values.indexPrice,
                isLong: isLong
              });
              values.realizedPnl = values.estimatedPnl.mul(values.sizeDeltaInTokens).div(position.sizeInTokens);
              values.estimatedPnlPercentage = !estimatedCollateralUsd.eq(0) ? getBasisPoints(values.estimatedPnl, estimatedCollateralUsd) : BigNumber.from(0);
              applyAcceptablePrice({
                marketInfo: marketInfo,
                isLong: isLong,
                isTrigger: isTrigger,
                savedAcceptablePriceImpactBps: savedAcceptablePriceImpactBps,
                values: values
              });

              // Profit
              profitUsd = BigNumber.from(0);
              if (values.realizedPnl.gt(0)) {
                profitUsd = profitUsd.add(values.realizedPnl);
              }
              if (values.positionPriceImpactDeltaUsd.gt(0)) {
                profitUsd = profitUsd.add(values.positionPriceImpactDeltaUsd);
              }
              profitAmount = convertToTokenAmount(profitUsd, collateralToken.decimals, values.collateralPrice); // Fees
              positionFeeInfo = getPositionFee(marketInfo, values.sizeDeltaUsd, values.positionPriceImpactDeltaUsd.gt(0), undefined);
              estimatedPositionFeeCost = estimateCollateralCost(positionFeeInfo.positionFeeUsd, collateralToken, values.collateralPrice);
              estimatedDiscountCost = estimateCollateralCost(positionFeeInfo.discountUsd, collateralToken, values.collateralPrice);
              values.positionFeeUsd = estimatedPositionFeeCost.usd;
              values.feeDiscountUsd = estimatedDiscountCost.usd;
              borrowFeeCost = estimateCollateralCost(position.pendingBorrowingFeesUsd, collateralToken, values.collateralPrice);
              values.borrowingFeeUsd = borrowFeeCost.usd;
              fundingFeeCost = estimateCollateralCost(position.pendingFundingFeesUsd, collateralToken, values.collateralPrice);
              values.fundingFeeUsd = fundingFeeCost.usd;
              if (profitUsd.gt(0) && values.decreaseSwapType === DecreasePositionSwapType.SwapPnlTokenToCollateralToken) {
                swapProfitStats = getSwapStats({
                  marketInfo: marketInfo,
                  tokenInAddress: pnlToken.value,
                  tokenOutAddress: collateralToken.value,
                  usdIn: profitUsd,
                  shouldApplyPriceImpact: true
                });
                values.swapProfitFeeUsd = swapProfitStats.swapFeeUsd.add(swapProfitStats.priceImpactDeltaUsd.mul(-1));
              } else {
                values.swapProfitFeeUsd = BigNumber.from(0);
              }
              negativePnlUsd = values.realizedPnl.lt(0) ? values.realizedPnl.abs() : BigNumber.from(0);
              negativePriceImpactUsd = values.positionPriceImpactDeltaUsd.lt(0) ? values.positionPriceImpactDeltaUsd.abs() : BigNumber.from(0);
              priceImpactDiffUsd = values.priceImpactDiffUsd.gt(0) ? values.priceImpactDiffUsd : BigNumber.from(0);
              totalFeesUsd = values.positionFeeUsd.add(values.borrowingFeeUsd).add(values.fundingFeeUsd).add(values.swapProfitFeeUsd).add(negativePnlUsd).add(negativePriceImpactUsd).add(priceImpactDiffUsd);
              payedInfo = payForCollateralCost({
                initialCostUsd: totalFeesUsd,
                collateralToken: collateralToken,
                collateralPrice: values.collateralPrice,
                outputAmount: profitAmount,
                remainingCollateralAmount: position.collateralAmount
              });
              values.payedOutputUsd = convertToUsd(payedInfo.paidOutputAmount, collateralToken.decimals, values.collateralPrice);
              values.payedRemainingCollateralAmount = payedInfo.paidRemainingCollateralAmount;
              values.payedRemainingCollateralUsd = convertToUsd(payedInfo.paidRemainingCollateralAmount, collateralToken.decimals, values.collateralPrice);
              values.receiveTokenAmount = payedInfo.outputAmount;

              // Collateral delta
              if (values.isFullClose) {
                values.collateralDeltaUsd = estimatedCollateralUsd;
                values.collateralDeltaAmount = position.collateralAmount;
                values.receiveTokenAmount = payedInfo.outputAmount.add(payedInfo.remainingCollateralAmount);
              } else {
                values.collateralDeltaUsd = BigNumber.from(0);
                values.collateralDeltaAmount = BigNumber.from(0);
                values.receiveTokenAmount = payedInfo.outputAmount;
              }
              values.receiveUsd = convertToUsd(values.receiveTokenAmount, collateralToken.decimals, values.collateralPrice);
              return _context9.abrupt("return", {
                marketInfo: marketInfo,
                values: values,
                position: position
              });
            case 60:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      return function (_x4) {
        return _ref13.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getSelectedPosition", function (_ref14) {
      var marketAddress = _ref14.marketAddress,
        collateralAddress = _ref14.collateralAddress,
        isLong = _ref14.isLong,
        positionsInfoData = _ref14.positionsInfoData;
      var positionKey = getPositionKey(_this.account, marketAddress, collateralAddress, isLong);
      var selectedPosition = getByKey(positionsInfoData, positionKey);
      return selectedPosition;
    });
    _defineProperty(_assertThisInitialized(_this), "getIncreasePositionParams", /*#__PURE__*/function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref15) {
        var _yield$_this$getMarke, _fees$executionFee, _values$swapPathStats, _fees$executionFee2;
        var fromTokenAddress, toTokenAddress, fromTokenAmount, toTokenAmount, collateralInToken, tradeType, tradeMode, marketAddress, referralCode, marketsInfoData, tokens, tokensData, pricesUpdatedAt, increasePositionAmounts, values, marketInfo, isNativePayment, initialCollateralTokenAddress, tradeFlags, fees, wntCollateralAmount, totalWntAmount, shouldApplySlippage, acceptablePrice, orderVaultAddress, multicall, exchangeRouter, encodedPayload;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              fromTokenAddress = _ref15.fromTokenAddress, toTokenAddress = _ref15.toTokenAddress, fromTokenAmount = _ref15.fromTokenAmount, toTokenAmount = _ref15.toTokenAmount, collateralInToken = _ref15.collateralInToken, tradeType = _ref15.tradeType, tradeMode = _ref15.tradeMode, marketAddress = _ref15.marketAddress, referralCode = _ref15.referralCode;
              _context10.t0 = _this.marketsInfo;
              if (_context10.t0) {
                _context10.next = 15;
                break;
              }
              _context10.next = 5;
              return _this.getMarketsInfo();
            case 5:
              _context10.t2 = _yield$_this$getMarke = _context10.sent;
              _context10.t1 = _context10.t2 === null;
              if (_context10.t1) {
                _context10.next = 9;
                break;
              }
              _context10.t1 = _yield$_this$getMarke === void 0;
            case 9:
              if (!_context10.t1) {
                _context10.next = 13;
                break;
              }
              _context10.t3 = void 0;
              _context10.next = 14;
              break;
            case 13:
              _context10.t3 = _yield$_this$getMarke.marketsInfoData;
            case 14:
              _context10.t0 = _context10.t3;
            case 15:
              marketsInfoData = _context10.t0;
              _context10.t4 = _this.tokensData;
              if (_context10.t4) {
                _context10.next = 21;
                break;
              }
              _context10.next = 20;
              return _this.getTokensData();
            case 20:
              _context10.t4 = _context10.sent;
            case 21:
              tokens = _context10.t4;
              if (tokens) {
                _context10.next = 24;
                break;
              }
              return _context10.abrupt("return");
            case 24:
              tokensData = tokens.tokensData, pricesUpdatedAt = tokens.pricesUpdatedAt;
              _context10.next = 27;
              return _this.getIncreaseAmounts({
                marketsInfoData: marketsInfoData,
                fromTokenAddress: fromTokenAddress,
                toTokenAddress: toTokenAddress,
                collateralInToken: collateralInToken,
                fromTokenAmount: fromTokenAmount,
                toTokenAmount: toTokenAmount,
                tradeType: tradeType,
                tradeMode: tradeMode,
                marketAddress: marketAddress,
                tokensData: tokensData
              });
            case 27:
              increasePositionAmounts = _context10.sent;
              if (increasePositionAmounts) {
                _context10.next = 31;
                break;
              }
              console.error('get increasePositionAmounts error');
              return _context10.abrupt("return");
            case 31:
              values = increasePositionAmounts.values, marketInfo = increasePositionAmounts.marketInfo;
              isNativePayment = fromTokenAddress === NATIVE_TOKEN_ADDRESS;
              initialCollateralTokenAddress = convertTokenAddress(_this.chainId, fromTokenAddress, 'wrapped');
              tradeFlags = getTradeFlags(tradeType, tradeMode);
              _context10.next = 37;
              return _this.getIncreaseAmountsFees({
                increaseAmounts: values,
                marketsInfoData: marketsInfoData,
                tokensData: tokensData,
                pricesUpdatedAt: pricesUpdatedAt
              });
            case 37:
              fees = _context10.sent;
              wntCollateralAmount = isNativePayment ? values.initialCollateralAmount : BigNumber.from(0);
              totalWntAmount = wntCollateralAmount.add((fees === null || fees === void 0 ? void 0 : (_fees$executionFee = fees.executionFee) === null || _fees$executionFee === void 0 ? void 0 : _fees$executionFee.feeTokenAmount.toString()) || '0');
              shouldApplySlippage = isMarketOrderType(OrderType.MarketIncrease);
              acceptablePrice = shouldApplySlippage ? applySlippageToPrice(ALLOWED_SLIPPAGE, values.acceptablePrice, true, tradeFlags.isLong) : values.acceptablePrice; // const params = {
              //   sendWnt: {
              //     receiver: getContract({ chainId: this.chainId, name: 'OrderVault' }),
              //     amount: totalWntAmount.toString(),
              //   },
              //   createOrder: {
              //     addresses_tuple: {
              //       receiver: this.account,
              //       initialCollateralToken: initialCollateralTokenAddress,
              //       callbackContract: AddressZero,
              //       market: market?.marketTokenAddress,
              //       swapPath: values.swapPathStats?.swapPath,
              //       uiFeeReceiver: AddressZero,
              //     },
              //     numbers_tuple: {
              //       sizeDeltaUsd: values.sizeDeltaUsd.toString(),
              //       initialCollateralDeltaAmount: BigNumber.from(0).toString(),
              //       triggerPrice: convertToContractPrice(
              //         values.triggerPrice || BigNumber.from(0),
              //         marketInfo.indexToken.decimals
              //       ).toString(),
              //       acceptablePrice: convertToContractPrice(acceptablePrice, marketInfo.indexToken.decimals).toString(),
              //       executionFee: fees?.executionFee?.feeTokenAmount.toString() || '0',
              //       callbackGasLimit: BigNumber.from(0).toString(),
              //       minOutputAmount: BigNumber.from(0).toString(),
              //     },
              //     orderType: String(tradeFlags.isLimit ? OrderType.LimitIncrease : OrderType.MarketIncrease),
              //     decreasePositionSwapType: String(DecreasePositionSwapType.NoSwap),
              //     isLong: tradeFlags.isLong,
              //     shouldUnwrapNativeToken: isNativePayment,
              //     referralCode: referralCode || ethers.constants.HashZero,
              //   },
              // }
              //return params
              orderVaultAddress = getContract({
                chainId: _this.chainId,
                name: 'OrderVault'
              });
              multicall = [{
                method: 'sendWnt',
                params: [orderVaultAddress, totalWntAmount]
              }, !isNativePayment ? {
                method: 'sendTokens',
                params: [initialCollateralTokenAddress, orderVaultAddress, values.initialCollateralAmount]
              } : undefined, {
                method: 'createOrder',
                params: [{
                  addresses: {
                    receiver: _this.account,
                    initialCollateralToken: initialCollateralTokenAddress,
                    callbackContract: AddressZero,
                    market: marketAddress,
                    swapPath: (_values$swapPathStats = values.swapPathStats) === null || _values$swapPathStats === void 0 ? void 0 : _values$swapPathStats.swapPath,
                    uiFeeReceiver: AddressZero
                  },
                  numbers: {
                    sizeDeltaUsd: values.sizeDeltaUsd,
                    initialCollateralDeltaAmount: BigNumber.from(0),
                    triggerPrice: convertToContractPrice(values.triggerPrice || BigNumber.from(0), marketInfo.indexToken.decimals).toString(),
                    acceptablePrice: convertToContractPrice(acceptablePrice, marketInfo.indexToken.decimals),
                    executionFee: (fees === null || fees === void 0 ? void 0 : (_fees$executionFee2 = fees.executionFee) === null || _fees$executionFee2 === void 0 ? void 0 : _fees$executionFee2.feeTokenAmount) || '0',
                    callbackGasLimit: BigNumber.from(0),
                    minOutputAmount: BigNumber.from(0)
                  },
                  orderType: tradeFlags.isLimit ? OrderType.LimitIncrease : OrderType.MarketIncrease,
                  decreasePositionSwapType: DecreasePositionSwapType.NoSwap,
                  isLong: tradeFlags.isLong,
                  shouldUnwrapNativeToken: isNativePayment,
                  referralCode: referralCode || ethers.constants.HashZero
                }]
              }];
              exchangeRouter = new ethers.Contract(getContract({
                chainId: _this.chainId,
                name: 'ExchangeRouter'
              }) || '', exchangeRouterAbi, _this.library.getSigner());
              encodedPayload = multicall.filter(Boolean).map(function (call) {
                return exchangeRouter.interface.encodeFunctionData(call.method, call.params);
              });
              return _context10.abrupt("return", {
                encodedPayload: encodedPayload,
                totalWntAmount: totalWntAmount
              });
            case 47:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      return function (_x5) {
        return _ref16.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getClosePositionParams", /*#__PURE__*/function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref17) {
        var _yield$_this$getMarke2, _fees$executionFee3, _swapAmounts, _swapAmounts$swapPath, _fees$executionFee4;
        var closingPositionKey, receiveTokenAddress, marketsInfoData, tokens, tokensData, pricesUpdatedAt, closePositionAmounts, values, position, isNativeReceive, swapRoutes, findSwapPath, receiveToken, swapAmounts, shouldSwap, fees, totalWntAmount, shouldApplySlippage, orderVaultAddress, initialCollateralTokenAddress, acceptablePrice, minOutputUsd, minOutputAmount, multicall, exchangeRouter, encodedPayload;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              closingPositionKey = _ref17.closingPositionKey, receiveTokenAddress = _ref17.receiveTokenAddress;
              _context11.t0 = _this.marketsInfo;
              if (_context11.t0) {
                _context11.next = 15;
                break;
              }
              _context11.next = 5;
              return _this.getMarketsInfo();
            case 5:
              _context11.t2 = _yield$_this$getMarke2 = _context11.sent;
              _context11.t1 = _context11.t2 === null;
              if (_context11.t1) {
                _context11.next = 9;
                break;
              }
              _context11.t1 = _yield$_this$getMarke2 === void 0;
            case 9:
              if (!_context11.t1) {
                _context11.next = 13;
                break;
              }
              _context11.t3 = void 0;
              _context11.next = 14;
              break;
            case 13:
              _context11.t3 = _yield$_this$getMarke2.marketsInfoData;
            case 14:
              _context11.t0 = _context11.t3;
            case 15:
              marketsInfoData = _context11.t0;
              _context11.t4 = _this.tokensData;
              if (_context11.t4) {
                _context11.next = 21;
                break;
              }
              _context11.next = 20;
              return _this.getTokensData();
            case 20:
              _context11.t4 = _context11.sent;
            case 21:
              tokens = _context11.t4;
              if (tokens) {
                _context11.next = 24;
                break;
              }
              return _context11.abrupt("return");
            case 24:
              tokensData = tokens.tokensData, pricesUpdatedAt = tokens.pricesUpdatedAt;
              _context11.next = 27;
              return _this.getCloseAmounts({
                closingPositionKey: closingPositionKey,
                marketsInfoData: marketsInfoData,
                tokensData: tokensData,
                pricesUpdatedAt: pricesUpdatedAt
              });
            case 27:
              closePositionAmounts = _context11.sent;
              if (closePositionAmounts) {
                _context11.next = 31;
                break;
              }
              console.error('get closePositionAmounts error');
              return _context11.abrupt("return");
            case 31:
              values = closePositionAmounts.values, position = closePositionAmounts.position;
              isNativeReceive = receiveTokenAddress === NATIVE_TOKEN_ADDRESS;
              swapRoutes = _this.getSwapRoutes({
                marketsInfoData: marketsInfoData,
                fromTokenAddress: position === null || position === void 0 ? void 0 : position.collateralTokenAddress,
                toTokenAddress: receiveTokenAddress
              });
              if (swapRoutes) {
                _context11.next = 36;
                break;
              }
              return _context11.abrupt("return");
            case 36:
              findSwapPath = swapRoutes.findSwapPath;
              _context11.next = 39;
              return _this.getTokenData({
                address: receiveTokenAddress
              });
            case 39:
              receiveToken = _context11.sent;
              if (receiveToken) {
                _context11.next = 43;
                break;
              }
              console.error("Get receive token error");
              return _context11.abrupt("return");
            case 43:
              shouldSwap = position && receiveToken && !getIsEquivalentTokens(position.collateralToken, receiveToken);
              if (!shouldSwap || !receiveToken || !(values !== null && values !== void 0 && values.receiveTokenAmount) || !position) {
                swapAmounts = undefined;
              } else {
                swapAmounts = getSwapAmountsByFromValue({
                  tokenIn: position.collateralToken,
                  tokenOut: receiveToken,
                  amountIn: values.receiveTokenAmount,
                  isLimit: false,
                  findSwapPath: findSwapPath
                });
              }
              _context11.next = 47;
              return _this.getDecreaseAmountsFees({
                decreaseAmounts: values,
                swapAmounts: swapAmounts,
                marketsInfoData: marketsInfoData,
                tokensData: tokensData,
                pricesUpdatedAt: pricesUpdatedAt,
                receiveTokenAddress: receiveTokenAddress,
                position: position
              });
            case 47:
              fees = _context11.sent;
              values.receiveTokenAmount;
              totalWntAmount = (fees === null || fees === void 0 ? void 0 : (_fees$executionFee3 = fees.executionFee) === null || _fees$executionFee3 === void 0 ? void 0 : _fees$executionFee3.feeTokenAmount.toString()) || '0';
              shouldApplySlippage = isMarketOrderType(OrderType.MarketIncrease);
              orderVaultAddress = getContract({
                chainId: _this.chainId,
                name: 'OrderVault'
              });
              initialCollateralTokenAddress = convertTokenAddress(_this.chainId, position.collateralTokenAddress, 'wrapped');
              acceptablePrice = shouldApplySlippage ? applySlippageToPrice(ALLOWED_SLIPPAGE, values.acceptablePrice, false, position.isLong) : values.acceptablePrice;
              minOutputUsd = BigNumber.from(0);
              minOutputAmount = shouldApplySlippage ? applySlippageToMinOut(ALLOWED_SLIPPAGE, minOutputUsd) : minOutputUsd;
              multicall = [{
                method: 'sendWnt',
                params: [orderVaultAddress, totalWntAmount.toString()]
              }, {
                method: 'createOrder',
                params: [{
                  addresses: {
                    receiver: _this.account,
                    initialCollateralToken: initialCollateralTokenAddress,
                    callbackContract: AddressZero,
                    market: position.marketAddress,
                    swapPath: ((_swapAmounts = swapAmounts) === null || _swapAmounts === void 0 ? void 0 : (_swapAmounts$swapPath = _swapAmounts.swapPathStats) === null || _swapAmounts$swapPath === void 0 ? void 0 : _swapAmounts$swapPath.swapPath) || [],
                    uiFeeReceiver: ethers.constants.AddressZero
                  },
                  numbers: {
                    sizeDeltaUsd: values.sizeDeltaUsd.toString(),
                    initialCollateralDeltaAmount: (values.collateralDeltaAmount || BigNumber.from(0)).toString(),
                    triggerPrice: convertToContractPrice(values.triggerPrice || BigNumber.from(0), position.indexToken.decimals).toString(),
                    acceptablePrice: convertToContractPrice(acceptablePrice, position.indexToken.decimals).toString(),
                    executionFee: fees === null || fees === void 0 ? void 0 : (_fees$executionFee4 = fees.executionFee) === null || _fees$executionFee4 === void 0 ? void 0 : _fees$executionFee4.feeTokenAmount.toString(),
                    callbackGasLimit: BigNumber.from(0).toString(),
                    minOutputAmount: minOutputAmount.toString()
                  },
                  orderType: OrderType.MarketDecrease,
                  decreasePositionSwapType: values.decreaseSwapType,
                  isLong: position.isLong,
                  shouldUnwrapNativeToken: isNativeReceive,
                  referralCode: ethers.constants.HashZero
                }]
              }];
              exchangeRouter = new ethers.Contract(getContract({
                chainId: _this.chainId,
                name: 'ExchangeRouter'
              }) || '', exchangeRouterAbi, _this.library.getSigner());
              encodedPayload = multicall.filter(Boolean).map(function (call) {
                return exchangeRouter.interface.encodeFunctionData(call.method, call.params);
              });
              return _context11.abrupt("return", {
                encodedPayload: encodedPayload,
                totalWntAmount: totalWntAmount
              });
            case 60:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
      return function (_x6) {
        return _ref18.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getSelectedTradeOption", function (_ref19) {
      var marketsInfoData = _ref19.marketsInfoData,
        tradeType = _ref19.tradeType,
        tradeMode = _ref19.tradeMode,
        tokensData = _ref19.tokensData,
        fromTokenAddress = _ref19.fromTokenAddress,
        toTokenAddress = _ref19.toTokenAddress,
        collateralInToken = _ref19.collateralInToken,
        market = _ref19.market;
      if (!marketsInfoData) {
        console.error('missing market info');
        return;
      }
      if (!market) {
        console.error('missing market info');
        return;
      }
      var availableTokensOptions = getAvailabeTokenData({
        chainId: _this.chainId,
        marketsInfoData: marketsInfoData,
        tokensData: tokensData
      });
      var avaialbleTradeModes = function avaialbleTradeModes() {
        var _TradeType$Long$Trade;
        if (!tradeType) {
          return [];
        }
        return (_TradeType$Long$Trade = {}, _defineProperty(_TradeType$Long$Trade, TradeType.Long, [TradeMode.Market, TradeMode.Limit, TradeMode.Trigger]), _defineProperty(_TradeType$Long$Trade, TradeType.Short, [TradeMode.Market, TradeMode.Limit, TradeMode.Trigger]), _defineProperty(_TradeType$Long$Trade, TradeType.Swap, [TradeMode.Market, TradeMode.Limit]), _TradeType$Long$Trade)[tradeType];
      };
      var tradeFlags = getTradeFlags(tradeType, tradeMode);
      var isSwap = tradeFlags.isSwap;
        tradeFlags.isLong;
        tradeFlags.isPosition;
      var fromToken = getByKey(tokensData, fromTokenAddress);
      var toToken = getByKey(tokensData, toTokenAddress);
      var isWrapOrUnwrap = Boolean(isSwap && fromToken && toToken && (getIsWrap(fromToken, toToken) || getIsUnwrap(fromToken, toToken)));
      var marketAddress = market.marketTokenAddress;
      var collateralAddress = collateralInToken || toTokenAddress ? market[tradeFlags.isLong ? 'longTokenAddress' : 'shortTokenAddress'] : undefined;
      var marketInfo = marketsInfoData[marketAddress];
      var collateralToken = getByKey(tokensData, collateralAddress);
      return {
        tradeType: tradeType,
        tradeMode: tradeMode,
        tradeFlags: tradeFlags,
        isWrapOrUnwrap: isWrapOrUnwrap,
        fromTokenAddress: fromTokenAddress,
        fromToken: fromToken,
        toTokenAddress: toTokenAddress,
        toToken: toToken,
        marketAddress: marketAddress,
        marketInfo: marketInfo,
        collateralAddress: collateralAddress,
        collateralToken: collateralToken,
        availableTokensOptions: availableTokensOptions,
        avaialbleTradeModes: avaialbleTradeModes()
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getIncreaseAmountsFees", /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref20) {
        var _increaseAmounts$swap, _increaseAmounts$swap2, _increaseAmounts$swap3, _positionsInfoData$pe, _positionsInfoData$pe2;
        var increaseAmounts, tokensData, marketsInfoData, pricesUpdatedAt, _yield$_this$getGasLi, gasLimits, estimatedGas, gasPrice, _yield$_this$getPosit3, positionsInfoData;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              increaseAmounts = _ref20.increaseAmounts, tokensData = _ref20.tokensData, marketsInfoData = _ref20.marketsInfoData, pricesUpdatedAt = _ref20.pricesUpdatedAt;
              if (tokensData) {
                _context12.next = 3;
                break;
              }
              return _context12.abrupt("return");
            case 3:
              _context12.next = 5;
              return _this.getGasLimits();
            case 5:
              _yield$_this$getGasLi = _context12.sent;
              gasLimits = _yield$_this$getGasLi.gasLimits;
              if (gasLimits) {
                _context12.next = 9;
                break;
              }
              return _context12.abrupt("return");
            case 9:
              estimatedGas = estimateExecuteIncreaseOrderGasLimit(gasLimits, {
                swapPath: ((_increaseAmounts$swap = increaseAmounts.swapPathStats) === null || _increaseAmounts$swap === void 0 ? void 0 : _increaseAmounts$swap.swapPath) || []
              });
              _context12.next = 12;
              return _this.getGasPrice();
            case 12:
              gasPrice = _context12.sent;
              if (gasPrice) {
                _context12.next = 15;
                break;
              }
              return _context12.abrupt("return");
            case 15:
              _context12.next = 17;
              return _this.getPositionsInfo({
                tokensData: tokensData,
                marketsInfoData: marketsInfoData,
                pricesUpdatedAt: pricesUpdatedAt
              });
            case 17:
              _yield$_this$getPosit3 = _context12.sent;
              positionsInfoData = _yield$_this$getPosit3.positionsInfoData;
              return _context12.abrupt("return", {
                fees: getTradeFees({
                  isIncrease: true,
                  initialCollateralUsd: increaseAmounts.initialCollateralUsd,
                  sizeDeltaUsd: increaseAmounts.sizeDeltaUsd,
                  swapSteps: ((_increaseAmounts$swap2 = increaseAmounts.swapPathStats) === null || _increaseAmounts$swap2 === void 0 ? void 0 : _increaseAmounts$swap2.swapSteps) || [],
                  positionFeeUsd: increaseAmounts.positionFeeUsd,
                  swapPriceImpactDeltaUsd: ((_increaseAmounts$swap3 = increaseAmounts.swapPathStats) === null || _increaseAmounts$swap3 === void 0 ? void 0 : _increaseAmounts$swap3.totalSwapPriceImpactDeltaUsd) || BigNumber.from(0),
                  positionPriceImpactDeltaUsd: increaseAmounts.positionPriceImpactDeltaUsd,
                  borrowingFeeUsd: (positionsInfoData === null || positionsInfoData === void 0 ? void 0 : (_positionsInfoData$pe = positionsInfoData.pendingBorrowingFeesUsd) === null || _positionsInfoData$pe === void 0 ? void 0 : _positionsInfoData$pe.sizeInUsd) || BigNumber.from(0),
                  fundingFeeUsd: (positionsInfoData === null || positionsInfoData === void 0 ? void 0 : (_positionsInfoData$pe2 = positionsInfoData.pendingFundingFeesUsd) === null || _positionsInfoData$pe2 === void 0 ? void 0 : _positionsInfoData$pe2.sizeInUsd) || BigNumber.from(0),
                  feeDiscountUsd: increaseAmounts.feeDiscountUsd,
                  swapProfitFeeUsd: BigNumber.from(0)
                }),
                executionFee: getExecutionFee(_this.chainId, gasLimits, tokensData, estimatedGas, gasPrice),
                feesType: 'increase'
              });
            case 20:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      return function (_x7) {
        return _ref21.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getDecreaseAmountsFees", /*#__PURE__*/function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref22) {
        var _swapAmounts$swapPath2, _swapAmounts$swapPath3, _swapAmounts$swapPath4;
        var decreaseAmounts, position, swapAmounts, tokensData, _yield$_this$getGasLi2, gasLimits, gasPrice, estimatedGas;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              decreaseAmounts = _ref22.decreaseAmounts, position = _ref22.position, _ref22.receiveTokenAddress, swapAmounts = _ref22.swapAmounts, tokensData = _ref22.tokensData, _ref22.marketsInfoData, _ref22.pricesUpdatedAt;
              if (tokensData) {
                _context13.next = 3;
                break;
              }
              return _context13.abrupt("return");
            case 3:
              _context13.next = 5;
              return _this.getGasLimits();
            case 5:
              _yield$_this$getGasLi2 = _context13.sent;
              gasLimits = _yield$_this$getGasLi2.gasLimits;
              _context13.next = 9;
              return _this.getGasPrice();
            case 9:
              gasPrice = _context13.sent;
              if (gasPrice) {
                _context13.next = 12;
                break;
              }
              return _context13.abrupt("return");
            case 12:
              if (gasLimits) {
                _context13.next = 14;
                break;
              }
              return _context13.abrupt("return");
            case 14:
              estimatedGas = estimateExecuteDecreaseOrderGasLimit(gasLimits, {
                swapPath: (swapAmounts === null || swapAmounts === void 0 ? void 0 : (_swapAmounts$swapPath2 = swapAmounts.swapPathStats) === null || _swapAmounts$swapPath2 === void 0 ? void 0 : _swapAmounts$swapPath2.swapPath) || []
              });
              return _context13.abrupt("return", {
                fees: getTradeFees({
                  isIncrease: false,
                  initialCollateralUsd: position.collateralUsd,
                  sizeDeltaUsd: decreaseAmounts.sizeDeltaUsd,
                  swapSteps: (swapAmounts === null || swapAmounts === void 0 ? void 0 : (_swapAmounts$swapPath3 = swapAmounts.swapPathStats) === null || _swapAmounts$swapPath3 === void 0 ? void 0 : _swapAmounts$swapPath3.swapSteps) || [],
                  positionFeeUsd: decreaseAmounts.positionFeeUsd,
                  swapPriceImpactDeltaUsd: (swapAmounts === null || swapAmounts === void 0 ? void 0 : (_swapAmounts$swapPath4 = swapAmounts.swapPathStats) === null || _swapAmounts$swapPath4 === void 0 ? void 0 : _swapAmounts$swapPath4.totalSwapPriceImpactDeltaUsd) || BigNumber.from(0),
                  positionPriceImpactDeltaUsd: decreaseAmounts.positionPriceImpactDeltaUsd,
                  borrowingFeeUsd: decreaseAmounts.borrowingFeeUsd,
                  fundingFeeUsd: decreaseAmounts.fundingFeeUsd,
                  feeDiscountUsd: decreaseAmounts.feeDiscountUsd,
                  swapProfitFeeUsd: decreaseAmounts.swapProfitFeeUsd
                }),
                executionFee: getExecutionFee(_this.chainId, gasLimits, tokensData, estimatedGas, gasPrice)
              });
            case 16:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      return function (_x8) {
        return _ref23.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getPositionsInfo", /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref24) {
        var marketsInfoData, tokensData, pricesUpdatedAt, _yield$_this$getPosit4, positionsData, _yield$_this$getPosit5, minCollateralUsd, positionsInfoData;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              marketsInfoData = _ref24.marketsInfoData, tokensData = _ref24.tokensData, pricesUpdatedAt = _ref24.pricesUpdatedAt;
              _context14.next = 3;
              return _this.getPositions({
                marketsInfoData: marketsInfoData,
                tokensData: tokensData,
                pricesUpdatedAt: pricesUpdatedAt
              });
            case 3:
              _yield$_this$getPosit4 = _context14.sent;
              positionsData = _yield$_this$getPosit4.positionsData;
              _context14.next = 7;
              return _this.getPositionsConstants();
            case 7:
              _yield$_this$getPosit5 = _context14.sent;
              minCollateralUsd = _yield$_this$getPosit5.minCollateralUsd;
              if (!(!marketsInfoData || !tokensData || !positionsData || !minCollateralUsd)) {
                _context14.next = 11;
                break;
              }
              return _context14.abrupt("return", {
                isLoading: true
              });
            case 11:
              positionsInfoData = Object.keys(positionsData).reduce(function (acc, positionKey) {
                var position = getByKey(positionsData, positionKey);
                var marketInfo = getByKey(marketsInfoData, position === null || position === void 0 ? void 0 : position.marketAddress);
                var indexToken = marketInfo === null || marketInfo === void 0 ? void 0 : marketInfo.indexToken;
                var pnlToken = position.isLong ? marketInfo === null || marketInfo === void 0 ? void 0 : marketInfo.longToken : marketInfo === null || marketInfo === void 0 ? void 0 : marketInfo.shortToken;
                var collateralToken = getByKey(tokensData, position.collateralTokenAddress);
                if (!marketInfo || !indexToken || !pnlToken || !collateralToken) {
                  return acc;
                }
                var markPrice = getMarkPrice({
                  prices: indexToken.prices,
                  isLong: position.isLong,
                  isIncrease: false
                });
                var collateralMinPrice = collateralToken.prices.minPrice;
                var entryPrice = getEntryPrice({
                  sizeInTokens: position.sizeInTokens,
                  sizeInUsd: position.sizeInUsd,
                  indexToken: indexToken
                });
                var pendingFundingFeesUsd = convertToUsd(position.fundingFeeAmount, collateralToken.decimals, collateralToken.prices.minPrice);
                var pendingClaimableFundingFeesLongUsd = convertToUsd(position.claimableLongTokenAmount, marketInfo.longToken.decimals, marketInfo.longToken.prices.minPrice);
                var pendingClaimableFundingFeesShortUsd = convertToUsd(position.claimableShortTokenAmount, marketInfo.shortToken.decimals, marketInfo.shortToken.prices.minPrice);
                var pendingClaimableFundingFeesUsd = pendingClaimableFundingFeesLongUsd === null || pendingClaimableFundingFeesLongUsd === void 0 ? void 0 : pendingClaimableFundingFeesLongUsd.add(pendingClaimableFundingFeesShortUsd);
                var totalPendingFeesUsd = getPositionPendingFeesUsd({
                  pendingBorrowingFeesUsd: position.pendingBorrowingFeesUsd,
                  pendingFundingFeesUsd: pendingFundingFeesUsd
                });
                var closingPriceImpactDeltaUsd = getPriceImpactForPosition(marketInfo, position.sizeInUsd.mul(-1), position.isLong, {
                  fallbackToZero: true
                });
                var positionFeeInfo = getPositionFee(marketInfo, position.sizeInUsd, closingPriceImpactDeltaUsd.gt(0), undefined);
                var closingFeeUsd = positionFeeInfo.positionFeeUsd;
                var collateralUsd = convertToUsd(position.collateralAmount, collateralToken.decimals, collateralMinPrice);
                var remainingCollateralUsd = collateralUsd.sub(totalPendingFeesUsd);
                var remainingCollateralAmount = convertToTokenAmount(remainingCollateralUsd, collateralToken.decimals, collateralMinPrice);
                var pnl = getPositionPnlUsd({
                  marketInfo: marketInfo,
                  sizeInUsd: position.sizeInUsd,
                  sizeInTokens: position.sizeInTokens,
                  markPrice: markPrice,
                  isLong: position.isLong
                });
                var pnlPercentage = collateralUsd && !collateralUsd.eq(0) ? getBasisPoints(pnl, collateralUsd) : BigNumber.from(0);
                var netValue = getPositionNetValue({
                  collateralUsd: collateralUsd,
                  pnl: pnl,
                  pendingBorrowingFeesUsd: position.pendingBorrowingFeesUsd,
                  pendingFundingFeesUsd: pendingFundingFeesUsd,
                  closingFeeUsd: closingFeeUsd
                });
                var pnlAfterFees = pnl.sub(totalPendingFeesUsd).sub(closingFeeUsd);
                var pnlAfterFeesPercentage = !collateralUsd.eq(0) ? getBasisPoints(pnlAfterFees, collateralUsd.add(closingFeeUsd)) : BigNumber.from(0);
                var leverage = getLeverage({
                  sizeInUsd: position.sizeInUsd,
                  collateralUsd: collateralUsd,
                  pnl: undefined,
                  pendingBorrowingFeesUsd: position.pendingBorrowingFeesUsd,
                  pendingFundingFeesUsd: pendingFundingFeesUsd
                });
                var hasLowCollateral = (leverage === null || leverage === void 0 ? void 0 : leverage.gt(MAX_ALLOWED_LEVERAGE)) || false;
                var liquidationPrice = getLiquidationPrice({
                  marketInfo: marketInfo,
                  collateralToken: collateralToken,
                  sizeInUsd: position.sizeInUsd,
                  sizeInTokens: position.sizeInTokens,
                  collateralUsd: collateralUsd,
                  collateralAmount: position.collateralAmount,
                  userReferralInfo: undefined,
                  minCollateralUsd: minCollateralUsd,
                  pendingBorrowingFeesUsd: position.pendingBorrowingFeesUsd,
                  pendingFundingFeesUsd: pendingFundingFeesUsd,
                  isLong: position.isLong
                });
                acc[positionKey] = _objectSpread$6(_objectSpread$6({}, position), {}, {
                  marketInfo: marketInfo,
                  indexToken: indexToken,
                  collateralToken: collateralToken,
                  pnlToken: pnlToken,
                  markPrice: markPrice,
                  entryPrice: entryPrice,
                  liquidationPrice: liquidationPrice,
                  collateralUsd: collateralUsd,
                  remainingCollateralUsd: remainingCollateralUsd,
                  remainingCollateralAmount: remainingCollateralAmount,
                  hasLowCollateral: hasLowCollateral,
                  leverage: leverage,
                  pnl: pnl,
                  pnlPercentage: pnlPercentage,
                  pnlAfterFees: pnlAfterFees,
                  pnlAfterFeesPercentage: pnlAfterFeesPercentage,
                  netValue: netValue,
                  closingFeeUsd: closingFeeUsd,
                  pendingFundingFeesUsd: pendingFundingFeesUsd,
                  pendingClaimableFundingFeesUsd: pendingClaimableFundingFeesUsd
                });
                return acc;
              }, {});
              return _context14.abrupt("return", {
                positionsInfoData: positionsInfoData,
                isLoading: false
              });
            case 13:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      return function (_x9) {
        return _ref25.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getGasLimits", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
      var _yield$runMulticall4, data;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return runMulticall(_this.chainId, 'useGasLimitsConfig', _this.library, {
              key: [],
              refreshInterval: 60000,
              request: function request() {
                return {
                  dataStore: {
                    contractAddress: getContract({
                      chainId: _this.chainId,
                      name: 'DataStore'
                    }) || '',
                    abi: DataStoreAbi,
                    calls: {
                      depositSingleToken: {
                        methodName: 'getUint',
                        params: [depositGasLimitKey(true)]
                      },
                      depositMultiToken: {
                        methodName: 'getUint',
                        params: [depositGasLimitKey(false)]
                      },
                      withdrawalMultiToken: {
                        methodName: 'getUint',
                        params: [withdrawalGasLimitKey()]
                      },
                      singleSwap: {
                        methodName: 'getUint',
                        params: [singleSwapGasLimitKey()]
                      },
                      swapOrder: {
                        methodName: 'getUint',
                        params: [swapOrderGasLimitKey()]
                      },
                      increaseOrder: {
                        methodName: 'getUint',
                        params: [increaseOrderGasLimitKey()]
                      },
                      decreaseOrder: {
                        methodName: 'getUint',
                        params: [decreaseOrderGasLimitKey()]
                      },
                      estimatedFeeBaseGasLimit: {
                        methodName: 'getUint',
                        params: [ESTIMATED_GAS_FEE_BASE_AMOUNT]
                      },
                      estimatedFeeMultiplierFactor: {
                        methodName: 'getUint',
                        params: [ESTIMATED_GAS_FEE_MULTIPLIER_FACTOR]
                      }
                    }
                  }
                };
              },
              parseResponse: function parseResponse(res) {
                var results = res.data.dataStore;
                return {
                  depositSingleToken: BigNumber.from(results.depositSingleToken.returnValues[0]),
                  depositMultiToken: BigNumber.from(results.depositMultiToken.returnValues[0]),
                  withdrawalMultiToken: BigNumber.from(results.withdrawalMultiToken.returnValues[0]),
                  singleSwap: BigNumber.from(results.singleSwap.returnValues[0]),
                  swapOrder: BigNumber.from(results.swapOrder.returnValues[0]),
                  increaseOrder: BigNumber.from(results.increaseOrder.returnValues[0]),
                  decreaseOrder: BigNumber.from(results.decreaseOrder.returnValues[0]),
                  estimatedFeeBaseGasLimit: BigNumber.from(results.estimatedFeeBaseGasLimit.returnValues[0]),
                  estimatedFeeMultiplierFactor: BigNumber.from(results.estimatedFeeMultiplierFactor.returnValues[0])
                };
              }
            });
          case 2:
            _yield$runMulticall4 = _context15.sent;
            data = _yield$runMulticall4.data;
            return _context15.abrupt("return", {
              gasLimits: data
            });
          case 5:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    })));
    _defineProperty(_assertThisInitialized(_this), "getPositionsConstants", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
      var _yield$runMulticall5, data;
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return runMulticall(_this.chainId, 'usePositionsConstants', _this.library, {
              key: [],
              refreshInterval: 60000,
              request: {
                dataStore: {
                  contractAddress: getContract({
                    chainId: _this.chainId,
                    name: 'DataStore'
                  }) || '',
                  abi: DataStoreAbi,
                  calls: {
                    minCollateralUsd: {
                      methodName: 'getUint',
                      params: [MIN_COLLATERAL_USD_KEY]
                    },
                    minPositionSizeUsd: {
                      methodName: 'getUint',
                      params: [MIN_POSITION_SIZE_USD_KEY]
                    }
                  }
                }
              },
              parseResponse: function parseResponse(res) {
                return {
                  minCollateralUsd: BigNumber.from(res.data.dataStore.minCollateralUsd.returnValues[0]),
                  minPositionSizeUsd: BigNumber.from(res.data.dataStore.minPositionSizeUsd.returnValues[0])
                };
              }
            });
          case 2:
            _yield$runMulticall5 = _context16.sent;
            data = _yield$runMulticall5.data;
            return _context16.abrupt("return", data || {});
          case 5:
          case "end":
            return _context16.stop();
        }
      }, _callee16);
    })));
    _defineProperty(_assertThisInitialized(_this), "getGasPrice", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
      var provider, executionFeeBufferBps, gasPrice, buffer;
      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            provider = _this.library;
            executionFeeBufferBps = '1000';
            _context17.prev = 2;
            _context17.next = 5;
            return provider.getGasPrice();
          case 5:
            gasPrice = _context17.sent;
            // if (executionFeeConfig.shouldUseMaxPriorityFeePerGas) {
            //   const feeData = await provider.getFeeData()

            //   // the wallet provider might not return maxPriorityFeePerGas in feeData
            //   // in which case we should fallback to the usual getGasPrice flow handled below
            //   if (feeData && feeData.maxPriorityFeePerGas) {
            //     gasPrice = gasPrice.add(feeData.maxPriorityFeePerGas)
            //   }
            // }

            // if (settings.executionFeeBufferBps) {
            //   const buffer = gasPrice.mul(settings.executionFeeBufferBps).div(BASIS_POINTS_DIVISOR)
            //   gasPrice = gasPrice.add(buffer)
            // }
            // const premium = GAS_PRICE_ADJUSTMENT_MAP[chainId] || BigNumber.from(0)

            if (executionFeeBufferBps) {
              buffer = gasPrice.mul(executionFeeBufferBps).div(BASIS_POINTS_DIVISOR);
              gasPrice = gasPrice.add(buffer);
            }
            return _context17.abrupt("return", gasPrice);
          case 10:
            _context17.prev = 10;
            _context17.t0 = _context17["catch"](2);
            // eslint-disable-next-line no-console
            console.error(_context17.t0);
            return _context17.abrupt("return");
          case 14:
          case "end":
            return _context17.stop();
        }
      }, _callee17, null, [[2, 10]]);
    })));
    _defineProperty(_assertThisInitialized(_this), "getOrdersInfo", /*#__PURE__*/function () {
      var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref29) {
        var account, marketsInfoData, tokensData, _yield$_this$getOrder, ordersData, wrappedToken, ordersInfoData;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              account = _ref29.account, marketsInfoData = _ref29.marketsInfoData, tokensData = _ref29.tokensData;
              _context18.next = 3;
              return _this.getOrders({
                account: account
              });
            case 3:
              _yield$_this$getOrder = _context18.sent;
              ordersData = _yield$_this$getOrder.ordersData;
              wrappedToken = getWrappedToken(_this.chainId);
              if (!(!marketsInfoData || !ordersData || !tokensData)) {
                _context18.next = 8;
                break;
              }
              return _context18.abrupt("return", {
                isLoading: true
              });
            case 8:
              ordersInfoData = Object.keys(ordersData).filter(function (orderKey) {
                return isVisibleOrder(ordersData[orderKey].orderType);
              }).reduce(function (acc, orderKey) {
                var order = getByKey(ordersData, orderKey);
                var orderInfo = getOrderInfo(marketsInfoData, tokensData, wrappedToken, order);
                if (!orderInfo) {
                  // eslint-disable-next-line no-console
                  console.warn("OrderInfo parsing error", JSON.stringify(order));
                  return acc;
                }
                acc[orderKey] = orderInfo;
                return acc;
              }, {});
              return _context18.abrupt("return", {
                ordersInfoData: ordersInfoData,
                isLoading: false
              });
            case 10:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }));
      return function (_x10) {
        return _ref30.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getOrders", /*#__PURE__*/function () {
      var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(_ref31) {
        var account, _ref33, data;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              account = _ref31.account;
              _context19.next = 3;
              return runMulticall(_this.chainId, 'useOrdersData', _this.library, {
                key: account ? [account] : null,
                request: function request() {
                  return {
                    dataStore: {
                      contractAddress: getContract({
                        chainId: _this.chainId,
                        name: 'DataStore'
                      }) || '',
                      abi: DataStoreAbi,
                      calls: {
                        count: {
                          methodName: 'getBytes32Count',
                          params: [accountOrderListKey(account)]
                        },
                        keys: {
                          methodName: 'getBytes32ValuesAt',
                          params: [accountOrderListKey(account), 0, DEFAULT_COUNT]
                        }
                      }
                    },
                    reader: {
                      contractAddress: getContract({
                        chainId: _this.chainId,
                        name: 'SyntheticsReader'
                      }) || '',
                      abi: SyntheticsReaderAbi,
                      calls: {
                        orders: {
                          methodName: 'getAccountOrders',
                          params: [getContract({
                            chainId: _this.chainId,
                            name: 'DataStore'
                          }), account, 0, DEFAULT_COUNT]
                        }
                      }
                    }
                  };
                },
                parseResponse: function parseResponse(res) {
                  var count = Number(res.data.dataStore.count.returnValues[0]);
                  var orderKeys = res.data.dataStore.keys.returnValues;
                  var orders = res.data.reader.orders.returnValues;
                  return {
                    count: count,
                    ordersData: orders.reduce(function (acc, order, i) {
                      var key = orderKeys[i];
                      var data = order.data;
                      acc[key] = {
                        key: key,
                        account: order.addresses.account,
                        receiver: order.addresses.receiver,
                        callbackContract: order.addresses.callbackContract,
                        marketAddress: order.addresses.market,
                        initialCollateralTokenAddress: order.addresses.initialCollateralToken,
                        swapPath: order.addresses.swapPath,
                        sizeDeltaUsd: BigNumber.from(order.numbers.sizeDeltaUsd),
                        initialCollateralDeltaAmount: BigNumber.from(order.numbers.initialCollateralDeltaAmount),
                        contractTriggerPrice: BigNumber.from(order.numbers.triggerPrice),
                        contractAcceptablePrice: BigNumber.from(order.numbers.acceptablePrice),
                        executionFee: BigNumber.from(order.numbers.executionFee),
                        callbackGasLimit: BigNumber.from(order.numbers.callbackGasLimit),
                        minOutputAmount: BigNumber.from(order.numbers.minOutputAmount),
                        updatedAtBlock: BigNumber.from(order.numbers.updatedAtBlock),
                        isLong: order.flags.isLong,
                        shouldUnwrapNativeToken: order.flags.shouldUnwrapNativeToken,
                        isFrozen: order.flags.isFrozen,
                        orderType: order.numbers.orderType,
                        decreasePositionSwapType: order.numbers.decreasePositionSwapType,
                        data: data
                      };
                      return acc;
                    }, {})
                  };
                }
              });
            case 3:
              _ref33 = _context19.sent;
              data = _ref33.data;
              return _context19.abrupt("return", {
                ordersData: data === null || data === void 0 ? void 0 : data.ordersData
              });
            case 6:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }));
      return function (_x11) {
        return _ref32.apply(this, arguments);
      };
    }());
    return _this;
  }
  return _createClass(GMXHelper);
}(Config);

var gmxHelper$1 = new GMXHelper({
  chainId: '42161'
});
var ClosePositionMulticall = createPlugin({
  protocol: 'GMX',
  type: 'ACTION',
  method: 'multicall',
  name: 'closePositionMulticall',
  supportedContracts: exchangeRouterContracts,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        value: new FctValue({
          readonly: true
        }),
        receiveToken: new FctAddress({
          destination: 'erc20',
          mode: 'INPUT',
          options: TOKENS[Number(chainId)].filter(function (token) {
            return !token.isSynthetic;
          })
        }),
        position: new FctString({
          mode: 'INPUT'
        }),
        methodParams: {
          data: new FctBytesList({
            readonly: true
          })
        }
      },
      output: {
        results: new FctBytesList({})
      }
    };
  },
  setValuesAsync: function () {
    var _setValuesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var chainId, account, input, provider, tokensData, marketsInfo, positonsInfo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            chainId = _ref2.chainId, account = _ref2.account, input = _ref2.input, provider = _ref2.provider;
            gmxHelper$1.setLibrary({
              chainId: chainId,
              provider: provider,
              account: account
            });
            _context.next = 4;
            return gmxHelper$1.getTokensData();
          case 4:
            tokensData = _context.sent;
            _context.next = 7;
            return gmxHelper$1.getMarketsInfo();
          case 7:
            marketsInfo = _context.sent;
            if (tokensData.tokensData && tokensData.pricesUpdatedAt) {
              gmxHelper$1.tokensData = tokensData;
            }
            gmxHelper$1.marketsInfo = marketsInfo === null || marketsInfo === void 0 ? void 0 : marketsInfo.marketsInfoData;
            _context.next = 12;
            return gmxHelper$1.getPositionsInfo({
              marketsInfoData: marketsInfo === null || marketsInfo === void 0 ? void 0 : marketsInfo.marketsInfoData,
              tokensData: tokensData.tokensData,
              pricesUpdatedAt: tokensData.pricesUpdatedAt
            });
          case 12:
            positonsInfo = _context.sent;
            if (positonsInfo !== null && positonsInfo !== void 0 && positonsInfo.positionsInfoData) {
              _context.next = 15;
              break;
            }
            return _context.abrupt("return");
          case 15:
            if (input) input.position.options = Object.keys(positonsInfo.positionsInfoData).map(function (key) {
              var _positonsInfo$positio = positonsInfo.positionsInfoData[key],
                marketInfo = _positonsInfo$positio.marketInfo,
                indexToken = _positonsInfo$positio.indexToken,
                entryPrice = _positonsInfo$positio.entryPrice,
                collateralToken = _positonsInfo$positio.collateralToken,
                liquidationPrice = _positonsInfo$positio.liquidationPrice,
                leverage = _positonsInfo$positio.leverage,
                closingFeeUsd = _positonsInfo$positio.closingFeeUsd;
              var shortToken = marketInfo.shortToken,
                longToken = marketInfo.longToken;
              return {
                value: key,
                marketAddress: marketInfo.marketTokenAddress,
                logoURI: indexToken.logoURI,
                name: "".concat(indexToken.symbol, " / USD"),
                indexToken: indexToken.symbol,
                longToken: longToken.symbol,
                shortToken: shortToken.symbol,
                collateralToken: collateralToken.symbol,
                entryPrice: entryPrice === null || entryPrice === void 0 ? void 0 : entryPrice.toString(),
                liquidationPrice: liquidationPrice === null || liquidationPrice === void 0 ? void 0 : liquidationPrice.toString(),
                leverage: leverage === null || leverage === void 0 ? void 0 : leverage.toString(),
                closingFeeUsd: closingFeeUsd === null || closingFeeUsd === void 0 ? void 0 : closingFeeUsd.toString()
              };
            });
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function setValuesAsync(_x) {
      return _setValuesAsync.apply(this, arguments);
    }
    return setValuesAsync;
  }(),
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref3) {
    var chainId = _ref3.chainId,
      input = _ref3.input,
      account = _ref3.account,
      provider = _ref3.provider;
    if (gmxHelper$1.chainId !== Number(chainId) || gmxHelper$1.account !== account) {
      gmxHelper$1.setLibrary({
        chainId: chainId,
        provider: provider,
        account: account
      });
    }
    var helper = gmxHelper$1;
    var getClosePositionParams = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var closingPositionKey, receiveTokenAddress, closeAmountsParams;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              closingPositionKey = input.position.value;
              receiveTokenAddress = input.receiveToken.value;
              if (closingPositionKey) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return");
            case 4:
              if (receiveTokenAddress) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return");
            case 6:
              if (!(typeof closingPositionKey !== 'string')) {
                _context2.next = 9;
                break;
              }
              console.error("position should be string value");
              return _context2.abrupt("return");
            case 9:
              if (!(typeof receiveTokenAddress !== 'string')) {
                _context2.next = 12;
                break;
              }
              console.error("receiveToken should be string value");
              return _context2.abrupt("return");
            case 12:
              _context2.next = 14;
              return helper.getClosePositionParams({
                closingPositionKey: closingPositionKey,
                receiveTokenAddress: receiveTokenAddress
                // marketsInfoData: marketsInfo?.marketsInfoData,
                // tokensData: tokenData.tokensData,
                // pricesUpdatedAt: tokenData.pricesUpdatedAt,
              });
            case 14:
              closeAmountsParams = _context2.sent;
              if (closeAmountsParams) {
                _context2.next = 17;
                break;
              }
              return _context2.abrupt("return", {
                params: {
                  value: undefined,
                  methodParams: {
                    data: undefined
                  }
                },
                error: 'get close amount params error'
              });
            case 17:
              return _context2.abrupt("return", {
                params: {
                  value: closeAmountsParams.totalWntAmount,
                  methodParams: {
                    data: closeAmountsParams.encodedPayload
                  }
                },
                error: undefined
              });
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function getClosePositionParams() {
        return _ref4.apply(this, arguments);
      };
    }();
    return {
      get: getClosePositionParams,
      depParamKeys: ['receiveToken', 'position']
    };
  }
});

var gmxHelper = new GMXHelper({
  chainId: '42161'
});
var IncreasePositionMulticall = createPlugin({
  protocol: 'GMX',
  type: 'ACTION',
  method: 'multicall',
  name: 'increasePositionMulticall',
  supportedContracts: exchangeRouterContracts,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        value: new FctValue({
          readonly: true
        }),
        market: new FctAddress({
          mode: 'INPUT'
        }),
        payToken: new FctAddress({
          destination: 'erc20',
          mode: 'INPUT',
          options: TOKENS[Number(chainId)].filter(function (token) {
            return !token.isSynthetic;
          })
        }),
        payAmount: new FctValue({
          mode: 'INPUT'
        }),
        getToken: new FctAddress({
          destination: 'erc20',
          mode: 'INPUT',
          options: TOKENS[Number(chainId)],
          readonly: true
        }),
        getAmount: new FctValue({
          mode: 'INPUT'
        }),
        collateralIn: new FctAddress({
          mode: 'INPUT'
        }),
        tradeType: new FctString({
          mode: 'INPUT',
          options: [{
            value: TradeType.Long,
            name: 'Long'
          }, {
            value: TradeType.Short,
            name: 'Short'
          }]
        }),
        methodParams: {
          data: new FctBytesList({
            readonly: true
          })
        }
      },
      output: {
        results: new FctBytesList({})
      }
    };
  },
  setValuesAsync: function () {
    var _setValuesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var chainId, account, input, provider, tokensData, marketsInfo, allMarkets, bestMarkets;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            chainId = _ref2.chainId, account = _ref2.account, input = _ref2.input, provider = _ref2.provider;
            gmxHelper.setLibrary({
              chainId: chainId,
              provider: provider,
              account: account
            });
            _context.next = 4;
            return gmxHelper.getTokensData();
          case 4:
            tokensData = _context.sent;
            _context.next = 7;
            return gmxHelper.getMarketsInfo();
          case 7:
            marketsInfo = _context.sent;
            if (tokensData.tokensData && tokensData.pricesUpdatedAt) {
              gmxHelper.tokensData = tokensData;
            }
            gmxHelper.marketsInfo = marketsInfo === null || marketsInfo === void 0 ? void 0 : marketsInfo.marketsInfoData;
            if (marketsInfo !== null && marketsInfo !== void 0 && marketsInfo.marketsInfoData) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return");
          case 12:
            if (input) {
              allMarkets = Object.keys(marketsInfo.marketsInfoData).filter(function (key) {
                var _marketsInfo$marketsI, _marketsInfo$marketsI2;
                return !((_marketsInfo$marketsI = marketsInfo.marketsInfoData[key]) !== null && _marketsInfo$marketsI !== void 0 && _marketsInfo$marketsI.isDisabled) && !((_marketsInfo$marketsI2 = marketsInfo.marketsInfoData[key]) !== null && _marketsInfo$marketsI2 !== void 0 && _marketsInfo$marketsI2.isSpotOnly);
              });
              bestMarkets = [];
              allMarkets.forEach(function (key) {
                //const { indexToken } = marketsInfo.marketsInfoData[key]
                // const availableMarkets = allMarkets.filter((market) =>
                //   isMarketIndexToken(marketsInfo.marketsInfoData[market], indexToken.value)
                // )

                // if (marketsAddressesSet.has(availableMarkets[0])) return
                // marketsAddressesSet.add(availableMarkets[0])
                var _marketsInfo$marketsI3 = marketsInfo.marketsInfoData[key],
                  indexToken = _marketsInfo$marketsI3.indexToken,
                  shortToken = _marketsInfo$marketsI3.shortToken,
                  longToken = _marketsInfo$marketsI3.longToken,
                  marketTokenAddress = _marketsInfo$marketsI3.marketTokenAddress;
                bestMarkets.push({
                  value: key,
                  logoURI: indexToken.logoURI,
                  name: "".concat(indexToken.symbol, " / USD, Pool: ").concat(longToken.symbol, "-").concat(shortToken.symbol),
                  marketAddress: marketTokenAddress,
                  indexToken: indexToken.symbol,
                  longToken: longToken.symbol,
                  shortToken: shortToken.symbol
                });
              });
              input.market.options = bestMarkets;
            }
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function setValuesAsync(_x) {
      return _setValuesAsync.apply(this, arguments);
    }
    return setValuesAsync;
  }(),
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref3) {
    var chainId = _ref3.chainId,
      input = _ref3.input,
      account = _ref3.account,
      provider = _ref3.provider;
    if (gmxHelper.chainId !== Number(chainId) || gmxHelper.account !== account) {
      gmxHelper.setLibrary({
        chainId: chainId,
        provider: provider,
        account: account
      });
    }
    var getIncreasePositionParams = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var payToken, market, payAmount, tradeType, collateralIn, marketsInfo, marketData, getToken, params, tradeTypeValue, increasePositionParams;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              payToken = input.payToken, market = input.market, payAmount = input.payAmount, tradeType = input.tradeType, collateralIn = input.collateralIn;
              if (market.value) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              if (!(typeof market.value !== 'string')) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              if (gmxHelper.marketsInfo) {
                _context2.next = 10;
                break;
              }
              _context2.next = 8;
              return gmxHelper.getMarketsInfo();
            case 8:
              marketsInfo = _context2.sent;
              gmxHelper.marketsInfo = marketsInfo === null || marketsInfo === void 0 ? void 0 : marketsInfo.marketsInfoData;
            case 10:
              marketData = gmxHelper.marketsInfo[market.value];
              getToken = marketData.indexTokenAddress;
              params = {
                params: {
                  getToken: getToken
                },
                error: undefined
              };
              collateralIn.options = [marketData.longToken, marketData.shortToken];
              if (!input.collateralIn.value || ![marketData.longToken.value, marketData.shortToken.value].includes(input.collateralIn.value)) {
                collateralIn.value = marketData.longToken.value;
              }
              if (payToken.value) {
                _context2.next = 17;
                break;
              }
              return _context2.abrupt("return", params);
            case 17:
              if (getToken) {
                _context2.next = 19;
                break;
              }
              return _context2.abrupt("return", params);
            case 19:
              if (payAmount.value) {
                _context2.next = 21;
                break;
              }
              return _context2.abrupt("return", params);
            case 21:
              if (tradeType.value) {
                _context2.next = 23;
                break;
              }
              return _context2.abrupt("return", params);
            case 23:
              if (!(typeof collateralIn.value !== 'string' || typeof payToken.value !== 'string' || typeof payAmount.value !== 'string' || typeof tradeType.value !== 'string')) {
                _context2.next = 26;
                break;
              }
              console.error("wrong param type");
              return _context2.abrupt("return", params);
            case 26:
              tradeTypeValue = tradeType.value;
              _context2.next = 29;
              return gmxHelper.getIncreasePositionParams({
                fromTokenAddress: payToken.value,
                toTokenAddress: getToken,
                fromTokenAmount: payAmount.value,
                toTokenAmount: '0',
                tradeType: tradeTypeValue,
                tradeMode: TradeMode.Market,
                marketAddress: market.value,
                collateralInToken: collateralIn.value || marketData.longToken.value
              });
            case 29:
              increasePositionParams = _context2.sent;
              if (increasePositionParams) {
                _context2.next = 32;
                break;
              }
              return _context2.abrupt("return", {
                params: {
                  value: undefined,
                  getToken: undefined,
                  methodParams: {
                    data: undefined
                  }
                },
                error: 'get increase amount params error'
              });
            case 32:
              return _context2.abrupt("return", {
                params: {
                  value: increasePositionParams.totalWntAmount.toString(),
                  getToken: params.params.getToken,
                  methodParams: {
                    data: increasePositionParams.encodedPayload
                  }
                },
                error: undefined
              });
            case 33:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function getIncreasePositionParams() {
        return _ref4.apply(this, arguments);
      };
    }();
    return {
      get: getIncreasePositionParams,
      depParamKeys: ['payToken', 'payAmount', 'getToken', 'market', 'tradeType', 'collateralIn']
    };
  }
});

// import { CancelDeposit } from './actions/CancelDeposit'
var actions$b = {
  // CancelDeposit,
  // CancelOrder,
  // CancelWithdrawal,
  // ClaimAffiliateRewards,
  // ClaimCollateral,
  // ClaimFundingFees,
  // ClaimUiFees,
  // CreateDeposit,
  // CreateOrder,
  // CreateWithdrawal,
  // Multicall,
  // SendTokens,
  // SendWnt,
  // SetSavedCallbackContract,
  // SetUiFeeFactor,
  // SimulateExecuteDeposit,
  // SimulateExecuteOrder,
  // SimulateExecuteWithdrawal,
  // UpdateOrder,
  ClosePositionMulticall: ClosePositionMulticall,
  IncreasePositionMulticall: IncreasePositionMulticall
};
var getters$9 = {
  // DataStore,
  // DepositHandler,
  // EventEmitter,
  // OrderHandler,
  // RoleStore,
  // Router,
  // WithdrawalHandler,
  // GetMarkets,
};
var GMX = {
  actions: actions$b,
  getters: getters$9
};

var Erc20AirdropCSV = createPlugin({
  protocol: 'KIROBO_MULTICALL_CSV',
  type: 'LIBRARY',
  toEns: '@lib:multicall',
  method: 'erc20Airdrop',
  name: 'erc20AirdropCSV',
  supportedContracts: kiroboMulticallContracts,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          token: new FctAddress({
            options: getSupportedTokens({
              chainId: chainId
            })
          }),
          from: new FctAddress({}),
          amount: new FctValue({}),
          recipients: new FctAddressList({})
        }
      },
      output: {}
    };
  },
  requiredApprovals: function requiredApprovals(params, _chainId, _walletAddress, vaultAddress) {
    var methodParams = params.methodParams;
    if (!vaultAddress) return [];
    var address = methodParams.from.value;
    if (vaultAddress && vaultAddress.toLowerCase() === address.toLowerCase()) return [];
    var tokenRecipients = methodParams.recipients.value;
    var tokenAmount = methodParams.amount.value;
    if (!tokenAmount) return [];
    if (!tokenRecipients) return [];
    if (!('length' in tokenRecipients)) return [];
    var amountToSend = BigNumber.from(tokenAmount).mul(tokenRecipients.length);
    if (!amountToSend || !amountToSend.toString() || amountToSend.lte('0')) return [];
    return [{
      to: methodParams.token.value,
      from: methodParams.from.value,
      params: {
        spender: vaultAddress,
        amount: amountToSend.toString()
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  beforeSimulate: function () {
    var _beforeSimulate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var _provider$signer;
      var input, provider, chainId, methodParams, tokenRecipients, tokenAmount, amountToSend, contractAddress, tokenAddress, contract;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            input = _ref2.input, provider = _ref2.provider, chainId = _ref2.chainId;
            methodParams = input.methodParams;
            tokenRecipients = methodParams.recipients.value;
            tokenAmount = methodParams.amount.value;
            if (tokenAmount) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return");
          case 6:
            if (tokenRecipients) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return");
          case 8:
            if ('length' in tokenRecipients) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return");
          case 10:
            amountToSend = BigNumber.from(tokenAmount).mul(tokenRecipients.length);
            contractAddress = kiroboMulticallSimulateContracts[chainId];
            tokenAddress = methodParams.token.value;
            if (tokenAddress) {
              _context.next = 15;
              break;
            }
            return _context.abrupt("return");
          case 15:
            contract = new Contract(tokenAddress, erc20Abi, provider === null || provider === void 0 ? void 0 : provider.signer);
            _context.next = 18;
            return provider === null || provider === void 0 ? void 0 : (_provider$signer = provider.signer) === null || _provider$signer === void 0 ? void 0 : _provider$signer.sendTransaction({
              to: contractAddress,
              value: '1' + '0'.repeat(3)
            });
          case 18:
            _context.next = 20;
            return contract['approve'](contractAddress, amountToSend.toString(), {});
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function beforeSimulate(_x) {
      return _beforeSimulate.apply(this, arguments);
    }
    return beforeSimulate;
  }(),
  estimateGasOnParams: function estimateGasOnParams(input, method, chainId) {
    // Gas notes:
    // 1st recipient 32000
    // every next recipient 27000

    var recipients = input.methodParams.recipients;
    if (!recipients.value || !recipients.value.length) {
      return '10000';
    }
    var gas = BigNumber.from(32000);
    var everyNextCall = BigNumber.from(27000);
    if (recipients.value.length > 1) {
      gas = gas.add(everyNextCall.mul(recipients.value.length - 1));
    }
    if (chainId === '42161' || chainId === '421613') {
      gas = gas.mul(13);
    }
    return gas.toString();
  }
});

//  'transfers_tuple[]': new FctTupleArray({ tupleParamsSchema:{ to: new FctAddressList({ key: 'to'}), amount: new FctValueList({ key: 'amount'})  } }),
// {
//   token: new FctAddress({}),
//   spender: new FctAddress({}),
//   amount: new FctValue({}),
// }
var Erc20ApprovalsCSV = createPlugin({
  protocol: 'KIROBO_MULTICALL_CSV',
  type: 'LIBRARY',
  toEns: '@lib:multicall',
  method: 'erc20Approvals',
  name: 'erc20ApprovalsCSV',
  supportedContracts: kiroboMulticallContracts,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          'approvals_tuple[]': new FctTupleArray({
            params: {
              token: new FctAddressList({
                options: getSupportedTokens({
                  chainId: chainId
                })
              }),
              spender: new FctAddressList({}),
              amount: new FctValueList({})
            }
          })
        }
      },
      output: {}
    };
  },
  estimateGasOnParams: function estimateGasOnParams(params, method, chainId) {
    // Gas notes:
    // 1 approve = 34000 gas

    var approvals_tuple = params.methodParams['approvals_tuple[]'];
    if (!approvals_tuple.value || !Array.isArray(approvals_tuple.value)) {
      return '10000';
    }
    var gas = BigNumber.from(approvals_tuple.value.length).mul(34000);
    if (chainId === '42161' || chainId === '421613') {
      gas = gas.mul(13);
    }
    return gas.toString();
  }
});

var Erc20MonoTransfersCSV = createPlugin({
  protocol: 'KIROBO_MULTICALL_CSV',
  type: 'LIBRARY',
  toEns: '@lib:multicall',
  method: 'erc20MonoTransfers',
  name: 'erc20MonoTransfersCSV',
  supportedContracts: kiroboMulticallContracts,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          token: new FctAddress({
            options: getSupportedTokens({
              chainId: chainId
            })
          }),
          from: new FctAddress({}),
          'transfers_tuple[]': new FctTupleArray({
            params: {
              to: new FctAddressList({}),
              amount: new FctValueList({})
            }
          })
        }
      },
      output: {}
    };
  },
  requiredApprovals: function requiredApprovals(params, _chainId, _walletAddress, vaultAddress) {
    var _params$methodParams$;
    var _params$methodParams = params.methodParams,
      from = _params$methodParams.from,
      token = _params$methodParams.token;
    if (!vaultAddress) return [];
    var address = from.value;
    if (vaultAddress && vaultAddress.toLowerCase() === address.toLowerCase()) return [];
    var tokenValues = (_params$methodParams$ = params.methodParams['transfers_tuple[]'].params.amount) === null || _params$methodParams$ === void 0 ? void 0 : _params$methodParams$.value;
    if (!tokenValues) return [];
    if (!('length' in tokenValues)) return [];
    var amountToSend = BigNumber.from('0');
    tokenValues.forEach(function (amount) {
      amountToSend = amountToSend.add(amount);
    });
    if (!amountToSend || !amountToSend.toString() || amountToSend.lte('0')) return [];
    return [{
      to: token.value,
      from: from.value,
      params: {
        spender: vaultAddress,
        amount: amountToSend.toString()
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  beforeSimulate: function () {
    var _beforeSimulate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var _methodParams$transfe, _provider$signer;
      var input, provider, chainId, methodParams, tokenValues, amountToSend, contractAddress, tokenAddress, contract;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            input = _ref2.input, provider = _ref2.provider, chainId = _ref2.chainId;
            methodParams = input.methodParams;
            tokenValues = (_methodParams$transfe = methodParams['transfers_tuple[]'].params.amount) === null || _methodParams$transfe === void 0 ? void 0 : _methodParams$transfe.value;
            if (tokenValues) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return");
          case 5:
            if ('length' in tokenValues) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return");
          case 7:
            amountToSend = BigNumber.from('0');
            tokenValues.forEach(function (amount) {
              amountToSend = amountToSend.add(amount);
            });
            contractAddress = kiroboMulticallSimulateContracts[chainId];
            _context.next = 12;
            return provider === null || provider === void 0 ? void 0 : (_provider$signer = provider.signer) === null || _provider$signer === void 0 ? void 0 : _provider$signer.sendTransaction({
              to: contractAddress,
              value: '1' + '0'.repeat(3)
            });
          case 12:
            tokenAddress = methodParams.token.value;
            if (tokenAddress) {
              _context.next = 15;
              break;
            }
            return _context.abrupt("return");
          case 15:
            contract = new Contract(tokenAddress, erc20Abi, provider === null || provider === void 0 ? void 0 : provider.signer); //const res = await contract['transfer'](contractAddress, amountToSend.toString(), {})
            _context.next = 18;
            return contract['approve'](contractAddress, amountToSend.toString(), {});
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function beforeSimulate(_x) {
      return _beforeSimulate.apply(this, arguments);
    }
    return beforeSimulate;
  }(),
  estimateGasOnParams: function estimateGasOnParams(params, method, chainId) {
    // Gas notes:
    // 35k first
    // 28k every next

    var transfers = params.methodParams['transfers_tuple[]'];
    if (!transfers.value || !Array.isArray(transfers.value)) {
      return '10000';
    }
    var gas = BigNumber.from(35000);
    if (transfers.value.length > 1) {
      gas = gas.add(BigNumber.from(transfers.value.length - 1).mul(BigNumber.from(28000)));
    }
    if (chainId === '42161' || chainId === '421613') {
      gas = gas.mul(BigNumber.from(13));
    }
    return gas.toString();
  }
});

var Erc20TransfersCSV = createPlugin({
  protocol: 'KIROBO_MULTICALL_CSV',
  type: 'LIBRARY',
  toEns: '@lib:multicall',
  method: 'erc20Transfers',
  name: 'erc20TransfersCSV',
  supportedContracts: kiroboMulticallContracts,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          'transfers_tuple[]': new FctTupleArray({
            params: {
              name: new FctCustomArray({
                virtual: true,
                required: false
              }),
              token: new FctAddressList({
                options: getSupportedTokens({
                  chainId: chainId
                })
              }),
              from: new FctAddressList({}),
              to: new FctAddressList({}),
              amount: new FctValueList({}),
              reason: new FctCustomArray({
                virtual: true,
                required: false
              })
            }
          })
        }
      },
      output: {}
    };
  },
  requiredApprovals: function requiredApprovals(params, _chainId, _walletAddress, vaultAddress) {
    params.to;
      var methodParams = params.methodParams;
    if (!vaultAddress) return [];
    var value = methodParams['transfers_tuple[]'].value;
    var tokensToApprove = {};
    value === null || value === void 0 ? void 0 : value.forEach(function (nestedParam) {
      var fromParam = nestedParam.find(function (param) {
        return param.name === 'from';
      });
      var tokenParam = nestedParam.find(function (param) {
        return param.name === 'token';
      });
      var amountParam = nestedParam.find(function (param) {
        return param.name === 'amount';
      });
      if (!(fromParam !== null && fromParam !== void 0 && fromParam.value)) return;
      if (!tokenParam) return;
      if (vaultAddress && vaultAddress.toLowerCase() === fromParam.value.toLowerCase()) return;
      if (!tokensToApprove[tokenParam.value]) {
        tokensToApprove[tokenParam.value] = {
          amount: BigNumber.from((amountParam === null || amountParam === void 0 ? void 0 : amountParam.value) || '0'),
          from: fromParam === null || fromParam === void 0 ? void 0 : fromParam.value
        };
        return;
      }
      tokensToApprove[tokenParam.value].amount = tokensToApprove[tokenParam.value].amount.add((amountParam === null || amountParam === void 0 ? void 0 : amountParam.value) || '0');
      return;
    });
    return Object.keys(tokensToApprove).map(function (tokenToApproveAddress) {
      var token = tokensToApprove[tokenToApproveAddress];
      return {
        to: tokenToApproveAddress,
        from: token.from,
        params: {
          spender: vaultAddress,
          amount: token.amount.toString()
        },
        method: 'approve',
        protocol: 'ERC20'
      };
    });
  },
  beforeSimulate: function () {
    var _beforeSimulate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
      var _provider$signer;
      var input, provider, chainId, methodParams, contractAddress, value, tokensToSend, multiApproveParams;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            input = _ref2.input, provider = _ref2.provider, chainId = _ref2.chainId;
            methodParams = input.methodParams;
            contractAddress = kiroboMulticallSimulateContracts[chainId];
            _context2.next = 5;
            return provider === null || provider === void 0 ? void 0 : (_provider$signer = provider.signer) === null || _provider$signer === void 0 ? void 0 : _provider$signer.sendTransaction({
              to: contractAddress,
              value: '1' + '0'.repeat(3)
            });
          case 5:
            value = methodParams['transfers_tuple[]'].value;
            tokensToSend = {};
            value === null || value === void 0 ? void 0 : value.forEach(function (nestedParam) {
              var tokenParam = nestedParam.find(function (param) {
                return param.name === 'token';
              });
              var amountParam = nestedParam.find(function (param) {
                return param.name === 'amount';
              });
              if (!tokenParam) return;
              if (!tokensToSend[tokenParam.value]) {
                return tokensToSend[tokenParam.value] = BigNumber.from((amountParam === null || amountParam === void 0 ? void 0 : amountParam.value) || '0');
              }
              return tokensToSend[tokenParam.value] = tokensToSend[tokenParam.value].add((amountParam === null || amountParam === void 0 ? void 0 : amountParam.value) || '0');
            });
            _context2.next = 10;
            return Promise.all(Object.keys(tokensToSend).map( /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
                var tokenContract;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      tokenContract = new Contract(key, erc20Abi, provider === null || provider === void 0 ? void 0 : provider.signer);
                      console.log({
                        token: key,
                        anount: tokensToSend[key].toString()
                      });
                      _context.next = 4;
                      return tokenContract['approve'](contractAddress, tokensToSend[key].toString(), {});
                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x2) {
                return _ref3.apply(this, arguments);
              };
            }()));
          case 10:
            multiApproveParams = [];
            multiApproveParams.push(value === null || value === void 0 ? void 0 : value.map(function (nestedParam) {
              return nestedParam.map(function (p) {
                if (p.name === 'token') return p.value;
                if (p.name === 'to') return contractAddress;
                if (p.name === 'amount') return p.value;
                return;
              }).filter(Boolean);
            }));
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function beforeSimulate(_x) {
      return _beforeSimulate.apply(this, arguments);
    }
    return beforeSimulate;
  }(),
  estimateGasOnParams: function estimateGasOnParams(params, method, chainId) {
    // Gas notes:
    // 36k per transfer

    var transfers = params.methodParams['transfers_tuple[]'];
    if (!transfers.value || !Array.isArray(transfers.value)) {
      return '10000';
    }
    var gas = BigNumber.from(transfers.value.length).mul(120000);
    if (chainId === '42161' || chainId === '421613') {
      gas = gas.mul(13);
    }
    return gas.toString();
  }
});

// {
//   to: new FctAddress({}),
//   value: new FctValue({}),
// }
var TrasnfersCSV = createPlugin({
  protocol: 'KIROBO_MULTICALL_CSV',
  type: 'LIBRARY',
  toEns: '@lib:multicall',
  method: 'trasnfers',
  name: 'trasnfersCSV',
  supportedContracts: kiroboMulticallContracts,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          'transfers_tuple[]': new FctTupleArray({
            params: {
              to: new FctAddressList({}),
              value: new FctValueList({})
            }
          })
        }
      },
      output: {}
    };
  },
  estimateGasOnParams: function estimateGasOnParams(params, method, chainId) {
    var transfers = params.methodParams['transfers_tuple[]'];
    if (!transfers.value || !Array.isArray(transfers.value)) {
      return '10000';
    }
    var gas = BigNumber.from(transfers.value.length).mul(36000);
    if (chainId === '42161' || chainId === '421613') {
      gas = gas.mul(13);
    }
    return gas.toString();
  }
});

var MultiAllowanceCSV = createPlugin({
  protocol: 'KIROBO_MULTICALL_CSV',
  type: 'LIBRARY:VIEWONLY',
  toEns: '@lib:multicall',
  method: 'multiAllowance',
  name: 'multiAllowanceCSV',
  supportedContracts: kiroboMulticallContracts,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          'allowances_tuple[]': new FctTupleArray({
            params: {
              token: new FctAddressList({
                options: getSupportedTokens({
                  chainId: chainId
                })
              }),
              owner: new FctAddressList({}),
              spender: new FctAddressList({})
            }
          })
        }
      },
      output: {
        allowances: new FctValueList({})
      }
    };
  }
});

var MultiBalanceCSV = createPlugin({
  protocol: 'KIROBO_MULTICALL_CSV',
  type: 'LIBRARY:VIEWONLY',
  toEns: '@lib:multicall',
  method: 'multiBalance',
  name: 'multiBalanceCSV',
  supportedContracts: kiroboMulticallContracts,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          'balances_tuple[]': new FctTupleArray({
            params: {
              token: new FctAddressList({
                options: getSupportedTokens({
                  chainId: chainId
                })
              }),
              account: new FctAddressList({})
            }
          })
        }
      },
      output: {
        balances: new FctValueList({})
      }
    };
  },
  estimateGasOnParams: function estimateGasOnParams(params, method, chainId) {
    var balances = params.methodParams['balances_tuple[]'];
    if (!balances.value || !Array.isArray(balances.value)) {
      return '10000';
    }
    var gas = BigNumber.from(balances.value.length).mul(BigNumber.from(7000));
    if (chainId === '42161' || chainId === '421613') {
      gas = gas.mul(BigNumber.from(13));
    }
    return gas.toString();
  }
});

var actions$a = {
  Erc20AirdropCSV: Erc20AirdropCSV,
  Erc20ApprovalsCSV: Erc20ApprovalsCSV,
  Erc20MonoTransfersCSV: Erc20MonoTransfersCSV,
  Erc20TransfersCSV: Erc20TransfersCSV,
  TrasnfersCSV: TrasnfersCSV
};
var getters$8 = {
  MultiAllowanceCSV: MultiAllowanceCSV,
  MultiBalanceCSV: MultiBalanceCSV
};
var KIROBO_MULTICALL_CSV = {
  actions: actions$a,
  getters: getters$8
};

var LIDO_STETH_TOKEN = [{
  address: '0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84',
  chainId: 1
}];

/* eslint-disable no-restricted-imports */
var Deposit$3 = createPlugin({
  protocol: 'LIDO',
  type: 'ACTION',
  method: 'submit',
  supportedContracts: LIDO_STETH_TOKEN,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        value: new FctValue({}),
        methodParams: {
          referral: new FctAddress({
            required: false
          })
        }
      },
      output: {}
    };
  },
  initParams: {
    methodParams: {
      referral: ethers.constants.AddressZero
    }
  }
});

/* eslint-disable no-restricted-imports */
var GetPooledEthByShares = createPlugin({
  protocol: 'LIDO',
  type: 'GETTER',
  method: 'getPooledEthByShares',
  supportedContracts: LIDO_STETH_TOKEN,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          shares: new FctValue18({})
        }
      },
      output: {
        ethAmount: new FctValue18({})
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var GetSharesByPooledETH = createPlugin({
  protocol: 'LIDO',
  type: 'GETTER',
  method: 'getSharesByPooledEth',
  supportedContracts: LIDO_STETH_TOKEN,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          ethAmount: new FctValue18({})
        }
      },
      output: {
        shares: new FctValue18({})
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var SharesOf = createPlugin({
  protocol: 'LIDO',
  type: 'GETTER',
  method: 'sharesOf',
  supportedContracts: LIDO_STETH_TOKEN,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          account: new FctAddress({})
        }
      },
      output: {
        shares: new FctValue18({})
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var actions$9 = {
  Deposit: Deposit$3
};
var getters$7 = {
  GetSharesByPooledETH: GetSharesByPooledETH,
  GetPooledEthByShares: GetPooledEthByShares,
  SharesOf: SharesOf
};
var Lido = {
  actions: actions$9,
  getters: getters$7
};

var BuyOnUniswapV2Fork = createPlugin({
  protocol: 'PARASWAP',
  type: 'ACTION',
  method: 'buyOnUniswapV2Fork',
  supportedContracts: [{
    address: '0xDEF171Fe48CF0115B1d80b88dc8eAB59176FEe57',
    chainId: 1
  }],
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          tokenIn: new FctAddress({}),
          amountInMax: new FctValue({}),
          amountOut: new FctValue({}),
          weth: new FctAddress({}),
          pools: new FctValueList({})
        }
      },
      output: {}
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams = params.methodParams,
      tokenIn = _params$methodParams.tokenIn,
      amountInMax = _params$methodParams.amountInMax;
    return [{
      to: tokenIn.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: amountInMax.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var MegaSwap = createPlugin({
  protocol: 'PARASWAP',
  type: 'ACTION',
  method: 'megaSwap',
  supportedContracts: [{
    address: '0xDEF171Fe48CF0115B1d80b88dc8eAB59176FEe57',
    chainId: 1
  }],
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          megaSwapSellData_tuple: {
            fromToken: new FctAddress({}),
            fromAmount: new FctValue({}),
            toAmount: new FctValue({}),
            expectedAmount: new FctValue({}),
            beneficiary: new FctAddress({}),
            'megaSwapPath_tuple{}': {
              fromAmountPercent: new FctValue({}),
              'path_tuple{}': {
                to: new FctAddress({}),
                totalNetworkFee: new FctValue({}),
                'adapters_tuple{}': {
                  adapter: new FctAddress({}),
                  percent: new FctValue({}),
                  networkFee: new FctValue({}),
                  'route_tuple{}': {
                    index: new FctValue({}),
                    targetExchange: new FctAddress({}),
                    percent: new FctValue({}),
                    payload: new FctBytes({}),
                    networkFee: new FctValue({})
                  }
                }
              }
            },
            partner: new FctAddress({}),
            feePercent: new FctValue({}),
            permit: new FctBytes({}),
            deadline: new FctValue({})
          }
        }
      },
      output: {
        undefined: new FctValue({})
      }
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams$ = params.methodParams['megaSwapSellData_tuple'],
      fromToken = _params$methodParams$.fromToken,
      fromAmount = _params$methodParams$.fromAmount;
    return [{
      to: fromToken.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: fromAmount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var MultiSwap = createPlugin({
  protocol: 'PARASWAP',
  type: 'ACTION',
  method: 'multiSwap',
  supportedContracts: [{
    address: '0xDEF171Fe48CF0115B1d80b88dc8eAB59176FEe57',
    chainId: 1
  }],
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          sellData_tuple: {
            fromToken: new FctAddress({}),
            fromAmount: new FctValue({}),
            toAmount: new FctValue({}),
            expectedAmount: new FctValue({}),
            beneficiary: new FctAddress({}),
            'path_tuple{}': {
              to: new FctAddress({}),
              totalNetworkFee: new FctValue({}),
              'adapters_tuple{}': {
                adapter: new FctAddress({}),
                percent: new FctValue({}),
                networkFee: new FctValue({}),
                'route_tuple{}': {
                  index: new FctValue({}),
                  targetExchange: new FctAddress({}),
                  percent: new FctValue({}),
                  payload: new FctBytes({}),
                  networkFee: new FctValue({})
                }
              }
            },
            partner: new FctAddress({}),
            feePercent: new FctValue({}),
            permit: new FctBytes({}),
            deadline: new FctValue({})
          }
        }
      },
      output: {
        undefined: new FctValue({})
      }
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams$ = params.methodParams['sellData_tuple'],
      fromToken = _params$methodParams$.fromToken,
      fromAmount = _params$methodParams$.fromAmount;
    return [{
      to: fromToken.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: fromAmount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var SimpleBuy = createPlugin({
  protocol: 'PARASWAP',
  type: 'ACTION',
  method: 'simpleBuy',
  supportedContracts: [{
    address: '0xDEF171Fe48CF0115B1d80b88dc8eAB59176FEe57',
    chainId: 1
  }],
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          simpleData_tuple: {
            fromToken: new FctAddress({}),
            toToken: new FctAddress({}),
            fromAmount: new FctValue({}),
            toAmount: new FctValue({}),
            expectedAmount: new FctValue({}),
            callees: new FctAddressList({}),
            exchangeData: new FctBytes({}),
            startIndexes: new FctValueList({}),
            values: new FctValueList({}),
            beneficiary: new FctAddress({}),
            partner: new FctAddress({}),
            feePercent: new FctValue({}),
            permit: new FctBytes({}),
            deadline: new FctValue({})
          }
        }
      },
      output: {}
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams$ = params.methodParams['simpleData_tuple'],
      fromToken = _params$methodParams$.fromToken,
      fromAmount = _params$methodParams$.fromAmount;
    return [{
      to: fromToken.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: fromAmount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

/* eslint-disable no-restricted-imports */
var SimpleSwap = createPlugin({
  protocol: 'PARASWAP',
  type: 'ACTION',
  method: 'simpleSwap',
  supportedContracts: [{
    address: '0xDEF171Fe48CF0115B1d80b88dc8eAB59176FEe57',
    chainId: 1
  }],
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          simpleData_tuple: {
            fromToken: new FctAddress({}),
            toToken: new FctAddress({}),
            fromAmount: new FctValue({}),
            toAmount: new FctValue({}),
            expectedAmount: new FctValue({}),
            callees: new FctAddressList({}),
            exchangeData: new FctBytes({}),
            startIndexes: new FctValueList({}),
            values: new FctValueList({}),
            beneficiary: new FctAddress({}),
            partner: new FctAddress({}),
            feePercent: new FctValue({}),
            permit: new FctBytes({}),
            deadline: new FctValue({})
          }
        }
      },
      output: {
        receivedAmount: new FctValue({})
      }
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams$ = params.methodParams['simpleData_tuple'],
      fromToken = _params$methodParams$.fromToken,
      fromAmount = _params$methodParams$.fromAmount;
    return [{
      to: fromToken.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: fromAmount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var SwapOnUniswapV2Fork = createPlugin({
  protocol: 'PARASWAP',
  type: 'ACTION',
  method: 'swapOnUniswapV2Fork',
  supportedContracts: [{
    address: '0xDEF171Fe48CF0115B1d80b88dc8eAB59176FEe57',
    chainId: 1
  }],
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({
          destination: 'paraswap_swapper_v5'
        }),
        value: new FctValue({
          destination: 'wei_amount'
        }),
        methodParams: {
          tokenIn: new FctAddress({
            destination: 'erc20'
          }),
          amountIn: new FctValue({
            destination: 'wei_amount'
          }),
          amountOutMin: new FctValue({
            destination: 'wei_amount'
          }),
          weth: new FctAddress({}),
          pools: new FctValueList({})
        }
      },
      output: {}
    };
  },
  initParams: {},
  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams = params.methodParams,
      tokenIn = _params$methodParams.tokenIn,
      amountIn = _params$methodParams.amountIn;
    return [{
      to: tokenIn.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: amountIn.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var SwapOnZeroXv4 = createPlugin({
  protocol: 'PARASWAP',
  type: 'ACTION',
  method: 'swapOnZeroXv4',
  supportedContracts: [{
    address: '0xDEF171Fe48CF0115B1d80b88dc8eAB59176FEe57',
    chainId: 1
  }],
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          fromToken: new FctAddress({}),
          toToken: new FctAddress({}),
          fromAmount: new FctValue({}),
          amountOutMin: new FctValue({}),
          exchange: new FctAddress({}),
          payload: new FctBytes({})
        }
      },
      output: {}
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams = params.methodParams,
      fromToken = _params$methodParams.fromToken,
      fromAmount = _params$methodParams.fromAmount;
    return [{
      to: fromToken.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: fromAmount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var actions$8 = {
  BuyOnUniswapV2Fork: BuyOnUniswapV2Fork,
  MegaSwap: MegaSwap,
  MultiSwap: MultiSwap,
  SimpleBuy: SimpleBuy,
  SimpleSwap: SimpleSwap,
  SwapOnUniswapV2Fork: SwapOnUniswapV2Fork,
  SwapOnZeroXv4: SwapOnZeroXv4
};
var Paraswap = {
  actions: actions$8
};

var LENDING_POOL_ADDRESSES = [{
  address: '0xF4B1486DD74D07706052A33d31d7c0AAFD0659E1',
  chainId: 42161
}];
var PROTOCOL_DATA_PROVIDER_ADDRESSES = [{
  address: '0x596B0cc4c5094507C50b579a662FE7e7b094A2cC',
  chainId: 42161
}];
var PRICE_ORACLE_ADDRESSES = [{
  address: '0xC0cE5De939aaD880b0bdDcf9aB5750a53EDa454b',
  chainId: 42161
}];
var R_TOKENS = {
  1: [],
  5: [],
  42161: RadiantV2RTokens,
  421613: [],
  11155111: []
};

var Borrow = createPlugin({
  protocol: 'RADIANTV2',
  type: 'ACTION',
  method: 'borrow',
  supportedContracts: LENDING_POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'radiant_lending_pool_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getRadiantV2Tokens({
              chainId: chainId
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          interestRateMode: new FctValue({
            options: [{
              value: '1'
            }, {
              value: '2'
            }]
          }),
          referralCode: new FctValue16({}),
          onBehalfOf: new FctAddress({})
        }
      },
      output: {}
    };
  },
  initParams: {
    methodParams: {
      referralCode: '0'
    }
  },
  requiredApprovals: function requiredApprovals(params, chainId, _walletAddress, vaultAddress) {
    var _params$methodParams = params.methodParams,
      amount = _params$methodParams.amount,
      onBehalfOf = _params$methodParams.onBehalfOf,
      asset = _params$methodParams.asset;
    var assetValue = asset.value;
    if (assetValue && typeof assetValue != 'string') {
      return [];
    }
    var fromTokenData = R_TOKENS[chainId].find(function (token) {
      return token.underlying.toLowerCase() === assetValue.toLowerCase();
    });
    if (!fromTokenData) {
      return [];
    }
    if (!vaultAddress) return [];
    var value;
    if (typeof amount.value === 'string') {
      value = amount.value;
    }
    if (!value && typeof amount.estimatedValue === 'string') {
      value = amount.estimatedValue;
    }
    if (!value) return [];
    return [{
      to: fromTokenData.address,
      from: onBehalfOf.value,
      params: {
        delegatee: vaultAddress,
        amount: value
      },
      method: 'approveDelegation',
      protocol: 'RADIANTV2'
    }];
  }
});

var Deposit$2 = createPlugin({
  protocol: 'RADIANTV2',
  type: 'ACTION',
  method: 'deposit',
  supportedContracts: LENDING_POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'radiant_lending_pool_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getRadiantV2Tokens({
              chainId: chainId
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          onBehalfOf: new FctAddress({}),
          referralCode: new FctValue16({})
        }
      },
      output: {}
    };
  },
  initParams: {
    methodParams: {
      referralCode: '0'
    }
  },
  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams = params.methodParams,
      asset = _params$methodParams.asset,
      amount = _params$methodParams.amount,
      onBehalfOf = _params$methodParams.onBehalfOf;
    return [{
      to: asset.value,
      from: onBehalfOf.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: amount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var Repay = createPlugin({
  protocol: 'RADIANTV2',
  type: 'ACTION',
  method: 'repay',
  supportedContracts: LENDING_POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'radiant_lending_pool_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getRadiantV2Tokens({
              chainId: chainId
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          rateMode: new FctValue({
            options: [{
              value: '1'
            }, {
              value: '2'
            }]
          }),
          onBehalfOf: new FctAddress({})
        }
      },
      output: {
        value: new FctValue({
          innerIndex: 0
        })
      }
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams = params.methodParams,
      asset = _params$methodParams.asset,
      amount = _params$methodParams.amount,
      onBehalfOf = _params$methodParams.onBehalfOf;
    return [{
      to: asset.value,
      from: onBehalfOf.value,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: amount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var SwapBorrowRateMode = createPlugin({
  protocol: 'RADIANTV2',
  type: 'ACTION',
  method: 'swapBorrowRateMode',
  supportedContracts: LENDING_POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'radiant_lending_pool_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getRadiantV2Tokens({
              chainId: chainId
            })
          }),
          rateMode: new FctValue({
            options: [{
              value: '1',
              name: 'Stable'
            }, {
              value: '2',
              name: 'Variable'
            }]
          })
        }
      },
      output: {}
    };
  }
});

var Withdraw$2 = createPlugin({
  protocol: 'RADIANTV2',
  type: 'ACTION',
  method: 'withdraw',
  supportedContracts: LENDING_POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'radiant_lending_pool_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getRadiantV2Tokens({
              chainId: chainId
            })
          }),
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          to: new FctAddress({})
        }
      },
      output: {
        value: new FctValue({
          innerIndex: 0
        })
      }
    };
  }
});

var GetAssetPrice = createPlugin({
  protocol: 'RADIANTV2',
  type: 'ORACLE',
  method: 'getAssetPrice',
  supportedContracts: PRICE_ORACLE_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          asset: new FctAddress({
            options: getRadiantV2Tokens({
              chainId: chainId
            })
          })
        }
      },
      output: {
        price: new FctValue18({
          innerIndex: 0
        })
      }
    };
  }
});

var GetAssetReserveData = createPlugin({
  protocol: 'RADIANTV2',
  type: 'GETTER',
  method: 'getReserveData',
  name: 'getAssetReserveData',
  supportedContracts: PROTOCOL_DATA_PROVIDER_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'aave_protocol_data_provider_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getRadiantV2Tokens({
              chainId: chainId
            })
          })
        }
      },
      output: {
        availableLiquidity: new FctValue({
          innerIndex: 0
        }),
        totalStableDebt: new FctValue({
          innerIndex: 1
        }),
        totalVariableDebt: new FctValue({
          innerIndex: 2
        }),
        supplyRate: new FctValue27({
          innerIndex: 3
        }),
        variableBorrowRate: new FctValue27({
          innerIndex: 4
        }),
        stableBorrowRate: new FctValue27({
          innerIndex: 5
        }),
        averageStableBorrowRate: new FctValue({
          innerIndex: 6
        }),
        liquidityIndex: new FctValue({
          innerIndex: 7
        }),
        variableBorrowIndex: new FctValue({
          innerIndex: 8
        }),
        lastUpdateTimestamp: new FctValue40({
          innerIndex: 9
        })
      }
    };
  }
});

var GetReserveConfigurationData = createPlugin({
  protocol: 'RADIANTV2',
  type: 'GETTER',
  method: 'getReserveConfigurationData',
  supportedContracts: PROTOCOL_DATA_PROVIDER_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'radiant_protocol_data_provider_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getRadiantV2Tokens({
              chainId: chainId
            })
          })
        }
      },
      output: {
        decimals: new FctDecimals({
          innerIndex: 0
        }),
        ltv: new FctBps({
          innerIndex: 1
        }),
        liquidationThreshold: new FctBps({
          innerIndex: 2
        }),
        liquidationBonus: new FctValue({
          innerIndex: 3
        }),
        reserveFactor: new FctValue({
          innerIndex: 4
        }),
        usageAsCollateralEnabled: new FctBoolean({
          innerIndex: 5
        }),
        borrowingEnabled: new FctBoolean({
          innerIndex: 6
        }),
        stableBorrowRateEnabled: new FctBoolean({
          innerIndex: 7
        }),
        isActive: new FctBoolean({
          innerIndex: 8
        }),
        isFrozen: new FctBoolean({
          innerIndex: 9
        })
      }
    };
  }
});

// Get reserve data response
var GetReserveData = createPlugin({
  protocol: 'RADIANTV2',
  type: 'GETTER',
  method: 'getReserveData',
  supportedContracts: LENDING_POOL_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'radiant_lending_pool_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getRadiantV2Tokens({
              chainId: chainId
            })
          })
        }
      },
      output: {
        configuration: new FctValue({
          innerIndex: 0
        }),
        liquidityIndex: new FctValue128({
          innerIndex: 1
        }),
        variableBorrowIndex: new FctValue128({
          innerIndex: 2
        }),
        currentLiquidityRate: new FctValue128({
          innerIndex: 3
        }),
        currentVariableBorrowRate: new FctValue128({
          innerIndex: 4
        }),
        currentStableBorrowRate: new FctValue128({
          innerIndex: 5
        }),
        lastUpdateTimestamp: new FctValue40({
          innerIndex: 6
        }),
        aTokenAddress: new FctAddress({
          innerIndex: 7
        }),
        stableDebtTokenAddress: new FctAddress({
          innerIndex: 8
        }),
        variableDebtTokenAddress: new FctAddress({
          innerIndex: 9
        }),
        interestRateStrategyAddress: new FctAddress({
          innerIndex: 10
        }),
        id: new FctValue8({
          innerIndex: 11
        })
      }
    };
  }
});

var GetReserveTokensAddresses = createPlugin({
  protocol: 'RADIANTV2',
  type: 'GETTER',
  method: 'getReserveTokensAddresses',
  supportedContracts: PROTOCOL_DATA_PROVIDER_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'radiant_lending_pool_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getRadiantV2Tokens({
              chainId: chainId
            })
          })
        }
      },
      output: {
        aTokenAddress: new FctAddress({
          innerIndex: 0
        }),
        stableDebtTokenAddress: new FctAddress({
          innerIndex: 1
        }),
        variableDebtTokenAddress: new FctAddress({
          innerIndex: 2
        })
      }
    };
  }
});

var GetUserAccountData = createPlugin({
  protocol: 'RADIANTV2',
  type: 'GETTER',
  method: 'getUserAccountData',
  supportedContracts: LENDING_POOL_ADDRESSES,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({
          destination: 'radiant_lending_pool_v2'
        }),
        methodParams: {
          user: new FctAddress({})
        }
      },
      output: {
        totalCollateralETH: new FctValue18({
          innerIndex: 0
        }),
        totalDebtETH: new FctValue18({
          innerIndex: 1
        }),
        availableBorrowsETH: new FctValue18({
          innerIndex: 2
        }),
        currentLiquidationThreshold: new FctBps({
          innerIndex: 3
        }),
        ltv: new FctBps({
          innerIndex: 4
        }),
        healthFactor: new FctValue18({
          innerIndex: 5
        })
      }
    };
  }
});

var GetUserReserveData = createPlugin({
  protocol: 'RADIANTV2',
  type: 'GETTER',
  method: 'getUserReserveData',
  supportedContracts: PROTOCOL_DATA_PROVIDER_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'radiant_protocol_data_provider_v2'
        }),
        methodParams: {
          asset: new FctAddress({
            destination: 'erc20',
            options: getRadiantV2Tokens({
              chainId: chainId
            })
          }),
          user: new FctAddress({})
        }
      },
      output: {
        currentATokenBalance: new FctValue18({
          innerIndex: 0
        }),
        currentStableDebt: new FctValue18({
          innerIndex: 1
        }),
        currentVariableDebt: new FctValue18({
          innerIndex: 2
        }),
        principalStableDebt: new FctValue18({
          innerIndex: 3
        }),
        scaledVariableDebt: new FctValue18({
          innerIndex: 4
        }),
        stableBorrowRate: new FctValue27({
          innerIndex: 5
        }),
        liquidityRate: new FctValue27({
          innerIndex: 6
        }),
        stableRateLastUpdated: new FctValue40({
          innerIndex: 7
        }),
        usageAsCollateralEnabled: new FctBoolean({
          innerIndex: 8
        })
      }
    };
  },
  initParams: {
    to: '0x057835Ad21a177dbdd3090bB1CAE03EaCF78Fc6d'
  }
});

var ApyBetween = createPlugin({
  protocol: 'RADIANTV2',
  type: 'VALIDATOR',
  method: 'between',
  name: 'apyBetween',
  description: 'Check if a value is between two numbers',
  supportedContracts: supportedContracts$2,
  onCreate: function onCreate(_ref) {
    _ref.chainId;
      var input = _ref.input;
    input.rateValue.subscribe({
      callback: function callback(_ref2) {
        var value = _ref2.value;
        input.methodParams.value.set({
          value: value
        });
      },
      id: 'change_value1_on_rateValue_change'
    });
    input.methodParams.value.set({
      value: input.rateValue.value
    });
    var setValue = function setValue(_ref3) {
      var value = _ref3.value,
        param = _ref3.param;
      if (!value) {
        param.set({
          value: undefined
        });
        return;
      }
      if (input.minApyValue.isVariable) {
        console.error('should be real value');
        return;
      }
      var rate = getAssetRateByApy({
        apy: value
      });
      param.set({
        value: rate.rate
      });
    };
    input.minApyValue.subscribe({
      callback: function callback(_ref4) {
        var value = _ref4.value;
        setValue({
          value: value,
          param: input.methodParams.minValue
        });
      },
      id: 'change_minValue_on_minApyValue_change'
    });
    setValue({
      value: input.minApyValue.value,
      param: input.methodParams.minValue
    });
    input.maxApyValue.subscribe({
      callback: function callback(_ref5) {
        var value = _ref5.value;
        setValue({
          value: value,
          param: input.methodParams.maxValue
        });
      },
      id: 'change_maxValue_on_maxApyValue_change'
    });
    setValue({
      value: input.maxApyValue.value,
      param: input.methodParams.maxValue
    });
  },
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        rateValue: new FctValue27({
          mode: 'VARIABLE'
        }),
        minApyValue: new FctPercent({
          destination: 'percent',
          mode: 'INPUT'
        }),
        maxApyValue: new FctPercent({
          destination: 'percent',
          mode: 'INPUT'
        }),
        methodParams: {
          minValue: new FctValue({
            readonly: true
          }),
          maxValue: new FctValue({
            readonly: true
          }),
          value: new FctValue({
            readonly: true
          })
        }
      },
      output: {
        value: new FctValue({
          innerIndex: 0,
          description: 'Result of minValue subtraction from value'
        })
      }
    };
  },
  validate: function validate(params, errors) {
    var minValue = params.methodParams.minValue.value;
    var maxValue = params.methodParams.maxValue.value;
    if (_typeof(minValue) === 'object') return true;
    if (_typeof(maxValue) === 'object') return true;
    var minValueBN = BigNumber.from(minValue);
    var maxValueBN = BigNumber.from(maxValue);
    if (minValueBN.gt(maxValueBN)) {
      errors.set('minValue', ERRORS.RANGE_ERROR);
      return false;
    }
    errors.delete('minValue');
    return true;
  }
});

/* eslint-disable no-restricted-imports */
var ApyGreaterThan = createPlugin({
  protocol: 'RADIANTV2',
  type: 'VALIDATOR',
  method: 'greaterThan',
  name: 'apyGreaterThan',
  description: 'Check if a value is greater than a number',
  supportedContracts: supportedContracts$2,
  onCreate: function onCreate(_ref) {
    _ref.chainId;
      var input = _ref.input;
    input.rateValue.subscribe({
      callback: function callback(_ref2) {
        var value = _ref2.value;
        input.methodParams.value1.set({
          value: value
        });
      },
      id: 'change_value1_on_rateValue_change'
    });
    input.methodParams.value1.set({
      value: input.rateValue.value
    });
    var setValue2 = function setValue2(_ref3) {
      var value = _ref3.value;
      if (!value) {
        input.methodParams.value2.set({
          value: undefined
        });
        return;
      }
      if (input.apyValue.isVariable) {
        console.error('should be real value');
        return;
      }
      var rate = getAssetRateByApy({
        apy: value
      });
      input.methodParams.value2.set({
        value: rate.rate
      });
    };
    input.apyValue.subscribe({
      callback: setValue2,
      id: 'change_value2_on_apyValue_change'
    });
    setValue2({
      value: input.apyValue.value
    });
  },
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        rateValue: new FctValue27({
          mode: 'VARIABLE'
        }),
        apyValue: new FctPercent({
          destination: 'percent',
          mode: 'INPUT'
        }),
        methodParams: {
          value1: new FctValue({
            readonly: true
          }),
          value2: new FctValue({
            readonly: true
          })
        }
      },
      output: {
        value: new FctValue({
          innerIndex: 0,
          description: 'Returns value2 subtraction from value1'
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var ApyLessThan = createPlugin({
  protocol: 'RADIANTV2',
  type: 'VALIDATOR',
  method: 'lessThan',
  description: 'Check if a value is less than a number',
  name: 'apyLessThan',
  supportedContracts: supportedContracts$2,
  onCreate: function onCreate(_ref) {
    _ref.chainId;
      var input = _ref.input;
    input.rateValue.subscribe({
      callback: function callback(_ref2) {
        var value = _ref2.value;
        input.methodParams.value1.set({
          value: value
        });
      },
      id: 'change_value1_on_rateValue_change'
    });
    input.methodParams.value1.set({
      value: input.rateValue.value
    });
    var setValue2 = function setValue2(_ref3) {
      var value = _ref3.value;
      if (!value) {
        input.methodParams.value2.set({
          value: undefined
        });
        return;
      }
      if (input.apyValue.isVariable) {
        console.error('should be real value');
        return;
      }
      var rate = getAssetRateByApy({
        apy: value
      });
      input.methodParams.value2.set({
        value: rate.rate
      });
    };
    input.apyValue.subscribe({
      callback: setValue2,
      id: 'change_value_on_apyValue_change'
    });
    setValue2({
      value: input.apyValue.value
    });
  },
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        rateValue: new FctValue27({
          mode: 'VARIABLE'
        }),
        apyValue: new FctPercent({
          destination: 'percent',
          mode: 'INPUT'
        }),
        methodParams: {
          value1: new FctValue({
            readonly: true
          }),
          value2: new FctValue({
            readonly: true
          })
        }
      },
      output: {
        value: new FctValue({
          innerIndex: 0,
          description: 'Returns value1 subtraction from value2'
        })
      }
    };
  }
});

var actions$7 = {
  Borrow: Borrow,
  Deposit: Deposit$2,
  Repay: Repay,
  Withdraw: Withdraw$2,
  SwapBorrowRateMode: SwapBorrowRateMode
};
var getters$6 = {
  GetUserAccountData: GetUserAccountData,
  GetReserveData: GetReserveData,
  GetUserReserveData: GetUserReserveData,
  GetReserveConfigurationData: GetReserveConfigurationData,
  GetAssetReserveData: GetAssetReserveData,
  GetReserveTokensAddresses: GetReserveTokensAddresses,
  GetAssetPrice: GetAssetPrice,
  ApyLessThan: ApyLessThan,
  ApyBetween: ApyBetween,
  ApyGreaterThan: ApyGreaterThan
};
var RadiantV2 = {
  actions: actions$7,
  getters: getters$6
};

var ROCKET_POOL_DEPOSIT_POOL = [{
  address: '0xDD3f50F8A6CafbE9b31a427582963f465E745AF8',
  chainId: 1
}];
var ROCKET_POOL_ERC20 = [{
  address: '0xae78736Cd615f374D3085123A210448E74Fc6393',
  chainId: 1
}];

/* eslint-disable no-restricted-imports */
var Deposit$1 = createPlugin({
  protocol: 'ROCKETPOOL',
  type: 'ACTION',
  method: 'deposit',
  name: 'stake',
  supportedContracts: ROCKET_POOL_DEPOSIT_POOL,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        value: new FctValue({}),
        methodParams: {}
      },
      output: {}
    };
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var _ROCKET_POOL_ERC20$fi;
    var to = params.to,
      value = params.value;
    if (!to.value || !value.value || !vaultAddress) return [];
    if (typeof to.value !== 'string' || typeof value.value !== 'string') return [];
    var rETH = (_ROCKET_POOL_ERC20$fi = ROCKET_POOL_ERC20.find(function (token) {
      return token.chainId === Number(chainId);
    })) === null || _ROCKET_POOL_ERC20$fi === void 0 ? void 0 : _ROCKET_POOL_ERC20$fi.address;
    if (!rETH) return [];
    return [{
      address: vaultAddress,
      toSpend: [{
        token: ethers.constants.AddressZero,
        amount: value.value
      }],
      toReceive: [{
        token: rETH,
        amount: value.value
      }]
    }];
  }
});

var _excluded$3 = ["amountOutMinimum"],
  _excluded2$3 = ["amountOutMinimum"];
function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SwapToRocketEth = createPlugin({
  protocol: 'ROCKETPOOL',
  type: 'ACTION',
  method: 'exactInput',
  name: 'swapToRocketEth',
  supportedContracts: SWAP_ROUTER_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        tokenIn: new FctAddress({
          mode: 'INPUT',
          destination: 'erc20',
          options: getSupportedTokens({
            chainId: chainId
          })
        }),
        amountIn: new FctValue({
          mode: 'INPUT',
          destination: 'wei_amount'
        }),
        tokenOut: new FctAddress({
          mode: 'INPUT',
          destination: 'erc20',
          readonly: true,
          options: [{
            chainId: 1,
            value: '0xae78736Cd615f374D3085123A210448E74Fc6393',
            name: 'Rocket Pool ETH',
            symbol: 'rETH',
            decimals: 18,
            logoURI: 'https://assets.coingecko.com/coins/images/20764/standard/reth.png?1696520159'
          }]
        }),
        amountOut: new FctValue({
          readonly: true,
          destination: 'wei_amount',
          required: false
        }),
        methodParams: {
          params_tuple: {
            tokenIn: new FctAddress({
              required: false,
              readonly: true,
              destination: 'erc20',
              options: getSupportedTokens({
                chainId: chainId
              })
            }),
            tokenOut: new FctAddress({
              required: false,
              readonly: true,
              destination: 'erc20',
              options: getSupportedTokens({
                chainId: chainId
              })
            }),
            fee: new FctValue24({
              required: false,
              readonly: true
            }),
            path: new FctBytes({
              required: false,
              readonly: true
            }),
            recipient: new FctAddress({
              mode: 'INPUT'
            }),
            deadline: new FctValue({
              mode: 'INPUT'
            }),
            amountIn: new FctValue({
              readonly: true,
              destination: 'wei_amount'
            }),
            amountOutMinimum: new FctValue({
              destination: 'wei_amount'
            }),
            sqrtPriceLimitX96: new FctValue160({
              required: false
            })
          }
        }
      },
      output: {
        amountOut: new FctValue({})
      }
    };
  },
  initParams: {
    tokenOut: '0xae78736Cd615f374D3085123A210448E74Fc6393',
    methodParams: {
      params_tuple: {
        deadline: {
          type: 'global',
          id: 'blockTimestamp'
        },
        amountOutMinimum: '0',
        sqrtPriceLimitX96: '0'
      }
    }
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref2) {
    _ref2.chainId;
      var input = _ref2.input;
      _ref2.provider;
      var setMethod = _ref2.setMethod;
      _ref2.account;
    var getPathParams = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
        var service, tokenInAddress, tokenOutAddress, defaultReturn, amountIn, amount, res, _input$methodParams$p, tokenIn, tokenOut, fee, sqrtPriceLimitX96, path, _res$params, _rest, _res$params2, amountOutMinimum, rest;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              service = _ref3.service;
              if (service) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              tokenInAddress = input === null || input === void 0 ? void 0 : input.tokenIn.value;
              tokenOutAddress = input === null || input === void 0 ? void 0 : input.tokenOut.value;
              defaultReturn = {
                params: {
                  amountIn: undefined,
                  methodParams: {
                    params_tuple: {
                      tokenIn: undefined,
                      tokenOut: undefined,
                      path: undefined,
                      amountInMaximum: undefined,
                      amountOut: undefined
                    }
                  }
                },
                error: undefined
              };
              if (!(!tokenInAddress || !tokenOutAddress || typeof tokenInAddress !== 'string' || typeof tokenOutAddress !== 'string')) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", defaultReturn);
            case 8:
              amountIn = input === null || input === void 0 ? void 0 : input.amountIn;
              if (amountIn) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return");
            case 11:
              amount = amountIn.value;
              if (!(amount === undefined)) {
                _context.next = 14;
                break;
              }
              return _context.abrupt("return", defaultReturn);
            case 14:
              if (amount) {
                _context.next = 16;
                break;
              }
              return _context.abrupt("return");
            case 16:
              _context.prev = 16;
              _context.next = 19;
              return service.create({
                cmd: 'simulateSwap',
                protocol: 'uniswap',
                token_in: tokenInAddress,
                token_in_decimals: 0,
                token_out: tokenOutAddress,
                token_out_decimals: 0,
                token_amount: amount,
                type: 'in',
                version: 'v3'
              });
            case 19:
              res = _context.sent;
              if (res) {
                _context.next = 22;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountOut: undefined,
                  methodParams: {
                    params_tuple: {
                      path: undefined,
                      amountOutMinimum: undefined
                    }
                  }
                },
                error: 'invalid trade'
              });
            case 22:
              _input$methodParams$p = input.methodParams.params_tuple, tokenIn = _input$methodParams$p.tokenIn, tokenOut = _input$methodParams$p.tokenOut, fee = _input$methodParams$p.fee, sqrtPriceLimitX96 = _input$methodParams$p.sqrtPriceLimitX96, path = _input$methodParams$p.path;
              if (res.params) {
                _context.next = 25;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountOut: undefined,
                  methodParams: {
                    params_tuple: {
                      path: undefined,
                      amountOutMinimum: undefined
                    }
                  }
                },
                error: 'invalid trade'
              });
            case 25:
              if (!(res.name === 'exactInputSingle')) {
                _context.next = 34;
                break;
              }
              if (setMethod) setMethod('exactInputSingle');
              tokenIn.virtual = false;
              tokenOut.virtual = false;
              fee.virtual = false;
              sqrtPriceLimitX96.virtual = false;
              path.virtual = true;
              _res$params = res === null || res === void 0 ? void 0 : res.params, _res$params.amountOutMinimum, _rest = _objectWithoutProperties(_res$params, _excluded$3);
              return _context.abrupt("return", {
                params: {
                  amountOut: res === null || res === void 0 ? void 0 : res.params.amountOutMinimum,
                  methodParams: {
                    params_tuple: _objectSpread$5(_objectSpread$5({}, _rest), {}, {
                      amountOutMinimum: '0' //swapPath?.amountOut,
                    })
                  }
                },

                error: undefined
              });
            case 34:
              if (!(res.name !== 'exactInput')) {
                _context.next = 36;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountOut: undefined,
                  methodParams: {
                    params_tuple: {
                      path: undefined,
                      amountOutMinimum: undefined
                    }
                  }
                },
                error: 'invalid trade'
              });
            case 36:
              if (setMethod) setMethod('exactInput');
              tokenIn.virtual = true;
              tokenOut.virtual = true;
              fee.virtual = true;
              sqrtPriceLimitX96.virtual = true;
              path.virtual = false;
              _res$params2 = res === null || res === void 0 ? void 0 : res.params, amountOutMinimum = _res$params2.amountOutMinimum, rest = _objectWithoutProperties(_res$params2, _excluded2$3);
              return _context.abrupt("return", {
                params: {
                  amountOut: amountOutMinimum,
                  methodParams: {
                    params_tuple: _objectSpread$5(_objectSpread$5({}, rest), {}, {
                      amountOutMinimum: '0'
                    })
                  }
                },
                error: undefined
              });
            case 46:
              _context.prev = 46;
              _context.t0 = _context["catch"](16);
              return _context.abrupt("return", {
                params: {
                  amountOut: undefined,
                  methodParams: {
                    params_tuple: {
                      path: undefined,
                      amountOutMinimum: undefined
                    }
                  }
                },
                error: _context.t0.message
              });
            case 49:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[16, 46]]);
      }));
      return function getPathParams(_x) {
        return _ref4.apply(this, arguments);
      };
    }();
    return {
      get: getPathParams,
      depParamKeys: ['tokenIn', 'tokenOut', 'amountIn']
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var tokenIn = params.tokenIn;
    if (!tokenIn.value || typeof tokenIn.value !== 'string') return [];
    var tokenToApprove = tokenIn.value;
    return [{
      to: tokenToApprove,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams['params_tuple'].amountIn.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  getSubscribtions: function getSubscribtions(_ref5) {
    _objectDestructuringEmpty(_ref5);
    return [{
      callback: function callback(params) {
        if (!params) return;
        if (!params.amountIn.value) return;
        params.methodParams.params_tuple.amountIn.setQuiet({
          value: params.amountIn.value
        });
        return;
      },
      id: 'set_amount_by_amountIn_id'
    }];
  }
});

/* eslint-disable no-restricted-imports */
var Withdraw$1 = createPlugin({
  protocol: 'ROCKETPOOL',
  type: 'ACTION',
  method: 'burn',
  name: 'unstake',
  supportedContracts: ROCKET_POOL_ERC20,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          amount: new FctValue18({})
        }
      },
      output: {}
    };
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      amount = params.methodParams.amount;
    if (!to.value || !amount.value || !vaultAddress) return [];
    if (typeof to.value !== 'string' || typeof amount.value !== 'string') return [];

    // TODO: cToken amount needs to be calculated off chain.
    return [{
      address: vaultAddress,
      toSpend: [{
        token: to.value,
        amount: amount.value
      }],
      toReceive: [{
        token: ethers.constants.AddressZero,
        amount: amount.value
      }]
    }];
  }
});

/* eslint-disable no-restricted-imports */
var GetCollateralRate = createPlugin({
  protocol: 'ROCKETPOOL',
  type: 'GETTER',
  method: 'getCollateralRate',
  supportedContracts: ROCKET_POOL_ERC20,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {}
      },
      output: {
        collateralRate: new FctValue18({})
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var GetEthValue = createPlugin({
  protocol: 'ROCKETPOOL',
  type: 'GETTER',
  method: 'getEthValue',
  supportedContracts: ROCKET_POOL_ERC20,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          rethAmount: new FctValue18({})
        }
      },
      output: {
        ethAmount: new FctValue18({})
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var GetExchangeRate = createPlugin({
  protocol: 'ROCKETPOOL',
  type: 'GETTER',
  method: 'getExchangeRate',
  supportedContracts: ROCKET_POOL_ERC20,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {}
      },
      output: {
        exchangeRate: new FctValue18({})
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var GetRethValue = createPlugin({
  protocol: 'ROCKETPOOL',
  type: 'GETTER',
  method: 'getRethValue',
  supportedContracts: ROCKET_POOL_ERC20,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          ethAmount: new FctValue18({})
        }
      },
      output: {
        rethAmount: new FctValue18({})
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var actions$6 = {
  Deposit: Deposit$1,
  Withdraw: Withdraw$1,
  SwapToRocketEth: SwapToRocketEth
};
var getters$5 = {
  GetExchangeRate: GetExchangeRate,
  GetRethValue: GetRethValue,
  GetEthValue: GetEthValue,
  GetCollateralRate: GetCollateralRate
};
var RocketPool = {
  actions: actions$6,
  getters: getters$5
};

var secureStorageAddresses = [{
  address: '0x039987486206d32aB55BE53c2748121a6559aAdE',
  chainId: 1
}, {
  address: '0x4FEe9fc300DFF6221e5911f296c4CaA3d23A7830',
  chainId: 5
}, {
  address: '0xF71396c6F168Dc1c213AA9433cB0E7C1e4B07964',
  chainId: 11155111
}];
var secureStorageAddressFrom = {
  '1': '0x039987486206d32aB55BE53c2748121a6559aAdE',
  '5': '0x4FEe9fc300DFF6221e5911f296c4CaA3d23A7830',
  '11155111': '0xF71396c6F168Dc1c213AA9433cB0E7C1e4B07964',
  '42161': '',
  '421613': ''
};

var Write_bytes = createPlugin({
  protocol: 'SECURE_STORAGE',
  type: 'ACTION',
  method: 'write_bytes',
  supportedContracts: secureStorageAddresses,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          key: new FctBytes32({
            messageType: 'stringOrBytes32'
          }),
          value: new FctBytes({
            messageType: 'stringOrBytes'
          })
        }
      },
      output: {}
    };
  }
});

var Write_bytes32 = createPlugin({
  protocol: 'SECURE_STORAGE',
  type: 'ACTION',
  method: 'write_bytes32',
  supportedContracts: secureStorageAddresses,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          key: new FctBytes32({
            messageType: 'stringOrBytes32'
          }),
          value: new FctBytes32({
            messageType: 'stringOrBytes32'
          })
        }
      },
      output: {}
    };
  }
});

var Write_fct_bytes = createPlugin({
  protocol: 'SECURE_STORAGE',
  type: 'ACTION',
  method: 'write_fct_bytes',
  supportedContracts: secureStorageAddresses,
  payerIndex: 0,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        from: new FctAddress({
          value: secureStorageAddressFrom[chainId],
          readonly: true
        }),
        methodParams: {
          key: new FctBytes32({
            messageType: 'stringOrBytes32'
          }),
          value: new FctBytes({
            messageType: 'stringOrBytes'
          })
        }
      },
      output: {}
    };
  }
});

var Write_fct_bytes32 = createPlugin({
  protocol: 'SECURE_STORAGE',
  type: 'ACTION',
  method: 'write_fct_bytes32',
  supportedContracts: secureStorageAddresses,
  payerIndex: 0,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        from: new FctAddress({
          value: secureStorageAddressFrom[chainId],
          readonly: true
        }),
        methodParams: {
          key: new FctBytes32({
            messageType: 'stringOrBytes32'
          }),
          value: new FctBytes32({
            messageType: 'stringOrBytes32'
          })
        }
      },
      output: {}
    };
  }
});

var Write_fct_uint256 = createPlugin({
  protocol: 'SECURE_STORAGE',
  type: 'ACTION',
  method: 'write_fct_uint256',
  supportedContracts: secureStorageAddresses,
  payerIndex: 0,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        from: new FctAddress({
          value: secureStorageAddressFrom[chainId],
          readonly: true
        }),
        methodParams: {
          key: new FctBytes32({
            messageType: 'stringOrBytes32'
          }),
          value: new FctValue({})
        }
      },
      output: {}
    };
  }
});

var Write_uint256 = createPlugin({
  protocol: 'SECURE_STORAGE',
  type: 'ACTION',
  method: 'write_uint256',
  supportedContracts: secureStorageAddresses,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          key: new FctBytes32({
            messageType: 'stringOrBytes32'
          }),
          value: new FctValue({})
        }
      },
      output: {}
    };
  }
});

var Read_bytes = createPlugin({
  protocol: 'SECURE_STORAGE',
  type: 'GETTER',
  method: 'read_bytes',
  supportedContracts: secureStorageAddresses,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          owner: new FctAddress({}),
          key: new FctBytes32({
            messageType: 'stringOrBytes32'
          })
        }
      },
      output: {
        value: new FctBytes({})
      }
    };
  }
});

var Read_bytes32 = createPlugin({
  protocol: 'SECURE_STORAGE',
  type: 'GETTER',
  method: 'read_bytes32',
  supportedContracts: secureStorageAddresses,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          owner: new FctAddress({}),
          key: new FctBytes32({
            messageType: 'stringOrBytes32'
          })
        }
      },
      output: {
        value: new FctBytes32({})
      }
    };
  }
});

var Read_fct_bytes = createPlugin({
  protocol: 'SECURE_STORAGE',
  type: 'GETTER',
  method: 'read_fct_bytes',
  supportedContracts: secureStorageAddresses,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          fctMsgHash: new FctBytes32({}),
          key: new FctBytes32({
            messageType: 'stringOrBytes32'
          })
        }
      },
      output: {
        value: new FctBytes({})
      }
    };
  },
  initParams: {
    methodParams: {
      fctMsgHash: {
        type: 'global',
        id: 'flowHash'
      }
    }
  }
});

var Read_fct_bytes32 = createPlugin({
  protocol: 'SECURE_STORAGE',
  type: 'GETTER',
  method: 'read_fct_bytes32',
  supportedContracts: secureStorageAddresses,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          fctMsgHash: new FctBytes32({}),
          key: new FctBytes32({
            messageType: 'stringOrBytes32'
          })
        }
      },
      output: {
        value: new FctBytes32({})
      }
    };
  },
  initParams: {
    methodParams: {
      fctMsgHash: {
        type: 'global',
        id: 'flowHash'
      }
    }
  }
});

var Read_fct_uint256 = createPlugin({
  protocol: 'SECURE_STORAGE',
  type: 'GETTER',
  method: 'read_fct_uint256',
  supportedContracts: secureStorageAddresses,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          fctMsgHash: new FctBytes32({}),
          key: new FctBytes32({
            messageType: 'stringOrBytes32'
          })
        }
      },
      output: {
        value: new FctValue({})
      }
    };
  },
  initParams: {
    methodParams: {
      fctMsgHash: {
        type: 'global',
        id: 'flowHash'
      }
    }
  }
});

var Read_uint256 = createPlugin({
  protocol: 'SECURE_STORAGE',
  type: 'GETTER',
  method: 'read_uint256',
  supportedContracts: secureStorageAddresses,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          owner: new FctAddress({}),
          key: new FctBytes32({
            messageType: 'stringOrBytes32'
          })
        }
      },
      output: {
        value: new FctValue({})
      }
    };
  }
});

var SupportsInterface = createPlugin({
  protocol: 'SECURE_STORAGE',
  type: 'GETTER',
  method: 'supportsInterface',
  supportedContracts: secureStorageAddresses,
  getParams: function getParams(_ref) {
    _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          interfaceId: new FctBytes4({})
        }
      },
      output: {
        isSupports: new FctBoolean({})
      }
    };
  }
});

var actions$5 = {
  Write_bytes: Write_bytes,
  Write_bytes32: Write_bytes32,
  Write_fct_bytes: Write_fct_bytes,
  Write_fct_bytes32: Write_fct_bytes32,
  Write_fct_uint256: Write_fct_uint256,
  Write_uint256: Write_uint256
};
var getters$4 = {
  Read_bytes: Read_bytes,
  Read_bytes32: Read_bytes32,
  Read_fct_bytes: Read_fct_bytes,
  Read_fct_bytes32: Read_fct_bytes32,
  Read_fct_uint256: Read_fct_uint256,
  Read_uint256: Read_uint256,
  SupportsInterface: SupportsInterface
};
var SecureStorage = {
  actions: actions$5,
  getters: getters$4
};

var supportedContracts$1 = [{
  address: '0x9b2343DF3d4b30b0Fed3C2105C094a76288defCB',
  chainId: 1
}, {
  address: '0x254fb98E8943faF0F732477c4dE6Af7a1Dd7fD2D',
  chainId: 5
}, {
  address: '0x78ca552EeA9338bf8f615339173920e3d3DfDca2',
  chainId: 42161
}, {
  address: '0xE947aBC17F8dF342b3535C3A18ac4101A5eAA24e',
  chainId: 421613
}, {
  address: '0x574F4cDAB7ec20E3A37BDE025260F0A2359503d6',
  chainId: 11155111
}];

var Add = createPlugin({
  protocol: 'TOKEN_MATH',
  type: 'CALCULATOR',
  method: 'add',
  description: 'Add amount1 and amount2',
  supportedContracts: supportedContracts$1,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          amount1: new FctValue({}),
          decimals1: new FctDecimals({}),
          amount2: new FctValue({}),
          decimals2: new FctDecimals({}),
          decimalsOut: new FctDecimals({})
        }
      },
      output: {
        result: new FctValue({
          innerIndex: 0
        })
      }
    };
  }
});

var Divide = createPlugin({
  protocol: 'TOKEN_MATH',
  type: 'CALCULATOR',
  method: 'div',
  description: 'Divide amount1 by amount2',
  supportedContracts: supportedContracts$1,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          amount1: new FctValue({}),
          decimals1: new FctDecimals({}),
          amount2: new FctValue({}),
          decimals2: new FctDecimals({}),
          decimalsOut: new FctDecimals({})
        }
      },
      output: {
        result: new FctValue({
          innerIndex: 0
        })
      }
    };
  }
});

var Mod = createPlugin({
  protocol: 'TOKEN_MATH',
  type: 'CALCULATOR',
  method: 'mod',
  description: 'Modulo amount1 and amount2',
  supportedContracts: supportedContracts$1,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          amount1: new FctValue({
            destination: 'wei_amount'
          }),
          decimals1: new FctDecimals({}),
          amount2: new FctValue({
            destination: 'wei_amount'
          }),
          decimals2: new FctDecimals({}),
          decimalsOut: new FctDecimals({})
        }
      },
      output: {
        result: new FctValue({
          innerIndex: 0
        })
      }
    };
  }
});

var Multiply = createPlugin({
  protocol: 'TOKEN_MATH',
  type: 'CALCULATOR',
  method: 'mul',
  description: 'Multiply amount1 and amount2',
  supportedContracts: supportedContracts$1,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          amount1: new FctValue({
            destination: 'wei_amount'
          }),
          decimals1: new FctDecimals({}),
          amount2: new FctValue({
            destination: 'wei_amount'
          }),
          decimals2: new FctDecimals({}),
          decimalsOut: new FctDecimals({})
        }
      },
      output: {
        result: new FctValue({
          innerIndex: 0
        })
      }
    };
  }
});

var MultiplyAndDivide = createPlugin({
  protocol: 'TOKEN_MATH',
  type: 'CALCULATOR',
  method: 'mulAndDiv',
  description: 'Multiply amount1 by amount2 and divide by amount3',
  supportedContracts: supportedContracts$1,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          amount1: new FctValue({
            destination: 'wei_amount'
          }),
          decimals1: new FctDecimals({}),
          amount2: new FctValue({
            destination: 'wei_amount'
          }),
          decimals2: new FctDecimals({}),
          amount3: new FctValue({
            destination: 'wei_amount'
          }),
          decimals3: new FctDecimals({}),
          decimalsOut: new FctDecimals({})
        }
      },
      output: {
        result: new FctValue({
          innerIndex: 0
        })
      }
    };
  }
});

var Subtract = createPlugin({
  protocol: 'TOKEN_MATH',
  type: 'CALCULATOR',
  method: 'sub',
  description: 'Subtract amount2 from amount1',
  supportedContracts: supportedContracts$1,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          amount1: new FctValue({
            destination: 'wei_amount'
          }),
          decimals1: new FctDecimals({}),
          amount2: new FctValue({
            destination: 'wei_amount'
          }),
          decimals2: new FctDecimals({}),
          decimalsOut: new FctDecimals({})
        }
      },
      output: {
        result: new FctValue({
          innerIndex: 0
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var getters$3 = {
  Add: Add,
  Subtract: Subtract,
  Multiply: Multiply,
  Divide: Divide,
  MultiplyAndDivide: MultiplyAndDivide,
  Mod: Mod
};
var TokensMath = {
  getters: getters$3
};

var supportedContracts = [{
  address: '0x421AC2A90550942ABB532e06d1d4d5220c095777',
  chainId: 1
}, {
  address: '0x93a9E720C3B161F70e60A7bd844F8ee6b19f07DE',
  chainId: 5
}, {
  address: '0x9706a492aFdaBE83D3B237d710eD811CE43acd59',
  chainId: 42161
}, {
  address: '0x27C133a452303195b237fe920442891FeF609c54',
  chainId: 421613
}, {
  address: '0x40b3dA447BE499e0D8165b314EB77e2356d0a92f',
  chainId: 11155111
}];

var Between = createPlugin({
  protocol: 'TOKEN_VALIDATOR',
  type: 'VALIDATOR',
  method: 'between',
  description: 'Check if amountIn is between minAmount and maxAmount',
  supportedContracts: supportedContracts,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          minAmount: new FctValue({
            destination: 'wei_amount'
          }),
          minDecimals: new FctDecimals({}),
          maxAmount: new FctValue({
            destination: 'wei_amount'
          }),
          maxDecimals: new FctDecimals({}),
          amountIn: new FctValue({
            destination: 'wei_amount'
          }),
          decimalsIn: new FctDecimals({}),
          decimalsOut: new FctDecimals({})
        }
      },
      output: {
        result: new FctValue({
          description: 'amountIn - minAmount',
          innerIndex: 0
        })
      }
    };
  }
});

var BetweenEqual = createPlugin({
  protocol: 'TOKEN_VALIDATOR',
  type: 'VALIDATOR',
  method: 'betweenEqual',
  description: 'Check if amountIn is between or equal minAmount and maxAmount',
  supportedContracts: supportedContracts,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          minAmount: new FctValue({
            destination: 'wei_amount'
          }),
          minDecimals: new FctDecimals({}),
          maxAmount: new FctValue({
            destination: 'wei_amount'
          }),
          maxDecimals: new FctDecimals({}),
          amountIn: new FctValue({
            destination: 'wei_amount'
          }),
          decimalsIn: new FctDecimals({}),
          decimalsOut: new FctDecimals({})
        }
      },
      output: {
        result: new FctValue({
          description: 'amountIn - minAmount',
          innerIndex: 0
        })
      }
    };
  }
});

var Equal = createPlugin({
  protocol: 'TOKEN_VALIDATOR',
  type: 'VALIDATOR',
  method: 'equal',
  description: 'Check if amount1 is equal amount2',
  supportedContracts: supportedContracts,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          amount1: new FctValue({
            destination: 'wei_amount'
          }),
          decimals1: new FctDecimals({}),
          amount2: new FctValue({
            destination: 'wei_amount'
          }),
          decimals2: new FctDecimals({}),
          decimalsOut: new FctDecimals({})
        }
      },
      output: {
        amount1: new FctValue({
          innerIndex: 0
        })
      }
    };
  }
});

var EqualAddress = createPlugin({
  protocol: 'TOKEN_VALIDATOR',
  type: 'VALIDATOR',
  method: 'equalAddress',
  description: 'Check if amount1 is equal amount2',
  supportedContracts: supportedContracts,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          address1: new FctAddress({}),
          address2: new FctAddress({})
        }
      },
      output: {
        address1: new FctAddress({
          innerIndex: 0
        })
      }
    };
  }
});

var EqualBytes32 = createPlugin({
  protocol: 'TOKEN_VALIDATOR',
  type: 'VALIDATOR',
  method: 'equalBytes32',
  description: 'Check if amount1 is equal amount2',
  supportedContracts: supportedContracts,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          value1: new FctBytes32({}),
          value2: new FctBytes32({})
        }
      },
      output: {
        value1: new FctBytes32({
          innerIndex: 0
        })
      }
    };
  }
});

var GreaterEqual = createPlugin({
  protocol: 'TOKEN_VALIDATOR',
  type: 'VALIDATOR',
  method: 'greaterEqual',
  description: 'Check if a amount1 is greater or equal to amount2',
  supportedContracts: supportedContracts,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          amount1: new FctValue({
            destination: 'wei_amount'
          }),
          decimals1: new FctDecimals({}),
          amount2: new FctValue({
            destination: 'wei_amount'
          }),
          decimals2: new FctDecimals({}),
          decimalsOut: new FctDecimals({})
        }
      },
      output: {
        result: new FctValue({
          description: 'amount1 - amount2',
          innerIndex: 0
        })
      }
    };
  }
});

var GreaterThan = createPlugin({
  protocol: 'TOKEN_VALIDATOR',
  type: 'VALIDATOR',
  method: 'greaterThan',
  description: 'Check if a amount1 is greater than amount2',
  supportedContracts: supportedContracts,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          amount1: new FctValue({
            destination: 'wei_amount'
          }),
          decimals1: new FctDecimals({}),
          amount2: new FctValue({
            destination: 'wei_amount'
          }),
          decimals2: new FctDecimals({}),
          decimalsOut: new FctDecimals({})
        }
      },
      output: {
        result: new FctValue({
          description: 'amount1 - amount2',
          innerIndex: 0
        })
      }
    };
  }
});

var LessEqual = createPlugin({
  protocol: 'TOKEN_VALIDATOR',
  type: 'VALIDATOR',
  method: 'lessEqual',
  description: 'Check if a amount2 is less or equal to amount1',
  supportedContracts: supportedContracts,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          amount1: new FctValue({
            destination: 'wei_amount'
          }),
          decimals1: new FctDecimals({}),
          amount2: new FctValue({
            destination: 'wei_amount'
          }),
          decimals2: new FctDecimals({}),
          decimalsOut: new FctDecimals({})
        }
      },
      output: {
        result: new FctValue({
          description: 'amount2 - amount1',
          innerIndex: 0
        })
      }
    };
  }
});

var LessThan = createPlugin({
  protocol: 'TOKEN_VALIDATOR',
  type: 'VALIDATOR',
  method: 'lessThan',
  description: 'Check if a amount2 is less than amount1',
  supportedContracts: supportedContracts,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          amount1: new FctValue({
            destination: 'wei_amount'
          }),
          decimals1: new FctDecimals({}),
          amount2: new FctValue({
            destination: 'wei_amount'
          }),
          decimals2: new FctDecimals({}),
          decimalsOut: new FctDecimals({})
        }
      },
      output: {
        result: new FctValue({
          description: 'amount2 - amount1',
          innerIndex: 0
        })
      }
    };
  }
});

/* eslint-disable no-restricted-imports */
var getters$2 = {
  Between: Between,
  BetweenEqual: BetweenEqual,
  Equal: Equal,
  EqualAddress: EqualAddress,
  EqualBytes32: EqualBytes32,
  GreaterEqual: GreaterEqual,
  GreaterThan: GreaterThan,
  LessEqual: LessEqual,
  LessThan: LessThan
};
var TokenValidator = {
  getters: getters$2
};

var _excluded$2 = ["amountOutMinimum", "recipient"],
  _excluded2$2 = ["amountOutMinimum", "recipient"];
function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SimpleSwapExactInput = createPlugin({
  protocol: 'UNISWAP_V3',
  type: 'ACTION',
  method: 'exactInput',
  name: 'simpleSwapExactInputV3',
  supportedContracts: SWAP_ROUTER_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        tokenIn: new FctAddress({
          mode: 'INPUT',
          destination: 'erc20',
          options: getSupportedTokens({
            chainId: chainId
          })
        }),
        tokenOut: new FctAddress({
          mode: 'INPUT',
          destination: 'erc20',
          options: getSupportedTokens({
            chainId: chainId
          })
        }),
        amountIn: new FctValue({
          mode: 'INPUT',
          destination: 'wei_amount'
        }),
        amountOut: new FctValue({
          readonly: true,
          destination: 'wei_amount',
          required: false
        }),
        methodParams: {
          params_tuple: {
            tokenIn: new FctAddress({
              required: false,
              readonly: true,
              destination: 'erc20',
              options: getSupportedTokens({
                chainId: chainId
              })
            }),
            tokenOut: new FctAddress({
              required: false,
              readonly: true,
              destination: 'erc20',
              options: getSupportedTokens({
                chainId: chainId
              })
            }),
            fee: new FctValue24({
              required: false,
              readonly: true
            }),
            path: new FctBytes({
              required: false,
              readonly: true
            }),
            recipient: new FctAddress({
              mode: 'INPUT'
            }),
            deadline: new FctValue({
              mode: 'INPUT'
            }),
            amountIn: new FctValue({
              readonly: true,
              destination: 'wei_amount'
            }),
            amountOutMinimum: new FctValue({
              destination: 'wei_amount'
            }),
            sqrtPriceLimitX96: new FctValue160({
              required: false
            })
          }
        }
      },
      output: {
        amountOut: new FctValue({})
      }
    };
  },
  initParams: {
    methodParams: {
      params_tuple: {
        deadline: {
          type: 'global',
          id: 'blockTimestamp'
        },
        amountOutMinimum: '0',
        sqrtPriceLimitX96: '0'
      }
    }
  },
  overrideSetMethodParams: function overrideSetMethodParams(_ref2) {
    var input = _ref2.input;
    return function (params, method) {
      var params_tuple = input.methodParams.params_tuple;
      if (method === 'exactInput') {
        params_tuple.path.value = params[0];
        params_tuple.recipient.value = params[1];
        params_tuple.deadline.value = params[2];
        params_tuple.amountIn.value = params[3];
        input.amountIn.value = params[3];
        params_tuple.amountOutMinimum.value = params[4];
      }
      if (method === 'exactInputSingle') {
        params_tuple.tokenIn.value = params[0];
        params_tuple.tokenOut.value = params[1];
        params_tuple.fee.value = params[2];
        params_tuple.recipient.value = params[3];
        params_tuple.deadline.value = params[4];
        params_tuple.amountIn.value = params[5];
        input.amountIn.value = params[5];
        params_tuple.amountOutMinimum.value = params[6];
        params_tuple.sqrtPriceLimitX96.value = params[7];
      }
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref3) {
    var input = _ref3.input,
      setMethod = _ref3.setMethod,
      provider = _ref3.provider;
    var getPathParams = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
        var service, tokenInAddress, tokenOutAddress, defaultReturn, amountIn, amount, isSimulationNeeded, decimalsIn, res, _input$methodParams$p, tokenIn, tokenOut, fee, sqrtPriceLimitX96, path, _res$params, _rest, _res$params2, amountOutMinimum, rest;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              service = _ref4.service;
              if (service) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              tokenInAddress = input === null || input === void 0 ? void 0 : input.tokenIn.value;
              tokenOutAddress = input === null || input === void 0 ? void 0 : input.tokenOut.value;
              defaultReturn = {
                params: {
                  amountOut: undefined,
                  methodParams: {
                    params_tuple: {
                      tokenIn: undefined,
                      tokenOut: undefined,
                      path: undefined,
                      amountOutMinimum: undefined,
                      amountIn: undefined
                    }
                  }
                },
                error: undefined
              };
              if (!(!tokenInAddress || !tokenOutAddress || typeof tokenInAddress !== 'string' || typeof tokenOutAddress !== 'string')) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", defaultReturn);
            case 8:
              amountIn = input === null || input === void 0 ? void 0 : input.amountIn;
              amount = amountIn.value;
              if (!(amount === undefined)) {
                _context.next = 12;
                break;
              }
              return _context.abrupt("return", defaultReturn);
            case 12:
              isSimulationNeeded = false;
              if (!(!amount || isVariable(amount))) {
                _context.next = 24;
                break;
              }
              isSimulationNeeded = true;
              if (!provider) {
                _context.next = 21;
                break;
              }
              _context.next = 18;
              return getTokenDecimals({
                address: tokenInAddress,
                provider: provider
              });
            case 18:
              _context.t0 = _context.sent;
              _context.next = 22;
              break;
            case 21:
              _context.t0 = 18;
            case 22:
              decimalsIn = _context.t0;
              amount = '1' + '0'.repeat(decimalsIn);
            case 24:
              _context.prev = 24;
              _context.next = 27;
              return service.create({
                cmd: 'simulateSwap',
                protocol: 'uniswap',
                token_in: tokenInAddress,
                token_in_decimals: 0,
                token_out: tokenOutAddress,
                token_out_decimals: 0,
                token_amount: amount,
                type: 'in',
                version: 'v3'
              });
            case 27:
              res = _context.sent;
              if (res) {
                _context.next = 30;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountOut: undefined,
                  methodParams: {
                    params_tuple: {
                      path: undefined,
                      amountOutMinimum: undefined
                    }
                  }
                },
                error: 'invalid trade'
              });
            case 30:
              _input$methodParams$p = input.methodParams.params_tuple, tokenIn = _input$methodParams$p.tokenIn, tokenOut = _input$methodParams$p.tokenOut, fee = _input$methodParams$p.fee, sqrtPriceLimitX96 = _input$methodParams$p.sqrtPriceLimitX96, path = _input$methodParams$p.path;
              if (res.params) {
                _context.next = 33;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountOut: undefined,
                  methodParams: {
                    params_tuple: {
                      path: undefined,
                      amountOutMinimum: undefined
                    }
                  }
                },
                error: 'invalid trade'
              });
            case 33:
              if (!(res.name === 'exactInputSingle')) {
                _context.next = 42;
                break;
              }
              if (setMethod) setMethod('exactInputSingle');
              tokenIn.virtual = false;
              tokenOut.virtual = false;
              fee.virtual = false;
              sqrtPriceLimitX96.virtual = false;
              path.virtual = true;
              _res$params = res === null || res === void 0 ? void 0 : res.params, _res$params.amountOutMinimum, _res$params.recipient, _rest = _objectWithoutProperties(_res$params, _excluded$2);
              return _context.abrupt("return", {
                params: {
                  amountOut: res === null || res === void 0 ? void 0 : res.params.amountOutMinimum,
                  methodParams: {
                    params_tuple: _objectSpread$4(_objectSpread$4({}, _rest), {}, {
                      amountOutMinimum: '0' //swapPath?.amountOut,
                    })
                  }
                },

                isSimulationNeeded: isSimulationNeeded,
                error: undefined
              });
            case 42:
              if (!(res.name !== 'exactInput')) {
                _context.next = 44;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountOut: undefined,
                  methodParams: {
                    params_tuple: {
                      path: undefined,
                      amountOutMinimum: undefined
                    }
                  }
                },
                error: 'invalid trade'
              });
            case 44:
              if (setMethod) setMethod('exactInput');
              tokenIn.virtual = true;
              tokenOut.virtual = true;
              fee.virtual = true;
              sqrtPriceLimitX96.virtual = true;
              path.virtual = false;
              _res$params2 = res === null || res === void 0 ? void 0 : res.params, amountOutMinimum = _res$params2.amountOutMinimum, _res$params2.recipient, rest = _objectWithoutProperties(_res$params2, _excluded2$2);
              return _context.abrupt("return", {
                params: {
                  amountOut: amountOutMinimum,
                  methodParams: {
                    params_tuple: _objectSpread$4(_objectSpread$4({}, rest), {}, {
                      amountOutMinimum: '0'
                    })
                  }
                },
                isSimulationNeeded: isSimulationNeeded,
                error: undefined
              });
            case 54:
              _context.prev = 54;
              _context.t1 = _context["catch"](24);
              return _context.abrupt("return", {
                params: {
                  amountOut: undefined,
                  methodParams: {
                    params_tuple: {
                      path: undefined,
                      amountOutMinimum: undefined
                    }
                  }
                },
                error: _context.t1.message
              });
            case 57:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[24, 54]]);
      }));
      return function getPathParams(_x) {
        return _ref5.apply(this, arguments);
      };
    }();
    return {
      get: getPathParams,
      depParamKeys: ['tokenIn', 'tokenOut', 'amountIn']
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var tokenIn = params.tokenIn;
    if (!tokenIn.value || typeof tokenIn.value !== 'string') return [];
    var tokenToApprove = tokenIn.value;
    return [{
      to: tokenToApprove,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams['params_tuple'].amountIn.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  getSubscribtions: function getSubscribtions(_ref6) {
    _objectDestructuringEmpty(_ref6);
    return [{
      callback: function callback(params) {
        if (!params) return;
        if (!params.amountIn.value) return;
        params.methodParams.params_tuple.amountIn.setQuiet({
          value: params.amountIn.value
        });
        return;
      },
      id: 'set_amount_by_amountIn_id'
    }];
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      amountIn = params.amountIn,
      amountOut = params.amountOut,
      tokenIn = params.tokenIn,
      tokenOut = params.tokenOut;
    if (!to.value || !amountIn.value || !amountOut.value || !tokenIn.value || !tokenOut.value || !vaultAddress) return [];
    if (typeof to.value !== 'string' || typeof amountIn.value !== 'string' || typeof amountOut.value !== 'string' || typeof tokenIn.value !== 'string' || typeof tokenOut.value !== 'string') return [];
    return [{
      address: vaultAddress,
      toSpend: [{
        token: tokenIn.value,
        amount: amountIn.value
      }],
      toReceive: [{
        token: tokenOut.value,
        amount: amountOut.value
      }]
    }];
  },
  estimateGasOnParams: function estimateGasOnParams(params, method, chainId) {
    var defaultGas = BigNumber.from('140000');
    if (method === 'exactInputSingle') {
      return chainId === '42161' || chainId === '421613' ? defaultGas.mul(13).toString() : defaultGas.toString();
    }
    // Else it means it is exactInput. We need to decode path.
    // 140k base, 85k per token in path.
    var path = params.methodParams.params_tuple.path;
    if (!path.value || typeof path.value !== 'string') {
      return chainId === '42161' || chainId === '421613' ? defaultGas.mul(13).toString() : defaultGas.toString();
    }
    var data = path.value;
    var offset = 2; // Skip the '0x' at the start
    var pathLength = 0;
    while (offset < data.length) {
      pathLength++;
      var isLastAddress = data.length - offset === 40;
      if (isLastAddress) {
        break;
      }
      offset += 40 + 6;
    }
    var additionalGas = BigNumber.from(pathLength - 2).mul(85000);
    var gas = defaultGas.add(additionalGas);
    if (chainId === '42161' || chainId === '421613') {
      gas = gas.mul(13);
    }
    return gas.toString();
  }
});

var _excluded$1 = ["amountInMaximum", "recipient"],
  _excluded2$1 = ["amountInMaximum", "recipient"];
function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SimpleSwapExactOutput = createPlugin({
  protocol: 'UNISWAP_V3',
  type: 'ACTION',
  method: 'exactOutput',
  name: 'simpleSwapExactOutputV3',
  supportedContracts: SWAP_ROUTER_ADDRESSES,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        tokenIn: new FctAddress({
          mode: 'INPUT',
          destination: 'erc20',
          options: getSupportedTokens({
            chainId: chainId
          })
        }),
        tokenOut: new FctAddress({
          mode: 'INPUT',
          destination: 'erc20',
          options: getSupportedTokens({
            chainId: chainId
          })
        }),
        amountIn: new FctValue({
          readonly: true,
          destination: 'wei_amount',
          required: false
        }),
        amountOut: new FctValue({
          mode: 'INPUT',
          destination: 'wei_amount'
        }),
        methodParams: {
          params_tuple: {
            tokenIn: new FctAddress({
              required: false,
              readonly: true,
              destination: 'erc20',
              options: getSupportedTokens({
                chainId: chainId
              })
            }),
            tokenOut: new FctAddress({
              required: false,
              readonly: true,
              destination: 'erc20',
              options: getSupportedTokens({
                chainId: chainId
              })
            }),
            fee: new FctValue24({
              required: false,
              readonly: true
            }),
            path: new FctBytes({
              required: false,
              readonly: true
            }),
            recipient: new FctAddress({
              mode: 'INPUT'
            }),
            deadline: new FctValue({
              mode: 'INPUT'
            }),
            amountOut: new FctValue({
              readonly: true,
              destination: 'wei_amount'
            }),
            amountInMaximum: new FctValue({
              destination: 'wei_amount'
            }),
            sqrtPriceLimitX96: new FctValue160({
              required: false
            })
          }
        }
      },
      output: {
        amountIn: new FctValue({})
      }
    };
  },
  initParams: {
    methodParams: {
      params_tuple: {
        deadline: {
          type: 'global',
          id: 'blockTimestamp'
        },
        sqrtPriceLimitX96: '0'
      }
    }
  },
  overrideSetMethodParams: function overrideSetMethodParams(_ref2) {
    var input = _ref2.input;
    return function (params, method) {
      var params_tuple = input.methodParams.params_tuple;
      if (method === 'exactOutput') {
        params_tuple.path.value = params[0];
        params_tuple.recipient.value = params[1];
        params_tuple.deadline.value = params[2];
        params_tuple.amountOut.value = params[3];
        input.amountOut.value = params[3];
        params_tuple.amountInMaximum.value = params[4];
      }
      if (method === 'exactOutputSingle') {
        params_tuple.tokenIn.value = params[0];
        params_tuple.tokenOut.value = params[1];
        params_tuple.fee.value = params[2];
        params_tuple.recipient.value = params[3];
        params_tuple.deadline.value = params[4];
        params_tuple.amountOut.value = params[5];
        input.amountOut.value = params[5];
        params_tuple.amountInMaximum.value = params[6];
        params_tuple.sqrtPriceLimitX96.value = params[7];
      }
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref3) {
    var input = _ref3.input,
      setMethod = _ref3.setMethod,
      provider = _ref3.provider;
    var getPathParams = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
        var service, tokenInAddress, tokenOutAddress, defaultReturn, amountOut, amount, isSimulationNeeded, decimalsOut, res, _input$methodParams$p, tokenIn, tokenOut, fee, sqrtPriceLimitX96, path, _res$params, _amountInMaximum, _rest, _res$params2, amountInMaximum, rest;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              service = _ref4.service;
              tokenInAddress = input === null || input === void 0 ? void 0 : input.tokenIn.value;
              tokenOutAddress = input === null || input === void 0 ? void 0 : input.tokenOut.value;
              defaultReturn = {
                params: {
                  amountIn: undefined,
                  methodParams: {
                    params_tuple: {
                      tokenIn: undefined,
                      tokenOut: undefined,
                      path: undefined,
                      amountInMaximum: undefined,
                      amountOut: undefined
                    }
                  }
                },
                error: undefined
              };
              if (!(!tokenInAddress || !tokenOutAddress || typeof tokenInAddress !== 'string' || typeof tokenOutAddress !== 'string')) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", defaultReturn);
            case 6:
              amountOut = input === null || input === void 0 ? void 0 : input.amountOut;
              amount = amountOut.value;
              if (!(amount === undefined)) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return", defaultReturn);
            case 10:
              isSimulationNeeded = false;
              if (!(!amount || isVariable(amount))) {
                _context.next = 22;
                break;
              }
              isSimulationNeeded = true;
              if (!provider) {
                _context.next = 19;
                break;
              }
              _context.next = 16;
              return getTokenDecimals({
                address: tokenOutAddress,
                provider: provider
              });
            case 16:
              _context.t0 = _context.sent;
              _context.next = 20;
              break;
            case 19:
              _context.t0 = 18;
            case 20:
              decimalsOut = _context.t0;
              amount = '1' + '0'.repeat(decimalsOut);
            case 22:
              _context.prev = 22;
              _context.next = 25;
              return service.create({
                cmd: 'simulateSwap',
                protocol: 'uniswap',
                token_in: tokenInAddress,
                token_in_decimals: 0,
                token_out: tokenOutAddress,
                token_out_decimals: 0,
                token_amount: amount,
                type: 'out',
                version: 'v3'
              });
            case 25:
              res = _context.sent;
              if (res) {
                _context.next = 28;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountIn: undefined,
                  methodParams: {
                    params_tuple: {
                      path: undefined,
                      amountInMaximum: undefined
                    }
                  }
                },
                error: 'invalid trade'
              });
            case 28:
              _input$methodParams$p = input.methodParams.params_tuple, tokenIn = _input$methodParams$p.tokenIn, tokenOut = _input$methodParams$p.tokenOut, fee = _input$methodParams$p.fee, sqrtPriceLimitX96 = _input$methodParams$p.sqrtPriceLimitX96, path = _input$methodParams$p.path;
              if (res.params) {
                _context.next = 31;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountIn: undefined,
                  methodParams: {
                    params_tuple: {
                      path: undefined,
                      amountInMaximum: undefined
                    }
                  }
                },
                error: 'invalid trade'
              });
            case 31:
              if (!(res.name === 'exactOutputSingle')) {
                _context.next = 40;
                break;
              }
              if (setMethod) setMethod('exactOutputSingle');
              tokenIn.virtual = false;
              tokenOut.virtual = false;
              fee.virtual = false;
              sqrtPriceLimitX96.virtual = false;
              path.virtual = true;
              _res$params = res === null || res === void 0 ? void 0 : res.params, _amountInMaximum = _res$params.amountInMaximum, _res$params.recipient, _rest = _objectWithoutProperties(_res$params, _excluded$1);
              return _context.abrupt("return", {
                params: {
                  amountIn: _amountInMaximum,
                  methodParams: {
                    params_tuple: _objectSpread$3(_objectSpread$3({}, _rest), {}, {
                      amountInMaximum: _amountInMaximum
                    })
                  }
                },
                isSimulationNeeded: isSimulationNeeded,
                error: undefined
              });
            case 40:
              if (!(res.name !== 'exactOutput')) {
                _context.next = 42;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  amountIn: undefined,
                  methodParams: {
                    params_tuple: {
                      path: undefined,
                      amountOutMinimum: undefined
                    }
                  }
                },
                error: 'invalid trade'
              });
            case 42:
              if (setMethod) setMethod('exactOutput');
              tokenIn.virtual = true;
              tokenOut.virtual = true;
              fee.virtual = true;
              sqrtPriceLimitX96.virtual = true;
              path.virtual = false;
              _res$params2 = res === null || res === void 0 ? void 0 : res.params, amountInMaximum = _res$params2.amountInMaximum, _res$params2.recipient, rest = _objectWithoutProperties(_res$params2, _excluded2$1);
              return _context.abrupt("return", {
                params: {
                  amountIn: amountInMaximum,
                  methodParams: {
                    params_tuple: _objectSpread$3(_objectSpread$3({}, rest), {}, {
                      amountInMaximum: amountInMaximum
                    })
                  }
                },
                isSimulationNeeded: isSimulationNeeded,
                error: undefined
              });
            case 52:
              _context.prev = 52;
              _context.t1 = _context["catch"](22);
              return _context.abrupt("return", {
                params: {
                  amountIn: undefined,
                  methodParams: {
                    params_tuple: {
                      path: undefined,
                      amountInMaximum: undefined
                    }
                  }
                },
                error: _context.t1.message
              });
            case 55:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[22, 52]]);
      }));
      return function getPathParams(_x) {
        return _ref5.apply(this, arguments);
      };
    }();
    return {
      get: getPathParams,
      depParamKeys: ['tokenIn', 'tokenOut', 'amountOut']
    };
  },
  requiredApprovals: function requiredApprovals(params) {
    var tokenIn = params.tokenIn;
    if (!tokenIn.value || typeof tokenIn.value !== 'string') return [];
    var tokenToApprove = tokenIn.value;
    return [{
      to: tokenToApprove,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams['params_tuple'].amountInMaximum.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  },
  getSubscribtions: function getSubscribtions(_ref6) {
    _objectDestructuringEmpty(_ref6);
    return [{
      callback: function callback(params) {
        if (!params) return;
        if (!params.amountOut.value) return;
        params.methodParams.params_tuple.amountOut.setQuiet({
          value: params.amountOut.value
        });
        return;
      },
      id: 'set_amount_by_amountOut_id'
    }];
  },
  assetFlow: function assetFlow(params, chainId, _walletAddress, vaultAddress) {
    var to = params.to,
      amountIn = params.amountIn,
      amountOut = params.amountOut,
      tokenIn = params.tokenIn,
      tokenOut = params.tokenOut;
    if (!to.value || !amountIn.value || !amountOut.value || !tokenIn.value || !tokenOut.value || !vaultAddress) return [];
    if (typeof to.value !== 'string' || typeof amountIn.value !== 'string' || typeof amountOut.value !== 'string' || typeof tokenIn.value !== 'string' || typeof tokenOut.value !== 'string') return [];
    return [{
      address: vaultAddress,
      toSpend: [{
        token: tokenIn.value,
        amount: amountIn.value
      }],
      toReceive: [{
        token: tokenOut.value,
        amount: amountOut.value
      }]
    }];
  }

  // onCreate: ({ input }) => {
  //   const setAmountOut = () => {
  //     input.methodParams.params_tuple.amountOut.set({ value: input.amountOut.value })
  //   }

  //   input.amountOut.subscribe({
  //     callback: () => {
  //       setAmountOut()
  //     },
  //     id: 'set amount by amountIn',
  //   })

  //   setAmountOut()
  // },
});

var actions$4 = {
  // ExactInput,
  // ExactInputSingle,
  // ExactOutput,
  // ExactOutputSingle,
  // Mint,
  // Burn,
  // IncreaseLiquidity,
  // DecreaseLiquidity,
  // Collect,
  SimpleSwapExactInput: SimpleSwapExactInput,
  SimpleSwapExactOutput: SimpleSwapExactOutput
};
var getters$1 = {
  // Positions,
  // ProtocolFees,
  // Slot0,
  // Ticks,
};
var UniswapV3 = {
  actions: actions$4,
  getters: getters$1
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var pluginType = {
  view: 'GETTER',
  payable: 'ACTION',
  nonpayable: 'ACTION',
  pure: 'GETTER'
};
var generateFunctionSignature = function generateFunctionSignature(name, inputs) {
  var params = inputs.map(function (input) {
    return input.type;
  }).join(',');
  return "".concat(name, "(").concat(params, ")");
};
var isArrayType = function isArrayType(value) {
  var parsedValue = value.match(/\[[^\]]*\]/);
  return parsedValue && parsedValue.length ? Boolean(parsedValue[0]) : false;
};
var is256Array = function is256Array(value) {
  if (!value.includes('256')) return;
  if (!value.includes('[')) return;
  if (!value.includes(']')) return;
  return true;
};
var generateParams = function generateParams(inputs, isOutput, errors, pluginName) {
  return inputs.reduce(function (acc, input, index) {
    var type = input.type;
    var name = input.name;
    var ioType = isOutput ? 'output' : 'input';
    if (!name) {
      errors.set(pluginName, "One of the ".concat(ioType, "s has no name using key ").concat(type, " instead"));
      name = type;
    }
    if (!type) {
      throw new Error("".concat(ioType, " ").concat(name, " has no type. This plugin will not be added to the list"));
    }
    if (!isOutput && (type === 'tuple' || type === 'tuple{}')) {
      if (!input.components) {
        throw new Error("".concat(ioType, " ").concat(name, " is a tuple, but has no components. This plugin will not be added to the list"));
      }
      return _objectSpread$2(_objectSpread$2({}, acc), {}, _defineProperty({}, "".concat(name, "_").concat(type), generateParams(input.components, isOutput, errors, name)));
    }
    var Parameter = is256Array(type) ? FctValueListN : paramsSchemas.find(function (Item) {
      var newItem = new Item({});
      return newItem.fctType === type;
    });
    var classInput = isOutput ? {
      innerIndex: index
    } : {};
    var paramInstance;
    if (Parameter) {
      paramInstance = new Parameter(classInput);
      paramInstance._fctType = type;
    } else {
      paramInstance = isArrayType(type) ? new FctCustomArray(classInput) : new FctCustom(classInput);
      paramInstance._fctType = type;
    }
    if (isOutput && type.includes("[]")) {
      var oName = name.replace("[]", '');
      var oType = type.replace("[]", '');
      var _Parameter = paramsSchemas.find(function (Item) {
        var newItem = new Item({});
        return newItem.fctType === oType;
      });
      var ParamConstructor;
      if (_Parameter) {
        ParamConstructor = _Parameter;
      } else {
        ParamConstructor = FctCustom;
      }
      var params = {};
      for (var n = 0; n < 5; n++) {
        var innerIndex = n + 2;
        var _paramInstance = new ParamConstructor({
          innerIndex: innerIndex,
          innerType: type
        });
        _paramInstance._fctType = oType;
        var _key = n > 0 ? "".concat(oName, "_").concat(n) : oName;
        params[_key] = _paramInstance;
      }
      return _objectSpread$2(_objectSpread$2({}, acc), params);
    }
    return _objectSpread$2(_objectSpread$2({}, acc), {}, _defineProperty({}, name, paramInstance));
  }, {});
};
var getPluginsFromABI = function getPluginsFromABI(_ref) {
  var abi = _ref.abi,
    protocol = _ref.protocol,
    chainId = _ref.chainId,
    contractAddress = _ref.contractAddress,
    pluginName = _ref.pluginName;
  var supportedContracts = [{
    chainId: Number(chainId),
    address: contractAddress
  }];
  var errors = new Map();
  var plugins = abi.filter(function (item) {
    return item.type === 'function';
  }).map(function (item) {
    var name = item.name,
      inputs = item.inputs,
      outputs = item.outputs,
      stateMutability = item.stateMutability;
    if (!name) {
      errors.set('unknown', 'One of the functions has no name. This plugin will not be added to the list');
      return undefined;
    }
    if (!stateMutability) {
      errors.set(name, "Function ".concat(name, " has no stateMutability. This plugin will not be added to the list"));
      return undefined;
    }
    try {
      var transferInputs = stateMutability === 'payable' ? {
        to: new FctAddress({}),
        value: new FctValue({})
      } : {
        to: new FctAddress({})
      };
      var pluginInputs = inputs && inputs.length ? generateParams(inputs, false, errors, name) : {};
      var pluginOutputs = outputs && outputs.length ? generateParams(outputs, true, errors, name) : {};
      var params = {
        name: pluginName ? pluginName : name,
        description: generateFunctionSignature(name, inputs || []),
        plugin: createPlugin({
          protocol: protocol,
          type: pluginType[stateMutability],
          method: name,
          name: pluginName,
          supportedContracts: supportedContracts,
          getParams: function getParams() {
            return {
              // @ts-expect-error: value not undefined
              input: _objectSpread$2(_objectSpread$2({}, transferInputs), {}, {
                methodParams: pluginInputs
              }),
              output: pluginOutputs
            };
          },
          initParams: {
            to: supportedContracts.length === 1 ? supportedContracts[0].address : undefined,
            value: '0'
          }
        })
      };
      return params;
    } catch (e) {
      console.error({
        catchederror: e
      });
      errors.set(name, e.message);
      return undefined;
    }
  }).filter(function (plugin) {
    return Boolean(plugin);
  });
  return {
    errors: errors,
    plugins: plugins
  };
};

/* eslint-disable no-restricted-imports */
var SendETH = createPlugin({
  protocol: 'UTILITY',
  type: 'ACTION',
  description: 'Send ETH',
  method: '',
  name: 'sendETH',
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        value: new FctValue({
          destination: 'wei_amount'
        }),
        methodParams: {}
      },
      output: {}
    };
  },
  initParams: {}
});

/* eslint-disable no-restricted-imports */
var UnwrapETH = createPlugin({
  protocol: 'UTILITY',
  type: 'ACTION',
  description: 'Unwrap WETH into ETH',
  method: 'withdraw',
  name: 'unwrapETH',
  supportedContracts: [{
    address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    chainId: 1
  }, {
    address: '0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6',
    chainId: 5
  }, {
    address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    chainId: 42161
  }, {
    address: '0x1757f2E7BEE5abE1A79532000d05e32D90dD79fF',
    chainId: 421613
  }],
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'wrapped_ether',
          options: getSupportedContracts({
            chainId: chainId,
            contracts: WETH_ADDRESSES
          })
        }),
        methodParams: {
          amount: new FctValue({
            destination: 'wei_amount'
          })
        }
      },
      output: {}
    };
  }
});

/* eslint-disable no-restricted-imports */
var WrapETH = createPlugin({
  protocol: 'UTILITY',
  type: 'ACTION',
  description: 'Wrap ETH into WETH',
  method: 'deposit',
  name: 'wrapETH',
  supportedContracts: [{
    address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    chainId: 1
  }, {
    address: '0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6',
    chainId: 5
  }, {
    address: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    chainId: 42161
  }, {
    address: '0x1757f2E7BEE5abE1A79532000d05e32D90dD79fF',
    chainId: 421613
  }],
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({
          destination: 'wrapped_ether',
          options: getSupportedContracts({
            chainId: chainId,
            contracts: WETH_ADDRESSES
          })
        }),
        value: new FctValue({
          destination: 'wei_amount'
        }),
        methodParams: {}
      },
      output: {}
    };
  }
});

/* eslint-disable no-restricted-imports */
var GetETHBalance = createPlugin({
  protocol: 'UTILITY',
  type: 'GETTER',
  description: 'Get native token balance',
  method: 'getEthBalance',
  name: 'getETHBalance',
  supportedContracts: MULTICALL_ADDRESSES$1,
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          address: new FctAddress({})
        }
      },
      output: {
        balance: new FctValue({
          destination: 'wei_amount',
          innerIndex: 0
        })
      }
    };
  },
  initParams: {}
});

/* eslint-disable no-restricted-imports */
var actions$3 = {
  WrapETH: WrapETH,
  UnwrapETH: UnwrapETH,
  SendETH: SendETH
};
var getters = {
  GetETHBalance: GetETHBalance
};
var Utility = {
  actions: actions$3,
  getters: getters
};

/* eslint-disable no-restricted-imports */
var operatorOptions = [{
  name: 'equal',
  value: 'equal'
}, {
  name: 'greater than',
  value: 'greater than'
}, {
  name: 'greater equal than',
  value: 'greater equal than'
}, {
  name: 'or',
  value: 'or'
}, {
  name: 'or not',
  value: 'or not'
}, {
  name: 'and',
  value: 'and'
}, {
  name: 'and not',
  value: 'and not'
}, {
  name: 'not equal',
  value: 'not equal'
}];
var Validate = createPlugin({
  protocol: 'VALIDATION_VARIABLE',
  type: 'VALIDATION_VARIABLE',
  method: 'validate',
  name: 'validate',
  getParams: function getParams() {
    return {
      input: {
        nodeId: new FctString({
          readonly: true
        }),
        methodParams: {
          id: new FctString({
            readonly: true
          }),
          value1: new FctValue({
            required: false
          }),
          operator: new FctString({
            options: operatorOptions,
            mode: 'INPUT'
          }),
          value2: new FctValue({
            required: false
          })
        }
      },
      output: {
        result: new FctValue({
          innerIndex: 0
        })
      }
    };
  },
  onChange: function onChange(_ref) {
    var input = _ref.input,
      output = _ref.output;
    var _input$methodParams = input.methodParams,
      id = _input$methodParams.id,
      value1 = _input$methodParams.value1,
      operator = _input$methodParams.operator,
      value2 = _input$methodParams.value2;
    output.result.set({
      value: {
        id: id.value,
        type: 'validation',
        value1: value1.value || '',
        operator: operator.value || '',
        value2: value2.value || ''
      }
    });
  }
});

var ValidationVariable = {
  getters: {
    Validate: Validate
  }
};

var getyVaults = function getyVaults(_ref) {
  var chainId = _ref.chainId;
  if (chainId === '5') return [];
  if (chainId === '421613') return [];
  if (chainId === '42161') return yVaultsArbitrum;
  return yVaultsMainnet;
};

var Deposit = createPlugin({
  protocol: 'YEARN',
  type: 'ACTION',
  method: 'deposit',
  description: 'Deposit into a Yearn vault',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId,
      vaultAddress = _ref.vaultAddress;
    return {
      input: {
        to: new FctAddress({
          destination: 'yearn_vault',
          options: getyVaults({
            chainId: chainId
          })
        }),
        depositToken: new FctAddress({
          destination: 'erc20',
          readonly: true
        }),
        methodParams: {
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          recipient: new FctAddress({
            value: vaultAddress
          })
        }
      },
      output: {}
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref2) {
    var input = _ref2.input,
      chainId = _ref2.chainId,
      provider = _ref2.provider;
    var to = input.to,
      depositToken = input.depositToken,
      methodParams = input.methodParams;
    var vaults = getyVaults({
      chainId: chainId
    });
    var getParamsAsync = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var toValue, asset, tokenContract, symbol, decimals;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              toValue = to.value;
              if (toValue) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  depositToken: undefined
                },
                error: undefined
              });
            case 3:
              if (!(typeof toValue !== 'string')) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  depositToken: undefined
                },
                error: undefined
              });
            case 5:
              asset = vaults.find(function (v) {
                return v.value.toLowerCase() === toValue.toLowerCase();
              });
              if (asset) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  depositToken: undefined
                },
                error: undefined
              });
            case 8:
              if (asset.underlyingToken) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  depositToken: undefined
                },
                error: undefined
              });
            case 10:
              tokenContract = new ethers.Contract(asset.underlyingToken, ['function decimals() view returns (uint8 decimals)', 'function symbol() view returns (string symbol)'], provider);
              _context.next = 13;
              return tokenContract.symbol();
            case 13:
              symbol = _context.sent;
              _context.next = 16;
              return tokenContract.decimals();
            case 16:
              decimals = _context.sent;
              methodParams.amount.label = "".concat(symbol, " Amount");
              methodParams.amount.decimals = decimals;
              depositToken.value = asset.underlyingToken;
              depositToken.label = symbol;
              depositToken.decimals = decimals;
              return _context.abrupt("return", {
                params: {
                  depositToken: asset.underlyingToken
                },
                error: undefined
              });
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getParamsAsync() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      get: getParamsAsync,
      depParamKeys: ['to']
    };
  },
  requiredApprovals: function requiredApprovals(params, chainId) {
    var vaults = getyVaults({
      chainId: chainId
    });
    var token = vaults.find(function (vault) {
      if (typeof (params === null || params === void 0 ? void 0 : params.to.value) === 'string') return vault.value.toLowerCase() === (params === null || params === void 0 ? void 0 : params.to.value.toLowerCase());
      return false;
    });
    if (!token) return [];
    return [{
      to: token.underlyingToken,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: params === null || params === void 0 ? void 0 : params.methodParams.amount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var Withdraw = createPlugin({
  protocol: 'YEARN',
  type: 'ACTION',
  method: 'withdraw',
  description: 'Withdraw from a Yearn vault',
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId,
      vaultAddress = _ref.vaultAddress;
    return {
      input: {
        to: new FctAddress({
          destination: 'yearn_vault',
          options: getyVaults({
            chainId: chainId
          })
        }),
        receiveToken: new FctAddress({
          destination: 'erc20',
          readonly: true
        }),
        methodParams: {
          amount: new FctValue({
            destination: 'wei_amount'
          }),
          recipient: new FctAddress({
            value: vaultAddress
          })
        }
      },
      output: {}
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref2) {
    var input = _ref2.input,
      chainId = _ref2.chainId,
      provider = _ref2.provider;
    var to = input.to,
      receiveToken = input.receiveToken;
    var vaults = getyVaults({
      chainId: chainId
    });
    var getParamsAsync = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var toValue, asset, tokenContract, symbol, decimals;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              toValue = to.value;
              if (toValue) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  receiveToken: undefined
                },
                error: undefined
              });
            case 3:
              if (!(typeof toValue !== 'string')) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  receiveToken: undefined
                },
                error: undefined
              });
            case 5:
              asset = vaults.find(function (v) {
                return v.value.toLowerCase() === toValue.toLowerCase();
              });
              if (asset) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  receiveToken: undefined
                },
                error: undefined
              });
            case 8:
              if (asset.underlyingToken) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return", {
                params: {
                  receiveToken: undefined
                },
                error: undefined
              });
            case 10:
              tokenContract = new ethers.Contract(asset.underlyingToken, ['function decimals() view returns (uint8 decimals)', 'function symbol() view returns (string symbol)'], provider);
              _context.next = 13;
              return tokenContract.symbol();
            case 13:
              symbol = _context.sent;
              _context.next = 16;
              return tokenContract.decimals();
            case 16:
              decimals = _context.sent;
              receiveToken.value = asset.underlyingToken;
              receiveToken.label = symbol;
              receiveToken.decimals = decimals;
              return _context.abrupt("return", {
                params: {
                  receiveToken: asset.underlyingToken
                },
                error: undefined
              });
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getParamsAsync() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      get: getParamsAsync,
      depParamKeys: ['to']
    };
  }
});

/* eslint-disable no-restricted-imports */
var actions$2 = {
  Deposit: Deposit,
  Withdraw: Withdraw
};
var Yearn = {
  actions: actions$2
};

var cBridgeContracts = [{
  address: '0x5427FEFA711Eff984124bFBB1AB6fbf5E3DA1820',
  chainId: 1,
  name: 'Celer Bridge Mainnet'
}, {
  address: '0x1619DE6B6B20eD217a58d00f37B9d47C7663feca',
  chainId: 42161,
  name: 'Celer Bridge Arbitrum'
}];

var ethereumMainnetNetworks = {
  mainnet: {
    name: "Ethereum Mainnet",
    color: "#29b6af",
    chainId: 1,
    rpcUrl: "https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
    blockTime: 15000,
    iconUrl: "./ETH.png",
    blockDelay: 8,
    symbol: "ETH",
    blockExplorerUrl: "https://etherscan.io",
    tokenSymbolList: ["USDC", "USDT", "WETH", "BUSD", "DODO", "LYRA", "DOMI", "MCB", "IMX", "oneDODO", "OLO", "BOBA", "FRAX", "ONG"]
  },
  bsc: {
    name: "BSC",
    color: "#7057ff",
    chainId: 56,
    rpcUrl: "https://bsc-dataseed.binance.org",
    blockTime: 4000,
    iconUrl: "./bsc.png",
    blockDelay: 8,
    symbol: "BNB",
    blockExplorerUrl: "https://bscscan.com",
    tokenSymbolList: ["USDC", "USDT", "WETH", "BUSD", "DODO", "DOMI", "MCB", "cUSD", "oneDODO", "OLO", "FRAX", "SWAY", "ONG"]
  },
  polygon: {
    name: "Polygon (Matic)",
    color: "#3099f2",
    chainId: 137,
    rpcUrl: "https://polygon-rpc.com",
    blockTime: 4000,
    iconUrl: "./polygon.png",
    blockDelay: 80,
    symbol: "MATIC",
    blockExplorerUrl: "https://polygonscan.com",
    tokenSymbolList: ["USDC", "USDT", "WETH", "IMX", "SWAY"]
  },
  arbitrum: {
    name: "Arbitrum",
    color: "#ff4a8d",
    chainId: 42161,
    rpcUrl: "https://arb1.arbitrum.io/rpc",
    blockTime: 4000,
    iconUrl: "./arbitrum.png",
    blockDelay: 8,
    symbol: "ETH",
    blockExplorerUrl: "https://arbiscan.io",
    tokenSymbolList: ["USDC", "USDT", "WETH", "DODO", "MCB", "IMX"]
  },
  Avalanche: {
    name: "Avalanche",
    color: "#3099f2",
    chainId: 43114,
    rpcUrl: "https://api.avax.network/ext/bc/C/rpc",
    blockTime: 5000,
    iconUrl: "./avalanche.png",
    blockDelay: 15,
    symbol: "AVAX",
    blockExplorerUrl: "https://snowtrace.io",
    tokenSymbolList: ["USDC", "USDT", "WETH", "IMX"]
  },
  Optimism: {
    name: "Optimism",
    color: "#3099f2",
    chainId: 10,
    rpcUrl: "https://mainnet.optimism.io",
    blockTime: 5000,
    iconUrl: "./optimism.png",
    blockDelay: 8,
    symbol: "ETH",
    blockExplorerUrl: "https://optimistic.etherscan.io",
    tokenSymbolList: ["USDC", "USDT", "WETH", "LYRA"]
  },
  Fantom: {
    name: "Fantom",
    color: "#3099f2",
    chainId: 250,
    rpcUrl: "https://rpc.ftm.tools",
    blockTime: 5000,
    iconUrl: "./fantom.png",
    blockDelay: 6,
    symbol: "FTM",
    blockExplorerUrl: "https://ftmscan.com",
    tokenSymbolList: ["USDC", "USDT", "WETH"]
  },
  BoBa: {
    name: "Boba Network",
    color: "#3099f2",
    chainId: 288,
    rpcUrl: "https://mainnet.boba.network",
    blockTime: 10000,
    iconUrl: "./boba.png",
    blockDelay: 8,
    symbol: "ETH",
    blockExplorerUrl: "https://blockexplorer.boba.network",
    tokenSymbolList: ["USDC", "OLO", "BOBA"]
  }
};

var getCelerBridgeChainOptions = function getCelerBridgeChainOptions(_ref) {
  var chainId = _ref.chainId;
  return Object.keys(ethereumMainnetNetworks).map(function (key) {
    var itemKey = key;
    var celerBridgeChainId = String(ethereumMainnetNetworks[itemKey].chainId);
    if (celerBridgeChainId === chainId) return;
    return {
      value: celerBridgeChainId,
      chainId: celerBridgeChainId,
      name: ethereumMainnetNetworks[itemKey].name,
      symbol: ethereumMainnetNetworks[itemKey].symbol
    };
  }).filter(Boolean);
};

var slippageDefaultOptions = [{
  value: '3000',
  name: '0.3%',
  decimals: 4
}, {
  value: '5000',
  name: '0.5%',
  decimals: 4
}, {
  value: '10000',
  name: '1%',
  decimals: 4
}];

var Send = createPlugin({
  protocol: 'cBridge',
  type: 'ACTION',
  method: 'send',
  name: 'sendToken',
  supportedContracts: cBridgeContracts,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          receiver: new FctAddress({}),
          token: new FctAddress({
            options: chainId === '1' ? celerBridgeMainnetTokens : []
          }),
          amount: new FctValue({}),
          dstChainId: new FctUinteger64({
            options: getCelerBridgeChainOptions({
              chainId: chainId
            })
          }),
          nonce: new FctUinteger64({
            hidden: true,
            value: generateRandomUint64Number()
          }),
          maxSlippage: new FctUinteger32Bps({
            options: slippageDefaultOptions
          })
        }
      },
      output: {}
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput() {
    var getParamsAsync = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                params: {},
                error: undefined
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getParamsAsync() {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      get: getParamsAsync,
      depParamKeys: ['methodParams.receiver', 'methodParams.token', 'methodParams.amount', 'methodParams.dstChainId', 'methodParams.maxSlippage']
    };
  },
  initParams: {
    methodParams: {
      dstChainId: '56',
      maxSlippage: '5000'
    }
  },
  requiredApprovals: function requiredApprovals(params) {
    var _params$methodParams = params.methodParams,
      token = _params$methodParams.token,
      amount = _params$methodParams.amount;
    if (!token.value || typeof token.value !== 'string') return [];
    var tokenToApprove = token.value;
    return [{
      to: tokenToApprove,
      params: {
        spender: params === null || params === void 0 ? void 0 : params.to.value,
        amount: amount.value
      },
      method: 'approve',
      protocol: 'ERC20'
    }];
  }
});

var SendNative = createPlugin({
  protocol: 'cBridge',
  type: 'ACTION',
  method: 'sendNative',
  name: 'sendETH',
  supportedContracts: cBridgeContracts,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        value: new FctValue({
          hidden: true
        }),
        methodParams: {
          receiver: new FctAddress({}),
          amount: new FctValue({
            decimals: 18
          }),
          dstChainId: new FctUinteger64({
            options: getCelerBridgeChainOptions({
              chainId: chainId
            })
          }),
          nonce: new FctUinteger64({
            hidden: true,
            value: generateRandomUint64Number()
          }),
          maxSlippage: new FctUinteger32Bps({
            options: slippageDefaultOptions
          })
        }
      },
      output: {}
    };
  },
  calculateValuesOnUserInput: function calculateValuesOnUserInput(_ref2) {
    var input = _ref2.input;
    var getParamsAsync = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var value, amount;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              value = input.value, amount = input.methodParams.amount;
              value.set({
                value: amount.value
              });
              return _context.abrupt("return", {
                params: {
                  value: amount.value
                },
                error: undefined
              });
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              console.log({
                error: _context.t0
              });
              return _context.abrupt("return", {
                params: {
                  value: undefined
                },
                error: (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message) || (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.response)
              });
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 6]]);
      }));
      return function getParamsAsync() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      get: getParamsAsync,
      depParamKeys: ['methodParams.receiver', 'methodParams.amount', 'methodParams.dstChainId', 'methodParams.maxSlippage']
    };
  },
  initParams: {
    methodParams: {
      dstChainId: '56',
      maxSlippage: '5000'
    }
  }
});

var actions$1 = {
  Send: Send,
  SendNative: SendNative
};
var cBridge = {
  actions: actions$1
};

var Magic$1 = createPlugin({
  protocol: 'MAGIC',
  type: 'LIBRARY',
  method: 'magic',
  usePureMethod: true,
  name: 'magic',
  supportedContracts: [{
    chainId: 1,
    address: '0x50Bb8165Dd11d41ef2fE90f96b5041F90966E8A7'
  }, {
    chainId: 5,
    address: '0x23D560eF20B57A87489D3Ec72D3789E73DF90424'
  }, {
    chainId: 11155111,
    address: '0xc074EEC205576C657a8EBDFeA8FCCd1a2924f193'
  }],
  getParams: function getParams() {
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {}
      },
      output: {}
    };
  }
});

/* eslint-disable no-restricted-imports */
var actions = {
  Magic: Magic$1
};
var Magic = {
  actions: actions
};

var plugins = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Inch: Inch,
  AaveV2: AaveV2,
  AaveV3: AaveV3,
  ChainLink: ChainLink,
  CompoundV2: CompoundV2,
  CompoundV3: CompoundV3,
  ComputedVariable: ComputedVariable,
  Curve: Curve,
  ERC20: ERC20,
  ERC721: ERC721,
  ERC1155: ERC1155,
  FCT_UNISWAP: FCT_UNISWAP,
  GMX: GMX,
  KIROBO_MULTICALL_CSV: KIROBO_MULTICALL_CSV,
  Lido: Lido,
  Paraswap: Paraswap,
  RadiantV2: RadiantV2,
  RocketPool: RocketPool,
  SecureStorage: SecureStorage,
  Sushiswap: Sushiswap$1,
  TokensMath: TokensMath,
  TokenValidator: TokenValidator,
  Uniswap: Uniswap$1,
  UniswapV3: UniswapV3,
  Utility: Utility,
  ValidationVariable: ValidationVariable,
  Yearn: Yearn,
  cBridge: cBridge,
  Magic: Magic
});

var GetAssetsPrices = createPlugin({
  protocol: 'AAVE',
  type: 'ORACLE',
  method: 'getAssetsPrices',
  supportedContracts: PRICE_ORACLE_ADDRESSES$1,
  getParams: function getParams(_ref) {
    var chainId = _ref.chainId;
    return {
      input: {
        to: new FctAddress({}),
        methodParams: {
          assets: new FctAddressList({
            options: getAaveTokens({
              chainId: chainId
            })
          })
        }
      },
      output: {
        prices: new FctValueList({
          destination: 'amount_list'
        })
      }
    };
  }
});

var BigNumberZD = BN.clone({
  DECIMAL_PLACES: 0,
  ROUNDING_MODE: BN.ROUND_DOWN
});
function valueToBigNumber(amount) {
  return new BN(amount);
}
function valueToZDBigNumber(amount) {
  return new BigNumberZD(amount);
}
var bn10 = new BN(10);
var bn10PowLookup = {};

/**
 * It's a performance optimized version of 10 ** x, which essentially memoizes previously used pows and resolves them as lookup.
 * @param decimals
 * @returns 10 ** decimals
 */
function pow10(decimals) {
  if (!bn10PowLookup[decimals]) bn10PowLookup[decimals] = bn10.pow(decimals);
  return bn10PowLookup[decimals];
}
function normalize(n, decimals) {
  return normalizeBN(n, decimals).toString(10);
}
function normalizeBN(n, decimals) {
  return valueToBigNumber(n).dividedBy(pow10(decimals));
}

var RAY_DECIMALS = 27;
var WAD = valueToZDBigNumber(10).pow(18);
WAD.dividedBy(2);
var RAY$1 = valueToZDBigNumber(10).pow(27);
var HALF_RAY = RAY$1.dividedBy(2);
valueToZDBigNumber(10).pow(9);
function rayMul(a, b) {
  return HALF_RAY.plus(valueToZDBigNumber(a).multipliedBy(b)).div(RAY$1);
}
function rayPow(a, p) {
  var x = valueToZDBigNumber(a);
  var n = valueToZDBigNumber(p);
  var z = !n.modulo(2).eq(0) ? x : valueToZDBigNumber(RAY$1);
  for (n = n.div(2); !n.eq(0); n = n.div(2)) {
    x = rayMul(x, x);
    if (!n.modulo(2).eq(0)) {
      z = rayMul(z, x);
    }
  }
  return z;
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var RAY = new BN(Math.pow(10, 27));
var SECONDS_PER_YEAR = 31536000;
var AaveHelper = /*#__PURE__*/function (_Config) {
  _inherits(AaveHelper, _Config);
  var _super = _createSuper$3(AaveHelper);
  function AaveHelper() {
    var _this;
    _classCallCheck(this, AaveHelper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "RAY", RAY);
    _defineProperty(_assertThisInitialized(_this), "SECONDS_PER_YEAR", SECONDS_PER_YEAR);
    _defineProperty(_assertThisInitialized(_this), "createContract", function (_ref) {
      var address = _ref.address,
        contractInterface = _ref.contractInterface,
        returns = _ref.returns;
      var contract = new ethers.Contract(address, new Interface(["function ".concat(contractInterface, " view ").concat(returns)]), _this.library);
      return contract;
    });
    _defineProperty(_assertThisInitialized(_this), "getAssetPrice", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var asset, usdPriceEth, getAssetPrice, contract, call, values, data, priceInEth;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              asset = _ref2.asset, usdPriceEth = _ref2.usdPriceEth;
              getAssetPrice = new AaveV2.getters.GetAssetPrice({
                chainId: String(_this.chainId),
                initParams: {
                  methodParams: {
                    asset: asset
                  }
                }
              });
              contract = _this.createContract({
                address: getAssetPrice.input.params.to.value,
                contractInterface: getAssetPrice.contractInterface,
                returns: getAssetPrice.contractInterfaceReturns
              });
              _context.next = 5;
              return getAssetPrice.create();
            case 5:
              call = _context.sent;
              values = call === null || call === void 0 ? void 0 : call.params.map(function (param) {
                return param.value;
              });
              _context.prev = 7;
              _context.next = 10;
              return contract.getAssetPrice.apply(contract, _toConsumableArray(values).concat([{
                from: _this.account
              }]));
            case 10:
              data = _context.sent;
              if (data) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return", undefined);
            case 13:
              priceInEth = normalize(data.toString(), 18);
              return _context.abrupt("return", {
                wei: data.toString(),
                eth: priceInEth,
                usd: usdPriceEth ? new BN(priceInEth).multipliedBy(usdPriceEth).toFixed(2) : undefined
              });
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](7);
              console.error(_context.t0);
              return _context.abrupt("return", undefined);
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[7, 17]]);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getAssetsPrices", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
        var _assetsParams$options;
        var usdPriceEth, assets, getAssetsPrices, assetsParams, filtredAssets, assetsAddresses, contract, call, values, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              usdPriceEth = _ref4.usdPriceEth, assets = _ref4.assets;
              getAssetsPrices = new GetAssetsPrices({
                chainId: String(_this.chainId)
              });
              assetsParams = getAssetsPrices.input.methodParams.assets;
              filtredAssets = assets ? (_assetsParams$options = assetsParams.options) === null || _assetsParams$options === void 0 ? void 0 : _assetsParams$options.filter(function (a) {
                var value = a.value.toLocaleLowerCase();
                return assets.map(function (asset) {
                  return asset.toLocaleLowerCase();
                }).includes(value);
              }) : assetsParams.options;
              if (filtredAssets !== null && filtredAssets !== void 0 && filtredAssets.length) {
                _context2.next = 7;
                break;
              }
              console.error("assets ".concat(assets, " not found"));
              return _context2.abrupt("return", []);
            case 7:
              assetsAddresses = filtredAssets.map(function (asset) {
                return asset.value;
              });
              assetsParams.set({
                value: assetsAddresses
              });
              contract = _this.createContract({
                address: getAssetsPrices.input.params.to.value,
                contractInterface: getAssetsPrices.contractInterface,
                returns: getAssetsPrices.contractInterfaceReturns
              });
              _context2.next = 12;
              return getAssetsPrices.create();
            case 12:
              call = _context2.sent;
              values = call === null || call === void 0 ? void 0 : call.params.map(function (param) {
                return param.value;
              });
              _context2.prev = 14;
              _context2.next = 17;
              return contract.getAssetsPrices.apply(contract, _toConsumableArray(values).concat([{
                from: _this.account
              }]));
            case 17:
              data = _context2.sent;
              if (data) {
                _context2.next = 20;
                break;
              }
              return _context2.abrupt("return", undefined);
            case 20:
              return _context2.abrupt("return", filtredAssets === null || filtredAssets === void 0 ? void 0 : filtredAssets.map(function (asset, i) {
                var priceInEth = normalize(data[i].toString(), 18);
                return _objectSpread$1({
                  wei: data[i].toString(),
                  eth: priceInEth,
                  usd: usdPriceEth ? new BN(priceInEth).multipliedBy(usdPriceEth).toFixed(2) : undefined
                }, asset);
              }));
            case 23:
              _context2.prev = 23;
              _context2.t0 = _context2["catch"](14);
              console.error(_context2.t0);
              return _context2.abrupt("return", undefined);
            case 27:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[14, 23]]);
      }));
      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getAssetAvailableBorrowPower", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref6) {
        var asset, account, usdPriceEth, userAccountData, availableBorrowsETH, availableBorrowEth, assetEthPrice, availableBorrowEthETH, assetBorrowPower, assetBorrowPowerUsd;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              asset = _ref6.asset, account = _ref6.account, usdPriceEth = _ref6.usdPriceEth;
              _context3.next = 3;
              return _this.getUserAccountData({
                account: account
              });
            case 3:
              userAccountData = _context3.sent;
              if (userAccountData) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return");
            case 6:
              availableBorrowsETH = userAccountData.availableBorrowsETH;
              availableBorrowEth = new BN(availableBorrowsETH);
              _context3.next = 10;
              return _this.getAssetPrice({
                asset: asset,
                usdPriceEth: usdPriceEth
              });
            case 10:
              assetEthPrice = _context3.sent;
              if (assetEthPrice) {
                _context3.next = 13;
                break;
              }
              return _context3.abrupt("return");
            case 13:
              availableBorrowEthETH = normalize(availableBorrowEth, 18);
              assetBorrowPower = new BN(availableBorrowEthETH).dividedBy(assetEthPrice.eth).multipliedBy(0.99);
              assetBorrowPowerUsd = assetEthPrice.usd ? assetBorrowPower.multipliedBy(assetEthPrice.usd).toFixed(2) : undefined;
              return _context3.abrupt("return", {
                eth: assetBorrowPower.toString(),
                usd: assetBorrowPowerUsd
              });
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref7.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getReserveTokensAddresses", /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref8) {
        var asset, reserveTokensAddresses, contract, data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              asset = _ref8.asset;
              reserveTokensAddresses = new AaveV2.getters.GetReserveTokensAddresses({
                chainId: String(_this.chainId),
                initParams: {
                  methodParams: {
                    asset: asset
                  }
                }
              });
              contract = _this.createContract({
                address: reserveTokensAddresses.input.params.to.value,
                contractInterface: reserveTokensAddresses.contractInterface,
                returns: reserveTokensAddresses.contractInterfaceReturns
              });
              _context4.prev = 3;
              _context4.next = 6;
              return contract.getReserveTokensAddresses(asset, {
                from: _this.account
              });
            case 6:
              data = _context4.sent;
              if (!(!data || _typeof(data) !== 'object' || !data.length)) {
                _context4.next = 9;
                break;
              }
              return _context4.abrupt("return", undefined);
            case 9:
              return _context4.abrupt("return", {
                aTokenAddress: data[0],
                stableDebtTokenAddress: data[1],
                variableDebtTokenAddress: data[2]
              });
            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](3);
              console.error(_context4.t0);
              return _context4.abrupt("return", undefined);
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[3, 12]]);
      }));
      return function (_x4) {
        return _ref9.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getReserveTokensAddressesV3", /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref10) {
        var asset, reserveTokensAddresses, contract, data;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              asset = _ref10.asset;
              reserveTokensAddresses = new AaveV3.getters.GetReserveData({
                chainId: String(_this.chainId),
                initParams: {
                  methodParams: {
                    asset: asset
                  }
                }
              });
              contract = _this.createContract({
                address: reserveTokensAddresses.input.params.to.value,
                contractInterface: reserveTokensAddresses.contractInterface,
                returns: reserveTokensAddresses.contractInterfaceReturns
              });
              _context5.prev = 3;
              _context5.next = 6;
              return contract.getReserveData(asset, {
                from: _this.account
              });
            case 6:
              data = _context5.sent;
              if (!(!data || _typeof(data) !== 'object' || !data.length)) {
                _context5.next = 9;
                break;
              }
              return _context5.abrupt("return", undefined);
            case 9:
              return _context5.abrupt("return", {
                aTokenAddress: data[8],
                stableDebtTokenAddress: data[9],
                variableDebtTokenAddress: data[10],
                underlyingAssetAddress: asset
              });
            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](3);
              console.error(_context5.t0);
              return _context5.abrupt("return", undefined);
            case 16:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[3, 12]]);
      }));
      return function (_x5) {
        return _ref11.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getUserAssetBalance", /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref12) {
        var asset, account, usdPriceEth, balances;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              asset = _ref12.asset, account = _ref12.account, usdPriceEth = _ref12.usdPriceEth;
              _context6.next = 3;
              return _this.getUserAssetsBalances({
                account: account,
                usdPriceEth: usdPriceEth,
                options: {
                  assets: [asset]
                }
              });
            case 3:
              balances = _context6.sent;
              if (balances) {
                _context6.next = 6;
                break;
              }
              return _context6.abrupt("return");
            case 6:
              return _context6.abrupt("return", balances[0]);
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x6) {
        return _ref13.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getUserAssetsBalances", /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref14) {
        var account, usdPriceEth, _ref14$options, options, assets, sortBy, prices, balances;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              account = _ref14.account, usdPriceEth = _ref14.usdPriceEth, _ref14$options = _ref14.options, options = _ref14$options === void 0 ? {} : _ref14$options;
              assets = options.assets;
              sortBy = options.sortBy ? options.sortBy : 'wallet';
              _context8.next = 5;
              return _this.getAssetsPrices({
                usdPriceEth: usdPriceEth,
                assets: assets
              });
            case 5:
              prices = _context8.sent;
              if (prices) {
                _context8.next = 8;
                break;
              }
              return _context8.abrupt("return");
            case 8:
              _context8.next = 10;
              return Promise.all(prices.map( /*#__PURE__*/function () {
                var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(price) {
                  var value, usd, symbol, decimals, logoURI, name, asset, address, userReserveData, currentATokenBalance, currentStableDebt, currentVariableDebt, currentSupplyEth, currentStableDebtEth, currentVariableDebtEth, erc20Contract, walletBallanceWei, walletBallanceEth, walletBalanceEthUsd, currentSupplyEthUsd, currentStableDebtUsd, currentVariableDebtUsd, apy;
                  return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        value = price.value, usd = price.usd, symbol = price.symbol, decimals = price.decimals, logoURI = price.logoURI, name = price.name;
                        asset = value;
                        address = value;
                        _context7.next = 5;
                        return _this.getUserReserveData({
                          account: account,
                          asset: asset
                        });
                      case 5:
                        userReserveData = _context7.sent;
                        if (userReserveData) {
                          _context7.next = 8;
                          break;
                        }
                        return _context7.abrupt("return");
                      case 8:
                        currentATokenBalance = userReserveData.currentATokenBalance, currentStableDebt = userReserveData.currentStableDebt, currentVariableDebt = userReserveData.currentVariableDebt;
                        currentSupplyEth = normalize(currentATokenBalance, 18);
                        currentStableDebtEth = normalize(currentStableDebt, 18);
                        currentVariableDebtEth = normalize(currentVariableDebt, 18);
                        erc20Contract = new ethers.Contract(asset, ['function balanceOf(address _owner) view returns (uint256 balance)'], _this.library);
                        _context7.next = 15;
                        return erc20Contract.balanceOf(account);
                      case 15:
                        walletBallanceWei = _context7.sent.toString();
                        walletBallanceEth = normalize(walletBallanceWei, decimals || 18);
                        walletBalanceEthUsd = usd ? new BN(walletBallanceEth).multipliedBy(usd).toFixed(2) : undefined;
                        currentSupplyEthUsd = usd ? new BN(currentSupplyEth).multipliedBy(usd).toFixed(2) : undefined;
                        currentStableDebtUsd = usd ? new BN(currentStableDebtEth).multipliedBy(usd).toFixed(2) : undefined;
                        currentVariableDebtUsd = usd ? new BN(currentVariableDebtEth).multipliedBy(usd).toFixed(2) : undefined;
                        _context7.next = 23;
                        return _this.getAssetAPY({
                          asset: asset
                        });
                      case 23:
                        apy = _context7.sent;
                        return _context7.abrupt("return", {
                          wallet: {
                            eth: walletBallanceEth,
                            usd: walletBalanceEthUsd,
                            apy: apy === null || apy === void 0 ? void 0 : apy.supplyAPY
                          },
                          supplied: {
                            eth: currentSupplyEth,
                            usd: currentSupplyEthUsd,
                            apy: apy === null || apy === void 0 ? void 0 : apy.supplyAPY
                          },
                          stableDebt: {
                            eth: currentStableDebtEth,
                            usd: currentStableDebtUsd,
                            apy: apy === null || apy === void 0 ? void 0 : apy.stableBorrowAPY
                          },
                          variableDebt: {
                            eth: currentVariableDebtEth,
                            usd: currentVariableDebtUsd,
                            apy: apy === null || apy === void 0 ? void 0 : apy.variableBorrowAPY
                          },
                          address: address,
                          symbol: symbol,
                          name: name,
                          decimals: decimals,
                          logoURI: logoURI
                        });
                      case 25:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x8) {
                  return _ref16.apply(this, arguments);
                };
              }()));
            case 10:
              balances = _context8.sent;
              return _context8.abrupt("return", balances.sort(function (price1, price2) {
                if (!price1) return 1;
                if (!price2) return -1;
                return new BN(price1[sortBy].usd || price1[sortBy].eth || '0').gte(price2[sortBy].usd || price2[sortBy].eth || '0') ? -1 : 1;
              }));
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      return function (_x7) {
        return _ref15.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getUserReserveData", /*#__PURE__*/function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref17) {
        var asset, account, userReserveData, contract, call, values, data;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              asset = _ref17.asset, account = _ref17.account;
              userReserveData = new AaveV2.getters.GetUserReserveData({
                chainId: String(_this.chainId),
                initParams: {
                  methodParams: {
                    asset: asset,
                    user: account
                  }
                }
              });
              contract = _this.createContract({
                address: userReserveData.input.params.to.value,
                contractInterface: userReserveData.contractInterface,
                returns: userReserveData.contractInterfaceReturns
              });
              _context9.next = 5;
              return userReserveData.create();
            case 5:
              call = _context9.sent;
              values = call === null || call === void 0 ? void 0 : call.params.map(function (param) {
                return param.value;
              });
              _context9.prev = 7;
              _context9.next = 10;
              return contract.getUserReserveData.apply(contract, _toConsumableArray(values).concat([{
                from: _this.account
              }]));
            case 10:
              data = _context9.sent;
              if (!(!data || _typeof(data) !== 'object' || !data.length)) {
                _context9.next = 13;
                break;
              }
              return _context9.abrupt("return", undefined);
            case 13:
              return _context9.abrupt("return", {
                currentATokenBalance: data[0].toString(),
                currentStableDebt: data[1].toString(),
                currentVariableDebt: data[2].toString(),
                principalStableDebt: data[3].toString(),
                scaledVariableDebt: data[4].toString(),
                stableBorrowRate: data[5].toString(),
                liquidityRate: data[6].toString(),
                stableRateLastUpdated: data[7],
                usageAsCollateralEnabled: data[8]
              });
            case 16:
              _context9.prev = 16;
              _context9.t0 = _context9["catch"](7);
              console.error(_context9.t0);
              return _context9.abrupt("return", undefined);
            case 20:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[7, 16]]);
      }));
      return function (_x9) {
        return _ref18.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getUserAccountData", /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref19) {
        var account, userAccountData, contract, call, values, data;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              account = _ref19.account;
              userAccountData = new AaveV2.getters.GetUserAccountData({
                chainId: String(_this.chainId),
                initParams: {
                  methodParams: {
                    user: account
                  }
                }
              });
              contract = _this.createContract({
                address: userAccountData.input.params.to.value,
                contractInterface: userAccountData.contractInterface,
                returns: userAccountData.contractInterfaceReturns
              });
              _context10.next = 5;
              return userAccountData.create();
            case 5:
              call = _context10.sent;
              values = call === null || call === void 0 ? void 0 : call.params.map(function (param) {
                return param.value;
              });
              _context10.prev = 7;
              _context10.next = 10;
              return contract.getUserAccountData.apply(contract, _toConsumableArray(values).concat([{
                from: _this.account
              }]));
            case 10:
              data = _context10.sent;
              if (!(!data || _typeof(data) !== 'object' || !data.length)) {
                _context10.next = 13;
                break;
              }
              return _context10.abrupt("return", undefined);
            case 13:
              return _context10.abrupt("return", {
                totalCollateralETH: data[0].toString(),
                totalDebtETH: data[1].toString(),
                availableBorrowsETH: data[2].toString(),
                currentLiquidationThreshold: data[3].toString(),
                ltv: data[4].toString(),
                healthFactor: data[5].toString()
              });
            case 16:
              _context10.prev = 16;
              _context10.t0 = _context10["catch"](7);
              console.error(_context10.t0);
              return _context10.abrupt("return", undefined);
            case 20:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[7, 16]]);
      }));
      return function (_x10) {
        return _ref20.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getReserveData", /*#__PURE__*/function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref21) {
        var asset, userReserveData, contract, call, values, data;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              asset = _ref21.asset;
              userReserveData = new AaveV2.getters.GetReserveData({
                chainId: String(_this.chainId),
                initParams: {
                  methodParams: {
                    asset: asset
                  }
                }
              });
              contract = _this.createContract({
                address: userReserveData.input.params.to.value,
                contractInterface: userReserveData.contractInterface,
                returns: userReserveData.contractInterfaceReturns
              });
              _context11.next = 5;
              return userReserveData.create();
            case 5:
              call = _context11.sent;
              values = call === null || call === void 0 ? void 0 : call.params.map(function (param) {
                return param.value;
              });
              _context11.prev = 7;
              _context11.next = 10;
              return contract.getReserveData.apply(contract, _toConsumableArray(values).concat([{
                from: _this.account
              }]));
            case 10:
              data = _context11.sent;
              if (!(!data || _typeof(data) !== 'object' || !data.length)) {
                _context11.next = 13;
                break;
              }
              return _context11.abrupt("return", undefined);
            case 13:
              return _context11.abrupt("return", {
                configuratio: data[0].toString(),
                liquidityIndex: data[1].toString(),
                variableBorrowIndex: data[2].toString(),
                currentLiquidityRate: data[3].toString(),
                currentVariableBorrowRate: data[4].toString(),
                currentStableBorrowRate: data[5].toString(),
                lastUpdateTimestamp: data[6].toString(),
                aTokenAddress: data[7],
                stableDebtTokenAddress: data[9],
                variableDebtTokenAddress: data[10],
                interestRateStrategyAddress: data[11],
                id: data[12]
              });
            case 16:
              _context11.prev = 16;
              _context11.t0 = _context11["catch"](7);
              console.error(_context11.t0);
              return _context11.abrupt("return", undefined);
            case 20:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[7, 16]]);
      }));
      return function (_x11) {
        return _ref22.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getAssetReserveData", /*#__PURE__*/function () {
      var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref23) {
        var asset, reserveDataProvider, contract, call, values, data;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              asset = _ref23.asset;
              reserveDataProvider = new AaveV2.getters.GetAssetReserveData({
                chainId: String(_this.chainId),
                initParams: {
                  methodParams: {
                    asset: asset
                  }
                }
              });
              contract = _this.createContract({
                address: reserveDataProvider.input.params.to.value,
                contractInterface: reserveDataProvider.contractInterface,
                returns: reserveDataProvider.contractInterfaceReturns
              });
              _context12.next = 5;
              return reserveDataProvider.create();
            case 5:
              call = _context12.sent;
              values = call === null || call === void 0 ? void 0 : call.params.map(function (param) {
                return param.value;
              });
              _context12.prev = 7;
              _context12.next = 10;
              return contract.getReserveData.apply(contract, _toConsumableArray(values).concat([{
                from: _this.account
              }]));
            case 10:
              data = _context12.sent;
              if (!(!data || _typeof(data) !== 'object' || !data.length)) {
                _context12.next = 13;
                break;
              }
              return _context12.abrupt("return", undefined);
            case 13:
              return _context12.abrupt("return", {
                availableLiquidity: data[0].toString(),
                totalStableDebt: data[1].toString(),
                totalVariableDebt: data[2].toString(),
                supplyRate: data[3].toString(),
                variableBorrowRate: data[4].toString(),
                stableBorrowRate: data[5].toString(),
                averageStableBorrowRate: data[6].toString(),
                liquidityIndex: data[6].toString(),
                variableBorrowIndex: data[8].toString(),
                lastUpdateTimestamp: data[9].toString()
              });
            case 16:
              _context12.prev = 16;
              _context12.t0 = _context12["catch"](7);
              console.error(_context12.t0);
              return _context12.abrupt("return", undefined);
            case 20:
            case "end":
              return _context12.stop();
          }
        }, _callee12, null, [[7, 16]]);
      }));
      return function (_x12) {
        return _ref24.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getAssetReserveDataV3", /*#__PURE__*/function () {
      var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref25) {
        var asset, reserveDataProvider, contract, call, values, data;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              asset = _ref25.asset;
              reserveDataProvider = new AaveV3.getters.GetReserveData({
                chainId: String(_this.chainId),
                initParams: {
                  methodParams: {
                    asset: asset
                  }
                }
              });
              contract = _this.createContract({
                address: reserveDataProvider.input.params.to.value,
                contractInterface: reserveDataProvider.contractInterface,
                returns: reserveDataProvider.contractInterfaceReturns
              });
              _context13.next = 5;
              return reserveDataProvider.create();
            case 5:
              call = _context13.sent;
              values = call === null || call === void 0 ? void 0 : call.params.map(function (param) {
                return param.value;
              });
              _context13.prev = 7;
              _context13.next = 10;
              return contract.getReserveData.apply(contract, _toConsumableArray(values).concat([{
                from: _this.account
              }]));
            case 10:
              data = _context13.sent;
              if (!(!data || _typeof(data) !== 'object' || !data.length)) {
                _context13.next = 13;
                break;
              }
              return _context13.abrupt("return", undefined);
            case 13:
              return _context13.abrupt("return", {
                availableLiquidity: data[0].toString(),
                totalStableDebt: data[1].toString(),
                totalVariableDebt: data[2].toString(),
                supplyRate: data[3].toString(),
                variableBorrowRate: data[4].toString(),
                stableBorrowRate: data[5].toString(),
                averageStableBorrowRate: data[6].toString(),
                liquidityIndex: data[6].toString(),
                variableBorrowIndex: data[8].toString(),
                lastUpdateTimestamp: data[9].toString()
              });
            case 16:
              _context13.prev = 16;
              _context13.t0 = _context13["catch"](7);
              console.error(_context13.t0);
              return _context13.abrupt("return", undefined);
            case 20:
            case "end":
              return _context13.stop();
          }
        }, _callee13, null, [[7, 16]]);
      }));
      return function (_x13) {
        return _ref26.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getReserveConfigurationData", /*#__PURE__*/function () {
      var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref27) {
        var asset, reserveConfigurationData, contract, call, values, data;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              asset = _ref27.asset;
              reserveConfigurationData = new AaveV2.getters.GetReserveConfigurationData({
                chainId: String(_this.chainId),
                initParams: {
                  methodParams: {
                    asset: asset
                  }
                }
              });
              contract = _this.createContract({
                address: reserveConfigurationData.input.params.to.value,
                contractInterface: reserveConfigurationData.contractInterface,
                returns: reserveConfigurationData.contractInterfaceReturns
              });
              _context14.next = 5;
              return reserveConfigurationData.create();
            case 5:
              call = _context14.sent;
              values = call === null || call === void 0 ? void 0 : call.params.map(function (param) {
                return param.value;
              });
              _context14.prev = 7;
              _context14.next = 10;
              return contract.getReserveConfigurationData.apply(contract, _toConsumableArray(values).concat([{
                from: _this.account
              }]));
            case 10:
              data = _context14.sent;
              if (!(!data || _typeof(data) !== 'object' || !data.length)) {
                _context14.next = 13;
                break;
              }
              return _context14.abrupt("return", undefined);
            case 13:
              return _context14.abrupt("return", {
                decimals: data[0].toString(),
                ltv: data[1].toString(),
                liquidationThreshold: data[2].toString(),
                liquidationBonus: data[3].toString(),
                reserveFactor: data[4].toString(),
                usageAsCollateralEnabled: data[5],
                borrowingEnabled: data[6],
                stableBorrowRateEnabled: data[7],
                isActive: data[8],
                isFrozen: data[9]
              });
            case 16:
              _context14.prev = 16;
              _context14.t0 = _context14["catch"](7);
              console.error(_context14.t0);
              return _context14.abrupt("return", undefined);
            case 20:
            case "end":
              return _context14.stop();
          }
        }, _callee14, null, [[7, 16]]);
      }));
      return function (_x14) {
        return _ref28.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getAssetAPY", /*#__PURE__*/function () {
      var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref29) {
        var asset, version, RAY, SECONDS_PER_YEAR, reserveData, supplyRate, variableBorrowRate, stableBorrowRate, supplyAPY, variableBorrowAPY, stableBorrowAPY;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              asset = _ref29.asset, version = _ref29.version;
              RAY = _this.RAY;
              SECONDS_PER_YEAR = _this.SECONDS_PER_YEAR;
              if (!(version === 'V3')) {
                _context15.next = 9;
                break;
              }
              _context15.next = 6;
              return _this.getAssetReserveDataV3({
                asset: asset
              });
            case 6:
              _context15.t0 = _context15.sent;
              _context15.next = 12;
              break;
            case 9:
              _context15.next = 11;
              return _this.getAssetReserveData({
                asset: asset
              });
            case 11:
              _context15.t0 = _context15.sent;
            case 12:
              reserveData = _context15.t0;
              if (reserveData) {
                _context15.next = 15;
                break;
              }
              return _context15.abrupt("return", undefined);
            case 15:
              supplyRate = reserveData.supplyRate, variableBorrowRate = reserveData.variableBorrowRate, stableBorrowRate = reserveData.stableBorrowRate;
              supplyAPY = rayPow(valueToZDBigNumber(new BN(supplyRate)).dividedBy(SECONDS_PER_YEAR).plus(RAY), SECONDS_PER_YEAR).minus(RAY);
              variableBorrowAPY = rayPow(valueToZDBigNumber(new BN(variableBorrowRate)).dividedBy(SECONDS_PER_YEAR).plus(RAY), SECONDS_PER_YEAR).minus(RAY);
              stableBorrowAPY = rayPow(valueToZDBigNumber(new BN(stableBorrowRate)).dividedBy(SECONDS_PER_YEAR).plus(RAY), SECONDS_PER_YEAR).minus(RAY);
              return _context15.abrupt("return", {
                supplyAPY: normalize(supplyAPY.multipliedBy(100), RAY_DECIMALS),
                stableBorrowAPY: normalize(stableBorrowAPY.multipliedBy(100), RAY_DECIMALS),
                variableBorrowAPY: normalize(variableBorrowAPY.multipliedBy(100), RAY_DECIMALS),
                asset: asset
              });
            case 20:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
      return function (_x15) {
        return _ref30.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getAssetRateByApy", getAssetRateByApy);
    _defineProperty(_assertThisInitialized(_this), "getAssetAPYByRate", function (_ref31) {
      var rate = _ref31.rate;
      var RAY = _this.RAY;
      var SECONDS_PER_YEAR = _this.SECONDS_PER_YEAR;
      var apy = rayPow(valueToZDBigNumber(new BN(rate)).dividedBy(SECONDS_PER_YEAR).plus(RAY), SECONDS_PER_YEAR).minus(RAY);
      return {
        apy: normalize(apy.multipliedBy(100), RAY_DECIMALS)
      };
    });
    return _this;
  }
  return _createClass(AaveHelper);
}(Config);

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ChainLinkHelper = /*#__PURE__*/function (_Config) {
  _inherits(ChainLinkHelper, _Config);
  var _super = _createSuper$2(ChainLinkHelper);
  function ChainLinkHelper() {
    var _this;
    _classCallCheck(this, ChainLinkHelper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getLatestRoundData", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(pairAddress) {
        var latestRoundData, contract, res, outputs, params;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              latestRoundData = new LatestRoundData({
                chainId: String(_this.chainId)
              });
              contract = new ethers.Contract(pairAddress, new ethers.utils.Interface(["function ".concat(latestRoundData.contractInterface, " view ").concat(latestRoundData.contractInterfaceReturns)]), _this.library);
              _context.next = 5;
              return contract.latestRoundData();
            case 5:
              res = _context.sent;
              if (res) {
                _context.next = 9;
                break;
              }
              console.error("latestRoundData request error for pair ".concat(pairAddress));
              return _context.abrupt("return", undefined);
            case 9:
              outputs = latestRoundData.output.params;
              params = {};
              Object.keys(outputs).forEach(function (key, i) {
                var outputKey = key;
                params[outputKey] = res[i].toString();
              });
              return _context.abrupt("return", params);
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
              return _context.abrupt("return");
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 15]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getPriceDecimals", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(pairAddress) {
        var dataFeedDecimals, contract, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              dataFeedDecimals = new DataFeedDecimals({
                chainId: String(_this.chainId)
              });
              contract = new ethers.Contract(pairAddress, new ethers.utils.Interface(["function ".concat(dataFeedDecimals.contractInterface, " view ").concat(dataFeedDecimals.contractInterfaceReturns)]), _this.library);
              _context2.next = 5;
              return contract.decimals();
            case 5:
              res = _context2.sent;
              if (res) {
                _context2.next = 9;
                break;
              }
              console.error("decimals request error for pair ".concat(pairAddress));
              return _context2.abrupt("return", undefined);
            case 9:
              return _context2.abrupt("return", res.toString());
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);
              return _context2.abrupt("return");
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 12]]);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    return _this;
  }
  return _createClass(ChainLinkHelper);
}(Config);

var ParaswapAugustusSwapperABI = [
	{
		inputs: [
			{
				internalType: "address payable",
				name: "_feeWallet",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "adapter",
				type: "address"
			}
		],
		name: "AdapterInitialized",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "previousAdminRole",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "bytes32",
				name: "newAdminRole",
				type: "bytes32"
			}
		],
		name: "RoleAdminChanged",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleGranted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			}
		],
		name: "RoleRevoked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "router",
				type: "address"
			}
		],
		name: "RouterInitialized",
		type: "event"
	},
	{
		stateMutability: "payable",
		type: "fallback"
	},
	{
		inputs: [
		],
		name: "DEFAULT_ADMIN_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "ROUTER_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "WHITELISTED_ROLE",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getAdapterData",
		outputs: [
			{
				internalType: "bytes",
				name: "",
				type: "bytes"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getFeeWallet",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes4",
				name: "selector",
				type: "bytes4"
			}
		],
		name: "getImplementation",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "partner",
				type: "address"
			}
		],
		name: "getPartnerFeeStructure",
		outputs: [
			{
				components: [
					{
						internalType: "uint256",
						name: "partnerShare",
						type: "uint256"
					},
					{
						internalType: "bool",
						name: "noPositiveSlippage",
						type: "bool"
					},
					{
						internalType: "bool",
						name: "positiveSlippageToUser",
						type: "bool"
					},
					{
						internalType: "uint16",
						name: "feePercent",
						type: "uint16"
					},
					{
						internalType: "string",
						name: "partnerId",
						type: "string"
					},
					{
						internalType: "bytes",
						name: "data",
						type: "bytes"
					}
				],
				internalType: "struct AugustusStorage.FeeStructure",
				name: "",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			}
		],
		name: "getRoleAdmin",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "index",
				type: "uint256"
			}
		],
		name: "getRoleMember",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			}
		],
		name: "getRoleMemberCount",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "getRouterData",
		outputs: [
			{
				internalType: "bytes",
				name: "",
				type: "bytes"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getTokenTransferProxy",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getVersion",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "grantRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "hasRole",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "adapter",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "initializeAdapter",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "router",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "initializeRouter",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "isAdapterInitialized",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "key",
				type: "bytes32"
			}
		],
		name: "isRouterInitialized",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "partner",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "_partnerShare",
				type: "uint256"
			},
			{
				internalType: "bool",
				name: "_noPositiveSlippage",
				type: "bool"
			},
			{
				internalType: "bool",
				name: "_positiveSlippageToUser",
				type: "bool"
			},
			{
				internalType: "uint16",
				name: "_feePercent",
				type: "uint16"
			},
			{
				internalType: "string",
				name: "partnerId",
				type: "string"
			},
			{
				internalType: "bytes",
				name: "_data",
				type: "bytes"
			}
		],
		name: "registerPartner",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "renounceRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "role",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "revokeRole",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address payable",
				name: "_feeWallet",
				type: "address"
			}
		],
		name: "setFeeWallet",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes4",
				name: "selector",
				type: "bytes4"
			},
			{
				internalType: "address",
				name: "implementation",
				type: "address"
			}
		],
		name: "setImplementation",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "address payable",
				name: "destination",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transferTokens",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		stateMutability: "payable",
		type: "receive"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "bytes16",
				name: "uuid",
				type: "bytes16"
			},
			{
				indexed: false,
				internalType: "address",
				name: "initiator",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "beneficiary",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "srcToken",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "destToken",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "srcAmount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "receivedAmount",
				type: "uint256"
			}
		],
		name: "Bought",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "uint256",
				name: "fee",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "partnerShare",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "paraswapShare",
				type: "uint256"
			}
		],
		name: "FeeTaken",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "bytes16",
				name: "uuid",
				type: "bytes16"
			},
			{
				indexed: false,
				internalType: "address",
				name: "initiator",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "beneficiary",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "srcToken",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "destToken",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "srcAmount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "receivedAmount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "expectedAmount",
				type: "uint256"
			}
		],
		name: "Swapped",
		type: "event"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountInMax",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			}
		],
		name: "buyOnUniswap",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "factory",
				type: "address"
			},
			{
				internalType: "bytes32",
				name: "initCode",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "amountInMax",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			}
		],
		name: "buyOnUniswapFork",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "tokenIn",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amountInMax",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOut",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "weth",
				type: "address"
			},
			{
				internalType: "uint256[]",
				name: "pools",
				type: "uint256[]"
			}
		],
		name: "buyOnUniswapV2Fork",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "fromToken",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "fromAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "toAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "expectedAmount",
						type: "uint256"
					},
					{
						internalType: "address payable",
						name: "beneficiary",
						type: "address"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "fromAmountPercent",
								type: "uint256"
							},
							{
								components: [
									{
										internalType: "address",
										name: "to",
										type: "address"
									},
									{
										internalType: "uint256",
										name: "totalNetworkFee",
										type: "uint256"
									},
									{
										components: [
											{
												internalType: "address payable",
												name: "adapter",
												type: "address"
											},
											{
												internalType: "uint256",
												name: "percent",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "networkFee",
												type: "uint256"
											},
											{
												components: [
													{
														internalType: "uint256",
														name: "index",
														type: "uint256"
													},
													{
														internalType: "address",
														name: "targetExchange",
														type: "address"
													},
													{
														internalType: "uint256",
														name: "percent",
														type: "uint256"
													},
													{
														internalType: "bytes",
														name: "payload",
														type: "bytes"
													},
													{
														internalType: "uint256",
														name: "networkFee",
														type: "uint256"
													}
												],
												internalType: "struct Utils.Route[]",
												name: "route",
												type: "tuple{}"
											}
										],
										internalType: "struct Utils.Adapter[]",
										name: "adapters",
										type: "tuple{}"
									}
								],
								internalType: "struct Utils.Path[]",
								name: "path",
								type: "tuple{}"
							}
						],
						internalType: "struct Utils.MegaSwapPath[]",
						name: "path",
						type: "tuple{}"
					},
					{
						internalType: "address payable",
						name: "partner",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "feePercent",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "permit",
						type: "bytes"
					},
					{
						internalType: "uint256",
						name: "deadline",
						type: "uint256"
					},
					{
						internalType: "bytes16",
						name: "uuid",
						type: "bytes16"
					}
				],
				internalType: "struct Utils.MegaSwapSellData",
				name: "data",
				type: "tuple"
			}
		],
		name: "megaSwap",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "fromToken",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "fromAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "toAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "expectedAmount",
						type: "uint256"
					},
					{
						internalType: "address payable",
						name: "beneficiary",
						type: "address"
					},
					{
						components: [
							{
								internalType: "address",
								name: "to",
								type: "address"
							},
							{
								internalType: "uint256",
								name: "totalNetworkFee",
								type: "uint256"
							},
							{
								components: [
									{
										internalType: "address payable",
										name: "adapter",
										type: "address"
									},
									{
										internalType: "uint256",
										name: "percent",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "networkFee",
										type: "uint256"
									},
									{
										components: [
											{
												internalType: "uint256",
												name: "index",
												type: "uint256"
											},
											{
												internalType: "address",
												name: "targetExchange",
												type: "address"
											},
											{
												internalType: "uint256",
												name: "percent",
												type: "uint256"
											},
											{
												internalType: "bytes",
												name: "payload",
												type: "bytes"
											},
											{
												internalType: "uint256",
												name: "networkFee",
												type: "uint256"
											}
										],
										internalType: "struct Utils.Route[]",
										name: "route",
										type: "tuple{}"
									}
								],
								internalType: "struct Utils.Adapter[]",
								name: "adapters",
								type: "tuple{}"
							}
						],
						internalType: "struct Utils.Path[]",
						name: "path",
						type: "tuple{}"
					},
					{
						internalType: "address payable",
						name: "partner",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "feePercent",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "permit",
						type: "bytes"
					},
					{
						internalType: "uint256",
						name: "deadline",
						type: "uint256"
					},
					{
						internalType: "bytes16",
						name: "uuid",
						type: "bytes16"
					}
				],
				internalType: "struct Utils.SellData",
				name: "data",
				type: "tuple"
			}
		],
		name: "multiSwap",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "fromToken",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "fromAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "toAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "expectedAmount",
						type: "uint256"
					},
					{
						internalType: "address payable",
						name: "beneficiary",
						type: "address"
					},
					{
						components: [
							{
								internalType: "uint256",
								name: "fromAmountPercent",
								type: "uint256"
							},
							{
								components: [
									{
										internalType: "address",
										name: "to",
										type: "address"
									},
									{
										internalType: "uint256",
										name: "totalNetworkFee",
										type: "uint256"
									},
									{
										components: [
											{
												internalType: "address payable",
												name: "adapter",
												type: "address"
											},
											{
												internalType: "uint256",
												name: "percent",
												type: "uint256"
											},
											{
												internalType: "uint256",
												name: "networkFee",
												type: "uint256"
											},
											{
												components: [
													{
														internalType: "uint256",
														name: "index",
														type: "uint256"
													},
													{
														internalType: "address",
														name: "targetExchange",
														type: "address"
													},
													{
														internalType: "uint256",
														name: "percent",
														type: "uint256"
													},
													{
														internalType: "bytes",
														name: "payload",
														type: "bytes"
													},
													{
														internalType: "uint256",
														name: "networkFee",
														type: "uint256"
													}
												],
												internalType: "struct Utils.Route[]",
												name: "route",
												type: "tuple{}"
											}
										],
										internalType: "struct Utils.Adapter[]",
										name: "adapters",
										type: "tuple{}"
									}
								],
								internalType: "struct Utils.Path[]",
								name: "path",
								type: "tuple{}"
							}
						],
						internalType: "struct Utils.MegaSwapPath[]",
						name: "path",
						type: "tuple{}"
					},
					{
						internalType: "address payable",
						name: "partner",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "feePercent",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "permit",
						type: "bytes"
					},
					{
						internalType: "uint256",
						name: "deadline",
						type: "uint256"
					},
					{
						internalType: "bytes16",
						name: "uuid",
						type: "bytes16"
					}
				],
				internalType: "struct Utils.MegaSwapSellData",
				name: "data",
				type: "tuple"
			}
		],
		name: "protectedMegaSwap",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "fromToken",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "fromAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "toAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "expectedAmount",
						type: "uint256"
					},
					{
						internalType: "address payable",
						name: "beneficiary",
						type: "address"
					},
					{
						components: [
							{
								internalType: "address",
								name: "to",
								type: "address"
							},
							{
								internalType: "uint256",
								name: "totalNetworkFee",
								type: "uint256"
							},
							{
								components: [
									{
										internalType: "address payable",
										name: "adapter",
										type: "address"
									},
									{
										internalType: "uint256",
										name: "percent",
										type: "uint256"
									},
									{
										internalType: "uint256",
										name: "networkFee",
										type: "uint256"
									},
									{
										components: [
											{
												internalType: "uint256",
												name: "index",
												type: "uint256"
											},
											{
												internalType: "address",
												name: "targetExchange",
												type: "address"
											},
											{
												internalType: "uint256",
												name: "percent",
												type: "uint256"
											},
											{
												internalType: "bytes",
												name: "payload",
												type: "bytes"
											},
											{
												internalType: "uint256",
												name: "networkFee",
												type: "uint256"
											}
										],
										internalType: "struct Utils.Route[]",
										name: "route",
										type: "tuple{}"
									}
								],
								internalType: "struct Utils.Adapter[]",
								name: "adapters",
								type: "tuple{}"
							}
						],
						internalType: "struct Utils.Path[]",
						name: "path",
						type: "tuple{}"
					},
					{
						internalType: "address payable",
						name: "partner",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "feePercent",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "permit",
						type: "bytes"
					},
					{
						internalType: "uint256",
						name: "deadline",
						type: "uint256"
					},
					{
						internalType: "bytes16",
						name: "uuid",
						type: "bytes16"
					}
				],
				internalType: "struct Utils.SellData",
				name: "data",
				type: "tuple"
			}
		],
		name: "protectedMultiSwap",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "fromToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "toToken",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "fromAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "toAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "expectedAmount",
						type: "uint256"
					},
					{
						internalType: "address[]",
						name: "callees",
						type: "address[]"
					},
					{
						internalType: "bytes",
						name: "exchangeData",
						type: "bytes"
					},
					{
						internalType: "uint256[]",
						name: "startIndexes",
						type: "uint256[]"
					},
					{
						internalType: "uint256[]",
						name: "values",
						type: "uint256[]"
					},
					{
						internalType: "address payable",
						name: "beneficiary",
						type: "address"
					},
					{
						internalType: "address payable",
						name: "partner",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "feePercent",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "permit",
						type: "bytes"
					},
					{
						internalType: "uint256",
						name: "deadline",
						type: "uint256"
					},
					{
						internalType: "bytes16",
						name: "uuid",
						type: "bytes16"
					}
				],
				internalType: "struct Utils.SimpleData",
				name: "data",
				type: "tuple"
			}
		],
		name: "protectedSimpleBuy",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "fromToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "toToken",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "fromAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "toAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "expectedAmount",
						type: "uint256"
					},
					{
						internalType: "address[]",
						name: "callees",
						type: "address[]"
					},
					{
						internalType: "bytes",
						name: "exchangeData",
						type: "bytes"
					},
					{
						internalType: "uint256[]",
						name: "startIndexes",
						type: "uint256[]"
					},
					{
						internalType: "uint256[]",
						name: "values",
						type: "uint256[]"
					},
					{
						internalType: "address payable",
						name: "beneficiary",
						type: "address"
					},
					{
						internalType: "address payable",
						name: "partner",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "feePercent",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "permit",
						type: "bytes"
					},
					{
						internalType: "uint256",
						name: "deadline",
						type: "uint256"
					},
					{
						internalType: "bytes16",
						name: "uuid",
						type: "bytes16"
					}
				],
				internalType: "struct Utils.SimpleData",
				name: "data",
				type: "tuple"
			}
		],
		name: "protectedSimpleSwap",
		outputs: [
			{
				internalType: "uint256",
				name: "receivedAmount",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "fromToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "toToken",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "fromAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "toAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "expectedAmount",
						type: "uint256"
					},
					{
						internalType: "address[]",
						name: "callees",
						type: "address[]"
					},
					{
						internalType: "bytes",
						name: "exchangeData",
						type: "bytes"
					},
					{
						internalType: "uint256[]",
						name: "startIndexes",
						type: "uint256[]"
					},
					{
						internalType: "uint256[]",
						name: "values",
						type: "uint256[]"
					},
					{
						internalType: "address payable",
						name: "beneficiary",
						type: "address"
					},
					{
						internalType: "address payable",
						name: "partner",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "feePercent",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "permit",
						type: "bytes"
					},
					{
						internalType: "uint256",
						name: "deadline",
						type: "uint256"
					},
					{
						internalType: "bytes16",
						name: "uuid",
						type: "bytes16"
					}
				],
				internalType: "struct Utils.SimpleData",
				name: "data",
				type: "tuple"
			}
		],
		name: "simpleBuy",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "fromToken",
						type: "address"
					},
					{
						internalType: "address",
						name: "toToken",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "fromAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "toAmount",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "expectedAmount",
						type: "uint256"
					},
					{
						internalType: "address[]",
						name: "callees",
						type: "address[]"
					},
					{
						internalType: "bytes",
						name: "exchangeData",
						type: "bytes"
					},
					{
						internalType: "uint256[]",
						name: "startIndexes",
						type: "uint256[]"
					},
					{
						internalType: "uint256[]",
						name: "values",
						type: "uint256[]"
					},
					{
						internalType: "address payable",
						name: "beneficiary",
						type: "address"
					},
					{
						internalType: "address payable",
						name: "partner",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "feePercent",
						type: "uint256"
					},
					{
						internalType: "bytes",
						name: "permit",
						type: "bytes"
					},
					{
						internalType: "uint256",
						name: "deadline",
						type: "uint256"
					},
					{
						internalType: "bytes16",
						name: "uuid",
						type: "bytes16"
					}
				],
				internalType: "struct Utils.SimpleData",
				name: "data",
				type: "tuple"
			}
		],
		name: "simpleSwap",
		outputs: [
			{
				internalType: "uint256",
				name: "receivedAmount",
				type: "uint256"
			}
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			}
		],
		name: "swapOnUniswap",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "factory",
				type: "address"
			},
			{
				internalType: "bytes32",
				name: "initCode",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "path",
				type: "address[]"
			}
		],
		name: "swapOnUniswapFork",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "tokenIn",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amountIn",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "weth",
				type: "address"
			},
			{
				internalType: "uint256[]",
				name: "pools",
				type: "uint256[]"
			}
		],
		name: "swapOnUniswapV2Fork",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract IERC20",
				name: "fromToken",
				type: "address"
			},
			{
				internalType: "contract IERC20",
				name: "toToken",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "fromAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "exchange",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "payload",
				type: "bytes"
			}
		],
		name: "swapOnZeroXv2",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract IERC20",
				name: "fromToken",
				type: "address"
			},
			{
				internalType: "contract IERC20",
				name: "toToken",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "fromAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "amountOutMin",
				type: "uint256"
			},
			{
				internalType: "address",
				name: "exchange",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "payload",
				type: "bytes"
			}
		],
		name: "swapOnZeroXv4",
		outputs: [
		],
		stateMutability: "payable",
		type: "function"
	}
];

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var API_URL = 'https://apiv5.paraswap.io';
var REJECT_PREV_REQUEST_ERROR = 'reject previous values';
var ParaswapHelper = /*#__PURE__*/function (_Config) {
  _inherits(ParaswapHelper, _Config);
  var _super = _createSuper$1(ParaswapHelper);
  function ParaswapHelper() {
    var _this;
    _classCallCheck(this, ParaswapHelper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "promiseReject", undefined);
    _defineProperty(_assertThisInitialized(_this), "getSwapParams", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var values;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.getSwap(params);
            case 3:
              values = _context.sent;
              return _context.abrupt("return", values);
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              if (!(_context.t0 === REJECT_PREV_REQUEST_ERROR)) {
                _context.next = 11;
                break;
              }
              return _context.abrupt("return", undefined);
            case 11:
              throw new Error(_context.t0);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 7]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getSwap", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
        var _this$promiseReject, _this2;
        var input, output;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              input = _ref2.input, output = _ref2.output;
              (_this$promiseReject = (_this2 = _this).promiseReject) === null || _this$promiseReject === void 0 ? void 0 : _this$promiseReject.call(_this2, REJECT_PREV_REQUEST_ERROR);
              return _context3.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
                  var networkId, isExactIn, amount, queryParams, searchString, pricesURL, data, _yield$data$json, priceRoute, txURL, txConfig, txData, txDataJson, IParaswapSwapper, decodedTx;
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _this.promiseReject = reject;
                        _context2.prev = 1;
                        networkId = _this.chainId.toString();
                        isExactIn = Boolean(input.amount);
                        if (!(!isExactIn && !output.amount)) {
                          _context2.next = 6;
                          break;
                        }
                        throw new Error('Amount is missing');
                      case 6:
                        amount = isExactIn ? input.amount : output.amount;
                        queryParams = {
                          srcToken: input.currency.address,
                          destToken: output.currency.address,
                          srcDecimals: input.currency.decimals.toString(),
                          destDecimals: output.currency.decimals.toString(),
                          amount: amount,
                          side: isExactIn ? 'SELL' : 'BUY',
                          network: _this.chainId.toString()
                        };
                        searchString = new URLSearchParams(queryParams);
                        pricesURL = "".concat(API_URL, "/prices/?").concat(searchString);
                        _context2.next = 12;
                        return fetch(pricesURL);
                      case 12:
                        data = _context2.sent;
                        _context2.next = 15;
                        return data.json();
                      case 15:
                        _yield$data$json = _context2.sent;
                        priceRoute = _yield$data$json.priceRoute;
                        txURL = "".concat(API_URL, "/transactions/").concat(networkId, "?ignoreChecks=true");
                        txConfig = {
                          priceRoute: priceRoute,
                          srcToken: queryParams.srcToken,
                          srcDecimals: queryParams.srcDecimals,
                          destToken: queryParams.destToken,
                          destDecimals: queryParams.destDecimals,
                          srcAmount: priceRoute.srcAmount,
                          destAmount: priceRoute.destAmount,
                          userAddress: _this.account
                        };
                        _context2.next = 21;
                        return fetch(txURL, {
                          method: 'POST',
                          body: JSON.stringify(txConfig),
                          headers: {
                            'Content-Type': 'application/json'
                          }
                        });
                      case 21:
                        txData = _context2.sent;
                        _context2.next = 24;
                        return txData.json();
                      case 24:
                        txDataJson = _context2.sent;
                        // Decode txData
                        IParaswapSwapper = new Interface(ParaswapAugustusSwapperABI);
                        decodedTx = IParaswapSwapper.parseTransaction({
                          data: txDataJson.data,
                          value: txDataJson.value
                        });
                        resolve({
                          params: {
                            value: txDataJson.value,
                            methodParams: Object.entries(decodedTx.args).reduce(function (acc, _ref5) {
                              var _ref6 = _slicedToArray(_ref5, 2),
                                key = _ref6[0],
                                value = _ref6[1];
                              if (key === 'pools') {
                                if (Array.isArray(value)) {
                                  acc[key] = value.map(function (val) {
                                    return val.toString();
                                  });
                                } else {
                                  acc[key] = [value.toString()];
                                }
                              } else {
                                acc[key] = value.toString();
                              }
                              return acc;
                            }, {})
                          },
                          state: 'VALID',
                          methodName: decodedTx.name,
                          plugin: _this.getParaswapPlugin(decodedTx.name),
                          inputAmount: priceRoute.srcAmount,
                          outputAmount: priceRoute.destAmount,
                          protocol: 'PARASWAP'
                        });
                        _context2.next = 33;
                        break;
                      case 30:
                        _context2.prev = 30;
                        _context2.t0 = _context2["catch"](1);
                        reject(_context2.t0);
                      case 33:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, null, [[1, 30]]);
                }));
                return function (_x3, _x4) {
                  return _ref4.apply(this, arguments);
                };
              }()));
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "getParaswapPlugin", function (methodName) {
      var plugin = Object.values(Paraswap.actions).find(function (plugin) {
        var pluginInit = new plugin({
          chainId: '1'
        });
        return pluginInit.method === methodName;
      });
      return plugin;
    });
    return _this;
  }
  return _createClass(ParaswapHelper);
}(Config);

var tokenLists = {
  '1': getSupportedTokens({
    chainId: '1'
  }),
  '5': getSupportedTokens({
    chainId: '5'
  }),
  '42161': getSupportedTokens({
    chainId: '42161'
  }),
  '421613': getSupportedTokens({
    chainId: '421613'
  }),
  '11155111': getSupportedTokens({
    chainId: '11155111'
  })
};
var Utils = /*#__PURE__*/_createClass(function Utils() {
  _classCallCheck(this, Utils);
});
_defineProperty(Utils, "getSupportedTokens", function (_ref) {
  var chainId = _ref.chainId;
  return tokenLists[chainId];
});
_defineProperty(Utils, "getERC20Data", function (_ref2) {
  var chainId = _ref2.chainId,
    address = _ref2.address;
  var tokens = tokenLists[chainId];
  if (!tokens) throw new Error("ChainId ".concat(chainId, " not supported"));
  var token = tokens.find(function (token) {
    return getAddress(token.value) === getAddress(address);
  });
  if (!token) throw new Error("Data for token ".concat(address, " not found"));
  return token;
});
_defineProperty(Utils, "getErc20BalanceOf", /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
    var chainId, address, account, erc20Contract, balance;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          chainId = _ref3.chainId, address = _ref3.address, account = _ref3.account;
          erc20Contract = new ethers.Contract(address, ['function balanceOf(address _owner) view returns (uint256 balance)'], provider[chainId]);
          _context.next = 4;
          return erc20Contract.balanceOf(account);
        case 4:
          balance = _context.sent.toString();
          return _context.abrupt("return", balance);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref4.apply(this, arguments);
  };
}());
_defineProperty(Utils, "getErc721BalanceOf", Utils.getErc20BalanceOf);
_defineProperty(Utils, "getErc1155BalanceOf", /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref5) {
    var chainId, address, id, account, erc1155Contract, balance;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          chainId = _ref5.chainId, address = _ref5.address, id = _ref5.id, account = _ref5.account;
          erc1155Contract = new ethers.Contract(address, ['function balanceOf(address _owner, uint256 id) view returns (uint256 balance)'], provider[chainId]);
          _context2.next = 4;
          return erc1155Contract.balanceOf(account, id);
        case 4:
          balance = _context2.sent.toString();
          return _context2.abrupt("return", balance);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function (_x2) {
    return _ref6.apply(this, arguments);
  };
}());

var Utils$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Utils: Utils
});

var multicallAbi = [
	{
		inputs: [
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "address[]",
				name: "recipients",
				type: "address[]"
			}
		],
		name: "erc20Airdrop",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "token",
						type: "address"
					},
					{
						internalType: "address",
						name: "spender",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "amount",
						type: "uint256"
					}
				],
				internalType: "struct ERC20_Approval[]",
				name: "approvals",
				type: "tuple[]"
			}
		],
		name: "erc20Approvals",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				components: [
					{
						internalType: "address",
						name: "to",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "amount",
						type: "uint256"
					}
				],
				internalType: "struct ERC20_Mono_Transfer[]",
				name: "transfers",
				type: "tuple[]"
			}
		],
		name: "erc20MonoTransfers",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "token",
						type: "address"
					},
					{
						internalType: "address",
						name: "from",
						type: "address"
					},
					{
						internalType: "address",
						name: "to",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "amount",
						type: "uint256"
					}
				],
				internalType: "struct ERC20_Transfer[]",
				name: "transfers",
				type: "tuple[]"
			}
		],
		name: "erc20Transfers",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "target",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "value",
						type: "uint256"
					},
					{
						internalType: "bytes32",
						name: "method",
						type: "bytes32"
					},
					{
						internalType: "bytes",
						name: "data",
						type: "bytes"
					}
				],
				internalType: "struct Action[]",
				name: "actions",
				type: "tuple[]"
			}
		],
		name: "multiAction",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "target",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "value",
						type: "uint256"
					},
					{
						internalType: "bytes32",
						name: "method",
						type: "bytes32"
					},
					{
						internalType: "bytes",
						name: "data",
						type: "bytes"
					}
				],
				internalType: "struct Action[]",
				name: "actions",
				type: "tuple[]"
			}
		],
		name: "multiActionIgnoringReverts",
		outputs: [
			{
				internalType: "bool",
				name: "succeed",
				type: "bool"
			},
			{
				internalType: "bool[]",
				name: "returnSuccess",
				type: "bool[]"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "token",
						type: "address"
					},
					{
						internalType: "address",
						name: "owner",
						type: "address"
					},
					{
						internalType: "address",
						name: "spender",
						type: "address"
					}
				],
				internalType: "struct Allowance[]",
				name: "allowances",
				type: "tuple[]"
			}
		],
		name: "multiAllowance",
		outputs: [
			{
				internalType: "uint256[]",
				name: "returnData",
				type: "uint256[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "token",
						type: "address"
					},
					{
						internalType: "address",
						name: "account",
						type: "address"
					}
				],
				internalType: "struct Balance[]",
				name: "balances",
				type: "tuple[]"
			}
		],
		name: "multiBalance",
		outputs: [
			{
				internalType: "uint256[]",
				name: "returnData",
				type: "uint256[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "target",
						type: "address"
					},
					{
						internalType: "bytes32",
						name: "callType",
						type: "bytes32"
					},
					{
						internalType: "uint256",
						name: "value",
						type: "uint256"
					},
					{
						internalType: "bytes32",
						name: "method",
						type: "bytes32"
					},
					{
						internalType: "bytes",
						name: "data",
						type: "bytes"
					}
				],
				internalType: "struct Call[]",
				name: "calls",
				type: "tuple[]"
			}
		],
		name: "multiCall",
		outputs: [
			{
				internalType: "bytes[]",
				name: "returnData",
				type: "bytes[]"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "target",
						type: "address"
					},
					{
						internalType: "bytes32",
						name: "callType",
						type: "bytes32"
					},
					{
						internalType: "uint256",
						name: "value",
						type: "uint256"
					},
					{
						internalType: "bytes32",
						name: "method",
						type: "bytes32"
					},
					{
						internalType: "bytes",
						name: "data",
						type: "bytes"
					}
				],
				internalType: "struct Call[]",
				name: "calls",
				type: "tuple[]"
			}
		],
		name: "multiCallIgnoringReverts",
		outputs: [
			{
				internalType: "bool",
				name: "succeed",
				type: "bool"
			},
			{
				internalType: "bool[]",
				name: "returnSuccess",
				type: "bool[]"
			},
			{
				internalType: "bytes[]",
				name: "returnData",
				type: "bytes[]"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "address",
						name: "to",
						type: "address"
					},
					{
						internalType: "uint256",
						name: "value",
						type: "uint256"
					}
				],
				internalType: "struct Transfer[]",
				name: "transfers",
				type: "tuple[]"
			}
		],
		name: "trasnfers",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var MULTICALL_CONTRACT_ADDRESS = {
  '1': '0x50Bb8165Dd11d41ef2fE90f96b5041F90966E8A7',
  '5': '0x23D560eF20B57A87489D3Ec72D3789E73DF90424',
  '42161': '',
  '421613': '',
  '11155111': '0xc074EEC205576C657a8EBDFeA8FCCd1a2924f193'
};
var Multicall = /*#__PURE__*/function () {
  function Multicall(_plugin, _protocol, _type, _method, _name, _config, _chainId, _vaultAddress, _walletAddress, _addPluginOnInit, _withPluginOutputs, _estimateGasFromPlugins, _beforeSimulate) {
    var _this = this;
    _classCallCheck(this, Multicall);
    _defineProperty(this, "_plugins", []);
    _defineProperty(this, "getOutputValues", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var provider, walletSigner, execute, withAutoApprovals, currentGasLimit, multicallInterface, outputs, mOutputs, call, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              provider = _ref.provider, walletSigner = _ref.walletSigner, execute = _ref.execute, withAutoApprovals = _ref.withAutoApprovals;
              _this.currentGasLimit = undefined;
              currentGasLimit = BigNumber.from('0');
              multicallInterface = _this.getInterface();
              multicallInterface.instance.output;
              outputs = {};
              mOutputs = _this.output.paramsList;
              if (!_this._beforeSimulate) {
                _context.next = 15;
                break;
              }
              if (walletSigner && withAutoApprovals && _this.getRequiredApprovals().length) {
                provider.signer = walletSigner;
              }
              _context.next = 12;
              return _this.create();
            case 12:
              call = _context.sent;
              _context.next = 15;
              return _this._beforeSimulate({
                chainId: _this.chainId,
                provider: provider,
                params: call === null || call === void 0 ? void 0 : call.params
              });
            case 15:
              _context.next = 17;
              return _this._getOutputValues({
                provider: provider,
                execute: execute
              });
            case 17:
              res = _context.sent;
              res.trx.forEach(function (value, i) {
                outputs[mOutputs[i].key] = value.toString();
              });
              if (res.gasLimit) currentGasLimit = currentGasLimit.add(res.gasLimit).mul(115).div(100).add(GAS_LIMIT_OVERHEAD);
              console.log({
                outputs: outputs
              });
              _this.currentGasLimit = currentGasLimit.add(MIN_GAS_LIMIT).add(GAS_LIMIT_OVERHEAD).toString();
              return _context.abrupt("return", outputs);
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(this, "add", function (pluginNodeJSON) {
      if (!_this.chainId) {
        console.error("chainId error: set chainId");
        return;
      }
      var pluginJSON = pluginNodeJSON || new _this._plugin({
        chainId: _this.chainId,
        walletAddress: _this._walletAddress,
        vaultAddress: _this._vaultAddress
      }).toJSON();
      var plugin = _this.jsonToPlugin(pluginJSON, _this.chainId);
      if (!plugin) {
        console.error('plugin error');
        return;
      }
      _this._plugins.push(plugin);
      _this.updateSubscriptions();
      return _this;
    });
    _defineProperty(this, "remove", function () {
      if (_this._plugins.length > 1) {
        _this._plugins.pop();
        _this.updateSubscriptions();
      }
      return _this;
    });
    _defineProperty(this, "removeAll", function () {
      _this._plugins = [];
      // this.updateSubscriptions()

      return _this;
    });
    _defineProperty(this, "toJSON", function () {
      var pluginsInterface = _this.getInterface();
      var json = JSON.parse(pluginsInterface.instance.toJSON());
      json.pluginsAmount = Number(pluginsInterface.instance.input.params.amountOfCalls.value) || _this.plugins.length;

      // this.plugins.forEach((plugin) => {
      //   data.push(plugin.toJSON())
      // })

      return JSON.stringify(json);
    });
    _defineProperty(this, "fromJSON", function (multicallJSON) {
      try {
        var multicallPlugins = JSON.parse(multicallJSON);
        if (multicallPlugins.pluginsAmount) {
          _this.removeAll();
        }
        for (var i = 0; i < multicallPlugins.pluginsAmount; i++) {
          _this.add();
        }
        var pluginsInterface = _this.getInterface();
        pluginsInterface.instance.fromJSON(multicallJSON);
        pluginsInterface.instance.input.params.amountOfCalls.value = String(multicallPlugins.pluginsAmount);
      } catch (e) {
        console.error(e);
      }
      return true;
    });
    _defineProperty(this, "jsonToPlugin", function (plugin, chainId) {
      var _getPluginInstanceFro;
      return (_getPluginInstanceFro = getPluginInstanceFrom({
        json: plugin,
        chainId: chainId,
        vaultAddress: _this._vaultAddress,
        walletAddress: _this._walletAddress
      })) === null || _getPluginInstanceFro === void 0 ? void 0 : _getPluginInstanceFro.instance;
    });
    _defineProperty(this, "subscribe", function (_ref3) {
      var callback = _ref3.callback,
        id = _ref3.id;
      _this.observers.set(id, callback);
    });
    _defineProperty(this, "unsubscribe", function (_ref4) {
      var id = _ref4.id;
      _this.observers.delete(id);
    });
    _defineProperty(this, "pluginParamsToMulticallParamsTuples", function () {
      var _this$plugins$;
      var uniqueParams = (_this$plugins$ = _this.plugins[0]) === null || _this$plugins$ === void 0 ? void 0 : _this$plugins$.input.paramsList.map(function (param) {
        var paramConfig = _this.config.params.find(function (p) {
          return p.key === param.key;
        });
        if (!(paramConfig !== null && paramConfig !== void 0 && paramConfig.isUnique)) return;
        var paramKey = paramConfig ? paramConfig.multicallKey : param.key;
        var newKey = paramKey;
        param.key = newKey;
        param.param.label = paramKey;
        return param;
      }).filter(Boolean);
      var inputs = _this.plugins.map(function (plugin, index) {
        return plugin.input.paramsList.map(function (param) {
          var paramConfig = _this.config.params.find(function (p) {
            return p.key === param.key;
          });
          var paramKey = paramConfig ? paramConfig.multicallKey : param.key;
          var newKey = "".concat(paramKey, "_").concat(index);
          if (paramConfig !== null && paramConfig !== void 0 && paramConfig.isUnique) {
            var _uniqueParams$find;
            var uniqueParam = uniqueParams === null || uniqueParams === void 0 ? void 0 : (_uniqueParams$find = uniqueParams.find(function (param) {
              return (param === null || param === void 0 ? void 0 : param.key) === paramKey;
            })) === null || _uniqueParams$find === void 0 ? void 0 : _uniqueParams$find.param;
            if (uniqueParam && index > 0) {
              uniqueParam.subscribe({
                callback: function callback(event) {
                  param.param.set({
                    value: event.value
                  });
                },
                id: "multicall.".concat(_this.method, ".").concat(newKey)
              });
            }
            return;
          }
          param.key = newKey;
          param.param.label = paramKey;
          param.param.isMultiParam = !(paramConfig !== null && paramConfig !== void 0 && paramConfig.isUnique);
          return param;
        }).filter(Boolean);
      });
      var outputs = _this._withPluginOutputs ? _this.plugins.map(function (plugin, index) {
        return plugin.output.paramsList.map(function (param) {
          var paramKey = param.key;
          var newKey = "".concat(paramKey, "_").concat(index);
          param.key = newKey;
          if (_this.method === 'multiCall') {
            param.param.innerIndex = 2 + _this.plugins.length + (index * 2 + 1);
          } else {
            param.param.innerIndex = index + 2;
          }
          param.param.label = paramKey;
          param.param.isMultiParam = true;
          return param;
        });
      }) : [];
      return {
        inputs: inputs,
        outputs: outputs,
        uniqueParams: uniqueParams
      };
    });
    _defineProperty(this, "create", function () {
      var errors = _this.plugins.map(function (plugin) {
        return plugin.input.errors;
      }).filter(Boolean);
      if (errors.length) {
        console.error(errors);
        return undefined;
      }
      var _this$pluginParamsToM = _this.pluginParamsToMulticallParamsTuples(),
        inputs = _this$pluginParamsToM.inputs,
        uniqueParams = _this$pluginParamsToM.uniqueParams;
      var tupleParams = {
        name: _this.config.tupleName || _this.name,
        type: 'tuple[]',
        value: []
      };
      console.log({
        method: _this.method
      });
      if (_this.method === 'multiCall') {
        tupleParams.customType = true;
        _this.plugins.forEach(function (plugin) {
          var _tupleParams$value;
          var trxParam = [];
          console.log({
            plugin: plugin
          });
          var callData = plugin.getCalldata();
          console.log({
            callData: callData
          });
          if (!callData) return;
          Object.keys(callData).map(function (key) {
            var callKey = key;
            var callDataParam = callData[callKey];
            trxParam.push({
              name: key,
              type: callDataParam.type,
              value: callDataParam.value
            });
          });
          (_tupleParams$value = tupleParams.value) === null || _tupleParams$value === void 0 ? void 0 : _tupleParams$value.push(trxParam);
        });
        console.log({
          multicallParams: JSON.stringify(tupleParams)
        });
      } else {
        tupleParams.value = inputs.map(function (inputParams) {
          if (inputParams.length === 1) {
            var param = inputParams[0].param;
            tupleParams.type = "".concat(param.fctType, "[]");
            return param.value;
          }
          var trxParam = [];
          tupleParams.customType = true;
          inputParams.forEach(function (_ref5) {
            var param = _ref5.param,
              key = _ref5.key;
            trxParam.push({
              name: param.label || paramKeyToName({
                key: key
              }),
              type: param.fctType,
              value: param.value
            });
          });
          return trxParam;
        });
      }
      var callParams = [];
      if (uniqueParams && uniqueParams.length) {
        uniqueParams.forEach(function (_ref6) {
          var param = _ref6.param,
            key = _ref6.key;
          callParams.push({
            name: param.label || paramKeyToName({
              key: key
            }),
            type: param.fctType,
            value: param.value
          });
        });
      }
      if (tupleParams && tupleParams.value) {
        callParams.push(tupleParams);
      }
      var callType = _this.type === 'LIBRARY:VIEWONLY' ? 'LIBRARY_VIEW_ONLY' : 'LIBRARY';
      var call = {
        value: '0',
        to: MULTICALL_CONTRACT_ADDRESS[_this.chainId],
        method: _this.method,
        params: callParams,
        toENS: _this.toENS,
        options: {
          gasLimit: _this.gasLimit,
          falseMeansFail: false,
          callType: callType
        }
      };
      return call;
    });
    _defineProperty(this, "getOutputParamsTypes", function () {
      if (_this.method === 'multiCall') {
        return [_this.plugins.map(function (pl) {
          return pl.output.paramsList.map(function (_ref7) {
            var param = _ref7.param;
            return param.fctType;
          });
        })];
      }
      return ["".concat(_this.output.paramsList[0].param.fctType, "[]")];
    });
    _defineProperty(this, "_getOutputValues", /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref8) {
        var _res2;
        var provider, execute, call, simulateContractAddress, contract, singerAddress, trx, res, _contract$callStatic, _res, methodParams, error, outputTypes, abiCoder, outputParams;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              provider = _ref8.provider, execute = _ref8.execute;
              call = _this.create();
              if (call) {
                _context2.next = 4;
                break;
              }
              throw new Error('wrong multicall data');
            case 4:
              simulateContractAddress = _this.method === 'erc20Approvals' ? kiroboMulticallContractsMap[_this.chainId] : kiroboMulticallSimulateContracts[_this.chainId];
              contract = new Contract(simulateContractAddress, multicallAbi, provider.signer);
              _context2.next = 8;
              return provider.signer.getAddress();
            case 8:
              singerAddress = _context2.sent;
              _context2.prev = 9;
              methodParams = call === null || call === void 0 ? void 0 : call.params.map(function (param) {
                if (!param.value) return param.value;
                if (typeof param.value === 'string') return param.value;
                if (_typeof(param.value) === 'object' && 'length' in param.value) {
                  if (param.type !== 'tuple[]') return param.value;
                  return param.value.map(function (paramValue) {
                    var p = [];
                    if (paramValue && _typeof(paramValue) === 'object' && 'length' in paramValue) paramValue.forEach(function (_p, i) {
                      p[i] = _p.value;
                      //p[_p.name] = _p.value
                    });

                    return p;
                  });
                }
                return undefined;
              });
              console.log({
                methodParams: JSON.stringify(methodParams)
              });
              _context2.next = 14;
              return (_contract$callStatic = contract.callStatic)[_this.method].apply(_contract$callStatic, _toConsumableArray(methodParams).concat([{
                from: singerAddress,
                value: '0'
              }]));
            case 14:
              trx = _context2.sent;
              console.log({
                trx: trx
              });
              if (!execute) {
                _context2.next = 21;
                break;
              }
              _context2.next = 19;
              return contract[_this.method].apply(contract, _toConsumableArray(methodParams).concat([{
                from: singerAddress,
                value: '0'
              }]));
            case 19:
              res = _context2.sent;
              console.log({
                trx: trx,
                res: res
              });
              //return { trx, res }
            case 21:
              console.log({
                res: res
              });
              if (!(_this.method !== 'multiCall')) {
                _context2.next = 24;
                break;
              }
              return _context2.abrupt("return", {
                trx: trx,
                gasLimit: (_res = res) === null || _res === void 0 ? void 0 : _res.gasLimit
              });
            case 24:
              _context2.next = 30;
              break;
            case 26:
              _context2.prev = 26;
              _context2.t0 = _context2["catch"](9);
              error = new Error(_context2.t0);
              throw error;
            case 30:
              outputTypes = _this.plugins.map(function (pl) {
                return pl.output.paramsList.map(function (_ref10) {
                  var param = _ref10.param;
                  return param.fctType;
                });
              }); //console.log({ pluginoutputtypes: this.plugins.map((pl) => pl.output.paramsList.map(({ param }) => param.fctType)) })
              abiCoder = new utils.AbiCoder();
              outputParams = trx.map(function (bytes, i) {
                return abiCoder.decode(outputTypes[i], bytes);
              });
              return _context2.abrupt("return", {
                trx: outputParams,
                gasLimit: (_res2 = res) === null || _res2 === void 0 ? void 0 : _res2.gasLimit
              });
            case 34:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[9, 26]]);
      }));
      return function (_x2) {
        return _ref9.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getRequiredApprovals", function () {
      var requiredApprovals = [];
      _this.plugins.forEach(function (plugin) {
        var pluginApprovals = plugin.getRequiredApprovals();
        requiredApprovals = requiredApprovals.concat(pluginApprovals);
      });
      return requiredApprovals;
    });
    _defineProperty(this, "observers", new Map());
    _defineProperty(this, "updateSubscriptions", function () {
      var multicallInterface = _this.getInterface();
      var _iterator = _createForOfIteratorHelper$1(_this.observers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var observer = _step.value;
          observer[1](multicallInterface, undefined, _this.chainId, _this.currentGasLimit);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    this._plugin = _plugin;
    this._protocol = _protocol;
    this._type = _type;
    this._method = _method;
    this._name = _name;
    this._config = _config;
    this._chainId = _chainId;
    this._vaultAddress = _vaultAddress;
    this._walletAddress = _walletAddress;
    this._addPluginOnInit = _addPluginOnInit;
    this._withPluginOutputs = _withPluginOutputs;
    this._estimateGasFromPlugins = _estimateGasFromPlugins;
    this._beforeSimulate = _beforeSimulate;
    if (this.plugins.length) return;
    if (this._addPluginOnInit === false) return;
    this.add();
  }
  _createClass(Multicall, [{
    key: "chainId",
    get: function get() {
      return this._chainId;
    }
  }, {
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "protocol",
    get: function get() {
      return this._protocol;
    }
  }, {
    key: "method",
    get: function get() {
      return this._method;
    }
  }, {
    key: "name",
    get: function get() {
      return this._name;
    }
  }, {
    key: "toENS",
    get: function get() {
      return '@lib:multicall';
    }
  }, {
    key: "config",
    get: function get() {
      return this._config;
    }
  }, {
    key: "contractInterface",
    get: function get() {
      return this.methodInterface;
    }
  }, {
    key: "methodInterface",
    get: function get() {
      var _this$pluginParamsToM2 = this.pluginParamsToMulticallParamsTuples(),
        inputs = _this$pluginParamsToM2.inputs,
        uniqueParams = _this$pluginParamsToM2.uniqueParams;
      var pluginInputs = inputs[0];
      var paramsToTypes = function paramsToTypes(inputs) {
        var types = '';
        inputs.forEach(function (_ref11) {
          var param = _ref11.param;
          types += "".concat(param._fctType, ",");
        });
        types = types.replace(/,$/, '');
        return types;
      };
      var listInterface = pluginInputs.length > 1 ? "(".concat(paramsToTypes(pluginInputs), ")[]") : "".concat(paramsToTypes(pluginInputs), "[]");
      if (uniqueParams && uniqueParams.length) return "".concat(this.method, "(").concat(paramsToTypes(uniqueParams), ",").concat(listInterface, ")");
      return "".concat(this.method, "(").concat(listInterface, ")");
    }
  }, {
    key: "methodInterfaceHash",
    get: function get() {
      return utils.id(this.methodInterface);
    }
  }, {
    key: "contractInterfaceReturns",
    get: function get() {
      var _this$pluginParamsToM3 = this.pluginParamsToMulticallParamsTuples(),
        outputs = _this$pluginParamsToM3.outputs;
      var pluginOutputs = outputs.length ? outputs[0] : [];
      var types = '';
      pluginOutputs.forEach(function (_ref12) {
        var param = _ref12.param;
        types += "".concat(param._fctType, ",");
      });
      types = types.replace(/,$/, '');
      return "returns (".concat(types, "[])");
    }
  }, {
    key: "plugins",
    get: function get() {
      return this._plugins;
    }
  }, {
    key: "gasLimit",
    get: function get() {
      if (this.currentGasLimit) return this.currentGasLimit;
      if (this._estimateGasFromPlugins) return this._estimateGasFromPlugins(this.plugins, this.chainId);
      var MIN_GAS_LIMIT = '42000';
      var gasLimit = MIN_GAS_LIMIT;
      var _iterator2 = _createForOfIteratorHelper$1(this.plugins),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var plugin = _step2.value;
          var pluginGasLimit = plugin.gasLimit && BigNumber.from(plugin.gasLimit).gte(MIN_GAS_LIMIT) ? plugin.gasLimit : BigNumber.from(MIN_GAS_LIMIT).mul(2).toString();
          gasLimit = BigNumber.from(gasLimit).add(pluginGasLimit).sub(MIN_GAS_LIMIT).toString();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return gasLimit;
    }
  }, {
    key: "input",
    get: function get() {
      return this.getInterface().instance.input;
    }
  }, {
    key: "output",
    get: function get() {
      return this.getInterface().instance.output;
    }
  }, {
    key: "getInterface",
    value: function getInterface() {
      var newInputValues = {};
      var newOutputValues = {};
      var _this$pluginParamsToM4 = this.pluginParamsToMulticallParamsTuples(),
        inputs = _this$pluginParamsToM4.inputs,
        outputs = _this$pluginParamsToM4.outputs,
        uniqueParams = _this$pluginParamsToM4.uniqueParams;
      var amountOfCallsParam = new FctValue({
        required: false,
        mode: 'INPUT'
      });
      amountOfCallsParam.value = String(this.plugins.length) || '1';
      amountOfCallsParam.virtual = true;
      _.set(newInputValues, 'amountOfCalls', amountOfCallsParam);
      uniqueParams.forEach(function (param) {
        if (!param) return;
        _.set(newInputValues, param.key, param.param);
      });
      inputs.forEach(function (pluginParams) {
        pluginParams.forEach(function (param) {
          _.set(newInputValues, param.key, param.param);
        });
      });
      outputs.forEach(function (pluginParams) {
        pluginParams.forEach(function (param) {
          _.set(newOutputValues, param.key, param.param);
        });
      });
      var Plugin = createPlugin({
        protocol: this.protocol,
        type: this.type,
        name: this.name,
        method: this.method,
        getParams: function getParams() {
          return {
            input: newInputValues,
            output: newOutputValues
          };
        }
      });
      var newPlugin = new Plugin({
        chainId: this.chainId
      });
      newPlugin.input.setMethodParams = this.setMethodParams;
      newPlugin.output.setOutputParams = this.setOutputParams;
      return {
        instance: newPlugin,
        details: {
          plugin: Plugin,
          name: this.name,
          description: this.name
        }
      };
    }
  }, {
    key: "setMethodParams",
    value: function setMethodParams(params) {
      var _this2 = this;
      var methodParamsConfig = this.config.params;
      params.some(function (param, i) {
        var paramConfig = methodParamsConfig[i];
        if (paramConfig.isUnique) return false;
        if (_typeof(param) === 'object' && 'length' in param) {
          while (_this2.plugins.length < param.length) {
            _this2.add();
          }
          return true;
        }
        return false;
      });
      var pluginInterface = this.getInterface();
      //pluginInterface.instance.input
      params.forEach(function (param, i) {
        var paramConfig = methodParamsConfig[i];
        if (paramConfig.isUnique) {
          pluginInterface.instance.input.set(_defineProperty({}, paramConfig.multicallKey, param));
          return;
        }
        if (_typeof(param) === 'object' && 'length' in param) {
          param.forEach(function (tupleParamValue, tupleIndex) {
            if (typeof tupleParamValue === 'string' || typeof tupleParamValue === 'boolean') {
              pluginInterface.instance.input.set(_defineProperty({}, "".concat(paramConfig.multicallKey, "_").concat(tupleIndex), tupleParamValue));
            }
            if (_typeof(tupleParamValue) === 'object' && 'length' in tupleParamValue) {
              tupleParamValue.forEach(function (tuplePramNestedValue, nestedTupleIndex) {
                var nestedParamConfig = methodParamsConfig[i + nestedTupleIndex];
                pluginInterface.instance.input.set(_defineProperty({}, "".concat(nestedParamConfig.multicallKey, "_").concat(tupleIndex), tuplePramNestedValue));
              });
            }
          });
        }
        return;
      });
    }
  }, {
    key: "setOutputParams",
    value: function setOutputParams(params) {
      if (_typeof(params) !== 'object' || !('length' in params)) return;
      var paramsValues = [];
      var getValues = function getValues(params) {
        if (typeof params === 'string' || typeof params === 'boolean') {
          paramsValues.push(params);
        }
        if (params && _typeof(params) === 'object' && 'length' in params) {
          var paramsArray = params;
          paramsArray.forEach(function (param) {
            getValues(param);
          });
        }
        return;
      };
      getValues(params);
      console.log({
        paramsValues: paramsValues
      });
      while (this.plugins.length < paramsValues.length) {
        this.add();
      }
      var pluginInterface = this.getInterface();
      pluginInterface.instance.output.paramsList.forEach(function (param, i) {
        var paramValue = paramsValues[i];
        if (typeof paramValue === 'string' || typeof paramValue === 'boolean') {
          param.param.set({
            value: paramValue
          });
        }
        if (_typeof(paramValue) === 'object' && 'length' in paramValue) {
          param.param.set({
            value: paramValue[0]
          });
        }
      });
    }
  }, {
    key: "currentGasLimit",
    get: function get() {
      return this._currentGasLimit;
    },
    set: function set(gasLimit) {
      this._currentGasLimit = gasLimit;
      this.updateSubscriptions();
    }
  }]);
  return Multicall;
}();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var createMulticallPlugin = function createMulticallPlugin(_ref) {
  var plugin = _ref.plugin,
    protocol = _ref.protocol,
    type = _ref.type,
    method = _ref.method,
    name = _ref.name,
    config = _ref.config,
    addPluginOnInit = _ref.addPluginOnInit,
    withPluginOutputs = _ref.withPluginOutputs,
    estimateGasFromPlugins = _ref.estimateGasFromPlugins,
    beforeSimulate = _ref.beforeSimulate;
  return /*#__PURE__*/function (_Multicall) {
    _inherits(MulticallPlugin, _Multicall);
    var _super = _createSuper(MulticallPlugin);
    function MulticallPlugin(_ref2) {
      var chainId = _ref2.chainId,
        vaultAddress = _ref2.vaultAddress,
        walletAddress = _ref2.walletAddress;
      _classCallCheck(this, MulticallPlugin);
      return _super.call(this, plugin, protocol, type, method, name, config, chainId, vaultAddress, walletAddress, addPluginOnInit, withPluginOutputs, estimateGasFromPlugins, beforeSimulate);
    }
    return _createClass(MulticallPlugin);
  }(Multicall);
};

var Erc20Airdrop = createMulticallPlugin({
  plugin: ERC20.actions.SimpleTransfer,
  protocol: 'KIROBO_MULTICALL',
  type: 'LIBRARY',
  method: 'erc20Airdrop',
  name: 'erc20Airdrop',
  config: {
    params: [{
      key: 'to',
      multicallKey: 'token',
      isUnique: true
    }, {
      key: 'methodParams.from',
      multicallKey: 'from',
      isUnique: true
    }, {
      key: 'methodParams.amount',
      multicallKey: 'amount',
      isUnique: true
    }, {
      key: 'methodParams.to',
      multicallKey: 'recipient'
    }],
    tupleName: 'recipients'
  },
  estimateGasFromPlugins: function estimateGasFromPlugins(plugins, chainId) {
    // Gas notes:
    // 1st call 32000
    // every next call 27000

    var gas = BigNumber.from(32000);
    if (plugins.length > 1) {
      gas = gas.add(BigNumber.from(plugins.length - 1).mul(BigNumber.from(27000)));
    }
    if (chainId === '42161' || chainId === '421613') {
      gas = gas.mul(BigNumber.from(13));
    }
    return gas.toString();
  },
  beforeSimulate: function () {
    var _beforeSimulate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var _provider$signer;
      var params, provider, chainId, tokenRecipients, tokenAmount, amountToSend, contractAddress, tokenAddress, contract;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            params = _ref.params, provider = _ref.provider, chainId = _ref.chainId;
            if (params) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            tokenRecipients = params[3].value;
            tokenAmount = params[2].value;
            console.log({
              params: params,
              tokenRecipients: tokenRecipients,
              tokenAmount: tokenAmount
            });
            if (tokenAmount) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return");
          case 8:
            if (tokenRecipients) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return");
          case 10:
            if ('length' in tokenRecipients) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return");
          case 12:
            amountToSend = BigNumber.from(tokenAmount).mul(tokenRecipients.length);
            contractAddress = kiroboMulticallSimulateContracts[chainId];
            tokenAddress = params[0].value;
            console.log({
              tokenAddress: tokenAddress
            });
            if (tokenAddress) {
              _context.next = 18;
              break;
            }
            return _context.abrupt("return");
          case 18:
            contract = new Contract(tokenAddress, erc20Abi, provider === null || provider === void 0 ? void 0 : provider.signer);
            _context.next = 21;
            return provider === null || provider === void 0 ? void 0 : (_provider$signer = provider.signer) === null || _provider$signer === void 0 ? void 0 : _provider$signer.sendTransaction({
              to: contractAddress,
              value: '1' + '0'.repeat(3)
            });
          case 21:
            _context.next = 23;
            return contract['approve'](contractAddress, amountToSend.toString(), {});
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function beforeSimulate(_x) {
      return _beforeSimulate.apply(this, arguments);
    }
    return beforeSimulate;
  }()
});

var Erc20Approvals = createMulticallPlugin({
  plugin: ERC20.actions.Approve,
  protocol: 'KIROBO_MULTICALL',
  type: 'LIBRARY',
  method: 'erc20Approvals',
  name: 'erc20Approvals',
  config: {
    params: [{
      key: 'to',
      multicallKey: 'token'
    }, {
      key: 'methodParams.spender',
      multicallKey: 'spender'
    }, {
      key: 'methodParams.amount',
      multicallKey: 'amount'
    }]
  },
  estimateGasFromPlugins: function estimateGasFromPlugins(plugins, chainId) {
    // Gas notes:
    // 1 approve = 34000 gas

    var gas = BigNumber.from(plugins.length).mul(34000);
    if (chainId === '42161' || chainId === '421613') {
      gas = gas.mul(13);
    }
    return gas.toString();
  }
});

var Erc20MonoTransfers = createMulticallPlugin({
  plugin: ERC20.actions.SimpleTransfer,
  protocol: 'KIROBO_MULTICALL',
  type: 'LIBRARY',
  method: 'erc20MonoTransfers',
  name: 'erc20MonoTransfers',
  config: {
    params: [{
      key: 'to',
      multicallKey: 'token',
      isUnique: true
    }, {
      key: 'methodParams.from',
      multicallKey: 'from',
      isUnique: true
    }, {
      key: 'methodParams.to',
      multicallKey: 'to'
    }, {
      key: 'methodParams.amount',
      multicallKey: 'amount'
    }],
    tupleName: 'transfers'
  },
  estimateGasFromPlugins: function estimateGasFromPlugins(plugins, chainId) {
    // Gas notes:
    // 35k first
    // 28k every next

    var gas = BigNumber.from(35000);
    if (plugins.length > 1) {
      gas = gas.add(BigNumber.from(28000).mul(BigNumber.from(plugins.length - 1)));
    }
    if (chainId === '42161' || chainId === '421613') {
      gas = gas.mul(BigNumber.from(13));
    }
    return gas.toString();
  },
  beforeSimulate: function () {
    var _beforeSimulate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var _params$find, _provider$signer;
      var params, provider, chainId, tupleParams, tokenValues, amountToSend, contractAddress, tokenAddress, contract;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            params = _ref.params, provider = _ref.provider, chainId = _ref.chainId;
            if (params) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            tupleParams = (_params$find = params.find(function (param) {
              return param.type === 'tuple[]';
            })) === null || _params$find === void 0 ? void 0 : _params$find.value;
            if (tupleParams) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return");
          case 6:
            console.log({
              tupleParams: tupleParams
            });
            tokenValues = tupleParams === null || tupleParams === void 0 ? void 0 : tupleParams.map(function (tuple) {
              return tuple.find(function (t) {
                return t.name === 'amount';
              });
            });
            console.log({
              tokenValues: tokenValues
            });
            if (tokenValues) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("return");
          case 11:
            if ('length' in tokenValues) {
              _context.next = 13;
              break;
            }
            return _context.abrupt("return");
          case 13:
            amountToSend = BigNumber.from('0');
            tokenValues.forEach(function (amount) {
              if (amount) amountToSend = amountToSend.add(amount.value);
            });
            console.log({
              amountToSend: amountToSend
            });
            contractAddress = kiroboMulticallSimulateContracts[chainId];
            _context.next = 19;
            return provider === null || provider === void 0 ? void 0 : (_provider$signer = provider.signer) === null || _provider$signer === void 0 ? void 0 : _provider$signer.sendTransaction({
              to: contractAddress,
              value: '1' + '0'.repeat(3)
            });
          case 19:
            tokenAddress = params[0].value;
            console.log({
              tokenAddress: tokenAddress
            });
            if (tokenAddress) {
              _context.next = 23;
              break;
            }
            return _context.abrupt("return");
          case 23:
            contract = new Contract(tokenAddress, erc20Abi, provider === null || provider === void 0 ? void 0 : provider.signer); //const res = await contract['transfer'](contractAddress, amountToSend.toString(), {})
            _context.next = 26;
            return contract['approve'](contractAddress, amountToSend.toString(), {});
          case 26:
            _context.sent;
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function beforeSimulate(_x) {
      return _beforeSimulate.apply(this, arguments);
    }
    return beforeSimulate;
  }()
});

var Erc20Transfers = createMulticallPlugin({
  plugin: ERC20.actions.SimpleTransfer,
  protocol: 'KIROBO_MULTICALL',
  type: 'LIBRARY',
  method: 'erc20Transfers',
  name: 'erc20Transfers',
  config: {
    params: [{
      key: 'to',
      multicallKey: 'token'
    }, {
      key: 'methodParams.from',
      multicallKey: 'from'
    }, {
      key: 'methodParams.to',
      multicallKey: 'to'
    }, {
      key: 'methodParams.amount',
      multicallKey: 'amount'
    }],
    tupleName: 'transfers'
  },
  beforeSimulate: function () {
    var _beforeSimulate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
      var _params$find, _provider$signer;
      var params, provider, chainId, tupleParams, contractAddress, value, tokensToSend, multiApproveParams;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            params = _ref.params, provider = _ref.provider, chainId = _ref.chainId;
            if (params) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            tupleParams = (_params$find = params.find(function (param) {
              return param.type === 'tuple[]';
            })) === null || _params$find === void 0 ? void 0 : _params$find.value;
            if (tupleParams) {
              _context2.next = 6;
              break;
            }
            return _context2.abrupt("return");
          case 6:
            console.log({
              tupleParams: tupleParams
            });
            contractAddress = kiroboMulticallSimulateContracts[chainId];
            _context2.next = 10;
            return provider === null || provider === void 0 ? void 0 : (_provider$signer = provider.signer) === null || _provider$signer === void 0 ? void 0 : _provider$signer.sendTransaction({
              to: contractAddress,
              value: '1' + '0'.repeat(3)
            });
          case 10:
            value = tupleParams;
            tokensToSend = {};
            console.log({
              value: value
            });
            value === null || value === void 0 ? void 0 : value.forEach(function (nestedParam) {
              console.log({
                nestedParam: nestedParam
              });
              var tokenParam = nestedParam.find(function (param) {
                return param.name === 'token';
              });
              var amountParam = nestedParam.find(function (param) {
                return param.name === 'amount';
              });
              console.log({
                tokenParam: tokenParam,
                amountParam: amountParam
              });
              if (!tokenParam) return;
              if (!tokensToSend[tokenParam.value]) {
                return tokensToSend[tokenParam.value] = BigNumber.from((amountParam === null || amountParam === void 0 ? void 0 : amountParam.value) || '0');
              }
              return tokensToSend[tokenParam.value] = tokensToSend[tokenParam.value].add((amountParam === null || amountParam === void 0 ? void 0 : amountParam.value) || '0');
            });
            _context2.next = 16;
            return Promise.all(Object.keys(tokensToSend).map( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
                var tokenContract;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      tokenContract = new Contract(key, erc20Abi, provider === null || provider === void 0 ? void 0 : provider.signer); //console.log({ token: key, anount: tokensToSend[key].toString() })
                      //const transfer = await tokenContract['transfer'](contractAddress, tokensToSend[key].toString(), {})
                      _context.next = 3;
                      return tokenContract['approve'](contractAddress, tokensToSend[key].toString(), {});
                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }()));
          case 16:
            multiApproveParams = [];
            multiApproveParams.push(value === null || value === void 0 ? void 0 : value.map(function (nestedParam) {
              return nestedParam.map(function (p) {
                if (p.name === 'token') return p.value;
                if (p.name === 'to') return contractAddress;
                if (p.name === 'amount') return p.value;
                return;
              }).filter(Boolean);
            }));
          case 18:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function beforeSimulate(_x) {
      return _beforeSimulate.apply(this, arguments);
    }
    return beforeSimulate;
  }(),
  estimateGasFromPlugins: function estimateGasFromPlugins(plugins, chainId) {
    // Gas notes:
    // 36k per transfer

    var gas = BigNumber.from(plugins.length).mul(36000);
    if (chainId === '42161' || chainId === '421613') {
      gas = gas.mul(13);
    }
    return gas.toString();
  }
});

var MultiBalance = createMulticallPlugin({
  plugin: ERC20.getters.BalanceOf,
  protocol: 'KIROBO_MULTICALL',
  type: 'LIBRARY:VIEWONLY',
  method: 'multiBalance',
  name: 'multiBalance',
  config: {
    params: [{
      key: 'to',
      multicallKey: 'token'
    }, {
      key: 'methodParams.owner',
      multicallKey: 'account'
    }]
  },
  estimateGasFromPlugins: function estimateGasFromPlugins(plugins, chainId) {
    // Gas notes:
    // 1 balance fetch - 7k

    var gas = BigNumber.from(plugins.length).mul(7000);
    if (chainId === '42161' || chainId === '421613') {
      gas = gas.mul(13);
    }
    return gas.toString();
  },
  withPluginOutputs: true
});

var MultiDivider = createMulticallPlugin({
  plugin: TokensMath.getters.Divide,
  protocol: 'KIROBO_MULTICALL',
  type: 'LIBRARY:VIEWONLY',
  method: 'multiCall',
  name: 'multiDivider',
  config: {
    params: [{
      key: 'methodParams.amount1',
      multicallKey: 'amount1'
    }, {
      key: 'methodParams.decimals1',
      multicallKey: 'decimals1'
    }, {
      key: 'methodParams.amount2',
      multicallKey: 'amount2'
    }, {
      key: 'methodParams.decimals2',
      multicallKey: 'decimals2'
    }, {
      key: 'methodParams.decimalsOut',
      multicallKey: 'decimalsOut'
    }],
    tupleName: 'divs'
  },
  addPluginOnInit: true,
  withPluginOutputs: true
});

var MultiMultiplier = createMulticallPlugin({
  plugin: TokensMath.getters.Multiply,
  protocol: 'KIROBO_MULTICALL',
  type: 'LIBRARY:VIEWONLY',
  method: 'multiCall',
  name: 'multiMultiplier',
  config: {
    params: [{
      key: 'methodParams.amount1',
      multicallKey: 'amount1'
    }, {
      key: 'methodParams.decimals1',
      multicallKey: 'decimals1'
    }, {
      key: 'methodParams.amount2',
      multicallKey: 'amount2'
    }, {
      key: 'methodParams.decimals2',
      multicallKey: 'decimals2'
    }, {
      key: 'methodParams.decimalsOut',
      multicallKey: 'decimalsOut'
    }],
    tupleName: 'muls'
  },
  addPluginOnInit: true,
  withPluginOutputs: true
});

var EthTransfers = createMulticallPlugin({
  plugin: Utility.actions.SendETH,
  protocol: 'KIROBO_MULTICALL',
  type: 'LIBRARY',
  method: 'trasnfers',
  name: 'ethTransfers',
  config: {
    params: [{
      key: 'to',
      multicallKey: 'to'
    }, {
      key: 'value',
      multicallKey: 'value'
    }],
    tupleName: 'transfers'
  },
  estimateGasFromPlugins: function estimateGasFromPlugins(plugins, chainId) {
    // 1 transfer - 36000
    var gas = BigNumber.from(plugins.length).mul(36000);
    if (chainId === '42161' || chainId === '421613') {
      gas = gas.mul(13);
    }
    return gas.toString();
  }
});

var MultiAdd = createMulticallPlugin({
  plugin: TokensMath.getters.Add,
  protocol: 'KIROBO_MULTICALL',
  type: 'LIBRARY:VIEWONLY',
  method: 'multiCall',
  name: 'multiAdd',
  config: {
    params: [{
      key: 'methodParams.amount1',
      multicallKey: 'amount1'
    }, {
      key: 'methodParams.decimals1',
      multicallKey: 'decimals1'
    }, {
      key: 'methodParams.amount2',
      multicallKey: 'amount2'
    }, {
      key: 'methodParams.decimals2',
      multicallKey: 'decimals2'
    }, {
      key: 'methodParams.decimalsOut',
      multicallKey: 'decimalsOut'
    }],
    tupleName: 'addends'
  },
  addPluginOnInit: true,
  withPluginOutputs: true
});

var MultiSubtract = createMulticallPlugin({
  plugin: TokensMath.getters.Subtract,
  protocol: 'KIROBO_MULTICALL',
  type: 'LIBRARY:VIEWONLY',
  method: 'multiCall',
  name: 'multiSubtract',
  config: {
    params: [{
      key: 'methodParams.amount1',
      multicallKey: 'amount1'
    }, {
      key: 'methodParams.decimals1',
      multicallKey: 'decimals1'
    }, {
      key: 'methodParams.amount2',
      multicallKey: 'amount2'
    }, {
      key: 'methodParams.decimals2',
      multicallKey: 'decimals2'
    }, {
      key: 'methodParams.decimalsOut',
      multicallKey: 'decimalsOut'
    }],
    tupleName: 'subtrahends'
  },
  addPluginOnInit: true,
  withPluginOutputs: true
});

var createApprovalsPlugin = function createApprovalsPlugin(_ref) {
  var requiredApprovals = _ref.requiredApprovals,
    chainId = _ref.chainId;
  requiredApprovals === null || requiredApprovals === void 0 ? void 0 : requiredApprovals.map(function (approve) {
    return console.log({
      params: approve.params
    });
  });
  var ApprovePlugin = ERC20.actions.Approve;
  var ApproveErc20MulticallPlugin = Erc20Approvals;
  var approveErc20MulticallPlugin = new ApproveErc20MulticallPlugin({
    chainId: chainId
  });
  var createApprovePlugin = function createApprovePlugin(approve) {
    if (approve.method !== 'approve' || approve.protocol !== 'ERC20') return;
    return new ApprovePlugin({
      chainId: chainId,
      initParams: {
        to: approve.to,
        methodParams: {
          spender: approve.params[0],
          amount: approve.params[1]
        }
      }
    });
  };
  if (!requiredApprovals || !requiredApprovals.length) {
    return;
  }
  if (requiredApprovals.length === 1) {
    var approvePlugin = createApprovePlugin(requiredApprovals[0]);
    if (!approvePlugin) return;
    return approvePlugin;
  }
  approveErc20MulticallPlugin.removeAll();
  requiredApprovals.forEach(function (approve) {
    var approvePlugin = createApprovePlugin(approve);
    if (!approvePlugin) return;
    approveErc20MulticallPlugin.add(approvePlugin.toJSON());
  });
  return approveErc20MulticallPlugin;
};

var multicallPlugins = [Erc20Airdrop, Erc20Approvals, Erc20MonoTransfers, Erc20Transfers, EthTransfers, MultiBalance, MultiDivider, MultiMultiplier, MultiAdd, MultiSubtract];
var getMulticallPlugin = function getMulticallPlugin(_ref) {
  var signature = _ref.signature,
    chainId = _ref.chainId;
  var mCallPlugin = multicallPlugins.map(function (Plugin) {
    return new Plugin({
      chainId: chainId
    });
  }).find(function (mPlugin) {
    return mPlugin.methodInterfaceHash === signature;
  });
  return mCallPlugin;
};

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var availablePlugins = Object.keys(plugins).map(function (key) {
  var pluginKey = key;
  return plugins[pluginKey];
});
var pluginsArray = [];
var pluginsMap = {};
var allPlugins = [];
var pluginsGroupKeys = ['type', 'protocol', 'method', 'methodInterface', 'methodInterfaceHash', 'name'];
availablePlugins.forEach(function (protocol) {
  var protocolType = protocol;
  Object.keys(protocolType).forEach(function (pluginType) {
    var type = pluginType;
    Object.keys(protocolType[type]).forEach(function (actionKey) {
      var protocolPlugins = protocolType[type];
      var key = actionKey;
      var Plugin = protocolPlugins[key];
      var plugin = new Plugin({
        chainId: '1'
      });
      pluginsGroupKeys.forEach(function (key) {
        var value = plugin[key];
        if (!pluginsMap[value]) {
          pluginsMap[value] = [];
        }
        pluginsMap[value].push({
          name: plugin.name,
          description: plugin.description,
          plugin: Plugin
        });
      });
      pluginsArray.push(Plugin);
    });
  });
});
pluginsArray.forEach(function (Plugin) {
  var plugin = new Plugin({
    chainId: '1'
  });
  var _plugin = {
    name: plugin.name,
    description: plugin.description,
    plugin: Plugin
  };
  allPlugins.push(_plugin);
});
var filterPlugins = function filterPlugins(_ref) {
  var plugins = _ref.plugins,
    key = _ref.key,
    value = _ref.value;
  return plugins.filter(function (Plugin) {
    var plugin = new Plugin.plugin({
      chainId: '1'
    });
    if (plugin[key] === value) return true;
    return false;
  });
};
var excludePlugins = function excludePlugins(_ref2) {
  var plugins = _ref2.plugins,
    key = _ref2.key,
    value = _ref2.value;
  return plugins.filter(function (Plugin) {
    var plugin = new Plugin.plugin({
      chainId: '1'
    });
    if (plugin[key] === value) return false;
    return true;
  });
};
var getPlugins = function getPlugins(_ref3) {
  var by = _ref3.by,
    excludeBy = _ref3.excludeBy;
  if (!by && !excludeBy) {
    return allPlugins;
  }
  var plugins = undefined;
  for (var _key in by) {
    var groupByKey = _key;
    var value = by[groupByKey];
    if (!value) continue;
    if (plugins) {
      plugins = filterPlugins({
        plugins: plugins,
        key: groupByKey,
        value: value
      });
    } else {
      plugins = pluginsMap[value] || [];
    }
  }
  for (var _key2 in excludeBy) {
    var excludeByKey = _key2;
    var values = excludeBy[excludeByKey];
    if (!values) continue;
    var _iterator = _createForOfIteratorHelper(values),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _value = _step.value;
        if (plugins && plugins.length) {
          plugins = excludePlugins({
            plugins: plugins,
            key: excludeByKey,
            value: _value
          });
        } else {
          plugins = excludePlugins({
            plugins: allPlugins,
            key: excludeByKey,
            value: _value
          });
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return plugins || [];
};
var getPlugin = function getPlugin(_ref4) {
  var signature = _ref4.signature,
    address = _ref4.address,
    chainId = _ref4.chainId;
  var plugins = allPlugins.filter(function (plugin) {
    var pluginInstance = new plugin.plugin({
      chainId: chainId
    });
    return pluginInstance.methodInterfaceHash === signature;
  });
  if (plugins.length === 1) {
    return plugins[0];
  }
  if (plugins.length > 1) {
    var plugin = plugins.find(function (plugin) {
      var pluginInstance = new plugin.plugin({
        chainId: chainId
      });
      if (pluginInstance.supportedContracts.length !== 0) {
        return pluginInstance.supportedContracts.findIndex(function (contract) {
          return contract.address.toLowerCase() === address.toLowerCase() && contract.chainId === Number(chainId);
        }) !== -1;
      }
      return false;
    });
    if (plugin) return plugin;
    throw new Error("Multiple plugins found for the same signature, can't determine which one to use");
  }
  return getMulticallPlugin({
    signature: signature,
    chainId: chainId
  });
};
var useChainId = function useChainId(_ref5) {
  var plugin = _ref5.plugin,
    chainId = _ref5.chainId;
  if (plugin.chainId === chainId) return plugin;
  var params = plugin.toJSON();
  var plugins = getPlugins({
    by: {
      protocol: plugin.protocol,
      method: plugin.method,
      methodInterface: plugin.methodInterface
    }
  });
  var newPlugin = new plugins[0].plugin({
    chainId: chainId
  });
  var isOk = newPlugin.fromJSON(params);
  if (isOk) {
    return newPlugin;
  }
  console.error('Failed to change chainId');
  return plugin;
};
var SWAP_WITHOUT_SLIPPAGE_METHOD = method$2;
var SIMPLE_ADD_LIQUIDITY_METHOD = liquidity_method;
var getPluginInstanceFrom = function getPluginInstanceFrom(_ref6) {
  var json = _ref6.json,
    chainId = _ref6.chainId,
    vaultAddress = _ref6.vaultAddress,
    walletAddress = _ref6.walletAddress;
  var pluginParsed = JSON.parse(json);
  var plugins;
  try {
    plugins = getPlugins({
      by: {
        protocol: pluginParsed.protocol,
        name: pluginParsed.name
      }
    });
  } catch (e) {
    console.error(e);
  }
  if (!plugins || !plugins.length) {
    var pluginInterface = new Interface(["function ".concat(pluginParsed.contractInterface, " ").concat(pluginParsed.type === 'GETTER' ? 'view' : pluginParsed.inputWithMeta && 'value' in pluginParsed.inputWithMeta ? 'payable' : 'nonpayable', " ").concat(pluginParsed.contractInterfaceReturns)]);
    var abi = Object.keys(pluginInterface.functions).map(function (key) {
      return pluginInterface.functions[key];
    });
    if (!abi) {
      console.error("Abi creation for plugin ".concat(pluginParsed.protocol, " ").concat(pluginParsed.contractInterface, " failed"));
    }
    var inputTo = 'to' in pluginParsed.input ? pluginParsed.input.to : undefined;
    var to = typeof inputTo === 'string' ? inputTo : inputTo === null || inputTo === void 0 ? void 0 : inputTo.value;
    if (typeof to !== 'string') {
      throw new Error("Address \"to\" for ".concat(pluginParsed.protocol, " ").concat(pluginParsed.contractInterface, " not a string"));
    }
    plugins = getPluginsFromABI({
      protocol: pluginParsed.protocol,
      abi: abi,
      contractAddress: to,
      chainId: chainId,
      pluginName: pluginParsed.name
    }).plugins;
  }
  if (!plugins) return undefined;
  var newPlugin = new plugins[0].plugin({
    chainId: chainId,
    vaultAddress: vaultAddress,
    walletAddress: walletAddress
  });
  newPlugin.fromJSON(json);
  return {
    instance: newPlugin,
    details: plugins[0]
  };
};

var getOutputValues = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var plugin, provider, execute, walletSigner, withAutoApprovals;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          plugin = _ref.plugin, provider = _ref.provider, execute = _ref.execute, walletSigner = _ref.walletSigner, withAutoApprovals = _ref.withAutoApprovals;
          if (!(withAutoApprovals && plugin.protocol !== 'KIROBO_MULTICALL_CSV')) {
            _context.next = 4;
            break;
          }
          _context.next = 4;
          return setPluginApprovals({
            plugin: plugin,
            provider: provider,
            walletSigner: walletSigner
          });
        case 4:
          if (!(plugin.method === 'addLiquidity_noMinProtection' || plugin.method === 'addLiquidityTo_noMinProtection')) {
            _context.next = 8;
            break;
          }
          _context.next = 7;
          return getSimpleAddLiquidityOutputValues({
            plugin: plugin,
            provider: provider,
            execute: execute
          });
        case 7:
          return _context.abrupt("return", _context.sent);
        case 8:
          if (!(plugin.method === 'swap_noSlippageProtection' || plugin.method === 'swapTo_noSlippageProtection')) {
            _context.next = 12;
            break;
          }
          _context.next = 11;
          return getSwapNoSlippageProtectionOutputValues({
            plugin: plugin,
            provider: provider,
            execute: execute
          });
        case 11:
          return _context.abrupt("return", _context.sent);
        case 12:
          _context.next = 14;
          return plugin.getOutputValues({
            provider: provider,
            execute: execute,
            walletSigner: walletSigner,
            withAutoApprovals: withAutoApprovals
          });
        case 14:
          return _context.abrupt("return", _context.sent);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getOutputValues(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var setOutputIsLoading = function setOutputIsLoading(isLoadIng, paramsList) {
  paramsList.forEach(function (_ref3) {
    var param = _ref3.param;
    param.isLoading = isLoadIng;
  });
};
var setPluginApprovals = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
    var plugin, provider, walletSigner, requiredApprovals, vaultSigner, chainId;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          plugin = _ref4.plugin, provider = _ref4.provider, walletSigner = _ref4.walletSigner;
          requiredApprovals = plugin.getRequiredApprovals();
          vaultSigner = provider.signer;
          if (!(!requiredApprovals || !requiredApprovals.length)) {
            _context3.next = 5;
            break;
          }
          return _context3.abrupt("return");
        case 5:
          chainId = plugin.chainId;
          _context3.next = 8;
          return Promise.all(requiredApprovals.map( /*#__PURE__*/function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(requiredApproval) {
              var to, from, approvePlugin, _requiredApproval$par, spender, amount, walletSignerAddress, _signer, _method, _requiredApproval$par2, approveTo, tokenId, approve721, _requiredApproval$par3, _operator, _approved, setApprovalForAll721, _requiredApproval$par4, operator, approved, setApprovalForAll1155;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    to = requiredApproval.to, from = requiredApproval.from;
                    _context2.t0 = requiredApproval.protocol;
                    _context2.next = _context2.t0 === 'ERC20' ? 4 : _context2.t0 === 'ERC721' ? 21 : _context2.t0 === 'ERC1155' ? 42 : 52;
                    break;
                  case 4:
                    approvePlugin = new Approve$1({
                      chainId: plugin.chainId
                    });
                    _requiredApproval$par = _slicedToArray(requiredApproval.params, 2), spender = _requiredApproval$par[0], amount = _requiredApproval$par[1];
                    _context2.next = 8;
                    return walletSigner === null || walletSigner === void 0 ? void 0 : walletSigner.getAddress();
                  case 8:
                    _context2.t1 = _context2.sent;
                    if (_context2.t1) {
                      _context2.next = 11;
                      break;
                    }
                    _context2.t1 = '';
                  case 11:
                    walletSignerAddress = _context2.t1.toLowerCase();
                    _signer = from && typeof from === 'string' && walletSignerAddress === from.toLowerCase() ? walletSigner : provider.signer;
                    if (_signer) {
                      _context2.next = 15;
                      break;
                    }
                    return _context2.abrupt("break", 53);
                  case 15:
                    if (!(typeof to !== 'string' || typeof spender !== 'string' || typeof amount !== 'string')) {
                      _context2.next = 17;
                      break;
                    }
                    return _context2.abrupt("break", 53);
                  case 17:
                    approvePlugin.input.set({
                      to: to,
                      methodParams: {
                        spender: spender,
                        amount: amount
                      }
                    });
                    _context2.next = 20;
                    return approvePlugin.getOutputValues({
                      provider: {
                        provider: provider.provider,
                        signer: _signer
                      },
                      execute: true
                    });
                  case 20:
                    return _context2.abrupt("break", 53);
                  case 21:
                    _method = requiredApproval.method;
                    _signer = from ? walletSigner : vaultSigner;
                    if (_signer) {
                      _context2.next = 25;
                      break;
                    }
                    return _context2.abrupt("break", 53);
                  case 25:
                    if (!(_method === 'approve')) {
                      _context2.next = 33;
                      break;
                    }
                    _requiredApproval$par2 = _slicedToArray(requiredApproval.params, 2), approveTo = _requiredApproval$par2[0], tokenId = _requiredApproval$par2[1];
                    if (!(typeof to !== 'string' || typeof approveTo !== 'string' || typeof tokenId !== 'string')) {
                      _context2.next = 29;
                      break;
                    }
                    return _context2.abrupt("break", 53);
                  case 29:
                    approve721 = new ERC721.actions.Approve({
                      chainId: chainId,
                      initParams: {
                        to: requiredApproval.to,
                        methodParams: {
                          to: approveTo,
                          tokenId: tokenId
                        }
                      }
                    });
                    _context2.next = 32;
                    return approve721.getOutputValues({
                      provider: {
                        provider: provider.provider,
                        signer: _signer
                      },
                      execute: true
                    });
                  case 32:
                    return _context2.abrupt("break", 53);
                  case 33:
                    if (!(_method === 'setApprovalForAll')) {
                      _context2.next = 41;
                      break;
                    }
                    _requiredApproval$par3 = _slicedToArray(requiredApproval.params, 2), _operator = _requiredApproval$par3[0], _approved = _requiredApproval$par3[1];
                    if (!(typeof to !== 'string' || typeof _operator !== 'string' || typeof _approved !== 'boolean')) {
                      _context2.next = 37;
                      break;
                    }
                    return _context2.abrupt("break", 53);
                  case 37:
                    setApprovalForAll721 = new ERC721.actions.SetApprovalForAll({
                      chainId: chainId,
                      initParams: {
                        to: requiredApproval.to,
                        methodParams: {
                          operator: _operator,
                          _approved: _approved
                        }
                      }
                    });
                    _context2.next = 40;
                    return setApprovalForAll721.getOutputValues({
                      provider: {
                        provider: provider.provider,
                        signer: _signer
                      },
                      execute: true
                    });
                  case 40:
                    return _context2.abrupt("break", 53);
                  case 41:
                    return _context2.abrupt("break", 53);
                  case 42:
                    _requiredApproval$par4 = _slicedToArray(requiredApproval.params, 2), operator = _requiredApproval$par4[0], approved = _requiredApproval$par4[1];
                    if (!(typeof to !== 'string' || typeof operator !== 'string' || typeof approved !== 'boolean')) {
                      _context2.next = 45;
                      break;
                    }
                    return _context2.abrupt("break", 53);
                  case 45:
                    _signer = requiredApproval.from ? walletSigner : vaultSigner;
                    if (_signer) {
                      _context2.next = 48;
                      break;
                    }
                    return _context2.abrupt("break", 53);
                  case 48:
                    setApprovalForAll1155 = new ERC1155.actions.SetApprovalForAll({
                      chainId: chainId,
                      initParams: {
                        to: requiredApproval.to,
                        methodParams: {
                          operator: operator,
                          approved: approved
                        }
                      }
                    });
                    _context2.next = 51;
                    return setApprovalForAll1155.getOutputValues({
                      provider: {
                        provider: provider.provider,
                        signer: _signer
                      },
                      execute: true
                    });
                  case 51:
                    return _context2.abrupt("break", 53);
                  case 52:
                    return _context2.abrupt("break", 53);
                  case 53:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return function (_x3) {
              return _ref6.apply(this, arguments);
            };
          }()));
        case 8:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function setPluginApprovals(_x2) {
    return _ref5.apply(this, arguments);
  };
}();
var getSimpleAddLiquidityOutputValues = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
    var plugin, provider, execute, chainId, libAddLiquidityPlugin, _plugins$Uniswap$acti, AddLiquidity, AddLiquidityETH, addLiquidity, libAddLiquidityMethod, blockNumber, block, blockTimestamp, singerAddress, to, _addLiquidity, _addLiquidity2, _addLiquidity3, _addLiquidity4, _addLiquidity5, res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          plugin = _ref7.plugin, provider = _ref7.provider, execute = _ref7.execute;
          chainId = plugin.chainId;
          libAddLiquidityPlugin = plugin;
          _plugins$Uniswap$acti = Uniswap$1.actions, AddLiquidity = _plugins$Uniswap$acti.AddLiquidity, AddLiquidityETH = _plugins$Uniswap$acti.AddLiquidityETH;
          addLiquidity = undefined;
          libAddLiquidityPlugin.create();
          libAddLiquidityMethod = libAddLiquidityPlugin.input.methodParams.method.value;
          _context4.next = 9;
          return provider.provider.getBlockNumber();
        case 9:
          blockNumber = _context4.sent;
          _context4.next = 12;
          return provider.provider.getBlock(blockNumber);
        case 12:
          block = _context4.sent;
          blockTimestamp = block.timestamp + 100;
          _context4.next = 16;
          return provider.signer.getAddress();
        case 16:
          singerAddress = _context4.sent;
          to = 'to' in libAddLiquidityPlugin.input.methodParams ? libAddLiquidityPlugin.input.methodParams.to.value : singerAddress;
          _context4.t0 = libAddLiquidityMethod;
          _context4.next = _context4.t0 === liquidity_method.addLiquidity ? 21 : _context4.t0 === liquidity_method.addLiquidityEthToken ? 23 : _context4.t0 === liquidity_method.addLiquidityTokenEth ? 25 : 27;
          break;
        case 21:
          addLiquidity = new AddLiquidity({
            chainId: chainId,
            initParams: {
              methodParams: {
                tokenA: libAddLiquidityPlugin.input.methodParams.tokenA.value,
                tokenB: libAddLiquidityPlugin.input.methodParams.tokenB.value,
                amountADesired: libAddLiquidityPlugin.input.methodParams.amountADesired.value,
                amountBDesired: libAddLiquidityPlugin.input.methodParams.amountBDesired.value,
                amountAMin: '0',
                amountBMin: '0',
                to: to,
                deadline: String(blockTimestamp)
              }
            }
          });
          return _context4.abrupt("break", 28);
        case 23:
          addLiquidity = new AddLiquidityETH({
            chainId: chainId,
            initParams: {
              value: libAddLiquidityPlugin.input.methodParams.amountADesired.value,
              methodParams: {
                token: libAddLiquidityPlugin.input.methodParams.tokenB.value,
                amountTokenDesired: libAddLiquidityPlugin.input.methodParams.amountBDesired.value,
                amountTokenMin: '0',
                amountETHMin: '0',
                to: to,
                deadline: String(blockTimestamp)
              }
            }
          });
          return _context4.abrupt("break", 28);
        case 25:
          addLiquidity = new AddLiquidityETH({
            chainId: chainId,
            initParams: {
              value: libAddLiquidityPlugin.input.methodParams.amountBDesired.value,
              methodParams: {
                token: libAddLiquidityPlugin.input.methodParams.tokenA.value,
                amountTokenDesired: libAddLiquidityPlugin.input.methodParams.amountADesired.value,
                amountTokenMin: '0',
                amountETHMin: '0',
                to: to,
                deadline: String(blockTimestamp)
              }
            }
          });
          return _context4.abrupt("break", 28);
        case 27:
          return _context4.abrupt("break", 28);
        case 28:
          _context4.prev = 28;
          setOutputIsLoading(true, libAddLiquidityPlugin.output.paramsList);
          _context4.next = 32;
          return (_addLiquidity = addLiquidity) === null || _addLiquidity === void 0 ? void 0 : _addLiquidity.getOutputValues({
            provider: provider,
            execute: execute
          });
        case 32:
          res = _context4.sent;
          libAddLiquidityPlugin.setError(undefined);
          libAddLiquidityPlugin.currentGasLimit = (_addLiquidity2 = addLiquidity) === null || _addLiquidity2 === void 0 ? void 0 : _addLiquidity2.currentGasLimit;
          libAddLiquidityPlugin.output.params.amountA.setEstimated({
            value: (_addLiquidity3 = addLiquidity) === null || _addLiquidity3 === void 0 ? void 0 : _addLiquidity3.output.params.amountA.getEstimated()
          });
          libAddLiquidityPlugin.output.params.amountB.setEstimated({
            value: (_addLiquidity4 = addLiquidity) === null || _addLiquidity4 === void 0 ? void 0 : _addLiquidity4.output.params.amountB.getEstimated()
          });
          libAddLiquidityPlugin.output.params.liquidity.setEstimated({
            value: (_addLiquidity5 = addLiquidity) === null || _addLiquidity5 === void 0 ? void 0 : _addLiquidity5.output.params.liquidity.getEstimated()
          });
          setOutputIsLoading(false, libAddLiquidityPlugin.output.paramsList);
          return _context4.abrupt("return", res);
        case 42:
          _context4.prev = 42;
          _context4.t1 = _context4["catch"](28);
          libAddLiquidityPlugin.setError(_context4.t1.message);
          libAddLiquidityPlugin.currentGasLimit = undefined;
          libAddLiquidityPlugin.output.params.amountA.setEstimated({
            value: undefined
          });
          libAddLiquidityPlugin.output.params.amountB.setEstimated({
            value: undefined
          });
          libAddLiquidityPlugin.output.params.liquidity.setEstimated({
            value: undefined
          });
          setOutputIsLoading(false, libAddLiquidityPlugin.output.paramsList);
          throw _context4.t1;
        case 51:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[28, 42]]);
  }));
  return function getSimpleAddLiquidityOutputValues(_x4) {
    return _ref8.apply(this, arguments);
  };
}();
var getSwapNoSlippageProtectionOutputValues = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9) {
    var plugin, provider, execute, chainId, libSwapPlugin, blockNumber, block, blockTimestamp, singerAddress, to, libSwapMethod, _plugins$Uniswap$acti2, UniswapV2SwapExactETHForTokens, UniswapV2SwapETHForExactTokens, UniswapV2SwapExactTokensForETH, UniswapV2SwapExactTokensForTokens, UniswapV2SwapTokensForExactETH, UniswapV2SwapTokensForExactTokens, swap, _libSwapPlugin$input$, amountIn, methodParams, amount, amountInVal, _swap, _swap2, res, _amountIn, amountOut, _swap3, _swap4, _amountIn2, _amountOut;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          plugin = _ref9.plugin, provider = _ref9.provider, execute = _ref9.execute;
          chainId = plugin.chainId;
          libSwapPlugin = plugin;
          _context5.next = 5;
          return provider.provider.getBlockNumber();
        case 5:
          blockNumber = _context5.sent;
          _context5.next = 8;
          return provider.provider.getBlock(blockNumber);
        case 8:
          block = _context5.sent;
          blockTimestamp = block.timestamp + 100;
          _context5.next = 12;
          return provider.signer.getAddress();
        case 12:
          singerAddress = _context5.sent;
          to = 'to' in libSwapPlugin.input.methodParams ? libSwapPlugin.input.methodParams.to.value : singerAddress;
          libSwapMethod = libSwapPlugin.input.methodParams.method.value;
          _plugins$Uniswap$acti2 = Uniswap$1.actions, UniswapV2SwapExactETHForTokens = _plugins$Uniswap$acti2.UniswapV2SwapExactETHForTokens, UniswapV2SwapETHForExactTokens = _plugins$Uniswap$acti2.UniswapV2SwapETHForExactTokens, UniswapV2SwapExactTokensForETH = _plugins$Uniswap$acti2.UniswapV2SwapExactTokensForETH, UniswapV2SwapExactTokensForTokens = _plugins$Uniswap$acti2.UniswapV2SwapExactTokensForTokens, UniswapV2SwapTokensForExactETH = _plugins$Uniswap$acti2.UniswapV2SwapTokensForExactETH, UniswapV2SwapTokensForExactTokens = _plugins$Uniswap$acti2.UniswapV2SwapTokensForExactTokens;
          swap = undefined;
          _libSwapPlugin$input$ = libSwapPlugin.input.params, amountIn = _libSwapPlugin$input$.amountIn, methodParams = _libSwapPlugin$input$.methodParams;
          amount = methodParams.amount.isVariable ? methodParams.amount.estimatedValue : methodParams.amount.value;
          amountInVal = amountIn.isVariable ? amountIn.estimatedValue : amountIn.value;
          _context5.t0 = libSwapMethod;
          _context5.next = _context5.t0 === method$2.swapExactETHForTokens ? 23 : _context5.t0 === method$2.swapETHForExactTokens ? 25 : _context5.t0 === method$2.swapExactTokensForETH ? 27 : _context5.t0 === method$2.swapExactTokensForTokens ? 29 : _context5.t0 === method$2.swapTokensForExactTokens ? 31 : _context5.t0 === method$2.swapTokensForExactETH ? 33 : 35;
          break;
        case 23:
          swap = new UniswapV2SwapExactETHForTokens({
            chainId: chainId,
            initParams: {
              value: amount,
              methodParams: {
                amountOutMin: '0',
                path: libSwapPlugin.input.methodParams.path.value,
                deadline: String(blockTimestamp),
                to: to
              }
            }
          });
          return _context5.abrupt("break", 35);
        case 25:
          swap = new UniswapV2SwapETHForExactTokens({
            chainId: chainId,
            initParams: {
              value: amountInVal,
              methodParams: {
                amountOut: amount,
                path: libSwapPlugin.input.methodParams.path.value,
                deadline: String(blockTimestamp),
                to: to
              }
            }
          });
          return _context5.abrupt("break", 35);
        case 27:
          swap = new UniswapV2SwapExactTokensForETH({
            chainId: chainId,
            initParams: {
              methodParams: {
                amountIn: amount,
                amountOutMin: '0',
                path: libSwapPlugin.input.methodParams.path.value,
                deadline: String(blockTimestamp),
                to: to
              }
            }
          });
          return _context5.abrupt("break", 35);
        case 29:
          swap = new UniswapV2SwapExactTokensForTokens({
            chainId: chainId,
            initParams: {
              methodParams: {
                amountIn: amount,
                amountOutMin: '0',
                path: libSwapPlugin.input.methodParams.path.value,
                deadline: String(blockTimestamp),
                to: to
              }
            }
          });
          return _context5.abrupt("break", 35);
        case 31:
          swap = new UniswapV2SwapTokensForExactTokens({
            chainId: chainId,
            initParams: {
              methodParams: {
                amountInMax: amountInVal,
                amountOut: amount,
                path: libSwapPlugin.input.methodParams.path.value,
                deadline: String(blockTimestamp),
                to: to
              }
            }
          });
          return _context5.abrupt("break", 35);
        case 33:
          swap = new UniswapV2SwapTokensForExactETH({
            chainId: chainId,
            initParams: {
              methodParams: {
                amountInMax: amountInVal,
                amountOut: amount,
                path: libSwapPlugin.input.methodParams.path.value,
                deadline: String(blockTimestamp),
                to: to
              }
            }
          });
          return _context5.abrupt("break", 35);
        case 35:
          _context5.prev = 35;
          setOutputIsLoading(true, libSwapPlugin.output.paramsList);
          _context5.next = 39;
          return (_swap = swap) === null || _swap === void 0 ? void 0 : _swap.getOutputValues({
            provider: provider,
            execute: execute
          });
        case 39:
          res = _context5.sent;
          libSwapPlugin.setError(undefined);
          libSwapPlugin.currentGasLimit = (_swap2 = swap) === null || _swap2 === void 0 ? void 0 : _swap2.currentGasLimit;
          _amountIn = libSwapPlugin.output.params.amountIn;
          amountOut = libSwapPlugin.output.params.amountOut;
          if (_amountIn instanceof FctParam && amountOut instanceof FctParam) {
            _amountIn.setEstimated({
              value: (_swap3 = swap) === null || _swap3 === void 0 ? void 0 : _swap3.output.params.amountIn.getEstimated()
            });
            amountOut.setEstimated({
              value: (_swap4 = swap) === null || _swap4 === void 0 ? void 0 : _swap4.output.params.amountOut.getEstimated()
            });
          }
          setOutputIsLoading(false, libSwapPlugin.output.paramsList);
          return _context5.abrupt("return", res);
        case 49:
          _context5.prev = 49;
          _context5.t1 = _context5["catch"](35);
          libSwapPlugin.setError(_context5.t1.message);
          libSwapPlugin.currentGasLimit = undefined;
          _amountIn2 = libSwapPlugin.output.params.amountIn;
          _amountOut = libSwapPlugin.output.params.amountOut;
          if (_amountIn2 instanceof FctParam && _amountOut instanceof FctParam) {
            _amountIn2.setEstimated({
              value: undefined
            });
            _amountOut.setEstimated({
              value: undefined
            });
          }
          setOutputIsLoading(false, libSwapPlugin.output.paramsList);
          throw _context5.t1;
        case 58:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[35, 49]]);
  }));
  return function getSwapNoSlippageProtectionOutputValues(_x5) {
    return _ref10.apply(this, arguments);
  };
}();

var _excluded = ["plugin"],
  _excluded2 = ["plugin"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var updateId = uniqid();
var PluginsModule = /*#__PURE__*/function () {
  function PluginsModule(_ref) {
    var _this = this;
    var _chainId = _ref.chainId;
    _classCallCheck(this, PluginsModule);
    _defineProperty(this, "_plugins", new Map());
    _defineProperty(this, "getOutputValues", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(testProvider) {
        var getPluginOutputs;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.startNodeIn) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", {});
            case 2:
              getPluginOutputs = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(nodeId) {
                  var plugin, errorMessage;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (nodeId) {
                          _context.next = 2;
                          break;
                        }
                        return _context.abrupt("return", {});
                      case 2:
                        plugin = _this.getPlugin(nodeId);
                        if (!(!plugin || !plugin.plugin)) {
                          _context.next = 6;
                          break;
                        }
                        console.error("plugin nodeId: ".concat(nodeId, " not found"));
                        return _context.abrupt("return", {});
                      case 6:
                        _context.prev = 6;
                        _context.next = 9;
                        return getOutputValues({
                          plugin: plugin.plugin,
                          provider: testProvider.provider,
                          execute: testProvider.execute
                        });
                      case 9:
                        _this._error = undefined;
                        if (plugin.options.jumpOnSuccess) {
                          _context.next = 12;
                          break;
                        }
                        return _context.abrupt("return", {});
                      case 12:
                        _context.next = 14;
                        return getPluginOutputs(plugin.options.jumpOnSuccess);
                      case 14:
                        return _context.abrupt("return", _context.sent);
                      case 17:
                        _context.prev = 17;
                        _context.t0 = _context["catch"](6);
                        errorMessage = "Plugin: ".concat(plugin.nodeId, "_").concat(plugin.plugin.protocol, "_").concat(plugin.plugin.name, " error: ").concat(_context.t0.message);
                        console.error(errorMessage);
                        _this._error = errorMessage;
                        if (_this.onChange) _this.onChange(undefined, {
                          nodeId: plugin.nodeId,
                          error: errorMessage
                        });
                        if (plugin.options.jumpOnFail) {
                          _context.next = 25;
                          break;
                        }
                        return _context.abrupt("return", {});
                      case 25:
                        _context.next = 27;
                        return getPluginOutputs(plugin.options.jumpOnFail);
                      case 27:
                        return _context.abrupt("return", _context.sent);
                      case 28:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee, null, [[6, 17]]);
                }));
                return function getPluginOutputs(_x2) {
                  return _ref3.apply(this, arguments);
                };
              }();
              _context2.next = 5;
              return getPluginOutputs(_this.startNodeIn);
            case 5:
              return _context2.abrupt("return", _context2.sent);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(this, "clear", function () {
      return _this._plugins.clear();
    });
    _defineProperty(this, "create", function () {});
    _defineProperty(this, "upsertPlugin", function (pluginNodeJSON) {
      if (!_this.chainId) {
        console.error("chainId error: set chainId");
        return;
      }
      var plugin = _this.jsonToPlugin(pluginNodeJSON.plugin, _this.chainId);
      if (!plugin) {
        console.error('plugin error');
        return;
      }
      var pluginNode = _objectSpread(_objectSpread({}, pluginNodeJSON), {}, {
        plugin: plugin
      });
      _this._plugins.set(pluginNode.nodeId, pluginNode);
      _this.subscribeOnUpdate();
      _this.updateVariablesSubsciptions();
      return _this.plugins;
    });
    _defineProperty(this, "setPlugin", function (nodeId, plugin) {
      return _this.plugins.set(nodeId, plugin);
    });
    _defineProperty(this, "getPlugin", function (nodeId) {
      return _this.plugins.get(nodeId);
    });
    _defineProperty(this, "removePlugin", function (nodeId) {
      return _this.plugins.delete(nodeId);
    });
    _defineProperty(this, "generateName", function () {
      var name = 'Module.';
      _this.pluginsList.forEach(function (pluginContainer, index, list) {
        var plugin = pluginContainer.plugin;
        name += "".concat(plugin.name).concat(index < list.length - 1 ? '.' : '');
      });
      return name;
    });
    _defineProperty(this, "toJSON", function () {
      var data = {};
      _this.pluginsList.forEach(function (pluginContainer, index, list) {
        var plugin = pluginContainer.plugin,
          rest = _objectWithoutProperties(pluginContainer, _excluded);
        data[rest.nodeId] = _objectSpread({
          plugin: plugin.toJSON()
        }, rest);
      });
      return JSON.stringify({
        data: data,
        startNodeId: _this.startNodeIn,
        name: _this.name,
        type: 'MODULE',
        method: 'MODULE'
      });
    });
    _defineProperty(this, "fromJSONWithMeta", function (moduleJson) {
      try {
        var module = JSON.parse(moduleJson);
        var data = module.data,
          startNodeId = module.startNodeId,
          name = module.name;
        _this._name = name;
        if (!data) return false;
        if (startNodeId) _this.setStartNodeIn(startNodeId);
        Object.keys(data).forEach(function (key) {
          var pluginContainer = data[key];
          var plugin = pluginContainer.plugin,
            rest = _objectWithoutProperties(pluginContainer, _excluded2);
          _this.upsertPlugin(_objectSpread({
            plugin: plugin
          }, rest));
        });
      } catch (e) {
        console.error(e);
      }
      return true;
    });
    _defineProperty(this, "jsonToPlugin", function (plugin, chainId) {
      var _getPluginInstanceFro;
      return (_getPluginInstanceFro = getPluginInstanceFrom({
        json: plugin,
        chainId: chainId
      })) === null || _getPluginInstanceFro === void 0 ? void 0 : _getPluginInstanceFro.instance;
    });
    _defineProperty(this, "subscribe", function (_ref4) {
      var callback = _ref4.callback,
        id = _ref4.id;
      _this.observers.set(id, callback);
    });
    _defineProperty(this, "unsubscribe", function (_ref5) {
      var id = _ref5.id;
      _this.observers.delete(id);
    });
    _defineProperty(this, "observers", new Map());
    _defineProperty(this, "subscribeOnUpdate", function () {
      _this.observers.forEach(function (_callback, id) {
        var subscribeId = id;
        _this.inputs.forEach(function (input) {
          input.param.unsubscribe({
            id: subscribeId
          });
          input.param.subscribe({
            id: subscribeId,
            callback: function callback(_ref6) {
              var value = _ref6.value;
              return _callback({
                value: value,
                key: input.key,
                nodeId: input.nodeId
              });
            }
          });
        });
      });
    });
    _defineProperty(this, "updateVariablesSubsciptions", function () {
      _this.pluginsList.forEach(function (plugin) {
        if (!plugin.outputVariables) return;
        plugin.outputVariables.forEach( /*#__PURE__*/function () {
          var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(subscription) {
            var fromNodeId, fromParamKey, toParamKey, fromPlugin, paramFromList, paramFrom, paramToList, paramTo;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  fromNodeId = subscription.fromNodeId, fromParamKey = subscription.fromParamKey, toParamKey = subscription.toParamKey;
                  fromPlugin = _this.getPlugin(fromNodeId);
                  if (fromPlugin) {
                    _context3.next = 4;
                    break;
                  }
                  return _context3.abrupt("return");
                case 4:
                  paramFromList = fromPlugin.plugin.output.paramsList;
                  paramFrom = paramFromList.find(function (param) {
                    return param.key === fromParamKey;
                  });
                  paramToList = plugin.plugin.input.paramsList;
                  paramTo = paramToList.find(function (param) {
                    return param.key === toParamKey;
                  });
                  if (!(!paramFrom || !paramTo)) {
                    _context3.next = 10;
                    break;
                  }
                  return _context3.abrupt("return");
                case 10:
                  paramTo.param.setString({
                    value: paramFrom.param.getOutputVariable(fromPlugin.nodeId)
                  });
                case 11:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          return function (_x3) {
            return _ref7.apply(this, arguments);
          };
        }());
      });
    });
    _defineProperty(this, "onUpdate", function (event) {
      _this.pluginsList.forEach(function (plugin) {
        if (!plugin.subscriptions) return;
        plugin.subscriptions.forEach( /*#__PURE__*/function () {
          var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(subscription) {
            var fromNodeId, fromParamKey, toParamKey, fromPlugin, paramFromList, paramFrom, paramToList, paramTo, value;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  fromNodeId = subscription.fromNodeId, fromParamKey = subscription.fromParamKey, toParamKey = subscription.toParamKey;
                  fromPlugin = _this.getPlugin(fromNodeId);
                  if (!(subscription.fromParamKey !== event.key)) {
                    _context4.next = 4;
                    break;
                  }
                  return _context4.abrupt("return");
                case 4:
                  if (!(subscription.fromNodeId !== event.nodeId)) {
                    _context4.next = 6;
                    break;
                  }
                  return _context4.abrupt("return");
                case 6:
                  if (fromPlugin) {
                    _context4.next = 8;
                    break;
                  }
                  return _context4.abrupt("return");
                case 8:
                  paramFromList = fromPlugin.plugin.input.paramsList;
                  paramFrom = paramFromList.find(function (param) {
                    return param.key === fromParamKey;
                  });
                  paramToList = plugin.plugin.input.paramsList;
                  paramTo = paramToList.find(function (param) {
                    return param.key === toParamKey;
                  });
                  if (paramFrom && paramTo) {
                    value = paramFrom.param.value;
                    paramTo.param.set({
                      value: value
                    });
                    if (_this.onChange) {
                      _this.onChange({
                        nodeId: plugin.nodeId,
                        key: subscription.toParamKey,
                        value: value
                      });
                    }
                  }
                case 13:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }));
          return function (_x4) {
            return _ref8.apply(this, arguments);
          };
        }());
      });
    });
    this._chainId = _chainId;
    this.subscribe({
      callback: this.onUpdate,
      id: updateId
    });
  }
  _createClass(PluginsModule, [{
    key: "type",
    get: function get() {
      return 'MODULE';
    }
  }, {
    key: "protocol",
    get: function get() {
      return 'MODULE';
    }
  }, {
    key: "chainId",
    get: function get() {
      return this._chainId;
    }
  }, {
    key: "plugins",
    get: function get() {
      return this._plugins;
    }
  }, {
    key: "error",
    get: function get() {
      return this._error;
    }
  }, {
    key: "pluginsList",
    get: function get() {
      var _this2 = this;
      var plugins = [];
      if (!this.startNodeIn) {
        return [];
      }
      var setPlugin = function setPlugin(nodeId) {
        if (!nodeId) return;
        var plugin = _this2.getPlugin(nodeId);
        if (!plugin) {
          console.error("plugin nodeId: ".concat(nodeId, " not found"));
          return;
        }
        plugins.push(plugin);
        setPlugin(plugin.options.jumpOnSuccess);
        setPlugin(plugin.options.jumpOnFail);
      };
      setPlugin(this.startNodeIn);
      return plugins;
    }
  }, {
    key: "createNewModule",
    value: function createNewModule(initNodeId) {
      var _this3 = this;
      //const plugins: PluginNode[] = []
      var prevIds = new Map();
      if (!this.startNodeIn) {
        return;
      }
      var changePluginId = function changePluginId(newId, prevId) {
        var _plugin$subscriptions, _plugin$outputVariabl;
        if (!prevId) return;
        prevIds.set(prevId, newId);
        var plugin = _this3.getPlugin(prevId);
        if (!plugin) {
          console.error("plugin nodeId: ".concat(prevId, " not found"));
          return;
        }
        _this3.removePlugin(prevId);
        plugin.nodeId = newId;
        _this3.setPlugin(newId, plugin);
        var subs = (_plugin$subscriptions = plugin.subscriptions) === null || _plugin$subscriptions === void 0 ? void 0 : _plugin$subscriptions.map(function (subscription) {
          var newIdFromPrevId = prevIds.get(subscription.fromNodeId);
          if (!newIdFromPrevId) return subscription;
          subscription.fromNodeId = newIdFromPrevId;
          return subscription;
        });
        plugin.subscriptions = subs;
        var outputSubs = (_plugin$outputVariabl = plugin.outputVariables) === null || _plugin$outputVariabl === void 0 ? void 0 : _plugin$outputVariabl.map(function (subscription) {
          var newIdFromPrevId = prevIds.get(subscription.fromNodeId);
          if (!newIdFromPrevId) return subscription;
          subscription.fromNodeId = newIdFromPrevId;
          return subscription;
        });
        plugin.outputVariables = outputSubs;
        if (plugin.options.jumpOnSuccess) {
          var _prevId = plugin.options.jumpOnSuccess;
          var _newId = uuid_1.v4();
          plugin.options.jumpOnSuccess = _newId;
          changePluginId(_newId, _prevId);
        }
        if (plugin.options.jumpOnFail) {
          var _prevId2 = plugin.options.jumpOnFail;
          var _newId2 = uuid_1.v4();
          plugin.options.jumpOnFail = _newId2;
          changePluginId(_newId2, _prevId2);
        }
      };
      var prevId = this.startNodeIn;
      var newId = initNodeId || uuid_1.v4();
      this.setStartNodeIn(newId);
      changePluginId(newId, prevId);
      var json = this.toJSON();
      this.fromJSONWithMeta(json);
      this.subscribeOnUpdate();
      this.updateVariablesSubsciptions();
    }
  }, {
    key: "getInterface",
    value: function getInterface(_ref9) {
      var chainId = _ref9.chainId,
        initModuleJSON = _ref9.initModuleJSON,
        startNodeId = _ref9.startNodeId;
      var json;
      if (!initModuleJSON) {
        this.createNewModule(startNodeId);
        json = this.toJSON();
      } else {
        json = initModuleJSON;
      }
      var newModule = new PluginsModule({
        chainId: chainId
      });
      newModule.fromJSONWithMeta(json);
      if (!newModule.startNodeIn) return;
      var initPlugin = newModule.getPlugin(newModule.startNodeIn);
      if (!initPlugin) return;
      var newInputValues = {};
      var newOutputValues = {};
      newModule.input.paramsList.forEach(function (param) {
        param.param.nodeId = param.nodeId;
        _.set(newInputValues, param.id, param.param);
      });
      newModule.output.paramsList.forEach(function (param) {
        param.param.nodeId = param.nodeId;
        _.set(newOutputValues, param.id, param.param);
      });
      var Plugin = createPlugin({
        protocol: newModule.protocol,
        type: 'MODULE',
        name: newModule.name,
        method: 'module',
        getParams: function getParams() {
          return {
            input: newInputValues,
            output: newOutputValues
          };
        }
      });
      var newPlugin = new Plugin({
        chainId: chainId
      });
      newPlugin.getOutputValues = newModule.getOutputValues;
      return {
        instance: newPlugin,
        moduleInstance: newModule
      };
    }
  }, {
    key: "input",
    get: function get() {
      return {
        paramsList: this.inputs
      };
    }
  }, {
    key: "output",
    get: function get() {
      return {
        paramsList: this.outputs
      };
    }
  }, {
    key: "inputs",
    get: function get() {
      var _this4 = this;
      var inputs = [];
      this.plugins.forEach(function (plugin) {
        var params = plugin.plugin.input.paramsList;
        params.forEach(function (_ref10) {
          var _plugin$subscriptions2, _plugin$outputVariabl2;
          var param = _ref10.param,
            key = _ref10.key;
          var id = key === "to" ? 'to' : "".concat(key, "_").concat(plugin.nodeId);
          param.label = param.label || key.replace('methodParams.', '');
          param.description = "".concat(plugin.plugin.name, "_").concat(param.key);
          if (plugin.nodeId === _this4.startNodeIn) {
            inputs.push({
              param: param,
              key: key,
              nodeId: plugin.nodeId,
              id: id
            });
            return;
          }
          if (!plugin.subscriptions && !plugin.outputVariables) {
            inputs.push({
              param: param,
              key: key,
              nodeId: plugin.nodeId,
              id: id
            });
            return;
          }
          if (!((_plugin$subscriptions2 = plugin.subscriptions) !== null && _plugin$subscriptions2 !== void 0 && _plugin$subscriptions2.find(function (subscription) {
            return subscription.toParamKey === key;
          })) && !((_plugin$outputVariabl2 = plugin.outputVariables) !== null && _plugin$outputVariabl2 !== void 0 && _plugin$outputVariabl2.find(function (subscription) {
            return subscription.toParamKey === key;
          }))) {
            inputs.push({
              param: param,
              key: key,
              nodeId: plugin.nodeId,
              id: id
            });
            return;
          }
          param.hidden = true;
          inputs.push({
            param: param,
            key: key,
            nodeId: plugin.nodeId,
            id: id
          });
        });
      });
      return inputs;
    }
  }, {
    key: "outputs",
    get: function get() {
      var outputs = [];
      this.plugins.forEach(function (plugin) {
        var params = plugin.plugin.output.paramsList;
        params.forEach(function (_ref11) {
          var key = _ref11.key,
            param = _ref11.param;
          var id = "".concat(key, "_").concat(plugin.nodeId);
          param.label = param.label || key;
          param.description = "".concat(plugin.plugin.name, "_").concat(key);
          outputs.push({
            key: key,
            param: param,
            nodeId: plugin.nodeId,
            id: id
          });
        });
      });
      return outputs;
    }
  }, {
    key: "startNodeIn",
    get: function get() {
      return this._startNodeIn;
    }
  }, {
    key: "setStartNodeIn",
    value: function setStartNodeIn(nodeId) {
      this._startNodeIn = nodeId;
    }
  }, {
    key: "name",
    get: function get() {
      return this._name || this.generateName();
    },
    set: function set(name) {
      this._name = name;
    }
  }]);
  return PluginsModule;
}();

export { AaveHelper, AaveV2, AaveV3, ChainLink, ChainLinkHelper, CompoundV2, CompoundV3, ComputedVariable, Curve, ERC1155, ERC20, ERC721, ERRORS, Erc20Airdrop, Erc20Approvals, Erc20MonoTransfers, Erc20Transfers, EthTransfers, FCT_UNISWAP, FctAddress, FctAddressList, FctBoolean, FctBps, FctBytes, FctBytes32, FctBytes32List, FctBytes4, FctBytesList, FctCustom, FctCustomArray, FctDecimals, FctInt256, FctInteger128, FctInteger24, FctInteger32, FctInteger64, FctParam, FctPercent, FctString, FctTimestamp, FctTupleArray, FctUInt80, FctUinteger32, FctUinteger32Bps, FctUinteger64, FctValue, FctValue128, FctValue128_27, FctValue16, FctValue160, FctValue18, FctValue24, FctValue27, FctValue40, FctValue8, FctValueList, FctValueListN, GMX, Inch, OneInchHelper as InchHelper, KIROBO_MULTICALL_CSV, Lido, Magic, MultiAdd, MultiBalance, MultiDivider, MultiMultiplier, MultiSubtract, Multicall, Paraswap, ParaswapHelper, PluginsModule, RadiantV2, RocketPool, SIMPLE_ADD_LIQUIDITY_METHOD, SWAP_WITHOUT_SLIPPAGE_METHOD, SecureStorage, Sushiswap$1 as Sushiswap, Sushiswap as SushiswapHelper, TokenValidator, Tokens, TokensMath, Uniswap$1 as Uniswap, Uniswap as UniswapHelper, UniswapV3, UniswapV3$1 as UniswapV3Helper, Utility, Utils, ValidationVariable, Yearn, cBridge, createApprovalsPlugin, createMulticallPlugin, getMethodInterface, getMulticallPlugin, getOutputValues, getOutputVariable, getOutputVariableOnChain, getPlugin, getPluginInstanceFrom, getPlugins, getPluginsFromABI, getSwapPath, getTokenDecimals, isConnectable, isVariable, maxValue, paramsSchemas, tokenTypes, useChainId, Utils$1 as utils };
